import * as e from "react";
function t() {
  return t = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var o = arguments[t];
      for (var r in o) Object.prototype.hasOwnProperty.call(o, r) && (e[r] = o[r]);
    }
    return e;
  }, t.apply(this, arguments);
}
function o(e, t) {
  if (null == e) return {};
  var o,
    r,
    n = function (e, t) {
      if (null == e) return {};
      var o,
        r,
        n = {},
        l = Object.keys(e);
      for (r = 0; r < l.length; r++) o = l[r], t.indexOf(o) >= 0 || (n[o] = e[o]);
      return n;
    }(e, t);
  if (Object.getOwnPropertySymbols) {
    var l = Object.getOwnPropertySymbols(e);
    for (r = 0; r < l.length; r++) o = l[r], t.indexOf(o) >= 0 || Object.prototype.propertyIsEnumerable.call(e, o) && (n[o] = e[o]);
  }
  return n;
}
var r = ["size", "color", "stroke"];
function n(n) {
  var l = n.size,
    a = void 0 === l ? 24 : l,
    i = n.color,
    c = void 0 === i ? "currentColor" : i,
    s = n.stroke,
    h = void 0 === s ? 2 : s,
    d = o(n, r);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-123",
    width: a,
    height: a,
    viewBox: "0 0 24 24",
    strokeWidth: h,
    stroke: c,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, d), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M3 10l2 -2v8"
  }), e.createElement("path", {
    d: "M9 8h3a1 1 0 0 1 1 1v2a1 1 0 0 1 -1 1h-2a1 1 0 0 0 -1 1v2a1 1 0 0 0 1 1h3"
  }), e.createElement("path", {
    d: "M17 8h2.5a1.5 1.5 0 0 1 1.5 1.5v1a1.5 1.5 0 0 1 -1.5 1.5h-1.5h1.5a1.5 1.5 0 0 1 1.5 1.5v1a1.5 1.5 0 0 1 -1.5 1.5h-2.5"
  }));
}
var l = ["size", "color", "stroke"];
function a(r) {
  var n = r.size,
    a = void 0 === n ? 24 : n,
    i = r.color,
    c = void 0 === i ? "currentColor" : i,
    s = r.stroke,
    h = void 0 === s ? 2 : s,
    d = o(r, l);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-24-hours",
    width: a,
    height: a,
    viewBox: "0 0 24 24",
    strokeWidth: h,
    stroke: c,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, d), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M20 11a8.1 8.1 0 0 0 -15.5 -2m-.5 -4v4h4"
  }), e.createElement("path", {
    d: "M4 13a8.094 8.094 0 0 0 3 5.24"
  }), e.createElement("path", {
    d: "M11 15h2a1 1 0 0 1 1 1v1a1 1 0 0 1 -1 1h-1a1 1 0 0 0 -1 1v1a1 1 0 0 0 1 1h2"
  }), e.createElement("path", {
    d: "M17 15v2a1 1 0 0 0 1 1h1"
  }), e.createElement("path", {
    d: "M20 15v6"
  }));
}
var i = ["size", "color", "stroke"];
function c(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    c = void 0 === a ? "currentColor" : a,
    s = r.stroke,
    h = void 0 === s ? 2 : s,
    d = o(r, i);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-2fa",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: h,
    stroke: c,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, d), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M7 16h-4l3.47 -4.66a2 2 0 1 0 -3.47 -1.54"
  }), e.createElement("path", {
    d: "M10 16v-8h4"
  }), e.createElement("line", {
    x1: 10,
    y1: 12,
    x2: 13,
    y2: 12
  }), e.createElement("path", {
    d: "M17 16v-6a2 2 0 0 1 4 0v6"
  }), e.createElement("line", {
    x1: 17,
    y1: 13,
    x2: 21,
    y2: 13
  }));
}
var s = ["size", "color", "stroke"];
function h(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    h = void 0 === c ? 2 : c,
    d = o(r, s);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-360-view",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: h,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, d), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M14 6a1 1 0 0 0 -1 -1h-2a1 1 0 0 0 -1 1v6a1 1 0 0 0 1 1h2a1 1 0 0 0 1 -1v-2a1 1 0 0 0 -1 -1h-3"
  }), e.createElement("path", {
    d: "M3 5h2.5a1.5 1.5 0 0 1 1.5 1.5v1a1.5 1.5 0 0 1 -1.5 1.5h-1.5h1.5a1.5 1.5 0 0 1 1.5 1.5v1a1.5 1.5 0 0 1 -1.5 1.5h-2.5"
  }), e.createElement("path", {
    d: "M17 7v4a2 2 0 1 0 4 0v-4a2 2 0 1 0 -4 0z"
  }), e.createElement("path", {
    d: "M3 16c0 1.657 4.03 3 9 3s9 -1.343 9 -3"
  }));
}
var d = ["size", "color", "stroke"];
function v(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, d);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-360",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M16.996 15.328c2.414 -.718 4.004 -1.94 4.004 -3.328c0 -2.21 -4.03 -4 -9 -4s-9 1.79 -9 4s4.03 4 9 4"
  }), e.createElement("path", {
    d: "M9 13l3 3l-3 3"
  }));
}
var m = ["size", "color", "stroke"];
function k(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, m);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-3d-cube-sphere-off",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M6 17.6l-2 -1.1v-2.5"
  }), e.createElement("path", {
    d: "M4 10v-2.5l2 -1.1"
  }), e.createElement("path", {
    d: "M10 4.1l2 -1.1l2 1.1"
  }), e.createElement("path", {
    d: "M18 6.4l2 1.1v2.5"
  }), e.createElement("path", {
    d: "M20 14v2"
  }), e.createElement("path", {
    d: "M14 19.9l-2 1.1l-2 -1.1"
  }), e.createElement("path", {
    d: "M18 8.6l2 -1.1"
  }), e.createElement("path", {
    d: "M12 12v2.5"
  }), e.createElement("path", {
    d: "M12 18.5v2.5"
  }), e.createElement("path", {
    d: "M12 12l-2 -1.12"
  }), e.createElement("path", {
    d: "M6 8.6l-2 -1.1"
  }), e.createElement("path", {
    d: "M3 3l18 18"
  }));
}
var w = ["size", "color", "stroke"];
function p(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, w);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-3d-cube-sphere",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M6 17.6l-2 -1.1v-2.5"
  }), e.createElement("path", {
    d: "M4 10v-2.5l2 -1.1"
  }), e.createElement("path", {
    d: "M10 4.1l2 -1.1l2 1.1"
  }), e.createElement("path", {
    d: "M18 6.4l2 1.1v2.5"
  }), e.createElement("path", {
    d: "M20 14v2.5l-2 1.12"
  }), e.createElement("path", {
    d: "M14 19.9l-2 1.1l-2 -1.1"
  }), e.createElement("line", {
    x1: 12,
    y1: 12,
    x2: 14,
    y2: 10.9
  }), e.createElement("line", {
    x1: 18,
    y1: 8.6,
    x2: 20,
    y2: 7.5
  }), e.createElement("line", {
    x1: 12,
    y1: 12,
    x2: 12,
    y2: 14.5
  }), e.createElement("line", {
    x1: 12,
    y1: 18.5,
    x2: 12,
    y2: 21
  }), e.createElement("path", {
    d: "M12 12l-2 -1.12"
  }), e.createElement("line", {
    x1: 6,
    y1: 8.6,
    x2: 4,
    y2: 7.5
  }));
}
var E = ["size", "color", "stroke"];
function u(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, E);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-3d-rotate",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M12 3a7 7 0 0 1 7 7v4l-3 -3"
  }), e.createElement("path", {
    d: "M22 11l-3 3"
  }), e.createElement("path", {
    d: "M8 15.5l-5 -3l5 -3l5 3v5.5l-5 3z"
  }), e.createElement("path", {
    d: "M3 12.5v5.5l5 3"
  }), e.createElement("path", {
    d: "M8 15.545l5 -3.03"
  }));
}
var g = ["size", "color", "stroke"];
function M(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, g);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-a-b-2",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M16 21h3c.81 0 1.48 -.67 1.48 -1.48l.02 -.02c0 -.82 -.69 -1.5 -1.5 -1.5h-3v3z"
  }), e.createElement("path", {
    d: "M16 15h2.5c.84 -.01 1.5 .66 1.5 1.5s-.66 1.5 -1.5 1.5h-2.5v-3z"
  }), e.createElement("path", {
    d: "M4 9v-4c0 -1.036 .895 -2 2 -2s2 .964 2 2v4"
  }), e.createElement("path", {
    d: "M2.99 11.98a9 9 0 0 0 9 9m9 -9a9 9 0 0 0 -9 -9"
  }), e.createElement("path", {
    d: "M8 7h-4"
  }));
}
var x = ["size", "color", "stroke"];
function f(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, x);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-a-b-off",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M3 16v-5.5a2.5 2.5 0 0 1 5 0v5.5m0 -4h-5"
  }), e.createElement("path", {
    d: "M12 12v6"
  }), e.createElement("path", {
    d: "M12 6v2"
  }), e.createElement("path", {
    d: "M16 8h3a2 2 0 1 1 0 4h-3m3 0a2 2 0 0 1 .83 3.82m-3.83 -3.82v-4"
  }), e.createElement("path", {
    d: "M3 3l18 18"
  }));
}
var z = ["size", "color", "stroke"];
function b(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, z);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-a-b",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M3 16v-5.5a2.5 2.5 0 0 1 5 0v5.5m0 -4h-5"
  }), e.createElement("line", {
    x1: 12,
    y1: 6,
    x2: 12,
    y2: 18
  }), e.createElement("path", {
    d: "M16 16v-8h3a2 2 0 0 1 0 4h-3m3 0a2 2 0 0 1 0 4h-3"
  }));
}
var L = ["size", "color", "stroke"];
function y(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, L);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-abacus-off",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M5 5v16"
  }), e.createElement("path", {
    d: "M19 21v-2m0 -4v-12"
  }), e.createElement("path", {
    d: "M5 7h2m4 0h8"
  }), e.createElement("path", {
    d: "M5 15h10"
  }), e.createElement("path", {
    d: "M8 13v4"
  }), e.createElement("path", {
    d: "M11 13v4"
  }), e.createElement("path", {
    d: "M16 16v1"
  }), e.createElement("path", {
    d: "M14 5v4"
  }), e.createElement("path", {
    d: "M11 5v2"
  }), e.createElement("path", {
    d: "M8 8v1"
  }), e.createElement("path", {
    d: "M3 21h18"
  }), e.createElement("path", {
    d: "M3 3l18 18"
  }));
}
var C = ["size", "color", "stroke"];
function j(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, C);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-abacus",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M5 3v18"
  }), e.createElement("path", {
    d: "M19 21v-18"
  }), e.createElement("path", {
    d: "M5 7h14"
  }), e.createElement("path", {
    d: "M5 15h14"
  }), e.createElement("path", {
    d: "M8 13v4"
  }), e.createElement("path", {
    d: "M11 13v4"
  }), e.createElement("path", {
    d: "M16 13v4"
  }), e.createElement("path", {
    d: "M14 5v4"
  }), e.createElement("path", {
    d: "M11 5v4"
  }), e.createElement("path", {
    d: "M8 5v4"
  }), e.createElement("path", {
    d: "M3 21h18"
  }));
}
var B = ["size", "color", "stroke"];
function H(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, B);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-abc",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M3 16v-6a2 2 0 1 1 4 0v6"
  }), e.createElement("path", {
    d: "M3 13h4"
  }), e.createElement("path", {
    d: "M10 8v6a2 2 0 1 0 4 0v-1a2 2 0 1 0 -4 0v1"
  }), e.createElement("path", {
    d: "M20.732 12a2 2 0 0 0 -3.732 1v1a2 2 0 0 0 3.726 1.01"
  }));
}
var N = ["size", "color", "stroke"];
function W(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, N);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-access-point-off",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("line", {
    x1: 3,
    y1: 3,
    x2: 21,
    y2: 21
  }), e.createElement("path", {
    d: "M14.828 9.172a4 4 0 0 1 1.172 2.828"
  }), e.createElement("path", {
    d: "M17.657 6.343a8 8 0 0 1 1.635 8.952"
  }), e.createElement("path", {
    d: "M9.168 14.828a4 4 0 0 1 0 -5.656"
  }), e.createElement("path", {
    d: "M6.337 17.657a8 8 0 0 1 0 -11.314"
  }));
}
var q = ["size", "color", "stroke"];
function O(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, q);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-access-point",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("line", {
    x1: 12,
    y1: 12,
    x2: 12,
    y2: 12.01
  }), e.createElement("path", {
    d: "M14.828 9.172a4 4 0 0 1 0 5.656"
  }), e.createElement("path", {
    d: "M17.657 6.343a8 8 0 0 1 0 11.314"
  }), e.createElement("path", {
    d: "M9.168 14.828a4 4 0 0 1 0 -5.656"
  }), e.createElement("path", {
    d: "M6.337 17.657a8 8 0 0 1 0 -11.314"
  }));
}
var P = ["size", "color", "stroke"];
function S(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, P);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-accessible-off",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M10 16.5l2 -3l2 3m-2 -3v-1.5m2.627 -1.376l.373 -.124m-6 0l2.231 .744"
  }), e.createElement("path", {
    d: "M20.042 16.045a9 9 0 0 0 -12.087 -12.087m-2.318 1.677a9 9 0 1 0 12.725 12.73"
  }), e.createElement("path", {
    d: "M12 8a0.5 .5 0 1 0 -.5 -.5"
  }), e.createElement("path", {
    d: "M3 3l18 18"
  }));
}
var I = ["size", "color", "stroke"];
function A(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, I);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-accessible",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 9
  }), e.createElement("path", {
    d: "M10 16.5l2 -3l2 3m-2 -3v-2l3 -1m-6 0l3 1"
  }), e.createElement("circle", {
    cx: 12,
    cy: 7.5,
    r: .5,
    fill: "currentColor"
  }));
}
var D = ["size", "color", "stroke"];
function F(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, D);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-activity-heartbeat",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M3 12h4.5l1.5 -6l4 12l2 -9l1.5 3h4.5"
  }));
}
var G = ["size", "color", "stroke"];
function J(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, G);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-activity",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M3 12h4l3 8l4 -16l3 8h4"
  }));
}
var K = ["size", "color", "stroke"];
function Q(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, K);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-ad-2",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M11.933 5h-6.933v16h13v-8"
  }), e.createElement("path", {
    d: "M14 17h-5"
  }), e.createElement("path", {
    d: "M9 13h5v-4h-5z"
  }), e.createElement("path", {
    d: "M15 5v-2"
  }), e.createElement("path", {
    d: "M18 6l2 -2"
  }), e.createElement("path", {
    d: "M19 9h2"
  }));
}
var R = ["size", "color", "stroke"];
function T(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, R);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-ad-off",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M9 5h10a2 2 0 0 1 2 2v10m-2 2h-14a2 2 0 0 1 -2 -2v-10a2 2 0 0 1 2 -2"
  }), e.createElement("path", {
    d: "M7 15v-4a2 2 0 0 1 2 -2m2 2v4"
  }), e.createElement("path", {
    d: "M7 13h4"
  }), e.createElement("path", {
    d: "M17 9v4"
  }), e.createElement("path", {
    d: "M16.115 12.131c.33 .149 .595 .412 .747 .74"
  }), e.createElement("path", {
    d: "M3 3l18 18"
  }));
}
var U = ["size", "color", "stroke"];
function V(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, U);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-ad",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("rect", {
    x: 3,
    y: 5,
    width: 18,
    height: 14,
    rx: 2
  }), e.createElement("path", {
    d: "M7 15v-4a2 2 0 0 1 4 0v4"
  }), e.createElement("line", {
    x1: 7,
    y1: 13,
    x2: 11,
    y2: 13
  }), e.createElement("path", {
    d: "M17 9v6h-1.5a1.5 1.5 0 1 1 1.5 -1.5"
  }));
}
var X = ["size", "color", "stroke"];
function Y(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, X);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-address-book-off",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M8 4h10a2 2 0 0 1 2 2v10m-.57 3.399c-.363 .37 -.87 .601 -1.43 .601h-10a2 2 0 0 1 -2 -2v-12"
  }), e.createElement("path", {
    d: "M10 16h6"
  }), e.createElement("path", {
    d: "M11 11a2 2 0 0 0 2 2m2 -2a2 2 0 0 0 -2 -2"
  }), e.createElement("path", {
    d: "M4 8h3"
  }), e.createElement("path", {
    d: "M4 12h3"
  }), e.createElement("path", {
    d: "M4 16h3"
  }), e.createElement("path", {
    d: "M3 3l18 18"
  }));
}
var Z = ["size", "color", "stroke"];
function $(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Z);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-address-book",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M20 6v12a2 2 0 0 1 -2 2h-10a2 2 0 0 1 -2 -2v-12a2 2 0 0 1 2 -2h10a2 2 0 0 1 2 2z"
  }), e.createElement("path", {
    d: "M10 16h6"
  }), e.createElement("circle", {
    cx: 13,
    cy: 11,
    r: 2
  }), e.createElement("path", {
    d: "M4 8h3"
  }), e.createElement("path", {
    d: "M4 12h3"
  }), e.createElement("path", {
    d: "M4 16h3"
  }));
}
var _ = ["size", "color", "stroke"];
function ee(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, _);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-adjustments-alt",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("rect", {
    x: 4,
    y: 8,
    width: 4,
    height: 4
  }), e.createElement("line", {
    x1: 6,
    y1: 4,
    x2: 6,
    y2: 8
  }), e.createElement("line", {
    x1: 6,
    y1: 12,
    x2: 6,
    y2: 20
  }), e.createElement("rect", {
    x: 10,
    y: 14,
    width: 4,
    height: 4
  }), e.createElement("line", {
    x1: 12,
    y1: 4,
    x2: 12,
    y2: 14
  }), e.createElement("line", {
    x1: 12,
    y1: 18,
    x2: 12,
    y2: 20
  }), e.createElement("rect", {
    x: 16,
    y: 5,
    width: 4,
    height: 4
  }), e.createElement("line", {
    x1: 18,
    y1: 4,
    x2: 18,
    y2: 5
  }), e.createElement("line", {
    x1: 18,
    y1: 9,
    x2: 18,
    y2: 20
  }));
}
var te = ["size", "color", "stroke"];
function oe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, te);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-adjustments-horizontal",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("circle", {
    cx: 14,
    cy: 6,
    r: 2
  }), e.createElement("line", {
    x1: 4,
    y1: 6,
    x2: 12,
    y2: 6
  }), e.createElement("line", {
    x1: 16,
    y1: 6,
    x2: 20,
    y2: 6
  }), e.createElement("circle", {
    cx: 8,
    cy: 12,
    r: 2
  }), e.createElement("line", {
    x1: 4,
    y1: 12,
    x2: 6,
    y2: 12
  }), e.createElement("line", {
    x1: 10,
    y1: 12,
    x2: 20,
    y2: 12
  }), e.createElement("circle", {
    cx: 17,
    cy: 18,
    r: 2
  }), e.createElement("line", {
    x1: 4,
    y1: 18,
    x2: 15,
    y2: 18
  }), e.createElement("line", {
    x1: 19,
    y1: 18,
    x2: 20,
    y2: 18
  }));
}
var re = ["size", "color", "stroke"];
function ne(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, re);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-adjustments-off",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("circle", {
    cx: 6,
    cy: 10,
    r: 2
  }), e.createElement("path", {
    d: "M6 6v2"
  }), e.createElement("path", {
    d: "M6 12v8"
  }), e.createElement("circle", {
    cx: 12,
    cy: 16,
    r: 2
  }), e.createElement("path", {
    d: "M12 4v4"
  }), e.createElement("path", {
    d: "M12 12v2"
  }), e.createElement("path", {
    d: "M12 18v2"
  }), e.createElement("circle", {
    cx: 18,
    cy: 7,
    r: 2
  }), e.createElement("path", {
    d: "M18 4v1"
  }), e.createElement("path", {
    d: "M18 9v5"
  }), e.createElement("path", {
    d: "M18 18v2"
  }), e.createElement("path", {
    d: "M3 3l18 18"
  }));
}
var le = ["size", "color", "stroke"];
function ae(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, le);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-adjustments",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("circle", {
    cx: 6,
    cy: 10,
    r: 2
  }), e.createElement("line", {
    x1: 6,
    y1: 4,
    x2: 6,
    y2: 8
  }), e.createElement("line", {
    x1: 6,
    y1: 12,
    x2: 6,
    y2: 20
  }), e.createElement("circle", {
    cx: 12,
    cy: 16,
    r: 2
  }), e.createElement("line", {
    x1: 12,
    y1: 4,
    x2: 12,
    y2: 14
  }), e.createElement("line", {
    x1: 12,
    y1: 18,
    x2: 12,
    y2: 20
  }), e.createElement("circle", {
    cx: 18,
    cy: 7,
    r: 2
  }), e.createElement("line", {
    x1: 18,
    y1: 4,
    x2: 18,
    y2: 5
  }), e.createElement("line", {
    x1: 18,
    y1: 9,
    x2: 18,
    y2: 20
  }));
}
var ie = ["size", "color", "stroke"];
function ce(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, ie);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-aerial-lift",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M4 5l16 -2m-8 1v10m-5.106 -6h10.306c2.45 3 2.45 9 -.2 12h-10.106c-2.544 -3 -2.544 -9 0 -12zm-1.894 6h14"
  }));
}
var se = ["size", "color", "stroke"];
function he(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, se);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-affiliate",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M5.931 6.936l1.275 4.249m5.607 5.609l4.251 1.275"
  }), e.createElement("path", {
    d: "M11.683 12.317l5.759 -5.759"
  }), e.createElement("circle", {
    cx: 5.5,
    cy: 5.5,
    r: 1.5
  }), e.createElement("circle", {
    cx: 18.5,
    cy: 5.5,
    r: 1.5
  }), e.createElement("circle", {
    cx: 18.5,
    cy: 18.5,
    r: 1.5
  }), e.createElement("circle", {
    cx: 8.5,
    cy: 15.5,
    r: 4.5
  }));
}
var de = ["size", "color", "stroke"];
function ve(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, de);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-air-balloon",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("rect", {
    x: 10,
    y: 19,
    width: 4,
    height: 3,
    rx: 1
  }), e.createElement("path", {
    d: "M12 16c3.314 0 6 -4.686 6 -8a6 6 0 1 0 -12 0c0 3.314 2.686 8 6 8z"
  }), e.createElement("ellipse", {
    cx: 12,
    cy: 9,
    rx: 2,
    ry: 7
  }));
}
var me = ["size", "color", "stroke"];
function ke(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, me);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-air-conditioning-disabled",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("rect", {
    x: 3,
    y: 8,
    width: 18,
    height: 8,
    rx: 2
  }), e.createElement("path", {
    d: "M7 16v-3a1 1 0 0 1 1 -1h8a1 1 0 0 1 1 1v3"
  }));
}
var we = ["size", "color", "stroke"];
function pe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, we);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-air-conditioning",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M8 16a3 3 0 0 1 -3 3"
  }), e.createElement("path", {
    d: "M16 16a3 3 0 0 0 3 3"
  }), e.createElement("path", {
    d: "M12 16v4"
  }), e.createElement("rect", {
    x: 3,
    y: 5,
    width: 18,
    height: 8,
    rx: 2
  }), e.createElement("path", {
    d: "M7 13v-3a1 1 0 0 1 1 -1h8a1 1 0 0 1 1 1v3"
  }));
}
var Ee = ["size", "color", "stroke"];
function ue(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Ee);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-alarm-minus",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("circle", {
    cx: 12,
    cy: 13,
    r: 7
  }), e.createElement("path", {
    d: "M7 4l-2.75 2"
  }), e.createElement("path", {
    d: "M17 4l2.75 2"
  }), e.createElement("path", {
    d: "M10 13h4"
  }));
}
var ge = ["size", "color", "stroke"];
function Me(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, ge);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-alarm-off",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M7.587 7.566a7 7 0 1 0 9.833 9.864m1.35 -2.645a7 7 0 0 0 -8.536 -8.56"
  }), e.createElement("path", {
    d: "M12 12v1h1"
  }), e.createElement("path", {
    d: "M5.261 5.265l-1.011 .735"
  }), e.createElement("path", {
    d: "M17 4l2.75 2"
  }), e.createElement("path", {
    d: "M3 3l18 18"
  }));
}
var xe = ["size", "color", "stroke"];
function fe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, xe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-alarm-plus",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("circle", {
    cx: 12,
    cy: 13,
    r: 7
  }), e.createElement("path", {
    d: "M7 4l-2.75 2"
  }), e.createElement("path", {
    d: "M17 4l2.75 2"
  }), e.createElement("path", {
    d: "M10 13h4"
  }), e.createElement("path", {
    d: "M12 11v4"
  }));
}
var ze = ["size", "color", "stroke"];
function be(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, ze);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-alarm-snooze",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("circle", {
    cx: 12,
    cy: 13,
    r: 7
  }), e.createElement("path", {
    d: "M10 11h4l-4 4h4"
  }), e.createElement("path", {
    d: "M7 4l-2.75 2"
  }), e.createElement("path", {
    d: "M17 4l2.75 2"
  }));
}
var Le = ["size", "color", "stroke"];
function ye(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Le);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-alarm",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("circle", {
    cx: 12,
    cy: 13,
    r: 7
  }), e.createElement("polyline", {
    points: "12 10 12 13 14 13"
  }), e.createElement("line", {
    x1: 7,
    y1: 4,
    x2: 4.25,
    y2: 6
  }), e.createElement("line", {
    x1: 17,
    y1: 4,
    x2: 19.75,
    y2: 6
  }));
}
var Ce = ["size", "color", "stroke"];
function je(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Ce);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-album-off",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M8 4h10a2 2 0 0 1 2 2v10m-.581 3.41c-.362 .364 -.864 .59 -1.419 .59h-12a2 2 0 0 1 -2 -2v-12c0 -.552 .224 -1.052 .585 -1.413"
  }), e.createElement("path", {
    d: "M12 4v4m1.503 1.497l.497 -.497l2 2v-7"
  }), e.createElement("path", {
    d: "M3 3l18 18"
  }));
}
var Be = ["size", "color", "stroke"];
function He(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Be);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-album",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("rect", {
    x: 4,
    y: 4,
    width: 16,
    height: 16,
    rx: 2
  }), e.createElement("path", {
    d: "M12 4v7l2 -2l2 2v-7"
  }));
}
var Ne = ["size", "color", "stroke"];
function We(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Ne);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-alert-circle",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 9
  }), e.createElement("line", {
    x1: 12,
    y1: 8,
    x2: 12,
    y2: 12
  }), e.createElement("line", {
    x1: 12,
    y1: 16,
    x2: 12.01,
    y2: 16
  }));
}
var qe = ["size", "color", "stroke"];
function Oe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, qe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-alert-octagon",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M8.7 3h6.6c.3 0 .5 .1 .7 .3l4.7 4.7c.2 .2 .3 .4 .3 .7v6.6c0 .3 -.1 .5 -.3 .7l-4.7 4.7c-.2 .2 -.4 .3 -.7 .3h-6.6c-.3 0 -.5 -.1 -.7 -.3l-4.7 -4.7c-.2 -.2 -.3 -.4 -.3 -.7v-6.6c0 -.3 .1 -.5 .3 -.7l4.7 -4.7c.2 -.2 .4 -.3 .7 -.3z"
  }), e.createElement("line", {
    x1: 12,
    y1: 8,
    x2: 12,
    y2: 12
  }), e.createElement("line", {
    x1: 12,
    y1: 16,
    x2: 12.01,
    y2: 16
  }));
}
var Pe = ["size", "color", "stroke"];
function Se(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Pe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-alert-triangle",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M12 9v2m0 4v.01"
  }), e.createElement("path", {
    d: "M5 19h14a2 2 0 0 0 1.84 -2.75l-7.1 -12.25a2 2 0 0 0 -3.5 0l-7.1 12.25a2 2 0 0 0 1.75 2.75"
  }));
}
var Ie = ["size", "color", "stroke"];
function Ae(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Ie);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-alien",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M11 17a2.5 2.5 0 0 0 2 0"
  }), e.createElement("path", {
    d: "M12 3c-4.664 0 -7.396 2.331 -7.862 5.595a11.816 11.816 0 0 0 2 8.592a10.777 10.777 0 0 0 3.199 3.064c1.666 1 3.664 1 5.33 0a10.777 10.777 0 0 0 3.199 -3.064a11.89 11.89 0 0 0 2 -8.592c-.466 -3.265 -3.198 -5.595 -7.862 -5.595z"
  }), e.createElement("line", {
    x1: 8,
    y1: 11,
    x2: 10,
    y2: 13
  }), e.createElement("line", {
    x1: 16,
    y1: 11,
    x2: 14,
    y2: 13
  }));
}
var De = ["size", "color", "stroke"];
function Fe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, De);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-align-box-bottom-center",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("rect", {
    x: 4,
    y: 4,
    width: 16,
    height: 16,
    rx: 2
  }), e.createElement("path", {
    d: "M9 15v2"
  }), e.createElement("path", {
    d: "M12 11v6"
  }), e.createElement("path", {
    d: "M15 13v4"
  }));
}
var Ge = ["size", "color", "stroke"];
function Je(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Ge);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-align-box-bottom-left",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("rect", {
    x: 4,
    y: 4,
    width: 16,
    height: 16,
    rx: 2
  }), e.createElement("path", {
    d: "M7 15v2"
  }), e.createElement("path", {
    d: "M10 11v6"
  }), e.createElement("path", {
    d: "M13 13v4"
  }));
}
var Ke = ["size", "color", "stroke"];
function Qe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Ke);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-align-box-bottom-right",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("rect", {
    x: 4,
    y: 4,
    width: 16,
    height: 16,
    rx: 2
  }), e.createElement("path", {
    d: "M11 15v2"
  }), e.createElement("path", {
    d: "M14 11v6"
  }), e.createElement("path", {
    d: "M17 13v4"
  }));
}
var Re = ["size", "color", "stroke"];
function Te(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Re);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-align-box-left-bottom",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M20 18.222v-12.444c0 -.982 -.796 -1.778 -1.778 -1.778h-12.444c-.982 0 -1.778 .796 -1.778 1.778v12.444c0 .982 .796 1.778 1.778 1.778h12.444c.982 0 1.778 -.796 1.778 -1.778z"
  }), e.createElement("path", {
    d: "M9 17h-2"
  }), e.createElement("path", {
    d: "M13 14h-6"
  }), e.createElement("path", {
    d: "M11 11h-4"
  }));
}
var Ue = ["size", "color", "stroke"];
function Ve(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Ue);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-align-box-left-middle",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M20 18.222v-12.444c0 -.982 -.796 -1.778 -1.778 -1.778h-12.444c-.982 0 -1.778 .796 -1.778 1.778v12.444c0 .982 .796 1.778 1.778 1.778h12.444c.982 0 1.778 -.796 1.778 -1.778z"
  }), e.createElement("path", {
    d: "M9 15h-2"
  }), e.createElement("path", {
    d: "M13 12h-6"
  }), e.createElement("path", {
    d: "M11 9h-4"
  }));
}
var Xe = ["size", "color", "stroke"];
function Ye(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Xe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-align-box-left-top",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M20 18.222v-12.444c0 -.982 -.796 -1.778 -1.778 -1.778h-12.444c-.982 0 -1.778 .796 -1.778 1.778v12.444c0 .982 .796 1.778 1.778 1.778h12.444c.982 0 1.778 -.796 1.778 -1.778z"
  }), e.createElement("path", {
    d: "M9 13h-2"
  }), e.createElement("path", {
    d: "M13 10h-6"
  }), e.createElement("path", {
    d: "M11 7h-4"
  }));
}
var Ze = ["size", "color", "stroke"];
function $e(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Ze);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-align-box-right-bottom",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M4 18.222v-12.444c0 -.982 .796 -1.778 1.778 -1.778h12.444c.982 0 1.778 .796 1.778 1.778v12.444c0 .982 -.796 1.778 -1.778 1.778h-12.444a1.778 1.778 0 0 1 -1.778 -1.778z"
  }), e.createElement("path", {
    d: "M15 17h2"
  }), e.createElement("path", {
    d: "M11 14h6"
  }), e.createElement("path", {
    d: "M13 11h4"
  }));
}
var _e = ["size", "color", "stroke"];
function et(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, _e);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-align-box-right-middle",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M4 18.222v-12.444c0 -.982 .796 -1.778 1.778 -1.778h12.444c.982 0 1.778 .796 1.778 1.778v12.444c0 .982 -.796 1.778 -1.778 1.778h-12.444a1.778 1.778 0 0 1 -1.778 -1.778z"
  }), e.createElement("path", {
    d: "M15 15h2"
  }), e.createElement("path", {
    d: "M11 12h6"
  }), e.createElement("path", {
    d: "M13 9h4"
  }));
}
var tt = ["size", "color", "stroke"];
function ot(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, tt);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-align-box-right-top",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M4 18.222v-12.444c0 -.982 .796 -1.778 1.778 -1.778h12.444c.982 0 1.778 .796 1.778 1.778v12.444c0 .982 -.796 1.778 -1.778 1.778h-12.444a1.778 1.778 0 0 1 -1.778 -1.778z"
  }), e.createElement("path", {
    d: "M15 13h2"
  }), e.createElement("path", {
    d: "M11 10h6"
  }), e.createElement("path", {
    d: "M13 7h4"
  }));
}
var rt = ["size", "color", "stroke"];
function nt(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, rt);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-align-box-top-center",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M5.778 20h12.444c.982 0 1.778 -.796 1.778 -1.778v-12.444c0 -.982 -.796 -1.778 -1.778 -1.778h-12.444c-.982 0 -1.778 .796 -1.778 1.778v12.444c0 .982 .796 1.778 1.778 1.778z"
  }), e.createElement("path", {
    d: "M9 9v-2"
  }), e.createElement("path", {
    d: "M12 13v-6"
  }), e.createElement("path", {
    d: "M15 11v-4"
  }));
}
var lt = ["size", "color", "stroke"];
function at(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, lt);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-align-box-top-left",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M5.778 20h12.444c.982 0 1.778 -.796 1.778 -1.778v-12.444c0 -.982 -.796 -1.778 -1.778 -1.778h-12.444c-.982 0 -1.778 .796 -1.778 1.778v12.444c0 .982 .796 1.778 1.778 1.778z"
  }), e.createElement("path", {
    d: "M7 9v-2"
  }), e.createElement("path", {
    d: "M10 13v-6"
  }), e.createElement("path", {
    d: "M13 11v-4"
  }));
}
var it = ["size", "color", "stroke"];
function ct(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, it);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-align-box-top-right",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M5.778 20h12.444c.982 0 1.778 -.796 1.778 -1.778v-12.444c0 -.982 -.796 -1.778 -1.778 -1.778h-12.444c-.982 0 -1.778 .796 -1.778 1.778v12.444c0 .982 .796 1.778 1.778 1.778z"
  }), e.createElement("path", {
    d: "M11 9v-2"
  }), e.createElement("path", {
    d: "M14 13v-6"
  }), e.createElement("path", {
    d: "M17 11v-4"
  }));
}
var st = ["size", "color", "stroke"];
function ht(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, st);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-align-center",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("line", {
    x1: 4,
    y1: 6,
    x2: 20,
    y2: 6
  }), e.createElement("line", {
    x1: 8,
    y1: 12,
    x2: 16,
    y2: 12
  }), e.createElement("line", {
    x1: 6,
    y1: 18,
    x2: 18,
    y2: 18
  }));
}
var dt = ["size", "color", "stroke"];
function vt(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, dt);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-align-justified",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("line", {
    x1: 4,
    y1: 6,
    x2: 20,
    y2: 6
  }), e.createElement("line", {
    x1: 4,
    y1: 12,
    x2: 20,
    y2: 12
  }), e.createElement("line", {
    x1: 4,
    y1: 18,
    x2: 16,
    y2: 18
  }));
}
var mt = ["size", "color", "stroke"];
function kt(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, mt);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-align-left",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("line", {
    x1: 4,
    y1: 6,
    x2: 20,
    y2: 6
  }), e.createElement("line", {
    x1: 4,
    y1: 12,
    x2: 14,
    y2: 12
  }), e.createElement("line", {
    x1: 4,
    y1: 18,
    x2: 18,
    y2: 18
  }));
}
var wt = ["size", "color", "stroke"];
function pt(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, wt);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-align-right",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("line", {
    x1: 4,
    y1: 6,
    x2: 20,
    y2: 6
  }), e.createElement("line", {
    x1: 10,
    y1: 12,
    x2: 20,
    y2: 12
  }), e.createElement("line", {
    x1: 6,
    y1: 18,
    x2: 20,
    y2: 18
  }));
}
var Et = ["size", "color", "stroke"];
function ut(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Et);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-alpha",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M18.1 6c-1.1 2.913 -1.9 4.913 -2.4 6c-1.879 4.088 -3.713 6 -6 6c-2.4 0 -4.8 -2.4 -4.8 -6s2.4 -6 4.8 -6c2.267 0 4.135 1.986 6 6c.512 1.102 1.312 3.102 2.4 6"
  }));
}
var gt = ["size", "color", "stroke"];
function Mt(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, gt);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-alphabet-cyrillic",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M6 10h2a2 2 0 0 1 2 2v5h-3a2 2 0 1 1 0 -4h3"
  }), e.createElement("path", {
    d: "M19 7h-3a2 2 0 0 0 -2 2v6a2 2 0 0 0 2 2h1a2 2 0 0 0 2 -2v-3a2 2 0 0 0 -2 -2h-3"
  }));
}
var xt = ["size", "color", "stroke"];
function ft(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, xt);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-alphabet-greek",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M10 10v7"
  }), e.createElement("rect", {
    x: 5,
    y: 10,
    width: 5,
    height: 7,
    rx: 2
  }), e.createElement("path", {
    d: "M14 20v-11a2 2 0 0 1 2 -2h1a2 2 0 0 1 2 2v1a2 2 0 0 1 -2 2a2 2 0 0 1 2 2v1a2 2 0 0 1 -2 2"
  }));
}
var zt = ["size", "color", "stroke"];
function bt(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, zt);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-alphabet-latin",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M6 10h2a2 2 0 0 1 2 2v5h-3a2 2 0 1 1 0 -4h3"
  }), e.createElement("path", {
    d: "M14 7v10"
  }), e.createElement("rect", {
    x: 14,
    y: 10,
    width: 5,
    height: 7,
    rx: 2
  }));
}
var Lt = ["size", "color", "stroke"];
function yt(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Lt);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-ambulance",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("circle", {
    cx: 7,
    cy: 17,
    r: 2
  }), e.createElement("circle", {
    cx: 17,
    cy: 17,
    r: 2
  }), e.createElement("path", {
    d: "M5 17h-2v-11a1 1 0 0 1 1 -1h9v12m-4 0h6m4 0h2v-6h-8m0 -5h5l3 5"
  }), e.createElement("path", {
    d: "M6 10h4m-2 -2v4"
  }));
}
var Ct = ["size", "color", "stroke"];
function jt(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Ct);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-ampersand",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M19 20l-10.403 -10.972a2.948 2.948 0 0 1 0 -4.165a2.94 2.94 0 0 1 4.161 0a2.948 2.948 0 0 1 0 4.165l-4.68 4.687a3.685 3.685 0 0 0 0 5.207a3.675 3.675 0 0 0 5.2 0l5.722 -5.922"
  }));
}
var Bt = ["size", "color", "stroke"];
function Ht(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Bt);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-analyze-off",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M20 11a8.1 8.1 0 0 0 -6.986 -6.918a8.086 8.086 0 0 0 -4.31 .62m-2.383 1.608a8.089 8.089 0 0 0 -1.326 1.69"
  }), e.createElement("path", {
    d: "M4 13a8.1 8.1 0 0 0 13.687 4.676"
  }), e.createElement("path", {
    d: "M20 16a1 1 0 0 0 -1 -1"
  }), e.createElement("circle", {
    cx: 5,
    cy: 8,
    r: 1
  }), e.createElement("path", {
    d: "M9.888 9.87a3 3 0 1 0 4.233 4.252m.595 -3.397a3.012 3.012 0 0 0 -1.426 -1.435"
  }), e.createElement("path", {
    d: "M3 3l18 18"
  }));
}
var Nt = ["size", "color", "stroke"];
function Wt(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Nt);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-analyze",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M20 11a8.1 8.1 0 0 0 -6.986 -6.918a8.095 8.095 0 0 0 -8.019 3.918"
  }), e.createElement("path", {
    d: "M4 13a8.1 8.1 0 0 0 15.001 2.998"
  }), e.createElement("circle", {
    cx: 19,
    cy: 16,
    r: 1
  }), e.createElement("circle", {
    cx: 5,
    cy: 8,
    r: 1
  }), e.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 3
  }));
}
var qt = ["size", "color", "stroke"];
function Ot(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, qt);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-anchor-off",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M12 12v9"
  }), e.createElement("path", {
    d: "M4 13a8 8 0 0 0 14.138 5.13m1.44 -2.56a7.99 7.99 0 0 0 .422 -2.57"
  }), e.createElement("path", {
    d: "M21 13h-2"
  }), e.createElement("path", {
    d: "M5 13h-2"
  }), e.createElement("path", {
    d: "M12.866 8.873a3.001 3.001 0 1 0 -3.737 -3.747"
  }), e.createElement("path", {
    d: "M3 3l18 18"
  }));
}
var Pt = ["size", "color", "stroke"];
function St(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Pt);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-anchor",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M12 9v12m-8 -8a8 8 0 0 0 16 0m1 0h-2m-14 0h-2"
  }), e.createElement("circle", {
    cx: 12,
    cy: 6,
    r: 3
  }));
}
var It = ["size", "color", "stroke"];
function At(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, It);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-angle",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M21 19h-18l9 -15"
  }), e.createElement("path", {
    d: "M20.615 15.171h.015"
  }), e.createElement("path", {
    d: "M19.515 11.771h.015"
  }), e.createElement("path", {
    d: "M17.715 8.671h.015"
  }), e.createElement("path", {
    d: "M15.415 5.971h.015"
  }));
}
var Dt = ["size", "color", "stroke"];
function Ft(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Dt);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-ankh",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M6 13h12"
  }), e.createElement("path", {
    d: "M12 21v-8l-.422 -.211a6.472 6.472 0 0 1 -3.578 -5.789a4 4 0 1 1 8 0a6.472 6.472 0 0 1 -3.578 5.789l-.422 .211"
  }));
}
var Gt = ["size", "color", "stroke"];
function Jt(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Gt);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-antenna-bars-1",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("line", {
    x1: 6,
    y1: 18,
    x2: 6,
    y2: 18.01
  }), e.createElement("line", {
    x1: 10,
    y1: 18,
    x2: 10,
    y2: 18.01
  }), e.createElement("line", {
    x1: 14,
    y1: 18,
    x2: 14,
    y2: 18.01
  }), e.createElement("line", {
    x1: 18,
    y1: 18,
    x2: 18,
    y2: 18.01
  }));
}
var Kt = ["size", "color", "stroke"];
function Qt(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Kt);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-antenna-bars-2",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("line", {
    x1: 6,
    y1: 18,
    x2: 6,
    y2: 15
  }), e.createElement("line", {
    x1: 10,
    y1: 18,
    x2: 10,
    y2: 18.01
  }), e.createElement("line", {
    x1: 14,
    y1: 18,
    x2: 14,
    y2: 18.01
  }), e.createElement("line", {
    x1: 18,
    y1: 18,
    x2: 18,
    y2: 18.01
  }));
}
var Rt = ["size", "color", "stroke"];
function Tt(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Rt);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-antenna-bars-3",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("line", {
    x1: 6,
    y1: 18,
    x2: 6,
    y2: 15
  }), e.createElement("line", {
    x1: 10,
    y1: 18,
    x2: 10,
    y2: 12
  }), e.createElement("line", {
    x1: 14,
    y1: 18,
    x2: 14,
    y2: 18.01
  }), e.createElement("line", {
    x1: 18,
    y1: 18,
    x2: 18,
    y2: 18.01
  }));
}
var Ut = ["size", "color", "stroke"];
function Vt(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Ut);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-antenna-bars-4",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("line", {
    x1: 6,
    y1: 18,
    x2: 6,
    y2: 15
  }), e.createElement("line", {
    x1: 10,
    y1: 18,
    x2: 10,
    y2: 12
  }), e.createElement("line", {
    x1: 14,
    y1: 18,
    x2: 14,
    y2: 9
  }), e.createElement("line", {
    x1: 18,
    y1: 18,
    x2: 18,
    y2: 18.01
  }));
}
var Xt = ["size", "color", "stroke"];
function Yt(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Xt);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-antenna-bars-5",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("line", {
    x1: 6,
    y1: 18,
    x2: 6,
    y2: 15
  }), e.createElement("line", {
    x1: 10,
    y1: 18,
    x2: 10,
    y2: 12
  }), e.createElement("line", {
    x1: 14,
    y1: 18,
    x2: 14,
    y2: 9
  }), e.createElement("line", {
    x1: 18,
    y1: 18,
    x2: 18,
    y2: 6
  }));
}
var Zt = ["size", "color", "stroke"];
function $t(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Zt);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-antenna-bars-off",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M6 18v-3"
  }), e.createElement("path", {
    d: "M10 18v-6"
  }), e.createElement("path", {
    d: "M14 18v-4"
  }), e.createElement("path", {
    d: "M14 10v-1"
  }), e.createElement("path", {
    d: "M18 14v-8"
  }), e.createElement("path", {
    d: "M3 3l18 18"
  }));
}
var _t = ["size", "color", "stroke"];
function eo(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, _t);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-antenna-off",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M20 4v8"
  }), e.createElement("path", {
    d: "M16 4.5v7"
  }), e.createElement("path", {
    d: "M12 5v3m0 4v9"
  }), e.createElement("path", {
    d: "M8 8v2.5"
  }), e.createElement("path", {
    d: "M4 6v4"
  }), e.createElement("path", {
    d: "M20 8h-8m-4 0h-4"
  }), e.createElement("path", {
    d: "M3 3l18 18"
  }));
}
var to = ["size", "color", "stroke"];
function oo(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, to);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-antenna",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M20 4v8"
  }), e.createElement("path", {
    d: "M16 4.5v7"
  }), e.createElement("path", {
    d: "M12 5v16"
  }), e.createElement("path", {
    d: "M8 5.5v5"
  }), e.createElement("path", {
    d: "M4 6v4"
  }), e.createElement("path", {
    d: "M20 8h-16"
  }));
}
var ro = ["size", "color", "stroke"];
function no(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, ro);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-aperture-off",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M3.6 15h10.55"
  }), e.createElement("path", {
    d: "M5.641 5.631a9 9 0 1 0 12.719 12.738m1.68 -2.318a9 9 0 0 0 -12.074 -12.098"
  }), e.createElement("path", {
    d: "M7.395 7.534l2.416 7.438"
  }), e.createElement("path", {
    d: "M17.032 4.636l-4.852 3.526m-2.334 1.695l-1.349 .98"
  }), e.createElement("path", {
    d: "M20.559 14.51l-8.535 -6.201"
  }), e.createElement("path", {
    d: "M12.257 20.916l2.123 -6.533m.984 -3.028l.154 -.473"
  }), e.createElement("path", {
    d: "M3 3l18 18"
  }));
}
var lo = ["size", "color", "stroke"];
function ao(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, lo);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-aperture",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 9
  }), e.createElement("path", {
    d: "M3.6 15h10.55"
  }), e.createElement("path", {
    d: "M6.551 4.938l3.26 10.034"
  }), e.createElement("path", {
    d: "M17.032 4.636l-8.535 6.201"
  }), e.createElement("path", {
    d: "M20.559 14.51l-8.535 -6.201"
  }), e.createElement("path", {
    d: "M12.257 20.916l3.261 -10.034"
  }));
}
var io = ["size", "color", "stroke"];
function co(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, io);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-api-app-off",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M12 15h-6.5a2.5 2.5 0 1 1 0 -5h.5"
  }), e.createElement("path", {
    d: "M15 15v3.5a2.5 2.5 0 1 1 -5 0v-.5"
  }), e.createElement("path", {
    d: "M13 9h5.5a2.5 2.5 0 1 1 0 5h-.5"
  }), e.createElement("path", {
    d: "M9 12v-3m.042 -3.957a2.5 2.5 0 0 1 4.958 .457v.5"
  }), e.createElement("path", {
    d: "M3 3l18 18"
  }));
}
var so = ["size", "color", "stroke"];
function ho(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, so);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-api-app",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M12 15h-6.5a2.5 2.5 0 1 1 0 -5h.5"
  }), e.createElement("path", {
    d: "M15 12v6.5a2.5 2.5 0 1 1 -5 0v-.5"
  }), e.createElement("path", {
    d: "M12 9h6.5a2.5 2.5 0 1 1 0 5h-.5"
  }), e.createElement("path", {
    d: "M9 12v-6.5a2.5 2.5 0 0 1 5 0v.5"
  }));
}
var vo = ["size", "color", "stroke"];
function mo(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, vo);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-api-off",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M4 13h5"
  }), e.createElement("path", {
    d: "M12 16v-4m0 -4h3a2 2 0 0 1 2 2v1c0 .554 -.225 1.055 -.589 1.417m-3.411 .583h-1"
  }), e.createElement("path", {
    d: "M20 8v8"
  }), e.createElement("path", {
    d: "M9 16v-5.5a2.5 2.5 0 0 0 -5 0v5.5"
  }), e.createElement("path", {
    d: "M3 3l18 18"
  }));
}
var ko = ["size", "color", "stroke"];
function wo(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, ko);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-api",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M4 13h5"
  }), e.createElement("path", {
    d: "M12 16v-8h3a2 2 0 0 1 2 2v1a2 2 0 0 1 -2 2h-3"
  }), e.createElement("path", {
    d: "M20 8v8"
  }), e.createElement("path", {
    d: "M9 16v-5.5a2.5 2.5 0 0 0 -5 0v5.5"
  }));
}
var po = ["size", "color", "stroke"];
function Eo(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, po);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-app-window",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("rect", {
    x: 3,
    y: 5,
    width: 18,
    height: 14,
    rx: 2
  }), e.createElement("path", {
    d: "M6 8h.01"
  }), e.createElement("path", {
    d: "M9 8h.01"
  }));
}
var uo = ["size", "color", "stroke"];
function go(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, uo);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-apple",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("circle", {
    cx: 12,
    cy: 14,
    r: 7
  }), e.createElement("path", {
    d: "M12 11v-6a2 2 0 0 1 2 -2h2v1a2 2 0 0 1 -2 2h-2"
  }), e.createElement("path", {
    d: "M10 10.5c1.333 .667 2.667 .667 4 0"
  }));
}
var Mo = ["size", "color", "stroke"];
function xo(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Mo);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-apps-off",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M8 4h1a1 1 0 0 1 1 1v1m-.29 3.704a0.997 .997 0 0 1 -.71 .296h-4a1 1 0 0 1 -1 -1v-4c0 -.276 .111 -.525 .292 -.706"
  }), e.createElement("path", {
    d: "M18 14h1a1 1 0 0 1 1 1v1m-.29 3.704a0.997 .997 0 0 1 -.71 .296h-4a1 1 0 0 1 -1 -1v-4c0 -.276 .111 -.525 .292 -.706"
  }), e.createElement("rect", {
    x: 4,
    y: 14,
    width: 6,
    height: 6,
    rx: 1
  }), e.createElement("path", {
    d: "M14 7h6"
  }), e.createElement("path", {
    d: "M17 4v6"
  }), e.createElement("path", {
    d: "M3 3l18 18"
  }));
}
var fo = ["size", "color", "stroke"];
function zo(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, fo);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-apps",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("rect", {
    x: 4,
    y: 4,
    width: 6,
    height: 6,
    rx: 1
  }), e.createElement("rect", {
    x: 4,
    y: 14,
    width: 6,
    height: 6,
    rx: 1
  }), e.createElement("rect", {
    x: 14,
    y: 14,
    width: 6,
    height: 6,
    rx: 1
  }), e.createElement("line", {
    x1: 14,
    y1: 7,
    x2: 20,
    y2: 7
  }), e.createElement("line", {
    x1: 17,
    y1: 4,
    x2: 17,
    y2: 10
  }));
}
var bo = ["size", "color", "stroke"];
function Lo(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, bo);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-archive-off",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M8 4h11a2 2 0 1 1 0 4h-7m-4 0h-3a2 2 0 0 1 -.826 -3.822"
  }), e.createElement("path", {
    d: "M5 8v10a2 2 0 0 0 2 2h10a2 2 0 0 0 1.824 -1.18m.176 -3.82v-7"
  }), e.createElement("path", {
    d: "M10 12h2"
  }), e.createElement("path", {
    d: "M3 3l18 18"
  }));
}
var yo = ["size", "color", "stroke"];
function Co(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, yo);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-archive",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("rect", {
    x: 3,
    y: 4,
    width: 18,
    height: 4,
    rx: 2
  }), e.createElement("path", {
    d: "M5 8v10a2 2 0 0 0 2 2h10a2 2 0 0 0 2 -2v-10"
  }), e.createElement("line", {
    x1: 10,
    y1: 12,
    x2: 14,
    y2: 12
  }));
}
var jo = ["size", "color", "stroke"];
function Bo(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, jo);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-armchair-2-off",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M5 10v-4a3 3 0 0 1 .128 -.869m2.038 -2.013c.264 -.078 .544 -.118 .834 -.118h8a3 3 0 0 1 3 3v4"
  }), e.createElement("path", {
    d: "M16.124 12.145a3.001 3.001 0 1 1 3.756 3.724m-.88 3.131h-14v-3a3 3 0 1 1 3 -3v2"
  }), e.createElement("path", {
    d: "M8 12h4"
  }), e.createElement("path", {
    d: "M7 19v2"
  }), e.createElement("path", {
    d: "M17 19v2"
  }), e.createElement("path", {
    d: "M3 3l18 18"
  }));
}
var Ho = ["size", "color", "stroke"];
function No(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Ho);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-armchair-2",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M5 10v-4a3 3 0 0 1 3 -3h8a3 3 0 0 1 3 3v4"
  }), e.createElement("path", {
    d: "M16 15v-2a3 3 0 1 1 3 3v3h-14v-3a3 3 0 1 1 3 -3v2"
  }), e.createElement("path", {
    d: "M8 12h8"
  }), e.createElement("path", {
    d: "M7 19v2"
  }), e.createElement("path", {
    d: "M17 19v2"
  }));
}
var Wo = ["size", "color", "stroke"];
function qo(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Wo);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-armchair-off",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M17 13a2 2 0 1 1 4 0v4m-2 2h-14a2 2 0 0 1 -2 -2v-4a2 2 0 1 1 4 0v2h8.036"
  }), e.createElement("path", {
    d: "M5 11v-5a3 3 0 0 1 .134 -.89m1.987 -1.98a3 3 0 0 1 .879 -.13h8a3 3 0 0 1 3 3v5"
  }), e.createElement("path", {
    d: "M6 19v2"
  }), e.createElement("path", {
    d: "M18 19v2"
  }), e.createElement("path", {
    d: "M3 3l18 18"
  }));
}
var Oo = ["size", "color", "stroke"];
function Po(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Oo);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-armchair",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M5 11a2 2 0 0 1 2 2v2h10v-2a2 2 0 1 1 4 0v4a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2v-4a2 2 0 0 1 2 -2z"
  }), e.createElement("path", {
    d: "M5 11v-5a3 3 0 0 1 3 -3h8a3 3 0 0 1 3 3v5"
  }), e.createElement("path", {
    d: "M6 19v2"
  }), e.createElement("path", {
    d: "M18 19v2"
  }));
}
var So = ["size", "color", "stroke"];
function Io(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, So);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-arrow-autofit-content",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M6 4l-3 3l3 3"
  }), e.createElement("path", {
    d: "M18 4l3 3l-3 3"
  }), e.createElement("rect", {
    x: 4,
    y: 14,
    width: 16,
    height: 6,
    rx: 2
  }), e.createElement("path", {
    d: "M10 7h-7"
  }), e.createElement("path", {
    d: "M21 7h-7"
  }));
}
var Ao = ["size", "color", "stroke"];
function Do(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Ao);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-arrow-autofit-down",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M12 20h-6a2 2 0 0 1 -2 -2v-12a2 2 0 0 1 2 -2h8"
  }), e.createElement("path", {
    d: "M18 4v17"
  }), e.createElement("path", {
    d: "M15 18l3 3l3 -3"
  }));
}
var Fo = ["size", "color", "stroke"];
function Go(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Fo);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-arrow-autofit-height",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M12 20h-6a2 2 0 0 1 -2 -2v-12a2 2 0 0 1 2 -2h6"
  }), e.createElement("path", {
    d: "M18 14v7"
  }), e.createElement("path", {
    d: "M18 3v7"
  }), e.createElement("path", {
    d: "M15 18l3 3l3 -3"
  }), e.createElement("path", {
    d: "M15 6l3 -3l3 3"
  }));
}
var Jo = ["size", "color", "stroke"];
function Ko(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Jo);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-arrow-autofit-left",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M4 12v-6a2 2 0 0 1 2 -2h12a2 2 0 0 1 2 2v8"
  }), e.createElement("path", {
    d: "M20 18h-17"
  }), e.createElement("path", {
    d: "M6 15l-3 3l3 3"
  }));
}
var Qo = ["size", "color", "stroke"];
function Ro(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Qo);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-arrow-autofit-right",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M20 12v-6a2 2 0 0 0 -2 -2h-12a2 2 0 0 0 -2 2v8"
  }), e.createElement("path", {
    d: "M4 18h17"
  }), e.createElement("path", {
    d: "M18 15l3 3l-3 3"
  }));
}
var To = ["size", "color", "stroke"];
function Uo(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, To);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-arrow-autofit-up",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M12 4h-6a2 2 0 0 0 -2 2v12a2 2 0 0 0 2 2h8"
  }), e.createElement("path", {
    d: "M18 20v-17"
  }), e.createElement("path", {
    d: "M15 6l3 -3l3 3"
  }));
}
var Vo = ["size", "color", "stroke"];
function Xo(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Vo);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-arrow-autofit-width",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M4 12v-6a2 2 0 0 1 2 -2h12a2 2 0 0 1 2 2v6"
  }), e.createElement("path", {
    d: "M10 18h-7"
  }), e.createElement("path", {
    d: "M21 18h-7"
  }), e.createElement("path", {
    d: "M6 15l-3 3l3 3"
  }), e.createElement("path", {
    d: "M18 15l3 3l-3 3"
  }));
}
var Yo = ["size", "color", "stroke"];
function Zo(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Yo);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-arrow-back-up",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M9 13l-4 -4l4 -4m-4 4h11a4 4 0 0 1 0 8h-1"
  }));
}
var $o = ["size", "color", "stroke"];
function _o(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, $o);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-arrow-back",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M9 11l-4 4l4 4m-4 -4h11a4 4 0 0 0 0 -8h-1"
  }));
}
var er = ["size", "color", "stroke"];
function tr(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, er);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-arrow-badge-down",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M17 13v-6l-5 4l-5 -4v6l5 4z"
  }));
}
var or = ["size", "color", "stroke"];
function rr(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, or);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-arrow-badge-left",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M11 17h6l-4 -5l4 -5h-6l-4 5z"
  }));
}
var nr = ["size", "color", "stroke"];
function lr(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, nr);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-arrow-badge-right",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M13 7h-6l4 5l-4 5h6l4 -5z"
  }));
}
var ar = ["size", "color", "stroke"];
function ir(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, ar);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-arrow-badge-up",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M17 11v6l-5 -4l-5 4v-6l5 -4z"
  }));
}
var cr = ["size", "color", "stroke"];
function sr(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, cr);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-arrow-bar-down",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("line", {
    x1: 12,
    y1: 20,
    x2: 12,
    y2: 10
  }), e.createElement("line", {
    x1: 12,
    y1: 20,
    x2: 16,
    y2: 16
  }), e.createElement("line", {
    x1: 12,
    y1: 20,
    x2: 8,
    y2: 16
  }), e.createElement("line", {
    x1: 4,
    y1: 4,
    x2: 20,
    y2: 4
  }));
}
var hr = ["size", "color", "stroke"];
function dr(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, hr);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-arrow-bar-left",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("line", {
    x1: 4,
    y1: 12,
    x2: 14,
    y2: 12
  }), e.createElement("line", {
    x1: 4,
    y1: 12,
    x2: 8,
    y2: 16
  }), e.createElement("line", {
    x1: 4,
    y1: 12,
    x2: 8,
    y2: 8
  }), e.createElement("line", {
    x1: 20,
    y1: 4,
    x2: 20,
    y2: 20
  }));
}
var vr = ["size", "color", "stroke"];
function mr(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, vr);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-arrow-bar-right",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("line", {
    x1: 20,
    y1: 12,
    x2: 10,
    y2: 12
  }), e.createElement("line", {
    x1: 20,
    y1: 12,
    x2: 16,
    y2: 16
  }), e.createElement("line", {
    x1: 20,
    y1: 12,
    x2: 16,
    y2: 8
  }), e.createElement("line", {
    x1: 4,
    y1: 4,
    x2: 4,
    y2: 20
  }));
}
var kr = ["size", "color", "stroke"];
function wr(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, kr);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-arrow-bar-to-down",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("line", {
    x1: 4,
    y1: 20,
    x2: 20,
    y2: 20
  }), e.createElement("line", {
    x1: 12,
    y1: 14,
    x2: 12,
    y2: 4
  }), e.createElement("line", {
    x1: 12,
    y1: 14,
    x2: 16,
    y2: 10
  }), e.createElement("line", {
    x1: 12,
    y1: 14,
    x2: 8,
    y2: 10
  }));
}
var pr = ["size", "color", "stroke"];
function Er(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, pr);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-arrow-bar-to-left",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("line", {
    x1: 10,
    y1: 12,
    x2: 20,
    y2: 12
  }), e.createElement("line", {
    x1: 10,
    y1: 12,
    x2: 14,
    y2: 16
  }), e.createElement("line", {
    x1: 10,
    y1: 12,
    x2: 14,
    y2: 8
  }), e.createElement("line", {
    x1: 4,
    y1: 4,
    x2: 4,
    y2: 20
  }));
}
var ur = ["size", "color", "stroke"];
function gr(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, ur);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-arrow-bar-to-right",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("line", {
    x1: 14,
    y1: 12,
    x2: 4,
    y2: 12
  }), e.createElement("line", {
    x1: 14,
    y1: 12,
    x2: 10,
    y2: 16
  }), e.createElement("line", {
    x1: 14,
    y1: 12,
    x2: 10,
    y2: 8
  }), e.createElement("line", {
    x1: 20,
    y1: 4,
    x2: 20,
    y2: 20
  }));
}
var Mr = ["size", "color", "stroke"];
function xr(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Mr);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-arrow-bar-to-up",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("line", {
    x1: 12,
    y1: 10,
    x2: 12,
    y2: 20
  }), e.createElement("line", {
    x1: 12,
    y1: 10,
    x2: 16,
    y2: 14
  }), e.createElement("line", {
    x1: 12,
    y1: 10,
    x2: 8,
    y2: 14
  }), e.createElement("line", {
    x1: 4,
    y1: 4,
    x2: 20,
    y2: 4
  }));
}
var fr = ["size", "color", "stroke"];
function zr(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, fr);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-arrow-bar-up",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("line", {
    x1: 12,
    y1: 4,
    x2: 12,
    y2: 14
  }), e.createElement("line", {
    x1: 12,
    y1: 4,
    x2: 16,
    y2: 8
  }), e.createElement("line", {
    x1: 12,
    y1: 4,
    x2: 8,
    y2: 8
  }), e.createElement("line", {
    x1: 4,
    y1: 20,
    x2: 20,
    y2: 20
  }));
}
var br = ["size", "color", "stroke"];
function Lr(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, br);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-arrow-bear-left-2",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M9 3h-5v5"
  }), e.createElement("path", {
    d: "M4 3l7.536 7.536a5 5 0 0 1 1.464 3.534v6.93"
  }), e.createElement("path", {
    d: "M20 5l-4.5 4.5"
  }));
}
var yr = ["size", "color", "stroke"];
function Cr(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, yr);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-arrow-bear-left",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M13 3h-5v5"
  }), e.createElement("path", {
    d: "M8 3l7.536 7.536a5 5 0 0 1 1.464 3.534v6.93"
  }));
}
var jr = ["size", "color", "stroke"];
function Br(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, jr);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-arrow-bear-right-2",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M15 3h5v5"
  }), e.createElement("path", {
    d: "M20 3l-7.536 7.536a5 5 0 0 0 -1.464 3.534v6.93"
  }), e.createElement("path", {
    d: "M4 5l4.5 4.5"
  }));
}
var Hr = ["size", "color", "stroke"];
function Nr(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Hr);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-arrow-bear-right",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M12 3h5v5"
  }), e.createElement("path", {
    d: "M17 3l-7.536 7.536a5 5 0 0 0 -1.464 3.534v6.93"
  }));
}
var Wr = ["size", "color", "stroke"];
function qr(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Wr);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-arrow-big-down-line",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M15 12h3.586a1 1 0 0 1 .707 1.707l-6.586 6.586a1 1 0 0 1 -1.414 0l-6.586 -6.586a1 1 0 0 1 .707 -1.707h3.586v-6h6v6z"
  }), e.createElement("path", {
    d: "M15 3h-6"
  }));
}
var Or = ["size", "color", "stroke"];
function Pr(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Or);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-arrow-big-down-lines",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M15 12h3.586a1 1 0 0 1 .707 1.707l-6.586 6.586a1 1 0 0 1 -1.414 0l-6.586 -6.586a1 1 0 0 1 .707 -1.707h3.586v-3h6v3z"
  }), e.createElement("path", {
    d: "M15 3h-6"
  }), e.createElement("path", {
    d: "M15 6h-6"
  }));
}
var Sr = ["size", "color", "stroke"];
function Ir(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Sr);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-arrow-big-down",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M15 4v8h3.586a1 1 0 0 1 .707 1.707l-6.586 6.586a1 1 0 0 1 -1.414 0l-6.586 -6.586a1 1 0 0 1 .707 -1.707h3.586v-8a1 1 0 0 1 1 -1h4a1 1 0 0 1 1 1z"
  }));
}
var Ar = ["size", "color", "stroke"];
function Dr(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Ar);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-arrow-big-left-line",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M12 15v3.586a1 1 0 0 1 -1.707 .707l-6.586 -6.586a1 1 0 0 1 0 -1.414l6.586 -6.586a1 1 0 0 1 1.707 .707v3.586h6v6h-6z"
  }), e.createElement("path", {
    d: "M21 15v-6"
  }));
}
var Fr = ["size", "color", "stroke"];
function Gr(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Fr);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-arrow-big-left-lines",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M12 15v3.586a1 1 0 0 1 -1.707 .707l-6.586 -6.586a1 1 0 0 1 0 -1.414l6.586 -6.586a1 1 0 0 1 1.707 .707v3.586h3v6h-3z"
  }), e.createElement("path", {
    d: "M21 15v-6"
  }), e.createElement("path", {
    d: "M18 15v-6"
  }));
}
var Jr = ["size", "color", "stroke"];
function Kr(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Jr);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-arrow-big-left",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M20 15h-8v3.586a1 1 0 0 1 -1.707 .707l-6.586 -6.586a1 1 0 0 1 0 -1.414l6.586 -6.586a1 1 0 0 1 1.707 .707v3.586h8a1 1 0 0 1 1 1v4a1 1 0 0 1 -1 1z"
  }));
}
var Qr = ["size", "color", "stroke"];
function Rr(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Qr);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-arrow-big-right-line",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M12 9v-3.586a1 1 0 0 1 1.707 -.707l6.586 6.586a1 1 0 0 1 0 1.414l-6.586 6.586a1 1 0 0 1 -1.707 -.707v-3.586h-6v-6h6z"
  }), e.createElement("path", {
    d: "M3 9v6"
  }));
}
var Tr = ["size", "color", "stroke"];
function Ur(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Tr);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-arrow-big-right-lines",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M12 9v-3.586a1 1 0 0 1 1.707 -.707l6.586 6.586a1 1 0 0 1 0 1.414l-6.586 6.586a1 1 0 0 1 -1.707 -.707v-3.586h-3v-6h3z"
  }), e.createElement("path", {
    d: "M3 9v6"
  }), e.createElement("path", {
    d: "M6 9v6"
  }));
}
var Vr = ["size", "color", "stroke"];
function Xr(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Vr);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-arrow-big-right",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M4 9h8v-3.586a1 1 0 0 1 1.707 -.707l6.586 6.586a1 1 0 0 1 0 1.414l-6.586 6.586a1 1 0 0 1 -1.707 -.707v-3.586h-8a1 1 0 0 1 -1 -1v-4a1 1 0 0 1 1 -1z"
  }));
}
var Yr = ["size", "color", "stroke"];
function Zr(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Yr);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-arrow-big-top",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M9 20v-8h-3.586a1 1 0 0 1 -.707 -1.707l6.586 -6.586a1 1 0 0 1 1.414 0l6.586 6.586a1 1 0 0 1 -.707 1.707h-3.586v8a1 1 0 0 1 -1 1h-4a1 1 0 0 1 -1 -1z"
  }));
}
var $r = ["size", "color", "stroke"];
function _r(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, $r);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-arrow-big-up-line",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M9 12h-3.586a1 1 0 0 1 -.707 -1.707l6.586 -6.586a1 1 0 0 1 1.414 0l6.586 6.586a1 1 0 0 1 -.707 1.707h-3.586v6h-6v-6z"
  }), e.createElement("path", {
    d: "M9 21h6"
  }));
}
var en = ["size", "color", "stroke"];
function tn(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, en);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-arrow-big-up-lines",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M9 12h-3.586a1 1 0 0 1 -.707 -1.707l6.586 -6.586a1 1 0 0 1 1.414 0l6.586 6.586a1 1 0 0 1 -.707 1.707h-3.586v3h-6v-3z"
  }), e.createElement("path", {
    d: "M9 21h6"
  }), e.createElement("path", {
    d: "M9 18h6"
  }));
}
var on = ["size", "color", "stroke"];
function rn(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, on);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-arrow-bounce",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M10 18h4"
  }), e.createElement("path", {
    d: "M3 8a9 9 0 0 1 9 9v1l1.428 -4.285a12 12 0 0 1 6.018 -6.938l.554 -.277"
  }), e.createElement("path", {
    d: "M15 6h5v5"
  }));
}
var nn = ["size", "color", "stroke"];
function ln(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, nn);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-arrow-curve-left",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M14 7l-4 -4l-4 4"
  }), e.createElement("path", {
    d: "M10 3v4.394a6.737 6.737 0 0 0 3 5.606a6.737 6.737 0 0 1 3 5.606v2.394"
  }));
}
var an = ["size", "color", "stroke"];
function cn(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, an);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-arrow-curve-right",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M10 7l4 -4l4 4"
  }), e.createElement("path", {
    d: "M14 3v4.394a6.737 6.737 0 0 1 -3 5.606a6.737 6.737 0 0 0 -3 5.606v2.394"
  }));
}
var sn = ["size", "color", "stroke"];
function hn(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, sn);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-arrow-down-bar",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M12 3v18"
  }), e.createElement("path", {
    d: "M9 18l3 3l3 -3"
  }), e.createElement("path", {
    d: "M9 3h6"
  }));
}
var dn = ["size", "color", "stroke"];
function vn(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, dn);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-arrow-down-circle",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 9
  }), e.createElement("line", {
    x1: 8,
    y1: 12,
    x2: 12,
    y2: 16
  }), e.createElement("line", {
    x1: 12,
    y1: 8,
    x2: 12,
    y2: 16
  }), e.createElement("line", {
    x1: 16,
    y1: 12,
    x2: 12,
    y2: 16
  }));
}
var mn = ["size", "color", "stroke"];
function kn(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, mn);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-arrow-down-left-circle",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 9
  }), e.createElement("line", {
    x1: 15,
    y1: 9,
    x2: 9,
    y2: 15
  }), e.createElement("polyline", {
    points: "15 15 9 15 9 9"
  }));
}
var wn = ["size", "color", "stroke"];
function pn(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, wn);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-arrow-down-left",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("line", {
    x1: 17,
    y1: 7,
    x2: 7,
    y2: 17
  }), e.createElement("polyline", {
    points: "16 17 7 17 7 8"
  }));
}
var En = ["size", "color", "stroke"];
function un(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, En);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-arrow-down-rhombus",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M12 8v13"
  }), e.createElement("path", {
    d: "M15 18l-3 3l-3 -3"
  }), e.createElement("path", {
    d: "M14.5 5.5l-2.5 -2.5l-2.5 2.5l2.5 2.5z"
  }));
}
var gn = ["size", "color", "stroke"];
function Mn(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, gn);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-arrow-down-right-circle",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 9
  }), e.createElement("line", {
    x1: 15,
    y1: 15,
    x2: 9,
    y2: 15
  }), e.createElement("polyline", {
    points: "15 9 15 15 9 9"
  }));
}
var xn = ["size", "color", "stroke"];
function fn(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, xn);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-arrow-down-right",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("line", {
    x1: 7,
    y1: 7,
    x2: 17,
    y2: 17
  }), e.createElement("polyline", {
    points: "17 8 17 17 8 17"
  }));
}
var zn = ["size", "color", "stroke"];
function bn(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, zn);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-arrow-down-square",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M12 7v14"
  }), e.createElement("path", {
    d: "M9 18l3 3l3 -3"
  }), e.createElement("path", {
    d: "M14 3v4h-4v-4z"
  }));
}
var Ln = ["size", "color", "stroke"];
function yn(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Ln);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-arrow-down-tail",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M12 6v15"
  }), e.createElement("path", {
    d: "M9 18l3 3l3 -3"
  }), e.createElement("path", {
    d: "M9 3l3 3l3 -3"
  }));
}
var Cn = ["size", "color", "stroke"];
function jn(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Cn);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-arrow-down",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("line", {
    x1: 12,
    y1: 5,
    x2: 12,
    y2: 19
  }), e.createElement("line", {
    x1: 18,
    y1: 13,
    x2: 12,
    y2: 19
  }), e.createElement("line", {
    x1: 6,
    y1: 13,
    x2: 12,
    y2: 19
  }));
}
var Bn = ["size", "color", "stroke"];
function Hn(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Bn);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-arrow-fork",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M16 3h5v5"
  }), e.createElement("path", {
    d: "M8 3h-5v5"
  }), e.createElement("path", {
    d: "M21 3l-7.536 7.536a5 5 0 0 0 -1.464 3.534v6.93"
  }), e.createElement("path", {
    d: "M3 3l7.536 7.536a5 5 0 0 1 1.464 3.534v.93"
  }));
}
var Nn = ["size", "color", "stroke"];
function Wn(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Nn);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-arrow-forward-up",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M15 13l4 -4l-4 -4m4 4h-11a4 4 0 0 0 0 8h1"
  }));
}
var qn = ["size", "color", "stroke"];
function On(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, qn);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-arrow-forward",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M15 11l4 4l-4 4m4 -4h-11a4 4 0 0 1 0 -8h1"
  }));
}
var Pn = ["size", "color", "stroke"];
function Sn(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Pn);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-arrow-guide",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("circle", {
    cx: 5,
    cy: 19,
    r: 2
  }), e.createElement("path", {
    d: "M7 19h3a2 2 0 0 0 2 -2v-8a2 2 0 0 1 2 -2h7"
  }), e.createElement("path", {
    d: "M18 4l3 3l-3 3"
  }));
}
var In = ["size", "color", "stroke"];
function An(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, In);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-arrow-iteration",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M8.5 16a5.5 5.5 0 1 0 -5.5 -5.5v.5"
  }), e.createElement("path", {
    d: "M3 16h18"
  }), e.createElement("path", {
    d: "M18 13l3 3l-3 3"
  }));
}
var Dn = ["size", "color", "stroke"];
function Fn(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Dn);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-arrow-left-bar",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M21 12h-18"
  }), e.createElement("path", {
    d: "M6 9l-3 3l3 3"
  }), e.createElement("path", {
    d: "M21 9v6"
  }));
}
var Gn = ["size", "color", "stroke"];
function Jn(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Gn);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-arrow-left-circle",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M17 12h-14"
  }), e.createElement("path", {
    d: "M6 9l-3 3l3 3"
  }), e.createElement("circle", {
    cx: 19,
    cy: 12,
    r: 2
  }));
}
var Kn = ["size", "color", "stroke"];
function Qn(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Kn);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-arrow-left-rhombus",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M16 12h-13"
  }), e.createElement("path", {
    d: "M6 9l-3 3l3 3"
  }), e.createElement("path", {
    d: "M18.5 9.5l2.5 2.5l-2.5 2.5l-2.5 -2.5z"
  }));
}
var Rn = ["size", "color", "stroke"];
function Tn(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Rn);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-arrow-left-right",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M17 13l4 -4l-4 -4"
  }), e.createElement("path", {
    d: "M7 13l-4 -4l4 -4"
  }), e.createElement("path", {
    d: "M12 14a5 5 0 0 1 5 -5h4"
  }), e.createElement("path", {
    d: "M12 19v-5a5 5 0 0 0 -5 -5h-4"
  }));
}
var Un = ["size", "color", "stroke"];
function Vn(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Un);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-arrow-left-square",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M17 12h-14"
  }), e.createElement("path", {
    d: "M6 9l-3 3l3 3"
  }), e.createElement("path", {
    d: "M21 14h-4v-4h4z"
  }));
}
var Xn = ["size", "color", "stroke"];
function Yn(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Xn);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-arrow-left-tail",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M18 12h-15"
  }), e.createElement("path", {
    d: "M6 9l-3 3l3 3"
  }), e.createElement("path", {
    d: "M21 9l-3 3l3 3"
  }));
}
var Zn = ["size", "color", "stroke"];
function $n(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Zn);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-arrow-left",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("line", {
    x1: 5,
    y1: 12,
    x2: 19,
    y2: 12
  }), e.createElement("line", {
    x1: 5,
    y1: 12,
    x2: 11,
    y2: 18
  }), e.createElement("line", {
    x1: 5,
    y1: 12,
    x2: 11,
    y2: 6
  }));
}
var _n = ["size", "color", "stroke"];
function el(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, _n);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-arrow-loop-left-2",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M13 21v-6m0 -6v-1a4 4 0 1 1 4 4h-13"
  }), e.createElement("path", {
    d: "M8 16l-4 -4l4 -4"
  }));
}
var tl = ["size", "color", "stroke"];
function ol(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, tl);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-arrow-loop-left",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M13 21v-13a4 4 0 1 1 4 4h-13"
  }), e.createElement("path", {
    d: "M8 16l-4 -4l4 -4"
  }));
}
var rl = ["size", "color", "stroke"];
function nl(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, rl);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-arrow-loop-right-2",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M12 21v-6m0 -6v-1a4 4 0 1 0 -4 4h13"
  }), e.createElement("path", {
    d: "M17 16l4 -4l-4 -4"
  }));
}
var ll = ["size", "color", "stroke"];
function al(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, ll);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-arrow-loop-right",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M12 21v-13a4 4 0 1 0 -4 4h13"
  }), e.createElement("path", {
    d: "M17 16l4 -4l-4 -4"
  }));
}
var il = ["size", "color", "stroke"];
function cl(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, il);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-arrow-merge-both",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M16 8l-4 -4l-4 4"
  }), e.createElement("path", {
    d: "M12 20v-16"
  }), e.createElement("path", {
    d: "M18 18c-4 -1.333 -6 -4.667 -6 -10"
  }), e.createElement("path", {
    d: "M6 18c4 -1.333 6 -4.667 6 -10"
  }));
}
var sl = ["size", "color", "stroke"];
function hl(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, sl);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-arrow-merge-left",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M8 8l4 -4l4 4"
  }), e.createElement("path", {
    d: "M12 20v-16"
  }), e.createElement("path", {
    d: "M6 18c4 -1.333 6 -4.667 6 -10"
  }));
}
var dl = ["size", "color", "stroke"];
function vl(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, dl);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-arrow-merge-right",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M16 8l-4 -4l-4 4"
  }), e.createElement("path", {
    d: "M12 20v-16"
  }), e.createElement("path", {
    d: "M18 18c-4 -1.333 -6 -4.667 -6 -10"
  }));
}
var ml = ["size", "color", "stroke"];
function kl(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, ml);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-arrow-merge",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M8 7l4 -4l4 4"
  }), e.createElement("path", {
    d: "M12 3v5.394a6.737 6.737 0 0 1 -3 5.606a6.737 6.737 0 0 0 -3 5.606v1.394"
  }), e.createElement("path", {
    d: "M12 3v5.394a6.737 6.737 0 0 0 3 5.606a6.737 6.737 0 0 1 3 5.606v1.394"
  }));
}
var wl = ["size", "color", "stroke"];
function pl(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, wl);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-arrow-move-down",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M12 11v10"
  }), e.createElement("path", {
    d: "M9 18l3 3l3 -3"
  }), e.createElement("circle", {
    cx: 12,
    cy: 5,
    r: 2
  }));
}
var El = ["size", "color", "stroke"];
function ul(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, El);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-arrow-move-left",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M13 12h-10"
  }), e.createElement("path", {
    d: "M6 15l-3 -3l3 -3"
  }), e.createElement("path", {
    d: "M17 12a2 2 0 1 1 4 0a2 2 0 0 1 -4 0z"
  }));
}
var gl = ["size", "color", "stroke"];
function Ml(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, gl);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-arrow-move-right",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M11 12h10"
  }), e.createElement("path", {
    d: "M18 9l3 3l-3 3"
  }), e.createElement("path", {
    d: "M7 12a2 2 0 1 1 -4 0a2 2 0 0 1 4 0z"
  }));
}
var xl = ["size", "color", "stroke"];
function fl(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, xl);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-arrow-move-up",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M12 13v-10"
  }), e.createElement("path", {
    d: "M9 6l3 -3l3 3"
  }), e.createElement("path", {
    d: "M12 17a2 2 0 1 1 0 4a2 2 0 0 1 0 -4z"
  }));
}
var zl = ["size", "color", "stroke"];
function bl(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, zl);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-arrow-narrow-down",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("line", {
    x1: 12,
    y1: 5,
    x2: 12,
    y2: 19
  }), e.createElement("line", {
    x1: 16,
    y1: 15,
    x2: 12,
    y2: 19
  }), e.createElement("line", {
    x1: 8,
    y1: 15,
    x2: 12,
    y2: 19
  }));
}
var Ll = ["size", "color", "stroke"];
function yl(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Ll);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-arrow-narrow-left",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("line", {
    x1: 5,
    y1: 12,
    x2: 19,
    y2: 12
  }), e.createElement("line", {
    x1: 5,
    y1: 12,
    x2: 9,
    y2: 16
  }), e.createElement("line", {
    x1: 5,
    y1: 12,
    x2: 9,
    y2: 8
  }));
}
var Cl = ["size", "color", "stroke"];
function jl(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Cl);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-arrow-narrow-right",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("line", {
    x1: 5,
    y1: 12,
    x2: 19,
    y2: 12
  }), e.createElement("line", {
    x1: 15,
    y1: 16,
    x2: 19,
    y2: 12
  }), e.createElement("line", {
    x1: 15,
    y1: 8,
    x2: 19,
    y2: 12
  }));
}
var Bl = ["size", "color", "stroke"];
function Hl(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Bl);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-arrow-narrow-up",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("line", {
    x1: 12,
    y1: 5,
    x2: 12,
    y2: 19
  }), e.createElement("line", {
    x1: 16,
    y1: 9,
    x2: 12,
    y2: 5
  }), e.createElement("line", {
    x1: 8,
    y1: 9,
    x2: 12,
    y2: 5
  }));
}
var Nl = ["size", "color", "stroke"];
function Wl(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Nl);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-arrow-ramp-left-2",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M18 3v8.707"
  }), e.createElement("path", {
    d: "M8 14l-4 -4l4 -4"
  }), e.createElement("path", {
    d: "M18 21c0 -6.075 -4.925 -11 -11 -11h-3"
  }));
}
var ql = ["size", "color", "stroke"];
function Ol(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, ql);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-arrow-ramp-left-3",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M18 3v6"
  }), e.createElement("path", {
    d: "M8 16l-4 -4l4 -4"
  }), e.createElement("path", {
    d: "M18 21v-6a3 3 0 0 0 -3 -3h-11"
  }));
}
var Pl = ["size", "color", "stroke"];
function Sl(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Pl);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-arrow-ramp-left",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("line", {
    x1: 17,
    y1: 3,
    x2: 17,
    y2: 11.707
  }), e.createElement("path", {
    d: "M13 7l4 -4l4 4"
  }), e.createElement("path", {
    d: "M7 14l-4 -4l4 -4"
  }), e.createElement("path", {
    d: "M17 21a11 11 0 0 0 -11 -11h-3"
  }));
}
var Il = ["size", "color", "stroke"];
function Al(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Il);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-arrow-ramp-right-2",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M6 3v8.707"
  }), e.createElement("path", {
    d: "M16 14l4 -4l-4 -4"
  }), e.createElement("path", {
    d: "M6 21c0 -6.075 4.925 -11 11 -11h3"
  }));
}
var Dl = ["size", "color", "stroke"];
function Fl(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Dl);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-arrow-ramp-right-3",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M6 3v6"
  }), e.createElement("path", {
    d: "M16 16l4 -4l-4 -4"
  }), e.createElement("path", {
    d: "M6 21v-6a3 3 0 0 1 3 -3h11"
  }));
}
var Gl = ["size", "color", "stroke"];
function Jl(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Gl);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-arrow-ramp-right",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("line", {
    x1: 7,
    y1: 3,
    x2: 7,
    y2: 11.707
  }), e.createElement("path", {
    d: "M11 7l-4 -4l-4 4"
  }), e.createElement("path", {
    d: "M17 14l4 -4l-4 -4"
  }), e.createElement("path", {
    d: "M7 21a11 11 0 0 1 11 -11h3"
  }));
}
var Kl = ["size", "color", "stroke"];
function Ql(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Kl);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-arrow-right-bar",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M18 15l3 -3l-3 -3"
  }), e.createElement("path", {
    d: "M3 12h18"
  }), e.createElement("path", {
    d: "M3 9v6"
  }));
}
var Rl = ["size", "color", "stroke"];
function Tl(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Rl);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-arrow-right-circle",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M18 15l3 -3l-3 -3"
  }), e.createElement("circle", {
    cx: 5,
    cy: 12,
    r: 2
  }), e.createElement("path", {
    d: "M7 12h14"
  }));
}
var Ul = ["size", "color", "stroke"];
function Vl(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Ul);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-arrow-right-rhombus",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M8 12h13"
  }), e.createElement("path", {
    d: "M18 9l3 3l-3 3"
  }), e.createElement("path", {
    d: "M5.5 9.5l-2.5 2.5l2.5 2.5l2.5 -2.5z"
  }));
}
var Xl = ["size", "color", "stroke"];
function Yl(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Xl);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-arrow-right-square",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("line", {
    x1: 7,
    y1: 12,
    x2: 21,
    y2: 12
  }), e.createElement("path", {
    d: "M18 15l3 -3l-3 -3"
  }), e.createElement("path", {
    d: "M3 10h4v4h-4z"
  }));
}
var Zl = ["size", "color", "stroke"];
function $l(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Zl);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-arrow-right-tail",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M18 15l3 -3l-3 -3"
  }), e.createElement("path", {
    d: "M3 15l3 -3l-3 -3"
  }), e.createElement("line", {
    x1: 6,
    y1: 12,
    x2: 21,
    y2: 12
  }));
}
var _l = ["size", "color", "stroke"];
function ea(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, _l);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-arrow-right",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("line", {
    x1: 5,
    y1: 12,
    x2: 19,
    y2: 12
  }), e.createElement("line", {
    x1: 13,
    y1: 18,
    x2: 19,
    y2: 12
  }), e.createElement("line", {
    x1: 13,
    y1: 6,
    x2: 19,
    y2: 12
  }));
}
var ta = ["size", "color", "stroke"];
function oa(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, ta);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-arrow-rotary-first-left",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M16 10a3 3 0 1 1 0 -6a3 3 0 0 1 0 6z"
  }), e.createElement("path", {
    d: "M16 10v10"
  }), e.createElement("path", {
    d: "M13.5 9.5l-8.5 8.5"
  }), e.createElement("path", {
    d: "M10 18h-5v-5"
  }));
}
var ra = ["size", "color", "stroke"];
function na(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, ra);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-arrow-rotary-first-right",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("circle", {
    cx: 8,
    cy: 7,
    r: 3
  }), e.createElement("path", {
    d: "M8 10v10"
  }), e.createElement("path", {
    d: "M10.5 9.5l8.5 8.5"
  }), e.createElement("path", {
    d: "M14 18h5v-5"
  }));
}
var la = ["size", "color", "stroke"];
function aa(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, la);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-arrow-rotary-last-left",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M15 15a3 3 0 1 1 0 -6a3 3 0 0 1 0 6z"
  }), e.createElement("path", {
    d: "M15 15v6"
  }), e.createElement("path", {
    d: "M12.5 9.5l-6.5 -6.5"
  }), e.createElement("path", {
    d: "M11 3h-5v5"
  }));
}
var ia = ["size", "color", "stroke"];
function ca(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, ia);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-arrow-rotary-last-right",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("circle", {
    cx: 9,
    cy: 12,
    r: 3
  }), e.createElement("path", {
    d: "M9 15v6"
  }), e.createElement("path", {
    d: "M11.5 9.5l6.5 -6.5"
  }), e.createElement("path", {
    d: "M13 3h5v5"
  }));
}
var sa = ["size", "color", "stroke"];
function ha(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, sa);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-arrow-rotary-left",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M16 10a3 3 0 1 1 0 -6a3 3 0 0 1 0 6z"
  }), e.createElement("path", {
    d: "M16 10v10"
  }), e.createElement("path", {
    d: "M13 7h-10"
  }), e.createElement("path", {
    d: "M7 11l-4 -4l4 -4"
  }));
}
var da = ["size", "color", "stroke"];
function va(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, da);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-arrow-rotary-right",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("circle", {
    cx: 8,
    cy: 7,
    r: 3
  }), e.createElement("path", {
    d: "M8 10v10"
  }), e.createElement("path", {
    d: "M17 11l4 -4l-4 -4"
  }), e.createElement("path", {
    d: "M11 7h10"
  }));
}
var ma = ["size", "color", "stroke"];
function ka(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, ma);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-arrow-rotary-straight",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("circle", {
    cx: 13,
    cy: 13,
    r: 3
  }), e.createElement("path", {
    d: "M13 16v5"
  }), e.createElement("path", {
    d: "M13 3v7"
  }), e.createElement("path", {
    d: "M9 7l4 -4l4 4"
  }));
}
var wa = ["size", "color", "stroke"];
function pa(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, wa);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-arrow-roundabout-left",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M3 9h8a5 5 0 1 1 5 5v7"
  }), e.createElement("path", {
    d: "M7 5l-4 4l4 4"
  }));
}
var Ea = ["size", "color", "stroke"];
function ua(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Ea);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-arrow-roundabout-right",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M21 9h-8a5 5 0 1 0 -5 5v7"
  }), e.createElement("path", {
    d: "M17 5l4 4l-4 4"
  }));
}
var ga = ["size", "color", "stroke"];
function Ma(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, ga);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-arrow-sharp-turn-left",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M17 18v-11.31a0.7 .7 0 0 0 -1.195 -.495l-9.805 9.805"
  }), e.createElement("path", {
    d: "M11 16h-5v-5"
  }));
}
var xa = ["size", "color", "stroke"];
function fa(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, xa);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-arrow-sharp-turn-right",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M7 18v-11.31a0.7 .7 0 0 1 1.195 -.495l9.805 9.805"
  }), e.createElement("path", {
    d: "M13 16h5v-5"
  }));
}
var za = ["size", "color", "stroke"];
function ba(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, za);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-arrow-up-bar",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("line", {
    x1: 12,
    y1: 21,
    x2: 12,
    y2: 3
  }), e.createElement("path", {
    d: "M15 6l-3 -3l-3 3"
  }), e.createElement("line", {
    x1: 9,
    y1: 21,
    x2: 15,
    y2: 21
  }));
}
var La = ["size", "color", "stroke"];
function ya(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, La);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-arrow-up-circle",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 9
  }), e.createElement("line", {
    x1: 12,
    y1: 8,
    x2: 8,
    y2: 12
  }), e.createElement("line", {
    x1: 12,
    y1: 8,
    x2: 12,
    y2: 16
  }), e.createElement("line", {
    x1: 16,
    y1: 12,
    x2: 12,
    y2: 8
  }));
}
var Ca = ["size", "color", "stroke"];
function ja(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Ca);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-arrow-up-left-circle",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 9
  }), e.createElement("line", {
    x1: 9,
    y1: 9,
    x2: 15,
    y2: 15
  }), e.createElement("polyline", {
    points: "15 9 9 9 9 15"
  }));
}
var Ba = ["size", "color", "stroke"];
function Ha(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Ba);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-arrow-up-left",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("line", {
    x1: 7,
    y1: 7,
    x2: 17,
    y2: 17
  }), e.createElement("polyline", {
    points: "16 7 7 7 7 16"
  }));
}
var Na = ["size", "color", "stroke"];
function Wa(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Na);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-arrow-up-rhombus",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M12 16v-13"
  }), e.createElement("path", {
    d: "M15 6l-3 -3l-3 3"
  }), e.createElement("path", {
    d: "M14.5 18.5l-2.5 2.5l-2.5 -2.5l2.5 -2.5z"
  }));
}
var qa = ["size", "color", "stroke"];
function Oa(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, qa);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-arrow-up-right-circle",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 9
  }), e.createElement("line", {
    x1: 15,
    y1: 9,
    x2: 9,
    y2: 15
  }), e.createElement("polyline", {
    points: "15 15 15 9 9 9"
  }));
}
var Pa = ["size", "color", "stroke"];
function Sa(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Pa);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-arrow-up-right",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("line", {
    x1: 17,
    y1: 7,
    x2: 7,
    y2: 17
  }), e.createElement("polyline", {
    points: "8 7 17 7 17 16"
  }));
}
var Ia = ["size", "color", "stroke"];
function Aa(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Ia);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-arrow-up-square",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("line", {
    x1: 12,
    y1: 17,
    x2: 12,
    y2: 3
  }), e.createElement("path", {
    d: "M15 6l-3 -3l-3 3"
  }), e.createElement("path", {
    d: "M10 21v-4h4v4z"
  }));
}
var Da = ["size", "color", "stroke"];
function Fa(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Da);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-arrow-up-tail",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("line", {
    x1: 12,
    y1: 18,
    x2: 12,
    y2: 3
  }), e.createElement("path", {
    d: "M15 6l-3 -3l-3 3"
  }), e.createElement("path", {
    d: "M15 21l-3 -3l-3 3"
  }));
}
var Ga = ["size", "color", "stroke"];
function Ja(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Ga);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-arrow-up",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("line", {
    x1: 12,
    y1: 5,
    x2: 12,
    y2: 19
  }), e.createElement("line", {
    x1: 18,
    y1: 11,
    x2: 12,
    y2: 5
  }), e.createElement("line", {
    x1: 6,
    y1: 11,
    x2: 12,
    y2: 5
  }));
}
var Ka = ["size", "color", "stroke"];
function Qa(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Ka);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-arrow-wave-left-down",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M7 13.998h-4v-4"
  }), e.createElement("path", {
    d: "M21 11.998c-.887 1.284 -2.48 2.033 -4 2c-1.52 .033 -3.113 -.716 -4 -2s-2.48 -2.033 -4 -2c-1.52 -.033 -3 1 -4 2l-2 2"
  }));
}
var Ra = ["size", "color", "stroke"];
function Ta(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Ra);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-arrow-wave-left-up",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M7 9.996h-4v4"
  }), e.createElement("path", {
    d: "M21 11.996c-.887 -1.285 -2.48 -2.033 -4 -2c-1.52 -.033 -3.113 .715 -4 2c-.887 1.284 -2.48 2.033 -4 2c-1.52 .033 -3 -1 -4 -2l-2 -2"
  }));
}
var Ua = ["size", "color", "stroke"];
function Va(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Ua);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-arrow-wave-right-down",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M17 13.998h4v-4"
  }), e.createElement("path", {
    d: "M3 11.998c.887 1.284 2.48 2.033 4 2c1.52 .033 3.113 -.716 4 -2s2.48 -2.033 4 -2c1.52 -.033 3 1 4 2l2 2"
  }));
}
var Xa = ["size", "color", "stroke"];
function Ya(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Xa);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-arrow-wave-right-up",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M17 10h4v4"
  }), e.createElement("path", {
    d: "M3 12c.887 -1.284 2.48 -2.033 4 -2c1.52 -.033 3.113 .716 4 2s2.48 2.033 4 2c1.52 .033 3 -1 4 -2l2 -2"
  }));
}
var Za = ["size", "color", "stroke"];
function $a(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Za);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-arrow-zig-zag",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M6 20v-10l10 6v-12"
  }), e.createElement("path", {
    d: "M13 7l3 -3l3 3"
  }));
}
var _a = ["size", "color", "stroke"];
function ei(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, _a);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-arrows-cross",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M16 4h4v4"
  }), e.createElement("path", {
    d: "M15 9l5 -5"
  }), e.createElement("path", {
    d: "M4 20l5 -5"
  }), e.createElement("path", {
    d: "M16 20h4v-4"
  }), e.createElement("path", {
    d: "M4 4l16 16"
  }));
}
var ti = ["size", "color", "stroke"];
function oi(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, ti);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-arrows-diagonal-2",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("polyline", {
    points: "16 20 20 20 20 16"
  }), e.createElement("line", {
    x1: 14,
    y1: 14,
    x2: 20,
    y2: 20
  }), e.createElement("polyline", {
    points: "8 4 4 4 4 8"
  }), e.createElement("line", {
    x1: 4,
    y1: 4,
    x2: 10,
    y2: 10
  }));
}
var ri = ["size", "color", "stroke"];
function ni(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, ri);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-arrows-diagonal-minimize-2",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M18 10h-4v-4"
  }), e.createElement("path", {
    d: "M20 4l-6 6"
  }), e.createElement("path", {
    d: "M6 14h4v4"
  }), e.createElement("path", {
    d: "M10 14l-6 6"
  }));
}
var li = ["size", "color", "stroke"];
function ai(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, li);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-arrows-diagonal-minimize",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M6 10h4v-4"
  }), e.createElement("path", {
    d: "M4 4l6 6"
  }), e.createElement("path", {
    d: "M18 14h-4v4"
  }), e.createElement("path", {
    d: "M14 14l6 6"
  }));
}
var ii = ["size", "color", "stroke"];
function ci(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, ii);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-arrows-diagonal",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("polyline", {
    points: "16 4 20 4 20 8"
  }), e.createElement("line", {
    x1: 14,
    y1: 10,
    x2: 20,
    y2: 4
  }), e.createElement("polyline", {
    points: "8 20 4 20 4 16"
  }), e.createElement("line", {
    x1: 4,
    y1: 20,
    x2: 10,
    y2: 14
  }));
}
var si = ["size", "color", "stroke"];
function hi(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, si);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-arrows-diff",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M11 16h10"
  }), e.createElement("path", {
    d: "M11 16l4 4"
  }), e.createElement("path", {
    d: "M11 16l4 -4"
  }), e.createElement("path", {
    d: "M13 8h-10"
  }), e.createElement("path", {
    d: "M13 8l-4 4"
  }), e.createElement("path", {
    d: "M13 8l-4 -4"
  }));
}
var di = ["size", "color", "stroke"];
function vi(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, di);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-arrows-double-ne-sw",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M3 14l11 -11"
  }), e.createElement("path", {
    d: "M10 3h4v4"
  }), e.createElement("path", {
    d: "M10 17v4h4"
  }), e.createElement("path", {
    d: "M21 10l-11 11"
  }));
}
var mi = ["size", "color", "stroke"];
function ki(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, mi);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-arrows-double-nw-se",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M14 21l-11 -11"
  }), e.createElement("path", {
    d: "M3 14v-4h4"
  }), e.createElement("path", {
    d: "M17 14h4v-4"
  }), e.createElement("line", {
    x1: 10,
    y1: 3,
    x2: 21,
    y2: 14
  }));
}
var wi = ["size", "color", "stroke"];
function pi(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, wi);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-arrows-double-se-nw",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("line", {
    x1: 3,
    y1: 10,
    x2: 14,
    y2: 21
  }), e.createElement("path", {
    d: "M14 17v4h-4"
  }), e.createElement("path", {
    d: "M14 3h-4v4"
  }), e.createElement("path", {
    d: "M21 14l-11 -11"
  }));
}
var Ei = ["size", "color", "stroke"];
function ui(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Ei);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-arrows-double-sw-ne",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M14 3l-11 11"
  }), e.createElement("path", {
    d: "M3 10v4h4"
  }), e.createElement("path", {
    d: "M17 10h4v4"
  }), e.createElement("path", {
    d: "M10 21l11 -11"
  }));
}
var gi = ["size", "color", "stroke"];
function Mi(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, gi);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-arrows-down-up",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("line", {
    x1: 17,
    y1: 3,
    x2: 17,
    y2: 21
  }), e.createElement("path", {
    d: "M10 18l-3 3l-3 -3"
  }), e.createElement("line", {
    x1: 7,
    y1: 21,
    x2: 7,
    y2: 3
  }), e.createElement("path", {
    d: "M20 6l-3 -3l-3 3"
  }));
}
var xi = ["size", "color", "stroke"];
function fi(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, xi);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-arrows-down",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("line", {
    x1: 7,
    y1: 21,
    x2: 7,
    y2: 3
  }), e.createElement("path", {
    d: "M20 18l-3 3l-3 -3"
  }), e.createElement("path", {
    d: "M4 18l3 3l3 -3"
  }), e.createElement("line", {
    x1: 17,
    y1: 21,
    x2: 17,
    y2: 3
  }));
}
var zi = ["size", "color", "stroke"];
function bi(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, zi);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-arrows-exchange-2",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M17 10h-14l4 -4"
  }), e.createElement("path", {
    d: "M7 14h14l-4 4"
  }));
}
var Li = ["size", "color", "stroke"];
function yi(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Li);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-arrows-exchange",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M7 10h14l-4 -4"
  }), e.createElement("path", {
    d: "M17 14h-14l4 4"
  }));
}
var Ci = ["size", "color", "stroke"];
function ji(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Ci);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-arrows-horizontal",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("polyline", {
    points: "7 8 3 12 7 16"
  }), e.createElement("polyline", {
    points: "17 8 21 12 17 16"
  }), e.createElement("line", {
    x1: 3,
    y1: 12,
    x2: 21,
    y2: 12
  }));
}
var Bi = ["size", "color", "stroke"];
function Hi(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Bi);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-arrows-join-2",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M3 7h1.948c1.913 0 3.705 .933 4.802 2.5a5.861 5.861 0 0 0 4.802 2.5h6.448"
  }), e.createElement("path", {
    d: "M3 17h1.95a5.854 5.854 0 0 0 4.798 -2.5a5.854 5.854 0 0 1 4.798 -2.5h5.454"
  }), e.createElement("path", {
    d: "M18 15l3 -3l-3 -3"
  }));
}
var Ni = ["size", "color", "stroke"];
function Wi(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Ni);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-arrows-join",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M3 7h5l3.5 5h9.5"
  }), e.createElement("path", {
    d: "M3 17h5l3.495 -5"
  }), e.createElement("path", {
    d: "M18 15l3 -3l-3 -3"
  }));
}
var qi = ["size", "color", "stroke"];
function Oi(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, qi);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-arrows-left-down",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M7 3l-4 4l4 4"
  }), e.createElement("path", {
    d: "M3 7h11a3 3 0 0 1 3 3v11"
  }), e.createElement("path", {
    d: "M13 17l4 4l4 -4"
  }));
}
var Pi = ["size", "color", "stroke"];
function Si(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Pi);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-arrows-left-right",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("line", {
    x1: 21,
    y1: 17,
    x2: 3,
    y2: 17
  }), e.createElement("path", {
    d: "M6 10l-3 -3l3 -3"
  }), e.createElement("line", {
    x1: 3,
    y1: 7,
    x2: 21,
    y2: 7
  }), e.createElement("path", {
    d: "M18 20l3 -3l-3 -3"
  }));
}
var Ii = ["size", "color", "stroke"];
function Ai(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Ii);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-arrows-left",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("line", {
    x1: 3,
    y1: 7,
    x2: 21,
    y2: 7
  }), e.createElement("path", {
    d: "M6 20l-3 -3l3 -3"
  }), e.createElement("path", {
    d: "M6 4l-3 3l3 3"
  }), e.createElement("line", {
    x1: 3,
    y1: 17,
    x2: 21,
    y2: 17
  }));
}
var Di = ["size", "color", "stroke"];
function Fi(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Di);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-arrows-maximize",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("polyline", {
    points: "16 4 20 4 20 8"
  }), e.createElement("line", {
    x1: 14,
    y1: 10,
    x2: 20,
    y2: 4
  }), e.createElement("polyline", {
    points: "8 20 4 20 4 16"
  }), e.createElement("line", {
    x1: 4,
    y1: 20,
    x2: 10,
    y2: 14
  }), e.createElement("polyline", {
    points: "16 20 20 20 20 16"
  }), e.createElement("line", {
    x1: 14,
    y1: 14,
    x2: 20,
    y2: 20
  }), e.createElement("polyline", {
    points: "8 4 4 4 4 8"
  }), e.createElement("line", {
    x1: 4,
    y1: 4,
    x2: 10,
    y2: 10
  }));
}
var Gi = ["size", "color", "stroke"];
function Ji(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Gi);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-arrows-minimize",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("polyline", {
    points: "5 9 9 9 9 5"
  }), e.createElement("line", {
    x1: 3,
    y1: 3,
    x2: 9,
    y2: 9
  }), e.createElement("polyline", {
    points: "5 15 9 15 9 19"
  }), e.createElement("line", {
    x1: 3,
    y1: 21,
    x2: 9,
    y2: 15
  }), e.createElement("polyline", {
    points: "19 9 15 9 15 5"
  }), e.createElement("line", {
    x1: 15,
    y1: 9,
    x2: 21,
    y2: 3
  }), e.createElement("polyline", {
    points: "19 15 15 15 15 19"
  }), e.createElement("line", {
    x1: 15,
    y1: 15,
    x2: 21,
    y2: 21
  }));
}
var Ki = ["size", "color", "stroke"];
function Qi(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Ki);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-arrows-move-horizontal",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M18 9l3 3l-3 3"
  }), e.createElement("path", {
    d: "M15 12h6"
  }), e.createElement("path", {
    d: "M6 9l-3 3l3 3"
  }), e.createElement("path", {
    d: "M3 12h6"
  }));
}
var Ri = ["size", "color", "stroke"];
function Ti(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Ri);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-arrows-move-vertical",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M9 18l3 3l3 -3"
  }), e.createElement("path", {
    d: "M12 15v6"
  }), e.createElement("path", {
    d: "M15 6l-3 -3l-3 3"
  }), e.createElement("path", {
    d: "M12 3v6"
  }));
}
var Ui = ["size", "color", "stroke"];
function Vi(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Ui);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-arrows-move",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M18 9l3 3l-3 3"
  }), e.createElement("path", {
    d: "M15 12h6"
  }), e.createElement("path", {
    d: "M6 9l-3 3l3 3"
  }), e.createElement("path", {
    d: "M3 12h6"
  }), e.createElement("path", {
    d: "M9 18l3 3l3 -3"
  }), e.createElement("path", {
    d: "M12 15v6"
  }), e.createElement("path", {
    d: "M15 6l-3 -3l-3 3"
  }), e.createElement("path", {
    d: "M12 3v6"
  }));
}
var Xi = ["size", "color", "stroke"];
function Yi(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Xi);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-arrows-random",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M20 21.004h-4v-4"
  }), e.createElement("path", {
    d: "M16 21.004l5 -5"
  }), e.createElement("path", {
    d: "M6.5 9.504l-3.5 -2l2 -3.504"
  }), e.createElement("path", {
    d: "M3 7.504l6.83 -1.87"
  }), e.createElement("path", {
    d: "M4 16.004l4 -1l1 4"
  }), e.createElement("path", {
    d: "M8 15.004l-3.5 6"
  }), e.createElement("path", {
    d: "M21 5.004l-.5 4l-4 -.5"
  }), e.createElement("path", {
    d: "M20.5 9.004l-4.5 -5.5"
  }));
}
var Zi = ["size", "color", "stroke"];
function $i(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Zi);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-arrows-right-down",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M3 17l4 4l4 -4"
  }), e.createElement("path", {
    d: "M7 21v-11a3 3 0 0 1 3 -3h11"
  }), e.createElement("path", {
    d: "M17 11l4 -4l-4 -4"
  }));
}
var _i = ["size", "color", "stroke"];
function ec(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, _i);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-arrows-right-left",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("line", {
    x1: 21,
    y1: 7,
    x2: 3,
    y2: 7
  }), e.createElement("path", {
    d: "M18 10l3 -3l-3 -3"
  }), e.createElement("path", {
    d: "M6 20l-3 -3l3 -3"
  }), e.createElement("line", {
    x1: 3,
    y1: 17,
    x2: 21,
    y2: 17
  }));
}
var tc = ["size", "color", "stroke"];
function oc(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, tc);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-arrows-right",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("line", {
    x1: 21,
    y1: 17,
    x2: 3,
    y2: 17
  }), e.createElement("path", {
    d: "M18 4l3 3l-3 3"
  }), e.createElement("path", {
    d: "M18 20l3 -3l-3 -3"
  }), e.createElement("line", {
    x1: 21,
    y1: 7,
    x2: 3,
    y2: 7
  }));
}
var rc = ["size", "color", "stroke"];
function nc(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, rc);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-arrows-shuffle-2",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M18 4l3 3l-3 3"
  }), e.createElement("path", {
    d: "M18 20l3 -3l-3 -3"
  }), e.createElement("path", {
    d: "M3 7h3a5 5 0 0 1 5 5a5 5 0 0 0 5 5h5"
  }), e.createElement("path", {
    d: "M3 17h3a5 5 0 0 0 5 -5a5 5 0 0 1 5 -5h5"
  }));
}
var lc = ["size", "color", "stroke"];
function ac(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, lc);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-arrows-shuffle",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M18 4l3 3l-3 3"
  }), e.createElement("path", {
    d: "M18 20l3 -3l-3 -3"
  }), e.createElement("path", {
    d: "M3 7h3a5 5 0 0 1 5 5a5 5 0 0 0 5 5h5"
  }), e.createElement("path", {
    d: "M21 7h-5a4.978 4.978 0 0 0 -2.998 .998m-4.002 8.003a4.984 4.984 0 0 1 -3 .999h-3"
  }));
}
var ic = ["size", "color", "stroke"];
function cc(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, ic);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-arrows-sort",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M3 9l4 -4l4 4m-4 -4v14"
  }), e.createElement("path", {
    d: "M21 15l-4 4l-4 -4m4 4v-14"
  }));
}
var sc = ["size", "color", "stroke"];
function hc(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, sc);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-arrows-split-2",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M21 17h-5.397a5 5 0 0 1 -4.096 -2.133l-.514 -.734a5 5 0 0 0 -4.096 -2.133h-3.897"
  }), e.createElement("path", {
    d: "M21 7h-5.395a5 5 0 0 0 -4.098 2.135l-.51 .73a5 5 0 0 1 -4.097 2.135h-3.9"
  }), e.createElement("path", {
    d: "M18 10l3 -3l-3 -3"
  }), e.createElement("path", {
    d: "M18 20l3 -3l-3 -3"
  }));
}
var dc = ["size", "color", "stroke"];
function vc(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, dc);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-arrows-split",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M21 17h-8l-3.5 -5h-6.5"
  }), e.createElement("path", {
    d: "M21 7h-8l-3.495 5"
  }), e.createElement("path", {
    d: "M18 10l3 -3l-3 -3"
  }), e.createElement("path", {
    d: "M18 20l3 -3l-3 -3"
  }));
}
var mc = ["size", "color", "stroke"];
function kc(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, mc);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-arrows-transfer-down",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M17 3v6"
  }), e.createElement("path", {
    d: "M10 18l-3 3l-3 -3"
  }), e.createElement("path", {
    d: "M7 21v-18"
  }), e.createElement("path", {
    d: "M20 6l-3 -3l-3 3"
  }), e.createElement("path", {
    d: "M17 21v-2"
  }), e.createElement("path", {
    d: "M17 15v-2"
  }));
}
var wc = ["size", "color", "stroke"];
function pc(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, wc);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-arrows-transfer-up",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M7 21v-6"
  }), e.createElement("path", {
    d: "M20 6l-3 -3l-3 3"
  }), e.createElement("path", {
    d: "M17 3v18"
  }), e.createElement("path", {
    d: "M10 18l-3 3l-3 -3"
  }), e.createElement("path", {
    d: "M7 3v2"
  }), e.createElement("path", {
    d: "M7 9v2"
  }));
}
var Ec = ["size", "color", "stroke"];
function uc(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Ec);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-arrows-up-down",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("line", {
    x1: 7,
    y1: 3,
    x2: 7,
    y2: 21
  }), e.createElement("path", {
    d: "M10 6l-3 -3l-3 3"
  }), e.createElement("path", {
    d: "M20 18l-3 3l-3 -3"
  }), e.createElement("line", {
    x1: 17,
    y1: 21,
    x2: 17,
    y2: 3
  }));
}
var gc = ["size", "color", "stroke"];
function Mc(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, gc);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-arrows-up-left",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M21 7l-4 -4l-4 4"
  }), e.createElement("path", {
    d: "M17 3v11a3 3 0 0 1 -3 3h-11"
  }), e.createElement("path", {
    d: "M7 13l-4 4l4 4"
  }));
}
var xc = ["size", "color", "stroke"];
function fc(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, xc);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-arrows-up-right",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M17 21l4 -4l-4 -4"
  }), e.createElement("path", {
    d: "M21 17h-11a3 3 0 0 1 -3 -3v-11"
  }), e.createElement("path", {
    d: "M11 7l-4 -4l-4 4"
  }));
}
var zc = ["size", "color", "stroke"];
function bc(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, zc);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-arrows-up",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("line", {
    x1: 17,
    y1: 3,
    x2: 17,
    y2: 21
  }), e.createElement("path", {
    d: "M4 6l3 -3l3 3"
  }), e.createElement("path", {
    d: "M20 6l-3 -3l-3 3"
  }), e.createElement("line", {
    x1: 7,
    y1: 3,
    x2: 7,
    y2: 21
  }));
}
var Lc = ["size", "color", "stroke"];
function yc(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Lc);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-arrows-vertical",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("polyline", {
    points: "8 7 12 3 16 7"
  }), e.createElement("polyline", {
    points: "8 17 12 21 16 17"
  }), e.createElement("line", {
    x1: 12,
    y1: 3,
    x2: 12,
    y2: 21
  }));
}
var Cc = ["size", "color", "stroke"];
function jc(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Cc);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-artboard-off",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M12 8h3a1 1 0 0 1 1 1v3"
  }), e.createElement("path", {
    d: "M15.716 15.698a0.997 .997 0 0 1 -.716 .302h-6a1 1 0 0 1 -1 -1v-6c0 -.273 .11 -.52 .287 -.7"
  }), e.createElement("path", {
    d: "M3 8h1"
  }), e.createElement("path", {
    d: "M3 16h1"
  }), e.createElement("path", {
    d: "M8 3v1"
  }), e.createElement("path", {
    d: "M16 3v1"
  }), e.createElement("path", {
    d: "M20 8h1"
  }), e.createElement("path", {
    d: "M20 16h1"
  }), e.createElement("path", {
    d: "M8 20v1"
  }), e.createElement("path", {
    d: "M16 20v1"
  }), e.createElement("path", {
    d: "M3 3l18 18"
  }));
}
var Bc = ["size", "color", "stroke"];
function Hc(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Bc);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-artboard",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("rect", {
    x: 8,
    y: 8,
    width: 8,
    height: 8,
    rx: 1
  }), e.createElement("line", {
    x1: 3,
    y1: 8,
    x2: 4,
    y2: 8
  }), e.createElement("line", {
    x1: 3,
    y1: 16,
    x2: 4,
    y2: 16
  }), e.createElement("line", {
    x1: 8,
    y1: 3,
    x2: 8,
    y2: 4
  }), e.createElement("line", {
    x1: 16,
    y1: 3,
    x2: 16,
    y2: 4
  }), e.createElement("line", {
    x1: 20,
    y1: 8,
    x2: 21,
    y2: 8
  }), e.createElement("line", {
    x1: 20,
    y1: 16,
    x2: 21,
    y2: 16
  }), e.createElement("line", {
    x1: 8,
    y1: 20,
    x2: 8,
    y2: 21
  }), e.createElement("line", {
    x1: 16,
    y1: 20,
    x2: 16,
    y2: 21
  }));
}
var Nc = ["size", "color", "stroke"];
function Wc(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Nc);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-article-off",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M8 4h11a2 2 0 0 1 2 2v11m-1.172 2.821a1.993 1.993 0 0 1 -.828 .179h-14a2 2 0 0 1 -2 -2v-12a2 2 0 0 1 1.156 -1.814"
  }), e.createElement("path", {
    d: "M7 8h1m4 0h5"
  }), e.createElement("path", {
    d: "M7 12h5m4 0h1"
  }), e.createElement("path", {
    d: "M7 16h9"
  }), e.createElement("path", {
    d: "M3 3l18 18"
  }));
}
var qc = ["size", "color", "stroke"];
function Oc(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, qc);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-article",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("rect", {
    x: 3,
    y: 4,
    width: 18,
    height: 16,
    rx: 2
  }), e.createElement("path", {
    d: "M7 8h10"
  }), e.createElement("path", {
    d: "M7 12h10"
  }), e.createElement("path", {
    d: "M7 16h10"
  }));
}
var Pc = ["size", "color", "stroke"];
function Sc(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Pc);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-aspect-ratio-off",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M9 5h10a2 2 0 0 1 2 2v10m-2 2h-14a2 2 0 0 1 -2 -2v-10a2 2 0 0 1 2 -2"
  }), e.createElement("path", {
    d: "M7 12v-3h2"
  }), e.createElement("path", {
    d: "M17 12v1m-2 2h-1"
  }), e.createElement("path", {
    d: "M3 3l18 18"
  }));
}
var Ic = ["size", "color", "stroke"];
function Ac(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Ic);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-aspect-ratio",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("rect", {
    x: 3,
    y: 5,
    width: 18,
    height: 14,
    rx: 2
  }), e.createElement("path", {
    d: "M7 12v-3h3"
  }), e.createElement("path", {
    d: "M17 12v3h-3"
  }));
}
var Dc = ["size", "color", "stroke"];
function Fc(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Dc);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-assembly-off",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M8.703 4.685l2.326 -1.385a2.056 2.056 0 0 1 2 0l6 3.573h-.029a2 2 0 0 1 1 1.747v6.536c0 .248 -.046 .49 -.132 .715m-2.156 1.837l-4.741 3.029a2 2 0 0 1 -1.942 0l-6 -3.833a2 2 0 0 1 -1.029 -1.747v-6.537a2 2 0 0 1 1.029 -1.748l1.157 -.689"
  }), e.createElement("path", {
    d: "M11.593 7.591c.295 -.133 .637 -.12 .921 .04l3 1.79h-.014c.312 .181 .503 .516 .5 .877v1.702m-1.152 2.86l-2.363 1.514a0.997 .997 0 0 1 -.97 0l-3 -1.922a1.003 1.003 0 0 1 -.515 -.876v-3.278c0 -.364 .197 -.7 .514 -.877l.568 -.339"
  }), e.createElement("path", {
    d: "M3 3l18 18"
  }));
}
var Gc = ["size", "color", "stroke"];
function Jc(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Gc);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-assembly",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M19 6.873a2 2 0 0 1 1 1.747v6.536a2 2 0 0 1 -1.029 1.748l-6 3.833a2 2 0 0 1 -1.942 0l-6 -3.833a2 2 0 0 1 -1.029 -1.747v-6.537a2 2 0 0 1 1.029 -1.748l6 -3.572a2.056 2.056 0 0 1 2 0l6 3.573h-.029z"
  }), e.createElement("path", {
    d: "M15.5 9.422c.312 .18 .503 .515 .5 .876v3.277c0 .364 -.197 .7 -.515 .877l-3 1.922a0.997 .997 0 0 1 -.97 0l-3 -1.922a1.003 1.003 0 0 1 -.515 -.876v-3.278c0 -.364 .197 -.7 .514 -.877l3 -1.79c.311 -.174 .69 -.174 1 0l3 1.79h-.014z"
  }));
}
var Kc = ["size", "color", "stroke"];
function Qc(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Kc);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-asset",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("circle", {
    cx: 9,
    cy: 15,
    r: 6
  }), e.createElement("circle", {
    cx: 9,
    cy: 15,
    r: 2
  }), e.createElement("circle", {
    cx: 19,
    cy: 5,
    r: 2
  }), e.createElement("path", {
    d: "M14.218 17.975l6.619 -12.174"
  }), e.createElement("path", {
    d: "M6.079 9.756l12.217 -6.631"
  }), e.createElement("circle", {
    cx: 9,
    cy: 15,
    r: 2
  }));
}
var Rc = ["size", "color", "stroke"];
function Tc(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Rc);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-asterisk-simple",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M12 12v-9"
  }), e.createElement("path", {
    d: "M12 12l-9 -2.5"
  }), e.createElement("path", {
    d: "M12 12l9 -2.5"
  }), e.createElement("path", {
    d: "M12 12l6 8.5"
  }), e.createElement("path", {
    d: "M12 12l-6 8.5"
  }));
}
var Uc = ["size", "color", "stroke"];
function Vc(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Uc);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-asterisk",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M12 12l8 -4.5"
  }), e.createElement("path", {
    d: "M12 12v9"
  }), e.createElement("path", {
    d: "M12 12l-8 -4.5"
  }), e.createElement("path", {
    d: "M12 12l8 4.5"
  }), e.createElement("path", {
    d: "M12 3v9"
  }), e.createElement("path", {
    d: "M12 12l-8 4.5"
  }));
}
var Xc = ["size", "color", "stroke"];
function Yc(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Xc);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-at-off",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M9.174 9.17a4 4 0 0 0 5.646 5.668m1.18 -2.838a4 4 0 0 0 -4 -4"
  }), e.createElement("path", {
    d: "M19.695 15.697a2.5 2.5 0 0 0 1.305 -2.197v-1.5a9 9 0 0 0 -13.055 -8.047m-2.322 1.683a9 9 0 0 0 9.877 14.644"
  }), e.createElement("path", {
    d: "M3 3l18 18"
  }));
}
var Zc = ["size", "color", "stroke"];
function $c(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Zc);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-at",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 4
  }), e.createElement("path", {
    d: "M16 12v1.5a2.5 2.5 0 0 0 5 0v-1.5a9 9 0 1 0 -5.5 8.28"
  }));
}
var _c = ["size", "color", "stroke"];
function es(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, _c);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-atom-2",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 3
  }), e.createElement("line", {
    x1: 12,
    y1: 21,
    x2: 12,
    y2: 21.01
  }), e.createElement("line", {
    x1: 3,
    y1: 9,
    x2: 3,
    y2: 9.01
  }), e.createElement("line", {
    x1: 21,
    y1: 9,
    x2: 21,
    y2: 9.01
  }), e.createElement("path", {
    d: "M8 20.1a9 9 0 0 1 -5 -7.1"
  }), e.createElement("path", {
    d: "M16 20.1a9 9 0 0 0 5 -7.1"
  }), e.createElement("path", {
    d: "M6.2 5a9 9 0 0 1 11.4 0"
  }));
}
var ts = ["size", "color", "stroke"];
function os(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, ts);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-atom-off",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M12 12v.01"
  }), e.createElement("path", {
    d: "M9.172 9.172c-3.906 3.905 -5.805 8.337 -4.243 9.9c1.562 1.561 5.994 -.338 9.9 -4.244m1.884 -2.113c2.587 -3.277 3.642 -6.502 2.358 -7.786c-1.284 -1.284 -4.508 -.23 -7.784 2.357"
  }), e.createElement("path", {
    d: "M4.929 4.929c-1.562 1.562 .337 5.994 4.243 9.9c3.905 3.905 8.337 5.804 9.9 4.242m-.072 -4.071c-.767 -1.794 -2.215 -3.872 -4.172 -5.828c-1.944 -1.945 -4.041 -3.402 -5.828 -4.172"
  }), e.createElement("path", {
    d: "M3 3l18 18"
  }));
}
var rs = ["size", "color", "stroke"];
function ns(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, rs);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-atom",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M12 12v.01"
  }), e.createElement("path", {
    d: "M19.071 4.929c-1.562 -1.562 -5.994 .337 -9.9 4.243c-3.905 3.905 -5.804 8.337 -4.242 9.9c1.562 1.561 5.994 -.338 9.9 -4.244c3.905 -3.905 5.804 -8.337 4.242 -9.9"
  }), e.createElement("path", {
    d: "M4.929 4.929c-1.562 1.562 .337 5.994 4.243 9.9c3.905 3.905 8.337 5.804 9.9 4.242c1.561 -1.562 -.338 -5.994 -4.244 -9.9c-3.905 -3.905 -8.337 -5.804 -9.9 -4.242"
  }));
}
var ls = ["size", "color", "stroke"];
function as(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, ls);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-augmented-reality-2",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M10 21h-2a2 2 0 0 1 -2 -2v-14a2 2 0 0 1 2 -2h8a2 2 0 0 1 2 2v3.5"
  }), e.createElement("path", {
    d: "M17 17l-4 -2.5l4 -2.5l4 2.5v4.5l-4 2.5z"
  }), e.createElement("path", {
    d: "M13 14.5v4.5l4 2.5"
  }), e.createElement("path", {
    d: "M17 17l4 -2.5"
  }), e.createElement("path", {
    d: "M11 4h2"
  }));
}
var is = ["size", "color", "stroke"];
function cs(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, is);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-augmented-reality-off",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M4 8v-2c0 -.557 .228 -1.061 .595 -1.424"
  }), e.createElement("path", {
    d: "M4 16v2a2 2 0 0 0 2 2h2"
  }), e.createElement("path", {
    d: "M16 4h2a2 2 0 0 1 2 2v2"
  }), e.createElement("path", {
    d: "M16 20h2c.558 0 1.062 -.228 1.425 -.596"
  }), e.createElement("path", {
    d: "M12 12.5l.312 -.195m2.457 -1.536l1.231 -.769"
  }), e.createElement("path", {
    d: "M9.225 9.235l-1.225 .765l4 2.5v4.5l3.076 -1.923m.924 -3.077v-2l-4 -2.5l-.302 .189"
  }), e.createElement("path", {
    d: "M8 10v4.5l4 2.5"
  }), e.createElement("path", {
    d: "M3 3l18 18"
  }));
}
var ss = ["size", "color", "stroke"];
function hs(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, ss);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-augmented-reality",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M4 8v-2a2 2 0 0 1 2 -2h2"
  }), e.createElement("path", {
    d: "M4 16v2a2 2 0 0 0 2 2h2"
  }), e.createElement("path", {
    d: "M16 4h2a2 2 0 0 1 2 2v2"
  }), e.createElement("path", {
    d: "M16 20h2a2 2 0 0 0 2 -2v-2"
  }), e.createElement("path", {
    d: "M12 12.5l4 -2.5"
  }), e.createElement("path", {
    d: "M8 10l4 2.5v4.5l4 -2.5v-4.5l-4 -2.5z"
  }), e.createElement("path", {
    d: "M8 10v4.5l4 2.5"
  }));
}
var ds = ["size", "color", "stroke"];
function vs(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, ds);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-award-off",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M16.72 12.704a6 6 0 0 0 -8.433 -8.418m-1.755 2.24a6 6 0 0 0 7.936 7.944"
  }), e.createElement("path", {
    d: "M12.002 15.003l3.4 5.89l1.598 -3.233l.707 .046m1.108 -2.902l-1.617 -2.8"
  }), e.createElement("path", {
    d: "M6.802 12.003l-3.4 5.89l3.598 -.233l1.598 3.232l3.4 -5.889"
  }), e.createElement("path", {
    d: "M3 3l18 18"
  }));
}
var ms = ["size", "color", "stroke"];
function ks(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, ms);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-award",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("circle", {
    cx: 12,
    cy: 9,
    r: 6
  }), e.createElement("path", {
    d: "M12.002 15.003l3.4 5.89l1.598 -3.233l3.598 .232l-3.4 -5.889"
  }), e.createElement("path", {
    d: "M6.802 12.003l-3.4 5.89l3.598 -.233l1.598 3.232l3.4 -5.889"
  }));
}
var ws = ["size", "color", "stroke"];
function ps(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, ws);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-axe",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M13 9l7.383 7.418c.823 .82 .823 2.148 0 2.967a2.11 2.11 0 0 1 -2.976 0l-7.407 -7.385"
  }), e.createElement("path", {
    d: "M6.66 15.66l-3.32 -3.32a1.25 1.25 0 0 1 .42 -2.044l3.24 -1.296l6 -6l3 3l-6 6l-1.296 3.24a1.25 1.25 0 0 1 -2.044 .42z"
  }));
}
var Es = ["size", "color", "stroke"];
function us(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Es);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-axis-x",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M4 13v.01"
  }), e.createElement("path", {
    d: "M4 9v.01"
  }), e.createElement("path", {
    d: "M4 5v.01"
  }), e.createElement("path", {
    d: "M17 20l3 -3l-3 -3"
  }), e.createElement("path", {
    d: "M4 17h16"
  }));
}
var gs = ["size", "color", "stroke"];
function Ms(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, gs);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-axis-y",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M11 20h-.01"
  }), e.createElement("path", {
    d: "M15 20h-.01"
  }), e.createElement("path", {
    d: "M19 20h-.01"
  }), e.createElement("path", {
    d: "M4 7l3 -3l3 3"
  }), e.createElement("path", {
    d: "M7 20v-16"
  }));
}
var xs = ["size", "color", "stroke"];
function fs(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, xs);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-baby-bottle",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M5 10h14"
  }), e.createElement("path", {
    d: "M12 2v2"
  }), e.createElement("path", {
    d: "M12 4a5 5 0 0 1 5 5v11a2 2 0 0 1 -2 2h-6a2 2 0 0 1 -2 -2v-11a5 5 0 0 1 5 -5z"
  }));
}
var zs = ["size", "color", "stroke"];
function bs(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, zs);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-baby-carriage",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("circle", {
    cx: 8,
    cy: 19,
    r: 2
  }), e.createElement("circle", {
    cx: 18,
    cy: 19,
    r: 2
  }), e.createElement("path", {
    d: "M2 5h2.5l1.632 4.897a6 6 0 0 0 5.693 4.103h2.675a5.5 5.5 0 0 0 0 -11h-.5v6"
  }), e.createElement("path", {
    d: "M6 9h14"
  }), e.createElement("path", {
    d: "M9 17l1 -3"
  }), e.createElement("path", {
    d: "M16 14l1 3"
  }));
}
var Ls = ["size", "color", "stroke"];
function ys(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Ls);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-backhoe",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("circle", {
    cx: 4,
    cy: 17,
    r: 2
  }), e.createElement("circle", {
    cx: 13,
    cy: 17,
    r: 2
  }), e.createElement("line", {
    x1: 13,
    y1: 19,
    x2: 4,
    y2: 19
  }), e.createElement("line", {
    x1: 4,
    y1: 15,
    x2: 13,
    y2: 15
  }), e.createElement("path", {
    d: "M8 12v-5h2a3 3 0 0 1 3 3v5"
  }), e.createElement("path", {
    d: "M5 15v-2a1 1 0 0 1 1 -1h7"
  }), e.createElement("path", {
    d: "M21.12 9.88l-3.12 -4.88l-5 5"
  }), e.createElement("path", {
    d: "M21.12 9.88a3 3 0 0 1 -2.12 5.12a3 3 0 0 1 -2.12 -.88l4.24 -4.24z"
  }));
}
var Cs = ["size", "color", "stroke"];
function js(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Cs);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-backpack-off",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M10 6h3a6 6 0 0 1 6 6v3m-.129 3.872a3.001 3.001 0 0 1 -2.871 2.128h-8a3 3 0 0 1 -3 -3v-6a5.99 5.99 0 0 1 2.285 -4.712"
  }), e.createElement("path", {
    d: "M10 6v-1a2 2 0 1 1 4 0v1"
  }), e.createElement("path", {
    d: "M9 21v-4a2 2 0 0 1 2 -2h2a2 2 0 0 1 2 2v4"
  }), e.createElement("path", {
    d: "M3 3l18 18"
  }));
}
var Bs = ["size", "color", "stroke"];
function Hs(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Bs);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-backpack",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M5 18v-6a6 6 0 0 1 6 -6h2a6 6 0 0 1 6 6v6a3 3 0 0 1 -3 3h-8a3 3 0 0 1 -3 -3z"
  }), e.createElement("path", {
    d: "M10 6v-1a2 2 0 1 1 4 0v1"
  }), e.createElement("path", {
    d: "M9 21v-4a2 2 0 0 1 2 -2h2a2 2 0 0 1 2 2v4"
  }), e.createElement("path", {
    d: "M11 10h2"
  }));
}
var Ns = ["size", "color", "stroke"];
function Ws(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Ns);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-backspace",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M20 6a1 1 0 0 1 1 1v10a1 1 0 0 1 -1 1h-11l-5 -5a1.5 1.5 0 0 1 0 -2l5 -5z"
  }), e.createElement("path", {
    d: "M12 10l4 4m0 -4l-4 4"
  }));
}
var qs = ["size", "color", "stroke"];
function Os(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, qs);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-badge-3d",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("rect", {
    x: 3,
    y: 5,
    width: 18,
    height: 14,
    rx: 2
  }), e.createElement("path", {
    d: "M7 9.5a0.5 .5 0 0 1 .5 -.5h1a1.5 1.5 0 0 1 0 3h-.5h.5a1.5 1.5 0 0 1 0 3h-1a0.5 .5 0 0 1 -.5 -.5"
  }), e.createElement("path", {
    d: "M14 9v6h1a2 2 0 0 0 2 -2v-2a2 2 0 0 0 -2 -2h-1z"
  }));
}
var Ps = ["size", "color", "stroke"];
function Ss(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Ps);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-badge-4k",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("rect", {
    x: 3,
    y: 5,
    width: 18,
    height: 14,
    rx: 2
  }), e.createElement("path", {
    d: "M7 9v2a1 1 0 0 0 1 1h1"
  }), e.createElement("path", {
    d: "M10 9v6"
  }), e.createElement("path", {
    d: "M14 9v6"
  }), e.createElement("path", {
    d: "M17 9l-2 3l2 3"
  }), e.createElement("path", {
    d: "M15 12h-1"
  }));
}
var Is = ["size", "color", "stroke"];
function As(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Is);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-badge-8k",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("rect", {
    x: 3,
    y: 5,
    width: 18,
    height: 14,
    rx: 2
  }), e.createElement("path", {
    d: "M14 9v6"
  }), e.createElement("path", {
    d: "M17 9l-2 3l2 3"
  }), e.createElement("path", {
    d: "M15 12h-1"
  }), e.createElement("path", {
    d: "M8.5 12h-.5a1 1 0 0 1 -1 -1v-1a1 1 0 0 1 1 -1h1a1 1 0 0 1 1 1v1a1 1 0 0 1 -1 1h-1a1 1 0 0 0 -1 1v1a1 1 0 0 0 1 1h1a1 1 0 0 0 1 -1v-1a1 1 0 0 0 -1 -1"
  }));
}
var Ds = ["size", "color", "stroke"];
function Fs(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Ds);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-badge-ad",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("rect", {
    x: 3,
    y: 5,
    width: 18,
    height: 14,
    rx: 2
  }), e.createElement("path", {
    d: "M14 9v6h1a2 2 0 0 0 2 -2v-2a2 2 0 0 0 -2 -2h-1z"
  }), e.createElement("path", {
    d: "M7 15v-4.5a1.5 1.5 0 0 1 3 0v4.5"
  }), e.createElement("path", {
    d: "M7 13h3"
  }));
}
var Gs = ["size", "color", "stroke"];
function Js(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Gs);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-badge-ar",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("rect", {
    x: 3,
    y: 5,
    width: 18,
    height: 14,
    rx: 2
  }), e.createElement("path", {
    d: "M7 15v-4.5a1.5 1.5 0 0 1 3 0v4.5"
  }), e.createElement("path", {
    d: "M7 13h3"
  }), e.createElement("path", {
    d: "M14 12h1.5a1.5 1.5 0 0 0 0 -3h-1.5v6m3 0l-2 -3"
  }));
}
var Ks = ["size", "color", "stroke"];
function Qs(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Ks);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-badge-cc",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("rect", {
    x: 3,
    y: 5,
    width: 18,
    height: 14,
    rx: 2
  }), e.createElement("path", {
    d: "M10 10.5a1.5 1.5 0 0 0 -3 0v3a1.5 1.5 0 0 0 3 0"
  }), e.createElement("path", {
    d: "M17 10.5a1.5 1.5 0 0 0 -3 0v3a1.5 1.5 0 0 0 3 0"
  }));
}
var Rs = ["size", "color", "stroke"];
function Ts(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Rs);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-badge-hd",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("rect", {
    x: 3,
    y: 5,
    width: 18,
    height: 14,
    rx: 2
  }), e.createElement("path", {
    d: "M14 9v6h1a2 2 0 0 0 2 -2v-2a2 2 0 0 0 -2 -2h-1z"
  }), e.createElement("path", {
    d: "M7 15v-6"
  }), e.createElement("path", {
    d: "M10 15v-6"
  }), e.createElement("path", {
    d: "M7 12h3"
  }));
}
var Us = ["size", "color", "stroke"];
function Vs(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Us);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-badge-off",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M7 7v10l5 3l5 -3m0 -4v-9l-5 3l-2.496 -1.497"
  }), e.createElement("path", {
    d: "M3 3l18 18"
  }));
}
var Xs = ["size", "color", "stroke"];
function Ys(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Xs);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-badge-sd",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("rect", {
    x: 3,
    y: 5,
    width: 18,
    height: 14,
    rx: 2
  }), e.createElement("path", {
    d: "M14 9v6h1a2 2 0 0 0 2 -2v-2a2 2 0 0 0 -2 -2h-1z"
  }), e.createElement("path", {
    d: "M7 14.25c0 .414 .336 .75 .75 .75h1.25a1 1 0 0 0 1 -1v-1a1 1 0 0 0 -1 -1h-1a1 1 0 0 1 -1 -1v-1a1 1 0 0 1 1 -1h1.25a0.75 .75 0 0 1 .75 .75"
  }));
}
var Zs = ["size", "color", "stroke"];
function $s(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Zs);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-badge-tm",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("rect", {
    x: 3,
    y: 5,
    width: 18,
    height: 14,
    rx: 2
  }), e.createElement("path", {
    d: "M6 9h4"
  }), e.createElement("path", {
    d: "M8 9v6"
  }), e.createElement("path", {
    d: "M13 15v-6l2 3l2 -3v6"
  }));
}
var _s = ["size", "color", "stroke"];
function eh(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, _s);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-badge-vo",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("rect", {
    x: 3,
    y: 5,
    width: 18,
    height: 14,
    rx: 2
  }), e.createElement("path", {
    d: "M7 9l2 6l2 -6"
  }), e.createElement("path", {
    d: "M15.5 9a1.5 1.5 0 0 1 1.5 1.5v3a1.5 1.5 0 0 1 -3 0v-3a1.5 1.5 0 0 1 1.5 -1.5z"
  }));
}
var th = ["size", "color", "stroke"];
function oh(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, th);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-badge-vr",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("rect", {
    x: 3,
    y: 5,
    width: 18,
    height: 14,
    rx: 2
  }), e.createElement("path", {
    d: "M14 12h1.5a1.5 1.5 0 0 0 0 -3h-1.5v6m3 0l-2 -3"
  }), e.createElement("path", {
    d: "M7 9l2 6l2 -6"
  }));
}
var rh = ["size", "color", "stroke"];
function nh(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, rh);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-badge-wc",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("rect", {
    x: 3,
    y: 5,
    width: 18,
    height: 14,
    rx: 2
  }), e.createElement("path", {
    d: "M6.5 9l.5 6l2 -4l2 4l.5 -6"
  }), e.createElement("path", {
    d: "M17 10.5a1.5 1.5 0 0 0 -3 0v3a1.5 1.5 0 0 0 3 0"
  }));
}
var lh = ["size", "color", "stroke"];
function ah(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, lh);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-badge",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M17 17v-13l-5 3l-5 -3v13l5 3z"
  }));
}
var ih = ["size", "color", "stroke"];
function ch(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, ih);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-badges-off",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M14.505 14.497l-2.505 1.503l-5 -3v4l5 3l5 -3"
  }), e.createElement("path", {
    d: "M13.873 9.876l3.127 -1.876v-4l-5 3l-2.492 -1.495m-2.508 1.495v1l2.492 1.495"
  }), e.createElement("path", {
    d: "M3 3l18 18"
  }));
}
var sh = ["size", "color", "stroke"];
function hh(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, sh);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-badges",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M17 17v-4l-5 3l-5 -3v4l5 3z"
  }), e.createElement("path", {
    d: "M17 8v-4l-5 3l-5 -3v4l5 3z"
  }));
}
var dh = ["size", "color", "stroke"];
function vh(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, dh);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-baguette",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M5.628 11.283l5.644 -5.637c2.665 -2.663 5.924 -3.747 8.663 -1.205l.188 .181a2.987 2.987 0 0 1 0 4.228l-11.287 11.274a2.996 2.996 0 0 1 -4.089 .135l-.143 -.135c-2.728 -2.724 -1.704 -6.117 1.024 -8.841z"
  }), e.createElement("path", {
    d: "M9.5 7.5l1.5 3.5"
  }), e.createElement("path", {
    d: "M6.5 10.5l1.5 3.5"
  }), e.createElement("path", {
    d: "M12.5 4.5l1.5 3.5"
  }));
}
var mh = ["size", "color", "stroke"];
function kh(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, mh);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-ball-american-football-off",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M15 9l-1 1m-2.003 2.003l-2.997 2.997"
  }), e.createElement("path", {
    d: "M10 12l2 2"
  }), e.createElement("path", {
    d: "M8 21a5 5 0 0 0 -5 -5"
  }), e.createElement("path", {
    d: "M6.813 6.802a12.96 12.96 0 0 0 -3.813 9.198a5 5 0 0 0 5 5a12.96 12.96 0 0 0 9.186 -3.801m1.789 -2.227a12.94 12.94 0 0 0 2.025 -6.972a5 5 0 0 0 -5 -5a12.94 12.94 0 0 0 -6.967 2.022"
  }), e.createElement("path", {
    d: "M16 3a5 5 0 0 0 5 5"
  }), e.createElement("path", {
    d: "M3 3l18 18"
  }));
}
var wh = ["size", "color", "stroke"];
function ph(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, wh);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-ball-american-football",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("line", {
    x1: 15,
    y1: 9,
    x2: 9,
    y2: 15
  }), e.createElement("line", {
    x1: 10,
    y1: 12,
    x2: 12,
    y2: 14
  }), e.createElement("line", {
    x1: 12,
    y1: 10,
    x2: 14,
    y2: 12
  }), e.createElement("path", {
    d: "M8 21a5 5 0 0 0 -5 -5"
  }), e.createElement("path", {
    d: "M16 3c-7.18 0 -13 5.82 -13 13a5 5 0 0 0 5 5c7.18 0 13 -5.82 13 -13a5 5 0 0 0 -5 -5"
  }), e.createElement("path", {
    d: "M16 3a5 5 0 0 0 5 5"
  }));
}
var Eh = ["size", "color", "stroke"];
function uh(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Eh);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-ball-baseball",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M5.636 18.364a9 9 0 1 0 12.728 -12.728a9 9 0 0 0 -12.728 12.728z"
  }), e.createElement("path", {
    d: "M12.495 3.02a9 9 0 0 1 -9.475 9.475"
  }), e.createElement("path", {
    d: "M20.98 11.505a9 9 0 0 0 -9.475 9.475"
  }), e.createElement("path", {
    d: "M9 9l2 2"
  }), e.createElement("path", {
    d: "M13 13l2 2"
  }), e.createElement("path", {
    d: "M11 7l2 1"
  }), e.createElement("path", {
    d: "M7 11l1 2"
  }), e.createElement("path", {
    d: "M16 11l1 2"
  }), e.createElement("path", {
    d: "M11 16l2 1"
  }));
}
var gh = ["size", "color", "stroke"];
function Mh(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, gh);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-ball-basketball",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 9
  }), e.createElement("line", {
    x1: 5.65,
    y1: 5.65,
    x2: 18.35,
    y2: 18.35
  }), e.createElement("line", {
    x1: 5.65,
    y1: 18.35,
    x2: 18.35,
    y2: 5.65
  }), e.createElement("path", {
    d: "M12 3a9 9 0 0 0 9 9"
  }), e.createElement("path", {
    d: "M3 12a9 9 0 0 1 9 9"
  }));
}
var xh = ["size", "color", "stroke"];
function fh(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, xh);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-ball-bowling",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 9
  }), e.createElement("line", {
    x1: 11,
    y1: 9,
    x2: 11,
    y2: 9.01
  }), e.createElement("line", {
    x1: 15,
    y1: 8,
    x2: 15,
    y2: 8.01
  }), e.createElement("line", {
    x1: 14,
    y1: 12,
    x2: 14,
    y2: 12.01
  }));
}
var zh = ["size", "color", "stroke"];
function bh(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, zh);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-ball-football-off",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M20.041 16.046a9 9 0 0 0 -12.084 -12.09m-2.323 1.683a9 9 0 0 0 12.726 12.73"
  }), e.createElement("path", {
    d: "M12 7l4.755 3.455l-.566 1.743l-.98 3.014l-.209 .788h-6l-1.755 -5.545l1.86 -1.351l2.313 -1.681z"
  }), e.createElement("path", {
    d: "M12 7v-4"
  }), e.createElement("line", {
    x1: 15,
    y1: 16,
    x2: 17.5,
    y2: 19
  }), e.createElement("path", {
    d: "M16.755 10.455l3.745 -1.455"
  }), e.createElement("path", {
    d: "M9.061 16.045l-2.561 2.955"
  }), e.createElement("path", {
    d: "M7.245 10.455l-3.745 -1.455"
  }), e.createElement("line", {
    x1: 3,
    y1: 3,
    x2: 21,
    y2: 21
  }));
}
var Lh = ["size", "color", "stroke"];
function yh(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Lh);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-ball-football",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 9
  }), e.createElement("path", {
    d: "M12 7l4.76 3.45l-1.76 5.55h-6l-1.76 -5.55z"
  }), e.createElement("path", {
    d: "M12 7v-4m3 13l2.5 3m-.74 -8.55l3.74 -1.45m-11.44 7.05l-2.56 2.95m.74 -8.55l-3.74 -1.45"
  }));
}
var Ch = ["size", "color", "stroke"];
function jh(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Ch);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-ball-tennis",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 9
  }), e.createElement("path", {
    d: "M6 5.3a9 9 0 0 1 0 13.4"
  }), e.createElement("path", {
    d: "M18 5.3a9 9 0 0 0 0 13.4"
  }));
}
var Bh = ["size", "color", "stroke"];
function Hh(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Bh);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-ball-volleyball",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 9
  }), e.createElement("path", {
    d: "M12 12a8 8 0 0 0 8 4"
  }), e.createElement("path", {
    d: "M7.5 13.5a12 12 0 0 0 8.5 6.5"
  }), e.createElement("path", {
    d: "M12 12a8 8 0 0 0 -7.464 4.928"
  }), e.createElement("path", {
    d: "M12.951 7.353a12 12 0 0 0 -9.88 4.111"
  }), e.createElement("path", {
    d: "M12 12a8 8 0 0 0 -.536 -8.928"
  }), e.createElement("path", {
    d: "M15.549 15.147a12 12 0 0 0 1.38 -10.611"
  }));
}
var Nh = ["size", "color", "stroke"];
function Wh(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Nh);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-ballon-off",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M14 8a2 2 0 0 0 -2 -2"
  }), e.createElement("path", {
    d: "M7.762 3.753a6 6 0 0 1 10.238 4.247c0 1.847 -.37 3.564 -1.007 4.993m-1.59 2.42c-.967 1.001 -2.14 1.587 -3.403 1.587c-3.314 0 -6 -4.03 -6 -9c0 -.593 .086 -1.166 .246 -1.707"
  }), e.createElement("path", {
    d: "M12 17v1a2 2 0 0 1 -2 2h-3a2 2 0 0 0 -2 2"
  }), e.createElement("path", {
    d: "M3 3l18 18"
  }));
}
var qh = ["size", "color", "stroke"];
function Oh(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, qh);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-ballon",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M14 8a2 2 0 0 0 -2 -2"
  }), e.createElement("path", {
    d: "M6 8a6 6 0 1 1 12 0c0 4.97 -2.686 9 -6 9s-6 -4.03 -6 -9"
  }), e.createElement("path", {
    d: "M12 17v1a2 2 0 0 1 -2 2h-3a2 2 0 0 0 -2 2"
  }));
}
var Ph = ["size", "color", "stroke"];
function Sh(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Ph);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-ballpen-off",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M14 6l7 7l-2 2"
  }), e.createElement("path", {
    d: "M10 10l-4.172 4.172a2.828 2.828 0 1 0 4 4l4.172 -4.172"
  }), e.createElement("path", {
    d: "M16 12l4.414 -4.414a2 2 0 0 0 0 -2.829l-1.171 -1.171a2 2 0 0 0 -2.829 0l-4.414 4.414"
  }), e.createElement("path", {
    d: "M4 20l1.768 -1.768"
  }), e.createElement("path", {
    d: "M3 3l18 18"
  }));
}
var Ih = ["size", "color", "stroke"];
function Ah(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Ih);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-ballpen",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M14 6l7 7l-4 4"
  }), e.createElement("path", {
    d: "M5.828 18.172a2.828 2.828 0 0 0 4 0l10.586 -10.586a2 2 0 0 0 0 -2.829l-1.171 -1.171a2 2 0 0 0 -2.829 0l-10.586 10.586a2.828 2.828 0 0 0 0 4z"
  }), e.createElement("path", {
    d: "M4 20l1.768 -1.768"
  }));
}
var Dh = ["size", "color", "stroke"];
function Fh(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Dh);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-ban",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 9
  }), e.createElement("line", {
    x1: 5.7,
    y1: 5.7,
    x2: 18.3,
    y2: 18.3
  }));
}
var Gh = ["size", "color", "stroke"];
function Jh(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Gh);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-bandage-off",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M10 12v.01"
  }), e.createElement("path", {
    d: "M12 14v.01"
  }), e.createElement("path", {
    d: "M10.513 6.487l1.987 -1.987a4.95 4.95 0 0 1 7 7l-2.018 2.018m-1.982 1.982l-4 4a4.95 4.95 0 0 1 -7 -7l4 -4"
  }), e.createElement("path", {
    d: "M3 3l18 18"
  }));
}
var Kh = ["size", "color", "stroke"];
function Qh(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Kh);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-bandage",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("line", {
    x1: 14,
    y1: 12,
    x2: 14,
    y2: 12.01
  }), e.createElement("line", {
    x1: 10,
    y1: 12,
    x2: 10,
    y2: 12.01
  }), e.createElement("line", {
    x1: 12,
    y1: 10,
    x2: 12,
    y2: 10.01
  }), e.createElement("line", {
    x1: 12,
    y1: 14,
    x2: 12,
    y2: 14.01
  }), e.createElement("path", {
    d: "M4.5 12.5l8 -8a4.94 4.94 0 0 1 7 7l-8 8a4.94 4.94 0 0 1 -7 -7"
  }));
}
var Rh = ["size", "color", "stroke"];
function Th(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Rh);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-barbell-off",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M2 12h1"
  }), e.createElement("path", {
    d: "M6 8h-2a1 1 0 0 0 -1 1v6a1 1 0 0 0 1 1h2"
  }), e.createElement("path", {
    d: "M6.298 6.288a0.997 .997 0 0 0 -.298 .712v10a1 1 0 0 0 1 1h1a1 1 0 0 0 1 -1v-8"
  }), e.createElement("path", {
    d: "M9 12h3"
  }), e.createElement("path", {
    d: "M15 15v2a1 1 0 0 0 1 1h1c.275 0 .523 -.11 .704 -.29m.296 -3.71v-7a1 1 0 0 0 -1 -1h-1a1 1 0 0 0 -1 1v4"
  }), e.createElement("path", {
    d: "M18 8h2a1 1 0 0 1 1 1v6a1 1 0 0 1 -1 1"
  }), e.createElement("path", {
    d: "M22 12h-1"
  }), e.createElement("path", {
    d: "M3 3l18 18"
  }));
}
var Uh = ["size", "color", "stroke"];
function Vh(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Uh);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-barbell",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M2 12h1"
  }), e.createElement("path", {
    d: "M6 8h-2a1 1 0 0 0 -1 1v6a1 1 0 0 0 1 1h2"
  }), e.createElement("path", {
    d: "M6 7v10a1 1 0 0 0 1 1h1a1 1 0 0 0 1 -1v-10a1 1 0 0 0 -1 -1h-1a1 1 0 0 0 -1 1z"
  }), e.createElement("path", {
    d: "M9 12h6"
  }), e.createElement("path", {
    d: "M15 7v10a1 1 0 0 0 1 1h1a1 1 0 0 0 1 -1v-10a1 1 0 0 0 -1 -1h-1a1 1 0 0 0 -1 1z"
  }), e.createElement("path", {
    d: "M18 8h2a1 1 0 0 1 1 1v6a1 1 0 0 1 -1 1h-2"
  }), e.createElement("path", {
    d: "M22 12h-1"
  }));
}
var Xh = ["size", "color", "stroke"];
function Yh(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Xh);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-barcode-off",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M4 7v-1c0 -.552 .224 -1.052 .586 -1.414"
  }), e.createElement("path", {
    d: "M4 17v1a2 2 0 0 0 2 2h2"
  }), e.createElement("path", {
    d: "M16 4h2a2 2 0 0 1 2 2v1"
  }), e.createElement("path", {
    d: "M16 20h2c.551 0 1.05 -.223 1.412 -.584"
  }), e.createElement("path", {
    d: "M5 11h1v2h-1z"
  }), e.createElement("path", {
    d: "M10 11v2"
  }), e.createElement("path", {
    d: "M15 11v.01"
  }), e.createElement("path", {
    d: "M19 11v2"
  }), e.createElement("path", {
    d: "M3 3l18 18"
  }));
}
var Zh = ["size", "color", "stroke"];
function $h(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Zh);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-barcode",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M4 7v-1a2 2 0 0 1 2 -2h2"
  }), e.createElement("path", {
    d: "M4 17v1a2 2 0 0 0 2 2h2"
  }), e.createElement("path", {
    d: "M16 4h2a2 2 0 0 1 2 2v1"
  }), e.createElement("path", {
    d: "M16 20h2a2 2 0 0 0 2 -2v-1"
  }), e.createElement("rect", {
    x: 5,
    y: 11,
    width: 1,
    height: 2
  }), e.createElement("line", {
    x1: 10,
    y1: 11,
    x2: 10,
    y2: 13
  }), e.createElement("rect", {
    x: 14,
    y: 11,
    width: 1,
    height: 2
  }), e.createElement("line", {
    x1: 19,
    y1: 11,
    x2: 19,
    y2: 13
  }));
}
var _h = ["size", "color", "stroke"];
function ed(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, _h);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-barrel-off",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M8 4h8.722a2 2 0 0 1 1.841 1.22c.958 2.26 1.437 4.52 1.437 6.78a16.35 16.35 0 0 1 -.407 3.609m-.964 3.013l-.066 .158a2 2 0 0 1 -1.841 1.22h-9.444a2 2 0 0 1 -1.841 -1.22c-.958 -2.26 -1.437 -4.52 -1.437 -6.78c0 -2.21 .458 -4.42 1.374 -6.63"
  }), e.createElement("path", {
    d: "M14 4c.585 2.337 .913 4.674 .985 7.01m-.114 3.86a33.415 33.415 0 0 1 -.871 5.13"
  }), e.createElement("path", {
    d: "M10 4a34.42 34.42 0 0 0 -.366 1.632m-.506 3.501a32.126 32.126 0 0 0 -.128 2.867c0 2.667 .333 5.333 1 8"
  }), e.createElement("path", {
    d: "M4.5 16h11.5"
  }), e.createElement("path", {
    d: "M19.5 8h-7.5m-4 0h-3.5"
  }), e.createElement("path", {
    d: "M3 3l18 18"
  }));
}
var td = ["size", "color", "stroke"];
function od(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, td);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-barrel",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M7.278 4h9.444a2 2 0 0 1 1.841 1.22c.958 2.26 1.437 4.52 1.437 6.78c0 2.26 -.479 4.52 -1.437 6.78a2 2 0 0 1 -1.841 1.22h-9.444a2 2 0 0 1 -1.841 -1.22c-.958 -2.26 -1.437 -4.52 -1.437 -6.78c0 -2.26 .479 -4.52 1.437 -6.78a2 2 0 0 1 1.841 -1.22z"
  }), e.createElement("path", {
    d: "M14 4c.667 2.667 1 5.333 1 8s-.333 5.333 -1 8"
  }), e.createElement("path", {
    d: "M10 4c-.667 2.667 -1 5.333 -1 8s.333 5.333 1 8"
  }), e.createElement("path", {
    d: "M4.5 16h15"
  }), e.createElement("path", {
    d: "M19.5 8h-15"
  }));
}
var rd = ["size", "color", "stroke"];
function nd(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, rd);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-barrier-block-off",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M11 7h8a1 1 0 0 1 1 1v7c0 .27 -.107 .516 -.282 .696"
  }), e.createElement("path", {
    d: "M16 16h-11a1 1 0 0 1 -1 -1v-7a1 1 0 0 1 1 -1h2"
  }), e.createElement("path", {
    d: "M7 16v4"
  }), e.createElement("path", {
    d: "M7.5 16l4.244 -4.244"
  }), e.createElement("path", {
    d: "M13.745 9.755l2.755 -2.755"
  }), e.createElement("path", {
    d: "M13.5 16l1.249 -1.249"
  }), e.createElement("path", {
    d: "M16.741 12.759l3.259 -3.259"
  }), e.createElement("path", {
    d: "M4 13.5l4.752 -4.752"
  }), e.createElement("path", {
    d: "M17 17v3"
  }), e.createElement("path", {
    d: "M5 20h4"
  }), e.createElement("path", {
    d: "M15 20h4"
  }), e.createElement("path", {
    d: "M17 7v-2"
  }), e.createElement("path", {
    d: "M3 3l18 18"
  }));
}
var ld = ["size", "color", "stroke"];
function ad(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, ld);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-barrier-block",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("rect", {
    x: 4,
    y: 7,
    width: 16,
    height: 9,
    rx: 1
  }), e.createElement("path", {
    d: "M7 16v4"
  }), e.createElement("path", {
    d: "M7.5 16l9 -9"
  }), e.createElement("path", {
    d: "M13.5 16l6.5 -6.5"
  }), e.createElement("path", {
    d: "M4 13.5l6.5 -6.5"
  }), e.createElement("path", {
    d: "M17 16v4"
  }), e.createElement("path", {
    d: "M5 20h4"
  }), e.createElement("path", {
    d: "M15 20h4"
  }), e.createElement("path", {
    d: "M17 7v-2"
  }), e.createElement("path", {
    d: "M7 7v-2"
  }));
}
var id = ["size", "color", "stroke"];
function cd(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, id);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-baseline",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M4 20h16"
  }), e.createElement("path", {
    d: "M8 16v-8a4 4 0 1 1 8 0v8"
  }), e.createElement("path", {
    d: "M8 10h8"
  }));
}
var sd = ["size", "color", "stroke"];
function hd(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, sd);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-basket-off",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M7 10l1.359 -1.63"
  }), e.createElement("path", {
    d: "M10.176 6.188l1.824 -2.188l5 6"
  }), e.createElement("path", {
    d: "M18.77 18.757c-.358 .768 -1.027 1.262 -1.77 1.243h-10c-.966 .024 -1.807 -.817 -2 -2l-2 -8h7"
  }), e.createElement("path", {
    d: "M14 10h7l-1.397 5.587"
  }), e.createElement("circle", {
    cx: 12,
    cy: 15,
    r: 2
  }), e.createElement("path", {
    d: "M3 3l18 18"
  }));
}
var dd = ["size", "color", "stroke"];
function vd(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, dd);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-basket",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("polyline", {
    points: "7 10 12 4 17 10"
  }), e.createElement("path", {
    d: "M21 10l-2 8a2 2.5 0 0 1 -2 2h-10a2 2.5 0 0 1 -2 -2l-2 -8z"
  }), e.createElement("circle", {
    cx: 12,
    cy: 15,
    r: 2
  }));
}
var md = ["size", "color", "stroke"];
function kd(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, md);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-bat",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M17 16c.74 -2.286 2.778 -3.762 5 -3c-.173 -2.595 .13 -5.314 -2 -7.5c-1.708 2.648 -3.358 2.557 -5 2.5v-4l-3 2l-3 -2v4c-1.642 .057 -3.292 .148 -5 -2.5c-2.13 2.186 -1.827 4.905 -2 7.5c2.222 -.762 4.26 .714 5 3c2.593 0 3.889 .952 5 4c1.111 -3.048 2.407 -4 5 -4z"
  }), e.createElement("path", {
    d: "M9 8a3 3 0 0 0 6 0"
  }));
}
var wd = ["size", "color", "stroke"];
function pd(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, wd);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-bath-off",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M16 12h4a1 1 0 0 1 1 1v3c0 .311 -.036 .614 -.103 .904m-1.61 2.378a3.982 3.982 0 0 1 -2.287 .718h-10a4 4 0 0 1 -4 -4v-3a1 1 0 0 1 1 -1h8"
  }), e.createElement("path", {
    d: "M6 12v-6m1.178 -2.824c.252 -.113 .53 -.176 .822 -.176h3v2.25"
  }), e.createElement("path", {
    d: "M4 21l1 -1.5"
  }), e.createElement("path", {
    d: "M20 21l-1 -1.5"
  }), e.createElement("path", {
    d: "M3 3l18 18"
  }));
}
var Ed = ["size", "color", "stroke"];
function ud(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Ed);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-bath",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M4 12h16a1 1 0 0 1 1 1v3a4 4 0 0 1 -4 4h-10a4 4 0 0 1 -4 -4v-3a1 1 0 0 1 1 -1z"
  }), e.createElement("path", {
    d: "M6 12v-7a2 2 0 0 1 2 -2h3v2.25"
  }), e.createElement("path", {
    d: "M4 21l1 -1.5"
  }), e.createElement("path", {
    d: "M20 21l-1 -1.5"
  }));
}
var gd = ["size", "color", "stroke"];
function Md(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, gd);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-battery-1",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M6 7h11a2 2 0 0 1 2 2v.5a0.5 .5 0 0 0 .5 .5a0.5 .5 0 0 1 .5 .5v3a0.5 .5 0 0 1 -.5 .5a0.5 .5 0 0 0 -.5 .5v.5a2 2 0 0 1 -2 2h-11a2 2 0 0 1 -2 -2v-6a2 2 0 0 1 2 -2"
  }), e.createElement("line", {
    x1: 7,
    y1: 10,
    x2: 7,
    y2: 14
  }));
}
var xd = ["size", "color", "stroke"];
function fd(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, xd);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-battery-2",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M6 7h11a2 2 0 0 1 2 2v.5a0.5 .5 0 0 0 .5 .5a0.5 .5 0 0 1 .5 .5v3a0.5 .5 0 0 1 -.5 .5a0.5 .5 0 0 0 -.5 .5v.5a2 2 0 0 1 -2 2h-11a2 2 0 0 1 -2 -2v-6a2 2 0 0 1 2 -2"
  }), e.createElement("line", {
    x1: 7,
    y1: 10,
    x2: 7,
    y2: 14
  }), e.createElement("line", {
    x1: 10,
    y1: 10,
    x2: 10,
    y2: 14
  }));
}
var zd = ["size", "color", "stroke"];
function bd(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, zd);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-battery-3",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M6 7h11a2 2 0 0 1 2 2v.5a0.5 .5 0 0 0 .5 .5a0.5 .5 0 0 1 .5 .5v3a0.5 .5 0 0 1 -.5 .5a0.5 .5 0 0 0 -.5 .5v.5a2 2 0 0 1 -2 2h-11a2 2 0 0 1 -2 -2v-6a2 2 0 0 1 2 -2"
  }), e.createElement("line", {
    x1: 7,
    y1: 10,
    x2: 7,
    y2: 14
  }), e.createElement("line", {
    x1: 10,
    y1: 10,
    x2: 10,
    y2: 14
  }), e.createElement("line", {
    x1: 13,
    y1: 10,
    x2: 13,
    y2: 14
  }));
}
var Ld = ["size", "color", "stroke"];
function yd(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Ld);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-battery-4",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M6 7h11a2 2 0 0 1 2 2v.5a0.5 .5 0 0 0 .5 .5a0.5 .5 0 0 1 .5 .5v3a0.5 .5 0 0 1 -.5 .5a0.5 .5 0 0 0 -.5 .5v.5a2 2 0 0 1 -2 2h-11a2 2 0 0 1 -2 -2v-6a2 2 0 0 1 2 -2"
  }), e.createElement("line", {
    x1: 7,
    y1: 10,
    x2: 7,
    y2: 14
  }), e.createElement("line", {
    x1: 10,
    y1: 10,
    x2: 10,
    y2: 14
  }), e.createElement("line", {
    x1: 13,
    y1: 10,
    x2: 13,
    y2: 14
  }), e.createElement("line", {
    x1: 16,
    y1: 10,
    x2: 16,
    y2: 14
  }));
}
var Cd = ["size", "color", "stroke"];
function jd(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Cd);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-battery-automotive",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("rect", {
    x: 3,
    y: 6,
    width: 18,
    height: 14,
    rx: 2
  }), e.createElement("path", {
    d: "M6 6v-2"
  }), e.createElement("line", {
    x1: 19,
    y1: 4,
    x2: 19,
    y2: 6
  }), e.createElement("line", {
    x1: 6.5,
    y1: 13,
    x2: 9.5,
    y2: 13
  }), e.createElement("line", {
    x1: 14.5,
    y1: 13,
    x2: 17.5,
    y2: 13
  }), e.createElement("line", {
    x1: 16,
    y1: 11.5,
    x2: 16,
    y2: 14.5
  }));
}
var Bd = ["size", "color", "stroke"];
function Hd(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Bd);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-battery-charging-2",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M4 9a2 2 0 0 1 2 -2h11a2 2 0 0 1 2 2v.5a0.5 .5 0 0 0 .5 .5a0.5 .5 0 0 1 .5 .5v3a0.5 .5 0 0 1 -.5 .5a0.5 .5 0 0 0 -.5 .5v.5a2 2 0 0 1 -2 2h-4.5"
  }), e.createElement("path", {
    d: "M3 15h6v2a2 2 0 0 1 -2 2h-2a2 2 0 0 1 -2 -2v-2z"
  }), e.createElement("path", {
    d: "M6 22v-3"
  }), e.createElement("path", {
    d: "M4 15v-2.5"
  }), e.createElement("path", {
    d: "M8 15v-2.5"
  }));
}
var Nd = ["size", "color", "stroke"];
function Wd(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Nd);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-battery-charging",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M16 7h1a2 2 0 0 1 2 2v.5a0.5 .5 0 0 0 .5 .5a0.5 .5 0 0 1 .5 .5v3a0.5 .5 0 0 1 -.5 .5a0.5 .5 0 0 0 -.5 .5v.5a2 2 0 0 1 -2 2h-2"
  }), e.createElement("path", {
    d: "M8 7h-2a2 2 0 0 0 -2 2v6a2 2 0 0 0 2 2h1"
  }), e.createElement("path", {
    d: "M12 8l-2 4h3l-2 4"
  }));
}
var qd = ["size", "color", "stroke"];
function Od(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, qd);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-battery-eco",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M4 9a2 2 0 0 1 2 -2h11a2 2 0 0 1 2 2v.5a0.5 .5 0 0 0 .5 .5a0.5 .5 0 0 1 .5 .5v3a0.5 .5 0 0 1 -.5 .5a0.5 .5 0 0 0 -.5 .5v.5a2 2 0 0 1 -2 2h-5.5"
  }), e.createElement("path", {
    d: "M3 16.143c0 -2.84 2.09 -5.143 4.667 -5.143h2.333v.857c0 2.84 -2.09 5.143 -4.667 5.143h-2.333v-.857z"
  }), e.createElement("path", {
    d: "M3 20v-3"
  }));
}
var Pd = ["size", "color", "stroke"];
function Sd(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Pd);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-battery-off",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("line", {
    x1: 3,
    y1: 3,
    x2: 21,
    y2: 21
  }), e.createElement("path", {
    d: "M11 7h6a2 2 0 0 1 2 2v.5a0.5 .5 0 0 0 .5 .5a0.5 .5 0 0 1 .5 .5v3a0.5 .5 0 0 1 -.5 .5a0.5 .5 0 0 0 -.5 .5v.5m-2 2h-11a2 2 0 0 1 -2 -2v-6a2 2 0 0 1 2 -2h1"
  }));
}
var Id = ["size", "color", "stroke"];
function Ad(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Id);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-battery",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M6 7h11a2 2 0 0 1 2 2v.5a0.5 .5 0 0 0 .5 .5a0.5 .5 0 0 1 .5 .5v3a0.5 .5 0 0 1 -.5 .5a0.5 .5 0 0 0 -.5 .5v.5a2 2 0 0 1 -2 2h-11a2 2 0 0 1 -2 -2v-6a2 2 0 0 1 2 -2"
  }));
}
var Dd = ["size", "color", "stroke"];
function Fd(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Dd);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-beach-off",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M15.071 15.102a7.502 7.502 0 0 0 -8.124 1.648"
  }), e.createElement("path", {
    d: "M10.27 6.269l9.926 5.731a6 6 0 0 0 -10.32 -6.123"
  }), e.createElement("path", {
    d: "M16.732 10c1.658 -2.87 2.225 -5.644 1.268 -6.196c-.957 -.552 -3.075 1.326 -4.732 4.196"
  }), e.createElement("path", {
    d: "M15 9l-.739 1.279"
  }), e.createElement("path", {
    d: "M12.794 12.82l-.794 1.376"
  }), e.createElement("path", {
    d: "M3 19.25a2.4 2.4 0 0 1 1 -.25a2.4 2.4 0 0 1 2 1a2.4 2.4 0 0 0 2 1a2.4 2.4 0 0 0 2 -1a2.4 2.4 0 0 1 2 -1a2.4 2.4 0 0 1 2 1a2.4 2.4 0 0 0 2 1a2.4 2.4 0 0 0 2 -1a2.4 2.4 0 0 1 1.135 -.858"
  }), e.createElement("path", {
    d: "M3 3l18 18"
  }));
}
var Gd = ["size", "color", "stroke"];
function Jd(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Gd);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-beach",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M17.553 16.75a7.5 7.5 0 0 0 -10.606 0"
  }), e.createElement("path", {
    d: "M18 3.804a6 6 0 0 0 -8.196 2.196l10.392 6a6 6 0 0 0 -2.196 -8.196z"
  }), e.createElement("path", {
    d: "M16.732 10c1.658 -2.87 2.225 -5.644 1.268 -6.196c-.957 -.552 -3.075 1.326 -4.732 4.196"
  }), e.createElement("path", {
    d: "M15 9l-3 5.196"
  }), e.createElement("path", {
    d: "M3 19.25a2.4 2.4 0 0 1 1 -.25a2.4 2.4 0 0 1 2 1a2.4 2.4 0 0 0 2 1a2.4 2.4 0 0 0 2 -1a2.4 2.4 0 0 1 2 -1a2.4 2.4 0 0 1 2 1a2.4 2.4 0 0 0 2 1a2.4 2.4 0 0 0 2 -1a2.4 2.4 0 0 1 2 -1a2.4 2.4 0 0 1 1 .25"
  }));
}
var Kd = ["size", "color", "stroke"];
function Qd(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Kd);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-bed-off",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M3 7v11"
  }), e.createElement("path", {
    d: "M3 14h11"
  }), e.createElement("path", {
    d: "M18 14h3"
  }), e.createElement("path", {
    d: "M21 18v-8a2 2 0 0 0 -2 -2h-7"
  }), e.createElement("path", {
    d: "M11 11v3"
  }), e.createElement("circle", {
    cx: 7,
    cy: 10,
    r: 1
  }), e.createElement("path", {
    d: "M3 3l18 18"
  }));
}
var Rd = ["size", "color", "stroke"];
function Td(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Rd);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-bed",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M3 7v11m0 -4h18m0 4v-8a2 2 0 0 0 -2 -2h-8v6"
  }), e.createElement("circle", {
    cx: 7,
    cy: 10,
    r: 1
  }));
}
var Ud = ["size", "color", "stroke"];
function Vd(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Ud);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-beer-off",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M7 7v1.111c0 1.242 .29 2.467 .845 3.578l.31 .622a8 8 0 0 1 .845 3.578v4.111h6v-4.111a8 8 0 0 1 .045 -.85m.953 -3.035l.157 -.315a7.999 7.999 0 0 0 .845 -3.578v-4.111h-9"
  }), e.createElement("path", {
    d: "M7 8h1m4 0h5"
  }), e.createElement("path", {
    d: "M3 3l18 18"
  }));
}
var Xd = ["size", "color", "stroke"];
function Yd(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Xd);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-beer",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M9 20h6v-4.111a8 8 0 0 1 .845 -3.578l.31 -.622a8 8 0 0 0 .845 -3.578v-4.111h-10v4.111a8 8 0 0 0 .845 3.578l.31 .622a8 8 0 0 1 .845 3.578v4.111z"
  }), e.createElement("path", {
    d: "M7 8h10"
  }));
}
var Zd = ["size", "color", "stroke"];
function $d(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Zd);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-bell-minus",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M10 5a2 2 0 1 1 4 0a7 7 0 0 1 4 6v3a4 4 0 0 0 2 3h-16a4 4 0 0 0 2 -3v-3a7 7 0 0 1 4 -6"
  }), e.createElement("path", {
    d: "M9 17v1a3 3 0 0 0 6 0v-1"
  }), e.createElement("line", {
    x1: 10,
    y1: 11,
    x2: 14,
    y2: 11
  }));
}
var _d = ["size", "color", "stroke"];
function ev(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, _d);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-bell-off",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("line", {
    x1: 3,
    y1: 3,
    x2: 21,
    y2: 21
  }), e.createElement("path", {
    d: "M17 17h-13a4 4 0 0 0 2 -3v-3a7 7 0 0 1 1.279 -3.716m2.072 -1.934c.209 -.127 .425 -.244 .649 -.35a2 2 0 1 1 4 0a7 7 0 0 1 4 6v3"
  }), e.createElement("path", {
    d: "M9 17v1a3 3 0 0 0 6 0v-1"
  }));
}
var tv = ["size", "color", "stroke"];
function ov(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, tv);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-bell-plus",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M10 5a2 2 0 1 1 4 0a7 7 0 0 1 4 6v3a4 4 0 0 0 2 3h-16a4 4 0 0 0 2 -3v-3a7 7 0 0 1 4 -6"
  }), e.createElement("path", {
    d: "M9 17v1a3 3 0 0 0 6 0v-1"
  }), e.createElement("line", {
    x1: 10,
    y1: 11,
    x2: 14,
    y2: 11
  }), e.createElement("line", {
    x1: 12,
    y1: 9,
    x2: 12,
    y2: 13
  }));
}
var rv = ["size", "color", "stroke"];
function nv(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, rv);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-bell-ringing-2",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M19.364 4.636a2 2 0 0 1 0 2.828a7 7 0 0 1 -1.414 7.072l-2.122 2.12a4 4 0 0 0 -.707 3.536l-11.313 -11.312a4 4 0 0 0 3.535 -.707l2.121 -2.123a7 7 0 0 1 7.072 -1.414a2 2 0 0 1 2.828 0z"
  }), e.createElement("path", {
    d: "M7.343 12.414l-.707 .707a3 3 0 0 0 4.243 4.243l.707 -.707"
  }));
}
var lv = ["size", "color", "stroke"];
function av(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, lv);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-bell-ringing",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M10 5a2 2 0 0 1 4 0a7 7 0 0 1 4 6v3a4 4 0 0 0 2 3h-16a4 4 0 0 0 2 -3v-3a7 7 0 0 1 4 -6"
  }), e.createElement("path", {
    d: "M9 17v1a3 3 0 0 0 6 0v-1"
  }), e.createElement("path", {
    d: "M21 6.727a11.05 11.05 0 0 0 -2.794 -3.727"
  }), e.createElement("path", {
    d: "M3 6.727a11.05 11.05 0 0 1 2.792 -3.727"
  }));
}
var iv = ["size", "color", "stroke"];
function cv(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, iv);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-bell-school",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 6
  }), e.createElement("path", {
    d: "M13.5 15h.5a2 2 0 0 1 2 2v1a2 2 0 0 1 -2 2h-8a2 2 0 0 1 -2 -2v-1a2 2 0 0 1 2 -2h.5"
  }), e.createElement("path", {
    d: "M16 17a5.698 5.698 0 0 0 4.467 -7.932l-.467 -1.068"
  }), e.createElement("path", {
    d: "M10 10v.01"
  }), e.createElement("circle", {
    cx: 20,
    cy: 8,
    r: 1
  }));
}
var sv = ["size", "color", "stroke"];
function hv(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, sv);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-bell-x",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M10 5a2 2 0 1 1 4 0a7 7 0 0 1 4 6v3a4 4 0 0 0 2 3h-16a4 4 0 0 0 2 -3v-3a7 7 0 0 1 4 -6"
  }), e.createElement("path", {
    d: "M9 17v1a3 3 0 0 0 6 0v-1"
  }), e.createElement("path", {
    d: "M10.5 9.5l3 3m0 -3l-3 3"
  }));
}
var dv = ["size", "color", "stroke"];
function vv(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, dv);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-bell-z",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M10 5a2 2 0 1 1 4 0a7 7 0 0 1 4 6v3a4 4 0 0 0 2 3h-16a4 4 0 0 0 2 -3v-3a7 7 0 0 1 4 -6"
  }), e.createElement("path", {
    d: "M9 17v1a3 3 0 0 0 6 0v-1"
  }), e.createElement("path", {
    d: "M10 9h4l-4 4h4"
  }));
}
var mv = ["size", "color", "stroke"];
function kv(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, mv);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-bell",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M10 5a2 2 0 0 1 4 0a7 7 0 0 1 4 6v3a4 4 0 0 0 2 3h-16a4 4 0 0 0 2 -3v-3a7 7 0 0 1 4 -6"
  }), e.createElement("path", {
    d: "M9 17v1a3 3 0 0 0 6 0v-1"
  }));
}
var wv = ["size", "color", "stroke"];
function pv(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, wv);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-beta",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M8 22v-14a4 4 0 0 1 4 -4h.5a3.5 3.5 0 0 1 0 7h-.5h.5a4.5 4.5 0 1 1 -4.5 4.5v-.5"
  }));
}
var Ev = ["size", "color", "stroke"];
function uv(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Ev);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-bible",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M19 4v16h-12a2 2 0 0 1 -2 -2v-12a2 2 0 0 1 2 -2h12z"
  }), e.createElement("path", {
    d: "M19 16h-12a2 2 0 0 0 -2 2"
  }), e.createElement("path", {
    d: "M12 7v6"
  }), e.createElement("path", {
    d: "M10 9h4"
  }));
}
var gv = ["size", "color", "stroke"];
function Mv(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, gv);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-bike-off",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("circle", {
    cx: 5,
    cy: 18,
    r: 3
  }), e.createElement("path", {
    d: "M16.437 16.44a3 3 0 0 0 4.123 4.123m1.44 -2.563a3 3 0 0 0 -3 -3"
  }), e.createElement("path", {
    d: "M12 19v-4l-3 -3l1.665 -1.332m2.215 -1.772l1.12 -.896l2 3h3"
  }), e.createElement("circle", {
    cx: 17,
    cy: 5,
    r: 1
  }), e.createElement("path", {
    d: "M3 3l18 18"
  }));
}
var xv = ["size", "color", "stroke"];
function fv(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, xv);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-bike",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("circle", {
    cx: 5,
    cy: 18,
    r: 3
  }), e.createElement("circle", {
    cx: 19,
    cy: 18,
    r: 3
  }), e.createElement("polyline", {
    points: "12 19 12 15 9 12 14 8 16 11 19 11"
  }), e.createElement("circle", {
    cx: 17,
    cy: 5,
    r: 1
  }));
}
var zv = ["size", "color", "stroke"];
function bv(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, zv);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-binary-off",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M11 7v-2h-1"
  }), e.createElement("path", {
    d: "M18 19v-1"
  }), e.createElement("path", {
    d: "M15.5 5h2a0.5 .5 0 0 1 .5 .5v4a0.5 .5 0 0 1 -.5 .5h-2a0.5 .5 0 0 1 -.5 -.5v-4a0.5 .5 0 0 1 .5 -.5z"
  }), e.createElement("path", {
    d: "M10.5 14h2a0.5 .5 0 0 1 .5 .5v4a0.5 .5 0 0 1 -.5 .5h-2a0.5 .5 0 0 1 -.5 -.5v-4a0.5 .5 0 0 1 .5 -.5z"
  }), e.createElement("path", {
    d: "M6 10v.01"
  }), e.createElement("path", {
    d: "M6 19v.01"
  }), e.createElement("path", {
    d: "M3 3l18 18"
  }));
}
var Lv = ["size", "color", "stroke"];
function yv(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Lv);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-binary-tree-2",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M14 6a2 2 0 1 0 -4 0a2 2 0 0 0 4 0z"
  }), e.createElement("path", {
    d: "M7 14a2 2 0 1 0 -4 0a2 2 0 0 0 4 0z"
  }), e.createElement("path", {
    d: "M21 14a2 2 0 1 0 -4 0a2 2 0 0 0 4 0z"
  }), e.createElement("path", {
    d: "M14 18a2 2 0 1 0 -4 0a2 2 0 0 0 4 0z"
  }), e.createElement("path", {
    d: "M12 8v8"
  }), e.createElement("path", {
    d: "M6.316 12.496l4.368 -4.992"
  }), e.createElement("path", {
    d: "M17.684 12.496l-4.366 -4.99"
  }));
}
var Cv = ["size", "color", "stroke"];
function jv(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Cv);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-binary-tree",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M6 20a2 2 0 1 0 -4 0a2 2 0 0 0 4 0z"
  }), e.createElement("path", {
    d: "M16 4a2 2 0 1 0 -4 0a2 2 0 0 0 4 0z"
  }), e.createElement("path", {
    d: "M16 20a2 2 0 1 0 -4 0a2 2 0 0 0 4 0z"
  }), e.createElement("path", {
    d: "M11 12a2 2 0 1 0 -4 0a2 2 0 0 0 4 0z"
  }), e.createElement("path", {
    d: "M21 12a2 2 0 1 0 -4 0a2 2 0 0 0 4 0z"
  }), e.createElement("path", {
    d: "M5.058 18.306l2.88 -4.606"
  }), e.createElement("path", {
    d: "M10.061 10.303l2.877 -4.604"
  }), e.createElement("path", {
    d: "M10.065 13.705l2.876 4.6"
  }), e.createElement("path", {
    d: "M15.063 5.7l2.881 4.61"
  }));
}
var Bv = ["size", "color", "stroke"];
function Hv(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Bv);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-binary",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M11 10v-5h-1m8 14v-5h-1"
  }), e.createElement("rect", {
    x: 15,
    y: 5,
    width: 3,
    height: 5,
    rx: .5
  }), e.createElement("rect", {
    x: 10,
    y: 14,
    width: 3,
    height: 5,
    rx: .5
  }), e.createElement("path", {
    d: "M6 10h.01m-.01 9h.01"
  }));
}
var Nv = ["size", "color", "stroke"];
function Wv(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Nv);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-biohazard-off",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M10.586 10.586a2 2 0 1 0 2.836 2.82"
  }), e.createElement("path", {
    d: "M11.939 14c0 .173 .048 .351 .056 .533v.217a4.75 4.75 0 0 1 -4.533 4.745h-.217"
  }), e.createElement("path", {
    d: "M2.495 14.745a4.75 4.75 0 0 1 7.737 -3.693"
  }), e.createElement("path", {
    d: "M16.745 19.495a4.75 4.75 0 0 1 -4.69 -5.503h-.06"
  }), e.createElement("path", {
    d: "M14.533 10.538a4.75 4.75 0 0 1 6.957 3.987v.217"
  }), e.createElement("path", {
    d: "M10.295 10.929a4.75 4.75 0 0 1 -2.988 -3.64m.66 -3.324a4.75 4.75 0 0 1 .5 -.66l.164 -.172"
  }), e.createElement("path", {
    d: "M15.349 3.133a4.75 4.75 0 0 1 -.836 7.385"
  }), e.createElement("path", {
    d: "M3 3l18 18"
  }));
}
var qv = ["size", "color", "stroke"];
function Ov(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, qv);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-biohazard",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 2
  }), e.createElement("path", {
    d: "M11.939 14c0 .173 .048 .351 .056 .533l0 .217a4.75 4.75 0 0 1 -4.533 4.745l-.217 0m-4.75 -4.75a4.75 4.75 0 0 1 7.737 -3.693m6.513 8.443a4.75 4.75 0 0 1 -4.69 -5.503l-.06 0m1.764 -2.944a4.75 4.75 0 0 1 7.731 3.477l0 .217m-11.195 -3.813a4.75 4.75 0 0 1 -1.828 -7.624l.164 -.172m6.718 0a4.75 4.75 0 0 1 -1.665 7.798"
  }));
}
var Pv = ["size", "color", "stroke"];
function Sv(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Pv);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-blade",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M17.707 3.707l2.586 2.586a1 1 0 0 1 0 1.414l-.586 .586a1 1 0 0 0 0 1.414l.586 .586a1 1 0 0 1 0 1.414l-8.586 8.586a1 1 0 0 1 -1.414 0l-.586 -.586a1 1 0 0 0 -1.414 0l-.586 .586a1 1 0 0 1 -1.414 0l-2.586 -2.586a1 1 0 0 1 0 -1.414l.586 -.586a1 1 0 0 0 0 -1.414l-.586 -.586a1 1 0 0 1 0 -1.414l8.586 -8.586a1 1 0 0 1 1.414 0l.586 .586a1 1 0 0 0 1.414 0l.586 -.586a1 1 0 0 1 1.414 0z"
  }), e.createElement("path", {
    d: "M8 16l3.2 -3.2"
  }), e.createElement("path", {
    d: "M12.8 11.2l3.2 -3.2"
  }), e.createElement("path", {
    d: "M14 8l2 2"
  }), e.createElement("path", {
    d: "M8 14l2 2"
  }), e.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 1
  }));
}
var Iv = ["size", "color", "stroke"];
function Av(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Iv);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-bleach-chlorine",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M5 19h14a2 2 0 0 0 1.84 -2.75l-7.1 -12.25a2 2 0 0 0 -3.5 0l-7.1 12.25a2 2 0 0 0 1.75 2.75"
  }), e.createElement("path", {
    d: "M11 12h-1a2 2 0 1 0 0 4h1"
  }), e.createElement("path", {
    d: "M14 12v4h2"
  }));
}
var Dv = ["size", "color", "stroke"];
function Fv(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Dv);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-bleach-no-chlorine",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M5 19h14a2 2 0 0 0 1.84 -2.75l-7.1 -12.25a2 2 0 0 0 -3.5 0l-7.1 12.25a2 2 0 0 0 1.75 2.75"
  }), e.createElement("path", {
    d: "M6.576 18.999l7.907 -13.733"
  }), e.createElement("path", {
    d: "M11.719 19.014l5.346 -9.284"
  }));
}
var Gv = ["size", "color", "stroke"];
function Jv(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Gv);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-bleach-off",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M5 19h14m1.986 -1.977a2.001 2.001 0 0 0 -.146 -.773l-7.1 -12.25a2 2 0 0 0 -3.5 0l-.815 1.405m-1.488 2.568l-4.797 8.277a2 2 0 0 0 1.75 2.75"
  }), e.createElement("path", {
    d: "M3 3l18 18"
  }));
}
var Kv = ["size", "color", "stroke"];
function Qv(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Kv);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-bleach",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M5 19h14a2 2 0 0 0 1.84 -2.75l-7.1 -12.25a2 2 0 0 0 -3.5 0l-7.1 12.25a2 2 0 0 0 1.75 2.75"
  }));
}
var Rv = ["size", "color", "stroke"];
function Tv(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Rv);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-blockquote",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M6 15h15"
  }), e.createElement("path", {
    d: "M21 19h-15"
  }), e.createElement("path", {
    d: "M15 11h6"
  }), e.createElement("path", {
    d: "M21 7h-6"
  }), e.createElement("path", {
    d: "M9 9h1a1 1 0 1 1 -1 1v-2.5a2 2 0 0 1 2 -2"
  }), e.createElement("path", {
    d: "M3 9h1a1 1 0 1 1 -1 1v-2.5a2 2 0 0 1 2 -2"
  }));
}
var Uv = ["size", "color", "stroke"];
function Vv(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Uv);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-bluetooth-connected",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("polyline", {
    points: "7 8 17 16 12 20 12 4 17 8 7 16"
  }), e.createElement("line", {
    x1: 4,
    y1: 12,
    x2: 5,
    y2: 12
  }), e.createElement("line", {
    x1: 18,
    y1: 12,
    x2: 19,
    y2: 12
  }));
}
var Xv = ["size", "color", "stroke"];
function Yv(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Xv);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-bluetooth-off",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("line", {
    x1: 3,
    y1: 3,
    x2: 21,
    y2: 21
  }), e.createElement("path", {
    d: "M16.438 16.45l-4.438 3.55v-8m0 -4v-4l5 4l-2.776 2.22m-2.222 1.779l-5 4"
  }));
}
var Zv = ["size", "color", "stroke"];
function $v(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Zv);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-bluetooth-x",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M7 8l10 8l-5 4v-16l1.003 .802m0 6.396l-6.003 4.802"
  }), e.createElement("path", {
    d: "M16 6l4 4"
  }), e.createElement("path", {
    d: "M20 6l-4 4"
  }));
}
var _v = ["size", "color", "stroke"];
function em(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, _v);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-bluetooth",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("polyline", {
    points: "7 8 17 16 12 20 12 4 17 8 7 16"
  }));
}
var tm = ["size", "color", "stroke"];
function om(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, tm);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-blur-off",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M12 3v5m0 4v8"
  }), e.createElement("path", {
    d: "M5.641 5.631a9 9 0 1 0 12.719 12.738m1.68 -2.318a9 9 0 0 0 -12.074 -12.098"
  }), e.createElement("path", {
    d: "M16 12h5"
  }), e.createElement("path", {
    d: "M13 9h7"
  }), e.createElement("path", {
    d: "M12 6h6"
  }), e.createElement("path", {
    d: "M12 18h6"
  }), e.createElement("path", {
    d: "M12 15h3m4 0h1"
  }), e.createElement("path", {
    d: "M3 3l18 18"
  }));
}
var rm = ["size", "color", "stroke"];
function nm(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, rm);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-blur",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M12 21a9.01 9.01 0 0 0 2.32 -.302a9.004 9.004 0 0 0 1.74 -16.733a9 9 0 1 0 -4.06 17.035z"
  }), e.createElement("path", {
    d: "M12 3v17"
  }), e.createElement("path", {
    d: "M12 12h9"
  }), e.createElement("path", {
    d: "M12 9h8"
  }), e.createElement("path", {
    d: "M12 6h6"
  }), e.createElement("path", {
    d: "M12 18h6"
  }), e.createElement("path", {
    d: "M12 15h8"
  }));
}
var lm = ["size", "color", "stroke"];
function am(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, lm);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-bmp",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M18 16v-8h2a2 2 0 1 1 0 4h-2"
  }), e.createElement("path", {
    d: "M6 14a2 2 0 0 1 -2 2h-2v-8h2a2 2 0 1 1 0 4h-2h2a2 2 0 0 1 2 2z"
  }), e.createElement("path", {
    d: "M9 16v-8l3 6l3 -6v8"
  }));
}
var im = ["size", "color", "stroke"];
function cm(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, im);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-bold-off",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M9 5h4a3.5 3.5 0 0 1 2.222 6.204m-3.222 .796h-5v-5"
  }), e.createElement("path", {
    d: "M17.107 17.112a3.5 3.5 0 0 1 -3.107 1.888h-7v-7"
  }), e.createElement("path", {
    d: "M3 3l18 18"
  }));
}
var sm = ["size", "color", "stroke"];
function hm(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, sm);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-bold",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M7 5h6a3.5 3.5 0 0 1 0 7h-6z"
  }), e.createElement("path", {
    d: "M13 12h1a3.5 3.5 0 0 1 0 7h-7v-7"
  }));
}
var dm = ["size", "color", "stroke"];
function vm(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, dm);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-bolt-off",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("line", {
    x1: 3,
    y1: 3,
    x2: 21,
    y2: 21
  }), e.createElement("path", {
    d: "M15.212 15.21l-4.212 5.79v-7h-6l3.79 -5.21m1.685 -2.32l2.525 -3.47v6m1 1h5l-2.104 2.893"
  }));
}
var mm = ["size", "color", "stroke"];
function km(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, mm);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-bolt",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("polyline", {
    points: "13 3 13 10 19 10 11 21 11 14 5 14 13 3"
  }));
}
var wm = ["size", "color", "stroke"];
function pm(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, wm);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-bomb",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M15.349 5.349l3.301 3.301a1.2 1.2 0 0 1 0 1.698l-.972 .972a7.5 7.5 0 1 1 -5 -5l.972 -.972a1.2 1.2 0 0 1 1.698 0z"
  }), e.createElement("path", {
    d: "M17 7l1.293 -1.293a2.414 2.414 0 0 0 .707 -1.707a1 1 0 0 1 1 -1h1"
  }), e.createElement("path", {
    d: "M7 13a3 3 0 0 1 3 -3"
  }));
}
var Em = ["size", "color", "stroke"];
function um(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Em);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-bone-off",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M12.5 8.502l.38 -.38a3 3 0 1 1 5.12 -2.122a3 3 0 1 1 -2.12 5.122l-.372 .372m-2.008 2.008l-2.378 2.378a3 3 0 1 1 -5.117 2.297l-.005 -.177l-.176 -.005a3 3 0 1 1 2.298 -5.115l2.378 -2.378"
  }), e.createElement("path", {
    d: "M3 3l18 18"
  }));
}
var gm = ["size", "color", "stroke"];
function Mm(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, gm);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-bone",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M15 3a3 3 0 0 1 3 3a3 3 0 1 1 -2.12 5.122l-4.758 4.758a3 3 0 1 1 -5.117 2.297l-.005 -.177l-.176 -.005a3 3 0 1 1 2.298 -5.115l4.758 -4.758a3 3 0 0 1 2.12 -5.122z"
  }));
}
var xm = ["size", "color", "stroke"];
function fm(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, xm);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-bong-off",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M9 4.999v-1.999h4v6m1.5 1.5l2.5 -2.5l2 2l-2.5 2.5m-.5 3.505a5 5 0 1 1 -7 -4.589v-2.416"
  }), e.createElement("path", {
    d: "M8 3h6"
  }), e.createElement("path", {
    d: "M6.1 17h9.8"
  }), e.createElement("path", {
    d: "M3 3l18 18"
  }));
}
var zm = ["size", "color", "stroke"];
function bm(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, zm);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-bong",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M13 3v8.416c.134 .059 .265 .123 .393 .193l3.607 -3.609l2 2l-3.608 3.608a5 5 0 1 1 -6.392 -2.192v-8.416h4z"
  }), e.createElement("path", {
    d: "M8 3h6"
  }), e.createElement("path", {
    d: "M6.1 17h9.8"
  }));
}
var Lm = ["size", "color", "stroke"];
function ym(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Lm);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-book-2",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M19 4v16h-12a2 2 0 0 1 -2 -2v-12a2 2 0 0 1 2 -2h12z"
  }), e.createElement("path", {
    d: "M19 16h-12a2 2 0 0 0 -2 2"
  }), e.createElement("path", {
    d: "M9 8h6"
  }));
}
var Cm = ["size", "color", "stroke"];
function jm(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Cm);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-book-download",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M12 20h-6a2 2 0 0 1 -2 -2v-12a2 2 0 0 1 2 -2h12v5"
  }), e.createElement("path", {
    d: "M13 16h-7a2 2 0 0 0 -2 2"
  }), e.createElement("path", {
    d: "M15 19l3 3l3 -3"
  }), e.createElement("path", {
    d: "M18 22v-9"
  }));
}
var Bm = ["size", "color", "stroke"];
function Hm(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Bm);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-book-off",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M3 19a9 9 0 0 1 9 0a8.999 8.999 0 0 1 5.899 -1.096"
  }), e.createElement("path", {
    d: "M3 6a8.995 8.995 0 0 1 2.114 -.884m3.8 -.21c1.07 .17 2.116 .534 3.086 1.094a9 9 0 0 1 9 0"
  }), e.createElement("path", {
    d: "M3 6v13"
  }), e.createElement("path", {
    d: "M12 6v2m0 4v7"
  }), e.createElement("path", {
    d: "M21 6v11"
  }), e.createElement("path", {
    d: "M3 3l18 18"
  }));
}
var Nm = ["size", "color", "stroke"];
function Wm(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Nm);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-book-upload",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M14 20h-8a2 2 0 0 1 -2 -2v-12a2 2 0 0 1 2 -2h12v5"
  }), e.createElement("path", {
    d: "M11 16h-5a2 2 0 0 0 -2 2"
  }), e.createElement("path", {
    d: "M15 16l3 -3l3 3"
  }), e.createElement("path", {
    d: "M18 13v9"
  }));
}
var qm = ["size", "color", "stroke"];
function Om(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, qm);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-book",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M3 19a9 9 0 0 1 9 0a9 9 0 0 1 9 0"
  }), e.createElement("path", {
    d: "M3 6a9 9 0 0 1 9 0a9 9 0 0 1 9 0"
  }), e.createElement("line", {
    x1: 3,
    y1: 6,
    x2: 3,
    y2: 19
  }), e.createElement("line", {
    x1: 12,
    y1: 6,
    x2: 12,
    y2: 19
  }), e.createElement("line", {
    x1: 21,
    y1: 6,
    x2: 21,
    y2: 19
  }));
}
var Pm = ["size", "color", "stroke"];
function Sm(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Pm);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-bookmark-off",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("line", {
    x1: 3,
    y1: 3,
    x2: 21,
    y2: 21
  }), e.createElement("path", {
    d: "M17 17v3l-5 -3l-5 3v-13m1.178 -2.818c.252 -.113 .53 -.176 .822 -.176h6a2 2 0 0 1 2 2v7"
  }));
}
var Im = ["size", "color", "stroke"];
function Am(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Im);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-bookmark",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M9 4h6a2 2 0 0 1 2 2v14l-5 -3l-5 3v-14a2 2 0 0 1 2 -2"
  }));
}
var Dm = ["size", "color", "stroke"];
function Fm(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Dm);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-bookmarks-off",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M11 7h2a2 2 0 0 1 2 2v2m0 4v6l-5 -3l-5 3v-12a2 2 0 0 1 2 -2"
  }), e.createElement("path", {
    d: "M9.265 4a2 2 0 0 1 1.735 -1h6a2 2 0 0 1 2 2v10"
  }), e.createElement("path", {
    d: "M3 3l18 18"
  }));
}
var Gm = ["size", "color", "stroke"];
function Jm(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Gm);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-bookmarks",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M13 7a2 2 0 0 1 2 2v12l-5 -3l-5 3v-12a2 2 0 0 1 2 -2h6z"
  }), e.createElement("path", {
    d: "M9.265 4a2 2 0 0 1 1.735 -1h6a2 2 0 0 1 2 2v12l-1 -.6"
  }));
}
var Km = ["size", "color", "stroke"];
function Qm(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Km);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-books-off",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M9 9v10a1 1 0 0 1 -1 1h-2a1 1 0 0 1 -1 -1v-14"
  }), e.createElement("path", {
    d: "M8 4a1 1 0 0 1 1 1"
  }), e.createElement("path", {
    d: "M9 5a1 1 0 0 1 1 -1h2a1 1 0 0 1 1 1v4"
  }), e.createElement("path", {
    d: "M13 13v6a1 1 0 0 1 -1 1h-2a1 1 0 0 1 -1 -1v-10"
  }), e.createElement("path", {
    d: "M5 8h3"
  }), e.createElement("path", {
    d: "M9 16h4"
  }), e.createElement("path", {
    d: "M14.254 10.244l-1.218 -4.424a1.02 1.02 0 0 1 .634 -1.219l.133 -.041l2.184 -.53c.562 -.135 1.133 .19 1.282 .732l3.236 11.75"
  }), e.createElement("path", {
    d: "M19.585 19.589l-1.572 .38c-.562 .136 -1.133 -.19 -1.282 -.731l-.952 -3.458"
  }), e.createElement("path", {
    d: "M14 9l4 -1"
  }), e.createElement("path", {
    d: "M19.207 15.199l.716 -.18"
  }), e.createElement("path", {
    d: "M3 3l18 18"
  }));
}
var Rm = ["size", "color", "stroke"];
function Tm(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Rm);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-books",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("rect", {
    x: 5,
    y: 4,
    width: 4,
    height: 16,
    rx: 1
  }), e.createElement("rect", {
    x: 9,
    y: 4,
    width: 4,
    height: 16,
    rx: 1
  }), e.createElement("path", {
    d: "M5 8h4"
  }), e.createElement("path", {
    d: "M9 16h4"
  }), e.createElement("path", {
    d: "M13.803 4.56l2.184 -.53c.562 -.135 1.133 .19 1.282 .732l3.695 13.418a1.02 1.02 0 0 1 -.634 1.219l-.133 .041l-2.184 .53c-.562 .135 -1.133 -.19 -1.282 -.732l-3.695 -13.418a1.02 1.02 0 0 1 .634 -1.219l.133 -.041z"
  }), e.createElement("path", {
    d: "M14 9l4 -1"
  }), e.createElement("path", {
    d: "M16 16l3.923 -.98"
  }));
}
var Um = ["size", "color", "stroke"];
function Vm(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Um);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-border-all",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("rect", {
    x: 4,
    y: 4,
    width: 16,
    height: 16,
    rx: 2
  }), e.createElement("line", {
    x1: 4,
    y1: 12,
    x2: 20,
    y2: 12
  }), e.createElement("line", {
    x1: 12,
    y1: 4,
    x2: 12,
    y2: 20
  }));
}
var Xm = ["size", "color", "stroke"];
function Ym(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Xm);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-border-bottom",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("line", {
    x1: 20,
    y1: 20,
    x2: 4,
    y2: 20
  }), e.createElement("line", {
    x1: 4,
    y1: 4,
    x2: 4,
    y2: 4.01
  }), e.createElement("line", {
    x1: 8,
    y1: 4,
    x2: 8,
    y2: 4.01
  }), e.createElement("line", {
    x1: 12,
    y1: 4,
    x2: 12,
    y2: 4.01
  }), e.createElement("line", {
    x1: 16,
    y1: 4,
    x2: 16,
    y2: 4.01
  }), e.createElement("line", {
    x1: 20,
    y1: 4,
    x2: 20,
    y2: 4.01
  }), e.createElement("line", {
    x1: 4,
    y1: 8,
    x2: 4,
    y2: 8.01
  }), e.createElement("line", {
    x1: 12,
    y1: 8,
    x2: 12,
    y2: 8.01
  }), e.createElement("line", {
    x1: 20,
    y1: 8,
    x2: 20,
    y2: 8.01
  }), e.createElement("line", {
    x1: 4,
    y1: 12,
    x2: 4,
    y2: 12.01
  }), e.createElement("line", {
    x1: 8,
    y1: 12,
    x2: 8,
    y2: 12.01
  }), e.createElement("line", {
    x1: 12,
    y1: 12,
    x2: 12,
    y2: 12.01
  }), e.createElement("line", {
    x1: 16,
    y1: 12,
    x2: 16,
    y2: 12.01
  }), e.createElement("line", {
    x1: 20,
    y1: 12,
    x2: 20,
    y2: 12.01
  }), e.createElement("line", {
    x1: 4,
    y1: 16,
    x2: 4,
    y2: 16.01
  }), e.createElement("line", {
    x1: 12,
    y1: 16,
    x2: 12,
    y2: 16.01
  }), e.createElement("line", {
    x1: 20,
    y1: 16,
    x2: 20,
    y2: 16.01
  }));
}
var Zm = ["size", "color", "stroke"];
function $m(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Zm);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-border-horizontal",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("line", {
    x1: 4,
    y1: 12,
    x2: 20,
    y2: 12
  }), e.createElement("line", {
    x1: 4,
    y1: 4,
    x2: 4,
    y2: 4.01
  }), e.createElement("line", {
    x1: 8,
    y1: 4,
    x2: 8,
    y2: 4.01
  }), e.createElement("line", {
    x1: 12,
    y1: 4,
    x2: 12,
    y2: 4.01
  }), e.createElement("line", {
    x1: 16,
    y1: 4,
    x2: 16,
    y2: 4.01
  }), e.createElement("line", {
    x1: 20,
    y1: 4,
    x2: 20,
    y2: 4.01
  }), e.createElement("line", {
    x1: 4,
    y1: 8,
    x2: 4,
    y2: 8.01
  }), e.createElement("line", {
    x1: 12,
    y1: 8,
    x2: 12,
    y2: 8.01
  }), e.createElement("line", {
    x1: 20,
    y1: 8,
    x2: 20,
    y2: 8.01
  }), e.createElement("line", {
    x1: 4,
    y1: 16,
    x2: 4,
    y2: 16.01
  }), e.createElement("line", {
    x1: 12,
    y1: 16,
    x2: 12,
    y2: 16.01
  }), e.createElement("line", {
    x1: 20,
    y1: 16,
    x2: 20,
    y2: 16.01
  }), e.createElement("line", {
    x1: 4,
    y1: 20,
    x2: 4,
    y2: 20.01
  }), e.createElement("line", {
    x1: 8,
    y1: 20,
    x2: 8,
    y2: 20.01
  }), e.createElement("line", {
    x1: 12,
    y1: 20,
    x2: 12,
    y2: 20.01
  }), e.createElement("line", {
    x1: 16,
    y1: 20,
    x2: 16,
    y2: 20.01
  }), e.createElement("line", {
    x1: 20,
    y1: 20,
    x2: 20,
    y2: 20.01
  }));
}
var _m = ["size", "color", "stroke"];
function ek(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, _m);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-border-inner",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("line", {
    x1: 4,
    y1: 12,
    x2: 20,
    y2: 12
  }), e.createElement("line", {
    x1: 12,
    y1: 4,
    x2: 12,
    y2: 20
  }), e.createElement("line", {
    x1: 4,
    y1: 4,
    x2: 4,
    y2: 4.01
  }), e.createElement("line", {
    x1: 8,
    y1: 4,
    x2: 8,
    y2: 4.01
  }), e.createElement("line", {
    x1: 16,
    y1: 4,
    x2: 16,
    y2: 4.01
  }), e.createElement("line", {
    x1: 20,
    y1: 4,
    x2: 20,
    y2: 4.01
  }), e.createElement("line", {
    x1: 4,
    y1: 8,
    x2: 4,
    y2: 8.01
  }), e.createElement("line", {
    x1: 20,
    y1: 8,
    x2: 20,
    y2: 8.01
  }), e.createElement("line", {
    x1: 4,
    y1: 16,
    x2: 4,
    y2: 16.01
  }), e.createElement("line", {
    x1: 20,
    y1: 16,
    x2: 20,
    y2: 16.01
  }), e.createElement("line", {
    x1: 4,
    y1: 20,
    x2: 4,
    y2: 20.01
  }), e.createElement("line", {
    x1: 8,
    y1: 20,
    x2: 8,
    y2: 20.01
  }), e.createElement("line", {
    x1: 16,
    y1: 20,
    x2: 16,
    y2: 20.01
  }), e.createElement("line", {
    x1: 20,
    y1: 20,
    x2: 20,
    y2: 20.01
  }));
}
var tk = ["size", "color", "stroke"];
function ok(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, tk);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-border-left",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("line", {
    x1: 4,
    y1: 20,
    x2: 4,
    y2: 4
  }), e.createElement("line", {
    x1: 8,
    y1: 4,
    x2: 8,
    y2: 4.01
  }), e.createElement("line", {
    x1: 12,
    y1: 4,
    x2: 12,
    y2: 4.01
  }), e.createElement("line", {
    x1: 16,
    y1: 4,
    x2: 16,
    y2: 4.01
  }), e.createElement("line", {
    x1: 20,
    y1: 4,
    x2: 20,
    y2: 4.01
  }), e.createElement("line", {
    x1: 12,
    y1: 8,
    x2: 12,
    y2: 8.01
  }), e.createElement("line", {
    x1: 20,
    y1: 8,
    x2: 20,
    y2: 8.01
  }), e.createElement("line", {
    x1: 8,
    y1: 12,
    x2: 8,
    y2: 12.01
  }), e.createElement("line", {
    x1: 12,
    y1: 12,
    x2: 12,
    y2: 12.01
  }), e.createElement("line", {
    x1: 16,
    y1: 12,
    x2: 16,
    y2: 12.01
  }), e.createElement("line", {
    x1: 20,
    y1: 12,
    x2: 20,
    y2: 12.01
  }), e.createElement("line", {
    x1: 12,
    y1: 16,
    x2: 12,
    y2: 16.01
  }), e.createElement("line", {
    x1: 20,
    y1: 16,
    x2: 20,
    y2: 16.01
  }), e.createElement("line", {
    x1: 8,
    y1: 20,
    x2: 8,
    y2: 20.01
  }), e.createElement("line", {
    x1: 12,
    y1: 20,
    x2: 12,
    y2: 20.01
  }), e.createElement("line", {
    x1: 16,
    y1: 20,
    x2: 16,
    y2: 20.01
  }), e.createElement("line", {
    x1: 20,
    y1: 20,
    x2: 20,
    y2: 20.01
  }));
}
var rk = ["size", "color", "stroke"];
function nk(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, rk);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-border-none",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("line", {
    x1: 4,
    y1: 4,
    x2: 4,
    y2: 4.01
  }), e.createElement("line", {
    x1: 8,
    y1: 4,
    x2: 8,
    y2: 4.01
  }), e.createElement("line", {
    x1: 12,
    y1: 4,
    x2: 12,
    y2: 4.01
  }), e.createElement("line", {
    x1: 16,
    y1: 4,
    x2: 16,
    y2: 4.01
  }), e.createElement("line", {
    x1: 20,
    y1: 4,
    x2: 20,
    y2: 4.01
  }), e.createElement("line", {
    x1: 4,
    y1: 8,
    x2: 4,
    y2: 8.01
  }), e.createElement("line", {
    x1: 12,
    y1: 8,
    x2: 12,
    y2: 8.01
  }), e.createElement("line", {
    x1: 20,
    y1: 8,
    x2: 20,
    y2: 8.01
  }), e.createElement("line", {
    x1: 4,
    y1: 12,
    x2: 4,
    y2: 12.01
  }), e.createElement("line", {
    x1: 8,
    y1: 12,
    x2: 8,
    y2: 12.01
  }), e.createElement("line", {
    x1: 12,
    y1: 12,
    x2: 12,
    y2: 12.01
  }), e.createElement("line", {
    x1: 16,
    y1: 12,
    x2: 16,
    y2: 12.01
  }), e.createElement("line", {
    x1: 20,
    y1: 12,
    x2: 20,
    y2: 12.01
  }), e.createElement("line", {
    x1: 4,
    y1: 16,
    x2: 4,
    y2: 16.01
  }), e.createElement("line", {
    x1: 12,
    y1: 16,
    x2: 12,
    y2: 16.01
  }), e.createElement("line", {
    x1: 20,
    y1: 16,
    x2: 20,
    y2: 16.01
  }), e.createElement("line", {
    x1: 4,
    y1: 20,
    x2: 4,
    y2: 20.01
  }), e.createElement("line", {
    x1: 8,
    y1: 20,
    x2: 8,
    y2: 20.01
  }), e.createElement("line", {
    x1: 12,
    y1: 20,
    x2: 12,
    y2: 20.01
  }), e.createElement("line", {
    x1: 16,
    y1: 20,
    x2: 16,
    y2: 20.01
  }), e.createElement("line", {
    x1: 20,
    y1: 20,
    x2: 20,
    y2: 20.01
  }));
}
var lk = ["size", "color", "stroke"];
function ak(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, lk);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-border-outer",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("rect", {
    x: 4,
    y: 4,
    width: 16,
    height: 16,
    rx: 2
  }), e.createElement("line", {
    x1: 12,
    y1: 8,
    x2: 12,
    y2: 8.01
  }), e.createElement("line", {
    x1: 8,
    y1: 12,
    x2: 8,
    y2: 12.01
  }), e.createElement("line", {
    x1: 12,
    y1: 12,
    x2: 12,
    y2: 12.01
  }), e.createElement("line", {
    x1: 16,
    y1: 12,
    x2: 16,
    y2: 12.01
  }), e.createElement("line", {
    x1: 12,
    y1: 16,
    x2: 12,
    y2: 16.01
  }));
}
var ik = ["size", "color", "stroke"];
function ck(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, ik);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-border-radius",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M4 12v-4a4 4 0 0 1 4 -4h4"
  }), e.createElement("line", {
    x1: 16,
    y1: 4,
    x2: 16,
    y2: 4.01
  }), e.createElement("line", {
    x1: 20,
    y1: 4,
    x2: 20,
    y2: 4.01
  }), e.createElement("line", {
    x1: 20,
    y1: 8,
    x2: 20,
    y2: 8.01
  }), e.createElement("line", {
    x1: 20,
    y1: 12,
    x2: 20,
    y2: 12.01
  }), e.createElement("line", {
    x1: 4,
    y1: 16,
    x2: 4,
    y2: 16.01
  }), e.createElement("line", {
    x1: 20,
    y1: 16,
    x2: 20,
    y2: 16.01
  }), e.createElement("line", {
    x1: 4,
    y1: 20,
    x2: 4,
    y2: 20.01
  }), e.createElement("line", {
    x1: 8,
    y1: 20,
    x2: 8,
    y2: 20.01
  }), e.createElement("line", {
    x1: 12,
    y1: 20,
    x2: 12,
    y2: 20.01
  }), e.createElement("line", {
    x1: 16,
    y1: 20,
    x2: 16,
    y2: 20.01
  }), e.createElement("line", {
    x1: 20,
    y1: 20,
    x2: 20,
    y2: 20.01
  }));
}
var sk = ["size", "color", "stroke"];
function hk(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, sk);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-border-right",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("line", {
    x1: 20,
    y1: 4,
    x2: 20,
    y2: 20
  }), e.createElement("line", {
    x1: 4,
    y1: 4,
    x2: 4,
    y2: 4.01
  }), e.createElement("line", {
    x1: 8,
    y1: 4,
    x2: 8,
    y2: 4.01
  }), e.createElement("line", {
    x1: 12,
    y1: 4,
    x2: 12,
    y2: 4.01
  }), e.createElement("line", {
    x1: 16,
    y1: 4,
    x2: 16,
    y2: 4.01
  }), e.createElement("line", {
    x1: 4,
    y1: 8,
    x2: 4,
    y2: 8.01
  }), e.createElement("line", {
    x1: 12,
    y1: 8,
    x2: 12,
    y2: 8.01
  }), e.createElement("line", {
    x1: 4,
    y1: 12,
    x2: 4,
    y2: 12.01
  }), e.createElement("line", {
    x1: 8,
    y1: 12,
    x2: 8,
    y2: 12.01
  }), e.createElement("line", {
    x1: 12,
    y1: 12,
    x2: 12,
    y2: 12.01
  }), e.createElement("line", {
    x1: 16,
    y1: 12,
    x2: 16,
    y2: 12.01
  }), e.createElement("line", {
    x1: 4,
    y1: 16,
    x2: 4,
    y2: 16.01
  }), e.createElement("line", {
    x1: 12,
    y1: 16,
    x2: 12,
    y2: 16.01
  }), e.createElement("line", {
    x1: 4,
    y1: 20,
    x2: 4,
    y2: 20.01
  }), e.createElement("line", {
    x1: 8,
    y1: 20,
    x2: 8,
    y2: 20.01
  }), e.createElement("line", {
    x1: 12,
    y1: 20,
    x2: 12,
    y2: 20.01
  }), e.createElement("line", {
    x1: 16,
    y1: 20,
    x2: 16,
    y2: 20.01
  }));
}
var dk = ["size", "color", "stroke"];
function vk(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, dk);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-border-style-2",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M4 18v.01"
  }), e.createElement("path", {
    d: "M8 18v.01"
  }), e.createElement("path", {
    d: "M12 18v.01"
  }), e.createElement("path", {
    d: "M16 18v.01"
  }), e.createElement("path", {
    d: "M20 18v.01"
  }), e.createElement("path", {
    d: "M18 12h2"
  }), e.createElement("path", {
    d: "M11 12h2"
  }), e.createElement("path", {
    d: "M4 12h2"
  }), e.createElement("path", {
    d: "M4 6h16"
  }));
}
var mk = ["size", "color", "stroke"];
function kk(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, mk);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-border-style",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M4 20v-14a2 2 0 0 1 2 -2h14"
  }), e.createElement("path", {
    d: "M20 8v.01"
  }), e.createElement("path", {
    d: "M20 12v.01"
  }), e.createElement("path", {
    d: "M20 16v.01"
  }), e.createElement("path", {
    d: "M8 20v.01"
  }), e.createElement("path", {
    d: "M12 20v.01"
  }), e.createElement("path", {
    d: "M16 20v.01"
  }), e.createElement("path", {
    d: "M20 20v.01"
  }));
}
var wk = ["size", "color", "stroke"];
function pk(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, wk);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-border-top",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("line", {
    x1: 4,
    y1: 4,
    x2: 20,
    y2: 4
  }), e.createElement("line", {
    x1: 4,
    y1: 8,
    x2: 4,
    y2: 8.01
  }), e.createElement("line", {
    x1: 12,
    y1: 8,
    x2: 12,
    y2: 8.01
  }), e.createElement("line", {
    x1: 20,
    y1: 8,
    x2: 20,
    y2: 8.01
  }), e.createElement("line", {
    x1: 4,
    y1: 12,
    x2: 4,
    y2: 12.01
  }), e.createElement("line", {
    x1: 8,
    y1: 12,
    x2: 8,
    y2: 12.01
  }), e.createElement("line", {
    x1: 12,
    y1: 12,
    x2: 12,
    y2: 12.01
  }), e.createElement("line", {
    x1: 16,
    y1: 12,
    x2: 16,
    y2: 12.01
  }), e.createElement("line", {
    x1: 20,
    y1: 12,
    x2: 20,
    y2: 12.01
  }), e.createElement("line", {
    x1: 4,
    y1: 16,
    x2: 4,
    y2: 16.01
  }), e.createElement("line", {
    x1: 12,
    y1: 16,
    x2: 12,
    y2: 16.01
  }), e.createElement("line", {
    x1: 20,
    y1: 16,
    x2: 20,
    y2: 16.01
  }), e.createElement("line", {
    x1: 4,
    y1: 20,
    x2: 4,
    y2: 20.01
  }), e.createElement("line", {
    x1: 8,
    y1: 20,
    x2: 8,
    y2: 20.01
  }), e.createElement("line", {
    x1: 12,
    y1: 20,
    x2: 12,
    y2: 20.01
  }), e.createElement("line", {
    x1: 16,
    y1: 20,
    x2: 16,
    y2: 20.01
  }), e.createElement("line", {
    x1: 20,
    y1: 20,
    x2: 20,
    y2: 20.01
  }));
}
var Ek = ["size", "color", "stroke"];
function uk(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Ek);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-border-vertical",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("line", {
    x1: 12,
    y1: 4,
    x2: 12,
    y2: 20
  }), e.createElement("line", {
    x1: 4,
    y1: 4,
    x2: 4,
    y2: 4.01
  }), e.createElement("line", {
    x1: 8,
    y1: 4,
    x2: 8,
    y2: 4.01
  }), e.createElement("line", {
    x1: 16,
    y1: 4,
    x2: 16,
    y2: 4.01
  }), e.createElement("line", {
    x1: 20,
    y1: 4,
    x2: 20,
    y2: 4.01
  }), e.createElement("line", {
    x1: 4,
    y1: 8,
    x2: 4,
    y2: 8.01
  }), e.createElement("line", {
    x1: 20,
    y1: 8,
    x2: 20,
    y2: 8.01
  }), e.createElement("line", {
    x1: 4,
    y1: 12,
    x2: 4,
    y2: 12.01
  }), e.createElement("line", {
    x1: 8,
    y1: 12,
    x2: 8,
    y2: 12.01
  }), e.createElement("line", {
    x1: 16,
    y1: 12,
    x2: 16,
    y2: 12.01
  }), e.createElement("line", {
    x1: 20,
    y1: 12,
    x2: 20,
    y2: 12.01
  }), e.createElement("line", {
    x1: 4,
    y1: 16,
    x2: 4,
    y2: 16.01
  }), e.createElement("line", {
    x1: 20,
    y1: 16,
    x2: 20,
    y2: 16.01
  }), e.createElement("line", {
    x1: 4,
    y1: 20,
    x2: 4,
    y2: 20.01
  }), e.createElement("line", {
    x1: 8,
    y1: 20,
    x2: 8,
    y2: 20.01
  }), e.createElement("line", {
    x1: 16,
    y1: 20,
    x2: 16,
    y2: 20.01
  }), e.createElement("line", {
    x1: 20,
    y1: 20,
    x2: 20,
    y2: 20.01
  }));
}
var gk = ["size", "color", "stroke"];
function Mk(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, gk);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-bottle-off",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M10 5h4v-2a1 1 0 0 0 -1 -1h-2a1 1 0 0 0 -1 1v2z"
  }), e.createElement("path", {
    d: "M14 3.5c0 1.626 .507 3.212 1.45 4.537l.05 .07a8.093 8.093 0 0 1 1.5 4.694v.199m0 4v2a2 2 0 0 1 -2 2h-6a2 2 0 0 1 -2 -2v-6.2a8.09 8.09 0 0 1 1.35 -4.474m1.336 -2.63a7.822 7.822 0 0 0 .314 -2.196"
  }), e.createElement("path", {
    d: "M7.003 14.803a2.4 2.4 0 0 0 .997 -.803a2.4 2.4 0 0 1 2 -1a2.4 2.4 0 0 1 2 1a2.4 2.4 0 0 0 2 1a2.4 2.4 0 0 0 .866 -.142"
  }), e.createElement("path", {
    d: "M3 3l18 18"
  }));
}
var xk = ["size", "color", "stroke"];
function fk(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, xk);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-bottle",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M10 5h4v-2a1 1 0 0 0 -1 -1h-2a1 1 0 0 0 -1 1v2z"
  }), e.createElement("path", {
    d: "M14 3.5c0 1.626 .507 3.212 1.45 4.537l.05 .07a8.093 8.093 0 0 1 1.5 4.694v6.199a2 2 0 0 1 -2 2h-6a2 2 0 0 1 -2 -2v-6.2c0 -1.682 .524 -3.322 1.5 -4.693l.05 -.07a7.823 7.823 0 0 0 1.45 -4.537"
  }), e.createElement("path", {
    d: "M7.003 14.803a2.4 2.4 0 0 0 .997 -.803a2.4 2.4 0 0 1 2 -1a2.4 2.4 0 0 1 2 1a2.4 2.4 0 0 0 2 1a2.4 2.4 0 0 0 2 -1a2.4 2.4 0 0 1 1 -.805"
  }));
}
var zk = ["size", "color", "stroke"];
function bk(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, zk);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-bounce-left",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M20 15.5c-3 -1 -5.5 -.5 -8 4.5c-.5 -3 -1.5 -5.5 -3 -8"
  }), e.createElement("path", {
    d: "M6 9a2 2 0 1 1 0 -4a2 2 0 0 1 0 4z"
  }));
}
var Lk = ["size", "color", "stroke"];
function yk(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Lk);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-bounce-right",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M4 15.5c3 -1 5.5 -.5 8 4.5c.5 -3 1.5 -5.5 3 -8"
  }), e.createElement("path", {
    d: "M18 9a2 2 0 1 1 0 -4a2 2 0 0 1 0 4z"
  }));
}
var Ck = ["size", "color", "stroke"];
function jk(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Ck);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-bow",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M17 3h4v4"
  }), e.createElement("path", {
    d: "M21 3l-15 15"
  }), e.createElement("path", {
    d: "M3 18h3v3"
  }), e.createElement("path", {
    d: "M16.5 20c1.576 -1.576 2.5 -4.095 2.5 -6.5c0 -4.81 -3.69 -8.5 -8.5 -8.5c-2.415 0 -4.922 .913 -6.5 2.5l12.5 12.5z"
  }));
}
var Bk = ["size", "color", "stroke"];
function Hk(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Bk);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-bowl",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M4 8h16a1 1 0 0 1 1 1v.5c0 1.5 -2.517 5.573 -4 6.5v1a1 1 0 0 1 -1 1h-8a1 1 0 0 1 -1 -1v-1c-1.687 -1.054 -4 -5 -4 -6.5v-.5a1 1 0 0 1 1 -1z"
  }));
}
var Nk = ["size", "color", "stroke"];
function Wk(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Nk);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-box-align-bottom-left",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M5 13h5a1 1 0 0 1 1 1v5a1 1 0 0 1 -1 1h-5a1 1 0 0 1 -1 -1v-5a1 1 0 0 1 1 -1z"
  }), e.createElement("path", {
    d: "M4 9v.01"
  }), e.createElement("path", {
    d: "M4 4v.01"
  }), e.createElement("path", {
    d: "M9 4v.01"
  }), e.createElement("path", {
    d: "M15 4v.01"
  }), e.createElement("path", {
    d: "M15 20v.01"
  }), e.createElement("path", {
    d: "M20 4v.01"
  }), e.createElement("path", {
    d: "M20 9v.01"
  }), e.createElement("path", {
    d: "M20 15v.01"
  }), e.createElement("path", {
    d: "M20 20v.01"
  }));
}
var qk = ["size", "color", "stroke"];
function Ok(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, qk);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-box-align-bottom-right",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M19 13h-5a1 1 0 0 0 -1 1v5a1 1 0 0 0 1 1h5a1 1 0 0 0 1 -1v-5a1 1 0 0 0 -1 -1z"
  }), e.createElement("path", {
    d: "M20 9v.01"
  }), e.createElement("path", {
    d: "M20 4v.01"
  }), e.createElement("path", {
    d: "M15 4v.01"
  }), e.createElement("path", {
    d: "M9 4v.01"
  }), e.createElement("path", {
    d: "M9 20v.01"
  }), e.createElement("path", {
    d: "M4 4v.01"
  }), e.createElement("path", {
    d: "M4 9v.01"
  }), e.createElement("path", {
    d: "M4 15v.01"
  }), e.createElement("path", {
    d: "M4 20v.01"
  }));
}
var Pk = ["size", "color", "stroke"];
function Sk(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Pk);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-box-align-bottom",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M4 14h16v5a1 1 0 0 1 -1 1h-14a1 1 0 0 1 -1 -1v-5z"
  }), e.createElement("path", {
    d: "M4 9v.01"
  }), e.createElement("path", {
    d: "M4 4v.01"
  }), e.createElement("path", {
    d: "M9 4v.01"
  }), e.createElement("path", {
    d: "M15 4v.01"
  }), e.createElement("path", {
    d: "M20 4v.01"
  }), e.createElement("path", {
    d: "M20 9v.01"
  }));
}
var Ik = ["size", "color", "stroke"];
function Ak(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Ik);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-box-align-left",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M9.752 19.753v-16h-5a1 1 0 0 0 -1 1v14a1 1 0 0 0 1 1h5z"
  }), e.createElement("path", {
    d: "M14.752 19.753h-.01"
  }), e.createElement("path", {
    d: "M19.753 19.753h-.011"
  }), e.createElement("path", {
    d: "M19.753 14.752h-.011"
  }), e.createElement("path", {
    d: "M19.753 8.752h-.011"
  }), e.createElement("path", {
    d: "M19.753 3.752h-.011"
  }), e.createElement("path", {
    d: "M14.752 3.752h-.01"
  }));
}
var Dk = ["size", "color", "stroke"];
function Fk(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Dk);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-box-align-right",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M14.248 19.753v-16h5a1 1 0 0 1 1 1v14a1 1 0 0 1 -1 1h-5z"
  }), e.createElement("path", {
    d: "M9.248 19.753h.01"
  }), e.createElement("path", {
    d: "M4.247 19.753h.011"
  }), e.createElement("path", {
    d: "M4.247 14.752h.011"
  }), e.createElement("path", {
    d: "M4.247 8.752h.011"
  }), e.createElement("path", {
    d: "M4.247 3.752h.011"
  }), e.createElement("path", {
    d: "M9.248 3.752h.01"
  }));
}
var Gk = ["size", "color", "stroke"];
function Jk(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Gk);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-box-align-top-left",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M11.005 5.005v5a1 1 0 0 1 -1 1h-5a1 1 0 0 1 -1 -1v-5a1 1 0 0 1 1 -1h5a1 1 0 0 1 1 1z"
  }), e.createElement("path", {
    d: "M15.005 4.005h-.01"
  }), e.createElement("path", {
    d: "M20.005 4.005h-.01"
  }), e.createElement("path", {
    d: "M20.005 9.005h-.01"
  }), e.createElement("path", {
    d: "M20.005 15.005h-.01"
  }), e.createElement("path", {
    d: "M4.005 15.005h-.01"
  }), e.createElement("path", {
    d: "M20.005 20.005h-.01"
  }), e.createElement("path", {
    d: "M15.005 20.005h-.01"
  }), e.createElement("path", {
    d: "M9.005 20.005h-.01"
  }), e.createElement("path", {
    d: "M4.005 20.005h-.01"
  }));
}
var Kk = ["size", "color", "stroke"];
function Qk(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Kk);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-box-align-top-right",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M19 11.01h-5a1 1 0 0 1 -1 -1v-5a1 1 0 0 1 1 -1h5a1 1 0 0 1 1 1v5a1 1 0 0 1 -1 1z"
  }), e.createElement("path", {
    d: "M20 15.01v-.01"
  }), e.createElement("path", {
    d: "M20 20.01v-.01"
  }), e.createElement("path", {
    d: "M15 20.01v-.01"
  }), e.createElement("path", {
    d: "M9 20.01v-.01"
  }), e.createElement("path", {
    d: "M9 4.01v-.01"
  }), e.createElement("path", {
    d: "M4 20.01v-.01"
  }), e.createElement("path", {
    d: "M4 15.01v-.01"
  }), e.createElement("path", {
    d: "M4 9.01v-.01"
  }), e.createElement("path", {
    d: "M4 4.01v-.01"
  }));
}
var Rk = ["size", "color", "stroke"];
function Tk(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Rk);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-box-align-top",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M4 9.505h16v-5a1 1 0 0 0 -1 -1h-14a1 1 0 0 0 -1 1v5z"
  }), e.createElement("path", {
    d: "M4 14.505v-.01"
  }), e.createElement("path", {
    d: "M4 19.505v-.01"
  }), e.createElement("path", {
    d: "M9 19.505v-.01"
  }), e.createElement("path", {
    d: "M15 19.505v-.01"
  }), e.createElement("path", {
    d: "M20 19.505v-.01"
  }), e.createElement("path", {
    d: "M20 14.505v-.01"
  }));
}
var Uk = ["size", "color", "stroke"];
function Vk(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Uk);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-box-margin",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M8 8h8v8h-8z"
  }), e.createElement("path", {
    d: "M4 4v.01"
  }), e.createElement("path", {
    d: "M8 4v.01"
  }), e.createElement("path", {
    d: "M12 4v.01"
  }), e.createElement("path", {
    d: "M16 4v.01"
  }), e.createElement("path", {
    d: "M20 4v.01"
  }), e.createElement("path", {
    d: "M4 20v.01"
  }), e.createElement("path", {
    d: "M8 20v.01"
  }), e.createElement("path", {
    d: "M12 20v.01"
  }), e.createElement("path", {
    d: "M16 20v.01"
  }), e.createElement("path", {
    d: "M20 20v.01"
  }), e.createElement("path", {
    d: "M20 16v.01"
  }), e.createElement("path", {
    d: "M20 12v.01"
  }), e.createElement("path", {
    d: "M20 8v.01"
  }), e.createElement("path", {
    d: "M4 16v.01"
  }), e.createElement("path", {
    d: "M4 12v.01"
  }), e.createElement("path", {
    d: "M4 8v.01"
  }));
}
var Xk = ["size", "color", "stroke"];
function Yk(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Xk);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-box-model-2-off",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M8 4h10a2 2 0 0 1 2 2v10m-.586 3.414a1.994 1.994 0 0 1 -1.414 .586h-12a2 2 0 0 1 -2 -2v-12c0 -.547 .22 -1.043 .576 -1.405"
  }), e.createElement("path", {
    d: "M12 8h4v4m0 4h-8v-8"
  }), e.createElement("path", {
    d: "M3 3l18 18"
  }));
}
var Zk = ["size", "color", "stroke"];
function $k(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Zk);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-box-model-2",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M8 8h8v8h-8z"
  }), e.createElement("rect", {
    x: 4,
    y: 4,
    width: 16,
    height: 16,
    rx: 2
  }));
}
var _k = ["size", "color", "stroke"];
function ew(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, _k);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-box-model-off",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M12 8h4v4m0 4h-8v-8"
  }), e.createElement("path", {
    d: "M8 4h10a2 2 0 0 1 2 2v10m-.586 3.414a1.994 1.994 0 0 1 -1.414 .586h-12a2 2 0 0 1 -2 -2v-12c0 -.547 .22 -1.043 .576 -1.405"
  }), e.createElement("path", {
    d: "M16 16l3.3 3.3"
  }), e.createElement("path", {
    d: "M16 8l3.3 -3.3"
  }), e.createElement("path", {
    d: "M8 8l-3.3 -3.3"
  }), e.createElement("path", {
    d: "M8 16l-3.3 3.3"
  }), e.createElement("path", {
    d: "M3 3l18 18"
  }));
}
var tw = ["size", "color", "stroke"];
function ow(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, tw);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-box-model",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M8 8h8v8h-8z"
  }), e.createElement("rect", {
    x: 4,
    y: 4,
    width: 16,
    height: 16,
    rx: 2
  }), e.createElement("path", {
    d: "M16 16l3.3 3.3"
  }), e.createElement("path", {
    d: "M16 8l3.3 -3.3"
  }), e.createElement("path", {
    d: "M8 8l-3.3 -3.3"
  }), e.createElement("path", {
    d: "M8 16l-3.3 3.3"
  }));
}
var rw = ["size", "color", "stroke"];
function nw(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, rw);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-box-multiple-0",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M14 6a2 2 0 0 1 2 2v4a2 2 0 1 1 -4 0v-4a2 2 0 0 1 2 -2z"
  }), e.createElement("rect", {
    x: 7,
    y: 3,
    width: 14,
    height: 14,
    rx: 2
  }), e.createElement("path", {
    d: "M17 17v2a2 2 0 0 1 -2 2h-10a2 2 0 0 1 -2 -2v-10a2 2 0 0 1 2 -2h2"
  }));
}
var lw = ["size", "color", "stroke"];
function aw(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, lw);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-box-multiple-1",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("rect", {
    x: 7,
    y: 3,
    width: 14,
    height: 14,
    rx: 2
  }), e.createElement("path", {
    d: "M17 17v2a2 2 0 0 1 -2 2h-10a2 2 0 0 1 -2 -2v-10a2 2 0 0 1 2 -2h2"
  }), e.createElement("path", {
    d: "M14 14v-8l-2 2"
  }));
}
var iw = ["size", "color", "stroke"];
function cw(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, iw);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-box-multiple-2",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("rect", {
    x: 7,
    y: 3,
    width: 14,
    height: 14,
    rx: 2
  }), e.createElement("path", {
    d: "M17 17v2a2 2 0 0 1 -2 2h-10a2 2 0 0 1 -2 -2v-10a2 2 0 0 1 2 -2h2"
  }), e.createElement("path", {
    d: "M12 8a2 2 0 1 1 4 0c0 .591 -.417 1.318 -.816 1.858l-3.184 4.143l4 0"
  }));
}
var sw = ["size", "color", "stroke"];
function hw(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, sw);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-box-multiple-3",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("rect", {
    x: 7,
    y: 3,
    width: 14,
    height: 14,
    rx: 2
  }), e.createElement("path", {
    d: "M17 17v2a2 2 0 0 1 -2 2h-10a2 2 0 0 1 -2 -2v-10a2 2 0 0 1 2 -2h2"
  }), e.createElement("path", {
    d: "M14 10a2 2 0 1 0 -2 -2"
  }), e.createElement("path", {
    d: "M12 12a2 2 0 1 0 2 -2"
  }));
}
var dw = ["size", "color", "stroke"];
function vw(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, dw);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-box-multiple-4",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("rect", {
    x: 7,
    y: 3,
    width: 14,
    height: 14,
    rx: 2
  }), e.createElement("path", {
    d: "M17 17v2a2 2 0 0 1 -2 2h-10a2 2 0 0 1 -2 -2v-10a2 2 0 0 1 2 -2h2"
  }), e.createElement("path", {
    d: "M15 14v-8l-4 6h5"
  }));
}
var mw = ["size", "color", "stroke"];
function kw(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, mw);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-box-multiple-5",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("rect", {
    x: 7,
    y: 3,
    width: 14,
    height: 14,
    rx: 2
  }), e.createElement("path", {
    d: "M12 14h2a2 2 0 1 0 0 -4h-2v-4h4"
  }), e.createElement("path", {
    d: "M17 17v2a2 2 0 0 1 -2 2h-10a2 2 0 0 1 -2 -2v-10a2 2 0 0 1 2 -2h2"
  }));
}
var ww = ["size", "color", "stroke"];
function pw(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, ww);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-box-multiple-6",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("rect", {
    x: 7,
    y: 3,
    width: 14,
    height: 14,
    rx: 2
  }), e.createElement("circle", {
    cx: 14,
    cy: 12,
    r: 2
  }), e.createElement("path", {
    d: "M16 8a2 2 0 1 0 -4 0v4"
  }), e.createElement("path", {
    d: "M17 17v2a2 2 0 0 1 -2 2h-10a2 2 0 0 1 -2 -2v-10a2 2 0 0 1 2 -2h2"
  }));
}
var Ew = ["size", "color", "stroke"];
function uw(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Ew);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-box-multiple-7",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("rect", {
    x: 7,
    y: 3,
    width: 14,
    height: 14,
    rx: 2
  }), e.createElement("path", {
    d: "M12 6h4l-2 8"
  }), e.createElement("path", {
    d: "M17 17v2a2 2 0 0 1 -2 2h-10a2 2 0 0 1 -2 -2v-10a2 2 0 0 1 2 -2h2"
  }));
}
var gw = ["size", "color", "stroke"];
function Mw(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, gw);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-box-multiple-8",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("rect", {
    x: 7,
    y: 3,
    width: 14,
    height: 14,
    rx: 2
  }), e.createElement("circle", {
    cx: 14,
    cy: 8,
    r: 2
  }), e.createElement("circle", {
    cx: 14,
    cy: 12,
    r: 2
  }), e.createElement("path", {
    d: "M17 17v2a2 2 0 0 1 -2 2h-10a2 2 0 0 1 -2 -2v-10a2 2 0 0 1 2 -2h2"
  }));
}
var xw = ["size", "color", "stroke"];
function fw(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, xw);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-box-multiple-9",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("rect", {
    x: 7,
    y: 3,
    width: 14,
    height: 14,
    rx: 2
  }), e.createElement("circle", {
    cx: 14,
    cy: 8,
    r: 2
  }), e.createElement("path", {
    d: "M12 12a2 2 0 1 0 4 0v-4"
  }), e.createElement("path", {
    d: "M17 17v2a2 2 0 0 1 -2 2h-10a2 2 0 0 1 -2 -2v-10a2 2 0 0 1 2 -2h2"
  }));
}
var zw = ["size", "color", "stroke"];
function bw(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, zw);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-box-multiple",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("rect", {
    x: 7,
    y: 3,
    width: 14,
    height: 14,
    rx: 2
  }), e.createElement("path", {
    d: "M17 17v2a2 2 0 0 1 -2 2h-10a2 2 0 0 1 -2 -2v-10a2 2 0 0 1 2 -2h2"
  }));
}
var Lw = ["size", "color", "stroke"];
function yw(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Lw);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-box-off",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M17.765 17.757l-5.765 3.243l-8 -4.5v-9l2.236 -1.258m2.57 -1.445l3.194 -1.797l8 4.5v8.5"
  }), e.createElement("path", {
    d: "M14.561 10.559l5.439 -3.059"
  }), e.createElement("path", {
    d: "M12 12v9"
  }), e.createElement("path", {
    d: "M12 12l-8 -4.5"
  }), e.createElement("path", {
    d: "M3 3l18 18"
  }));
}
var Cw = ["size", "color", "stroke"];
function jw(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Cw);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-box-padding",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("rect", {
    x: 4,
    y: 4,
    width: 16,
    height: 16,
    rx: 2
  }), e.createElement("path", {
    d: "M8 16v.01"
  }), e.createElement("path", {
    d: "M8 12v.01"
  }), e.createElement("path", {
    d: "M8 8v.01"
  }), e.createElement("path", {
    d: "M16 16v.01"
  }), e.createElement("path", {
    d: "M16 12v.01"
  }), e.createElement("path", {
    d: "M16 8v.01"
  }), e.createElement("path", {
    d: "M12 8v.01"
  }), e.createElement("path", {
    d: "M12 16v.01"
  }));
}
var Bw = ["size", "color", "stroke"];
function Hw(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Bw);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-box-seam",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M12 3l8 4.5v9l-8 4.5l-8 -4.5v-9l8 -4.5"
  }), e.createElement("path", {
    d: "M12 12l8 -4.5"
  }), e.createElement("path", {
    d: "M8.2 9.8l7.6 -4.6"
  }), e.createElement("path", {
    d: "M12 12v9"
  }), e.createElement("path", {
    d: "M12 12l-8 -4.5"
  }));
}
var Nw = ["size", "color", "stroke"];
function Ww(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Nw);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-box",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("polyline", {
    points: "12 3 20 7.5 20 16.5 12 21 4 16.5 4 7.5 12 3"
  }), e.createElement("line", {
    x1: 12,
    y1: 12,
    x2: 20,
    y2: 7.5
  }), e.createElement("line", {
    x1: 12,
    y1: 12,
    x2: 12,
    y2: 21
  }), e.createElement("line", {
    x1: 12,
    y1: 12,
    x2: 4,
    y2: 7.5
  }));
}
var qw = ["size", "color", "stroke"];
function Ow(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, qw);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-braces-off",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M5.176 5.177c-.113 .251 -.176 .53 -.176 .823v3c0 1.657 -.895 3 -2 3c1.105 0 2 1.343 2 3v3a2 2 0 0 0 2 2"
  }), e.createElement("path", {
    d: "M17 4a2 2 0 0 1 2 2v3c0 1.657 .895 3 2 3c-1.105 0 -2 1.343 -2 3m-.176 3.821a2 2 0 0 1 -1.824 1.179"
  }), e.createElement("path", {
    d: "M3 3l18 18"
  }));
}
var Pw = ["size", "color", "stroke"];
function Sw(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Pw);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-braces",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M7 4a2 2 0 0 0 -2 2v3a2 3 0 0 1 -2 3a2 3 0 0 1 2 3v3a2 2 0 0 0 2 2"
  }), e.createElement("path", {
    d: "M17 4a2 2 0 0 1 2 2v3a2 3 0 0 0 2 3a2 3 0 0 0 -2 3v3a2 2 0 0 1 -2 2"
  }));
}
var Iw = ["size", "color", "stroke"];
function Aw(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Iw);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-brackets-contain-end",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M14 4h4v16h-4"
  }), e.createElement("path", {
    d: "M5 16h.01"
  }), e.createElement("path", {
    d: "M9 16h.01"
  }), e.createElement("path", {
    d: "M13 16h.01"
  }));
}
var Dw = ["size", "color", "stroke"];
function Fw(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Dw);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-brackets-contain-start",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M9 4h-4v16h4"
  }), e.createElement("path", {
    d: "M18 16h-.01"
  }), e.createElement("path", {
    d: "M14 16h-.01"
  }), e.createElement("path", {
    d: "M10 16h-.01"
  }));
}
var Gw = ["size", "color", "stroke"];
function Jw(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Gw);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-brackets-contain",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M7 4h-4v16h4"
  }), e.createElement("path", {
    d: "M17 4h4v16h-4"
  }), e.createElement("path", {
    d: "M8 16h.01"
  }), e.createElement("path", {
    d: "M12 16h.01"
  }), e.createElement("path", {
    d: "M16 16h.01"
  }));
}
var Kw = ["size", "color", "stroke"];
function Qw(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Kw);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-brackets-off",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M5 5v15h3"
  }), e.createElement("path", {
    d: "M16 4h3v11m0 4v1h-3"
  }), e.createElement("path", {
    d: "M3 3l18 18"
  }));
}
var Rw = ["size", "color", "stroke"];
function Tw(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Rw);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-brackets",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M8 4h-3v16h3"
  }), e.createElement("path", {
    d: "M16 4h3v16h-3"
  }));
}
var Uw = ["size", "color", "stroke"];
function Vw(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Uw);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-braile",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M15 5a1 1 0 1 0 2 0a1 1 0 0 0 -2 0z"
  }), e.createElement("path", {
    d: "M7 5a1 1 0 1 0 2 0a1 1 0 0 0 -2 0z"
  }), e.createElement("path", {
    d: "M7 19a1 1 0 1 0 2 0a1 1 0 0 0 -2 0z"
  }), e.createElement("path", {
    d: "M16 12h.01"
  }), e.createElement("path", {
    d: "M8 12h.01"
  }), e.createElement("path", {
    d: "M16 19h.01"
  }));
}
var Xw = ["size", "color", "stroke"];
function Yw(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Xw);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-brain",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M15.5 13a3.5 3.5 0 0 0 -3.5 3.5v1a3.5 3.5 0 0 0 7 0v-1.8"
  }), e.createElement("path", {
    d: "M8.5 13a3.5 3.5 0 0 1 3.5 3.5v1a3.5 3.5 0 0 1 -7 0v-1.8"
  }), e.createElement("path", {
    d: "M17.5 16a3.5 3.5 0 0 0 0 -7h-.5"
  }), e.createElement("path", {
    d: "M19 9.3v-2.8a3.5 3.5 0 0 0 -7 0"
  }), e.createElement("path", {
    d: "M6.5 16a3.5 3.5 0 0 1 0 -7h.5"
  }), e.createElement("path", {
    d: "M5 9.3v-2.8a3.5 3.5 0 0 1 7 0v10"
  }));
}
var Zw = ["size", "color", "stroke"];
function $w(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Zw);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-brand-4chan",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M14 11s6.054 -1.05 6 -4.5c-.038 -2.324 -2.485 -3.19 -3.016 -1.5c0 0 -.502 -2 -2.01 -2c-1.508 0 -2.984 3 -.974 8z"
  }), e.createElement("path", {
    d: "M13.98 11s6.075 -1.05 6.02 -4.5c-.038 -2.324 -2.493 -3.19 -3.025 -1.5c0 0 -.505 -2 -2.017 -2c-1.513 0 -2.994 3 -.977 8z"
  }), e.createElement("path", {
    d: "M13 13.98l.062 .309l.081 .35l.075 .29l.092 .328l.11 .358l.061 .188l.139 .392c.64 1.73 1.841 3.837 3.88 3.805c2.324 -.038 3.19 -2.493 1.5 -3.025l.148 -.045l.165 -.058a4.13 4.13 0 0 0 .098 -.039l.222 -.098c.586 -.28 1.367 -.832 1.367 -1.777c0 -1.513 -3 -2.994 -8 -.977z"
  }), e.createElement("path", {
    d: "M10.02 13l-.309 .062l-.35 .081l-.29 .075l-.328 .092l-.358 .11l-.188 .061l-.392 .139c-1.73 .64 -3.837 1.84 -3.805 3.88c.038 2.324 2.493 3.19 3.025 1.5l.045 .148l.058 .165l.039 .098l.098 .222c.28 .586 .832 1.367 1.777 1.367c1.513 0 2.994 -3 .977 -8z"
  }), e.createElement("path", {
    d: "M11 10.02l-.062 -.309l-.081 -.35l-.075 -.29l-.092 -.328l-.11 -.358l-.128 -.382l-.148 -.399c-.658 -1.687 -1.844 -3.634 -3.804 -3.604c-2.324 .038 -3.19 2.493 -1.5 3.025l-.148 .045l-.164 .058a4.13 4.13 0 0 0 -.1 .039l-.22 .098c-.588 .28 -1.368 .832 -1.368 1.777c0 1.513 3 2.994 8 .977z"
  }));
}
var _w = ["size", "color", "stroke"];
function ep(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, _w);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-brand-abstract",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M12 3c7.2 0 9 1.8 9 9s-1.8 9 -9 9s-9 -1.8 -9 -9s1.8 -9 9 -9z"
  }), e.createElement("circle", {
    cx: 10.5,
    cy: 13.5,
    r: 2.5
  }), e.createElement("path", {
    d: "M8 8h8v8"
  }));
}
var tp = ["size", "color", "stroke"];
function op(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, tp);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-brand-adobe",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M12.893 4.514l7.977 13.994a0.993 .993 0 0 1 -.394 1.365a1.04 1.04 0 0 1 -.5 .127h-3.476l-4.5 -8l-2.5 4h1.5l2 4h-8.977c-.565 0 -1.023 -.45 -1.023 -1.003c0 -.171 .045 -.34 .13 -.49l7.977 -13.993a1.034 1.034 0 0 1 1.786 0z"
  }));
}
var rp = ["size", "color", "stroke"];
function np(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, rp);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-brand-adonis-js",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M12 3c7.2 0 9 1.8 9 9s-1.8 9 -9 9s-9 -1.8 -9 -9s1.8 -9 9 -9z"
  }), e.createElement("path", {
    d: "M8.863 16.922c1.137 -.422 1.637 -.922 3.137 -.922s2 .5 3.138 .922c.713 .264 1.516 -.102 1.778 -.772c.126 -.32 .11 -.673 -.044 -.983l-3.708 -7.474c-.297 -.598 -1.058 -.859 -1.7 -.583a1.24 1.24 0 0 0 -.627 .583l-3.709 7.474c-.321 .648 -.017 1.415 .679 1.714c.332 .143 .715 .167 1.056 .04z"
  }));
}
var lp = ["size", "color", "stroke"];
function ap(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, lp);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-brand-airbnb",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M12 10c-2 0 -3 1 -3 3c0 1.5 1.494 3.535 3 5.5c1 1 1.5 1.5 2.5 2s2.5 1 4.5 -.5s1.5 -3.5 .5 -6s-2.333 -5.5 -5 -9.5c-.834 -1 -1.5 -1.5 -2.503 -1.5c-1 0 -1.623 .45 -2.497 1.5c-2.667 4 -4 7 -5 9.5s-1.5 4.5 .5 6s3.5 1 4.5 .5s1.5 -1 2.5 -2c1.506 -1.965 3 -4 3 -5.5c0 -2 -1 -3 -3 -3z"
  }));
}
var ip = ["size", "color", "stroke"];
function cp(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, ip);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-brand-airtable",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M3 10v8l7 -3v-2.6z"
  }), e.createElement("path", {
    d: "M3 6l9 3l9 -3l-9 -3z"
  }), e.createElement("path", {
    d: "M14 12.3v8.7l7 -3v-8z"
  }));
}
var sp = ["size", "color", "stroke"];
function hp(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, sp);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-brand-algolia",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("rect", {
    x: 4,
    y: 4,
    width: 16,
    height: 16,
    rx: 2
  }), e.createElement("path", {
    d: "M11.5 7h1"
  }), e.createElement("path", {
    d: "M7.403 9.11l.707 -.706"
  }), e.createElement("circle", {
    cx: 12,
    cy: 13,
    r: 3.5
  }), e.createElement("path", {
    d: "M12 12v1l.9 -.5z"
  }));
}
var dp = ["size", "color", "stroke"];
function vp(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, dp);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-brand-alpine-js",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M3 11.5l4.5 4.5h9l-9 -9z"
  }), e.createElement("path", {
    d: "M16.5 16l4.5 -4.5l-4.5 -4.5l-4.5 4.5"
  }));
}
var mp = ["size", "color", "stroke"];
function kp(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, mp);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-brand-amazon",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M17 12.5a15.198 15.198 0 0 1 -7.37 1.44a14.62 14.62 0 0 1 -6.63 -2.94"
  }), e.createElement("path", {
    d: "M19.5 15c.907 -1.411 1.451 -3.323 1.5 -5c-1.197 -.773 -2.577 -.935 -4 -1"
  }));
}
var wp = ["size", "color", "stroke"];
function pp(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, wp);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-brand-amd",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M16 16v-7c0 -.566 -.434 -1 -1 -1h-7l-5 -5h17c.566 0 1 .434 1 1v17l-5 -5z"
  }), e.createElement("path", {
    d: "M11.293 20.707l4.707 -4.707h-7a1 1 0 0 1 -1 -1v-7l-4.707 4.707a1 1 0 0 0 -.293 .707v6.586a1 1 0 0 0 1 1h6.586a1 1 0 0 0 .707 -.293z"
  }));
}
var Ep = ["size", "color", "stroke"];
function up(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Ep);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-brand-amigo",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 2
  }), e.createElement("path", {
    d: "M9.591 3.635l-7.13 14.082c-1.712 3.38 1.759 5.45 3.69 3.573l1.86 -1.81c3.142 -3.054 4.959 -2.99 8.039 .11l1.329 1.337c2.372 2.387 5.865 .078 4.176 -3.225l-7.195 -14.067c-1.114 -2.18 -3.666 -2.18 -4.77 0z"
  }));
}
var gp = ["size", "color", "stroke"];
function Mp(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, gp);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-brand-amongus",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M10.646 12.774c-1.939 .396 -4.467 .317 -6.234 -.601c-2.454 -1.263 -1.537 -4.66 1.423 -4.982c2.254 -.224 3.814 -.354 5.65 .214c.835 .256 1.93 .569 1.355 3.281c-.191 1.067 -1.07 1.904 -2.194 2.088z"
  }), e.createElement("path", {
    d: "M5.84 7.132c.083 -.564 .214 -1.12 .392 -1.661c.456 -.936 1.095 -2.068 3.985 -2.456a22.464 22.464 0 0 1 2.867 .08c1.776 .14 2.643 1.234 3.287 3.368c.339 1.157 .46 2.342 .629 3.537v11l-12.704 -.019c-.552 -2.386 -.262 -5.894 .204 -8.481"
  }), e.createElement("path", {
    d: "M17 10c.991 .163 2.105 .383 3.069 .67c.255 .13 .52 .275 .534 .505c.264 3.434 .57 7.448 .278 9.825h-3.881"
  }));
}
var xp = ["size", "color", "stroke"];
function fp(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, xp);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-brand-android",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("line", {
    x1: 4,
    y1: 10,
    x2: 4,
    y2: 16
  }), e.createElement("line", {
    x1: 20,
    y1: 10,
    x2: 20,
    y2: 16
  }), e.createElement("path", {
    d: "M7 9h10v8a1 1 0 0 1 -1 1h-8a1 1 0 0 1 -1 -1v-8a5 5 0 0 1 10 0"
  }), e.createElement("line", {
    x1: 8,
    y1: 3,
    x2: 9,
    y2: 5
  }), e.createElement("line", {
    x1: 16,
    y1: 3,
    x2: 15,
    y2: 5
  }), e.createElement("line", {
    x1: 9,
    y1: 18,
    x2: 9,
    y2: 21
  }), e.createElement("line", {
    x1: 15,
    y1: 18,
    x2: 15,
    y2: 21
  }));
}
var zp = ["size", "color", "stroke"];
function bp(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, zp);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-brand-angular",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M5.428 17.245l6.076 3.471a1 1 0 0 0 .992 0l6.076 -3.471a1 1 0 0 0 .495 -.734l1.323 -9.704a1 1 0 0 0 -.658 -1.078l-7.4 -2.612a1 1 0 0 0 -.665 0l-7.399 2.613a1 1 0 0 0 -.658 1.078l1.323 9.704a1 1 0 0 0 .495 .734z"
  }), e.createElement("path", {
    d: "M9 15l3 -8l3 8"
  }), e.createElement("path", {
    d: "M10 13h4"
  }));
}
var Lp = ["size", "color", "stroke"];
function yp(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Lp);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-brand-ao3",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M2 5c7.109 4.1 10.956 10.131 12 14c1.074 -4.67 4.49 -8.94 8 -11"
  }), e.createElement("circle", {
    cx: 14,
    cy: 8,
    r: 2
  }), e.createElement("path", {
    d: "M7 9c-.278 5.494 -2.337 7.33 -4 10c4.013 -2 6.02 -5 15.05 -5c4.012 0 3.51 2.5 1.003 3c2.006 .5 2.508 5 -2.007 2"
  }));
}
var Cp = ["size", "color", "stroke"];
function jp(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Cp);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-brand-appgallery",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("rect", {
    x: 4,
    y: 4,
    width: 16,
    height: 16,
    rx: 4
  }), e.createElement("path", {
    d: "M9 8a3 3 0 0 0 6 0"
  }));
}
var Bp = ["size", "color", "stroke"];
function Hp(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Bp);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-brand-apple-arcade",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("circle", {
    cx: 12,
    cy: 5,
    r: 2
  }), e.createElement("path", {
    d: "M20 12.5v4.75a0.734 .734 0 0 1 -.055 .325a0.704 .704 0 0 1 -.348 .366l-5.462 2.58a4.998 4.998 0 0 1 -4.27 0l-5.462 -2.58a0.705 .705 0 0 1 -.401 -.691l-.002 -4.75"
  }), e.createElement("path", {
    d: "M4.431 12.216l5.634 -2.332a5.065 5.065 0 0 1 3.87 0l5.634 2.332a0.692 .692 0 0 1 .028 1.269l-5.462 2.543a5.064 5.064 0 0 1 -4.27 0l-5.462 -2.543a0.691 .691 0 0 1 .028 -1.27z"
  }), e.createElement("line", {
    x1: 12,
    y1: 7,
    x2: 12,
    y2: 13
  }));
}
var Np = ["size", "color", "stroke"];
function Wp(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Np);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-brand-apple-podcast",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M18.364 18.364a9 9 0 1 0 -12.728 0"
  }), e.createElement("path", {
    d: "M11.766 22h.468a2 2 0 0 0 1.985 -1.752l.5 -4a2 2 0 0 0 -1.985 -2.248h-1.468a2 2 0 0 0 -1.985 2.248l.5 4a2 2 0 0 0 1.985 1.752z"
  }), e.createElement("circle", {
    cx: 12,
    cy: 9,
    r: 2
  }));
}
var qp = ["size", "color", "stroke"];
function Op(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, qp);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-brand-apple",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M9 7c-3 0 -4 3 -4 5.5c0 3 2 7.5 4 7.5c1.088 -.046 1.679 -.5 3 -.5c1.312 0 1.5 .5 3 .5s4 -3 4 -5c-.028 -.01 -2.472 -.403 -2.5 -3c-.019 -2.17 2.416 -2.954 2.5 -3c-1.023 -1.492 -2.951 -1.963 -3.5 -2c-1.433 -.111 -2.83 1 -3.5 1c-.68 0 -1.9 -1 -3 -1z"
  }), e.createElement("path", {
    d: "M12 4a2 2 0 0 0 2 -2a2 2 0 0 0 -2 2"
  }));
}
var Pp = ["size", "color", "stroke"];
function Sp(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Pp);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-brand-appstore",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 9
  }), e.createElement("path", {
    d: "M8 16l1.106 -1.99m1.4 -2.522l2.494 -4.488"
  }), e.createElement("path", {
    d: "M7 14h5m2.9 0h2.1"
  }), e.createElement("path", {
    d: "M16 16l-2.51 -4.518m-1.487 -2.677l-1.003 -1.805"
  }));
}
var Ip = ["size", "color", "stroke"];
function Ap(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Ip);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-brand-asana",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("circle", {
    cx: 12,
    cy: 7,
    r: 3
  }), e.createElement("circle", {
    cx: 17,
    cy: 16,
    r: 3
  }), e.createElement("circle", {
    cx: 7,
    cy: 16,
    r: 3
  }));
}
var Dp = ["size", "color", "stroke"];
function Fp(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Dp);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-brand-backbone",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M5 20l14 -8l-14 -8z"
  }), e.createElement("path", {
    d: "M19 20l-14 -8l14 -8z"
  }));
}
var Gp = ["size", "color", "stroke"];
function Jp(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Gp);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-brand-badoo",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M22 9.43c0 5.838 -4.477 10.57 -10 10.57s-10 -4.662 -10 -10.5c-.004 -2.667 1.83 -5.01 4.322 -5.429c2.492 -.418 4.9 1.392 5.678 3.929c.768 -2.54 3.177 -4.354 5.668 -3.931c2.495 .417 4.332 2.69 4.332 5.36z"
  }), e.createElement("path", {
    d: "M7.5 10c0 2.761 2.015 5 4.5 5s4.5 -2.239 4.5 -5"
  }));
}
var Kp = ["size", "color", "stroke"];
function Qp(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Kp);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-brand-baidu",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("ellipse", {
    cx: 5,
    cy: 9.5,
    rx: 1,
    ry: 1.5
  }), e.createElement("path", {
    d: "M14.463 11.596c1.282 1.774 3.476 3.416 3.476 3.416s1.921 1.574 .593 3.636c-1.328 2.063 -4.892 1.152 -4.892 1.152s-1.416 -.44 -3.06 -.088c-1.644 .356 -3.06 .22 -3.06 .22s-2.055 -.22 -2.47 -2.304c-.416 -2.084 1.918 -3.638 2.102 -3.858c.182 -.222 1.409 -.966 2.284 -2.394c.875 -1.428 3.337 -2.287 5.027 .221z"
  }), e.createElement("ellipse", {
    cx: 9,
    cy: 4.5,
    rx: 1,
    ry: 1.5
  }), e.createElement("ellipse", {
    cx: 15,
    cy: 4.5,
    rx: 1,
    ry: 1.5
  }), e.createElement("ellipse", {
    cx: 19,
    cy: 9.5,
    rx: 1,
    ry: 1.5
  }));
}
var Rp = ["size", "color", "stroke"];
function Tp(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Rp);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-brand-bandcamp",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M8.5 6h13.5l-7 12h-13z"
  }));
}
var Up = ["size", "color", "stroke"];
function Vp(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Up);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-brand-bandlab",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M6.885 7l-2.536 4.907c-2.021 3.845 -2.499 8.775 3.821 9.093h6.808c4.86 -.207 7.989 -2.975 4.607 -9.093l-2.988 -4.907"
  }), e.createElement("path", {
    d: "M15.078 4h-5.136l3.678 8.768c.547 1.14 .847 1.822 .162 2.676c-.053 .093 -1.332 1.907 -3.053 1.495c-.825 -.187 -1.384 -.926 -1.32 -1.74c.04 -.91 .62 -1.717 1.488 -2.074a4.463 4.463 0 0 1 2.723 -.358"
  }));
}
var Xp = ["size", "color", "stroke"];
function Yp(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Xp);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-brand-beats",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 9
  }), e.createElement("circle", {
    cx: 12.5,
    cy: 12.5,
    r: 3.5
  }), e.createElement("path", {
    d: "M9 12v-8"
  }));
}
var Zp = ["size", "color", "stroke"];
function $p(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Zp);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-brand-behance",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M3 18v-12h4.5a3 3 0 0 1 0 6a3 3 0 0 1 0 6h-4.5"
  }), e.createElement("line", {
    x1: 3,
    y1: 12,
    x2: 7.5,
    y2: 12
  }), e.createElement("path", {
    d: "M14 13h7a3.5 3.5 0 0 0 -7 0v2a3.5 3.5 0 0 0 6.64 1"
  }), e.createElement("line", {
    x1: 16,
    y1: 6,
    x2: 19,
    y2: 6
  }));
}
var _p = ["size", "color", "stroke"];
function eE(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, _p);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-brand-binance",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M6 8l2 2l4 -4l4 4l2 -2l-6 -6z"
  }), e.createElement("path", {
    d: "M6 16l2 -2l4 4l3.5 -3.5l2 2l-5.5 5.5z"
  }), e.createElement("path", {
    d: "M20 10l1.997 2.001l-1.997 1.999l-2 -2z"
  }), e.createElement("path", {
    d: "M4 10l2 2l-2 2l-2 -2z"
  }), e.createElement("path", {
    d: "M12 10l2 2l-2 2l-2 -2z"
  }));
}
var tE = ["size", "color", "stroke"];
function oE(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, tE);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-brand-bing",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M5 3l4 1.5v12l6 -2.5l-2 -1l-1 -4l7 2.5v4.5l-10 5l-4 -2z"
  }));
}
var rE = ["size", "color", "stroke"];
function nE(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, rE);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-brand-bitbucket",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M3.648 4a0.64 .64 0 0 0 -.64 .744l3.14 14.528c.07 .417 .43 .724 .852 .728h10a0.644 .644 0 0 0 .642 -.539l3.35 -14.71a0.641 .641 0 0 0 -.64 -.744l-16.704 -.007z"
  }), e.createElement("path", {
    d: "M14 15h-4l-1 -6h6z"
  }));
}
var lE = ["size", "color", "stroke"];
function aE(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, lE);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-brand-blackbery",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M7 6a1 1 0 0 0 -1 -1h-2l-.5 2h2.5a1 1 0 0 0 1 -1z"
  }), e.createElement("path", {
    d: "M6 12a1 1 0 0 0 -1 -1h-2l-.5 2h2.5a1 1 0 0 0 1 -1z"
  }), e.createElement("path", {
    d: "M13 12a1 1 0 0 0 -1 -1h-2l-.5 2h2.5a1 1 0 0 0 1 -1z"
  }), e.createElement("path", {
    d: "M14 6a1 1 0 0 0 -1 -1h-2l-.5 2h2.5a1 1 0 0 0 1 -1z"
  }), e.createElement("path", {
    d: "M12 18a1 1 0 0 0 -1 -1h-2l-.5 2h2.5a1 1 0 0 0 1 -1z"
  }), e.createElement("path", {
    d: "M20 15a1 1 0 0 0 -1 -1h-2l-.5 2h2.5a1 1 0 0 0 1 -1z"
  }), e.createElement("path", {
    d: "M21 9a1 1 0 0 0 -1 -1h-2l-.5 2h2.5a1 1 0 0 0 1 -1z"
  }));
}
var iE = ["size", "color", "stroke"];
function cE(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, iE);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-brand-blender",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("ellipse", {
    cx: 15,
    cy: 14,
    rx: 6,
    ry: 5
  }), e.createElement("circle", {
    cx: 15,
    cy: 14,
    r: 1
  }), e.createElement("path", {
    d: "M3 16l9 -6.5"
  }), e.createElement("path", {
    d: "M6 9h9"
  }), e.createElement("path", {
    d: "M13 5l5.65 5"
  }));
}
var sE = ["size", "color", "stroke"];
function hE(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, sE);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-brand-blogger",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M8 21h8a5 5 0 0 0 5 -5v-3a3 3 0 0 0 -3 -3h-1v-2a5 5 0 0 0 -5 -5h-4a5 5 0 0 0 -5 5v8a5 5 0 0 0 5 5z"
  }), e.createElement("rect", {
    x: 7,
    y: 7,
    width: 6,
    height: 3,
    rx: 1.5
  }), e.createElement("rect", {
    x: 7,
    y: 14,
    width: 10,
    height: 3,
    rx: 1.5
  }));
}
var dE = ["size", "color", "stroke"];
function vE(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, dE);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-brand-booking",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M4 18v-9.5a4.5 4.5 0 0 1 4.5 -4.5h7a4.5 4.5 0 0 1 4.5 4.5v7a4.5 4.5 0 0 1 -4.5 4.5h-9.5a2 2 0 0 1 -2 -2z"
  }), e.createElement("path", {
    d: "M8 12h3.5a2 2 0 1 1 0 4h-3.5v-7a1 1 0 0 1 1 -1h1.5a2 2 0 1 1 0 4h-1.5"
  }), e.createElement("line", {
    x1: 16,
    y1: 16,
    x2: 16.01,
    y2: 16
  }));
}
var mE = ["size", "color", "stroke"];
function kE(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, mE);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-brand-bootstrap",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M2 12a2 2 0 0 0 2 -2v-4a2 2 0 0 1 2 -2h12a2 2 0 0 1 2 2v4a2 2 0 0 0 2 2"
  }), e.createElement("path", {
    d: "M2 12a2 2 0 0 1 2 2v4a2 2 0 0 0 2 2h12a2 2 0 0 0 2 -2v-4a2 2 0 0 1 2 -2"
  }), e.createElement("path", {
    d: "M9 16v-8h3.5a2 2 0 1 1 0 4h-3.5h4a2 2 0 1 1 0 4h-4z"
  }));
}
var wE = ["size", "color", "stroke"];
function pE(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, wE);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-brand-bulma",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M5 16l1 -9l5 -5l6.5 6l-3.5 4l5 5l-8 5z"
  }));
}
var EE = ["size", "color", "stroke"];
function uE(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, EE);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-brand-bumble",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M7 12h10"
  }), e.createElement("path", {
    d: "M9 8h6"
  }), e.createElement("path", {
    d: "M10 16h4"
  }), e.createElement("path", {
    d: "M16.268 3h-8.536a1.46 1.46 0 0 0 -1.268 .748l-4.268 7.509a1.507 1.507 0 0 0 0 1.486l4.268 7.509c.26 .462 .744 .747 1.268 .748h8.536a1.46 1.46 0 0 0 1.268 -.748l4.268 -7.509a1.507 1.507 0 0 0 0 -1.486l-4.268 -7.509a1.46 1.46 0 0 0 -1.268 -.748z"
  }));
}
var gE = ["size", "color", "stroke"];
function ME(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, gE);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-brand-bunpo",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M3.9 7.205a17.764 17.764 0 0 0 4.008 2.753a7.917 7.917 0 0 0 4.57 .567c1.5 -.33 2.907 -.998 4.121 -1.956a12.107 12.107 0 0 0 2.892 -2.903c.603 -.94 .745 -1.766 .484 -2.231c-.261 -.465 -.927 -.568 -1.72 -.257a7.564 7.564 0 0 0 -2.608 2.034a18.425 18.425 0 0 0 -2.588 3.884a34.927 34.927 0 0 0 -2.093 5.073a12.908 12.908 0 0 0 -.677 3.515c-.07 .752 .07 1.51 .405 2.184c.323 .562 1.06 1.132 2.343 1.132c3.474 0 5.093 -3.53 5.463 -5.62c.24 -1.365 -.085 -3.197 -1.182 -4.01"
  }));
}
var xE = ["size", "color", "stroke"];
function fE(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, xE);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-brand-campaignmonitor",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M3 18l9 -6.462l-9 -5.538v12h18v-12l-9 5.538"
  }));
}
var zE = ["size", "color", "stroke"];
function bE(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, zE);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-brand-carbon",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M14 10v-.2a1.8 1.8 0 0 0 -1.8 -1.8h-.4a1.8 1.8 0 0 0 -1.8 1.8v4.4a1.8 1.8 0 0 0 1.8 1.8h.4a1.8 1.8 0 0 0 1.8 -1.8v-.2"
  }), e.createElement("rect", {
    x: 3,
    y: 3,
    width: 18,
    height: 18,
    rx: 3
  }));
}
var LE = ["size", "color", "stroke"];
function yE(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, LE);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-brand-cashapp",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M17.1 8.648a0.568 .568 0 0 1 -.761 .011a5.682 5.682 0 0 0 -3.659 -1.34c-1.102 0 -2.205 .363 -2.205 1.374c0 1.023 1.182 1.364 2.546 1.875c2.386 .796 4.363 1.796 4.363 4.137c0 2.545 -1.977 4.295 -5.204 4.488l-.295 1.364a0.557 .557 0 0 1 -.546 .443h-2.034l-.102 -.011a0.568 .568 0 0 1 -.432 -.67l.318 -1.444a7.432 7.432 0 0 1 -3.273 -1.784v-.011a0.545 .545 0 0 1 0 -.773l1.137 -1.102c.214 -.2 .547 -.2 .761 0a5.495 5.495 0 0 0 3.852 1.5c1.478 0 2.466 -.625 2.466 -1.614c0 -.989 -1 -1.25 -2.886 -1.954c-2 -.716 -3.898 -1.728 -3.898 -4.091c0 -2.75 2.284 -4.091 4.989 -4.216l.284 -1.398a0.545 .545 0 0 1 .545 -.432h2.023l.114 .012a0.544 .544 0 0 1 .42 .647l-.307 1.557a8.528 8.528 0 0 1 2.818 1.58l.023 .022c.216 .228 .216 .569 0 .773l-1.057 1.057z"
  }));
}
var CE = ["size", "color", "stroke"];
function jE(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, CE);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-brand-chrome",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 9
  }), e.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 3
  }), e.createElement("path", {
    d: "M12 9h8.4"
  }), e.createElement("path", {
    d: "M14.598 13.5l-4.2 7.275"
  }), e.createElement("path", {
    d: "M9.402 13.5l-4.2 -7.275"
  }));
}
var BE = ["size", "color", "stroke"];
function HE(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, BE);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-brand-citymapper",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M3 11a1 1 0 1 1 -1 1.013a1 1 0 0 1 1 -1v-.013z"
  }), e.createElement("path", {
    d: "M21 11a1 1 0 1 1 -1 1.013a1 1 0 0 1 1 -1v-.013z"
  }), e.createElement("path", {
    d: "M8 12h8"
  }), e.createElement("path", {
    d: "M13 9l3 3l-3 3"
  }));
}
var NE = ["size", "color", "stroke"];
function WE(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, NE);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-brand-codecov",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M9.695 12.985a5.972 5.972 0 0 0 -3.295 -.985c-1.257 0 -2.436 .339 -3.4 1a9 9 0 1 1 18 0c-.966 -.664 -2.14 -1 -3.4 -1a6 6 0 0 0 -5.605 8.144"
  }));
}
var qE = ["size", "color", "stroke"];
function OE(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, qE);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-brand-codepen",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M3 15l9 6l9 -6l-9 -6l-9 6"
  }), e.createElement("path", {
    d: "M3 9l9 6l9 -6l-9 -6l-9 6"
  }), e.createElement("line", {
    x1: 3,
    y1: 9,
    x2: 3,
    y2: 15
  }), e.createElement("line", {
    x1: 21,
    y1: 9,
    x2: 21,
    y2: 15
  }), e.createElement("line", {
    x1: 12,
    y1: 3,
    x2: 12,
    y2: 9
  }), e.createElement("line", {
    x1: 12,
    y1: 15,
    x2: 12,
    y2: 21
  }));
}
var PE = ["size", "color", "stroke"];
function SE(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, PE);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-brand-codesandbox",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M20 7.5v9l-4 2.25l-4 2.25l-4 -2.25l-4 -2.25v-9l4 -2.25l4 -2.25l4 2.25z"
  }), e.createElement("path", {
    d: "M12 12l4 -2.25l4 -2.25"
  }), e.createElement("line", {
    x1: 12,
    y1: 12,
    x2: 12,
    y2: 21
  }), e.createElement("path", {
    d: "M12 12l-4 -2.25l-4 -2.25"
  }), e.createElement("path", {
    d: "M20 12l-4 2v4.75"
  }), e.createElement("path", {
    d: "M4 12l4 2l0 4.75"
  }), e.createElement("path", {
    d: "M8 5.25l4 2.25l4 -2.25"
  }));
}
var IE = ["size", "color", "stroke"];
function AE(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, IE);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-brand-cohost",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("ellipse", {
    cx: 17,
    cy: 14,
    rx: 3,
    ry: 2
  }), e.createElement("path", {
    d: "M4.526 17.666c-1.133 -.772 -1.897 -1.924 -2.291 -3.456c-.398 -1.54 -.29 -2.937 .32 -4.19c.61 -1.255 1.59 -2.34 2.938 -3.254c1.348 -.914 2.93 -1.625 4.749 -2.132c1.81 -.504 3.516 -.708 5.12 -.61c1.608 .1 2.979 .537 4.112 1.31s1.897 1.924 2.291 3.456c.398 1.541 .29 2.938 -.32 4.192c-.61 1.253 -1.59 2.337 -2.938 3.252c-1.348 .915 -2.93 1.626 -4.749 2.133c-1.81 .503 -3.516 .707 -5.12 .61c-1.608 -.102 -2.979 -.538 -4.112 -1.31z"
  }), e.createElement("path", {
    d: "M10.998 12.508c-.53 -.316 -1.23 -.508 -1.998 -.508c-1.657 0 -3 .895 -3 2s1.343 2 3 2c.767 0 1.467 -.192 1.998 -.508"
  }));
}
var DE = ["size", "color", "stroke"];
function FE(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, DE);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-brand-coinbase",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M12.95 22c-4.503 .001 -8.445 -3.04 -9.61 -7.413c-1.165 -4.373 .737 -8.988 4.638 -11.25a9.906 9.906 0 0 1 12.008 1.598l-3.335 3.367a5.185 5.185 0 0 0 -7.354 .013a5.252 5.252 0 0 0 0 7.393a5.185 5.185 0 0 0 7.354 .013l3.349 3.367a9.887 9.887 0 0 1 -7.05 2.912z"
  }));
}
var GE = ["size", "color", "stroke"];
function JE(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, GE);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-brand-comedy-central",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M5.343 17.657a8 8 0 1 0 0 -11.314"
  }), e.createElement("path", {
    d: "M13.828 9.172a4 4 0 1 0 0 5.656"
  }));
}
var KE = ["size", "color", "stroke"];
function QE(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, KE);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-brand-coreos",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M21 12a9 9 0 1 1 -18 0a9 9 0 0 1 18 0z"
  }), e.createElement("path", {
    d: "M12 3c-3.263 3.212 -2.994 7.654 -3 12c4.59 .244 8.814 -.282 12 -3"
  }), e.createElement("path", {
    d: "M9.5 9a4.494 4.494 0 0 1 5.5 5.5"
  }));
}
var RE = ["size", "color", "stroke"];
function TE(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, RE);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-brand-couchdb",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M6 12h12v-2a2 2 0 0 1 2 -2a2 2 0 0 0 -2 -2h-12a2 2 0 0 0 -2 2a2 2 0 0 1 2 2v2z"
  }), e.createElement("path", {
    d: "M6 15h12"
  }), e.createElement("path", {
    d: "M6 18h12"
  }), e.createElement("path", {
    d: "M21 11v7"
  }), e.createElement("path", {
    d: "M3 11v7"
  }));
}
var UE = ["size", "color", "stroke"];
function VE(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, UE);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-brand-couchsurfing",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M3.1 13c3.267 0 5.9 -.167 7.9 -.5c3 -.5 4 -2 4 -3.5a3 3 0 1 0 -6 0c0 1.554 1.807 3.005 3 4c1.193 .995 2 2.5 2 3.5a1.5 1.5 0 1 1 -3 0c0 -2 4 -3.5 7 -3.5h2.9"
  }), e.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 9
  }));
}
var XE = ["size", "color", "stroke"];
function YE(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, XE);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-brand-cpp",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M18 12h4"
  }), e.createElement("path", {
    d: "M20 10v4"
  }), e.createElement("path", {
    d: "M11 12h4"
  }), e.createElement("path", {
    d: "M13 10v4"
  }), e.createElement("path", {
    d: "M9 9a3 3 0 0 0 -3 -3h-.5a3.5 3.5 0 0 0 -3.5 3.5v5a3.5 3.5 0 0 0 3.5 3.5h.5a3 3 0 0 0 3 -3"
  }));
}
var ZE = ["size", "color", "stroke"];
function $E(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, ZE);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-brand-css3",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M20 4l-2 14.5l-6 2l-6 -2l-2 -14.5z"
  }), e.createElement("path", {
    d: "M8.5 8h7l-4.5 4h4l-.5 3.5l-2.5 .75l-2.5 -.75l-.1 -.5"
  }));
}
var _E = ["size", "color", "stroke"];
function eu(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, _E);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-brand-ctemplar",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M6.04 14.831l4.46 -4.331"
  }), e.createElement("path", {
    d: "M12.555 20.82c4.55 -3.456 7.582 -8.639 8.426 -14.405a1.668 1.668 0 0 0 -.934 -1.767a19.647 19.647 0 0 0 -8.047 -1.648a19.647 19.647 0 0 0 -8.047 1.647a1.668 1.668 0 0 0 -.934 1.767c.844 5.766 3.875 10.95 8.426 14.406a0.948 .948 0 0 0 1.11 0z"
  }), e.createElement("path", {
    d: "M20 5c-2 0 -4.37 3.304 -8 6.644c-3.63 -3.34 -6 -6.644 -8 -6.644"
  }), e.createElement("path", {
    d: "M17.738 15l-4.238 -4.5"
  }));
}
var tu = ["size", "color", "stroke"];
function ou(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, tu);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-brand-cucumber",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M20 10.99c-.01 5.52 -4.48 10 -10 10.01v-2.26l-.01 -.01c-4.28 -1.11 -6.86 -5.47 -5.76 -9.75a8.001 8.001 0 0 1 9.74 -5.76c3.53 .91 6.03 4.13 6.03 7.78v-.01z"
  }), e.createElement("path", {
    d: "M10.5 8l-.5 -1"
  }), e.createElement("path", {
    d: "M13.5 14l.5 1"
  }), e.createElement("path", {
    d: "M9 12.5l-1 .5"
  }), e.createElement("path", {
    d: "M11 14l-.5 1"
  }), e.createElement("path", {
    d: "M13 8l.5 -1"
  }), e.createElement("path", {
    d: "M16 12.5l-1 -.5"
  }), e.createElement("path", {
    d: "M9 10l-1 -.5"
  }));
}
var ru = ["size", "color", "stroke"];
function nu(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, ru);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-brand-cupra",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M4.5 10l-2.5 -4l15.298 6.909a0.2 .2 0 0 1 .09 .283l-3.388 5.808"
  }), e.createElement("path", {
    d: "M10 19l-3.388 -5.808a0.2 .2 0 0 1 .09 -.283l15.298 -6.909l-2.5 4"
  }));
}
var lu = ["size", "color", "stroke"];
function au(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, lu);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-brand-cypress",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M19.48 17.007a9 9 0 1 0 -7.48 3.993c.896 0 1.691 -.573 1.974 -1.423l3.526 -10.577"
  }), e.createElement("path", {
    d: "M13.5 9l2 6"
  }), e.createElement("path", {
    d: "M10.764 9.411a3 3 0 1 0 -.023 5.19"
  }));
}
var iu = ["size", "color", "stroke"];
function cu(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, iu);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-brand-d3",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M3 4h1.8c3.976 0 7.2 3.582 7.2 8s-3.224 8 -7.2 8h-1.8"
  }), e.createElement("path", {
    d: "M12 4h5.472c1.948 0 3.528 1.79 3.528 4s-1.58 4 -3.528 4"
  }), e.createElement("path", {
    d: "M17.472 12h-2.472"
  }), e.createElement("path", {
    d: "M17.472 12h-2.352"
  }), e.createElement("path", {
    d: "M17.472 12c1.948 0 3.528 1.79 3.528 4s-1.58 4 -3.528 4h-5.472"
  }));
}
var su = ["size", "color", "stroke"];
function hu(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, su);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-brand-days-counter",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M20.779 10.007a9 9 0 1 0 -10.77 10.772"
  }), e.createElement("path", {
    d: "M13 21h8v-7"
  }), e.createElement("path", {
    d: "M12 8v4l3 3"
  }));
}
var du = ["size", "color", "stroke"];
function vu(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, du);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-brand-dcos",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M3 18l18 -12h-18l9 14l9 -14v10l-18 -10z"
  }));
}
var mu = ["size", "color", "stroke"];
function ku(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, mu);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-brand-debian",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M12 17c-2.397 -.943 -4 -3.153 -4 -5.635c0 -2.19 1.039 -3.14 1.604 -3.595c2.646 -2.133 6.396 -.27 6.396 3.23c0 2.5 -2.905 2.121 -3.5 1.5c-.595 -.621 -1 -1.5 -.5 -2.5"
  }), e.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 9
  }));
}
var wu = ["size", "color", "stroke"];
function pu(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, wu);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-brand-deliveroo",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M15 11l1 -9l5 .5l-1 13.5l-3 6l-12.5 -2.5l-1.5 -6l7 -1.5l-1.5 -7.5l4.5 -1z"
  }), e.createElement("circle", {
    cx: 15.5,
    cy: 15.5,
    r: 1,
    fill: "currentColor"
  }), e.createElement("circle", {
    cx: 11.5,
    cy: 14.5,
    r: 1,
    fill: "currentColor"
  }));
}
var Eu = ["size", "color", "stroke"];
function uu(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Eu);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-brand-deno",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 9
  }), e.createElement("path", {
    d: "M13.47 20.882l-1.47 -5.882c-2.649 -.088 -5 -1.624 -5 -3.5c0 -1.933 2.239 -3.5 5 -3.5s4 1 5 3c.024 .048 .69 2.215 2 6.5"
  }), e.createElement("path", {
    d: "M12 11h.01"
  }));
}
var gu = ["size", "color", "stroke"];
function Mu(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, gu);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-brand-denodo",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M11 11h2v2h-2z"
  }), e.createElement("path", {
    d: "M3.634 15.634l1.732 -1l1 1.732l-1.732 1z"
  }), e.createElement("path", {
    d: "M11 19h2v2h-2z"
  }), e.createElement("path", {
    d: "M18.634 14.634l1.732 1l-1 1.732l-1.732 -1z"
  }), e.createElement("path", {
    d: "M17.634 7.634l1.732 -1l1 1.732l-1.732 1z"
  }), e.createElement("path", {
    d: "M11 3h2v2h-2z"
  }), e.createElement("path", {
    d: "M3.634 8.366l1 -1.732l1.732 1l-1 1.732z"
  }));
}
var xu = ["size", "color", "stroke"];
function fu(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, xu);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-brand-deviantart",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M18 3v4l-3.857 6h3.857v4h-6.429l-2.571 4h-3v-4l3.857 -6h-3.857v-4h6.429l2.571 -4z"
  }));
}
var zu = ["size", "color", "stroke"];
function bu(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, zu);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-brand-dingtalk",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M21 12a9 9 0 1 1 -18 0a9 9 0 0 1 18 0z"
  }), e.createElement("path", {
    d: "M8 7.5l7.02 2.632a1 1 0 0 1 .567 1.33l-1.087 2.538h1.5l-5 4l1 -4c-3.1 .03 -3.114 -3.139 -4 -6.5z"
  }));
}
var Lu = ["size", "color", "stroke"];
function yu(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Lu);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-brand-discord",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("circle", {
    cx: 9,
    cy: 12,
    r: 1
  }), e.createElement("circle", {
    cx: 15,
    cy: 12,
    r: 1
  }), e.createElement("path", {
    d: "M7.5 7.5c3.5 -1 5.5 -1 9 0"
  }), e.createElement("path", {
    d: "M7 16.5c3.5 1 6.5 1 10 0"
  }), e.createElement("path", {
    d: "M15.5 17c0 1 1.5 3 2 3c1.5 0 2.833 -1.667 3.5 -3c.667 -1.667 .5 -5.833 -1.5 -11.5c-1.457 -1.015 -3 -1.34 -4.5 -1.5l-1 2.5"
  }), e.createElement("path", {
    d: "M8.5 17c0 1 -1.356 3 -1.832 3c-1.429 0 -2.698 -1.667 -3.333 -3c-.635 -1.667 -.476 -5.833 1.428 -11.5c1.388 -1.015 2.782 -1.34 4.237 -1.5l1 2.5"
  }));
}
var Cu = ["size", "color", "stroke"];
function ju(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Cu);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-brand-disney",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M3.22 5.838c-1.307 -.15 -1.22 -.578 -1.22 -.794c0 -.216 .424 -1.044 4.34 -1.044c4.694 0 14.66 3.645 14.66 10.042s-8.71 4.931 -10.435 4.52c-1.724 -.412 -5.565 -2.256 -5.565 -4.174c0 -1.395 3.08 -2.388 6.715 -2.388c3.634 0 5.285 1.041 5.285 2c0 .5 -.074 1.229 -1 1.5"
  }), e.createElement("path", {
    d: "M10.02 8a505.153 505.153 0 0 0 0 13"
  }));
}
var Bu = ["size", "color", "stroke"];
function Hu(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Bu);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-brand-disqus",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M11.847 21c-2.259 0 -4.323 -.667 -5.919 -2h-3.928l1.708 -3.266c-.545 -1.174 -.759 -2.446 -.758 -3.734c0 -4.97 3.84 -9 8.898 -9c5.052 0 9.152 4.03 9.152 9c0 4.972 -4.098 9 -9.153 9z"
  }), e.createElement("path", {
    d: "M11.485 15h-1.485v-6h1.485c2.112 0 3.515 .823 3.515 2.981v.035c0 2.18 -1.403 2.984 -3.515 2.984z"
  }));
}
var Nu = ["size", "color", "stroke"];
function Wu(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Nu);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-brand-django",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("rect", {
    x: 3,
    y: 3,
    width: 18,
    height: 18,
    rx: 3
  }), e.createElement("path", {
    d: "M12 7v8.5l-2.015 .201a2.715 2.715 0 1 1 0 -5.402l2.015 .201"
  }), e.createElement("path", {
    d: "M16 7v.01"
  }), e.createElement("path", {
    d: "M16 10v5.586c0 .905 -.36 1.774 -1 2.414"
  }));
}
var qu = ["size", "color", "stroke"];
function Ou(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, qu);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-brand-docker",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M22 12.54c-1.804 -.345 -2.701 -1.08 -3.523 -2.94c-.487 .696 -1.102 1.568 -.92 2.4c.028 .238 -.32 1.002 -.557 1h-14c0 5.208 3.164 7 6.196 7c4.124 .022 7.828 -1.376 9.854 -5c1.146 -.101 2.296 -1.505 2.95 -2.46z"
  }), e.createElement("path", {
    d: "M5 10h3v3h-3z"
  }), e.createElement("path", {
    d: "M8 10h3v3h-3z"
  }), e.createElement("path", {
    d: "M11 10h3v3h-3z"
  }), e.createElement("path", {
    d: "M8 7h3v3h-3z"
  }), e.createElement("path", {
    d: "M11 7h3v3h-3z"
  }), e.createElement("path", {
    d: "M11 4h3v3h-3z"
  }), e.createElement("path", {
    d: "M4.571 18c1.5 0 2.047 -.074 2.958 -.78"
  }), e.createElement("line", {
    x1: 10,
    y1: 16,
    x2: 10,
    y2: 16.01
  }));
}
var Pu = ["size", "color", "stroke"];
function Su(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Pu);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-brand-doctrine",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("circle", {
    cx: 12,
    cy: 14,
    r: 7
  }), e.createElement("path", {
    d: "M9 14h6"
  }), e.createElement("path", {
    d: "M12 11l3 3l-3 3"
  }), e.createElement("path", {
    d: "M10 3l6.9 6"
  }));
}
var Iu = ["size", "color", "stroke"];
function Au(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Iu);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-brand-dolby-digital",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M21 6v12h-.89c-3.34 0 -6.047 -2.686 -6.047 -6s2.707 -6 6.046 -6h.891z"
  }), e.createElement("path", {
    d: "M3.063 6v12h.891c3.34 0 6.046 -2.686 6.046 -6s-2.707 -6 -6.046 -6h-.89z"
  }));
}
var Du = ["size", "color", "stroke"];
function Fu(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Du);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-brand-douban",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M4 20h16"
  }), e.createElement("path", {
    d: "M5 4h14"
  }), e.createElement("path", {
    d: "M8 8h8a2 2 0 0 1 2 2v2a2 2 0 0 1 -2 2h-8a2 2 0 0 1 -2 -2v-2a2 2 0 0 1 2 -2z"
  }), e.createElement("path", {
    d: "M16 14l-2 6"
  }), e.createElement("path", {
    d: "M8 17l1 3"
  }));
}
var Gu = ["size", "color", "stroke"];
function Ju(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Gu);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-brand-dribbble",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 9
  }), e.createElement("path", {
    d: "M9 3.6c5 6 7 10.5 7.5 16.2"
  }), e.createElement("path", {
    d: "M6.4 19c3.5 -3.5 6 -6.5 14.5 -6.4"
  }), e.createElement("path", {
    d: "M3.1 10.75c5 0 9.814 -.38 15.314 -5"
  }));
}
var Ku = ["size", "color", "stroke"];
function Qu(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Ku);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-brand-drops",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M17.637 7.416a7.907 7.907 0 0 1 1.76 8.666a8 8 0 0 1 -7.397 4.918a8 8 0 0 1 -7.396 -4.918a7.907 7.907 0 0 1 1.759 -8.666l5.637 -5.416l5.637 5.416z"
  }), e.createElement("path", {
    d: "M14.466 10.923a3.595 3.595 0 0 1 .77 3.877a3.5 3.5 0 0 1 -3.236 2.2a3.5 3.5 0 0 1 -3.236 -2.2a3.595 3.595 0 0 1 .77 -3.877l2.466 -2.423l2.466 2.423z"
  }));
}
var Ru = ["size", "color", "stroke"];
function Tu(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Ru);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-brand-drupal",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M12 2c0 4.308 -7 6 -7 12.005a7 7 0 0 0 14 0c0 -6.005 -7 -7.697 -7 -12.005z"
  }), e.createElement("path", {
    d: "M12 11.33a65.753 65.753 0 0 1 -2.012 2.023c-.996 .957 -1.988 1.967 -1.988 3.647c0 2.17 1.79 3.997 4 3.997s4 -1.827 4 -3.997c0 -1.676 -.989 -2.685 -1.983 -3.642c-.42 -.404 -2.259 -2.357 -5.517 -5.858l3.5 3.83z"
  }));
}
var Uu = ["size", "color", "stroke"];
function Vu(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Uu);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-brand-edge",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M20.978 11.372a9 9 0 1 0 -1.593 5.773"
  }), e.createElement("path", {
    d: "M20.978 11.372c.21 2.993 -5.034 2.413 -6.913 1.486c1.392 -1.6 .402 -4.038 -2.274 -3.851c-1.745 .122 -2.927 1.157 -2.784 3.202c.28 3.99 4.444 6.205 10.36 4.79"
  }), e.createElement("path", {
    d: "M3.022 12.628c-.283 -4.043 8.717 -7.228 11.248 -2.688"
  }), e.createElement("path", {
    d: "M12.628 20.978c-2.993 .21 -5.162 -4.725 -3.567 -9.748"
  }));
}
var Xu = ["size", "color", "stroke"];
function Yu(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Xu);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-brand-elastic",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M14 2a5 5 0 0 1 5 5c0 .712 -.232 1.387 -.5 2c1.894 .042 3.5 1.595 3.5 3.5c0 1.869 -1.656 3.4 -3.5 3.5c.333 .625 .5 1.125 .5 1.5a2.5 2.5 0 0 1 -2.5 2.5c-.787 0 -1.542 -.432 -2 -1c-.786 1.73 -2.476 3 -4.5 3a5 5 0 0 1 -4.583 -7.003a3.5 3.5 0 0 1 -.11 -6.992l.195 -.005a2.5 2.5 0 0 1 1.998 -4c.787 0 1.542 .432 2 1c.786 -1.73 2.476 -3 4.5 -3z"
  }), e.createElement("path", {
    d: "M8.5 9l-2.999 -1"
  }), e.createElement("path", {
    d: "M9.5 5l-1 4l1 2l5 2l4 -4"
  }), e.createElement("path", {
    d: "M18.499 16l-2.999 -.5l-1 -2.5"
  }), e.createElement("path", {
    d: "M14.5 19l1 -3.5"
  }), e.createElement("path", {
    d: "M5.417 14.997l4.083 -3.997"
  }));
}
var Zu = ["size", "color", "stroke"];
function $u(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Zu);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-brand-ember",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M3 12.958c8.466 1.647 11.112 -1.196 12.17 -2.294c2.116 -2.196 0 -6.589 -2.646 -5.49c-2.644 1.096 -6.35 7.686 -3.174 12.078c2.116 2.928 6 2.178 11.65 -2.252"
  }));
}
var _u = ["size", "color", "stroke"];
function eg(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, _u);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-brand-envato",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M4.711 17.875c-.534 -1.339 -1.35 -4.178 .129 -6.47c1.415 -2.193 3.769 -3.608 5.099 -4.278l-5.229 10.748z"
  }), e.createElement("path", {
    d: "M19.715 12.508c-.54 3.409 -2.094 6.156 -4.155 7.348c-4.069 2.353 -8.144 .45 -9.297 -.188c.877 -1.436 4.433 -7.22 6.882 -10.591c2.714 -3.737 5.864 -5.978 6.565 -6.077c.001 .201 .03 .55 .071 1.03c.144 1.709 .443 5.264 -.066 8.478z"
  }));
}
var tg = ["size", "color", "stroke"];
function og(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, tg);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-brand-etsy",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M14 12h-5"
  }), e.createElement("rect", {
    x: 3,
    y: 3,
    width: 18,
    height: 18,
    rx: 5
  }), e.createElement("path", {
    d: "M15 16h-5a1 1 0 0 1 -1 -1v-6a1 1 0 0 1 1 -1h5"
  }));
}
var rg = ["size", "color", "stroke"];
function ng(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, rg);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-brand-evernote",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M4 8h5v-5"
  }), e.createElement("path", {
    d: "M17.9 19c.6 -2.5 1.1 -5.471 1.1 -9c0 -4.5 -2 -5 -3 -5c-1.906 0 -3 -.5 -3.5 -1c-.354 -.354 -.5 -1 -1.5 -1h-2l-5 5c0 6 2.5 8 5 8c1 0 1.5 -.5 2 -1.5s1.414 -.326 2.5 0c1.044 .313 2.01 .255 2.5 .5c1 .5 2 1.5 2 3c0 .5 0 3 -3 3s-3 -3 -1 -3"
  }), e.createElement("path", {
    d: "M15 10h1"
  }));
}
var lg = ["size", "color", "stroke"];
function ag(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, lg);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-brand-facebook",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M7 10v4h3v7h4v-7h3l1 -4h-4v-2a1 1 0 0 1 1 -1h3v-4h-3a5 5 0 0 0 -5 5v2h-3"
  }));
}
var ig = ["size", "color", "stroke"];
function cg(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, ig);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-brand-figma",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("circle", {
    cx: 15,
    cy: 12,
    r: 3
  }), e.createElement("rect", {
    x: 6,
    y: 3,
    width: 12,
    height: 6,
    rx: 3
  }), e.createElement("path", {
    d: "M9 9a3 3 0 0 0 0 6h3m-3 0a3 3 0 1 0 3 3v-15"
  }));
}
var sg = ["size", "color", "stroke"];
function hg(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, sg);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-brand-finder",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("rect", {
    x: 3,
    y: 4,
    width: 18,
    height: 16,
    rx: 1
  }), e.createElement("path", {
    d: "M7 8v1"
  }), e.createElement("path", {
    d: "M17 8v1"
  }), e.createElement("path", {
    d: "M12.5 4c-.654 1.486 -1.26 3.443 -1.5 9h2.5c-.19 2.867 .094 5.024 .5 7"
  }), e.createElement("path", {
    d: "M7 15.5c3.667 2 6.333 2 10 0"
  }));
}
var dg = ["size", "color", "stroke"];
function vg(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, dg);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-brand-firebase",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M4.53 17.05l6.15 -11.72h-.02c.38 -.74 1.28 -1.02 2.01 -.63c.26 .14 .48 .36 .62 .62l1.06 2.01"
  }), e.createElement("path", {
    d: "M15.47 6.45c.58 -.59 1.53 -.59 2.11 -.01c.22 .22 .36 .5 .41 .81l1.5 9.11c.1 .62 -.2 1.24 -.76 1.54l-6.07 2.9c-.46 .25 -1.01 .26 -1.46 0l-6.02 -2.92c-.55 -.31 -.85 -.92 -.75 -1.54l1.96 -12.04c.12 -.82 .89 -1.38 1.7 -1.25c.46 .07 .87 .36 1.09 .77l1.24 1.76"
  }), e.createElement("path", {
    d: "M4.57 17.18l10.93 -10.68"
  }));
}
var mg = ["size", "color", "stroke"];
function kg(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, mg);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-brand-firefox",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M4.028 7.82a9 9 0 1 0 12.823 -3.4c-1.636 -1.02 -3.064 -1.02 -4.851 -1.02h-1.647"
  }), e.createElement("path", {
    d: "M4.914 9.485c-1.756 -1.569 -.805 -5.38 .109 -6.17c.086 .896 .585 1.208 1.111 1.685c.88 -.275 1.313 -.282 1.867 0c.82 -.91 1.694 -2.354 2.628 -2.093c-1.082 1.741 -.07 3.733 1.371 4.173c-.17 .975 -1.484 1.913 -2.76 2.686c-1.296 .938 -.722 1.85 0 2.234c.949 .506 3.611 -.995 4.545 .354c-1.698 .102 -1.536 3.107 -3.983 2.727c2.523 .957 4.345 .462 5.458 -.34c1.965 -1.52 2.879 -3.542 2.879 -5.557c-.014 -1.398 .194 -2.695 -1.26 -4.75"
  }));
}
var wg = ["size", "color", "stroke"];
function pg(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, wg);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-brand-flickr",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("circle", {
    cx: 7,
    cy: 12,
    r: 3
  }), e.createElement("circle", {
    cx: 17,
    cy: 12,
    r: 3
  }));
}
var Eg = ["size", "color", "stroke"];
function ug(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Eg);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-brand-flightradar24",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 9
  }), e.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 5
  }), e.createElement("path", {
    d: "M8.5 20l3.5 -8l-6.5 6"
  }), e.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 1
  }));
}
var gg = ["size", "color", "stroke"];
function Mg(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, gg);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-brand-flipboard",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M3.973 3h16.054c.537 0 .973 .436 .973 .973v4.052a0.973 .973 0 0 1 -.973 .973h-5.025v4.831c0 .648 -.525 1.173 -1.173 1.173h-4.829v5.025a0.973 .973 0 0 1 -.974 .973h-4.053a0.973 .973 0 0 1 -.973 -.973v-16.054c0 -.537 .436 -.973 .973 -.973z"
  }));
}
var xg = ["size", "color", "stroke"];
function fg(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, xg);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-brand-flutter",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M7 14l-3 -3l8 -8h6z"
  }), e.createElement("path", {
    d: "M14 21l-5 -5l5 -5h5l-5 5l5 5z"
  }));
}
var zg = ["size", "color", "stroke"];
function bg(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, zg);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-brand-fortnite",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M8 3h7.5l-.5 4h-3v3h3v3.5h-3v6.5l-4 1z"
  }));
}
var Lg = ["size", "color", "stroke"];
function yg(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Lg);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-brand-foursquare",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M7 3h10c.644 0 1.11 .696 .978 1.33l-1.984 9.859a1.014 1.014 0 0 1 -.994 .811h-2.254c-.308 0 -.6 .141 -.793 .382l-4.144 5.25c-.599 .752 -1.809 .331 -1.809 -.632v-16c0 -.564 .44 -1 1 -1z"
  }), e.createElement("line", {
    x1: 12,
    y1: 9,
    x2: 17,
    y2: 9
  }));
}
var Cg = ["size", "color", "stroke"];
function jg(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Cg);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-brand-framer",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M6 15h12l-12 -12h12v6h-12v6l6 6v-6"
  }));
}
var Bg = ["size", "color", "stroke"];
function Hg(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Bg);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-brand-funimation",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 9
  }), e.createElement("path", {
    d: "M8 13h8a4 4 0 1 1 -8 0z"
  }));
}
var Ng = ["size", "color", "stroke"];
function Wg(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Ng);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-brand-gatsby",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M3.296 14.297l6.407 6.407a9.018 9.018 0 0 1 -6.325 -6.116l-.082 -.291z"
  }), e.createElement("path", {
    d: "M16 13h5c-.41 3.603 -3.007 6.59 -6.386 7.614l-11.228 -11.229a9.004 9.004 0 0 1 15.66 -2.985"
  }));
}
var qg = ["size", "color", "stroke"];
function Og(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, qg);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-brand-git",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("circle", {
    cx: 16,
    cy: 12,
    r: 1
  }), e.createElement("circle", {
    cx: 12,
    cy: 8,
    r: 1
  }), e.createElement("circle", {
    cx: 12,
    cy: 16,
    r: 1
  }), e.createElement("path", {
    d: "M12 15v-6"
  }), e.createElement("path", {
    d: "M15 11l-2 -2"
  }), e.createElement("path", {
    d: "M11 7l-1.9 -1.9"
  }), e.createElement("path", {
    d: "M10.5 20.4l-6.9 -6.9c-.781 -.781 -.781 -2.219 0 -3l6.9 -6.9c.781 -.781 2.219 -.781 3 0l6.9 6.9c.781 .781 .781 2.219 0 3l-6.9 6.9c-.781 .781 -2.219 .781 -3 0z"
  }));
}
var Pg = ["size", "color", "stroke"];
function Sg(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Pg);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-brand-github-copilot",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M4 18v-5.5c0 -.667 .167 -1.333 .5 -2"
  }), e.createElement("path", {
    d: "M12 7.5c0 -1 -.01 -4.07 -4 -3.5c-3.5 .5 -4 2.5 -4 3.5c0 1.5 .002 4 3 4c4 0 5 -2.5 5 -4z"
  }), e.createElement("path", {
    d: "M4 12c-1.333 .667 -2 1.333 -2 2c0 1 0 3 1.5 4c3.001 2 6.5 3 8.5 3s5.499 -1 8.5 -3c1.5 -1 1.5 -3 1.5 -4c0 -.667 -.667 -1.333 -2 -2"
  }), e.createElement("path", {
    d: "M20 18v-5.5c0 -.667 -.167 -1.333 -.5 -2"
  }), e.createElement("path", {
    d: "M12 7.5l.003 -.297l.01 -.269l.027 -.298l.013 -.105l.033 -.215c.014 -.073 .029 -.146 .046 -.22l.06 -.223c.336 -1.118 1.262 -2.237 3.808 -1.873c2.838 .405 3.703 1.797 3.93 2.842l.036 .204c.005 .033 .01 .066 .013 .098l.016 .185l.005 .171l-.003 .49l-.015 .394l-.02 .271c-.122 1.366 -.655 2.845 -2.962 2.845c-3.256 0 -4.524 -1.656 -4.883 -3.081l-.053 -.242a3.865 3.865 0 0 1 -.036 -.235l-.021 -.227a3.518 3.518 0 0 1 -.007 -.215z"
  }), e.createElement("path", {
    d: "M10 15v2"
  }), e.createElement("path", {
    d: "M14 15v2"
  }));
}
var Ig = ["size", "color", "stroke"];
function Ag(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Ig);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-brand-github",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M9 19c-4.3 1.4 -4.3 -2.5 -6 -3m12 5v-3.5c0 -1 .1 -1.4 -.5 -2c2.8 -.3 5.5 -1.4 5.5 -6a4.6 4.6 0 0 0 -1.3 -3.2a4.2 4.2 0 0 0 -.1 -3.2s-1.1 -.3 -3.5 1.3a12.3 12.3 0 0 0 -6.2 0c-2.4 -1.6 -3.5 -1.3 -3.5 -1.3a4.2 4.2 0 0 0 -.1 3.2a4.6 4.6 0 0 0 -1.3 3.2c0 4.6 2.7 5.7 5.5 6c-.6 .6 -.6 1.2 -.5 2v3.5"
  }));
}
var Dg = ["size", "color", "stroke"];
function Fg(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Dg);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-brand-gitlab",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M21 14l-9 7l-9 -7l3 -11l3 7h6l3 -7z"
  }));
}
var Gg = ["size", "color", "stroke"];
function Jg(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Gg);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-brand-gmail",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M16 20h3a1 1 0 0 0 1 -1v-14a1 1 0 0 0 -1 -1h-3v16z"
  }), e.createElement("path", {
    d: "M5 20h3v-16h-3a1 1 0 0 0 -1 1v14a1 1 0 0 0 1 1z"
  }), e.createElement("path", {
    d: "M16 4l-4 4l-4 -4"
  }), e.createElement("path", {
    d: "M4 6.5l8 7.5l8 -7.5"
  }));
}
var Kg = ["size", "color", "stroke"];
function Qg(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Kg);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-brand-google-analytics",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("rect", {
    x: 10,
    y: 9,
    width: 4,
    height: 12,
    rx: 1.105
  }), e.createElement("rect", {
    x: 17,
    y: 3,
    width: 4,
    height: 18,
    rx: 1.105
  }), e.createElement("circle", {
    cx: 5,
    cy: 19,
    r: 2
  }));
}
var Rg = ["size", "color", "stroke"];
function Tg(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Rg);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-brand-google-big-query",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M17.73 19.875a2.225 2.225 0 0 1 -1.948 1.125h-7.283a2.222 2.222 0 0 1 -1.947 -1.158l-4.272 -6.75a2.269 2.269 0 0 1 0 -2.184l4.272 -6.75a2.225 2.225 0 0 1 1.946 -1.158h7.285c.809 0 1.554 .443 1.947 1.158l3.98 6.75a2.33 2.33 0 0 1 0 2.25l-3.98 6.75v-.033z"
  }), e.createElement("circle", {
    cx: 11.5,
    cy: 11.5,
    r: 3.5
  }), e.createElement("path", {
    d: "M14 14l2 2"
  }));
}
var Ug = ["size", "color", "stroke"];
function Vg(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Ug);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-brand-google-drive",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M12 10l-6 10l-3 -5l6 -10z"
  }), e.createElement("path", {
    d: "M9 15h12l-3 5h-12"
  }), e.createElement("path", {
    d: "M15 15l-6 -10h6l6 10z"
  }));
}
var Xg = ["size", "color", "stroke"];
function Yg(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Xg);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-brand-google-fit",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M12 9.314l-2.343 -2.344a3.314 3.314 0 0 0 -4.686 4.686l2.343 2.344l4.686 4.686l7.03 -7.03a3.314 3.314 0 0 0 -4.687 -4.685l-7.03 7.029"
  }));
}
var Zg = ["size", "color", "stroke"];
function $g(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Zg);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-brand-google-home",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M19.072 20.998h-14.144a1.928 1.928 0 0 1 -1.928 -1.928v-6.857c0 -.512 .203 -1.003 .566 -1.365l7.07 -7.063a1.928 1.928 0 0 1 2.727 0l7.071 7.063c.363 .362 .566 .853 .566 1.365v6.857a1.928 1.928 0 0 1 -1.928 1.928z"
  }), e.createElement("path", {
    d: "M7 13v4h10v-4l-5 -5"
  }), e.createElement("path", {
    d: "M14.8 5.2l-11.8 11.8"
  }), e.createElement("path", {
    d: "M7 17v4"
  }), e.createElement("path", {
    d: "M17 17v4"
  }));
}
var _g = ["size", "color", "stroke"];
function eM(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, _g);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-brand-google-one",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M11 4.998v13.982a1.998 1.998 0 0 0 3.995 0v-13.982a1.998 1.998 0 1 0 -3.995 0z"
  }), e.createElement("path", {
    d: "M6.63 8.407a2.125 2.125 0 0 0 -.074 2.944c.77 .834 2.051 .869 2.862 .077l4.95 -4.834c.812 -.792 .846 -2.11 .076 -2.945a1.984 1.984 0 0 0 -2.861 -.077l-4.953 4.835z"
  }));
}
var tM = ["size", "color", "stroke"];
function oM(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, tM);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-brand-google-photos",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M7.5 7c2.485 0 4.5 1.974 4.5 4.409v.591h-8.397a0.61 .61 0 0 1 -.426 -.173a0.585 .585 0 0 1 -.177 -.418c0 -2.435 2.015 -4.409 4.5 -4.409z"
  }), e.createElement("path", {
    d: "M16.5 17c-2.485 0 -4.5 -1.974 -4.5 -4.409v-.591h8.397c.333 0 .603 .265 .603 .591c0 2.435 -2.015 4.409 -4.5 4.409z"
  }), e.createElement("path", {
    d: "M7 16.5c0 -2.485 1.972 -4.5 4.405 -4.5h.595v8.392a0.61 .61 0 0 1 -.173 .431a0.584 .584 0 0 1 -.422 .177c-2.433 0 -4.405 -2.015 -4.405 -4.5z"
  }), e.createElement("path", {
    d: "M17 7.5c0 2.485 -1.972 4.5 -4.405 4.5h-.595v-8.397a0.61 .61 0 0 1 .175 -.428a0.584 .584 0 0 1 .42 -.175c2.433 0 4.405 2.015 4.405 4.5z"
  }));
}
var rM = ["size", "color", "stroke"];
function nM(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, rM);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-brand-google-play",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M4 3.71v16.58a0.7 .7 0 0 0 1.05 .606l14.622 -8.42a0.55 .55 0 0 0 0 -.953l-14.622 -8.419a0.7 .7 0 0 0 -1.05 .607z"
  }), e.createElement("line", {
    x1: 15,
    y1: 9,
    x2: 4.5,
    y2: 20.5
  }), e.createElement("line", {
    x1: 4.5,
    y1: 3.5,
    x2: 15,
    y2: 15
  }));
}
var lM = ["size", "color", "stroke"];
function aM(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, lM);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-brand-google-podcasts",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M12 3v2"
  }), e.createElement("path", {
    d: "M12 19v2"
  }), e.createElement("path", {
    d: "M12 8v8"
  }), e.createElement("path", {
    d: "M8 17v2"
  }), e.createElement("path", {
    d: "M4 11v2"
  }), e.createElement("path", {
    d: "M20 11v2"
  }), e.createElement("path", {
    d: "M8 5v8"
  }), e.createElement("path", {
    d: "M16 7v-2"
  }), e.createElement("path", {
    d: "M16 19v-8"
  }));
}
var iM = ["size", "color", "stroke"];
function cM(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, iM);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-brand-google",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M17.788 5.108a9 9 0 1 0 3.212 6.892h-8"
  }));
}
var sM = ["size", "color", "stroke"];
function hM(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, sM);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-brand-grammarly",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 9
  }), e.createElement("path", {
    d: "M15.697 9.434a4.5 4.5 0 1 0 .217 4.788"
  }), e.createElement("path", {
    d: "M13.5 14h2.5v2.5"
  }));
}
var dM = ["size", "color", "stroke"];
function vM(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, dM);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-brand-graphql",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M5.308 7.265l5.385 -3.029"
  }), e.createElement("path", {
    d: "M13.308 4.235l5.384 3.03"
  }), e.createElement("path", {
    d: "M20 9.5v5"
  }), e.createElement("path", {
    d: "M18.693 16.736l-5.385 3.029"
  }), e.createElement("path", {
    d: "M10.692 19.765l-5.384 -3.03"
  }), e.createElement("path", {
    d: "M4 14.5v-5"
  }), e.createElement("path", {
    d: "M12.772 4.786l6.121 10.202"
  }), e.createElement("path", {
    d: "M18.5 16h-13"
  }), e.createElement("path", {
    d: "M5.107 14.988l6.122 -10.201"
  }), e.createElement("circle", {
    cx: 12,
    cy: 3.5,
    r: 1.5
  }), e.createElement("circle", {
    cx: 12,
    cy: 20.5,
    r: 1.5
  }), e.createElement("circle", {
    cx: 4,
    cy: 8,
    r: 1.5
  }), e.createElement("circle", {
    cx: 4,
    cy: 16,
    r: 1.5
  }), e.createElement("circle", {
    cx: 20,
    cy: 16,
    r: 1.5
  }), e.createElement("circle", {
    cx: 20,
    cy: 8,
    r: 1.5
  }));
}
var mM = ["size", "color", "stroke"];
function kM(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, mM);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-brand-gravatar",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M5.64 5.632a9 9 0 1 0 6.36 -2.632v7.714"
  }));
}
var wM = ["size", "color", "stroke"];
function pM(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, wM);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-brand-grindr",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M13 13.282c0 .492 .784 1.718 2.102 1.718c1.318 0 2.898 -.966 2.898 -2.062c0 -.817 -.932 -.938 -1.409 -.938c-.228 0 -3.591 .111 -3.591 1.282z"
  }), e.createElement("path", {
    d: "M12 21c-2.984 0 -6.471 -2.721 -6.63 -2.982c-2.13 -3.49 -2.37 -13.703 -2.37 -13.703l1.446 -1.315c2.499 .39 5.023 .617 7.554 .68a58.626 58.626 0 0 0 7.554 -.68l1.446 1.315s-.24 10.213 -2.37 13.704c-.16 .26 -3.646 2.981 -6.63 2.981z"
  }), e.createElement("path", {
    d: "M11 13.282c0 .492 -.784 1.718 -2.102 1.718c-1.318 0 -2.898 -.966 -2.898 -2.062c0 -.817 .932 -.938 1.409 -.938c.228 0 3.591 .111 3.591 1.282z"
  }));
}
var EM = ["size", "color", "stroke"];
function uM(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, EM);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-brand-guardian",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M14 13h6"
  }), e.createElement("path", {
    d: "M4 12c0 -9.296 9.5 -9 9.5 -9c-2.808 0 -4.5 4.373 -4.5 9s1.763 8.976 4.572 8.976c0 .023 -9.572 1.092 -9.572 -8.976z"
  }), e.createElement("path", {
    d: "M14.5 3c1.416 0 3.853 1.16 4.5 2v3.5"
  }), e.createElement("path", {
    d: "M15 13v8s2.77 -.37 4 -2v-6"
  }), e.createElement("path", {
    d: "M13.5 21h1.5"
  }), e.createElement("path", {
    d: "M13.5 3h1"
  }));
}
var gM = ["size", "color", "stroke"];
function MM(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, gM);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-brand-gumroad",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M21 12a9 9 0 1 1 -18 0a9 9 0 0 1 18 0z"
  }), e.createElement("path", {
    d: "M13.5 13h2.5v3"
  }), e.createElement("path", {
    d: "M15.024 9.382a4 4 0 1 0 -3.024 6.618c1.862 0 2.554 -1.278 3 -3"
  }));
}
var xM = ["size", "color", "stroke"];
function fM(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, xM);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-brand-hbo",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M2 16v-8"
  }), e.createElement("path", {
    d: "M6 8v8"
  }), e.createElement("path", {
    d: "M2 12h4"
  }), e.createElement("path", {
    d: "M9 16h2a2 2 0 1 0 0 -4h-2h2a2 2 0 1 0 0 -4h-2v8z"
  }), e.createElement("path", {
    d: "M19 8a4 4 0 1 1 0 8a4 4 0 0 1 0 -8z"
  }), e.createElement("circle", {
    cx: 19,
    cy: 12,
    r: 1
  }));
}
var zM = ["size", "color", "stroke"];
function bM(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, zM);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-brand-headlessui",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M6.744 4.325l7.82 -1.267a4.456 4.456 0 0 1 5.111 3.686l1.267 7.82a4.456 4.456 0 0 1 -3.686 5.111l-7.82 1.267a4.456 4.456 0 0 1 -5.111 -3.686l-1.267 -7.82a4.456 4.456 0 0 1 3.686 -5.111z"
  }), e.createElement("path", {
    d: "M7.252 7.704l7.897 -1.28a1 1 0 0 1 1.147 .828l.36 2.223l-9.562 3.51l-.67 -4.134a1 1 0 0 1 .828 -1.147z"
  }));
}
var LM = ["size", "color", "stroke"];
function yM(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, LM);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-brand-hipchat",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M17.802 17.292s.077 -.055 .2 -.149c1.843 -1.425 2.998 -3.49 2.998 -5.789c0 -4.286 -4.03 -7.764 -8.998 -7.764c-4.97 0 -9.002 3.478 -9.002 7.764c0 4.288 4.03 7.646 9 7.646c.424 0 1.12 -.028 2.088 -.084c1.262 .82 3.104 1.493 4.716 1.493c.499 0 .734 -.41 .414 -.828c-.486 -.596 -1.156 -1.551 -1.416 -2.29z"
  }), e.createElement("path", {
    d: "M7.5 13.5c2.5 2.5 6.5 2.5 9 0"
  }));
}
var CM = ["size", "color", "stroke"];
function jM(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, CM);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-brand-html5",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M20 4l-2 14.5l-6 2l-6 -2l-2 -14.5z"
  }), e.createElement("path", {
    d: "M15.5 8h-7l.5 4h6l-.5 3.5l-2.5 .75l-2.5 -.75l-.1 -.5"
  }));
}
var BM = ["size", "color", "stroke"];
function HM(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, BM);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-brand-inertia",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M12.5 8l4 4l-4 4h4.5l4 -4l-4 -4z"
  }), e.createElement("path", {
    d: "M3.5 8l4 4l-4 4h4.5l4 -4l-4 -4z"
  }));
}
var NM = ["size", "color", "stroke"];
function WM(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, NM);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-brand-instagram",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("rect", {
    x: 4,
    y: 4,
    width: 16,
    height: 16,
    rx: 4
  }), e.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 3
  }), e.createElement("line", {
    x1: 16.5,
    y1: 7.5,
    x2: 16.5,
    y2: 7.501
  }));
}
var qM = ["size", "color", "stroke"];
function OM(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, qM);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-brand-intercom",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("rect", {
    x: 4,
    y: 4,
    width: 16,
    height: 16,
    rx: 2
  }), e.createElement("path", {
    d: "M7 8v3"
  }), e.createElement("path", {
    d: "M10 7v6"
  }), e.createElement("path", {
    d: "M14 7v6"
  }), e.createElement("path", {
    d: "M17 8v3"
  }), e.createElement("path", {
    d: "M7 15c4 2.667 6 2.667 10 0"
  }));
}
var PM = ["size", "color", "stroke"];
function SM(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, PM);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-brand-javascript",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M20 4l-2 14.5l-6 2l-6 -2l-2 -14.5z"
  }), e.createElement("path", {
    d: "M7.5 8h3v8l-2 -1"
  }), e.createElement("path", {
    d: "M16.5 8h-2.5a0.5 .5 0 0 0 -.5 .5v3a0.5 .5 0 0 0 .5 .5h1.423a0.5 .5 0 0 1 .495 .57l-.418 2.93l-2 .5"
  }));
}
var IM = ["size", "color", "stroke"];
function AM(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, IM);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-brand-kickstarter",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M11 9l2.975 -4.65c.615 -.9 1.405 -1.35 2.377 -1.35c.79 0 1.474 .286 2.054 .858c.576 .574 .866 1.256 .866 2.054c0 .588 -.153 1.109 -.46 1.559l-2.812 4.029l3.465 4.912c.356 .46 .535 .998 .535 1.613a2.92 2.92 0 0 1 -.843 2.098c-.561 .584 -1.242 .877 -2.04 .877c-.876 0 -1.545 -.29 -2.005 -.87l-4.112 -5.697v3.067c0 .876 -.313 1.69 -.611 2.175c-.543 .883 -1.35 1.325 -2.389 1.325c-.944 0 -1.753 -.327 -2.271 -.974c-.486 -.6 -.729 -1.392 -.729 -2.38v-11.371c0 -.934 .247 -1.706 .74 -2.313c.512 -.641 1.347 -.962 2.26 -.962c.868 0 1.821 .321 2.4 .962c.323 .356 .515 .714 .6 1.08c.052 .224 0 .643 0 1.26v2.698z"
  }));
}
var DM = ["size", "color", "stroke"];
function FM(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, DM);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-brand-kotlin",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M20 20h-16v-16h16"
  }), e.createElement("line", {
    x1: 4,
    y1: 20,
    x2: 20,
    y2: 4
  }), e.createElement("path", {
    d: "M4 12l8 -8"
  }), e.createElement("line", {
    x1: 12,
    y1: 12,
    x2: 20,
    y2: 20
  }));
}
var GM = ["size", "color", "stroke"];
function JM(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, GM);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-brand-laravel",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M3 17l8 5l7 -4v-8l-4 -2.5l4 -2.5l4 2.5v4l-11 6.5l-4 -2.5v-7.5l-4 -2.5z"
  }), e.createElement("path", {
    d: "M11 18v4"
  }), e.createElement("path", {
    d: "M7 15.5l7 -4"
  }), e.createElement("path", {
    d: "M14 7.5v4"
  }), e.createElement("path", {
    d: "M14 11.5l4 2.5"
  }), e.createElement("path", {
    d: "M11 13v-7.5l-4 -2.5l-4 2.5"
  }), e.createElement("path", {
    d: "M7 8l4 -2.5"
  }), e.createElement("path", {
    d: "M18 10l4 -2.5"
  }));
}
var KM = ["size", "color", "stroke"];
function QM(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, KM);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-brand-lastfm",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M20 8c-.83 -1 -1.388 -1 -2 -1c-.612 0 -2 .271 -2 2s1.384 2.233 3 3c1.616 .767 2.125 1.812 2 3s-1 2 -3 2s-3 -1 -3.5 -2s-1.585 -4.78 -2.497 -5.997a5 5 0 1 0 -1.003 6.997"
  }));
}
var RM = ["size", "color", "stroke"];
function TM(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, RM);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-brand-linkedin",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("rect", {
    x: 4,
    y: 4,
    width: 16,
    height: 16,
    rx: 2
  }), e.createElement("line", {
    x1: 8,
    y1: 11,
    x2: 8,
    y2: 16
  }), e.createElement("line", {
    x1: 8,
    y1: 8,
    x2: 8,
    y2: 8.01
  }), e.createElement("line", {
    x1: 12,
    y1: 16,
    x2: 12,
    y2: 11
  }), e.createElement("path", {
    d: "M16 16v-3a2 2 0 0 0 -4 0"
  }));
}
var UM = ["size", "color", "stroke"];
function VM(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, UM);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-brand-linktree",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M9 3l-7 12h3v5h5v-5h-2l4 -7z"
  }), e.createElement("path", {
    d: "M15 3l7 12h-3v5h-5v-5h2l-4 -7z"
  }));
}
var XM = ["size", "color", "stroke"];
function YM(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, XM);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-brand-linqpad",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M5 21h3.5l2.5 -6l2.5 -1l2.5 7h4l1 -4.5l-2 -1l-7 -12l-6 -.5l1.5 4l2.5 .5l1 2.5l-7 8z"
  }));
}
var ZM = ["size", "color", "stroke"];
function $M(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, ZM);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-brand-loom",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M17.464 6.518a6.001 6.001 0 1 0 -3.023 7.965"
  }), e.createElement("path", {
    d: "M17.482 17.464a6.001 6.001 0 1 0 -7.965 -3.023"
  }), e.createElement("path", {
    d: "M6.54 17.482a6.001 6.001 0 1 0 3.024 -7.965"
  }), e.createElement("path", {
    d: "M6.518 6.54a6.001 6.001 0 1 0 7.965 3.024"
  }));
}
var _M = ["size", "color", "stroke"];
function ex(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, _M);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-brand-mailgun",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M17 12a2 2 0 1 0 4 0a9 9 0 1 0 -2.987 6.697"
  }), e.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 5
  }), e.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 1
  }), e.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 1
  }));
}
var tx = ["size", "color", "stroke"];
function ox(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, tx);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-brand-mantine",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 9
  }), e.createElement("path", {
    d: "M11 16c1.22 -.912 2 -2.36 2 -4a5.01 5.01 0 0 0 -2 -4"
  }), e.createElement("path", {
    d: "M14 9h-2"
  }), e.createElement("path", {
    d: "M14 15h-2"
  }), e.createElement("path", {
    d: "M10 12h.01"
  }));
}
var rx = ["size", "color", "stroke"];
function nx(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, rx);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-brand-mastercard",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("circle", {
    cx: 14,
    cy: 12,
    r: 3
  }), e.createElement("path", {
    d: "M12 9.765a3 3 0 1 0 0 4.47"
  }), e.createElement("rect", {
    x: 3,
    y: 5,
    width: 18,
    height: 14,
    rx: 2
  }));
}
var lx = ["size", "color", "stroke"];
function ax(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, lx);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-brand-mastodon",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M18.648 15.254c-1.816 1.763 -6.648 1.626 -6.648 1.626a18.262 18.262 0 0 1 -3.288 -.256c1.127 1.985 4.12 2.81 8.982 2.475c-1.945 2.013 -13.598 5.257 -13.668 -7.636l-.026 -1.154c0 -3.036 .023 -4.115 1.352 -5.633c1.671 -1.91 6.648 -1.666 6.648 -1.666s4.977 -.243 6.648 1.667c1.329 1.518 1.352 2.597 1.352 5.633s-.456 4.074 -1.352 4.944z"
  }), e.createElement("path", {
    d: "M12 11.204v-2.926c0 -1.258 -.895 -2.278 -2 -2.278s-2 1.02 -2 2.278v4.722m4 -4.722c0 -1.258 .895 -2.278 2 -2.278s2 1.02 2 2.278v4.722"
  }));
}
var ix = ["size", "color", "stroke"];
function cx(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, ix);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-brand-matrix",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M4 3h-1v18h1"
  }), e.createElement("path", {
    d: "M20 21h1v-18h-1"
  }), e.createElement("path", {
    d: "M7 9v6"
  }), e.createElement("path", {
    d: "M12 15v-3.5a2.5 2.5 0 1 0 -5 0v.5"
  }), e.createElement("path", {
    d: "M17 15v-3.5a2.5 2.5 0 1 0 -5 0v.5"
  }));
}
var sx = ["size", "color", "stroke"];
function hx(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, sx);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-brand-mcdonalds",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M20 20c0 -3.952 -.966 -16 -4.038 -16s-3.962 9.087 -3.962 14.756c0 -5.669 -.896 -14.756 -3.962 -14.756c-3.065 0 -4.038 12.048 -4.038 16"
  }));
}
var dx = ["size", "color", "stroke"];
function vx(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, dx);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-brand-medium",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("rect", {
    x: 4,
    y: 4,
    width: 16,
    height: 16,
    rx: 2
  }), e.createElement("path", {
    d: "M8 9h1l3 3l3 -3h1"
  }), e.createElement("line", {
    x1: 8,
    y1: 15,
    x2: 10,
    y2: 15
  }), e.createElement("line", {
    x1: 14,
    y1: 15,
    x2: 16,
    y2: 15
  }), e.createElement("line", {
    x1: 9,
    y1: 9,
    x2: 9,
    y2: 15
  }), e.createElement("line", {
    x1: 15,
    y1: 9,
    x2: 15,
    y2: 15
  }));
}
var mx = ["size", "color", "stroke"];
function kx(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, mx);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-brand-mercedes",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 9
  }), e.createElement("path", {
    d: "M12 3v9"
  }), e.createElement("path", {
    d: "M12 12l7 5"
  }), e.createElement("path", {
    d: "M12 12l-7 5"
  }));
}
var wx = ["size", "color", "stroke"];
function px(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, wx);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-brand-messenger",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M3 20l1.3 -3.9a9 8 0 1 1 3.4 2.9l-4.7 1"
  }), e.createElement("path", {
    d: "M8 13l3 -2l2 2l3 -2"
  }));
}
var Ex = ["size", "color", "stroke"];
function ux(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Ex);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-brand-meta",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M12 10.174c1.766 -2.784 3.315 -4.174 4.648 -4.174c2 0 3.263 2.213 4 5.217c.704 2.869 .5 6.783 -2 6.783c-1.114 0 -2.648 -1.565 -4.148 -3.652a27.627 27.627 0 0 1 -2.5 -4.174z"
  }), e.createElement("path", {
    d: "M12 10.174c-1.766 -2.784 -3.315 -4.174 -4.648 -4.174c-2 0 -3.263 2.213 -4 5.217c-.704 2.869 -.5 6.783 2 6.783c1.114 0 2.648 -1.565 4.148 -3.652c1 -1.391 1.833 -2.783 2.5 -4.174z"
  }));
}
var gx = ["size", "color", "stroke"];
function Mx(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, gx);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-brand-miniprogram",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M21 12a9 9 0 1 1 -18 0a9 9 0 0 1 18 0z"
  }), e.createElement("path", {
    d: "M7.996 11.503a2.5 2.5 0 1 0 4.004 1.997v-3a2.5 2.5 0 1 1 3.995 2.004"
  }));
}
var xx = ["size", "color", "stroke"];
function fx(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, xx);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-brand-mixpanel",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("circle", {
    cx: 4.5,
    cy: 12,
    r: 2.5
  }), e.createElement("circle", {
    cx: 20.5,
    cy: 12,
    r: 1.5
  }), e.createElement("circle", {
    cx: 13,
    cy: 12,
    r: 2
  }));
}
var zx = ["size", "color", "stroke"];
function bx(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, zx);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-brand-monday",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("circle", {
    cx: 19.5,
    cy: 15.5,
    r: 1.5
  }), e.createElement("path", {
    d: "M9.5 7a1.5 1.5 0 0 1 1.339 2.177l-4.034 7.074c-.264 .447 -.75 .749 -1.305 .749a1.5 1.5 0 0 1 -1.271 -2.297l3.906 -6.827a1.5 1.5 0 0 1 1.365 -.876z"
  }), e.createElement("path", {
    d: "M16.5 7a1.5 1.5 0 0 1 1.339 2.177l-4.034 7.074c-.264 .447 -.75 .749 -1.305 .749a1.5 1.5 0 0 1 -1.271 -2.297l3.906 -6.827a1.5 1.5 0 0 1 1.365 -.876z"
  }));
}
var Lx = ["size", "color", "stroke"];
function yx(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Lx);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-brand-mongodb",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M12 3v19"
  }), e.createElement("path", {
    d: "M18 11.227c0 3.273 -1.812 4.77 -6 9.273c-4.188 -4.503 -6 -6 -6 -9.273c0 -4.454 3.071 -6.927 6 -9.227c2.929 2.3 6 4.773 6 9.227z"
  }));
}
var Cx = ["size", "color", "stroke"];
function jx(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Cx);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-brand-my-oppo",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M18.316 5h-12.632l-3.418 4.019a1.089 1.089 0 0 0 .019 1.447l9.714 10.534l9.715 -10.49a1.09 1.09 0 0 0 .024 -1.444l-3.422 -4.066z"
  }), e.createElement("path", {
    d: "M9 11l3 3l3 -3"
  }));
}
var Bx = ["size", "color", "stroke"];
function Hx(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Bx);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-brand-mysql",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M13 21c-1.427 -1.026 -3.59 -3.854 -4 -6c-.486 .77 -1.501 2 -2 2c-1.499 -.888 -.574 -3.973 0 -6c-1.596 -1.433 -2.468 -2.458 -2.5 -4c-3.35 -3.44 -.444 -5.27 2.5 -3h1c8.482 .5 6.421 8.07 9 11.5c2.295 .522 3.665 2.254 5 3.5c-2.086 -.2 -2.784 -.344 -3.5 0c.478 1.64 2.123 2.2 3.5 3"
  }), e.createElement("path", {
    d: "M9 7h.01"
  }));
}
var Nx = ["size", "color", "stroke"];
function Wx(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Nx);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-brand-national-geographic",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M7 3h10v18h-10z"
  }));
}
var qx = ["size", "color", "stroke"];
function Ox(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, qx);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-brand-nem",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M12.182 2c1.94 .022 3.879 .382 5.818 1.08l.364 .135a23.075 23.075 0 0 1 3.636 1.785c0 5.618 -1.957 10.258 -5.87 13.92c-1.24 1.239 -2.5 2.204 -3.78 2.898l-.35 .182c-1.4 -.703 -2.777 -1.729 -4.13 -3.079c-3.912 -3.663 -5.87 -8.303 -5.87 -13.921c2.545 -1.527 5.09 -2.471 7.636 -2.832l.364 -.048a16.786 16.786 0 0 1 1.818 -.12h.364z"
  }), e.createElement("path", {
    d: "M2.1 7.07c2.073 6.72 5.373 7.697 9.9 2.93c0 -4 1.357 -6.353 4.07 -7.06l.59 -.11"
  }), e.createElement("path", {
    d: "M16.35 18.51s2.65 -5.51 -4.35 -8.51"
  }));
}
var Px = ["size", "color", "stroke"];
function Sx(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Px);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-brand-netbeans",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M19 6.873a2 2 0 0 1 1 1.747v6.536a2 2 0 0 1 -1.029 1.748l-6 3.833a2 2 0 0 1 -1.942 0l-6 -3.833a2 2 0 0 1 -1.029 -1.747v-6.537a2 2 0 0 1 1.029 -1.748l6 -3.572a2.056 2.056 0 0 1 2 0l6 3.573h-.029z"
  }), e.createElement("path", {
    d: "M15.5 9.43a1 1 0 0 1 .5 .874v3.268a1 1 0 0 1 -.515 .874l-3 1.917a1 1 0 0 1 -.97 0l-3 -1.917a1 1 0 0 1 -.515 -.873v-3.269a1 1 0 0 1 .514 -.874l3 -1.786c.311 -.173 .69 -.173 1 0l3 1.787h-.014z"
  }), e.createElement("path", {
    d: "M12 21v-9l-7.5 -4.5"
  }), e.createElement("path", {
    d: "M12 12l7.5 -4.5"
  }), e.createElement("path", {
    d: "M12 3v4.5"
  }), e.createElement("path", {
    d: "M19.5 16l-3.5 -2"
  }), e.createElement("path", {
    d: "M8 14l-3.5 2"
  }));
}
var Ix = ["size", "color", "stroke"];
function Ax(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Ix);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-brand-netease-music",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M9 4c-2.93 1.346 -5 5.046 -5 8.492c0 4.508 4 7.508 8 7.508s8 -3 8 -7c0 -3.513 -3.5 -5.513 -6 -5.513s-5 1.513 -5 4.513c0 2 1.5 3 3 3s3 -.998 3 -3c0 -3.513 -2 -4.508 -2 -6.515c0 -3.504 3.5 -2.603 4 -1.502"
  }));
}
var Dx = ["size", "color", "stroke"];
function Fx(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Dx);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-brand-netflix",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M9 3l10 18h-4l-10 -18z"
  }), e.createElement("path", {
    d: "M5 3v18h4v-10.5"
  }), e.createElement("path", {
    d: "M19 21v-18h-4v10.5"
  }));
}
var Gx = ["size", "color", "stroke"];
function Jx(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Gx);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-brand-nexo",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M17 3l5 3v12l-5 3l-10 -6v-6l10 6v-6l-5 -3z"
  }), e.createElement("path", {
    d: "M12 6l-5 -3l-5 3v12l5 3l4.7 -3.13"
  }));
}
var Kx = ["size", "color", "stroke"];
function Qx(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Kx);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-brand-nextcloud",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 5
  }), e.createElement("circle", {
    cx: 4.5,
    cy: 12.5,
    r: 2.5
  }), e.createElement("circle", {
    cx: 19.5,
    cy: 12.5,
    r: 2.5
  }));
}
var Rx = ["size", "color", "stroke"];
function Tx(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Rx);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-brand-nextjs",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M9 15v-6l7.745 10.65a9 9 0 1 1 2.255 -1.993"
  }), e.createElement("path", {
    d: "M15 12v-3"
  }));
}
var Ux = ["size", "color", "stroke"];
function Vx(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Ux);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-brand-nord-vpn",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M9.992 15l-2.007 -3l-4.015 8c-2.212 -3.061 -2.625 -7.098 -.915 -10.463a10.14 10.14 0 0 1 8.945 -5.537a10.14 10.14 0 0 1 8.945 5.537c1.71 3.365 1.297 7.402 -.915 10.463l-4.517 -8l-1.505 1.5"
  }), e.createElement("path", {
    d: "M14.5 15l-3 -6l-2.5 4.5"
  }));
}
var Xx = ["size", "color", "stroke"];
function Yx(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Xx);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-brand-notion",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("rect", {
    x: 4,
    y: 4,
    width: 16,
    height: 16,
    rx: 2
  }), e.createElement("path", {
    d: "M7 7h3l6 6"
  }), e.createElement("path", {
    d: "M8 7v10"
  }), e.createElement("path", {
    d: "M7 17h2"
  }), e.createElement("path", {
    d: "M15 7h2"
  }), e.createElement("path", {
    d: "M16 7v10h-1l-7 -7"
  }));
}
var Zx = ["size", "color", "stroke"];
function $x(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Zx);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-brand-npm",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M1 8h22v7h-12v2h-4v-2h-6z"
  }), e.createElement("path", {
    d: "M7 8v7"
  }), e.createElement("path", {
    d: "M14 8v7"
  }), e.createElement("path", {
    d: "M17 11v4"
  }), e.createElement("path", {
    d: "M4 11v4"
  }), e.createElement("path", {
    d: "M11 11v1"
  }), e.createElement("path", {
    d: "M20 11v4"
  }));
}
var _x = ["size", "color", "stroke"];
function ef(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, _x);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-brand-nuxt",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M12.146 8.583l-1.3 -2.09a1.046 1.046 0 0 0 -1.786 .017l-5.91 9.908a1.046 1.046 0 0 0 .897 1.582h3.913"
  }), e.createElement("path", {
    d: "M20.043 18c.743 0 1.201 -.843 .82 -1.505l-4.044 -7.013a0.936 .936 0 0 0 -1.638 0l-4.043 7.013c-.382 .662 .076 1.505 .819 1.505h8.086z"
  }));
}
var tf = ["size", "color", "stroke"];
function of(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, tf);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-brand-nytimes",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M11.036 5.058a8.001 8.001 0 1 0 8.706 9.965"
  }), e.createElement("path", {
    d: "M12 21v-11l-7.5 4"
  }), e.createElement("path", {
    d: "M17.5 3a2.5 2.5 0 1 1 0 5l-11 -5a2.5 2.5 0 0 0 -.67 4.91"
  }), e.createElement("path", {
    d: "M9 12v8"
  }), e.createElement("path", {
    d: "M16 13h-.01"
  }));
}
var rf = ["size", "color", "stroke"];
function nf(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, rf);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-brand-office",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M4 18h9v-12l-5 2v5l-4 2v-8l9 -4l7 2v13l-7 3z"
  }));
}
var lf = ["size", "color", "stroke"];
function af(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, lf);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-brand-ok-ru",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("circle", {
    cx: 12,
    cy: 9,
    r: 2
  }), e.createElement("path", {
    d: "M20 12c0 8 0 8 -8 8s-8 0 -8 -8s0 -8 8 -8s8 0 8 8z"
  }), e.createElement("path", {
    d: "M9.5 13c1.333 .667 3.667 .667 5 0"
  }), e.createElement("path", {
    d: "M9.5 17l2.5 -3l2.5 3"
  }), e.createElement("path", {
    d: "M12 13.5v.5"
  }));
}
var cf = ["size", "color", "stroke"];
function sf(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, cf);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-brand-onedrive",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M18.456 10.45a6.45 6.45 0 0 0 -11.999 -2.151a4.857 4.857 0 0 0 -4.44 5.241a4.856 4.856 0 0 0 5.236 4.444h10.751a3.771 3.771 0 0 0 3.99 -3.54a3.772 3.772 0 0 0 -3.538 -3.992z"
  }));
}
var hf = ["size", "color", "stroke"];
function df(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, hf);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-brand-onlyfans",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M8.5 6a6.5 6.5 0 1 0 0 13a6.5 6.5 0 0 0 0 -13z"
  }), e.createElement("path", {
    d: "M8.5 15a2.5 2.5 0 1 1 0 -5a2.5 2.5 0 0 1 0 5z"
  }), e.createElement("path", {
    d: "M14 16c2.5 0 6.42 -1.467 7 -4h-6c3 -1 6.44 -3.533 7 -6h-4c-3.03 0 -3.764 -.196 -5 1.5"
  }));
}
var vf = ["size", "color", "stroke"];
function mf(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, vf);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-brand-open-source",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M12 3a9 9 0 0 1 3.618 17.243l-2.193 -5.602a3 3 0 1 0 -2.849 0l-2.193 5.603a9 9 0 0 1 3.617 -17.244z"
  }));
}
var kf = ["size", "color", "stroke"];
function wf(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, kf);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-brand-openvpn",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M15.618 20.243l-2.193 -5.602a3 3 0 1 0 -2.849 0l-2.193 5.603"
  }), e.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 9
  }));
}
var pf = ["size", "color", "stroke"];
function Ef(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, pf);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-brand-opera",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 9
  }), e.createElement("ellipse", {
    cx: 12,
    cy: 12,
    rx: 3,
    ry: 5
  }));
}
var uf = ["size", "color", "stroke"];
function gf(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, uf);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-brand-pagekit",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M12.077 20h-5.077v-16h11v14h-5.077"
  }));
}
var Mf = ["size", "color", "stroke"];
function xf(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Mf);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-brand-patreon",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M3 3h3v18h-3z"
  }), e.createElement("circle", {
    cx: 15,
    cy: 9.5,
    r: 6.5
  }));
}
var ff = ["size", "color", "stroke"];
function zf(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, ff);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-brand-paypal",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M10 13l2.5 0c2.5 0 5 -2.5 5 -5c0 -3 -1.9 -5 -5 -5h-5.5c-.5 0 -1 .5 -1 1l-2 14c0 .5 .5 1 1 1h2.8l1.2 -5c.1 -.6 .4 -1 1 -1zm7.5 -5.8c1.7 1 2.5 2.8 2.5 4.8c0 2.5 -2.5 4.5 -5 4.5h-2.6l-.6 3.6a1 1 0 0 1 -1 .8l-2.7 0a0.5 .5 0 0 1 -.5 -.6l.2 -1.4"
  }));
}
var bf = ["size", "color", "stroke"];
function Lf(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, bf);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-brand-paypay",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M6.375 21l3.938 -13.838"
  }), e.createElement("path", {
    d: "M3 6c16.731 0 21.231 9.881 4.5 11"
  }), e.createElement("path", {
    d: "M21 19v-14a2 2 0 0 0 -2 -2h-14a2 2 0 0 0 -2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2 -2z"
  }));
}
var yf = ["size", "color", "stroke"];
function Cf(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, yf);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-brand-peanut",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M15 16.25l-.816 -.36l-.462 -.196c-1.444 -.592 -2 -.593 -3.447 -.002l-.462 .195l-.817 .359a4.5 4.5 0 1 1 .004 -8.49v-.006l1.054 .462l.434 .178c1.292 .507 1.863 .48 3.237 -.082l.462 -.195l.817 -.359a4.5 4.5 0 1 1 -.004 8.49"
  }));
}
var jf = ["size", "color", "stroke"];
function Bf(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, jf);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-brand-pepsi",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 9
  }), e.createElement("path", {
    d: "M4 16c5.713 -2.973 11 -3.5 13.449 -11.162"
  }), e.createElement("path", {
    d: "M5 17.5c5.118 -2.859 15 0 14 -11"
  }));
}
var Hf = ["size", "color", "stroke"];
function Nf(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Hf);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-brand-php",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("ellipse", {
    cx: 12,
    cy: 12,
    rx: 10,
    ry: 9
  }), e.createElement("path", {
    d: "M5.5 15l.395 -1.974l.605 -3.026h1.32a1 1 0 0 1 .986 1.164l-.167 1a1 1 0 0 1 -.986 .836h-1.653"
  }), e.createElement("path", {
    d: "M15.5 15l.395 -1.974l.605 -3.026h1.32a1 1 0 0 1 .986 1.164l-.167 1a1 1 0 0 1 -.986 .836h-1.653"
  }), e.createElement("path", {
    d: "M12 7.5l-1 5.5"
  }), e.createElement("path", {
    d: "M11.6 10h2.4l-.5 3"
  }));
}
var Wf = ["size", "color", "stroke"];
function qf(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Wf);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-brand-picsart",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("circle", {
    cx: 12,
    cy: 9,
    r: 7
  }), e.createElement("circle", {
    cx: 12,
    cy: 9,
    r: 3
  }), e.createElement("path", {
    d: "M5 9v11a2 2 0 1 0 4 0v-4.5"
  }));
}
var Of = ["size", "color", "stroke"];
function Pf(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Of);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-brand-pinterest",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("line", {
    x1: 8,
    y1: 20,
    x2: 12,
    y2: 11
  }), e.createElement("path", {
    d: "M10.7 14c.437 1.263 1.43 2 2.55 2c2.071 0 3.75 -1.554 3.75 -4a5 5 0 1 0 -9.7 1.7"
  }), e.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 9
  }));
}
var Sf = ["size", "color", "stroke"];
function If(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Sf);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-brand-pocket",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M5 4h14a2 2 0 0 1 2 2v6a9 9 0 0 1 -18 0v-6a2 2 0 0 1 2 -2"
  }), e.createElement("polyline", {
    points: "8 11 12 15 16 11"
  }));
}
var Af = ["size", "color", "stroke"];
function Df(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Af);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-brand-polymer",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M6.706 6l-3.706 6l3.706 6h1.059l8.47 -12h1.06l3.705 6l-3.706 6"
  }));
}
var Ff = ["size", "color", "stroke"];
function Gf(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Ff);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-brand-powershell",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M4.887 20h11.868c.893 0 1.664 -.665 1.847 -1.592l2.358 -12c.212 -1.081 -.442 -2.14 -1.462 -2.366a1.784 1.784 0 0 0 -.385 -.042h-11.868c-.893 0 -1.664 .665 -1.847 1.592l-2.358 12c-.212 1.081 .442 2.14 1.462 2.366c.127 .028 .256 .042 .385 .042z"
  }), e.createElement("path", {
    d: "M9 8l4 4l-6 4"
  }), e.createElement("path", {
    d: "M12 16h3"
  }));
}
var Jf = ["size", "color", "stroke"];
function Kf(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Jf);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-brand-prisma",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M4.186 16.202l3.615 5.313c.265 .39 .754 .57 1.215 .447l10.166 -2.718a1.086 1.086 0 0 0 .713 -1.511l-7.505 -15.483a0.448 .448 0 0 0 -.787 -.033l-7.453 12.838a1.07 1.07 0 0 0 .037 1.147z"
  }), e.createElement("path", {
    d: "M8.5 22l3.5 -20"
  }));
}
var Qf = ["size", "color", "stroke"];
function Rf(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Qf);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-brand-producthunt",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M10 16v-8h2.5a2.5 2.5 0 1 1 0 5h-2.5"
  }), e.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 9
  }));
}
var Tf = ["size", "color", "stroke"];
function Uf(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Tf);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-brand-pushbullet",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 9
  }), e.createElement("path", {
    d: "M11 8v8h2a4 4 0 1 0 0 -8h-2z"
  }), e.createElement("path", {
    d: "M8 8v8"
  }));
}
var Vf = ["size", "color", "stroke"];
function Xf(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Vf);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-brand-pushover",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M6.16 10.985c-.83 -1.935 1.53 -7.985 8.195 -7.985c3.333 0 4.645 1.382 4.645 3.9c0 2.597 -2.612 6.1 -9 6.1"
  }), e.createElement("path", {
    d: "M12.5 6l-5.5 15"
  }));
}
var Yf = ["size", "color", "stroke"];
function Zf(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Yf);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-brand-python",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M12 9h-7a2 2 0 0 0 -2 2v4a2 2 0 0 0 2 2h3"
  }), e.createElement("path", {
    d: "M12 15h7a2 2 0 0 0 2 -2v-4a2 2 0 0 0 -2 -2h-3"
  }), e.createElement("path", {
    d: "M8 9v-4a2 2 0 0 1 2 -2h4a2 2 0 0 1 2 2v5a2 2 0 0 1 -2 2h-4a2 2 0 0 0 -2 2v5a2 2 0 0 0 2 2h4a2 2 0 0 0 2 -2v-4"
  }), e.createElement("line", {
    x1: 11,
    y1: 6,
    x2: 11,
    y2: 6.01
  }), e.createElement("line", {
    x1: 13,
    y1: 18,
    x2: 13,
    y2: 18.01
  }));
}
var $f = ["size", "color", "stroke"];
function _f(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, $f);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-brand-qq",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M14 7h.01"
  }), e.createElement("path", {
    d: "M10 7h.01"
  }), e.createElement("path", {
    d: "M6 11c4 4 8 4 12 0"
  }), e.createElement("path", {
    d: "M9 13.5v2.5"
  }), e.createElement("path", {
    d: "M10.5 10c.667 1.333 2.333 1.333 3 0h-3z"
  }), e.createElement("path", {
    d: "M16 21c1.5 0 3.065 -1 1 -3c4.442 2 1.987 -4.5 1 -7c0 -4 -1.558 -8 -6 -8s-6 4 -6 8c-.987 2.5 -3.442 9 1 7c-2.065 2 -.5 3 1 3h8z"
  }));
}
var ez = ["size", "color", "stroke"];
function tz(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, ez);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-brand-react-native",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M6.357 9c-2.637 .68 -4.357 1.845 -4.357 3.175c0 2.107 4.405 3.825 9.85 3.825c.74 0 1.26 -.039 1.95 -.097"
  }), e.createElement("path", {
    d: "M9.837 15.9c-.413 -.596 -.806 -1.133 -1.18 -1.8c-2.751 -4.9 -3.488 -9.77 -1.63 -10.873c1.15 -.697 3.047 .253 4.974 2.254"
  }), e.createElement("path", {
    d: "M6.429 15.387c-.702 2.688 -.56 4.716 .56 5.395c1.783 1.08 5.387 -1.958 8.043 -6.804c.36 -.67 .683 -1.329 .968 -1.978"
  }), e.createElement("path", {
    d: "M12 18.52c1.928 2 3.817 2.95 4.978 2.253c1.85 -1.102 1.121 -5.972 -1.633 -10.873c-.384 -.677 -.777 -1.204 -1.18 -1.8"
  }), e.createElement("path", {
    d: "M17.66 15c2.612 -.687 4.34 -1.85 4.34 -3.176c0 -2.11 -4.408 -3.824 -9.845 -3.824c-.747 0 -1.266 .029 -1.955 .087"
  }), e.createElement("path", {
    d: "M8 12c.285 -.66 .607 -1.308 .968 -1.978c2.647 -4.844 6.253 -7.89 8.046 -6.801c1.11 .679 1.262 2.706 .56 5.393"
  }), e.createElement("path", {
    d: "M12.26 12.015h-.01c-.01 .13 -.12 .24 -.26 .24a0.263 .263 0 0 1 -.25 -.26c0 -.14 .11 -.25 .24 -.25h-.01c.13 -.01 .25 .11 .25 .24"
  }));
}
var oz = ["size", "color", "stroke"];
function rz(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, oz);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-brand-react",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M6.306 8.711c-2.602 .723 -4.306 1.926 -4.306 3.289c0 2.21 4.477 4 10 4c.773 0 1.526 -.035 2.248 -.102"
  }), e.createElement("path", {
    d: "M17.692 15.289c2.603 -.722 4.308 -1.926 4.308 -3.289c0 -2.21 -4.477 -4 -10 -4c-.773 0 -1.526 .035 -2.25 .102"
  }), e.createElement("path", {
    d: "M6.305 15.287c-.676 2.615 -.485 4.693 .695 5.373c1.913 1.105 5.703 -1.877 8.464 -6.66c.387 -.67 .733 -1.339 1.036 -1.998"
  }), e.createElement("path", {
    d: "M17.694 8.716c.677 -2.616 .487 -4.696 -.694 -5.376c-1.913 -1.105 -5.703 1.877 -8.464 6.66c-.387 .67 -.733 1.34 -1.037 1.999"
  }), e.createElement("path", {
    d: "M12 5.424c-1.925 -1.892 -3.82 -2.766 -5 -2.084c-1.913 1.104 -1.226 5.877 1.536 10.66c.386 .67 .793 1.304 1.212 1.896"
  }), e.createElement("path", {
    d: "M11.998 18.574c1.926 1.893 3.821 2.768 5.002 2.086c1.913 -1.104 1.226 -5.877 -1.536 -10.66c-.375 -.65 -.78 -1.283 -1.212 -1.897"
  }), e.createElement("path", {
    d: "M11.5 12.866a1 1 0 1 0 1 -1.732a1 1 0 0 0 -1 1.732z"
  }));
}
var nz = ["size", "color", "stroke"];
function lz(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, nz);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-brand-reason",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("rect", {
    x: 3,
    y: 3,
    width: 18,
    height: 18,
    rx: 2
  }), e.createElement("path", {
    d: "M18 18h-3v-6h3"
  }), e.createElement("path", {
    d: "M18 15h-3"
  }), e.createElement("path", {
    d: "M8 18v-6h2.5a1.5 1.5 0 0 1 0 3h-2.5"
  }), e.createElement("path", {
    d: "M12 18l-2 -3"
  }));
}
var az = ["size", "color", "stroke"];
function iz(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, az);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-brand-reddit",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M12 8c2.648 0 5.028 .826 6.675 2.14a2.5 2.5 0 0 1 2.326 4.36c0 3.59 -4.03 6.5 -9 6.5c-4.875 0 -8.845 -2.8 -9 -6.294l-1 -.206a2.5 2.5 0 0 1 2.326 -4.36c1.646 -1.313 4.026 -2.14 6.674 -2.14z"
  }), e.createElement("path", {
    d: "M12 8l1 -5l6 1"
  }), e.createElement("circle", {
    cx: 19,
    cy: 4,
    r: 1
  }), e.createElement("circle", {
    cx: 9,
    cy: 13,
    r: .5,
    fill: "currentColor"
  }), e.createElement("circle", {
    cx: 15,
    cy: 13,
    r: .5,
    fill: "currentColor"
  }), e.createElement("path", {
    d: "M10 17c.667 .333 1.333 .5 2 .5s1.333 -.167 2 -.5"
  }));
}
var cz = ["size", "color", "stroke"];
function sz(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, cz);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-brand-redhat",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M6 10.5l1.436 -4c.318 -.876 .728 -1.302 1.359 -1.302c.219 0 1.054 .365 1.88 .583c.825 .219 .733 -.329 .908 -.487c.176 -.158 .355 -.294 .61 -.294c.242 0 .553 .048 1.692 .448c.759 .267 1.493 .574 2.204 .922c1.175 .582 1.426 .913 1.595 1.507l.816 4.623c2.086 .898 3.5 2.357 3.5 3.682c0 1.685 -1.2 3.818 -5.957 3.818c-6.206 0 -14.043 -4.042 -14.043 -7.32c0 -1.044 1.333 -1.77 4 -2.18z"
  }), e.createElement("path", {
    d: "M6 10.5c0 .969 4.39 3.5 9.5 3.5c1.314 0 3 .063 3 -1.5"
  }));
}
var hz = ["size", "color", "stroke"];
function dz(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, hz);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-brand-redux",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M16.54 7c-.805 -2.365 -2.536 -4 -4.54 -4c-2.774 0 -5.023 2.632 -5.023 6.496c0 1.956 1.582 4.727 2.512 5.996"
  }), e.createElement("path", {
    d: "M4.711 11.979c-1.656 1.877 -2.214 4.185 -1.211 5.911c1.387 2.39 5.138 2.831 8.501 .9c1.703 -.979 2.875 -3.362 3.516 -4.798"
  }), e.createElement("path", {
    d: "M15.014 19.99c2.511 0 4.523 -.438 5.487 -2.1c1.387 -2.39 -.215 -5.893 -3.579 -7.824c-1.702 -.979 -4.357 -1.235 -5.927 -1.07"
  }), e.createElement("path", {
    d: "M10.493 9.862c.48 .276 1.095 .112 1.372 -.366a0.997 .997 0 0 0 -.367 -1.365a1.007 1.007 0 0 0 -1.373 .366a0.997 .997 0 0 0 .368 1.365z"
  }), e.createElement("ellipse", {
    cx: 9.5,
    cy: 15.5,
    rx: 1
  }), e.createElement("ellipse", {
    cx: 15.5,
    cy: 14,
    rx: 1
  }));
}
var vz = ["size", "color", "stroke"];
function mz(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, vz);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-brand-revolut",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M10.908 6c-.091 .363 -.908 5 -.908 5h1.228c1.59 0 2.772 -1.168 2.772 -2.943c0 -1.249 -.818 -2.057 -2.087 -2.057h-1.005z"
  }), e.createElement("path", {
    d: "M15.5 13.5l1.791 4.558c.535 1.352 1.13 2.008 1.709 2.442c-1 .5 -2.616 .522 -3.605 .497c-.973 0 -2.28 -.24 -3.106 -2.6l-1.289 -3.397h-1.5s-.465 2.243 -.65 3.202c-.092 .704 .059 1.594 .15 2.298c-1 .5 -2.5 .5 -3.5 .5c-.727 0 -1.45 -.248 -1.5 -1.5l.004 -.311a7 7 0 0 1 .149 -1.409c.75 -3.577 1.366 -7.17 1.847 -10.78c.23 -1.722 0 -3.5 0 -3.5c.585 -.144 2.709 -.602 6.787 -.471a10.26 10.26 0 0 1 3.641 .722c.308 .148 .601 .326 .875 .531c.254 .212 .497 .437 .727 .674c.3 .382 .545 .804 .727 1.253c.155 .483 .237 .987 .243 1.493c.001 2.462 -1.412 4.676 -3.5 5.798z"
  }));
}
var kz = ["size", "color", "stroke"];
function wz(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, kz);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-brand-safari",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("polyline", {
    points: "8 16 10 10 16 8 14 14 8 16"
  }), e.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 9
  }));
}
var pz = ["size", "color", "stroke"];
function Ez(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, pz);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-brand-samsungpass",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("rect", {
    x: 4,
    y: 10,
    width: 16,
    height: 11,
    rx: 2
  }), e.createElement("path", {
    d: "M7 10v-1.862c0 -2.838 2.239 -5.138 5 -5.138s5 2.3 5 5.138v1.862"
  }), e.createElement("path", {
    d: "M10.485 17.577c.337 .29 .7 .423 1.515 .423h.413c.323 0 .633 -.133 .862 -.368a1.27 1.27 0 0 0 .356 -.886c0 -.332 -.128 -.65 -.356 -.886a1.203 1.203 0 0 0 -.862 -.368h-.826a1.2 1.2 0 0 1 -.861 -.367a1.27 1.27 0 0 1 -.356 -.886c0 -.332 .128 -.651 .356 -.886a1.2 1.2 0 0 1 .861 -.368h.413c.816 0 1.178 .133 1.515 .423"
  }));
}
var uz = ["size", "color", "stroke"];
function gz(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, uz);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-brand-sass",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 9
  }), e.createElement("path", {
    d: "M12 10.523c2.46 -.826 4.002 -.826 4.002 -2.155c0 -1.366 -1.347 -1.366 -2.735 -1.366c-1.91 0 -3.352 .49 -4.537 1.748c-.848 .902 -1.027 2.449 -.153 3.307c.973 .956 3.206 1.789 2.884 3.493c-.233 1.235 -1.469 1.823 -2.617 1.202c-.782 -.424 -.454 -1.746 .626 -2.512s2.822 -.992 4.1 -.24c.98 .575 1.046 1.724 .434 2.193"
  }));
}
var Mz = ["size", "color", "stroke"];
function xz(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Mz);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-brand-sentry",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M3 18a1.93 1.93 0 0 0 .306 1.076a2 2 0 0 0 1.584 .924c.646 .033 -.537 0 .11 0h3a4.992 4.992 0 0 0 -3.66 -4.81c.558 -.973 1.24 -2.149 2.04 -3.531a8.997 8.997 0 0 1 5.62 8.341h4c.663 0 2.337 .005 3 0a2 2 0 0 0 1.84 -2.75l-7.1 -12.25a2 2 0 0 0 -3.5 0l-1.84 3.176c4.482 2.05 7.6 6.571 7.6 11.824"
  }));
}
var fz = ["size", "color", "stroke"];
function zz(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, fz);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-brand-sharik",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M4.281 16.606a8.968 8.968 0 0 1 1.363 -10.977a9.033 9.033 0 0 1 11.011 -1.346c-1.584 4.692 -2.415 6.96 -4.655 8.717c-1.584 1.242 -3.836 2.24 -7.719 3.606zm16.335 -7.306c2.113 7.59 -4.892 13.361 -11.302 11.264c1.931 -3.1 3.235 -4.606 4.686 -6.065c1.705 -1.715 3.591 -3.23 6.616 -5.199z"
  }));
}
var bz = ["size", "color", "stroke"];
function Lz(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, bz);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-brand-shazam",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M10 12l2 -2a2.828 2.828 0 0 1 4 0a2.828 2.828 0 0 1 0 4l-3 3"
  }), e.createElement("path", {
    d: "M14 12l-2 2a2.828 2.828 0 1 1 -4 -4l3 -3"
  }), e.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 9
  }));
}
var yz = ["size", "color", "stroke"];
function Cz(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, yz);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-brand-shopee",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M4 7l.867 12.143a2 2 0 0 0 1.995 1.857h10.276a2 2 0 0 0 1.995 -1.857l.867 -12.143h-16z"
  }), e.createElement("path", {
    d: "M8.5 7c0 -1.653 1.5 -4 3.5 -4s3.5 2.347 3.5 4"
  }), e.createElement("path", {
    d: "M9.5 17c.413 .462 1 1 2.5 1s2.5 -.897 2.5 -2s-1 -1.5 -2.5 -2s-2 -1.47 -2 -2c0 -1.104 1 -2 2 -2s1.5 0 2.5 1"
  }));
}
var jz = ["size", "color", "stroke"];
function Bz(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, jz);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-brand-sketch",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M3.262 10.878l8 8.789c.4 .44 1.091 .44 1.491 0l8 -8.79c.313 -.344 .349 -.859 .087 -1.243l-3.537 -5.194a1 1 0 0 0 -.823 -.436h-8.926a1 1 0 0 0 -.823 .436l-3.54 5.192c-.263 .385 -.227 .901 .087 1.246z"
  }));
}
var Hz = ["size", "color", "stroke"];
function Nz(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Hz);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-brand-skype",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M12 3a9 9 0 0 1 8.603 11.65a4.5 4.5 0 0 1 -5.953 5.953a9 9 0 0 1 -11.253 -11.253a4.5 4.5 0 0 1 5.953 -5.954a8.987 8.987 0 0 1 2.65 -.396z"
  }), e.createElement("path", {
    d: "M8 14.5c.5 2 2.358 2.5 4 2.5c2.905 0 4 -1.187 4 -2.5c0 -1.503 -1.927 -2.5 -4 -2.5s-4 -.997 -4 -2.5c0 -1.313 1.095 -2.5 4 -2.5c1.642 0 3.5 .5 4 2.5"
  }));
}
var Wz = ["size", "color", "stroke"];
function qz(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Wz);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-brand-slack",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M12 12v-6a2 2 0 0 1 4 0v6m0 -2a2 2 0 1 1 2 2h-6"
  }), e.createElement("path", {
    d: "M12 12h6a2 2 0 0 1 0 4h-6m2 0a2 2 0 1 1 -2 2v-6"
  }), e.createElement("path", {
    d: "M12 12v6a2 2 0 0 1 -4 0v-6m0 2a2 2 0 1 1 -2 -2h6"
  }), e.createElement("path", {
    d: "M12 12h-6a2 2 0 0 1 0 -4h6m-2 0a2 2 0 1 1 2 -2v6"
  }));
}
var Oz = ["size", "color", "stroke"];
function Pz(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Oz);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-brand-snapchat",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M16.882 7.842a4.882 4.882 0 0 0 -9.764 0c0 4.273 -.213 6.409 -4.118 8.118c2 .882 2 .882 3 3c3 0 4 2 6 2s3 -2 6 -2c1 -2.118 1 -2.118 3 -3c-3.906 -1.709 -4.118 -3.845 -4.118 -8.118zm-13.882 8.119c4 -2.118 4 -4.118 1 -7.118m17 7.118c-4 -2.118 -4 -4.118 -1 -7.118"
  }));
}
var Sz = ["size", "color", "stroke"];
function Iz(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Sz);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-brand-snapseed",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M8.152 3.115a0.46 .46 0 0 0 -.609 0c-2.943 2.58 -4.529 5.441 -4.543 8.378c0 2.928 1.586 5.803 4.543 8.392a0.46 .46 0 0 0 .61 0c2.957 -2.589 4.547 -5.464 4.547 -8.392c0 -2.928 -1.6 -5.799 -4.548 -8.378z"
  }), e.createElement("path", {
    d: "M8 20l12.09 -.011c.503 0 .91 -.434 .91 -.969v-6.063c0 -.535 -.407 -.968 -.91 -.968h-7.382"
  }));
}
var Az = ["size", "color", "stroke"];
function Dz(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Az);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-brand-snowflake",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M14 21v-5.5l4.5 2.5"
  }), e.createElement("path", {
    d: "M10 21v-5.5l-4.5 2.5"
  }), e.createElement("path", {
    d: "M3.5 14.5l4.5 -2.5l-4.5 -2.5"
  }), e.createElement("path", {
    d: "M20.5 9.5l-4.5 2.5l4.5 2.5"
  }), e.createElement("path", {
    d: "M10 3v5.5l-4.5 -2.5"
  }), e.createElement("path", {
    d: "M14 3v5.5l4.5 -2.5"
  }), e.createElement("path", {
    d: "M12 11l1 1l-1 1l-1 -1z"
  }));
}
var Fz = ["size", "color", "stroke"];
function Gz(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Fz);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-brand-socket-io",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 9
  }), e.createElement("path", {
    d: "M11 11h1l3 -4z"
  }), e.createElement("path", {
    d: "M12 13h1l-4 4z"
  }));
}
var Jz = ["size", "color", "stroke"];
function Kz(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Jz);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-brand-solidjs",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M2 17.5c4.667 3 8 4.5 10 4.5c2.5 0 4 -1.5 4 -3.5s-1.5 -3.5 -4 -3.5c-2 0 -5.333 .833 -10 2.5z"
  }), e.createElement("path", {
    d: "M5 13.5c4.667 -1.667 8 -2.5 10 -2.5c2.5 0 4 1.5 4 3.5c0 .738 -.204 1.408 -.588 1.96l-2.883 3.825"
  }), e.createElement("path", {
    d: "M22 6.5c-4 -3 -8 -4.5 -10 -4.5c-2.04 0 -2.618 .463 -3.419 1.545"
  }), e.createElement("path", {
    d: "M2 17.5l3 -4"
  }), e.createElement("path", {
    d: "M22 6.5l-3 4"
  }), e.createElement("path", {
    d: "M8.581 3.545l-2.953 3.711"
  }), e.createElement("path", {
    d: "M7.416 12.662c-1.51 -.476 -2.416 -1.479 -2.416 -3.162c0 -2.5 1.5 -3.5 4 -3.5c1.688 0 5.087 1.068 8.198 3.204a114.76 114.76 0 0 1 1.802 1.296l-2.302 .785"
  }));
}
var Qz = ["size", "color", "stroke"];
function Rz(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Qz);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-brand-soundcloud",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M17 11h1c1.38 0 3 1.274 3 3c0 1.657 -1.5 3 -3 3l-6 0v-10c3 0 4.5 1.5 5 4z"
  }), e.createElement("line", {
    x1: 9,
    y1: 8,
    x2: 9,
    y2: 17
  }), e.createElement("line", {
    x1: 6,
    y1: 17,
    x2: 6,
    y2: 10
  }), e.createElement("line", {
    x1: 3,
    y1: 16,
    x2: 3,
    y2: 14
  }));
}
var Tz = ["size", "color", "stroke"];
function Uz(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Tz);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-brand-spacehey",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("circle", {
    cx: 17,
    cy: 6,
    r: 2
  }), e.createElement("path", {
    d: "M14 20h6v-6a3 3 0 0 0 -6 0v6z"
  }), e.createElement("path", {
    d: "M11 8v2.5a3.5 3.5 0 0 1 -3.5 3.5h-.5a3 3 0 0 1 0 -6h4z"
  }));
}
var Vz = ["size", "color", "stroke"];
function Xz(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Vz);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-brand-spotify",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 9
  }), e.createElement("path", {
    d: "M8 11.973c2.5 -1.473 5.5 -.973 7.5 .527"
  }), e.createElement("path", {
    d: "M9 15c1.5 -1 4 -1 5 .5"
  }), e.createElement("path", {
    d: "M7 9c2 -1 6 -2 10 .5"
  }));
}
var Yz = ["size", "color", "stroke"];
function Zz(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Yz);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-brand-stackoverflow",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M4 17v1a2 2 0 0 0 2 2h12a2 2 0 0 0 2 -2v-1"
  }), e.createElement("path", {
    d: "M8 16h8"
  }), e.createElement("path", {
    d: "M8.322 12.582l7.956 .836"
  }), e.createElement("path", {
    d: "M8.787 9.168l7.826 1.664"
  }), e.createElement("path", {
    d: "M10.096 5.764l7.608 2.472"
  }));
}
var $z = ["size", "color", "stroke"];
function _z(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, $z);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-brand-stackshare",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("circle", {
    cx: 19,
    cy: 6,
    r: 2
  }), e.createElement("circle", {
    cx: 19,
    cy: 18,
    r: 2
  }), e.createElement("circle", {
    cx: 5,
    cy: 12,
    r: 2
  }), e.createElement("path", {
    d: "M7 12h3l3.5 6h3.5"
  }), e.createElement("path", {
    d: "M17 6h-3.5l-3.5 6"
  }));
}
var eb = ["size", "color", "stroke"];
function tb(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, eb);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-brand-steam",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M16.5 5a4.5 4.5 0 1 1 -.653 8.953l-4.347 3.009l0 .038a3 3 0 0 1 -2.824 2.995l-.176 .005a3 3 0 0 1 -2.94 -2.402l-2.56 -1.098v-3.5l3.51 1.755a2.989 2.989 0 0 1 2.834 -.635l2.727 -3.818a4.5 4.5 0 0 1 4.429 -5.302z"
  }), e.createElement("circle", {
    cx: 16.5,
    cy: 9.5,
    r: 1,
    fill: "currentColor"
  }));
}
var ob = ["size", "color", "stroke"];
function rb(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, ob);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-brand-storybook",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M5 4l.5 16.5l13.5 .5v-18z"
  }), e.createElement("path", {
    d: "M9 15c.6 1.5 1.639 2 3.283 2h-.283c1.8 0 3 -.974 3 -2.435c0 -1.194 -.831 -1.799 -2.147 -2.333l-1.975 -.802c-1.15 -.467 -1.878 -1.422 -1.878 -2.467c0 -.97 .899 -1.786 2.087 -1.893l.613 -.055c1.528 -.138 2.999 .762 3.3 1.985"
  }), e.createElement("path", {
    d: "M16 3.5v1"
  }));
}
var nb = ["size", "color", "stroke"];
function lb(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, nb);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-brand-storytel",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M4.103 22c2.292 -2.933 16.825 -2.43 16.825 -11.538c0 -6.298 -4.974 -8.462 -8.451 -8.462c-3.477 0 -9.477 3.036 -9.477 11.241c0 6.374 1.103 8.759 1.103 8.759z"
  }));
}
var ab = ["size", "color", "stroke"];
function ib(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, ab);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-brand-strava",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M15 13l-5 -10l-5 10m6 0l4 8l4 -8"
  }));
}
var cb = ["size", "color", "stroke"];
function sb(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, cb);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-brand-stripe",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M11.453 8.056c0 -.623 .518 -.979 1.442 -.979c1.69 0 3.41 .343 4.605 .923l.5 -4c-.948 -.449 -2.82 -1 -5.5 -1c-1.895 0 -3.373 .087 -4.5 1c-1.172 .956 -2 2.33 -2 4c0 3.03 1.958 4.906 5 6c1.961 .69 3 .743 3 1.5c0 .735 -.851 1.5 -2 1.5c-1.423 0 -3.963 -.609 -5.5 -1.5l-.5 4c1.321 .734 3.474 1.5 6 1.5c2.004 0 3.957 -.468 5.084 -1.36c1.263 -.979 1.916 -2.268 1.916 -4.14c0 -3.096 -1.915 -4.547 -5.003 -5.637c-1.646 -.605 -2.544 -1.07 -2.544 -1.807z"
  }));
}
var hb = ["size", "color", "stroke"];
function db(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, hb);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-brand-sublime-text",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M19 8l-14 4.5v-5.5l14 -4.5z"
  }), e.createElement("path", {
    d: "M19 17l-14 4.5v-5.5l14 -4.5z"
  }), e.createElement("path", {
    d: "M19 11.5l-14 -4.5"
  }), e.createElement("path", {
    d: "M5 12.5l14 4.5"
  }));
}
var vb = ["size", "color", "stroke"];
function mb(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, vb);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-brand-superhuman",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M16 12l4 3l-8 7l-8 -7l4 -3"
  }), e.createElement("path", {
    d: "M12 3l-8 6l8 6l8 -6z"
  }), e.createElement("path", {
    d: "M12 15h8"
  }));
}
var kb = ["size", "color", "stroke"];
function wb(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, kb);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-brand-supernova",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 2
  }), e.createElement("path", {
    d: "M15 15h.5c3.038 0 5.5 -1.343 5.5 -3s-2.462 -3 -5.5 -3c-1.836 0 -3.462 .49 -4.46 1.245"
  }), e.createElement("path", {
    d: "M9 9h-.5c-3.038 0 -5.5 1.343 -5.5 3s2.462 3 5.5 3c1.844 0 3.476 -.495 4.474 -1.255"
  }), e.createElement("path", {
    d: "M15 9v-.5c0 -3.038 -1.343 -5.5 -3 -5.5s-3 2.462 -3 5.5c0 1.833 .49 3.457 1.241 4.456"
  }), e.createElement("path", {
    d: "M9 15v.5c0 3.038 1.343 5.5 3 5.5s3 -2.462 3 -5.5c0 -1.842 -.494 -3.472 -1.252 -4.47"
  }));
}
var pb = ["size", "color", "stroke"];
function Eb(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, pb);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-brand-surfshark",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M19.954 9.447c-.237 -6.217 0 -6.217 -5.996 -6.425c-5.774 -.208 -6.824 1.002 -7.91 5.382c-2.884 11.816 -3.845 14.716 4.792 11.198c9.392 -3.831 9.297 -5.382 9.114 -10.155z"
  }), e.createElement("path", {
    d: "M8 16h.452c1.943 .007 3.526 -1.461 3.543 -3.286v-2.428c.018 -1.828 1.607 -3.298 3.553 -3.286h.452"
  }));
}
var ub = ["size", "color", "stroke"];
function gb(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, ub);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-brand-svelte",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M15 8l-5 3l.821 -.495c1.86 -1.15 4.412 -.49 5.574 1.352a3.91 3.91 0 0 1 -1.264 5.42l-5.053 3.126c-1.86 1.151 -4.312 .591 -5.474 -1.251a3.91 3.91 0 0 1 1.263 -5.42l.26 -.16"
  }), e.createElement("path", {
    d: "M8 17l5 -3l-.822 .496c-1.86 1.151 -4.411 .491 -5.574 -1.351a3.91 3.91 0 0 1 1.264 -5.42l5.054 -3.127c1.86 -1.15 4.311 -.59 5.474 1.252a3.91 3.91 0 0 1 -1.264 5.42l-.26 .16"
  }));
}
var Mb = ["size", "color", "stroke"];
function xb(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Mb);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-brand-symfony",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M6 13c.458 .667 1.125 1 2 1c1.313 0 2 -.875 2 -1.5c0 -1.5 -2 -1 -2 -2c0 -.625 .516 -1.5 1.5 -1.5c2.5 0 1.563 2 5.5 2c.667 0 1 -.333 1 -1"
  }), e.createElement("path", {
    d: "M9 17c-.095 .667 .238 1 1 1c1.714 0 2.714 -2 3 -6c.286 -4 1.571 -6 3 -6c.571 0 .905 .333 1 1"
  }), e.createElement("path", {
    d: "M22 12c0 5.523 -4.477 10 -10 10s-10 -4.477 -10 -10s4.477 -10 10 -10a10 10 0 0 1 10 10z"
  }));
}
var fb = ["size", "color", "stroke"];
function zb(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, fb);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-brand-tabler",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M8 9l3 3l-3 3"
  }), e.createElement("line", {
    x1: 13,
    y1: 15,
    x2: 16,
    y2: 15
  }), e.createElement("rect", {
    x: 4,
    y: 4,
    width: 16,
    height: 16,
    rx: 4
  }));
}
var bb = ["size", "color", "stroke"];
function Lb(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, bb);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-brand-tailwind",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M11.667 6c-2.49 0 -4.044 1.222 -4.667 3.667c.933 -1.223 2.023 -1.68 3.267 -1.375c.71 .174 1.217 .68 1.778 1.24c.916 .912 2 1.968 4.288 1.968c2.49 0 4.044 -1.222 4.667 -3.667c-.933 1.223 -2.023 1.68 -3.267 1.375c-.71 -.174 -1.217 -.68 -1.778 -1.24c-.916 -.912 -1.975 -1.968 -4.288 -1.968zm-4 6.5c-2.49 0 -4.044 1.222 -4.667 3.667c.933 -1.223 2.023 -1.68 3.267 -1.375c.71 .174 1.217 .68 1.778 1.24c.916 .912 1.975 1.968 4.288 1.968c2.49 0 4.044 -1.222 4.667 -3.667c-.933 1.223 -2.023 1.68 -3.267 1.375c-.71 -.174 -1.217 -.68 -1.778 -1.24c-.916 -.912 -1.975 -1.968 -4.288 -1.968z"
  }));
}
var yb = ["size", "color", "stroke"];
function Cb(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, yb);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-brand-taobao",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M17 10h-6.5"
  }), e.createElement("path", {
    d: "M11 9c-.44 .843 -1 1.5 -2 2"
  }), e.createElement("path", {
    d: "M13 10v6.8"
  }), e.createElement("path", {
    d: "M9 15c.71 3.675 6 1.366 8.5 .5"
  }), e.createElement("path", {
    d: "M17 14.5l1 2"
  }), e.createElement("path", {
    d: "M10 13h5"
  }), e.createElement("path", {
    d: "M3 10c4.5 1 2.902 4.85 0 8"
  }), e.createElement("path", {
    d: "M7 9c1.43 -1.652 2.06 -2.876 2.5 -4"
  }), e.createElement("path", {
    d: "M8.5 7c4.333 -.667 7 -1 8 -1c1.5 0 3.5 -.5 4 1.5c.333 1.333 .5 2.833 .5 4.5v4c0 2 -1 3 -5 3"
  }), e.createElement("circle", {
    cx: 5,
    cy: 6,
    r: 1
  }));
}
var jb = ["size", "color", "stroke"];
function Bb(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, jb);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-brand-ted",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M2 8h4"
  }), e.createElement("path", {
    d: "M4 8v8"
  }), e.createElement("path", {
    d: "M13 8h-4v8h4"
  }), e.createElement("path", {
    d: "M9 12h2.5"
  }), e.createElement("path", {
    d: "M16 8v8h2a3 3 0 0 0 3 -3v-2a3 3 0 0 0 -3 -3h-2z"
  }));
}
var Hb = ["size", "color", "stroke"];
function Nb(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Hb);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-brand-telegram",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M15 10l-4 4l6 6l4 -16l-18 7l4 2l2 6l3 -4"
  }));
}
var Wb = ["size", "color", "stroke"];
function qb(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Wb);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-brand-tether",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M14.08 20.188c-1.15 1.083 -3.02 1.083 -4.17 0l-6.93 -6.548c-.96 -.906 -1.27 -2.624 -.69 -3.831l2.4 -5.018c.47 -.991 1.72 -1.791 2.78 -1.791h9.06c1.06 0 2.31 .802 2.78 1.79l2.4 5.019c.58 1.207 .26 2.925 -.69 3.83c-3.453 3.293 -3.466 3.279 -6.94 6.549z"
  }), e.createElement("path", {
    d: "M12 15v-7"
  }), e.createElement("path", {
    d: "M8 8h8"
  }));
}
var Ob = ["size", "color", "stroke"];
function Pb(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Ob);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-brand-threejs",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M8 22l-5 -19l19 5.5z"
  }), e.createElement("path", {
    d: "M12.573 17.58l-6.152 -1.576l8.796 -9.466l1.914 6.64"
  }), e.createElement("path", {
    d: "M12.573 17.58l-1.573 -6.58l6.13 2.179"
  }), e.createElement("path", {
    d: "M9.527 4.893l1.473 6.107l-6.31 -1.564z"
  }));
}
var Sb = ["size", "color", "stroke"];
function Ib(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Sb);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-brand-tidal",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M5.333 6l3.334 3.25l3.333 -3.25l3.333 3.25l3.334 -3.25l3.333 3.25l-3.333 3.25l-3.334 -3.25l-3.333 3.25l3.333 3.25l-3.333 3.25l-3.333 -3.25l3.333 -3.25l-3.333 -3.25l-3.334 3.25l-3.333 -3.25z"
  }));
}
var Ab = ["size", "color", "stroke"];
function Db(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Ab);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-brand-tiktok",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M9 12a4 4 0 1 0 4 4v-12a5 5 0 0 0 5 5"
  }));
}
var Fb = ["size", "color", "stroke"];
function Gb(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Fb);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-brand-tinder",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M18.918 8.174c2.56 4.982 .501 11.656 -5.38 12.626c-7.702 1.687 -12.84 -7.716 -7.054 -13.229c.309 -.305 1.161 -1.095 1.516 -1.349c0 .528 .27 3.475 1 3.167c3 0 4 -4.222 3.587 -7.389c2.7 1.411 4.987 3.376 6.331 6.174z"
  }));
}
var Jb = ["size", "color", "stroke"];
function Kb(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Jb);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-brand-topbuzz",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M4.417 8.655a0.524 .524 0 0 1 -.405 -.622l.986 -4.617a0.524 .524 0 0 1 .626 -.404l14.958 3.162c.285 .06 .467 .339 .406 .622l-.987 4.618a0.524 .524 0 0 1 -.625 .404l-4.345 -.92c-.198 -.04 -.315 .024 -.353 .197l-2.028 9.49a0.527 .527 0 0 1 -.625 .404l-4.642 -.982a0.527 .527 0 0 1 -.406 -.622l2.028 -9.493c.037 -.17 -.031 -.274 -.204 -.31l-4.384 -.927z"
  }));
}
var Qb = ["size", "color", "stroke"];
function Rb(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Qb);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-brand-torchain",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M15.588 15.537l-3.553 -3.537l-7.742 8.18c-.791 .85 .153 2.18 1.238 1.73l9.616 -4.096a1.398 1.398 0 0 0 .44 -2.277z"
  }), e.createElement("path", {
    d: "M8.412 8.464l3.553 3.536l7.742 -8.18c.791 -.85 -.153 -2.18 -1.238 -1.73l-9.616 4.098a1.398 1.398 0 0 0 -.44 2.277z"
  }));
}
var Tb = ["size", "color", "stroke"];
function Ub(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Tb);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-brand-toyota",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("ellipse", {
    cx: 12,
    cy: 12,
    rx: 10,
    ry: 7
  }), e.createElement("path", {
    d: "M9 12c0 3.866 1.343 7 3 7s3 -3.134 3 -7s-1.343 -7 -3 -7s-3 3.134 -3 7z"
  }), e.createElement("path", {
    d: "M6.415 6.191c-.888 .503 -1.415 1.13 -1.415 1.809c0 1.657 3.134 3 7 3s7 -1.343 7 -3c0 -.678 -.525 -1.304 -1.41 -1.806"
  }));
}
var Vb = ["size", "color", "stroke"];
function Xb(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Vb);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-brand-trello",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("rect", {
    x: 4,
    y: 4,
    width: 16,
    height: 16,
    rx: 2
  }), e.createElement("path", {
    d: "M7 7h3v10h-3z"
  }), e.createElement("path", {
    d: "M14 7h3v6h-3z"
  }));
}
var Yb = ["size", "color", "stroke"];
function Zb(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Yb);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-brand-tripadvisor",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("circle", {
    cx: 6.5,
    cy: 13.5,
    r: 1.5
  }), e.createElement("circle", {
    cx: 17.5,
    cy: 13.5,
    r: 1.5
  }), e.createElement("path", {
    d: "M17.5 9a4.5 4.5 0 1 0 3.5 1.671l1 -1.671h-4.5z"
  }), e.createElement("path", {
    d: "M6.5 9a4.5 4.5 0 1 1 -3.5 1.671l-1 -1.671h4.5z"
  }), e.createElement("path", {
    d: "M10.5 15.5l1.5 2l1.5 -2"
  }), e.createElement("path", {
    d: "M9 6.75c2 -.667 4 -.667 6 0"
  }));
}
var $b = ["size", "color", "stroke"];
function _b(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, $b);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-brand-tumblr",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M14 21h4v-4h-4v-6h4v-4h-4v-4h-4v1a3 3 0 0 1 -3 3h-1v4h4v6a4 4 0 0 0 4 4"
  }));
}
var eL = ["size", "color", "stroke"];
function tL(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, eL);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-brand-twilio",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M21 12a9 9 0 1 1 -18 0a9 9 0 0 1 18 0z"
  }), e.createElement("circle", {
    cx: 9,
    cy: 9,
    r: 1
  }), e.createElement("circle", {
    cx: 15,
    cy: 9,
    r: 1
  }), e.createElement("circle", {
    cx: 15,
    cy: 15,
    r: 1
  }), e.createElement("circle", {
    cx: 9,
    cy: 15,
    r: 1
  }));
}
var oL = ["size", "color", "stroke"];
function rL(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, oL);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-brand-twitch",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M4 5v11a1 1 0 0 0 1 1h2v4l4 -4h5.584c.266 0 .52 -.105 .707 -.293l2.415 -2.414c.187 -.188 .293 -.442 .293 -.708v-8.585a1 1 0 0 0 -1 -1h-14a1 1 0 0 0 -1 1z"
  }), e.createElement("line", {
    x1: 16,
    y1: 8,
    x2: 16,
    y2: 12
  }), e.createElement("line", {
    x1: 12,
    y1: 8,
    x2: 12,
    y2: 12
  }));
}
var nL = ["size", "color", "stroke"];
function lL(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, nL);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-brand-twitter",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M22 4.01c-1 .49 -1.98 .689 -3 .99c-1.121 -1.265 -2.783 -1.335 -4.38 -.737s-2.643 2.06 -2.62 3.737v1c-3.245 .083 -6.135 -1.395 -8 -4c0 0 -4.182 7.433 4 11c-1.872 1.247 -3.739 2.088 -6 2c3.308 1.803 6.913 2.423 10.034 1.517c3.58 -1.04 6.522 -3.723 7.651 -7.742a13.84 13.84 0 0 0 .497 -3.753c-.002 -.249 1.51 -2.772 1.818 -4.013z"
  }));
}
var aL = ["size", "color", "stroke"];
function iL(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, aL);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-brand-typescript",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M15 17.5c.32 .32 .754 .5 1.207 .5h.543c.69 0 1.25 -.56 1.25 -1.25v-.25a1.5 1.5 0 0 0 -1.5 -1.5a1.5 1.5 0 0 1 -1.5 -1.5v-.25c0 -.69 .56 -1.25 1.25 -1.25h.543c.453 0 .887 .18 1.207 .5"
  }), e.createElement("path", {
    d: "M9 12h4"
  }), e.createElement("path", {
    d: "M11 12v6"
  }), e.createElement("path", {
    d: "M21 19v-14a2 2 0 0 0 -2 -2h-14a2 2 0 0 0 -2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2 -2z"
  }));
}
var cL = ["size", "color", "stroke"];
function sL(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, cL);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-brand-uber",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 9
  }), e.createElement("rect", {
    x: 9,
    y: 9,
    width: 6,
    height: 6,
    rx: 1
  }), e.createElement("path", {
    d: "M3 12h6"
  }));
}
var hL = ["size", "color", "stroke"];
function dL(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, hL);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-brand-ubuntu",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("circle", {
    cx: 12,
    cy: 5,
    r: 2
  }), e.createElement("path", {
    d: "M17.723 7.41a7.992 7.992 0 0 0 -3.74 -2.162m-3.971 0a7.993 7.993 0 0 0 -3.789 2.216m-1.881 3.215a8 8 0 0 0 -.342 2.32c0 .738 .1 1.453 .287 2.132m1.96 3.428a7.993 7.993 0 0 0 3.759 2.19m3.998 -.003a7.993 7.993 0 0 0 3.747 -2.186m1.962 -3.43a8.008 8.008 0 0 0 .287 -2.131c0 -.764 -.107 -1.503 -.307 -2.203"
  }), e.createElement("circle", {
    cx: 5,
    cy: 17,
    r: 2
  }), e.createElement("circle", {
    cx: 19,
    cy: 17,
    r: 2
  }));
}
var vL = ["size", "color", "stroke"];
function mL(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, vL);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-brand-unity",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M14 3l6 4v7"
  }), e.createElement("path", {
    d: "M18 17l-6 4l-6 -4"
  }), e.createElement("path", {
    d: "M4 14v-7l6 -4"
  }), e.createElement("path", {
    d: "M4 7l8 5v9"
  }), e.createElement("path", {
    d: "M20 7l-8 5"
  }));
}
var kL = ["size", "color", "stroke"];
function wL(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, kL);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-brand-unsplash",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M4 11h5v4h6v-4h5v9h-16zm5 -7h6v4h-6z"
  }));
}
var pL = ["size", "color", "stroke"];
function EL(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, pL);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-brand-upwork",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M3 7v5a3 3 0 0 0 6 0v-5h1l4 6c.824 1.319 1.945 2 3.5 2a3.5 3.5 0 0 0 0 -7c-2.027 0 -3.137 1.006 -3.5 3c-.242 1.33 -.908 3.996 -2 8"
  }));
}
var uL = ["size", "color", "stroke"];
function gL(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, uL);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-brand-valorant",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M14.5 14h4.5l2 -2v-6z"
  }), e.createElement("path", {
    d: "M9 19h5l-11 -13v6z"
  }));
}
var ML = ["size", "color", "stroke"];
function xL(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, ML);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-brand-vercel",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M3 19h18l-9 -15z"
  }));
}
var fL = ["size", "color", "stroke"];
function zL(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, fL);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-brand-vimeo",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M3 8.5l1 1s1.5 -1.102 2 -.5c.509 .609 1.863 7.65 2.5 9c.556 1.184 1.978 2.89 4 1.5c2 -1.5 7.5 -5.5 8.5 -11.5c.444 -2.661 -1 -4 -2.5 -4c-2 0 -4.047 1.202 -4.5 4c2.05 -1.254 2.551 1.003 1.5 3c-1.052 2.005 -2 3 -2.5 3c-.49 0 -.924 -1.165 -1.5 -3.5c-.59 -2.42 -.5 -6.5 -3 -6.5s-5.5 4.5 -5.5 4.5z"
  }));
}
var bL = ["size", "color", "stroke"];
function LL(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, bL);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-brand-vinted",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M11.028 6c0 7.695 -.292 11.728 0 12c2.046 -5.002 4.246 -12.642 5.252 -14.099c.343 -.497 .768 -.93 1.257 -1.277c.603 -.39 1.292 -.76 1.463 -.575c-.07 2.319 -4.023 15.822 -4.209 16.314a6.135 6.135 0 0 1 -3.465 3.386c-3.213 .78 -3.429 -.446 -3.836 -1.134c-.95 -2.103 -1.682 -14.26 -1.445 -15.615c.05 -.523 .143 -1.851 2.491 -2c2.359 -.354 2.547 1.404 2.492 3z"
  }));
}
var yL = ["size", "color", "stroke"];
function CL(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, yL);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-brand-visa",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M21 15l-1 -6l-2.5 6"
  }), e.createElement("path", {
    d: "M9 15l1 -6"
  }), e.createElement("path", {
    d: "M3 9h1v6h.5l2.5 -6"
  }), e.createElement("path", {
    d: "M16 9.5a0.5 .5 0 0 0 -.5 -.5h-.75c-.721 0 -1.337 .521 -1.455 1.233l-.09 .534a1.059 1.059 0 0 0 1.045 1.233a1.059 1.059 0 0 1 1.045 1.233l-.09 .534a1.476 1.476 0 0 1 -1.455 1.233h-.75a0.5 .5 0 0 1 -.5 -.5"
  }), e.createElement("path", {
    d: "M18 14h2.7"
  }));
}
var jL = ["size", "color", "stroke"];
function BL(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, jL);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-brand-visual-studio",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M4 8l2 -1l10 13l4 -2v-12l-4 -2l-10 13l-2 -1z"
  }));
}
var HL = ["size", "color", "stroke"];
function NL(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, HL);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-brand-vite",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M10 4.5l6 -1.5l-2 6.5l2 -.5l-4 7v-5l-3 1z"
  }), e.createElement("path", {
    d: "M15 6.5l7 -1.5l-10 17l-10 -17l7.741 1.5"
  }));
}
var WL = ["size", "color", "stroke"];
function qL(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, WL);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-brand-vivaldi",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M21.648 6.808c-2.468 4.28 -4.937 8.56 -7.408 12.836c-.397 .777 -1.366 1.301 -2.24 1.356c-.962 .102 -1.7 -.402 -2.154 -1.254c-1.563 -2.684 -3.106 -5.374 -4.66 -8.064c-.943 -1.633 -1.891 -3.266 -2.83 -4.905a2.47 2.47 0 0 1 -.06 -2.45a2.493 2.493 0 0 1 2.085 -1.307c.951 -.065 1.85 .438 2.287 1.281c.697 1.19 2.043 3.83 2.55 4.682a3.919 3.919 0 0 0 3.282 2.017c2.126 .133 3.974 -.95 4.21 -3.058c0 -.164 .228 -3.178 .846 -3.962c.619 -.784 1.64 -1.155 2.606 -.893a2.484 2.484 0 0 1 1.814 2.062c.08 .581 -.041 1.171 -.343 1.674"
  }));
}
var OL = ["size", "color", "stroke"];
function PL(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, OL);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-brand-vk",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M14 19h-4a8 8 0 0 1 -8 -8v-5h4v5a4 4 0 0 0 4 4h0v-9h4v4.5l.03 -.004a4.531 4.531 0 0 0 3.97 -4.496h4l-.342 1.711a6.858 6.858 0 0 1 -3.658 4.789h0a5.34 5.34 0 0 1 3.566 4.111l.434 2.389h0h-4a4.531 4.531 0 0 0 -3.97 -4.496v4.5z"
  }));
}
var SL = ["size", "color", "stroke"];
function IL(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, SL);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-brand-volkswagen",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M12 21a9 9 0 0 0 9 -9a9 9 0 0 0 -9 -9a9 9 0 0 0 -9 9a9 9 0 0 0 9 9z"
  }), e.createElement("path", {
    d: "M5 7l4.5 11l1.5 -5h2l1.5 5l4.5 -11"
  }), e.createElement("path", {
    d: "M9 4l2 6h2l2 -6"
  }));
}
var AL = ["size", "color", "stroke"];
function DL(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, AL);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-brand-vsco",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M21 12a9 9 0 1 1 -18 0a9 9 0 0 1 18 0z"
  }), e.createElement("path", {
    d: "M17 12a5 5 0 1 0 -10 0a5 5 0 0 0 10 0z"
  }), e.createElement("path", {
    d: "M12 3v4"
  }), e.createElement("path", {
    d: "M21 12h-4"
  }), e.createElement("path", {
    d: "M12 21v-4"
  }), e.createElement("path", {
    d: "M3 12h4"
  }), e.createElement("path", {
    d: "M18.364 5.636l-2.828 2.828"
  }), e.createElement("path", {
    d: "M18.364 18.364l-2.828 -2.828"
  }), e.createElement("path", {
    d: "M5.636 18.364l2.828 -2.828"
  }), e.createElement("path", {
    d: "M5.636 5.636l2.828 2.828"
  }));
}
var FL = ["size", "color", "stroke"];
function GL(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, FL);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-brand-vscode",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M16 3v18l4 -2.5v-13z"
  }), e.createElement("path", {
    d: "M9.165 13.903l-4.165 3.597l-2 -1l4.333 -4.5m1.735 -1.802l6.932 -7.198v5l-4.795 4.141"
  }), e.createElement("path", {
    d: "M16 16.5l-11 -10l-2 1l13 13.5"
  }));
}
var JL = ["size", "color", "stroke"];
function KL(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, JL);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-brand-vue",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M16.5 4l-4.5 8l-4.5 -8"
  }), e.createElement("path", {
    d: "M3 4l9 16l9 -16"
  }));
}
var QL = ["size", "color", "stroke"];
function RL(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, QL);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-brand-walmart",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M12 8.04v-5.04"
  }), e.createElement("path", {
    d: "M15.5 10l4.5 -2.5"
  }), e.createElement("path", {
    d: "M15.5 14l4.5 2.5"
  }), e.createElement("path", {
    d: "M12 15.96v5.04"
  }), e.createElement("path", {
    d: "M8.5 14l-4.5 2.5"
  }), e.createElement("path", {
    d: "M8.5 10l-4.5 -2.505"
  }));
}
var TL = ["size", "color", "stroke"];
function UL(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, TL);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-brand-waze",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M6.66 17.52a7 7 0 0 1 -3.66 -4.52c2 0 3 -1 3 -2.51c0 -3.92 2.25 -7.49 7.38 -7.49c4.62 0 7.62 3.51 7.62 8a8.08 8.08 0 0 1 -3.39 6.62"
  }), e.createElement("path", {
    d: "M10 18.69a17.29 17.29 0 0 0 3.33 .3h.54"
  }), e.createElement("circle", {
    cx: 16,
    cy: 19,
    r: 2
  }), e.createElement("circle", {
    cx: 8,
    cy: 19,
    r: 2
  }), e.createElement("path", {
    d: "M16 9h.01"
  }), e.createElement("path", {
    d: "M11 9h.01"
  }));
}
var VL = ["size", "color", "stroke"];
function XL(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, VL);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-brand-webflow",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M17 10s-1.376 3.606 -1.5 4c-.046 -.4 -1.5 -8 -1.5 -8c-2.627 0 -3.766 1.562 -4.5 3.5c0 0 -1.843 4.593 -2 5c-.013 -.368 -.5 -4.5 -.5 -4.5c-.15 -2.371 -2.211 -3.98 -4 -3.98l2 12.98c2.745 -.013 4.72 -1.562 5.5 -3.5c0 0 1.44 -4.3 1.5 -4.5c.013 .18 1 8 1 8c2.758 0 4.694 -1.626 5.5 -3.5l3.5 -9.5c-2.732 -.006 -4.253 2.055 -5 4z"
  }));
}
var YL = ["size", "color", "stroke"];
function ZL(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, YL);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-brand-wechat",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M16.5 10c3.038 0 5.5 2.015 5.5 4.5c0 1.397 -.778 2.645 -1.999 3.47l-.001 2.03l-1.964 -1.178a6.649 6.649 0 0 1 -1.536 .178c-3.038 0 -5.5 -2.015 -5.5 -4.5s2.462 -4.5 5.5 -4.5z"
  }), e.createElement("path", {
    d: "M11.197 15.698c-.69 .196 -1.43 .302 -2.197 .302a8.008 8.008 0 0 1 -2.612 -.432l-2.388 1.432v-2.801c-1.237 -1.082 -2 -2.564 -2 -4.199c0 -3.314 3.134 -6 7 -6c3.782 0 6.863 2.57 6.996 5.785l.004 .233"
  }), e.createElement("path", {
    d: "M10 8h.01"
  }), e.createElement("path", {
    d: "M7 8h.01"
  }), e.createElement("path", {
    d: "M15 14h.01"
  }), e.createElement("path", {
    d: "M18 14h.01"
  }));
}
var $L = ["size", "color", "stroke"];
function _L(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, $L);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-brand-weibo",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M19 14.127c0 3.073 -3.502 5.873 -8 5.873c-4.126 0 -8 -2.224 -8 -5.565c0 -1.78 .984 -3.737 2.7 -5.567c2.362 -2.51 5.193 -3.687 6.551 -2.238c.415 .44 .752 1.39 .749 2.062c2 -1.615 4.308 .387 3.5 2.693c1.26 .557 2.5 .538 2.5 2.742z"
  }), e.createElement("path", {
    d: "M15 4h1a5 5 0 0 1 5 5v1"
  }));
}
var ey = ["size", "color", "stroke"];
function ty(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, ey);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-brand-whatsapp",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M3 21l1.65 -3.8a9 9 0 1 1 3.4 2.9l-5.05 .9"
  }), e.createElement("path", {
    d: "M9 10a0.5 .5 0 0 0 1 0v-1a0.5 .5 0 0 0 -1 0v1a5 5 0 0 0 5 5h1a0.5 .5 0 0 0 0 -1h-1a0.5 .5 0 0 0 0 1"
  }));
}
var oy = ["size", "color", "stroke"];
function ry(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, oy);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-brand-windows",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M17.8 20l-12 -1.5c-1 -.1 -1.8 -.9 -1.8 -1.9v-9.2c0 -1 .8 -1.8 1.8 -1.9l12 -1.5c1.2 -.1 2.2 .8 2.2 1.9v12.1c0 1.2 -1.1 2.1 -2.2 1.9z"
  }), e.createElement("line", {
    x1: 12,
    y1: 5,
    x2: 12,
    y2: 19
  }), e.createElement("line", {
    x1: 4,
    y1: 12,
    x2: 20,
    y2: 12
  }));
}
var ny = ["size", "color", "stroke"];
function ly(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, ny);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-brand-windy",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M9 4c0 5.5 -.33 16 4 16s7.546 -11.27 8 -13"
  }), e.createElement("path", {
    d: "M3 4c.253 5.44 1.449 16 5.894 16c4.444 0 8.42 -10.036 9.106 -14"
  }));
}
var ay = ["size", "color", "stroke"];
function iy(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, ay);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-brand-wish",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M2 6l5.981 2.392l-.639 6.037c-.18 .893 .06 1.819 .65 2.514a3 3 0 0 0 2.381 1.057a4.328 4.328 0 0 0 4.132 -3.57c-.18 .893 .06 1.819 .65 2.514a3 3 0 0 0 2.38 1.056a4.328 4.328 0 0 0 4.132 -3.57l.333 -4.633"
  }), e.createElement("path", {
    d: "M14.504 14.429l.334 -2.999"
  }));
}
var cy = ["size", "color", "stroke"];
function sy(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, cy);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-brand-wix",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M3 9l1.5 6l1.379 -5.515a0.64 .64 0 0 1 1.242 0l1.379 5.515l1.5 -6"
  }), e.createElement("path", {
    d: "M13 11.5v3.5"
  }), e.createElement("path", {
    d: "M16 9l5 6"
  }), e.createElement("path", {
    d: "M21 9l-5 6"
  }), e.createElement("path", {
    d: "M13 9h.01"
  }));
}
var hy = ["size", "color", "stroke"];
function dy(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, hy);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-brand-wordpress",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M9.5 9h3"
  }), e.createElement("path", {
    d: "M4 9h2.5"
  }), e.createElement("path", {
    d: "M11 9l3 11l4 -9"
  }), e.createElement("path", {
    d: "M5.5 9l3.5 11l3 -7"
  }), e.createElement("path", {
    d: "M18 11c.177 -.528 1 -1.364 1 -2.5c0 -1.78 -.776 -2.5 -1.875 -2.5c-.898 0 -1.125 .812 -1.125 1.429c0 1.83 2 2.058 2 3.571z"
  }), e.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 9
  }));
}
var vy = ["size", "color", "stroke"];
function my(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, vy);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-brand-xbox",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 9
  }), e.createElement("path", {
    d: "M6.5 5c7.72 2.266 10.037 7.597 12.5 12.5"
  }), e.createElement("path", {
    d: "M17.5 5c-7.72 2.266 -10.037 7.597 -12.5 12.5"
  }));
}
var ky = ["size", "color", "stroke"];
function wy(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, ky);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-brand-xing",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M16 21l-4 -7l6.5 -11"
  }), e.createElement("path", {
    d: "M7 7l2 3.5l-3 4.5"
  }));
}
var py = ["size", "color", "stroke"];
function Ey(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, py);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-brand-yahoo",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("line", {
    x1: 3,
    y1: 6,
    x2: 8,
    y2: 6
  }), e.createElement("line", {
    x1: 7,
    y1: 18,
    x2: 14,
    y2: 18
  }), e.createElement("path", {
    d: "M4.5 6l5.5 7v5"
  }), e.createElement("path", {
    d: "M10 13l6 -5"
  }), e.createElement("line", {
    x1: 12.5,
    y1: 8,
    x2: 17.5,
    y2: 8
  }), e.createElement("line", {
    x1: 20,
    y1: 11,
    x2: 20,
    y2: 15
  }), e.createElement("line", {
    x1: 20,
    y1: 18,
    x2: 20,
    y2: 18.01
  }));
}
var uy = ["size", "color", "stroke"];
function gy(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, uy);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-brand-yatse",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M7.002 3l4.998 2.876v5.088l4.197 -2.73l4.803 2.731l-9.281 5.478l-2.383 1.41l-2.334 1.377l-3.002 1.77v-5.565l3.002 -1.771z"
  }));
}
var My = ["size", "color", "stroke"];
function xy(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, My);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-brand-ycombinator",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("rect", {
    x: 4,
    y: 4,
    width: 16,
    height: 16,
    rx: 2
  }), e.createElement("path", {
    d: "M8 7.002l4 5.998l4 -6"
  }), e.createElement("line", {
    x1: 12,
    y1: 17,
    x2: 12,
    y2: 13
  }));
}
var fy = ["size", "color", "stroke"];
function zy(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, fy);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-brand-youtube-kids",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M17.782 17.03l-3.413 .235l-.023 .002c-1.117 .09 -2.214 .335 -3.257 .725l-2.197 .794a3.597 3.597 0 0 1 -2.876 -.189a3.342 3.342 0 0 1 -1.732 -2.211l-1.204 -5.293a3.21 3.21 0 0 1 .469 -2.503a3.468 3.468 0 0 1 2.177 -1.452l9.843 -2.06c1.87 -.392 3.716 .744 4.124 2.537l1.227 5.392a3.217 3.217 0 0 1 -.61 2.7a3.506 3.506 0 0 1 -2.528 1.323z"
  }), e.createElement("path", {
    d: "M10 10l.972 4l4.028 -3z"
  }));
}
var by = ["size", "color", "stroke"];
function Ly(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, by);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-brand-youtube",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("rect", {
    x: 3,
    y: 5,
    width: 18,
    height: 14,
    rx: 4
  }), e.createElement("path", {
    d: "M10 9l5 3l-5 3z"
  }));
}
var yy = ["size", "color", "stroke"];
function Cy(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, yy);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-brand-zalando",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M7.531 21c-.65 0 -1.004 -.15 -1.196 -.27c-.266 -.157 -.753 -.563 -1.197 -1.747a20.583 20.583 0 0 1 -1.137 -6.983c.015 -2.745 .436 -5.07 1.137 -6.975c.444 -1.2 .93 -1.605 1.197 -1.763c.192 -.103 .545 -.262 1.195 -.262c.244 0 .532 .022 .871 .075a19.093 19.093 0 0 1 6.425 2.475h.007a19.572 19.572 0 0 1 5.287 4.508c.783 .99 .879 1.627 .879 1.942c0 .315 -.096 .953 -.879 1.943a19.571 19.571 0 0 1 -5.287 4.5h-.007a19.041 19.041 0 0 1 -6.425 2.474a5.01 5.01 0 0 1 -.871 .083z"
  }));
}
var jy = ["size", "color", "stroke"];
function By(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, jy);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-brand-zapier",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M3 12h6"
  }), e.createElement("path", {
    d: "M21 12h-6"
  }), e.createElement("path", {
    d: "M12 3v6"
  }), e.createElement("path", {
    d: "M12 15v6"
  }), e.createElement("path", {
    d: "M5.636 5.636l4.243 4.243"
  }), e.createElement("path", {
    d: "M18.364 18.364l-4.243 -4.243"
  }), e.createElement("path", {
    d: "M18.364 5.636l-4.243 4.243"
  }), e.createElement("path", {
    d: "M9.879 14.121l-4.243 4.243"
  }));
}
var Hy = ["size", "color", "stroke"];
function Ny(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Hy);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-brand-zeit",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M3 20h18l-9 -16z"
  }));
}
var Wy = ["size", "color", "stroke"];
function qy(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Wy);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-brand-zhihu",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M14 6h6v12h-2l-2 2l-1 -2h-1z"
  }), e.createElement("path", {
    d: "M4 12h6.5"
  }), e.createElement("path", {
    d: "M10.5 6h-5"
  }), e.createElement("path", {
    d: "M6 4c-.5 2.5 -1.5 3.5 -2.5 4.5"
  }), e.createElement("path", {
    d: "M8 6v7c0 4.5 -2 5.5 -4 7"
  }), e.createElement("path", {
    d: "M11 18l-3 -5"
  }));
}
var Oy = ["size", "color", "stroke"];
function Py(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Oy);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-brand-zoom",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M17.011 9.385v5.128l3.989 3.487v-12z"
  }), e.createElement("path", {
    d: "M3.887 6h10.08c1.468 0 3.033 1.203 3.033 2.803v8.196a0.991 .991 0 0 1 -.975 1.001h-10.373c-1.667 0 -2.652 -1.5 -2.652 -3l.01 -8.002a0.882 .882 0 0 1 .208 -.71a0.841 .841 0 0 1 .67 -.287z"
  }));
}
var Sy = ["size", "color", "stroke"];
function Iy(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Sy);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-brand-zulip",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M6.5 3h11c1.325 0 2.5 1 2.5 2.5c0 2 -1.705 3.264 -2 3.5l-4.5 4l2 -5h-9a2.5 2.5 0 0 1 0 -5z"
  }), e.createElement("path", {
    d: "M17.5 21h-11c-1.325 0 -2.5 -1 -2.5 -2.5c0 -2 1.705 -3.264 2 -3.5l4.5 -4l-2 5h9a2.5 2.5 0 1 1 0 5z"
  }));
}
var Ay = ["size", "color", "stroke"];
function Dy(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Ay);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-brand-zwift",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M5.5 4c-1.465 0 -2.5 1.101 -2.5 2.5s1.035 2.5 2.5 2.5h2.5l-4.637 7.19a2.434 2.434 0 0 0 -.011 2.538c.473 .787 1.35 1.272 2.3 1.272h10.848c1.465 0 2.5 -1.101 2.5 -2.5s-1.035 -2.5 -2.5 -2.5h-2.5l7 -11h-15.5z"
  }));
}
var Fy = ["size", "color", "stroke"];
function Gy(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Fy);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-bread-off",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M18.415 18.414a1.994 1.994 0 0 1 -1.415 .586h-10a2 2 0 0 1 -2 -2v-6.764a3 3 0 0 1 .435 -4.795m3.565 -.441h8a3 3 0 0 1 2 5.235v4.765"
  }), e.createElement("path", {
    d: "M3 3l18 18"
  }));
}
var Jy = ["size", "color", "stroke"];
function Ky(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Jy);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-bread",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M17 5a3 3 0 0 1 2 5.235v6.765a2 2 0 0 1 -2 2h-10a2 2 0 0 1 -2 -2v-6.764a3 3 0 0 1 1.824 -5.231l.176 -.005h10z"
  }));
}
var Qy = ["size", "color", "stroke"];
function Ry(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Qy);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-briefcase-off",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M11 7h8a2 2 0 0 1 2 2v8m-1.166 2.818a1.993 1.993 0 0 1 -.834 .182h-14a2 2 0 0 1 -2 -2v-9a2 2 0 0 1 2 -2h2"
  }), e.createElement("path", {
    d: "M8.185 4.158a2 2 0 0 1 1.815 -1.158h4a2 2 0 0 1 2 2v2"
  }), e.createElement("path", {
    d: "M12 12v.01"
  }), e.createElement("path", {
    d: "M3 13a19.998 19.998 0 0 0 11.905 1.928m3.263 -.763a20.003 20.003 0 0 0 2.832 -1.165"
  }), e.createElement("path", {
    d: "M3 3l18 18"
  }));
}
var Ty = ["size", "color", "stroke"];
function Uy(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Ty);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-briefcase",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("rect", {
    x: 3,
    y: 7,
    width: 18,
    height: 13,
    rx: 2
  }), e.createElement("path", {
    d: "M8 7v-2a2 2 0 0 1 2 -2h4a2 2 0 0 1 2 2v2"
  }), e.createElement("line", {
    x1: 12,
    y1: 12,
    x2: 12,
    y2: 12.01
  }), e.createElement("path", {
    d: "M3 13a20 20 0 0 0 18 0"
  }));
}
var Vy = ["size", "color", "stroke"];
function Xy(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Vy);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-brightness-2",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 3
  }), e.createElement("path", {
    d: "M6 6h3.5l2.5 -2.5l2.5 2.5h3.5v3.5l2.5 2.5l-2.5 2.5v3.5h-3.5l-2.5 2.5l-2.5 -2.5h-3.5v-3.5l-2.5 -2.5l2.5 -2.5z"
  }));
}
var Yy = ["size", "color", "stroke"];
function Zy(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Yy);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-brightness-down",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 3
  }), e.createElement("line", {
    x1: 12,
    y1: 5,
    x2: 12,
    y2: 5.01
  }), e.createElement("line", {
    x1: 17,
    y1: 7,
    x2: 17,
    y2: 7.01
  }), e.createElement("line", {
    x1: 19,
    y1: 12,
    x2: 19,
    y2: 12.01
  }), e.createElement("line", {
    x1: 17,
    y1: 17,
    x2: 17,
    y2: 17.01
  }), e.createElement("line", {
    x1: 12,
    y1: 19,
    x2: 12,
    y2: 19.01
  }), e.createElement("line", {
    x1: 7,
    y1: 17,
    x2: 7,
    y2: 17.01
  }), e.createElement("line", {
    x1: 5,
    y1: 12,
    x2: 5,
    y2: 12.01
  }), e.createElement("line", {
    x1: 7,
    y1: 7,
    x2: 7,
    y2: 7.01
  }));
}
var $y = ["size", "color", "stroke"];
function _y(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, $y);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-brightness-half",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M12 9a3 3 0 0 0 0 6v-6z"
  }), e.createElement("path", {
    d: "M6 6h3.5l2.5 -2.5l2.5 2.5h3.5v3.5l2.5 2.5l-2.5 2.5v3.5h-3.5l-2.5 2.5l-2.5 -2.5h-3.5v-3.5l-2.5 -2.5l2.5 -2.5z"
  }));
}
var eC = ["size", "color", "stroke"];
function tC(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, eC);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-brightness-off",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M12 3v5m0 4v9"
  }), e.createElement("path", {
    d: "M5.641 5.631a9 9 0 1 0 12.719 12.738m1.68 -2.318a9 9 0 0 0 -12.074 -12.098"
  }), e.createElement("path", {
    d: "M12.5 8.5l4.15 -4.15"
  }), e.createElement("path", {
    d: "M12 14l1.025 -.983m2.065 -1.981l4.28 -4.106"
  }), e.createElement("path", {
    d: "M12 19.6l3.79 -3.79m2.006 -2.006l3.054 -3.054"
  }), e.createElement("path", {
    d: "M3 3l18 18"
  }));
}
var oC = ["size", "color", "stroke"];
function rC(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, oC);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-brightness-up",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 3
  }), e.createElement("line", {
    x1: 12,
    y1: 5,
    x2: 12,
    y2: 3
  }), e.createElement("line", {
    x1: 17,
    y1: 7,
    x2: 18.4,
    y2: 5.6
  }), e.createElement("line", {
    x1: 19,
    y1: 12,
    x2: 21,
    y2: 12
  }), e.createElement("line", {
    x1: 17,
    y1: 17,
    x2: 18.4,
    y2: 18.4
  }), e.createElement("line", {
    x1: 12,
    y1: 19,
    x2: 12,
    y2: 21
  }), e.createElement("line", {
    x1: 7,
    y1: 17,
    x2: 5.6,
    y2: 18.4
  }), e.createElement("line", {
    x1: 6,
    y1: 12,
    x2: 4,
    y2: 12
  }), e.createElement("line", {
    x1: 7,
    y1: 7,
    x2: 5.6,
    y2: 5.6
  }));
}
var nC = ["size", "color", "stroke"];
function lC(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, nC);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-brightness",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 9
  }), e.createElement("line", {
    x1: 12,
    y1: 3,
    x2: 12,
    y2: 21
  }), e.createElement("line", {
    x1: 12,
    y1: 9,
    x2: 16.65,
    y2: 4.35
  }), e.createElement("line", {
    x1: 12,
    y1: 14.3,
    x2: 19.37,
    y2: 6.93
  }), e.createElement("line", {
    x1: 12,
    y1: 19.6,
    x2: 20.85,
    y2: 10.75
  }));
}
var aC = ["size", "color", "stroke"];
function iC(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, aC);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-broadcast-off",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M18.364 19.364a9 9 0 0 0 -9.721 -14.717m-2.488 1.509a9 9 0 0 0 -.519 13.208"
  }), e.createElement("path", {
    d: "M15.536 16.536a5 5 0 0 0 -3.536 -8.536m-3.001 1a5 5 0 0 0 -.535 7.536"
  }), e.createElement("path", {
    d: "M12 12a1 1 0 1 0 1 1"
  }), e.createElement("path", {
    d: "M3 3l18 18"
  }));
}
var cC = ["size", "color", "stroke"];
function sC(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, cC);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-broadcast",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M18.364 19.364a9 9 0 1 0 -12.728 0"
  }), e.createElement("path", {
    d: "M15.536 16.536a5 5 0 1 0 -7.072 0"
  }), e.createElement("circle", {
    cx: 12,
    cy: 13,
    r: 1
  }));
}
var hC = ["size", "color", "stroke"];
function dC(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, hC);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-browser-check",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("rect", {
    x: 4,
    y: 4,
    width: 16,
    height: 16,
    rx: 1
  }), e.createElement("path", {
    d: "M4 8h16"
  }), e.createElement("path", {
    d: "M8 4v4"
  }), e.createElement("path", {
    d: "M9.5 14.5l1.5 1.5l3 -3"
  }));
}
var vC = ["size", "color", "stroke"];
function mC(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, vC);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-browser-off",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M8 4h11a1 1 0 0 1 1 1v11m-.288 3.702a0.997 .997 0 0 1 -.712 .298h-14a1 1 0 0 1 -1 -1v-14c0 -.276 .112 -.526 .293 -.707"
  }), e.createElement("path", {
    d: "M4 8h4m4 0h8"
  }), e.createElement("path", {
    d: "M3 3l18 18"
  }));
}
var kC = ["size", "color", "stroke"];
function wC(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, kC);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-browser-plus",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("rect", {
    x: 4,
    y: 4,
    width: 16,
    height: 16,
    rx: 1
  }), e.createElement("path", {
    d: "M4 8h16"
  }), e.createElement("path", {
    d: "M8 4v4"
  }), e.createElement("path", {
    d: "M10 14h4"
  }), e.createElement("path", {
    d: "M12 12v4"
  }));
}
var pC = ["size", "color", "stroke"];
function EC(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, pC);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-browser-x",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("rect", {
    x: 4,
    y: 4,
    width: 16,
    height: 16,
    rx: 1
  }), e.createElement("path", {
    d: "M4 8h16"
  }), e.createElement("path", {
    d: "M8 4v4"
  }), e.createElement("path", {
    d: "M10 16l4 -4"
  }), e.createElement("path", {
    d: "M14 16l-4 -4"
  }));
}
var uC = ["size", "color", "stroke"];
function gC(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, uC);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-browser",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("rect", {
    x: 4,
    y: 4,
    width: 16,
    height: 16,
    rx: 1
  }), e.createElement("line", {
    x1: 4,
    y1: 8,
    x2: 20,
    y2: 8
  }), e.createElement("line", {
    x1: 8,
    y1: 4,
    x2: 8,
    y2: 8
  }));
}
var MC = ["size", "color", "stroke"];
function xC(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, MC);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-brush-off",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M3 17a4 4 0 1 1 4 4h-4v-4z"
  }), e.createElement("path", {
    d: "M21 3a15.996 15.996 0 0 0 -9.309 4.704m-1.795 2.212a15.993 15.993 0 0 0 -1.696 3.284"
  }), e.createElement("path", {
    d: "M21 3a15.996 15.996 0 0 1 -4.697 9.302m-2.195 1.786a15.993 15.993 0 0 1 -3.308 1.712"
  }), e.createElement("path", {
    d: "M3 3l18 18"
  }));
}
var fC = ["size", "color", "stroke"];
function zC(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, fC);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-brush",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M3 21v-4a4 4 0 1 1 4 4h-4"
  }), e.createElement("path", {
    d: "M21 3a16 16 0 0 0 -12.8 10.2"
  }), e.createElement("path", {
    d: "M21 3a16 16 0 0 1 -10.2 12.8"
  }), e.createElement("path", {
    d: "M10.6 9a9 9 0 0 1 4.4 4.4"
  }));
}
var bC = ["size", "color", "stroke"];
function LC(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, bC);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-bucket-droplet",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M5 16l1.465 1.638a2 2 0 1 1 -3.015 .099l1.55 -1.737z"
  }), e.createElement("path", {
    d: "M13.737 9.737c2.299 -2.3 3.23 -5.095 2.081 -6.245c-1.15 -1.15 -3.945 -.217 -6.244 2.082c-2.3 2.299 -3.231 5.095 -2.082 6.244c1.15 1.15 3.946 .218 6.245 -2.081z"
  }), e.createElement("path", {
    d: "M7.492 11.818c.362 .362 .768 .676 1.208 .934l6.895 4.047c1.078 .557 2.255 -.075 3.692 -1.512c1.437 -1.437 2.07 -2.614 1.512 -3.692c-.372 -.718 -1.72 -3.017 -4.047 -6.895a6.015 6.015 0 0 0 -.934 -1.208"
  }));
}
var yC = ["size", "color", "stroke"];
function CC(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, yC);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-bucket-off",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M5.029 5.036c-.655 .58 -1.029 1.25 -1.029 1.964c0 2.033 3.033 3.712 6.96 3.967m3.788 -.21c3.064 -.559 5.252 -2.029 5.252 -3.757c0 -2.21 -3.582 -4 -8 -4c-1.605 0 -3.1 .236 -4.352 .643"
  }), e.createElement("path", {
    d: "M4 7c0 .664 .088 1.324 .263 1.965l2.737 10.035c.5 1.5 2.239 2 5 2s4.5 -.5 5 -2c.1 -.3 .252 -.812 .457 -1.535m.862 -3.146c.262 -.975 .735 -2.76 1.418 -5.354a7.45 7.45 0 0 0 .263 -1.965"
  }), e.createElement("path", {
    d: "M3 3l18 18"
  }));
}
var jC = ["size", "color", "stroke"];
function BC(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, jC);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-bucket",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("ellipse", {
    cx: 12,
    cy: 7,
    rx: 8,
    ry: 4
  }), e.createElement("path", {
    d: "M4 7c0 .664 .088 1.324 .263 1.965l2.737 10.035c.5 1.5 2.239 2 5 2s4.5 -.5 5 -2c.333 -1 1.246 -4.345 2.737 -10.035a7.45 7.45 0 0 0 .263 -1.965"
  }));
}
var HC = ["size", "color", "stroke"];
function NC(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, HC);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-bug-off",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M9.884 5.873a3 3 0 0 1 5.116 2.127v1"
  }), e.createElement("path", {
    d: "M13 9h3a6 6 0 0 1 1 3v1m-.298 3.705a5.002 5.002 0 0 1 -9.702 -1.705v-3a6 6 0 0 1 1 -3h1"
  }), e.createElement("path", {
    d: "M3 13h4"
  }), e.createElement("path", {
    d: "M17 13h4"
  }), e.createElement("path", {
    d: "M12 20v-6"
  }), e.createElement("path", {
    d: "M4 19l3.35 -2"
  }), e.createElement("path", {
    d: "M4 7l3.75 2.4"
  }), e.createElement("path", {
    d: "M20 7l-3.75 2.4"
  }), e.createElement("path", {
    d: "M3 3l18 18"
  }));
}
var WC = ["size", "color", "stroke"];
function qC(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, WC);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-bug",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M9 9v-1a3 3 0 0 1 6 0v1"
  }), e.createElement("path", {
    d: "M8 9h8a6 6 0 0 1 1 3v3a5 5 0 0 1 -10 0v-3a6 6 0 0 1 1 -3"
  }), e.createElement("line", {
    x1: 3,
    y1: 13,
    x2: 7,
    y2: 13
  }), e.createElement("line", {
    x1: 17,
    y1: 13,
    x2: 21,
    y2: 13
  }), e.createElement("line", {
    x1: 12,
    y1: 20,
    x2: 12,
    y2: 14
  }), e.createElement("line", {
    x1: 4,
    y1: 19,
    x2: 7.35,
    y2: 17
  }), e.createElement("line", {
    x1: 20,
    y1: 19,
    x2: 16.65,
    y2: 17
  }), e.createElement("line", {
    x1: 4,
    y1: 7,
    x2: 7.75,
    y2: 9.4
  }), e.createElement("line", {
    x1: 20,
    y1: 7,
    x2: 16.25,
    y2: 9.4
  }));
}
var OC = ["size", "color", "stroke"];
function PC(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, OC);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-building-arch",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("line", {
    x1: 3,
    y1: 21,
    x2: 21,
    y2: 21
  }), e.createElement("path", {
    d: "M4 21v-15a2 2 0 0 1 2 -2h12a2 2 0 0 1 2 2v15"
  }), e.createElement("path", {
    d: "M9 21v-8a3 3 0 0 1 6 0v8"
  }));
}
var SC = ["size", "color", "stroke"];
function IC(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, SC);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-building-bank",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("line", {
    x1: 3,
    y1: 21,
    x2: 21,
    y2: 21
  }), e.createElement("line", {
    x1: 3,
    y1: 10,
    x2: 21,
    y2: 10
  }), e.createElement("polyline", {
    points: "5 6 12 3 19 6"
  }), e.createElement("line", {
    x1: 4,
    y1: 10,
    x2: 4,
    y2: 21
  }), e.createElement("line", {
    x1: 20,
    y1: 10,
    x2: 20,
    y2: 21
  }), e.createElement("line", {
    x1: 8,
    y1: 14,
    x2: 8,
    y2: 17
  }), e.createElement("line", {
    x1: 12,
    y1: 14,
    x2: 12,
    y2: 17
  }), e.createElement("line", {
    x1: 16,
    y1: 14,
    x2: 16,
    y2: 17
  }));
}
var AC = ["size", "color", "stroke"];
function DC(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, AC);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-building-bridge-2",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M6 7h12a2 2 0 0 1 2 2v9a1 1 0 0 1 -1 1h-2a1 1 0 0 1 -1 -1v-2a4 4 0 0 0 -8 0v2a1 1 0 0 1 -1 1h-2a1 1 0 0 1 -1 -1v-9a2 2 0 0 1 2 -2"
  }));
}
var FC = ["size", "color", "stroke"];
function GC(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, FC);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-building-bridge",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("line", {
    x1: 6,
    y1: 5,
    x2: 6,
    y2: 19
  }), e.createElement("line", {
    x1: 18,
    y1: 5,
    x2: 18,
    y2: 19
  }), e.createElement("line", {
    x1: 2,
    y1: 15,
    x2: 22,
    y2: 15
  }), e.createElement("path", {
    d: "M3 8a7.5 7.5 0 0 0 3 -2a6.5 6.5 0 0 0 12 0a7.5 7.5 0 0 0 3 2"
  }), e.createElement("line", {
    x1: 12,
    y1: 10,
    x2: 12,
    y2: 15
  }));
}
var JC = ["size", "color", "stroke"];
function KC(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, JC);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-building-broadcast-tower",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 1
  }), e.createElement("path", {
    d: "M16.616 13.924a5 5 0 1 0 -9.23 .004"
  }), e.createElement("path", {
    d: "M20.307 15.469a9 9 0 1 0 -16.615 0"
  }), e.createElement("path", {
    d: "M9 21l3 -9l3 9"
  }), e.createElement("path", {
    d: "M10 19h4"
  }));
}
var QC = ["size", "color", "stroke"];
function RC(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, QC);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-building-carousel",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 6
  }), e.createElement("circle", {
    cx: 5,
    cy: 8,
    r: 2
  }), e.createElement("circle", {
    cx: 12,
    cy: 4,
    r: 2
  }), e.createElement("circle", {
    cx: 19,
    cy: 8,
    r: 2
  }), e.createElement("circle", {
    cx: 5,
    cy: 16,
    r: 2
  }), e.createElement("circle", {
    cx: 19,
    cy: 16,
    r: 2
  }), e.createElement("path", {
    d: "M8 22l4 -10l4 10"
  }));
}
var TC = ["size", "color", "stroke"];
function UC(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, TC);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-building-castle",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M15 19v-2a3 3 0 0 0 -6 0v2a1 1 0 0 1 -1 1h-4a1 1 0 0 1 -1 -1v-14h4v3h3v-3h4v3h3v-3h4v14a1 1 0 0 1 -1 1h-4a1 1 0 0 1 -1 -1z"
  }), e.createElement("line", {
    x1: 3,
    y1: 11,
    x2: 21,
    y2: 11
  }));
}
var VC = ["size", "color", "stroke"];
function XC(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, VC);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-building-church",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("line", {
    x1: 3,
    y1: 21,
    x2: 21,
    y2: 21
  }), e.createElement("path", {
    d: "M10 21v-4a2 2 0 0 1 4 0v4"
  }), e.createElement("line", {
    x1: 10,
    y1: 5,
    x2: 14,
    y2: 5
  }), e.createElement("line", {
    x1: 12,
    y1: 3,
    x2: 12,
    y2: 8
  }), e.createElement("path", {
    d: "M6 21v-7m-2 2l8 -8l8 8m-2 -2v7"
  }));
}
var YC = ["size", "color", "stroke"];
function ZC(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, YC);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-building-circus",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M4 11h16"
  }), e.createElement("path", {
    d: "M12 6.5c0 1 -5 4.5 -8 4.5"
  }), e.createElement("path", {
    d: "M12 6.5c0 1 5 4.5 8 4.5"
  }), e.createElement("path", {
    d: "M6 11c-.333 5.333 -1 8.667 -2 10h4c1 0 4 -4 4 -9v-1"
  }), e.createElement("path", {
    d: "M18 11c.333 5.333 1 8.667 2 10h-4c-1 0 -4 -4 -4 -9v-1"
  }), e.createElement("path", {
    d: "M12 7v-4l2 1h-2"
  }));
}
var $C = ["size", "color", "stroke"];
function _C(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, $C);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-building-community",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M8 9l5 5v7h-5v-4m0 4h-5v-7l5 -5m1 1v-6a1 1 0 0 1 1 -1h10a1 1 0 0 1 1 1v17h-8"
  }), e.createElement("line", {
    x1: 13,
    y1: 7,
    x2: 13,
    y2: 7.01
  }), e.createElement("line", {
    x1: 17,
    y1: 7,
    x2: 17,
    y2: 7.01
  }), e.createElement("line", {
    x1: 17,
    y1: 11,
    x2: 17,
    y2: 11.01
  }), e.createElement("line", {
    x1: 17,
    y1: 15,
    x2: 17,
    y2: 15.01
  }));
}
var ej = ["size", "color", "stroke"];
function tj(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, ej);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-building-cottage",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("line", {
    x1: 3,
    y1: 21,
    x2: 21,
    y2: 21
  }), e.createElement("path", {
    d: "M4 21v-11l2.5 -4.5l5.5 -2.5l5.5 2.5l2.5 4.5v11"
  }), e.createElement("circle", {
    cx: 12,
    cy: 9,
    r: 2
  }), e.createElement("path", {
    d: "M9 21v-5a1 1 0 0 1 1 -1h4a1 1 0 0 1 1 1v5"
  }));
}
var oj = ["size", "color", "stroke"];
function rj(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, oj);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-building-estate",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M3 21h18"
  }), e.createElement("path", {
    d: "M19 21v-4"
  }), e.createElement("path", {
    d: "M19 17a2 2 0 0 0 2 -2v-2a2 2 0 1 0 -4 0v2a2 2 0 0 0 2 2z"
  }), e.createElement("path", {
    d: "M14 21v-14a3 3 0 0 0 -3 -3h-4a3 3 0 0 0 -3 3v14"
  }), e.createElement("path", {
    d: "M9 17v4"
  }), e.createElement("path", {
    d: "M8 13h2"
  }), e.createElement("path", {
    d: "M8 9h2"
  }));
}
var nj = ["size", "color", "stroke"];
function lj(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, nj);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-building-factory-2",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M3 21h18"
  }), e.createElement("path", {
    d: "M5 21v-12l5 4v-4l5 4h4"
  }), e.createElement("path", {
    d: "M19 21v-8l-1.436 -9.574a0.5 .5 0 0 0 -.495 -.426h-1.145a0.5 .5 0 0 0 -.494 .418l-1.43 8.582"
  }), e.createElement("path", {
    d: "M9 17h1"
  }), e.createElement("path", {
    d: "M14 17h1"
  }));
}
var aj = ["size", "color", "stroke"];
function ij(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, aj);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-building-factory",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M4 21c1.147 -4.02 1.983 -8.027 2 -12h6c.017 3.973 .853 7.98 2 12"
  }), e.createElement("path", {
    d: "M12.5 13h4.5c.025 2.612 .894 5.296 2 8"
  }), e.createElement("path", {
    d: "M9 5a2.4 2.4 0 0 1 2 -1a2.4 2.4 0 0 1 2 1a2.4 2.4 0 0 0 2 1a2.4 2.4 0 0 0 2 -1a2.4 2.4 0 0 1 2 -1a2.4 2.4 0 0 1 2 1"
  }), e.createElement("line", {
    x1: 3,
    y1: 21,
    x2: 22,
    y2: 21
  }));
}
var cj = ["size", "color", "stroke"];
function sj(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, cj);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-building-fortress",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M7 21h1a1 1 0 0 0 1 -1v-1h0a3 3 0 0 1 6 0m3 2h1a1 1 0 0 0 1 -1v-15l-3 -2l-3 2v6h-4v-6l-3 -2l-3 2v15a1 1 0 0 0 1 1h2m8 -2v1a1 1 0 0 0 1 1h2"
  }), e.createElement("path", {
    d: "M7 7h0v.01"
  }), e.createElement("path", {
    d: "M7 10h0v.01"
  }), e.createElement("path", {
    d: "M7 13h0v.01"
  }), e.createElement("path", {
    d: "M17 7h0v.01"
  }), e.createElement("path", {
    d: "M17 10h0v.01"
  }), e.createElement("path", {
    d: "M17 13h0v.01"
  }));
}
var hj = ["size", "color", "stroke"];
function dj(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, hj);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-building-hospital",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("line", {
    x1: 3,
    y1: 21,
    x2: 21,
    y2: 21
  }), e.createElement("path", {
    d: "M5 21v-16a2 2 0 0 1 2 -2h10a2 2 0 0 1 2 2v16"
  }), e.createElement("path", {
    d: "M9 21v-4a2 2 0 0 1 2 -2h2a2 2 0 0 1 2 2v4"
  }), e.createElement("line", {
    x1: 10,
    y1: 9,
    x2: 14,
    y2: 9
  }), e.createElement("line", {
    x1: 12,
    y1: 7,
    x2: 12,
    y2: 11
  }));
}
var vj = ["size", "color", "stroke"];
function mj(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, vj);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-building-lighthouse",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M12 3l2 3l2 15h-8l2 -15z"
  }), e.createElement("line", {
    x1: 8,
    y1: 9,
    x2: 16,
    y2: 9
  }), e.createElement("path", {
    d: "M3 11l2 -2l-2 -2"
  }), e.createElement("path", {
    d: "M21 11l-2 -2l2 -2"
  }));
}
var kj = ["size", "color", "stroke"];
function wj(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, kj);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-building-monument",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M8 18l2 -13l2 -2l2 2l2 13"
  }), e.createElement("path", {
    d: "M5 21v-3h14v3"
  }), e.createElement("line", {
    x1: 3,
    y1: 21,
    x2: 21,
    y2: 21
  }));
}
var pj = ["size", "color", "stroke"];
function Ej(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, pj);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-building-pavilon",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M3 21h7v-3a2 2 0 0 1 4 0v3h7"
  }), e.createElement("line", {
    x1: 6,
    y1: 21,
    x2: 6,
    y2: 12
  }), e.createElement("line", {
    x1: 18,
    y1: 21,
    x2: 18,
    y2: 12
  }), e.createElement("path", {
    d: "M6 12h12a3 3 0 0 0 3 -3a9 8 0 0 1 -9 -6a9 8 0 0 1 -9 6a3 3 0 0 0 3 3"
  }));
}
var uj = ["size", "color", "stroke"];
function gj(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, uj);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-building-skyscraper",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("line", {
    x1: 3,
    y1: 21,
    x2: 21,
    y2: 21
  }), e.createElement("path", {
    d: "M5 21v-14l8 -4v18"
  }), e.createElement("path", {
    d: "M19 21v-10l-6 -4"
  }), e.createElement("line", {
    x1: 9,
    y1: 9,
    x2: 9,
    y2: 9.01
  }), e.createElement("line", {
    x1: 9,
    y1: 12,
    x2: 9,
    y2: 12.01
  }), e.createElement("line", {
    x1: 9,
    y1: 15,
    x2: 9,
    y2: 15.01
  }), e.createElement("line", {
    x1: 9,
    y1: 18,
    x2: 9,
    y2: 18.01
  }));
}
var Mj = ["size", "color", "stroke"];
function xj(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Mj);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-building-stadium",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("ellipse", {
    cx: 12,
    cy: 12,
    rx: 8,
    ry: 2
  }), e.createElement("path", {
    d: "M4 12v7c0 .94 2.51 1.785 6 2v-3h4v3c3.435 -.225 6 -1.07 6 -2v-7"
  }), e.createElement("path", {
    d: "M15 6h4v-3h-4v7"
  }), e.createElement("path", {
    d: "M7 6h4v-3h-4v7"
  }));
}
var fj = ["size", "color", "stroke"];
function zj(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, fj);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-building-store",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("line", {
    x1: 3,
    y1: 21,
    x2: 21,
    y2: 21
  }), e.createElement("path", {
    d: "M3 7v1a3 3 0 0 0 6 0v-1m0 1a3 3 0 0 0 6 0v-1m0 1a3 3 0 0 0 6 0v-1h-18l2 -4h14l2 4"
  }), e.createElement("line", {
    x1: 5,
    y1: 21,
    x2: 5,
    y2: 10.85
  }), e.createElement("line", {
    x1: 19,
    y1: 21,
    x2: 19,
    y2: 10.85
  }), e.createElement("path", {
    d: "M9 21v-4a2 2 0 0 1 2 -2h2a2 2 0 0 1 2 2v4"
  }));
}
var bj = ["size", "color", "stroke"];
function Lj(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, bj);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-building-tunnel",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M5 21h14a2 2 0 0 0 2 -2v-7a9 9 0 0 0 -18 0v7a2 2 0 0 0 2 2z"
  }), e.createElement("path", {
    d: "M8 21v-9a4 4 0 1 1 8 0v9"
  }), e.createElement("path", {
    d: "M3 17h4"
  }), e.createElement("path", {
    d: "M17 17h4"
  }), e.createElement("path", {
    d: "M21 12h-4"
  }), e.createElement("path", {
    d: "M7 12h-4"
  }), e.createElement("path", {
    d: "M12 3v5"
  }), e.createElement("path", {
    d: "M6 6l3 3"
  }), e.createElement("path", {
    d: "M15 9l3 -3l-3 3z"
  }));
}
var yj = ["size", "color", "stroke"];
function Cj(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, yj);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-building-warehouse",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M3 21v-13l9 -4l9 4v13"
  }), e.createElement("path", {
    d: "M13 13h4v8h-10v-6h6"
  }), e.createElement("path", {
    d: "M13 21v-9a1 1 0 0 0 -1 -1h-2a1 1 0 0 0 -1 1v3"
  }));
}
var jj = ["size", "color", "stroke"];
function Bj(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, jj);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-building-wind-turbine",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("circle", {
    cx: 12,
    cy: 11,
    r: 2
  }), e.createElement("path", {
    d: "M10 11v-2.573c0 -.18 .013 -.358 .04 -.536l.716 -4.828c.064 -.597 .597 -1.063 1.244 -1.063s1.18 .466 1.244 1.063l.716 4.828c.027 .178 .04 .357 .04 .536v2.573"
  }), e.createElement("path", {
    d: "M13.01 9.28l2.235 1.276c.156 .09 .305 .19 .446 .3l3.836 2.911c.487 .352 .624 1.04 .3 1.596c-.325 .556 -.997 .782 -1.548 .541l-4.555 -1.68a3.624 3.624 0 0 1 -.486 -.231l-2.235 -1.277"
  }), e.createElement("path", {
    d: "M13 12.716l-2.236 1.277a3.624 3.624 0 0 1 -.485 .23l-4.555 1.681c-.551 .241 -1.223 .015 -1.548 -.54c-.324 -.557 -.187 -1.245 .3 -1.597l3.836 -2.91a3.41 3.41 0 0 1 .446 -.3l2.235 -1.277"
  }), e.createElement("path", {
    d: "M7 21h10"
  }), e.createElement("path", {
    d: "M10 21l1 -7"
  }), e.createElement("path", {
    d: "M13 14l1 7"
  }));
}
var Hj = ["size", "color", "stroke"];
function Nj(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Hj);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-building",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("line", {
    x1: 3,
    y1: 21,
    x2: 21,
    y2: 21
  }), e.createElement("line", {
    x1: 9,
    y1: 8,
    x2: 10,
    y2: 8
  }), e.createElement("line", {
    x1: 9,
    y1: 12,
    x2: 10,
    y2: 12
  }), e.createElement("line", {
    x1: 9,
    y1: 16,
    x2: 10,
    y2: 16
  }), e.createElement("line", {
    x1: 14,
    y1: 8,
    x2: 15,
    y2: 8
  }), e.createElement("line", {
    x1: 14,
    y1: 12,
    x2: 15,
    y2: 12
  }), e.createElement("line", {
    x1: 14,
    y1: 16,
    x2: 15,
    y2: 16
  }), e.createElement("path", {
    d: "M5 21v-16a2 2 0 0 1 2 -2h10a2 2 0 0 1 2 2v16"
  }));
}
var Wj = ["size", "color", "stroke"];
function qj(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Wj);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-bulb-off",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M3 12h1m8 -9v1m8 8h1m-15.4 -6.4l.7 .7m12.1 -.7l-.7 .7"
  }), e.createElement("path", {
    d: "M11.089 7.083a5 5 0 0 1 5.826 5.84m-1.378 2.611a5.012 5.012 0 0 1 -.537 .466a3.5 3.5 0 0 0 -1 3a2 2 0 1 1 -4 0a3.5 3.5 0 0 0 -1 -3a5 5 0 0 1 -.528 -7.544"
  }), e.createElement("path", {
    d: "M9.7 17h4.6"
  }), e.createElement("path", {
    d: "M3 3l18 18"
  }));
}
var Oj = ["size", "color", "stroke"];
function Pj(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Oj);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-bulb",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M3 12h1m8 -9v1m8 8h1m-15.4 -6.4l.7 .7m12.1 -.7l-.7 .7"
  }), e.createElement("path", {
    d: "M9 16a5 5 0 1 1 6 0a3.5 3.5 0 0 0 -1 3a2 2 0 0 1 -4 0a3.5 3.5 0 0 0 -1 -3"
  }), e.createElement("line", {
    x1: 9.7,
    y1: 17,
    x2: 14.3,
    y2: 17
  }));
}
var Sj = ["size", "color", "stroke"];
function Ij(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Sj);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-bulldozer",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("circle", {
    cx: 4,
    cy: 17,
    r: 2
  }), e.createElement("circle", {
    cx: 13,
    cy: 17,
    r: 2
  }), e.createElement("path", {
    d: "M18 13v6h3"
  }), e.createElement("line", {
    x1: 13,
    y1: 19,
    x2: 4,
    y2: 19
  }), e.createElement("line", {
    x1: 4,
    y1: 15,
    x2: 13,
    y2: 15
  }), e.createElement("path", {
    d: "M8 12v-5h2a3 3 0 0 1 3 3v5"
  }), e.createElement("path", {
    d: "M5 15v-2a1 1 0 0 1 1 -1h7"
  }), e.createElement("line", {
    x1: 18,
    y1: 17,
    x2: 15,
    y2: 17
  }));
}
var Aj = ["size", "color", "stroke"];
function Dj(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Aj);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-bus-off",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("circle", {
    cx: 6,
    cy: 17,
    r: 2
  }), e.createElement("path", {
    d: "M16.18 16.172a2 2 0 0 0 2.652 2.648"
  }), e.createElement("path", {
    d: "M4 17h-2v-11a1 1 0 0 1 1 -1h2m4 0h8c2.761 0 5 3.134 5 7v5h-1m-5 0h-8"
  }), e.createElement("path", {
    d: "M16 5l1.5 7h4.5"
  }), e.createElement("path", {
    d: "M2 10h8m4 0h3"
  }), e.createElement("path", {
    d: "M7 7v3"
  }), e.createElement("path", {
    d: "M12 5v3"
  }), e.createElement("path", {
    d: "M3 3l18 18"
  }));
}
var Fj = ["size", "color", "stroke"];
function Gj(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Fj);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-bus-stop",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("rect", {
    x: 3,
    y: 3,
    width: 4,
    height: 6,
    rx: 1
  }), e.createElement("circle", {
    cx: 18,
    cy: 17,
    r: 2
  }), e.createElement("path", {
    d: "M10 5h7c2.761 0 5 3.134 5 7v5h-2"
  }), e.createElement("path", {
    d: "M16 17h-8"
  }), e.createElement("path", {
    d: "M16 5l1.5 7h4.5"
  }), e.createElement("path", {
    d: "M9.5 10h7.5"
  }), e.createElement("path", {
    d: "M12 5v5"
  }), e.createElement("path", {
    d: "M5 9v11"
  }));
}
var Jj = ["size", "color", "stroke"];
function Kj(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Jj);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-bus",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("circle", {
    cx: 6,
    cy: 17,
    r: 2
  }), e.createElement("circle", {
    cx: 18,
    cy: 17,
    r: 2
  }), e.createElement("path", {
    d: "M4 17h-2v-11a1 1 0 0 1 1 -1h14a5 7 0 0 1 5 7v5h-2m-4 0h-8"
  }), e.createElement("polyline", {
    points: "16 5 17.5 12 22 12"
  }), e.createElement("line", {
    x1: 2,
    y1: 10,
    x2: 17,
    y2: 10
  }), e.createElement("line", {
    x1: 7,
    y1: 5,
    x2: 7,
    y2: 10
  }), e.createElement("line", {
    x1: 12,
    y1: 5,
    x2: 12,
    y2: 10
  }));
}
var Qj = ["size", "color", "stroke"];
function Rj(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Qj);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-businessplan",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("ellipse", {
    cx: 16,
    cy: 6,
    rx: 5,
    ry: 3
  }), e.createElement("path", {
    d: "M11 6v4c0 1.657 2.239 3 5 3s5 -1.343 5 -3v-4"
  }), e.createElement("path", {
    d: "M11 10v4c0 1.657 2.239 3 5 3s5 -1.343 5 -3v-4"
  }), e.createElement("path", {
    d: "M11 14v4c0 1.657 2.239 3 5 3s5 -1.343 5 -3v-4"
  }), e.createElement("path", {
    d: "M7 9h-2.5a1.5 1.5 0 0 0 0 3h1a1.5 1.5 0 0 1 0 3h-2.5"
  }), e.createElement("path", {
    d: "M5 15v1m0 -8v1"
  }));
}
var Tj = ["size", "color", "stroke"];
function Uj(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Tj);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-butterfly",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M11.995 18.176a3 3 0 1 1 -4.953 -2.449l-.025 .023a4.502 4.502 0 0 1 1.483 -8.75c1.414 0 2.675 .652 3.5 1.671a4.5 4.5 0 1 1 4.983 7.079a3 3 0 1 1 -4.983 2.25z"
  }), e.createElement("path", {
    d: "M12 19v-10"
  }), e.createElement("path", {
    d: "M9 3l3 2l3 -2"
  }));
}
var Vj = ["size", "color", "stroke"];
function Xj(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Vj);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-c-sharp",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M10 9a3 3 0 0 0 -3 -3h-.5a3.5 3.5 0 0 0 -3.5 3.5v5a3.5 3.5 0 0 0 3.5 3.5h.5a3 3 0 0 0 3 -3"
  }), e.createElement("path", {
    d: "M16 7l-1 10"
  }), e.createElement("path", {
    d: "M20 7l-1 10"
  }), e.createElement("path", {
    d: "M14 10h7.5"
  }), e.createElement("path", {
    d: "M21 14h-7.5"
  }));
}
var Yj = ["size", "color", "stroke"];
function Zj(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Yj);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-cactus-off",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M6 9v1a3 3 0 0 0 3 3h1"
  }), e.createElement("path", {
    d: "M18 8v5a3 3 0 0 1 -.129 .872m-2.014 2.004a3 3 0 0 1 -.857 .124h-1"
  }), e.createElement("path", {
    d: "M10 21v-11m0 -4v-1a2 2 0 1 1 4 0v5m0 4v7"
  }), e.createElement("path", {
    d: "M7 21h10"
  }), e.createElement("path", {
    d: "M3 3l18 18"
  }));
}
var $j = ["size", "color", "stroke"];
function _j(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, $j);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-cactus",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M6 9v1a3 3 0 0 0 3 3h1"
  }), e.createElement("path", {
    d: "M18 8v5a3 3 0 0 1 -3 3h-1"
  }), e.createElement("path", {
    d: "M10 21v-16a2 2 0 1 1 4 0v16"
  }), e.createElement("path", {
    d: "M7 21h10"
  }));
}
var eB = ["size", "color", "stroke"];
function tB(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, eB);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-cake-off",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M21 17v-5a3 3 0 0 0 -3 -3h-5m-4 0h-3a3 3 0 0 0 -3 3v8h17"
  }), e.createElement("path", {
    d: "M2.996 14.803c.312 .135 .654 .204 1.004 .197a2.4 2.4 0 0 0 2 -1a2.4 2.4 0 0 1 2 -1a2.4 2.4 0 0 1 2 1a2.4 2.4 0 0 0 2 1a2.4 2.4 0 0 0 2 -1m4 0a2.4 2.4 0 0 0 2 1c.35 .007 .692 -.062 1.004 -.197"
  }), e.createElement("path", {
    d: "M10.172 6.188c.07 -.158 .163 -.31 .278 -.451l1.55 -1.737l1.465 1.638a2 2 0 0 1 -.65 3.19"
  }), e.createElement("path", {
    d: "M3 3l18 18"
  }));
}
var oB = ["size", "color", "stroke"];
function rB(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, oB);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-cake",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M3 20h18v-8a3 3 0 0 0 -3 -3h-12a3 3 0 0 0 -3 3v8z"
  }), e.createElement("path", {
    d: "M2.996 14.803c.312 .135 .654 .204 1.004 .197a2.4 2.4 0 0 0 2 -1a2.4 2.4 0 0 1 2 -1a2.4 2.4 0 0 1 2 1a2.4 2.4 0 0 0 2 1a2.4 2.4 0 0 0 2 -1a2.4 2.4 0 0 1 2 -1a2.4 2.4 0 0 1 2 1a2.4 2.4 0 0 0 2 1c.35 .007 .692 -.062 1.004 -.197"
  }), e.createElement("path", {
    d: "M12 4l1.465 1.638a2 2 0 1 1 -3.015 .099l1.55 -1.737z"
  }));
}
var nB = ["size", "color", "stroke"];
function lB(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, nB);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-calculator-off",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M19.823 19.824a2 2 0 0 1 -1.823 1.176h-12a2 2 0 0 1 -2 -2v-14c0 -.295 .064 -.575 .178 -.827m2.822 -1.173h11a2 2 0 0 1 2 2v11"
  }), e.createElement("path", {
    d: "M10 10h-1a1 1 0 0 1 -1 -1v-1m3 -1h4a1 1 0 0 1 1 1v1a1 1 0 0 1 -1 1h-1"
  }), e.createElement("path", {
    d: "M8 14v.01"
  }), e.createElement("path", {
    d: "M12 14v.01"
  }), e.createElement("path", {
    d: "M8 17v.01"
  }), e.createElement("path", {
    d: "M12 17v.01"
  }), e.createElement("path", {
    d: "M16 17v.01"
  }), e.createElement("path", {
    d: "M3 3l18 18"
  }));
}
var aB = ["size", "color", "stroke"];
function iB(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, aB);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-calculator",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("rect", {
    x: 4,
    y: 3,
    width: 16,
    height: 18,
    rx: 2
  }), e.createElement("rect", {
    x: 8,
    y: 7,
    width: 8,
    height: 3,
    rx: 1
  }), e.createElement("line", {
    x1: 8,
    y1: 14,
    x2: 8,
    y2: 14.01
  }), e.createElement("line", {
    x1: 12,
    y1: 14,
    x2: 12,
    y2: 14.01
  }), e.createElement("line", {
    x1: 16,
    y1: 14,
    x2: 16,
    y2: 14.01
  }), e.createElement("line", {
    x1: 8,
    y1: 17,
    x2: 8,
    y2: 17.01
  }), e.createElement("line", {
    x1: 12,
    y1: 17,
    x2: 12,
    y2: 17.01
  }), e.createElement("line", {
    x1: 16,
    y1: 17,
    x2: 16,
    y2: 17.01
  }));
}
var cB = ["size", "color", "stroke"];
function sB(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, cB);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-calendar-due",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("rect", {
    x: 4,
    y: 5,
    width: 16,
    height: 16,
    rx: 2
  }), e.createElement("path", {
    d: "M16 3v4"
  }), e.createElement("path", {
    d: "M8 3v4"
  }), e.createElement("path", {
    d: "M4 11h16"
  }), e.createElement("circle", {
    cx: 12,
    cy: 16,
    r: 1
  }));
}
var hB = ["size", "color", "stroke"];
function dB(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, hB);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-calendar-event",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("rect", {
    x: 4,
    y: 5,
    width: 16,
    height: 16,
    rx: 2
  }), e.createElement("line", {
    x1: 16,
    y1: 3,
    x2: 16,
    y2: 7
  }), e.createElement("line", {
    x1: 8,
    y1: 3,
    x2: 8,
    y2: 7
  }), e.createElement("line", {
    x1: 4,
    y1: 11,
    x2: 20,
    y2: 11
  }), e.createElement("rect", {
    x: 8,
    y: 15,
    width: 2,
    height: 2
  }));
}
var vB = ["size", "color", "stroke"];
function mB(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, vB);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-calendar-minus",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("rect", {
    x: 4,
    y: 5,
    width: 16,
    height: 16,
    rx: 2
  }), e.createElement("line", {
    x1: 16,
    y1: 3,
    x2: 16,
    y2: 7
  }), e.createElement("line", {
    x1: 8,
    y1: 3,
    x2: 8,
    y2: 7
  }), e.createElement("line", {
    x1: 4,
    y1: 11,
    x2: 20,
    y2: 11
  }), e.createElement("line", {
    x1: 10,
    y1: 16,
    x2: 14,
    y2: 16
  }));
}
var kB = ["size", "color", "stroke"];
function wB(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, kB);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-calendar-off",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M19.823 19.824a2 2 0 0 1 -1.823 1.176h-12a2 2 0 0 1 -2 -2v-12a2 2 0 0 1 1.175 -1.823m3.825 -.177h9a2 2 0 0 1 2 2v9"
  }), e.createElement("line", {
    x1: 16,
    y1: 3,
    x2: 16,
    y2: 7
  }), e.createElement("line", {
    x1: 8,
    y1: 3,
    x2: 8,
    y2: 4
  }), e.createElement("path", {
    d: "M4 11h7m4 0h5"
  }), e.createElement("line", {
    x1: 11,
    y1: 15,
    x2: 12,
    y2: 15
  }), e.createElement("line", {
    x1: 12,
    y1: 15,
    x2: 12,
    y2: 18
  }), e.createElement("line", {
    x1: 3,
    y1: 3,
    x2: 21,
    y2: 21
  }));
}
var pB = ["size", "color", "stroke"];
function EB(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, pB);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-calendar-plus",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("rect", {
    x: 4,
    y: 5,
    width: 16,
    height: 16,
    rx: 2
  }), e.createElement("line", {
    x1: 16,
    y1: 3,
    x2: 16,
    y2: 7
  }), e.createElement("line", {
    x1: 8,
    y1: 3,
    x2: 8,
    y2: 7
  }), e.createElement("line", {
    x1: 4,
    y1: 11,
    x2: 20,
    y2: 11
  }), e.createElement("line", {
    x1: 10,
    y1: 16,
    x2: 14,
    y2: 16
  }), e.createElement("line", {
    x1: 12,
    y1: 14,
    x2: 12,
    y2: 18
  }));
}
var uB = ["size", "color", "stroke"];
function gB(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, uB);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-calendar-stats",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M11.795 21h-6.795a2 2 0 0 1 -2 -2v-12a2 2 0 0 1 2 -2h12a2 2 0 0 1 2 2v4"
  }), e.createElement("path", {
    d: "M18 14v4h4"
  }), e.createElement("circle", {
    cx: 18,
    cy: 18,
    r: 4
  }), e.createElement("path", {
    d: "M15 3v4"
  }), e.createElement("path", {
    d: "M7 3v4"
  }), e.createElement("path", {
    d: "M3 11h16"
  }));
}
var MB = ["size", "color", "stroke"];
function xB(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, MB);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-calendar-time",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M11.795 21h-6.795a2 2 0 0 1 -2 -2v-12a2 2 0 0 1 2 -2h12a2 2 0 0 1 2 2v4"
  }), e.createElement("circle", {
    cx: 18,
    cy: 18,
    r: 4
  }), e.createElement("path", {
    d: "M15 3v4"
  }), e.createElement("path", {
    d: "M7 3v4"
  }), e.createElement("path", {
    d: "M3 11h16"
  }), e.createElement("path", {
    d: "M18 16.496v1.504l1 1"
  }));
}
var fB = ["size", "color", "stroke"];
function zB(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, fB);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-calendar",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("rect", {
    x: 4,
    y: 5,
    width: 16,
    height: 16,
    rx: 2
  }), e.createElement("line", {
    x1: 16,
    y1: 3,
    x2: 16,
    y2: 7
  }), e.createElement("line", {
    x1: 8,
    y1: 3,
    x2: 8,
    y2: 7
  }), e.createElement("line", {
    x1: 4,
    y1: 11,
    x2: 20,
    y2: 11
  }), e.createElement("line", {
    x1: 11,
    y1: 15,
    x2: 12,
    y2: 15
  }), e.createElement("line", {
    x1: 12,
    y1: 15,
    x2: 12,
    y2: 18
  }));
}
var bB = ["size", "color", "stroke"];
function LB(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, bB);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-camera-minus",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("circle", {
    cx: 12,
    cy: 13,
    r: 3
  }), e.createElement("path", {
    d: "M5 7h1a2 2 0 0 0 2 -2a1 1 0 0 1 1 -1h3m9 6v8a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2v-9a2 2 0 0 1 2 -2"
  }), e.createElement("line", {
    x1: 15,
    y1: 6,
    x2: 21,
    y2: 6
  }));
}
var yB = ["size", "color", "stroke"];
function CB(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, yB);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-camera-off",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M8.29 4.296a1 1 0 0 1 .71 -.296h6a1 1 0 0 1 1 1a2 2 0 0 0 2 2h1a2 2 0 0 1 2 2v8m-1.179 2.824c-.25 .113 -.528 .176 -.821 .176h-14a2 2 0 0 1 -2 -2v-9a2 2 0 0 1 2 -2h1c.292 0 .568 -.062 .818 -.175"
  }), e.createElement("path", {
    d: "M10.436 10.44a3 3 0 1 0 4.126 4.122"
  }), e.createElement("line", {
    x1: 3,
    y1: 3,
    x2: 21,
    y2: 21
  }));
}
var jB = ["size", "color", "stroke"];
function BB(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, jB);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-camera-plus",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("circle", {
    cx: 12,
    cy: 13,
    r: 3
  }), e.createElement("path", {
    d: "M5 7h2a2 2 0 0 0 2 -2a1 1 0 0 1 1 -1h2m9 7v7a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2v-9a2 2 0 0 1 2 -2"
  }), e.createElement("line", {
    x1: 15,
    y1: 6,
    x2: 21,
    y2: 6
  }), e.createElement("line", {
    x1: 18,
    y1: 3,
    x2: 18,
    y2: 9
  }));
}
var HB = ["size", "color", "stroke"];
function NB(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, HB);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-camera-rotate",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M5 7h1a2 2 0 0 0 2 -2a1 1 0 0 1 1 -1h6a1 1 0 0 1 1 1a2 2 0 0 0 2 2h1a2 2 0 0 1 2 2v9a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2v-9a2 2 0 0 1 2 -2"
  }), e.createElement("path", {
    d: "M11.245 15.904a3 3 0 0 0 3.755 -2.904m-2.25 -2.905a3 3 0 0 0 -3.75 2.905"
  }), e.createElement("path", {
    d: "M14 13h2v2"
  }), e.createElement("path", {
    d: "M10 13h-2v-2"
  }));
}
var WB = ["size", "color", "stroke"];
function qB(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, WB);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-camera-selfie",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M5 7h1a2 2 0 0 0 2 -2a1 1 0 0 1 1 -1h6a1 1 0 0 1 1 1a2 2 0 0 0 2 2h1a2 2 0 0 1 2 2v9a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2v-9a2 2 0 0 1 2 -2"
  }), e.createElement("path", {
    d: "M9.5 15a3.5 3.5 0 0 0 5 0"
  }), e.createElement("line", {
    x1: 15,
    y1: 11,
    x2: 15.01,
    y2: 11
  }), e.createElement("line", {
    x1: 9,
    y1: 11,
    x2: 9.01,
    y2: 11
  }));
}
var OB = ["size", "color", "stroke"];
function PB(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, OB);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-camera",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M5 7h1a2 2 0 0 0 2 -2a1 1 0 0 1 1 -1h6a1 1 0 0 1 1 1a2 2 0 0 0 2 2h1a2 2 0 0 1 2 2v9a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2v-9a2 2 0 0 1 2 -2"
  }), e.createElement("circle", {
    cx: 12,
    cy: 13,
    r: 3
  }));
}
var SB = ["size", "color", "stroke"];
function IB(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, SB);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-campfire",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M4 21l16 -4"
  }), e.createElement("path", {
    d: "M20 21l-16 -4"
  }), e.createElement("path", {
    d: "M12 15a4 4 0 0 0 4 -4c0 -3 -2 -3 -2 -8c-4 2 -6 5 -6 8a4 4 0 0 0 4 4z"
  }));
}
var AB = ["size", "color", "stroke"];
function DB(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, AB);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-candle",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M9 21h6v-9a1 1 0 0 0 -1 -1h-4a1 1 0 0 0 -1 1v9z"
  }), e.createElement("path", {
    d: "M12 3l1.465 1.638a2 2 0 1 1 -3.015 .099l1.55 -1.737z"
  }));
}
var FB = ["size", "color", "stroke"];
function GB(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, FB);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-candy-off",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M11.174 7.17l.119 -.12a2 2 0 0 1 2.828 0l2.829 2.83a2 2 0 0 1 0 2.828l-.124 .124m-1.996 1.996l-2.123 2.123a2 2 0 0 1 -2.828 0l-2.829 -2.831a2 2 0 0 1 0 -2.828l2.113 -2.112"
  }), e.createElement("path", {
    d: "M16.243 9.172l3.086 -.772a1.5 1.5 0 0 0 .697 -2.516l-2.216 -2.217a1.5 1.5 0 0 0 -2.44 .47l-1.248 2.913"
  }), e.createElement("path", {
    d: "M9.172 16.243l-.772 3.086a1.5 1.5 0 0 1 -2.516 .697l-2.217 -2.216a1.5 1.5 0 0 1 .47 -2.44l2.913 -1.248"
  }), e.createElement("path", {
    d: "M3 3l18 18"
  }));
}
var JB = ["size", "color", "stroke"];
function KB(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, JB);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-candy",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M7.05 11.293l4.243 -4.243a2 2 0 0 1 2.828 0l2.829 2.83a2 2 0 0 1 0 2.828l-4.243 4.243a2 2 0 0 1 -2.828 0l-2.829 -2.831a2 2 0 0 1 0 -2.828z"
  }), e.createElement("path", {
    d: "M16.243 9.172l3.086 -.772a1.5 1.5 0 0 0 .697 -2.516l-2.216 -2.217a1.5 1.5 0 0 0 -2.44 .47l-1.248 2.913"
  }), e.createElement("path", {
    d: "M9.172 16.243l-.772 3.086a1.5 1.5 0 0 1 -2.516 .697l-2.217 -2.216a1.5 1.5 0 0 1 .47 -2.44l2.913 -1.248"
  }));
}
var QB = ["size", "color", "stroke"];
function RB(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, QB);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-cane",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M9 21l6.324 -11.69c.54 -.974 1.756 -4.104 -1.499 -5.762c-3.255 -1.657 -5.175 .863 -5.825 2.032"
  }));
}
var TB = ["size", "color", "stroke"];
function UB(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, TB);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-cannabis",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M7 20s0 -2 1 -3.5c-1.5 0 -2 -.5 -4 -1.5c0 0 1.839 -1.38 5 -1c-1.789 -.97 -3.279 -2.03 -5 -6c0 0 3.98 -.3 6.5 3.5c-2.284 -4.9 1.5 -9.5 1.5 -9.5c2.734 5.47 2.389 7.5 1.5 9.5c2.531 -3.77 6.5 -3.5 6.5 -3.5c-1.721 3.97 -3.211 5.03 -5 6c3.161 -.38 5 1 5 1c-2 1 -2.5 1.5 -4 1.5c1 1.5 1 3.5 1 3.5c-2 0 -4.438 -2.22 -5 -3c-.563 .78 -3 3 -5 3z"
  }), e.createElement("path", {
    d: "M12 22v-5"
  }));
}
var VB = ["size", "color", "stroke"];
function XB(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, VB);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-capture-off",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M4 16v2a2 2 0 0 0 2 2h2"
  }), e.createElement("path", {
    d: "M16 4h2a2 2 0 0 1 2 2v2"
  }), e.createElement("path", {
    d: "M16 20h2c.554 0 1.055 -.225 1.417 -.589"
  }), e.createElement("path", {
    d: "M9.87 9.887a3 3 0 0 0 4.255 4.23m.58 -3.416a3.012 3.012 0 0 0 -1.4 -1.403"
  }), e.createElement("path", {
    d: "M4 8v-2c0 -.548 .22 -1.044 .577 -1.405"
  }), e.createElement("path", {
    d: "M3 3l18 18"
  }));
}
var YB = ["size", "color", "stroke"];
function ZB(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, YB);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-capture",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M4 8v-2a2 2 0 0 1 2 -2h2"
  }), e.createElement("path", {
    d: "M4 16v2a2 2 0 0 0 2 2h2"
  }), e.createElement("path", {
    d: "M16 4h2a2 2 0 0 1 2 2v2"
  }), e.createElement("path", {
    d: "M16 20h2a2 2 0 0 0 2 -2v-2"
  }), e.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 3
  }));
}
var $B = ["size", "color", "stroke"];
function _B(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, $B);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-car-crane",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("circle", {
    cx: 5,
    cy: 17,
    r: 2
  }), e.createElement("circle", {
    cx: 17,
    cy: 17,
    r: 2
  }), e.createElement("path", {
    d: "M7 18h8m4 0h2v-6a5 5 0 0 0 -5 -5h-1l1.5 5h4.5"
  }), e.createElement("path", {
    d: "M12 18v-11h3"
  }), e.createElement("path", {
    d: "M3 17v-5h9"
  }), e.createElement("path", {
    d: "M4 12v-6l18 -3v2"
  }), e.createElement("path", {
    d: "M8 12v-4l-4 -2"
  }));
}
var eH = ["size", "color", "stroke"];
function tH(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, eH);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-car-crash",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("circle", {
    cx: 10,
    cy: 17,
    r: 2
  }), e.createElement("path", {
    d: "M7 6l4 5h1a2 2 0 0 1 2 2v4h-2m-4 0h-5m0 -6h8m-6 0v-5m2 0h-4"
  }), e.createElement("path", {
    d: "M14 8v-2"
  }), e.createElement("path", {
    d: "M19 12h2"
  }), e.createElement("path", {
    d: "M17.5 15.5l1.5 1.5"
  }), e.createElement("path", {
    d: "M17.5 8.5l1.5 -1.5"
  }));
}
var oH = ["size", "color", "stroke"];
function rH(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, oH);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-car-off",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("circle", {
    cx: 7,
    cy: 17,
    r: 2
  }), e.createElement("path", {
    d: "M15.584 15.588a2 2 0 0 0 2.828 2.83"
  }), e.createElement("path", {
    d: "M5 17h-2v-6l2 -5h1m4 0h4l4 5h1a2 2 0 0 1 2 2v4m-6 0h-6m-6 -6h8m4 0h3m-6 -3v-2"
  }), e.createElement("path", {
    d: "M3 3l18 18"
  }));
}
var nH = ["size", "color", "stroke"];
function lH(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, nH);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-car-turbine",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("circle", {
    cx: 11,
    cy: 13,
    r: 4
  }), e.createElement("path", {
    d: "M18.86 11c.088 .66 .14 1.512 .14 2a8 8 0 1 1 -8 -8h6"
  }), e.createElement("path", {
    d: "M11 9c2.489 .108 4.489 .108 6 0"
  }), e.createElement("rect", {
    x: 17,
    y: 3,
    width: 4,
    height: 8,
    rx: 1
  }), e.createElement("path", {
    d: "M11 13l-3.5 -1.5"
  }), e.createElement("path", {
    d: "M11 13l2.5 3"
  }), e.createElement("path", {
    d: "M8.5 16l2.5 -3"
  }), e.createElement("path", {
    d: "M11 13l3.5 -1.5"
  }), e.createElement("path", {
    d: "M11 9v4"
  }));
}
var aH = ["size", "color", "stroke"];
function iH(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, aH);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-car",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("circle", {
    cx: 7,
    cy: 17,
    r: 2
  }), e.createElement("circle", {
    cx: 17,
    cy: 17,
    r: 2
  }), e.createElement("path", {
    d: "M5 17h-2v-6l2 -5h9l4 5h1a2 2 0 0 1 2 2v4h-2m-4 0h-6m-6 -6h15m-6 0v-5"
  }));
}
var cH = ["size", "color", "stroke"];
function sH(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, cH);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-caravan",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("circle", {
    cx: 11,
    cy: 17,
    r: 2
  }), e.createElement("line", {
    x1: 21,
    y1: 17,
    x2: 13,
    y2: 17
  }), e.createElement("path", {
    d: "M9 17h-5a1 1 0 0 1 -1 -1v-9a2 2 0 0 1 2 -2h10l4 4v8"
  }), e.createElement("rect", {
    x: 6,
    y: 8,
    width: 6,
    height: 4,
    rx: 1
  }));
}
var hH = ["size", "color", "stroke"];
function dH(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, hH);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-cardboards-off",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M20.96 16.953c.026 -.147 .04 -.298 .04 -.453v-8.5a2 2 0 0 0 -2 -2h-9m-4 0h-1a2 2 0 0 0 -2 2v8.5a2.5 2.5 0 0 0 2.5 2.5h1.06a3 3 0 0 0 2.34 -1.13l1.54 -1.92a2 2 0 0 1 3.12 0l1.54 1.92a3 3 0 0 0 2.34 1.13h1.06c.155 0 .307 -.014 .454 -.041"
  }), e.createElement("circle", {
    cx: 8,
    cy: 12,
    r: 1
  }), e.createElement("path", {
    d: "M16.714 12.7a1 1 0 0 0 -1.417 -1.411l1.417 1.41z"
  }), e.createElement("path", {
    d: "M3 3l18 18"
  }));
}
var vH = ["size", "color", "stroke"];
function mH(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, vH);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-cardboards",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M3 8v8.5a2.5 2.5 0 0 0 2.5 2.5h1.06a3 3 0 0 0 2.34 -1.13l1.54 -1.92a2 2 0 0 1 3.12 0l1.54 1.92a3 3 0 0 0 2.34 1.13h1.06a2.5 2.5 0 0 0 2.5 -2.5v-8.5a2 2 0 0 0 -2 -2h-14a2 2 0 0 0 -2 2z"
  }), e.createElement("circle", {
    cx: 8,
    cy: 12,
    r: 1
  }), e.createElement("circle", {
    cx: 16,
    cy: 12,
    r: 1
  }));
}
var kH = ["size", "color", "stroke"];
function wH(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, kH);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-cards",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M3.604 7.197l7.138 -3.109a0.96 .96 0 0 1 1.27 .527l4.924 11.902a1.004 1.004 0 0 1 -.514 1.304l-7.137 3.109a0.96 .96 0 0 1 -1.271 -.527l-4.924 -11.903a1.005 1.005 0 0 1 .514 -1.304z"
  }), e.createElement("path", {
    d: "M15 4h1a1 1 0 0 1 1 1v3.5"
  }), e.createElement("path", {
    d: "M20 6c.264 .112 .52 .217 .768 .315a1 1 0 0 1 .53 1.311l-2.298 5.374"
  }));
}
var pH = ["size", "color", "stroke"];
function EH(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, pH);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-caret-down",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M6 10l6 6l6 -6h-12"
  }));
}
var uH = ["size", "color", "stroke"];
function gH(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, uH);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-caret-left",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M14 6l-6 6l6 6v-12"
  }));
}
var MH = ["size", "color", "stroke"];
function xH(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, MH);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-caret-right",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M10 18l6 -6l-6 -6v12"
  }));
}
var fH = ["size", "color", "stroke"];
function zH(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, fH);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-caret-up",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M18 14l-6 -6l-6 6h12"
  }));
}
var bH = ["size", "color", "stroke"];
function LH(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, bH);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-carousel-horizontal",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("rect", {
    x: 7,
    y: 5,
    width: 10,
    height: 14,
    rx: 1
  }), e.createElement("path", {
    d: "M22 17h-1a1 1 0 0 1 -1 -1v-8a1 1 0 0 1 1 -1h1"
  }), e.createElement("path", {
    d: "M2 17h1a1 1 0 0 0 1 -1v-8a1 1 0 0 0 -1 -1h-1"
  }));
}
var yH = ["size", "color", "stroke"];
function CH(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, yH);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-carousel-vertical",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M19 8v8a1 1 0 0 1 -1 1h-12a1 1 0 0 1 -1 -1v-8a1 1 0 0 1 1 -1h12a1 1 0 0 1 1 1z"
  }), e.createElement("path", {
    d: "M7 22v-1a1 1 0 0 1 1 -1h8a1 1 0 0 1 1 1v1"
  }), e.createElement("path", {
    d: "M17 2v1a1 1 0 0 1 -1 1h-8a1 1 0 0 1 -1 -1v-1"
  }));
}
var jH = ["size", "color", "stroke"];
function BH(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, jH);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-carrot-off",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M8.868 8.846c-2.756 3.382 -5.868 12.154 -5.868 12.154s8.75 -3.104 12.134 -5.85m1.667 -2.342a4.486 4.486 0 0 0 -5.589 -5.615"
  }), e.createElement("path", {
    d: "M9 13l-1.5 -1.5"
  }), e.createElement("path", {
    d: "M22 8s-1.14 -2 -3 -2c-1.406 0 -3 2 -3 2s1.14 2 3 2s3 -2 3 -2z"
  }), e.createElement("path", {
    d: "M16 2s-2 1.14 -2 3s2 3 2 3s2 -1.577 2 -3c0 -1.86 -2 -3 -2 -3z"
  }), e.createElement("path", {
    d: "M3 3l18 18"
  }));
}
var HH = ["size", "color", "stroke"];
function NH(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, HH);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-carrot",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M3 21s9.834 -3.489 12.684 -6.34a4.487 4.487 0 0 0 .005 -6.344a4.483 4.483 0 0 0 -6.342 -.005c-2.86 2.861 -6.347 12.689 -6.347 12.689z"
  }), e.createElement("path", {
    d: "M9 13l-1.5 -1.5"
  }), e.createElement("path", {
    d: "M16 14l-2 -2"
  }), e.createElement("path", {
    d: "M22 8s-1.14 -2 -3 -2c-1.406 0 -3 2 -3 2s1.14 2 3 2s3 -2 3 -2z"
  }), e.createElement("path", {
    d: "M16 2s-2 1.14 -2 3s2 3 2 3s2 -1.577 2 -3c0 -1.86 -2 -3 -2 -3z"
  }));
}
var WH = ["size", "color", "stroke"];
function qH(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, WH);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-cash-banknote-off",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M9.88 9.878a3 3 0 1 0 4.242 4.243m.58 -3.425a3.012 3.012 0 0 0 -1.412 -1.405"
  }), e.createElement("path", {
    d: "M10 6h9a2 2 0 0 1 2 2v8c0 .294 -.064 .574 -.178 .825m-2.822 1.175h-13a2 2 0 0 1 -2 -2v-8a2 2 0 0 1 2 -2h1"
  }), e.createElement("line", {
    x1: 18,
    y1: 12,
    x2: 18.01,
    y2: 12
  }), e.createElement("line", {
    x1: 6,
    y1: 12,
    x2: 6.01,
    y2: 12
  }), e.createElement("line", {
    x1: 3,
    y1: 3,
    x2: 21,
    y2: 21
  }));
}
var OH = ["size", "color", "stroke"];
function PH(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, OH);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-cash-banknote",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 3
  }), e.createElement("rect", {
    x: 3,
    y: 6,
    width: 18,
    height: 12,
    rx: 2
  }), e.createElement("line", {
    x1: 18,
    y1: 12,
    x2: 18.01,
    y2: 12
  }), e.createElement("line", {
    x1: 6,
    y1: 12,
    x2: 6.01,
    y2: 12
  }));
}
var SH = ["size", "color", "stroke"];
function IH(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, SH);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-cash-off",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M13 9h6a2 2 0 0 1 2 2v6m-2 2h-10a2 2 0 0 1 -2 -2v-6a2 2 0 0 1 2 -2"
  }), e.createElement("path", {
    d: "M12.582 12.59a2 2 0 0 0 2.83 2.826"
  }), e.createElement("path", {
    d: "M17 9v-2a2 2 0 0 0 -2 -2h-6m-4 0a2 2 0 0 0 -2 2v6a2 2 0 0 0 2 2h2"
  }), e.createElement("path", {
    d: "M3 3l18 18"
  }));
}
var AH = ["size", "color", "stroke"];
function DH(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, AH);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-cash",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("rect", {
    x: 7,
    y: 9,
    width: 14,
    height: 10,
    rx: 2
  }), e.createElement("circle", {
    cx: 14,
    cy: 14,
    r: 2
  }), e.createElement("path", {
    d: "M17 9v-2a2 2 0 0 0 -2 -2h-10a2 2 0 0 0 -2 2v6a2 2 0 0 0 2 2h2"
  }));
}
var FH = ["size", "color", "stroke"];
function GH(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, FH);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-cast-off",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M3 19h.01"
  }), e.createElement("path", {
    d: "M7 19a4 4 0 0 0 -4 -4"
  }), e.createElement("path", {
    d: "M11 19a8 8 0 0 0 -8 -8"
  }), e.createElement("path", {
    d: "M15 19h3a3 3 0 0 0 .875 -.13m1.997 -2.002a3 3 0 0 0 .128 -.868v-8a3 3 0 0 0 -3 -3h-9m-3.865 .136a3 3 0 0 0 -1.935 1.864"
  }), e.createElement("path", {
    d: "M3 3l18 18"
  }));
}
var JH = ["size", "color", "stroke"];
function KH(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, JH);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-cast",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("line", {
    x1: 3,
    y1: 19,
    x2: 3.01,
    y2: 19
  }), e.createElement("path", {
    d: "M7 19a4 4 0 0 0 -4 -4"
  }), e.createElement("path", {
    d: "M11 19a8 8 0 0 0 -8 -8"
  }), e.createElement("path", {
    d: "M15 19h3a3 3 0 0 0 3 -3v-8a3 3 0 0 0 -3 -3h-12a3 3 0 0 0 -2.8 2"
  }));
}
var QH = ["size", "color", "stroke"];
function RH(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, QH);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-cat",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M20 3v10a8 8 0 1 1 -16 0v-10l3.432 3.432a7.963 7.963 0 0 1 4.568 -1.432c1.769 0 3.403 .574 4.728 1.546l3.272 -3.546z"
  }), e.createElement("path", {
    d: "M2 16h5l-4 4"
  }), e.createElement("path", {
    d: "M22 16h-5l4 4"
  }), e.createElement("circle", {
    cx: 12,
    cy: 16,
    r: 1
  }), e.createElement("path", {
    d: "M9 11v.01"
  }), e.createElement("path", {
    d: "M15 11v.01"
  }));
}
var TH = ["size", "color", "stroke"];
function UH(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, TH);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-category-2",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M14 4h6v6h-6z"
  }), e.createElement("path", {
    d: "M4 14h6v6h-6z"
  }), e.createElement("circle", {
    cx: 17,
    cy: 17,
    r: 3
  }), e.createElement("circle", {
    cx: 7,
    cy: 7,
    r: 3
  }));
}
var VH = ["size", "color", "stroke"];
function XH(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, VH);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-category",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M4 4h6v6h-6z"
  }), e.createElement("path", {
    d: "M14 4h6v6h-6z"
  }), e.createElement("path", {
    d: "M4 14h6v6h-6z"
  }), e.createElement("circle", {
    cx: 17,
    cy: 17,
    r: 3
  }));
}
var YH = ["size", "color", "stroke"];
function ZH(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, YH);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-ce-off",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M11 4a7.99 7.99 0 0 0 -2.581 .426"
  }), e.createElement("path", {
    d: "M5.867 5.864a8 8 0 0 0 5.133 14.136"
  }), e.createElement("path", {
    d: "M20 4a8.001 8.001 0 0 0 -7.29 4.7"
  }), e.createElement("path", {
    d: "M12 12a8 8 0 0 0 8 8"
  }), e.createElement("path", {
    d: "M16 12h4"
  }), e.createElement("path", {
    d: "M3 3l18 18"
  }));
}
var $H = ["size", "color", "stroke"];
function _H(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, $H);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-ce",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M11 4a8 8 0 1 0 0 16"
  }), e.createElement("path", {
    d: "M20 4a8 8 0 1 0 0 16"
  }), e.createElement("line", {
    x1: 12,
    y1: 12,
    x2: 20,
    y2: 12
  }));
}
var eN = ["size", "color", "stroke"];
function tN(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, eN);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-cell-signal-1",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M20 20h-15.269a0.731 .731 0 0 1 -.517 -1.249l14.537 -14.537a0.731 .731 0 0 1 1.249 .517v15.269z"
  }));
}
var oN = ["size", "color", "stroke"];
function rN(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, oN);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-cell-signal-2",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M20 20h-15.269a0.731 .731 0 0 1 -.517 -1.249l14.537 -14.537a0.731 .731 0 0 1 1.249 .517v15.269z"
  }), e.createElement("path", {
    d: "M8 20v-5"
  }));
}
var nN = ["size", "color", "stroke"];
function lN(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, nN);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-cell-signal-3",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M20 20h-15.269a0.731 .731 0 0 1 -.517 -1.249l14.537 -14.537a0.731 .731 0 0 1 1.249 .517v15.269z"
  }), e.createElement("path", {
    d: "M12 20v-9"
  }));
}
var aN = ["size", "color", "stroke"];
function iN(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, aN);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-cell-signal-4",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M20 20h-15.269a0.731 .731 0 0 1 -.517 -1.249l14.537 -14.537a0.731 .731 0 0 1 1.249 .517v15.269z"
  }), e.createElement("path", {
    d: "M16 7v13"
  }));
}
var cN = ["size", "color", "stroke"];
function sN(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, cN);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-cell-signal-5",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M20 20h-15.269a0.731 .731 0 0 1 -.517 -1.249l14.537 -14.537a0.731 .731 0 0 1 1.249 .517v15.269z"
  }), e.createElement("path", {
    d: "M16 7v13"
  }), e.createElement("path", {
    d: "M12 20v-9"
  }), e.createElement("path", {
    d: "M8 20v-5"
  }));
}
var hN = ["size", "color", "stroke"];
function dN(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, hN);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-cell-signal-off",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M20 20h-15.269a0.731 .731 0 0 1 -.517 -1.249l7.265 -7.264m2 -2.001l5.272 -5.272a0.731 .731 0 0 1 1.249 .517v11.269"
  }), e.createElement("path", {
    d: "M3 3l18 18"
  }));
}
var vN = ["size", "color", "stroke"];
function mN(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, vN);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-cell",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M8 4l-4 2v5l4 2l4 -2v-5z"
  }), e.createElement("path", {
    d: "M12 11l4 2l4 -2v-5l-4 -2l-4 2"
  }), e.createElement("path", {
    d: "M8 13v5l4 2l4 -2v-5"
  }));
}
var kN = ["size", "color", "stroke"];
function wN(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, kN);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-certificate-2-off",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M12 12a3 3 0 1 0 3 3"
  }), e.createElement("path", {
    d: "M11 7h3"
  }), e.createElement("path", {
    d: "M10 18v4l2 -1l2 1v-4"
  }), e.createElement("path", {
    d: "M10 19h-2a2 2 0 0 1 -2 -2v-11m1.18 -2.825c.25 -.112 .529 -.175 .82 -.175h8a2 2 0 0 1 2 2v9m-.175 3.82a2 2 0 0 1 -1.825 1.18h-2"
  }), e.createElement("path", {
    d: "M3 3l18 18"
  }));
}
var pN = ["size", "color", "stroke"];
function EN(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, pN);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-certificate-2",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("circle", {
    cx: 12,
    cy: 15,
    r: 3
  }), e.createElement("path", {
    d: "M10 7h4"
  }), e.createElement("path", {
    d: "M10 18v4l2 -1l2 1v-4"
  }), e.createElement("path", {
    d: "M10 19h-2a2 2 0 0 1 -2 -2v-12a2 2 0 0 1 2 -2h8a2 2 0 0 1 2 2v12a2 2 0 0 1 -2 2h-2"
  }));
}
var uN = ["size", "color", "stroke"];
function gN(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, uN);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-certificate-off",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M12.876 12.881a3 3 0 0 0 4.243 4.243m.588 -3.42a3.012 3.012 0 0 0 -1.437 -1.423"
  }), e.createElement("path", {
    d: "M13 17.5v4.5l2 -1.5l2 1.5v-4.5"
  }), e.createElement("path", {
    d: "M10 19h-5a2 2 0 0 1 -2 -2v-10c0 -1.1 .9 -2 2 -2m4 0h10a2 2 0 0 1 2 2v10"
  }), e.createElement("path", {
    d: "M6 9h3m4 0h5"
  }), e.createElement("path", {
    d: "M6 12h3"
  }), e.createElement("path", {
    d: "M6 15h2"
  }), e.createElement("path", {
    d: "M3 3l18 18"
  }));
}
var MN = ["size", "color", "stroke"];
function xN(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, MN);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-certificate",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("circle", {
    cx: 15,
    cy: 15,
    r: 3
  }), e.createElement("path", {
    d: "M13 17.5v4.5l2 -1.5l2 1.5v-4.5"
  }), e.createElement("path", {
    d: "M10 19h-5a2 2 0 0 1 -2 -2v-10c0 -1.1 .9 -2 2 -2h14a2 2 0 0 1 2 2v10a2 2 0 0 1 -1 1.73"
  }), e.createElement("line", {
    x1: 6,
    y1: 9,
    x2: 18,
    y2: 9
  }), e.createElement("line", {
    x1: 6,
    y1: 12,
    x2: 9,
    y2: 12
  }), e.createElement("line", {
    x1: 6,
    y1: 15,
    x2: 8,
    y2: 15
  }));
}
var fN = ["size", "color", "stroke"];
function zN(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, fN);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-chair-director",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M6 21l12 -9"
  }), e.createElement("path", {
    d: "M6 12l12 9"
  }), e.createElement("path", {
    d: "M5 12h14"
  }), e.createElement("path", {
    d: "M6 3v9"
  }), e.createElement("path", {
    d: "M18 3v9"
  }), e.createElement("path", {
    d: "M6 8h12"
  }), e.createElement("path", {
    d: "M6 5h12"
  }));
}
var bN = ["size", "color", "stroke"];
function LN(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, bN);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-chalkboard-off",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M8 19h-3a2 2 0 0 1 -2 -2v-10a2 2 0 0 1 2 -2m4 0h10a2 2 0 0 1 2 2v10"
  }), e.createElement("path", {
    d: "M17 17v1a1 1 0 0 1 -1 1h-4a1 1 0 0 1 -1 -1v-1a1 1 0 0 1 1 -1h4"
  }), e.createElement("path", {
    d: "M3 3l18 18"
  }));
}
var yN = ["size", "color", "stroke"];
function CN(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, yN);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-chalkboard",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M8 19h-3a2 2 0 0 1 -2 -2v-10a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v11a1 1 0 0 1 -1 1"
  }), e.createElement("rect", {
    x: 11,
    y: 16,
    width: 6,
    height: 3,
    rx: 1
  }));
}
var jN = ["size", "color", "stroke"];
function BN(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, jN);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-charging-pile",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("line", {
    x1: 18,
    y1: 7,
    x2: 17,
    y2: 8
  }), e.createElement("path", {
    d: "M14 11h1a2 2 0 0 1 2 2v3a1.5 1.5 0 0 0 3 0v-7l-3 -3"
  }), e.createElement("path", {
    d: "M4 20v-14a2 2 0 0 1 2 -2h6a2 2 0 0 1 2 2v14"
  }), e.createElement("path", {
    d: "M9 11.5l-1.5 2.5h3l-1.5 2.5"
  }), e.createElement("line", {
    x1: 3,
    y1: 20,
    x2: 15,
    y2: 20
  }), e.createElement("line", {
    x1: 4,
    y1: 8,
    x2: 14,
    y2: 8
  }));
}
var HN = ["size", "color", "stroke"];
function NN(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, HN);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-chart-arcs-3",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 1
  }), e.createElement("path", {
    d: "M7 12a5 5 0 1 0 5 -5"
  }), e.createElement("path", {
    d: "M6.29 18.957a9 9 0 1 0 5.71 -15.957"
  }));
}
var WN = ["size", "color", "stroke"];
function qN(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, WN);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-chart-arcs",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 1
  }), e.createElement("path", {
    d: "M16.924 11.132a5 5 0 1 0 -4.056 5.792"
  }), e.createElement("path", {
    d: "M3 12a9 9 0 1 0 9 -9"
  }));
}
var ON = ["size", "color", "stroke"];
function PN(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, ON);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-chart-area-line",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("polyline", {
    points: "4 19 8 13 12 15 16 10 20 14 20 19 4 19"
  }), e.createElement("polyline", {
    points: "4 12 7 8 11 10 16 4 20 8"
  }));
}
var SN = ["size", "color", "stroke"];
function IN(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, SN);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-chart-area",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("line", {
    x1: 4,
    y1: 19,
    x2: 20,
    y2: 19
  }), e.createElement("polyline", {
    points: "4 15 8 9 12 11 16 6 20 10 20 15 4 15"
  }));
}
var AN = ["size", "color", "stroke"];
function DN(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, AN);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-chart-arrows-vertical",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M18 21v-14"
  }), e.createElement("path", {
    d: "M9 15l3 -3l3 3"
  }), e.createElement("path", {
    d: "M15 10l3 -3l3 3"
  }), e.createElement("line", {
    x1: 3,
    y1: 21,
    x2: 21,
    y2: 21
  }), e.createElement("line", {
    x1: 12,
    y1: 21,
    x2: 12,
    y2: 12
  }), e.createElement("path", {
    d: "M3 6l3 -3l3 3"
  }), e.createElement("path", {
    d: "M6 21v-18"
  }));
}
var FN = ["size", "color", "stroke"];
function GN(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, FN);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-chart-arrows",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("line", {
    x1: 3,
    y1: 18,
    x2: 17,
    y2: 18
  }), e.createElement("path", {
    d: "M9 9l3 3l-3 3"
  }), e.createElement("path", {
    d: "M14 15l3 3l-3 3"
  }), e.createElement("line", {
    x1: 3,
    y1: 3,
    x2: 3,
    y2: 21
  }), e.createElement("line", {
    x1: 3,
    y1: 12,
    x2: 12,
    y2: 12
  }), e.createElement("path", {
    d: "M18 3l3 3l-3 3"
  }), e.createElement("line", {
    x1: 3,
    y1: 6,
    x2: 21,
    y2: 6
  }));
}
var JN = ["size", "color", "stroke"];
function KN(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, JN);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-chart-bar-off",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("rect", {
    x: 3,
    y: 12,
    width: 6,
    height: 8,
    rx: 1
  }), e.createElement("path", {
    d: "M12 8h2a1 1 0 0 1 1 1v2m0 4v4a1 1 0 0 1 -1 1h-4a1 1 0 0 1 -1 -1v-10"
  }), e.createElement("path", {
    d: "M15 11v-6a1 1 0 0 1 1 -1h4a1 1 0 0 1 1 1v12m-1 3h-4a1 1 0 0 1 -1 -1v-4"
  }), e.createElement("path", {
    d: "M4 20h14"
  }), e.createElement("path", {
    d: "M3 3l18 18"
  }));
}
var QN = ["size", "color", "stroke"];
function RN(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, QN);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-chart-bar",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("rect", {
    x: 3,
    y: 12,
    width: 6,
    height: 8,
    rx: 1
  }), e.createElement("rect", {
    x: 9,
    y: 8,
    width: 6,
    height: 12,
    rx: 1
  }), e.createElement("rect", {
    x: 15,
    y: 4,
    width: 6,
    height: 16,
    rx: 1
  }), e.createElement("line", {
    x1: 4,
    y1: 20,
    x2: 18,
    y2: 20
  }));
}
var TN = ["size", "color", "stroke"];
function UN(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, TN);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-chart-bubble",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("circle", {
    cx: 6,
    cy: 16,
    r: 3
  }), e.createElement("circle", {
    cx: 16,
    cy: 19,
    r: 2
  }), e.createElement("circle", {
    cx: 14.5,
    cy: 7.5,
    r: 4.5
  }));
}
var VN = ["size", "color", "stroke"];
function XN(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, VN);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-chart-candle",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("rect", {
    x: 4,
    y: 6,
    width: 4,
    height: 5,
    rx: 1
  }), e.createElement("line", {
    x1: 6,
    y1: 4,
    x2: 6,
    y2: 6
  }), e.createElement("line", {
    x1: 6,
    y1: 11,
    x2: 6,
    y2: 20
  }), e.createElement("rect", {
    x: 10,
    y: 14,
    width: 4,
    height: 5,
    rx: 1
  }), e.createElement("line", {
    x1: 12,
    y1: 4,
    x2: 12,
    y2: 14
  }), e.createElement("line", {
    x1: 12,
    y1: 19,
    x2: 12,
    y2: 20
  }), e.createElement("rect", {
    x: 16,
    y: 5,
    width: 4,
    height: 6,
    rx: 1
  }), e.createElement("line", {
    x1: 18,
    y1: 4,
    x2: 18,
    y2: 5
  }), e.createElement("line", {
    x1: 18,
    y1: 11,
    x2: 18,
    y2: 20
  }));
}
var YN = ["size", "color", "stroke"];
function ZN(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, YN);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-chart-circles",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("circle", {
    cx: 9.5,
    cy: 9.5,
    r: 5.5
  }), e.createElement("circle", {
    cx: 14.5,
    cy: 14.5,
    r: 5.5
  }));
}
var $N = ["size", "color", "stroke"];
function _N(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, $N);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-chart-donut-2",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M12 3v5m4 4h5"
  }), e.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 4
  }), e.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 9
  }));
}
var eW = ["size", "color", "stroke"];
function tW(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, eW);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-chart-donut-3",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M12 3v5m4 4h5"
  }), e.createElement("path", {
    d: "M8.929 14.582l-3.429 2.918"
  }), e.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 4
  }), e.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 9
  }));
}
var oW = ["size", "color", "stroke"];
function rW(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, oW);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-chart-donut-4",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M8.848 14.667l-3.348 2.833"
  }), e.createElement("path", {
    d: "M12 3v5m4 4h5"
  }), e.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 9
  }), e.createElement("path", {
    d: "M14.219 15.328l2.781 4.172"
  }), e.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 4
  }));
}
var nW = ["size", "color", "stroke"];
function lW(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, nW);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-chart-donut",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M10 3.2a9 9 0 1 0 10.8 10.8a1 1 0 0 0 -1 -1h-3.8a4.1 4.1 0 1 1 -5 -5v-4a0.9 .9 0 0 0 -1 -.8"
  }), e.createElement("path", {
    d: "M15 3.5a9 9 0 0 1 5.5 5.5h-4.5a9 9 0 0 0 -1 -1v-4.5"
  }));
}
var aW = ["size", "color", "stroke"];
function iW(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, aW);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-chart-dots-2",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M3 3v18h18"
  }), e.createElement("circle", {
    cx: 9,
    cy: 15,
    r: 2
  }), e.createElement("circle", {
    cx: 13,
    cy: 5,
    r: 2
  }), e.createElement("circle", {
    cx: 18,
    cy: 12,
    r: 2
  }), e.createElement("path", {
    d: "M21 3l-6 1.5"
  }), e.createElement("path", {
    d: "M14.113 6.65l2.771 3.695"
  }), e.createElement("path", {
    d: "M16 12.5l-5 2"
  }));
}
var cW = ["size", "color", "stroke"];
function sW(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, cW);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-chart-dots-3",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("circle", {
    cx: 5,
    cy: 7,
    r: 2
  }), e.createElement("circle", {
    cx: 16,
    cy: 15,
    r: 2
  }), e.createElement("circle", {
    cx: 18,
    cy: 6,
    r: 3
  }), e.createElement("circle", {
    cx: 6,
    cy: 18,
    r: 3
  }), e.createElement("path", {
    d: "M9 17l5 -1.5"
  }), e.createElement("path", {
    d: "M6.5 8.5l7.81 5.37"
  }), e.createElement("path", {
    d: "M7 7l8 -1"
  }));
}
var hW = ["size", "color", "stroke"];
function dW(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, hW);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-chart-dots",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M3 3v18h18"
  }), e.createElement("circle", {
    cx: 9,
    cy: 9,
    r: 2
  }), e.createElement("circle", {
    cx: 19,
    cy: 7,
    r: 2
  }), e.createElement("circle", {
    cx: 14,
    cy: 15,
    r: 2
  }), e.createElement("line", {
    x1: 10.16,
    y1: 10.62,
    x2: 12.5,
    y2: 13.5
  }), e.createElement("path", {
    d: "M15.088 13.328l2.837 -4.586"
  }));
}
var vW = ["size", "color", "stroke"];
function mW(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, vW);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-chart-grid-dots",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("circle", {
    cx: 18,
    cy: 6,
    r: 2
  }), e.createElement("circle", {
    cx: 6,
    cy: 12,
    r: 2
  }), e.createElement("circle", {
    cx: 6,
    cy: 18,
    r: 2
  }), e.createElement("circle", {
    cx: 18,
    cy: 18,
    r: 2
  }), e.createElement("path", {
    d: "M8 18h8"
  }), e.createElement("path", {
    d: "M18 20v1"
  }), e.createElement("path", {
    d: "M18 3v1"
  }), e.createElement("path", {
    d: "M6 20v1"
  }), e.createElement("path", {
    d: "M6 10v-7"
  }), e.createElement("path", {
    d: "M12 3v18"
  }), e.createElement("path", {
    d: "M18 8v8"
  }), e.createElement("path", {
    d: "M8 12h13"
  }), e.createElement("path", {
    d: "M21 6h-1"
  }), e.createElement("path", {
    d: "M16 6h-13"
  }), e.createElement("path", {
    d: "M3 12h1"
  }), e.createElement("path", {
    d: "M20 18h1"
  }), e.createElement("path", {
    d: "M3 18h1"
  }), e.createElement("path", {
    d: "M6 14v2"
  }));
}
var kW = ["size", "color", "stroke"];
function wW(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, kW);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-chart-histogram",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M3 3v18h18"
  }), e.createElement("path", {
    d: "M20 18v3"
  }), e.createElement("path", {
    d: "M16 16v5"
  }), e.createElement("path", {
    d: "M12 13v8"
  }), e.createElement("path", {
    d: "M8 16v5"
  }), e.createElement("path", {
    d: "M3 11c6 0 5 -5 9 -5s3 5 9 5"
  }));
}
var pW = ["size", "color", "stroke"];
function EW(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, pW);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-chart-infographic",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("circle", {
    cx: 7,
    cy: 7,
    r: 4
  }), e.createElement("path", {
    d: "M7 3v4h4"
  }), e.createElement("line", {
    x1: 9,
    y1: 17,
    x2: 9,
    y2: 21
  }), e.createElement("line", {
    x1: 17,
    y1: 14,
    x2: 17,
    y2: 21
  }), e.createElement("line", {
    x1: 13,
    y1: 13,
    x2: 13,
    y2: 21
  }), e.createElement("line", {
    x1: 21,
    y1: 12,
    x2: 21,
    y2: 21
  }));
}
var uW = ["size", "color", "stroke"];
function gW(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, uW);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-chart-line",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("line", {
    x1: 4,
    y1: 19,
    x2: 20,
    y2: 19
  }), e.createElement("polyline", {
    points: "4 15 8 9 12 11 16 6 20 10"
  }));
}
var MW = ["size", "color", "stroke"];
function xW(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, MW);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-chart-pie-2",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M12 3v9h9"
  }), e.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 9
  }));
}
var fW = ["size", "color", "stroke"];
function zW(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, fW);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-chart-pie-3",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M12 12l-6.5 5.5"
  }), e.createElement("path", {
    d: "M12 3v9h9"
  }), e.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 9
  }));
}
var bW = ["size", "color", "stroke"];
function LW(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, bW);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-chart-pie-4",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M12 12l-6.5 5.5"
  }), e.createElement("path", {
    d: "M12 3v9h9"
  }), e.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 9
  }), e.createElement("path", {
    d: "M12 12l5 7.5"
  }));
}
var yW = ["size", "color", "stroke"];
function CW(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, yW);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-chart-pie-off",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M5.63 5.643a9 9 0 0 0 12.742 12.715m1.674 -2.29a9.03 9.03 0 0 0 .754 -2.068a1 1 0 0 0 -1 -1h-2.8m-4 0a2 2 0 0 1 -2 -2m0 -4v-3a0.9 .9 0 0 0 -1 -.8a9.005 9.005 0 0 0 -2.057 .749"
  }), e.createElement("path", {
    d: "M15 3.5a9 9 0 0 1 5.5 5.5h-4.5a1 1 0 0 1 -1 -1v-4.5"
  }), e.createElement("path", {
    d: "M3 3l18 18"
  }));
}
var jW = ["size", "color", "stroke"];
function BW(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, jW);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-chart-pie",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M10 3.2a9 9 0 1 0 10.8 10.8a1 1 0 0 0 -1 -1h-6.8a2 2 0 0 1 -2 -2v-7a0.9 .9 0 0 0 -1 -.8"
  }), e.createElement("path", {
    d: "M15 3.5a9 9 0 0 1 5.5 5.5h-4.5a1 1 0 0 1 -1 -1v-4.5"
  }));
}
var HW = ["size", "color", "stroke"];
function NW(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, HW);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-chart-ppf",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M19 17c0 -6.075 -5.373 -11 -12 -11"
  }), e.createElement("path", {
    d: "M3 3v18h18"
  }));
}
var WW = ["size", "color", "stroke"];
function qW(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, WW);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-chart-radar",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M12 3l9.5 7l-3.5 11h-12l-3.5 -11z"
  }), e.createElement("path", {
    d: "M12 7.5l5.5 4l-2.5 5.5h-6.5l-2 -5.5z"
  }), e.createElement("path", {
    d: "M2.5 10l9.5 3l9.5 -3"
  }), e.createElement("path", {
    d: "M12 3v10l6 8"
  }), e.createElement("path", {
    d: "M6 21l6 -8"
  }));
}
var OW = ["size", "color", "stroke"];
function PW(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, OW);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-chart-sankey",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M3 3v18h18"
  }), e.createElement("path", {
    d: "M3 6h18"
  }), e.createElement("path", {
    d: "M3 8c10 0 8 9 18 9"
  }));
}
var SW = ["size", "color", "stroke"];
function IW(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, SW);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-chart-treemap",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("rect", {
    x: 4,
    y: 4,
    width: 16,
    height: 16,
    rx: 2
  }), e.createElement("path", {
    d: "M12 4v16"
  }), e.createElement("path", {
    d: "M4 15h8"
  }), e.createElement("path", {
    d: "M12 12h8"
  }), e.createElement("path", {
    d: "M16 12v8"
  }), e.createElement("path", {
    d: "M16 16h4"
  }));
}
var AW = ["size", "color", "stroke"];
function DW(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, AW);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-check",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M5 12l5 5l10 -10"
  }));
}
var FW = ["size", "color", "stroke"];
function GW(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, FW);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-checkbox",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("polyline", {
    points: "9 11 12 14 20 6"
  }), e.createElement("path", {
    d: "M20 12v6a2 2 0 0 1 -2 2h-12a2 2 0 0 1 -2 -2v-12a2 2 0 0 1 2 -2h9"
  }));
}
var JW = ["size", "color", "stroke"];
function KW(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, JW);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-checklist",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M9.615 20h-2.615a2 2 0 0 1 -2 -2v-12a2 2 0 0 1 2 -2h8a2 2 0 0 1 2 2v8"
  }), e.createElement("path", {
    d: "M14 19l2 2l4 -4"
  }), e.createElement("path", {
    d: "M9 8h4"
  }), e.createElement("path", {
    d: "M9 12h2"
  }));
}
var QW = ["size", "color", "stroke"];
function RW(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, QW);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-checks",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M7 12l5 5l10 -10"
  }), e.createElement("path", {
    d: "M2 12l5 5m5 -5l5 -5"
  }));
}
var TW = ["size", "color", "stroke"];
function UW(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, TW);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-checkup-list",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M9 5h-2a2 2 0 0 0 -2 2v12a2 2 0 0 0 2 2h10a2 2 0 0 0 2 -2v-12a2 2 0 0 0 -2 -2h-2"
  }), e.createElement("rect", {
    x: 9,
    y: 3,
    width: 6,
    height: 4,
    rx: 2
  }), e.createElement("path", {
    d: "M9 14h.01"
  }), e.createElement("path", {
    d: "M9 17h.01"
  }), e.createElement("path", {
    d: "M12 16l1 1l3 -3"
  }));
}
var VW = ["size", "color", "stroke"];
function XW(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, VW);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-cheese",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M4.519 20.008l16.481 -.008v-3.5a2 2 0 1 1 0 -4v-3.5h-16.722"
  }), e.createElement("path", {
    d: "M21 9l-9.385 -4.992c-2.512 .12 -4.758 1.42 -6.327 3.425c-1.423 1.82 -2.288 4.221 -2.288 6.854c0 2.117 .56 4.085 1.519 5.721"
  }), e.createElement("path", {
    d: "M15 13v.01"
  }), e.createElement("path", {
    d: "M8 13v.01"
  }), e.createElement("path", {
    d: "M11 16v.01"
  }));
}
var YW = ["size", "color", "stroke"];
function ZW(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, YW);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-chef-hat-off",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M8.72 4.712a3.999 3.999 0 0 1 7.19 1.439a4 4 0 0 1 2.09 7.723v.126m0 4v3h-12v-7.126a4.002 4.002 0 0 1 .081 -7.796"
  }), e.createElement("path", {
    d: "M6.161 17.009l10.839 -.009"
  }), e.createElement("path", {
    d: "M3 3l18 18"
  }));
}
var $W = ["size", "color", "stroke"];
function _W(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, $W);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-chef-hat",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M12 3c1.918 0 3.52 1.35 3.91 3.151a4 4 0 0 1 2.09 7.723l0 7.126h-12v-7.126a4.002 4.002 0 1 1 2.092 -7.723a3.999 3.999 0 0 1 3.908 -3.151z"
  }), e.createElement("path", {
    d: "M6.161 17.009l11.839 -.009"
  }));
}
var eq = ["size", "color", "stroke"];
function tq(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, eq);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-cherry",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("circle", {
    cx: 7.5,
    cy: 16.5,
    r: 3.5
  }), e.createElement("circle", {
    cx: 17,
    cy: 18,
    r: 3
  }), e.createElement("path", {
    d: "M9 13c.366 -2.006 1.866 -3.873 4.5 -5.6"
  }), e.createElement("path", {
    d: "M17 15c-1.333 -2.333 -2.333 -5.333 -1 -9"
  }), e.createElement("path", {
    d: "M5 6c3.667 -2.667 7.333 -2.667 11 0c-3.667 2.667 -7.333 2.667 -11 0"
  }));
}
var oq = ["size", "color", "stroke"];
function rq(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, oq);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-chess-bishop",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M8 16l-1.447 .724a1 1 0 0 0 -.553 .894v2.382h12v-2.382a1 1 0 0 0 -.553 -.894l-1.447 -.724h-8z"
  }), e.createElement("circle", {
    cx: 12,
    cy: 4,
    r: 1
  }), e.createElement("path", {
    d: "M9.5 16c-1.667 0 -2.5 -1.669 -2.5 -3c0 -3.667 1.667 -6 5 -7c3.333 1 5 3.427 5 7c0 1.284 -.775 2.881 -2.325 2.994l-.175 .006h-5z"
  }), e.createElement("path", {
    d: "M15 8l-3 3"
  }), e.createElement("path", {
    d: "M12 5v1"
  }));
}
var nq = ["size", "color", "stroke"];
function lq(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, nq);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-chess-king",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M8 16l-1.447 .724a1 1 0 0 0 -.553 .894v2.382h12v-2.382a1 1 0 0 0 -.553 -.894l-1.447 -.724h-8z"
  }), e.createElement("path", {
    d: "M8.5 16a3.5 3.5 0 1 1 3.163 -5h.674a3.5 3.5 0 1 1 3.163 5z"
  }), e.createElement("path", {
    d: "M9 6h6"
  }), e.createElement("path", {
    d: "M12 3v8"
  }));
}
var aq = ["size", "color", "stroke"];
function iq(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, aq);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-chess-knight",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M8 16l-1.447 .724a1 1 0 0 0 -.553 .894v2.382h12v-2.382a1 1 0 0 0 -.553 -.894l-1.447 -.724h-8z"
  }), e.createElement("path", {
    d: "M9 3l1 3l-3.491 2.148a1 1 0 0 0 .524 1.852h2.967l-2.073 6h7.961l.112 -5c0 -3 -1.09 -5.983 -4 -7c-1.94 -.678 -2.94 -1.011 -3 -1z"
  }));
}
var cq = ["size", "color", "stroke"];
function sq(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, cq);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-chess-queen",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M16 16l2 -11l-4 4l-2 -5l-2 5l-4 -4l2 11"
  }), e.createElement("path", {
    d: "M8 16l-1.447 .724a1 1 0 0 0 -.553 .894v2.382h12v-2.382a1 1 0 0 0 -.553 -.894l-1.447 -.724h-8z"
  }), e.createElement("circle", {
    cx: 12,
    cy: 4,
    r: 1
  }), e.createElement("circle", {
    cx: 6,
    cy: 5,
    r: 1
  }), e.createElement("circle", {
    cx: 18,
    cy: 5,
    r: 1
  }));
}
var hq = ["size", "color", "stroke"];
function dq(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, hq);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-chess-rook",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M8 16l-1.447 .724a1 1 0 0 0 -.553 .894v2.382h12v-2.382a1 1 0 0 0 -.553 -.894l-1.447 -.724h-8z"
  }), e.createElement("path", {
    d: "M8 16l1 -9h6l1 9"
  }), e.createElement("path", {
    d: "M6 4l.5 3h11l.5 -3"
  }), e.createElement("path", {
    d: "M10 4v3"
  }), e.createElement("path", {
    d: "M14 4v3"
  }));
}
var vq = ["size", "color", "stroke"];
function mq(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, vq);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-chess",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M12 3a3 3 0 0 1 3 3c0 1.113 -.6 2.482 -1.5 3l1.5 7h-6l1.5 -7c-.9 -.518 -1.5 -1.887 -1.5 -3a3 3 0 0 1 3 -3z"
  }), e.createElement("path", {
    d: "M8 9h8"
  }), e.createElement("path", {
    d: "M6.684 16.772a1 1 0 0 0 -.684 .949v1.279a1 1 0 0 0 1 1h10a1 1 0 0 0 1 -1v-1.28a1 1 0 0 0 -.684 -.948l-2.316 -.772h-6l-2.316 .772z"
  }));
}
var kq = ["size", "color", "stroke"];
function wq(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, kq);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-chevron-down-left",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M8 8v8h8"
  }));
}
var pq = ["size", "color", "stroke"];
function Eq(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, pq);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-chevron-down-right",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M16 8v8h-8"
  }));
}
var uq = ["size", "color", "stroke"];
function gq(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, uq);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-chevron-down",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("polyline", {
    points: "6 9 12 15 18 9"
  }));
}
var Mq = ["size", "color", "stroke"];
function xq(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Mq);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-chevron-left",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("polyline", {
    points: "15 6 9 12 15 18"
  }));
}
var fq = ["size", "color", "stroke"];
function zq(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, fq);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-chevron-right",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("polyline", {
    points: "9 6 15 12 9 18"
  }));
}
var bq = ["size", "color", "stroke"];
function Lq(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, bq);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-chevron-up-left",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M8 16v-8h8"
  }));
}
var yq = ["size", "color", "stroke"];
function Cq(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, yq);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-chevron-up-right",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M8 8h8v8"
  }));
}
var jq = ["size", "color", "stroke"];
function Bq(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, jq);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-chevron-up",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("polyline", {
    points: "6 15 12 9 18 15"
  }));
}
var Hq = ["size", "color", "stroke"];
function Nq(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Hq);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-chevrons-down-left",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M11 5v8h8"
  }), e.createElement("path", {
    d: "M7 9v8h8"
  }));
}
var Wq = ["size", "color", "stroke"];
function qq(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Wq);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-chevrons-down-right",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M13 5v8h-8"
  }), e.createElement("path", {
    d: "M17 9v8h-8"
  }));
}
var Oq = ["size", "color", "stroke"];
function Pq(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Oq);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-chevrons-down",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("polyline", {
    points: "7 7 12 12 17 7"
  }), e.createElement("polyline", {
    points: "7 13 12 18 17 13"
  }));
}
var Sq = ["size", "color", "stroke"];
function Iq(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Sq);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-chevrons-left",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("polyline", {
    points: "11 7 6 12 11 17"
  }), e.createElement("polyline", {
    points: "17 7 12 12 17 17"
  }));
}
var Aq = ["size", "color", "stroke"];
function Dq(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Aq);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-chevrons-right",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("polyline", {
    points: "7 7 12 12 7 17"
  }), e.createElement("polyline", {
    points: "13 7 18 12 13 17"
  }));
}
var Fq = ["size", "color", "stroke"];
function Gq(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Fq);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-chevrons-up-left",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M7 15v-8h8"
  }), e.createElement("path", {
    d: "M11 19v-8h8"
  }));
}
var Jq = ["size", "color", "stroke"];
function Kq(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Jq);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-chevrons-up-right",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M9 7h8v8"
  }), e.createElement("path", {
    d: "M5 11h8v8"
  }));
}
var Qq = ["size", "color", "stroke"];
function Rq(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Qq);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-chevrons-up",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("polyline", {
    points: "7 11 12 6 17 11"
  }), e.createElement("polyline", {
    points: "7 17 12 12 17 17"
  }));
}
var Tq = ["size", "color", "stroke"];
function Uq(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Tq);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-chisel",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M14 14l1.5 1.5"
  }), e.createElement("path", {
    d: "M18.347 15.575l2.08 2.079a1.96 1.96 0 0 1 -2.773 2.772l-2.08 -2.079a1.96 1.96 0 0 1 2.773 -2.772z"
  }), e.createElement("path", {
    d: "M3 6l3 -3l7.414 7.414a2 2 0 0 1 .586 1.414v2.172h-2.172a2 2 0 0 1 -1.414 -.586l-7.414 -7.414z"
  }));
}
var Vq = ["size", "color", "stroke"];
function Xq(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Vq);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-christmas-tree-off",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M9.5 5.5l2.5 -2.5l4 4l-2 1l4 4l-1.5 .5m.5 4.5h-12l4 -4l-3 -1l3 -3"
  }), e.createElement("path", {
    d: "M14 17v3a1 1 0 0 1 -1 1h-2a1 1 0 0 1 -1 -1v-3"
  }), e.createElement("path", {
    d: "M3 3l18 18"
  }));
}
var Yq = ["size", "color", "stroke"];
function Zq(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Yq);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-christmas-tree",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M12 3l4 4l-2 1l4 4l-3 1l4 4h-14l4 -4l-3 -1l4 -4l-2 -1z"
  }), e.createElement("path", {
    d: "M14 17v3a1 1 0 0 1 -1 1h-2a1 1 0 0 1 -1 -1v-3"
  }));
}
var $q = ["size", "color", "stroke"];
function _q(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, $q);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-circle-caret-down",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 9
  }), e.createElement("path", {
    d: "M12 15l-4 -4h8z"
  }));
}
var eO = ["size", "color", "stroke"];
function tO(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, eO);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-circle-caret-left",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M9 12l4 -4v8z"
  }), e.createElement("path", {
    d: "M12 21a9 9 0 1 1 0 -18a9 9 0 0 1 0 18z"
  }));
}
var oO = ["size", "color", "stroke"];
function rO(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, oO);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-circle-caret-right",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M15 12l-4 -4v8z"
  }), e.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 9
  }));
}
var nO = ["size", "color", "stroke"];
function lO(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, nO);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-circle-caret-up",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M12 9l4 4h-8z"
  }), e.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 9
  }));
}
var aO = ["size", "color", "stroke"];
function iO(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, aO);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-circle-check",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 9
  }), e.createElement("path", {
    d: "M9 12l2 2l4 -4"
  }));
}
var cO = ["size", "color", "stroke"];
function sO(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, cO);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-circle-chevron-down",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M15 11l-3 3l-3 -3"
  }), e.createElement("path", {
    d: "M12 3a9 9 0 1 0 0 18a9 9 0 0 0 0 -18z"
  }));
}
var hO = ["size", "color", "stroke"];
function dO(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, hO);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-circle-chevron-left",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M13 15l-3 -3l3 -3"
  }), e.createElement("path", {
    d: "M21 12a9 9 0 1 0 -18 0a9 9 0 0 0 18 0z"
  }));
}
var vO = ["size", "color", "stroke"];
function mO(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, vO);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-circle-chevron-right",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M11 9l3 3l-3 3"
  }), e.createElement("path", {
    d: "M3 12a9 9 0 1 0 18 0a9 9 0 0 0 -18 0z"
  }));
}
var kO = ["size", "color", "stroke"];
function wO(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, kO);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-circle-chevron-up",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M9 13l3 -3l3 3"
  }), e.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 9
  }));
}
var pO = ["size", "color", "stroke"];
function EO(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, pO);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-circle-chevrons-down",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M15 9l-3 3l-3 -3"
  }), e.createElement("path", {
    d: "M15 13l-3 3l-3 -3"
  }), e.createElement("path", {
    d: "M12 3a9 9 0 1 0 0 18a9 9 0 0 0 0 -18z"
  }));
}
var uO = ["size", "color", "stroke"];
function gO(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, uO);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-circle-chevrons-left",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M15 15l-3 -3l3 -3"
  }), e.createElement("path", {
    d: "M11 15l-3 -3l3 -3"
  }), e.createElement("path", {
    d: "M21 12a9 9 0 1 0 -.004 .265l.004 -.265z"
  }));
}
var MO = ["size", "color", "stroke"];
function xO(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, MO);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-circle-chevrons-right",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M9 9l3 3l-3 3"
  }), e.createElement("path", {
    d: "M13 9l3 3l-3 3"
  }), e.createElement("path", {
    d: "M3 12a9 9 0 1 0 .004 -.265l-.004 .265z"
  }));
}
var fO = ["size", "color", "stroke"];
function zO(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, fO);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-circle-chevrons-up",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M9 15l3 -3l3 3"
  }), e.createElement("path", {
    d: "M9 11l3 -3l3 3"
  }), e.createElement("path", {
    d: "M12 21a9 9 0 1 0 -.265 -.004l.265 .004z"
  }));
}
var bO = ["size", "color", "stroke"];
function LO(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, bO);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-circle-dashed",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M8.56 3.69a9 9 0 0 0 -2.92 1.95"
  }), e.createElement("path", {
    d: "M3.69 8.56a9 9 0 0 0 -.69 3.44"
  }), e.createElement("path", {
    d: "M3.69 15.44a9 9 0 0 0 1.95 2.92"
  }), e.createElement("path", {
    d: "M8.56 20.31a9 9 0 0 0 3.44 .69"
  }), e.createElement("path", {
    d: "M15.44 20.31a9 9 0 0 0 2.92 -1.95"
  }), e.createElement("path", {
    d: "M20.31 15.44a9 9 0 0 0 .69 -3.44"
  }), e.createElement("path", {
    d: "M20.31 8.56a9 9 0 0 0 -1.95 -2.92"
  }), e.createElement("path", {
    d: "M15.44 3.69a9 9 0 0 0 -3.44 -.69"
  }));
}
var yO = ["size", "color", "stroke"];
function CO(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, yO);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-circle-dot",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 1
  }), e.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 9
  }));
}
var jO = ["size", "color", "stroke"];
function BO(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, jO);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-circle-dotted",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("line", {
    x1: 7.5,
    y1: 4.21,
    x2: 7.5,
    y2: 4.22
  }), e.createElement("line", {
    x1: 4.21,
    y1: 7.5,
    x2: 4.21,
    y2: 7.51
  }), e.createElement("line", {
    x1: 3,
    y1: 12,
    x2: 3,
    y2: 12.01
  }), e.createElement("line", {
    x1: 4.21,
    y1: 16.5,
    x2: 4.21,
    y2: 16.51
  }), e.createElement("line", {
    x1: 7.5,
    y1: 19.79,
    x2: 7.5,
    y2: 19.8
  }), e.createElement("line", {
    x1: 12,
    y1: 21,
    x2: 12,
    y2: 21.01
  }), e.createElement("line", {
    x1: 16.5,
    y1: 19.79,
    x2: 16.5,
    y2: 19.8
  }), e.createElement("line", {
    x1: 19.79,
    y1: 16.5,
    x2: 19.79,
    y2: 16.51
  }), e.createElement("line", {
    x1: 21,
    y1: 12,
    x2: 21,
    y2: 12.01
  }), e.createElement("line", {
    x1: 19.79,
    y1: 7.5,
    x2: 19.79,
    y2: 7.51
  }), e.createElement("line", {
    x1: 16.5,
    y1: 4.21,
    x2: 16.5,
    y2: 4.22
  }), e.createElement("line", {
    x1: 12,
    y1: 3,
    x2: 12,
    y2: 3.01
  }));
}
var HO = ["size", "color", "stroke"];
function NO(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, HO);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-circle-half-2",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 9
  }), e.createElement("path", {
    d: "M12 3v18"
  }), e.createElement("path", {
    d: "M12 14l7 -7"
  }), e.createElement("path", {
    d: "M12 19l8.5 -8.5"
  }), e.createElement("path", {
    d: "M12 9l4.5 -4.5"
  }));
}
var WO = ["size", "color", "stroke"];
function qO(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, WO);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-circle-half-vertical",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 9
  }), e.createElement("path", {
    d: "M3 12h18"
  }));
}
var OO = ["size", "color", "stroke"];
function PO(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, OO);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-circle-half",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 9
  }), e.createElement("path", {
    d: "M12 3v18"
  }));
}
var SO = ["size", "color", "stroke"];
function IO(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, SO);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-circle-key",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("circle", {
    cx: 14,
    cy: 10,
    r: 2
  }), e.createElement("path", {
    d: "M21 12a9 9 0 1 1 -18 0a9 9 0 0 1 18 0z"
  }), e.createElement("path", {
    d: "M12.5 11.5l-4 4l1.5 1.5"
  }), e.createElement("path", {
    d: "M12 15l-1.5 -1.5"
  }));
}
var AO = ["size", "color", "stroke"];
function DO(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, AO);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-circle-letter-a",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 9
  }), e.createElement("path", {
    d: "M10 16v-6a2 2 0 1 1 4 0v6"
  }), e.createElement("path", {
    d: "M10 13h4"
  }));
}
var FO = ["size", "color", "stroke"];
function GO(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, FO);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-circle-letter-b",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 9
  }), e.createElement("path", {
    d: "M10 16h2a2 2 0 1 0 0 -4h-2h2a2 2 0 1 0 0 -4h-2v8z"
  }));
}
var JO = ["size", "color", "stroke"];
function KO(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, JO);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-circle-letter-c",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 9
  }), e.createElement("path", {
    d: "M14 10a2 2 0 1 0 -4 0v4a2 2 0 1 0 4 0"
  }));
}
var QO = ["size", "color", "stroke"];
function RO(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, QO);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-circle-letter-d",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 9
  }), e.createElement("path", {
    d: "M10 8v8h2a2 2 0 0 0 2 -2v-4a2 2 0 0 0 -2 -2h-2z"
  }));
}
var TO = ["size", "color", "stroke"];
function UO(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, TO);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-circle-letter-e",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 9
  }), e.createElement("path", {
    d: "M14 8h-4v8h4"
  }), e.createElement("path", {
    d: "M10 12h2.5"
  }));
}
var VO = ["size", "color", "stroke"];
function XO(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, VO);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-circle-letter-f",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 9
  }), e.createElement("path", {
    d: "M10 12h3"
  }), e.createElement("path", {
    d: "M14 8h-4v8"
  }));
}
var YO = ["size", "color", "stroke"];
function ZO(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, YO);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-circle-letter-g",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 9
  }), e.createElement("path", {
    d: "M14 8h-2a2 2 0 0 0 -2 2v4a2 2 0 0 0 2 2h2v-4h-1"
  }));
}
var $O = ["size", "color", "stroke"];
function _O(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, $O);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-circle-letter-h",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 9
  }), e.createElement("path", {
    d: "M10 16v-8m4 0v8"
  }), e.createElement("path", {
    d: "M10 12h4"
  }));
}
var eP = ["size", "color", "stroke"];
function tP(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, eP);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-circle-letter-i",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 9
  }), e.createElement("path", {
    d: "M12 8v8"
  }));
}
var oP = ["size", "color", "stroke"];
function rP(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, oP);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-circle-letter-j",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 9
  }), e.createElement("path", {
    d: "M10 8h4v6a2 2 0 1 1 -4 0"
  }));
}
var nP = ["size", "color", "stroke"];
function lP(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, nP);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-circle-letter-k",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 9
  }), e.createElement("path", {
    d: "M10 8v8"
  }), e.createElement("path", {
    d: "M14 8l-2.5 4l2.5 4"
  }), e.createElement("path", {
    d: "M10 12h1.5"
  }));
}
var aP = ["size", "color", "stroke"];
function iP(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, aP);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-circle-letter-l",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 9
  }), e.createElement("path", {
    d: "M10 8v8h4"
  }));
}
var cP = ["size", "color", "stroke"];
function sP(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, cP);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-circle-letter-m",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 9
  }), e.createElement("path", {
    d: "M9 16v-8l3 5l3 -5v8"
  }));
}
var hP = ["size", "color", "stroke"];
function dP(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, hP);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-circle-letter-n",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 9
  }), e.createElement("path", {
    d: "M10 16v-8l4 8v-8"
  }));
}
var vP = ["size", "color", "stroke"];
function mP(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, vP);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-circle-letter-o",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 9
  }), e.createElement("path", {
    d: "M12 8a2 2 0 0 1 2 2v4a2 2 0 1 1 -4 0v-4a2 2 0 0 1 2 -2z"
  }));
}
var kP = ["size", "color", "stroke"];
function wP(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, kP);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-circle-letter-p",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 9
  }), e.createElement("path", {
    d: "M10 12h2a2 2 0 1 0 0 -4h-2v8"
  }));
}
var pP = ["size", "color", "stroke"];
function EP(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, pP);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-circle-letter-q",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 9
  }), e.createElement("path", {
    d: "M12 8a2 2 0 0 1 2 2v4a2 2 0 1 1 -4 0v-4a2 2 0 0 1 2 -2z"
  }), e.createElement("path", {
    d: "M13 15l1 1"
  }));
}
var uP = ["size", "color", "stroke"];
function gP(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, uP);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-circle-letter-r",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 9
  }), e.createElement("path", {
    d: "M10 12h2a2 2 0 1 0 0 -4h-2v8m4 0l-3 -4"
  }));
}
var MP = ["size", "color", "stroke"];
function xP(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, MP);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-circle-letter-s",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 9
  }), e.createElement("path", {
    d: "M10 15a1 1 0 0 0 1 1h2a1 1 0 0 0 1 -1v-2a1 1 0 0 0 -1 -1h-2a1 1 0 0 1 -1 -1v-2a1 1 0 0 1 1 -1h2a1 1 0 0 1 1 1"
  }));
}
var fP = ["size", "color", "stroke"];
function zP(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, fP);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-circle-letter-t",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 9
  }), e.createElement("path", {
    d: "M10 8h4"
  }), e.createElement("path", {
    d: "M12 8v8"
  }));
}
var bP = ["size", "color", "stroke"];
function LP(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, bP);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-circle-letter-u",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 9
  }), e.createElement("path", {
    d: "M10 8v6a2 2 0 1 0 4 0v-6"
  }));
}
var yP = ["size", "color", "stroke"];
function CP(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, yP);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-circle-letter-v",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 9
  }), e.createElement("path", {
    d: "M10 8l2 8l2 -8"
  }));
}
var jP = ["size", "color", "stroke"];
function BP(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, jP);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-circle-letter-w",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 9
  }), e.createElement("path", {
    d: "M9 8l1 8l2 -5l2 5l1 -8"
  }));
}
var HP = ["size", "color", "stroke"];
function NP(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, HP);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-circle-letter-x",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 9
  }), e.createElement("path", {
    d: "M10 8l4 8"
  }), e.createElement("path", {
    d: "M10 16l4 -8"
  }));
}
var WP = ["size", "color", "stroke"];
function qP(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, WP);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-circle-letter-y",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 9
  }), e.createElement("path", {
    d: "M10 8l2 5l2 -5"
  }), e.createElement("path", {
    d: "M12 16v-3"
  }));
}
var OP = ["size", "color", "stroke"];
function PP(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, OP);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-circle-letter-z",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 9
  }), e.createElement("path", {
    d: "M10 8h4l-4 8h4"
  }));
}
var SP = ["size", "color", "stroke"];
function IP(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, SP);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-circle-minus",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 9
  }), e.createElement("line", {
    x1: 9,
    y1: 12,
    x2: 15,
    y2: 12
  }));
}
var AP = ["size", "color", "stroke"];
function DP(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, AP);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-circle-number-0",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 9
  }), e.createElement("path", {
    d: "M10 10v4a2 2 0 1 0 4 0v-4a2 2 0 1 0 -4 0z"
  }));
}
var FP = ["size", "color", "stroke"];
function GP(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, FP);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-circle-number-1",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 9
  }), e.createElement("path", {
    d: "M10 10l2 -2v8"
  }));
}
var JP = ["size", "color", "stroke"];
function KP(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, JP);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-circle-number-2",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 9
  }), e.createElement("path", {
    d: "M10 8h3a1 1 0 0 1 1 1v2a1 1 0 0 1 -1 1h-2a1 1 0 0 0 -1 1v2a1 1 0 0 0 1 1h3"
  }));
}
var QP = ["size", "color", "stroke"];
function RP(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, QP);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-circle-number-3",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 9
  }), e.createElement("path", {
    d: "M10 9a1 1 0 0 1 1 -1h2a1 1 0 0 1 1 1v2a1 1 0 0 1 -1 1h-2h2a1 1 0 0 1 1 1v2a1 1 0 0 1 -1 1h-2a1 1 0 0 1 -1 -1"
  }));
}
var TP = ["size", "color", "stroke"];
function UP(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, TP);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-circle-number-4",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 9
  }), e.createElement("path", {
    d: "M10 8v3a1 1 0 0 0 1 1h3"
  }), e.createElement("path", {
    d: "M14 8v8"
  }));
}
var VP = ["size", "color", "stroke"];
function XP(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, VP);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-circle-number-5",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 9
  }), e.createElement("path", {
    d: "M10 15a1 1 0 0 0 1 1h2a1 1 0 0 0 1 -1v-2a1 1 0 0 0 -1 -1h-3v-4h4"
  }));
}
var YP = ["size", "color", "stroke"];
function ZP(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, YP);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-circle-number-6",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 9
  }), e.createElement("path", {
    d: "M14 9a1 1 0 0 0 -1 -1h-2a1 1 0 0 0 -1 1v6a1 1 0 0 0 1 1h2a1 1 0 0 0 1 -1v-2a1 1 0 0 0 -1 -1h-3"
  }));
}
var $P = ["size", "color", "stroke"];
function _P(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, $P);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-circle-number-7",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 9
  }), e.createElement("path", {
    d: "M10 8h4l-2 8"
  }));
}
var eS = ["size", "color", "stroke"];
function tS(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, eS);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-circle-number-8",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 9
  }), e.createElement("path", {
    d: "M12 12h-1a1 1 0 0 1 -1 -1v-2a1 1 0 0 1 1 -1h2a1 1 0 0 1 1 1v2a1 1 0 0 1 -1 1h-2a1 1 0 0 0 -1 1v2a1 1 0 0 0 1 1h2a1 1 0 0 0 1 -1v-2a1 1 0 0 0 -1 -1"
  }));
}
var oS = ["size", "color", "stroke"];
function rS(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, oS);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-circle-number-9",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 9
  }), e.createElement("path", {
    d: "M10 15a1 1 0 0 0 1 1h2a1 1 0 0 0 1 -1v-6a1 1 0 0 0 -1 -1h-2a1 1 0 0 0 -1 1v2a1 1 0 0 0 1 1h3"
  }));
}
var nS = ["size", "color", "stroke"];
function lS(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, nS);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-circle-off",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M20.042 16.045a9 9 0 0 0 -12.087 -12.087m-2.318 1.677a9 9 0 1 0 12.725 12.73"
  }), e.createElement("path", {
    d: "M3 3l18 18"
  }));
}
var aS = ["size", "color", "stroke"];
function iS(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, aS);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-circle-plus",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 9
  }), e.createElement("line", {
    x1: 9,
    y1: 12,
    x2: 15,
    y2: 12
  }), e.createElement("line", {
    x1: 12,
    y1: 9,
    x2: 12,
    y2: 15
  }));
}
var cS = ["size", "color", "stroke"];
function sS(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, cS);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-circle-rectangle-off",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M14 10h3v3m-3 1h-7v-4h3"
  }), e.createElement("path", {
    d: "M20.042 16.045a9 9 0 0 0 -12.087 -12.087m-2.318 1.677a9 9 0 1 0 12.725 12.73"
  }), e.createElement("path", {
    d: "M3 3l18 18"
  }));
}
var hS = ["size", "color", "stroke"];
function dS(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, hS);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-circle-rectangle",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 9
  }), e.createElement("path", {
    d: "M7 10h10v4h-10z"
  }));
}
var vS = ["size", "color", "stroke"];
function mS(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, vS);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-circle-square",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("circle", {
    cx: 9.5,
    cy: 9.5,
    r: 6.5
  }), e.createElement("rect", {
    x: 10,
    y: 10,
    width: 11,
    height: 11,
    rx: 2
  }));
}
var kS = ["size", "color", "stroke"];
function wS(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, kS);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-circle-triangle",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 9
  }), e.createElement("path", {
    d: "M12 20l7 -12h-14z"
  }));
}
var pS = ["size", "color", "stroke"];
function ES(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, pS);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-circle-x",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 9
  }), e.createElement("path", {
    d: "M10 10l4 4m0 -4l-4 4"
  }));
}
var uS = ["size", "color", "stroke"];
function gS(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, uS);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-circle",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 9
  }));
}
var MS = ["size", "color", "stroke"];
function xS(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, MS);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-circles-relation",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M9.183 6.117a6 6 0 1 0 4.511 3.986"
  }), e.createElement("path", {
    d: "M14.813 17.883a6 6 0 1 0 -4.496 -3.954"
  }));
}
var fS = ["size", "color", "stroke"];
function zS(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, fS);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-circles",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("circle", {
    cx: 12,
    cy: 7,
    r: 4
  }), e.createElement("circle", {
    cx: 6.5,
    cy: 17,
    r: 4
  }), e.createElement("circle", {
    cx: 17.5,
    cy: 17,
    r: 4
  }));
}
var bS = ["size", "color", "stroke"];
function LS(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, bS);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-circuit-ammeter",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 7
  }), e.createElement("path", {
    d: "M5 12h-3"
  }), e.createElement("path", {
    d: "M19 12h3"
  }), e.createElement("path", {
    d: "M10 14v-3c0 -1.036 .895 -2 2 -2s2 .964 2 2v3"
  }), e.createElement("path", {
    d: "M14 12h-4"
  }));
}
var yS = ["size", "color", "stroke"];
function CS(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, yS);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-circuit-battery",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M2 12h4"
  }), e.createElement("path", {
    d: "M18 12h4"
  }), e.createElement("path", {
    d: "M18 5v14"
  }), e.createElement("path", {
    d: "M14 9v6"
  }), e.createElement("path", {
    d: "M10 5v14"
  }), e.createElement("path", {
    d: "M6 9v6"
  }));
}
var jS = ["size", "color", "stroke"];
function BS(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, jS);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-circuit-bulb",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M2 12h5"
  }), e.createElement("path", {
    d: "M17 12h5"
  }), e.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 5
  }), e.createElement("path", {
    d: "M8.5 8.5l7 7"
  }), e.createElement("path", {
    d: "M15.5 8.5l-7 7"
  }));
}
var HS = ["size", "color", "stroke"];
function NS(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, HS);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-circuit-capacitor-polarized",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M22 12h-8"
  }), e.createElement("path", {
    d: "M2 12h8"
  }), e.createElement("path", {
    d: "M10 7v10"
  }), e.createElement("path", {
    d: "M14 7v10"
  }), e.createElement("path", {
    d: "M17 5h4"
  }), e.createElement("path", {
    d: "M19 3v4"
  }));
}
var WS = ["size", "color", "stroke"];
function qS(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, WS);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-circuit-capacitor",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M22 12h-8"
  }), e.createElement("path", {
    d: "M2 12h8"
  }), e.createElement("path", {
    d: "M10 7v10"
  }), e.createElement("path", {
    d: "M14 7v10"
  }));
}
var OS = ["size", "color", "stroke"];
function PS(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, OS);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-circuit-cell-plus",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M2 12h9"
  }), e.createElement("path", {
    d: "M15 12h7"
  }), e.createElement("path", {
    d: "M11 5v14"
  }), e.createElement("path", {
    d: "M15 9v6"
  }), e.createElement("path", {
    d: "M3 5h4"
  }), e.createElement("path", {
    d: "M5 3v4"
  }));
}
var SS = ["size", "color", "stroke"];
function IS(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, SS);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-circuit-cell",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M2 12h8"
  }), e.createElement("path", {
    d: "M14 12h8"
  }), e.createElement("path", {
    d: "M10 5v14"
  }), e.createElement("path", {
    d: "M14 9v6"
  }));
}
var AS = ["size", "color", "stroke"];
function DS(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, AS);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-circuit-changeover",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M2 12h2"
  }), e.createElement("path", {
    d: "M20 7h2"
  }), e.createElement("circle", {
    cx: 6,
    cy: 12,
    r: 2
  }), e.createElement("circle", {
    cx: 18,
    cy: 7,
    r: 2
  }), e.createElement("path", {
    d: "M20 17h2"
  }), e.createElement("circle", {
    cx: 18,
    cy: 17,
    r: 2
  }), e.createElement("path", {
    d: "M7.5 10.5l8.5 -3.5"
  }));
}
var FS = ["size", "color", "stroke"];
function GS(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, FS);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-circuit-diode-zener",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M22 12h-6"
  }), e.createElement("path", {
    d: "M2 12h6"
  }), e.createElement("path", {
    d: "M8 7l8 5l-8 5z"
  }), e.createElement("path", {
    d: "M14 7h2v10h2"
  }));
}
var JS = ["size", "color", "stroke"];
function KS(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, JS);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-circuit-diode",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M22 12h-6"
  }), e.createElement("path", {
    d: "M2 12h6"
  }), e.createElement("path", {
    d: "M8 7l8 5l-8 5z"
  }), e.createElement("path", {
    d: "M16 7v10"
  }));
}
var QS = ["size", "color", "stroke"];
function RS(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, QS);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-circuit-ground-digital",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M12 13v-10"
  }), e.createElement("path", {
    d: "M12 21l-6 -8h12z"
  }));
}
var TS = ["size", "color", "stroke"];
function US(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, TS);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-circuit-ground",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M12 13v-8"
  }), e.createElement("path", {
    d: "M4 13h16"
  }), e.createElement("path", {
    d: "M7 16h10"
  }), e.createElement("path", {
    d: "M10 19h4"
  }));
}
var VS = ["size", "color", "stroke"];
function XS(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, VS);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-circuit-inductor",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M2 14h3v-2a2 2 0 1 1 4 0v2v-1.5a2.5 2.5 0 1 1 5 0v1.5v-1.5a2.5 2.5 0 1 1 5 0v1.5h3"
  }));
}
var YS = ["size", "color", "stroke"];
function ZS(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, YS);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-circuit-motor",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 7
  }), e.createElement("path", {
    d: "M5 12h-3"
  }), e.createElement("path", {
    d: "M19 12h3"
  }), e.createElement("path", {
    d: "M10 14v-4l2 2l2 -2v4"
  }));
}
var $S = ["size", "color", "stroke"];
function _S(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, $S);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-circuit-pushbutton",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M2 17h2"
  }), e.createElement("path", {
    d: "M20 17h2"
  }), e.createElement("circle", {
    cx: 6,
    cy: 17,
    r: 2
  }), e.createElement("circle", {
    cx: 18,
    cy: 17,
    r: 2
  }), e.createElement("path", {
    d: "M6 11h12"
  }), e.createElement("path", {
    d: "M12 11v-6"
  }));
}
var eI = ["size", "color", "stroke"];
function tI(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, eI);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-circuit-resistor",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M2 12h2l2 -5l3 10l3 -10l3 10l3 -10l1.5 5h2.5"
  }));
}
var oI = ["size", "color", "stroke"];
function rI(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, oI);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-circuit-switch-closed",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M2 12h2"
  }), e.createElement("path", {
    d: "M20 12h2"
  }), e.createElement("circle", {
    cx: 6,
    cy: 12,
    r: 2
  }), e.createElement("circle", {
    cx: 18,
    cy: 12,
    r: 2
  }), e.createElement("path", {
    d: "M8 12h8"
  }));
}
var nI = ["size", "color", "stroke"];
function lI(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, nI);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-circuit-switch-open",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M2 12h2"
  }), e.createElement("path", {
    d: "M20 12h2"
  }), e.createElement("circle", {
    cx: 6,
    cy: 12,
    r: 2
  }), e.createElement("circle", {
    cx: 18,
    cy: 12,
    r: 2
  }), e.createElement("path", {
    d: "M7.5 10.5l7.5 -5.5"
  }));
}
var aI = ["size", "color", "stroke"];
function iI(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, aI);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-circuit-voltmeter",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 7
  }), e.createElement("path", {
    d: "M5 12h-3"
  }), e.createElement("path", {
    d: "M19 12h3"
  }), e.createElement("path", {
    d: "M10 10l2 4l2 -4"
  }));
}
var cI = ["size", "color", "stroke"];
function sI(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, cI);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-clear-all",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M8 6h12"
  }), e.createElement("path", {
    d: "M6 12h12"
  }), e.createElement("path", {
    d: "M4 18h12"
  }));
}
var hI = ["size", "color", "stroke"];
function dI(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, hI);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-clear-formatting",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M17 15l4 4m0 -4l-4 4"
  }), e.createElement("path", {
    d: "M7 6v-1h11v1"
  }), e.createElement("line", {
    x1: 7,
    y1: 19,
    x2: 11,
    y2: 19
  }), e.createElement("line", {
    x1: 13,
    y1: 5,
    x2: 9,
    y2: 19
  }));
}
var vI = ["size", "color", "stroke"];
function mI(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, vI);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-click",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("line", {
    x1: 3,
    y1: 12,
    x2: 6,
    y2: 12
  }), e.createElement("line", {
    x1: 12,
    y1: 3,
    x2: 12,
    y2: 6
  }), e.createElement("line", {
    x1: 7.8,
    y1: 7.8,
    x2: 5.6,
    y2: 5.6
  }), e.createElement("line", {
    x1: 16.2,
    y1: 7.8,
    x2: 18.4,
    y2: 5.6
  }), e.createElement("line", {
    x1: 7.8,
    y1: 16.2,
    x2: 5.6,
    y2: 18.4
  }), e.createElement("path", {
    d: "M12 12l9 3l-4 2l-2 4l-3 -9"
  }));
}
var kI = ["size", "color", "stroke"];
function wI(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, kI);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-clipboard-check",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M9 5h-2a2 2 0 0 0 -2 2v12a2 2 0 0 0 2 2h10a2 2 0 0 0 2 -2v-12a2 2 0 0 0 -2 -2h-2"
  }), e.createElement("rect", {
    x: 9,
    y: 3,
    width: 6,
    height: 4,
    rx: 2
  }), e.createElement("path", {
    d: "M9 14l2 2l4 -4"
  }));
}
var pI = ["size", "color", "stroke"];
function EI(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, pI);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-clipboard-copy",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M9 5h-2a2 2 0 0 0 -2 2v12a2 2 0 0 0 2 2h3m9 -9v-5a2 2 0 0 0 -2 -2h-2"
  }), e.createElement("path", {
    d: "M13 17v-1a1 1 0 0 1 1 -1h1m3 0h1a1 1 0 0 1 1 1v1m0 3v1a1 1 0 0 1 -1 1h-1m-3 0h-1a1 1 0 0 1 -1 -1v-1"
  }), e.createElement("rect", {
    x: 9,
    y: 3,
    width: 6,
    height: 4,
    rx: 2
  }));
}
var uI = ["size", "color", "stroke"];
function gI(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, uI);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-clipboard-data",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M9 5h-2a2 2 0 0 0 -2 2v12a2 2 0 0 0 2 2h10a2 2 0 0 0 2 -2v-12a2 2 0 0 0 -2 -2h-2"
  }), e.createElement("rect", {
    x: 9,
    y: 3,
    width: 6,
    height: 4,
    rx: 2
  }), e.createElement("path", {
    d: "M9 17v-4"
  }), e.createElement("path", {
    d: "M12 17v-1"
  }), e.createElement("path", {
    d: "M15 17v-2"
  }), e.createElement("path", {
    d: "M12 17v-1"
  }));
}
var MI = ["size", "color", "stroke"];
function xI(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, MI);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-clipboard-heart",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M9 5h-2a2 2 0 0 0 -2 2v12a2 2 0 0 0 2 2h10a2 2 0 0 0 2 -2v-12a2 2 0 0 0 -2 -2h-2"
  }), e.createElement("rect", {
    x: 9,
    y: 3,
    width: 6,
    height: 4,
    rx: 2
  }), e.createElement("path", {
    d: "M11.993 16.75l2.747 -2.815a1.9 1.9 0 0 0 .005 -2.632a1.775 1.775 0 0 0 -2.56 -.005l-.183 .188l-.183 -.189a1.775 1.775 0 0 0 -2.56 -.004a1.899 1.899 0 0 0 -.004 2.632l2.738 2.825z"
  }));
}
var fI = ["size", "color", "stroke"];
function zI(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, fI);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-clipboard-list",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M9 5h-2a2 2 0 0 0 -2 2v12a2 2 0 0 0 2 2h10a2 2 0 0 0 2 -2v-12a2 2 0 0 0 -2 -2h-2"
  }), e.createElement("rect", {
    x: 9,
    y: 3,
    width: 6,
    height: 4,
    rx: 2
  }), e.createElement("line", {
    x1: 9,
    y1: 12,
    x2: 9.01,
    y2: 12
  }), e.createElement("line", {
    x1: 13,
    y1: 12,
    x2: 15,
    y2: 12
  }), e.createElement("line", {
    x1: 9,
    y1: 16,
    x2: 9.01,
    y2: 16
  }), e.createElement("line", {
    x1: 13,
    y1: 16,
    x2: 15,
    y2: 16
  }));
}
var bI = ["size", "color", "stroke"];
function LI(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, bI);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-clipboard-off",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M5.575 5.597a1.994 1.994 0 0 0 -.575 1.403v12a2 2 0 0 0 2 2h10a2 2 0 0 0 2 -2m0 -4v-8a2 2 0 0 0 -2 -2h-2"
  }), e.createElement("path", {
    d: "M9 5a2 2 0 0 1 2 -2h2a2 2 0 1 1 0 4h-2"
  }), e.createElement("path", {
    d: "M3 3l18 18"
  }));
}
var yI = ["size", "color", "stroke"];
function CI(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, yI);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-clipboard-plus",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M9 5h-2a2 2 0 0 0 -2 2v12a2 2 0 0 0 2 2h10a2 2 0 0 0 2 -2v-12a2 2 0 0 0 -2 -2h-2"
  }), e.createElement("rect", {
    x: 9,
    y: 3,
    width: 6,
    height: 4,
    rx: 2
  }), e.createElement("path", {
    d: "M10 14h4"
  }), e.createElement("path", {
    d: "M12 12v4"
  }));
}
var jI = ["size", "color", "stroke"];
function BI(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, jI);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-clipboard-text",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M9 5h-2a2 2 0 0 0 -2 2v12a2 2 0 0 0 2 2h10a2 2 0 0 0 2 -2v-12a2 2 0 0 0 -2 -2h-2"
  }), e.createElement("rect", {
    x: 9,
    y: 3,
    width: 6,
    height: 4,
    rx: 2
  }), e.createElement("path", {
    d: "M9 12h6"
  }), e.createElement("path", {
    d: "M9 16h6"
  }));
}
var HI = ["size", "color", "stroke"];
function NI(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, HI);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-clipboard-typography",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M9 5h-2a2 2 0 0 0 -2 2v12a2 2 0 0 0 2 2h10a2 2 0 0 0 2 -2v-12a2 2 0 0 0 -2 -2h-2"
  }), e.createElement("rect", {
    x: 9,
    y: 3,
    width: 6,
    height: 4,
    rx: 2
  }), e.createElement("path", {
    d: "M9 12v-1h6v1"
  }), e.createElement("path", {
    d: "M12 11v6"
  }), e.createElement("path", {
    d: "M11 17h2"
  }));
}
var WI = ["size", "color", "stroke"];
function qI(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, WI);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-clipboard-x",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M9 5h-2a2 2 0 0 0 -2 2v12a2 2 0 0 0 2 2h10a2 2 0 0 0 2 -2v-12a2 2 0 0 0 -2 -2h-2"
  }), e.createElement("rect", {
    x: 9,
    y: 3,
    width: 6,
    height: 4,
    rx: 2
  }), e.createElement("path", {
    d: "M10 12l4 4m0 -4l-4 4"
  }));
}
var OI = ["size", "color", "stroke"];
function PI(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, OI);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-clipboard",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M9 5h-2a2 2 0 0 0 -2 2v12a2 2 0 0 0 2 2h10a2 2 0 0 0 2 -2v-12a2 2 0 0 0 -2 -2h-2"
  }), e.createElement("rect", {
    x: 9,
    y: 3,
    width: 6,
    height: 4,
    rx: 2
  }));
}
var SI = ["size", "color", "stroke"];
function II(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, SI);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-clock-2",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("rect", {
    x: 4,
    y: 4,
    width: 16,
    height: 16,
    rx: 1
  }), e.createElement("path", {
    d: "M12 7v5l3 3"
  }), e.createElement("path", {
    d: "M4 12h1"
  }), e.createElement("path", {
    d: "M19 12h1"
  }), e.createElement("path", {
    d: "M12 19v1"
  }));
}
var AI = ["size", "color", "stroke"];
function DI(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, AI);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-clock-cancel",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("circle", {
    cx: 19,
    cy: 19,
    r: 3
  }), e.createElement("path", {
    d: "M17 21l4 -4"
  }), e.createElement("path", {
    d: "M20.995 12.3a9 9 0 1 0 -8.683 8.694"
  }), e.createElement("path", {
    d: "M12 7v5l2 2"
  }));
}
var FI = ["size", "color", "stroke"];
function GI(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, FI);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-clock-edit",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M21 12a9.001 9.001 0 1 0 -9.972 8.948c.32 .034 .644 .052 .972 .052"
  }), e.createElement("path", {
    d: "M12 7v5l2 2"
  }), e.createElement("path", {
    d: "M18.42 15.61a2.1 2.1 0 0 1 2.97 2.97l-3.39 3.42h-3v-3l3.42 -3.39z"
  }));
}
var JI = ["size", "color", "stroke"];
function KI(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, JI);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-clock-hour-1",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 9
  }), e.createElement("path", {
    d: "M12 7v5"
  }), e.createElement("path", {
    d: "M12 12l2 -3"
  }));
}
var QI = ["size", "color", "stroke"];
function RI(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, QI);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-clock-hour-10",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 9
  }), e.createElement("path", {
    d: "M12 12l-3 -2"
  }), e.createElement("path", {
    d: "M12 7v5"
  }));
}
var TI = ["size", "color", "stroke"];
function UI(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, TI);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-clock-hour-11",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 9
  }), e.createElement("path", {
    d: "M12 12l-2 -3"
  }), e.createElement("path", {
    d: "M12 7v5"
  }));
}
var VI = ["size", "color", "stroke"];
function XI(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, VI);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-clock-hour-12",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 9
  }), e.createElement("path", {
    d: "M12 7v5"
  }));
}
var YI = ["size", "color", "stroke"];
function ZI(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, YI);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-clock-hour-2",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 9
  }), e.createElement("path", {
    d: "M12 12l3 -2"
  }), e.createElement("path", {
    d: "M12 7v5"
  }));
}
var $I = ["size", "color", "stroke"];
function _I(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, $I);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-clock-hour-3",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 9
  }), e.createElement("path", {
    d: "M12 12h3.5"
  }), e.createElement("path", {
    d: "M12 7v5"
  }));
}
var eA = ["size", "color", "stroke"];
function tA(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, eA);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-clock-hour-4",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 9
  }), e.createElement("path", {
    d: "M12 12l3 2"
  }), e.createElement("path", {
    d: "M12 7v5"
  }));
}
var oA = ["size", "color", "stroke"];
function rA(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, oA);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-clock-hour-5",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 9
  }), e.createElement("path", {
    d: "M12 12l2 3"
  }), e.createElement("path", {
    d: "M12 7v5"
  }));
}
var nA = ["size", "color", "stroke"];
function lA(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, nA);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-clock-hour-6",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 9
  }), e.createElement("path", {
    d: "M12 12v3.5"
  }), e.createElement("path", {
    d: "M12 7v5"
  }));
}
var aA = ["size", "color", "stroke"];
function iA(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, aA);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-clock-hour-7",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 9
  }), e.createElement("path", {
    d: "M12 12l-2 3"
  }), e.createElement("path", {
    d: "M12 7v5"
  }));
}
var cA = ["size", "color", "stroke"];
function sA(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, cA);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-clock-hour-8",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 9
  }), e.createElement("path", {
    d: "M12 12l-3 2"
  }), e.createElement("path", {
    d: "M12 7v5"
  }));
}
var hA = ["size", "color", "stroke"];
function dA(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, hA);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-clock-hour-9",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 9
  }), e.createElement("path", {
    d: "M12 12h-3.5"
  }), e.createElement("path", {
    d: "M12 7v5"
  }));
}
var vA = ["size", "color", "stroke"];
function mA(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, vA);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-clock-off",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M12 7v1"
  }), e.createElement("path", {
    d: "M20.042 16.045a9 9 0 0 0 -12.087 -12.087m-2.318 1.677a9 9 0 1 0 12.725 12.73"
  }), e.createElement("path", {
    d: "M3 3l18 18"
  }));
}
var kA = ["size", "color", "stroke"];
function wA(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, kA);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-clock-pause",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M13 20.94a8.916 8.916 0 0 1 -7.364 -2.576a9 9 0 1 1 15.306 -5.342"
  }), e.createElement("path", {
    d: "M12 7v5l2 2"
  }), e.createElement("path", {
    d: "M17 17v5"
  }), e.createElement("path", {
    d: "M21 17v5"
  }));
}
var pA = ["size", "color", "stroke"];
function EA(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, pA);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-clock-play",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M12 7v5l2 2"
  }), e.createElement("path", {
    d: "M17 22l5 -3l-5 -3z"
  }), e.createElement("path", {
    d: "M13.017 20.943a9 9 0 1 1 7.831 -7.292"
  }));
}
var uA = ["size", "color", "stroke"];
function gA(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, uA);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-clock-record",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M20.995 12.3a9 9 0 1 0 -8.683 8.694"
  }), e.createElement("path", {
    d: "M12 7v5l2 2"
  }), e.createElement("circle", {
    cx: 19,
    cy: 19,
    r: 3
  }));
}
var MA = ["size", "color", "stroke"];
function xA(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, MA);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-clock-stop",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M21 12a9 9 0 1 0 -9 9"
  }), e.createElement("path", {
    d: "M12 7v5l1 1"
  }), e.createElement("path", {
    d: "M16 16h6v6h-6z"
  }));
}
var fA = ["size", "color", "stroke"];
function zA(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, fA);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-clock",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 9
  }), e.createElement("polyline", {
    points: "12 7 12 12 15 15"
  }));
}
var bA = ["size", "color", "stroke"];
function LA(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, bA);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-clothes-rack-off",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("circle", {
    cx: 12,
    cy: 5,
    r: 2
  }), e.createElement("path", {
    d: "M12 7v1m0 4v9"
  }), e.createElement("path", {
    d: "M9 21h6"
  }), e.createElement("path", {
    d: "M7.757 9.243a6 6 0 0 0 3.129 1.653m3.578 -.424a5.999 5.999 0 0 0 1.779 -1.229"
  }), e.createElement("path", {
    d: "M3 3l18 18"
  }));
}
var yA = ["size", "color", "stroke"];
function CA(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, yA);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-clothes-rack",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("circle", {
    cx: 12,
    cy: 5,
    r: 2
  }), e.createElement("path", {
    d: "M12 7v14"
  }), e.createElement("path", {
    d: "M9 21h6"
  }), e.createElement("path", {
    d: "M7.757 9.243a6 6 0 0 0 8.486 0"
  }));
}
var jA = ["size", "color", "stroke"];
function BA(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, jA);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-cloud-computing",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M6.657 16c-2.572 0 -4.657 -2.007 -4.657 -4.483c0 -2.475 2.085 -4.482 4.657 -4.482c.393 -1.762 1.794 -3.2 3.675 -3.773c1.88 -.572 3.956 -.193 5.444 .996c1.488 1.19 2.162 3.007 1.77 4.769h.99c1.913 0 3.464 1.56 3.464 3.486c0 1.927 -1.551 3.487 -3.465 3.487h-11.878"
  }), e.createElement("path", {
    d: "M12 16v5"
  }), e.createElement("path", {
    d: "M16 16v4a1 1 0 0 0 1 1h4"
  }), e.createElement("path", {
    d: "M8 16v4a1 1 0 0 1 -1 1h-4"
  }));
}
var HA = ["size", "color", "stroke"];
function NA(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, HA);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-cloud-data-connection",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M5 9.897c0 -1.714 1.46 -3.104 3.26 -3.104c.275 -1.22 1.255 -2.215 2.572 -2.611c1.317 -.397 2.77 -.134 3.811 .69c1.042 .822 1.514 2.08 1.239 3.3h.693a2.42 2.42 0 0 1 2.425 2.414a2.42 2.42 0 0 1 -2.425 2.414h-8.315c-1.8 0 -3.26 -1.39 -3.26 -3.103z"
  }), e.createElement("path", {
    d: "M12 13v3"
  }), e.createElement("circle", {
    cx: 12,
    cy: 18,
    r: 2
  }), e.createElement("path", {
    d: "M14 18h7"
  }), e.createElement("path", {
    d: "M3 18h7"
  }));
}
var WA = ["size", "color", "stroke"];
function qA(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, WA);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-cloud-download",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M19 18a3.5 3.5 0 0 0 0 -7h-1a5 4.5 0 0 0 -11 -2a4.6 4.4 0 0 0 -2.1 8.4"
  }), e.createElement("line", {
    x1: 12,
    y1: 13,
    x2: 12,
    y2: 22
  }), e.createElement("polyline", {
    points: "9 19 12 22 15 19"
  }));
}
var OA = ["size", "color", "stroke"];
function PA(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, OA);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-cloud-fog",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M7 16a4.6 4.4 0 0 1 0 -9a5 4.5 0 0 1 11 2h1a3.5 3.5 0 0 1 0 7h-12"
  }), e.createElement("line", {
    x1: 5,
    y1: 20,
    x2: 19,
    y2: 20
  }));
}
var SA = ["size", "color", "stroke"];
function IA(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, SA);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-cloud-lock-open",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M19 18a3.5 3.5 0 0 0 0 -7h-1c.397 -1.768 -.285 -3.593 -1.788 -4.787c-1.503 -1.193 -3.6 -1.575 -5.5 -1s-3.315 2.019 -3.712 3.787c-2.199 -.088 -4.155 1.326 -4.666 3.373c-.512 2.047 .564 4.154 2.566 5.027"
  }), e.createElement("rect", {
    x: 8,
    y: 15,
    width: 8,
    height: 5,
    rx: 1
  }), e.createElement("path", {
    d: "M10 15v-2a2 2 0 0 1 3.736 -.994"
  }));
}
var AA = ["size", "color", "stroke"];
function DA(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, AA);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-cloud-lock",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M19 18a3.5 3.5 0 0 0 0 -7h-1c.397 -1.768 -.285 -3.593 -1.788 -4.787c-1.503 -1.193 -3.6 -1.575 -5.5 -1s-3.315 2.019 -3.712 3.787c-2.199 -.088 -4.155 1.326 -4.666 3.373c-.512 2.047 .564 4.154 2.566 5.027"
  }), e.createElement("rect", {
    x: 8,
    y: 15,
    width: 8,
    height: 5,
    rx: 1
  }), e.createElement("path", {
    d: "M10 15v-2a2 2 0 1 1 4 0v2"
  }));
}
var FA = ["size", "color", "stroke"];
function GA(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, FA);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-cloud-off",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("line", {
    x1: 3,
    y1: 3,
    x2: 21,
    y2: 21
  }), e.createElement("path", {
    d: "M18 18h-11c-2.598 0 -4.705 -2.015 -4.705 -4.5s2.107 -4.5 4.705 -4.5c.112 -.5 .305 -.973 .568 -1.408m2.094 -1.948c.329 -.174 .68 -.319 1.05 -.43c1.9 -.576 3.997 -.194 5.5 1c1.503 1.192 2.185 3.017 1.788 4.786h1a3.5 3.5 0 0 1 2.212 6.212"
  }));
}
var JA = ["size", "color", "stroke"];
function KA(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, JA);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-cloud-rain",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M7 18a4.6 4.4 0 0 1 0 -9a5 4.5 0 0 1 11 2h1a3.5 3.5 0 0 1 0 7"
  }), e.createElement("path", {
    d: "M11 13v2m0 3v2m4 -5v2m0 3v2"
  }));
}
var QA = ["size", "color", "stroke"];
function RA(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, QA);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-cloud-snow",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M7 18a4.6 4.4 0 0 1 0 -9a5 4.5 0 0 1 11 2h1a3.5 3.5 0 0 1 0 7"
  }), e.createElement("path", {
    d: "M11 15v.01m0 3v.01m0 3v.01m4 -4v.01m0 3v.01"
  }));
}
var TA = ["size", "color", "stroke"];
function UA(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, TA);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-cloud-storm",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M7 18a4.6 4.4 0 0 1 0 -9a5 4.5 0 0 1 11 2h1a3.5 3.5 0 0 1 0 7h-1"
  }), e.createElement("polyline", {
    points: "13 14 11 18 14 18 12 22"
  }));
}
var VA = ["size", "color", "stroke"];
function XA(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, VA);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-cloud-upload",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M7 18a4.6 4.4 0 0 1 0 -9a5 4.5 0 0 1 11 2h1a3.5 3.5 0 0 1 0 7h-1"
  }), e.createElement("polyline", {
    points: "9 15 12 12 15 15"
  }), e.createElement("line", {
    x1: 12,
    y1: 12,
    x2: 12,
    y2: 21
  }));
}
var YA = ["size", "color", "stroke"];
function ZA(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, YA);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-cloud",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M6.657 18c-2.572 0 -4.657 -2.007 -4.657 -4.483c0 -2.475 2.085 -4.482 4.657 -4.482c.393 -1.762 1.794 -3.2 3.675 -3.773c1.88 -.572 3.956 -.193 5.444 .996c1.488 1.19 2.162 3.007 1.77 4.769h.99c1.913 0 3.464 1.56 3.464 3.486c0 1.927 -1.551 3.487 -3.465 3.487h-11.878"
  }));
}
var $A = ["size", "color", "stroke"];
function _A(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, $A);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-clover-2",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M11 11l-3.397 -3.44a2.104 2.104 0 0 1 0 -2.95a2.04 2.04 0 0 1 2.912 0l.485 .39l.485 -.39a2.04 2.04 0 0 1 2.912 0a2.104 2.104 0 0 1 0 2.95l-3.397 3.44z"
  }), e.createElement("path", {
    d: "M11 11l-3.397 3.44a2.104 2.104 0 0 0 0 2.95a2.04 2.04 0 0 0 2.912 0l.485 -.39l.485 .39a2.04 2.04 0 0 0 2.912 0a2.104 2.104 0 0 0 0 -2.95l-3.397 -3.44z"
  }), e.createElement("path", {
    d: "M14.44 7.603a2.104 2.104 0 0 1 2.95 0a2.04 2.04 0 0 1 0 2.912l-.39 .485l.39 .485a2.04 2.04 0 0 1 0 2.912a2.104 2.104 0 0 1 -2.95 0"
  }), e.createElement("path", {
    d: "M7.56 7.603a2.104 2.104 0 0 0 -2.95 0a2.04 2.04 0 0 0 0 2.912l.39 .485l-.39 .485a2.04 2.04 0 0 0 0 2.912a2.104 2.104 0 0 0 2.95 0"
  }), e.createElement("path", {
    d: "M15 15l6 6"
  }));
}
var eD = ["size", "color", "stroke"];
function tD(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, eD);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-clover",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M12 10l-3.397 -3.44a2.104 2.104 0 0 1 0 -2.95a2.04 2.04 0 0 1 2.912 0l.485 .39l.485 -.39a2.04 2.04 0 0 1 2.912 0a2.104 2.104 0 0 1 0 2.95l-3.397 3.44z"
  }), e.createElement("path", {
    d: "M12 14l-3.397 3.44a2.104 2.104 0 0 0 0 2.95a2.04 2.04 0 0 0 2.912 0l.485 -.39l.485 .39a2.04 2.04 0 0 0 2.912 0a2.104 2.104 0 0 0 0 -2.95l-3.397 -3.44z"
  }), e.createElement("path", {
    d: "M14 12l3.44 -3.397a2.104 2.104 0 0 1 2.95 0a2.04 2.04 0 0 1 0 2.912l-.39 .485l.39 .485a2.04 2.04 0 0 1 0 2.912a2.104 2.104 0 0 1 -2.95 0l-3.44 -3.397z"
  }), e.createElement("path", {
    d: "M10 12l-3.44 -3.397a2.104 2.104 0 0 0 -2.95 0a2.04 2.04 0 0 0 0 2.912l.39 .485l-.39 .485a2.04 2.04 0 0 0 0 2.912a2.104 2.104 0 0 0 2.95 0l3.44 -3.397z"
  }));
}
var oD = ["size", "color", "stroke"];
function rD(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, oD);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-clubs",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M12 3a4 4 0 0 1 3.164 6.447a4 4 0 1 1 -1.164 6.198v1.355l1 4h-6l1 -4l.001 -1.355a4 4 0 1 1 -1.164 -6.199a4 4 0 0 1 3.163 -6.446z"
  }));
}
var nD = ["size", "color", "stroke"];
function lD(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, nD);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-code-asterix",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M6 19a2 2 0 0 1 -2 -2v-4l-1 -1l1 -1v-4a2 2 0 0 1 2 -2"
  }), e.createElement("path", {
    d: "M12 11.875l3 -1.687"
  }), e.createElement("path", {
    d: "M12 11.875v3.375"
  }), e.createElement("path", {
    d: "M12 11.875l-3 -1.687"
  }), e.createElement("path", {
    d: "M12 11.875l3 1.688"
  }), e.createElement("path", {
    d: "M12 8.5v3.375"
  }), e.createElement("path", {
    d: "M12 11.875l-3 1.688"
  }), e.createElement("path", {
    d: "M18 19a2 2 0 0 0 2 -2v-4l1 -1l-1 -1v-4a2 2 0 0 0 -2 -2"
  }));
}
var aD = ["size", "color", "stroke"];
function iD(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, aD);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-code-circle-2",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M8.5 13.5l-1.5 -1.5l1.5 -1.5"
  }), e.createElement("path", {
    d: "M15.5 10.5l1.5 1.5l-1.5 1.5"
  }), e.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 9
  }), e.createElement("path", {
    d: "M13 9.5l-2 5.5"
  }));
}
var cD = ["size", "color", "stroke"];
function sD(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, cD);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-code-circle",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M10 14l-2 -2l2 -2"
  }), e.createElement("path", {
    d: "M14 10l2 2l-2 2"
  }), e.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 9
  }));
}
var hD = ["size", "color", "stroke"];
function dD(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, hD);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-code-dots",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M15 12h.01"
  }), e.createElement("path", {
    d: "M12 12h.01"
  }), e.createElement("path", {
    d: "M9 12h.01"
  }), e.createElement("path", {
    d: "M6 19a2 2 0 0 1 -2 -2v-4l-1 -1l1 -1v-4a2 2 0 0 1 2 -2"
  }), e.createElement("path", {
    d: "M18 19a2 2 0 0 0 2 -2v-4l1 -1l-1 -1v-4a2 2 0 0 0 -2 -2"
  }));
}
var vD = ["size", "color", "stroke"];
function mD(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, vD);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-code-minus",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M9 12h6"
  }), e.createElement("path", {
    d: "M6 19a2 2 0 0 1 -2 -2v-4l-1 -1l1 -1v-4a2 2 0 0 1 2 -2"
  }), e.createElement("path", {
    d: "M18 19a2 2 0 0 0 2 -2v-4l1 -1l-1 -1v-4a2 2 0 0 0 -2 -2"
  }));
}
var kD = ["size", "color", "stroke"];
function wD(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, kD);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-code-off",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M7 8l-4 4l4 4"
  }), e.createElement("path", {
    d: "M17 8l4 4l-2.5 2.5"
  }), e.createElement("path", {
    d: "M14 4l-1.201 4.805m-.802 3.207l-1.997 7.988"
  }), e.createElement("path", {
    d: "M3 3l18 18"
  }));
}
var pD = ["size", "color", "stroke"];
function ED(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, pD);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-code-plus",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M9 12h6"
  }), e.createElement("path", {
    d: "M12 9v6"
  }), e.createElement("path", {
    d: "M6 19a2 2 0 0 1 -2 -2v-4l-1 -1l1 -1v-4a2 2 0 0 1 2 -2"
  }), e.createElement("path", {
    d: "M18 19a2 2 0 0 0 2 -2v-4l1 -1l-1 -1v-4a2 2 0 0 0 -2 -2"
  }));
}
var uD = ["size", "color", "stroke"];
function gD(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, uD);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-code",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("polyline", {
    points: "7 8 3 12 7 16"
  }), e.createElement("polyline", {
    points: "17 8 21 12 17 16"
  }), e.createElement("line", {
    x1: 14,
    y1: 4,
    x2: 10,
    y2: 20
  }));
}
var MD = ["size", "color", "stroke"];
function xD(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, MD);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-coffee-off",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M3 14c.83 .642 2.077 1.017 3.5 1c1.423 .017 2.67 -.358 3.5 -1c.73 -.565 1.783 -.923 2.994 -.99"
  }), e.createElement("path", {
    d: "M8 3c-.194 .14 -.364 .305 -.506 .49"
  }), e.createElement("path", {
    d: "M12 3a2.4 2.4 0 0 0 -1 2a2.4 2.4 0 0 0 1 2"
  }), e.createElement("path", {
    d: "M14 10h3v3m-.257 3.743a6.003 6.003 0 0 1 -5.743 4.257h-2a6 6 0 0 1 -6 -6v-5h7"
  }), e.createElement("path", {
    d: "M20.116 16.124a3 3 0 0 0 -3.118 -4.953"
  }), e.createElement("path", {
    d: "M3 3l18 18"
  }));
}
var fD = ["size", "color", "stroke"];
function zD(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, fD);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-coffee",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M3 14c.83 .642 2.077 1.017 3.5 1c1.423 .017 2.67 -.358 3.5 -1c.83 -.642 2.077 -1.017 3.5 -1c1.423 -.017 2.67 .358 3.5 1"
  }), e.createElement("path", {
    d: "M8 3a2.4 2.4 0 0 0 -1 2a2.4 2.4 0 0 0 1 2"
  }), e.createElement("path", {
    d: "M12 3a2.4 2.4 0 0 0 -1 2a2.4 2.4 0 0 0 1 2"
  }), e.createElement("path", {
    d: "M3 10h14v5a6 6 0 0 1 -6 6h-2a6 6 0 0 1 -6 -6v-5z"
  }), e.createElement("path", {
    d: "M16.746 16.726a3 3 0 1 0 .252 -5.555"
  }));
}
var bD = ["size", "color", "stroke"];
function LD(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, bD);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-coffin",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M7 3l-2 6l2 12h6l2 -12l-2 -6z"
  }), e.createElement("path", {
    d: "M10 7v5"
  }), e.createElement("path", {
    d: "M8 9h4"
  }), e.createElement("path", {
    d: "M13 21h4l2 -12l-2 -6h-4"
  }));
}
var yD = ["size", "color", "stroke"];
function CD(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, yD);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-coin-bitcoin",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 9
  }), e.createElement("path", {
    d: "M9 8h4.09c1.055 0 1.91 .895 1.91 2s-.855 2 -1.91 2c1.055 0 1.91 .895 1.91 2s-.855 2 -1.91 2h-4.09"
  }), e.createElement("path", {
    d: "M10 12h4"
  }), e.createElement("path", {
    d: "M10 7v10v-9"
  }), e.createElement("path", {
    d: "M13 7v1"
  }), e.createElement("path", {
    d: "M13 16v1"
  }));
}
var jD = ["size", "color", "stroke"];
function BD(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, jD);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-coin-euro",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 9
  }), e.createElement("path", {
    d: "M14.401 8c-.669 -.628 -1.5 -1 -2.401 -1c-2.21 0 -4 2.239 -4 5s1.79 5 4 5c.9 0 1.731 -.372 2.4 -1"
  }), e.createElement("path", {
    d: "M7 10.5h4"
  }), e.createElement("path", {
    d: "M7 13.5h4"
  }));
}
var HD = ["size", "color", "stroke"];
function ND(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, HD);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-coin-monero",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 9
  }), e.createElement("path", {
    d: "M4 16h4v-7l4 4l4 -4v7h4"
  }));
}
var WD = ["size", "color", "stroke"];
function qD(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, WD);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-coin-off",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M14.8 9a2 2 0 0 0 -1.8 -1h-1m-2.82 1.171a2 2 0 0 0 1.82 2.829h1m2.824 2.822a2 2 0 0 1 -1.824 1.178h-2a2 2 0 0 1 -1.8 -1"
  }), e.createElement("path", {
    d: "M20.042 16.045a9 9 0 0 0 -12.087 -12.087m-2.318 1.677a9 9 0 1 0 12.725 12.73"
  }), e.createElement("path", {
    d: "M12 6v2m0 8v2"
  }), e.createElement("path", {
    d: "M3 3l18 18"
  }));
}
var OD = ["size", "color", "stroke"];
function PD(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, OD);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-coin-pound",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 9
  }), e.createElement("path", {
    d: "M15 9a2 2 0 1 0 -4 0v5a2 2 0 0 1 -2 2h6"
  }), e.createElement("path", {
    d: "M9 12h4"
  }));
}
var SD = ["size", "color", "stroke"];
function ID(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, SD);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-coin-rupee",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 9
  }), e.createElement("path", {
    d: "M15 8h-6h1a3 3 0 0 1 0 6h-1l3 3"
  }), e.createElement("path", {
    d: "M9 11h6"
  }));
}
var AD = ["size", "color", "stroke"];
function DD(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, AD);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-coin-yen",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 9
  }), e.createElement("path", {
    d: "M9 12h6"
  }), e.createElement("path", {
    d: "M9 15h6"
  }), e.createElement("path", {
    d: "M9 8l3 4.5"
  }), e.createElement("path", {
    d: "M15 8l-3 4.5v4.5"
  }));
}
var FD = ["size", "color", "stroke"];
function GD(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, FD);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-coin-yuan",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 9
  }), e.createElement("path", {
    d: "M9 13h6"
  }), e.createElement("path", {
    d: "M9 8l3 4.5"
  }), e.createElement("path", {
    d: "M15 8l-3 4.5v4.5"
  }));
}
var JD = ["size", "color", "stroke"];
function KD(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, JD);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-coin",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 9
  }), e.createElement("path", {
    d: "M14.8 9a2 2 0 0 0 -1.8 -1h-2a2 2 0 1 0 0 4h2a2 2 0 1 1 0 4h-2a2 2 0 0 1 -1.8 -1"
  }), e.createElement("path", {
    d: "M12 7v10"
  }));
}
var QD = ["size", "color", "stroke"];
function RD(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, QD);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-coins",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M9 14c0 1.657 2.686 3 6 3s6 -1.343 6 -3s-2.686 -3 -6 -3s-6 1.343 -6 3z"
  }), e.createElement("path", {
    d: "M9 14v4c0 1.656 2.686 3 6 3s6 -1.344 6 -3v-4"
  }), e.createElement("path", {
    d: "M3 6c0 1.072 1.144 2.062 3 2.598s4.144 .536 6 0c1.856 -.536 3 -1.526 3 -2.598c0 -1.072 -1.144 -2.062 -3 -2.598s-4.144 -.536 -6 0c-1.856 .536 -3 1.526 -3 2.598z"
  }), e.createElement("path", {
    d: "M3 6v10c0 .888 .772 1.45 2 2"
  }), e.createElement("path", {
    d: "M3 11c0 .888 .772 1.45 2 2"
  }));
}
var TD = ["size", "color", "stroke"];
function UD(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, TD);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-color-filter",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M13.58 13.79c.27 .68 .42 1.43 .42 2.21c0 1.77 -.77 3.37 -2 4.46a5.93 5.93 0 0 1 -4 1.54c-3.31 0 -6 -2.69 -6 -6c0 -2.76 1.88 -5.1 4.42 -5.79"
  }), e.createElement("path", {
    d: "M17.58 10.21c2.54 .69 4.42 3.03 4.42 5.79c0 3.31 -2.69 6 -6 6a5.93 5.93 0 0 1 -4 -1.54"
  }), e.createElement("circle", {
    cx: 12,
    cy: 8,
    r: 6
  }));
}
var VD = ["size", "color", "stroke"];
function XD(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, VD);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-color-picker-off",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M11 7l6 6"
  }), e.createElement("path", {
    d: "M12.001 7.999l3.699 -3.699a1 1 0 0 1 1.4 0l2.6 2.6a1 1 0 0 1 0 1.4l-3.702 3.702m-1.998 1.998l-6 6h-4v-4l6.002 -6.002"
  }), e.createElement("path", {
    d: "M3 3l18 18"
  }));
}
var YD = ["size", "color", "stroke"];
function ZD(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, YD);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-color-picker",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M11 7l6 6"
  }), e.createElement("path", {
    d: "M4 16l11.7 -11.7a1 1 0 0 1 1.4 0l2.6 2.6a1 1 0 0 1 0 1.4l-11.7 11.7h-4v-4z"
  }));
}
var $D = ["size", "color", "stroke"];
function _D(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, $D);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-color-swatch-off",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M13 13v4a4 4 0 0 0 6.832 2.825m1.168 -2.825v-12a2 2 0 0 0 -2 -2h-4a2 2 0 0 0 -2 2v4"
  }), e.createElement("path", {
    d: "M13 7.35l-2 -2a2 2 0 0 0 -2.11 -.461m-2.13 1.874l-1.416 1.415a2 2 0 0 0 0 2.828l9 9"
  }), e.createElement("path", {
    d: "M7.3 13h-2.3a2 2 0 0 0 -2 2v4a2 2 0 0 0 2 2h12"
  }), e.createElement("path", {
    d: "M17 17v.01"
  }), e.createElement("path", {
    d: "M3 3l18 18"
  }));
}
var eF = ["size", "color", "stroke"];
function tF(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, eF);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-color-swatch",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M19 3h-4a2 2 0 0 0 -2 2v12a4 4 0 0 0 8 0v-12a2 2 0 0 0 -2 -2"
  }), e.createElement("path", {
    d: "M13 7.35l-2 -2a2 2 0 0 0 -2.828 0l-2.828 2.828a2 2 0 0 0 0 2.828l9 9"
  }), e.createElement("path", {
    d: "M7.3 13h-2.3a2 2 0 0 0 -2 2v4a2 2 0 0 0 2 2h12"
  }), e.createElement("line", {
    x1: 17,
    y1: 17,
    x2: 17,
    y2: 17.01
  }));
}
var oF = ["size", "color", "stroke"];
function rF(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, oF);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-column-insert-left",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M14 4h4a1 1 0 0 1 1 1v14a1 1 0 0 1 -1 1h-4a1 1 0 0 1 -1 -1v-14a1 1 0 0 1 1 -1z"
  }), e.createElement("line", {
    x1: 5,
    y1: 12,
    x2: 9,
    y2: 12
  }), e.createElement("line", {
    x1: 7,
    y1: 10,
    x2: 7,
    y2: 14
  }));
}
var nF = ["size", "color", "stroke"];
function lF(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, nF);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-column-insert-right",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M6 4h4a1 1 0 0 1 1 1v14a1 1 0 0 1 -1 1h-4a1 1 0 0 1 -1 -1v-14a1 1 0 0 1 1 -1z"
  }), e.createElement("line", {
    x1: 15,
    y1: 12,
    x2: 19,
    y2: 12
  }), e.createElement("line", {
    x1: 17,
    y1: 10,
    x2: 17,
    y2: 14
  }));
}
var aF = ["size", "color", "stroke"];
function iF(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, aF);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-columns-off",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M4 6h2"
  }), e.createElement("path", {
    d: "M4 10h5.5"
  }), e.createElement("path", {
    d: "M4 14h5.5"
  }), e.createElement("path", {
    d: "M4 18h5.5"
  }), e.createElement("path", {
    d: "M14.5 6h5.5"
  }), e.createElement("path", {
    d: "M14.5 10h5.5"
  }), e.createElement("path", {
    d: "M18 14h2"
  }), e.createElement("path", {
    d: "M14.5 18h3.5"
  }), e.createElement("path", {
    d: "M3 3l18 18"
  }));
}
var cF = ["size", "color", "stroke"];
function sF(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, cF);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-columns",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("line", {
    x1: 4,
    y1: 6,
    x2: 9.5,
    y2: 6
  }), e.createElement("line", {
    x1: 4,
    y1: 10,
    x2: 9.5,
    y2: 10
  }), e.createElement("line", {
    x1: 4,
    y1: 14,
    x2: 9.5,
    y2: 14
  }), e.createElement("line", {
    x1: 4,
    y1: 18,
    x2: 9.5,
    y2: 18
  }), e.createElement("line", {
    x1: 14.5,
    y1: 6,
    x2: 20,
    y2: 6
  }), e.createElement("line", {
    x1: 14.5,
    y1: 10,
    x2: 20,
    y2: 10
  }), e.createElement("line", {
    x1: 14.5,
    y1: 14,
    x2: 20,
    y2: 14
  }), e.createElement("line", {
    x1: 14.5,
    y1: 18,
    x2: 20,
    y2: 18
  }));
}
var hF = ["size", "color", "stroke"];
function dF(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, hF);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-comet",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M15.5 18.5l-3 1.5l.5 -3.5l-2 -2l3 -.5l1.5 -3l1.5 3l3 .5l-2 2l.5 3.5z"
  }), e.createElement("line", {
    x1: 4,
    y1: 4,
    x2: 11,
    y2: 11
  }), e.createElement("line", {
    x1: 9,
    y1: 4,
    x2: 12.5,
    y2: 7.5
  }), e.createElement("line", {
    x1: 4,
    y1: 9,
    x2: 7.5,
    y2: 12.5
  }));
}
var vF = ["size", "color", "stroke"];
function mF(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, vF);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-command-off",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M9 9v8a2 2 0 1 1 -2 -2h8m3.411 3.417a2 2 0 0 1 -3.411 -1.417v-2m0 -4v-4a2 2 0 1 1 2 2h-4m-4 0h-2a2 2 0 0 1 -1.417 -3.411"
  }), e.createElement("path", {
    d: "M3 3l18 18"
  }));
}
var kF = ["size", "color", "stroke"];
function wF(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, kF);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-command",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M7 9a2 2 0 1 1 2 -2v10a2 2 0 1 1 -2 -2h10a2 2 0 1 1 -2 2v-10a2 2 0 1 1 2 2h-10"
  }));
}
var pF = ["size", "color", "stroke"];
function EF(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, pF);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-compass-off",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M12.999 9l3.001 -1l-1.002 3.005m-.998 2.995l-6 2l2 -6"
  }), e.createElement("path", {
    d: "M20.042 16.045a9 9 0 0 0 -12.087 -12.087m-2.318 1.677a9 9 0 1 0 12.725 12.73"
  }), e.createElement("path", {
    d: "M12 3v2"
  }), e.createElement("path", {
    d: "M12 19v2"
  }), e.createElement("path", {
    d: "M3 12h2"
  }), e.createElement("path", {
    d: "M19 12h2"
  }), e.createElement("path", {
    d: "M3 3l18 18"
  }));
}
var uF = ["size", "color", "stroke"];
function gF(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, uF);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-compass",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("polyline", {
    points: "8 16 10 10 16 8 14 14 8 16"
  }), e.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 9
  }), e.createElement("line", {
    x1: 12,
    y1: 3,
    x2: 12,
    y2: 5
  }), e.createElement("line", {
    x1: 12,
    y1: 19,
    x2: 12,
    y2: 21
  }), e.createElement("line", {
    x1: 3,
    y1: 12,
    x2: 5,
    y2: 12
  }), e.createElement("line", {
    x1: 19,
    y1: 12,
    x2: 21,
    y2: 12
  }));
}
var MF = ["size", "color", "stroke"];
function xF(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, MF);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-components-off",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M3 12l3 3l3 -3l-3 -3z"
  }), e.createElement("path", {
    d: "M18.5 14.5l2.5 -2.5l-3 -3l-2.5 2.5"
  }), e.createElement("path", {
    d: "M12.499 8.501l2.501 -2.501l-3 -3l-2.5 2.5"
  }), e.createElement("path", {
    d: "M9 18l3 3l3 -3l-3 -3z"
  }), e.createElement("path", {
    d: "M3 3l18 18"
  }));
}
var fF = ["size", "color", "stroke"];
function zF(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, fF);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-components",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M3 12l3 3l3 -3l-3 -3z"
  }), e.createElement("path", {
    d: "M15 12l3 3l3 -3l-3 -3z"
  }), e.createElement("path", {
    d: "M9 6l3 3l3 -3l-3 -3z"
  }), e.createElement("path", {
    d: "M9 18l3 3l3 -3l-3 -3z"
  }));
}
var bF = ["size", "color", "stroke"];
function LF(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, bF);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-cone-2",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("ellipse", {
    cx: 12,
    cy: 7,
    rx: 7,
    ry: 3
  }), e.createElement("path", {
    d: "M19 7v.5l-7 12.5l-7 -12.5v-.5"
  }));
}
var yF = ["size", "color", "stroke"];
function CF(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, yF);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-cone-off",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M18.305 18.305c-1.132 1.003 -3.53 1.695 -6.305 1.695c-3.866 0 -7 -1.343 -7 -3s3.134 -3 7 -3c.747 0 1.467 .05 2.142 .143"
  }), e.createElement("path", {
    d: "M17.07 13.054l-5.07 -9.054l-1.432 2.558m-1.439 2.569l-4.129 7.373v.5"
  }), e.createElement("path", {
    d: "M3 3l18 18"
  }));
}
var jF = ["size", "color", "stroke"];
function BF(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, jF);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-cone",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M12 14c3.866 0 7 1.343 7 3s-3.134 3 -7 3s-7 -1.343 -7 -3s3.134 -3 7 -3z"
  }), e.createElement("path", {
    d: "M19 17v-.5l-7 -12.5l-7 12.5v.5"
  }));
}
var HF = ["size", "color", "stroke"];
function NF(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, HF);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-confetti-off",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M4 5h1"
  }), e.createElement("path", {
    d: "M5 5v1"
  }), e.createElement("path", {
    d: "M11.5 4l-.5 2"
  }), e.createElement("path", {
    d: "M18 5h2"
  }), e.createElement("path", {
    d: "M19 4v2"
  }), e.createElement("path", {
    d: "M15 9l-1 1"
  }), e.createElement("path", {
    d: "M18 13l2 -.5"
  }), e.createElement("path", {
    d: "M18 19h1"
  }), e.createElement("path", {
    d: "M19 19v1"
  }), e.createElement("path", {
    d: "M14 16.518l-6.518 -6.518l-4.39 9.58a1.003 1.003 0 0 0 1.329 1.329l9.579 -4.39v-.001z"
  }), e.createElement("path", {
    d: "M3 3l18 18"
  }));
}
var WF = ["size", "color", "stroke"];
function qF(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, WF);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-confetti",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M4 5h2"
  }), e.createElement("path", {
    d: "M5 4v2"
  }), e.createElement("path", {
    d: "M11.5 4l-.5 2"
  }), e.createElement("path", {
    d: "M18 5h2"
  }), e.createElement("path", {
    d: "M19 4v2"
  }), e.createElement("path", {
    d: "M15 9l-1 1"
  }), e.createElement("path", {
    d: "M18 13l2 -.5"
  }), e.createElement("path", {
    d: "M18 19h2"
  }), e.createElement("path", {
    d: "M19 18v2"
  }), e.createElement("path", {
    d: "M14 16.518l-6.518 -6.518l-4.39 9.58a1.003 1.003 0 0 0 1.329 1.329l9.579 -4.39z"
  }));
}
var OF = ["size", "color", "stroke"];
function PF(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, OF);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-confucius",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M9 19l3 2v-18"
  }), e.createElement("path", {
    d: "M4 10l8 -2"
  }), e.createElement("path", {
    d: "M4 18l8 -10"
  }), e.createElement("path", {
    d: "M20 18l-8 -8l8 -4"
  }));
}
var SF = ["size", "color", "stroke"];
function IF(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, SF);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-container-off",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M20 4v.01"
  }), e.createElement("path", {
    d: "M20 20v.01"
  }), e.createElement("path", {
    d: "M20 16v.01"
  }), e.createElement("path", {
    d: "M20 12v.01"
  }), e.createElement("path", {
    d: "M20 8v.01"
  }), e.createElement("path", {
    d: "M8.297 4.289a0.997 .997 0 0 1 .703 -.289h6a1 1 0 0 1 1 1v7m0 4v3a1 1 0 0 1 -1 1h-6a1 1 0 0 1 -1 -1v-11"
  }), e.createElement("path", {
    d: "M4 4v.01"
  }), e.createElement("path", {
    d: "M4 20v.01"
  }), e.createElement("path", {
    d: "M4 16v.01"
  }), e.createElement("path", {
    d: "M4 12v.01"
  }), e.createElement("path", {
    d: "M4 8v.01"
  }), e.createElement("path", {
    d: "M3 3l18 18"
  }));
}
var AF = ["size", "color", "stroke"];
function DF(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, AF);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-container",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M20 4v.01"
  }), e.createElement("path", {
    d: "M20 20v.01"
  }), e.createElement("path", {
    d: "M20 16v.01"
  }), e.createElement("path", {
    d: "M20 12v.01"
  }), e.createElement("path", {
    d: "M20 8v.01"
  }), e.createElement("rect", {
    x: 8,
    y: 4,
    width: 8,
    height: 16,
    rx: 1
  }), e.createElement("path", {
    d: "M4 4v.01"
  }), e.createElement("path", {
    d: "M4 20v.01"
  }), e.createElement("path", {
    d: "M4 16v.01"
  }), e.createElement("path", {
    d: "M4 12v.01"
  }), e.createElement("path", {
    d: "M4 8v.01"
  }));
}
var FF = ["size", "color", "stroke"];
function GF(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, FF);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-contrast-2-off",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M4 18h2a6 6 0 0 0 6 -6m.878 -3.126a5.996 5.996 0 0 1 5.122 -2.874h2"
  }), e.createElement("path", {
    d: "M8 4h10a2 2 0 0 1 2 2v10m-.586 3.414a1.994 1.994 0 0 1 -1.414 .586h-12a2 2 0 0 1 -2 -2v-12c0 -.547 .22 -1.043 .576 -1.405"
  }), e.createElement("path", {
    d: "M3 3l18 18"
  }));
}
var JF = ["size", "color", "stroke"];
function KF(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, JF);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-contrast-2",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("rect", {
    x: 4,
    y: 4,
    width: 16,
    height: 16,
    rx: 2
  }), e.createElement("path", {
    d: "M4 18h2a6 6 0 0 0 6 -6a6 6 0 0 1 6 -6h2"
  }));
}
var QF = ["size", "color", "stroke"];
function RF(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, QF);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-contrast-off",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M12 12v5a4.984 4.984 0 0 0 3.522 -1.45m1.392 -2.623a5 5 0 0 0 -4.914 -5.927v1"
  }), e.createElement("path", {
    d: "M5.641 5.631a9 9 0 1 0 12.719 12.738m1.68 -2.318a9 9 0 0 0 -12.074 -12.098"
  }), e.createElement("path", {
    d: "M3 3l18 18"
  }));
}
var TF = ["size", "color", "stroke"];
function UF(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, TF);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-contrast",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 9
  }), e.createElement("path", {
    d: "M12 17a5 5 0 0 0 0 -10v10"
  }));
}
var VF = ["size", "color", "stroke"];
function XF(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, VF);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-cooker",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M12 7h.01"
  }), e.createElement("path", {
    d: "M15 7h.01"
  }), e.createElement("path", {
    d: "M9 7h.01"
  }), e.createElement("rect", {
    x: 5,
    y: 3,
    width: 14,
    height: 18,
    rx: 2
  }), e.createElement("path", {
    d: "M9 15h6"
  }), e.createElement("path", {
    d: "M5 11h14"
  }));
}
var YF = ["size", "color", "stroke"];
function ZF(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, YF);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-cookie-man",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M12 2a5 5 0 0 1 2.845 9.112l.147 .369l1.755 -.803c.969 -.443 2.12 -.032 2.571 .918a1.88 1.88 0 0 1 -.787 2.447l-.148 .076l-2.383 1.089v2.02l1.426 1.425l.114 .125a1.96 1.96 0 0 1 -2.762 2.762l-.125 -.114l-2.079 -2.08l-.114 -.124a1.957 1.957 0 0 1 -.161 -.22h-.599c-.047 .075 -.101 .15 -.16 .22l-.115 .125l-2.08 2.079a1.96 1.96 0 0 1 -2.886 -2.648l.114 -.125l1.427 -1.426v-2.019l-2.383 -1.09l-.148 -.075a1.88 1.88 0 0 1 -.787 -2.447c.429 -.902 1.489 -1.318 2.424 -.978l.147 .06l1.755 .803l.147 -.369a4.995 4.995 0 0 1 -2.15 -3.895l-.005 -.217a5 5 0 0 1 5 -5z"
  }), e.createElement("path", {
    d: "M12 16h.01"
  }), e.createElement("path", {
    d: "M12 13h.01"
  }), e.createElement("path", {
    d: "M10 7h.01"
  }), e.createElement("path", {
    d: "M14 7h.01"
  }), e.createElement("path", {
    d: "M12 9h.01"
  }));
}
var $F = ["size", "color", "stroke"];
function _F(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, $F);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-cookie-off",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M8 13v.01"
  }), e.createElement("path", {
    d: "M12 17v.01"
  }), e.createElement("path", {
    d: "M12 12v.01"
  }), e.createElement("path", {
    d: "M18.192 18.187a3 3 0 0 1 -.976 .652c-1.048 .263 -1.787 .483 -2.216 .661c-.475 .197 -1.092 .538 -1.852 1.024a3 3 0 0 1 -2.296 0c-.802 -.503 -1.419 -.844 -1.852 -1.024c-.471 -.195 -1.21 -.415 -2.216 -.66a3 3 0 0 1 -1.623 -1.624c-.265 -1.052 -.485 -1.79 -.661 -2.216c-.198 -.479 -.54 -1.096 -1.024 -1.852a3 3 0 0 1 0 -2.296c.48 -.744 .82 -1.361 1.024 -1.852c.171 -.413 .391 -1.152 .66 -2.216a3 3 0 0 1 .649 -.971m2.821 -1.174c.14 -.049 .263 -.095 .37 -.139c.458 -.19 1.075 -.531 1.852 -1.024a3 3 0 0 1 2.296 0l2.667 1.104a4 4 0 0 0 4.656 6.14l.053 .132a3 3 0 0 1 0 2.296c-.497 .786 -.838 1.404 -1.024 1.852a6.579 6.579 0 0 0 -.135 .36"
  }), e.createElement("path", {
    d: "M3 3l18 18"
  }));
}
var eG = ["size", "color", "stroke"];
function tG(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, eG);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-cookie",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M8 13v.01"
  }), e.createElement("path", {
    d: "M12 17v.01"
  }), e.createElement("path", {
    d: "M12 12v.01"
  }), e.createElement("path", {
    d: "M16 14v.01"
  }), e.createElement("path", {
    d: "M11 8v.01"
  }), e.createElement("path", {
    d: "M13.148 3.476l2.667 1.104a4 4 0 0 0 4.656 6.14l.053 .132a3 3 0 0 1 0 2.296c-.497 .786 -.838 1.404 -1.024 1.852c-.189 .456 -.409 1.194 -.66 2.216a3 3 0 0 1 -1.624 1.623c-1.048 .263 -1.787 .483 -2.216 .661c-.475 .197 -1.092 .538 -1.852 1.024a3 3 0 0 1 -2.296 0c-.802 -.503 -1.419 -.844 -1.852 -1.024c-.471 -.195 -1.21 -.415 -2.216 -.66a3 3 0 0 1 -1.623 -1.624c-.265 -1.052 -.485 -1.79 -.661 -2.216c-.198 -.479 -.54 -1.096 -1.024 -1.852a3 3 0 0 1 0 -2.296c.48 -.744 .82 -1.361 1.024 -1.852c.171 -.413 .391 -1.152 .66 -2.216a3 3 0 0 1 1.624 -1.623c1.032 -.256 1.77 -.476 2.216 -.661c.458 -.19 1.075 -.531 1.852 -1.024a3 3 0 0 1 2.296 0z"
  }));
}
var oG = ["size", "color", "stroke"];
function rG(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, oG);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-copy-off",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M19.414 19.415a1.994 1.994 0 0 1 -1.414 .585h-8a2 2 0 0 1 -2 -2v-8c0 -.554 .225 -1.055 .589 -1.417m3.411 -.583h6a2 2 0 0 1 2 2v6"
  }), e.createElement("path", {
    d: "M16 8v-2a2 2 0 0 0 -2 -2h-6m-3.418 .59c-.36 .36 -.582 .86 -.582 1.41v8a2 2 0 0 0 2 2h2"
  }), e.createElement("path", {
    d: "M3 3l18 18"
  }));
}
var nG = ["size", "color", "stroke"];
function lG(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, nG);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-copy",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("rect", {
    x: 8,
    y: 8,
    width: 12,
    height: 12,
    rx: 2
  }), e.createElement("path", {
    d: "M16 8v-2a2 2 0 0 0 -2 -2h-8a2 2 0 0 0 -2 2v8a2 2 0 0 0 2 2h2"
  }));
}
var aG = ["size", "color", "stroke"];
function iG(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, aG);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-copyleft-off",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M13.303 9.3a3.01 3.01 0 0 1 1.405 1.406m-.586 3.413a3.016 3.016 0 0 1 -4.122 .131"
  }), e.createElement("path", {
    d: "M20.042 16.045a9 9 0 0 0 -12.087 -12.087m-2.318 1.677a9 9 0 1 0 12.725 12.73"
  }), e.createElement("path", {
    d: "M3 3l18 18"
  }));
}
var cG = ["size", "color", "stroke"];
function sG(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, cG);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-copyleft",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 9
  }), e.createElement("path", {
    d: "M10 9.75a3.016 3.016 0 0 1 4.163 .173a2.993 2.993 0 0 1 0 4.154a3.016 3.016 0 0 1 -4.163 .173"
  }));
}
var hG = ["size", "color", "stroke"];
function dG(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, hG);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-copyright-off",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M14 9.75a3.016 3.016 0 0 0 -.711 -.466m-3.41 .596a2.993 2.993 0 0 0 -.042 4.197a3.016 3.016 0 0 0 4.163 .173"
  }), e.createElement("path", {
    d: "M20.042 16.045a9 9 0 0 0 -12.087 -12.087m-2.318 1.677a9 9 0 1 0 12.725 12.73"
  }), e.createElement("path", {
    d: "M3 3l18 18"
  }));
}
var vG = ["size", "color", "stroke"];
function mG(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, vG);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-copyright",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 9
  }), e.createElement("path", {
    d: "M14 9.75a3.016 3.016 0 0 0 -4.163 .173a2.993 2.993 0 0 0 0 4.154a3.016 3.016 0 0 0 4.163 .173"
  }));
}
var kG = ["size", "color", "stroke"];
function wG(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, kG);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-corner-down-left-double",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M19 5v6a3 3 0 0 1 -3 3h-7"
  }), e.createElement("path", {
    d: "M13 10l-4 4l4 4m-5 -8l-4 4l4 4"
  }));
}
var pG = ["size", "color", "stroke"];
function EG(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, pG);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-corner-down-left",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M18 6v6a3 3 0 0 1 -3 3h-10l4 -4m0 8l-4 -4"
  }));
}
var uG = ["size", "color", "stroke"];
function gG(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, uG);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-corner-down-right-double",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M4 5v6a3 3 0 0 0 3 3h7"
  }), e.createElement("path", {
    d: "M10 10l4 4l-4 4m5 -8l4 4l-4 4"
  }));
}
var MG = ["size", "color", "stroke"];
function xG(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, MG);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-corner-down-right",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M6 6v6a3 3 0 0 0 3 3h10l-4 -4m0 8l4 -4"
  }));
}
var fG = ["size", "color", "stroke"];
function zG(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, fG);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-corner-left-down-double",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M18 4h-6a3 3 0 0 0 -3 3v7"
  }), e.createElement("path", {
    d: "M13 10l-4 4l-4 -4m8 5l-4 4l-4 -4"
  }));
}
var bG = ["size", "color", "stroke"];
function LG(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, bG);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-corner-left-down",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M18 6h-6a3 3 0 0 0 -3 3v10l-4 -4m8 0l-4 4"
  }));
}
var yG = ["size", "color", "stroke"];
function CG(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, yG);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-corner-left-up-double",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M18 19h-6a3 3 0 0 1 -3 -3v-7"
  }), e.createElement("path", {
    d: "M13 13l-4 -4l-4 4m8 -5l-4 -4l-4 4"
  }));
}
var jG = ["size", "color", "stroke"];
function BG(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, jG);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-corner-left-up",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M18 18h-6a3 3 0 0 1 -3 -3v-10l-4 4m8 0l-4 -4"
  }));
}
var HG = ["size", "color", "stroke"];
function NG(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, HG);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-corner-right-down-double",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M5 4h6a3 3 0 0 1 3 3v7"
  }), e.createElement("path", {
    d: "M10 10l4 4l4 -4m-8 5l4 4l4 -4"
  }));
}
var WG = ["size", "color", "stroke"];
function qG(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, WG);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-corner-right-down",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M6 6h6a3 3 0 0 1 3 3v10l-4 -4m8 0l-4 4"
  }));
}
var OG = ["size", "color", "stroke"];
function PG(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, OG);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-corner-right-up-double",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M5 19h6a3 3 0 0 0 3 -3v-7"
  }), e.createElement("path", {
    d: "M10 13l4 -4l4 4m-8 -5l4 -4l4 4"
  }));
}
var SG = ["size", "color", "stroke"];
function IG(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, SG);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-corner-right-up",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M6 18h6a3 3 0 0 0 3 -3v-10l-4 4m8 0l-4 -4"
  }));
}
var AG = ["size", "color", "stroke"];
function DG(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, AG);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-corner-up-left-double",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M19 18v-6a3 3 0 0 0 -3 -3h-7"
  }), e.createElement("path", {
    d: "M13 13l-4 -4l4 -4m-5 8l-4 -4l4 -4"
  }));
}
var FG = ["size", "color", "stroke"];
function GG(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, FG);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-corner-up-left",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M18 18v-6a3 3 0 0 0 -3 -3h-10l4 -4m0 8l-4 -4"
  }));
}
var JG = ["size", "color", "stroke"];
function KG(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, JG);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-corner-up-right-double",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M4 18v-6a3 3 0 0 1 3 -3h7"
  }), e.createElement("path", {
    d: "M10 13l4 -4l-4 -4m5 8l4 -4l-4 -4"
  }));
}
var QG = ["size", "color", "stroke"];
function RG(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, QG);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-corner-up-right",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M6 18v-6a3 3 0 0 1 3 -3h10l-4 -4m0 8l4 -4"
  }));
}
var TG = ["size", "color", "stroke"];
function UG(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, TG);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-cpu-2",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("rect", {
    x: 5,
    y: 5,
    width: 14,
    height: 14,
    rx: 1
  }), e.createElement("path", {
    d: "M8 10v-2h2m6 6v2h-2m-4 0h-2v-2m8 -4v-2h-2"
  }), e.createElement("path", {
    d: "M3 10h2"
  }), e.createElement("path", {
    d: "M3 14h2"
  }), e.createElement("path", {
    d: "M10 3v2"
  }), e.createElement("path", {
    d: "M14 3v2"
  }), e.createElement("path", {
    d: "M21 10h-2"
  }), e.createElement("path", {
    d: "M21 14h-2"
  }), e.createElement("path", {
    d: "M14 21v-2"
  }), e.createElement("path", {
    d: "M10 21v-2"
  }));
}
var VG = ["size", "color", "stroke"];
function XG(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, VG);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-cpu-off",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M9 5h9a1 1 0 0 1 1 1v9m-.292 3.706a0.997 .997 0 0 1 -.708 .294h-12a1 1 0 0 1 -1 -1v-12c0 -.272 .108 -.518 .284 -.698"
  }), e.createElement("path", {
    d: "M13 9h2v2m0 4h-6v-6"
  }), e.createElement("path", {
    d: "M3 10h2"
  }), e.createElement("path", {
    d: "M3 14h2"
  }), e.createElement("path", {
    d: "M10 3v2"
  }), e.createElement("path", {
    d: "M14 3v2"
  }), e.createElement("path", {
    d: "M21 10h-2"
  }), e.createElement("path", {
    d: "M21 14h-2"
  }), e.createElement("path", {
    d: "M14 21v-2"
  }), e.createElement("path", {
    d: "M10 21v-2"
  }), e.createElement("path", {
    d: "M3 3l18 18"
  }));
}
var YG = ["size", "color", "stroke"];
function ZG(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, YG);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-cpu",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("rect", {
    x: 5,
    y: 5,
    width: 14,
    height: 14,
    rx: 1
  }), e.createElement("path", {
    d: "M9 9h6v6h-6z"
  }), e.createElement("path", {
    d: "M3 10h2"
  }), e.createElement("path", {
    d: "M3 14h2"
  }), e.createElement("path", {
    d: "M10 3v2"
  }), e.createElement("path", {
    d: "M14 3v2"
  }), e.createElement("path", {
    d: "M21 10h-2"
  }), e.createElement("path", {
    d: "M21 14h-2"
  }), e.createElement("path", {
    d: "M14 21v-2"
  }), e.createElement("path", {
    d: "M10 21v-2"
  }));
}
var $G = ["size", "color", "stroke"];
function _G(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, $G);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-crane-off",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M6 21h6"
  }), e.createElement("path", {
    d: "M9 21v-12"
  }), e.createElement("path", {
    d: "M9 5v-2l-1.001 1.001"
  }), e.createElement("path", {
    d: "M6.005 5.995l-3.005 3.005h6"
  }), e.createElement("path", {
    d: "M13 9h8"
  }), e.createElement("path", {
    d: "M9 3l10 6"
  }), e.createElement("path", {
    d: "M17 9v4a2 2 0 0 1 2 2m-2 2a2 2 0 0 1 -2 -2"
  }), e.createElement("path", {
    d: "M3 3l18 18"
  }));
}
var eJ = ["size", "color", "stroke"];
function tJ(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, eJ);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-crane",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M6 21h6"
  }), e.createElement("path", {
    d: "M9 21v-18l-6 6h18"
  }), e.createElement("path", {
    d: "M9 3l10 6"
  }), e.createElement("path", {
    d: "M17 9v4a2 2 0 1 1 -2 2"
  }));
}
var oJ = ["size", "color", "stroke"];
function rJ(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, oJ);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-creative-commons-by",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 9
  }), e.createElement("circle", {
    cx: 12,
    cy: 7,
    r: 1
  }), e.createElement("path", {
    d: "M9 13v-1a1 1 0 0 1 1 -1h4a1 1 0 0 1 1 1v1a1 1 0 0 1 -1 1h-.5l-.5 4h-2l-.5 -4h-.5a1 1 0 0 1 -1 -1z"
  }));
}
var nJ = ["size", "color", "stroke"];
function lJ(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, nJ);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-creative-commons-nc",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 9
  }), e.createElement("path", {
    d: "M15 9h-4.5a1.5 1.5 0 0 0 0 3h3a1.5 1.5 0 0 1 0 3h-4.5"
  }), e.createElement("path", {
    d: "M12 7v2"
  }), e.createElement("path", {
    d: "M12 15v2"
  }), e.createElement("path", {
    d: "M6 6l3 3"
  }), e.createElement("path", {
    d: "M15 15l3 3"
  }));
}
var aJ = ["size", "color", "stroke"];
function iJ(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, aJ);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-creative-commons-nd",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 9
  }), e.createElement("path", {
    d: "M9 10h6"
  }), e.createElement("path", {
    d: "M9 14h6"
  }));
}
var cJ = ["size", "color", "stroke"];
function sJ(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, cJ);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-creative-commons-off",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M5.638 5.634a9 9 0 1 0 12.723 12.733m1.686 -2.332a9 9 0 0 0 -12.093 -12.077"
  }), e.createElement("path", {
    d: "M10.5 10.5a2.187 2.187 0 0 0 -2.914 .116a1.928 1.928 0 0 0 0 2.768a2.188 2.188 0 0 0 2.914 .116"
  }), e.createElement("path", {
    d: "M16.5 10.5a2.194 2.194 0 0 0 -2.309 -.302"
  }), e.createElement("path", {
    d: "M3 3l18 18"
  }));
}
var hJ = ["size", "color", "stroke"];
function dJ(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, hJ);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-creative-commons-sa",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 9
  }), e.createElement("path", {
    d: "M12 16a4 4 0 1 0 -4 -4v1"
  }), e.createElement("path", {
    d: "M6 12l2 2l2 -2"
  }));
}
var vJ = ["size", "color", "stroke"];
function mJ(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, vJ);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-creative-commons-zero",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 9
  }), e.createElement("ellipse", {
    cx: 12,
    cy: 12,
    rx: 3,
    ry: 4
  }), e.createElement("path", {
    d: "M14 9l-4 6"
  }));
}
var kJ = ["size", "color", "stroke"];
function wJ(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, kJ);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-creative-commons",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 9
  }), e.createElement("path", {
    d: "M10.5 10.5c-.847 -.71 -2.132 -.658 -2.914 .116a1.928 1.928 0 0 0 0 2.768c.782 .774 2.067 .825 2.914 .116"
  }), e.createElement("path", {
    d: "M16.5 10.5c-.847 -.71 -2.132 -.658 -2.914 .116a1.928 1.928 0 0 0 0 2.768c.782 .774 2.067 .825 2.914 .116"
  }));
}
var pJ = ["size", "color", "stroke"];
function EJ(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, pJ);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-credit-card-off",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("line", {
    x1: 3,
    y1: 3,
    x2: 21,
    y2: 21
  }), e.createElement("path", {
    d: "M9 5h9a3 3 0 0 1 3 3v8a3 3 0 0 1 -.128 .87"
  }), e.createElement("path", {
    d: "M18.87 18.872a3 3 0 0 1 -.87 .128h-12a3 3 0 0 1 -3 -3v-8c0 -1.352 .894 -2.495 2.124 -2.87"
  }), e.createElement("line", {
    x1: 3,
    y1: 11,
    x2: 11,
    y2: 11
  }), e.createElement("line", {
    x1: 15,
    y1: 11,
    x2: 21,
    y2: 11
  }), e.createElement("line", {
    x1: 7,
    y1: 15,
    x2: 7.01,
    y2: 15
  }), e.createElement("line", {
    x1: 11,
    y1: 15,
    x2: 13,
    y2: 15
  }));
}
var uJ = ["size", "color", "stroke"];
function gJ(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, uJ);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-credit-card",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("rect", {
    x: 3,
    y: 5,
    width: 18,
    height: 14,
    rx: 3
  }), e.createElement("line", {
    x1: 3,
    y1: 10,
    x2: 21,
    y2: 10
  }), e.createElement("line", {
    x1: 7,
    y1: 15,
    x2: 7.01,
    y2: 15
  }), e.createElement("line", {
    x1: 11,
    y1: 15,
    x2: 13,
    y2: 15
  }));
}
var MJ = ["size", "color", "stroke"];
function xJ(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, MJ);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-cricket",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M11.105 18.79l-1.006 .992a4.159 4.159 0 0 1 -6.038 -5.715l.157 -.166l8.282 -8.401l1.5 1.5l3.45 -3.391a2.08 2.08 0 0 1 3.057 2.815l-.116 .126l-3.391 3.45l1.5 1.5l-3.668 3.617"
  }), e.createElement("path", {
    d: "M10.5 7.5l6 6"
  }), e.createElement("circle", {
    cx: 14,
    cy: 18,
    r: 3
  }));
}
var fJ = ["size", "color", "stroke"];
function zJ(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, fJ);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-crop",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M8 5v10a1 1 0 0 0 1 1h10"
  }), e.createElement("path", {
    d: "M5 8h10a1 1 0 0 1 1 1v10"
  }));
}
var bJ = ["size", "color", "stroke"];
function LJ(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, bJ);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-cross-off",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M16 12h3v-4h-5v-5h-4v3m-2 2h-3v4h5v9h4v-7"
  }), e.createElement("path", {
    d: "M3 3l18 18"
  }));
}
var yJ = ["size", "color", "stroke"];
function CJ(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, yJ);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-cross",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M10 21h4v-9h5v-4h-5v-5h-4v5h-5v4h5z"
  }));
}
var jJ = ["size", "color", "stroke"];
function BJ(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, jJ);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-crosshair",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M4 8v-2a2 2 0 0 1 2 -2h2"
  }), e.createElement("path", {
    d: "M4 16v2a2 2 0 0 0 2 2h2"
  }), e.createElement("path", {
    d: "M16 4h2a2 2 0 0 1 2 2v2"
  }), e.createElement("path", {
    d: "M16 20h2a2 2 0 0 0 2 -2v-2"
  }), e.createElement("line", {
    x1: 9,
    y1: 12,
    x2: 15,
    y2: 12
  }), e.createElement("line", {
    x1: 12,
    y1: 9,
    x2: 12,
    y2: 15
  }));
}
var HJ = ["size", "color", "stroke"];
function NJ(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, HJ);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-crown-off",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M18 18h-13l-1.865 -9.327a0.25 .25 0 0 1 .4 -.244l4.465 3.571l1.6 -2.4m1.596 -2.394l.804 -1.206l4 6l4.464 -3.571a0.25 .25 0 0 1 .401 .244l-1.363 6.818"
  }), e.createElement("line", {
    x1: 3,
    y1: 3,
    x2: 21,
    y2: 21
  }));
}
var WJ = ["size", "color", "stroke"];
function qJ(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, WJ);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-crown",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M12 6l4 6l5 -4l-2 10h-14l-2 -10l5 4z"
  }));
}
var OJ = ["size", "color", "stroke"];
function PJ(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, OJ);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-crutches-off",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M8.178 4.174a2 2 0 0 1 1.822 -1.174h4a2 2 0 1 1 0 4h-3"
  }), e.createElement("path", {
    d: "M11 21h2"
  }), e.createElement("path", {
    d: "M12 21v-4.092a3 3 0 0 1 .504 -1.664l.992 -1.488a3 3 0 0 0 .097 -.155m.407 -3.601v-3"
  }), e.createElement("path", {
    d: "M12 21v-4.092a3 3 0 0 0 -.504 -1.664l-.992 -1.488a3 3 0 0 1 -.504 -1.664v-2.092"
  }), e.createElement("path", {
    d: "M10 11h1"
  }), e.createElement("path", {
    d: "M3 3l18 18"
  }));
}
var SJ = ["size", "color", "stroke"];
function IJ(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, SJ);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-crutches",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("rect", {
    x: 8,
    y: 3,
    width: 8,
    height: 4,
    rx: 2
  }), e.createElement("path", {
    d: "M11 21h2"
  }), e.createElement("path", {
    d: "M12 21v-4.092a3 3 0 0 1 .504 -1.664l.992 -1.488a3 3 0 0 0 .504 -1.664v-5.092"
  }), e.createElement("path", {
    d: "M12 21v-4.092a3 3 0 0 0 -.504 -1.664l-.992 -1.488a3 3 0 0 1 -.504 -1.664v-5.092"
  }), e.createElement("path", {
    d: "M10 11h4"
  }));
}
var AJ = ["size", "color", "stroke"];
function DJ(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, AJ);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-crystal-ball",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M6.73 17.018a8 8 0 1 1 10.54 0"
  }), e.createElement("path", {
    d: "M5 19a2 2 0 0 0 2 2h10a2 2 0 1 0 0 -4h-10a2 2 0 0 0 -2 2z"
  }), e.createElement("path", {
    d: "M11 7a3 3 0 0 0 -3 3"
  }));
}
var FJ = ["size", "color", "stroke"];
function GJ(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, FJ);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-cube-send",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M16 12.5l-5 -3l5 -3l5 3v5.5l-5 3z"
  }), e.createElement("path", {
    d: "M11 9.5v5.5l5 3"
  }), e.createElement("path", {
    d: "M16 12.545l5 -3.03"
  }), e.createElement("path", {
    d: "M7 9h-5"
  }), e.createElement("path", {
    d: "M7 12h-3"
  }), e.createElement("path", {
    d: "M7 15h-1"
  }));
}
var JJ = ["size", "color", "stroke"];
function KJ(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, JJ);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-cube-unfolded",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M2 15h10v5h5v-5h5v-5h-10v-5h-5v5h-5z"
  }), e.createElement("path", {
    d: "M7 15v-5h5v5h5v-5"
  }));
}
var QJ = ["size", "color", "stroke"];
function RJ(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, QJ);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-cup-off",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M8 8h-3v3h6m4 0h4v-3h-7"
  }), e.createElement("path", {
    d: "M17.5 11l-.323 2.154m-.525 3.497l-.652 4.349h-8l-1.5 -10"
  }), e.createElement("path", {
    d: "M6 8v-1c0 -.296 .064 -.577 .18 -.83m2.82 -1.17h7a2 2 0 0 1 2 2v1"
  }), e.createElement("path", {
    d: "M15 5v-2"
  }), e.createElement("path", {
    d: "M3 3l18 18"
  }));
}
var TJ = ["size", "color", "stroke"];
function UJ(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, TJ);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-cup",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M5 11h14v-3h-14z"
  }), e.createElement("path", {
    d: "M17.5 11l-1.5 10h-8l-1.5 -10"
  }), e.createElement("path", {
    d: "M6 8v-1a2 2 0 0 1 2 -2h8a2 2 0 0 1 2 2v1"
  }), e.createElement("path", {
    d: "M15 5v-2"
  }));
}
var VJ = ["size", "color", "stroke"];
function XJ(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, VJ);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-curling",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("rect", {
    x: 4,
    y: 9,
    width: 16,
    height: 10,
    rx: 4
  }), e.createElement("path", {
    d: "M4 14h16"
  }), e.createElement("path", {
    d: "M8 5h6a2 2 0 0 1 2 2v2"
  }));
}
var YJ = ["size", "color", "stroke"];
function ZJ(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, YJ);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-curly-loop",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M21 8c-4 0 -7 2 -7 5a3 3 0 0 0 6 0c0 -3 -2.5 -5 -8 -5s-8 2 -8 5a3 3 0 0 0 6 0c0 -3 -3 -5 -7 -5"
  }));
}
var $J = ["size", "color", "stroke"];
function _J(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, $J);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-currency-afghani",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M15 13h-3.5a3.5 3.5 0 1 1 3.5 -3.5v6.5h-7"
  }), e.createElement("path", {
    d: "M12 3v.01"
  }), e.createElement("path", {
    d: "M12 19v2"
  }));
}
var eK = ["size", "color", "stroke"];
function tK(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, eK);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-currency-bahraini",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M3 10v1a4 4 0 0 0 4 4h2a2 2 0 0 0 2 -2v-3"
  }), e.createElement("path", {
    d: "M7 19.01v-.01"
  }), e.createElement("path", {
    d: "M14 15.01v-.01"
  }), e.createElement("path", {
    d: "M17 15h2.004a2 2 0 0 0 1.649 -3.131l-2.653 -3.869"
  }));
}
var oK = ["size", "color", "stroke"];
function rK(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, oK);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-currency-baht",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M8 6h5a3 3 0 0 1 3 3v.143a2.857 2.857 0 0 1 -2.857 2.857h-5.143"
  }), e.createElement("path", {
    d: "M8 12h5a3 3 0 0 1 3 3v.143a2.857 2.857 0 0 1 -2.857 2.857h-5.143"
  }), e.createElement("path", {
    d: "M8 6v12"
  }), e.createElement("path", {
    d: "M11 4v2"
  }), e.createElement("path", {
    d: "M11 18v2"
  }));
}
var nK = ["size", "color", "stroke"];
function lK(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, nK);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-currency-bitcoin",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M6 6h8a3 3 0 0 1 0 6a3 3 0 0 1 0 6h-8"
  }), e.createElement("line", {
    x1: 8,
    y1: 6,
    x2: 8,
    y2: 18
  }), e.createElement("line", {
    x1: 8,
    y1: 12,
    x2: 14,
    y2: 12
  }), e.createElement("line", {
    x1: 9,
    y1: 3,
    x2: 9,
    y2: 6
  }), e.createElement("line", {
    x1: 13,
    y1: 3,
    x2: 13,
    y2: 6
  }), e.createElement("line", {
    x1: 9,
    y1: 18,
    x2: 9,
    y2: 21
  }), e.createElement("line", {
    x1: 13,
    y1: 18,
    x2: 13,
    y2: 21
  }));
}
var aK = ["size", "color", "stroke"];
function iK(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, aK);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-currency-cent",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M16.007 7.54a5.965 5.965 0 0 0 -4.008 -1.54a5.996 5.996 0 0 0 -5.992 6c0 3.314 2.682 6 5.992 6a5.965 5.965 0 0 0 4.004 -1.536"
  }), e.createElement("path", {
    d: "M12 20v-2"
  }), e.createElement("path", {
    d: "M12 6v-2"
  }));
}
var cK = ["size", "color", "stroke"];
function sK(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, cK);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-currency-dinar",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M14 20.01v-.01"
  }), e.createElement("path", {
    d: "M6 13l2.386 -.9a1 1 0 0 0 -.095 -1.902l-1.514 -.404a1 1 0 0 1 -.102 -1.9l2.325 -.894"
  }), e.createElement("path", {
    d: "M3 14v1a3 3 0 0 0 3 3h4.161a3 3 0 0 0 2.983 -3.32l-1.144 -10.68"
  }), e.createElement("path", {
    d: "M16 17l1 1h2.004a2 2 0 0 0 1.649 -3.131l-2.653 -3.869"
  }));
}
var hK = ["size", "color", "stroke"];
function dK(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, hK);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-currency-dirham",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M8.5 19h-3.5"
  }), e.createElement("path", {
    d: "M8.599 16.479a1.5 1.5 0 1 0 -1.099 2.521"
  }), e.createElement("path", {
    d: "M7 4v9"
  }), e.createElement("path", {
    d: "M15 13h1.888a1.5 1.5 0 0 0 1.296 -2.256l-2.184 -3.744"
  }), e.createElement("path", {
    d: "M11 13.01v-.01"
  }));
}
var vK = ["size", "color", "stroke"];
function mK(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, vK);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-currency-dogecoin",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M6 12h6"
  }), e.createElement("path", {
    d: "M9 6v12"
  }), e.createElement("path", {
    d: "M6 18h6a6 6 0 1 0 0 -12h-6"
  }));
}
var kK = ["size", "color", "stroke"];
function wK(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, kK);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-currency-dollar-australian",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M3 18l3.279 -11.476a0.75 .75 0 0 1 1.442 0l3.279 11.476"
  }), e.createElement("path", {
    d: "M21 6h-4a3 3 0 0 0 0 6h1a3 3 0 0 1 0 6h-4"
  }), e.createElement("path", {
    d: "M17 20v-2"
  }), e.createElement("path", {
    d: "M18 6v-2"
  }), e.createElement("path", {
    d: "M4.5 14h5"
  }));
}
var pK = ["size", "color", "stroke"];
function EK(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, pK);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-currency-dollar-brunei",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M21 6h-4a3 3 0 0 0 0 6h1a3 3 0 0 1 0 6h-4"
  }), e.createElement("path", {
    d: "M17 20v-2"
  }), e.createElement("path", {
    d: "M18 6v-2"
  }), e.createElement("path", {
    d: "M3 6v12h4a3 3 0 0 0 0 -6h-4h4a3 3 0 0 0 0 -6h-4z"
  }));
}
var uK = ["size", "color", "stroke"];
function gK(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, uK);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-currency-dollar-canadian",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M21 6h-4a3 3 0 0 0 0 6h1a3 3 0 0 1 0 6h-4"
  }), e.createElement("path", {
    d: "M10 18h-1a6 6 0 1 1 0 -12h1"
  }), e.createElement("path", {
    d: "M17 20v-2"
  }), e.createElement("path", {
    d: "M18 6v-2"
  }));
}
var MK = ["size", "color", "stroke"];
function xK(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, MK);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-currency-dollar-guyanese",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M21 6h-4a3 3 0 0 0 0 6h1a3 3 0 0 1 0 6h-4"
  }), e.createElement("path", {
    d: "M10 6h-3a4 4 0 0 0 -4 4v4a4 4 0 0 0 4 4h3v-6h-2"
  }), e.createElement("path", {
    d: "M17 20v-2"
  }), e.createElement("path", {
    d: "M18 6v-2"
  }));
}
var fK = ["size", "color", "stroke"];
function zK(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, fK);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-currency-dollar-off",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M16.7 8a3 3 0 0 0 -2.7 -2h-4m-2.557 1.431a3 3 0 0 0 2.557 4.569h2m4.564 4.558a2.998 2.998 0 0 1 -2.564 1.442h-4a3 3 0 0 1 -2.7 -2"
  }), e.createElement("path", {
    d: "M12 3v3m0 12v3"
  }), e.createElement("path", {
    d: "M3 3l18 18"
  }));
}
var bK = ["size", "color", "stroke"];
function LK(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, bK);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-currency-dollar-singapore",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M21 6h-4a3 3 0 0 0 0 6h1a3 3 0 0 1 0 6h-4"
  }), e.createElement("path", {
    d: "M10 6h-4a3 3 0 1 0 0 6h1a3 3 0 0 1 0 6h-4"
  }), e.createElement("path", {
    d: "M17 20v-2"
  }), e.createElement("path", {
    d: "M18 6v-2"
  }));
}
var yK = ["size", "color", "stroke"];
function CK(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, yK);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-currency-dollar-zimbabwean",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M21 6h-4a3 3 0 0 0 0 6h1a3 3 0 0 1 0 6h-4"
  }), e.createElement("path", {
    d: "M17 20v-2"
  }), e.createElement("path", {
    d: "M18 6v-2"
  }), e.createElement("path", {
    d: "M3 6h7l-7 12h7"
  }));
}
var jK = ["size", "color", "stroke"];
function BK(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, jK);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-currency-dollar",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M16.7 8a3 3 0 0 0 -2.7 -2h-4a3 3 0 0 0 0 6h4a3 3 0 0 1 0 6h-4a3 3 0 0 1 -2.7 -2"
  }), e.createElement("path", {
    d: "M12 3v3m0 12v3"
  }));
}
var HK = ["size", "color", "stroke"];
function NK(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, HK);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-currency-dong",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M6 19h12"
  }), e.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 4
  }), e.createElement("path", {
    d: "M16 16v-12"
  }), e.createElement("path", {
    d: "M17 5h-4"
  }));
}
var WK = ["size", "color", "stroke"];
function qK(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, WK);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-currency-dram",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M4 10a6 6 0 1 1 12 0v10"
  }), e.createElement("path", {
    d: "M12 16h8"
  }), e.createElement("path", {
    d: "M12 12h8"
  }));
}
var OK = ["size", "color", "stroke"];
function PK(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, OK);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-currency-ethereum",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M6 12l6 -9l6 9l-6 9z"
  }), e.createElement("path", {
    d: "M6 12l6 -3l6 3l-6 2z"
  }));
}
var SK = ["size", "color", "stroke"];
function IK(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, SK);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-currency-euro-off",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M17.2 7c-1.977 -2.26 -4.954 -2.602 -7.234 -1.04m-1.913 2.079c-1.604 2.72 -1.374 6.469 .69 8.894c2.292 2.691 5.995 2.758 8.356 .18"
  }), e.createElement("path", {
    d: "M10 10h-5m0 4h8"
  }), e.createElement("path", {
    d: "M3 3l18 18"
  }));
}
var AK = ["size", "color", "stroke"];
function DK(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, AK);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-currency-euro",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M17.2 7a6 7 0 1 0 0 10"
  }), e.createElement("path", {
    d: "M13 10h-8m0 4h8"
  }));
}
var FK = ["size", "color", "stroke"];
function GK(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, FK);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-currency-forint",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M11 4h-4a3 3 0 0 0 -3 3v12"
  }), e.createElement("path", {
    d: "M10 11h-6"
  }), e.createElement("path", {
    d: "M16 4v13a2 2 0 0 0 2 2h2"
  }), e.createElement("path", {
    d: "M19 9h-5"
  }));
}
var JK = ["size", "color", "stroke"];
function KK(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, JK);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-currency-frank",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M17 5h-6a2 2 0 0 0 -2 2v12"
  }), e.createElement("path", {
    d: "M7 15h4"
  }), e.createElement("path", {
    d: "M9 11h7"
  }));
}
var QK = ["size", "color", "stroke"];
function RK(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, QK);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-currency-guarani",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M16.007 7.54a5.965 5.965 0 0 0 -4.008 -1.54a5.996 5.996 0 0 0 -5.992 6c0 3.314 2.682 6 5.992 6a5.965 5.965 0 0 0 4.004 -1.536c.732 -.66 1.064 -2.148 .997 -4.464h-5"
  }), e.createElement("path", {
    d: "M12 20v-16"
  }));
}
var TK = ["size", "color", "stroke"];
function UK(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, TK);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-currency-hryvnia",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M8 7a2.64 2.64 0 0 1 2.562 -2h3.376a2.64 2.64 0 0 1 2.562 2a2.57 2.57 0 0 1 -1.344 2.922l-5.876 2.938a3.338 3.338 0 0 0 -1.78 3.64a3.11 3.11 0 0 0 3.05 2.5h2.888a2.64 2.64 0 0 0 2.562 -2"
  }), e.createElement("path", {
    d: "M6 10h12"
  }), e.createElement("path", {
    d: "M6 14h12"
  }));
}
var VK = ["size", "color", "stroke"];
function XK(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, VK);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-currency-kip",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M6 12h12"
  }), e.createElement("path", {
    d: "M9 5v14"
  }), e.createElement("path", {
    d: "M16 19a7 7 0 0 0 -7 -7a7 7 0 0 0 7 -7"
  }));
}
var YK = ["size", "color", "stroke"];
function ZK(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, YK);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-currency-krone-czech",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M5 6v12"
  }), e.createElement("path", {
    d: "M5 12c3.5 0 6 -3 6 -6"
  }), e.createElement("path", {
    d: "M5 12c3.5 0 6 3 6 6"
  }), e.createElement("path", {
    d: "M19 6l-2 2l-2 -2"
  }), e.createElement("path", {
    d: "M19 12h-2a3 3 0 0 0 0 6h2"
  }));
}
var $K = ["size", "color", "stroke"];
function _K(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, $K);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-currency-krone-danish",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M5 6v12"
  }), e.createElement("path", {
    d: "M5 12c3.5 0 6 -3 6 -6"
  }), e.createElement("path", {
    d: "M5 12c3.5 0 6 3 6 6"
  }), e.createElement("path", {
    d: "M15 10v8"
  }), e.createElement("path", {
    d: "M19 10a4 4 0 0 0 -4 4"
  }), e.createElement("path", {
    d: "M20 18.01v-.01"
  }));
}
var eQ = ["size", "color", "stroke"];
function tQ(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, eQ);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-currency-krone-swedish",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M5 6v12"
  }), e.createElement("path", {
    d: "M5 12c3.5 0 6 -3 6 -6"
  }), e.createElement("path", {
    d: "M5 12c3.5 0 6 3 6 6"
  }), e.createElement("path", {
    d: "M15 10v8"
  }), e.createElement("path", {
    d: "M19 10a4 4 0 0 0 -4 4"
  }));
}
var oQ = ["size", "color", "stroke"];
function rQ(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, oQ);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-currency-lari",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M18 13a6 6 0 1 0 -6 6"
  }), e.createElement("path", {
    d: "M6 19h12"
  }), e.createElement("path", {
    d: "M10 5v7"
  }), e.createElement("path", {
    d: "M14 12v-7"
  }));
}
var nQ = ["size", "color", "stroke"];
function lQ(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, nQ);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-currency-leu",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M17 18h-7a3 3 0 0 1 -3 -3v-10"
  }));
}
var aQ = ["size", "color", "stroke"];
function iQ(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, aQ);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-currency-lira",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M10 5v15a7 7 0 0 0 7 -7"
  }), e.createElement("path", {
    d: "M6 15l8 -4"
  }), e.createElement("path", {
    d: "M14 7l-8 4"
  }));
}
var cQ = ["size", "color", "stroke"];
function sQ(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, cQ);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-currency-litecoin",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M18 19h-8.194a2 2 0 0 1 -1.98 -2.283l1.674 -11.717"
  }), e.createElement("path", {
    d: "M14 9l-9 4"
  }));
}
var hQ = ["size", "color", "stroke"];
function dQ(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, hQ);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-currency-lyd",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M11 15h.01"
  }), e.createElement("path", {
    d: "M21 5v10a2 2 0 0 1 -2 2h-2.764a2 2 0 0 1 -1.789 -1.106l-.447 -.894"
  }), e.createElement("path", {
    d: "M5 8l2.773 4.687c.427 .697 .234 1.626 -.43 2.075a1.38 1.38 0 0 1 -.773 .238h-2.224a0.93 .93 0 0 1 -.673 -.293l-.673 -.707"
  }));
}
var vQ = ["size", "color", "stroke"];
function mQ(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, vQ);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-currency-manat",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M7 19v-7a5 5 0 1 1 10 0v7"
  }), e.createElement("path", {
    d: "M12 5v14"
  }));
}
var kQ = ["size", "color", "stroke"];
function wQ(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, kQ);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-currency-monero",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M3 18h3v-11l6 7l6 -7v11h3"
  }));
}
var pQ = ["size", "color", "stroke"];
function EQ(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, pQ);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-currency-naira",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M7 18v-10.948a1.05 1.05 0 0 1 1.968 -.51l6.064 10.916a1.05 1.05 0 0 0 1.968 -.51v-10.948"
  }), e.createElement("path", {
    d: "M5 10h14"
  }), e.createElement("path", {
    d: "M5 14h14"
  }));
}
var uQ = ["size", "color", "stroke"];
function gQ(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, uQ);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-currency-off",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M18.531 14.524a7 7 0 0 0 -9.06 -9.053m-2.422 1.582a7 7 0 0 0 9.903 9.896"
  }), e.createElement("path", {
    d: "M4 4l3 3"
  }), e.createElement("path", {
    d: "M20 4l-3 3"
  }), e.createElement("path", {
    d: "M4 20l3 -3"
  }), e.createElement("path", {
    d: "M20 20l-3 -3"
  }), e.createElement("path", {
    d: "M3 3l18 18"
  }));
}
var MQ = ["size", "color", "stroke"];
function xQ(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, MQ);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-currency-paanga",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M21 6h-4a3 3 0 0 0 0 6h1a3 3 0 0 1 0 6h-4"
  }), e.createElement("path", {
    d: "M17 20v-2"
  }), e.createElement("path", {
    d: "M18 6v-2"
  }), e.createElement("path", {
    d: "M3 6h8"
  }), e.createElement("path", {
    d: "M7 6v12"
  }));
}
var fQ = ["size", "color", "stroke"];
function zQ(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, fQ);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-currency-peso",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M8 19v-14h3.5a4.5 4.5 0 1 1 0 9h-3.5"
  }), e.createElement("path", {
    d: "M18 8h-12"
  }), e.createElement("path", {
    d: "M18 11h-12"
  }));
}
var bQ = ["size", "color", "stroke"];
function LQ(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, bQ);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-currency-pound-off",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M17 18.5a6 6 0 0 1 -5 0a6 6 0 0 0 -5 .5a3 3 0 0 0 2 -2.5v-7.5m1.192 -2.825a4 4 0 0 1 6.258 .825m-3.45 6h-6"
  }), e.createElement("path", {
    d: "M3 3l18 18"
  }));
}
var yQ = ["size", "color", "stroke"];
function CQ(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, yQ);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-currency-pound",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M17 18.5a6 6 0 0 1 -5 0a6 6 0 0 0 -5 .5a3 3 0 0 0 2 -2.5v-7.5a4 4 0 0 1 7.45 -2m-2.55 6h-7"
  }));
}
var jQ = ["size", "color", "stroke"];
function BQ(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, jQ);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-currency-quetzal",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 6
  }), e.createElement("path", {
    d: "M13 13l5 5"
  }));
}
var HQ = ["size", "color", "stroke"];
function NQ(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, HQ);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-currency-real",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M21 6h-4a3 3 0 0 0 0 6h1a3 3 0 0 1 0 6h-4"
  }), e.createElement("path", {
    d: "M4 18v-12h3a3 3 0 1 1 0 6h-3c5.5 0 5 4 6 6"
  }), e.createElement("path", {
    d: "M18 6v-2"
  }), e.createElement("path", {
    d: "M17 20v-2"
  }));
}
var WQ = ["size", "color", "stroke"];
function qQ(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, WQ);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-currency-renminbi",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M15 9v8a2 2 0 1 0 4 0"
  }), e.createElement("path", {
    d: "M19 9h-14"
  }), e.createElement("path", {
    d: "M19 5h-14"
  }), e.createElement("path", {
    d: "M9 9v4c0 2.5 -.667 4 -2 6"
  }));
}
var OQ = ["size", "color", "stroke"];
function PQ(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, OQ);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-currency-ripple",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("circle", {
    cx: 7,
    cy: 12,
    r: 3
  }), e.createElement("circle", {
    cx: 17,
    cy: 7,
    r: 3
  }), e.createElement("circle", {
    cx: 17,
    cy: 17,
    r: 3
  }), e.createElement("path", {
    d: "M10 12h3l2 -2.5"
  }), e.createElement("path", {
    d: "M15 14.5l-2 -2.5"
  }));
}
var SQ = ["size", "color", "stroke"];
function IQ(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, SQ);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-currency-riyal",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M15 9v2a2 2 0 1 1 -4 0v-1v1a2 2 0 1 1 -4 0v-1v4a2 2 0 1 1 -4 0v-2"
  }), e.createElement("path", {
    d: "M18 12.01v-.01"
  }), e.createElement("path", {
    d: "M22 10v1a5 5 0 0 1 -5 5"
  }));
}
var AQ = ["size", "color", "stroke"];
function DQ(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, AQ);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-currency-rubel",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M8 19v-14h6a3 3 0 0 1 0 6h-8"
  }), e.createElement("path", {
    d: "M14 15h-8"
  }));
}
var FQ = ["size", "color", "stroke"];
function GQ(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, FQ);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-currency-rufiyaa",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M20 16h.01"
  }), e.createElement("path", {
    d: "M4 16c9.5 -4 11.5 -8 14 -9"
  }), e.createElement("path", {
    d: "M12 8l5 3"
  }));
}
var JQ = ["size", "color", "stroke"];
function KQ(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, JQ);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-currency-rupee-nepalese",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M15 5h-11h3a4 4 0 1 1 0 8h-3l6 6"
  }), e.createElement("path", {
    d: "M21 17l-4.586 -4.414a2 2 0 0 0 -2.828 2.828l.707 .707"
  }));
}
var QQ = ["size", "color", "stroke"];
function RQ(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, QQ);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-currency-rupee",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M18 5h-11h3a4 4 0 0 1 0 8h-3l6 6"
  }), e.createElement("line", {
    x1: 7,
    y1: 9,
    x2: 18,
    y2: 9
  }));
}
var TQ = ["size", "color", "stroke"];
function UQ(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, TQ);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-currency-shekel",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M6 18v-12h4a4 4 0 0 1 4 4v4"
  }), e.createElement("path", {
    d: "M18 6v12h-4a4 4 0 0 1 -4 -4v-4"
  }));
}
var VQ = ["size", "color", "stroke"];
function XQ(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, VQ);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-currency-solana",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M4 18h12l4 -4h-12z"
  }), e.createElement("path", {
    d: "M8 14l-4 -4h12l4 4"
  }), e.createElement("path", {
    d: "M16 10l4 -4h-12l-4 4"
  }));
}
var YQ = ["size", "color", "stroke"];
function ZQ(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, YQ);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-currency-som",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M10 18v-12h-5v10a2 2 0 0 1 -2 2"
  }), e.createElement("path", {
    d: "M14 6v12h4a3 3 0 0 0 0 -6h-4h4a3 3 0 0 0 0 -6h-4z"
  }));
}
var $Q = ["size", "color", "stroke"];
function _Q(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, $Q);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-currency-taka",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("circle", {
    cx: 16.5,
    cy: 15.5,
    r: 1
  }), e.createElement("path", {
    d: "M7 7a2 2 0 1 1 4 0v9a3 3 0 0 0 6 0v-.5"
  }), e.createElement("path", {
    d: "M8 11h6"
  }));
}
var eR = ["size", "color", "stroke"];
function tR(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, eR);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-currency-tenge",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M6 5h12"
  }), e.createElement("path", {
    d: "M6 9h12"
  }), e.createElement("path", {
    d: "M12 9v10"
  }));
}
var oR = ["size", "color", "stroke"];
function rR(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, oR);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-currency-tugrik",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M7 6h10"
  }), e.createElement("path", {
    d: "M12 6v13"
  }), e.createElement("path", {
    d: "M8 17l8 -3"
  }), e.createElement("path", {
    d: "M16 10l-8 3"
  }));
}
var nR = ["size", "color", "stroke"];
function lR(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, nR);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-currency-won",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M4 6l3.245 11.358a0.85 .85 0 0 0 1.624 .035l3.131 -9.393l3.131 9.393a0.85 .85 0 0 0 1.624 -.035l3.245 -11.358"
  }), e.createElement("path", {
    d: "M21 10h-18"
  }), e.createElement("path", {
    d: "M21 14h-18"
  }));
}
var aR = ["size", "color", "stroke"];
function iR(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, aR);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-currency-yen-off",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M12 19v-7m5 -7l-3.328 4.66"
  }), e.createElement("path", {
    d: "M8 17h8"
  }), e.createElement("path", {
    d: "M8 13h5"
  }), e.createElement("path", {
    d: "M3 3l18 18"
  }));
}
var cR = ["size", "color", "stroke"];
function sR(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, cR);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-currency-yen",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M12 19v-7l-5 -7m10 0l-5 7"
  }), e.createElement("line", {
    x1: 8,
    y1: 17,
    x2: 16,
    y2: 17
  }), e.createElement("line", {
    x1: 8,
    y1: 13,
    x2: 16,
    y2: 13
  }));
}
var hR = ["size", "color", "stroke"];
function dR(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, hR);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-currency-yuan",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M12 19v-7l-5 -7"
  }), e.createElement("path", {
    d: "M17 5l-5 7"
  }), e.createElement("path", {
    d: "M8 13h8"
  }));
}
var vR = ["size", "color", "stroke"];
function mR(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, vR);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-currency-zloty",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M12 18h-7l7 -7h-7"
  }), e.createElement("path", {
    d: "M17 18v-13"
  }), e.createElement("path", {
    d: "M14 14.5l6 -3.5"
  }));
}
var kR = ["size", "color", "stroke"];
function wR(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, kR);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-currency",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 7
  }), e.createElement("path", {
    d: "M4 4l3 3"
  }), e.createElement("path", {
    d: "M20 4l-3 3"
  }), e.createElement("path", {
    d: "M4 20l3 -3"
  }), e.createElement("path", {
    d: "M20 20l-3 -3"
  }));
}
var pR = ["size", "color", "stroke"];
function ER(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, pR);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-current-location-off",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M14.685 10.661c-.3 -.6 -.795 -1.086 -1.402 -1.374m-3.397 .584a3 3 0 1 0 4.24 4.245"
  }), e.createElement("path", {
    d: "M6.357 6.33a8 8 0 1 0 11.301 11.326m1.642 -2.378a8 8 0 0 0 -10.597 -10.569"
  }), e.createElement("path", {
    d: "M12 2v2"
  }), e.createElement("path", {
    d: "M12 20v2"
  }), e.createElement("path", {
    d: "M20 12h2"
  }), e.createElement("path", {
    d: "M2 12h2"
  }), e.createElement("path", {
    d: "M3 3l18 18"
  }));
}
var uR = ["size", "color", "stroke"];
function gR(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, uR);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-current-location",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 3
  }), e.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 8
  }), e.createElement("line", {
    x1: 12,
    y1: 2,
    x2: 12,
    y2: 4
  }), e.createElement("line", {
    x1: 12,
    y1: 20,
    x2: 12,
    y2: 22
  }), e.createElement("line", {
    x1: 20,
    y1: 12,
    x2: 22,
    y2: 12
  }), e.createElement("line", {
    x1: 2,
    y1: 12,
    x2: 4,
    y2: 12
  }));
}
var MR = ["size", "color", "stroke"];
function xR(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, MR);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-cursor-off",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M9 4a3 3 0 0 1 3 3v1m0 9a3 3 0 0 1 -3 3"
  }), e.createElement("path", {
    d: "M15 4a3 3 0 0 0 -3 3v1m0 4v5a3 3 0 0 0 3 3"
  }), e.createElement("path", {
    d: "M3 3l18 18"
  }));
}
var fR = ["size", "color", "stroke"];
function zR(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, fR);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-cursor-text",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M10 12h4"
  }), e.createElement("path", {
    d: "M9 4a3 3 0 0 1 3 3v10a3 3 0 0 1 -3 3"
  }), e.createElement("path", {
    d: "M15 4a3 3 0 0 0 -3 3v10a3 3 0 0 0 3 3"
  }));
}
var bR = ["size", "color", "stroke"];
function LR(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, bR);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-cut",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("circle", {
    cx: 7,
    cy: 17,
    r: 3
  }), e.createElement("circle", {
    cx: 17,
    cy: 17,
    r: 3
  }), e.createElement("line", {
    x1: 9.15,
    y1: 14.85,
    x2: 18,
    y2: 4
  }), e.createElement("line", {
    x1: 6,
    y1: 4,
    x2: 14.85,
    y2: 14.85
  }));
}
var yR = ["size", "color", "stroke"];
function CR(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, yR);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-cylinder",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("ellipse", {
    cx: 12,
    cy: 6,
    rx: 5,
    ry: 3
  }), e.createElement("path", {
    d: "M7 6v12c0 1.657 2.239 3 5 3s5 -1.343 5 -3v-12"
  }));
}
var jR = ["size", "color", "stroke"];
function BR(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, jR);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-dashboard-off",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M11.175 11.178a2 2 0 1 0 2.653 2.634"
  }), e.createElement("path", {
    d: "M14.5 10.5l1 -1"
  }), e.createElement("path", {
    d: "M8.621 4.612a9 9 0 0 1 11.721 11.72m-1.516 2.488a9.008 9.008 0 0 1 -1.226 1.18h-11.2a9 9 0 0 1 -.268 -13.87"
  }), e.createElement("path", {
    d: "M3 3l18 18"
  }));
}
var HR = ["size", "color", "stroke"];
function NR(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, HR);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-dashboard",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("circle", {
    cx: 12,
    cy: 13,
    r: 2
  }), e.createElement("line", {
    x1: 13.45,
    y1: 11.55,
    x2: 15.5,
    y2: 9.5
  }), e.createElement("path", {
    d: "M6.4 20a9 9 0 1 1 11.2 0z"
  }));
}
var WR = ["size", "color", "stroke"];
function qR(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, WR);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-database-export",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("ellipse", {
    cx: 12,
    cy: 6,
    rx: 8,
    ry: 3
  }), e.createElement("path", {
    d: "M4 6v6c0 1.657 3.582 3 8 3a19.84 19.84 0 0 0 3.302 -.267m4.698 -2.733v-6"
  }), e.createElement("path", {
    d: "M4 12v6c0 1.599 3.335 2.905 7.538 2.995m8.462 -6.995v-2m-6 7h7m-3 -3l3 3l-3 3"
  }));
}
var OR = ["size", "color", "stroke"];
function PR(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, OR);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-database-import",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("ellipse", {
    cx: 12,
    cy: 6,
    rx: 8,
    ry: 3
  }), e.createElement("path", {
    d: "M4 6v8m5.009 .783c.924 .14 1.933 .217 2.991 .217c4.418 0 8 -1.343 8 -3v-6"
  }), e.createElement("path", {
    d: "M11.252 20.987c.246 .009 .496 .013 .748 .013c4.418 0 8 -1.343 8 -3v-6m-18 7h7m-3 -3l3 3l-3 3"
  }));
}
var SR = ["size", "color", "stroke"];
function IR(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, SR);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-database-off",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M12.983 8.978c3.955 -.182 7.017 -1.446 7.017 -2.978c0 -1.657 -3.582 -3 -8 -3c-1.661 0 -3.204 .19 -4.483 .515m-2.783 1.228c-.471 .382 -.734 .808 -.734 1.257c0 1.22 1.944 2.271 4.734 2.74"
  }), e.createElement("path", {
    d: "M4 6v6c0 1.657 3.582 3 8 3c.986 0 1.93 -.067 2.802 -.19m3.187 -.82c1.251 -.53 2.011 -1.228 2.011 -1.99v-6"
  }), e.createElement("path", {
    d: "M4 12v6c0 1.657 3.582 3 8 3c3.217 0 5.991 -.712 7.261 -1.74m.739 -3.26v-4"
  }), e.createElement("line", {
    x1: 3,
    y1: 3,
    x2: 21,
    y2: 21
  }));
}
var AR = ["size", "color", "stroke"];
function DR(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, AR);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-database",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("ellipse", {
    cx: 12,
    cy: 6,
    rx: 8,
    ry: 3
  }), e.createElement("path", {
    d: "M4 6v6a8 3 0 0 0 16 0v-6"
  }), e.createElement("path", {
    d: "M4 12v6a8 3 0 0 0 16 0v-6"
  }));
}
var FR = ["size", "color", "stroke"];
function GR(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, FR);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-deer",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M3 3c0 2 1 3 4 3c2 0 3 1 3 3"
  }), e.createElement("path", {
    d: "M21 3c0 2 -1 3 -4 3c-2 0 -3 .333 -3 3"
  }), e.createElement("path", {
    d: "M12 18c-1 0 -4 -3 -4 -6c0 -2 1.333 -3 4 -3s4 1 4 3c0 3 -3 6 -4 6"
  }), e.createElement("path", {
    d: "M15.185 14.889l.095 -.18a4 4 0 1 1 -6.56 0"
  }), e.createElement("path", {
    d: "M17 3c0 1.333 -.333 2.333 -1 3"
  }), e.createElement("path", {
    d: "M7 3c0 1.333 .333 2.333 1 3"
  }), e.createElement("path", {
    d: "M7 6c-2.667 .667 -4.333 1.667 -5 3"
  }), e.createElement("path", {
    d: "M17 6c2.667 .667 4.333 1.667 5 3"
  }), e.createElement("path", {
    d: "M8.5 10l-1.5 -1"
  }), e.createElement("path", {
    d: "M15.5 10l1.5 -1"
  }), e.createElement("path", {
    d: "M12 15h.01"
  }));
}
var JR = ["size", "color", "stroke"];
function KR(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, JR);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-delta",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M4 20h16l-8 -16z"
  }));
}
var QR = ["size", "color", "stroke"];
function RR(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, QR);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-dental-broken",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M12 5.5c-1.074 -.586 -2.583 -1.5 -4 -1.5c-2.1 -.001 -4 1.247 -4 5c0 4.899 1.056 8.41 2.671 10.537c.573 .756 1.97 .521 2.567 -.236c.398 -.505 .819 -1.439 1.262 -2.801c.292 -.771 .892 -1.504 1.5 -1.5c.602 .004 1.21 .737 1.5 1.5c.443 1.362 .864 2.295 1.262 2.8c.597 .759 1.994 .993 2.567 .237c1.615 -2.127 2.671 -5.637 2.671 -10.537c0 -3.74 -1.908 -4.994 -4 -5c-1.423 -.004 -2.92 .911 -4 1.5z"
  }), e.createElement("path", {
    d: "M12 5.5l1 2.5l-2 2l2 2"
  }));
}
var TR = ["size", "color", "stroke"];
function UR(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, TR);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-dental-off",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M19.277 15.281c.463 -1.75 .723 -3.844 .723 -6.281c0 -3.74 -1.908 -4.994 -4 -5c-1.423 -.004 -2.92 .911 -4 1.5c-1.074 -.586 -2.583 -1.5 -4 -1.5m-2.843 1.153c-.707 .784 -1.157 2.017 -1.157 3.847c0 4.899 1.056 8.41 2.671 10.537c.573 .756 1.97 .521 2.567 -.236c.398 -.505 .819 -1.439 1.262 -2.801c.292 -.771 .892 -1.504 1.5 -1.5c.602 .004 1.21 .737 1.5 1.5c.443 1.362 .864 2.295 1.262 2.8c.597 .759 1.994 .993 2.567 .237c.305 -.402 .59 -.853 .852 -1.353"
  }), e.createElement("path", {
    d: "M12 5.5l3 1.5"
  }), e.createElement("path", {
    d: "M3 3l18 18"
  }));
}
var VR = ["size", "color", "stroke"];
function XR(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, VR);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-dental",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M12 5.5c-1.074 -.586 -2.583 -1.5 -4 -1.5c-2.1 -.001 -4 1.247 -4 5c0 4.899 1.056 8.41 2.671 10.537c.573 .756 1.97 .521 2.567 -.236c.398 -.505 .819 -1.439 1.262 -2.801c.292 -.771 .892 -1.504 1.5 -1.5c.602 .004 1.21 .737 1.5 1.5c.443 1.362 .864 2.295 1.262 2.8c.597 .759 1.994 .993 2.567 .237c1.615 -2.127 2.671 -5.637 2.671 -10.537c0 -3.74 -1.908 -4.994 -4 -5c-1.423 -.004 -2.92 .911 -4 1.5z"
  }), e.createElement("path", {
    d: "M12 5.5l3 1.5"
  }));
}
var YR = ["size", "color", "stroke"];
function ZR(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, YR);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-details-off",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M5 19h14"
  }), e.createElement("path", {
    d: "M20.986 16.984a2.003 2.003 0 0 0 -.146 -.734l-7.1 -12.25a2 2 0 0 0 -3.5 0l-.821 1.417m-1.469 2.534l-4.81 8.299a2 2 0 0 0 1.75 2.75"
  }), e.createElement("path", {
    d: "M12 3v5m0 4v7"
  }), e.createElement("path", {
    d: "M3 3l18 18"
  }));
}
var $R = ["size", "color", "stroke"];
function _R(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, $R);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-details",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M5 19h14a2 2 0 0 0 1.84 -2.75l-7.1 -12.25a2 2 0 0 0 -3.5 0l-7.1 12.25a2 2 0 0 0 1.75 2.75"
  }), e.createElement("path", {
    d: "M12 3v16"
  }));
}
var eT = ["size", "color", "stroke"];
function tT(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, eT);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-device-airpods-case",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M21 10h-18"
  }), e.createElement("rect", {
    x: 3,
    y: 4,
    width: 18,
    height: 16,
    rx: 4
  }), e.createElement("path", {
    d: "M7 10v1.5a1.5 1.5 0 0 0 1.5 1.5h7a1.5 1.5 0 0 0 1.5 -1.5v-1.5"
  }));
}
var oT = ["size", "color", "stroke"];
function rT(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, oT);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-device-airpods",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M6 4a4 4 0 0 1 3.995 3.8l.005 .2v10.5a1.5 1.5 0 0 1 -3 0v-6.5h-1a4 4 0 0 1 -3.995 -3.8l-.005 -.2a4 4 0 0 1 4 -4z"
  }), e.createElement("path", {
    d: "M18 4a4 4 0 0 0 -3.995 3.8l-.005 .2v10.5a1.5 1.5 0 0 0 3 0v-6.5h1a4 4 0 0 0 3.995 -3.8l.005 -.2a4 4 0 0 0 -4 -4z"
  }));
}
var nT = ["size", "color", "stroke"];
function lT(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, nT);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-device-analytics",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("rect", {
    x: 3,
    y: 4,
    width: 18,
    height: 12,
    rx: 1
  }), e.createElement("line", {
    x1: 7,
    y1: 20,
    x2: 17,
    y2: 20
  }), e.createElement("line", {
    x1: 9,
    y1: 16,
    x2: 9,
    y2: 20
  }), e.createElement("line", {
    x1: 15,
    y1: 16,
    x2: 15,
    y2: 20
  }), e.createElement("path", {
    d: "M8 12l3 -3l2 2l3 -3"
  }));
}
var aT = ["size", "color", "stroke"];
function iT(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, aT);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-device-audio-tape",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("rect", {
    x: 3,
    y: 5,
    width: 18,
    height: 14,
    rx: 2
  }), e.createElement("path", {
    d: "M3 17l4 -3h10l4 3"
  }), e.createElement("circle", {
    cx: 7.5,
    cy: 9.5,
    r: .5,
    fill: "currentColor"
  }), e.createElement("circle", {
    cx: 16.5,
    cy: 9.5,
    r: .5,
    fill: "currentColor"
  }));
}
var cT = ["size", "color", "stroke"];
function sT(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, cT);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-device-camera-phone",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("circle", {
    cx: 18.5,
    cy: 8.5,
    r: 2.5
  }), e.createElement("path", {
    d: "M13 7h-8a2 2 0 0 0 -2 2v7a2 2 0 0 0 2 2h13a2 2 0 0 0 2 -2v-2"
  }), e.createElement("path", {
    d: "M17 15v-1"
  }));
}
var hT = ["size", "color", "stroke"];
function dT(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, hT);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-device-cctv-off",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M7 7h-3a1 1 0 0 1 -1 -1v-2c0 -.275 .11 -.523 .29 -.704m3.71 -.296h13a1 1 0 0 1 1 1v2a1 1 0 0 1 -1 1h-9"
  }), e.createElement("path", {
    d: "M10.36 10.35a4 4 0 1 0 5.285 5.3"
  }), e.createElement("path", {
    d: "M19 7v7c0 .321 -.022 .637 -.064 .947m-1.095 2.913a7 7 0 0 1 -12.841 -3.86l-.001 -7"
  }), e.createElement("path", {
    d: "M12 14h.01"
  }), e.createElement("path", {
    d: "M3 3l18 18"
  }));
}
var vT = ["size", "color", "stroke"];
function mT(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, vT);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-device-cctv",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("rect", {
    x: 3,
    y: 3,
    width: 18,
    height: 4,
    rx: 1
  }), e.createElement("circle", {
    cx: 12,
    cy: 14,
    r: 4
  }), e.createElement("path", {
    d: "M19 7v7a7 7 0 0 1 -14 0v-7"
  }), e.createElement("line", {
    x1: 12,
    y1: 14,
    x2: 12.01,
    y2: 14
  }));
}
var kT = ["size", "color", "stroke"];
function wT(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, kT);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-device-computer-camera-off",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M6.15 6.153a7 7 0 0 0 9.696 9.696m2 -2a7 7 0 0 0 -9.699 -9.695"
  }), e.createElement("path", {
    d: "M9.13 9.122a3 3 0 0 0 3.743 3.749m2 -2a3 3 0 0 0 -3.737 -3.736"
  }), e.createElement("path", {
    d: "M8 16l-2.091 3.486a1 1 0 0 0 .857 1.514h10.468a1 1 0 0 0 .857 -1.514l-2.091 -3.486"
  }), e.createElement("line", {
    x1: 3,
    y1: 3,
    x2: 21,
    y2: 21
  }));
}
var pT = ["size", "color", "stroke"];
function ET(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, pT);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-device-computer-camera",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("circle", {
    cx: 12,
    cy: 10,
    r: 7
  }), e.createElement("circle", {
    cx: 12,
    cy: 10,
    r: 3
  }), e.createElement("path", {
    d: "M8 16l-2.091 3.486a1 1 0 0 0 .857 1.514h10.468a1 1 0 0 0 .857 -1.514l-2.091 -3.486"
  }));
}
var uT = ["size", "color", "stroke"];
function gT(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, uT);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-device-desktop-analytics",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("rect", {
    x: 3,
    y: 4,
    width: 18,
    height: 12,
    rx: 1
  }), e.createElement("path", {
    d: "M7 20h10"
  }), e.createElement("path", {
    d: "M9 16v4"
  }), e.createElement("path", {
    d: "M15 16v4"
  }), e.createElement("path", {
    d: "M9 12v-4"
  }), e.createElement("path", {
    d: "M12 12v-1"
  }), e.createElement("path", {
    d: "M15 12v-2"
  }), e.createElement("path", {
    d: "M12 12v-1"
  }));
}
var MT = ["size", "color", "stroke"];
function xT(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, MT);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-device-desktop-off",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M8 4h12a1 1 0 0 1 1 1v10a1 1 0 0 1 -1 1m-4 0h-12a1 1 0 0 1 -1 -1v-10a1 1 0 0 1 1 -1"
  }), e.createElement("line", {
    x1: 7,
    y1: 20,
    x2: 17,
    y2: 20
  }), e.createElement("line", {
    x1: 9,
    y1: 16,
    x2: 9,
    y2: 20
  }), e.createElement("line", {
    x1: 15,
    y1: 16,
    x2: 15,
    y2: 20
  }), e.createElement("line", {
    x1: 3,
    y1: 3,
    x2: 21,
    y2: 21
  }));
}
var fT = ["size", "color", "stroke"];
function zT(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, fT);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-device-desktop",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("rect", {
    x: 3,
    y: 4,
    width: 18,
    height: 12,
    rx: 1
  }), e.createElement("line", {
    x1: 7,
    y1: 20,
    x2: 17,
    y2: 20
  }), e.createElement("line", {
    x1: 9,
    y1: 16,
    x2: 9,
    y2: 20
  }), e.createElement("line", {
    x1: 15,
    y1: 16,
    x2: 15,
    y2: 20
  }));
}
var bT = ["size", "color", "stroke"];
function LT(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, bT);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-device-floppy",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M6 4h10l4 4v10a2 2 0 0 1 -2 2h-12a2 2 0 0 1 -2 -2v-12a2 2 0 0 1 2 -2"
  }), e.createElement("circle", {
    cx: 12,
    cy: 14,
    r: 2
  }), e.createElement("polyline", {
    points: "14 4 14 8 8 8 8 4"
  }));
}
var yT = ["size", "color", "stroke"];
function CT(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, yT);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-device-gamepad-2",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M12 5h3.5a5 5 0 0 1 0 10h-5.5l-4.015 4.227a2.3 2.3 0 0 1 -3.923 -2.035l1.634 -8.173a5 5 0 0 1 4.904 -4.019h3.4z"
  }), e.createElement("path", {
    d: "M14 15l4.07 4.284a2.3 2.3 0 0 0 3.925 -2.023l-1.6 -8.232"
  }), e.createElement("path", {
    d: "M8 9v2"
  }), e.createElement("path", {
    d: "M7 10h2"
  }), e.createElement("path", {
    d: "M14 10h2"
  }));
}
var jT = ["size", "color", "stroke"];
function BT(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, jT);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-device-gamepad",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("rect", {
    x: 2,
    y: 6,
    width: 20,
    height: 12,
    rx: 2
  }), e.createElement("path", {
    d: "M6 12h4m-2 -2v4"
  }), e.createElement("line", {
    x1: 15,
    y1: 11,
    x2: 15,
    y2: 11.01
  }), e.createElement("line", {
    x1: 18,
    y1: 13,
    x2: 18,
    y2: 13.01
  }));
}
var HT = ["size", "color", "stroke"];
function NT(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, HT);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-device-heart-monitor",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("rect", {
    x: 4,
    y: 4,
    width: 16,
    height: 16,
    rx: 2
  }), e.createElement("path", {
    d: "M4 9h6l1 -2l2 4l1 -2h6"
  }), e.createElement("path", {
    d: "M4 14h16"
  }), e.createElement("path", {
    d: "M14 17v.01"
  }), e.createElement("path", {
    d: "M17 17v.01"
  }));
}
var WT = ["size", "color", "stroke"];
function qT(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, WT);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-device-ipad-horizontal",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("rect", {
    x: 2,
    y: 4,
    width: 20,
    height: 16,
    rx: 2
  }), e.createElement("path", {
    d: "M9 17h6"
  }));
}
var OT = ["size", "color", "stroke"];
function PT(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, OT);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-device-ipad",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M20 4v16a2 2 0 0 1 -2 2h-12a2 2 0 0 1 -2 -2v-16a2 2 0 0 1 2 -2h12a2 2 0 0 1 2 2z"
  }), e.createElement("path", {
    d: "M9 19h6"
  }));
}
var ST = ["size", "color", "stroke"];
function IT(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, ST);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-device-landline-phone",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M20 3h-2a2 2 0 0 0 -2 2v14a2 2 0 0 0 2 2h2a2 2 0 0 0 2 -2v-14a2 2 0 0 0 -2 -2z"
  }), e.createElement("path", {
    d: "M16 4h-11a3 3 0 0 0 -3 3v10a3 3 0 0 0 3 3h11"
  }), e.createElement("path", {
    d: "M12 8h-6v3h6z"
  }), e.createElement("path", {
    d: "M12 14v.01"
  }), e.createElement("path", {
    d: "M9 14v.01"
  }), e.createElement("path", {
    d: "M6 14v.01"
  }), e.createElement("path", {
    d: "M12 17v.01"
  }), e.createElement("path", {
    d: "M9 17v.01"
  }), e.createElement("path", {
    d: "M6 17v.01"
  }));
}
var AT = ["size", "color", "stroke"];
function DT(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, AT);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-device-laptop-off",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M3 19h16"
  }), e.createElement("path", {
    d: "M10 6h8a1 1 0 0 1 1 1v8m-3 1h-10a1 1 0 0 1 -1 -1v-8a1 1 0 0 1 1 -1"
  }), e.createElement("path", {
    d: "M3 3l18 18"
  }));
}
var FT = ["size", "color", "stroke"];
function GT(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, FT);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-device-laptop",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("line", {
    x1: 3,
    y1: 19,
    x2: 21,
    y2: 19
  }), e.createElement("rect", {
    x: 5,
    y: 6,
    width: 14,
    height: 10,
    rx: 1
  }));
}
var JT = ["size", "color", "stroke"];
function KT(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, JT);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-device-mobile-charging",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("rect", {
    x: 6,
    y: 3,
    width: 12,
    height: 18,
    rx: 2
  }), e.createElement("path", {
    d: "M11 4h2"
  }), e.createElement("path", {
    d: "M12 9.5l-1 2.5h2l-1 2.5"
  }));
}
var QT = ["size", "color", "stroke"];
function RT(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, QT);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-device-mobile-message",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M11 3h10v8h-3l-4 2v-2h-3z"
  }), e.createElement("path", {
    d: "M15 16v4a1 1 0 0 1 -1 1h-8a1 1 0 0 1 -1 -1v-14a1 1 0 0 1 1 -1h2"
  }), e.createElement("path", {
    d: "M10 18v.01"
  }));
}
var TT = ["size", "color", "stroke"];
function UT(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, TT);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-device-mobile-off",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M7.174 3.178c.252 -.114 .531 -.178 .826 -.178h8a2 2 0 0 1 2 2v9m0 4v1a2 2 0 0 1 -2 2h-8a2 2 0 0 1 -2 -2v-13"
  }), e.createElement("path", {
    d: "M11 4h2"
  }), e.createElement("path", {
    d: "M12 17v.01"
  }), e.createElement("path", {
    d: "M3 3l18 18"
  }));
}
var VT = ["size", "color", "stroke"];
function XT(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, VT);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-device-mobile-rotated",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("rect", {
    x: 3,
    y: 6,
    width: 18,
    height: 12,
    rx: 2
  }), e.createElement("path", {
    d: "M20 11v2"
  }), e.createElement("path", {
    d: "M7 12h-.01"
  }));
}
var YT = ["size", "color", "stroke"];
function ZT(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, YT);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-device-mobile-vibration",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("rect", {
    x: 3,
    y: 3,
    width: 12,
    height: 18,
    rx: 2
  }), e.createElement("line", {
    x1: 8,
    y1: 4,
    x2: 10,
    y2: 4
  }), e.createElement("line", {
    x1: 9,
    y1: 17,
    x2: 9,
    y2: 17.01
  }), e.createElement("path", {
    d: "M21 6l-2 3l2 3l-2 3l2 3"
  }));
}
var $T = ["size", "color", "stroke"];
function _T(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, $T);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-device-mobile",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("rect", {
    x: 6,
    y: 3,
    width: 12,
    height: 18,
    rx: 2
  }), e.createElement("line", {
    x1: 11,
    y1: 4,
    x2: 13,
    y2: 4
  }), e.createElement("line", {
    x1: 12,
    y1: 17,
    x2: 12,
    y2: 17.01
  }));
}
var eU = ["size", "color", "stroke"];
function tU(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, eU);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-device-nintendo-off",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M4.713 4.718a3.995 3.995 0 0 0 -1.713 3.282v8a4 4 0 0 0 4 4h3v-10m0 -4v-2h-2"
  }), e.createElement("path", {
    d: "M14 10v-6h3a4 4 0 0 1 4 4v8c0 .308 -.035 .608 -.1 .896m-1.62 2.39a3.982 3.982 0 0 1 -2.28 .714h-3v-6"
  }), e.createElement("circle", {
    cx: 6.5,
    cy: 8.5,
    r: 1
  }), e.createElement("path", {
    d: "M3 3l18 18"
  }));
}
var oU = ["size", "color", "stroke"];
function rU(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, oU);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-device-nintendo",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M10 20v-16h-3a4 4 0 0 0 -4 4v8a4 4 0 0 0 4 4h3z"
  }), e.createElement("path", {
    d: "M14 20v-16h3a4 4 0 0 1 4 4v8a4 4 0 0 1 -4 4h-3z"
  }), e.createElement("circle", {
    cx: 17.5,
    cy: 15.5,
    r: 1,
    fill: "currentColor"
  }), e.createElement("circle", {
    cx: 6.5,
    cy: 8.5,
    r: 1,
    fill: "currentColor"
  }));
}
var nU = ["size", "color", "stroke"];
function lU(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, nU);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-device-sd-card",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M7 21h10a2 2 0 0 0 2 -2v-14a2 2 0 0 0 -2 -2h-6.172a2 2 0 0 0 -1.414 .586l-3.828 3.828a2 2 0 0 0 -.586 1.414v10.172a2 2 0 0 0 2 2z"
  }), e.createElement("path", {
    d: "M13 6v2"
  }), e.createElement("path", {
    d: "M16 6v2"
  }), e.createElement("path", {
    d: "M10 7v1"
  }));
}
var aU = ["size", "color", "stroke"];
function iU(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, aU);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-device-sim-1",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M6 3h8.5l4.5 4.5v12.5a1 1 0 0 1 -1 1h-12a1 1 0 0 1 -1 -1v-16a1 1 0 0 1 1 -1z"
  }), e.createElement("path", {
    d: "M10 11l2 -2v8"
  }));
}
var cU = ["size", "color", "stroke"];
function sU(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, cU);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-device-sim-2",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M6 3h8.5l4.5 4.5v12.5a1 1 0 0 1 -1 1h-12a1 1 0 0 1 -1 -1v-16a1 1 0 0 1 1 -1z"
  }), e.createElement("path", {
    d: "M10 9h3a1 1 0 0 1 1 1v2a1 1 0 0 1 -1 1h-2a1 1 0 0 0 -1 1v2a1 1 0 0 0 1 1h3"
  }));
}
var hU = ["size", "color", "stroke"];
function dU(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, hU);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-device-sim-3",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M6 3h8.5l4.5 4.5v12.5a1 1 0 0 1 -1 1h-12a1 1 0 0 1 -1 -1v-16a1 1 0 0 1 1 -1z"
  }), e.createElement("path", {
    d: "M10 9h2.5a1.5 1.5 0 0 1 1.5 1.5v1a1.5 1.5 0 0 1 -1.5 1.5h-1.5h1.5a1.5 1.5 0 0 1 1.5 1.5v1a1.5 1.5 0 0 1 -1.5 1.5h-2.5"
  }));
}
var vU = ["size", "color", "stroke"];
function mU(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, vU);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-device-sim",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M6 3h8.5l4.5 4.5v12.5a1 1 0 0 1 -1 1h-12a1 1 0 0 1 -1 -1v-16a1 1 0 0 1 1 -1z"
  }), e.createElement("path", {
    d: "M9 11h3v6"
  }), e.createElement("path", {
    d: "M15 17v.01"
  }), e.createElement("path", {
    d: "M15 14v.01"
  }), e.createElement("path", {
    d: "M15 11v.01"
  }), e.createElement("path", {
    d: "M9 14v.01"
  }), e.createElement("path", {
    d: "M9 17v.01"
  }));
}
var kU = ["size", "color", "stroke"];
function wU(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, kU);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-device-speaker-off",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M7 3h10a2 2 0 0 1 2 2v10m0 4a2 2 0 0 1 -2 2h-10a2 2 0 0 1 -2 -2v-14"
  }), e.createElement("path", {
    d: "M11.114 11.133a3.001 3.001 0 1 0 3.754 3.751"
  }), e.createElement("path", {
    d: "M12 7v.01"
  }), e.createElement("path", {
    d: "M3 3l18 18"
  }));
}
var pU = ["size", "color", "stroke"];
function EU(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, pU);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-device-speaker",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("rect", {
    x: 5,
    y: 3,
    width: 14,
    height: 18,
    rx: 2
  }), e.createElement("circle", {
    cx: 12,
    cy: 14,
    r: 3
  }), e.createElement("line", {
    x1: 12,
    y1: 7,
    x2: 12,
    y2: 7.01
  }));
}
var uU = ["size", "color", "stroke"];
function gU(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, uU);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-device-tablet-off",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M7 3h11a1 1 0 0 1 1 1v11m0 4v1a1 1 0 0 1 -1 1h-12a1 1 0 0 1 -1 -1v-15"
  }), e.createElement("circle", {
    cx: 12,
    cy: 17,
    r: 1
  }), e.createElement("path", {
    d: "M3 3l18 18"
  }));
}
var MU = ["size", "color", "stroke"];
function xU(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, MU);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-device-tablet",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("rect", {
    x: 5,
    y: 3,
    width: 14,
    height: 18,
    rx: 1
  }), e.createElement("circle", {
    cx: 12,
    cy: 17,
    r: 1
  }));
}
var fU = ["size", "color", "stroke"];
function zU(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, fU);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-device-tv-off",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M11 7h8a2 2 0 0 1 2 2v8m-1.178 2.824c-.25 .113 -.529 .176 -.822 .176h-14a2 2 0 0 1 -2 -2v-9a2 2 0 0 1 2 -2h2"
  }), e.createElement("path", {
    d: "M16 3l-4 4l-4 -4"
  }), e.createElement("path", {
    d: "M3 3l18 18"
  }));
}
var bU = ["size", "color", "stroke"];
function LU(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, bU);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-device-tv-old",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("rect", {
    x: 3,
    y: 7,
    width: 18,
    height: 13,
    rx: 2
  }), e.createElement("path", {
    d: "M16 3l-4 4l-4 -4"
  }), e.createElement("path", {
    d: "M15 7v13"
  }), e.createElement("path", {
    d: "M18 15v.01"
  }), e.createElement("path", {
    d: "M18 12v.01"
  }));
}
var yU = ["size", "color", "stroke"];
function CU(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, yU);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-device-tv",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("rect", {
    x: 3,
    y: 7,
    width: 18,
    height: 13,
    rx: 2
  }), e.createElement("polyline", {
    points: "16 3 12 7 8 3"
  }));
}
var jU = ["size", "color", "stroke"];
function BU(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, jU);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-device-watch-off",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M10 6h5a3 3 0 0 1 3 3v5m-.882 3.125a2.99 2.99 0 0 1 -2.118 .875h-6a3 3 0 0 1 -3 -3v-6c0 -.828 .336 -1.578 .878 -2.121"
  }), e.createElement("path", {
    d: "M9 18v3h6v-3"
  }), e.createElement("path", {
    d: "M9 5v-2h6v3"
  }), e.createElement("path", {
    d: "M3 3l18 18"
  }));
}
var HU = ["size", "color", "stroke"];
function NU(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, HU);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-device-watch-stats-2",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("rect", {
    x: 6,
    y: 6,
    width: 12,
    height: 12,
    rx: 3
  }), e.createElement("path", {
    d: "M9 18v3h6v-3"
  }), e.createElement("path", {
    d: "M9 6v-3h6v3"
  }), e.createElement("path", {
    d: "M12 10a2 2 0 1 0 2 2"
  }));
}
var WU = ["size", "color", "stroke"];
function qU(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, WU);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-device-watch-stats",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("rect", {
    x: 6,
    y: 6,
    width: 12,
    height: 12,
    rx: 3
  }), e.createElement("path", {
    d: "M9 18v3h6v-3"
  }), e.createElement("path", {
    d: "M9 6v-3h6v3"
  }), e.createElement("path", {
    d: "M9 14v-4"
  }), e.createElement("path", {
    d: "M12 14v-1"
  }), e.createElement("path", {
    d: "M15 14v-3"
  }));
}
var OU = ["size", "color", "stroke"];
function PU(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, OU);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-device-watch",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("rect", {
    x: 6,
    y: 6,
    width: 12,
    height: 12,
    rx: 3
  }), e.createElement("path", {
    d: "M9 18v3h6v-3"
  }), e.createElement("path", {
    d: "M9 6v-3h6v3"
  }));
}
var SU = ["size", "color", "stroke"];
function IU(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, SU);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-devices-2",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M10 15h-6a1 1 0 0 1 -1 -1v-8a1 1 0 0 1 1 -1h6"
  }), e.createElement("rect", {
    x: 13,
    y: 4,
    width: 8,
    height: 16,
    rx: 1
  }), e.createElement("line", {
    x1: 7,
    y1: 19,
    x2: 10,
    y2: 19
  }), e.createElement("line", {
    x1: 17,
    y1: 8,
    x2: 17,
    y2: 8.01
  }), e.createElement("circle", {
    cx: 17,
    cy: 16,
    r: 1
  }), e.createElement("line", {
    x1: 9,
    y1: 15,
    x2: 9,
    y2: 19
  }));
}
var AU = ["size", "color", "stroke"];
function DU(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, AU);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-devices-off",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M13 9a1 1 0 0 1 1 -1h6a1 1 0 0 1 1 1v8m-1 3h-6a1 1 0 0 1 -1 -1v-6"
  }), e.createElement("path", {
    d: "M18 8v-3a1 1 0 0 0 -1 -1h-9m-4 0a1 1 0 0 0 -1 1v12a1 1 0 0 0 1 1h9"
  }), e.createElement("path", {
    d: "M16 9h2"
  }), e.createElement("path", {
    d: "M3 3l18 18"
  }));
}
var FU = ["size", "color", "stroke"];
function GU(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, FU);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-devices-pc-off",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M9 9v10h-6v-14h2"
  }), e.createElement("path", {
    d: "M13 9h9v7h-2m-4 0h-4v-4"
  }), e.createElement("path", {
    d: "M14 19h5"
  }), e.createElement("path", {
    d: "M17 17v2"
  }), e.createElement("path", {
    d: "M6 13v.01"
  }), e.createElement("path", {
    d: "M6 16v.01"
  }), e.createElement("path", {
    d: "M3 3l18 18"
  }));
}
var JU = ["size", "color", "stroke"];
function KU(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, JU);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-devices-pc",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M3 5h6v14h-6z"
  }), e.createElement("path", {
    d: "M12 9h10v7h-10z"
  }), e.createElement("path", {
    d: "M14 19h6"
  }), e.createElement("path", {
    d: "M17 16v3"
  }), e.createElement("path", {
    d: "M6 13v.01"
  }), e.createElement("path", {
    d: "M6 16v.01"
  }));
}
var QU = ["size", "color", "stroke"];
function RU(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, QU);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-devices",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("rect", {
    x: 13,
    y: 8,
    width: 8,
    height: 12,
    rx: 1
  }), e.createElement("path", {
    d: "M18 8v-3a1 1 0 0 0 -1 -1h-13a1 1 0 0 0 -1 1v12a1 1 0 0 0 1 1h9"
  }), e.createElement("line", {
    x1: 16,
    y1: 9,
    x2: 18,
    y2: 9
  }));
}
var TU = ["size", "color", "stroke"];
function UU(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, TU);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-dialpad-off",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M7 7h-4v-4"
  }), e.createElement("path", {
    d: "M17 3h4v4h-4z"
  }), e.createElement("path", {
    d: "M10 6v-3h4v4h-3"
  }), e.createElement("path", {
    d: "M3 10h4v4h-4z"
  }), e.createElement("path", {
    d: "M17 13v-3h4v4h-3"
  }), e.createElement("path", {
    d: "M14 14h-4v-4"
  }), e.createElement("path", {
    d: "M10 17h4v4h-4z"
  }), e.createElement("path", {
    d: "M3 3l18 18"
  }));
}
var VU = ["size", "color", "stroke"];
function XU(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, VU);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-dialpad",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M3 3h4v4h-4z"
  }), e.createElement("path", {
    d: "M17 3h4v4h-4z"
  }), e.createElement("path", {
    d: "M10 3h4v4h-4z"
  }), e.createElement("path", {
    d: "M3 10h4v4h-4z"
  }), e.createElement("path", {
    d: "M17 10h4v4h-4z"
  }), e.createElement("path", {
    d: "M10 10h4v4h-4z"
  }), e.createElement("path", {
    d: "M10 17h4v4h-4z"
  }));
}
var YU = ["size", "color", "stroke"];
function ZU(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, YU);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-diamond-off",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M9 5h9l3 5l-3.308 3.697m-1.883 2.104l-3.309 3.699a0.7 .7 0 0 1 -1 0l-8.5 -9.5l2.62 -4.368"
  }), e.createElement("path", {
    d: "M10 12l-2 -2.2l.6 -1"
  }), e.createElement("path", {
    d: "M3 3l18 18"
  }));
}
var $U = ["size", "color", "stroke"];
function _U(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, $U);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-diamond",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M6 5h12l3 5l-8.5 9.5a0.7 .7 0 0 1 -1 0l-8.5 -9.5l3 -5"
  }), e.createElement("path", {
    d: "M10 12l-2 -2.2l.6 -1"
  }));
}
var eV = ["size", "color", "stroke"];
function tV(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, eV);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-diamonds",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M10.831 20.413l-5.375 -6.91c-.608 -.783 -.608 -2.223 0 -3.005l5.375 -6.911a1.457 1.457 0 0 1 2.338 0l5.375 6.91c.608 .783 .608 2.223 0 3.005l-5.375 6.911a1.457 1.457 0 0 1 -2.338 0z"
  }));
}
var oV = ["size", "color", "stroke"];
function rV(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, oV);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-dice-1",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("rect", {
    x: 4,
    y: 4,
    width: 16,
    height: 16,
    rx: 2
  }), e.createElement("circle", {
    cx: 12,
    cy: 12,
    r: .5,
    fill: "currentColor"
  }));
}
var nV = ["size", "color", "stroke"];
function lV(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, nV);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-dice-2",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("rect", {
    x: 4,
    y: 4,
    width: 16,
    height: 16,
    rx: 2
  }), e.createElement("circle", {
    cx: 9.5,
    cy: 9.5,
    r: .5,
    fill: "currentColor"
  }), e.createElement("circle", {
    cx: 14.5,
    cy: 14.5,
    r: .5,
    fill: "currentColor"
  }));
}
var aV = ["size", "color", "stroke"];
function iV(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, aV);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-dice-3",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("rect", {
    x: 4,
    y: 4,
    width: 16,
    height: 16,
    rx: 2
  }), e.createElement("circle", {
    cx: 8.5,
    cy: 8.5,
    r: .5,
    fill: "currentColor"
  }), e.createElement("circle", {
    cx: 15.5,
    cy: 15.5,
    r: .5,
    fill: "currentColor"
  }), e.createElement("circle", {
    cx: 12,
    cy: 12,
    r: .5,
    fill: "currentColor"
  }));
}
var cV = ["size", "color", "stroke"];
function sV(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, cV);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-dice-4",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("rect", {
    x: 4,
    y: 4,
    width: 16,
    height: 16,
    rx: 2
  }), e.createElement("circle", {
    cx: 8.5,
    cy: 8.5,
    r: .5,
    fill: "currentColor"
  }), e.createElement("circle", {
    cx: 15.5,
    cy: 8.5,
    r: .5,
    fill: "currentColor"
  }), e.createElement("circle", {
    cx: 15.5,
    cy: 15.5,
    r: .5,
    fill: "currentColor"
  }), e.createElement("circle", {
    cx: 8.5,
    cy: 15.5,
    r: .5,
    fill: "currentColor"
  }));
}
var hV = ["size", "color", "stroke"];
function dV(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, hV);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-dice-5",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("rect", {
    x: 4,
    y: 4,
    width: 16,
    height: 16,
    rx: 2
  }), e.createElement("circle", {
    cx: 8.5,
    cy: 8.5,
    r: .5,
    fill: "currentColor"
  }), e.createElement("circle", {
    cx: 15.5,
    cy: 8.5,
    r: .5,
    fill: "currentColor"
  }), e.createElement("circle", {
    cx: 15.5,
    cy: 15.5,
    r: .5,
    fill: "currentColor"
  }), e.createElement("circle", {
    cx: 8.5,
    cy: 15.5,
    r: .5,
    fill: "currentColor"
  }), e.createElement("circle", {
    cx: 12,
    cy: 12,
    r: .5,
    fill: "currentColor"
  }));
}
var vV = ["size", "color", "stroke"];
function mV(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, vV);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-dice-6",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("rect", {
    x: 4,
    y: 4,
    width: 16,
    height: 16,
    rx: 2
  }), e.createElement("circle", {
    cx: 8.5,
    cy: 7.5,
    r: .5,
    fill: "currentColor"
  }), e.createElement("circle", {
    cx: 15.5,
    cy: 7.5,
    r: .5,
    fill: "currentColor"
  }), e.createElement("circle", {
    cx: 8.5,
    cy: 12,
    r: .5,
    fill: "currentColor"
  }), e.createElement("circle", {
    cx: 15.5,
    cy: 12,
    r: .5,
    fill: "currentColor"
  }), e.createElement("circle", {
    cx: 15.5,
    cy: 16.5,
    r: .5,
    fill: "currentColor"
  }), e.createElement("circle", {
    cx: 8.5,
    cy: 16.5,
    r: .5,
    fill: "currentColor"
  }));
}
var kV = ["size", "color", "stroke"];
function wV(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, kV);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-dice",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("rect", {
    x: 4,
    y: 4,
    width: 16,
    height: 16,
    rx: 2
  }), e.createElement("circle", {
    cx: 8.5,
    cy: 8.5,
    r: .5,
    fill: "currentColor"
  }), e.createElement("circle", {
    cx: 15.5,
    cy: 8.5,
    r: .5,
    fill: "currentColor"
  }), e.createElement("circle", {
    cx: 15.5,
    cy: 15.5,
    r: .5,
    fill: "currentColor"
  }), e.createElement("circle", {
    cx: 8.5,
    cy: 15.5,
    r: .5,
    fill: "currentColor"
  }));
}
var pV = ["size", "color", "stroke"];
function EV(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, pV);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-dimensions",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M3 5h11"
  }), e.createElement("path", {
    d: "M12 7l2 -2l-2 -2"
  }), e.createElement("path", {
    d: "M5 3l-2 2l2 2"
  }), e.createElement("path", {
    d: "M19 10v11"
  }), e.createElement("path", {
    d: "M17 19l2 2l2 -2"
  }), e.createElement("path", {
    d: "M21 12l-2 -2l-2 2"
  }), e.createElement("rect", {
    x: 3,
    y: 10,
    width: 11,
    height: 11,
    rx: 2
  }));
}
var uV = ["size", "color", "stroke"];
function gV(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, uV);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-direction-horizontal",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M10 9l-3 3l3 3"
  }), e.createElement("path", {
    d: "M14 9l3 3l-3 3"
  }));
}
var MV = ["size", "color", "stroke"];
function xV(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, MV);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-direction-sign-off",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M18.73 14.724l1.949 -1.95a1.095 1.095 0 0 0 0 -1.548l-7.905 -7.905a1.095 1.095 0 0 0 -1.548 0l-1.95 1.95m-2.01 2.01l-3.945 3.945a1.095 1.095 0 0 0 0 1.548l7.905 7.905c.427 .428 1.12 .428 1.548 0l3.95 -3.95"
  }), e.createElement("path", {
    d: "M8 12h4"
  }), e.createElement("path", {
    d: "M13.748 13.752l-1.748 1.748"
  }), e.createElement("path", {
    d: "M3 3l18 18"
  }));
}
var fV = ["size", "color", "stroke"];
function zV(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, fV);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-direction-sign",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M3.32 12.774l7.906 7.905c.427 .428 1.12 .428 1.548 0l7.905 -7.905a1.095 1.095 0 0 0 0 -1.548l-7.905 -7.905a1.095 1.095 0 0 0 -1.548 0l-7.905 7.905a1.095 1.095 0 0 0 0 1.548z"
  }), e.createElement("path", {
    d: "M8 12h7.5"
  }), e.createElement("path", {
    d: "M12 8.5l3.5 3.5l-3.5 3.5"
  }));
}
var bV = ["size", "color", "stroke"];
function LV(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, bV);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-direction",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M9 10l3 -3l3 3"
  }), e.createElement("path", {
    d: "M9 14l3 3l3 -3"
  }));
}
var yV = ["size", "color", "stroke"];
function CV(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, yV);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-directions-off",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M12 21v-4"
  }), e.createElement("path", {
    d: "M12 13v-1"
  }), e.createElement("path", {
    d: "M12 5v-2"
  }), e.createElement("path", {
    d: "M10 21h4"
  }), e.createElement("path", {
    d: "M8 8v1h1m4 0h6l2 -2l-2 -2h-10"
  }), e.createElement("path", {
    d: "M14 14v3h-8l-2 -2l2 -2h7"
  }), e.createElement("path", {
    d: "M3 3l18 18"
  }));
}
var jV = ["size", "color", "stroke"];
function BV(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, jV);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-directions",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M12 21v-4"
  }), e.createElement("path", {
    d: "M12 13v-4"
  }), e.createElement("path", {
    d: "M12 5v-2"
  }), e.createElement("path", {
    d: "M10 21h4"
  }), e.createElement("path", {
    d: "M8 5v4h11l2 -2l-2 -2z"
  }), e.createElement("path", {
    d: "M14 13v4h-8l-2 -2l2 -2z"
  }));
}
var HV = ["size", "color", "stroke"];
function NV(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, HV);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-disabled-2",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("circle", {
    cx: 17,
    cy: 6,
    r: 2
  }), e.createElement("path", {
    d: "M9 11a5 5 0 1 0 3.95 7.95"
  }), e.createElement("path", {
    d: "M19 20l-4 -5h-4l3 -5l-4 -3l-4 1"
  }));
}
var WV = ["size", "color", "stroke"];
function qV(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, WV);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-disabled-off",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M11 7a2 2 0 1 0 -2 -2"
  }), e.createElement("path", {
    d: "M11 11v4h4l4 5"
  }), e.createElement("path", {
    d: "M15 11h1"
  }), e.createElement("path", {
    d: "M7 11.5a5 5 0 1 0 6 7.5"
  }), e.createElement("path", {
    d: "M3 3l18 18"
  }));
}
var OV = ["size", "color", "stroke"];
function PV(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, OV);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-disabled",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("circle", {
    cx: 11,
    cy: 5,
    r: 2
  }), e.createElement("polyline", {
    points: "11 7 11 15 15 15 19 20"
  }), e.createElement("line", {
    x1: 11,
    y1: 11,
    x2: 16,
    y2: 11
  }), e.createElement("path", {
    d: "M7 11.5a5 5 0 1 0 6 7.5"
  }));
}
var SV = ["size", "color", "stroke"];
function IV(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, SV);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-disc-golf",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M5 5h14"
  }), e.createElement("path", {
    d: "M6 5c.32 6.744 2.74 9.246 6 10"
  }), e.createElement("path", {
    d: "M18 5c-.32 6.744 -2.74 9.246 -6 10"
  }), e.createElement("path", {
    d: "M10 5c.006 4.915 .552 7.082 2 10"
  }), e.createElement("path", {
    d: "M14 5c-.006 4.915 -.552 7.082 -2 10"
  }), e.createElement("path", {
    d: "M12 15v6"
  }), e.createElement("path", {
    d: "M12 3v2"
  }), e.createElement("path", {
    d: "M7 16c.64 .64 1.509 1 2.414 1h5.172c.905 0 1.774 -.36 2.414 -1"
  }), e.createElement("path", {
    d: "M11 21h2"
  }));
}
var AV = ["size", "color", "stroke"];
function DV(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, AV);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-disc-off",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M20.044 16.04a9 9 0 0 0 -12.082 -12.085m-2.333 1.688a9 9 0 0 0 6.371 15.357c2.491 0 4.73 -.997 6.36 -2.631"
  }), e.createElement("path", {
    d: "M11.298 11.288a1 1 0 1 0 1.402 1.427"
  }), e.createElement("path", {
    d: "M7 12c0 -1.38 .559 -2.629 1.462 -3.534m2.607 -1.38c.302 -.056 .613 -.086 .931 -.086"
  }), e.createElement("path", {
    d: "M12 17a4.985 4.985 0 0 0 3.551 -1.48m1.362 -2.587c.057 -.302 .087 -.614 .087 -.933"
  }), e.createElement("path", {
    d: "M3 3l18 18"
  }));
}
var FV = ["size", "color", "stroke"];
function GV(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, FV);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-disc",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 9
  }), e.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 1
  }), e.createElement("path", {
    d: "M7 12a5 5 0 0 1 5 -5"
  }), e.createElement("path", {
    d: "M12 17a5 5 0 0 0 5 -5"
  }));
}
var JV = ["size", "color", "stroke"];
function KV(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, JV);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-discount-2-off",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M9 15l3 -3m2 -2l1 -1"
  }), e.createElement("path", {
    d: "M9.148 9.145a0.498 .498 0 0 0 .352 .855a0.5 .5 0 0 0 .35 -.142"
  }), e.createElement("path", {
    d: "M14.148 14.145a0.498 .498 0 0 0 .352 .855a0.5 .5 0 0 0 .35 -.142"
  }), e.createElement("path", {
    d: "M8.887 4.89a2.2 2.2 0 0 0 .863 -.53l.7 -.7a2.2 2.2 0 0 1 3.12 0l.7 .7c.412 .41 .97 .64 1.55 .64h1a2.2 2.2 0 0 1 2.2 2.2v1c0 .58 .23 1.138 .64 1.55l.7 .7a2.2 2.2 0 0 1 0 3.12l-.7 .7a2.2 2.2 0 0 0 -.528 .858m-.757 3.248a2.193 2.193 0 0 1 -1.555 .644h-1a2.2 2.2 0 0 0 -1.55 .64l-.7 .7a2.2 2.2 0 0 1 -3.12 0l-.7 -.7a2.2 2.2 0 0 0 -1.55 -.64h-1a2.2 2.2 0 0 1 -2.2 -2.2v-1a2.2 2.2 0 0 0 -.64 -1.55l-.7 -.7a2.2 2.2 0 0 1 0 -3.12l.7 -.7a2.2 2.2 0 0 0 .64 -1.55v-1c0 -.604 .244 -1.152 .638 -1.55"
  }), e.createElement("path", {
    d: "M3 3l18 18"
  }));
}
var QV = ["size", "color", "stroke"];
function RV(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, QV);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-discount-2",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("line", {
    x1: 9,
    y1: 15,
    x2: 15,
    y2: 9
  }), e.createElement("circle", {
    cx: 9.5,
    cy: 9.5,
    r: .5,
    fill: "currentColor"
  }), e.createElement("circle", {
    cx: 14.5,
    cy: 14.5,
    r: .5,
    fill: "currentColor"
  }), e.createElement("path", {
    d: "M5 7.2a2.2 2.2 0 0 1 2.2 -2.2h1a2.2 2.2 0 0 0 1.55 -.64l.7 -.7a2.2 2.2 0 0 1 3.12 0l.7 .7a2.2 2.2 0 0 0 1.55 .64h1a2.2 2.2 0 0 1 2.2 2.2v1a2.2 2.2 0 0 0 .64 1.55l.7 .7a2.2 2.2 0 0 1 0 3.12l-.7 .7a2.2 2.2 0 0 0 -.64 1.55v1a2.2 2.2 0 0 1 -2.2 2.2h-1a2.2 2.2 0 0 0 -1.55 .64l-.7 .7a2.2 2.2 0 0 1 -3.12 0l-.7 -.7a2.2 2.2 0 0 0 -1.55 -.64h-1a2.2 2.2 0 0 1 -2.2 -2.2v-1a2.2 2.2 0 0 0 -.64 -1.55l-.7 -.7a2.2 2.2 0 0 1 0 -3.12l.7 -.7a2.2 2.2 0 0 0 .64 -1.55v-1"
  }));
}
var TV = ["size", "color", "stroke"];
function UV(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, TV);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-discount-check",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M5 7.2a2.2 2.2 0 0 1 2.2 -2.2h1a2.2 2.2 0 0 0 1.55 -.64l.7 -.7a2.2 2.2 0 0 1 3.12 0l.7 .7c.412 .41 .97 .64 1.55 .64h1a2.2 2.2 0 0 1 2.2 2.2v1c0 .58 .23 1.138 .64 1.55l.7 .7a2.2 2.2 0 0 1 0 3.12l-.7 .7a2.2 2.2 0 0 0 -.64 1.55v1a2.2 2.2 0 0 1 -2.2 2.2h-1a2.2 2.2 0 0 0 -1.55 .64l-.7 .7a2.2 2.2 0 0 1 -3.12 0l-.7 -.7a2.2 2.2 0 0 0 -1.55 -.64h-1a2.2 2.2 0 0 1 -2.2 -2.2v-1a2.2 2.2 0 0 0 -.64 -1.55l-.7 -.7a2.2 2.2 0 0 1 0 -3.12l.7 -.7a2.2 2.2 0 0 0 .64 -1.55v-1"
  }), e.createElement("path", {
    d: "M9 12l2 2l4 -4"
  }));
}
var VV = ["size", "color", "stroke"];
function XV(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, VV);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-discount-off",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M9 15l3 -3m2 -2l1 -1"
  }), e.createElement("path", {
    d: "M9.148 9.145a0.498 .498 0 0 0 .352 .855a0.5 .5 0 0 0 .35 -.142"
  }), e.createElement("path", {
    d: "M14.148 14.145a0.498 .498 0 0 0 .352 .855a0.5 .5 0 0 0 .35 -.142"
  }), e.createElement("path", {
    d: "M5.641 5.631a9 9 0 1 0 12.719 12.738m1.68 -2.318a9 9 0 0 0 -12.074 -12.098"
  }), e.createElement("path", {
    d: "M3 3l18 18"
  }));
}
var YV = ["size", "color", "stroke"];
function ZV(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, YV);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-discount",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("line", {
    x1: 9,
    y1: 15,
    x2: 15,
    y2: 9
  }), e.createElement("circle", {
    cx: 9.5,
    cy: 9.5,
    r: .5,
    fill: "currentColor"
  }), e.createElement("circle", {
    cx: 14.5,
    cy: 14.5,
    r: .5,
    fill: "currentColor"
  }), e.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 9
  }));
}
var $V = ["size", "color", "stroke"];
function _V(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, $V);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-divide",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("circle", {
    cx: 12,
    cy: 6,
    r: 1,
    fill: "currentColor"
  }), e.createElement("circle", {
    cx: 12,
    cy: 18,
    r: 1,
    fill: "currentColor"
  }), e.createElement("line", {
    x1: 5,
    y1: 12,
    x2: 19,
    y2: 12
  }));
}
var eX = ["size", "color", "stroke"];
function tX(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, eX);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-dna-2-off",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M17 3v1c-.007 2.46 -.91 4.554 -2.705 6.281m-2.295 1.719c-3.328 1.99 -4.997 4.662 -5.008 8.014v1"
  }), e.createElement("path", {
    d: "M17 21.014v-1c-.004 -1.44 -.315 -2.755 -.932 -3.944m-4.068 -4.07c-1.903 -1.138 -3.263 -2.485 -4.082 -4.068"
  }), e.createElement("path", {
    d: "M8 4h9"
  }), e.createElement("path", {
    d: "M7 20h10"
  }), e.createElement("path", {
    d: "M12 8h4"
  }), e.createElement("path", {
    d: "M8 16h8"
  }), e.createElement("path", {
    d: "M3 3l18 18"
  }));
}
var oX = ["size", "color", "stroke"];
function rX(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, oX);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-dna-2",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M17 3v1c-.01 3.352 -1.68 6.023 -5.008 8.014c-3.328 1.99 3.336 -2.005 .008 -.014c-3.328 1.99 -4.997 4.662 -5.008 8.014v1"
  }), e.createElement("path", {
    d: "M17 21.014v-1c-.01 -3.352 -1.68 -6.023 -5.008 -8.014c-3.328 -1.99 3.336 2.005 .008 .014c-3.328 -1.991 -4.997 -4.662 -5.008 -8.014v-1"
  }), e.createElement("path", {
    d: "M7 4h10"
  }), e.createElement("path", {
    d: "M7 20h10"
  }), e.createElement("path", {
    d: "M8 8h8"
  }), e.createElement("path", {
    d: "M8 16h8"
  }));
}
var nX = ["size", "color", "stroke"];
function lX(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, nX);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-dna-off",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M16 12a3.898 3.898 0 0 0 -1.172 -2.828a4.027 4.027 0 0 0 -2.828 -1.172m-2.828 1.172a4 4 0 1 0 5.656 5.656"
  }), e.createElement("path", {
    d: "M9.172 20.485a4 4 0 1 0 -5.657 -5.657"
  }), e.createElement("path", {
    d: "M14.828 3.515a4 4 0 1 0 5.657 5.657"
  }), e.createElement("path", {
    d: "M3 3l18 18"
  }));
}
var aX = ["size", "color", "stroke"];
function iX(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, aX);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-dna",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M14.828 14.828a4 4 0 1 0 -5.656 -5.656a4 4 0 0 0 5.656 5.656z"
  }), e.createElement("path", {
    d: "M9.172 20.485a4 4 0 1 0 -5.657 -5.657"
  }), e.createElement("path", {
    d: "M14.828 3.515a4 4 0 0 0 5.657 5.657"
  }));
}
var cX = ["size", "color", "stroke"];
function sX(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, cX);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-dog-bowl",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M10 15l5.586 -5.585a2 2 0 1 1 3.414 -1.415a2 2 0 1 1 -1.413 3.414l-3.587 3.586"
  }), e.createElement("path", {
    d: "M12 13l-3.586 -3.585a2 2 0 1 0 -3.414 -1.415a2 2 0 1 0 1.413 3.414l3.587 3.586"
  }), e.createElement("path", {
    d: "M3 20h18c-.175 -1.671 -.046 -3.345 -2 -5h-14c-1.333 1 -2 2.667 -2 5z"
  }));
}
var hX = ["size", "color", "stroke"];
function dX(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, hX);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-dog",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M11 5h2"
  }), e.createElement("path", {
    d: "M19 12c-.667 5.333 -2.333 8 -5 8h-4c-2.667 0 -4.333 -2.667 -5 -8"
  }), e.createElement("path", {
    d: "M11 16c0 .667 .333 1 1 1s1 -.333 1 -1h-2z"
  }), e.createElement("path", {
    d: "M12 18v2"
  }), e.createElement("path", {
    d: "M10 11v.01"
  }), e.createElement("path", {
    d: "M14 11v.01"
  }), e.createElement("path", {
    d: "M5 4l6 .97l-6.238 6.688a1.021 1.021 0 0 1 -1.41 .111a0.953 .953 0 0 1 -.327 -.954l1.975 -6.815z"
  }), e.createElement("path", {
    d: "M19 4l-6 .97l6.238 6.688c.358 .408 .989 .458 1.41 .111a0.953 .953 0 0 0 .327 -.954l-1.975 -6.815z"
  }));
}
var vX = ["size", "color", "stroke"];
function mX(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, vX);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-door-enter",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M13 12v.01"
  }), e.createElement("path", {
    d: "M3 21h18"
  }), e.createElement("path", {
    d: "M5 21v-16a2 2 0 0 1 2 -2h6m4 10.5v7.5"
  }), e.createElement("path", {
    d: "M21 7h-7m3 -3l-3 3l3 3"
  }));
}
var kX = ["size", "color", "stroke"];
function wX(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, kX);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-door-exit",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M13 12v.01"
  }), e.createElement("path", {
    d: "M3 21h18"
  }), e.createElement("path", {
    d: "M5 21v-16a2 2 0 0 1 2 -2h7.5m2.5 10.5v7.5"
  }), e.createElement("path", {
    d: "M14 7h7m-3 -3l3 3l-3 3"
  }));
}
var pX = ["size", "color", "stroke"];
function EX(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, pX);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-door-off",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M3 21h18"
  }), e.createElement("path", {
    d: "M6 21v-15"
  }), e.createElement("path", {
    d: "M7.18 3.175c.25 -.112 .528 -.175 .82 -.175h8a2 2 0 0 1 2 2v9"
  }), e.createElement("path", {
    d: "M18 18v3"
  }), e.createElement("path", {
    d: "M3 3l18 18"
  }));
}
var uX = ["size", "color", "stroke"];
function gX(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, uX);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-door",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M14 12v.01"
  }), e.createElement("path", {
    d: "M3 21h18"
  }), e.createElement("path", {
    d: "M6 21v-16a2 2 0 0 1 2 -2h8a2 2 0 0 1 2 2v16"
  }));
}
var MX = ["size", "color", "stroke"];
function xX(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, MX);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-dots-circle-horizontal",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 9
  }), e.createElement("line", {
    x1: 8,
    y1: 12,
    x2: 8,
    y2: 12.01
  }), e.createElement("line", {
    x1: 12,
    y1: 12,
    x2: 12,
    y2: 12.01
  }), e.createElement("line", {
    x1: 16,
    y1: 12,
    x2: 16,
    y2: 12.01
  }));
}
var fX = ["size", "color", "stroke"];
function zX(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, fX);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-dots-diagonal-2",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("circle", {
    cx: 7,
    cy: 7,
    r: 1
  }), e.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 1
  }), e.createElement("circle", {
    cx: 17,
    cy: 17,
    r: 1
  }));
}
var bX = ["size", "color", "stroke"];
function LX(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, bX);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-dots-diagonal",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("circle", {
    cx: 7,
    cy: 17,
    r: 1
  }), e.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 1
  }), e.createElement("circle", {
    cx: 17,
    cy: 7,
    r: 1
  }));
}
var yX = ["size", "color", "stroke"];
function CX(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, yX);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-dots-vertical",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 1
  }), e.createElement("circle", {
    cx: 12,
    cy: 19,
    r: 1
  }), e.createElement("circle", {
    cx: 12,
    cy: 5,
    r: 1
  }));
}
var jX = ["size", "color", "stroke"];
function BX(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, jX);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-dots",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("circle", {
    cx: 5,
    cy: 12,
    r: 1
  }), e.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 1
  }), e.createElement("circle", {
    cx: 19,
    cy: 12,
    r: 1
  }));
}
var HX = ["size", "color", "stroke"];
function NX(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, HX);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-download-off",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M4 17v2a2 2 0 0 0 2 2h12a2 2 0 0 0 1.83 -1.19"
  }), e.createElement("path", {
    d: "M7 11l5 5l2.005 -2.005m1.994 -1.994l1.001 -1.001"
  }), e.createElement("path", {
    d: "M12 4v4m0 4v4"
  }), e.createElement("path", {
    d: "M3 3l18 18"
  }));
}
var WX = ["size", "color", "stroke"];
function qX(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, WX);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-download",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M4 17v2a2 2 0 0 0 2 2h12a2 2 0 0 0 2 -2v-2"
  }), e.createElement("polyline", {
    points: "7 11 12 16 17 11"
  }), e.createElement("line", {
    x1: 12,
    y1: 4,
    x2: 12,
    y2: 16
  }));
}
var OX = ["size", "color", "stroke"];
function PX(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, OX);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-drag-drop-2",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("rect", {
    x: 8,
    y: 8,
    width: 12,
    height: 12,
    rx: 2
  }), e.createElement("line", {
    x1: 4,
    y1: 4,
    x2: 4,
    y2: 4.01
  }), e.createElement("line", {
    x1: 8,
    y1: 4,
    x2: 8,
    y2: 4.01
  }), e.createElement("line", {
    x1: 12,
    y1: 4,
    x2: 12,
    y2: 4.01
  }), e.createElement("line", {
    x1: 16,
    y1: 4,
    x2: 16,
    y2: 4.01
  }), e.createElement("line", {
    x1: 4,
    y1: 8,
    x2: 4,
    y2: 8.01
  }), e.createElement("line", {
    x1: 4,
    y1: 12,
    x2: 4,
    y2: 12.01
  }), e.createElement("line", {
    x1: 4,
    y1: 16,
    x2: 4,
    y2: 16.01
  }));
}
var SX = ["size", "color", "stroke"];
function IX(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, SX);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-drag-drop",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M19 11v-2a2 2 0 0 0 -2 -2h-8a2 2 0 0 0 -2 2v8a2 2 0 0 0 2 2h2"
  }), e.createElement("path", {
    d: "M13 13l9 3l-4 2l-2 4l-3 -9"
  }), e.createElement("line", {
    x1: 3,
    y1: 3,
    x2: 3,
    y2: 3.01
  }), e.createElement("line", {
    x1: 7,
    y1: 3,
    x2: 7,
    y2: 3.01
  }), e.createElement("line", {
    x1: 11,
    y1: 3,
    x2: 11,
    y2: 3.01
  }), e.createElement("line", {
    x1: 15,
    y1: 3,
    x2: 15,
    y2: 3.01
  }), e.createElement("line", {
    x1: 3,
    y1: 7,
    x2: 3,
    y2: 7.01
  }), e.createElement("line", {
    x1: 3,
    y1: 11,
    x2: 3,
    y2: 11.01
  }), e.createElement("line", {
    x1: 3,
    y1: 15,
    x2: 3,
    y2: 15.01
  }));
}
var AX = ["size", "color", "stroke"];
function DX(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, AX);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-drone-off",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M14 14h-4v-4"
  }), e.createElement("path", {
    d: "M10 10l-3.5 -3.5"
  }), e.createElement("path", {
    d: "M9.957 5.95a3.503 3.503 0 0 0 -2.917 -2.91m-3.02 .989a3.5 3.5 0 0 0 1.98 5.936"
  }), e.createElement("path", {
    d: "M14 10l3.5 -3.5"
  }), e.createElement("path", {
    d: "M18 9.965a3.5 3.5 0 1 0 -3.966 -3.965"
  }), e.createElement("line", {
    x1: 14,
    y1: 14,
    x2: 17.5,
    y2: 17.5
  }), e.createElement("path", {
    d: "M14.035 18a3.5 3.5 0 0 0 5.936 1.98m.987 -3.026a3.503 3.503 0 0 0 -2.918 -2.913"
  }), e.createElement("line", {
    x1: 10,
    y1: 14,
    x2: 6.5,
    y2: 17.5
  }), e.createElement("path", {
    d: "M6 14.035a3.5 3.5 0 1 0 3.966 3.965"
  }), e.createElement("line", {
    x1: 3,
    y1: 3,
    x2: 21,
    y2: 21
  }));
}
var FX = ["size", "color", "stroke"];
function GX(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, FX);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-drone",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M10 10h4v4h-4z"
  }), e.createElement("line", {
    x1: 10,
    y1: 10,
    x2: 6.5,
    y2: 6.5
  }), e.createElement("path", {
    d: "M9.96 6a3.5 3.5 0 1 0 -3.96 3.96"
  }), e.createElement("path", {
    d: "M14 10l3.5 -3.5"
  }), e.createElement("path", {
    d: "M18 9.96a3.5 3.5 0 1 0 -3.96 -3.96"
  }), e.createElement("line", {
    x1: 14,
    y1: 14,
    x2: 17.5,
    y2: 17.5
  }), e.createElement("path", {
    d: "M14.04 18a3.5 3.5 0 1 0 3.96 -3.96"
  }), e.createElement("line", {
    x1: 10,
    y1: 14,
    x2: 6.5,
    y2: 17.5
  }), e.createElement("path", {
    d: "M6 14.04a3.5 3.5 0 1 0 3.96 3.96"
  }));
}
var JX = ["size", "color", "stroke"];
function KX(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, JX);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-drop-circle",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M10.07 15.34c1.115 .88 2.74 .88 3.855 0c1.115 -.88 1.398 -2.388 .671 -3.575l-2.596 -3.765l-2.602 3.765c-.726 1.187 -.443 2.694 .672 3.575z"
  }), e.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 9
  }));
}
var QX = ["size", "color", "stroke"];
function RX(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, QX);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-droplet-filled-2",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M6.8 11a6 6 0 1 0 10.396 0l-5.197 -8l-5.2 8z"
  }), e.createElement("path", {
    d: "M6 14h12"
  }), e.createElement("path", {
    d: "M7.305 17.695l3.695 -3.695"
  }), e.createElement("path", {
    d: "M10.26 19.74l5.74 -5.74l-5.74 5.74z"
  }));
}
var TX = ["size", "color", "stroke"];
function UX(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, TX);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-droplet-filled",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M6.8 11a6 6 0 1 0 10.396 0l-5.197 -8l-5.2 8z"
  }), e.createElement("path", {
    d: "M12 3v17"
  }), e.createElement("path", {
    d: "M12 12l3.544 -3.544"
  }), e.createElement("path", {
    d: "M12 17.3l5.558 -5.558"
  }));
}
var VX = ["size", "color", "stroke"];
function XX(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, VX);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-droplet-half-2",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M6.8 11a6 6 0 1 0 10.396 0l-5.197 -8l-5.2 8z"
  }), e.createElement("path", {
    d: "M6 14h12"
  }));
}
var YX = ["size", "color", "stroke"];
function ZX(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, YX);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-droplet-half",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M6.8 11a6 6 0 1 0 10.396 0l-5.197 -8l-5.2 8z"
  }), e.createElement("path", {
    d: "M12 3v17"
  }));
}
var $X = ["size", "color", "stroke"];
function _X(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, $X);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-droplet-off",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M8.454 8.458l-1.653 2.545a6 6 0 0 0 10.32 6.123"
  }), e.createElement("path", {
    d: "M18 14a5.971 5.971 0 0 0 -.803 -3l-5.197 -8l-1.968 3.03"
  }), e.createElement("path", {
    d: "M3 3l18 18"
  }));
}
var eY = ["size", "color", "stroke"];
function tY(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, eY);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-droplet",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M6.8 11a6 6 0 1 0 10.396 0l-5.197 -8l-5.2 8z"
  }));
}
var oY = ["size", "color", "stroke"];
function rY(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, oY);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-e-passport",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("rect", {
    x: 2,
    y: 5,
    width: 20,
    height: 14,
    rx: 1.999
  }), e.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 3
  }), e.createElement("path", {
    d: "M9 12h-7"
  }), e.createElement("path", {
    d: "M15 12h7"
  }));
}
var nY = ["size", "color", "stroke"];
function lY(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, nY);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-ear-off",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M6 10c0 -1.146 .277 -2.245 .78 -3.219m1.792 -2.208a7 7 0 0 1 10.428 9.027a10 10 0 0 1 -.633 .762m-2.045 1.96a8 8 0 0 0 -1.322 2.278a4.5 4.5 0 0 1 -6.8 1.4"
  }), e.createElement("path", {
    d: "M11.42 7.414a3 3 0 0 1 4.131 4.13"
  }), e.createElement("line", {
    x1: 3,
    y1: 3,
    x2: 21,
    y2: 21
  }));
}
var aY = ["size", "color", "stroke"];
function iY(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, aY);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-ear",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M6 10a7 7 0 1 1 13 3.6a10 10 0 0 1 -2 2a8 8 0 0 0 -2 3a4.5 4.5 0 0 1 -6.8 1.4"
  }), e.createElement("path", {
    d: "M10 10a3 3 0 1 1 5 2.2"
  }));
}
var cY = ["size", "color", "stroke"];
function sY(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, cY);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-ease-in-control-point",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M3 19c8 0 18 -16 18 -16"
  }), e.createElement("path", {
    d: "M17 19a2 2 0 1 0 4 0a2 2 0 0 0 -4 0z"
  }), e.createElement("path", {
    d: "M17 19h-2"
  }), e.createElement("path", {
    d: "M12 19h-2"
  }));
}
var hY = ["size", "color", "stroke"];
function dY(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, hY);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-ease-in-out-control-points",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M17 20a2 2 0 1 0 4 0a2 2 0 0 0 -4 0z"
  }), e.createElement("path", {
    d: "M17 20h-2"
  }), e.createElement("path", {
    d: "M7 4a2 2 0 1 1 -4 0a2 2 0 0 1 4 0z"
  }), e.createElement("path", {
    d: "M7 4h2"
  }), e.createElement("path", {
    d: "M14 4h-2"
  }), e.createElement("path", {
    d: "M12 20h-2"
  }), e.createElement("path", {
    d: "M3 20c8 0 10 -16 18 -16"
  }));
}
var vY = ["size", "color", "stroke"];
function mY(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, vY);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-ease-in-out",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M3 20c8 0 10 -16 18 -16"
  }));
}
var kY = ["size", "color", "stroke"];
function wY(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, kY);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-ease-in",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M3 20c8 0 18 -16 18 -16"
  }));
}
var pY = ["size", "color", "stroke"];
function EY(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, pY);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-ease-out-control-point",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M3 21s10 -16 18 -16"
  }), e.createElement("path", {
    d: "M7 5a2 2 0 1 1 -4 0a2 2 0 0 1 4 0z"
  }), e.createElement("path", {
    d: "M7 5h2"
  }), e.createElement("path", {
    d: "M14 5h-2"
  }));
}
var uY = ["size", "color", "stroke"];
function gY(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, uY);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-ease-out",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M3 20s10 -16 18 -16"
  }));
}
var MY = ["size", "color", "stroke"];
function xY(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, MY);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-edit-circle-off",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M10.507 10.498l-1.507 1.502v3h3l1.493 -1.498m2.002 -2.01l4.89 -4.907a2.1 2.1 0 0 0 -2.97 -2.97l-4.913 4.896"
  }), e.createElement("path", {
    d: "M16 5l3 3"
  }), e.createElement("path", {
    d: "M7.476 7.471a7.002 7.002 0 0 0 2.524 13.529a7.004 7.004 0 0 0 6.53 -4.474"
  }), e.createElement("path", {
    d: "M3 3l18 18"
  }));
}
var fY = ["size", "color", "stroke"];
function zY(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, fY);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-edit-circle",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M12 15l8.385 -8.415a2.1 2.1 0 0 0 -2.97 -2.97l-8.415 8.385v3h3z"
  }), e.createElement("path", {
    d: "M16 5l3 3"
  }), e.createElement("path", {
    d: "M9 7.07a7.002 7.002 0 0 0 1 13.93a7.002 7.002 0 0 0 6.929 -5.999"
  }));
}
var bY = ["size", "color", "stroke"];
function LY(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, bY);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-edit-off",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M7 7h-1a2 2 0 0 0 -2 2v9a2 2 0 0 0 2 2h9a2 2 0 0 0 2 -2v-1"
  }), e.createElement("path", {
    d: "M10.507 10.498l-1.507 1.502v3h3l1.493 -1.498m2.002 -2.01l4.89 -4.907a2.1 2.1 0 0 0 -2.97 -2.97l-4.913 4.896"
  }), e.createElement("path", {
    d: "M16 5l3 3"
  }), e.createElement("path", {
    d: "M3 3l18 18"
  }));
}
var yY = ["size", "color", "stroke"];
function CY(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, yY);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-edit",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M7 7h-1a2 2 0 0 0 -2 2v9a2 2 0 0 0 2 2h9a2 2 0 0 0 2 -2v-1"
  }), e.createElement("path", {
    d: "M20.385 6.585a2.1 2.1 0 0 0 -2.97 -2.97l-8.415 8.385v3h3l8.385 -8.415z"
  }), e.createElement("path", {
    d: "M16 5l3 3"
  }));
}
var jY = ["size", "color", "stroke"];
function BY(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, jY);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-egg-cracked",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M19 14.083c0 4.154 -2.966 6.74 -7 6.917c-4.2 .006 -7 -2.763 -7 -6.917c0 -5.538 3.5 -11.09 7 -11.083c3.5 .007 7 5.545 7 11.083z"
  }), e.createElement("path", {
    d: "M12 3l-1.5 5l3.5 2.5l-2 3.5"
  }));
}
var HY = ["size", "color", "stroke"];
function NY(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, HY);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-egg-fried",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 3
  }), e.createElement("path", {
    d: "M14 3a5 5 0 0 1 4.872 6.13a3 3 0 0 1 .178 5.681a3 3 0 1 1 -4.684 3.626a5 5 0 1 1 -8.662 -4.996a5 5 0 1 1 4.645 -8.856a4.982 4.982 0 0 1 3.651 -1.585z"
  }));
}
var WY = ["size", "color", "stroke"];
function qY(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, WY);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-egg-off",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M17.927 17.934c-1.211 1.858 -3.351 2.953 -5.927 3.066c-4.2 .006 -7 -2.763 -7 -6.917c0 -2.568 .753 -5.14 1.91 -7.158"
  }), e.createElement("path", {
    d: "M8.642 4.628c1.034 -1.02 2.196 -1.63 3.358 -1.628c3.5 .007 7 5.545 7 11.083c0 .298 -.015 .587 -.045 .868"
  }), e.createElement("path", {
    d: "M3 3l18 18"
  }));
}
var OY = ["size", "color", "stroke"];
function PY(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, OY);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-egg",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M19 14.083c0 4.154 -2.966 6.74 -7 6.917c-4.2 .006 -7 -2.763 -7 -6.917c0 -5.538 3.5 -11.09 7 -11.083c3.5 .007 7 5.545 7 11.083z"
  }));
}
var SY = ["size", "color", "stroke"];
function IY(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, SY);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-eggs",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M13 22c-3 0 -4.868 -2.118 -4.995 -5c-.005 -3 1.995 -5 4.995 -5c4 0 8.01 2.5 8.005 5c-.005 2.5 -4.005 5 -8.005 5z"
  }), e.createElement("path", {
    d: "M8 18c-3.03 -.196 -5 -2.309 -5 -5.38c0 -4.307 2.75 -8.625 5.5 -8.62c2.614 .005 5.248 3.915 5.5 8"
  }));
}
var AY = ["size", "color", "stroke"];
function DY(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, AY);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-elevator-off",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M8 4h10a1 1 0 0 1 1 1v10m0 4a1 1 0 0 1 -1 1h-12a1 1 0 0 1 -1 -1v-14"
  }), e.createElement("path", {
    d: "M12 8l2 2"
  }), e.createElement("path", {
    d: "M10 14l2 2l2 -2"
  }), e.createElement("path", {
    d: "M3 3l18 18"
  }));
}
var FY = ["size", "color", "stroke"];
function GY(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, FY);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-elevator",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("rect", {
    x: 5,
    y: 4,
    width: 14,
    height: 16,
    rx: 1
  }), e.createElement("path", {
    d: "M10 10l2 -2l2 2"
  }), e.createElement("path", {
    d: "M10 14l2 2l2 -2"
  }));
}
var JY = ["size", "color", "stroke"];
function KY(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, JY);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-emergency-bed",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("circle", {
    cx: 16,
    cy: 18,
    r: 2
  }), e.createElement("circle", {
    cx: 8,
    cy: 18,
    r: 2
  }), e.createElement("path", {
    d: "M4 8l2.1 2.8a3 3 0 0 0 2.4 1.2h11.5"
  }), e.createElement("path", {
    d: "M10 6h4"
  }), e.createElement("path", {
    d: "M12 4v4"
  }), e.createElement("path", {
    d: "M12 12v2l-2.5 2.5"
  }), e.createElement("path", {
    d: "M14.5 16.5l-2.5 -2.5"
  }));
}
var QY = ["size", "color", "stroke"];
function RY(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, QY);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-empathize-off",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M12 8a2.5 2.5 0 1 0 -2.5 -2.5"
  }), e.createElement("path", {
    d: "M12.317 12.315l-.317 .317l-.728 -.727a3.088 3.088 0 1 0 -4.367 4.367l5.095 5.096l4.689 -4.69m1.324 -2.673a3.087 3.087 0 0 0 -3.021 -3.018"
  }), e.createElement("path", {
    d: "M3 3l18 18"
  }));
}
var TY = ["size", "color", "stroke"];
function UY(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, TY);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-empathize",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("circle", {
    cx: 12,
    cy: 5.5,
    r: 2.5
  }), e.createElement("path", {
    d: "M12 21.368l5.095 -5.096a3.088 3.088 0 1 0 -4.367 -4.367l-.728 .727l-.728 -.727a3.088 3.088 0 1 0 -4.367 4.367l5.095 5.096z"
  }));
}
var VY = ["size", "color", "stroke"];
function XY(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, VY);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-emphasis",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M16 5h-8v10h8m-1 -5h-7"
  }), e.createElement("line", {
    x1: 6,
    y1: 20,
    x2: 6,
    y2: 20.01
  }), e.createElement("line", {
    x1: 10,
    y1: 20,
    x2: 10,
    y2: 20.01
  }), e.createElement("line", {
    x1: 14,
    y1: 20,
    x2: 14,
    y2: 20.01
  }), e.createElement("line", {
    x1: 18,
    y1: 20,
    x2: 18,
    y2: 20.01
  }));
}
var YY = ["size", "color", "stroke"];
function ZY(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, YY);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-engine-off",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M3 10v6"
  }), e.createElement("path", {
    d: "M12 5v3"
  }), e.createElement("path", {
    d: "M10 5h4"
  }), e.createElement("path", {
    d: "M5 13h-2"
  }), e.createElement("path", {
    d: "M16 16h-1v2a1 1 0 0 1 -1 1h-3.465a1 1 0 0 1 -.832 -.445l-1.703 -2.555h-2v-6h2l.99 -.99m3.01 -1.01h1.382a1 1 0 0 1 .894 .553l1.448 2.894a1 1 0 0 0 .894 .553h1.382v-2h2a1 1 0 0 1 1 1v6"
  }), e.createElement("path", {
    d: "M3 3l18 18"
  }));
}
var $Y = ["size", "color", "stroke"];
function _Y(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, $Y);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-engine",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M3 10v6"
  }), e.createElement("path", {
    d: "M12 5v3"
  }), e.createElement("path", {
    d: "M10 5h4"
  }), e.createElement("path", {
    d: "M5 13h-2"
  }), e.createElement("path", {
    d: "M6 10h2l2 -2h3.382a1 1 0 0 1 .894 .553l1.448 2.894a1 1 0 0 0 .894 .553h1.382v-2h2a1 1 0 0 1 1 1v6a1 1 0 0 1 -1 1h-2v-2h-3v2a1 1 0 0 1 -1 1h-3.465a1 1 0 0 1 -.832 -.445l-1.703 -2.555h-2v-6z"
  }));
}
var eZ = ["size", "color", "stroke"];
function tZ(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, eZ);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-equal-double",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M3 10h7"
  }), e.createElement("path", {
    d: "M3 14h7"
  }), e.createElement("path", {
    d: "M14 10h7"
  }), e.createElement("path", {
    d: "M14 14h7"
  }));
}
var oZ = ["size", "color", "stroke"];
function rZ(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, oZ);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-equal-not",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M5 10h14"
  }), e.createElement("path", {
    d: "M5 14h14"
  }), e.createElement("path", {
    d: "M5 19l14 -14"
  }));
}
var nZ = ["size", "color", "stroke"];
function lZ(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, nZ);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-equal",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M5 10h14"
  }), e.createElement("path", {
    d: "M5 14h14"
  }));
}
var aZ = ["size", "color", "stroke"];
function iZ(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, aZ);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-eraser-off",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M3 3l18 18"
  }), e.createElement("path", {
    d: "M19 20h-10.5l-4.21 -4.3a1 1 0 0 1 0 -1.41l4.995 -4.993m2.009 -2.01l2.997 -2.996a1 1 0 0 1 1.41 0l5 5a1 1 0 0 1 0 1.41c-1.417 1.431 -2.406 2.432 -2.97 3m-2.02 2.043l-4.211 4.256"
  }), e.createElement("path", {
    d: "M18 13.3l-6.3 -6.3"
  }));
}
var cZ = ["size", "color", "stroke"];
function sZ(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, cZ);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-eraser",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M19 20h-10.5l-4.21 -4.3a1 1 0 0 1 0 -1.41l10 -10a1 1 0 0 1 1.41 0l5 5a1 1 0 0 1 0 1.41l-9.2 9.3"
  }), e.createElement("path", {
    d: "M18 13.3l-6.3 -6.3"
  }));
}
var hZ = ["size", "color", "stroke"];
function dZ(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, hZ);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-error-404-off",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M3 7v4a1 1 0 0 0 1 1h3"
  }), e.createElement("path", {
    d: "M7 7v10"
  }), e.createElement("path", {
    d: "M10 10v6a1 1 0 0 0 1 1h2a1 1 0 0 0 1 -1v-2m0 -4v-2a1 1 0 0 0 -1 -1h-2"
  }), e.createElement("path", {
    d: "M17 7v4a1 1 0 0 0 1 1h3"
  }), e.createElement("path", {
    d: "M21 7v10"
  }), e.createElement("path", {
    d: "M3 3l18 18"
  }));
}
var vZ = ["size", "color", "stroke"];
function mZ(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, vZ);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-error-404",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M3 7v4a1 1 0 0 0 1 1h3"
  }), e.createElement("path", {
    d: "M7 7v10"
  }), e.createElement("path", {
    d: "M10 8v8a1 1 0 0 0 1 1h2a1 1 0 0 0 1 -1v-8a1 1 0 0 0 -1 -1h-2a1 1 0 0 0 -1 1z"
  }), e.createElement("path", {
    d: "M17 7v4a1 1 0 0 0 1 1h3"
  }), e.createElement("path", {
    d: "M21 7v10"
  }));
}
var kZ = ["size", "color", "stroke"];
function wZ(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, kZ);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-exchange-off",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("circle", {
    cx: 5,
    cy: 18,
    r: 2
  }), e.createElement("circle", {
    cx: 19,
    cy: 6,
    r: 2
  }), e.createElement("path", {
    d: "M19 8v5c0 .594 -.104 1.164 -.294 1.692m-1.692 2.298a4.978 4.978 0 0 1 -3.014 1.01h-3l3 -3"
  }), e.createElement("path", {
    d: "M14 21l-3 -3"
  }), e.createElement("path", {
    d: "M5 16v-5c0 -1.632 .782 -3.082 1.992 -3.995m3.008 -1.005h3l-3 -3"
  }), e.createElement("path", {
    d: "M11.501 7.499l1.499 -1.499"
  }), e.createElement("path", {
    d: "M3 3l18 18"
  }));
}
var pZ = ["size", "color", "stroke"];
function EZ(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, pZ);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-exchange",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("circle", {
    cx: 5,
    cy: 18,
    r: 2
  }), e.createElement("circle", {
    cx: 19,
    cy: 6,
    r: 2
  }), e.createElement("path", {
    d: "M19 8v5a5 5 0 0 1 -5 5h-3l3 -3m0 6l-3 -3"
  }), e.createElement("path", {
    d: "M5 16v-5a5 5 0 0 1 5 -5h3l-3 -3m0 6l3 -3"
  }));
}
var uZ = ["size", "color", "stroke"];
function gZ(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, uZ);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-exclamation-circle",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 9
  }), e.createElement("path", {
    d: "M12 9v4"
  }), e.createElement("path", {
    d: "M12 16v.01"
  }));
}
var MZ = ["size", "color", "stroke"];
function xZ(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, MZ);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-exclamation-mark-off",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M12 19v.01"
  }), e.createElement("path", {
    d: "M12 15v-3m0 -4v-3"
  }), e.createElement("path", {
    d: "M3 3l18 18"
  }));
}
var fZ = ["size", "color", "stroke"];
function zZ(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, fZ);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-exclamation-mark",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M12 19v.01"
  }), e.createElement("path", {
    d: "M12 15v-10"
  }));
}
var bZ = ["size", "color", "stroke"];
function LZ(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, bZ);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-explicit-off",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M14 8h-2m-2 2v6h4"
  }), e.createElement("path", {
    d: "M8 4h10a2 2 0 0 1 2 2v10m-.586 3.414a1.994 1.994 0 0 1 -1.414 .586h-12a2 2 0 0 1 -2 -2v-12c0 -.547 .22 -1.043 .576 -1.405"
  }), e.createElement("path", {
    d: "M12 12h-2"
  }), e.createElement("path", {
    d: "M3 3l18 18"
  }));
}
var yZ = ["size", "color", "stroke"];
function CZ(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, yZ);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-explicit",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("rect", {
    x: 4,
    y: 4,
    width: 16,
    height: 16,
    rx: 1
  }), e.createElement("path", {
    d: "M14 8h-4v8h4"
  }), e.createElement("path", {
    d: "M14 12h-4"
  }));
}
var jZ = ["size", "color", "stroke"];
function BZ(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, jZ);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-exposure-0",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M12 19a4 4 0 0 0 4 -4v-6a4 4 0 1 0 -8 0v6a4 4 0 0 0 4 4z"
  }));
}
var HZ = ["size", "color", "stroke"];
function NZ(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, HZ);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-exposure-minus-1",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M3 12h6"
  }), e.createElement("path", {
    d: "M18 19v-14l-4 4"
  }));
}
var WZ = ["size", "color", "stroke"];
function qZ(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, WZ);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-exposure-minus-2",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M12 9a4 4 0 1 1 8 0c0 1.098 -.564 2.025 -1.159 2.815l-6.841 7.185h8"
  }), e.createElement("path", {
    d: "M3 12h6"
  }));
}
var OZ = ["size", "color", "stroke"];
function PZ(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, OZ);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-exposure-off",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M4.6 19.4l7.4 -7.4m2 -2l5.4 -5.4"
  }), e.createElement("path", {
    d: "M8 4h10a2 2 0 0 1 2 2v10m-.586 3.414a1.994 1.994 0 0 1 -1.414 .586h-12a2 2 0 0 1 -2 -2v-12c0 -.547 .22 -1.043 .576 -1.405"
  }), e.createElement("path", {
    d: "M7 9h2m0 0v2"
  }), e.createElement("path", {
    d: "M13 16h3"
  }), e.createElement("path", {
    d: "M3 3l18 18"
  }));
}
var SZ = ["size", "color", "stroke"];
function IZ(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, SZ);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-exposure-plus-1",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M3 12h6"
  }), e.createElement("path", {
    d: "M6 9v6"
  }), e.createElement("path", {
    d: "M18 19v-14l-4 4"
  }));
}
var AZ = ["size", "color", "stroke"];
function DZ(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, AZ);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-exposure-plus-2",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M12 9a4 4 0 1 1 8 0c0 1.098 -.564 2.025 -1.159 2.815l-6.841 7.185h8"
  }), e.createElement("path", {
    d: "M3 12h6"
  }), e.createElement("path", {
    d: "M6 9v6"
  }));
}
var FZ = ["size", "color", "stroke"];
function GZ(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, FZ);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-exposure",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("rect", {
    x: 4,
    y: 4,
    width: 16,
    height: 16,
    rx: 2
  }), e.createElement("line", {
    x1: 4.6,
    y1: 19.4,
    x2: 19.4,
    y2: 4.6
  }), e.createElement("path", {
    d: "M7 9h4m-2 -2v4"
  }), e.createElement("line", {
    x1: 13,
    y1: 16,
    x2: 17,
    y2: 16
  }));
}
var JZ = ["size", "color", "stroke"];
function KZ(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, JZ);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-external-link-off",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M7 7h-1a2 2 0 0 0 -2 2v9a2 2 0 0 0 2 2h9a2 2 0 0 0 2 -2v-1"
  }), e.createElement("path", {
    d: "M10 14l1.996 -1.996m2.007 -2.007l5.997 -5.997"
  }), e.createElement("path", {
    d: "M15 4h5v5"
  }), e.createElement("path", {
    d: "M3 3l18 18"
  }));
}
var QZ = ["size", "color", "stroke"];
function RZ(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, QZ);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-external-link",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M11 7h-5a2 2 0 0 0 -2 2v9a2 2 0 0 0 2 2h9a2 2 0 0 0 2 -2v-5"
  }), e.createElement("line", {
    x1: 10,
    y1: 14,
    x2: 20,
    y2: 4
  }), e.createElement("polyline", {
    points: "15 4 20 4 20 9"
  }));
}
var TZ = ["size", "color", "stroke"];
function UZ(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, TZ);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-eye-check",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 2
  }), e.createElement("path", {
    d: "M12 19c-4 0 -7.333 -2.333 -10 -7c2.667 -4.667 6 -7 10 -7s7.333 2.333 10 7c-.42 .736 -.858 1.414 -1.311 2.033"
  }), e.createElement("path", {
    d: "M15 19l2 2l4 -4"
  }));
}
var VZ = ["size", "color", "stroke"];
function XZ(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, VZ);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-eye-off",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("line", {
    x1: 3,
    y1: 3,
    x2: 21,
    y2: 21
  }), e.createElement("path", {
    d: "M10.584 10.587a2 2 0 0 0 2.828 2.83"
  }), e.createElement("path", {
    d: "M9.363 5.365a9.466 9.466 0 0 1 2.637 -.365c4 0 7.333 2.333 10 7c-.778 1.361 -1.612 2.524 -2.503 3.488m-2.14 1.861c-1.631 1.1 -3.415 1.651 -5.357 1.651c-4 0 -7.333 -2.333 -10 -7c1.369 -2.395 2.913 -4.175 4.632 -5.341"
  }));
}
var YZ = ["size", "color", "stroke"];
function ZZ(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, YZ);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-eye-table",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M8.003 18.003h-.011"
  }), e.createElement("path", {
    d: "M12.003 18.002h-.011"
  }), e.createElement("path", {
    d: "M16.003 18.002h-.011"
  }), e.createElement("path", {
    d: "M4 3h16"
  }), e.createElement("path", {
    d: "M5 3v17a1 1 0 0 0 1 1h12a1 1 0 0 0 1 -1v-17"
  }), e.createElement("path", {
    d: "M14 7h-4"
  }), e.createElement("path", {
    d: "M9 15h1"
  }), e.createElement("path", {
    d: "M14 15h1"
  }), e.createElement("path", {
    d: "M12 11v-4"
  }));
}
var $Z = ["size", "color", "stroke"];
function _Z(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, $Z);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-eye",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 2
  }), e.createElement("path", {
    d: "M22 12c-2.667 4.667 -6 7 -10 7s-7.333 -2.333 -10 -7c2.667 -4.667 6 -7 10 -7s7.333 2.333 10 7"
  }));
}
var e$ = ["size", "color", "stroke"];
function t$(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, e$);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-eyeglass-2",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M8 4h-2l-3 10v2.5"
  }), e.createElement("path", {
    d: "M16 4h2l3 10v2.5"
  }), e.createElement("line", {
    x1: 10,
    y1: 16,
    x2: 14,
    y2: 16
  }), e.createElement("circle", {
    cx: 17.5,
    cy: 16.5,
    r: 3.5
  }), e.createElement("circle", {
    cx: 6.5,
    cy: 16.5,
    r: 3.5
  }));
}
var o$ = ["size", "color", "stroke"];
function r$(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, o$);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-eyeglass-off",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M5.536 5.546l-2.536 8.454"
  }), e.createElement("path", {
    d: "M16 4h2l3 10"
  }), e.createElement("path", {
    d: "M10 16h4"
  }), e.createElement("path", {
    d: "M19.426 19.423a3.5 3.5 0 0 1 -5.426 -2.923v-2.5m4 0h3v2.5c0 .157 -.01 .312 -.03 .463"
  }), e.createElement("path", {
    d: "M10 16.5a3.5 3.5 0 0 1 -7 0v-2.5h7v2.5"
  }), e.createElement("path", {
    d: "M3 3l18 18"
  }));
}
var n$ = ["size", "color", "stroke"];
function l$(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, n$);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-eyeglass",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M8 4h-2l-3 10"
  }), e.createElement("path", {
    d: "M16 4h2l3 10"
  }), e.createElement("line", {
    x1: 10,
    y1: 16,
    x2: 14,
    y2: 16
  }), e.createElement("path", {
    d: "M21 16.5a3.5 3.5 0 0 1 -7 0v-2.5h7v2.5"
  }), e.createElement("path", {
    d: "M10 16.5a3.5 3.5 0 0 1 -7 0v-2.5h7v2.5"
  }));
}
var a$ = ["size", "color", "stroke"];
function i$(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, a$);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-face-id-error",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M4 8v-2a2 2 0 0 1 2 -2h2"
  }), e.createElement("path", {
    d: "M4 16v2a2 2 0 0 0 2 2h2"
  }), e.createElement("path", {
    d: "M16 4h2a2 2 0 0 1 2 2v2"
  }), e.createElement("path", {
    d: "M16 20h2a2 2 0 0 0 2 -2v-2"
  }), e.createElement("path", {
    d: "M9 10h.01"
  }), e.createElement("path", {
    d: "M15 10h.01"
  }), e.createElement("path", {
    d: "M9.5 15.05a3.5 3.5 0 0 1 5 0"
  }));
}
var c$ = ["size", "color", "stroke"];
function s$(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, c$);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-face-id",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M4 8v-2a2 2 0 0 1 2 -2h2"
  }), e.createElement("path", {
    d: "M4 16v2a2 2 0 0 0 2 2h2"
  }), e.createElement("path", {
    d: "M16 4h2a2 2 0 0 1 2 2v2"
  }), e.createElement("path", {
    d: "M16 20h2a2 2 0 0 0 2 -2v-2"
  }), e.createElement("line", {
    x1: 9,
    y1: 10,
    x2: 9.01,
    y2: 10
  }), e.createElement("line", {
    x1: 15,
    y1: 10,
    x2: 15.01,
    y2: 10
  }), e.createElement("path", {
    d: "M9.5 15a3.5 3.5 0 0 0 5 0"
  }));
}
var h$ = ["size", "color", "stroke"];
function d$(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, h$);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-face-mask-off",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M5.002 14.5h-.222c-1.535 0 -2.778 -1.12 -2.778 -2.5s1.243 -2.5 2.778 -2.5h.222"
  }), e.createElement("path", {
    d: "M19.002 14.5h.222c1.534 0 2.778 -1.12 2.778 -2.5s-1.244 -2.5 -2.778 -2.5h-.222"
  }), e.createElement("path", {
    d: "M9 10h1m4 0h1"
  }), e.createElement("path", {
    d: "M9 14h5"
  }), e.createElement("path", {
    d: "M19 15v-6.49a2 2 0 0 0 -1.45 -1.923l-5 -1.429a2 2 0 0 0 -1.1 0l-1.788 .511m-3.118 .891l-.094 .027a2 2 0 0 0 -1.45 1.922v6.982a2 2 0 0 0 1.45 1.923l5 1.429a2 2 0 0 0 1.1 0l4.899 -1.4"
  }), e.createElement("path", {
    d: "M3 3l18 18"
  }));
}
var v$ = ["size", "color", "stroke"];
function m$(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, v$);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-face-mask",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M5.002 14.5h-.222c-1.535 0 -2.778 -1.12 -2.778 -2.5s1.243 -2.5 2.778 -2.5h.222"
  }), e.createElement("path", {
    d: "M19.002 14.5h.222c1.534 0 2.778 -1.12 2.778 -2.5s-1.244 -2.5 -2.778 -2.5h-.222"
  }), e.createElement("path", {
    d: "M9 10h6"
  }), e.createElement("path", {
    d: "M9 14h6"
  }), e.createElement("path", {
    d: "M12.55 18.843l5 -1.429a2 2 0 0 0 1.45 -1.923v-6.981a2 2 0 0 0 -1.45 -1.923l-5 -1.429a2 2 0 0 0 -1.1 0l-5 1.429a2 2 0 0 0 -1.45 1.922v6.982a2 2 0 0 0 1.45 1.923l5 1.429a2 2 0 0 0 1.1 0z"
  }));
}
var k$ = ["size", "color", "stroke"];
function w$(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, k$);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-fall",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M11 21l1 -5l-1 -4l-3 -4h4l3 -3"
  }), e.createElement("path", {
    d: "M6 16l-1 -4l3 -4"
  }), e.createElement("circle", {
    cx: 6,
    cy: 5,
    r: 1
  }), e.createElement("path", {
    d: "M13.5 12h2.5l4 2"
  }));
}
var p$ = ["size", "color", "stroke"];
function E$(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, p$);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-feather-off",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M4 20l8 -8"
  }), e.createElement("path", {
    d: "M14 5v5h5"
  }), e.createElement("path", {
    d: "M9 11v4h4"
  }), e.createElement("path", {
    d: "M6 13v5h5"
  }), e.createElement("path", {
    d: "M6 13l3.502 -3.502m2.023 -2.023l2.475 -2.475"
  }), e.createElement("path", {
    d: "M19 10c.638 -.636 1 -1.515 1 -2.486a3.515 3.515 0 0 0 -3.517 -3.514c-.97 0 -1.847 .367 -2.483 1"
  }), e.createElement("path", {
    d: "M11 18l3.499 -3.499m2.008 -2.008l2.493 -2.493"
  }), e.createElement("path", {
    d: "M3 3l18 18"
  }));
}
var u$ = ["size", "color", "stroke"];
function g$(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, u$);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-feather",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M4 20l10 -10m0 -5v5h5m-9 -1v5h5m-9 -1v5h5m-5 -5l4 -4l4 -4"
  }), e.createElement("path", {
    d: "M19 10c.638 -.636 1 -1.515 1 -2.486a3.515 3.515 0 0 0 -3.517 -3.514c-.97 0 -1.847 .367 -2.483 1m-3 13l4 -4l4 -4"
  }));
}
var M$ = ["size", "color", "stroke"];
function x$(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, M$);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-fence-off",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M12 12h-8v4h12m4 0v-4h-4"
  }), e.createElement("path", {
    d: "M6 16v4h4v-4"
  }), e.createElement("path", {
    d: "M10 12v-2m0 -4l-2 -2m-2 2v6"
  }), e.createElement("path", {
    d: "M14 16v4h4v-2"
  }), e.createElement("path", {
    d: "M18 12v-6l-2 -2l-2 2v4"
  }), e.createElement("path", {
    d: "M3 3l18 18"
  }));
}
var f$ = ["size", "color", "stroke"];
function z$(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, f$);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-fence",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M4 12v4h16v-4z"
  }), e.createElement("path", {
    d: "M6 16v4h4v-4m0 -4v-6l-2 -2l-2 2v6"
  }), e.createElement("path", {
    d: "M14 16v4h4v-4m0 -4v-6l-2 -2l-2 2v6"
  }));
}
var b$ = ["size", "color", "stroke"];
function L$(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, b$);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-fidget-spinner",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M10 17a3 3 0 1 1 -1.543 -2.623l2.087 -3.754a3 3 0 0 1 1.456 -5.623a3 3 0 0 1 1.457 5.623l2.087 3.754a3 3 0 1 1 -1.538 2.8l-.006 -.177h-4z"
  }), e.createElement("path", {
    d: "M17 17v.01"
  }), e.createElement("path", {
    d: "M7 17v.01"
  }), e.createElement("path", {
    d: "M12 8v.01"
  }));
}
var y$ = ["size", "color", "stroke"];
function C$(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, y$);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-file-3d",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M14 3v4a1 1 0 0 0 1 1h4"
  }), e.createElement("path", {
    d: "M17 21h-10a2 2 0 0 1 -2 -2v-14a2 2 0 0 1 2 -2h7l5 5v11a2 2 0 0 1 -2 2z"
  }), e.createElement("path", {
    d: "M12 13.5l4 -1.5"
  }), e.createElement("path", {
    d: "M8 11.846l4 1.654v4.5l4 -1.846v-4.308l-4 -1.846z"
  }), e.createElement("path", {
    d: "M8 12v4.2l4 1.8"
  }));
}
var j$ = ["size", "color", "stroke"];
function B$(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, j$);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-file-alert",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M14 3v4a1 1 0 0 0 1 1h4"
  }), e.createElement("path", {
    d: "M17 21h-10a2 2 0 0 1 -2 -2v-14a2 2 0 0 1 2 -2h7l5 5v11a2 2 0 0 1 -2 2z"
  }), e.createElement("line", {
    x1: 12,
    y1: 17,
    x2: 12.01,
    y2: 17
  }), e.createElement("line", {
    x1: 12,
    y1: 11,
    x2: 12,
    y2: 14
  }));
}
var H$ = ["size", "color", "stroke"];
function N$(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, H$);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-file-analytics",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M14 3v4a1 1 0 0 0 1 1h4"
  }), e.createElement("path", {
    d: "M17 21h-10a2 2 0 0 1 -2 -2v-14a2 2 0 0 1 2 -2h7l5 5v11a2 2 0 0 1 -2 2z"
  }), e.createElement("line", {
    x1: 9,
    y1: 17,
    x2: 9,
    y2: 12
  }), e.createElement("line", {
    x1: 12,
    y1: 17,
    x2: 12,
    y2: 16
  }), e.createElement("line", {
    x1: 15,
    y1: 17,
    x2: 15,
    y2: 14
  }));
}
var W$ = ["size", "color", "stroke"];
function q$(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, W$);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-file-arrow-left",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M14 3v4a1 1 0 0 0 1 1h4"
  }), e.createElement("path", {
    d: "M17 21h-10a2 2 0 0 1 -2 -2v-14a2 2 0 0 1 2 -2h7l5 5v11a2 2 0 0 1 -2 2z"
  }), e.createElement("path", {
    d: "M15 15h-6"
  }), e.createElement("path", {
    d: "M11.5 17.5l-2.5 -2.5l2.5 -2.5"
  }));
}
var O$ = ["size", "color", "stroke"];
function P$(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, O$);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-file-arrow-right",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M14 3v4a1 1 0 0 0 1 1h4"
  }), e.createElement("path", {
    d: "M17 21h-10a2 2 0 0 1 -2 -2v-14a2 2 0 0 1 2 -2h7l5 5v11a2 2 0 0 1 -2 2z"
  }), e.createElement("path", {
    d: "M9 15h6"
  }), e.createElement("path", {
    d: "M12.5 17.5l2.5 -2.5l-2.5 -2.5"
  }));
}
var S$ = ["size", "color", "stroke"];
function I$(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, S$);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-file-barcode",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M14 3v4a1 1 0 0 0 1 1h4"
  }), e.createElement("path", {
    d: "M17 21h-10a2 2 0 0 1 -2 -2v-14a2 2 0 0 1 2 -2h7l5 5v11a2 2 0 0 1 -2 2z"
  }), e.createElement("path", {
    d: "M8 13h1v3h-1z"
  }), e.createElement("path", {
    d: "M12 13v3"
  }), e.createElement("path", {
    d: "M15 13h1v3h-1z"
  }));
}
var A$ = ["size", "color", "stroke"];
function D$(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, A$);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-file-broken",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M14 3v4a1 1 0 0 0 1 1h4"
  }), e.createElement("path", {
    d: "M5 7v-2a2 2 0 0 1 2 -2h7l5 5v2"
  }), e.createElement("path", {
    d: "M19 19a2 2 0 0 1 -2 2h-10a2 2 0 0 1 -2 -2"
  }), e.createElement("path", {
    d: "M5 16h.01"
  }), e.createElement("path", {
    d: "M5 13h.01"
  }), e.createElement("path", {
    d: "M5 10h.01"
  }), e.createElement("path", {
    d: "M19 13h.01"
  }), e.createElement("path", {
    d: "M19 16h.01"
  }));
}
var F$ = ["size", "color", "stroke"];
function G$(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, F$);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-file-certificate",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M14 3v4a1 1 0 0 0 1 1h4"
  }), e.createElement("path", {
    d: "M5 8v-3a2 2 0 0 1 2 -2h7l5 5v11a2 2 0 0 1 -2 2h-5"
  }), e.createElement("circle", {
    cx: 6,
    cy: 14,
    r: 3
  }), e.createElement("path", {
    d: "M4.5 17l-1.5 5l3 -1.5l3 1.5l-1.5 -5"
  }));
}
var J$ = ["size", "color", "stroke"];
function K$(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, J$);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-file-chart",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M14 3v4a1 1 0 0 0 1 1h4"
  }), e.createElement("path", {
    d: "M17 21h-10a2 2 0 0 1 -2 -2v-14a2 2 0 0 1 2 -2h7l5 5v11a2 2 0 0 1 -2 2z"
  }), e.createElement("path", {
    d: "M12 10v4h4"
  }), e.createElement("circle", {
    cx: 12,
    cy: 14,
    r: 4
  }));
}
var Q$ = ["size", "color", "stroke"];
function R$(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Q$);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-file-check",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M14 3v4a1 1 0 0 0 1 1h4"
  }), e.createElement("path", {
    d: "M17 21h-10a2 2 0 0 1 -2 -2v-14a2 2 0 0 1 2 -2h7l5 5v11a2 2 0 0 1 -2 2z"
  }), e.createElement("path", {
    d: "M9 15l2 2l4 -4"
  }));
}
var T$ = ["size", "color", "stroke"];
function U$(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, T$);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-file-code-2",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M10 12h-1v5h1"
  }), e.createElement("path", {
    d: "M14 12h1v5h-1"
  }), e.createElement("path", {
    d: "M14 3v4a1 1 0 0 0 1 1h4"
  }), e.createElement("path", {
    d: "M17 21h-10a2 2 0 0 1 -2 -2v-14a2 2 0 0 1 2 -2h7l5 5v11a2 2 0 0 1 -2 2z"
  }));
}
var V$ = ["size", "color", "stroke"];
function X$(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, V$);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-file-code",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M14 3v4a1 1 0 0 0 1 1h4"
  }), e.createElement("path", {
    d: "M17 21h-10a2 2 0 0 1 -2 -2v-14a2 2 0 0 1 2 -2h7l5 5v11a2 2 0 0 1 -2 2z"
  }), e.createElement("path", {
    d: "M10 13l-1 2l1 2"
  }), e.createElement("path", {
    d: "M14 13l1 2l-1 2"
  }));
}
var Y$ = ["size", "color", "stroke"];
function Z$(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Y$);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-file-database",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("ellipse", {
    cx: 12,
    cy: 12.75,
    rx: 4,
    ry: 1.75
  }), e.createElement("path", {
    d: "M8 12.5v3.75c0 .966 1.79 1.75 4 1.75s4 -.784 4 -1.75v-3.75"
  }), e.createElement("path", {
    d: "M14 3v4a1 1 0 0 0 1 1h4"
  }), e.createElement("path", {
    d: "M17 21h-10a2 2 0 0 1 -2 -2v-14a2 2 0 0 1 2 -2h7l5 5v11a2 2 0 0 1 -2 2z"
  }));
}
var $$ = ["size", "color", "stroke"];
function _$(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, $$);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-file-delta",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M14 3v4a1 1 0 0 0 1 1h4"
  }), e.createElement("path", {
    d: "M17 21h-10a2 2 0 0 1 -2 -2v-14a2 2 0 0 1 2 -2h7l5 5v11a2 2 0 0 1 -2 2z"
  }), e.createElement("path", {
    d: "M9 17h6l-3 -6z"
  }));
}
var e_ = ["size", "color", "stroke"];
function t_(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, e_);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-file-description",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M14 3v4a1 1 0 0 0 1 1h4"
  }), e.createElement("path", {
    d: "M17 21h-10a2 2 0 0 1 -2 -2v-14a2 2 0 0 1 2 -2h7l5 5v11a2 2 0 0 1 -2 2z"
  }), e.createElement("path", {
    d: "M9 17h6"
  }), e.createElement("path", {
    d: "M9 13h6"
  }));
}
var o_ = ["size", "color", "stroke"];
function r_(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, o_);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-file-diff",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M14 3v4a1 1 0 0 0 1 1h4"
  }), e.createElement("path", {
    d: "M17 21h-10a2 2 0 0 1 -2 -2v-14a2 2 0 0 1 2 -2h7l5 5v11a2 2 0 0 1 -2 2z"
  }), e.createElement("line", {
    x1: 12,
    y1: 10,
    x2: 12,
    y2: 14
  }), e.createElement("line", {
    x1: 10,
    y1: 12,
    x2: 14,
    y2: 12
  }), e.createElement("line", {
    x1: 10,
    y1: 17,
    x2: 14,
    y2: 17
  }));
}
var n_ = ["size", "color", "stroke"];
function l_(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, n_);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-file-digit",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M14 3v4a1 1 0 0 0 1 1h4"
  }), e.createElement("rect", {
    x: 9,
    y: 12,
    width: 3,
    height: 5,
    rx: 1
  }), e.createElement("path", {
    d: "M17 21h-10a2 2 0 0 1 -2 -2v-14a2 2 0 0 1 2 -2h7l5 5v11a2 2 0 0 1 -2 2z"
  }), e.createElement("path", {
    d: "M15 12v5"
  }));
}
var a_ = ["size", "color", "stroke"];
function i_(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, a_);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-file-dislike",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("rect", {
    x: 3,
    y: 14,
    width: 3,
    height: 5,
    rx: 1
  }), e.createElement("path", {
    d: "M6 15a1 1 0 0 1 1 -1h3.756a1 1 0 0 1 .958 .713l1.2 3c.09 .303 .133 .63 -.056 .884c-.188 .254 -.542 .403 -.858 .403h-2v2.467a1.1 1.1 0 0 1 -2.015 .61l-1.985 -3.077v-4z"
  }), e.createElement("path", {
    d: "M14 3v4a1 1 0 0 0 1 1h4"
  }), e.createElement("path", {
    d: "M5 11v-6a2 2 0 0 1 2 -2h7l5 5v11a2 2 0 0 1 -2 2h-2.5"
  }));
}
var c_ = ["size", "color", "stroke"];
function s_(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, c_);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-file-dollar",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M14 3v4a1 1 0 0 0 1 1h4"
  }), e.createElement("path", {
    d: "M17 21h-10a2 2 0 0 1 -2 -2v-14a2 2 0 0 1 2 -2h7l5 5v11a2 2 0 0 1 -2 2z"
  }), e.createElement("path", {
    d: "M14 11h-2.5a1.5 1.5 0 0 0 0 3h1a1.5 1.5 0 0 1 0 3h-2.5"
  }), e.createElement("path", {
    d: "M12 17v1m0 -8v1"
  }));
}
var h_ = ["size", "color", "stroke"];
function d_(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, h_);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-file-dots",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M14 3v4a1 1 0 0 0 1 1h4"
  }), e.createElement("path", {
    d: "M17 21h-10a2 2 0 0 1 -2 -2v-14a2 2 0 0 1 2 -2h7l5 5v11a2 2 0 0 1 -2 2z"
  }), e.createElement("path", {
    d: "M9 14v.01"
  }), e.createElement("path", {
    d: "M12 14v.01"
  }), e.createElement("path", {
    d: "M15 14v.01"
  }));
}
var v_ = ["size", "color", "stroke"];
function m_(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, v_);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-file-download",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M14 3v4a1 1 0 0 0 1 1h4"
  }), e.createElement("path", {
    d: "M17 21h-10a2 2 0 0 1 -2 -2v-14a2 2 0 0 1 2 -2h7l5 5v11a2 2 0 0 1 -2 2z"
  }), e.createElement("path", {
    d: "M12 17v-6"
  }), e.createElement("path", {
    d: "M9.5 14.5l2.5 2.5l2.5 -2.5"
  }));
}
var k_ = ["size", "color", "stroke"];
function w_(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, k_);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-file-euro",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M14 3v4a1 1 0 0 0 1 1h4"
  }), e.createElement("path", {
    d: "M17 21h-10a2 2 0 0 1 -2 -2v-14a2 2 0 0 1 2 -2h7l5 5v11a2 2 0 0 1 -2 2z"
  }), e.createElement("path", {
    d: "M12 14h-3"
  }), e.createElement("path", {
    d: "M14.004 11.172a3 3 0 1 0 -.001 5.656"
  }));
}
var p_ = ["size", "color", "stroke"];
function E_(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, p_);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-file-export",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M14 3v4a1 1 0 0 0 1 1h4"
  }), e.createElement("path", {
    d: "M11.5 21h-4.5a2 2 0 0 1 -2 -2v-14a2 2 0 0 1 2 -2h7l5 5v5m-5 6h7m-3 -3l3 3l-3 3"
  }));
}
var u_ = ["size", "color", "stroke"];
function g_(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, u_);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-file-function",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M14 3v4a1 1 0 0 0 1 1h4"
  }), e.createElement("path", {
    d: "M17 21h-10a2 2 0 0 1 -2 -2v-14a2 2 0 0 1 2 -2h7l5 5v11a2 2 0 0 1 -2 2z"
  }), e.createElement("path", {
    d: "M10.5 17h.333c.474 0 .87 -.323 .916 -.746l.502 -4.508c.047 -.423 .443 -.746 .916 -.746h.333"
  }), e.createElement("path", {
    d: "M10.5 14h3"
  }));
}
var M_ = ["size", "color", "stroke"];
function x_(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, M_);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-file-horizontal",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M16 5v4a1 1 0 0 0 1 1h4"
  }), e.createElement("path", {
    d: "M3 7v10a2 2 0 0 0 2 2h14a2 2 0 0 0 2 -2v-7l-5 -5h-11a2 2 0 0 0 -2 2z"
  }));
}
var f_ = ["size", "color", "stroke"];
function z_(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, f_);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-file-import",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M14 3v4a1 1 0 0 0 1 1h4"
  }), e.createElement("path", {
    d: "M5 13v-8a2 2 0 0 1 2 -2h7l5 5v11a2 2 0 0 1 -2 2h-5.5m-9.5 -2h7m-3 -3l3 3l-3 3"
  }));
}
var b_ = ["size", "color", "stroke"];
function L_(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, b_);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-file-infinity",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M15.536 17.586a2.123 2.123 0 0 0 -2.929 0a1.951 1.951 0 0 0 0 2.828c.809 .781 2.12 .781 2.929 0c.809 -.781 -.805 .778 .004 -.003l1.46 -1.41l1.46 -1.419"
  }), e.createElement("path", {
    d: "M15.54 17.582l1.46 1.42l1.46 1.41c.809 .78 -.805 -.779 .004 .002s2.12 .781 2.929 0a1.951 1.951 0 0 0 0 -2.828a2.123 2.123 0 0 0 -2.929 0"
  }), e.createElement("path", {
    d: "M14 3v4a1 1 0 0 0 1 1h4"
  }), e.createElement("path", {
    d: "M9.5 21h-2.5a2 2 0 0 1 -2 -2v-14a2 2 0 0 1 2 -2h7l5 5v6"
  }));
}
var y_ = ["size", "color", "stroke"];
function C_(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, y_);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-file-info",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M14 3v4a1 1 0 0 0 1 1h4"
  }), e.createElement("path", {
    d: "M17 21h-10a2 2 0 0 1 -2 -2v-14a2 2 0 0 1 2 -2h7l5 5v11a2 2 0 0 1 -2 2z"
  }), e.createElement("path", {
    d: "M11 14h1v4h1"
  }), e.createElement("path", {
    d: "M12 11h.01"
  }));
}
var j_ = ["size", "color", "stroke"];
function B_(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, j_);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-file-invoice",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M14 3v4a1 1 0 0 0 1 1h4"
  }), e.createElement("path", {
    d: "M17 21h-10a2 2 0 0 1 -2 -2v-14a2 2 0 0 1 2 -2h7l5 5v11a2 2 0 0 1 -2 2z"
  }), e.createElement("line", {
    x1: 9,
    y1: 7,
    x2: 10,
    y2: 7
  }), e.createElement("line", {
    x1: 9,
    y1: 13,
    x2: 15,
    y2: 13
  }), e.createElement("line", {
    x1: 13,
    y1: 17,
    x2: 15,
    y2: 17
  }));
}
var H_ = ["size", "color", "stroke"];
function N_(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, H_);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-file-lambda",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M14 3v4a1 1 0 0 0 1 1h4"
  }), e.createElement("path", {
    d: "M17 21h-10a2 2 0 0 1 -2 -2v-14a2 2 0 0 1 2 -2h7l5 5v11a2 2 0 0 1 -2 2z"
  }), e.createElement("path", {
    d: "M10 17l2 -3"
  }), e.createElement("path", {
    d: "M15 17c-2.5 0 -2.5 -6 -5 -6"
  }));
}
var W_ = ["size", "color", "stroke"];
function q_(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, W_);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-file-like",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("rect", {
    x: 3,
    y: 16,
    width: 3,
    height: 5,
    rx: 1
  }), e.createElement("path", {
    d: "M6 20a1 1 0 0 0 1 1h3.756a1 1 0 0 0 .958 -.713l1.2 -3c.09 -.303 .133 -.63 -.056 -.884c-.188 -.254 -.542 -.403 -.858 -.403h-2v-2.467a1.1 1.1 0 0 0 -2.015 -.61l-1.985 3.077v4z"
  }), e.createElement("path", {
    d: "M14 3v4a1 1 0 0 0 1 1h4"
  }), e.createElement("path", {
    d: "M5 12.1v-7.1a2 2 0 0 1 2 -2h7l5 5v11a2 2 0 0 1 -2 2h-2.3"
  }));
}
var O_ = ["size", "color", "stroke"];
function P_(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, O_);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-file-minus",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M14 3v4a1 1 0 0 0 1 1h4"
  }), e.createElement("path", {
    d: "M17 21h-10a2 2 0 0 1 -2 -2v-14a2 2 0 0 1 2 -2h7l5 5v11a2 2 0 0 1 -2 2z"
  }), e.createElement("line", {
    x1: 9,
    y1: 14,
    x2: 15,
    y2: 14
  }));
}
var S_ = ["size", "color", "stroke"];
function I_(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, S_);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-file-music",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M14 3v4a1 1 0 0 0 1 1h4"
  }), e.createElement("path", {
    d: "M17 21h-10a2 2 0 0 1 -2 -2v-14a2 2 0 0 1 2 -2h7l5 5v11a2 2 0 0 1 -2 2z"
  }), e.createElement("circle", {
    cx: 11,
    cy: 16,
    r: 1
  }), e.createElement("polyline", {
    points: "12 16 12 11 14 12"
  }));
}
var A_ = ["size", "color", "stroke"];
function D_(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, A_);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-file-off",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("line", {
    x1: 3,
    y1: 3,
    x2: 21,
    y2: 21
  }), e.createElement("path", {
    d: "M7 3h7l5 5v7m0 4a2 2 0 0 1 -2 2h-10a2 2 0 0 1 -2 -2v-14"
  }));
}
var F_ = ["size", "color", "stroke"];
function G_(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, F_);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-file-orientation",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M14 3v4a1 1 0 0 0 1 1h4"
  }), e.createElement("path", {
    d: "M10 21h-3a2 2 0 0 1 -2 -2v-14a2 2 0 0 1 2 -2h7l5 5v2"
  }), e.createElement("path", {
    d: "M13 20h5a2 2 0 0 0 2 -2v-5"
  }), e.createElement("path", {
    d: "M15 22l-2 -2l2 -2"
  }), e.createElement("path", {
    d: "M18 15l2 -2l2 2"
  }));
}
var J_ = ["size", "color", "stroke"];
function K_(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, J_);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-file-pencil",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M14 3v4a1 1 0 0 0 1 1h4"
  }), e.createElement("path", {
    d: "M17 21h-10a2 2 0 0 1 -2 -2v-14a2 2 0 0 1 2 -2h7l5 5v11a2 2 0 0 1 -2 2z"
  }), e.createElement("path", {
    d: "M10 18l5 -5a1.414 1.414 0 0 0 -2 -2l-5 5v2h2z"
  }));
}
var Q_ = ["size", "color", "stroke"];
function R_(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Q_);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-file-percent",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M10 17l4 -4"
  }), e.createElement("path", {
    d: "M14 3v4a1 1 0 0 0 1 1h4"
  }), e.createElement("path", {
    d: "M17 21h-10a2 2 0 0 1 -2 -2v-14a2 2 0 0 1 2 -2h7l5 5v11a2 2 0 0 1 -2 2z"
  }), e.createElement("path", {
    d: "M10 13h.01"
  }), e.createElement("path", {
    d: "M14 17h.01"
  }));
}
var T_ = ["size", "color", "stroke"];
function U_(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, T_);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-file-phone",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M14 3v4a1 1 0 0 0 1 1h4"
  }), e.createElement("path", {
    d: "M17 21h-10a2 2 0 0 1 -2 -2v-14a2 2 0 0 1 2 -2h7l5 5v11a2 2 0 0 1 -2 2z"
  }), e.createElement("path", {
    d: "M9 12a0.5 .5 0 0 0 1 0v-1a0.5 .5 0 0 0 -1 0v1a5 5 0 0 0 5 5h1a0.5 .5 0 0 0 0 -1h-1a0.5 .5 0 0 0 0 1"
  }));
}
var V_ = ["size", "color", "stroke"];
function X_(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, V_);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-file-plus",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M14 3v4a1 1 0 0 0 1 1h4"
  }), e.createElement("path", {
    d: "M17 21h-10a2 2 0 0 1 -2 -2v-14a2 2 0 0 1 2 -2h7l5 5v11a2 2 0 0 1 -2 2z"
  }), e.createElement("line", {
    x1: 12,
    y1: 11,
    x2: 12,
    y2: 17
  }), e.createElement("line", {
    x1: 9,
    y1: 14,
    x2: 15,
    y2: 14
  }));
}
var Y_ = ["size", "color", "stroke"];
function Z_(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Y_);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-file-power",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M14 3v4a1 1 0 0 0 1 1h4"
  }), e.createElement("path", {
    d: "M17 21h-10a2 2 0 0 1 -2 -2v-14a2 2 0 0 1 2 -2h7l5 5v11a2 2 0 0 1 -2 2z"
  }), e.createElement("path", {
    d: "M12 11l-2 3h4l-2 3"
  }));
}
var $_ = ["size", "color", "stroke"];
function __(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, $_);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-file-report",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("circle", {
    cx: 17,
    cy: 17,
    r: 4
  }), e.createElement("path", {
    d: "M17 13v4h4"
  }), e.createElement("path", {
    d: "M12 3v4a1 1 0 0 0 1 1h4"
  }), e.createElement("path", {
    d: "M11.5 21h-6.5a2 2 0 0 1 -2 -2v-14a2 2 0 0 1 2 -2h7l5 5v2m0 3v4"
  }));
}
var e0 = ["size", "color", "stroke"];
function t0(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, e0);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-file-rss",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M14 3v4a1 1 0 0 0 1 1h4"
  }), e.createElement("path", {
    d: "M17 21h-10a2 2 0 0 1 -2 -2v-14a2 2 0 0 1 2 -2h7l5 5v11a2 2 0 0 1 -2 2z"
  }), e.createElement("path", {
    d: "M12 17a3 3 0 0 0 -3 -3"
  }), e.createElement("path", {
    d: "M15 17a6 6 0 0 0 -6 -6"
  }), e.createElement("path", {
    d: "M9 17h.01"
  }));
}
var o0 = ["size", "color", "stroke"];
function r0(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, o0);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-file-scissors",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M14 3v4a1 1 0 0 0 1 1h4"
  }), e.createElement("path", {
    d: "M17 21h-10a2 2 0 0 1 -2 -2v-14a2 2 0 0 1 2 -2h7l5 5v11a2 2 0 0 1 -2 2z"
  }), e.createElement("circle", {
    cx: 15,
    cy: 17,
    r: 1
  }), e.createElement("circle", {
    cx: 9,
    cy: 17,
    r: 1
  }), e.createElement("path", {
    d: "M9 17l6 -6"
  }), e.createElement("path", {
    d: "M15 17l-6 -6"
  }));
}
var n0 = ["size", "color", "stroke"];
function l0(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, n0);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-file-search",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M14 3v4a1 1 0 0 0 1 1h4"
  }), e.createElement("path", {
    d: "M12 21h-5a2 2 0 0 1 -2 -2v-14a2 2 0 0 1 2 -2h7l5 5v4.5"
  }), e.createElement("circle", {
    cx: 16.5,
    cy: 17.5,
    r: 2.5
  }), e.createElement("line", {
    x1: 18.5,
    y1: 19.5,
    x2: 21,
    y2: 22
  }));
}
var a0 = ["size", "color", "stroke"];
function i0(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, a0);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-file-settings",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("circle", {
    cx: 12,
    cy: 14,
    r: 2
  }), e.createElement("path", {
    d: "M12 10.5v1.5"
  }), e.createElement("path", {
    d: "M12 16v1.5"
  }), e.createElement("path", {
    d: "M15.031 12.25l-1.299 .75"
  }), e.createElement("path", {
    d: "M10.268 15l-1.3 .75"
  }), e.createElement("path", {
    d: "M15 15.803l-1.285 -.773"
  }), e.createElement("path", {
    d: "M10.285 12.97l-1.285 -.773"
  }), e.createElement("path", {
    d: "M14 3v4a1 1 0 0 0 1 1h4"
  }), e.createElement("path", {
    d: "M17 21h-10a2 2 0 0 1 -2 -2v-14a2 2 0 0 1 2 -2h7l5 5v11a2 2 0 0 1 -2 2z"
  }));
}
var c0 = ["size", "color", "stroke"];
function s0(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, c0);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-file-shredder",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M14 3v4a1 1 0 0 0 1 1h4"
  }), e.createElement("path", {
    d: "M5 12v-7a2 2 0 0 1 2 -2h7l5 5v4"
  }), e.createElement("line", {
    x1: 3,
    y1: 12,
    x2: 21,
    y2: 12
  }), e.createElement("line", {
    x1: 6,
    y1: 16,
    x2: 6,
    y2: 18
  }), e.createElement("line", {
    x1: 10,
    y1: 16,
    x2: 10,
    y2: 22
  }), e.createElement("line", {
    x1: 14,
    y1: 16,
    x2: 14,
    y2: 18
  }), e.createElement("line", {
    x1: 18,
    y1: 16,
    x2: 18,
    y2: 20
  }));
}
var h0 = ["size", "color", "stroke"];
function d0(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, h0);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-file-signal",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M14 3v4a1 1 0 0 0 1 1h4"
  }), e.createElement("path", {
    d: "M17 21h-10a2 2 0 0 1 -2 -2v-14a2 2 0 0 1 2 -2h7l5 5v11a2 2 0 0 1 -2 2z"
  }), e.createElement("path", {
    d: "M12 14v.01"
  }), e.createElement("path", {
    d: "M9.525 11.525a3.5 3.5 0 0 0 0 4.95m4.95 0a3.5 3.5 0 0 0 0 -4.95"
  }));
}
var v0 = ["size", "color", "stroke"];
function m0(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, v0);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-file-spreadsheet",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M14 3v4a1 1 0 0 0 1 1h4"
  }), e.createElement("path", {
    d: "M17 21h-10a2 2 0 0 1 -2 -2v-14a2 2 0 0 1 2 -2h7l5 5v11a2 2 0 0 1 -2 2z"
  }), e.createElement("path", {
    d: "M8 11h8v7h-8z"
  }), e.createElement("path", {
    d: "M8 15h8"
  }), e.createElement("path", {
    d: "M11 11v7"
  }));
}
var k0 = ["size", "color", "stroke"];
function w0(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, k0);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-file-stack",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M14 3v4a1 1 0 0 0 1 1h4"
  }), e.createElement("path", {
    d: "M5 12v-7a2 2 0 0 1 2 -2h7l5 5v4"
  }), e.createElement("path", {
    d: "M5 21h14"
  }), e.createElement("path", {
    d: "M5 18h14"
  }), e.createElement("path", {
    d: "M5 15h14"
  }));
}
var p0 = ["size", "color", "stroke"];
function E0(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, p0);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-file-star",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M14 3v4a1 1 0 0 0 1 1h4"
  }), e.createElement("path", {
    d: "M17 21h-10a2 2 0 0 1 -2 -2v-14a2 2 0 0 1 2 -2h7l5 5v11a2 2 0 0 1 -2 2z"
  }), e.createElement("path", {
    d: "M11.8 16.817l-2.172 1.138a0.392 .392 0 0 1 -.568 -.41l.415 -2.411l-1.757 -1.707a0.389 .389 0 0 1 .217 -.665l2.428 -.352l1.086 -2.193a0.392 .392 0 0 1 .702 0l1.086 2.193l2.428 .352a0.39 .39 0 0 1 .217 .665l-1.757 1.707l.414 2.41a0.39 .39 0 0 1 -.567 .411l-2.172 -1.138z"
  }));
}
var u0 = ["size", "color", "stroke"];
function g0(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, u0);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-file-symlink",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M4 21v-4a3 3 0 0 1 3 -3h5"
  }), e.createElement("path", {
    d: "M9 17l3 -3l-3 -3"
  }), e.createElement("path", {
    d: "M14 3v4a1 1 0 0 0 1 1h4"
  }), e.createElement("path", {
    d: "M5 11v-6a2 2 0 0 1 2 -2h7l5 5v11a2 2 0 0 1 -2 2h-9.5"
  }));
}
var M0 = ["size", "color", "stroke"];
function x0(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, M0);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-file-text",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M14 3v4a1 1 0 0 0 1 1h4"
  }), e.createElement("path", {
    d: "M17 21h-10a2 2 0 0 1 -2 -2v-14a2 2 0 0 1 2 -2h7l5 5v11a2 2 0 0 1 -2 2z"
  }), e.createElement("line", {
    x1: 9,
    y1: 9,
    x2: 10,
    y2: 9
  }), e.createElement("line", {
    x1: 9,
    y1: 13,
    x2: 15,
    y2: 13
  }), e.createElement("line", {
    x1: 9,
    y1: 17,
    x2: 15,
    y2: 17
  }));
}
var f0 = ["size", "color", "stroke"];
function z0(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, f0);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-file-time",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M14 3v4a1 1 0 0 0 1 1h4"
  }), e.createElement("path", {
    d: "M17 21h-10a2 2 0 0 1 -2 -2v-14a2 2 0 0 1 2 -2h7l5 5v11a2 2 0 0 1 -2 2z"
  }), e.createElement("circle", {
    cx: 12,
    cy: 14,
    r: 4
  }), e.createElement("path", {
    d: "M12 12.496v1.504l1 1"
  }));
}
var b0 = ["size", "color", "stroke"];
function L0(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, b0);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-file-typography",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M14 3v4a1 1 0 0 0 1 1h4"
  }), e.createElement("path", {
    d: "M17 21h-10a2 2 0 0 1 -2 -2v-14a2 2 0 0 1 2 -2h7l5 5v11a2 2 0 0 1 -2 2z"
  }), e.createElement("path", {
    d: "M11 18h2"
  }), e.createElement("path", {
    d: "M12 18v-7"
  }), e.createElement("path", {
    d: "M9 12v-1h6v1"
  }));
}
var y0 = ["size", "color", "stroke"];
function C0(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, y0);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-file-unknown",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M14 3v4a1 1 0 0 0 1 1h4"
  }), e.createElement("path", {
    d: "M17 21h-10a2 2 0 0 1 -2 -2v-14a2 2 0 0 1 2 -2h7l5 5v11a2 2 0 0 1 -2 2z"
  }), e.createElement("path", {
    d: "M12 17v.01"
  }), e.createElement("path", {
    d: "M12 14a1.5 1.5 0 1 0 -1.14 -2.474"
  }));
}
var j0 = ["size", "color", "stroke"];
function B0(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, j0);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-file-upload",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M14 3v4a1 1 0 0 0 1 1h4"
  }), e.createElement("path", {
    d: "M17 21h-10a2 2 0 0 1 -2 -2v-14a2 2 0 0 1 2 -2h7l5 5v11a2 2 0 0 1 -2 2z"
  }), e.createElement("path", {
    d: "M12 11v6"
  }), e.createElement("path", {
    d: "M9.5 13.5l2.5 -2.5l2.5 2.5"
  }));
}
var H0 = ["size", "color", "stroke"];
function N0(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, H0);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-file-vector",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M14 3v4a1 1 0 0 0 1 1h4"
  }), e.createElement("circle", {
    cx: 9.5,
    cy: 16.5,
    r: 1.5
  }), e.createElement("circle", {
    cx: 14.5,
    cy: 12.5,
    r: 1.5
  }), e.createElement("path", {
    d: "M17 21h-10a2 2 0 0 1 -2 -2v-14a2 2 0 0 1 2 -2h7l5 5v11a2 2 0 0 1 -2 2z"
  }), e.createElement("path", {
    d: "M9.5 15a2.5 2.5 0 0 1 2.5 -2.5h1"
  }));
}
var W0 = ["size", "color", "stroke"];
function q0(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, W0);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-file-x",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M14 3v4a1 1 0 0 0 1 1h4"
  }), e.createElement("path", {
    d: "M17 21h-10a2 2 0 0 1 -2 -2v-14a2 2 0 0 1 2 -2h7l5 5v11a2 2 0 0 1 -2 2z"
  }), e.createElement("path", {
    d: "M10 12l4 4m0 -4l-4 4"
  }));
}
var O0 = ["size", "color", "stroke"];
function P0(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, O0);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-file-zip",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M6 20.735a2 2 0 0 1 -1 -1.735v-14a2 2 0 0 1 2 -2h7l5 5v11a2 2 0 0 1 -2 2h-1"
  }), e.createElement("path", {
    d: "M11 17a2 2 0 0 1 2 2v2a1 1 0 0 1 -1 1h-2a1 1 0 0 1 -1 -1v-2a2 2 0 0 1 2 -2z"
  }), e.createElement("line", {
    x1: 11,
    y1: 5,
    x2: 10,
    y2: 5
  }), e.createElement("line", {
    x1: 13,
    y1: 7,
    x2: 12,
    y2: 7
  }), e.createElement("line", {
    x1: 11,
    y1: 9,
    x2: 10,
    y2: 9
  }), e.createElement("line", {
    x1: 13,
    y1: 11,
    x2: 12,
    y2: 11
  }), e.createElement("line", {
    x1: 11,
    y1: 13,
    x2: 10,
    y2: 13
  }), e.createElement("line", {
    x1: 13,
    y1: 15,
    x2: 12,
    y2: 15
  }));
}
var S0 = ["size", "color", "stroke"];
function I0(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, S0);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-file",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M14 3v4a1 1 0 0 0 1 1h4"
  }), e.createElement("path", {
    d: "M17 21h-10a2 2 0 0 1 -2 -2v-14a2 2 0 0 1 2 -2h7l5 5v11a2 2 0 0 1 -2 2z"
  }));
}
var A0 = ["size", "color", "stroke"];
function D0(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, A0);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-files-off",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M15 3v4a1 1 0 0 0 1 1h4"
  }), e.createElement("path", {
    d: "M17 17h-6a2 2 0 0 1 -2 -2v-6m0 -4a2 2 0 0 1 2 -2h4l5 5v7c0 .294 -.063 .572 -.177 .823"
  }), e.createElement("path", {
    d: "M16 17v2a2 2 0 0 1 -2 2h-7a2 2 0 0 1 -2 -2v-10a2 2 0 0 1 2 -2"
  }), e.createElement("line", {
    x1: 3,
    y1: 3,
    x2: 21,
    y2: 21
  }));
}
var F0 = ["size", "color", "stroke"];
function G0(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, F0);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-files",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M15 3v4a1 1 0 0 0 1 1h4"
  }), e.createElement("path", {
    d: "M18 17h-7a2 2 0 0 1 -2 -2v-10a2 2 0 0 1 2 -2h4l5 5v7a2 2 0 0 1 -2 2z"
  }), e.createElement("path", {
    d: "M16 17v2a2 2 0 0 1 -2 2h-7a2 2 0 0 1 -2 -2v-10a2 2 0 0 1 2 -2h2"
  }));
}
var J0 = ["size", "color", "stroke"];
function K0(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, J0);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-filter-off",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("line", {
    x1: 3,
    y1: 3,
    x2: 21,
    y2: 21
  }), e.createElement("path", {
    d: "M9 5h9.5a1 1 0 0 1 .5 1.5l-4.049 4.454m-.951 3.046v5l-4 -3v-4l-5 -5.5a1 1 0 0 1 .18 -1.316"
  }));
}
var Q0 = ["size", "color", "stroke"];
function R0(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Q0);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-filter",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M5.5 5h13a1 1 0 0 1 .5 1.5l-5 5.5l0 7l-4 -3l0 -4l-5 -5.5a1 1 0 0 1 .5 -1.5"
  }));
}
var T0 = ["size", "color", "stroke"];
function U0(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, T0);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-fingerprint-off",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M18.9 7a8 8 0 0 1 1.1 5v1a6 6 0 0 0 .8 3"
  }), e.createElement("path", {
    d: "M8 11c0 -.848 .264 -1.634 .713 -2.28m2.4 -1.621a4 4 0 0 1 4.887 3.901l-.001 1"
  }), e.createElement("path", {
    d: "M12 12v1a14 14 0 0 0 2.5 8"
  }), e.createElement("path", {
    d: "M8 15a18 18 0 0 0 1.8 6"
  }), e.createElement("path", {
    d: "M4.9 19a22 22 0 0 1 -.9 -7v-1a8 8 0 0 1 1.854 -5.143m2.176 -1.825a8 8 0 0 1 7.97 .018"
  }), e.createElement("path", {
    d: "M3 3l18 18"
  }));
}
var V0 = ["size", "color", "stroke"];
function X0(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, V0);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-fingerprint",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M18.9 7a8 8 0 0 1 1.1 5v1a6 6 0 0 0 .8 3"
  }), e.createElement("path", {
    d: "M8 11a4 4 0 0 1 8 0v1a10 10 0 0 0 2 6"
  }), e.createElement("path", {
    d: "M12 11v2a14 14 0 0 0 2.5 8"
  }), e.createElement("path", {
    d: "M8 15a18 18 0 0 0 1.8 6"
  }), e.createElement("path", {
    d: "M4.9 19a22 22 0 0 1 -.9 -7v-1a8 8 0 0 1 12 -6.95"
  }));
}
var Y0 = ["size", "color", "stroke"];
function Z0(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Y0);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-fire-hydrant-off",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M5 21h14"
  }), e.createElement("path", {
    d: "M17 21v-4m2 -2v-2a1 1 0 0 0 -1 -1h-1v-4a5 5 0 0 0 -8.533 -3.538m-1.387 2.638a5.03 5.03 0 0 0 -.08 .9v4h-1a1 1 0 0 0 -1 1v2a1 1 0 0 0 1 1h1v5"
  }), e.createElement("path", {
    d: "M12 12a2 2 0 1 0 2 2"
  }), e.createElement("path", {
    d: "M6 8h2m4 0h6"
  }), e.createElement("path", {
    d: "M3 3l18 18"
  }));
}
var $0 = ["size", "color", "stroke"];
function _0(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, $0);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-fire-hydrant",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M5 21h14"
  }), e.createElement("path", {
    d: "M17 21v-5h1a1 1 0 0 0 1 -1v-2a1 1 0 0 0 -1 -1h-1v-4a5 5 0 0 0 -10 0v4h-1a1 1 0 0 0 -1 1v2a1 1 0 0 0 1 1h1v5"
  }), e.createElement("circle", {
    cx: 12,
    cy: 14,
    r: 2
  }), e.createElement("path", {
    d: "M6 8h12"
  }));
}
var e2 = ["size", "color", "stroke"];
function t2(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, e2);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-firetruck",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("circle", {
    cx: 5,
    cy: 17,
    r: 2
  }), e.createElement("circle", {
    cx: 17,
    cy: 17,
    r: 2
  }), e.createElement("path", {
    d: "M7 18h8m4 0h2v-6a5 5 0 0 0 -5 -5h-1l1.5 5h4.5"
  }), e.createElement("path", {
    d: "M12 18v-11h3"
  }), e.createElement("polyline", {
    points: "3 17 3 12 12 12"
  }), e.createElement("line", {
    x1: 3,
    y1: 9,
    x2: 21,
    y2: 3
  }), e.createElement("line", {
    x1: 6,
    y1: 12,
    x2: 6,
    y2: 8
  }));
}
var o2 = ["size", "color", "stroke"];
function r2(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, o2);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-first-aid-kit-off",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M8.595 4.577a1.994 1.994 0 0 1 1.405 -.577h4a2 2 0 0 1 2 2v2"
  }), e.createElement("path", {
    d: "M12 8h6a2 2 0 0 1 2 2v6m-.576 3.405a1.994 1.994 0 0 1 -1.424 .595h-12a2 2 0 0 1 -2 -2v-8a2 2 0 0 1 2 -2h2"
  }), e.createElement("path", {
    d: "M10 14h4"
  }), e.createElement("path", {
    d: "M12 12v4"
  }), e.createElement("path", {
    d: "M3 3l18 18"
  }));
}
var n2 = ["size", "color", "stroke"];
function l2(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, n2);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-first-aid-kit",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M8 8v-2a2 2 0 0 1 2 -2h4a2 2 0 0 1 2 2v2"
  }), e.createElement("rect", {
    x: 4,
    y: 8,
    width: 16,
    height: 12,
    rx: 2
  }), e.createElement("path", {
    d: "M10 14h4"
  }), e.createElement("path", {
    d: "M12 12v4"
  }));
}
var a2 = ["size", "color", "stroke"];
function i2(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, a2);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-fish-bone",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M16.69 7.44a6.973 6.973 0 0 0 -1.69 4.56a6.97 6.97 0 0 0 1.699 4.571m0 -.004c1.914 -.684 3.691 -2.183 5.301 -4.565c-1.613 -2.384 -3.394 -3.883 -5.312 -4.565"
  }), e.createElement("path", {
    d: "M2 9.504a40.73 40.73 0 0 0 2.422 2.504a39.679 39.679 0 0 0 -2.422 2.498"
  }), e.createElement("path", {
    d: "M18 11v.01"
  }), e.createElement("path", {
    d: "M4.422 12.005h10.578"
  }), e.createElement("path", {
    d: "M7 10v4"
  }), e.createElement("path", {
    d: "M11 8v8"
  }));
}
var c2 = ["size", "color", "stroke"];
function s2(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, c2);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-fish-christianity",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M22 7s-5.646 10 -12.308 10c-3.226 .025 -6.194 -1.905 -7.692 -5c1.498 -3.095 4.466 -5.025 7.692 -5c6.662 0 12.308 10 12.308 10"
  }));
}
var h2 = ["size", "color", "stroke"];
function d2(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, h2);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-fish-hook-off",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M16 9v3m-.085 3.924a5.002 5.002 0 0 1 -9.915 -.924v-4l3 3"
  }), e.createElement("circle", {
    cx: 16,
    cy: 7,
    r: 2
  }), e.createElement("path", {
    d: "M16 5v-2"
  }), e.createElement("path", {
    d: "M3 3l18 18"
  }));
}
var v2 = ["size", "color", "stroke"];
function m2(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, v2);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-fish-hook",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M16 9v6a5 5 0 0 1 -10 0v-4l3 3"
  }), e.createElement("circle", {
    cx: 16,
    cy: 7,
    r: 2
  }), e.createElement("path", {
    d: "M16 5v-2"
  }));
}
var k2 = ["size", "color", "stroke"];
function w2(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, k2);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-fish-off",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M16.69 7.44a6.973 6.973 0 0 0 -1.63 3.635"
  }), e.createElement("path", {
    d: "M2 9.504c5.307 5.948 10.293 8.57 14.597 7.1m2.583 -1.449c.988 -.788 1.93 -1.836 2.82 -3.153c-3.005 -4.443 -6.596 -5.812 -10.564 -4.548m-2.764 1.266c-2.145 1.266 -4.378 3.215 -6.672 5.786"
  }), e.createElement("path", {
    d: "M18 11v.01"
  }), e.createElement("path", {
    d: "M11.153 11.169c-.287 .777 -.171 1.554 .347 2.331"
  }), e.createElement("path", {
    d: "M3 3l18 18"
  }));
}
var p2 = ["size", "color", "stroke"];
function E2(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, p2);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-fish",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M16.69 7.44a6.973 6.973 0 0 0 -1.69 4.56c0 1.747 .64 3.345 1.699 4.571"
  }), e.createElement("path", {
    d: "M2 9.504c7.715 8.647 14.75 10.265 20 2.498c-5.25 -7.761 -12.285 -6.142 -20 2.504"
  }), e.createElement("path", {
    d: "M18 11v.01"
  }), e.createElement("path", {
    d: "M11.5 10.5c-.667 1 -.667 2 0 3"
  }));
}
var u2 = ["size", "color", "stroke"];
function g2(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, u2);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-flag-2-off",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M5 14h9m4 0h1v-9h-10m-4 0v16"
  }), e.createElement("path", {
    d: "M3 3l18 18"
  }));
}
var M2 = ["size", "color", "stroke"];
function x2(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, M2);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-flag-2",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M5 14h14v-9h-14v16"
  }));
}
var f2 = ["size", "color", "stroke"];
function z2(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, f2);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-flag-3",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M5 14h14l-4.5 -4.5l4.5 -4.5h-14v16"
  }));
}
var b2 = ["size", "color", "stroke"];
function L2(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, b2);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-flag-off",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M5 5v16"
  }), e.createElement("path", {
    d: "M19 5v9"
  }), e.createElement("path", {
    d: "M7.641 3.645a4.994 4.994 0 0 1 4.359 1.355a5 5 0 0 0 7 0"
  }), e.createElement("path", {
    d: "M5 14a5 5 0 0 1 7 0a4.984 4.984 0 0 0 3.437 1.429m3.019 -.966c.19 -.14 .371 -.294 .544 -.463"
  }), e.createElement("path", {
    d: "M3 3l18 18"
  }));
}
var y2 = ["size", "color", "stroke"];
function C2(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, y2);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-flag",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("line", {
    x1: 5,
    y1: 5,
    x2: 5,
    y2: 21
  }), e.createElement("line", {
    x1: 19,
    y1: 5,
    x2: 19,
    y2: 14
  }), e.createElement("path", {
    d: "M5 5a5 5 0 0 1 7 0a5 5 0 0 0 7 0"
  }), e.createElement("path", {
    d: "M5 14a5 5 0 0 1 7 0a5 5 0 0 0 7 0"
  }));
}
var j2 = ["size", "color", "stroke"];
function B2(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, j2);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-flame-off",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M8.973 8.974c-.335 .378 -.67 .716 -.973 1.026c-1.226 1.26 -2 3.24 -2 5a6 6 0 0 0 11.472 2.466m.383 -3.597c-.32 -1.409 -1.122 -3.045 -1.855 -3.869c-.281 .472 -.543 .87 -.79 1.202m-2.358 -2.35c-.068 -2.157 -1.182 -4.184 -1.852 -4.852c0 .968 -.18 1.801 -.465 2.527"
  }), e.createElement("path", {
    d: "M3 3l18 18"
  }));
}
var H2 = ["size", "color", "stroke"];
function N2(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, H2);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-flame",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M12 12c2 -2.96 0 -7 -1 -8c0 3.038 -1.773 4.741 -3 6c-1.226 1.26 -2 3.24 -2 5a6 6 0 1 0 12 0c0 -1.532 -1.056 -3.94 -2 -5c-1.786 3 -2.791 3 -4 2z"
  }));
}
var W2 = ["size", "color", "stroke"];
function q2(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, W2);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-flare",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M12 3l3 6l6 3l-6 3l-3 6l-3 -6l-6 -3l6 -3z"
  }));
}
var O2 = ["size", "color", "stroke"];
function P2(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, O2);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-flask-2-off",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M6.1 15h8.9"
  }), e.createElement("path", {
    d: "M17.742 17.741a6 6 0 0 1 -2.424 3.259h-6.635a6.002 6.002 0 0 1 1.317 -10.66v-.326m0 -4.014v-3h4v7m.613 .598a6.004 6.004 0 0 1 2.801 2.817"
  }), e.createElement("path", {
    d: "M9 3h6"
  }), e.createElement("path", {
    d: "M3 3l18 18"
  }));
}
var S2 = ["size", "color", "stroke"];
function I2(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, S2);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-flask-2",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M6.1 15h11.8"
  }), e.createElement("path", {
    d: "M14 3v7.342a6.002 6.002 0 0 1 1.318 10.658h-6.635a6.002 6.002 0 0 1 1.317 -10.66v-7.34h4z"
  }), e.createElement("path", {
    d: "M9 3h6"
  }));
}
var A2 = ["size", "color", "stroke"];
function D2(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, A2);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-flask-off",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M9 3h6"
  }), e.createElement("path", {
    d: "M13 9h1"
  }), e.createElement("path", {
    d: "M10 3v3m-.268 3.736l-3.732 10.264a0.7 .7 0 0 0 .5 1h11a0.7 .7 0 0 0 .5 -1l-1.143 -3.142m-2.288 -6.294l-.569 -1.564v-6"
  }), e.createElement("path", {
    d: "M3 3l18 18"
  }));
}
var F2 = ["size", "color", "stroke"];
function G2(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, F2);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-flask",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("line", {
    x1: 9,
    y1: 3,
    x2: 15,
    y2: 3
  }), e.createElement("line", {
    x1: 10,
    y1: 9,
    x2: 14,
    y2: 9
  }), e.createElement("path", {
    d: "M10 3v6l-4 11a0.7 .7 0 0 0 .5 1h11a0.7 .7 0 0 0 .5 -1l-4 -11v-6"
  }));
}
var J2 = ["size", "color", "stroke"];
function K2(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, J2);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-flip-flops",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M18 4c2.21 0 4 1.682 4 3.758c0 .078 -.003 .156 -.008 .234l-.6 9.014c-.11 1.683 -1.596 2.994 -3.392 2.994s-3.28 -1.311 -3.392 -2.994l-.6 -9.014c-.138 -2.071 1.538 -3.855 3.743 -3.985a4.15 4.15 0 0 1 .25 -.007z"
  }), e.createElement("path", {
    d: "M14.5 14c1 -3.333 2.167 -5 3.5 -5c1.333 0 2.5 1.667 3.5 5"
  }), e.createElement("path", {
    d: "M18 16v1"
  }), e.createElement("path", {
    d: "M6 4c2.21 0 4 1.682 4 3.758c0 .078 -.003 .156 -.008 .234l-.6 9.014c-.11 1.683 -1.596 2.994 -3.392 2.994s-3.28 -1.311 -3.392 -2.994l-.6 -9.014c-.138 -2.071 1.538 -3.855 3.742 -3.985c.084 -.005 .167 -.007 .25 -.007z"
  }), e.createElement("path", {
    d: "M2.5 14c1 -3.333 2.167 -5 3.5 -5c1.333 0 2.5 1.667 3.5 5"
  }), e.createElement("path", {
    d: "M6 16v1"
  }));
}
var Q2 = ["size", "color", "stroke"];
function R2(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Q2);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-flip-horizontal",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("line", {
    x1: 3,
    y1: 12,
    x2: 21,
    y2: 12
  }), e.createElement("polyline", {
    points: "7 16 17 16 7 21 7 16"
  }), e.createElement("polyline", {
    points: "7 8 17 8 7 3 7 8"
  }));
}
var T2 = ["size", "color", "stroke"];
function U2(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, T2);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-flip-vertical",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("line", {
    x1: 12,
    y1: 3,
    x2: 12,
    y2: 21
  }), e.createElement("polyline", {
    points: "16 7 16 17 21 17 16 7"
  }), e.createElement("polyline", {
    points: "8 7 8 17 3 17 8 7"
  }));
}
var V2 = ["size", "color", "stroke"];
function X2(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, V2);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-float-center",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("rect", {
    width: 6,
    height: 6,
    x: 9,
    y: 5,
    rx: 1
  }), e.createElement("line", {
    x1: 4,
    y1: 7,
    x2: 5,
    y2: 7
  }), e.createElement("line", {
    x1: 4,
    y1: 11,
    x2: 5,
    y2: 11
  }), e.createElement("line", {
    x1: 19,
    y1: 7,
    x2: 20,
    y2: 7
  }), e.createElement("line", {
    x1: 19,
    y1: 11,
    x2: 20,
    y2: 11
  }), e.createElement("line", {
    x1: 4,
    y1: 15,
    x2: 20,
    y2: 15
  }), e.createElement("line", {
    x1: 4,
    y1: 19,
    x2: 20,
    y2: 19
  }));
}
var Y2 = ["size", "color", "stroke"];
function Z2(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Y2);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-float-left",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("rect", {
    width: 6,
    height: 6,
    x: 4,
    y: 5,
    rx: 1
  }), e.createElement("line", {
    x1: 14,
    y1: 7,
    x2: 20,
    y2: 7
  }), e.createElement("line", {
    x1: 14,
    y1: 11,
    x2: 20,
    y2: 11
  }), e.createElement("line", {
    x1: 4,
    y1: 15,
    x2: 20,
    y2: 15
  }), e.createElement("line", {
    x1: 4,
    y1: 19,
    x2: 20,
    y2: 19
  }));
}
var $2 = ["size", "color", "stroke"];
function _2(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, $2);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-float-none",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("rect", {
    width: 6,
    height: 6,
    x: 4,
    y: 5,
    rx: 1
  }), e.createElement("line", {
    x1: 4,
    y1: 15,
    x2: 20,
    y2: 15
  }), e.createElement("line", {
    x1: 4,
    y1: 19,
    x2: 20,
    y2: 19
  }));
}
var e1 = ["size", "color", "stroke"];
function t1(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, e1);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-float-right",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("rect", {
    width: 6,
    height: 6,
    x: 14,
    y: 5,
    rx: 1
  }), e.createElement("line", {
    x1: 4,
    y1: 7,
    x2: 10,
    y2: 7
  }), e.createElement("line", {
    x1: 4,
    y1: 11,
    x2: 10,
    y2: 11
  }), e.createElement("line", {
    x1: 4,
    y1: 15,
    x2: 20,
    y2: 15
  }), e.createElement("line", {
    x1: 4,
    y1: 19,
    x2: 20,
    y2: 19
  }));
}
var o1 = ["size", "color", "stroke"];
function r1(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, o1);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-flower-off",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M9.875 9.882a3 3 0 0 0 4.247 4.238m.581 -3.423a3.012 3.012 0 0 0 -1.418 -1.409"
  }), e.createElement("path", {
    d: "M9 5a3 3 0 0 1 6 0c0 .562 -.259 1.442 -.776 2.64l-.724 1.36l1.76 -1.893c.499 -.6 .922 -1.002 1.27 -1.205a2.968 2.968 0 0 1 4.07 1.099a3.011 3.011 0 0 1 -1.09 4.098c-.374 .217 -.99 .396 -1.846 .535l-1.779 .244m.292 .282l1.223 .166c.995 .145 1.698 .337 2.11 .576a3.011 3.011 0 0 1 1.226 3.832m-2.277 1.733a2.968 2.968 0 0 1 -1.929 -.369c-.348 -.202 -.771 -.604 -1.27 -1.205l-1.76 -1.893l.724 1.36c.516 1.199 .776 2.079 .776 2.64a3 3 0 0 1 -6 0c0 -.562 .259 -1.442 .776 -2.64l.724 -1.36l-1.76 1.893c-.499 .601 -.922 1.003 -1.27 1.205a2.968 2.968 0 0 1 -4.07 -1.098a3.011 3.011 0 0 1 1.09 -4.098c.374 -.218 .99 -.396 1.846 -.536l2.664 -.366l-2.4 -.325c-.995 -.145 -1.698 -.337 -2.11 -.576a3.011 3.011 0 0 1 -1.09 -4.099a2.968 2.968 0 0 1 2.134 -1.467"
  }), e.createElement("path", {
    d: "M3 3l18 18"
  }));
}
var n1 = ["size", "color", "stroke"];
function l1(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, n1);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-flower",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 3
  }), e.createElement("path", {
    d: "M12 2a3 3 0 0 1 3 3c0 .562 -.259 1.442 -.776 2.64l-.724 1.36l1.76 -1.893c.499 -.6 .922 -1.002 1.27 -1.205a2.968 2.968 0 0 1 4.07 1.099a3.011 3.011 0 0 1 -1.09 4.098c-.374 .217 -.99 .396 -1.846 .535l-2.664 .366l2.4 .326c.995 .145 1.698 .337 2.11 .576a3.011 3.011 0 0 1 1.09 4.098a2.968 2.968 0 0 1 -4.07 1.098c-.348 -.202 -.771 -.604 -1.27 -1.205l-1.76 -1.893l.724 1.36c.516 1.199 .776 2.079 .776 2.64a3 3 0 0 1 -6 0c0 -.562 .259 -1.442 .776 -2.64l.724 -1.36l-1.76 1.893c-.499 .601 -.922 1.003 -1.27 1.205a2.968 2.968 0 0 1 -4.07 -1.098a3.011 3.011 0 0 1 1.09 -4.098c.374 -.218 .99 -.396 1.846 -.536l2.664 -.366l-2.4 -.325c-.995 -.145 -1.698 -.337 -2.11 -.576a3.011 3.011 0 0 1 -1.09 -4.099a2.968 2.968 0 0 1 4.07 -1.099c.348 .203 .771 .604 1.27 1.205l1.76 1.894c-1 -2.292 -1.5 -3.625 -1.5 -4a3 3 0 0 1 3 -3z"
  }));
}
var a1 = ["size", "color", "stroke"];
function i1(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, a1);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-focus-2",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("circle", {
    cx: 12,
    cy: 12,
    r: .5,
    fill: "currentColor"
  }), e.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 7
  }), e.createElement("line", {
    x1: 12,
    y1: 3,
    x2: 12,
    y2: 5
  }), e.createElement("line", {
    x1: 3,
    y1: 12,
    x2: 5,
    y2: 12
  }), e.createElement("line", {
    x1: 12,
    y1: 19,
    x2: 12,
    y2: 21
  }), e.createElement("line", {
    x1: 19,
    y1: 12,
    x2: 21,
    y2: 12
  }));
}
var c1 = ["size", "color", "stroke"];
function s1(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, c1);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-focus-centered",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 1
  }), e.createElement("path", {
    d: "M4 8v-2a2 2 0 0 1 2 -2h2"
  }), e.createElement("path", {
    d: "M4 16v2a2 2 0 0 0 2 2h2"
  }), e.createElement("path", {
    d: "M16 4h2a2 2 0 0 1 2 2v2"
  }), e.createElement("path", {
    d: "M16 20h2a2 2 0 0 0 2 -2v-2"
  }));
}
var h1 = ["size", "color", "stroke"];
function d1(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, h1);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-focus",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("circle", {
    cx: 12,
    cy: 12,
    r: .5,
    fill: "currentColor"
  }), e.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 9
  }));
}
var v1 = ["size", "color", "stroke"];
function m1(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, v1);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-fold-down",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M12 11v8l3 -3m-6 0l3 3"
  }), e.createElement("line", {
    x1: 9,
    y1: 7,
    x2: 10,
    y2: 7
  }), e.createElement("line", {
    x1: 14,
    y1: 7,
    x2: 15,
    y2: 7
  }), e.createElement("line", {
    x1: 19,
    y1: 7,
    x2: 20,
    y2: 7
  }), e.createElement("line", {
    x1: 4,
    y1: 7,
    x2: 5,
    y2: 7
  }));
}
var k1 = ["size", "color", "stroke"];
function w1(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, k1);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-fold-up",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M12 13v-8l-3 3m6 0l-3 -3"
  }), e.createElement("line", {
    x1: 9,
    y1: 17,
    x2: 10,
    y2: 17
  }), e.createElement("line", {
    x1: 14,
    y1: 17,
    x2: 15,
    y2: 17
  }), e.createElement("line", {
    x1: 19,
    y1: 17,
    x2: 20,
    y2: 17
  }), e.createElement("line", {
    x1: 4,
    y1: 17,
    x2: 5,
    y2: 17
  }));
}
var p1 = ["size", "color", "stroke"];
function E1(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, p1);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-fold",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M12 3v6l3 -3m-6 0l3 3"
  }), e.createElement("path", {
    d: "M12 21v-6l3 3m-6 0l3 -3"
  }), e.createElement("line", {
    x1: 4,
    y1: 12,
    x2: 5,
    y2: 12
  }), e.createElement("line", {
    x1: 9,
    y1: 12,
    x2: 10,
    y2: 12
  }), e.createElement("line", {
    x1: 14,
    y1: 12,
    x2: 15,
    y2: 12
  }), e.createElement("line", {
    x1: 19,
    y1: 12,
    x2: 20,
    y2: 12
  }));
}
var u1 = ["size", "color", "stroke"];
function g1(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, u1);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-folder-minus",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M5 4h4l3 3h7a2 2 0 0 1 2 2v8a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2v-11a2 2 0 0 1 2 -2"
  }), e.createElement("line", {
    x1: 9,
    y1: 13,
    x2: 15,
    y2: 13
  }));
}
var M1 = ["size", "color", "stroke"];
function x1(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, M1);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-folder-off",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("line", {
    x1: 3,
    y1: 3,
    x2: 21,
    y2: 21
  }), e.createElement("path", {
    d: "M19 19h-14a2 2 0 0 1 -2 -2v-11a2 2 0 0 1 1.172 -1.821m3.828 -.179h1l3 3h7a2 2 0 0 1 2 2v8"
  }));
}
var f1 = ["size", "color", "stroke"];
function z1(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, f1);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-folder-plus",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M5 4h4l3 3h7a2 2 0 0 1 2 2v8a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2v-11a2 2 0 0 1 2 -2"
  }), e.createElement("line", {
    x1: 12,
    y1: 10,
    x2: 12,
    y2: 16
  }), e.createElement("line", {
    x1: 9,
    y1: 13,
    x2: 15,
    y2: 13
  }));
}
var b1 = ["size", "color", "stroke"];
function L1(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, b1);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-folder-x",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M5 4h4l3 3h7a2 2 0 0 1 2 2v8a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2v-11a2 2 0 0 1 2 -2"
  }), e.createElement("path", {
    d: "M10 11l4 4m0 -4l-4 4"
  }));
}
var y1 = ["size", "color", "stroke"];
function C1(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, y1);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-folder",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M5 4h4l3 3h7a2 2 0 0 1 2 2v8a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2v-11a2 2 0 0 1 2 -2"
  }));
}
var j1 = ["size", "color", "stroke"];
function B1(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, j1);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-folders-off",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M17 17h-8a2 2 0 0 1 -2 -2v-8m1.177 -2.823c.251 -.114 .53 -.177 .823 -.177h3l2 2h5a2 2 0 0 1 2 2v7c0 .55 -.223 1.05 -.583 1.411"
  }), e.createElement("path", {
    d: "M17 17v2a2 2 0 0 1 -2 2h-10a2 2 0 0 1 -2 -2v-9a2 2 0 0 1 2 -2h2"
  }), e.createElement("path", {
    d: "M3 3l18 18"
  }));
}
var H1 = ["size", "color", "stroke"];
function N1(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, H1);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-folders",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M9 4h3l2 2h5a2 2 0 0 1 2 2v7a2 2 0 0 1 -2 2h-10a2 2 0 0 1 -2 -2v-9a2 2 0 0 1 2 -2"
  }), e.createElement("path", {
    d: "M17 17v2a2 2 0 0 1 -2 2h-10a2 2 0 0 1 -2 -2v-9a2 2 0 0 1 2 -2h2"
  }));
}
var W1 = ["size", "color", "stroke"];
function q1(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, W1);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-forbid-2",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 9
  }), e.createElement("line", {
    x1: 9,
    y1: 15,
    x2: 15,
    y2: 9
  }));
}
var O1 = ["size", "color", "stroke"];
function P1(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, O1);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-forbid",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 9
  }), e.createElement("line", {
    x1: 9,
    y1: 9,
    x2: 15,
    y2: 15
  }));
}
var S1 = ["size", "color", "stroke"];
function I1(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, S1);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-forklift",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("circle", {
    cx: 5,
    cy: 17,
    r: 2
  }), e.createElement("circle", {
    cx: 14,
    cy: 17,
    r: 2
  }), e.createElement("line", {
    x1: 7,
    y1: 17,
    x2: 12,
    y2: 17
  }), e.createElement("path", {
    d: "M3 17v-6h13v6"
  }), e.createElement("path", {
    d: "M5 11v-4h4"
  }), e.createElement("path", {
    d: "M9 11v-6h4l3 6"
  }), e.createElement("path", {
    d: "M22 15h-3v-10"
  }), e.createElement("line", {
    x1: 16,
    y1: 13,
    x2: 19,
    y2: 13
  }));
}
var A1 = ["size", "color", "stroke"];
function D1(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, A1);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-forms",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M12 3a3 3 0 0 0 -3 3v12a3 3 0 0 0 3 3"
  }), e.createElement("path", {
    d: "M6 3a3 3 0 0 1 3 3v12a3 3 0 0 1 -3 3"
  }), e.createElement("path", {
    d: "M13 7h7a1 1 0 0 1 1 1v8a1 1 0 0 1 -1 1h-7"
  }), e.createElement("path", {
    d: "M5 7h-1a1 1 0 0 0 -1 1v8a1 1 0 0 0 1 1h1"
  }), e.createElement("path", {
    d: "M17 12h.01"
  }), e.createElement("path", {
    d: "M13 12h.01"
  }));
}
var F1 = ["size", "color", "stroke"];
function G1(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, F1);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-fountain-off",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M9 16v-5a2 2 0 1 0 -4 0"
  }), e.createElement("path", {
    d: "M15 16v-1m0 -4a2 2 0 1 1 4 0"
  }), e.createElement("path", {
    d: "M12 16v-4m0 -4v-2a3 3 0 0 1 6 0"
  }), e.createElement("path", {
    d: "M7.451 3.43a3 3 0 0 1 4.549 2.57"
  }), e.createElement("path", {
    d: "M20 16h1v1m-.871 3.114a2.99 2.99 0 0 1 -2.129 .886h-12a3 3 0 0 1 -3 -3v-2h13"
  }), e.createElement("path", {
    d: "M3 3l18 18"
  }));
}
var J1 = ["size", "color", "stroke"];
function K1(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, J1);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-fountain",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M9 16v-5a2 2 0 1 0 -4 0"
  }), e.createElement("path", {
    d: "M15 16v-5a2 2 0 1 1 4 0"
  }), e.createElement("path", {
    d: "M12 16v-10a3 3 0 0 1 6 0"
  }), e.createElement("path", {
    d: "M6 6a3 3 0 0 1 6 0"
  }), e.createElement("path", {
    d: "M3 16h18v2a3 3 0 0 1 -3 3h-12a3 3 0 0 1 -3 -3v-2z"
  }));
}
var Q1 = ["size", "color", "stroke"];
function R1(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Q1);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-frame-off",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M4 7h3m4 0h9"
  }), e.createElement("path", {
    d: "M4 17h13"
  }), e.createElement("path", {
    d: "M7 7v13"
  }), e.createElement("path", {
    d: "M17 4v9m0 4v3"
  }), e.createElement("path", {
    d: "M3 3l18 18"
  }));
}
var T1 = ["size", "color", "stroke"];
function U1(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, T1);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-frame",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("line", {
    x1: 4,
    y1: 7,
    x2: 20,
    y2: 7
  }), e.createElement("line", {
    x1: 4,
    y1: 17,
    x2: 20,
    y2: 17
  }), e.createElement("line", {
    x1: 7,
    y1: 4,
    x2: 7,
    y2: 20
  }), e.createElement("line", {
    x1: 17,
    y1: 4,
    x2: 17,
    y2: 20
  }));
}
var V1 = ["size", "color", "stroke"];
function X1(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, V1);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-free-rights",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 9
  }), e.createElement("path", {
    d: "M13.867 9.75c-.246 -.48 -.708 -.769 -1.2 -.75h-1.334c-.736 0 -1.333 .67 -1.333 1.5c0 .827 .597 1.499 1.333 1.499h1.334c.736 0 1.333 .671 1.333 1.5c0 .828 -.597 1.499 -1.333 1.499h-1.334c-.492 .019 -.954 -.27 -1.2 -.75"
  }), e.createElement("path", {
    d: "M12 7v2"
  }), e.createElement("path", {
    d: "M12 15v2"
  }), e.createElement("path", {
    d: "M6 6l1.5 1.5"
  }), e.createElement("path", {
    d: "M16.5 16.5l1.5 1.5"
  }));
}
var Y1 = ["size", "color", "stroke"];
function Z1(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Y1);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-fridge-off",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M7 3h10a2 2 0 0 1 2 2v10m0 4a2 2 0 0 1 -2 2h-10a2 2 0 0 1 -2 -2v-14"
  }), e.createElement("path", {
    d: "M5 10h5m4 0h5"
  }), e.createElement("path", {
    d: "M9 13v3"
  }), e.createElement("path", {
    d: "M3 3l18 18"
  }));
}
var $1 = ["size", "color", "stroke"];
function _1(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, $1);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-fridge",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("rect", {
    x: 5,
    y: 3,
    width: 14,
    height: 18,
    rx: 2
  }), e.createElement("path", {
    d: "M5 10h14"
  }), e.createElement("path", {
    d: "M9 13v3"
  }), e.createElement("path", {
    d: "M9 6v1"
  }));
}
var e4 = ["size", "color", "stroke"];
function t4(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, e4);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-friends-off",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M5 5a2 2 0 0 0 2 2m2 -2a2 2 0 0 0 -2 -2"
  }), e.createElement("path", {
    d: "M5 22v-5l-1 -1v-4a1 1 0 0 1 1 -1h4a1 1 0 0 1 1 1v4l-1 1v5"
  }), e.createElement("circle", {
    cx: 17,
    cy: 5,
    r: 2
  }), e.createElement("path", {
    d: "M15 22v-4h-2l1.254 -3.763m1.036 -2.942a0.997 .997 0 0 1 .71 -.295h2a1 1 0 0 1 1 1l1.503 4.508m-1.503 2.492v3"
  }), e.createElement("path", {
    d: "M3 3l18 18"
  }));
}
var o4 = ["size", "color", "stroke"];
function r4(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, o4);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-friends",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("circle", {
    cx: 7,
    cy: 5,
    r: 2
  }), e.createElement("path", {
    d: "M5 22v-5l-1 -1v-4a1 1 0 0 1 1 -1h4a1 1 0 0 1 1 1v4l-1 1v5"
  }), e.createElement("circle", {
    cx: 17,
    cy: 5,
    r: 2
  }), e.createElement("path", {
    d: "M15 22v-4h-2l2 -6a1 1 0 0 1 1 -1h2a1 1 0 0 1 1 1l2 6h-2v4"
  }));
}
var n4 = ["size", "color", "stroke"];
function l4(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, n4);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-function-off",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M9 15.5v.25c0 .69 .56 1.25 1.25 1.25a1.38 1.38 0 0 0 1.374 -1.244l.376 -3.756m.363 -3.63l.013 -.126a1.38 1.38 0 0 1 1.374 -1.244c.69 0 1.25 .56 1.25 1.25v.25"
  }), e.createElement("path", {
    d: "M8 4h10a2 2 0 0 1 2 2v10m-.586 3.414a1.994 1.994 0 0 1 -1.414 .586h-12a2 2 0 0 1 -2 -2v-12c0 -.547 .22 -1.043 .576 -1.405"
  }), e.createElement("path", {
    d: "M9 12h3"
  }), e.createElement("path", {
    d: "M3 3l18 18"
  }));
}
var a4 = ["size", "color", "stroke"];
function i4(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, a4);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-function",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("rect", {
    x: 4,
    y: 4,
    width: 16,
    height: 16,
    rx: 2.667
  }), e.createElement("path", {
    d: "M9 15.5v.25c0 .69 .56 1.25 1.25 1.25c.71 0 1.304 -.538 1.374 -1.244l.752 -7.512a1.381 1.381 0 0 1 1.374 -1.244c.69 0 1.25 .56 1.25 1.25v.25"
  }), e.createElement("path", {
    d: "M9 12h6"
  }));
}
var c4 = ["size", "color", "stroke"];
function s4(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, c4);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-garden-cart-off",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M15.733 15.732a2.5 2.5 0 1 0 3.544 3.527"
  }), e.createElement("path", {
    d: "M6 8v11a1 1 0 0 0 1.806 .591l3.694 -5.091v.055"
  }), e.createElement("path", {
    d: "M6 8h2m4 0h9l-3.005 6.01m-3.319 .693l-4.276 -.45a4 4 0 0 1 -3.296 -2.493l-2.853 -7.13a1 1 0 0 0 -.928 -.63h-1.323"
  }), e.createElement("path", {
    d: "M3 3l18 18"
  }));
}
var h4 = ["size", "color", "stroke"];
function d4(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, h4);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-garden-cart",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("circle", {
    cx: 17.5,
    cy: 17.5,
    r: 2.5
  }), e.createElement("path", {
    d: "M6 8v11a1 1 0 0 0 1.806 .591l3.694 -5.091v.055"
  }), e.createElement("path", {
    d: "M6 8h15l-3.5 7l-7.1 -.747a4 4 0 0 1 -3.296 -2.493l-2.853 -7.13a1 1 0 0 0 -.928 -.63h-1.323"
  }));
}
var v4 = ["size", "color", "stroke"];
function m4(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, v4);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-gas-station-off",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M15 11a2 2 0 0 1 2 2m3 3v-7l-3 -3"
  }), e.createElement("path", {
    d: "M4 20v-14c0 -.548 .22 -1.044 .577 -1.405m3.423 -.595h4a2 2 0 0 1 2 2v4m0 4v6"
  }), e.createElement("path", {
    d: "M3 20h12"
  }), e.createElement("path", {
    d: "M18 7v1a1 1 0 0 0 1 1h1"
  }), e.createElement("path", {
    d: "M4 11h7"
  }), e.createElement("path", {
    d: "M3 3l18 18"
  }));
}
var k4 = ["size", "color", "stroke"];
function w4(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, k4);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-gas-station",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M14 11h1a2 2 0 0 1 2 2v3a1.5 1.5 0 0 0 3 0v-7l-3 -3"
  }), e.createElement("path", {
    d: "M4 20v-14a2 2 0 0 1 2 -2h6a2 2 0 0 1 2 2v14"
  }), e.createElement("line", {
    x1: 3,
    y1: 20,
    x2: 15,
    y2: 20
  }), e.createElement("path", {
    d: "M18 7v1a1 1 0 0 0 1 1h1"
  }), e.createElement("line", {
    x1: 4,
    y1: 11,
    x2: 14,
    y2: 11
  }));
}
var p4 = ["size", "color", "stroke"];
function E4(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, p4);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-gauge-off",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M20.038 16.052a9 9 0 0 0 -12.067 -12.102m-2.333 1.686a9 9 0 1 0 12.73 12.726"
  }), e.createElement("path", {
    d: "M11.283 11.303a1 1 0 0 0 1.419 1.41"
  }), e.createElement("path", {
    d: "M14 10l2 -2"
  }), e.createElement("path", {
    d: "M7 12c0 -1.386 .564 -2.64 1.475 -3.546m2.619 -1.372c.294 -.054 .597 -.082 .906 -.082"
  }), e.createElement("path", {
    d: "M3 3l18 18"
  }));
}
var u4 = ["size", "color", "stroke"];
function g4(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, u4);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-gauge",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 9
  }), e.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 1
  }), e.createElement("line", {
    x1: 13.41,
    y1: 10.59,
    x2: 16,
    y2: 8
  }), e.createElement("path", {
    d: "M7 12a5 5 0 0 1 5 -5"
  }));
}
var M4 = ["size", "color", "stroke"];
function x4(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, M4);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-gavel",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M13 10l7.383 7.418c.823 .82 .823 2.148 0 2.967a2.11 2.11 0 0 1 -2.976 0l-7.407 -7.385"
  }), e.createElement("path", {
    d: "M6 9l4 4"
  }), e.createElement("path", {
    d: "M13 10l-4 -4"
  }), e.createElement("path", {
    d: "M3 21h7"
  }), e.createElement("path", {
    d: "M6.793 15.793l-3.586 -3.586a1 1 0 0 1 0 -1.414l2.293 -2.293l.5 .5l3 -3l-.5 -.5l2.293 -2.293a1 1 0 0 1 1.414 0l3.586 3.586a1 1 0 0 1 0 1.414l-2.293 2.293l-.5 -.5l-3 3l.5 .5l-2.293 2.293a1 1 0 0 1 -1.414 0z"
  }));
}
var f4 = ["size", "color", "stroke"];
function z4(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, f4);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-gender-agender",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 6
  }), e.createElement("path", {
    d: "M7 12h11"
  }));
}
var b4 = ["size", "color", "stroke"];
function L4(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, b4);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-gender-androgyne",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M13 11l6 -6"
  }), e.createElement("circle", {
    cx: 9,
    cy: 15,
    r: 5
  }), e.createElement("path", {
    d: "M19 9v-4h-4"
  }), e.createElement("path", {
    d: "M16.5 10.5l-3 -3"
  }));
}
var y4 = ["size", "color", "stroke"];
function C4(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, y4);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-gender-bigender",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("circle", {
    cx: 11,
    cy: 11,
    r: 4
  }), e.createElement("path", {
    d: "M19 3l-5 5"
  }), e.createElement("path", {
    d: "M15 3h4v4"
  }), e.createElement("path", {
    d: "M11 16v6"
  }), e.createElement("path", {
    d: "M8 19h6"
  }));
}
var j4 = ["size", "color", "stroke"];
function B4(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, j4);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-gender-demiboy",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("circle", {
    cx: 10,
    cy: 14,
    r: 5
  }), e.createElement("path", {
    d: "M19 5l-5.4 5.4"
  }), e.createElement("path", {
    d: "M19 5h-5"
  }));
}
var H4 = ["size", "color", "stroke"];
function N4(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, H4);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-gender-demigirl",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("circle", {
    cx: 12,
    cy: 9,
    r: 5
  }), e.createElement("path", {
    d: "M12 14v7"
  }), e.createElement("path", {
    d: "M9 18h3"
  }));
}
var W4 = ["size", "color", "stroke"];
function q4(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, W4);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-gender-epicene",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M15.536 15.536a5 5 0 1 0 -7.072 -7.072a5 5 0 0 0 7.072 7.072z"
  }), e.createElement("path", {
    d: "M15.536 15.535l5.464 -5.535"
  }), e.createElement("path", {
    d: "M3 14l5.464 -5.535"
  }), e.createElement("path", {
    d: "M12 12h.01"
  }));
}
var O4 = ["size", "color", "stroke"];
function P4(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, O4);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-gender-female",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("circle", {
    cx: 12,
    cy: 9,
    r: 5
  }), e.createElement("path", {
    d: "M12 14v7"
  }), e.createElement("path", {
    d: "M9 18h6"
  }));
}
var S4 = ["size", "color", "stroke"];
function I4(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, S4);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-gender-femme",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("circle", {
    cx: 12,
    cy: 9,
    r: 5
  }), e.createElement("path", {
    d: "M12 14v7"
  }), e.createElement("path", {
    d: "M7 18h10"
  }));
}
var A4 = ["size", "color", "stroke"];
function D4(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, A4);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-gender-genderfluid",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M10 15.464a4 4 0 1 0 4 -6.928a4 4 0 0 0 -4 6.928z"
  }), e.createElement("path", {
    d: "M15.464 13.999l3 -5.196"
  }), e.createElement("path", {
    d: "M5.536 15.195l3 -5.196"
  }), e.createElement("path", {
    d: "M12 12h.01"
  }), e.createElement("path", {
    d: "M9 9l-6 -6"
  }), e.createElement("path", {
    d: "M5.5 8.5l3 -3"
  }), e.createElement("path", {
    d: "M21 21l-6 -6"
  }), e.createElement("path", {
    d: "M17 20l3 -3"
  }), e.createElement("path", {
    d: "M3 7v-4h4"
  }));
}
var F4 = ["size", "color", "stroke"];
function G4(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, F4);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-gender-genderless",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M12 10a5 5 0 1 1 0 10a5 5 0 0 1 0 -10z"
  }), e.createElement("path", {
    d: "M12 10v-7"
  }), e.createElement("path", {
    d: "M7 15h10"
  }));
}
var J4 = ["size", "color", "stroke"];
function K4(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, J4);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-gender-genderqueer",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M12 11a5 5 0 1 1 0 10a5 5 0 0 1 0 -10z"
  }), e.createElement("path", {
    d: "M12 11v-8"
  }), e.createElement("path", {
    d: "M14.5 4.5l-5 3"
  }), e.createElement("path", {
    d: "M9.5 4.5l5 3"
  }));
}
var Q4 = ["size", "color", "stroke"];
function R4(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Q4);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-gender-hermaphrodite",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M12 14v7"
  }), e.createElement("path", {
    d: "M9 18h6"
  }), e.createElement("path", {
    d: "M12 6a4 4 0 1 1 0 8a4 4 0 0 1 0 -8z"
  }), e.createElement("path", {
    d: "M15 3a3 3 0 1 1 -6 0"
  }));
}
var T4 = ["size", "color", "stroke"];
function U4(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, T4);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-gender-intergender",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M13.5 11.5l6.5 6.5v-4"
  }), e.createElement("path", {
    d: "M11.5 13.5l6.5 6.5"
  }), e.createElement("path", {
    d: "M9 4a5 5 0 1 1 0 10a5 5 0 0 1 0 -10z"
  }), e.createElement("path", {
    d: "M14 20l2 -2"
  }));
}
var V4 = ["size", "color", "stroke"];
function X4(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, V4);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-gender-male",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("circle", {
    cx: 10,
    cy: 14,
    r: 5
  }), e.createElement("path", {
    d: "M19 5l-5.4 5.4"
  }), e.createElement("path", {
    d: "M19 5h-5"
  }), e.createElement("path", {
    d: "M19 5v5"
  }));
}
var Y4 = ["size", "color", "stroke"];
function Z4(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Y4);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-gender-neutrois",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M12 10a5 5 0 1 1 0 10a5 5 0 0 1 0 -10z"
  }), e.createElement("path", {
    d: "M12 10v-7"
  }));
}
var $4 = ["size", "color", "stroke"];
function _4(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, $4);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-gender-third",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M11 12a5 5 0 1 0 10 0a5 5 0 0 0 -10 0z"
  }), e.createElement("path", {
    d: "M11 12h-3"
  }), e.createElement("path", {
    d: "M8 12l-5 -4v8z"
  }));
}
var e3 = ["size", "color", "stroke"];
function t3(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, e3);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-gender-transgender",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 4
  }), e.createElement("path", {
    d: "M15 9l6 -6"
  }), e.createElement("path", {
    d: "M21 7v-4h-4"
  }), e.createElement("path", {
    d: "M9 9l-6 -6"
  }), e.createElement("path", {
    d: "M3 7v-4h4"
  }), e.createElement("path", {
    d: "M5.5 8.5l3 -3"
  }), e.createElement("path", {
    d: "M12 16v5"
  }), e.createElement("path", {
    d: "M9.5 19h5"
  }));
}
var o3 = ["size", "color", "stroke"];
function r3(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, o3);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-gender-trasvesti",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M15 20a5 5 0 1 1 0 -10a5 5 0 0 1 0 10z"
  }), e.createElement("path", {
    d: "M6 6l5.4 5.4"
  }), e.createElement("path", {
    d: "M4 8l4 -4"
  }));
}
var n3 = ["size", "color", "stroke"];
function l3(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, n3);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-geometry",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M7 21l4 -12m2 0l1.48 4.439m.949 2.847l1.571 4.714"
  }), e.createElement("circle", {
    cx: 12,
    cy: 7,
    r: 2
  }), e.createElement("path", {
    d: "M4 12c1.526 2.955 4.588 5 8 5c3.41 0 6.473 -2.048 8 -5"
  }), e.createElement("path", {
    d: "M12 5v-2"
  }));
}
var a3 = ["size", "color", "stroke"];
function i3(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, a3);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-ghost-2",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M10 9h.01"
  }), e.createElement("path", {
    d: "M14 9h.01"
  }), e.createElement("path", {
    d: "M12 3a7 7 0 0 1 7 7v1l1 0a2 2 0 1 1 0 4l-1 0v3l2 3h-10a6 6 0 0 1 -6 -5.775l0 -.226l-1 0a2 2 0 0 1 0 -4l1 0v-1a7 7 0 0 1 7 -7z"
  }), e.createElement("path", {
    d: "M11 14h2a1 1 0 0 0 -2 0z"
  }));
}
var c3 = ["size", "color", "stroke"];
function s3(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, c3);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-ghost-off",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M8.794 4.776a7 7 0 0 1 10.206 6.224v4m-.12 3.898a1.779 1.779 0 0 1 -2.98 .502a1.65 1.65 0 0 0 -2.6 0a1.65 1.65 0 0 1 -2.6 0a1.65 1.65 0 0 0 -2.6 0a1.78 1.78 0 0 1 -3.1 -1.4v-7c0 -1.683 .594 -3.227 1.583 -4.434"
  }), e.createElement("path", {
    d: "M14 10h.01"
  }), e.createElement("path", {
    d: "M10 14a3.5 3.5 0 0 0 4 0"
  }), e.createElement("path", {
    d: "M3 3l18 18"
  }));
}
var h3 = ["size", "color", "stroke"];
function d3(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, h3);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-ghost",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M5 11a7 7 0 0 1 14 0v7a1.78 1.78 0 0 1 -3.1 1.4a1.65 1.65 0 0 0 -2.6 0a1.65 1.65 0 0 1 -2.6 0a1.65 1.65 0 0 0 -2.6 0a1.78 1.78 0 0 1 -3.1 -1.4v-7"
  }), e.createElement("line", {
    x1: 10,
    y1: 10,
    x2: 10.01,
    y2: 10
  }), e.createElement("line", {
    x1: 14,
    y1: 10,
    x2: 14.01,
    y2: 10
  }), e.createElement("path", {
    d: "M10 14a3.5 3.5 0 0 0 4 0"
  }));
}
var v3 = ["size", "color", "stroke"];
function m3(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, v3);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-gif",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M8 8h-3a2 2 0 0 0 -2 2v4a2 2 0 0 0 2 2h3v-4h-1"
  }), e.createElement("path", {
    d: "M12 8v8"
  }), e.createElement("path", {
    d: "M16 16v-8h5"
  }), e.createElement("path", {
    d: "M20 12h-4"
  }));
}
var k3 = ["size", "color", "stroke"];
function w3(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, k3);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-gift-card",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("rect", {
    x: 3,
    y: 5,
    width: 18,
    height: 14,
    rx: 3
  }), e.createElement("path", {
    d: "M7 16l3 -3l3 3"
  }), e.createElement("path", {
    d: "M8 13c-.789 0 -2 -.672 -2 -1.5s.711 -1.5 1.5 -1.5c1.128 -.02 2.077 1.17 2.5 3c.423 -1.83 1.372 -3.02 2.5 -3c.789 0 1.5 .672 1.5 1.5s-1.211 1.5 -2 1.5h-4z"
  }));
}
var p3 = ["size", "color", "stroke"];
function E3(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, p3);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-gift-off",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M12 8h8a1 1 0 0 1 1 1v2a1 1 0 0 1 -1 1h-4m-4 0h-8a1 1 0 0 1 -1 -1v-2a1 1 0 0 1 1 -1h4"
  }), e.createElement("path", {
    d: "M12 12v9"
  }), e.createElement("path", {
    d: "M19 12v3m0 4a2 2 0 0 1 -2 2h-10a2 2 0 0 1 -2 -2v-7"
  }), e.createElement("path", {
    d: "M7.5 8a2.5 2.5 0 0 1 -2.457 -2.963m2.023 -2c.14 -.023 .286 -.037 .434 -.037c1.974 -.034 3.76 1.95 4.5 5c.74 -3.05 2.526 -5.034 4.5 -5a2.5 2.5 0 1 1 0 5"
  }), e.createElement("path", {
    d: "M3 3l18 18"
  }));
}
var u3 = ["size", "color", "stroke"];
function g3(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, u3);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-gift",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("rect", {
    x: 3,
    y: 8,
    width: 18,
    height: 4,
    rx: 1
  }), e.createElement("line", {
    x1: 12,
    y1: 8,
    x2: 12,
    y2: 21
  }), e.createElement("path", {
    d: "M19 12v7a2 2 0 0 1 -2 2h-10a2 2 0 0 1 -2 -2v-7"
  }), e.createElement("path", {
    d: "M7.5 8a2.5 2.5 0 0 1 0 -5a4.8 8 0 0 1 4.5 5a4.8 8 0 0 1 4.5 -5a2.5 2.5 0 0 1 0 5"
  }));
}
var M3 = ["size", "color", "stroke"];
function x3(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, M3);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-git-branch-deleted",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("circle", {
    cx: 7,
    cy: 18,
    r: 2
  }), e.createElement("circle", {
    cx: 7,
    cy: 6,
    r: 2
  }), e.createElement("path", {
    d: "M7 8v8"
  }), e.createElement("path", {
    d: "M9 18h6a2 2 0 0 0 2 -2v-5"
  }), e.createElement("path", {
    d: "M14 14l3 -3l3 3"
  }), e.createElement("path", {
    d: "M15 4l4 4"
  }), e.createElement("path", {
    d: "M15 8l4 -4"
  }));
}
var f3 = ["size", "color", "stroke"];
function z3(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, f3);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-git-branch",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("circle", {
    cx: 7,
    cy: 18,
    r: 2
  }), e.createElement("circle", {
    cx: 7,
    cy: 6,
    r: 2
  }), e.createElement("circle", {
    cx: 17,
    cy: 6,
    r: 2
  }), e.createElement("line", {
    x1: 7,
    y1: 8,
    x2: 7,
    y2: 16
  }), e.createElement("path", {
    d: "M9 18h6a2 2 0 0 0 2 -2v-5"
  }), e.createElement("polyline", {
    points: "14 14 17 11 20 14"
  }));
}
var b3 = ["size", "color", "stroke"];
function L3(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, b3);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-git-cherry-pick",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("circle", {
    cx: 7,
    cy: 12,
    r: 3
  }), e.createElement("path", {
    d: "M7 3v6"
  }), e.createElement("path", {
    d: "M7 15v6"
  }), e.createElement("path", {
    d: "M13 7h2.5l1.5 5l-1.5 5h-2.5"
  }), e.createElement("path", {
    d: "M17 12h3"
  }));
}
var y3 = ["size", "color", "stroke"];
function C3(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, y3);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-git-commit",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 3
  }), e.createElement("line", {
    x1: 12,
    y1: 3,
    x2: 12,
    y2: 9
  }), e.createElement("line", {
    x1: 12,
    y1: 15,
    x2: 12,
    y2: 21
  }));
}
var j3 = ["size", "color", "stroke"];
function B3(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, j3);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-git-compare",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("circle", {
    cx: 6,
    cy: 6,
    r: 2
  }), e.createElement("circle", {
    cx: 18,
    cy: 18,
    r: 2
  }), e.createElement("path", {
    d: "M11 6h5a2 2 0 0 1 2 2v8"
  }), e.createElement("polyline", {
    points: "14 9 11 6 14 3"
  }), e.createElement("path", {
    d: "M13 18h-5a2 2 0 0 1 -2 -2v-8"
  }), e.createElement("polyline", {
    points: "10 15 13 18 10 21"
  }));
}
var H3 = ["size", "color", "stroke"];
function N3(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, H3);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-git-fork",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("circle", {
    cx: 12,
    cy: 18,
    r: 2
  }), e.createElement("circle", {
    cx: 7,
    cy: 6,
    r: 2
  }), e.createElement("circle", {
    cx: 17,
    cy: 6,
    r: 2
  }), e.createElement("path", {
    d: "M7 8v2a2 2 0 0 0 2 2h6a2 2 0 0 0 2 -2v-2"
  }), e.createElement("line", {
    x1: 12,
    y1: 12,
    x2: 12,
    y2: 16
  }));
}
var W3 = ["size", "color", "stroke"];
function q3(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, W3);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-git-merge",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("circle", {
    cx: 7,
    cy: 18,
    r: 2
  }), e.createElement("circle", {
    cx: 7,
    cy: 6,
    r: 2
  }), e.createElement("circle", {
    cx: 17,
    cy: 12,
    r: 2
  }), e.createElement("line", {
    x1: 7,
    y1: 8,
    x2: 7,
    y2: 16
  }), e.createElement("path", {
    d: "M7 8a4 4 0 0 0 4 4h4"
  }));
}
var O3 = ["size", "color", "stroke"];
function P3(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, O3);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-git-pull-request-closed",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("circle", {
    cx: 6,
    cy: 18,
    r: 2
  }), e.createElement("circle", {
    cx: 6,
    cy: 6,
    r: 2
  }), e.createElement("circle", {
    cx: 18,
    cy: 18,
    r: 2
  }), e.createElement("path", {
    d: "M6 8v8"
  }), e.createElement("path", {
    d: "M18 11v5"
  }), e.createElement("path", {
    d: "M16 4l4 4m0 -4l-4 4"
  }));
}
var S3 = ["size", "color", "stroke"];
function I3(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, S3);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-git-pull-request-draft",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("circle", {
    cx: 6,
    cy: 18,
    r: 2
  }), e.createElement("circle", {
    cx: 6,
    cy: 6,
    r: 2
  }), e.createElement("circle", {
    cx: 18,
    cy: 18,
    r: 2
  }), e.createElement("path", {
    d: "M6 8v8"
  }), e.createElement("path", {
    d: "M18 11h.01"
  }), e.createElement("path", {
    d: "M18 6h.01"
  }));
}
var A3 = ["size", "color", "stroke"];
function D3(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, A3);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-git-pull-request",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("circle", {
    cx: 6,
    cy: 18,
    r: 2
  }), e.createElement("circle", {
    cx: 6,
    cy: 6,
    r: 2
  }), e.createElement("circle", {
    cx: 18,
    cy: 18,
    r: 2
  }), e.createElement("line", {
    x1: 6,
    y1: 8,
    x2: 6,
    y2: 16
  }), e.createElement("path", {
    d: "M11 6h5a2 2 0 0 1 2 2v8"
  }), e.createElement("polyline", {
    points: "14 9 11 6 14 3"
  }));
}
var F3 = ["size", "color", "stroke"];
function G3(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, F3);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-gizmo",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M20 19l-8 -5.5l-8 5.5"
  }), e.createElement("path", {
    d: "M12 4v9.5"
  }), e.createElement("circle", {
    cx: 12,
    cy: 4,
    r: 1
  }), e.createElement("circle", {
    cx: 4,
    cy: 19,
    r: 1
  }), e.createElement("circle", {
    cx: 20,
    cy: 19,
    r: 1
  }));
}
var J3 = ["size", "color", "stroke"];
function K3(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, J3);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-glass-full",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("line", {
    x1: 8,
    y1: 21,
    x2: 16,
    y2: 21
  }), e.createElement("line", {
    x1: 12,
    y1: 15,
    x2: 12,
    y2: 21
  }), e.createElement("path", {
    d: "M17 3l1 7c0 3.012 -2.686 5 -6 5s-6 -1.988 -6 -5l1 -7h10z"
  }), e.createElement("path", {
    d: "M6 10a5 5 0 0 1 6 0a5 5 0 0 0 6 0"
  }));
}
var Q3 = ["size", "color", "stroke"];
function R3(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Q3);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-glass-off",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("line", {
    x1: 8,
    y1: 21,
    x2: 16,
    y2: 21
  }), e.createElement("line", {
    x1: 12,
    y1: 15,
    x2: 12,
    y2: 21
  }), e.createElement("path", {
    d: "M7 3h10l1 7a4.511 4.511 0 0 1 -1.053 2.94m-2.386 1.625a7.48 7.48 0 0 1 -2.561 .435c-3.314 0 -6 -1.988 -6 -5l.5 -3.495"
  }), e.createElement("line", {
    x1: 3,
    y1: 3,
    x2: 21,
    y2: 21
  }));
}
var T3 = ["size", "color", "stroke"];
function U3(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, T3);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-glass",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("line", {
    x1: 8,
    y1: 21,
    x2: 16,
    y2: 21
  }), e.createElement("line", {
    x1: 12,
    y1: 15,
    x2: 12,
    y2: 21
  }), e.createElement("path", {
    d: "M17 3l1 7c0 3.012 -2.686 5 -6 5s-6 -1.988 -6 -5l1 -7h10z"
  }));
}
var V3 = ["size", "color", "stroke"];
function X3(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, V3);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-globe-off",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M8.36 8.339a4 4 0 0 0 5.281 5.31m1.995 -1.98a4 4 0 0 0 -5.262 -5.325"
  }), e.createElement("path", {
    d: "M6.75 16a8.015 8.015 0 0 0 9.799 .553m2.016 -1.998a8.015 8.015 0 0 0 -2.565 -11.555"
  }), e.createElement("path", {
    d: "M12 18v4"
  }), e.createElement("path", {
    d: "M8 22h8"
  }), e.createElement("path", {
    d: "M3 3l18 18"
  }));
}
var Y3 = ["size", "color", "stroke"];
function Z3(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Y3);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-globe",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("circle", {
    cx: 12,
    cy: 10,
    r: 4
  }), e.createElement("path", {
    d: "M6.75 16a8.015 8.015 0 1 0 9.25 -13"
  }), e.createElement("line", {
    x1: 12,
    y1: 18,
    x2: 12,
    y2: 22
  }), e.createElement("line", {
    x1: 8,
    y1: 22,
    x2: 16,
    y2: 22
  }));
}
var $3 = ["size", "color", "stroke"];
function _3(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, $3);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-go-game",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("circle", {
    cx: 6,
    cy: 6,
    r: 2
  }), e.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 2
  }), e.createElement("circle", {
    cx: 6,
    cy: 18,
    r: 2
  }), e.createElement("circle", {
    cx: 18,
    cy: 18,
    r: 2
  }), e.createElement("path", {
    d: "M3 12h7m4 0h7"
  }), e.createElement("path", {
    d: "M3 6h1m4 0h13"
  }), e.createElement("path", {
    d: "M3 18h1m4 0h8m4 0h1"
  }), e.createElement("path", {
    d: "M6 3v1m0 4v8m0 4v1"
  }), e.createElement("path", {
    d: "M12 3v7m0 4v7"
  }), e.createElement("path", {
    d: "M18 3v13m0 4v1"
  }));
}
var e5 = ["size", "color", "stroke"];
function t5(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, e5);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-golf-off",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M12 18v-6m0 -4v-5l7 4l-5.07 2.897"
  }), e.createElement("path", {
    d: "M9 17.67c-.62 .36 -1 .82 -1 1.33c0 1.1 1.8 2 4 2s4 -.9 4 -2c0 -.5 -.38 -.97 -1 -1.33"
  }), e.createElement("path", {
    d: "M3 3l18 18"
  }));
}
var o5 = ["size", "color", "stroke"];
function r5(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, o5);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-golf",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M12 18v-15l7 4l-7 4"
  }), e.createElement("path", {
    d: "M9 17.67c-.62 .36 -1 .82 -1 1.33c0 1.1 1.8 2 4 2s4 -.9 4 -2c0 -.5 -.38 -.97 -1 -1.33"
  }));
}
var n5 = ["size", "color", "stroke"];
function l5(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, n5);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-gps",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 9
  }), e.createElement("path", {
    d: "M12 17l-1 -4l-4 -1l9 -4z"
  }));
}
var a5 = ["size", "color", "stroke"];
function i5(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, a5);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-gradienter",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M3.227 14c.917 3.999 4.497 7 8.773 7c4.277 0 7.858 -3 8.773 -7"
  }), e.createElement("path", {
    d: "M20.78 10a8.994 8.994 0 0 0 -8.78 -7a8.985 8.985 0 0 0 -8.782 7"
  }), e.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 2
  }));
}
var c5 = ["size", "color", "stroke"];
function s5(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, c5);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-grain",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("circle", {
    cx: 4.5,
    cy: 9.5,
    r: 1
  }), e.createElement("circle", {
    cx: 9.5,
    cy: 4.5,
    r: 1
  }), e.createElement("circle", {
    cx: 9.5,
    cy: 14.5,
    r: 1
  }), e.createElement("circle", {
    cx: 4.5,
    cy: 19.5,
    r: 1
  }), e.createElement("circle", {
    cx: 14.5,
    cy: 9.5,
    r: 1
  }), e.createElement("circle", {
    cx: 19.5,
    cy: 4.5,
    r: 1
  }), e.createElement("circle", {
    cx: 14.5,
    cy: 19.5,
    r: 1
  }), e.createElement("circle", {
    cx: 19.5,
    cy: 14.5,
    r: 1
  }));
}
var h5 = ["size", "color", "stroke"];
function d5(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, h5);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-graph-off",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M8 4h10a2 2 0 0 1 2 2v10m-.586 3.414a1.994 1.994 0 0 1 -1.414 .586h-12a2 2 0 0 1 -2 -2v-12c0 -.547 .22 -1.043 .576 -1.405"
  }), e.createElement("path", {
    d: "M7 14l3 -3l2 2l.5 -.5m2 -2l.5 -.5l2 2"
  }), e.createElement("path", {
    d: "M3 3l18 18"
  }));
}
var v5 = ["size", "color", "stroke"];
function m5(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, v5);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-graph",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M4 18v-12a2 2 0 0 1 2 -2h12a2 2 0 0 1 2 2v12a2 2 0 0 1 -2 2h-12a2 2 0 0 1 -2 -2z"
  }), e.createElement("path", {
    d: "M7 14l3 -3l2 2l3 -3l2 2"
  }));
}
var k5 = ["size", "color", "stroke"];
function w5(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, k5);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-grave-2",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M7 16.17v-9.17a3 3 0 0 1 3 -3h4a3 3 0 0 1 3 3v9.171"
  }), e.createElement("path", {
    d: "M12 7v5"
  }), e.createElement("path", {
    d: "M10 9h4"
  }), e.createElement("path", {
    d: "M5 21v-2a3 3 0 0 1 3 -3h8a3 3 0 0 1 3 3v2h-14z"
  }));
}
var p5 = ["size", "color", "stroke"];
function E5(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, p5);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-grave",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M5 21v-2a3 3 0 0 1 3 -3h8a3 3 0 0 1 3 3v2h-14z"
  }), e.createElement("path", {
    d: "M10 16v-5h-4v-4h4v-4h4v4h4v4h-4v5"
  }));
}
var u5 = ["size", "color", "stroke"];
function g5(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, u5);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-grid-dots",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("circle", {
    cx: 5,
    cy: 5,
    r: 1
  }), e.createElement("circle", {
    cx: 12,
    cy: 5,
    r: 1
  }), e.createElement("circle", {
    cx: 19,
    cy: 5,
    r: 1
  }), e.createElement("circle", {
    cx: 5,
    cy: 12,
    r: 1
  }), e.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 1
  }), e.createElement("circle", {
    cx: 19,
    cy: 12,
    r: 1
  }), e.createElement("circle", {
    cx: 5,
    cy: 19,
    r: 1
  }), e.createElement("circle", {
    cx: 12,
    cy: 19,
    r: 1
  }), e.createElement("circle", {
    cx: 19,
    cy: 19,
    r: 1
  }));
}
var M5 = ["size", "color", "stroke"];
function x5(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, M5);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-grid-pattern",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("rect", {
    x: 4,
    y: 4,
    width: 16,
    height: 16,
    rx: 2
  }), e.createElement("path", {
    d: "M10 8v8"
  }), e.createElement("path", {
    d: "M14 8v8"
  }), e.createElement("path", {
    d: "M8 10h8"
  }), e.createElement("path", {
    d: "M8 14h8"
  }));
}
var f5 = ["size", "color", "stroke"];
function z5(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, f5);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-grill-fork",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M5 5l11.5 11.5"
  }), e.createElement("path", {
    d: "M19.347 16.575l1.08 1.079a1.96 1.96 0 0 1 -2.773 2.772l-1.08 -1.079a1.96 1.96 0 0 1 2.773 -2.772z"
  }), e.createElement("path", {
    d: "M3 7l3.05 3.15a2.9 2.9 0 0 0 4.1 -4.1l-3.15 -3.05"
  }));
}
var b5 = ["size", "color", "stroke"];
function L5(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, b5);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-grill-off",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M8 8h-3a6 6 0 0 0 6 6h2c.315 0 .624 -.024 .926 -.071m2.786 -1.214a5.99 5.99 0 0 0 2.284 -4.49l.004 -.225h-7"
  }), e.createElement("path", {
    d: "M18.827 18.815a2 2 0 1 1 -2.663 -2.633"
  }), e.createElement("path", {
    d: "M9 14l-3 6"
  }), e.createElement("path", {
    d: "M15 18h-8"
  }), e.createElement("path", {
    d: "M15 5v-1"
  }), e.createElement("path", {
    d: "M12 5v-1"
  }), e.createElement("path", {
    d: "M9 5v-1"
  }), e.createElement("path", {
    d: "M3 3l18 18"
  }));
}
var y5 = ["size", "color", "stroke"];
function C5(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, y5);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-grill-spatula",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M10.2 10.2l6.3 6.3"
  }), e.createElement("path", {
    d: "M19.347 16.575l1.08 1.079a1.96 1.96 0 0 1 -2.773 2.772l-1.08 -1.079a1.96 1.96 0 0 1 2.773 -2.772z"
  }), e.createElement("path", {
    d: "M3 7l3.05 3.15a2.9 2.9 0 0 0 4.1 -4.1l-3.15 -3.05l-4 4z"
  }));
}
var j5 = ["size", "color", "stroke"];
function B5(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, j5);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-grill",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M19 8h-14a6 6 0 0 0 6 6h2a6 6 0 0 0 5.996 -5.775l.004 -.225z"
  }), e.createElement("path", {
    d: "M17 20a2 2 0 1 1 0 -4a2 2 0 0 1 0 4z"
  }), e.createElement("path", {
    d: "M15 14l1 2"
  }), e.createElement("path", {
    d: "M9 14l-3 6"
  }), e.createElement("path", {
    d: "M15 18h-8"
  }), e.createElement("path", {
    d: "M15 5v-1"
  }), e.createElement("path", {
    d: "M12 5v-1"
  }), e.createElement("path", {
    d: "M9 5v-1"
  }));
}
var H5 = ["size", "color", "stroke"];
function N5(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, H5);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-grip-horizontal",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("circle", {
    cx: 5,
    cy: 9,
    r: 1
  }), e.createElement("circle", {
    cx: 5,
    cy: 15,
    r: 1
  }), e.createElement("circle", {
    cx: 12,
    cy: 9,
    r: 1
  }), e.createElement("circle", {
    cx: 12,
    cy: 15,
    r: 1
  }), e.createElement("circle", {
    cx: 19,
    cy: 9,
    r: 1
  }), e.createElement("circle", {
    cx: 19,
    cy: 15,
    r: 1
  }));
}
var W5 = ["size", "color", "stroke"];
function q5(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, W5);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-grip-vertical",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("circle", {
    cx: 9,
    cy: 5,
    r: 1
  }), e.createElement("circle", {
    cx: 9,
    cy: 12,
    r: 1
  }), e.createElement("circle", {
    cx: 9,
    cy: 19,
    r: 1
  }), e.createElement("circle", {
    cx: 15,
    cy: 5,
    r: 1
  }), e.createElement("circle", {
    cx: 15,
    cy: 12,
    r: 1
  }), e.createElement("circle", {
    cx: 15,
    cy: 19,
    r: 1
  }));
}
var O5 = ["size", "color", "stroke"];
function P5(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, O5);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-growth",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M16.5 15a4.5 4.5 0 0 0 -4.5 4.5m4.5 -8.5a4.5 4.5 0 0 0 -4.5 4.5m4.5 -8.5a4.5 4.5 0 0 0 -4.5 4.5m-4 3.5c2.21 0 4 2.015 4 4.5m-4 -8.5c2.21 0 4 2.015 4 4.5m-4 -8.5c2.21 0 4 2.015 4 4.5m0 -7.5v6"
  }));
}
var S5 = ["size", "color", "stroke"];
function I5(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, S5);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-guitar-pick",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M16 18.5c2 -2.5 4 -6.5 4 -10.5c0 -2.946 -2.084 -4.157 -4.204 -4.654c-.864 -.23 -2.13 -.346 -3.796 -.346c-1.667 0 -2.932 .115 -3.796 .346c-2.12 .497 -4.204 1.708 -4.204 4.654c0 3.312 2 8 4 10.5c.297 .37 .618 .731 .963 1.081l.354 .347a3.9 3.9 0 0 0 5.364 0a14.05 14.05 0 0 0 1.319 -1.428z"
  }));
}
var A5 = ["size", "color", "stroke"];
function D5(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, A5);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-h-1",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M19 18v-8l-2 2"
  }), e.createElement("path", {
    d: "M4 6v12"
  }), e.createElement("path", {
    d: "M12 6v12"
  }), e.createElement("path", {
    d: "M11 18h2"
  }), e.createElement("path", {
    d: "M3 18h2"
  }), e.createElement("path", {
    d: "M4 12h8"
  }), e.createElement("path", {
    d: "M3 6h2"
  }), e.createElement("path", {
    d: "M11 6h2"
  }));
}
var F5 = ["size", "color", "stroke"];
function G5(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, F5);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-h-2",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M17 12a2 2 0 1 1 4 0c0 .591 -.417 1.318 -.816 1.858l-3.184 4.143l4 0"
  }), e.createElement("path", {
    d: "M4 6v12"
  }), e.createElement("path", {
    d: "M12 6v12"
  }), e.createElement("path", {
    d: "M11 18h2"
  }), e.createElement("path", {
    d: "M3 18h2"
  }), e.createElement("path", {
    d: "M4 12h8"
  }), e.createElement("path", {
    d: "M3 6h2"
  }), e.createElement("path", {
    d: "M11 6h2"
  }));
}
var J5 = ["size", "color", "stroke"];
function K5(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, J5);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-h-3",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M19 14a2 2 0 1 0 -2 -2"
  }), e.createElement("path", {
    d: "M17 16a2 2 0 1 0 2 -2"
  }), e.createElement("path", {
    d: "M4 6v12"
  }), e.createElement("path", {
    d: "M12 6v12"
  }), e.createElement("path", {
    d: "M11 18h2"
  }), e.createElement("path", {
    d: "M3 18h2"
  }), e.createElement("path", {
    d: "M4 12h8"
  }), e.createElement("path", {
    d: "M3 6h2"
  }), e.createElement("path", {
    d: "M11 6h2"
  }));
}
var Q5 = ["size", "color", "stroke"];
function R5(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Q5);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-h-4",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M20 18v-8l-4 6h5"
  }), e.createElement("path", {
    d: "M4 6v12"
  }), e.createElement("path", {
    d: "M12 6v12"
  }), e.createElement("path", {
    d: "M11 18h2"
  }), e.createElement("path", {
    d: "M3 18h2"
  }), e.createElement("path", {
    d: "M4 12h8"
  }), e.createElement("path", {
    d: "M3 6h2"
  }), e.createElement("path", {
    d: "M11 6h2"
  }));
}
var T5 = ["size", "color", "stroke"];
function U5(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, T5);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-h-5",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M17 18h2a2 2 0 1 0 0 -4h-2v-4h4"
  }), e.createElement("path", {
    d: "M4 6v12"
  }), e.createElement("path", {
    d: "M12 6v12"
  }), e.createElement("path", {
    d: "M11 18h2"
  }), e.createElement("path", {
    d: "M3 18h2"
  }), e.createElement("path", {
    d: "M4 12h8"
  }), e.createElement("path", {
    d: "M3 6h2"
  }), e.createElement("path", {
    d: "M11 6h2"
  }));
}
var V5 = ["size", "color", "stroke"];
function X5(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, V5);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-h-6",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M19 14a2 2 0 1 0 0 4a2 2 0 0 0 0 -4z"
  }), e.createElement("path", {
    d: "M21 12a2 2 0 1 0 -4 0v4"
  }), e.createElement("path", {
    d: "M4 6v12"
  }), e.createElement("path", {
    d: "M12 6v12"
  }), e.createElement("path", {
    d: "M11 18h2"
  }), e.createElement("path", {
    d: "M3 18h2"
  }), e.createElement("path", {
    d: "M4 12h8"
  }), e.createElement("path", {
    d: "M3 6h2"
  }), e.createElement("path", {
    d: "M11 6h2"
  }));
}
var Y5 = ["size", "color", "stroke"];
function Z5(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Y5);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-hammer-off",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M10.698 10.72l-6.668 6.698a2.091 2.091 0 0 0 0 2.967a2.11 2.11 0 0 0 2.976 0l6.696 -6.676"
  }), e.createElement("path", {
    d: "M18.713 14.702l1.994 -1.995a1 1 0 0 0 0 -1.414l-7.586 -7.586a1 1 0 0 0 -1.414 0l-1.999 1.999"
  }), e.createElement("path", {
    d: "M3 3l18 18"
  }));
}
var $5 = ["size", "color", "stroke"];
function _5(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, $5);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-hammer",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M11.414 10l-7.383 7.418a2.091 2.091 0 0 0 0 2.967a2.11 2.11 0 0 0 2.976 0l7.407 -7.385"
  }), e.createElement("path", {
    d: "M18.121 15.293l2.586 -2.586a1 1 0 0 0 0 -1.414l-7.586 -7.586a1 1 0 0 0 -1.414 0l-2.586 2.586a1 1 0 0 0 0 1.414l7.586 7.586a1 1 0 0 0 1.414 0z"
  }));
}
var e6 = ["size", "color", "stroke"];
function t6(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, e6);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-hand-click",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M8 13v-8.5a1.5 1.5 0 0 1 3 0v7.5"
  }), e.createElement("path", {
    d: "M11 11.5v-2a1.5 1.5 0 0 1 3 0v2.5"
  }), e.createElement("path", {
    d: "M14 10.5a1.5 1.5 0 0 1 3 0v1.5"
  }), e.createElement("path", {
    d: "M17 11.5a1.5 1.5 0 0 1 3 0v4.5a6 6 0 0 1 -6 6h-2h.208a6 6 0 0 1 -5.012 -2.7l-.196 -.3c-.312 -.479 -1.407 -2.388 -3.286 -5.728a1.5 1.5 0 0 1 .536 -2.022a1.867 1.867 0 0 1 2.28 .28l1.47 1.47"
  }), e.createElement("path", {
    d: "M5 3l-1 -1"
  }), e.createElement("path", {
    d: "M4 7h-1"
  }), e.createElement("path", {
    d: "M14 3l1 -1"
  }), e.createElement("path", {
    d: "M15 6h1"
  }));
}
var o6 = ["size", "color", "stroke"];
function r6(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, o6);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-hand-finger-off",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M8 13v-5"
  }), e.createElement("path", {
    d: "M8.06 4.077a1.5 1.5 0 0 1 2.94 .423v2.5m0 4v1"
  }), e.createElement("path", {
    d: "M12.063 8.065a1.5 1.5 0 0 1 1.937 1.435v.5"
  }), e.createElement("path", {
    d: "M14.06 10.082a1.5 1.5 0 0 1 2.94 .418v1.5"
  }), e.createElement("path", {
    d: "M17 11.5a1.5 1.5 0 0 1 3 0v4.5m-.88 3.129a5.996 5.996 0 0 1 -5.12 2.871h-2h.208a6 6 0 0 1 -5.012 -2.7l-.196 -.3c-.312 -.479 -1.407 -2.388 -3.286 -5.728a1.5 1.5 0 0 1 .536 -2.022a1.867 1.867 0 0 1 2.28 .28l1.47 1.47"
  }), e.createElement("path", {
    d: "M3 3l18 18"
  }));
}
var n6 = ["size", "color", "stroke"];
function l6(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, n6);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-hand-finger",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M8 13v-8.5a1.5 1.5 0 0 1 3 0v7.5"
  }), e.createElement("path", {
    d: "M11 11.5v-2a1.5 1.5 0 1 1 3 0v2.5"
  }), e.createElement("path", {
    d: "M14 10.5a1.5 1.5 0 0 1 3 0v1.5"
  }), e.createElement("path", {
    d: "M17 11.5a1.5 1.5 0 0 1 3 0v4.5a6 6 0 0 1 -6 6h-2h.208a6 6 0 0 1 -5.012 -2.7a69.74 69.74 0 0 1 -.196 -.3c-.312 -.479 -1.407 -2.388 -3.286 -5.728a1.5 1.5 0 0 1 .536 -2.022a1.867 1.867 0 0 1 2.28 .28l1.47 1.47"
  }));
}
var a6 = ["size", "color", "stroke"];
function i6(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, a6);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-hand-grab",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M8 11v-3.5a1.5 1.5 0 0 1 3 0v2.5"
  }), e.createElement("path", {
    d: "M11 9.5v-3a1.5 1.5 0 0 1 3 0v3.5"
  }), e.createElement("path", {
    d: "M14 7.5a1.5 1.5 0 0 1 3 0v2.5"
  }), e.createElement("path", {
    d: "M17 9.5a1.5 1.5 0 0 1 3 0v4.5a6 6 0 0 1 -6 6h-2h.208a6 6 0 0 1 -5.012 -2.7l-.196 -.3c-.312 -.479 -1.407 -2.388 -3.286 -5.728a1.5 1.5 0 0 1 .536 -2.022a1.867 1.867 0 0 1 2.28 .28l1.47 1.47"
  }));
}
var c6 = ["size", "color", "stroke"];
function s6(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, c6);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-hand-little-finger",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M8 13v-2.5a1.5 1.5 0 0 1 3 0v1.5"
  }), e.createElement("path", {
    d: "M11 11.5v-1a1.5 1.5 0 0 1 3 0v1.5"
  }), e.createElement("path", {
    d: "M17 12v-5.5a1.5 1.5 0 0 1 3 0v9.5a6 6 0 0 1 -6 6h-2h.208a6 6 0 0 1 -5.012 -2.7a69.74 69.74 0 0 1 -.196 -.3c-.312 -.479 -1.407 -2.388 -3.286 -5.728a1.5 1.5 0 0 1 .536 -2.022a1.867 1.867 0 0 1 2.28 .28l1.47 1.47"
  }), e.createElement("path", {
    d: "M14 10.5a1.5 1.5 0 0 1 3 0v1.5"
  }));
}
var h6 = ["size", "color", "stroke"];
function d6(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, h6);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-hand-middle-finger",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M8 13v-2.5a1.5 1.5 0 0 1 3 0v1.5"
  }), e.createElement("path", {
    d: "M14 10.5a1.5 1.5 0 0 1 3 0v1.5"
  }), e.createElement("path", {
    d: "M17 11.5a1.5 1.5 0 0 1 3 0v4.5a6 6 0 0 1 -6 6h-2h.208a6 6 0 0 1 -5.012 -2.7a69.74 69.74 0 0 1 -.196 -.3c-.312 -.479 -1.407 -2.388 -3.286 -5.728a1.5 1.5 0 0 1 .536 -2.022a1.867 1.867 0 0 1 2.28 .28l1.47 1.47"
  }), e.createElement("path", {
    d: "M11 11.5v-8a1.5 1.5 0 1 1 3 0v8.5"
  }));
}
var v6 = ["size", "color", "stroke"];
function m6(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, v6);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-hand-move",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M8 13v-8.5a1.5 1.5 0 0 1 3 0v7.5"
  }), e.createElement("path", {
    d: "M11 11.5v-2a1.5 1.5 0 0 1 3 0v2.5"
  }), e.createElement("path", {
    d: "M14 10.5a1.5 1.5 0 0 1 3 0v1.5"
  }), e.createElement("path", {
    d: "M17 11.5a1.5 1.5 0 0 1 3 0v4.5a6 6 0 0 1 -6 6h-2h.208a6 6 0 0 1 -5.012 -2.7l-.196 -.3c-.312 -.479 -1.407 -2.388 -3.286 -5.728a1.5 1.5 0 0 1 .536 -2.022a1.867 1.867 0 0 1 2.28 .28l1.47 1.47"
  }), e.createElement("path", {
    d: "M2.541 5.594a13.487 13.487 0 0 1 2.46 -1.427"
  }), e.createElement("path", {
    d: "M14 3.458c1.32 .354 2.558 .902 3.685 1.612"
  }));
}
var k6 = ["size", "color", "stroke"];
function w6(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, k6);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-hand-off",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("line", {
    x1: 3,
    y1: 3,
    x2: 21,
    y2: 21
  }), e.createElement("path", {
    d: "M8 13.5v-5.5m.44 -3.562a1.5 1.5 0 0 1 2.56 1.062v1.5m0 4.008v.992m0 -6.5v-2a1.5 1.5 0 1 1 3 0v6.5m0 -4.5a1.5 1.5 0 0 1 3 0v6.5m0 -4.5a1.5 1.5 0 0 1 3 0v8.5a6 6 0 0 1 -6 6h-2c-2.114 -.292 -3.956 -1.397 -5 -3l-2.7 -5.25a1.7 1.7 0 0 1 2.75 -2l.9 1.75"
  }));
}
var p6 = ["size", "color", "stroke"];
function E6(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, p6);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-hand-ring-finger",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M8 13v-2.5a1.5 1.5 0 0 1 3 0v1.5"
  }), e.createElement("path", {
    d: "M17 11.5a1.5 1.5 0 0 1 3 0v4.5a6 6 0 0 1 -6 6h-2h.208a6 6 0 0 1 -5.012 -2.7a69.74 69.74 0 0 1 -.196 -.3c-.312 -.479 -1.407 -2.388 -3.286 -5.728a1.5 1.5 0 0 1 .536 -2.022a1.867 1.867 0 0 1 2.28 .28l1.47 1.47"
  }), e.createElement("path", {
    d: "M11 11.5v-2a1.5 1.5 0 1 1 3 0v2.5"
  }), e.createElement("path", {
    d: "M14 12v-6.5a1.5 1.5 0 0 1 3 0v6.5"
  }));
}
var u6 = ["size", "color", "stroke"];
function g6(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, u6);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-hand-rock",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M11 11.5v-1a1.5 1.5 0 0 1 3 0v1.5"
  }), e.createElement("path", {
    d: "M17 12v-6.5a1.5 1.5 0 0 1 3 0v10.5a6 6 0 0 1 -6 6h-2h.208a6 6 0 0 1 -5.012 -2.7a69.74 69.74 0 0 1 -.196 -.3c-.312 -.479 -1.407 -2.388 -3.286 -5.728a1.5 1.5 0 0 1 .536 -2.022a1.867 1.867 0 0 1 2.28 .28l1.47 1.47"
  }), e.createElement("path", {
    d: "M14 10.5a1.5 1.5 0 0 1 3 0v1.5"
  }), e.createElement("path", {
    d: "M8 13v-8.5a1.5 1.5 0 0 1 3 0v7.5"
  }));
}
var M6 = ["size", "color", "stroke"];
function x6(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, M6);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-hand-sanitizer",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M7 21h10v-10a3 3 0 0 0 -3 -3h-4a3 3 0 0 0 -3 3v10z"
  }), e.createElement("path", {
    d: "M15 3h-6a2 2 0 0 0 -2 2"
  }), e.createElement("path", {
    d: "M12 3v5"
  }), e.createElement("path", {
    d: "M12 11v4"
  }), e.createElement("path", {
    d: "M10 13h4"
  }));
}
var f6 = ["size", "color", "stroke"];
function z6(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, f6);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-hand-stop",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M8 13v-7.5a1.5 1.5 0 0 1 3 0v6.5"
  }), e.createElement("path", {
    d: "M11 5.5v-2a1.5 1.5 0 1 1 3 0v8.5"
  }), e.createElement("path", {
    d: "M14 5.5a1.5 1.5 0 0 1 3 0v6.5"
  }), e.createElement("path", {
    d: "M17 7.5a1.5 1.5 0 0 1 3 0v8.5a6 6 0 0 1 -6 6h-2h.208a6 6 0 0 1 -5.012 -2.7a69.74 69.74 0 0 1 -.196 -.3c-.312 -.479 -1.407 -2.388 -3.286 -5.728a1.5 1.5 0 0 1 .536 -2.022a1.867 1.867 0 0 1 2.28 .28l1.47 1.47"
  }));
}
var b6 = ["size", "color", "stroke"];
function L6(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, b6);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-hand-three-fingers",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M8 13v-8.5a1.5 1.5 0 0 1 3 0v7.5"
  }), e.createElement("path", {
    d: "M17 11.5a1.5 1.5 0 0 1 3 0v4.5a6 6 0 0 1 -6 6h-2h.208a6 6 0 0 1 -5.012 -2.7a69.74 69.74 0 0 1 -.196 -.3c-.312 -.479 -1.407 -2.388 -3.286 -5.728a1.5 1.5 0 0 1 .536 -2.022a1.867 1.867 0 0 1 2.28 .28l1.47 1.47"
  }), e.createElement("path", {
    d: "M11 5.5v-2a1.5 1.5 0 1 1 3 0v8.5"
  }), e.createElement("path", {
    d: "M14 5.5a1.5 1.5 0 0 1 3 0v6.5"
  }));
}
var y6 = ["size", "color", "stroke"];
function C6(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, y6);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-hand-two-fingers",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M8 13v-8.5a1.5 1.5 0 0 1 3 0v7.5"
  }), e.createElement("path", {
    d: "M17 11.5a1.5 1.5 0 0 1 3 0v4.5a6 6 0 0 1 -6 6h-2h.208a6 6 0 0 1 -5.012 -2.7a69.74 69.74 0 0 1 -.196 -.3c-.312 -.479 -1.407 -2.388 -3.286 -5.728a1.5 1.5 0 0 1 .536 -2.022a1.867 1.867 0 0 1 2.28 .28l1.47 1.47"
  }), e.createElement("path", {
    d: "M14 10.5a1.5 1.5 0 0 1 3 0v1.5"
  }), e.createElement("path", {
    d: "M11 5.5v-2a1.5 1.5 0 1 1 3 0v8.5"
  }));
}
var j6 = ["size", "color", "stroke"];
function B6(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, j6);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-hanger-2",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M12 9l-7.971 4.428a2 2 0 0 0 -1.029 1.749v.823a2 2 0 0 0 2 2h1"
  }), e.createElement("path", {
    d: "M18 18h1a2 2 0 0 0 2 -2v-.823a2 2 0 0 0 -1.029 -1.749l-7.971 -4.428c-1.457 -.81 -1.993 -2.333 -1.996 -4a2 2 0 1 1 4 0"
  }), e.createElement("rect", {
    x: 6,
    y: 16,
    width: 12,
    height: 5,
    rx: 2
  }));
}
var H6 = ["size", "color", "stroke"];
function N6(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, H6);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-hanger-off",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M14.004 6a2 2 0 1 0 -4 0m6.506 6.506l3.461 1.922a2 2 0 0 1 1.029 1.749v.823m-2 2h-14a2 2 0 0 1 -2 -2v-.823a2 2 0 0 1 1.029 -1.749l6.673 -3.707"
  }), e.createElement("path", {
    d: "M3 3l18 18"
  }));
}
var W6 = ["size", "color", "stroke"];
function q6(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, W6);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-hanger",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M14.004 6a2 2 0 1 0 -4 0c.003 1.667 .67 3 2.004 4h-.008l7.971 4.428a2 2 0 0 1 1.029 1.749v.823a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2v-.823a2 2 0 0 1 1.029 -1.749l7.971 -4.428"
  }));
}
var O6 = ["size", "color", "stroke"];
function P6(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, O6);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-hash",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("line", {
    x1: 5,
    y1: 9,
    x2: 19,
    y2: 9
  }), e.createElement("line", {
    x1: 5,
    y1: 15,
    x2: 19,
    y2: 15
  }), e.createElement("line", {
    x1: 11,
    y1: 4,
    x2: 7,
    y2: 20
  }), e.createElement("line", {
    x1: 17,
    y1: 4,
    x2: 13,
    y2: 20
  }));
}
var S6 = ["size", "color", "stroke"];
function I6(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, S6);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-haze",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M3 12h1"
  }), e.createElement("path", {
    d: "M12 3v1"
  }), e.createElement("path", {
    d: "M20 12h1"
  }), e.createElement("path", {
    d: "M5.6 5.6l.7 .7"
  }), e.createElement("path", {
    d: "M18.4 5.6l-.7 .7"
  }), e.createElement("path", {
    d: "M8 12a4 4 0 1 1 8 0"
  }), e.createElement("path", {
    d: "M3 16h18"
  }), e.createElement("path", {
    d: "M3 20h18"
  }));
}
var A6 = ["size", "color", "stroke"];
function D6(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, A6);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-heading-off",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M7 12h5m4 0h1"
  }), e.createElement("path", {
    d: "M7 7v12"
  }), e.createElement("path", {
    d: "M17 5v8m0 4v2"
  }), e.createElement("path", {
    d: "M15 19h4"
  }), e.createElement("path", {
    d: "M15 5h4"
  }), e.createElement("path", {
    d: "M5 19h4"
  }), e.createElement("path", {
    d: "M3 3l18 18"
  }));
}
var F6 = ["size", "color", "stroke"];
function G6(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, F6);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-heading",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M7 12h10"
  }), e.createElement("path", {
    d: "M7 5v14"
  }), e.createElement("path", {
    d: "M17 5v14"
  }), e.createElement("path", {
    d: "M15 19h4"
  }), e.createElement("path", {
    d: "M15 5h4"
  }), e.createElement("path", {
    d: "M5 19h4"
  }), e.createElement("path", {
    d: "M5 5h4"
  }));
}
var J6 = ["size", "color", "stroke"];
function K6(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, J6);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-headphones-off",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("line", {
    x1: 3,
    y1: 3,
    x2: 21,
    y2: 21
  }), e.createElement("rect", {
    x: 4,
    y: 13,
    width: 5,
    height: 7,
    rx: 2
  }), e.createElement("path", {
    d: "M17 13h1a2 2 0 0 1 2 2v1m-.589 3.417c-.361 .36 -.86 .583 -1.411 .583h-1a2 2 0 0 1 -2 -2v-3"
  }), e.createElement("path", {
    d: "M4 15v-3c0 -2.21 .896 -4.21 2.344 -5.658m2.369 -1.638a8 8 0 0 1 11.287 7.296v3"
  }));
}
var Q6 = ["size", "color", "stroke"];
function R6(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Q6);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-headphones",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("rect", {
    x: 4,
    y: 13,
    rx: 2,
    width: 5,
    height: 7
  }), e.createElement("rect", {
    x: 15,
    y: 13,
    rx: 2,
    width: 5,
    height: 7
  }), e.createElement("path", {
    d: "M4 15v-3a8 8 0 0 1 16 0v3"
  }));
}
var T6 = ["size", "color", "stroke"];
function U6(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, T6);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-headset-off",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("rect", {
    x: 4,
    y: 13,
    width: 4,
    height: 6,
    rx: 2
  }), e.createElement("path", {
    d: "M17.185 13.173a2 2 0 0 1 2.815 1.827v1m-1.18 2.825a2 2 0 0 1 -2.82 -1.825v-1"
  }), e.createElement("path", {
    d: "M4 15v-3c0 -2.208 .894 -4.207 2.34 -5.654m2.377 -1.643a8 8 0 0 1 11.283 7.297v3"
  }), e.createElement("path", {
    d: "M18 19c0 1.657 -2.686 3 -6 3"
  }), e.createElement("path", {
    d: "M3 3l18 18"
  }));
}
var V6 = ["size", "color", "stroke"];
function X6(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, V6);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-headset",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("rect", {
    x: 4,
    y: 13,
    rx: 2,
    width: 4,
    height: 6
  }), e.createElement("rect", {
    x: 16,
    y: 13,
    rx: 2,
    width: 4,
    height: 6
  }), e.createElement("path", {
    d: "M4 15v-3a8 8 0 0 1 16 0v3"
  }), e.createElement("path", {
    d: "M18 19a6 3 0 0 1 -6 3"
  }));
}
var Y6 = ["size", "color", "stroke"];
function Z6(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Y6);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-health-recognition",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M4 8v-2a2 2 0 0 1 2 -2h2"
  }), e.createElement("path", {
    d: "M4 16v2a2 2 0 0 0 2 2h2"
  }), e.createElement("path", {
    d: "M16 4h2a2 2 0 0 1 2 2v2"
  }), e.createElement("path", {
    d: "M16 20h2a2 2 0 0 0 2 -2v-2"
  }), e.createElement("path", {
    d: "M8.603 9.61a2.04 2.04 0 0 1 2.912 0l.485 .39l.5 -.396a2.035 2.035 0 0 1 2.897 .007a2.104 2.104 0 0 1 0 2.949l-3.397 3.44l-3.397 -3.44a2.104 2.104 0 0 1 0 -2.95z"
  }));
}
var $6 = ["size", "color", "stroke"];
function _6(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, $6);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-heart-broken",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M19.5 12.572l-7.5 7.428l-7.5 -7.428a5 5 0 1 1 7.5 -6.566a5 5 0 1 1 7.5 6.572"
  }), e.createElement("path", {
    d: "M12 6l-2 4l4 3l-2 4v3"
  }));
}
var e8 = ["size", "color", "stroke"];
function t8(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, e8);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-heart-handshake",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M19.5 12.572l-7.5 7.428l-7.5 -7.428a5 5 0 1 1 7.5 -6.566a5 5 0 1 1 7.5 6.572"
  }), e.createElement("path", {
    d: "M12 6l-3.293 3.293a1 1 0 0 0 0 1.414l.543 .543c.69 .69 1.81 .69 2.5 0l1 -1a3.182 3.182 0 0 1 4.5 0l2.25 2.25"
  }), e.createElement("path", {
    d: "M12.5 15.5l2 2"
  }), e.createElement("path", {
    d: "M15 13l2 2"
  }));
}
var o8 = ["size", "color", "stroke"];
function r8(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, o8);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-heart-minus",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M13 19l-1 1l-7.5 -7.428a5 5 0 1 1 7.5 -6.566a5 5 0 0 1 8 6"
  }), e.createElement("path", {
    d: "M14 16h6"
  }));
}
var n8 = ["size", "color", "stroke"];
function l8(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, n8);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-heart-off",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M3 3l18 18"
  }), e.createElement("path", {
    d: "M19.5 12.572l-1.5 1.428m-2 2l-4 4l-7.5 -7.428m0 0a5 5 0 0 1 -1.288 -5.068a4.976 4.976 0 0 1 1.788 -2.504m3 -1c1.56 .003 3.05 .727 4 2.006a5 5 0 1 1 7.5 6.572"
  }));
}
var a8 = ["size", "color", "stroke"];
function i8(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, a8);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-heart-plus",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M13 19l-1 1l-7.5 -7.428a5 5 0 1 1 7.5 -6.566a5 5 0 0 1 8.003 5.996"
  }), e.createElement("path", {
    d: "M14 16h6"
  }), e.createElement("path", {
    d: "M17 13v6"
  }));
}
var c8 = ["size", "color", "stroke"];
function s8(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, c8);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-heart-rate-monitor",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("rect", {
    x: 3,
    y: 4,
    width: 18,
    height: 12,
    rx: 1
  }), e.createElement("path", {
    d: "M7 20h10"
  }), e.createElement("path", {
    d: "M9 16v4"
  }), e.createElement("path", {
    d: "M15 16v4"
  }), e.createElement("path", {
    d: "M7 10h2l2 3l2 -6l1 3h3"
  }));
}
var h8 = ["size", "color", "stroke"];
function d8(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, h8);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-heart",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M19.5 12.572l-7.5 7.428l-7.5 -7.428m0 0a5 5 0 1 1 7.5 -6.566a5 5 0 1 1 7.5 6.572"
  }));
}
var v8 = ["size", "color", "stroke"];
function m8(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, v8);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-heartbeat",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M19.5 13.572l-7.5 7.428l-2.896 -2.868m-6.117 -8.104a5 5 0 0 1 9.013 -3.022a5 5 0 1 1 7.5 6.572"
  }), e.createElement("path", {
    d: "M3 13h2l2 3l2 -6l1 3h3"
  }));
}
var k8 = ["size", "color", "stroke"];
function w8(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, k8);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-hearts-off",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M14.017 18.001l-2.017 1.999l-7.5 -7.428a5 5 0 0 1 .49 -7.586m3.01 -.998a5 5 0 0 1 4 2.018a5 5 0 0 1 8.153 5.784"
  }), e.createElement("path", {
    d: "M11.814 11.814a2.81 2.81 0 0 0 -.007 3.948l4.182 4.238l2.01 -2.021m1.977 -1.99l.211 -.212a2.81 2.81 0 0 0 .006 -3.948a2.747 2.747 0 0 0 -3.91 -.007l-.283 .178"
  }), e.createElement("path", {
    d: "M3 3l18 18"
  }));
}
var p8 = ["size", "color", "stroke"];
function E8(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, p8);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-hearts",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M14.017 18.001l-2.017 1.999l-7.5 -7.428a5 5 0 1 1 7.5 -6.566a5 5 0 0 1 8.153 5.784"
  }), e.createElement("path", {
    d: "M15.99 20l4.197 -4.223a2.81 2.81 0 0 0 .006 -3.948a2.747 2.747 0 0 0 -3.91 -.007l-.28 .282l-.279 -.283a2.747 2.747 0 0 0 -3.91 -.007a2.81 2.81 0 0 0 -.007 3.948l4.182 4.238z"
  }));
}
var u8 = ["size", "color", "stroke"];
function g8(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, u8);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-helicopter-landing",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("rect", {
    x: 4,
    y: 4,
    width: 16,
    height: 16,
    rx: 2
  }), e.createElement("line", {
    x1: 9,
    y1: 8,
    x2: 9,
    y2: 16
  }), e.createElement("line", {
    x1: 9,
    y1: 12,
    x2: 15,
    y2: 12
  }), e.createElement("line", {
    x1: 15,
    y1: 8,
    x2: 15,
    y2: 16
  }));
}
var M8 = ["size", "color", "stroke"];
function x8(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, M8);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-helicopter",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M3 10l1 2h6"
  }), e.createElement("path", {
    d: "M12 9a2 2 0 0 0 -2 2v3c0 1.1 .9 2 2 2h7a2 2 0 0 0 2 -2c0 -3.31 -3.13 -5 -7 -5h-2z"
  }), e.createElement("line", {
    x1: 13,
    y1: 9,
    x2: 13,
    y2: 6
  }), e.createElement("line", {
    x1: 5,
    y1: 6,
    x2: 20,
    y2: 6
  }), e.createElement("path", {
    d: "M15 9.1v3.9h5.5"
  }), e.createElement("line", {
    x1: 15,
    y1: 19,
    x2: 15,
    y2: 16
  }), e.createElement("line", {
    x1: 19,
    y1: 19,
    x2: 11,
    y2: 19
  }));
}
var f8 = ["size", "color", "stroke"];
function z8(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, f8);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-helmet-off",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M8.633 4.654a9 9 0 0 1 11.718 11.7m-1.503 2.486a9.008 9.008 0 0 1 -1.192 1.16h-11.312a9 9 0 0 1 -.185 -13.847"
  }), e.createElement("path", {
    d: "M20 9h-7m-2.768 1.246c.507 2 1.596 3.418 3.268 4.254c.524 .262 1.07 .49 1.64 .683"
  }), e.createElement("path", {
    d: "M3 3l18 18"
  }));
}
var b8 = ["size", "color", "stroke"];
function L8(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, b8);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-helmet",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M12 4a9 9 0 0 1 5.656 16h-11.312a9 9 0 0 1 5.656 -16z"
  }), e.createElement("path", {
    d: "M20 9h-8.8a1 1 0 0 0 -.968 1.246c.507 2 1.596 3.418 3.268 4.254c2 1 4.333 1.5 7 1.5"
  }));
}
var y8 = ["size", "color", "stroke"];
function C8(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, y8);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-help-off",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M5.641 5.631a9 9 0 1 0 12.719 12.738m1.68 -2.318a9 9 0 0 0 -12.074 -12.098"
  }), e.createElement("path", {
    d: "M12 17v.01"
  }), e.createElement("path", {
    d: "M12 13.5a1.5 1.5 0 0 1 .394 -1.1m2.106 -1.9a2.6 2.6 0 0 0 -3.347 -3.361"
  }), e.createElement("path", {
    d: "M3 3l18 18"
  }));
}
var j8 = ["size", "color", "stroke"];
function B8(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, j8);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-help",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 9
  }), e.createElement("line", {
    x1: 12,
    y1: 17,
    x2: 12,
    y2: 17.01
  }), e.createElement("path", {
    d: "M12 13.5a1.5 1.5 0 0 1 1 -1.5a2.6 2.6 0 1 0 -3 -4"
  }));
}
var H8 = ["size", "color", "stroke"];
function N8(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, H8);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-hexagon-3d",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M19 6.844a2.007 2.007 0 0 1 1 1.752v6.555c0 .728 -.394 1.399 -1.03 1.753l-5.999 3.844a1.995 1.995 0 0 1 -1.942 0l-6 -3.844a2.007 2.007 0 0 1 -1.029 -1.752v-6.556c0 -.729 .394 -1.4 1.029 -1.753l6 -3.583a2.05 2.05 0 0 1 2 0l6 3.584h-.03z"
  }), e.createElement("path", {
    d: "M12 16.5v4.5"
  }), e.createElement("path", {
    d: "M4.5 7.5l3.5 2.5"
  }), e.createElement("path", {
    d: "M16 10l4 -2.5"
  }), e.createElement("path", {
    d: "M12 7.5v4.5l-4 2"
  }), e.createElement("path", {
    d: "M12 12l4 2"
  }), e.createElement("path", {
    d: "M12 16.5l4 -2.5v-4l-4 -2.5l-4 2.5v4z"
  }));
}
var W8 = ["size", "color", "stroke"];
function q8(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, W8);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-hexagon-letter-a",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M19 6.873a2 2 0 0 1 1 1.747v6.536a2 2 0 0 1 -1.029 1.748l-6 3.833a2 2 0 0 1 -1.942 0l-6 -3.833a2 2 0 0 1 -1.029 -1.747v-6.537a2 2 0 0 1 1.029 -1.748l6 -3.572a2.056 2.056 0 0 1 2 0l6 3.573h-.029z"
  }), e.createElement("path", {
    d: "M10 16v-6a2 2 0 1 1 4 0v6"
  }), e.createElement("path", {
    d: "M10 13h4"
  }));
}
var O8 = ["size", "color", "stroke"];
function P8(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, O8);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-hexagon-letter-b",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M19 6.873a2 2 0 0 1 1 1.747v6.536a2 2 0 0 1 -1.029 1.748l-6 3.833a2 2 0 0 1 -1.942 0l-6 -3.833a2 2 0 0 1 -1.029 -1.747v-6.537a2 2 0 0 1 1.029 -1.748l6 -3.572a2.056 2.056 0 0 1 2 0l6 3.573h-.029z"
  }), e.createElement("path", {
    d: "M10 16h2a2 2 0 1 0 0 -4h-2h2a2 2 0 1 0 0 -4h-2v8z"
  }));
}
var S8 = ["size", "color", "stroke"];
function I8(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, S8);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-hexagon-letter-c",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M19 6.873a2 2 0 0 1 1 1.747v6.536a2 2 0 0 1 -1.029 1.748l-6 3.833a2 2 0 0 1 -1.942 0l-6 -3.833a2 2 0 0 1 -1.029 -1.747v-6.537a2 2 0 0 1 1.029 -1.748l6 -3.572a2.056 2.056 0 0 1 2 0l6 3.573h-.029z"
  }), e.createElement("path", {
    d: "M14 10a2 2 0 1 0 -4 0v4a2 2 0 1 0 4 0"
  }));
}
var A8 = ["size", "color", "stroke"];
function D8(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, A8);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-hexagon-letter-d",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M19 6.873a2 2 0 0 1 1 1.747v6.536a2 2 0 0 1 -1.029 1.748l-6 3.833a2 2 0 0 1 -1.942 0l-6 -3.833a2 2 0 0 1 -1.029 -1.747v-6.537a2 2 0 0 1 1.029 -1.748l6 -3.572a2.056 2.056 0 0 1 2 0l6 3.573h-.029z"
  }), e.createElement("path", {
    d: "M10 8v8h2a2 2 0 0 0 2 -2v-4a2 2 0 0 0 -2 -2h-2z"
  }));
}
var F8 = ["size", "color", "stroke"];
function G8(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, F8);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-hexagon-letter-e",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M19 6.873a2 2 0 0 1 1 1.747v6.536a2 2 0 0 1 -1.029 1.748l-6 3.833a2 2 0 0 1 -1.942 0l-6 -3.833a2 2 0 0 1 -1.029 -1.747v-6.537a2 2 0 0 1 1.029 -1.748l6 -3.572a2.056 2.056 0 0 1 2 0l6 3.573h-.029z"
  }), e.createElement("path", {
    d: "M14 8h-4v8h4"
  }), e.createElement("path", {
    d: "M10 12h2.5"
  }));
}
var J8 = ["size", "color", "stroke"];
function K8(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, J8);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-hexagon-letter-f",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M19 6.873a2 2 0 0 1 1 1.747v6.536a2 2 0 0 1 -1.029 1.748l-6 3.833a2 2 0 0 1 -1.942 0l-6 -3.833a2 2 0 0 1 -1.029 -1.747v-6.537a2 2 0 0 1 1.029 -1.748l6 -3.572a2.056 2.056 0 0 1 2 0l6 3.573h-.029z"
  }), e.createElement("path", {
    d: "M10 12h3"
  }), e.createElement("path", {
    d: "M14 8h-4v8"
  }));
}
var Q8 = ["size", "color", "stroke"];
function R8(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Q8);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-hexagon-letter-g",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M19 6.873a2 2 0 0 1 1 1.747v6.536a2 2 0 0 1 -1.029 1.748l-6 3.833a2 2 0 0 1 -1.942 0l-6 -3.833a2 2 0 0 1 -1.029 -1.747v-6.537a2 2 0 0 1 1.029 -1.748l6 -3.572a2.056 2.056 0 0 1 2 0l6 3.573h-.029z"
  }), e.createElement("path", {
    d: "M14 8h-2a2 2 0 0 0 -2 2v4a2 2 0 0 0 2 2h2v-4h-1"
  }));
}
var T8 = ["size", "color", "stroke"];
function U8(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, T8);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-hexagon-letter-h",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M19 6.873a2 2 0 0 1 1 1.747v6.536a2 2 0 0 1 -1.029 1.748l-6 3.833a2 2 0 0 1 -1.942 0l-6 -3.833a2 2 0 0 1 -1.029 -1.747v-6.537a2 2 0 0 1 1.029 -1.748l6 -3.572a2.056 2.056 0 0 1 2 0l6 3.573h-.029z"
  }), e.createElement("path", {
    d: "M10 16v-8m4 0v8"
  }), e.createElement("path", {
    d: "M10 12h4"
  }));
}
var V8 = ["size", "color", "stroke"];
function X8(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, V8);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-hexagon-letter-i",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M19 6.873a2 2 0 0 1 1 1.747v6.536a2 2 0 0 1 -1.029 1.748l-6 3.833a2 2 0 0 1 -1.942 0l-6 -3.833a2 2 0 0 1 -1.029 -1.747v-6.537a2 2 0 0 1 1.029 -1.748l6 -3.572a2.056 2.056 0 0 1 2 0l6 3.573h-.029z"
  }), e.createElement("path", {
    d: "M12 8v8"
  }));
}
var Y8 = ["size", "color", "stroke"];
function Z8(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Y8);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-hexagon-letter-j",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M19 6.873a2 2 0 0 1 1 1.747v6.536a2 2 0 0 1 -1.029 1.748l-6 3.833a2 2 0 0 1 -1.942 0l-6 -3.833a2 2 0 0 1 -1.029 -1.747v-6.537a2 2 0 0 1 1.029 -1.748l6 -3.572a2.056 2.056 0 0 1 2 0l6 3.573h-.029z"
  }), e.createElement("path", {
    d: "M10 8h4v6a2 2 0 1 1 -4 0"
  }));
}
var $8 = ["size", "color", "stroke"];
function _8(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, $8);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-hexagon-letter-k",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M19 6.873a2 2 0 0 1 1 1.747v6.536a2 2 0 0 1 -1.029 1.748l-6 3.833a2 2 0 0 1 -1.942 0l-6 -3.833a2 2 0 0 1 -1.029 -1.747v-6.537a2 2 0 0 1 1.029 -1.748l6 -3.572a2.056 2.056 0 0 1 2 0l6 3.573h-.029z"
  }), e.createElement("path", {
    d: "M10 8v8"
  }), e.createElement("path", {
    d: "M14 8l-2.5 4l2.5 4"
  }), e.createElement("path", {
    d: "M10 12h1.5"
  }));
}
var e7 = ["size", "color", "stroke"];
function t7(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, e7);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-hexagon-letter-l",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M19 6.873a2 2 0 0 1 1 1.747v6.536a2 2 0 0 1 -1.029 1.748l-6 3.833a2 2 0 0 1 -1.942 0l-6 -3.833a2 2 0 0 1 -1.029 -1.747v-6.537a2 2 0 0 1 1.029 -1.748l6 -3.572a2.056 2.056 0 0 1 2 0l6 3.573h-.029z"
  }), e.createElement("path", {
    d: "M10 8v8h4"
  }));
}
var o7 = ["size", "color", "stroke"];
function r7(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, o7);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-hexagon-letter-m",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M19 6.873a2 2 0 0 1 1 1.747v6.536a2 2 0 0 1 -1.029 1.748l-6 3.833a2 2 0 0 1 -1.942 0l-6 -3.833a2 2 0 0 1 -1.029 -1.747v-6.537a2 2 0 0 1 1.029 -1.748l6 -3.572a2.056 2.056 0 0 1 2 0l6 3.573h-.029z"
  }), e.createElement("path", {
    d: "M9 16v-8l3 5l3 -5v8"
  }));
}
var n7 = ["size", "color", "stroke"];
function l7(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, n7);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-hexagon-letter-n",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M19 6.873a2 2 0 0 1 1 1.747v6.536a2 2 0 0 1 -1.029 1.748l-6 3.833a2 2 0 0 1 -1.942 0l-6 -3.833a2 2 0 0 1 -1.029 -1.747v-6.537a2 2 0 0 1 1.029 -1.748l6 -3.572a2.056 2.056 0 0 1 2 0l6 3.573h-.029z"
  }), e.createElement("path", {
    d: "M10 16v-8l4 8v-8"
  }));
}
var a7 = ["size", "color", "stroke"];
function i7(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, a7);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-hexagon-letter-o",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M19 6.873a2 2 0 0 1 1 1.747v6.536a2 2 0 0 1 -1.029 1.748l-6 3.833a2 2 0 0 1 -1.942 0l-6 -3.833a2 2 0 0 1 -1.029 -1.747v-6.537a2 2 0 0 1 1.029 -1.748l6 -3.572a2.056 2.056 0 0 1 2 0l6 3.573h-.029z"
  }), e.createElement("path", {
    d: "M12 8a2 2 0 0 1 2 2v4a2 2 0 1 1 -4 0v-4a2 2 0 0 1 2 -2z"
  }));
}
var c7 = ["size", "color", "stroke"];
function s7(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, c7);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-hexagon-letter-p",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M19 6.873a2 2 0 0 1 1 1.747v6.536a2 2 0 0 1 -1.029 1.748l-6 3.833a2 2 0 0 1 -1.942 0l-6 -3.833a2 2 0 0 1 -1.029 -1.747v-6.537a2 2 0 0 1 1.029 -1.748l6 -3.572a2.056 2.056 0 0 1 2 0l6 3.573h-.029z"
  }), e.createElement("path", {
    d: "M10 12h2a2 2 0 1 0 0 -4h-2v8"
  }));
}
var h7 = ["size", "color", "stroke"];
function d7(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, h7);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-hexagon-letter-q",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M19 6.873a2 2 0 0 1 1 1.747v6.536a2 2 0 0 1 -1.029 1.748l-6 3.833a2 2 0 0 1 -1.942 0l-6 -3.833a2 2 0 0 1 -1.029 -1.747v-6.537a2 2 0 0 1 1.029 -1.748l6 -3.572a2.056 2.056 0 0 1 2 0l6 3.573h-.029z"
  }), e.createElement("path", {
    d: "M12 8a2 2 0 0 1 2 2v4a2 2 0 1 1 -4 0v-4a2 2 0 0 1 2 -2z"
  }), e.createElement("path", {
    d: "M13 15l1 1"
  }));
}
var v7 = ["size", "color", "stroke"];
function m7(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, v7);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-hexagon-letter-r",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M19 6.873a2 2 0 0 1 1 1.747v6.536a2 2 0 0 1 -1.029 1.748l-6 3.833a2 2 0 0 1 -1.942 0l-6 -3.833a2 2 0 0 1 -1.029 -1.747v-6.537a2 2 0 0 1 1.029 -1.748l6 -3.572a2.056 2.056 0 0 1 2 0l6 3.573h-.029z"
  }), e.createElement("path", {
    d: "M10 12h2a2 2 0 1 0 0 -4h-2v8m4 0l-3 -4"
  }));
}
var k7 = ["size", "color", "stroke"];
function w7(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, k7);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-hexagon-letter-s",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M19 6.873a2 2 0 0 1 1 1.747v6.536a2 2 0 0 1 -1.029 1.748l-6 3.833a2 2 0 0 1 -1.942 0l-6 -3.833a2 2 0 0 1 -1.029 -1.747v-6.537a2 2 0 0 1 1.029 -1.748l6 -3.572a2.056 2.056 0 0 1 2 0l6 3.573h-.029z"
  }), e.createElement("path", {
    d: "M10 15a1 1 0 0 0 1 1h2a1 1 0 0 0 1 -1v-2a1 1 0 0 0 -1 -1h-2a1 1 0 0 1 -1 -1v-2a1 1 0 0 1 1 -1h2a1 1 0 0 1 1 1"
  }));
}
var p7 = ["size", "color", "stroke"];
function E7(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, p7);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-hexagon-letter-t",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M19 6.873a2 2 0 0 1 1 1.747v6.536a2 2 0 0 1 -1.029 1.748l-6 3.833a2 2 0 0 1 -1.942 0l-6 -3.833a2 2 0 0 1 -1.029 -1.747v-6.537a2 2 0 0 1 1.029 -1.748l6 -3.572a2.056 2.056 0 0 1 2 0l6 3.573h-.029z"
  }), e.createElement("path", {
    d: "M10 8h4"
  }), e.createElement("path", {
    d: "M12 8v8"
  }));
}
var u7 = ["size", "color", "stroke"];
function g7(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, u7);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-hexagon-letter-u",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M19 6.873a2 2 0 0 1 1 1.747v6.536a2 2 0 0 1 -1.029 1.748l-6 3.833a2 2 0 0 1 -1.942 0l-6 -3.833a2 2 0 0 1 -1.029 -1.747v-6.537a2 2 0 0 1 1.029 -1.748l6 -3.572a2.056 2.056 0 0 1 2 0l6 3.573h-.029z"
  }), e.createElement("path", {
    d: "M10 8v6a2 2 0 1 0 4 0v-6"
  }));
}
var M7 = ["size", "color", "stroke"];
function x7(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, M7);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-hexagon-letter-v",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M19 6.873a2 2 0 0 1 1 1.747v6.536a2 2 0 0 1 -1.029 1.748l-6 3.833a2 2 0 0 1 -1.942 0l-6 -3.833a2 2 0 0 1 -1.029 -1.747v-6.537a2 2 0 0 1 1.029 -1.748l6 -3.572a2.056 2.056 0 0 1 2 0l6 3.573h-.029z"
  }), e.createElement("path", {
    d: "M10 8l2 8l2 -8"
  }));
}
var f7 = ["size", "color", "stroke"];
function z7(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, f7);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-hexagon-letter-w",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M19 6.873a2 2 0 0 1 1 1.747v6.536a2 2 0 0 1 -1.029 1.748l-6 3.833a2 2 0 0 1 -1.942 0l-6 -3.833a2 2 0 0 1 -1.029 -1.747v-6.537a2 2 0 0 1 1.029 -1.748l6 -3.572a2.056 2.056 0 0 1 2 0l6 3.573h-.029z"
  }), e.createElement("path", {
    d: "M9 8l1 8l2 -5l2 5l1 -8"
  }));
}
var b7 = ["size", "color", "stroke"];
function L7(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, b7);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-hexagon-letter-x",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M19 6.873a2 2 0 0 1 1 1.747v6.536a2 2 0 0 1 -1.029 1.748l-6 3.833a2 2 0 0 1 -1.942 0l-6 -3.833a2 2 0 0 1 -1.029 -1.747v-6.537a2 2 0 0 1 1.029 -1.748l6 -3.572a2.056 2.056 0 0 1 2 0l6 3.573h-.029z"
  }), e.createElement("path", {
    d: "M10 8l4 8"
  }), e.createElement("path", {
    d: "M10 16l4 -8"
  }));
}
var y7 = ["size", "color", "stroke"];
function C7(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, y7);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-hexagon-letter-y",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M19 6.873a2 2 0 0 1 1 1.747v6.536a2 2 0 0 1 -1.029 1.748l-6 3.833a2 2 0 0 1 -1.942 0l-6 -3.833a2 2 0 0 1 -1.029 -1.747v-6.537a2 2 0 0 1 1.029 -1.748l6 -3.572a2.056 2.056 0 0 1 2 0l6 3.573h-.029z"
  }), e.createElement("path", {
    d: "M10 8l2 5l2 -5"
  }), e.createElement("path", {
    d: "M12 16v-3"
  }));
}
var j7 = ["size", "color", "stroke"];
function B7(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, j7);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-hexagon-letter-z",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M19 6.873a2 2 0 0 1 1 1.747v6.536a2 2 0 0 1 -1.029 1.748l-6 3.833a2 2 0 0 1 -1.942 0l-6 -3.833a2 2 0 0 1 -1.029 -1.747v-6.537a2 2 0 0 1 1.029 -1.748l6 -3.572a2.056 2.056 0 0 1 2 0l6 3.573h-.029z"
  }), e.createElement("path", {
    d: "M10 8h4l-4 8h4"
  }));
}
var H7 = ["size", "color", "stroke"];
function N7(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, H7);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-hexagon-number-0",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M19 6.873a2 2 0 0 1 1 1.747v6.536a2 2 0 0 1 -1.029 1.748l-6 3.833a2 2 0 0 1 -1.942 0l-6 -3.833a2 2 0 0 1 -1.029 -1.747v-6.537a2 2 0 0 1 1.029 -1.748l6 -3.572a2.056 2.056 0 0 1 2 0l6 3.573h-.029z"
  }), e.createElement("path", {
    d: "M10 10v4a2 2 0 1 0 4 0v-4a2 2 0 1 0 -4 0z"
  }));
}
var W7 = ["size", "color", "stroke"];
function q7(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, W7);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-hexagon-number-1",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M19 6.873a2 2 0 0 1 1 1.747v6.536a2 2 0 0 1 -1.029 1.748l-6 3.833a2 2 0 0 1 -1.942 0l-6 -3.833a2 2 0 0 1 -1.029 -1.747v-6.537a2 2 0 0 1 1.029 -1.748l6 -3.572a2.056 2.056 0 0 1 2 0l6 3.573h-.029z"
  }), e.createElement("path", {
    d: "M10 10l2 -2v8"
  }));
}
var O7 = ["size", "color", "stroke"];
function P7(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, O7);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-hexagon-number-2",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M19 6.873a2 2 0 0 1 1 1.747v6.536a2 2 0 0 1 -1.029 1.748l-6 3.833a2 2 0 0 1 -1.942 0l-6 -3.833a2 2 0 0 1 -1.029 -1.747v-6.537a2 2 0 0 1 1.029 -1.748l6 -3.572a2.056 2.056 0 0 1 2 0l6 3.573h-.029z"
  }), e.createElement("path", {
    d: "M10 8h3a1 1 0 0 1 1 1v2a1 1 0 0 1 -1 1h-2a1 1 0 0 0 -1 1v2a1 1 0 0 0 1 1h3"
  }));
}
var S7 = ["size", "color", "stroke"];
function I7(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, S7);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-hexagon-number-3",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M19 6.873a2 2 0 0 1 1 1.747v6.536a2 2 0 0 1 -1.029 1.748l-6 3.833a2 2 0 0 1 -1.942 0l-6 -3.833a2 2 0 0 1 -1.029 -1.747v-6.537a2 2 0 0 1 1.029 -1.748l6 -3.572a2.056 2.056 0 0 1 2 0l6 3.573h-.029z"
  }), e.createElement("path", {
    d: "M10 9a1 1 0 0 1 1 -1h2a1 1 0 0 1 1 1v2a1 1 0 0 1 -1 1h-2h2a1 1 0 0 1 1 1v2a1 1 0 0 1 -1 1h-2a1 1 0 0 1 -1 -1"
  }));
}
var A7 = ["size", "color", "stroke"];
function D7(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, A7);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-hexagon-number-4",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M19 6.873a2 2 0 0 1 1 1.747v6.536a2 2 0 0 1 -1.029 1.748l-6 3.833a2 2 0 0 1 -1.942 0l-6 -3.833a2 2 0 0 1 -1.029 -1.747v-6.537a2 2 0 0 1 1.029 -1.748l6 -3.572a2.056 2.056 0 0 1 2 0l6 3.573h-.029z"
  }), e.createElement("path", {
    d: "M10 8v3a1 1 0 0 0 1 1h3"
  }), e.createElement("path", {
    d: "M14 8v8"
  }));
}
var F7 = ["size", "color", "stroke"];
function G7(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, F7);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-hexagon-number-5",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M19 6.873a2 2 0 0 1 1 1.747v6.536a2 2 0 0 1 -1.029 1.748l-6 3.833a2 2 0 0 1 -1.942 0l-6 -3.833a2 2 0 0 1 -1.029 -1.747v-6.537a2 2 0 0 1 1.029 -1.748l6 -3.572a2.056 2.056 0 0 1 2 0l6 3.573h-.029z"
  }), e.createElement("path", {
    d: "M10 15a1 1 0 0 0 1 1h2a1 1 0 0 0 1 -1v-2a1 1 0 0 0 -1 -1h-3v-4h4"
  }));
}
var J7 = ["size", "color", "stroke"];
function K7(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, J7);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-hexagon-number-6",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M19 6.873a2 2 0 0 1 1 1.747v6.536a2 2 0 0 1 -1.029 1.748l-6 3.833a2 2 0 0 1 -1.942 0l-6 -3.833a2 2 0 0 1 -1.029 -1.747v-6.537a2 2 0 0 1 1.029 -1.748l6 -3.572a2.056 2.056 0 0 1 2 0l6 3.573h-.029z"
  }), e.createElement("path", {
    d: "M14 9a1 1 0 0 0 -1 -1h-2a1 1 0 0 0 -1 1v6a1 1 0 0 0 1 1h2a1 1 0 0 0 1 -1v-2a1 1 0 0 0 -1 -1h-3"
  }));
}
var Q7 = ["size", "color", "stroke"];
function R7(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Q7);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-hexagon-number-7",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M19.02 6.858a2.006 2.006 0 0 1 1.003 1.752v6.555c0 .728 -.395 1.4 -1.032 1.753l-6.017 3.844a2.006 2.006 0 0 1 -1.948 0l-6.016 -3.844a2.006 2.006 0 0 1 -1.032 -1.752v-6.556c0 -.728 .395 -1.4 1.032 -1.753l6.017 -3.582a2.062 2.062 0 0 1 2.006 0l6.017 3.583h-.029z"
  }), e.createElement("path", {
    d: "M10 8h4l-2 8"
  }));
}
var T7 = ["size", "color", "stroke"];
function U7(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, T7);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-hexagon-number-8",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M19 6.873a2 2 0 0 1 1 1.747v6.536a2 2 0 0 1 -1.029 1.748l-6 3.833a2 2 0 0 1 -1.942 0l-6 -3.833a2 2 0 0 1 -1.029 -1.747v-6.537a2 2 0 0 1 1.029 -1.748l6 -3.572a2.056 2.056 0 0 1 2 0l6 3.573h-.029z"
  }), e.createElement("path", {
    d: "M12 12h-1a1 1 0 0 1 -1 -1v-2a1 1 0 0 1 1 -1h2a1 1 0 0 1 1 1v2a1 1 0 0 1 -1 1h-2a1 1 0 0 0 -1 1v2a1 1 0 0 0 1 1h2a1 1 0 0 0 1 -1v-2a1 1 0 0 0 -1 -1"
  }));
}
var V7 = ["size", "color", "stroke"];
function X7(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, V7);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-hexagon-number-9",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M19 6.873a2 2 0 0 1 1 1.747v6.536a2 2 0 0 1 -1.029 1.748l-6 3.833a2 2 0 0 1 -1.942 0l-6 -3.833a2 2 0 0 1 -1.029 -1.747v-6.537a2 2 0 0 1 1.029 -1.748l6 -3.572a2.056 2.056 0 0 1 2 0l6 3.573h-.029z"
  }), e.createElement("path", {
    d: "M10 15a1 1 0 0 0 1 1h2a1 1 0 0 0 1 -1v-6a1 1 0 0 0 -1 -1h-2a1 1 0 0 0 -1 1v2a1 1 0 0 0 1 1h3"
  }));
}
var Y7 = ["size", "color", "stroke"];
function Z7(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Y7);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-hexagon-off",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M8.693 4.69l2.336 -1.39a2.056 2.056 0 0 1 2 0l6 3.573h-.029a2 2 0 0 1 1 1.747v6.536c0 .246 -.045 .485 -.13 .707m-2.16 1.847l-4.739 3.027a2 2 0 0 1 -1.942 0l-6 -3.833a2 2 0 0 1 -1.029 -1.747v-6.537a2 2 0 0 1 1.029 -1.748l1.154 -.687"
  }), e.createElement("path", {
    d: "M3 3l18 18"
  }));
}
var $7 = ["size", "color", "stroke"];
function _7(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, $7);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-hexagon",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M19 6.873a2 2 0 0 1 1 1.747v6.536a2 2 0 0 1 -1.029 1.748l-6 3.833a2 2 0 0 1 -1.942 0l-6 -3.833a2 2 0 0 1 -1.029 -1.747v-6.537a2 2 0 0 1 1.029 -1.748l6 -3.572a2.056 2.056 0 0 1 2 0l6 3.573z"
  }));
}
var e9 = ["size", "color", "stroke"];
function t9(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, e9);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-hexagons-off",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M4 18v-5l4 -2l4 2v5l-4 2z"
  }), e.createElement("path", {
    d: "M8 11v-3m1.332 -2.666l2.668 -1.334l4 2v5"
  }), e.createElement("path", {
    d: "M12 13l.661 -.331"
  }), e.createElement("path", {
    d: "M15.345 11.328l.655 -.328l4 2v3m-1.334 2.667l-2.666 1.333l-4 -2"
  }), e.createElement("path", {
    d: "M3 3l18 18"
  }));
}
var o9 = ["size", "color", "stroke"];
function r9(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, o9);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-hexagons",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M4 18v-5l4 -2l4 2v5l-4 2z"
  }), e.createElement("path", {
    d: "M8 11v-5l4 -2l4 2v5"
  }), e.createElement("path", {
    d: "M12 13l4 -2l4 2v5l-4 2l-4 -2"
  }));
}
var n9 = ["size", "color", "stroke"];
function l9(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, n9);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-hierarchy-2",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M10 3h4v4h-4z"
  }), e.createElement("path", {
    d: "M3 17h4v4h-4z"
  }), e.createElement("path", {
    d: "M17 17h4v4h-4z"
  }), e.createElement("path", {
    d: "M7 17l5 -4l5 4"
  }), e.createElement("line", {
    x1: 12,
    y1: 7,
    x2: 12,
    y2: 13
  }));
}
var a9 = ["size", "color", "stroke"];
function i9(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, a9);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-hierarchy-3",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("circle", {
    cx: 12,
    cy: 5,
    r: 2
  }), e.createElement("circle", {
    cx: 8,
    cy: 12,
    r: 2
  }), e.createElement("circle", {
    cx: 12,
    cy: 19,
    r: 2
  }), e.createElement("circle", {
    cx: 20,
    cy: 19,
    r: 2
  }), e.createElement("circle", {
    cx: 4,
    cy: 19,
    r: 2
  }), e.createElement("circle", {
    cx: 16,
    cy: 12,
    r: 2
  }), e.createElement("path", {
    d: "M5 17l2 -3"
  }), e.createElement("path", {
    d: "M9 10l2 -3"
  }), e.createElement("path", {
    d: "M13 7l2 3"
  }), e.createElement("path", {
    d: "M17 14l2 3"
  }), e.createElement("path", {
    d: "M15 14l-2 3"
  }), e.createElement("path", {
    d: "M9 14l2 3"
  }));
}
var c9 = ["size", "color", "stroke"];
function s9(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, c9);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-hierarchy-off",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("circle", {
    cx: 12,
    cy: 5,
    r: 2
  }), e.createElement("circle", {
    cx: 5,
    cy: 19,
    r: 2
  }), e.createElement("path", {
    d: "M17.585 17.587a2 2 0 0 0 2.813 2.843"
  }), e.createElement("path", {
    d: "M6.5 17.5l5.5 -4.5l5.5 4.5"
  }), e.createElement("path", {
    d: "M12 7v1m0 4v1"
  }), e.createElement("path", {
    d: "M3 3l18 18"
  }));
}
var h9 = ["size", "color", "stroke"];
function d9(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, h9);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-hierarchy",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("circle", {
    cx: 12,
    cy: 5,
    r: 2
  }), e.createElement("circle", {
    cx: 5,
    cy: 19,
    r: 2
  }), e.createElement("circle", {
    cx: 19,
    cy: 19,
    r: 2
  }), e.createElement("path", {
    d: "M6.5 17.5l5.5 -4.5l5.5 4.5"
  }), e.createElement("line", {
    x1: 12,
    y1: 7,
    x2: 12,
    y2: 13
  }));
}
var v9 = ["size", "color", "stroke"];
function m9(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, v9);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-highlight-off",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M8.998 9.002l-5.998 5.998v4h4l6 -6m1.997 -1.997l2.503 -2.503a2.828 2.828 0 1 0 -4 -4l-2.497 2.497"
  }), e.createElement("path", {
    d: "M12.5 5.5l4 4"
  }), e.createElement("path", {
    d: "M4.5 13.5l4 4"
  }), e.createElement("path", {
    d: "M19 15h2v2m-2 2h-6l3.004 -3.004"
  }), e.createElement("path", {
    d: "M3 3l18 18"
  }));
}
var k9 = ["size", "color", "stroke"];
function w9(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, k9);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-highlight",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M3 19h4l10.5 -10.5a2.828 2.828 0 1 0 -4 -4l-10.5 10.5v4"
  }), e.createElement("path", {
    d: "M12.5 5.5l4 4"
  }), e.createElement("path", {
    d: "M4.5 13.5l4 4"
  }), e.createElement("path", {
    d: "M21 15v4h-8l4 -4z"
  }));
}
var p9 = ["size", "color", "stroke"];
function E9(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, p9);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-history-off",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M3.05 11a8.975 8.975 0 0 1 2.54 -5.403m2.314 -1.697a9 9 0 0 1 12.113 12.112m-1.695 2.312a9 9 0 0 1 -14.772 -3.324m-.5 5v-5h5"
  }), e.createElement("path", {
    d: "M3 3l18 18"
  }));
}
var u9 = ["size", "color", "stroke"];
function g9(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, u9);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-history-toggle",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M12 8v4l3 3"
  }), e.createElement("path", {
    d: "M8.56 3.69a9 9 0 0 0 -2.92 1.95"
  }), e.createElement("path", {
    d: "M3.69 8.56a9 9 0 0 0 -.69 3.44"
  }), e.createElement("path", {
    d: "M3.69 15.44a9 9 0 0 0 1.95 2.92"
  }), e.createElement("path", {
    d: "M8.56 20.31a9 9 0 0 0 3.44 .69"
  }), e.createElement("path", {
    d: "M15.44 20.31a9 9 0 0 0 2.92 -1.95"
  }), e.createElement("path", {
    d: "M20.31 15.44a9 9 0 0 0 .69 -3.44"
  }), e.createElement("path", {
    d: "M20.31 8.56a9 9 0 0 0 -1.95 -2.92"
  }), e.createElement("path", {
    d: "M15.44 3.69a9 9 0 0 0 -3.44 -.69"
  }));
}
var M9 = ["size", "color", "stroke"];
function x9(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, M9);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-history",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("polyline", {
    points: "12 8 12 12 14 14"
  }), e.createElement("path", {
    d: "M3.05 11a9 9 0 1 1 .5 4m-.5 5v-5h5"
  }));
}
var f9 = ["size", "color", "stroke"];
function z9(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, f9);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-home-2",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("polyline", {
    points: "5 12 3 12 12 3 21 12 19 12"
  }), e.createElement("path", {
    d: "M5 12v7a2 2 0 0 0 2 2h10a2 2 0 0 0 2 -2v-7"
  }), e.createElement("rect", {
    x: 10,
    y: 12,
    width: 4,
    height: 4
  }));
}
var b9 = ["size", "color", "stroke"];
function L9(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, b9);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-home-bolt",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M19 10l-7 -7l-9 9h2v7a2 2 0 0 0 2 2h7.5"
  }), e.createElement("path", {
    d: "M9 21v-6a2 2 0 0 1 2 -2h2c.661 0 1.248 .32 1.612 .815"
  }), e.createElement("path", {
    d: "M19 14l-2 4h4l-2 4"
  }));
}
var y9 = ["size", "color", "stroke"];
function C9(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, y9);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-home-cancel",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("circle", {
    cx: 19,
    cy: 19,
    r: 3
  }), e.createElement("path", {
    d: "M17 21l4 -4"
  }), e.createElement("path", {
    d: "M19 12h2l-9 -9l-9 9h2v7a2 2 0 0 0 2 2h5.5"
  }), e.createElement("path", {
    d: "M9 21v-6a2 2 0 0 1 2 -2h2c.58 0 1.103 .247 1.468 .642"
  }));
}
var j9 = ["size", "color", "stroke"];
function B9(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, j9);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-home-check",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M9 21v-6a2 2 0 0 1 2 -2h2a2 2 0 0 1 2 2"
  }), e.createElement("path", {
    d: "M19 13.488v-1.488h2l-9 -9l-9 9h2v7a2 2 0 0 0 2 2h4.525"
  }), e.createElement("path", {
    d: "M15 19l2 2l4 -4"
  }));
}
var H9 = ["size", "color", "stroke"];
function N9(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, H9);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-home-cog",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M9 21v-6a2 2 0 0 1 2 -2h1.6"
  }), e.createElement("path", {
    d: "M20.001 11.001l-8.001 -8.001l-9 9h2v7a2 2 0 0 0 2 2h4.159"
  }), e.createElement("circle", {
    cx: 18.001,
    cy: 18,
    r: 2
  }), e.createElement("path", {
    d: "M18.001 14.5v1.5"
  }), e.createElement("path", {
    d: "M18.001 20v1.5"
  }), e.createElement("path", {
    d: "M21.032 16.25l-1.299 .75"
  }), e.createElement("path", {
    d: "M16.27 19l-1.3 .75"
  }), e.createElement("path", {
    d: "M14.97 16.25l1.3 .75"
  }), e.createElement("path", {
    d: "M19.733 19l1.3 .75"
  }));
}
var W9 = ["size", "color", "stroke"];
function q9(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, W9);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-home-dollar",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M19 10l-7 -7l-9 9h2v7a2 2 0 0 0 2 2h6"
  }), e.createElement("path", {
    d: "M9 21v-6a2 2 0 0 1 2 -2h2c.387 0 .748 .11 1.054 .3"
  }), e.createElement("path", {
    d: "M21 15h-2.5a1.5 1.5 0 0 0 0 3h1a1.5 1.5 0 0 1 0 3h-2.5"
  }), e.createElement("path", {
    d: "M19 21v1m0 -8v1"
  }));
}
var O9 = ["size", "color", "stroke"];
function P9(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, O9);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-home-dot",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M19 12h2l-9 -9l-9 9h2v7a2 2 0 0 0 2 2h5"
  }), e.createElement("circle", {
    cx: 19,
    cy: 19,
    r: 3
  }), e.createElement("path", {
    d: "M9 21v-6a2 2 0 0 1 2 -2h2c.641 0 1.212 .302 1.578 .771"
  }));
}
var S9 = ["size", "color", "stroke"];
function I9(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, S9);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-home-down",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M19 12h2l-9 -9l-9 9h2v7a2 2 0 0 0 2 2h5.5"
  }), e.createElement("path", {
    d: "M9 21v-6a2 2 0 0 1 2 -2h2a2 2 0 0 1 2 2"
  }), e.createElement("path", {
    d: "M19 16v6"
  }), e.createElement("path", {
    d: "M22 19l-3 3l-3 -3"
  }));
}
var A9 = ["size", "color", "stroke"];
function D9(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, A9);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-home-eco",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M20.002 11.002l-8.002 -8.002l-9 9h2v7a2 2 0 0 0 2 2h5"
  }), e.createElement("path", {
    d: "M9 21v-6a2 2 0 0 1 2 -2h2c.325 0 .631 .077 .902 .215"
  }), e.createElement("path", {
    d: "M16 22s0 -2 3 -4"
  }), e.createElement("path", {
    d: "M19 21a3 3 0 0 1 0 -6h3v3a3 3 0 0 1 -3 3z"
  }));
}
var F9 = ["size", "color", "stroke"];
function G9(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, F9);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-home-edit",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M9 21v-6a2 2 0 0 1 2 -2h2c.645 0 1.218 .305 1.584 .78"
  }), e.createElement("path", {
    d: "M20.004 11.004l-8.004 -8.004l-9 9h2v7a2 2 0 0 0 2 2h4"
  }), e.createElement("path", {
    d: "M18.42 15.61a2.1 2.1 0 0 1 2.97 2.97l-3.39 3.42h-3v-3l3.42 -3.39z"
  }));
}
var J9 = ["size", "color", "stroke"];
function K9(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, J9);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-home-exclamation",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M21 12l-9 -9l-9 9h2v7a2 2 0 0 0 2 2h8"
  }), e.createElement("path", {
    d: "M9 21v-6a2 2 0 0 1 2 -2h2a2 2 0 0 1 1.857 1.257"
  }), e.createElement("path", {
    d: "M19 16v3"
  }), e.createElement("path", {
    d: "M19 22v.01"
  }));
}
var Q9 = ["size", "color", "stroke"];
function R9(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Q9);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-home-hand",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M18 9l-6 -6l-9 9h2v7a2 2 0 0 0 2 2h3.5"
  }), e.createElement("path", {
    d: "M9 21v-6a2 2 0 0 1 2 -2h2"
  }), e.createElement("path", {
    d: "M16 17.5l-.585 -.578a1.516 1.516 0 0 0 -2 0c-.477 .433 -.551 1.112 -.177 1.622l1.762 2.456c.37 .506 1.331 1 2 1h3c1.009 0 1.497 -.683 1.622 -1.593c.252 -.938 .378 -1.74 .378 -2.407c0 -1 -.939 -1.843 -2 -2h-1v-2.636c0 -.754 -.672 -1.364 -1.5 -1.364s-1.5 .61 -1.5 1.364v4.136z"
  }));
}
var T9 = ["size", "color", "stroke"];
function U9(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, T9);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-home-heart",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M21 12l-9 -9l-9 9h2v7a2 2 0 0 0 2 2h6"
  }), e.createElement("path", {
    d: "M9 21v-6a2 2 0 0 1 2 -2h2c.39 0 .754 .112 1.061 .304"
  }), e.createElement("path", {
    d: "M18.994 21.5l2.518 -2.58a1.74 1.74 0 0 0 .004 -2.413a1.627 1.627 0 0 0 -2.346 -.005l-.168 .172l-.168 -.172a1.627 1.627 0 0 0 -2.346 -.004a1.74 1.74 0 0 0 -.004 2.412l2.51 2.59z"
  }));
}
var V9 = ["size", "color", "stroke"];
function X9(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, V9);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-home-infinity",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M19 14v-2h2l-9 -9l-9 9h2v7a2 2 0 0 0 2 2h2.5"
  }), e.createElement("path", {
    d: "M9 21v-6a2 2 0 0 1 2 -2h2a2 2 0 0 1 1.75 1.032"
  }), e.createElement("path", {
    d: "M15.536 17.586a2.123 2.123 0 0 0 -2.929 0a1.951 1.951 0 0 0 0 2.828c.809 .781 2.12 .781 2.929 0c.809 -.781 -.805 .778 .004 -.003l1.46 -1.41l1.46 -1.419"
  }), e.createElement("path", {
    d: "M15.54 17.582l1.46 1.42l1.46 1.41c.809 .78 -.805 -.779 .004 .002s2.12 .781 2.929 0a1.951 1.951 0 0 0 0 -2.828a2.123 2.123 0 0 0 -2.929 0"
  }));
}
var Y9 = ["size", "color", "stroke"];
function Z9(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Y9);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-home-link",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M20.085 11.085l-8.085 -8.085l-9 9h2v7a2 2 0 0 0 2 2h4.5"
  }), e.createElement("path", {
    d: "M9 21v-6a2 2 0 0 1 2 -2h2a2 2 0 0 1 1.807 1.143"
  }), e.createElement("circle", {
    cx: 21,
    cy: 21,
    r: 1
  }), e.createElement("circle", {
    cx: 21,
    cy: 16,
    r: 1
  }), e.createElement("circle", {
    cx: 16,
    cy: 19,
    r: 1
  }), e.createElement("path", {
    d: "M21 16l-5 3l5 2"
  }));
}
var $9 = ["size", "color", "stroke"];
function _9(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, $9);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-home-minus",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M19 15v-3h2l-9 -9l-9 9h2v7a2 2 0 0 0 2 2h5.5"
  }), e.createElement("path", {
    d: "M16 19h6"
  }), e.createElement("path", {
    d: "M9 21v-6a2 2 0 0 1 2 -2h2a2 2 0 0 1 2 2"
  }));
}
var eee = ["size", "color", "stroke"];
function tee(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, eee);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-home-move",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M9 21v-6a2 2 0 0 1 2 -2h2a2 2 0 0 1 2 2"
  }), e.createElement("path", {
    d: "M19 12h2l-9 -9l-9 9h2v7a2 2 0 0 0 2 2h5.5"
  }), e.createElement("path", {
    d: "M16 19h6"
  }), e.createElement("path", {
    d: "M19 16l3 3l-3 3"
  }));
}
var oee = ["size", "color", "stroke"];
function ree(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, oee);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-home-off",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M5 12h-2l4.497 -4.497m1.999 -1.999l2.504 -2.504l9 9h-2"
  }), e.createElement("path", {
    d: "M5 12v7a2 2 0 0 0 2 2h10a2 2 0 0 0 2 -2m0 -4v-3"
  }), e.createElement("path", {
    d: "M9 21v-6a2 2 0 0 1 2 -2h2m2 2v6"
  }), e.createElement("path", {
    d: "M3 3l18 18"
  }));
}
var nee = ["size", "color", "stroke"];
function lee(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, nee);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-home-plus",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M19 12h2l-9 -9l-9 9h2v7a2 2 0 0 0 2 2h5.5"
  }), e.createElement("path", {
    d: "M9 21v-6a2 2 0 0 1 2 -2h2a2 2 0 0 1 2 2"
  }), e.createElement("path", {
    d: "M16 19h6"
  }), e.createElement("path", {
    d: "M19 16v6"
  }));
}
var aee = ["size", "color", "stroke"];
function iee(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, aee);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-home-question",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M20.136 11.136l-8.136 -8.136l-9 9h2v7a2 2 0 0 0 2 2h7"
  }), e.createElement("path", {
    d: "M9 21v-6a2 2 0 0 1 2 -2h2c.467 0 .896 .16 1.236 .428"
  }), e.createElement("path", {
    d: "M19 22v.01"
  }), e.createElement("path", {
    d: "M19 19a2.003 2.003 0 0 0 .914 -3.782a1.98 1.98 0 0 0 -2.414 .483"
  }));
}
var cee = ["size", "color", "stroke"];
function see(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, cee);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-home-ribbon",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M16 15h5v7l-2.5 -1.5l-2.5 1.5z"
  }), e.createElement("path", {
    d: "M20 11l-8 -8l-9 9h2v7a2 2 0 0 0 2 2h5"
  }), e.createElement("path", {
    d: "M9 21v-6a2 2 0 0 1 2 -2h1.5"
  }));
}
var hee = ["size", "color", "stroke"];
function dee(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, hee);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-home-search",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M21 12l-9 -9l-9 9h2v7a2 2 0 0 0 2 2h4.7"
  }), e.createElement("path", {
    d: "M9 21v-6a2 2 0 0 1 2 -2h2"
  }), e.createElement("circle", {
    cx: 18,
    cy: 18,
    r: 3
  }), e.createElement("path", {
    d: "M20.2 20.2l1.8 1.8"
  }));
}
var vee = ["size", "color", "stroke"];
function mee(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, vee);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-home-share",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M9 21v-6a2 2 0 0 1 2 -2h2c.247 0 .484 .045 .702 .127"
  }), e.createElement("path", {
    d: "M19 12h2l-9 -9l-9 9h2v7a2 2 0 0 0 2 2h5"
  }), e.createElement("path", {
    d: "M16 22l5 -5"
  }), e.createElement("path", {
    d: "M21 21.5v-4.5h-4.5"
  }));
}
var kee = ["size", "color", "stroke"];
function wee(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, kee);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-home-shield",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M9 21v-6a2 2 0 0 1 2 -2h1.341"
  }), e.createElement("path", {
    d: "M19.682 10.682l-7.682 -7.682l-9 9h2v7a2 2 0 0 0 2 2h5"
  }), e.createElement("path", {
    d: "M22 16c0 4 -2.5 6 -3.5 6s-3.5 -2 -3.5 -6c1 0 2.5 -.5 3.5 -1.5c1 1 2.5 1.5 3.5 1.5z"
  }));
}
var pee = ["size", "color", "stroke"];
function Eee(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, pee);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-home-signal",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M15 22v-2"
  }), e.createElement("path", {
    d: "M18 22v-4"
  }), e.createElement("path", {
    d: "M21 22v-6"
  }), e.createElement("path", {
    d: "M19 12.494v-.494h2l-9 -9l-9 9h2v7a2 2 0 0 0 2 2h4"
  }), e.createElement("path", {
    d: "M9 21v-6a2 2 0 0 1 2 -2h2a2 2 0 0 1 2 2v.5"
  }));
}
var uee = ["size", "color", "stroke"];
function gee(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, uee);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-home-star",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M19.258 10.258l-7.258 -7.258l-9 9h2v7a2 2 0 0 0 2 2h4"
  }), e.createElement("path", {
    d: "M9 21v-6a2 2 0 0 1 2 -2h1.5"
  }), e.createElement("path", {
    d: "M17.8 20.817l-2.172 1.138a0.392 .392 0 0 1 -.568 -.41l.415 -2.411l-1.757 -1.707a0.389 .389 0 0 1 .217 -.665l2.428 -.352l1.086 -2.193a0.392 .392 0 0 1 .702 0l1.086 2.193l2.428 .352a0.39 .39 0 0 1 .217 .665l-1.757 1.707l.414 2.41a0.39 .39 0 0 1 -.567 .411l-2.172 -1.138z"
  }));
}
var Mee = ["size", "color", "stroke"];
function xee(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Mee);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-home-stats",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M19 13v-1h2l-9 -9l-9 9h2v7a2 2 0 0 0 2 2h2.5"
  }), e.createElement("path", {
    d: "M9 21v-6a2 2 0 0 1 2 -2h2a2 2 0 0 1 2 2"
  }), e.createElement("path", {
    d: "M13 22l3 -3l2 2l4 -4"
  }), e.createElement("path", {
    d: "M19 17h3v3"
  }));
}
var fee = ["size", "color", "stroke"];
function zee(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, fee);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-home-up",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M9 21v-6a2 2 0 0 1 2 -2h2c.641 0 1.212 .302 1.578 .771"
  }), e.createElement("path", {
    d: "M20.136 11.136l-8.136 -8.136l-9 9h2v7a2 2 0 0 0 2 2h6.344"
  }), e.createElement("path", {
    d: "M19 22v-6"
  }), e.createElement("path", {
    d: "M22 19l-3 -3l-3 3"
  }));
}
var bee = ["size", "color", "stroke"];
function Lee(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, bee);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-home-x",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M19 13.4v-1.4h2l-9 -9l-9 9h2v7a2 2 0 0 0 2 2h5.5"
  }), e.createElement("path", {
    d: "M9 21v-6a2 2 0 0 1 2 -2h2c.402 0 .777 .119 1.091 .323"
  }), e.createElement("path", {
    d: "M21.5 21.5l-5 -5"
  }), e.createElement("path", {
    d: "M16.5 21.5l5 -5"
  }));
}
var yee = ["size", "color", "stroke"];
function Cee(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, yee);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-home",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("polyline", {
    points: "5 12 3 12 12 3 21 12 19 12"
  }), e.createElement("path", {
    d: "M5 12v7a2 2 0 0 0 2 2h10a2 2 0 0 0 2 -2v-7"
  }), e.createElement("path", {
    d: "M9 21v-6a2 2 0 0 1 2 -2h2a2 2 0 0 1 2 2v6"
  }));
}
var jee = ["size", "color", "stroke"];
function Bee(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, jee);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-horse-toy",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M3.5 17.5c5.667 4.667 11.333 4.667 17 0"
  }), e.createElement("path", {
    d: "M19 18.5l-2 -8.5l1 -2l2 1l1.5 -1.5l-2.5 -4.5c-5.052 .218 -5.99 3.133 -7 6h-6a3 3 0 0 0 -3 3"
  }), e.createElement("path", {
    d: "M5 18.5l2 -9.5"
  }), e.createElement("path", {
    d: "M8 20l2 -5h4l2 5"
  }));
}
var Hee = ["size", "color", "stroke"];
function Nee(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Hee);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-hotel-service",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M8.5 10a1.5 1.5 0 0 1 -1.5 -1.5a5.5 5.5 0 0 1 11 0v10.5a2 2 0 0 1 -2 2h-7a2 2 0 0 1 -2 -2v-2c0 -1.38 .71 -2.444 1.88 -3.175l4.424 -2.765c1.055 -.66 1.696 -1.316 1.696 -2.56a2.5 2.5 0 1 0 -5 0a1.5 1.5 0 0 1 -1.5 1.5z"
  }));
}
var Wee = ["size", "color", "stroke"];
function qee(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Wee);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-hourglass-empty",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M6 20v-2a6 6 0 1 1 12 0v2a1 1 0 0 1 -1 1h-10a1 1 0 0 1 -1 -1z"
  }), e.createElement("path", {
    d: "M6 4v2a6 6 0 1 0 12 0v-2a1 1 0 0 0 -1 -1h-10a1 1 0 0 0 -1 1z"
  }));
}
var Oee = ["size", "color", "stroke"];
function Pee(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Oee);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-hourglass-high",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M6.5 7h11"
  }), e.createElement("path", {
    d: "M6 20v-2a6 6 0 1 1 12 0v2a1 1 0 0 1 -1 1h-10a1 1 0 0 1 -1 -1z"
  }), e.createElement("path", {
    d: "M6 4v2a6 6 0 1 0 12 0v-2a1 1 0 0 0 -1 -1h-10a1 1 0 0 0 -1 1z"
  }));
}
var See = ["size", "color", "stroke"];
function Iee(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, See);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-hourglass-low",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M6.5 17h11"
  }), e.createElement("path", {
    d: "M6 20v-2a6 6 0 1 1 12 0v2a1 1 0 0 1 -1 1h-10a1 1 0 0 1 -1 -1z"
  }), e.createElement("path", {
    d: "M6 4v2a6 6 0 1 0 12 0v-2a1 1 0 0 0 -1 -1h-10a1 1 0 0 0 -1 1z"
  }));
}
var Aee = ["size", "color", "stroke"];
function Dee(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Aee);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-hourglass-off",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M18 18v2a1 1 0 0 1 -1 1h-10a1 1 0 0 1 -1 -1v-2a6 6 0 0 1 6 -6"
  }), e.createElement("path", {
    d: "M6 6a6 6 0 0 0 6 6m3.13 -.88a5.996 5.996 0 0 0 2.87 -5.12v-2a1 1 0 0 0 -1 -1h-10"
  }), e.createElement("path", {
    d: "M3 3l18 18"
  }));
}
var Fee = ["size", "color", "stroke"];
function Gee(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Fee);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-hourglass",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M6.5 7h11"
  }), e.createElement("path", {
    d: "M6.5 17h11"
  }), e.createElement("path", {
    d: "M6 20v-2a6 6 0 1 1 12 0v2a1 1 0 0 1 -1 1h-10a1 1 0 0 1 -1 -1z"
  }), e.createElement("path", {
    d: "M6 4v2a6 6 0 1 0 12 0v-2a1 1 0 0 0 -1 -1h-10a1 1 0 0 0 -1 1z"
  }));
}
var Jee = ["size", "color", "stroke"];
function Kee(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Jee);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-ice-cream-2",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M17.657 11.004a6 6 0 1 0 -11.315 0"
  }), e.createElement("path", {
    d: "M6.342 11l5.658 11l5.657 -10.996z"
  }));
}
var Qee = ["size", "color", "stroke"];
function Ree(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Qee);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-ice-cream-off",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M12 21.5v-4.5"
  }), e.createElement("path", {
    d: "M8 8v9h8v-1m0 -4v-5a4 4 0 0 0 -7.277 -2.294"
  }), e.createElement("path", {
    d: "M8 10.5l1.74 -.76m2.79 -1.222l3.47 -1.518"
  }), e.createElement("path", {
    d: "M8 14.5l4.488 -1.964"
  }), e.createElement("path", {
    d: "M3 3l18 18"
  }));
}
var Tee = ["size", "color", "stroke"];
function Uee(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Tee);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-ice-cream",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M12 21.5v-4.5"
  }), e.createElement("path", {
    d: "M8 17h8v-10a4 4 0 1 0 -8 0v10z"
  }), e.createElement("path", {
    d: "M8 10.5l8 -3.5"
  }), e.createElement("path", {
    d: "M8 14.5l8 -3.5"
  }));
}
var Vee = ["size", "color", "stroke"];
function Xee(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Vee);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-ice-skating",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M5.905 5h3.418a1 1 0 0 1 .928 .629l1.143 2.856a3 3 0 0 0 2.207 1.83l4.717 .926a2.084 2.084 0 0 1 1.682 2.045v.714a1 1 0 0 1 -1 1h-13.895a1 1 0 0 1 -.995 -1.1l.8 -8a1 1 0 0 1 .995 -.9z"
  }), e.createElement("path", {
    d: "M3 19h17a1 1 0 0 0 1 -1"
  }), e.createElement("path", {
    d: "M9 15v4"
  }), e.createElement("path", {
    d: "M15 15v4"
  }));
}
var Yee = ["size", "color", "stroke"];
function Zee(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Yee);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-icons-off",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M4.01 4.041a3.5 3.5 0 0 0 2.49 5.959c.975 0 1.865 -.357 2.5 -1m.958 -3.044a3.503 3.503 0 0 0 -2.905 -2.912"
  }), e.createElement("path", {
    d: "M2.5 21h8l-4 -7z"
  }), e.createElement("path", {
    d: "M14 3l7 7"
  }), e.createElement("path", {
    d: "M14 10l7 -7"
  }), e.createElement("path", {
    d: "M18 14h3v3m0 4h-7v-7"
  }), e.createElement("path", {
    d: "M3 3l18 18"
  }));
}
var $ee = ["size", "color", "stroke"];
function _ee(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, $ee);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-icons",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("circle", {
    cx: 6.5,
    cy: 6.5,
    r: 3.5
  }), e.createElement("path", {
    d: "M2.5 21h8l-4 -7z"
  }), e.createElement("path", {
    d: "M14 3l7 7"
  }), e.createElement("path", {
    d: "M14 10l7 -7"
  }), e.createElement("path", {
    d: "M14 14h7v7h-7z"
  }));
}
var ete = ["size", "color", "stroke"];
function tte(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, ete);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-id-badge-2",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M7 12h3v4h-3z"
  }), e.createElement("path", {
    d: "M10 6h-6a1 1 0 0 0 -1 1v12a1 1 0 0 0 1 1h16a1 1 0 0 0 1 -1v-12a1 1 0 0 0 -1 -1h-6"
  }), e.createElement("rect", {
    x: 10,
    y: 3,
    width: 4,
    height: 5,
    rx: 1
  }), e.createElement("path", {
    d: "M14 16h2"
  }), e.createElement("path", {
    d: "M14 12h4"
  }));
}
var ote = ["size", "color", "stroke"];
function rte(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, ote);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-id-badge-off",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M7.141 3.125a3 3 0 0 1 .859 -.125h8a3 3 0 0 1 3 3v9m-.13 3.874a3.001 3.001 0 0 1 -2.87 2.126h-8a3 3 0 0 1 -3 -3v-12a3 3 0 0 1 .128 -.869"
  }), e.createElement("path", {
    d: "M11.179 11.176a2 2 0 1 0 2.635 2.667"
  }), e.createElement("path", {
    d: "M10 6h4"
  }), e.createElement("path", {
    d: "M9 18h6"
  }), e.createElement("path", {
    d: "M3 3l18 18"
  }));
}
var nte = ["size", "color", "stroke"];
function lte(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, nte);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-id-badge",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("rect", {
    x: 5,
    y: 3,
    width: 14,
    height: 18,
    rx: 3
  }), e.createElement("circle", {
    cx: 12,
    cy: 13,
    r: 2
  }), e.createElement("path", {
    d: "M10 6h4"
  }), e.createElement("path", {
    d: "M9 18h6"
  }));
}
var ate = ["size", "color", "stroke"];
function ite(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, ate);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-id-off",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M8 4h10a3 3 0 0 1 3 3v10m-1.437 2.561c-.455 .279 -.99 .439 -1.563 .439h-12a3 3 0 0 1 -3 -3v-10c0 -1.083 .573 -2.031 1.433 -2.559"
  }), e.createElement("path", {
    d: "M8.175 8.178a2 2 0 1 0 2.646 2.65"
  }), e.createElement("path", {
    d: "M15 8h2"
  }), e.createElement("path", {
    d: "M16 12h1"
  }), e.createElement("path", {
    d: "M7 16h9"
  }), e.createElement("path", {
    d: "M3 3l18 18"
  }));
}
var cte = ["size", "color", "stroke"];
function ste(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, cte);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-id",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("rect", {
    x: 3,
    y: 4,
    width: 18,
    height: 16,
    rx: 3
  }), e.createElement("circle", {
    cx: 9,
    cy: 10,
    r: 2
  }), e.createElement("line", {
    x1: 15,
    y1: 8,
    x2: 17,
    y2: 8
  }), e.createElement("line", {
    x1: 15,
    y1: 12,
    x2: 17,
    y2: 12
  }), e.createElement("line", {
    x1: 7,
    y1: 16,
    x2: 17,
    y2: 16
  }));
}
var hte = ["size", "color", "stroke"];
function dte(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, hte);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-inbox-off",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M8 4h10a2 2 0 0 1 2 2v10m-.593 3.422a1.994 1.994 0 0 1 -1.407 .578h-12a2 2 0 0 1 -2 -2v-12c0 -.554 .225 -1.056 .59 -1.418"
  }), e.createElement("path", {
    d: "M4 13h3l3 3h4l.987 -.987m2.013 -2.013h3"
  }), e.createElement("path", {
    d: "M3 3l18 18"
  }));
}
var vte = ["size", "color", "stroke"];
function mte(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, vte);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-inbox",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("rect", {
    x: 4,
    y: 4,
    width: 16,
    height: 16,
    rx: 2
  }), e.createElement("path", {
    d: "M4 13h3l3 3h4l3 -3h3"
  }));
}
var kte = ["size", "color", "stroke"];
function wte(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, kte);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-indent-decrease",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("line", {
    x1: 20,
    y1: 6,
    x2: 13,
    y2: 6
  }), e.createElement("line", {
    x1: 20,
    y1: 12,
    x2: 11,
    y2: 12
  }), e.createElement("line", {
    x1: 20,
    y1: 18,
    x2: 13,
    y2: 18
  }), e.createElement("path", {
    d: "M8 8l-4 4l4 4"
  }));
}
var pte = ["size", "color", "stroke"];
function Ete(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, pte);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-indent-increase",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("line", {
    x1: 20,
    y1: 6,
    x2: 9,
    y2: 6
  }), e.createElement("line", {
    x1: 20,
    y1: 12,
    x2: 13,
    y2: 12
  }), e.createElement("line", {
    x1: 20,
    y1: 18,
    x2: 9,
    y2: 18
  }), e.createElement("path", {
    d: "M4 8l4 4l-4 4"
  }));
}
var ute = ["size", "color", "stroke"];
function gte(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, ute);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-infinity-off",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M8.165 8.174a3.998 3.998 0 0 0 -5.166 3.826a4 4 0 0 0 6.829 2.828a10 10 0 0 0 2.172 -2.828m1.677 -2.347a10 10 0 0 1 .495 -.481a4 4 0 1 1 5.129 6.1m-3.521 .537a3.994 3.994 0 0 1 -1.608 -.981a10 10 0 0 1 -2.172 -2.828"
  }), e.createElement("path", {
    d: "M3 3l18 18"
  }));
}
var Mte = ["size", "color", "stroke"];
function xte(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Mte);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-infinity",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M9.828 9.172a4 4 0 1 0 0 5.656a10 10 0 0 0 2.172 -2.828a10 10 0 0 1 2.172 -2.828a4 4 0 1 1 0 5.656a10 10 0 0 1 -2.172 -2.828a10 10 0 0 0 -2.172 -2.828"
  }));
}
var fte = ["size", "color", "stroke"];
function zte(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, fte);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-info-circle",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 9
  }), e.createElement("line", {
    x1: 12,
    y1: 8,
    x2: 12.01,
    y2: 8
  }), e.createElement("polyline", {
    points: "11 12 12 12 12 16 13 16"
  }));
}
var bte = ["size", "color", "stroke"];
function Lte(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, bte);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-info-square-rounded",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M12 8h.01"
  }), e.createElement("path", {
    d: "M11 12h1v4h1"
  }), e.createElement("path", {
    d: "M12 3c7.2 0 9 1.8 9 9s-1.8 9 -9 9s-9 -1.8 -9 -9s1.8 -9 9 -9z"
  }));
}
var yte = ["size", "color", "stroke"];
function Cte(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, yte);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-info-square",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("line", {
    x1: 12,
    y1: 8,
    x2: 12.01,
    y2: 8
  }), e.createElement("rect", {
    x: 4,
    y: 4,
    width: 16,
    height: 16,
    rx: 2
  }), e.createElement("polyline", {
    points: "11 12 12 12 12 16 13 16"
  }));
}
var jte = ["size", "color", "stroke"];
function Bte(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, jte);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-inner-shadow-bottom-left",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 9
  }), e.createElement("path", {
    d: "M6 12a6 6 0 0 0 6 6"
  }));
}
var Hte = ["size", "color", "stroke"];
function Nte(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Hte);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-inner-shadow-bottom-right",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M12 21a9 9 0 1 1 0 -18a9 9 0 0 1 0 18z"
  }), e.createElement("path", {
    d: "M18 12a6 6 0 0 1 -6 6"
  }));
}
var Wte = ["size", "color", "stroke"];
function qte(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Wte);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-inner-shadow-bottom",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M18.364 18.364a9 9 0 1 0 -12.728 -12.728a9 9 0 0 0 12.728 12.728z"
  }), e.createElement("path", {
    d: "M7.757 16.243a6 6 0 0 0 8.486 0"
  }));
}
var Ote = ["size", "color", "stroke"];
function Pte(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Ote);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-inner-shadow-left",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M5.636 5.636a9 9 0 1 1 12.728 12.728a9 9 0 0 1 -12.728 -12.728z"
  }), e.createElement("path", {
    d: "M7.757 16.243a6 6 0 0 1 0 -8.486"
  }));
}
var Ste = ["size", "color", "stroke"];
function Ite(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Ste);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-inner-shadow-right",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M18.364 18.364a9 9 0 1 1 -12.728 -12.728a9 9 0 0 1 12.728 12.728z"
  }), e.createElement("path", {
    d: "M16.243 7.757a6 6 0 0 1 0 8.486"
  }));
}
var Ate = ["size", "color", "stroke"];
function Dte(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Ate);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-inner-shadow-top-left",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M12 3a9 9 0 1 1 0 18a9 9 0 0 1 0 -18z"
  }), e.createElement("path", {
    d: "M6 12a6 6 0 0 1 6 -6"
  }));
}
var Fte = ["size", "color", "stroke"];
function Gte(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Fte);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-inner-shadow-top-right",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M12 3a9 9 0 1 0 0 18a9 9 0 0 0 0 -18z"
  }), e.createElement("path", {
    d: "M18 12a6 6 0 0 0 -6 -6"
  }));
}
var Jte = ["size", "color", "stroke"];
function Kte(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Jte);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-inner-shadow-top",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M5.636 5.636a9 9 0 1 0 12.728 12.728a9 9 0 0 0 -12.728 -12.728z"
  }), e.createElement("path", {
    d: "M16.243 7.757a6 6 0 0 0 -8.486 0"
  }));
}
var Qte = ["size", "color", "stroke"];
function Rte(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Qte);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-input-search",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M19 11v-3a2 2 0 0 0 -2 -2h-12a2 2 0 0 0 -2 2v5a2 2 0 0 0 2 2h5"
  }), e.createElement("circle", {
    cx: 15.5,
    cy: 15.5,
    r: 2.5
  }), e.createElement("path", {
    d: "M17.5 17.5l2.5 2.5"
  }));
}
var Tte = ["size", "color", "stroke"];
function Ute(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Tte);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-ironing-1",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M9 6h7.459a3 3 0 0 1 2.959 2.507l.577 3.464l.81 4.865a1 1 0 0 1 -.985 1.164h-16.82a7 7 0 0 1 7 -7h9.8"
  }), e.createElement("path", {
    d: "M12 15h.01"
  }));
}
var Vte = ["size", "color", "stroke"];
function Xte(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Vte);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-ironing-2",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M10 15h.01"
  }), e.createElement("path", {
    d: "M9 6h7.459a3 3 0 0 1 2.959 2.507l.577 3.464l.81 4.865a1 1 0 0 1 -.985 1.164h-16.82a7 7 0 0 1 7 -7h9.8"
  }), e.createElement("path", {
    d: "M14 15h.01"
  }));
}
var Yte = ["size", "color", "stroke"];
function Zte(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Yte);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-ironing-3",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M12 15h.01"
  }), e.createElement("path", {
    d: "M9 6h7.459a3 3 0 0 1 2.959 2.507l.577 3.464l.81 4.865a1 1 0 0 1 -.985 1.164h-16.82a7 7 0 0 1 7 -7h9.8"
  }), e.createElement("path", {
    d: "M9 15h.01"
  }), e.createElement("path", {
    d: "M15 15h.01"
  }));
}
var $te = ["size", "color", "stroke"];
function _te(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, $te);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-ironing-off",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M10 6h6.459a3 3 0 0 1 2.959 2.507l.577 3.464l.804 4.821l.007 .044m-2.806 1.164h-15a7 7 0 0 1 7 -7h1m4 0h4.8"
  }), e.createElement("path", {
    d: "M3 3l18 18"
  }));
}
var eoe = ["size", "color", "stroke"];
function toe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, eoe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-ironing-steam-off",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M9 4h7.459a3 3 0 0 1 2.959 2.507l.577 3.464l.81 4.865a1 1 0 0 1 -.821 1.15"
  }), e.createElement("path", {
    d: "M16 16h-13a7.001 7.001 0 0 1 6.056 -6.937"
  }), e.createElement("path", {
    d: "M13 9h6.8"
  }), e.createElement("path", {
    d: "M12 19v2"
  }), e.createElement("path", {
    d: "M8 19l-1 2"
  }), e.createElement("path", {
    d: "M16 19l1 2"
  }), e.createElement("path", {
    d: "M3 3l18 18"
  }));
}
var ooe = ["size", "color", "stroke"];
function roe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, ooe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-ironing-steam",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M12 19v2"
  }), e.createElement("path", {
    d: "M9 4h7.459a3 3 0 0 1 2.959 2.507l.577 3.464l.81 4.865a1 1 0 0 1 -.985 1.164h-16.82a7 7 0 0 1 7 -7h9.8"
  }), e.createElement("path", {
    d: "M8 19l-1 2"
  }), e.createElement("path", {
    d: "M16 19l1 2"
  }));
}
var noe = ["size", "color", "stroke"];
function loe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, noe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-italic",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("line", {
    x1: 11,
    y1: 5,
    x2: 17,
    y2: 5
  }), e.createElement("line", {
    x1: 7,
    y1: 19,
    x2: 13,
    y2: 19
  }), e.createElement("line", {
    x1: 14,
    y1: 5,
    x2: 10,
    y2: 19
  }));
}
var aoe = ["size", "color", "stroke"];
function ioe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, aoe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-jacket",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M16 3l-4 5l-4 -5"
  }), e.createElement("path", {
    d: "M12 19a2 2 0 0 1 -2 2h-4a2 2 0 0 1 -2 -2v-8.172a2 2 0 0 1 .586 -1.414l.828 -.828a2 2 0 0 0 .586 -1.414v-2.172a2 2 0 0 1 2 -2h8a2 2 0 0 1 2 2v2.172a2 2 0 0 0 .586 1.414l.828 .828a2 2 0 0 1 .586 1.414v8.172a2 2 0 0 1 -2 2h-4a2 2 0 0 1 -2 -2z"
  }), e.createElement("path", {
    d: "M20 13h-3a1 1 0 0 0 -1 1v2a1 1 0 0 0 1 1h3"
  }), e.createElement("path", {
    d: "M4 17h3a1 1 0 0 0 1 -1v-2a1 1 0 0 0 -1 -1h-3"
  }), e.createElement("path", {
    d: "M12 19v-11"
  }));
}
var coe = ["size", "color", "stroke"];
function soe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, coe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-jetpack",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M10 6a3 3 0 1 0 -6 0v7h6v-7z"
  }), e.createElement("path", {
    d: "M14 13h6v-7a3 3 0 0 0 -6 0v7z"
  }), e.createElement("path", {
    d: "M5 16c0 2.333 .667 4 2 5c1.333 -1 2 -2.667 2 -5"
  }), e.createElement("path", {
    d: "M15 16c0 2.333 .667 4 2 5c1.333 -1 2 -2.667 2 -5"
  }), e.createElement("path", {
    d: "M10 8h4"
  }), e.createElement("path", {
    d: "M10 11h4"
  }));
}
var hoe = ["size", "color", "stroke"];
function doe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, hoe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-jewish-star",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M12 2l3 5h6l-3 5l3 5h-6l-3 5l-3 -5h-6l3 -5l-3 -5h6z"
  }));
}
var voe = ["size", "color", "stroke"];
function moe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, voe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-jpg",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M21 8h-2a2 2 0 0 0 -2 2v4a2 2 0 0 0 2 2h2v-4h-1"
  }), e.createElement("path", {
    d: "M10 16v-8h2a2 2 0 1 1 0 4h-2"
  }), e.createElement("path", {
    d: "M3 8h4v6a2 2 0 0 1 -2 2h-1.5a0.5 .5 0 0 1 -.5 -.5v-.5"
  }));
}
var koe = ["size", "color", "stroke"];
function woe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, koe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-jump-rope",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M6 14v-6a3 3 0 1 1 6 0v8a3 3 0 0 0 6 0v-6"
  }), e.createElement("rect", {
    x: 16,
    y: 3,
    width: 4,
    height: 7,
    rx: 2
  }), e.createElement("rect", {
    x: 4,
    y: 14,
    width: 4,
    height: 7,
    rx: 2
  }));
}
var poe = ["size", "color", "stroke"];
function Eoe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, poe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-karate",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("circle", {
    cx: 18,
    cy: 4,
    r: 1
  }), e.createElement("path", {
    d: "M3 9l4.5 1l3 2.5"
  }), e.createElement("path", {
    d: "M13 21v-8l3 -5.5"
  }), e.createElement("path", {
    d: "M8 4.5l4 2l4 1l4 3.5l-2 3.5"
  }));
}
var uoe = ["size", "color", "stroke"];
function goe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, uoe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-kayak",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M6.414 6.414a2 2 0 0 0 0 -2.828l-1.414 -1.414l-2.828 2.828l1.414 1.414a2 2 0 0 0 2.828 0z"
  }), e.createElement("path", {
    d: "M17.586 17.586a2 2 0 0 0 0 2.828l1.414 1.414l2.828 -2.828l-1.414 -1.414a2 2 0 0 0 -2.828 0z"
  }), e.createElement("path", {
    d: "M6.5 6.5l11 11"
  }), e.createElement("path", {
    d: "M22 2.5c-9.983 2.601 -17.627 7.952 -20 19.5c9.983 -2.601 17.627 -7.952 20 -19.5z"
  }), e.createElement("path", {
    d: "M6.5 12.5l5 5"
  }), e.createElement("path", {
    d: "M12.5 6.5l5 5"
  }));
}
var Moe = ["size", "color", "stroke"];
function xoe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Moe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-kering",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M16 15v-3.5a2.5 2.5 0 1 1 5 0v3.5m0 -2h-5"
  }), e.createElement("path", {
    d: "M3 9l3 6l3 -6"
  }), e.createElement("path", {
    d: "M9 20l6 -16"
  }));
}
var foe = ["size", "color", "stroke"];
function zoe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, foe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-key-off",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M10.17 6.159l2.316 -2.316a2.877 2.877 0 0 1 4.069 0l3.602 3.602a2.877 2.877 0 0 1 0 4.069l-2.33 2.33"
  }), e.createElement("path", {
    d: "M14.931 14.948a2.863 2.863 0 0 1 -1.486 -.79l-.301 -.302l-6.558 6.558a2 2 0 0 1 -1.239 .578l-.175 .008h-1.172a1 1 0 0 1 -.993 -.883l-.007 -.117v-1.172a2 2 0 0 1 .467 -1.284l.119 -.13l.414 -.414h2v-2h2v-2l2.144 -2.144l-.301 -.301a2.863 2.863 0 0 1 -.794 -1.504"
  }), e.createElement("path", {
    d: "M15 9h.01"
  }), e.createElement("path", {
    d: "M3 3l18 18"
  }));
}
var boe = ["size", "color", "stroke"];
function Loe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, boe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-key",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M16.555 3.843l3.602 3.602a2.877 2.877 0 0 1 0 4.069l-2.643 2.643a2.877 2.877 0 0 1 -4.069 0l-.301 -.301l-6.558 6.558a2 2 0 0 1 -1.239 .578l-.175 .008h-1.172a1 1 0 0 1 -.993 -.883l-.007 -.117v-1.172a2 2 0 0 1 .467 -1.284l.119 -.13l.414 -.414h2v-2h2v-2l2.144 -2.144l-.301 -.301a2.877 2.877 0 0 1 0 -4.069l2.643 -2.643a2.877 2.877 0 0 1 4.069 0z"
  }), e.createElement("path", {
    d: "M15 9h.01"
  }));
}
var yoe = ["size", "color", "stroke"];
function Coe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, yoe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-keyboard-hide",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("rect", {
    x: 2,
    y: 3,
    width: 20,
    height: 12,
    rx: 2
  }), e.createElement("line", {
    x1: 6,
    y1: 7,
    x2: 6,
    y2: 7
  }), e.createElement("line", {
    x1: 10,
    y1: 7,
    x2: 10,
    y2: 7
  }), e.createElement("line", {
    x1: 14,
    y1: 7,
    x2: 14,
    y2: 7
  }), e.createElement("line", {
    x1: 18,
    y1: 7,
    x2: 18,
    y2: 7
  }), e.createElement("line", {
    x1: 6,
    y1: 11,
    x2: 6,
    y2: 11.01
  }), e.createElement("line", {
    x1: 18,
    y1: 11,
    x2: 18,
    y2: 11.01
  }), e.createElement("line", {
    x1: 10,
    y1: 11,
    x2: 14,
    y2: 11
  }), e.createElement("path", {
    d: "M10 21l2 -2l2 2"
  }));
}
var joe = ["size", "color", "stroke"];
function Boe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, joe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-keyboard-off",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M18 18h-14a2 2 0 0 1 -2 -2v-8a2 2 0 0 1 2 -2h2m4 0h10a2 2 0 0 1 2 2v8c0 .554 -.226 1.056 -.59 1.418"
  }), e.createElement("line", {
    x1: 6,
    y1: 10,
    x2: 6,
    y2: 10.01
  }), e.createElement("line", {
    x1: 10,
    y1: 10,
    x2: 10,
    y2: 10.01
  }), e.createElement("line", {
    x1: 14,
    y1: 10,
    x2: 14,
    y2: 10.01
  }), e.createElement("line", {
    x1: 18,
    y1: 10,
    x2: 18,
    y2: 10.01
  }), e.createElement("line", {
    x1: 6,
    y1: 14,
    x2: 6,
    y2: 14.01
  }), e.createElement("line", {
    x1: 18,
    y1: 14,
    x2: 18,
    y2: 14.01
  }), e.createElement("line", {
    x1: 10,
    y1: 14,
    x2: 14,
    y2: 14
  }), e.createElement("line", {
    x1: 3,
    y1: 3,
    x2: 21,
    y2: 21
  }));
}
var Hoe = ["size", "color", "stroke"];
function Noe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Hoe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-keyboard-show",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("rect", {
    x: 2,
    y: 3,
    width: 20,
    height: 12,
    rx: 2
  }), e.createElement("line", {
    x1: 6,
    y1: 7,
    x2: 6,
    y2: 7
  }), e.createElement("line", {
    x1: 10,
    y1: 7,
    x2: 10,
    y2: 7
  }), e.createElement("line", {
    x1: 14,
    y1: 7,
    x2: 14,
    y2: 7
  }), e.createElement("line", {
    x1: 18,
    y1: 7,
    x2: 18,
    y2: 7
  }), e.createElement("line", {
    x1: 6,
    y1: 11,
    x2: 6,
    y2: 11.01
  }), e.createElement("line", {
    x1: 18,
    y1: 11,
    x2: 18,
    y2: 11.01
  }), e.createElement("line", {
    x1: 10,
    y1: 11,
    x2: 14,
    y2: 11
  }), e.createElement("path", {
    d: "M10 19l2 2l2 -2"
  }));
}
var Woe = ["size", "color", "stroke"];
function qoe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Woe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-keyboard",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("rect", {
    x: 2,
    y: 6,
    width: 20,
    height: 12,
    rx: 2
  }), e.createElement("line", {
    x1: 6,
    y1: 10,
    x2: 6,
    y2: 10
  }), e.createElement("line", {
    x1: 10,
    y1: 10,
    x2: 10,
    y2: 10
  }), e.createElement("line", {
    x1: 14,
    y1: 10,
    x2: 14,
    y2: 10
  }), e.createElement("line", {
    x1: 18,
    y1: 10,
    x2: 18,
    y2: 10
  }), e.createElement("line", {
    x1: 6,
    y1: 14,
    x2: 6,
    y2: 14.01
  }), e.createElement("line", {
    x1: 18,
    y1: 14,
    x2: 18,
    y2: 14.01
  }), e.createElement("line", {
    x1: 10,
    y1: 14,
    x2: 14,
    y2: 14
  }));
}
var Ooe = ["size", "color", "stroke"];
function Poe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Ooe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-keyframe-align-center",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M12 20v2"
  }), e.createElement("path", {
    d: "M12.816 16.58c-.207 .267 -.504 .42 -.816 .42c-.312 0 -.61 -.153 -.816 -.42l-2.908 -3.748a1.39 1.39 0 0 1 0 -1.664l2.908 -3.748c.207 -.267 .504 -.42 .816 -.42c.312 0 .61 .153 .816 .42l2.908 3.748a1.39 1.39 0 0 1 0 1.664l-2.908 3.748z"
  }), e.createElement("path", {
    d: "M12 2v2"
  }), e.createElement("path", {
    d: "M3 12h2"
  }), e.createElement("path", {
    d: "M19 12h2"
  }));
}
var Soe = ["size", "color", "stroke"];
function Ioe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Soe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-keyframe-align-horizontal",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M12.816 16.58c-.207 .267 -.504 .42 -.816 .42c-.312 0 -.61 -.153 -.816 -.42l-2.908 -3.748a1.39 1.39 0 0 1 0 -1.664l2.908 -3.748c.207 -.267 .504 -.42 .816 -.42c.312 0 .61 .153 .816 .42l2.908 3.748a1.39 1.39 0 0 1 0 1.664l-2.908 3.748z"
  }), e.createElement("path", {
    d: "M3 12h2"
  }), e.createElement("path", {
    d: "M19 12h2"
  }));
}
var Aoe = ["size", "color", "stroke"];
function Doe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Aoe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-keyframe-align-vertical",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M12 2v2"
  }), e.createElement("path", {
    d: "M12.816 16.58c-.207 .267 -.504 .42 -.816 .42c-.312 0 -.61 -.153 -.816 -.42l-2.908 -3.748a1.39 1.39 0 0 1 0 -1.664l2.908 -3.748c.207 -.267 .504 -.42 .816 -.42c.312 0 .61 .153 .816 .42l2.908 3.748a1.39 1.39 0 0 1 0 1.664l-2.908 3.748z"
  }), e.createElement("path", {
    d: "M12 20v2"
  }));
}
var Foe = ["size", "color", "stroke"];
function Goe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Foe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-keyframe",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M13.225 18.412a1.595 1.595 0 0 1 -1.225 .588c-.468 0 -.914 -.214 -1.225 -.588l-4.361 -5.248a1.844 1.844 0 0 1 0 -2.328l4.361 -5.248a1.595 1.595 0 0 1 1.225 -.588c.468 0 .914 .214 1.225 .588l4.361 5.248a1.844 1.844 0 0 1 0 2.328l-4.361 5.248z"
  }));
}
var Joe = ["size", "color", "stroke"];
function Koe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Joe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-keyframes",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M9.225 18.412a1.595 1.595 0 0 1 -1.225 .588c-.468 0 -.914 -.214 -1.225 -.588l-4.361 -5.248a1.844 1.844 0 0 1 0 -2.328l4.361 -5.248a1.595 1.595 0 0 1 1.225 -.588c.468 0 .914 .214 1.225 .588l4.361 5.248a1.844 1.844 0 0 1 0 2.328l-4.361 5.248z"
  }), e.createElement("path", {
    d: "M17 5l4.586 5.836a1.844 1.844 0 0 1 0 2.328l-4.586 5.836"
  }), e.createElement("path", {
    d: "M13 5l4.586 5.836a1.844 1.844 0 0 1 0 2.328l-4.586 5.836"
  }));
}
var Qoe = ["size", "color", "stroke"];
function Roe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Qoe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-ladder-off",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M8 3v1m0 4v13"
  }), e.createElement("path", {
    d: "M16 3v9m0 4v5"
  }), e.createElement("path", {
    d: "M8 14h6"
  }), e.createElement("path", {
    d: "M8 10h2m4 0h2"
  }), e.createElement("path", {
    d: "M10 6h6"
  }), e.createElement("path", {
    d: "M8 18h8"
  }), e.createElement("path", {
    d: "M3 3l18 18"
  }));
}
var Toe = ["size", "color", "stroke"];
function Uoe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Toe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-ladder",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M8 3v18"
  }), e.createElement("path", {
    d: "M16 3v18"
  }), e.createElement("path", {
    d: "M8 14h8"
  }), e.createElement("path", {
    d: "M8 10h8"
  }), e.createElement("path", {
    d: "M8 6h8"
  }), e.createElement("path", {
    d: "M8 18h8"
  }));
}
var Voe = ["size", "color", "stroke"];
function Xoe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Voe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-lambda",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M6 20l6.5 -9"
  }), e.createElement("path", {
    d: "M19 20c-6 0 -6 -16 -12 -16"
  }));
}
var Yoe = ["size", "color", "stroke"];
function Zoe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Yoe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-lamp-2",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M5 21h9"
  }), e.createElement("path", {
    d: "M10 21l-7 -8l8.5 -5.5"
  }), e.createElement("path", {
    d: "M13 14c-2.148 -2.148 -2.148 -5.852 0 -8c2.088 -2.088 5.842 -1.972 8 0l-8 8z"
  }), e.createElement("path", {
    d: "M11.742 7.574l-1.156 -1.156a2 2 0 0 1 2.828 -2.829l1.144 1.144"
  }), e.createElement("path", {
    d: "M15.5 11.995l.208 .274a2.527 2.527 0 0 0 3.556 0c.939 -.933 .98 -2.42 .122 -3.4l-.366 -.369"
  }));
}
var $oe = ["size", "color", "stroke"];
function _oe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, $oe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-lamp-off",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M9 20h6"
  }), e.createElement("path", {
    d: "M12 20v-8"
  }), e.createElement("path", {
    d: "M7.325 7.35l-2.325 4.65h7m4 0h3l-4 -8h-6l-.338 .676"
  }), e.createElement("path", {
    d: "M3 3l18 18"
  }));
}
var ere = ["size", "color", "stroke"];
function tre(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, ere);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-lamp",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M9 20h6"
  }), e.createElement("path", {
    d: "M12 20v-8"
  }), e.createElement("path", {
    d: "M5 12h14l-4 -8h-6z"
  }));
}
var ore = ["size", "color", "stroke"];
function rre(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, ore);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-language-hiragana",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M4 5h7"
  }), e.createElement("path", {
    d: "M7 4c0 4.846 0 7 .5 8"
  }), e.createElement("path", {
    d: "M10 8.5c0 2.286 -2 4.5 -3.5 4.5s-2.5 -1.135 -2.5 -2c0 -2 1 -3 3 -3s5 .57 5 2.857c0 1.524 -.667 2.571 -2 3.143"
  }), e.createElement("path", {
    d: "M12 20l4 -9l4 9"
  }), e.createElement("path", {
    d: "M19.1 18h-6.2"
  }));
}
var nre = ["size", "color", "stroke"];
function lre(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, nre);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-language-katakana",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M5 5h6.586a1 1 0 0 1 .707 1.707l-1.293 1.293"
  }), e.createElement("path", {
    d: "M8 8c0 1.5 .5 3 -2 5"
  }), e.createElement("path", {
    d: "M12 20l4 -9l4 9"
  }), e.createElement("path", {
    d: "M19.1 18h-6.2"
  }));
}
var are = ["size", "color", "stroke"];
function ire(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, are);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-language-off",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M4 5h1m4 0h2"
  }), e.createElement("path", {
    d: "M9 3v2m-.508 3.517c-.814 2.655 -2.52 4.483 -4.492 4.483"
  }), e.createElement("path", {
    d: "M5 9c-.003 2.144 2.952 3.908 6.7 4"
  }), e.createElement("path", {
    d: "M12 20l2.463 -5.541m1.228 -2.764l.309 -.695l.8 1.8"
  }), e.createElement("path", {
    d: "M18 18h-5.1"
  }), e.createElement("path", {
    d: "M3 3l18 18"
  }));
}
var cre = ["size", "color", "stroke"];
function sre(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, cre);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-language",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M4 5h7"
  }), e.createElement("path", {
    d: "M9 3v2c0 4.418 -2.239 8 -5 8"
  }), e.createElement("path", {
    d: "M5 9c-.003 2.144 2.952 3.908 6.7 4"
  }), e.createElement("path", {
    d: "M12 20l4 -9l4 9"
  }), e.createElement("path", {
    d: "M19.1 18h-6.2"
  }));
}
var hre = ["size", "color", "stroke"];
function dre(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, hre);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-lasso-off",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M4.028 13.252c-.657 -.972 -1.028 -2.078 -1.028 -3.252c0 -1.804 .878 -3.449 2.319 -4.69m2.49 -1.506a11.066 11.066 0 0 1 4.191 -.804c4.97 0 9 3.134 9 7c0 1.799 -.873 3.44 -2.307 4.68m-2.503 1.517a11.066 11.066 0 0 1 -4.19 .803c-1.913 0 -3.686 -.464 -5.144 -1.255"
  }), e.createElement("circle", {
    cx: 5,
    cy: 15,
    r: 2
  }), e.createElement("path", {
    d: "M5 17c0 1.42 .316 2.805 1 4"
  }), e.createElement("path", {
    d: "M3 3l18 18"
  }));
}
var vre = ["size", "color", "stroke"];
function mre(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, vre);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-lasso-polygon",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M4.028 13.252l-1.028 -3.252l2 -7l7 5l8 -3l1 9l-9 3l-5.144 -1.255"
  }), e.createElement("circle", {
    cx: 5,
    cy: 15,
    r: 2
  }), e.createElement("path", {
    d: "M5 17c0 1.42 .316 2.805 1 4"
  }));
}
var kre = ["size", "color", "stroke"];
function wre(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, kre);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-lasso",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M4.028 13.252c-.657 -.972 -1.028 -2.078 -1.028 -3.252c0 -3.866 4.03 -7 9 -7s9 3.134 9 7s-4.03 7 -9 7c-1.913 0 -3.686 -.464 -5.144 -1.255"
  }), e.createElement("circle", {
    cx: 5,
    cy: 15,
    r: 2
  }), e.createElement("path", {
    d: "M5 17c0 1.42 .316 2.805 1 4"
  }));
}
var pre = ["size", "color", "stroke"];
function Ere(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, pre);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-layers-difference",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M16 16v2a2 2 0 0 1 -2 2h-8a2 2 0 0 1 -2 -2v-8a2 2 0 0 1 2 -2h2v-2a2 2 0 0 1 2 -2h8a2 2 0 0 1 2 2v8a2 2 0 0 1 -2 2h-2"
  }), e.createElement("polyline", {
    points: "10 8 8 8 8 10"
  }), e.createElement("polyline", {
    points: "8 14 8 16 10 16"
  }), e.createElement("polyline", {
    points: "14 8 16 8 16 10"
  }), e.createElement("polyline", {
    points: "16 14 16 16 14 16"
  }));
}
var ure = ["size", "color", "stroke"];
function gre(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, ure);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-layers-intersect-2",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("rect", {
    x: 8,
    y: 4,
    width: 12,
    height: 12,
    rx: 2
  }), e.createElement("rect", {
    x: 4,
    y: 8,
    width: 12,
    height: 12,
    rx: 2
  }), e.createElement("path", {
    d: "M9 15l6 -6"
  }));
}
var Mre = ["size", "color", "stroke"];
function xre(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Mre);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-layers-intersect",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("rect", {
    x: 8,
    y: 4,
    width: 12,
    height: 12,
    rx: 2
  }), e.createElement("rect", {
    x: 4,
    y: 8,
    width: 12,
    height: 12,
    rx: 2
  }));
}
var fre = ["size", "color", "stroke"];
function zre(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, fre);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-layers-linked",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M19 8.268a2 2 0 0 1 1 1.732v8a2 2 0 0 1 -2 2h-8a2 2 0 0 1 -2 -2v-8a2 2 0 0 1 2 -2h3"
  }), e.createElement("path", {
    d: "M5.003 15.734a2 2 0 0 1 -1.003 -1.734v-8a2 2 0 0 1 2 -2h8a2 2 0 0 1 2 2v8a2 2 0 0 1 -2 2h-3"
  }));
}
var bre = ["size", "color", "stroke"];
function Lre(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, bre);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-layers-off",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M8.59 4.581c.362 -.359 .86 -.581 1.41 -.581h8a2 2 0 0 1 2 2v8c0 .556 -.227 1.06 -.594 1.422m-3.406 .578h-6a2 2 0 0 1 -2 -2v-6"
  }), e.createElement("path", {
    d: "M16 16v2a2 2 0 0 1 -2 2h-8a2 2 0 0 1 -2 -2v-8a2 2 0 0 1 2 -2h2"
  }), e.createElement("path", {
    d: "M3 3l18 18"
  }));
}
var yre = ["size", "color", "stroke"];
function Cre(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, yre);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-layers-subtract",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("rect", {
    x: 8,
    y: 4,
    width: 12,
    height: 12,
    rx: 2
  }), e.createElement("path", {
    d: "M16 16v2a2 2 0 0 1 -2 2h-8a2 2 0 0 1 -2 -2v-8a2 2 0 0 1 2 -2h2"
  }));
}
var jre = ["size", "color", "stroke"];
function Bre(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, jre);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-layers-union",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M16 16v2a2 2 0 0 1 -2 2h-8a2 2 0 0 1 -2 -2v-8a2 2 0 0 1 2 -2h2v-2a2 2 0 0 1 2 -2h8a2 2 0 0 1 2 2v8a2 2 0 0 1 -2 2h-2"
  }));
}
var Hre = ["size", "color", "stroke"];
function Nre(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Hre);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-layout-2",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("rect", {
    x: 4,
    y: 4,
    width: 6,
    height: 5,
    rx: 2
  }), e.createElement("rect", {
    x: 4,
    y: 13,
    width: 6,
    height: 7,
    rx: 2
  }), e.createElement("rect", {
    x: 14,
    y: 4,
    width: 6,
    height: 7,
    rx: 2
  }), e.createElement("rect", {
    x: 14,
    y: 15,
    width: 6,
    height: 5,
    rx: 2
  }));
}
var Wre = ["size", "color", "stroke"];
function qre(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Wre);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-layout-align-bottom",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("line", {
    x1: 4,
    y1: 20,
    x2: 20,
    y2: 20
  }), e.createElement("rect", {
    x: 9,
    y: 4,
    width: 6,
    height: 12,
    rx: 2
  }));
}
var Ore = ["size", "color", "stroke"];
function Pre(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Ore);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-layout-align-center",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("line", {
    x1: 12,
    y1: 4,
    x2: 12,
    y2: 9
  }), e.createElement("line", {
    x1: 12,
    y1: 15,
    x2: 12,
    y2: 20
  }), e.createElement("rect", {
    x: 6,
    y: 9,
    width: 12,
    height: 6,
    rx: 2
  }));
}
var Sre = ["size", "color", "stroke"];
function Ire(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Sre);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-layout-align-left",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("line", {
    x1: 4,
    y1: 4,
    x2: 4,
    y2: 20
  }), e.createElement("rect", {
    x: 8,
    y: 9,
    width: 12,
    height: 6,
    rx: 2
  }));
}
var Are = ["size", "color", "stroke"];
function Dre(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Are);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-layout-align-middle",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("line", {
    x1: 4,
    y1: 12,
    x2: 9,
    y2: 12
  }), e.createElement("line", {
    x1: 15,
    y1: 12,
    x2: 20,
    y2: 12
  }), e.createElement("rect", {
    x: 9,
    y: 6,
    width: 6,
    height: 12,
    rx: 2
  }));
}
var Fre = ["size", "color", "stroke"];
function Gre(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Fre);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-layout-align-right",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("line", {
    x1: 20,
    y1: 4,
    x2: 20,
    y2: 20
  }), e.createElement("rect", {
    x: 4,
    y: 9,
    width: 12,
    height: 6,
    rx: 2
  }));
}
var Jre = ["size", "color", "stroke"];
function Kre(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Jre);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-layout-align-top",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("line", {
    x1: 4,
    y1: 4,
    x2: 20,
    y2: 4
  }), e.createElement("rect", {
    x: 9,
    y: 8,
    width: 6,
    height: 12,
    rx: 2
  }));
}
var Qre = ["size", "color", "stroke"];
function Rre(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Qre);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-layout-board-split",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("rect", {
    x: 4,
    y: 4,
    width: 16,
    height: 16,
    rx: 2
  }), e.createElement("path", {
    d: "M4 12h8"
  }), e.createElement("path", {
    d: "M12 15h8"
  }), e.createElement("path", {
    d: "M12 9h8"
  }), e.createElement("path", {
    d: "M12 4v16"
  }));
}
var Tre = ["size", "color", "stroke"];
function Ure(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Tre);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-layout-board",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("rect", {
    x: 4,
    y: 4,
    width: 16,
    height: 16,
    rx: 2
  }), e.createElement("path", {
    d: "M4 9h8"
  }), e.createElement("path", {
    d: "M12 15h8"
  }), e.createElement("path", {
    d: "M12 4v16"
  }));
}
var Vre = ["size", "color", "stroke"];
function Xre(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Vre);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-layout-bottombar-collapse",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M20 6v12a2 2 0 0 1 -2 2h-12a2 2 0 0 1 -2 -2v-12a2 2 0 0 1 2 -2h12a2 2 0 0 1 2 2z"
  }), e.createElement("path", {
    d: "M20 15h-16"
  }), e.createElement("path", {
    d: "M14 8l-2 2l-2 -2"
  }));
}
var Yre = ["size", "color", "stroke"];
function Zre(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Yre);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-layout-bottombar-expand",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M20 6v12a2 2 0 0 1 -2 2h-12a2 2 0 0 1 -2 -2v-12a2 2 0 0 1 2 -2h12a2 2 0 0 1 2 2z"
  }), e.createElement("path", {
    d: "M20 15h-16"
  }), e.createElement("path", {
    d: "M14 10l-2 -2l-2 2"
  }));
}
var $re = ["size", "color", "stroke"];
function _re(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, $re);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-layout-bottombar",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("rect", {
    x: 4,
    y: 4,
    width: 16,
    height: 16,
    rx: 2
  }), e.createElement("line", {
    x1: 4,
    y1: 15,
    x2: 20,
    y2: 15
  }));
}
var ene = ["size", "color", "stroke"];
function tne(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, ene);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-layout-cards",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("rect", {
    x: 4,
    y: 4,
    width: 6,
    height: 16,
    rx: 2
  }), e.createElement("rect", {
    x: 14,
    y: 4,
    width: 6,
    height: 10,
    rx: 2
  }));
}
var one = ["size", "color", "stroke"];
function rne(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, one);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-layout-collage",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("rect", {
    x: 4,
    y: 4,
    width: 16,
    height: 16,
    rx: 2
  }), e.createElement("path", {
    d: "M10 4l4 16"
  }), e.createElement("path", {
    d: "M12 12l-8 2"
  }));
}
var nne = ["size", "color", "stroke"];
function lne(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, nne);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-layout-columns",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("rect", {
    x: 4,
    y: 4,
    width: 16,
    height: 16,
    rx: 2
  }), e.createElement("line", {
    x1: 12,
    y1: 4,
    x2: 12,
    y2: 20
  }));
}
var ane = ["size", "color", "stroke"];
function ine(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, ane);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-layout-dashboard",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M4 4h6v8h-6z"
  }), e.createElement("path", {
    d: "M4 16h6v4h-6z"
  }), e.createElement("path", {
    d: "M14 12h6v8h-6z"
  }), e.createElement("path", {
    d: "M14 4h6v4h-6z"
  }));
}
var cne = ["size", "color", "stroke"];
function sne(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, cne);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-layout-distribute-horizontal",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("line", {
    x1: 4,
    y1: 4,
    x2: 20,
    y2: 4
  }), e.createElement("line", {
    x1: 4,
    y1: 20,
    x2: 20,
    y2: 20
  }), e.createElement("rect", {
    x: 6,
    y: 9,
    width: 12,
    height: 6,
    rx: 2
  }));
}
var hne = ["size", "color", "stroke"];
function dne(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, hne);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-layout-distribute-vertical",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("line", {
    x1: 4,
    y1: 4,
    x2: 4,
    y2: 20
  }), e.createElement("line", {
    x1: 20,
    y1: 4,
    x2: 20,
    y2: 20
  }), e.createElement("rect", {
    x: 9,
    y: 6,
    width: 6,
    height: 12,
    rx: 2
  }));
}
var vne = ["size", "color", "stroke"];
function mne(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, vne);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-layout-grid-add",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("rect", {
    x: 4,
    y: 4,
    width: 6,
    height: 6,
    rx: 1
  }), e.createElement("rect", {
    x: 14,
    y: 4,
    width: 6,
    height: 6,
    rx: 1
  }), e.createElement("rect", {
    x: 4,
    y: 14,
    width: 6,
    height: 6,
    rx: 1
  }), e.createElement("path", {
    d: "M14 17h6m-3 -3v6"
  }));
}
var kne = ["size", "color", "stroke"];
function wne(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, kne);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-layout-grid",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("rect", {
    x: 4,
    y: 4,
    width: 6,
    height: 6,
    rx: 1
  }), e.createElement("rect", {
    x: 14,
    y: 4,
    width: 6,
    height: 6,
    rx: 1
  }), e.createElement("rect", {
    x: 4,
    y: 14,
    width: 6,
    height: 6,
    rx: 1
  }), e.createElement("rect", {
    x: 14,
    y: 14,
    width: 6,
    height: 6,
    rx: 1
  }));
}
var pne = ["size", "color", "stroke"];
function Ene(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, pne);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-layout-kanban",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("line", {
    x1: 4,
    y1: 4,
    x2: 10,
    y2: 4
  }), e.createElement("line", {
    x1: 14,
    y1: 4,
    x2: 20,
    y2: 4
  }), e.createElement("rect", {
    x: 4,
    y: 8,
    width: 6,
    height: 12,
    rx: 2
  }), e.createElement("rect", {
    x: 14,
    y: 8,
    width: 6,
    height: 6,
    rx: 2
  }));
}
var une = ["size", "color", "stroke"];
function gne(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, une);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-layout-list",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("rect", {
    x: 4,
    y: 4,
    width: 16,
    height: 6,
    rx: 2
  }), e.createElement("rect", {
    x: 4,
    y: 14,
    width: 16,
    height: 6,
    rx: 2
  }));
}
var Mne = ["size", "color", "stroke"];
function xne(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Mne);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-layout-navbar-collapse",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M4 18v-12a2 2 0 0 1 2 -2h12a2 2 0 0 1 2 2v12a2 2 0 0 1 -2 2h-12a2 2 0 0 1 -2 -2z"
  }), e.createElement("path", {
    d: "M4 9h16"
  }), e.createElement("path", {
    d: "M10 16l2 -2l2 2"
  }));
}
var fne = ["size", "color", "stroke"];
function zne(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, fne);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-layout-navbar-expand",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M4 18v-12a2 2 0 0 1 2 -2h12a2 2 0 0 1 2 2v12a2 2 0 0 1 -2 2h-12a2 2 0 0 1 -2 -2z"
  }), e.createElement("path", {
    d: "M4 9h16"
  }), e.createElement("path", {
    d: "M10 14l2 2l2 -2"
  }));
}
var bne = ["size", "color", "stroke"];
function Lne(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, bne);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-layout-navbar",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("rect", {
    x: 4,
    y: 4,
    width: 16,
    height: 16,
    rx: 2
  }), e.createElement("line", {
    x1: 4,
    y1: 9,
    x2: 20,
    y2: 9
  }));
}
var yne = ["size", "color", "stroke"];
function Cne(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, yne);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-layout-off",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M8 4a2 2 0 0 1 2 2m-1.162 2.816a1.993 1.993 0 0 1 -.838 .184h-2a2 2 0 0 1 -2 -2v-1c0 -.549 .221 -1.046 .58 -1.407"
  }), e.createElement("rect", {
    x: 4,
    y: 13,
    width: 6,
    height: 7,
    rx: 2
  }), e.createElement("path", {
    d: "M14 10v-4a2 2 0 0 1 2 -2h2a2 2 0 0 1 2 2v10m-.595 3.423a1.994 1.994 0 0 1 -1.405 .577h-2a2 2 0 0 1 -2 -2v-4"
  }), e.createElement("path", {
    d: "M3 3l18 18"
  }));
}
var jne = ["size", "color", "stroke"];
function Bne(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, jne);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-layout-rows",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("rect", {
    x: 4,
    y: 4,
    width: 16,
    height: 16,
    rx: 2
  }), e.createElement("line", {
    x1: 4,
    y1: 12,
    x2: 20,
    y2: 12
  }));
}
var Hne = ["size", "color", "stroke"];
function Nne(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Hne);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-layout-sidebar-left-collapse",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("rect", {
    x: 4,
    y: 4,
    width: 16,
    height: 16,
    rx: 2
  }), e.createElement("path", {
    d: "M9 4v16"
  }), e.createElement("path", {
    d: "M15 10l-2 2l2 2"
  }));
}
var Wne = ["size", "color", "stroke"];
function qne(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Wne);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-layout-sidebar-left-expand",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("rect", {
    x: 4,
    y: 4,
    width: 16,
    height: 16,
    rx: 2
  }), e.createElement("path", {
    d: "M9 4v16"
  }), e.createElement("path", {
    d: "M14 10l2 2l-2 2"
  }));
}
var One = ["size", "color", "stroke"];
function Pne(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, One);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-layout-sidebar-right-collapse",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("rect", {
    x: 4,
    y: 4,
    width: 16,
    height: 16,
    rx: 2
  }), e.createElement("path", {
    d: "M15 4v16"
  }), e.createElement("path", {
    d: "M9 10l2 2l-2 2"
  }));
}
var Sne = ["size", "color", "stroke"];
function Ine(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Sne);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-layout-sidebar-right-expand",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("rect", {
    x: 4,
    y: 4,
    width: 16,
    height: 16,
    rx: 2
  }), e.createElement("path", {
    d: "M15 4v16"
  }), e.createElement("path", {
    d: "M10 10l-2 2l2 2"
  }));
}
var Ane = ["size", "color", "stroke"];
function Dne(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Ane);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-layout-sidebar-right",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("rect", {
    x: 4,
    y: 4,
    width: 16,
    height: 16,
    rx: 2
  }), e.createElement("line", {
    x1: 15,
    y1: 4,
    x2: 15,
    y2: 20
  }));
}
var Fne = ["size", "color", "stroke"];
function Gne(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Fne);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-layout-sidebar",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("rect", {
    x: 4,
    y: 4,
    width: 16,
    height: 16,
    rx: 2
  }), e.createElement("line", {
    x1: 9,
    y1: 4,
    x2: 9,
    y2: 20
  }));
}
var Jne = ["size", "color", "stroke"];
function Kne(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Jne);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-layout",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("rect", {
    x: 4,
    y: 4,
    width: 6,
    height: 5,
    rx: 2
  }), e.createElement("rect", {
    x: 4,
    y: 13,
    width: 6,
    height: 7,
    rx: 2
  }), e.createElement("rect", {
    x: 14,
    y: 4,
    width: 6,
    height: 16,
    rx: 2
  }));
}
var Qne = ["size", "color", "stroke"];
function Rne(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Qne);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-leaf-off",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M5 21c.475 -4.27 2.3 -7.64 6.331 -9.683"
  }), e.createElement("path", {
    d: "M6.618 6.623c-1.874 1.625 -2.625 3.877 -2.632 6.377c0 1 0 3 2 5h3.014c2.733 0 5.092 -.635 6.92 -2.087m1.899 -2.099c1.224 -1.872 1.987 -4.434 2.181 -7.814v-2h-4.014c-2.863 0 -5.118 .405 -6.861 1.118"
  }), e.createElement("path", {
    d: "M3 3l18 18"
  }));
}
var Tne = ["size", "color", "stroke"];
function Une(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Tne);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-leaf",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M5 21c.5 -4.5 2.5 -8 7 -10"
  }), e.createElement("path", {
    d: "M9 18c6.218 0 10.5 -3.288 11 -12v-2h-4.014c-9 0 -11.986 4 -12 9c0 1 0 3 2 5h3z"
  }));
}
var Vne = ["size", "color", "stroke"];
function Xne(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Vne);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-lego-off",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M9.5 11h.01"
  }), e.createElement("path", {
    d: "M9.5 15a3.5 3.5 0 0 0 5 0"
  }), e.createElement("path", {
    d: "M8 4v-1h8v2h1a3 3 0 0 1 3 3v8m-.884 3.127a2.99 2.99 0 0 1 -2.116 .873v1h-10v-1a3 3 0 0 1 -3 -3v-9c0 -1.083 .574 -2.032 1.435 -2.56"
  }), e.createElement("path", {
    d: "M3 3l18 18"
  }));
}
var Yne = ["size", "color", "stroke"];
function Zne(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Yne);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-lego",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("line", {
    x1: 9.5,
    y1: 11,
    x2: 9.51,
    y2: 11
  }), e.createElement("line", {
    x1: 14.5,
    y1: 11,
    x2: 14.51,
    y2: 11
  }), e.createElement("path", {
    d: "M9.5 15a3.5 3.5 0 0 0 5 0"
  }), e.createElement("path", {
    d: "M7 5h1v-2h8v2h1a3 3 0 0 1 3 3v9a3 3 0 0 1 -3 3v1h-10v-1a3 3 0 0 1 -3 -3v-9a3 3 0 0 1 3 -3"
  }));
}
var $ne = ["size", "color", "stroke"];
function _ne(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, $ne);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-lemon-2",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M18 4a2 2 0 0 1 1.185 3.611c1.55 2.94 .873 6.917 -1.892 9.682c-2.765 2.765 -6.743 3.442 -9.682 1.892a2 2 0 1 1 -2.796 -2.796c-1.55 -2.94 -.873 -6.917 1.892 -9.682c2.765 -2.765 6.743 -3.442 9.682 -1.892a1.999 1.999 0 0 1 1.611 -.815z"
  }));
}
var ele = ["size", "color", "stroke"];
function tle(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, ele);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-lemon",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M17.536 3.393c3.905 3.906 3.905 10.237 0 14.143c-3.906 3.905 -10.237 3.905 -14.143 0l14.143 -14.143"
  }), e.createElement("path", {
    d: "M5.868 15.06a6.5 6.5 0 0 0 9.193 -9.192"
  }), e.createElement("path", {
    d: "M10.464 10.464l4.597 4.597"
  }), e.createElement("path", {
    d: "M10.464 10.464v6.364"
  }), e.createElement("path", {
    d: "M10.464 10.464h6.364"
  }));
}
var ole = ["size", "color", "stroke"];
function rle(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, ole);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-letter-a",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M7 20v-12a4 4 0 0 1 4 -4h2a4 4 0 0 1 4 4v12"
  }), e.createElement("line", {
    x1: 7,
    y1: 13,
    x2: 17,
    y2: 13
  }));
}
var nle = ["size", "color", "stroke"];
function lle(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, nle);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-letter-b",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M7 20v-16h6a4 4 0 0 1 0 8a4 4 0 0 1 0 8h-6"
  }), e.createElement("line", {
    x1: 7,
    y1: 12,
    x2: 13,
    y2: 12
  }));
}
var ale = ["size", "color", "stroke"];
function ile(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, ale);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-letter-c",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M18 9a5 5 0 0 0 -5 -5h-2a5 5 0 0 0 -5 5v6a5 5 0 0 0 5 5h2a5 5 0 0 0 5 -5"
  }));
}
var cle = ["size", "color", "stroke"];
function sle(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, cle);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-letter-case-lower",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("circle", {
    cx: 6.5,
    cy: 15.5,
    r: 3.5
  }), e.createElement("path", {
    d: "M10 12v7"
  }), e.createElement("circle", {
    cx: 17.5,
    cy: 15.5,
    r: 3.5
  }), e.createElement("path", {
    d: "M21 12v7"
  }));
}
var hle = ["size", "color", "stroke"];
function dle(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, hle);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-letter-case-toggle",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("circle", {
    cx: 6.5,
    cy: 15.5,
    r: 3.5
  }), e.createElement("path", {
    d: "M14 19v-10.5a3.5 3.5 0 0 1 7 0v10.5"
  }), e.createElement("path", {
    d: "M14 13h7"
  }), e.createElement("path", {
    d: "M10 12v7"
  }));
}
var vle = ["size", "color", "stroke"];
function mle(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, vle);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-letter-case-upper",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M3 19v-10.5a3.5 3.5 0 0 1 7 0v10.5"
  }), e.createElement("path", {
    d: "M3 13h7"
  }), e.createElement("path", {
    d: "M14 19v-10.5a3.5 3.5 0 0 1 7 0v10.5"
  }), e.createElement("path", {
    d: "M14 13h7"
  }));
}
var kle = ["size", "color", "stroke"];
function wle(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, kle);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-letter-case",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("circle", {
    cx: 17.5,
    cy: 15.5,
    r: 3.5
  }), e.createElement("path", {
    d: "M3 19v-10.5a3.5 3.5 0 0 1 7 0v10.5"
  }), e.createElement("path", {
    d: "M3 13h7"
  }), e.createElement("path", {
    d: "M21 12v7"
  }));
}
var ple = ["size", "color", "stroke"];
function Ele(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, ple);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-letter-d",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M7 4h6a5 5 0 0 1 5 5v6a5 5 0 0 1 -5 5h-6v-16"
  }));
}
var ule = ["size", "color", "stroke"];
function gle(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, ule);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-letter-e",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M17 4h-10v16h10"
  }), e.createElement("line", {
    x1: 7,
    y1: 12,
    x2: 15,
    y2: 12
  }));
}
var Mle = ["size", "color", "stroke"];
function xle(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Mle);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-letter-f",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M17 4h-10v16"
  }), e.createElement("line", {
    x1: 7,
    y1: 12,
    x2: 15,
    y2: 12
  }));
}
var fle = ["size", "color", "stroke"];
function zle(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, fle);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-letter-g",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M18 9a5 5 0 0 0 -5 -5h-2a5 5 0 0 0 -5 5v6a5 5 0 0 0 5 5h2a5 5 0 0 0 5 -5v-2h-4"
  }));
}
var ble = ["size", "color", "stroke"];
function Lle(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, ble);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-letter-h",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("line", {
    x1: 17,
    y1: 4,
    x2: 17,
    y2: 20
  }), e.createElement("line", {
    x1: 7,
    y1: 12,
    x2: 17,
    y2: 12
  }), e.createElement("line", {
    x1: 7,
    y1: 4,
    x2: 7,
    y2: 20
  }));
}
var yle = ["size", "color", "stroke"];
function Cle(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, yle);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-letter-i",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("line", {
    x1: 12,
    y1: 4,
    x2: 12,
    y2: 20
  }));
}
var jle = ["size", "color", "stroke"];
function Ble(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, jle);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-letter-j",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M17 4v12a4 4 0 0 1 -4 4h-2a4 4 0 0 1 -4 -4"
  }));
}
var Hle = ["size", "color", "stroke"];
function Nle(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Hle);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-letter-k",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("line", {
    x1: 7,
    y1: 4,
    x2: 7,
    y2: 20
  }), e.createElement("path", {
    d: "M7 12h2l8 -8"
  }), e.createElement("line", {
    x1: 9,
    y1: 12,
    x2: 17,
    y2: 20
  }));
}
var Wle = ["size", "color", "stroke"];
function qle(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Wle);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-letter-l",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M7 4v16h10"
  }));
}
var Ole = ["size", "color", "stroke"];
function Ple(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Ole);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-letter-m",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M6 20v-16l6 14l6 -14v16"
  }));
}
var Sle = ["size", "color", "stroke"];
function Ile(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Sle);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-letter-n",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M7 20v-16l10 16v-16"
  }));
}
var Ale = ["size", "color", "stroke"];
function Dle(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Ale);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-letter-o",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M18 9a5 5 0 0 0 -5 -5h-2a5 5 0 0 0 -5 5v6a5 5 0 0 0 5 5h2a5 5 0 0 0 5 -5v-6"
  }));
}
var Fle = ["size", "color", "stroke"];
function Gle(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Fle);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-letter-p",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M7 20v-16h5.5a4 4 0 0 1 0 9h-5.5"
  }));
}
var Jle = ["size", "color", "stroke"];
function Kle(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Jle);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-letter-q",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M18 9a5 5 0 0 0 -5 -5h-2a5 5 0 0 0 -5 5v6a5 5 0 0 0 5 5h2a5 5 0 0 0 5 -5v-6"
  }), e.createElement("line", {
    x1: 13,
    y1: 15,
    x2: 18,
    y2: 20
  }));
}
var Qle = ["size", "color", "stroke"];
function Rle(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Qle);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-letter-r",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M7 20v-16h5.5a4 4 0 0 1 0 9h-5.5"
  }), e.createElement("line", {
    x1: 12,
    y1: 13,
    x2: 17,
    y2: 20
  }));
}
var Tle = ["size", "color", "stroke"];
function Ule(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Tle);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-letter-s",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M17 8a4 4 0 0 0 -4 -4h-2a4 4 0 0 0 0 8h2a4 4 0 0 1 0 8h-2a4 4 0 0 1 -4 -4"
  }));
}
var Vle = ["size", "color", "stroke"];
function Xle(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Vle);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-letter-spacing",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M5 12v-5.5a2.5 2.5 0 0 1 5 0v5.5m0 -4h-5"
  }), e.createElement("path", {
    d: "M13 4l3 8l3 -8"
  }), e.createElement("path", {
    d: "M5 18h14"
  }), e.createElement("path", {
    d: "M17 20l2 -2l-2 -2"
  }), e.createElement("path", {
    d: "M7 16l-2 2l2 2"
  }));
}
var Yle = ["size", "color", "stroke"];
function Zle(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Yle);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-letter-t",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("line", {
    x1: 6,
    y1: 4,
    x2: 18,
    y2: 4
  }), e.createElement("line", {
    x1: 12,
    y1: 4,
    x2: 12,
    y2: 20
  }));
}
var $le = ["size", "color", "stroke"];
function _le(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, $le);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-letter-u",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M6 4v11a5 5 0 0 0 5 5h2a5 5 0 0 0 5 -5v-11"
  }));
}
var eae = ["size", "color", "stroke"];
function tae(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, eae);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-letter-v",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M6 4l6 16l6 -16"
  }));
}
var oae = ["size", "color", "stroke"];
function rae(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, oae);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-letter-w",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M4 4l4 16l4 -14l4 14l4 -16"
  }));
}
var nae = ["size", "color", "stroke"];
function lae(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, nae);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-letter-x",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("line", {
    x1: 7,
    y1: 4,
    x2: 17,
    y2: 20
  }), e.createElement("line", {
    x1: 17,
    y1: 4,
    x2: 7,
    y2: 20
  }));
}
var aae = ["size", "color", "stroke"];
function iae(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, aae);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-letter-y",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M7 4l5 9l5 -9"
  }), e.createElement("line", {
    x1: 12,
    y1: 13,
    x2: 12,
    y2: 20
  }));
}
var cae = ["size", "color", "stroke"];
function sae(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, cae);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-letter-z",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M7 4h10l-10 16h10"
  }));
}
var hae = ["size", "color", "stroke"];
function dae(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, hae);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-license-off",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M15 21h-9a3 3 0 0 1 -3 -3v-1h10v2a2 2 0 1 0 4 0v-2m0 -4v-8a2 2 0 1 1 2 2h-2m2 -4h-11a3 3 0 0 0 -.864 .126m-2.014 2.025a3 3 0 0 0 -.122 .849v11"
  }), e.createElement("path", {
    d: "M11 7h2"
  }), e.createElement("path", {
    d: "M9 11h2"
  }), e.createElement("path", {
    d: "M3 3l18 18"
  }));
}
var vae = ["size", "color", "stroke"];
function mae(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, vae);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-license",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M15 21h-9a3 3 0 0 1 -3 -3v-1h10v2a2 2 0 0 0 4 0v-14a2 2 0 1 1 2 2h-2m2 -4h-11a3 3 0 0 0 -3 3v11"
  }), e.createElement("line", {
    x1: 9,
    y1: 7,
    x2: 13,
    y2: 7
  }), e.createElement("line", {
    x1: 9,
    y1: 11,
    x2: 13,
    y2: 11
  }));
}
var kae = ["size", "color", "stroke"];
function wae(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, kae);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-lifebuoy-off",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M9.171 9.172a4 4 0 0 0 5.65 5.663m1.179 -2.835a4 4 0 0 0 -4 -4"
  }), e.createElement("path", {
    d: "M5.64 5.632a9 9 0 1 0 12.73 12.725m1.667 -2.301a9 9 0 0 0 -12.077 -12.1"
  }), e.createElement("path", {
    d: "M15 15l3.35 3.35"
  }), e.createElement("path", {
    d: "M9 15l-3.35 3.35"
  }), e.createElement("path", {
    d: "M5.65 5.65l3.35 3.35"
  }), e.createElement("path", {
    d: "M18.35 5.65l-3.35 3.35"
  }), e.createElement("path", {
    d: "M3 3l18 18"
  }));
}
var pae = ["size", "color", "stroke"];
function Eae(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, pae);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-lifebuoy",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 4
  }), e.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 9
  }), e.createElement("line", {
    x1: 15,
    y1: 15,
    x2: 18.35,
    y2: 18.35
  }), e.createElement("line", {
    x1: 9,
    y1: 15,
    x2: 5.65,
    y2: 18.35
  }), e.createElement("line", {
    x1: 5.65,
    y1: 5.65,
    x2: 9,
    y2: 9
  }), e.createElement("line", {
    x1: 18.35,
    y1: 5.65,
    x2: 15,
    y2: 9
  }));
}
var uae = ["size", "color", "stroke"];
function gae(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, uae);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-line-dashed",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M5 12h2"
  }), e.createElement("path", {
    d: "M17 12h2"
  }), e.createElement("path", {
    d: "M11 12h2"
  }));
}
var Mae = ["size", "color", "stroke"];
function xae(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Mae);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-line-dotted",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M4 12v.01"
  }), e.createElement("path", {
    d: "M8 12v.01"
  }), e.createElement("path", {
    d: "M12 12v.01"
  }), e.createElement("path", {
    d: "M16 12v.01"
  }), e.createElement("path", {
    d: "M20 12v.01"
  }));
}
var fae = ["size", "color", "stroke"];
function zae(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, fae);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-line-height",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("polyline", {
    points: "3 8 6 5 9 8"
  }), e.createElement("polyline", {
    points: "3 16 6 19 9 16"
  }), e.createElement("line", {
    x1: 6,
    y1: 5,
    x2: 6,
    y2: 19
  }), e.createElement("line", {
    x1: 13,
    y1: 6,
    x2: 20,
    y2: 6
  }), e.createElement("line", {
    x1: 13,
    y1: 12,
    x2: 20,
    y2: 12
  }), e.createElement("line", {
    x1: 13,
    y1: 18,
    x2: 20,
    y2: 18
  }));
}
var bae = ["size", "color", "stroke"];
function Lae(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, bae);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-line",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("circle", {
    cx: 6,
    cy: 18,
    r: 2
  }), e.createElement("circle", {
    cx: 18,
    cy: 6,
    r: 2
  }), e.createElement("line", {
    x1: 7.5,
    y1: 16.5,
    x2: 16.5,
    y2: 7.5
  }));
}
var yae = ["size", "color", "stroke"];
function Cae(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, yae);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-link-off",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M10 14a3.5 3.5 0 0 0 4.47 .444m2.025 -1.94c.557 -.556 1.392 -1.39 2.505 -2.504a3.536 3.536 0 0 0 -5 -5l-.5 .5"
  }), e.createElement("path", {
    d: "M9.548 9.544a3.5 3.5 0 0 0 -.548 .456l-4 4a3.536 3.536 0 0 0 5 5l.5 -.5"
  }), e.createElement("path", {
    d: "M3 3l18 18"
  }), e.createElement("path", {
    d: "M3 3l18 18"
  }));
}
var jae = ["size", "color", "stroke"];
function Bae(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, jae);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-link",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M10 14a3.5 3.5 0 0 0 5 0l4 -4a3.5 3.5 0 0 0 -5 -5l-.5 .5"
  }), e.createElement("path", {
    d: "M14 10a3.5 3.5 0 0 0 -5 0l-4 4a3.5 3.5 0 0 0 5 5l.5 -.5"
  }));
}
var Hae = ["size", "color", "stroke"];
function Nae(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Hae);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-list-check",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M3.5 5.5l1.5 1.5l2.5 -2.5"
  }), e.createElement("path", {
    d: "M3.5 11.5l1.5 1.5l2.5 -2.5"
  }), e.createElement("path", {
    d: "M3.5 17.5l1.5 1.5l2.5 -2.5"
  }), e.createElement("line", {
    x1: 11,
    y1: 6,
    x2: 20,
    y2: 6
  }), e.createElement("line", {
    x1: 11,
    y1: 12,
    x2: 20,
    y2: 12
  }), e.createElement("line", {
    x1: 11,
    y1: 18,
    x2: 20,
    y2: 18
  }));
}
var Wae = ["size", "color", "stroke"];
function qae(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Wae);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-list-details",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M13 5h8"
  }), e.createElement("path", {
    d: "M13 9h5"
  }), e.createElement("path", {
    d: "M13 15h8"
  }), e.createElement("path", {
    d: "M13 19h5"
  }), e.createElement("rect", {
    x: 3,
    y: 4,
    width: 6,
    height: 6,
    rx: 1
  }), e.createElement("rect", {
    x: 3,
    y: 14,
    width: 6,
    height: 6,
    rx: 1
  }));
}
var Oae = ["size", "color", "stroke"];
function Pae(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Oae);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-list-numbers",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M11 6h9"
  }), e.createElement("path", {
    d: "M11 12h9"
  }), e.createElement("path", {
    d: "M12 18h8"
  }), e.createElement("path", {
    d: "M4 16a2 2 0 1 1 4 0c0 .591 -.5 1 -1 1.5l-3 2.5h4"
  }), e.createElement("path", {
    d: "M6 10v-6l-2 2"
  }));
}
var Sae = ["size", "color", "stroke"];
function Iae(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Sae);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-list-search",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("circle", {
    cx: 15,
    cy: 15,
    r: 4
  }), e.createElement("path", {
    d: "M18.5 18.5l2.5 2.5"
  }), e.createElement("path", {
    d: "M4 6h16"
  }), e.createElement("path", {
    d: "M4 12h4"
  }), e.createElement("path", {
    d: "M4 18h4"
  }));
}
var Aae = ["size", "color", "stroke"];
function Dae(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Aae);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-list",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("line", {
    x1: 9,
    y1: 6,
    x2: 20,
    y2: 6
  }), e.createElement("line", {
    x1: 9,
    y1: 12,
    x2: 20,
    y2: 12
  }), e.createElement("line", {
    x1: 9,
    y1: 18,
    x2: 20,
    y2: 18
  }), e.createElement("line", {
    x1: 5,
    y1: 6,
    x2: 5,
    y2: 6.01
  }), e.createElement("line", {
    x1: 5,
    y1: 12,
    x2: 5,
    y2: 12.01
  }), e.createElement("line", {
    x1: 5,
    y1: 18,
    x2: 5,
    y2: 18.01
  }));
}
var Fae = ["size", "color", "stroke"];
function Gae(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Fae);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-live-photo-off",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M11.296 11.29a1 1 0 1 0 1.414 1.415"
  }), e.createElement("path", {
    d: "M8.473 8.456a5 5 0 1 0 7.076 7.066m1.365 -2.591a5 5 0 0 0 -5.807 -5.851"
  }), e.createElement("path", {
    d: "M15.9 20.11v.01"
  }), e.createElement("path", {
    d: "M19.04 17.61v.01"
  }), e.createElement("path", {
    d: "M20.77 14v.01"
  }), e.createElement("path", {
    d: "M20.77 10v.01"
  }), e.createElement("path", {
    d: "M19.04 6.39v.01"
  }), e.createElement("path", {
    d: "M15.9 3.89v.01"
  }), e.createElement("path", {
    d: "M12 3v.01"
  }), e.createElement("path", {
    d: "M8.1 3.89v.01"
  }), e.createElement("path", {
    d: "M4.96 6.39v.01"
  }), e.createElement("path", {
    d: "M3.23 10v.01"
  }), e.createElement("path", {
    d: "M3.23 14v.01"
  }), e.createElement("path", {
    d: "M4.96 17.61v.01"
  }), e.createElement("path", {
    d: "M8.1 20.11v.01"
  }), e.createElement("path", {
    d: "M12 21v.01"
  }), e.createElement("path", {
    d: "M3 3l18 18"
  }));
}
var Jae = ["size", "color", "stroke"];
function Kae(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Jae);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-live-photo",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 1
  }), e.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 5
  }), e.createElement("line", {
    x1: 15.9,
    y1: 20.11,
    x2: 15.9,
    y2: 20.12
  }), e.createElement("line", {
    x1: 19.04,
    y1: 17.61,
    x2: 19.04,
    y2: 17.62
  }), e.createElement("line", {
    x1: 20.77,
    y1: 14,
    x2: 20.77,
    y2: 14.01
  }), e.createElement("line", {
    x1: 20.77,
    y1: 10,
    x2: 20.77,
    y2: 10.01
  }), e.createElement("line", {
    x1: 19.04,
    y1: 6.39,
    x2: 19.04,
    y2: 6.4
  }), e.createElement("line", {
    x1: 15.9,
    y1: 3.89,
    x2: 15.9,
    y2: 3.9
  }), e.createElement("line", {
    x1: 12,
    y1: 3,
    x2: 12,
    y2: 3.01
  }), e.createElement("line", {
    x1: 8.1,
    y1: 3.89,
    x2: 8.1,
    y2: 3.9
  }), e.createElement("line", {
    x1: 4.96,
    y1: 6.39,
    x2: 4.96,
    y2: 6.4
  }), e.createElement("line", {
    x1: 3.23,
    y1: 10,
    x2: 3.23,
    y2: 10.01
  }), e.createElement("line", {
    x1: 3.23,
    y1: 14,
    x2: 3.23,
    y2: 14.01
  }), e.createElement("line", {
    x1: 4.96,
    y1: 17.61,
    x2: 4.96,
    y2: 17.62
  }), e.createElement("line", {
    x1: 8.1,
    y1: 20.11,
    x2: 8.1,
    y2: 20.12
  }), e.createElement("line", {
    x1: 12,
    y1: 21,
    x2: 12,
    y2: 21.01
  }));
}
var Qae = ["size", "color", "stroke"];
function Rae(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Qae);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-live-view",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M4 8v-2a2 2 0 0 1 2 -2h2"
  }), e.createElement("path", {
    d: "M4 16v2a2 2 0 0 0 2 2h2"
  }), e.createElement("path", {
    d: "M16 4h2a2 2 0 0 1 2 2v2"
  }), e.createElement("path", {
    d: "M16 20h2a2 2 0 0 0 2 -2v-2"
  }), e.createElement("line", {
    x1: 12,
    y1: 11,
    x2: 12,
    y2: 11.01
  }), e.createElement("path", {
    d: "M12 18l-3.5 -5a4 4 0 1 1 7 0l-3.5 5"
  }));
}
var Tae = ["size", "color", "stroke"];
function Uae(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Tae);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-loader-2",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M12 3a9 9 0 1 0 9 9"
  }));
}
var Vae = ["size", "color", "stroke"];
function Xae(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Vae);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-loader-3",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M3 12a9 9 0 0 0 9 9a9 9 0 0 0 9 -9a9 9 0 0 0 -9 -9"
  }), e.createElement("path", {
    d: "M17 12a5 5 0 1 0 -5 5"
  }));
}
var Yae = ["size", "color", "stroke"];
function Zae(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Yae);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-loader-quarter",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("line", {
    x1: 12,
    y1: 6,
    x2: 12,
    y2: 3
  }), e.createElement("line", {
    x1: 6,
    y1: 12,
    x2: 3,
    y2: 12
  }), e.createElement("line", {
    x1: 7.75,
    y1: 7.75,
    x2: 5.6,
    y2: 5.6
  }));
}
var $ae = ["size", "color", "stroke"];
function _ae(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, $ae);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-loader",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("line", {
    x1: 12,
    y1: 6,
    x2: 12,
    y2: 3
  }), e.createElement("line", {
    x1: 16.25,
    y1: 7.75,
    x2: 18.4,
    y2: 5.6
  }), e.createElement("line", {
    x1: 18,
    y1: 12,
    x2: 21,
    y2: 12
  }), e.createElement("line", {
    x1: 16.25,
    y1: 16.25,
    x2: 18.4,
    y2: 18.4
  }), e.createElement("line", {
    x1: 12,
    y1: 18,
    x2: 12,
    y2: 21
  }), e.createElement("line", {
    x1: 7.75,
    y1: 16.25,
    x2: 5.6,
    y2: 18.4
  }), e.createElement("line", {
    x1: 6,
    y1: 12,
    x2: 3,
    y2: 12
  }), e.createElement("line", {
    x1: 7.75,
    y1: 7.75,
    x2: 5.6,
    y2: 5.6
  }));
}
var eie = ["size", "color", "stroke"];
function tie(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, eie);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-location-broken",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M13 20l-3 -6l-7 -3.5a0.55 .55 0 0 1 0 -1l18 -6.5c-1.698 4.703 -3.05 8.37 -4 11"
  }), e.createElement("path", {
    d: "M16 17l4 4m0 -4l-4 4"
  }));
}
var oie = ["size", "color", "stroke"];
function rie(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, oie);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-location-off",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M10.72 6.712l10.28 -3.712l-3.724 10.313m-1.056 2.925l-1.72 4.762a0.55 .55 0 0 1 -1 0l-3.5 -7l-7 -3.5a0.55 .55 0 0 1 0 -1l4.775 -1.724"
  }), e.createElement("path", {
    d: "M3 3l18 18"
  }));
}
var nie = ["size", "color", "stroke"];
function lie(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, nie);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-location",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M21 3l-6.5 18a0.55 .55 0 0 1 -1 0l-3.5 -7l-7 -3.5a0.55 .55 0 0 1 0 -1l18 -6.5"
  }));
}
var aie = ["size", "color", "stroke"];
function iie(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, aie);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-lock-access-off",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M4 8v-2c0 -.554 .225 -1.055 .588 -1.417"
  }), e.createElement("path", {
    d: "M4 16v2a2 2 0 0 0 2 2h2"
  }), e.createElement("path", {
    d: "M16 4h2a2 2 0 0 1 2 2v2"
  }), e.createElement("path", {
    d: "M16 20h2c.55 0 1.05 -.222 1.41 -.582"
  }), e.createElement("path", {
    d: "M15 11a1 1 0 0 1 1 1m-.29 3.704a0.997 .997 0 0 1 -.71 .296h-6a1 1 0 0 1 -1 -1v-3a1 1 0 0 1 1 -1h2"
  }), e.createElement("path", {
    d: "M10 11v-1m1.182 -2.826a2 2 0 0 1 2.818 1.826v1"
  }), e.createElement("path", {
    d: "M3 3l18 18"
  }));
}
var cie = ["size", "color", "stroke"];
function sie(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, cie);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-lock-access",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M4 8v-2a2 2 0 0 1 2 -2h2"
  }), e.createElement("path", {
    d: "M4 16v2a2 2 0 0 0 2 2h2"
  }), e.createElement("path", {
    d: "M16 4h2a2 2 0 0 1 2 2v2"
  }), e.createElement("path", {
    d: "M16 20h2a2 2 0 0 0 2 -2v-2"
  }), e.createElement("rect", {
    x: 8,
    y: 11,
    width: 8,
    height: 5,
    rx: 1
  }), e.createElement("path", {
    d: "M10 11v-2a2 2 0 1 1 4 0v2"
  }));
}
var hie = ["size", "color", "stroke"];
function die(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, hie);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-lock-off",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("line", {
    x1: 3,
    y1: 3,
    x2: 21,
    y2: 21
  }), e.createElement("path", {
    d: "M19 19a2 2 0 0 1 -2 2h-10a2 2 0 0 1 -2 -2v-6a2 2 0 0 1 2 -2h4m4 0h2a2 2 0 0 1 2 2v2"
  }), e.createElement("circle", {
    cx: 12,
    cy: 16,
    r: 1
  }), e.createElement("path", {
    d: "M8 11v-3m.712 -3.278a4 4 0 0 1 7.288 2.278v4"
  }));
}
var vie = ["size", "color", "stroke"];
function mie(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, vie);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-lock-open-off",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M15 11h2a2 2 0 0 1 2 2v2m0 4a2 2 0 0 1 -2 2h-10a2 2 0 0 1 -2 -2v-6a2 2 0 0 1 2 -2h4"
  }), e.createElement("circle", {
    cx: 12,
    cy: 16,
    r: 1
  }), e.createElement("path", {
    d: "M8 11v-3m.347 -3.631a4 4 0 0 1 7.653 1.631"
  }), e.createElement("path", {
    d: "M3 3l18 18"
  }));
}
var kie = ["size", "color", "stroke"];
function wie(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, kie);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-lock-open",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("rect", {
    x: 5,
    y: 11,
    width: 14,
    height: 10,
    rx: 2
  }), e.createElement("circle", {
    cx: 12,
    cy: 16,
    r: 1
  }), e.createElement("path", {
    d: "M8 11v-5a4 4 0 0 1 8 0"
  }));
}
var pie = ["size", "color", "stroke"];
function Eie(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, pie);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-lock-square-rounded",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M12 3c7.2 0 9 1.8 9 9s-1.8 9 -9 9s-9 -1.8 -9 -9s1.8 -9 9 -9z"
  }), e.createElement("rect", {
    x: 8,
    y: 11,
    width: 8,
    height: 5,
    rx: 1
  }), e.createElement("path", {
    d: "M10 11v-2a2 2 0 1 1 4 0v2"
  }));
}
var uie = ["size", "color", "stroke"];
function gie(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, uie);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-lock-square",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("rect", {
    x: 8,
    y: 11,
    width: 8,
    height: 5,
    rx: 1
  }), e.createElement("path", {
    d: "M10 11v-2a2 2 0 1 1 4 0v2"
  }), e.createElement("rect", {
    x: 4,
    y: 4,
    width: 16,
    height: 16,
    rx: 2
  }));
}
var Mie = ["size", "color", "stroke"];
function xie(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Mie);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-lock",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("rect", {
    x: 5,
    y: 11,
    width: 14,
    height: 10,
    rx: 2
  }), e.createElement("circle", {
    cx: 12,
    cy: 16,
    r: 1
  }), e.createElement("path", {
    d: "M8 11v-4a4 4 0 0 1 8 0v4"
  }));
}
var fie = ["size", "color", "stroke"];
function zie(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, fie);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-logic-and",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M22 12h-5"
  }), e.createElement("path", {
    d: "M2 9h5"
  }), e.createElement("path", {
    d: "M2 15h5"
  }), e.createElement("path", {
    d: "M9 5c6 0 8 3.5 8 7s-2 7 -8 7h-2v-14h2z"
  }));
}
var bie = ["size", "color", "stroke"];
function Lie(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, bie);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-logic-buffer",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M22 12h-5"
  }), e.createElement("path", {
    d: "M2 9h5"
  }), e.createElement("path", {
    d: "M2 15h5"
  }), e.createElement("path", {
    d: "M7 5l10 7l-10 7z"
  }));
}
var yie = ["size", "color", "stroke"];
function Cie(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, yie);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-logic-nand",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M22 12h-3"
  }), e.createElement("path", {
    d: "M2 9h3"
  }), e.createElement("path", {
    d: "M2 15h3"
  }), e.createElement("path", {
    d: "M7 5c6 0 8 3.5 8 7s-2 7 -8 7h-2v-14h2z"
  }), e.createElement("circle", {
    cx: 17,
    cy: 12,
    r: 2
  }));
}
var jie = ["size", "color", "stroke"];
function Bie(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, jie);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-logic-nor",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M22 12h-4"
  }), e.createElement("path", {
    d: "M2 9h5"
  }), e.createElement("path", {
    d: "M2 15h5"
  }), e.createElement("path", {
    d: "M6 5c10.667 2.1 10.667 12.6 0 14c1.806 -4.667 1.806 -9.333 0 -14z"
  }), e.createElement("circle", {
    cx: 16,
    cy: 12,
    r: 2
  }));
}
var Hie = ["size", "color", "stroke"];
function Nie(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Hie);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-logic-not",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M22 12h-3"
  }), e.createElement("path", {
    d: "M2 9h3"
  }), e.createElement("path", {
    d: "M2 15h3"
  }), e.createElement("path", {
    d: "M5 5l10 7l-10 7z"
  }), e.createElement("circle", {
    cx: 17,
    cy: 12,
    r: 2
  }));
}
var Wie = ["size", "color", "stroke"];
function qie(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Wie);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-logic-or",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M22 12h-6"
  }), e.createElement("path", {
    d: "M2 9h7"
  }), e.createElement("path", {
    d: "M2 15h7"
  }), e.createElement("path", {
    d: "M8 5c10.667 2.1 10.667 12.6 0 14c1.806 -4.667 1.806 -9.333 0 -14z"
  }));
}
var Oie = ["size", "color", "stroke"];
function Pie(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Oie);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-logic-xnor",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M22 12h-2"
  }), e.createElement("path", {
    d: "M2 9h4"
  }), e.createElement("path", {
    d: "M2 15h4"
  }), e.createElement("path", {
    d: "M5 19c1.778 -4.667 1.778 -9.333 0 -14"
  }), e.createElement("path", {
    d: "M8 5c10.667 2.1 10.667 12.6 0 14c1.806 -4.667 1.806 -9.333 0 -14z"
  }), e.createElement("circle", {
    cx: 18,
    cy: 12,
    r: 2
  }));
}
var Sie = ["size", "color", "stroke"];
function Iie(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Sie);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-logic-xor",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M22 12h-4"
  }), e.createElement("path", {
    d: "M2 9h6"
  }), e.createElement("path", {
    d: "M2 15h6"
  }), e.createElement("path", {
    d: "M7 19c1.778 -4.667 1.778 -9.333 0 -14"
  }), e.createElement("path", {
    d: "M10 5c10.667 2.1 10.667 12.6 0 14c1.806 -4.667 1.806 -9.333 0 -14z"
  }));
}
var Aie = ["size", "color", "stroke"];
function Die(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Aie);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-login",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M14 8v-2a2 2 0 0 0 -2 -2h-7a2 2 0 0 0 -2 2v12a2 2 0 0 0 2 2h7a2 2 0 0 0 2 -2v-2"
  }), e.createElement("path", {
    d: "M20 12h-13l3 -3m0 6l-3 -3"
  }));
}
var Fie = ["size", "color", "stroke"];
function Gie(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Fie);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-logout",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M14 8v-2a2 2 0 0 0 -2 -2h-7a2 2 0 0 0 -2 2v12a2 2 0 0 0 2 2h7a2 2 0 0 0 2 -2v-2"
  }), e.createElement("path", {
    d: "M7 12h14l-3 -3m0 6l3 -3"
  }));
}
var Jie = ["size", "color", "stroke"];
function Kie(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Jie);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-lollipop-off",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M7.462 7.493a7 7 0 0 0 9.06 9.039m2.416 -1.57a7 7 0 1 0 -9.884 -9.915"
  }), e.createElement("path", {
    d: "M21 10a3.5 3.5 0 0 0 -7 0"
  }), e.createElement("path", {
    d: "M12.71 12.715a3.5 3.5 0 0 1 -5.71 -2.715"
  }), e.createElement("path", {
    d: "M14 17c.838 0 1.607 -.294 2.209 -.785m1.291 -2.715a3.5 3.5 0 0 0 -3.5 -3.5"
  }), e.createElement("path", {
    d: "M14 3a3.5 3.5 0 0 0 -3.5 3.5"
  }), e.createElement("path", {
    d: "M3 21l6 -6"
  }), e.createElement("path", {
    d: "M3 3l18 18"
  }));
}
var Qie = ["size", "color", "stroke"];
function Rie(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Qie);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-lollipop",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("circle", {
    cx: 14,
    cy: 10,
    r: 7
  }), e.createElement("path", {
    d: "M21 10a3.5 3.5 0 0 0 -7 0"
  }), e.createElement("path", {
    d: "M14 10a3.5 3.5 0 0 1 -7 0"
  }), e.createElement("path", {
    d: "M14 17a3.5 3.5 0 0 0 0 -7"
  }), e.createElement("path", {
    d: "M14 3a3.5 3.5 0 0 0 0 7"
  }), e.createElement("path", {
    d: "M3 21l6 -6"
  }));
}
var Tie = ["size", "color", "stroke"];
function Uie(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Tie);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-luggage-off",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M10 6h6a2 2 0 0 1 2 2v6m0 4a2 2 0 0 1 -2 2h-8a2 2 0 0 1 -2 -2v-10c0 -.546 .218 -1.04 .573 -1.4"
  }), e.createElement("path", {
    d: "M9 5a2 2 0 0 1 2 -2h2a2 2 0 0 1 2 2v1"
  }), e.createElement("path", {
    d: "M6 10h4m4 0h4"
  }), e.createElement("path", {
    d: "M6 16h10"
  }), e.createElement("path", {
    d: "M9 20v1"
  }), e.createElement("path", {
    d: "M15 20v1"
  }), e.createElement("path", {
    d: "M3 3l18 18"
  }));
}
var Vie = ["size", "color", "stroke"];
function Xie(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Vie);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-luggage",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("rect", {
    x: 6,
    y: 6,
    width: 12,
    height: 14,
    rx: 2
  }), e.createElement("path", {
    d: "M9 6v-1a2 2 0 0 1 2 -2h2a2 2 0 0 1 2 2v1"
  }), e.createElement("path", {
    d: "M6 10h12"
  }), e.createElement("path", {
    d: "M6 16h12"
  }), e.createElement("path", {
    d: "M9 20v1"
  }), e.createElement("path", {
    d: "M15 20v1"
  }));
}
var Yie = ["size", "color", "stroke"];
function Zie(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Yie);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-lungs-off",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M6.583 6.608c-1.206 1.058 -2.07 2.626 -2.933 5.449c-.42 1.37 -.636 2.962 -.648 4.775c-.012 1.675 1.261 3.054 2.877 3.161l.203 .007c1.611 0 2.918 -1.335 2.918 -2.98v-8.02"
  }), e.createElement("path", {
    d: "M15 11v-3.743c0 -.694 .552 -1.257 1.233 -1.257c.204 0 .405 .052 .584 .15l.13 .083c1.46 1.059 2.432 2.647 3.405 5.824c.42 1.37 .636 2.962 .648 4.775c0 .063 0 .125 -.004 .187m-1.455 2.51c-.417 .265 -.9 .43 -1.419 .464l-.202 .007c-1.613 0 -2.92 -1.335 -2.92 -2.98v-2.02"
  }), e.createElement("path", {
    d: "M9 12a2.99 2.99 0 0 0 2.132 -.89"
  }), e.createElement("path", {
    d: "M12 4v4"
  }), e.createElement("path", {
    d: "M3 3l18 18"
  }));
}
var $ie = ["size", "color", "stroke"];
function _ie(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, $ie);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-lungs",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M6.081 20c1.612 0 2.919 -1.335 2.919 -2.98v-9.763c0 -.694 -.552 -1.257 -1.232 -1.257c-.205 0 -.405 .052 -.584 .15l-.13 .083c-1.46 1.059 -2.432 2.647 -3.404 5.824c-.42 1.37 -.636 2.962 -.648 4.775c-.012 1.675 1.261 3.054 2.877 3.161l.203 .007z"
  }), e.createElement("path", {
    d: "M17.92 20c-1.613 0 -2.92 -1.335 -2.92 -2.98v-9.763c0 -.694 .552 -1.257 1.233 -1.257c.204 0 .405 .052 .584 .15l.13 .083c1.46 1.059 2.432 2.647 3.405 5.824c.42 1.37 .636 2.962 .648 4.775c.012 1.675 -1.261 3.054 -2.878 3.161l-.202 .007z"
  }), e.createElement("path", {
    d: "M9 12a3 3 0 0 0 3 -3a3 3 0 0 0 3 3"
  }), e.createElement("path", {
    d: "M12 4v5"
  }));
}
var ece = ["size", "color", "stroke"];
function tce(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, ece);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-macro-off",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M6 15a6 6 0 0 0 11.47 2.467"
  }), e.createElement("path", {
    d: "M15.53 15.53a6.001 6.001 0 0 0 -3.53 5.47"
  }), e.createElement("path", {
    d: "M12 21a6 6 0 0 0 -6 -6"
  }), e.createElement("path", {
    d: "M12 21v-10"
  }), e.createElement("path", {
    d: "M10.866 10.87a5.007 5.007 0 0 1 -3.734 -3.723m-.132 -4.147l3 2l2 -2l2 2l3 -2v3a5 5 0 0 1 -2.604 4.389"
  }), e.createElement("path", {
    d: "M3 3l18 18"
  }));
}
var oce = ["size", "color", "stroke"];
function rce(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, oce);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-macro",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M6 15a6 6 0 1 0 12 0"
  }), e.createElement("path", {
    d: "M18 15a6 6 0 0 0 -6 6"
  }), e.createElement("path", {
    d: "M12 21a6 6 0 0 0 -6 -6"
  }), e.createElement("path", {
    d: "M12 21v-10"
  }), e.createElement("path", {
    d: "M12 11a5 5 0 0 1 -5 -5v-3l3 2l2 -2l2 2l3 -2v3a5 5 0 0 1 -5 5z"
  }));
}
var nce = ["size", "color", "stroke"];
function lce(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, nce);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-magnet-off",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M7 3a2 2 0 0 1 2 2m0 4v4a3 3 0 0 0 5.552 1.578m.448 -3.578v-6a2 2 0 0 1 2 -2h1a2 2 0 0 1 2 2v8a7.99 7.99 0 0 1 -.424 2.577m-1.463 2.584a8 8 0 0 1 -14.113 -5.161v-8.001c0 -.297 .065 -.58 .181 -.833"
  }), e.createElement("path", {
    d: "M4 8h4"
  }), e.createElement("path", {
    d: "M15 8h4"
  }), e.createElement("path", {
    d: "M3 3l18 18"
  }));
}
var ace = ["size", "color", "stroke"];
function ice(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, ace);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-magnet",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M4 13v-8a2 2 0 0 1 2 -2h1a2 2 0 0 1 2 2v8a2 2 0 0 0 6 0v-8a2 2 0 0 1 2 -2h1a2 2 0 0 1 2 2v8a8 8 0 0 1 -16 0"
  }), e.createElement("line", {
    x1: 4,
    y1: 8,
    x2: 9,
    y2: 8
  }), e.createElement("line", {
    x1: 15,
    y1: 8,
    x2: 19,
    y2: 8
  }));
}
var cce = ["size", "color", "stroke"];
function sce(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, cce);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-mail-fast",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M3 7h3"
  }), e.createElement("path", {
    d: "M3 11h2"
  }), e.createElement("path", {
    d: "M9.02 8.801l-.6 6a2 2 0 0 0 1.99 2.199h7.98a2 2 0 0 0 1.99 -1.801l.6 -6a2 2 0 0 0 -1.99 -2.199h-7.98a2 2 0 0 0 -1.99 1.801z"
  }), e.createElement("path", {
    d: "M9.8 7.5l2.982 3.28a3 3 0 0 0 4.238 .202l3.28 -2.982"
  }));
}
var hce = ["size", "color", "stroke"];
function dce(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, hce);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-mail-forward",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M12 18h-7a2 2 0 0 1 -2 -2v-10a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v7.5"
  }), e.createElement("path", {
    d: "M3 6l9 6l9 -6"
  }), e.createElement("path", {
    d: "M15 18h6"
  }), e.createElement("path", {
    d: "M18 15l3 3l-3 3"
  }));
}
var vce = ["size", "color", "stroke"];
function mce(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, vce);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-mail-off",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M9 5h10a2 2 0 0 1 2 2v10m-2 2h-14a2 2 0 0 1 -2 -2v-10a2 2 0 0 1 2 -2"
  }), e.createElement("path", {
    d: "M3 7l9 6l.598 -.399m2.402 -1.601l6 -4"
  }), e.createElement("path", {
    d: "M3 3l18 18"
  }));
}
var kce = ["size", "color", "stroke"];
function wce(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, kce);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-mail-opened",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("polyline", {
    points: "3 9 12 15 21 9 12 3 3 9"
  }), e.createElement("path", {
    d: "M21 9v10a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2v-10"
  }), e.createElement("line", {
    x1: 3,
    y1: 19,
    x2: 9,
    y2: 13
  }), e.createElement("line", {
    x1: 15,
    y1: 13,
    x2: 21,
    y2: 19
  }));
}
var pce = ["size", "color", "stroke"];
function Ece(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, pce);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-mail",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("rect", {
    x: 3,
    y: 5,
    width: 18,
    height: 14,
    rx: 2
  }), e.createElement("polyline", {
    points: "3 7 12 13 21 7"
  }));
}
var uce = ["size", "color", "stroke"];
function gce(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, uce);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-mailbox-off",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M10 21v-6.5a3.5 3.5 0 0 0 -7 0v6.5h18m0 -4v-2a4 4 0 0 0 -4 -4h-2m-4 0h-4.5"
  }), e.createElement("path", {
    d: "M12 8v-5h4l2 2l-2 2h-4"
  }), e.createElement("path", {
    d: "M6 15h1"
  }), e.createElement("path", {
    d: "M3 3l18 18"
  }));
}
var Mce = ["size", "color", "stroke"];
function xce(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Mce);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-mailbox",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M10 21v-6.5a3.5 3.5 0 0 0 -7 0v6.5h18v-6a4 4 0 0 0 -4 -4h-10.5"
  }), e.createElement("path", {
    d: "M12 11v-8h4l2 2l-2 2h-4"
  }), e.createElement("path", {
    d: "M6 15h1"
  }));
}
var fce = ["size", "color", "stroke"];
function zce(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, fce);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-man",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M10 16v5"
  }), e.createElement("path", {
    d: "M14 16v5"
  }), e.createElement("path", {
    d: "M9 9h6l-1 7h-4z"
  }), e.createElement("path", {
    d: "M5 11c1.333 -1.333 2.667 -2 4 -2"
  }), e.createElement("path", {
    d: "M19 11c-1.333 -1.333 -2.667 -2 -4 -2"
  }), e.createElement("circle", {
    cx: 12,
    cy: 4,
    r: 2
  }));
}
var bce = ["size", "color", "stroke"];
function Lce(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, bce);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-manual-gearbox",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("circle", {
    cx: 5,
    cy: 6,
    r: 2
  }), e.createElement("circle", {
    cx: 12,
    cy: 6,
    r: 2
  }), e.createElement("circle", {
    cx: 19,
    cy: 6,
    r: 2
  }), e.createElement("circle", {
    cx: 5,
    cy: 18,
    r: 2
  }), e.createElement("circle", {
    cx: 12,
    cy: 18,
    r: 2
  }), e.createElement("line", {
    x1: 5,
    y1: 8,
    x2: 5,
    y2: 16
  }), e.createElement("line", {
    x1: 12,
    y1: 8,
    x2: 12,
    y2: 16
  }), e.createElement("path", {
    d: "M19 8v2a2 2 0 0 1 -2 2h-12"
  }));
}
var yce = ["size", "color", "stroke"];
function Cce(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, yce);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-map-2",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("line", {
    x1: 18,
    y1: 6,
    x2: 18,
    y2: 6.01
  }), e.createElement("path", {
    d: "M18 13l-3.5 -5a4 4 0 1 1 7 0l-3.5 5"
  }), e.createElement("polyline", {
    points: "10.5 4.75 9 4 3 7 3 20 9 17 15 20 21 17 21 15"
  }), e.createElement("line", {
    x1: 9,
    y1: 4,
    x2: 9,
    y2: 17
  }), e.createElement("line", {
    x1: 15,
    y1: 15,
    x2: 15,
    y2: 20
  }));
}
var jce = ["size", "color", "stroke"];
function Bce(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, jce);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-map-off",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M8.32 4.34l.68 -.34l6 3l6 -3v13m-2.67 1.335l-3.33 1.665l-6 -3l-6 3v-13l2.665 -1.333"
  }), e.createElement("path", {
    d: "M9 4v1m0 4v8"
  }), e.createElement("path", {
    d: "M15 7v4m0 4v5"
  }), e.createElement("path", {
    d: "M3 3l18 18"
  }));
}
var Hce = ["size", "color", "stroke"];
function Nce(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Hce);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-map-pin-off",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("line", {
    x1: 3,
    y1: 3,
    x2: 21,
    y2: 21
  }), e.createElement("path", {
    d: "M9.44 9.435a3 3 0 0 0 4.126 4.124m1.434 -2.559a3 3 0 0 0 -3 -3"
  }), e.createElement("path", {
    d: "M8.048 4.042a8 8 0 0 1 10.912 10.908m-1.8 2.206l-3.745 3.744a2 2 0 0 1 -2.827 0l-4.244 -4.243a8 8 0 0 1 -.48 -10.79"
  }));
}
var Wce = ["size", "color", "stroke"];
function qce(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Wce);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-map-pin",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("circle", {
    cx: 12,
    cy: 11,
    r: 3
  }), e.createElement("path", {
    d: "M17.657 16.657l-4.243 4.243a2 2 0 0 1 -2.827 0l-4.244 -4.243a8 8 0 1 1 11.314 0z"
  }));
}
var Oce = ["size", "color", "stroke"];
function Pce(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Oce);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-map-pins",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M10.828 9.828a4 4 0 1 0 -5.656 0l2.828 2.829l2.828 -2.829z"
  }), e.createElement("line", {
    x1: 8,
    y1: 7,
    x2: 8,
    y2: 7.01
  }), e.createElement("path", {
    d: "M18.828 17.828a4 4 0 1 0 -5.656 0l2.828 2.829l2.828 -2.829z"
  }), e.createElement("line", {
    x1: 16,
    y1: 15,
    x2: 16,
    y2: 15.01
  }));
}
var Sce = ["size", "color", "stroke"];
function Ice(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Sce);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-map-search",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M11 18l-2 -1l-6 3v-13l6 -3l6 3l6 -3v10"
  }), e.createElement("path", {
    d: "M9 4v13"
  }), e.createElement("path", {
    d: "M15 7v5"
  }), e.createElement("circle", {
    cx: 16.5,
    cy: 17.5,
    r: 2.5
  }), e.createElement("path", {
    d: "M18.5 19.5l2.5 2.5"
  }));
}
var Ace = ["size", "color", "stroke"];
function Dce(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Ace);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-map",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("polyline", {
    points: "3 7 9 4 15 7 21 4 21 17 15 20 9 17 3 20 3 7"
  }), e.createElement("line", {
    x1: 9,
    y1: 4,
    x2: 9,
    y2: 17
  }), e.createElement("line", {
    x1: 15,
    y1: 7,
    x2: 15,
    y2: 20
  }));
}
var Fce = ["size", "color", "stroke"];
function Gce(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Fce);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-markdown-off",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M9 5h10a2 2 0 0 1 2 2v10"
  }), e.createElement("path", {
    d: "M19 19h-14a2 2 0 0 1 -2 -2v-10a2 2 0 0 1 1.85 -1.995"
  }), e.createElement("path", {
    d: "M7 15v-6l2 2l.995 -.995m1.005 .995v4"
  }), e.createElement("path", {
    d: "M17.5 13.5l.5 -.5m-2 -.997v-3.003"
  }), e.createElement("path", {
    d: "M3 3l18 18"
  }));
}
var Jce = ["size", "color", "stroke"];
function Kce(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Jce);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-markdown",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("rect", {
    x: 3,
    y: 5,
    width: 18,
    height: 14,
    rx: 2
  }), e.createElement("path", {
    d: "M7 15v-6l2 2l2 -2v6"
  }), e.createElement("path", {
    d: "M14 13l2 2l2 -2m-2 2v-6"
  }));
}
var Qce = ["size", "color", "stroke"];
function Rce(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Qce);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-marquee-2",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M4 6v-1a1 1 0 0 1 1 -1h1m5 0h2m5 0h1a1 1 0 0 1 1 1v1m0 5v2m0 5v1a1 1 0 0 1 -1 1h-1m-5 0h-2m-5 0h-1a1 1 0 0 1 -1 -1v-1m0 -5v-2"
  }));
}
var Tce = ["size", "color", "stroke"];
function Uce(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Tce);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-marquee-off",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M4 6c0 -.556 .227 -1.059 .593 -1.421"
  }), e.createElement("path", {
    d: "M9 4h1.5"
  }), e.createElement("path", {
    d: "M13.5 4h1.5"
  }), e.createElement("path", {
    d: "M18 4a2 2 0 0 1 2 2"
  }), e.createElement("path", {
    d: "M20 9v1.5"
  }), e.createElement("path", {
    d: "M20 13.5v1.5"
  }), e.createElement("path", {
    d: "M19.402 19.426a1.993 1.993 0 0 1 -1.402 .574"
  }), e.createElement("path", {
    d: "M15 20h-1.5"
  }), e.createElement("path", {
    d: "M10.5 20h-1.5"
  }), e.createElement("path", {
    d: "M6 20a2 2 0 0 1 -2 -2"
  }), e.createElement("path", {
    d: "M4 15v-1.5"
  }), e.createElement("path", {
    d: "M4 10.5v-1.5"
  }), e.createElement("path", {
    d: "M3 3l18 18"
  }));
}
var Vce = ["size", "color", "stroke"];
function Xce(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Vce);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-marquee",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M4 6a2 2 0 0 1 2 -2m3 0h1.5m3 0h1.5m3 0a2 2 0 0 1 2 2m0 3v1.5m0 3v1.5m0 3a2 2 0 0 1 -2 2m-3 0h-1.5m-3 0h-1.5m-3 0a2 2 0 0 1 -2 -2m0 -3v-1.5m0 -3v-1.5m0 -3"
  }));
}
var Yce = ["size", "color", "stroke"];
function Zce(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Yce);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-mars",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("circle", {
    cx: 10,
    cy: 14,
    r: 5
  }), e.createElement("line", {
    x1: 19,
    y1: 5,
    x2: 13.6,
    y2: 10.4
  }), e.createElement("line", {
    x1: 19,
    y1: 5,
    x2: 14,
    y2: 5
  }), e.createElement("line", {
    x1: 19,
    y1: 5,
    x2: 19,
    y2: 10
  }));
}
var $ce = ["size", "color", "stroke"];
function _ce(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, $ce);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-mask-off",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M19.42 19.41a2 2 0 0 1 -1.42 .59h-12a2 2 0 0 1 -2 -2v-12c0 -.554 .225 -1.055 .588 -1.417m3.412 -.583h10a2 2 0 0 1 2 2v10"
  }), e.createElement("path", {
    d: "M9.885 9.872a3 3 0 1 0 4.245 4.24m.582 -3.396a3.012 3.012 0 0 0 -1.438 -1.433"
  }), e.createElement("path", {
    d: "M3 3l18 18"
  }));
}
var ese = ["size", "color", "stroke"];
function tse(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, ese);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-mask",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 3
  }), e.createElement("rect", {
    x: 4,
    y: 4,
    width: 16,
    height: 16,
    rx: 2
  }));
}
var ose = ["size", "color", "stroke"];
function rse(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, ose);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-masks-theater-off",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M13 9c.058 -.005 .133 0 .192 0h6.616a2 2 0 0 1 1.992 2.183l-.554 6.041m-1.286 2.718a3.99 3.99 0 0 1 -2.71 1.058h-1.5a4 4 0 0 1 -3.983 -3.635l-.567 -6.182"
  }), e.createElement("path", {
    d: "M18 13h.01"
  }), e.createElement("path", {
    d: "M15 16.5c.657 .438 1.313 .588 1.97 .451"
  }), e.createElement("path", {
    d: "M8.632 15.982a4.05 4.05 0 0 1 -.382 .018h-1.5a4 4 0 0 1 -3.983 -3.635l-.567 -6.182a2 2 0 0 1 .514 -1.531a1.99 1.99 0 0 1 1.286 -.652m4 0h2.808a2 2 0 0 1 2 2"
  }), e.createElement("path", {
    d: "M6 8h.01"
  }), e.createElement("path", {
    d: "M6 12c.764 -.51 1.528 -.63 2.291 -.36"
  }), e.createElement("path", {
    d: "M3 3l18 18"
  }));
}
var nse = ["size", "color", "stroke"];
function lse(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, nse);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-masks-theater",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M13.192 9h6.616a2 2 0 0 1 1.992 2.183l-.567 6.182a4 4 0 0 1 -3.983 3.635h-1.5a4 4 0 0 1 -3.983 -3.635l-.567 -6.182a2 2 0 0 1 1.992 -2.183z"
  }), e.createElement("path", {
    d: "M15 13h.01"
  }), e.createElement("path", {
    d: "M18 13h.01"
  }), e.createElement("path", {
    d: "M15 16.5c1 .667 2 .667 3 0"
  }), e.createElement("path", {
    d: "M8.632 15.982a4.037 4.037 0 0 1 -.382 .018h-1.5a4 4 0 0 1 -3.983 -3.635l-.567 -6.182a2 2 0 0 1 1.992 -2.183h6.616a2 2 0 0 1 2 2"
  }), e.createElement("path", {
    d: "M6 8h.01"
  }), e.createElement("path", {
    d: "M9 8h.01"
  }), e.createElement("path", {
    d: "M6 12c.764 -.51 1.528 -.63 2.291 -.36"
  }));
}
var ase = ["size", "color", "stroke"];
function ise(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, ase);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-massage",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("circle", {
    cx: 4,
    cy: 17,
    r: 1
  }), e.createElement("circle", {
    cx: 9,
    cy: 5,
    r: 1
  }), e.createElement("path", {
    d: "M4 22l4 -2v-3h12"
  }), e.createElement("path", {
    d: "M11 20h9"
  }), e.createElement("path", {
    d: "M8 14l3 -2l1 -4c3 1 3 4 3 6"
  }));
}
var cse = ["size", "color", "stroke"];
function sse(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, cse);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-matchstick",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M3 21l14 -9"
  }), e.createElement("circle", {
    cx: 17,
    cy: 12,
    r: 1
  }), e.createElement("path", {
    d: "M17 3l3.62 7.29a4.007 4.007 0 0 1 -.764 4.51a4 4 0 0 1 -6.493 -4.464l3.637 -7.336z"
  }));
}
var hse = ["size", "color", "stroke"];
function dse(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, hse);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-math-1-divide-2",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M5 12h14"
  }), e.createElement("path", {
    d: "M10 15h3a1 1 0 0 1 1 1v1a1 1 0 0 1 -1 1h-2a1 1 0 0 0 -1 1v1a1 1 0 0 0 1 1h3"
  }), e.createElement("path", {
    d: "M10 5l2 -2v6"
  }));
}
var vse = ["size", "color", "stroke"];
function mse(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, vse);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-math-1-divide-3",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M10 15.5a0.5 .5 0 0 1 .5 -.5h2a1.5 1.5 0 0 1 0 3h-1.167h1.167a1.5 1.5 0 0 1 0 3h-2a0.5 .5 0 0 1 -.5 -.5"
  }), e.createElement("path", {
    d: "M5 12h14"
  }), e.createElement("path", {
    d: "M10 5l2 -2v6"
  }));
}
var kse = ["size", "color", "stroke"];
function wse(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, kse);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-math-avg",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M3 21l18 -18"
  }), e.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 8
  }));
}
var pse = ["size", "color", "stroke"];
function Ese(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, pse);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-math-equal-greater",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M5 18l14 -4"
  }), e.createElement("path", {
    d: "M5 14l14 -4l-14 -4"
  }));
}
var use = ["size", "color", "stroke"];
function gse(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, use);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-math-equal-lower",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M19 18l-14 -4"
  }), e.createElement("path", {
    d: "M19 14l-14 -4l14 -4"
  }));
}
var Mse = ["size", "color", "stroke"];
function xse(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Mse);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-math-function-off",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M14 10h1c.882 0 .986 .777 1.694 2.692"
  }), e.createElement("path", {
    d: "M13 17c.864 0 1.727 -.663 2.495 -1.512m1.717 -2.302c.993 -1.45 2.39 -3.186 3.788 -3.186"
  }), e.createElement("path", {
    d: "M3 19c0 1.5 .5 2 2 2s2 -4 3 -9c.237 -1.186 .446 -2.317 .647 -3.35m.727 -3.248c.423 -1.492 .91 -2.402 1.626 -2.402c1.5 0 2 .5 2 2"
  }), e.createElement("path", {
    d: "M5 12h6"
  }), e.createElement("path", {
    d: "M3 3l18 18"
  }));
}
var fse = ["size", "color", "stroke"];
function zse(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, fse);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-math-function-y",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M3 19a2 2 0 0 0 2 2c2 0 2 -4 3 -9s1 -9 3 -9a2 2 0 0 1 2 2"
  }), e.createElement("path", {
    d: "M5 12h6"
  }), e.createElement("path", {
    d: "M15 12l3 5.063"
  }), e.createElement("path", {
    d: "M21 12l-4.8 9"
  }));
}
var bse = ["size", "color", "stroke"];
function Lse(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, bse);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-math-function",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M3 19a2 2 0 0 0 2 2c2 0 2 -4 3 -9s1 -9 3 -9a2 2 0 0 1 2 2"
  }), e.createElement("path", {
    d: "M5 12h6"
  }), e.createElement("path", {
    d: "M15 12l6 6"
  }), e.createElement("path", {
    d: "M15 18l6 -6"
  }));
}
var yse = ["size", "color", "stroke"];
function Cse(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, yse);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-math-greater",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M5 18l14 -6l-14 -6"
  }));
}
var jse = ["size", "color", "stroke"];
function Bse(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, jse);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-math-integral-x",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M3 19a2 2 0 0 0 2 2c2 0 2 -4 3 -9s1 -9 3 -9a2 2 0 0 1 2 2"
  }), e.createElement("path", {
    d: "M14 12l6 6"
  }), e.createElement("path", {
    d: "M14 18l6 -6"
  }));
}
var Hse = ["size", "color", "stroke"];
function Nse(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Hse);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-math-integral",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M7 19a2 2 0 0 0 2 2c2 0 2 -4 3 -9s1 -9 3 -9a2 2 0 0 1 2 2"
  }));
}
var Wse = ["size", "color", "stroke"];
function qse(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Wse);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-math-integrals",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M3 19a2 2 0 0 0 2 2c2 0 2 -4 3 -9s1 -9 3 -9a2 2 0 0 1 2 2"
  }), e.createElement("path", {
    d: "M11 19a2 2 0 0 0 2 2c2 0 2 -4 3 -9s1 -9 3 -9a2 2 0 0 1 2 2"
  }));
}
var Ose = ["size", "color", "stroke"];
function Pse(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Ose);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-math-lower",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M19 18l-14 -6l14 -6"
  }));
}
var Sse = ["size", "color", "stroke"];
function Ise(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Sse);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-math-max",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("circle", {
    cx: 12,
    cy: 5,
    r: 2
  }), e.createElement("path", {
    d: "M3 20c0 -8.75 4 -14 7 -14.5m4 0c3 .5 7 5.75 7 14.5"
  }));
}
var Ase = ["size", "color", "stroke"];
function Dse(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Ase);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-math-min",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M12 17a2 2 0 1 1 0 4a2 2 0 0 1 0 -4z"
  }), e.createElement("path", {
    d: "M3 4c0 8.75 4 14 7 14.5"
  }), e.createElement("path", {
    d: "M14 18.5c3 -.5 7 -5.75 7 -14.5"
  }));
}
var Fse = ["size", "color", "stroke"];
function Gse(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Fse);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-math-not",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M5 12h14v4"
  }));
}
var Jse = ["size", "color", "stroke"];
function Kse(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Jse);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-math-off",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M14 19l2.5 -2.5"
  }), e.createElement("path", {
    d: "M18.5 14.5l1.5 -1.5"
  }), e.createElement("path", {
    d: "M3 3l18 18"
  }), e.createElement("path", {
    d: "M19 5h-7l-.646 2.262"
  }), e.createElement("path", {
    d: "M10.448 10.431l-2.448 8.569l-3 -6h-2"
  }));
}
var Qse = ["size", "color", "stroke"];
function Rse(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Qse);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-math-pi-divide-2",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M10 15h3a1 1 0 0 1 1 1v1a1 1 0 0 1 -1 1h-2a1 1 0 0 0 -1 1v1a1 1 0 0 0 1 1h3"
  }), e.createElement("path", {
    d: "M5 12h14"
  }), e.createElement("path", {
    d: "M10 9v-6"
  }), e.createElement("path", {
    d: "M14 3v6"
  }), e.createElement("path", {
    d: "M15 3h-6"
  }));
}
var Tse = ["size", "color", "stroke"];
function Use(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Tse);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-math-pi",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M7 20v-16"
  }), e.createElement("path", {
    d: "M17 4v16"
  }), e.createElement("path", {
    d: "M20 4h-16"
  }));
}
var Vse = ["size", "color", "stroke"];
function Xse(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Vse);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-math-symbols",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("line", {
    x1: 3,
    y1: 12,
    x2: 21,
    y2: 12
  }), e.createElement("line", {
    x1: 12,
    y1: 3,
    x2: 12,
    y2: 21
  }), e.createElement("line", {
    x1: 16.5,
    y1: 4.5,
    x2: 19.5,
    y2: 7.5
  }), e.createElement("line", {
    x1: 19.5,
    y1: 4.5,
    x2: 16.5,
    y2: 7.5
  }), e.createElement("line", {
    x1: 6,
    y1: 4,
    x2: 6,
    y2: 8
  }), e.createElement("line", {
    x1: 4,
    y1: 6,
    x2: 8,
    y2: 6
  }), e.createElement("line", {
    x1: 18,
    y1: 16,
    x2: 18.01,
    y2: 16
  }), e.createElement("line", {
    x1: 18,
    y1: 20,
    x2: 18.01,
    y2: 20
  }), e.createElement("line", {
    x1: 4,
    y1: 18,
    x2: 8,
    y2: 18
  }));
}
var Yse = ["size", "color", "stroke"];
function Zse(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Yse);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-math-x-divide-2",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M10 15h3a1 1 0 0 1 1 1v1a1 1 0 0 1 -1 1h-2a1 1 0 0 0 -1 1v1a1 1 0 0 0 1 1h3"
  }), e.createElement("path", {
    d: "M5 12h14"
  }), e.createElement("path", {
    d: "M9 3l6 6"
  }), e.createElement("path", {
    d: "M9 9l6 -6"
  }));
}
var $se = ["size", "color", "stroke"];
function _se(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, $se);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-math-x-divide-y-2",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M3 21l18 -18"
  }), e.createElement("path", {
    d: "M15 14l3 4.5"
  }), e.createElement("path", {
    d: "M21 14l-4.5 7"
  }), e.createElement("path", {
    d: "M3 4l6 6"
  }), e.createElement("path", {
    d: "M3 10l6 -6"
  }));
}
var ehe = ["size", "color", "stroke"];
function the(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, ehe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-math-x-divide-y",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M9 3l6 6"
  }), e.createElement("path", {
    d: "M9 9l6 -6"
  }), e.createElement("path", {
    d: "M9 15l3 4.5"
  }), e.createElement("path", {
    d: "M15 15l-4.5 7"
  }), e.createElement("path", {
    d: "M5 12h14"
  }));
}
var ohe = ["size", "color", "stroke"];
function rhe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, ohe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-math-x-minus-x",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M2 9l6 6"
  }), e.createElement("path", {
    d: "M2 15l6 -6"
  }), e.createElement("path", {
    d: "M16 9l6 6"
  }), e.createElement("path", {
    d: "M16 15l6 -6"
  }), e.createElement("path", {
    d: "M10 12h4"
  }));
}
var nhe = ["size", "color", "stroke"];
function lhe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, nhe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-math-x-minus-y",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M2 9l6 6"
  }), e.createElement("path", {
    d: "M2 15l6 -6"
  }), e.createElement("path", {
    d: "M16 9l3 5.063"
  }), e.createElement("path", {
    d: "M22 9l-4.8 9"
  }), e.createElement("path", {
    d: "M10 12h4"
  }));
}
var ahe = ["size", "color", "stroke"];
function ihe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, ahe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-math-x-plus-x",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M2 9l6 6"
  }), e.createElement("path", {
    d: "M2 15l6 -6"
  }), e.createElement("path", {
    d: "M16 9l6 6"
  }), e.createElement("path", {
    d: "M16 15l6 -6"
  }), e.createElement("path", {
    d: "M10 12h4"
  }), e.createElement("path", {
    d: "M12 10v4"
  }));
}
var che = ["size", "color", "stroke"];
function she(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, che);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-math-x-plus-y",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M16 9l3 5.063"
  }), e.createElement("path", {
    d: "M2 9l6 6"
  }), e.createElement("path", {
    d: "M2 15l6 -6"
  }), e.createElement("path", {
    d: "M22 9l-4.8 9"
  }), e.createElement("path", {
    d: "M10 12h4"
  }), e.createElement("path", {
    d: "M12 10v4"
  }));
}
var hhe = ["size", "color", "stroke"];
function dhe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, hhe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-math-xy",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M14 9l3 5.063"
  }), e.createElement("path", {
    d: "M4 9l6 6"
  }), e.createElement("path", {
    d: "M4 15l6 -6"
  }), e.createElement("path", {
    d: "M20 9l-4.8 9"
  }));
}
var vhe = ["size", "color", "stroke"];
function mhe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, vhe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-math-y-minus-y",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M2 9l3 5.063"
  }), e.createElement("path", {
    d: "M8 9l-4.8 9"
  }), e.createElement("path", {
    d: "M16 9l3 5.063"
  }), e.createElement("path", {
    d: "M22 9l-4.8 9"
  }), e.createElement("path", {
    d: "M10 12h4"
  }));
}
var khe = ["size", "color", "stroke"];
function whe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, khe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-math-y-plus-y",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M2 9l3 5.063"
  }), e.createElement("path", {
    d: "M8 9l-4.8 9"
  }), e.createElement("path", {
    d: "M16 9l3 5.063"
  }), e.createElement("path", {
    d: "M22 9l-4.8 9"
  }), e.createElement("path", {
    d: "M10 12h4"
  }), e.createElement("path", {
    d: "M12 10v4"
  }));
}
var phe = ["size", "color", "stroke"];
function Ehe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, phe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-math",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M19 5h-7l-4 14l-3 -6h-2"
  }), e.createElement("path", {
    d: "M14 13l6 6"
  }), e.createElement("path", {
    d: "M14 19l6 -6"
  }));
}
var uhe = ["size", "color", "stroke"];
function ghe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, uhe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-maximize-off",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M4 8v-2c0 -.551 .223 -1.05 .584 -1.412"
  }), e.createElement("path", {
    d: "M4 16v2a2 2 0 0 0 2 2h2"
  }), e.createElement("path", {
    d: "M16 4h2a2 2 0 0 1 2 2v2"
  }), e.createElement("path", {
    d: "M16 20h2c.545 0 1.04 -.218 1.4 -.572"
  }), e.createElement("path", {
    d: "M3 3l18 18"
  }));
}
var Mhe = ["size", "color", "stroke"];
function xhe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Mhe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-maximize",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M4 8v-2a2 2 0 0 1 2 -2h2"
  }), e.createElement("path", {
    d: "M4 16v2a2 2 0 0 0 2 2h2"
  }), e.createElement("path", {
    d: "M16 4h2a2 2 0 0 1 2 2v2"
  }), e.createElement("path", {
    d: "M16 20h2a2 2 0 0 0 2 -2v-2"
  }));
}
var fhe = ["size", "color", "stroke"];
function zhe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, fhe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-meat-off",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M13.62 8.382l1.966 -1.967a2 2 0 1 1 3.414 -1.415a2 2 0 1 1 -1.413 3.414l-1.82 1.821"
  }), e.createElement("path", {
    d: "M5.904 18.596c2.733 2.734 5.9 4 7.07 2.829c1.172 -1.172 -.094 -4.338 -2.828 -7.071c-2.733 -2.734 -5.9 -4 -7.07 -2.829c-1.172 1.172 .094 4.338 2.828 7.071z"
  }), e.createElement("path", {
    d: "M7.5 16l1 1"
  }), e.createElement("path", {
    d: "M12.975 21.425c1.582 -1.582 2.679 -3.407 3.242 -5.2"
  }), e.createElement("path", {
    d: "M16.6 12.6c-.16 -1.238 -.653 -2.345 -1.504 -3.195c-.85 -.85 -1.955 -1.344 -3.192 -1.503"
  }), e.createElement("path", {
    d: "M8.274 8.284c-1.792 .563 -3.616 1.66 -5.198 3.242"
  }), e.createElement("path", {
    d: "M3 3l18 18"
  }));
}
var bhe = ["size", "color", "stroke"];
function Lhe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, bhe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-meat",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M13.62 8.382l1.966 -1.967a2 2 0 1 1 3.414 -1.415a2 2 0 1 1 -1.413 3.414l-1.82 1.821"
  }), e.createElement("path", {
    d: "M5.904 18.596c2.733 2.734 5.9 4 7.07 2.829c1.172 -1.172 -.094 -4.338 -2.828 -7.071c-2.733 -2.734 -5.9 -4 -7.07 -2.829c-1.172 1.172 .094 4.338 2.828 7.071z"
  }), e.createElement("path", {
    d: "M7.5 16l1 1"
  }), e.createElement("path", {
    d: "M12.975 21.425c3.905 -3.906 4.855 -9.288 2.121 -12.021c-2.733 -2.734 -8.115 -1.784 -12.02 2.121"
  }));
}
var yhe = ["size", "color", "stroke"];
function Che(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, yhe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-medal-2",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M9 3h6l3 7l-6 2l-6 -2z"
  }), e.createElement("path", {
    d: "M12 12l-3 -9"
  }), e.createElement("path", {
    d: "M15 11l-3 -8"
  }), e.createElement("path", {
    d: "M12 19.5l-3 1.5l.5 -3.5l-2 -2l3 -.5l1.5 -3l1.5 3l3 .5l-2 2l.5 3.5z"
  }));
}
var jhe = ["size", "color", "stroke"];
function Bhe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, jhe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-medal",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M12 4v3m-4 -3v6m8 -6v6"
  }), e.createElement("path", {
    d: "M12 18.5l-3 1.5l.5 -3.5l-2 -2l3 -.5l1.5 -3l1.5 3l3 .5l-2 2l.5 3.5z"
  }));
}
var Hhe = ["size", "color", "stroke"];
function Nhe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Hhe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-medical-cross-off",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M17.928 17.733l-.574 -.331l-3.354 -1.938v4.536a1 1 0 0 1 -1 1h-2a1 1 0 0 1 -1 -1v-4.536l-3.928 2.268a1 1 0 0 1 -1.366 -.366l-1 -1.732a1 1 0 0 1 .366 -1.366l3.927 -2.268l-3.927 -2.268a1 1 0 0 1 -.366 -1.366l1 -1.732a1 1 0 0 1 1.366 -.366l.333 .192m3.595 -.46v-2a1 1 0 0 1 1 -1h2a1 1 0 0 1 1 1v4.535l3.928 -2.267a1 1 0 0 1 1.366 .366l1 1.732a1 1 0 0 1 -.366 1.366l-3.927 2.268l3.927 2.269a1 1 0 0 1 .366 1.366l-.24 .416"
  }), e.createElement("path", {
    d: "M3 3l18 18"
  }));
}
var Whe = ["size", "color", "stroke"];
function qhe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Whe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-medical-cross",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M13 3a1 1 0 0 1 1 1v4.535l3.928 -2.267a1 1 0 0 1 1.366 .366l1 1.732a1 1 0 0 1 -.366 1.366l-3.927 2.268l3.927 2.269a1 1 0 0 1 .366 1.366l-1 1.732a1 1 0 0 1 -1.366 .366l-3.928 -2.269v4.536a1 1 0 0 1 -1 1h-2a1 1 0 0 1 -1 -1v-4.536l-3.928 2.268a1 1 0 0 1 -1.366 -.366l-1 -1.732a1 1 0 0 1 .366 -1.366l3.927 -2.268l-3.927 -2.268a1 1 0 0 1 -.366 -1.366l1 -1.732a1 1 0 0 1 1.366 -.366l3.928 2.267v-4.535a1 1 0 0 1 1 -1h2z"
  }));
}
var Ohe = ["size", "color", "stroke"];
function Phe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Ohe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-medicine-syrup",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M8 21h8a1 1 0 0 0 1 -1v-10a3 3 0 0 0 -3 -3h-4a3 3 0 0 0 -3 3v10a1 1 0 0 0 1 1z"
  }), e.createElement("path", {
    d: "M10 14h4"
  }), e.createElement("path", {
    d: "M12 12v4"
  }), e.createElement("path", {
    d: "M10 7v-3a1 1 0 0 1 1 -1h2a1 1 0 0 1 1 1v3"
  }));
}
var She = ["size", "color", "stroke"];
function Ihe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, She);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-meeple",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M9 20h-5a1 1 0 0 1 -1 -1c0 -2 3.378 -4.907 4 -6c-1 0 -4 -.5 -4 -2c0 -2 4 -3.5 6 -4c0 -1.5 .5 -4 3 -4s3 2.5 3 4c2 .5 6 2 6 4c0 1.5 -3 2 -4 2c.622 1.093 4 4 4 6a1 1 0 0 1 -1 1h-5c-1 0 -2 -4 -3 -4s-2 4 -3 4z"
  }));
}
var Ahe = ["size", "color", "stroke"];
function Dhe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Ahe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-menorah",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M12 4v16"
  }), e.createElement("path", {
    d: "M8 4v2a4 4 0 1 0 8 0v-2"
  }), e.createElement("path", {
    d: "M4 4v2a8 8 0 1 0 16 0v-2"
  }), e.createElement("path", {
    d: "M10 20h4"
  }));
}
var Fhe = ["size", "color", "stroke"];
function Ghe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Fhe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-menu-2",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("line", {
    x1: 4,
    y1: 6,
    x2: 20,
    y2: 6
  }), e.createElement("line", {
    x1: 4,
    y1: 12,
    x2: 20,
    y2: 12
  }), e.createElement("line", {
    x1: 4,
    y1: 18,
    x2: 20,
    y2: 18
  }));
}
var Jhe = ["size", "color", "stroke"];
function Khe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Jhe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-menu-order",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M4 10h16"
  }), e.createElement("path", {
    d: "M4 14h16"
  }), e.createElement("path", {
    d: "M9 18l3 3l3 -3"
  }), e.createElement("path", {
    d: "M9 6l3 -3l3 3"
  }));
}
var Qhe = ["size", "color", "stroke"];
function Rhe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Qhe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-menu",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("line", {
    x1: 4,
    y1: 8,
    x2: 20,
    y2: 8
  }), e.createElement("line", {
    x1: 4,
    y1: 16,
    x2: 20,
    y2: 16
  }));
}
var The = ["size", "color", "stroke"];
function Uhe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, The);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-message-2-code",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M12 20l-3 -3h-2a3 3 0 0 1 -3 -3v-6a3 3 0 0 1 3 -3h10a3 3 0 0 1 3 3v6a3 3 0 0 1 -3 3h-2l-3 3"
  }), e.createElement("path", {
    d: "M10 9l-2 2l2 2"
  }), e.createElement("path", {
    d: "M14 9l2 2l-2 2"
  }));
}
var Vhe = ["size", "color", "stroke"];
function Xhe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Vhe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-message-2-off",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M9 5h8a3 3 0 0 1 3 3v6a2.97 2.97 0 0 1 -.44 1.563m-2.56 1.437h-2l-3 3l-3 -3h-2a3 3 0 0 1 -3 -3v-6c0 -1.092 .584 -2.049 1.457 -2.573"
  }), e.createElement("path", {
    d: "M8 9h1m4 0h3"
  }), e.createElement("path", {
    d: "M8 13h5"
  }), e.createElement("path", {
    d: "M3 3l18 18"
  }));
}
var Yhe = ["size", "color", "stroke"];
function Zhe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Yhe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-message-2-share",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M17 4h4v4"
  }), e.createElement("path", {
    d: "M20 11v3a3 3 0 0 1 -3 3h-2l-3 3l-3 -3h-2a3 3 0 0 1 -3 -3v-6a3 3 0 0 1 3 -3h7"
  }), e.createElement("path", {
    d: "M16 9l5 -5"
  }));
}
var $he = ["size", "color", "stroke"];
function _he(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, $he);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-message-2",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M12 20l-3 -3h-2a3 3 0 0 1 -3 -3v-6a3 3 0 0 1 3 -3h10a3 3 0 0 1 3 3v6a3 3 0 0 1 -3 3h-2l-3 3"
  }), e.createElement("line", {
    x1: 8,
    y1: 9,
    x2: 16,
    y2: 9
  }), e.createElement("line", {
    x1: 8,
    y1: 13,
    x2: 14,
    y2: 13
  }));
}
var ede = ["size", "color", "stroke"];
function tde(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, ede);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-message-chatbot",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M4 21v-13a3 3 0 0 1 3 -3h10a3 3 0 0 1 3 3v6a3 3 0 0 1 -3 3h-9l-4 4"
  }), e.createElement("path", {
    d: "M9.5 9h.01"
  }), e.createElement("path", {
    d: "M14.5 9h.01"
  }), e.createElement("path", {
    d: "M9.5 13a3.5 3.5 0 0 0 5 0"
  }));
}
var ode = ["size", "color", "stroke"];
function rde(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, ode);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-message-circle-2",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M3 20l1.3 -3.9a9 8 0 1 1 3.4 2.9l-4.7 1"
  }));
}
var nde = ["size", "color", "stroke"];
function lde(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, nde);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-message-circle-off",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("line", {
    x1: 3,
    y1: 3,
    x2: 21,
    y2: 21
  }), e.createElement("path", {
    d: "M8.585 4.581c3.225 -1.181 7.032 -.616 9.66 1.626c2.983 2.543 3.602 6.525 1.634 9.662m-1.908 2.108c-2.786 2.19 -6.89 2.665 -10.271 1.023l-4.7 1l1.3 -3.9c-2.237 -3.308 -1.489 -7.54 1.714 -10.084"
  }));
}
var ade = ["size", "color", "stroke"];
function ide(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, ade);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-message-circle",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M3 20l1.3 -3.9a9 8 0 1 1 3.4 2.9l-4.7 1"
  }), e.createElement("line", {
    x1: 12,
    y1: 12,
    x2: 12,
    y2: 12.01
  }), e.createElement("line", {
    x1: 8,
    y1: 12,
    x2: 8,
    y2: 12.01
  }), e.createElement("line", {
    x1: 16,
    y1: 12,
    x2: 16,
    y2: 12.01
  }));
}
var cde = ["size", "color", "stroke"];
function sde(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, cde);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-message-code",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M4 21v-13a3 3 0 0 1 3 -3h10a3 3 0 0 1 3 3v6a3 3 0 0 1 -3 3h-9l-4 4"
  }), e.createElement("path", {
    d: "M10 9l-2 2l2 2"
  }), e.createElement("path", {
    d: "M14 9l2 2l-2 2"
  }));
}
var hde = ["size", "color", "stroke"];
function dde(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, hde);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-message-dots",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M4 21v-13a3 3 0 0 1 3 -3h10a3 3 0 0 1 3 3v6a3 3 0 0 1 -3 3h-9l-4 4"
  }), e.createElement("line", {
    x1: 12,
    y1: 11,
    x2: 12,
    y2: 11.01
  }), e.createElement("line", {
    x1: 8,
    y1: 11,
    x2: 8,
    y2: 11.01
  }), e.createElement("line", {
    x1: 16,
    y1: 11,
    x2: 16,
    y2: 11.01
  }));
}
var vde = ["size", "color", "stroke"];
function mde(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, vde);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-message-forward",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M4 21v-13a3 3 0 0 1 3 -3h10a3 3 0 0 1 3 3v6a3 3 0 0 1 -3 3h-9l-4 4"
  }), e.createElement("path", {
    d: "M13 9l2 2l-2 2"
  }), e.createElement("path", {
    d: "M15 11h-6"
  }));
}
var kde = ["size", "color", "stroke"];
function wde(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, kde);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-message-language",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M4 21v-13a3 3 0 0 1 3 -3h10a3 3 0 0 1 3 3v6a3 3 0 0 1 -3 3h-9l-4 4"
  }), e.createElement("path", {
    d: "M10 14v-4a2 2 0 1 1 4 0v4"
  }), e.createElement("path", {
    d: "M14 12h-4"
  }));
}
var pde = ["size", "color", "stroke"];
function Ede(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, pde);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-message-off",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("line", {
    x1: 3,
    y1: 3,
    x2: 21,
    y2: 21
  }), e.createElement("path", {
    d: "M17 17h-9l-4 4v-13c0 -1.086 .577 -2.036 1.44 -2.563m3.561 -.437h8a3 3 0 0 1 3 3v6c0 .575 -.162 1.112 -.442 1.568"
  }));
}
var ude = ["size", "color", "stroke"];
function gde(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, ude);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-message-plus",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M4 21v-13a3 3 0 0 1 3 -3h10a3 3 0 0 1 3 3v6a3 3 0 0 1 -3 3h-9l-4 4"
  }), e.createElement("line", {
    x1: 10,
    y1: 11,
    x2: 14,
    y2: 11
  }), e.createElement("line", {
    x1: 12,
    y1: 9,
    x2: 12,
    y2: 13
  }));
}
var Mde = ["size", "color", "stroke"];
function xde(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Mde);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-message-report",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M4 21v-13a3 3 0 0 1 3 -3h10a3 3 0 0 1 3 3v6a3 3 0 0 1 -3 3h-9l-4 4"
  }), e.createElement("line", {
    x1: 12,
    y1: 8,
    x2: 12,
    y2: 11
  }), e.createElement("line", {
    x1: 12,
    y1: 14,
    x2: 12,
    y2: 14.01
  }));
}
var fde = ["size", "color", "stroke"];
function zde(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, fde);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-message-share",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M20 11v3a3 3 0 0 1 -3 3h-9l-4 4v-13a3 3 0 0 1 3 -3h7"
  }), e.createElement("path", {
    d: "M17 4h4v4"
  }), e.createElement("path", {
    d: "M16 9l5 -5"
  }));
}
var bde = ["size", "color", "stroke"];
function Lde(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, bde);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-message",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M4 21v-13a3 3 0 0 1 3 -3h10a3 3 0 0 1 3 3v6a3 3 0 0 1 -3 3h-9l-4 4"
  }), e.createElement("line", {
    x1: 8,
    y1: 9,
    x2: 16,
    y2: 9
  }), e.createElement("line", {
    x1: 8,
    y1: 13,
    x2: 14,
    y2: 13
  }));
}
var yde = ["size", "color", "stroke"];
function Cde(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, yde);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-messages-off",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("line", {
    x1: 3,
    y1: 3,
    x2: 21,
    y2: 21
  }), e.createElement("path", {
    d: "M11 11a1 1 0 0 1 -1 -1m0 -3.968v-2.032a1 1 0 0 1 1 -1h9a1 1 0 0 1 1 1v10l-3 -3h-3"
  }), e.createElement("path", {
    d: "M14 15v2a1 1 0 0 1 -1 1h-7l-3 3v-10a1 1 0 0 1 1 -1h2"
  }));
}
var jde = ["size", "color", "stroke"];
function Bde(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, jde);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-messages",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M21 14l-3 -3h-7a1 1 0 0 1 -1 -1v-6a1 1 0 0 1 1 -1h9a1 1 0 0 1 1 1v10"
  }), e.createElement("path", {
    d: "M14 15v2a1 1 0 0 1 -1 1h-7l-3 3v-10a1 1 0 0 1 1 -1h2"
  }));
}
var Hde = ["size", "color", "stroke"];
function Nde(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Hde);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-meteor-off",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M9.75 5.761l3.25 -2.761l-1 5l9 -5l-5 9h5l-2.467 2.536m-1.983 2.04l-2.441 2.51a6.5 6.5 0 1 1 -8.855 -9.506l2.322 -1.972"
  }), e.createElement("circle", {
    cx: 9.5,
    cy: 14.5,
    r: 2.5
  }), e.createElement("path", {
    d: "M3 3l18 18"
  }));
}
var Wde = ["size", "color", "stroke"];
function qde(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Wde);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-meteor",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M21 3l-5 9h5l-6.891 7.086a6.5 6.5 0 1 1 -8.855 -9.506l7.746 -6.58l-1 5l9 -5z"
  }), e.createElement("circle", {
    cx: 9.5,
    cy: 14.5,
    r: 2.5
  }));
}
var Ode = ["size", "color", "stroke"];
function Pde(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Ode);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-mickey",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M5.5 3a3.5 3.5 0 0 1 3.25 4.8a7.017 7.017 0 0 0 -2.424 2.1a3.5 3.5 0 1 1 -.826 -6.9z"
  }), e.createElement("path", {
    d: "M18.5 3a3.5 3.5 0 1 1 -.826 6.902a7.013 7.013 0 0 0 -2.424 -2.103a3.5 3.5 0 0 1 3.25 -4.799z"
  }), e.createElement("circle", {
    cx: 12,
    cy: 14,
    r: 7
  }));
}
var Sde = ["size", "color", "stroke"];
function Ide(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Sde);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-microphone-2-off",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M16.908 12.917a5 5 0 1 0 -5.827 -5.819"
  }), e.createElement("path", {
    d: "M10.116 10.125l-6.529 7.46a2 2 0 1 0 2.827 2.83l7.461 -6.529"
  }), e.createElement("path", {
    d: "M3 3l18 18"
  }));
}
var Ade = ["size", "color", "stroke"];
function Dde(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Ade);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-microphone-2",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M15.002 12.9a5 5 0 1 0 -3.902 -3.9"
  }), e.createElement("path", {
    d: "M15.002 12.9l-3.902 -3.899l-7.513 8.584a2 2 0 1 0 2.827 2.83l8.588 -7.515z"
  }));
}
var Fde = ["size", "color", "stroke"];
function Gde(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Fde);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-microphone-off",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("line", {
    x1: 3,
    y1: 3,
    x2: 21,
    y2: 21
  }), e.createElement("path", {
    d: "M9 5a3 3 0 0 1 6 0v5a3 3 0 0 1 -.13 .874m-2 2a3 3 0 0 1 -3.87 -2.872v-1"
  }), e.createElement("path", {
    d: "M5 10a7 7 0 0 0 10.846 5.85m2.002 -2a6.967 6.967 0 0 0 1.152 -3.85"
  }), e.createElement("line", {
    x1: 8,
    y1: 21,
    x2: 16,
    y2: 21
  }), e.createElement("line", {
    x1: 12,
    y1: 17,
    x2: 12,
    y2: 21
  }));
}
var Jde = ["size", "color", "stroke"];
function Kde(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Jde);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-microphone",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("rect", {
    x: 9,
    y: 2,
    width: 6,
    height: 11,
    rx: 3
  }), e.createElement("path", {
    d: "M5 10a7 7 0 0 0 14 0"
  }), e.createElement("line", {
    x1: 8,
    y1: 21,
    x2: 16,
    y2: 21
  }), e.createElement("line", {
    x1: 12,
    y1: 17,
    x2: 12,
    y2: 21
  }));
}
var Qde = ["size", "color", "stroke"];
function Rde(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Qde);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-microscope-off",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M5 21h14"
  }), e.createElement("path", {
    d: "M6 18h2"
  }), e.createElement("path", {
    d: "M7 18v3"
  }), e.createElement("path", {
    d: "M10 10l-1 1l3 3l1 -1m2 -2l3 -3l-3 -3l-3 3"
  }), e.createElement("path", {
    d: "M10.5 12.5l-1.5 1.5"
  }), e.createElement("path", {
    d: "M17 3l3 3"
  }), e.createElement("path", {
    d: "M12 21a6 6 0 0 0 5.457 -3.505m.441 -3.599a5.996 5.996 0 0 0 -2.183 -3.608"
  }), e.createElement("path", {
    d: "M3 3l18 18"
  }));
}
var Tde = ["size", "color", "stroke"];
function Ude(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Tde);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-microscope",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M5 21h14"
  }), e.createElement("path", {
    d: "M6 18h2"
  }), e.createElement("path", {
    d: "M7 18v3"
  }), e.createElement("path", {
    d: "M9 11l3 3l6 -6l-3 -3z"
  }), e.createElement("path", {
    d: "M10.5 12.5l-1.5 1.5"
  }), e.createElement("path", {
    d: "M17 3l3 3"
  }), e.createElement("path", {
    d: "M12 21a6 6 0 0 0 3.715 -10.712"
  }));
}
var Vde = ["size", "color", "stroke"];
function Xde(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Vde);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-microwave-off",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M18 18h-14a1 1 0 0 1 -1 -1v-10a1 1 0 0 1 1 -1h2m4 0h10a1 1 0 0 1 1 1v10"
  }), e.createElement("path", {
    d: "M15 6v5m0 4v3"
  }), e.createElement("path", {
    d: "M18 12h.01"
  }), e.createElement("path", {
    d: "M18 9h.01"
  }), e.createElement("path", {
    d: "M6.5 10.5c1 -.667 1.5 -.667 2.5 0c.636 .265 1.272 .665 1.907 .428"
  }), e.createElement("path", {
    d: "M6.5 13.5c1 -.667 1.5 -.667 2.5 0c.833 .347 1.667 .926 2.5 0"
  }), e.createElement("path", {
    d: "M3 3l18 18"
  }));
}
var Yde = ["size", "color", "stroke"];
function Zde(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Yde);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-microwave",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("rect", {
    x: 3,
    y: 6,
    width: 18,
    height: 12,
    rx: 1
  }), e.createElement("path", {
    d: "M15 6v12"
  }), e.createElement("path", {
    d: "M18 12h.01"
  }), e.createElement("path", {
    d: "M18 15h.01"
  }), e.createElement("path", {
    d: "M18 9h.01"
  }), e.createElement("path", {
    d: "M6.5 10.5c1 -.667 1.5 -.667 2.5 0c.833 .347 1.667 .926 2.5 0"
  }), e.createElement("path", {
    d: "M6.5 13.5c1 -.667 1.5 -.667 2.5 0c.833 .347 1.667 .926 2.5 0"
  }));
}
var $de = ["size", "color", "stroke"];
function _de(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, $de);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-military-award",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("circle", {
    cx: 12,
    cy: 13,
    r: 4
  }), e.createElement("path", {
    d: "M8.5 10.5l-1 -2.5h-5.5l2.48 5.788a2 2 0 0 0 1.84 1.212h2.18"
  }), e.createElement("path", {
    d: "M15.5 10.5l1 -2.5h5.5l-2.48 5.788a2 2 0 0 1 -1.84 1.212h-2.18"
  }));
}
var eve = ["size", "color", "stroke"];
function tve(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, eve);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-military-rank",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M17 7v13h-10v-13l5 -3z"
  }), e.createElement("path", {
    d: "M10 13l2 -1l2 1"
  }), e.createElement("path", {
    d: "M10 17l2 -1l2 1"
  }), e.createElement("path", {
    d: "M10 9l2 -1l2 1"
  }));
}
var ove = ["size", "color", "stroke"];
function rve(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, ove);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-milk-off",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M10 6h6v-2a1 1 0 0 0 -1 -1h-6a1 1 0 0 0 -1 1"
  }), e.createElement("path", {
    d: "M16 6l1.094 1.759a6 6 0 0 1 .906 3.17v3.071m0 4v1a2 2 0 0 1 -2 2h-8a2 2 0 0 1 -2 -2v-8.071a6 6 0 0 1 .906 -3.17l.327 -.525"
  }), e.createElement("circle", {
    cx: 12,
    cy: 16,
    r: 2
  }), e.createElement("path", {
    d: "M3 3l18 18"
  }));
}
var nve = ["size", "color", "stroke"];
function lve(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, nve);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-milk",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M8 6h8v-2a1 1 0 0 0 -1 -1h-6a1 1 0 0 0 -1 1v2z"
  }), e.createElement("path", {
    d: "M16 6l1.094 1.759a6 6 0 0 1 .906 3.17v8.071a2 2 0 0 1 -2 2h-8a2 2 0 0 1 -2 -2v-8.071a6 6 0 0 1 .906 -3.17l1.094 -1.759"
  }), e.createElement("circle", {
    cx: 12,
    cy: 16,
    r: 2
  }), e.createElement("path", {
    d: "M10 10h4"
  }));
}
var ave = ["size", "color", "stroke"];
function ive(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, ave);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-milkshake",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M17 10a5 5 0 0 0 -10 0"
  }), e.createElement("rect", {
    x: 6,
    y: 10,
    width: 12,
    height: 3,
    rx: 1
  }), e.createElement("path", {
    d: "M7 13l1.81 7.243a1 1 0 0 0 .97 .757h4.44a1 1 0 0 0 .97 -.757l1.81 -7.243"
  }), e.createElement("path", {
    d: "M12 5v-2"
  }));
}
var cve = ["size", "color", "stroke"];
function sve(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, cve);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-minimize",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M15 19v-2a2 2 0 0 1 2 -2h2"
  }), e.createElement("path", {
    d: "M15 5v2a2 2 0 0 0 2 2h2"
  }), e.createElement("path", {
    d: "M5 15h2a2 2 0 0 1 2 2v2"
  }), e.createElement("path", {
    d: "M5 9h2a2 2 0 0 0 2 -2v-2"
  }));
}
var hve = ["size", "color", "stroke"];
function dve(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, hve);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-minus-vertical",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M12 5v14"
  }));
}
var vve = ["size", "color", "stroke"];
function mve(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, vve);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-minus",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("line", {
    x1: 5,
    y1: 12,
    x2: 19,
    y2: 12
  }));
}
var kve = ["size", "color", "stroke"];
function wve(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, kve);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-mist-off",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M12 5h9"
  }), e.createElement("path", {
    d: "M3 10h7"
  }), e.createElement("path", {
    d: "M18 10h1"
  }), e.createElement("path", {
    d: "M5 15h5"
  }), e.createElement("path", {
    d: "M14 15h1m4 0h2"
  }), e.createElement("path", {
    d: "M3 20h9m4 0h3"
  }), e.createElement("path", {
    d: "M3 3l18 18"
  }));
}
var pve = ["size", "color", "stroke"];
function Eve(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, pve);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-mist",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M5 5h3m4 0h9"
  }), e.createElement("path", {
    d: "M3 10h11m4 0h1"
  }), e.createElement("path", {
    d: "M5 15h5m4 0h7"
  }), e.createElement("path", {
    d: "M3 20h9m4 0h3"
  }));
}
var uve = ["size", "color", "stroke"];
function gve(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, uve);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-moneybag",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M9.5 3h5a1.5 1.5 0 0 1 1.5 1.5a3.5 3.5 0 0 1 -3.5 3.5h-1a3.5 3.5 0 0 1 -3.5 -3.5a1.5 1.5 0 0 1 1.5 -1.5z"
  }), e.createElement("path", {
    d: "M4 17v-1a8 8 0 1 1 16 0v1a4 4 0 0 1 -4 4h-8a4 4 0 0 1 -4 -4z"
  }));
}
var Mve = ["size", "color", "stroke"];
function xve(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Mve);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-mood-angry",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M12 21a9 9 0 1 1 0 -18a9 9 0 0 1 0 18z"
  }), e.createElement("path", {
    d: "M8 9l2 1"
  }), e.createElement("path", {
    d: "M16 9l-2 1"
  }), e.createElement("path", {
    d: "M14.5 16.05a3.5 3.5 0 0 0 -5 0"
  }));
}
var fve = ["size", "color", "stroke"];
function zve(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, fve);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-mood-annoyed-2",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M12 21a9 9 0 1 1 0 -18a9 9 0 0 1 0 18z"
  }), e.createElement("path", {
    d: "M15 14c-2 0 -3 1 -3.5 2.05"
  }), e.createElement("path", {
    d: "M10 9.25c-.5 1 -2.5 1 -3 0"
  }), e.createElement("path", {
    d: "M17 9.25c-.5 1 -2.5 1 -3 0"
  }));
}
var bve = ["size", "color", "stroke"];
function Lve(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, bve);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-mood-annoyed",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M12 21a9 9 0 1 1 0 -18a9 9 0 0 1 0 18z"
  }), e.createElement("path", {
    d: "M15 14c-2 0 -3 1 -3.5 2.05"
  }), e.createElement("path", {
    d: "M9 10h-.01"
  }), e.createElement("path", {
    d: "M15 10h-.01"
  }));
}
var yve = ["size", "color", "stroke"];
function Cve(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, yve);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-mood-boy",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M17 4.5a9 9 0 0 1 3.864 5.89a2.5 2.5 0 0 1 -.29 4.36a9 9 0 0 1 -17.137 0a2.5 2.5 0 0 1 -.29 -4.36a9 9 0 0 1 3.746 -5.81"
  }), e.createElement("path", {
    d: "M9.5 16a3.5 3.5 0 0 0 5 0"
  }), e.createElement("path", {
    d: "M8.5 2c1.5 1 2.5 3.5 2.5 5"
  }), e.createElement("path", {
    d: "M12.5 2c1.5 2 2 3.5 2 5"
  }), e.createElement("line", {
    x1: 9,
    y1: 12,
    x2: 9.01,
    y2: 12
  }), e.createElement("line", {
    x1: 15,
    y1: 12,
    x2: 15.01,
    y2: 12
  }));
}
var jve = ["size", "color", "stroke"];
function Bve(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, jve);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-mood-confuzed",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 9
  }), e.createElement("line", {
    x1: 9,
    y1: 10,
    x2: 9.01,
    y2: 10
  }), e.createElement("line", {
    x1: 15,
    y1: 10,
    x2: 15.01,
    y2: 10
  }), e.createElement("path", {
    d: "M9.5 16a10 10 0 0 1 6 -1.5"
  }));
}
var Hve = ["size", "color", "stroke"];
function Nve(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Hve);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-mood-crazy-happy",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 9
  }), e.createElement("line", {
    x1: 7,
    y1: 8.5,
    x2: 10,
    y2: 11.5
  }), e.createElement("path", {
    d: "M7 11.5l3 -3"
  }), e.createElement("line", {
    x1: 14,
    y1: 8.5,
    x2: 17,
    y2: 11.5
  }), e.createElement("path", {
    d: "M14 11.5l3 -3"
  }), e.createElement("path", {
    d: "M9.5 15a3.5 3.5 0 0 0 5 0"
  }));
}
var Wve = ["size", "color", "stroke"];
function qve(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Wve);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-mood-cry",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("line", {
    x1: 9,
    y1: 10,
    x2: 9.01,
    y2: 10
  }), e.createElement("line", {
    x1: 15,
    y1: 10,
    x2: 15.01,
    y2: 10
  }), e.createElement("path", {
    d: "M9.5 15.25a3.5 3.5 0 0 1 5 0"
  }), e.createElement("path", {
    d: "M17.566 17.606a2 2 0 1 0 2.897 .03l-1.463 -1.636l-1.434 1.606z"
  }), e.createElement("path", {
    d: "M20.865 13.517a8.937 8.937 0 0 0 .135 -1.517a9 9 0 1 0 -9 9c.69 0 1.36 -.076 2 -.222"
  }));
}
var Ove = ["size", "color", "stroke"];
function Pve(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Ove);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-mood-empty",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 9
  }), e.createElement("line", {
    x1: 9,
    y1: 10,
    x2: 9.01,
    y2: 10
  }), e.createElement("line", {
    x1: 15,
    y1: 10,
    x2: 15.01,
    y2: 10
  }), e.createElement("line", {
    x1: 9,
    y1: 15,
    x2: 15,
    y2: 15
  }));
}
var Sve = ["size", "color", "stroke"];
function Ive(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Sve);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-mood-happy",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 9
  }), e.createElement("line", {
    x1: 9,
    y1: 9,
    x2: 9.01,
    y2: 9
  }), e.createElement("line", {
    x1: 15,
    y1: 9,
    x2: 15.01,
    y2: 9
  }), e.createElement("path", {
    d: "M8 13a4 4 0 1 0 8 0m0 0h-8"
  }));
}
var Ave = ["size", "color", "stroke"];
function Dve(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Ave);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-mood-kid",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 9
  }), e.createElement("line", {
    x1: 9,
    y1: 10,
    x2: 9.01,
    y2: 10
  }), e.createElement("line", {
    x1: 15,
    y1: 10,
    x2: 15.01,
    y2: 10
  }), e.createElement("path", {
    d: "M9.5 15a3.5 3.5 0 0 0 5 0"
  }), e.createElement("path", {
    d: "M12 3a2 2 0 0 0 0 4"
  }));
}
var Fve = ["size", "color", "stroke"];
function Gve(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Fve);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-mood-look-left",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 9
  }), e.createElement("path", {
    d: "M9 9h.01"
  }), e.createElement("path", {
    d: "M4 15h4"
  }));
}
var Jve = ["size", "color", "stroke"];
function Kve(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Jve);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-mood-look-right",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M12 21a9 9 0 1 1 0 -18a9 9 0 0 1 0 18z"
  }), e.createElement("path", {
    d: "M15 9h-.01"
  }), e.createElement("path", {
    d: "M20 15h-4"
  }));
}
var Qve = ["size", "color", "stroke"];
function Rve(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Qve);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-mood-nerd",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 9
  }), e.createElement("circle", {
    cx: 8,
    cy: 10,
    r: 2
  }), e.createElement("circle", {
    cx: 16,
    cy: 10,
    r: 2
  }), e.createElement("path", {
    d: "M9.5 15a3.5 3.5 0 0 0 5 0"
  }), e.createElement("path", {
    d: "M3.5 9h2.5"
  }), e.createElement("path", {
    d: "M18 9h2.5"
  }), e.createElement("path", {
    d: "M10 9.5c1.333 -1.333 2.667 -1.333 4 0"
  }));
}
var Tve = ["size", "color", "stroke"];
function Uve(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Tve);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-mood-nervous",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 9
  }), e.createElement("path", {
    d: "M9 10h.01"
  }), e.createElement("path", {
    d: "M15 10h.01"
  }), e.createElement("path", {
    d: "M8 16l2 -2l2 2l2 -2l2 2"
  }));
}
var Vve = ["size", "color", "stroke"];
function Xve(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Vve);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-mood-neutral",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 9
  }), e.createElement("line", {
    x1: 9,
    y1: 10,
    x2: 9.01,
    y2: 10
  }), e.createElement("line", {
    x1: 15,
    y1: 10,
    x2: 15.01,
    y2: 10
  }));
}
var Yve = ["size", "color", "stroke"];
function Zve(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Yve);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-mood-off",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M5.634 5.638a9 9 0 0 0 12.732 12.724m1.679 -2.322a9 9 0 0 0 -12.08 -12.086"
  }), e.createElement("path", {
    d: "M9 10h.01"
  }), e.createElement("path", {
    d: "M15 10h.01"
  }), e.createElement("path", {
    d: "M9.5 15a3.5 3.5 0 0 0 5 0"
  }), e.createElement("path", {
    d: "M3 3l18 18"
  }));
}
var $ve = ["size", "color", "stroke"];
function _ve(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, $ve);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-mood-sad-2",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 9
  }), e.createElement("path", {
    d: "M14.5 16.05a3.5 3.5 0 0 0 -5 0"
  }), e.createElement("path", {
    d: "M10 9.25c-.5 1 -2.5 1 -3 0"
  }), e.createElement("path", {
    d: "M17 9.25c-.5 1 -2.5 1 -3 0"
  }));
}
var eme = ["size", "color", "stroke"];
function tme(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, eme);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-mood-sad-dizzy",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 9
  }), e.createElement("path", {
    d: "M14.5 16.05a3.5 3.5 0 0 0 -5 0"
  }), e.createElement("path", {
    d: "M8 9l2 2"
  }), e.createElement("path", {
    d: "M10 9l-2 2"
  }), e.createElement("path", {
    d: "M14 9l2 2"
  }), e.createElement("path", {
    d: "M16 9l-2 2"
  }));
}
var ome = ["size", "color", "stroke"];
function rme(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, ome);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-mood-sad-squint",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 9
  }), e.createElement("path", {
    d: "M14.5 16.05a3.5 3.5 0 0 0 -5 0"
  }), e.createElement("path", {
    d: "M8.5 11.5l1.5 -1.5l-1.5 -1.5"
  }), e.createElement("path", {
    d: "M15.5 11.5l-1.5 -1.5l1.5 -1.5"
  }));
}
var nme = ["size", "color", "stroke"];
function lme(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, nme);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-mood-sad",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 9
  }), e.createElement("line", {
    x1: 9,
    y1: 10,
    x2: 9.01,
    y2: 10
  }), e.createElement("line", {
    x1: 15,
    y1: 10,
    x2: 15.01,
    y2: 10
  }), e.createElement("path", {
    d: "M9.5 15.25a3.5 3.5 0 0 1 5 0"
  }));
}
var ame = ["size", "color", "stroke"];
function ime(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, ame);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-mood-sick",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M12 21a9 9 0 1 1 0 -18a9 9 0 0 1 0 18z"
  }), e.createElement("path", {
    d: "M9 10h-.01"
  }), e.createElement("path", {
    d: "M15 10h-.01"
  }), e.createElement("path", {
    d: "M8 16l1 -1l1.5 1l1.5 -1l1.5 1l1.5 -1l1 1"
  }));
}
var cme = ["size", "color", "stroke"];
function sme(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, cme);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-mood-silence",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M12 21a9 9 0 1 1 0 -18a9 9 0 0 1 0 18z"
  }), e.createElement("path", {
    d: "M9 10h-.01"
  }), e.createElement("path", {
    d: "M15 10h-.01"
  }), e.createElement("path", {
    d: "M8 15h8"
  }), e.createElement("path", {
    d: "M9 14v2"
  }), e.createElement("path", {
    d: "M12 14v2"
  }), e.createElement("path", {
    d: "M15 14v2"
  }));
}
var hme = ["size", "color", "stroke"];
function dme(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, hme);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-mood-sing",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 9
  }), e.createElement("path", {
    d: "M9 9h.01"
  }), e.createElement("path", {
    d: "M15 9h.01"
  }), e.createElement("circle", {
    cx: 15,
    cy: 15,
    r: 2
  }));
}
var vme = ["size", "color", "stroke"];
function mme(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, vme);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-mood-smile-beam",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M12 21a9 9 0 1 1 0 -18a9 9 0 0 1 0 18z"
  }), e.createElement("path", {
    d: "M10 10c-.5 -1 -2.5 -1 -3 0"
  }), e.createElement("path", {
    d: "M17 10c-.5 -1 -2.5 -1 -3 0"
  }), e.createElement("path", {
    d: "M14.5 15a3.5 3.5 0 0 1 -5 0"
  }));
}
var kme = ["size", "color", "stroke"];
function wme(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, kme);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-mood-smile-dizzy",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 9
  }), e.createElement("path", {
    d: "M14.5 15a3.5 3.5 0 0 1 -5 0"
  }), e.createElement("path", {
    d: "M8 9l2 2"
  }), e.createElement("path", {
    d: "M10 9l-2 2"
  }), e.createElement("path", {
    d: "M14 9l2 2"
  }), e.createElement("path", {
    d: "M16 9l-2 2"
  }));
}
var pme = ["size", "color", "stroke"];
function Eme(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, pme);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-mood-smile",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 9
  }), e.createElement("line", {
    x1: 9,
    y1: 10,
    x2: 9.01,
    y2: 10
  }), e.createElement("line", {
    x1: 15,
    y1: 10,
    x2: 15.01,
    y2: 10
  }), e.createElement("path", {
    d: "M9.5 15a3.5 3.5 0 0 0 5 0"
  }));
}
var ume = ["size", "color", "stroke"];
function gme(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, ume);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-mood-suprised",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 9
  }), e.createElement("line", {
    x1: 9,
    y1: 9,
    x2: 9.01,
    y2: 9
  }), e.createElement("line", {
    x1: 15,
    y1: 9,
    x2: 15.01,
    y2: 9
  }), e.createElement("circle", {
    cx: 12,
    cy: 15,
    r: 2
  }));
}
var Mme = ["size", "color", "stroke"];
function xme(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Mme);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-mood-tongue-wink-2",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 9
  }), e.createElement("path", {
    d: "M12 21a9 9 0 1 1 0 -18a9 9 0 0 1 0 18z"
  }), e.createElement("path", {
    d: "M15 10h-.01"
  }), e.createElement("path", {
    d: "M10 14v2a2 2 0 1 0 4 0v-2m1.5 0h-7"
  }), e.createElement("path", {
    d: "M7 10c.5 -1 2.5 -1 3 0"
  }));
}
var fme = ["size", "color", "stroke"];
function zme(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, fme);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-mood-tongue-wink",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M12 21a9 9 0 1 1 0 -18a9 9 0 0 1 0 18z"
  }), e.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 9
  }), e.createElement("path", {
    d: "M9 10h.01"
  }), e.createElement("path", {
    d: "M10 14v2a2 2 0 0 0 4 0v-2"
  }), e.createElement("path", {
    d: "M15.5 14h-7"
  }), e.createElement("path", {
    d: "M17 10c-.5 -1 -2.5 -1 -3 0"
  }));
}
var bme = ["size", "color", "stroke"];
function Lme(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, bme);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-mood-tongue",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 9
  }), e.createElement("line", {
    x1: 9,
    y1: 10,
    x2: 9.01,
    y2: 10
  }), e.createElement("line", {
    x1: 15,
    y1: 10,
    x2: 15.01,
    y2: 10
  }), e.createElement("path", {
    d: "M10 14v2a2 2 0 0 0 4 0v-2m1.5 0h-7"
  }));
}
var yme = ["size", "color", "stroke"];
function Cme(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, yme);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-mood-unamused",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 9
  }), e.createElement("path", {
    d: "M11 16l4 -1.5"
  }), e.createElement("path", {
    d: "M10 10c-.5 -1 -2.5 -1 -3 0"
  }), e.createElement("path", {
    d: "M17 10c-.5 -1 -2.5 -1 -3 0"
  }));
}
var jme = ["size", "color", "stroke"];
function Bme(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, jme);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-mood-wink-2",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M12 21a9 9 0 1 1 0 -18a9 9 0 0 1 0 18z"
  }), e.createElement("path", {
    d: "M9 10h-.01"
  }), e.createElement("path", {
    d: "M14.5 15a3.5 3.5 0 0 1 -5 0"
  }), e.createElement("path", {
    d: "M15.5 8.5l-1.5 1.5l1.5 1.5"
  }));
}
var Hme = ["size", "color", "stroke"];
function Nme(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Hme);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-mood-wink",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 9
  }), e.createElement("path", {
    d: "M15 10h.01"
  }), e.createElement("path", {
    d: "M9.5 15a3.5 3.5 0 0 0 5 0"
  }), e.createElement("path", {
    d: "M8.5 8.5l1.5 1.5l-1.5 1.5"
  }));
}
var Wme = ["size", "color", "stroke"];
function qme(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Wme);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-mood-wrrr",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M12 21a9 9 0 1 1 0 -18a9 9 0 0 1 0 18z"
  }), e.createElement("path", {
    d: "M8 16l1 -1l1.5 1l1.5 -1l1.5 1l1.5 -1l1 1"
  }), e.createElement("path", {
    d: "M8.5 11.5l1.5 -1.5l-1.5 -1.5"
  }), e.createElement("path", {
    d: "M15.5 11.5l-1.5 -1.5l1.5 -1.5"
  }));
}
var Ome = ["size", "color", "stroke"];
function Pme(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Ome);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-mood-xd",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 9
  }), e.createElement("path", {
    d: "M12 21a9 9 0 1 1 0 -18a9 9 0 0 1 0 18z"
  }), e.createElement("path", {
    d: "M9 14h6a3 3 0 1 1 -6 0z"
  }), e.createElement("path", {
    d: "M9 8l6 3"
  }), e.createElement("path", {
    d: "M9 11l6 -3"
  }));
}
var Sme = ["size", "color", "stroke"];
function Ime(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Sme);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-moon-2",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M16.418 4.157a8 8 0 0 0 0 15.686"
  }), e.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 9
  }));
}
var Ame = ["size", "color", "stroke"];
function Dme(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Ame);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-moon-off",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M7.962 3.949a8.97 8.97 0 0 1 4.038 -.957v.008h.393a7.478 7.478 0 0 0 -2.07 3.308m-.141 3.84c.186 .823 .514 1.626 .989 2.373a7.49 7.49 0 0 0 4.586 3.268m3.893 -.11c.223 -.067 .444 -.144 .663 -.233a9.088 9.088 0 0 1 -.274 .597m-1.695 2.337a9 9 0 0 1 -12.71 -12.749"
  }), e.createElement("path", {
    d: "M3 3l18 18"
  }));
}
var Fme = ["size", "color", "stroke"];
function Gme(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Fme);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-moon-stars",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M12 3c.132 0 .263 0 .393 0a7.5 7.5 0 0 0 7.92 12.446a9 9 0 1 1 -8.313 -12.454z"
  }), e.createElement("path", {
    d: "M17 4a2 2 0 0 0 2 2a2 2 0 0 0 -2 2a2 2 0 0 0 -2 -2a2 2 0 0 0 2 -2"
  }), e.createElement("path", {
    d: "M19 11h2m-1 -1v2"
  }));
}
var Jme = ["size", "color", "stroke"];
function Kme(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Jme);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-moon",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M12 3c.132 0 .263 0 .393 0a7.5 7.5 0 0 0 7.92 12.446a9 9 0 1 1 -8.313 -12.454z"
  }));
}
var Qme = ["size", "color", "stroke"];
function Rme(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Qme);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-moped",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("circle", {
    cx: 18,
    cy: 17,
    r: 2
  }), e.createElement("path", {
    d: "M5 16v1a2 2 0 0 0 4 0v-5h-3a3 3 0 0 0 -3 3v1h10a6 6 0 0 1 5 -4v-5a2 2 0 0 0 -2 -2h-1"
  }), e.createElement("line", {
    x1: 6,
    y1: 9,
    x2: 9,
    y2: 9
  }));
}
var Tme = ["size", "color", "stroke"];
function Ume(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Tme);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-motorbike",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("circle", {
    cx: 5,
    cy: 16,
    r: 3
  }), e.createElement("circle", {
    cx: 19,
    cy: 16,
    r: 3
  }), e.createElement("path", {
    d: "M7.5 14h5l4 -4h-10.5m1.5 4l4 -4"
  }), e.createElement("path", {
    d: "M13 6h2l1.5 3l2 4"
  }));
}
var Vme = ["size", "color", "stroke"];
function Xme(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Vme);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-mountain-off",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M18.281 14.26l-4.201 -8.872a2.3 2.3 0 0 0 -4.158 0l-.165 .349m-1.289 2.719l-5.468 11.544h17"
  }), e.createElement("path", {
    d: "M7.5 11l2 2.5l2 -2"
  }), e.createElement("path", {
    d: "M3 3l18 18"
  }));
}
var Yme = ["size", "color", "stroke"];
function Zme(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Yme);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-mountain",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M3 20h18l-6.921 -14.612a2.3 2.3 0 0 0 -4.158 0l-6.921 14.612z"
  }), e.createElement("path", {
    d: "M7.5 11l2 2.5l2.5 -2.5l2 3l2.5 -2"
  }));
}
var $me = ["size", "color", "stroke"];
function _me(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, $me);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-mouse-2",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("rect", {
    x: 6,
    y: 3,
    width: 12,
    height: 18,
    rx: 4
  }), e.createElement("path", {
    d: "M12 3v7"
  }), e.createElement("path", {
    d: "M6 10h12"
  }));
}
var eke = ["size", "color", "stroke"];
function tke(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, eke);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-mouse-off",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M7.733 3.704a3.982 3.982 0 0 1 2.267 -.704h4a4 4 0 0 1 4 4v7m-.1 3.895a4.002 4.002 0 0 1 -3.9 3.105h-4a4 4 0 0 1 -4 -4v-10c0 -.3 .033 -.593 .096 -.874"
  }), e.createElement("path", {
    d: "M12 7v1"
  }), e.createElement("path", {
    d: "M3 3l18 18"
  }));
}
var oke = ["size", "color", "stroke"];
function rke(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, oke);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-mouse",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("rect", {
    x: 6,
    y: 3,
    width: 12,
    height: 18,
    rx: 4
  }), e.createElement("line", {
    x1: 12,
    y1: 7,
    x2: 12,
    y2: 11
  }));
}
var nke = ["size", "color", "stroke"];
function lke(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, nke);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-moustache",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M15 9a3 3 0 0 1 2.599 1.5h.001c.933 1.333 2.133 1.556 3.126 1.556l.291 -.006l.77 -.044l.213 -.006c-.963 1.926 -3.163 2.925 -6.6 2.996l-.4 .004l-.165 -.005a3 3 0 0 1 .165 -5.995z"
  }), e.createElement("path", {
    d: "M9 9a3 3 0 0 0 -2.599 1.5h-.001c-.933 1.333 -2.133 1.556 -3.126 1.556l-.291 -.006l-.77 -.044l-.213 -.006c.963 1.926 3.163 2.925 6.6 2.996l.4 .004l.165 -.005a3 3 0 0 0 -.165 -5.995z"
  }));
}
var ake = ["size", "color", "stroke"];
function ike(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, ake);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-movie-off",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M8 4h10a2 2 0 0 1 2 2v10m-.592 3.42c-.362 .359 -.859 .58 -1.408 .58h-12a2 2 0 0 1 -2 -2v-12c0 -.539 .213 -1.028 .56 -1.388"
  }), e.createElement("path", {
    d: "M8 8v12"
  }), e.createElement("path", {
    d: "M16 4v8m0 4v4"
  }), e.createElement("path", {
    d: "M4 8h4"
  }), e.createElement("path", {
    d: "M4 16h4"
  }), e.createElement("path", {
    d: "M4 12h8m4 0h4"
  }), e.createElement("path", {
    d: "M16 8h4"
  }), e.createElement("path", {
    d: "M3 3l18 18"
  }));
}
var cke = ["size", "color", "stroke"];
function ske(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, cke);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-movie",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("rect", {
    x: 4,
    y: 4,
    width: 16,
    height: 16,
    rx: 2
  }), e.createElement("line", {
    x1: 8,
    y1: 4,
    x2: 8,
    y2: 20
  }), e.createElement("line", {
    x1: 16,
    y1: 4,
    x2: 16,
    y2: 20
  }), e.createElement("line", {
    x1: 4,
    y1: 8,
    x2: 8,
    y2: 8
  }), e.createElement("line", {
    x1: 4,
    y1: 16,
    x2: 8,
    y2: 16
  }), e.createElement("line", {
    x1: 4,
    y1: 12,
    x2: 20,
    y2: 12
  }), e.createElement("line", {
    x1: 16,
    y1: 8,
    x2: 20,
    y2: 8
  }), e.createElement("line", {
    x1: 16,
    y1: 16,
    x2: 20,
    y2: 16
  }));
}
var hke = ["size", "color", "stroke"];
function dke(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, hke);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-mug-off",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M9 5h5.917a1.08 1.08 0 0 1 1.083 1.077v5.923m-.167 3.88a4.33 4.33 0 0 1 -4.166 3.12h-4.334c-2.393 0 -4.333 -1.929 -4.333 -4.308v-8.615a1.08 1.08 0 0 1 1.083 -1.077h.917"
  }), e.createElement("path", {
    d: "M16 8h2.5c1.38 0 2.5 1.045 2.5 2.333v2.334c0 1.148 -.89 2.103 -2.06 2.297"
  }), e.createElement("path", {
    d: "M3 3l18 18"
  }));
}
var vke = ["size", "color", "stroke"];
function mke(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, vke);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-mug",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M4.083 5h10.834a1.08 1.08 0 0 1 1.083 1.077v8.615c0 2.38 -1.94 4.308 -4.333 4.308h-4.334c-2.393 0 -4.333 -1.929 -4.333 -4.308v-8.615a1.08 1.08 0 0 1 1.083 -1.077"
  }), e.createElement("path", {
    d: "M16 8h2.5c1.38 0 2.5 1.045 2.5 2.333v2.334c0 1.288 -1.12 2.333 -2.5 2.333h-2.5"
  }));
}
var kke = ["size", "color", "stroke"];
function wke(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, kke);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-multiplier-0-5x",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M8 16h2a2 2 0 1 0 0 -4h-2v-4h4"
  }), e.createElement("path", {
    d: "M5 16v.01"
  }), e.createElement("path", {
    d: "M15 16l4 -4"
  }), e.createElement("path", {
    d: "M19 16l-4 -4"
  }));
}
var pke = ["size", "color", "stroke"];
function Eke(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, pke);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-multiplier-1-5x",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M4 16v-8l-2 2"
  }), e.createElement("path", {
    d: "M10 16h2a2 2 0 1 0 0 -4h-2v-4h4"
  }), e.createElement("path", {
    d: "M7 16v.01"
  }), e.createElement("path", {
    d: "M17 16l4 -4"
  }), e.createElement("path", {
    d: "M21 16l-4 -4"
  }));
}
var uke = ["size", "color", "stroke"];
function gke(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, uke);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-multiplier-1x",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M9 16v-8l-2 2"
  }), e.createElement("path", {
    d: "M13 16l4 -4"
  }), e.createElement("path", {
    d: "M17 16l-4 -4"
  }));
}
var Mke = ["size", "color", "stroke"];
function xke(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Mke);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-multiplier-2x",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M14 16l4 -4"
  }), e.createElement("path", {
    d: "M18 16l-4 -4"
  }), e.createElement("path", {
    d: "M6 10a2 2 0 1 1 4 0c0 .591 -.417 1.318 -.816 1.858l-3.184 4.143l4 0"
  }));
}
var fke = ["size", "color", "stroke"];
function zke(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, fke);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-mushroom-off",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M5.874 5.89a8.128 8.128 0 0 0 -1.874 5.21a0.9 .9 0 0 0 .9 .9h7.1m4 0h3.1a0.9 .9 0 0 0 .9 -.9c0 -4.474 -3.582 -8.1 -8 -8.1c-1.43 0 -2.774 .38 -3.936 1.047"
  }), e.createElement("path", {
    d: "M10 12v7a2 2 0 1 0 4 0v-5"
  }), e.createElement("path", {
    d: "M3 3l18 18"
  }));
}
var bke = ["size", "color", "stroke"];
function Lke(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, bke);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-mushroom",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M20 11.1c0 -4.474 -3.582 -8.1 -8 -8.1s-8 3.626 -8 8.1a0.9 .9 0 0 0 .9 .9h14.2a0.9 .9 0 0 0 .9 -.9z"
  }), e.createElement("path", {
    d: "M10 12v7a2 2 0 1 0 4 0v-7"
  }));
}
var yke = ["size", "color", "stroke"];
function Cke(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, yke);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-music-off",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("circle", {
    cx: 6,
    cy: 17,
    r: 3
  }), e.createElement("path", {
    d: "M14.42 14.45a3 3 0 1 0 4.138 4.119"
  }), e.createElement("path", {
    d: "M9 17v-8m0 -4v-1h10v11"
  }), e.createElement("path", {
    d: "M12 8h7"
  }), e.createElement("path", {
    d: "M3 3l18 18"
  }));
}
var jke = ["size", "color", "stroke"];
function Bke(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, jke);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-music",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("circle", {
    cx: 6,
    cy: 17,
    r: 3
  }), e.createElement("circle", {
    cx: 16,
    cy: 17,
    r: 3
  }), e.createElement("polyline", {
    points: "9 17 9 4 19 4 19 17"
  }), e.createElement("line", {
    x1: 9,
    y1: 8,
    x2: 19,
    y2: 8
  }));
}
var Hke = ["size", "color", "stroke"];
function Nke(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Hke);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-navigation-off",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M16.28 12.28c-.95 -2.064 -2.377 -5.157 -4.28 -9.28c-.7 1.515 -1.223 2.652 -1.573 3.41m-1.27 2.75c-.882 1.913 -2.59 5.618 -5.127 11.115c-.07 .2 -.017 .424 .135 .572c.15 .148 .374 .193 .57 .116l7.265 -2.463l7.265 2.463c.196 .077 .42 .032 .57 -.116a0.548 .548 0 0 0 .134 -.572l-.26 -.563"
  }), e.createElement("path", {
    d: "M3 3l18 18"
  }));
}
var Wke = ["size", "color", "stroke"];
function qke(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Wke);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-navigation",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M12 18.5l7.265 2.463a0.535 .535 0 0 0 .57 -.116a0.548 .548 0 0 0 .134 -.572l-7.969 -17.275l-7.97 17.275a0.547 .547 0 0 0 .135 .572a0.535 .535 0 0 0 .57 .116l7.265 -2.463"
  }));
}
var Oke = ["size", "color", "stroke"];
function Pke(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Oke);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-needle-thread",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M3 21c-.667 -.667 3.262 -6.236 11.785 -16.709a3.5 3.5 0 1 1 5.078 4.791c-10.575 8.612 -16.196 12.585 -16.863 11.918z"
  }), e.createElement("path", {
    d: "M17.5 6.5l-1 1"
  }), e.createElement("path", {
    d: "M17 7c-2.333 -2.667 -3.5 -4 -5 -4s-2 1 -2 2c0 4 8.161 8.406 6 11c-1.056 1.268 -3.363 1.285 -5.75 .808"
  }), e.createElement("path", {
    d: "M5.739 15.425c-1.393 -.565 -3.739 -1.925 -3.739 -3.425"
  }), e.createElement("path", {
    d: "M19.5 9.5l1.5 1.5"
  }));
}
var Ske = ["size", "color", "stroke"];
function Ike(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Ske);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-needle",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M3 21c-.667 -.667 3.262 -6.236 11.785 -16.709a3.5 3.5 0 1 1 5.078 4.791c-10.575 8.612 -16.196 12.585 -16.863 11.918z"
  }), e.createElement("path", {
    d: "M17.5 6.5l-1 1"
  }));
}
var Ake = ["size", "color", "stroke"];
function Dke(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Ake);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-network-off",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M6.537 6.516a6 6 0 0 0 7.932 7.954m2.246 -1.76a6 6 0 0 0 -8.415 -8.433"
  }), e.createElement("path", {
    d: "M12 3c1.333 .333 2 2.333 2 6c0 .348 -.006 .681 -.018 1m-.545 3.43c-.332 .89 -.811 1.414 -1.437 1.57"
  }), e.createElement("path", {
    d: "M12 3c-.938 .234 -1.547 1.295 -1.825 3.182m-.156 3.837c.117 3.02 .777 4.68 1.981 4.981"
  }), e.createElement("path", {
    d: "M6 9h3m4 0h5"
  }), e.createElement("path", {
    d: "M3 19h7"
  }), e.createElement("path", {
    d: "M14 19h5"
  }), e.createElement("circle", {
    cx: 12,
    cy: 19,
    r: 2
  }), e.createElement("path", {
    d: "M12 15v2"
  }), e.createElement("path", {
    d: "M3 3l18 18"
  }));
}
var Fke = ["size", "color", "stroke"];
function Gke(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Fke);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-network",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("circle", {
    cx: 12,
    cy: 9,
    r: 6
  }), e.createElement("path", {
    d: "M12 3c1.333 .333 2 2.333 2 6s-.667 5.667 -2 6"
  }), e.createElement("path", {
    d: "M12 3c-1.333 .333 -2 2.333 -2 6s.667 5.667 2 6"
  }), e.createElement("path", {
    d: "M6 9h12"
  }), e.createElement("path", {
    d: "M3 19h7"
  }), e.createElement("path", {
    d: "M14 19h7"
  }), e.createElement("circle", {
    cx: 12,
    cy: 19,
    r: 2
  }), e.createElement("path", {
    d: "M12 15v2"
  }));
}
var Jke = ["size", "color", "stroke"];
function Kke(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Jke);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-new-section",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("line", {
    x1: 9,
    y1: 12,
    x2: 15,
    y2: 12
  }), e.createElement("line", {
    x1: 12,
    y1: 9,
    x2: 12,
    y2: 15
  }), e.createElement("path", {
    d: "M4 6v-1a1 1 0 0 1 1 -1h1m5 0h2m5 0h1a1 1 0 0 1 1 1v1m0 5v2m0 5v1a1 1 0 0 1 -1 1h-1m-5 0h-2m-5 0h-1a1 1 0 0 1 -1 -1v-1m0 -5v-2m0 -5"
  }));
}
var Qke = ["size", "color", "stroke"];
function Rke(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Qke);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-news-off",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M16 6h3a1 1 0 0 1 1 1v9m-.606 3.435a2 2 0 0 1 -3.394 -1.435v-2m0 -4v-7a1 1 0 0 0 -1 -1h-7m-3.735 .321a0.996 .996 0 0 0 -.265 .679v12a3 3 0 0 0 3 3h11"
  }), e.createElement("path", {
    d: "M8 12h4"
  }), e.createElement("path", {
    d: "M8 16h4"
  }), e.createElement("path", {
    d: "M3 3l18 18"
  }));
}
var Tke = ["size", "color", "stroke"];
function Uke(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Tke);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-news",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M16 6h3a1 1 0 0 1 1 1v11a2 2 0 0 1 -4 0v-13a1 1 0 0 0 -1 -1h-10a1 1 0 0 0 -1 1v12a3 3 0 0 0 3 3h11"
  }), e.createElement("line", {
    x1: 8,
    y1: 8,
    x2: 12,
    y2: 8
  }), e.createElement("line", {
    x1: 8,
    y1: 12,
    x2: 12,
    y2: 12
  }), e.createElement("line", {
    x1: 8,
    y1: 16,
    x2: 12,
    y2: 16
  }));
}
var Vke = ["size", "color", "stroke"];
function Xke(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Vke);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-nfc-off",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M11 20a3 3 0 0 1 -3 -3v-9"
  }), e.createElement("path", {
    d: "M13 4a3 3 0 0 1 3 3v5m0 4v2l-5 -5"
  }), e.createElement("path", {
    d: "M8 4h9a3 3 0 0 1 3 3v9m-.873 3.116a2.99 2.99 0 0 1 -2.127 .884h-10a3 3 0 0 1 -3 -3v-10c0 -.83 .337 -1.582 .882 -2.125"
  }), e.createElement("path", {
    d: "M3 3l18 18"
  }));
}
var Yke = ["size", "color", "stroke"];
function Zke(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Yke);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-nfc",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M11 20a3 3 0 0 1 -3 -3v-11l5 5"
  }), e.createElement("path", {
    d: "M13 4a3 3 0 0 1 3 3v11l-5 -5"
  }), e.createElement("rect", {
    x: 4,
    y: 4,
    width: 16,
    height: 16,
    rx: 3
  }));
}
var $ke = ["size", "color", "stroke"];
function _ke(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, $ke);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-no-copyright",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 9
  }), e.createElement("path", {
    d: "M14 9.75a3.016 3.016 0 0 0 -4.163 .173a2.993 2.993 0 0 0 0 4.154a3.016 3.016 0 0 0 4.163 .173"
  }), e.createElement("path", {
    d: "M6 6l1.5 1.5"
  }), e.createElement("path", {
    d: "M16.5 16.5l1.5 1.5"
  }));
}
var ewe = ["size", "color", "stroke"];
function twe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, ewe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-no-creative-commons",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 9
  }), e.createElement("path", {
    d: "M10.5 10.5c-.847 -.71 -2.132 -.658 -2.914 .116a1.928 1.928 0 0 0 0 2.768c.782 .774 2.067 .825 2.914 .116"
  }), e.createElement("path", {
    d: "M16.5 10.5c-.847 -.71 -2.132 -.658 -2.914 .116a1.928 1.928 0 0 0 0 2.768c.782 .774 2.067 .825 2.914 .116"
  }), e.createElement("path", {
    d: "M6 6l1.5 1.5"
  }), e.createElement("path", {
    d: "M16.5 16.5l1.5 1.5"
  }));
}
var owe = ["size", "color", "stroke"];
function rwe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, owe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-no-derivatives",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 9
  }), e.createElement("path", {
    d: "M9 10h6"
  }), e.createElement("path", {
    d: "M9 14h6"
  }));
}
var nwe = ["size", "color", "stroke"];
function lwe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, nwe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-north-star",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M3 12h18"
  }), e.createElement("path", {
    d: "M12 21v-18"
  }), e.createElement("path", {
    d: "M7.5 7.5l9 9"
  }), e.createElement("path", {
    d: "M7.5 16.5l9 -9"
  }));
}
var awe = ["size", "color", "stroke"];
function iwe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, awe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-note-off",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M13 20l3.505 -3.505m1.994 -1.994l1.501 -1.501"
  }), e.createElement("path", {
    d: "M17 13h3v-7a2 2 0 0 0 -2 -2h-10m-3.427 .6c-.355 .36 -.573 .853 -.573 1.4v12a2 2 0 0 0 2 2h7v-6c0 -.272 .109 -.519 .285 -.699"
  }), e.createElement("path", {
    d: "M3 3l18 18"
  }));
}
var cwe = ["size", "color", "stroke"];
function swe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, cwe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-note",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("line", {
    x1: 13,
    y1: 20,
    x2: 20,
    y2: 13
  }), e.createElement("path", {
    d: "M13 20v-6a1 1 0 0 1 1 -1h6v-7a2 2 0 0 0 -2 -2h-12a2 2 0 0 0 -2 2v12a2 2 0 0 0 2 2h7"
  }));
}
var hwe = ["size", "color", "stroke"];
function dwe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, hwe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-notebook-off",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M8 4h9a2 2 0 0 1 2 2v9m-.179 3.828a2 2 0 0 1 -1.821 1.172h-11a1 1 0 0 1 -1 -1v-14m4 -1v1m0 4v13"
  }), e.createElement("path", {
    d: "M13 8h2"
  }), e.createElement("path", {
    d: "M3 3l18 18"
  }));
}
var vwe = ["size", "color", "stroke"];
function mwe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, vwe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-notebook",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M6 4h11a2 2 0 0 1 2 2v12a2 2 0 0 1 -2 2h-11a1 1 0 0 1 -1 -1v-14a1 1 0 0 1 1 -1m3 0v18"
  }), e.createElement("line", {
    x1: 13,
    y1: 8,
    x2: 15,
    y2: 8
  }), e.createElement("line", {
    x1: 13,
    y1: 12,
    x2: 15,
    y2: 12
  }));
}
var kwe = ["size", "color", "stroke"];
function wwe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, kwe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-notes-off",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M7 3h10a2 2 0 0 1 2 2v10m0 4a2 2 0 0 1 -2 2h-10a2 2 0 0 1 -2 -2v-14"
  }), e.createElement("path", {
    d: "M11 7h4"
  }), e.createElement("path", {
    d: "M9 11h2"
  }), e.createElement("path", {
    d: "M9 15h4"
  }), e.createElement("path", {
    d: "M3 3l18 18"
  }));
}
var pwe = ["size", "color", "stroke"];
function Ewe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, pwe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-notes",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("rect", {
    x: 5,
    y: 3,
    width: 14,
    height: 18,
    rx: 2
  }), e.createElement("line", {
    x1: 9,
    y1: 7,
    x2: 15,
    y2: 7
  }), e.createElement("line", {
    x1: 9,
    y1: 11,
    x2: 15,
    y2: 11
  }), e.createElement("line", {
    x1: 9,
    y1: 15,
    x2: 13,
    y2: 15
  }));
}
var uwe = ["size", "color", "stroke"];
function gwe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, uwe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-notification-off",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M6.154 6.187a2 2 0 0 0 -1.154 1.813v9a2 2 0 0 0 2 2h9a2 2 0 0 0 1.811 -1.151"
  }), e.createElement("circle", {
    cx: 17,
    cy: 7,
    r: 3
  }), e.createElement("path", {
    d: "M3 3l18 18"
  }));
}
var Mwe = ["size", "color", "stroke"];
function xwe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Mwe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-notification",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M10 6h-3a2 2 0 0 0 -2 2v9a2 2 0 0 0 2 2h9a2 2 0 0 0 2 -2v-3"
  }), e.createElement("circle", {
    cx: 17,
    cy: 7,
    r: 3
  }));
}
var fwe = ["size", "color", "stroke"];
function zwe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, fwe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-number-0",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M16 16v-8"
  }), e.createElement("path", {
    d: "M12 20a4 4 0 0 0 4 -4v-8a4 4 0 1 0 -8 0v8a4 4 0 0 0 4 4z"
  }));
}
var bwe = ["size", "color", "stroke"];
function Lwe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, bwe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-number-1",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M13 20v-16l-5 5"
  }));
}
var ywe = ["size", "color", "stroke"];
function Cwe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, ywe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-number-2",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M8 8a4 4 0 1 1 8 0c0 1.098 -.564 2.025 -1.159 2.815l-6.841 9.185h8"
  }));
}
var jwe = ["size", "color", "stroke"];
function Bwe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, jwe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-number-3",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M12 12a4 4 0 1 0 -4 -4"
  }), e.createElement("path", {
    d: "M8 16a4 4 0 1 0 4 -4"
  }));
}
var Hwe = ["size", "color", "stroke"];
function Nwe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Hwe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-number-4",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M15 20v-15l-8 11h10"
  }));
}
var Wwe = ["size", "color", "stroke"];
function qwe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Wwe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-number-5",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M8 20h4a4 4 0 1 0 0 -8h-4v-8h8"
  }));
}
var Owe = ["size", "color", "stroke"];
function Pwe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Owe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-number-6",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M8 16a4 4 0 1 0 8 0v-1a4 4 0 1 0 -8 0"
  }), e.createElement("path", {
    d: "M16 8a4 4 0 1 0 -8 0v8"
  }));
}
var Swe = ["size", "color", "stroke"];
function Iwe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Swe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-number-7",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M8 4h8l-4 16"
  }));
}
var Awe = ["size", "color", "stroke"];
function Dwe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Awe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-number-8",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("circle", {
    cx: 12,
    cy: 8,
    r: 4
  }), e.createElement("circle", {
    cx: 12,
    cy: 16,
    r: 4
  }));
}
var Fwe = ["size", "color", "stroke"];
function Gwe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Fwe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-number-9",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M16 8a4 4 0 1 0 -8 0v1a4 4 0 1 0 8 0"
  }), e.createElement("path", {
    d: "M8 16a4 4 0 1 0 8 0v-8"
  }));
}
var Jwe = ["size", "color", "stroke"];
function Kwe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Jwe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-number",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M4 17v-10l7 10v-10"
  }), e.createElement("path", {
    d: "M15 17h5"
  }), e.createElement("ellipse", {
    cx: 17.5,
    cy: 10,
    rx: 2.5,
    ry: 3
  }));
}
var Qwe = ["size", "color", "stroke"];
function Rwe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Qwe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-numbers",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M8 10v-7l-2 2"
  }), e.createElement("path", {
    d: "M6 16a2 2 0 1 1 4 0c0 .591 -.601 1.46 -1 2l-3 3.001h4"
  }), e.createElement("path", {
    d: "M15 14a2 2 0 1 0 2 -2a2 2 0 1 0 -2 -2"
  }), e.createElement("path", {
    d: "M6.5 10h3"
  }));
}
var Twe = ["size", "color", "stroke"];
function Uwe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Twe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-nurse",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M12 6c2.941 0 5.685 .847 8 2.31l-2 9.69h-12l-2 -9.691a14.93 14.93 0 0 1 8 -2.309z"
  }), e.createElement("path", {
    d: "M10 12h4"
  }), e.createElement("path", {
    d: "M12 10v4"
  }));
}
var Vwe = ["size", "color", "stroke"];
function Xwe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Vwe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-octagon-off",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M7.647 3.653l.353 -.353c.2 -.2 .4 -.3 .7 -.3h6.6c.3 0 .5 .1 .7 .3l4.7 4.7c.2 .2 .3 .4 .3 .7v6.6c0 .3 -.1 .5 -.3 .7l-.35 .35m-1.997 1.997l-2.353 2.353c-.2 .2 -.4 .3 -.7 .3h-6.6c-.3 0 -.5 -.1 -.7 -.3l-4.7 -4.7c-.2 -.2 -.3 -.4 -.3 -.7v-6.6c0 -.3 .1 -.5 .3 -.7l2.35 -2.35"
  }), e.createElement("path", {
    d: "M3 3l18 18"
  }));
}
var Ywe = ["size", "color", "stroke"];
function Zwe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Ywe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-octagon",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M8.7 3h6.6c.3 0 .5 .1 .7 .3l4.7 4.7c.2 .2 .3 .4 .3 .7v6.6c0 .3 -.1 .5 -.3 .7l-4.7 4.7c-.2 .2 -.4 .3 -.7 .3h-6.6c-.3 0 -.5 -.1 -.7 -.3l-4.7 -4.7c-.2 -.2 -.3 -.4 -.3 -.7v-6.6c0 -.3 .1 -.5 .3 -.7l4.7 -4.7c.2 -.2 .4 -.3 .7 -.3z"
  }));
}
var $we = ["size", "color", "stroke"];
function _we(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, $we);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-old",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M11 21l-1 -4l-2 -3v-6"
  }), e.createElement("path", {
    d: "M5 14l-1 -3l4 -3l3 2l3 .5"
  }), e.createElement("circle", {
    cx: 8,
    cy: 4,
    r: 1
  }), e.createElement("path", {
    d: "M7 17l-2 4"
  }), e.createElement("path", {
    d: "M16 21v-8.5a1.5 1.5 0 0 1 3 0v.5"
  }));
}
var epe = ["size", "color", "stroke"];
function tpe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, epe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-olympics-off",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M6 6a3 3 0 1 0 3 3"
  }), e.createElement("circle", {
    cx: 18,
    cy: 9,
    r: 3
  }), e.createElement("path", {
    d: "M9 9a3 3 0 0 0 3 3m2.566 -1.445a3 3 0 0 0 -4.135 -4.113"
  }), e.createElement("circle", {
    cx: 9,
    cy: 15,
    r: 3
  }), e.createElement("path", {
    d: "M12.878 12.88a3 3 0 0 0 4.239 4.247m.586 -3.431a3.012 3.012 0 0 0 -1.43 -1.414"
  }), e.createElement("path", {
    d: "M3 3l18 18"
  }));
}
var ope = ["size", "color", "stroke"];
function rpe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, ope);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-olympics",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("circle", {
    cx: 6,
    cy: 9,
    r: 3
  }), e.createElement("circle", {
    cx: 18,
    cy: 9,
    r: 3
  }), e.createElement("circle", {
    cx: 12,
    cy: 9,
    r: 3
  }), e.createElement("circle", {
    cx: 9,
    cy: 15,
    r: 3
  }), e.createElement("circle", {
    cx: 15,
    cy: 15,
    r: 3
  }));
}
var npe = ["size", "color", "stroke"];
function lpe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, npe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-om",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M7 12c2.21 0 4 -1.567 4 -3.5s-1.79 -3.5 -4 -3.5c-1.594 0 -2.97 .816 -3.613 1.996"
  }), e.createElement("path", {
    d: "M3.423 14.483a4.944 4.944 0 0 0 -.423 2.017c0 2.485 1.79 4.5 4 4.5s4 -2.015 4 -4.5s-1.79 -4.5 -4 -4.5"
  }), e.createElement("path", {
    d: "M14.071 17.01c.327 2.277 1.739 3.99 3.429 3.99c1.933 0 3.5 -2.239 3.5 -5s-1.567 -5 -3.5 -5c-.96 0 -1.868 .606 -2.5 1.5c-.717 1.049 -1.76 1.7 -2.936 1.7c-.92 0 -1.766 -.406 -2.434 -1.087"
  }), e.createElement("path", {
    d: "M17 3l2 2"
  }), e.createElement("path", {
    d: "M12 3c1.667 3.667 4.667 5.333 9 5"
  }));
}
var ape = ["size", "color", "stroke"];
function ipe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, ape);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-omega",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M4 19h5v-1a7.35 7.35 0 1 1 6 0v1h5"
  }));
}
var cpe = ["size", "color", "stroke"];
function spe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, cpe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-outbound",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 9
  }), e.createElement("path", {
    d: "M9 15l6 -6"
  }), e.createElement("path", {
    d: "M11 9h4v4"
  }));
}
var hpe = ["size", "color", "stroke"];
function dpe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, hpe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-outlet",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("rect", {
    x: 4,
    y: 4,
    width: 16,
    height: 16,
    rx: 2
  }), e.createElement("circle", {
    cx: 9,
    cy: 12,
    r: .5,
    fill: "currentColor"
  }), e.createElement("circle", {
    cx: 15,
    cy: 12,
    r: .5,
    fill: "currentColor"
  }));
}
var vpe = ["size", "color", "stroke"];
function mpe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, vpe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-oval-vertical",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M3 12c0 -3.314 4.03 -6 9 -6s9 2.686 9 6s-4.03 6 -9 6s-9 -2.686 -9 -6z"
  }));
}
var kpe = ["size", "color", "stroke"];
function wpe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, kpe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-oval",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("ellipse", {
    cx: 12,
    cy: 12,
    rx: 6,
    ry: 9
  }));
}
var ppe = ["size", "color", "stroke"];
function Epe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, ppe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-overline",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M7 9v5a5 5 0 0 0 10 0v-5"
  }), e.createElement("path", {
    d: "M5 5h14"
  }));
}
var upe = ["size", "color", "stroke"];
function gpe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, upe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-package-off",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M8.812 4.793l3.188 -1.793l8 4.5v8.5m-2.282 1.784l-5.718 3.216l-8 -4.5v-9l2.223 -1.25"
  }), e.createElement("path", {
    d: "M14.543 10.57l5.457 -3.07"
  }), e.createElement("path", {
    d: "M12 12v9"
  }), e.createElement("path", {
    d: "M12 12l-8 -4.5"
  }), e.createElement("path", {
    d: "M16 5.25l-4.35 2.447m-2.564 1.442l-1.086 .611"
  }), e.createElement("path", {
    d: "M3 3l18 18"
  }));
}
var Mpe = ["size", "color", "stroke"];
function xpe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Mpe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-package",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("polyline", {
    points: "12 3 20 7.5 20 16.5 12 21 4 16.5 4 7.5 12 3"
  }), e.createElement("line", {
    x1: 12,
    y1: 12,
    x2: 20,
    y2: 7.5
  }), e.createElement("line", {
    x1: 12,
    y1: 12,
    x2: 12,
    y2: 21
  }), e.createElement("line", {
    x1: 12,
    y1: 12,
    x2: 4,
    y2: 7.5
  }), e.createElement("line", {
    x1: 16,
    y1: 5.25,
    x2: 8,
    y2: 9.75
  }));
}
var fpe = ["size", "color", "stroke"];
function zpe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, fpe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-packages",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M7 16.5l-5 -3l5 -3l5 3v5.5l-5 3z"
  }), e.createElement("path", {
    d: "M2 13.5v5.5l5 3"
  }), e.createElement("path", {
    d: "M7 16.545l5 -3.03"
  }), e.createElement("path", {
    d: "M17 16.5l-5 -3l5 -3l5 3v5.5l-5 3z"
  }), e.createElement("path", {
    d: "M12 19l5 3"
  }), e.createElement("path", {
    d: "M17 16.5l5 -3"
  }), e.createElement("path", {
    d: "M12 13.5v-5.5l-5 -3l5 -3l5 3v5.5"
  }), e.createElement("path", {
    d: "M7 5.03v5.455"
  }), e.createElement("path", {
    d: "M12 8l5 -3"
  }));
}
var bpe = ["size", "color", "stroke"];
function Lpe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, bpe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-packge-export",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M12 21l-8 -4.5v-9l8 -4.5l8 4.5v4.5"
  }), e.createElement("path", {
    d: "M12 12l8 -4.5"
  }), e.createElement("path", {
    d: "M12 12v9"
  }), e.createElement("path", {
    d: "M12 12l-8 -4.5"
  }), e.createElement("path", {
    d: "M15 18h7"
  }), e.createElement("path", {
    d: "M19 15l3 3l-3 3"
  }));
}
var ype = ["size", "color", "stroke"];
function Cpe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, ype);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-packge-import",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M12 21l-8 -4.5v-9l8 -4.5l8 4.5v4.5"
  }), e.createElement("path", {
    d: "M12 12l8 -4.5"
  }), e.createElement("path", {
    d: "M12 12v9"
  }), e.createElement("path", {
    d: "M12 12l-8 -4.5"
  }), e.createElement("path", {
    d: "M22 18h-7"
  }), e.createElement("path", {
    d: "M18 15l-3 3l3 3"
  }));
}
var jpe = ["size", "color", "stroke"];
function Bpe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, jpe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-pacman",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M5.636 5.636a9 9 0 0 1 13.397 .747l-5.619 5.617l5.619 5.617a9 9 0 1 1 -13.397 -11.981z"
  }), e.createElement("circle", {
    cx: 11.5,
    cy: 7.5,
    r: 1,
    fill: "currentColor"
  }));
}
var Hpe = ["size", "color", "stroke"];
function Npe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Hpe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-page-break",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M14 3v4a1 1 0 0 0 1 1h4"
  }), e.createElement("path", {
    d: "M19 18v1a2 2 0 0 1 -2 2h-10a2 2 0 0 1 -2 -2v-1"
  }), e.createElement("path", {
    d: "M3 14h3m4.5 0h3m4.5 0h3"
  }), e.createElement("path", {
    d: "M5 10v-5a2 2 0 0 1 2 -2h7l5 5v2"
  }));
}
var Wpe = ["size", "color", "stroke"];
function qpe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Wpe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-paint-off",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M7 3h10a2 2 0 0 1 2 2v2a2 2 0 0 1 -2 2h-4m-4 0h-2a2 2 0 0 1 -2 -2v-2"
  }), e.createElement("path", {
    d: "M19 6h1a2 2 0 0 1 2 2a5 5 0 0 1 -5 5m-4 0h-1v2"
  }), e.createElement("rect", {
    x: 10,
    y: 15,
    width: 4,
    height: 6,
    rx: 1
  }), e.createElement("path", {
    d: "M3 3l18 18"
  }));
}
var Ope = ["size", "color", "stroke"];
function Ppe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Ope);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-paint",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("rect", {
    x: 5,
    y: 3,
    width: 14,
    height: 6,
    rx: 2
  }), e.createElement("path", {
    d: "M19 6h1a2 2 0 0 1 2 2a5 5 0 0 1 -5 5l-5 0v2"
  }), e.createElement("rect", {
    x: 10,
    y: 15,
    width: 4,
    height: 6,
    rx: 1
  }));
}
var Spe = ["size", "color", "stroke"];
function Ipe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Spe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-palette-off",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M15 15h-1a2 2 0 0 0 -1 3.75a1.3 1.3 0 0 1 -1 2.25a9 9 0 0 1 -6.372 -15.356"
  }), e.createElement("path", {
    d: "M8 4c1.236 -.623 2.569 -1 4 -1c4.97 0 9 3.582 9 8c0 1.06 -.474 2.078 -1.318 2.828a4.516 4.516 0 0 1 -1.127 .73"
  }), e.createElement("circle", {
    cx: 8.5,
    cy: 10.5,
    r: 1
  }), e.createElement("circle", {
    cx: 12.5,
    cy: 7.5,
    r: 1
  }), e.createElement("circle", {
    cx: 16.5,
    cy: 10.5,
    r: 1
  }), e.createElement("path", {
    d: "M3 3l18 18"
  }));
}
var Ape = ["size", "color", "stroke"];
function Dpe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Ape);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-palette",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M12 21a9 9 0 0 1 0 -18c4.97 0 9 3.582 9 8c0 1.06 -.474 2.078 -1.318 2.828c-.844 .75 -1.989 1.172 -3.182 1.172h-2.5a2 2 0 0 0 -1 3.75a1.3 1.3 0 0 1 -1 2.25"
  }), e.createElement("circle", {
    cx: 8.5,
    cy: 10.5,
    r: 1
  }), e.createElement("circle", {
    cx: 12.5,
    cy: 7.5,
    r: 1
  }), e.createElement("circle", {
    cx: 16.5,
    cy: 10.5,
    r: 1
  }));
}
var Fpe = ["size", "color", "stroke"];
function Gpe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Fpe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-panorama-horizontal-off",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M10.95 6.952c2.901 .15 5.803 -.323 8.705 -1.42a1 1 0 0 1 1.345 .934v10.534m-3.212 .806c-4.483 -1.281 -8.966 -1.074 -13.449 .622a0.993 .993 0 0 1 -1.339 -.935v-11.027a1 1 0 0 1 1.338 -.935c.588 .221 1.176 .418 1.764 .59"
  }), e.createElement("path", {
    d: "M3 3l18 18"
  }));
}
var Jpe = ["size", "color", "stroke"];
function Kpe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Jpe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-panorama-horizontal",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M4.338 5.53c5.106 1.932 10.211 1.932 15.317 .002a1 1 0 0 1 1.345 .934v11c0 .692 -.692 1.2 -1.34 .962c-5.107 -1.932 -10.214 -1.932 -15.321 0c-.648 .246 -1.339 -.242 -1.339 -.935v-11.027a1 1 0 0 1 1.338 -.935z"
  }));
}
var Qpe = ["size", "color", "stroke"];
function Rpe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Qpe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-panorama-vertical-off",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M7 3h10.53c.693 0 1.18 .691 .935 1.338c-1.098 2.898 -1.573 5.795 -1.425 8.692m.828 4.847c.172 .592 .37 1.185 .595 1.778a1 1 0 0 1 -.934 1.345h-11c-.692 0 -1.208 -.692 -.962 -1.34c1.697 -4.486 1.903 -8.973 .619 -13.46"
  }), e.createElement("path", {
    d: "M3 3l18 18"
  }));
}
var Tpe = ["size", "color", "stroke"];
function Upe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Tpe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-panorama-vertical",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M18.463 4.338c-1.932 5.106 -1.932 10.211 0 15.317a1 1 0 0 1 -.934 1.345h-11c-.692 0 -1.208 -.692 -.962 -1.34c1.932 -5.107 1.932 -10.214 0 -15.321c-.246 -.648 .243 -1.339 .935 -1.339h11.028c.693 0 1.18 .691 .935 1.338z"
  }));
}
var Vpe = ["size", "color", "stroke"];
function Xpe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Vpe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-paper-bag-off",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M7.158 3.185c.256 -.119 .542 -.185 .842 -.185h8a2 2 0 0 1 2 2v1.82a5 5 0 0 0 .528 2.236l.944 1.888a5 5 0 0 1 .528 2.236v2.82m-.177 3.824a2 2 0 0 1 -1.823 1.176h-12a2 2 0 0 1 -2 -2v-5.82a5 5 0 0 1 .528 -2.236l1.472 -2.944v-2"
  }), e.createElement("path", {
    d: "M13.185 13.173a2 2 0 1 0 2.64 2.647"
  }), e.createElement("path", {
    d: "M6 21a2 2 0 0 0 2 -2v-5.82a5 5 0 0 0 -.528 -2.236l-1.472 -2.944"
  }), e.createElement("path", {
    d: "M11 7h2"
  }), e.createElement("path", {
    d: "M3 3l18 18"
  }));
}
var Ype = ["size", "color", "stroke"];
function Zpe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Ype);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-paper-bag",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M8 3h8a2 2 0 0 1 2 2v1.82a5 5 0 0 0 .528 2.236l.944 1.888a5 5 0 0 1 .528 2.236v5.82a2 2 0 0 1 -2 2h-12a2 2 0 0 1 -2 -2v-5.82a5 5 0 0 1 .528 -2.236l1.472 -2.944v-3a2 2 0 0 1 2 -2z"
  }), e.createElement("circle", {
    cx: 14,
    cy: 15,
    r: 2
  }), e.createElement("path", {
    d: "M6 21a2 2 0 0 0 2 -2v-5.82a5 5 0 0 0 -.528 -2.236l-1.472 -2.944"
  }), e.createElement("path", {
    d: "M11 7h2"
  }));
}
var $pe = ["size", "color", "stroke"];
function _pe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, $pe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-paperclip",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M15 7l-6.5 6.5a1.5 1.5 0 0 0 3 3l6.5 -6.5a3 3 0 0 0 -6 -6l-6.5 6.5a4.5 4.5 0 0 0 9 9l6.5 -6.5"
  }));
}
var eEe = ["size", "color", "stroke"];
function tEe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, eEe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-parachute-off",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M22 12c0 -5.523 -4.477 -10 -10 -10c-1.737 0 -3.37 .443 -4.794 1.222m-2.28 1.71a9.969 9.969 0 0 0 -2.926 7.068"
  }), e.createElement("path", {
    d: "M22 12c0 -1.66 -1.46 -3 -3.25 -3c-1.63 0 -2.973 1.099 -3.212 2.54m-.097 -.09c-.23 -1.067 -1.12 -1.935 -2.29 -2.284m-3.445 .568c-.739 .55 -1.206 1.36 -1.206 2.266c0 -1.66 -1.46 -3 -3.25 -3c-1.8 0 -3.25 1.34 -3.25 3"
  }), e.createElement("path", {
    d: "M2 12l10 10l-3.5 -10"
  }), e.createElement("path", {
    d: "M14.582 14.624l-2.582 7.376l4.992 -4.992m2.014 -2.014l2.994 -2.994"
  }), e.createElement("path", {
    d: "M3 3l18 18"
  }));
}
var oEe = ["size", "color", "stroke"];
function rEe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, oEe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-parachute",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M22 12a10 10 0 1 0 -20 0"
  }), e.createElement("path", {
    d: "M22 12c0 -1.66 -1.46 -3 -3.25 -3c-1.8 0 -3.25 1.34 -3.25 3c0 -1.66 -1.57 -3 -3.5 -3s-3.5 1.34 -3.5 3c0 -1.66 -1.46 -3 -3.25 -3c-1.8 0 -3.25 1.34 -3.25 3"
  }), e.createElement("path", {
    d: "M2 12l10 10l-3.5 -10"
  }), e.createElement("path", {
    d: "M15.5 12l-3.5 10l10 -10"
  }));
}
var nEe = ["size", "color", "stroke"];
function lEe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, nEe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-parentheses-off",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M5.743 5.745a12.253 12.253 0 0 0 1.257 14.255"
  }), e.createElement("path", {
    d: "M17 4a12.25 12.25 0 0 1 2.474 11.467m-1.22 2.794a12.291 12.291 0 0 1 -1.254 1.739"
  }), e.createElement("path", {
    d: "M3 3l18 18"
  }));
}
var aEe = ["size", "color", "stroke"];
function iEe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, aEe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-parentheses",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M7 4a12.25 12.25 0 0 0 0 16"
  }), e.createElement("path", {
    d: "M17 4a12.25 12.25 0 0 1 0 16"
  }));
}
var cEe = ["size", "color", "stroke"];
function sEe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, cEe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-parking-off",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M8 4h10a2 2 0 0 1 2 2v10m-.582 3.41c-.362 .365 -.864 .59 -1.418 .59h-12a2 2 0 0 1 -2 -2v-12c0 -.554 .225 -1.056 .59 -1.418"
  }), e.createElement("path", {
    d: "M9 16v-7m3 -1h1a2 2 0 0 1 1.817 2.836m-2.817 1.164h-3"
  }), e.createElement("path", {
    d: "M3 3l18 18"
  }));
}
var hEe = ["size", "color", "stroke"];
function dEe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, hEe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-parking",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("rect", {
    x: 4,
    y: 4,
    width: 16,
    height: 16,
    rx: 2
  }), e.createElement("path", {
    d: "M9 16v-8h4a2 2 0 0 1 0 4h-4"
  }));
}
var vEe = ["size", "color", "stroke"];
function mEe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, vEe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-password",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M12 10v4"
  }), e.createElement("path", {
    d: "M10 13l4 -2"
  }), e.createElement("path", {
    d: "M10 11l4 2"
  }), e.createElement("path", {
    d: "M5 10v4"
  }), e.createElement("path", {
    d: "M3 13l4 -2"
  }), e.createElement("path", {
    d: "M3 11l4 2"
  }), e.createElement("path", {
    d: "M19 10v4"
  }), e.createElement("path", {
    d: "M17 13l4 -2"
  }), e.createElement("path", {
    d: "M17 11l4 2"
  }));
}
var kEe = ["size", "color", "stroke"];
function wEe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, kEe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-paw-off",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M11.168 11.154c-.71 .31 -1.184 1.107 -2.004 2.593c-.942 1.703 -2.846 1.845 -3.321 3.291c-.097 .265 -.145 .677 -.143 .962c0 1.176 .787 2 1.8 2c1.259 0 3.004 -1 4.5 -1s3.241 1 4.5 1c.927 0 1.664 -.689 1.783 -1.708"
  }), e.createElement("path", {
    d: "M20.188 8.082a1.039 1.039 0 0 0 -.406 -.082h-.015c-.735 .012 -1.56 .75 -1.993 1.866c-.519 1.335 -.28 2.7 .538 3.052c.129 .055 .267 .082 .406 .082c.739 0 1.575 -.742 2.011 -1.866c.516 -1.335 .273 -2.7 -.54 -3.052h-.001z"
  }), e.createElement("path", {
    d: "M10.997 6.992a3.608 3.608 0 0 0 -.04 -.725c-.203 -1.297 -1.047 -2.267 -1.932 -2.267a1.237 1.237 0 0 0 -.758 .265"
  }), e.createElement("path", {
    d: "M16.456 6.733c.214 -1.376 -.375 -2.594 -1.32 -2.722a1.164 1.164 0 0 0 -.162 -.011c-.885 0 -1.728 .97 -1.93 2.267c-.214 1.376 .375 2.594 1.32 2.722c.054 .007 .108 .011 .162 .011c.885 0 1.73 -.974 1.93 -2.267z"
  }), e.createElement("path", {
    d: "M5.69 12.918c.816 -.352 1.054 -1.719 .536 -3.052c-.436 -1.124 -1.271 -1.866 -2.009 -1.866c-.14 0 -.277 .027 -.407 .082c-.816 .352 -1.054 1.719 -.536 3.052c.436 1.124 1.271 1.866 2.009 1.866c.14 0 .277 -.027 .407 -.082z"
  }), e.createElement("path", {
    d: "M3 3l18 18"
  }));
}
var pEe = ["size", "color", "stroke"];
function EEe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, pEe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-paw",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M14.7 13.5c-1.1 -1.996 -1.441 -2.5 -2.7 -2.5c-1.259 0 -1.736 .755 -2.836 2.747c-.942 1.703 -2.846 1.845 -3.321 3.291c-.097 .265 -.145 .677 -.143 .962c0 1.176 .787 2 1.8 2c1.259 0 3.004 -1 4.5 -1s3.241 1 4.5 1c1.013 0 1.8 -.823 1.8 -2c0 -.285 -.049 -.697 -.146 -.962c-.475 -1.451 -2.512 -1.835 -3.454 -3.538z"
  }), e.createElement("path", {
    d: "M20.188 8.082a1.039 1.039 0 0 0 -.406 -.082h-.015c-.735 .012 -1.56 .75 -1.993 1.866c-.519 1.335 -.28 2.7 .538 3.052c.129 .055 .267 .082 .406 .082c.739 0 1.575 -.742 2.011 -1.866c.516 -1.335 .273 -2.7 -.54 -3.052z"
  }), e.createElement("path", {
    d: "M9.474 9c.055 0 .109 -.004 .163 -.011c.944 -.128 1.533 -1.346 1.32 -2.722c-.203 -1.297 -1.047 -2.267 -1.932 -2.267c-.055 0 -.109 .004 -.163 .011c-.944 .128 -1.533 1.346 -1.32 2.722c.204 1.293 1.048 2.267 1.933 2.267z"
  }), e.createElement("path", {
    d: "M16.456 6.733c.214 -1.376 -.375 -2.594 -1.32 -2.722a1.164 1.164 0 0 0 -.162 -.011c-.885 0 -1.728 .97 -1.93 2.267c-.214 1.376 .375 2.594 1.32 2.722c.054 .007 .108 .011 .162 .011c.885 0 1.73 -.974 1.93 -2.267z"
  }), e.createElement("path", {
    d: "M5.69 12.918c.816 -.352 1.054 -1.719 .536 -3.052c-.436 -1.124 -1.271 -1.866 -2.009 -1.866c-.14 0 -.277 .027 -.407 .082c-.816 .352 -1.054 1.719 -.536 3.052c.436 1.124 1.271 1.866 2.009 1.866c.14 0 .277 -.027 .407 -.082z"
  }));
}
var uEe = ["size", "color", "stroke"];
function gEe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, uEe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-peace",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 9
  }), e.createElement("line", {
    x1: 12,
    y1: 3,
    x2: 12,
    y2: 21
  }), e.createElement("line", {
    x1: 12,
    y1: 12,
    x2: 18.3,
    y2: 18.3
  }), e.createElement("line", {
    x1: 12,
    y1: 12,
    x2: 5.7,
    y2: 18.3
  }));
}
var MEe = ["size", "color", "stroke"];
function xEe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, MEe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-pencil-minus",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M8 20l10.5 -10.5a2.828 2.828 0 1 0 -4 -4l-10.5 10.5v4h4z"
  }), e.createElement("path", {
    d: "M13.5 6.5l4 4"
  }), e.createElement("path", {
    d: "M16 18h4"
  }));
}
var fEe = ["size", "color", "stroke"];
function zEe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, fEe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-pencil-off",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M10.003 9.997l-6.003 6.003v4h4l6.006 -6.006m1.99 -1.99l2.504 -2.504a2.828 2.828 0 1 0 -4 -4l-2.5 2.5"
  }), e.createElement("path", {
    d: "M13.5 6.5l4 4"
  }), e.createElement("path", {
    d: "M3 3l18 18"
  }));
}
var bEe = ["size", "color", "stroke"];
function LEe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, bEe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-pencil-plus",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M8 20l10.5 -10.5a2.828 2.828 0 1 0 -4 -4l-10.5 10.5v4h4z"
  }), e.createElement("path", {
    d: "M13.5 6.5l4 4"
  }), e.createElement("path", {
    d: "M16 18h4m-2 -2v4"
  }));
}
var yEe = ["size", "color", "stroke"];
function CEe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, yEe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-pencil",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M4 20h4l10.5 -10.5a1.5 1.5 0 0 0 -4 -4l-10.5 10.5v4"
  }), e.createElement("line", {
    x1: 13.5,
    y1: 6.5,
    x2: 17.5,
    y2: 10.5
  }));
}
var jEe = ["size", "color", "stroke"];
function BEe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, jEe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-pennant-2",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M16 21h-4"
  }), e.createElement("path", {
    d: "M14 21v-18"
  }), e.createElement("path", {
    d: "M14 4l-9 4l9 4"
  }));
}
var HEe = ["size", "color", "stroke"];
function NEe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, HEe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-pennant-off",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M8 21h4"
  }), e.createElement("path", {
    d: "M10 21v-11m0 -4v-3"
  }), e.createElement("path", {
    d: "M10 4l9 4l-4.858 2.16m-2.764 1.227l-1.378 .613"
  }), e.createElement("path", {
    d: "M3 3l18 18"
  }));
}
var WEe = ["size", "color", "stroke"];
function qEe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, WEe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-pennant",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("line", {
    x1: 8,
    y1: 21,
    x2: 12,
    y2: 21
  }), e.createElement("line", {
    x1: 10,
    y1: 21,
    x2: 10,
    y2: 3
  }), e.createElement("path", {
    d: "M10 4l9 4l-9 4"
  }));
}
var OEe = ["size", "color", "stroke"];
function PEe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, OEe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-pentagon-off",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M8.868 4.857l1.936 -1.457a2 2 0 0 1 2.397 -.006l7.032 5.237a2 2 0 0 1 .7 2.247l-1.522 4.485m-1.027 3.029l-.424 1.25a2 2 0 0 1 -1.894 1.358h-8.12a2 2 0 0 1 -1.9 -1.373l-2.896 -8.765a2 2 0 0 1 .696 -2.225l2.736 -2.06"
  }), e.createElement("path", {
    d: "M3 3l18 18"
  }));
}
var SEe = ["size", "color", "stroke"];
function IEe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, SEe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-pentagon",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M13.2 3.394l7.033 5.237a2 2 0 0 1 .7 2.247l-2.973 8.764a2 2 0 0 1 -1.894 1.358h-8.12a2 2 0 0 1 -1.9 -1.373l-2.896 -8.765a2 2 0 0 1 .696 -2.225l6.958 -5.237a2 2 0 0 1 2.397 -.006z"
  }));
}
var AEe = ["size", "color", "stroke"];
function DEe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, AEe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-pentagram",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M5.636 5.636a9 9 0 1 1 12.728 12.728a9 9 0 0 1 -12.728 -12.728z"
  }), e.createElement("path", {
    d: "M15.236 11l5.264 4h-6.5l-2 6l-2 -6h-6.5l5.276 -4l-2.056 -6.28l5.28 3.78l5.28 -3.78z"
  }));
}
var FEe = ["size", "color", "stroke"];
function GEe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, FEe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-pepper-off",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M12.59 12.59c-.77 1.418 -2.535 2.41 -4.59 2.41c-2.761 0 -5 -1.79 -5 -4a8 8 0 0 0 13.643 5.67m1.64 -2.357a7.97 7.97 0 0 0 .717 -3.313a3 3 0 0 0 -5.545 -1.59"
  }), e.createElement("path", {
    d: "M16 8c0 -2 2 -4 4 -4"
  }), e.createElement("path", {
    d: "M3 3l18 18"
  }));
}
var JEe = ["size", "color", "stroke"];
function KEe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, JEe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-pepper",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M13 11c0 2.21 -2.239 4 -5 4s-5 -1.79 -5 -4a8 8 0 1 0 16 0a3 3 0 0 0 -6 0"
  }), e.createElement("path", {
    d: "M16 8c0 -2 2 -4 4 -4"
  }));
}
var QEe = ["size", "color", "stroke"];
function REe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, QEe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-percentage",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("circle", {
    cx: 17,
    cy: 17,
    r: 1
  }), e.createElement("circle", {
    cx: 7,
    cy: 7,
    r: 1
  }), e.createElement("line", {
    x1: 6,
    y1: 18,
    x2: 18,
    y2: 6
  }));
}
var TEe = ["size", "color", "stroke"];
function UEe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, TEe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-perfume",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M10 6v3"
  }), e.createElement("path", {
    d: "M14 6v3"
  }), e.createElement("rect", {
    x: 5,
    y: 9,
    width: 14,
    height: 12,
    rx: 2
  }), e.createElement("circle", {
    cx: 12,
    cy: 15,
    r: 2
  }), e.createElement("path", {
    d: "M9 3h6v3h-6z"
  }));
}
var VEe = ["size", "color", "stroke"];
function XEe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, VEe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-perspective-off",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M8.511 4.502l9.63 1.375a1 1 0 0 1 .859 .99v8.133m-.859 3.123l-12 1.714a1 1 0 0 1 -1.141 -.99v-13.694a1 1 0 0 1 .01 -.137"
  }), e.createElement("path", {
    d: "M3 3l18 18"
  }));
}
var YEe = ["size", "color", "stroke"];
function ZEe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, YEe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-perspective",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M6.141 4.163l12 1.714a1 1 0 0 1 .859 .99v10.266a1 1 0 0 1 -.859 .99l-12 1.714a1 1 0 0 1 -1.141 -.99v-13.694a1 1 0 0 1 1.141 -.99z"
  }));
}
var $Ee = ["size", "color", "stroke"];
function _Ee(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, $Ee);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-phone-call",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M5 4h4l2 5l-2.5 1.5a11 11 0 0 0 5 5l1.5 -2.5l5 2v4a2 2 0 0 1 -2 2a16 16 0 0 1 -15 -15a2 2 0 0 1 2 -2"
  }), e.createElement("path", {
    d: "M15 7a2 2 0 0 1 2 2"
  }), e.createElement("path", {
    d: "M15 3a6 6 0 0 1 6 6"
  }));
}
var eue = ["size", "color", "stroke"];
function tue(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, eue);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-phone-calling",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M5 4h4l2 5l-2.5 1.5a11 11 0 0 0 5 5l1.5 -2.5l5 2v4a2 2 0 0 1 -2 2a16 16 0 0 1 -15 -15a2 2 0 0 1 2 -2"
  }), e.createElement("line", {
    x1: 15,
    y1: 7,
    x2: 15,
    y2: 7.01
  }), e.createElement("line", {
    x1: 18,
    y1: 7,
    x2: 18,
    y2: 7.01
  }), e.createElement("line", {
    x1: 21,
    y1: 7,
    x2: 21,
    y2: 7.01
  }));
}
var oue = ["size", "color", "stroke"];
function rue(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, oue);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-phone-check",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M5 4h4l2 5l-2.5 1.5a11 11 0 0 0 5 5l1.5 -2.5l5 2v4a2 2 0 0 1 -2 2a16 16 0 0 1 -15 -15a2 2 0 0 1 2 -2"
  }), e.createElement("path", {
    d: "M15 6l2 2l4 -4"
  }));
}
var nue = ["size", "color", "stroke"];
function lue(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, nue);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-phone-incoming",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M5 4h4l2 5l-2.5 1.5a11 11 0 0 0 5 5l1.5 -2.5l5 2v4a2 2 0 0 1 -2 2a16 16 0 0 1 -15 -15a2 2 0 0 1 2 -2"
  }), e.createElement("line", {
    x1: 15,
    y1: 9,
    x2: 20,
    y2: 4
  }), e.createElement("polyline", {
    points: "15 5 15 9 19 9"
  }));
}
var aue = ["size", "color", "stroke"];
function iue(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, aue);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-phone-off",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("line", {
    x1: 3,
    y1: 21,
    x2: 21,
    y2: 3
  }), e.createElement("path", {
    d: "M5.831 14.161a15.946 15.946 0 0 1 -2.831 -8.161a2 2 0 0 1 2 -2h4l2 5l-2.5 1.5c.108 .22 .223 .435 .345 .645m1.751 2.277c.843 .84 1.822 1.544 2.904 2.078l1.5 -2.5l5 2v4a2 2 0 0 1 -2 2a15.963 15.963 0 0 1 -10.344 -4.657"
  }));
}
var cue = ["size", "color", "stroke"];
function sue(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, cue);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-phone-outgoing",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M5 4h4l2 5l-2.5 1.5a11 11 0 0 0 5 5l1.5 -2.5l5 2v4a2 2 0 0 1 -2 2a16 16 0 0 1 -15 -15a2 2 0 0 1 2 -2"
  }), e.createElement("line", {
    x1: 15,
    y1: 9,
    x2: 20,
    y2: 4
  }), e.createElement("polyline", {
    points: "16 4 20 4 20 8"
  }));
}
var hue = ["size", "color", "stroke"];
function due(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, hue);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-phone-pause",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M5 4h4l2 5l-2.5 1.5a11 11 0 0 0 5 5l1.5 -2.5l5 2v4a2 2 0 0 1 -2 2a16 16 0 0 1 -15 -15a2 2 0 0 1 2 -2"
  }), e.createElement("line", {
    x1: 20,
    y1: 3,
    x2: 20,
    y2: 7
  }), e.createElement("line", {
    x1: 16,
    y1: 3,
    x2: 16,
    y2: 7
  }));
}
var vue = ["size", "color", "stroke"];
function mue(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, vue);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-phone-plus",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M5 4h4l2 5l-2.5 1.5a11 11 0 0 0 5 5l1.5 -2.5l5 2v4a2 2 0 0 1 -2 2a16 16 0 0 1 -15 -15a2 2 0 0 1 2 -2"
  }), e.createElement("path", {
    d: "M15 6h6m-3 -3v6"
  }));
}
var kue = ["size", "color", "stroke"];
function wue(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, kue);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-phone-x",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M5 4h4l2 5l-2.5 1.5a11 11 0 0 0 5 5l1.5 -2.5l5 2v4a2 2 0 0 1 -2 2a16 16 0 0 1 -15 -15a2 2 0 0 1 2 -2"
  }), e.createElement("path", {
    d: "M16 4l4 4m0 -4l-4 4"
  }));
}
var pue = ["size", "color", "stroke"];
function Eue(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, pue);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-phone",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M5 4h4l2 5l-2.5 1.5a11 11 0 0 0 5 5l1.5 -2.5l5 2v4a2 2 0 0 1 -2 2a16 16 0 0 1 -15 -15a2 2 0 0 1 2 -2"
  }));
}
var uue = ["size", "color", "stroke"];
function gue(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, uue);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-photo-cancel",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M15 8h.01"
  }), e.createElement("path", {
    d: "M12 20h-5a3 3 0 0 1 -3 -3v-10a3 3 0 0 1 3 -3h10a3 3 0 0 1 3 3v5"
  }), e.createElement("path", {
    d: "M4 15l4 -4c.928 -.893 2.072 -.893 3 0l3 3"
  }), e.createElement("path", {
    d: "M14 14l1 -1c.553 -.532 1.182 -.747 1.796 -.645"
  }), e.createElement("circle", {
    cx: 19,
    cy: 19,
    r: 3
  }), e.createElement("path", {
    d: "M17 21l4 -4"
  }));
}
var Mue = ["size", "color", "stroke"];
function xue(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Mue);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-photo-check",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M15 8h.01"
  }), e.createElement("path", {
    d: "M11 20h-4a3 3 0 0 1 -3 -3v-10a3 3 0 0 1 3 -3h10a3 3 0 0 1 3 3v6"
  }), e.createElement("path", {
    d: "M4 15l4 -4c.928 -.893 2.072 -.893 3 0l4 4"
  }), e.createElement("path", {
    d: "M14 14l1 -1c.928 -.893 2.072 -.893 3 0"
  }), e.createElement("path", {
    d: "M15 19l2 2l4 -4"
  }));
}
var fue = ["size", "color", "stroke"];
function zue(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, fue);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-photo-down",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M15 8h.01"
  }), e.createElement("path", {
    d: "M12 20h-5a3 3 0 0 1 -3 -3v-10a3 3 0 0 1 3 -3h10a3 3 0 0 1 3 3v5"
  }), e.createElement("path", {
    d: "M4 15l4 -4c.928 -.893 2.072 -.893 3 0l4 4"
  }), e.createElement("path", {
    d: "M14 14l1 -1c.617 -.593 1.328 -.793 2.009 -.598"
  }), e.createElement("path", {
    d: "M19 16v6"
  }), e.createElement("path", {
    d: "M22 19l-3 3l-3 -3"
  }));
}
var bue = ["size", "color", "stroke"];
function Lue(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, bue);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-photo-edit",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M15 8h.01"
  }), e.createElement("path", {
    d: "M11 20h-4a3 3 0 0 1 -3 -3v-10a3 3 0 0 1 3 -3h10a3 3 0 0 1 3 3v4"
  }), e.createElement("path", {
    d: "M4 15l4 -4c.928 -.893 2.072 -.893 3 0l3 3"
  }), e.createElement("path", {
    d: "M14 14l1 -1c.31 -.298 .644 -.497 .987 -.596"
  }), e.createElement("path", {
    d: "M18.42 15.61a2.1 2.1 0 0 1 2.97 2.97l-3.39 3.42h-3v-3l3.42 -3.39z"
  }));
}
var yue = ["size", "color", "stroke"];
function Cue(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, yue);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-photo-heart",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M15 8h.01"
  }), e.createElement("path", {
    d: "M12.5 20h-5.5a3 3 0 0 1 -3 -3v-10a3 3 0 0 1 3 -3h10a3 3 0 0 1 3 3v5"
  }), e.createElement("path", {
    d: "M4 15l4 -4c.928 -.893 2.072 -.893 3 0l2.5 2.5"
  }), e.createElement("path", {
    d: "M18.994 21.5l2.518 -2.58a1.74 1.74 0 0 0 .004 -2.413a1.627 1.627 0 0 0 -2.346 -.005l-.168 .172l-.168 -.172a1.627 1.627 0 0 0 -2.346 -.004a1.74 1.74 0 0 0 -.004 2.412l2.51 2.59z"
  }));
}
var jue = ["size", "color", "stroke"];
function Bue(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, jue);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-photo-minus",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M15 8h.01"
  }), e.createElement("path", {
    d: "M12 20h-5a3 3 0 0 1 -3 -3v-10a3 3 0 0 1 3 -3h10a3 3 0 0 1 3 3v8"
  }), e.createElement("path", {
    d: "M4 15l4 -4c.928 -.893 2.072 -.893 3 0l4 4"
  }), e.createElement("path", {
    d: "M14 14l1 -1c.928 -.893 2.072 -.893 3 0l2 2"
  }), e.createElement("path", {
    d: "M16 19h6"
  }));
}
var Hue = ["size", "color", "stroke"];
function Nue(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Hue);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-photo-off",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("line", {
    x1: 3,
    y1: 3,
    x2: 21,
    y2: 21
  }), e.createElement("line", {
    x1: 15,
    y1: 8,
    x2: 15.01,
    y2: 8
  }), e.createElement("path", {
    d: "M19.121 19.122a3 3 0 0 1 -2.121 .878h-10a3 3 0 0 1 -3 -3v-10c0 -.833 .34 -1.587 .888 -2.131m3.112 -.869h9a3 3 0 0 1 3 3v9"
  }), e.createElement("path", {
    d: "M4 15l4 -4c.928 -.893 2.072 -.893 3 0l5 5"
  }), e.createElement("path", {
    d: "M16.32 12.34c.577 -.059 1.162 .162 1.68 .66l2 2"
  }));
}
var Wue = ["size", "color", "stroke"];
function que(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Wue);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-photo-plus",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M15 8h.01"
  }), e.createElement("path", {
    d: "M12 20h-5a3 3 0 0 1 -3 -3v-10a3 3 0 0 1 3 -3h10a3 3 0 0 1 3 3v5"
  }), e.createElement("path", {
    d: "M4 15l4 -4c.928 -.893 2.072 -.893 3 0l4 4"
  }), e.createElement("path", {
    d: "M14 14l1 -1c.617 -.593 1.328 -.793 2.009 -.598"
  }), e.createElement("path", {
    d: "M16 19h6"
  }), e.createElement("path", {
    d: "M19 16v6"
  }));
}
var Oue = ["size", "color", "stroke"];
function Pue(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Oue);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-photo-search",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M15 8h.01"
  }), e.createElement("path", {
    d: "M12 20h-5a3 3 0 0 1 -3 -3v-10a3 3 0 0 1 3 -3h10a3 3 0 0 1 3 3v4.5"
  }), e.createElement("path", {
    d: "M4 15l4 -4c.928 -.893 2.072 -.893 3 0l2 2"
  }), e.createElement("circle", {
    cx: 18,
    cy: 18,
    r: 3
  }), e.createElement("path", {
    d: "M20.2 20.2l1.8 1.8"
  }));
}
var Sue = ["size", "color", "stroke"];
function Iue(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Sue);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-photo-shield",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M15 8h.01"
  }), e.createElement("path", {
    d: "M11.5 20h-4.5a3 3 0 0 1 -3 -3v-10a3 3 0 0 1 3 -3h10a3 3 0 0 1 3 3v4"
  }), e.createElement("path", {
    d: "M4 15l4 -4c.928 -.893 2.072 -.893 3 0l1.5 1.5"
  }), e.createElement("path", {
    d: "M22 16c0 4 -2.5 6 -3.5 6s-3.5 -2 -3.5 -6c1 0 2.5 -.5 3.5 -1.5c1 1 2.5 1.5 3.5 1.5z"
  }));
}
var Aue = ["size", "color", "stroke"];
function Due(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Aue);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-photo-star",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M15 8h.01"
  }), e.createElement("path", {
    d: "M11 20h-4a3 3 0 0 1 -3 -3v-10a3 3 0 0 1 3 -3h10a3 3 0 0 1 3 3v3.5"
  }), e.createElement("path", {
    d: "M4 15l4 -4c.928 -.893 2.072 -.893 3 0l2 2"
  }), e.createElement("path", {
    d: "M17.8 20.817l-2.172 1.138a0.392 .392 0 0 1 -.568 -.41l.415 -2.411l-1.757 -1.707a0.389 .389 0 0 1 .217 -.665l2.428 -.352l1.086 -2.193a0.392 .392 0 0 1 .702 0l1.086 2.193l2.428 .352a0.39 .39 0 0 1 .217 .665l-1.757 1.707l.414 2.41a0.39 .39 0 0 1 -.567 .411l-2.172 -1.138z"
  }));
}
var Fue = ["size", "color", "stroke"];
function Gue(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Fue);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-photo-up",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M15 8h.01"
  }), e.createElement("path", {
    d: "M12 20h-5a3 3 0 0 1 -3 -3v-10a3 3 0 0 1 3 -3h10a3 3 0 0 1 3 3v5"
  }), e.createElement("path", {
    d: "M4 15l4 -4c.928 -.893 2.072 -.893 3 0l4 4"
  }), e.createElement("path", {
    d: "M14 14l1 -1c.617 -.593 1.328 -.793 2.009 -.598"
  }), e.createElement("path", {
    d: "M19 22v-6"
  }), e.createElement("path", {
    d: "M22 19l-3 -3l-3 3"
  }));
}
var Jue = ["size", "color", "stroke"];
function Kue(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Jue);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-photo-x",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M15 8h.01"
  }), e.createElement("path", {
    d: "M13 20h-6a3 3 0 0 1 -3 -3v-10a3 3 0 0 1 3 -3h10a3 3 0 0 1 3 3v6"
  }), e.createElement("path", {
    d: "M4 15l4 -4c.928 -.893 2.072 -.893 3 0l2.5 2.5"
  }), e.createElement("path", {
    d: "M21.5 21.5l-5 -5"
  }), e.createElement("path", {
    d: "M16.5 21.5l5 -5"
  }));
}
var Que = ["size", "color", "stroke"];
function Rue(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Que);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-photo",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("line", {
    x1: 15,
    y1: 8,
    x2: 15.01,
    y2: 8
  }), e.createElement("rect", {
    x: 4,
    y: 4,
    width: 16,
    height: 16,
    rx: 3
  }), e.createElement("path", {
    d: "M4 15l4 -4a3 5 0 0 1 3 0l5 5"
  }), e.createElement("path", {
    d: "M14 14l1 -1a3 5 0 0 1 3 0l2 2"
  }));
}
var Tue = ["size", "color", "stroke"];
function Uue(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Tue);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-physotherapist",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M9 15l-1 -3l4 -2l4 1h3.5"
  }), e.createElement("circle", {
    cx: 4,
    cy: 19,
    r: 1
  }), e.createElement("circle", {
    cx: 12,
    cy: 6,
    r: 1
  }), e.createElement("path", {
    d: "M12 17v-7"
  }), e.createElement("path", {
    d: "M8 20h7l1 -4l4 -2"
  }), e.createElement("path", {
    d: "M18 20h3"
  }));
}
var Vue = ["size", "color", "stroke"];
function Xue(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Vue);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-picture-in-picture-off",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M11 19h-6a2 2 0 0 1 -2 -2v-10a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v4"
  }), e.createElement("rect", {
    x: 14,
    y: 14,
    width: 7,
    height: 5,
    rx: 1
  }), e.createElement("line", {
    x1: 7,
    y1: 9,
    x2: 11,
    y2: 13
  }), e.createElement("path", {
    d: "M7 12v-3h3"
  }));
}
var Yue = ["size", "color", "stroke"];
function Zue(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Yue);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-picture-in-picture-on",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M11 19h-6a2 2 0 0 1 -2 -2v-10a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v4"
  }), e.createElement("rect", {
    x: 14,
    y: 14,
    width: 7,
    height: 5,
    rx: 1
  }), e.createElement("line", {
    x1: 7,
    y1: 9,
    x2: 11,
    y2: 13
  }), e.createElement("path", {
    d: "M8 13h3v-3"
  }));
}
var $ue = ["size", "color", "stroke"];
function _ue(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, $ue);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-picture-in-picture-top",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M11 5h-6a2 2 0 0 0 -2 2v10a2 2 0 0 0 2 2h14a2 2 0 0 0 2 -2v-4"
  }), e.createElement("path", {
    d: "M15 10h5a1 1 0 0 0 1 -1v-3a1 1 0 0 0 -1 -1h-5a1 1 0 0 0 -1 1v3a1 1 0 0 0 1 1z"
  }));
}
var ege = ["size", "color", "stroke"];
function tge(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, ege);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-picture-in-picture",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M11 19h-6a2 2 0 0 1 -2 -2v-10a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v4"
  }), e.createElement("rect", {
    x: 14,
    y: 14,
    width: 7,
    height: 5,
    rx: 1
  }));
}
var oge = ["size", "color", "stroke"];
function rge(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, oge);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-pig-money",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M15 11v.01"
  }), e.createElement("path", {
    d: "M5.173 8.378a3 3 0 1 1 4.656 -1.377"
  }), e.createElement("path", {
    d: "M16 4v3.803a6.019 6.019 0 0 1 2.658 3.197h1.341a1 1 0 0 1 1 1v2a1 1 0 0 1 -1 1h-1.342c-.336 .95 -.907 1.8 -1.658 2.473v2.027a1.5 1.5 0 0 1 -3 0v-.583a6.04 6.04 0 0 1 -1 .083h-4a6.04 6.04 0 0 1 -1 -.083v.583a1.5 1.5 0 0 1 -3 0v-2l.001 -.027a6 6 0 0 1 3.999 -10.473h2.5l4.5 -3h.001z"
  }));
}
var nge = ["size", "color", "stroke"];
function lge(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, nge);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-pig-off",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M15 11v.01"
  }), e.createElement("path", {
    d: "M10 6h1.499l4.5 -3l.001 3.803a6.019 6.019 0 0 1 2.658 3.197h1.341a1 1 0 0 1 1 1v2a1 1 0 0 1 -1 1h-1.342c-.057 .16 -.12 .318 -.19 .472m-1.467 2.528v1.5a1.5 1.5 0 0 1 -3 0v-.583a6.04 6.04 0 0 1 -1 .083h-4a6.04 6.04 0 0 1 -1 -.083v.583a1.5 1.5 0 0 1 -3 0v-2l0 -.027a6 6 0 0 1 1.5 -9.928"
  }), e.createElement("path", {
    d: "M3 3l18 18"
  }));
}
var age = ["size", "color", "stroke"];
function ige(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, age);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-pig",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M15 11v.01"
  }), e.createElement("path", {
    d: "M16 3l0 3.803a6.019 6.019 0 0 1 2.658 3.197h1.341a1 1 0 0 1 1 1v2a1 1 0 0 1 -1 1h-1.342a6.008 6.008 0 0 1 -1.658 2.473v2.027a1.5 1.5 0 0 1 -3 0v-.583a6.04 6.04 0 0 1 -1 .083h-4a6.04 6.04 0 0 1 -1 -.083v.583a1.5 1.5 0 0 1 -3 0v-2l.001 -.027a6 6 0 0 1 3.999 -10.473h2.5l4.5 -3z"
  }));
}
var cge = ["size", "color", "stroke"];
function sge(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, cge);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-pilcrow",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M13 4v16"
  }), e.createElement("path", {
    d: "M17 4v16"
  }), e.createElement("path", {
    d: "M19 4h-9.5a4.5 4.5 0 0 0 0 9h3.5"
  }));
}
var hge = ["size", "color", "stroke"];
function dge(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, hge);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-pill-off",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M10.495 6.505l2.005 -2.005a4.95 4.95 0 0 1 7 7l-1.998 1.998m-2 2l-4.002 4.002a4.95 4.95 0 0 1 -7 -7l4 -4"
  }), e.createElement("path", {
    d: "M8.5 8.5l7 7"
  }), e.createElement("path", {
    d: "M3 3l18 18"
  }));
}
var vge = ["size", "color", "stroke"];
function mge(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, vge);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-pill",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M4.5 12.5l8 -8a4.94 4.94 0 0 1 7 7l-8 8a4.94 4.94 0 0 1 -7 -7"
  }), e.createElement("line", {
    x1: 8.5,
    y1: 8.5,
    x2: 15.5,
    y2: 15.5
  }));
}
var kge = ["size", "color", "stroke"];
function wge(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, kge);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-pills",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("circle", {
    cx: 8,
    cy: 8,
    r: 5
  }), e.createElement("circle", {
    cx: 17,
    cy: 17,
    r: 4
  }), e.createElement("path", {
    d: "M4.5 4.5l7 7"
  }), e.createElement("path", {
    d: "M19.5 14.5l-5 5"
  }));
}
var pge = ["size", "color", "stroke"];
function Ege(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, pge);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-pin",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M15 4.5l-4 4l-4 1.5l-1.5 1.5l7 7l1.5 -1.5l1.5 -4l4 -4"
  }), e.createElement("line", {
    x1: 9,
    y1: 15,
    x2: 4.5,
    y2: 19.5
  }), e.createElement("line", {
    x1: 14.5,
    y1: 4,
    x2: 20,
    y2: 9.5
  }));
}
var uge = ["size", "color", "stroke"];
function gge(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, uge);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-ping-pong",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M12.718 20.713a7.64 7.64 0 0 1 -7.48 -12.755l.72 -.72a7.643 7.643 0 0 1 9.105 -1.283l2.387 -2.345a2.08 2.08 0 0 1 3.057 2.815l-.116 .126l-2.346 2.387a7.644 7.644 0 0 1 -1.052 8.864"
  }), e.createElement("circle", {
    cx: 14,
    cy: 18,
    r: 3
  }), e.createElement("path", {
    d: "M9.3 5.3l9.4 9.4"
  }));
}
var Mge = ["size", "color", "stroke"];
function xge(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Mge);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-pinned-off",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("line", {
    x1: 3,
    y1: 3,
    x2: 21,
    y2: 21
  }), e.createElement("path", {
    d: "M15 4.5l-3.249 3.249m-2.57 1.433l-2.181 .818l-1.5 1.5l7 7l1.5 -1.5l.82 -2.186m1.43 -2.563l3.25 -3.251"
  }), e.createElement("line", {
    x1: 9,
    y1: 15,
    x2: 4.5,
    y2: 19.5
  }), e.createElement("line", {
    x1: 14.5,
    y1: 4,
    x2: 20,
    y2: 9.5
  }));
}
var fge = ["size", "color", "stroke"];
function zge(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, fge);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-pinned",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M9 4v6l-2 4v2h10v-2l-2 -4v-6"
  }), e.createElement("line", {
    x1: 12,
    y1: 16,
    x2: 12,
    y2: 21
  }), e.createElement("line", {
    x1: 8,
    y1: 4,
    x2: 16,
    y2: 4
  }));
}
var bge = ["size", "color", "stroke"];
function Lge(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, bge);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-pizza-off",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M10.313 6.277l1.687 -3.277l5.34 10.376m2.477 6.463a19.093 19.093 0 0 1 -7.817 1.661c-3.04 0 -5.952 -.714 -8.5 -1.983l5.434 -10.559"
  }), e.createElement("path", {
    d: "M5.38 15.866a14.94 14.94 0 0 0 6.815 1.634c1.56 .002 3.105 -.24 4.582 -.713"
  }), e.createElement("path", {
    d: "M11 14v-.01"
  }), e.createElement("path", {
    d: "M3 3l18 18"
  }));
}
var yge = ["size", "color", "stroke"];
function Cge(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, yge);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-pizza",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M12 21.5c-3.04 0 -5.952 -.714 -8.5 -1.983l8.5 -16.517l8.5 16.517a19.09 19.09 0 0 1 -8.5 1.983z"
  }), e.createElement("path", {
    d: "M5.38 15.866a14.94 14.94 0 0 0 6.815 1.634a14.944 14.944 0 0 0 6.502 -1.479"
  }), e.createElement("path", {
    d: "M13 11.01v-.01"
  }), e.createElement("path", {
    d: "M11 14v-.01"
  }));
}
var jge = ["size", "color", "stroke"];
function Bge(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, jge);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-placeholder",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M10 20.415a8 8 0 1 0 3 -15.415h-3"
  }), e.createElement("path", {
    d: "M13 8l-3 -3l3 -3"
  }), e.createElement("path", {
    d: "M7 17l4 -4l-4 -4l-4 4z"
  }));
}
var Hge = ["size", "color", "stroke"];
function Nge(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Hge);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-plane-arrival",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M15.157 11.81l4.83 1.295a2 2 0 1 1 -1.036 3.863l-14.489 -3.882l-1.345 -6.572l2.898 .776l1.414 2.45l2.898 .776l-.12 -7.279l2.898 .777l2.052 7.797z"
  }), e.createElement("path", {
    d: "M3 21h18"
  }));
}
var Wge = ["size", "color", "stroke"];
function qge(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Wge);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-plane-departure",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M14.639 10.258l4.83 -1.294a2 2 0 1 1 1.035 3.863l-14.489 3.883l-4.45 -5.02l2.897 -.776l2.45 1.414l2.897 -.776l-3.743 -6.244l2.898 -.777l5.675 5.727z"
  }), e.createElement("path", {
    d: "M3 21h18"
  }));
}
var Oge = ["size", "color", "stroke"];
function Pge(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Oge);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-plane-inflight",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M15 11.085h5a2 2 0 1 1 0 4h-15l-3 -6h3l2 2h3l-2 -7h3l4 7z"
  }), e.createElement("path", {
    d: "M3 21h18"
  }));
}
var Sge = ["size", "color", "stroke"];
function Ige(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Sge);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-plane-off",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M9.788 5.758l-.788 -2.758h3l4 7h4a2 2 0 1 1 0 4h-2m-2.718 1.256l-3.282 5.744h-3l2 -7h-4l-2 2h-3l2 -4l-2 -4h3l2 2h3"
  }), e.createElement("path", {
    d: "M3 3l18 18"
  }));
}
var Age = ["size", "color", "stroke"];
function Dge(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Age);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-plane-tilt",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M14.5 6.5l3 -2.9a2.05 2.05 0 0 1 2.9 2.9l-2.9 3l2.5 7.5l-2.5 2.55l-3.5 -6.55l-3 3v3l-2 2l-1.5 -4.5l-4.5 -1.5l2 -2h3l3 -3l-6.5 -3.5l2.5 -2.5l7.5 2.5z"
  }));
}
var Fge = ["size", "color", "stroke"];
function Gge(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Fge);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-plane",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M16 10h4a2 2 0 0 1 0 4h-4l-4 7h-3l2 -7h-4l-2 2h-3l2 -4l-2 -4h3l2 2h4l-2 -7h3z"
  }));
}
var Jge = ["size", "color", "stroke"];
function Kge(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Jge);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-planet-off",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M18.816 13.58c1.956 1.825 3.157 3.449 3.184 4.445m-3.428 .593c-2.098 -.634 -4.944 -2.03 -7.919 -3.976c-5.47 -3.579 -9.304 -7.664 -8.56 -9.123c.32 -.628 1.591 -.6 3.294 -.113"
  }), e.createElement("path", {
    d: "M7.042 7.059a7 7 0 0 0 9.908 9.89m1.581 -2.425a7 7 0 0 0 -9.057 -9.054"
  }), e.createElement("path", {
    d: "M3 3l18 18"
  }));
}
var Qge = ["size", "color", "stroke"];
function Rge(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Qge);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-planet",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M18.816 13.58c2.292 2.138 3.546 4 3.092 4.9c-.745 1.46 -5.783 -.259 -11.255 -3.838c-5.47 -3.579 -9.304 -7.664 -8.56 -9.123c.464 -.91 2.926 -.444 5.803 .805"
  }), e.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 7
  }));
}
var Tge = ["size", "color", "stroke"];
function Uge(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Tge);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-plant-2-off",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M2 9c0 5.523 4.477 10 10 10a9.953 9.953 0 0 0 5.418 -1.593m2.137 -1.855a9.961 9.961 0 0 0 2.445 -6.552"
  }), e.createElement("path", {
    d: "M12 19c0 -1.988 .58 -3.84 1.58 -5.397m1.878 -2.167a9.961 9.961 0 0 1 6.542 -2.436"
  }), e.createElement("path", {
    d: "M2 9a10 10 0 0 1 10 10"
  }), e.createElement("path", {
    d: "M12 4a9.7 9.7 0 0 1 3.002 7.013"
  }), e.createElement("path", {
    d: "M9.01 11.5a9.696 9.696 0 0 1 .163 -2.318m1.082 -2.942a9.696 9.696 0 0 1 1.745 -2.24"
  }), e.createElement("path", {
    d: "M3 3l18 18"
  }));
}
var Vge = ["size", "color", "stroke"];
function Xge(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Vge);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-plant-2",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M2 9a10 10 0 1 0 20 0"
  }), e.createElement("path", {
    d: "M12 19a10 10 0 0 1 10 -10"
  }), e.createElement("path", {
    d: "M2 9a10 10 0 0 1 10 10"
  }), e.createElement("path", {
    d: "M12 4a9.7 9.7 0 0 1 2.99 7.5"
  }), e.createElement("path", {
    d: "M9.01 11.5a9.7 9.7 0 0 1 2.99 -7.5"
  }));
}
var Yge = ["size", "color", "stroke"];
function Zge(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Yge);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-plant-off",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M17 17v2a2 2 0 0 1 -2 2h-6a2 2 0 0 1 -2 -2v-4h8"
  }), e.createElement("path", {
    d: "M11.9 7.908a6.006 6.006 0 0 0 -4.79 -4.806m-4.11 -.102v2a6 6 0 0 0 6 6h2"
  }), e.createElement("path", {
    d: "M12.531 8.528a6.001 6.001 0 0 1 5.469 -3.528h3v1a6.002 6.002 0 0 1 -5.037 5.923"
  }), e.createElement("path", {
    d: "M12 15v-3"
  }), e.createElement("path", {
    d: "M3 3l18 18"
  }));
}
var $ge = ["size", "color", "stroke"];
function _ge(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, $ge);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-plant",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M7 15h10v4a2 2 0 0 1 -2 2h-6a2 2 0 0 1 -2 -2v-4z"
  }), e.createElement("path", {
    d: "M12 9a6 6 0 0 0 -6 -6h-3v2a6 6 0 0 0 6 6h3"
  }), e.createElement("path", {
    d: "M12 11a6 6 0 0 1 6 -6h3v1a6 6 0 0 1 -6 6h-3"
  }), e.createElement("line", {
    x1: 12,
    y1: 15,
    x2: 12,
    y2: 9
  }));
}
var eMe = ["size", "color", "stroke"];
function tMe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, eMe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-play-card-off",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M7 3h10a2 2 0 0 1 2 2v10m0 4a2 2 0 0 1 -2 2h-10a2 2 0 0 1 -2 -2v-14"
  }), e.createElement("path", {
    d: "M16 18h.01"
  }), e.createElement("path", {
    d: "M13.716 13.712l-1.716 2.288l-3 -4l1.29 -1.72"
  }), e.createElement("path", {
    d: "M3 3l18 18"
  }));
}
var oMe = ["size", "color", "stroke"];
function rMe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, oMe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-play-card",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M19 5v14a2 2 0 0 1 -2 2h-10a2 2 0 0 1 -2 -2v-14a2 2 0 0 1 2 -2h10a2 2 0 0 1 2 2z"
  }), e.createElement("path", {
    d: "M8 6h.01"
  }), e.createElement("path", {
    d: "M16 18h.01"
  }), e.createElement("path", {
    d: "M12 16l-3 -4l3 -4l3 4z"
  }));
}
var nMe = ["size", "color", "stroke"];
function lMe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, nMe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-player-eject",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M5 12h14l-7 -8z"
  }), e.createElement("rect", {
    x: 5,
    y: 16,
    width: 14,
    height: 4,
    rx: 1
  }));
}
var aMe = ["size", "color", "stroke"];
function iMe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, aMe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-player-pause",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("rect", {
    x: 6,
    y: 5,
    width: 4,
    height: 14,
    rx: 1
  }), e.createElement("rect", {
    x: 14,
    y: 5,
    width: 4,
    height: 14,
    rx: 1
  }));
}
var cMe = ["size", "color", "stroke"];
function sMe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, cMe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-player-play",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M7 4v16l13 -8z"
  }));
}
var hMe = ["size", "color", "stroke"];
function dMe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, hMe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-player-record",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 7
  }));
}
var vMe = ["size", "color", "stroke"];
function mMe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, vMe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-player-skip-back",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M20 5v14l-12 -7z"
  }), e.createElement("line", {
    x1: 4,
    y1: 5,
    x2: 4,
    y2: 19
  }));
}
var kMe = ["size", "color", "stroke"];
function wMe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, kMe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-player-skip-forward",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M4 5v14l12 -7z"
  }), e.createElement("line", {
    x1: 20,
    y1: 5,
    x2: 20,
    y2: 19
  }));
}
var pMe = ["size", "color", "stroke"];
function EMe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, pMe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-player-stop",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("rect", {
    x: 5,
    y: 5,
    width: 14,
    height: 14,
    rx: 2
  }));
}
var uMe = ["size", "color", "stroke"];
function gMe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, uMe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-player-track-next",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M3 5v14l8 -7z"
  }), e.createElement("path", {
    d: "M14 5v14l8 -7z"
  }));
}
var MMe = ["size", "color", "stroke"];
function xMe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, MMe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-player-track-prev",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M21 5v14l-8 -7z"
  }), e.createElement("path", {
    d: "M10 5v14l-8 -7z"
  }));
}
var fMe = ["size", "color", "stroke"];
function zMe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, fMe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-playlist-add",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M19 8h-14"
  }), e.createElement("path", {
    d: "M5 12h9"
  }), e.createElement("path", {
    d: "M11 16h-6"
  }), e.createElement("path", {
    d: "M15 16h6"
  }), e.createElement("path", {
    d: "M18 13v6"
  }));
}
var bMe = ["size", "color", "stroke"];
function LMe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, bMe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-playlist-off",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M14 14a3 3 0 1 0 3 3"
  }), e.createElement("path", {
    d: "M17 13v-9h4"
  }), e.createElement("path", {
    d: "M13 5h-4m-4 0h-2"
  }), e.createElement("path", {
    d: "M3 9h6"
  }), e.createElement("path", {
    d: "M9 13h-6"
  }), e.createElement("path", {
    d: "M3 3l18 18"
  }));
}
var yMe = ["size", "color", "stroke"];
function CMe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, yMe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-playlist-x",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M19 8h-14"
  }), e.createElement("path", {
    d: "M5 12h7"
  }), e.createElement("path", {
    d: "M12 16h-7"
  }), e.createElement("path", {
    d: "M16 14l4 4"
  }), e.createElement("path", {
    d: "M20 14l-4 4"
  }));
}
var jMe = ["size", "color", "stroke"];
function BMe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, jMe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-playlist",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("circle", {
    cx: 14,
    cy: 17,
    r: 3
  }), e.createElement("path", {
    d: "M17 17v-13h4"
  }), e.createElement("path", {
    d: "M13 5h-10"
  }), e.createElement("line", {
    x1: 3,
    y1: 9,
    x2: 13,
    y2: 9
  }), e.createElement("path", {
    d: "M9 13h-6"
  }));
}
var HMe = ["size", "color", "stroke"];
function NMe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, HMe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-playstation-circle",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M12 21a9 9 0 0 0 9 -9a9 9 0 0 0 -9 -9a9 9 0 0 0 -9 9a9 9 0 0 0 9 9z"
  }), e.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 4.5
  }));
}
var WMe = ["size", "color", "stroke"];
function qMe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, WMe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-playstation-square",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M12 21a9 9 0 0 0 9 -9a9 9 0 0 0 -9 -9a9 9 0 0 0 -9 9a9 9 0 0 0 9 9z"
  }), e.createElement("rect", {
    x: 8,
    y: 8,
    width: 8,
    height: 8,
    rx: 1
  }));
}
var OMe = ["size", "color", "stroke"];
function PMe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, OMe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-playstation-triangle",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M12 21a9 9 0 0 0 9 -9a9 9 0 0 0 -9 -9a9 9 0 0 0 -9 9a9 9 0 0 0 9 9z"
  }), e.createElement("path", {
    d: "M7.5 15h9l-4.5 -8z"
  }));
}
var SMe = ["size", "color", "stroke"];
function IMe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, SMe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-playstation-x",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M12 21a9 9 0 0 0 9 -9a9 9 0 0 0 -9 -9a9 9 0 0 0 -9 9a9 9 0 0 0 9 9z"
  }), e.createElement("path", {
    d: "M8.5 8.5l7 7"
  }), e.createElement("path", {
    d: "M8.5 15.5l7 -7"
  }));
}
var AMe = ["size", "color", "stroke"];
function DMe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, AMe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-plug-connected-x",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M20 16l-4 4"
  }), e.createElement("path", {
    d: "M7 12l5 5l-1.5 1.5a3.536 3.536 0 1 1 -5 -5l1.5 -1.5z"
  }), e.createElement("path", {
    d: "M17 12l-5 -5l1.5 -1.5a3.536 3.536 0 1 1 5 5l-1.5 1.5z"
  }), e.createElement("path", {
    d: "M3 21l2.5 -2.5"
  }), e.createElement("path", {
    d: "M18.5 5.5l2.5 -2.5"
  }), e.createElement("path", {
    d: "M10 11l-2 2"
  }), e.createElement("path", {
    d: "M13 14l-2 2"
  }), e.createElement("path", {
    d: "M16 16l4 4"
  }));
}
var FMe = ["size", "color", "stroke"];
function GMe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, FMe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-plug-connected",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M7 12l5 5l-1.5 1.5a3.536 3.536 0 1 1 -5 -5l1.5 -1.5z"
  }), e.createElement("path", {
    d: "M17 12l-5 -5l1.5 -1.5a3.536 3.536 0 1 1 5 5l-1.5 1.5z"
  }), e.createElement("path", {
    d: "M3 21l2.5 -2.5"
  }), e.createElement("path", {
    d: "M18.5 5.5l2.5 -2.5"
  }), e.createElement("path", {
    d: "M10 11l-2 2"
  }), e.createElement("path", {
    d: "M13 14l-2 2"
  }));
}
var JMe = ["size", "color", "stroke"];
function KMe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, JMe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-plug-off",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M16.123 16.092l-.177 .177a5.81 5.81 0 1 1 -8.215 -8.215l.159 -.159"
  }), e.createElement("path", {
    d: "M4 20l3.5 -3.5"
  }), e.createElement("path", {
    d: "M15 4l-3.5 3.5"
  }), e.createElement("path", {
    d: "M20 9l-3.5 3.5"
  }), e.createElement("path", {
    d: "M3 3l18 18"
  }));
}
var QMe = ["size", "color", "stroke"];
function RMe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, QMe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-plug-x",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M13.55 17.733a5.806 5.806 0 0 1 -7.356 -4.052a5.81 5.81 0 0 1 1.537 -5.627l2.054 -2.054l7.165 7.165"
  }), e.createElement("path", {
    d: "M4 20l3.5 -3.5"
  }), e.createElement("path", {
    d: "M15 4l-3.5 3.5"
  }), e.createElement("path", {
    d: "M20 9l-3.5 3.5"
  }), e.createElement("path", {
    d: "M16 16l4 4"
  }), e.createElement("path", {
    d: "M20 16l-4 4"
  }));
}
var TMe = ["size", "color", "stroke"];
function UMe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, TMe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-plug",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M9.785 6l8.215 8.215l-2.054 2.054a5.81 5.81 0 1 1 -8.215 -8.215l2.054 -2.054z"
  }), e.createElement("path", {
    d: "M4 20l3.5 -3.5"
  }), e.createElement("path", {
    d: "M15 4l-3.5 3.5"
  }), e.createElement("path", {
    d: "M20 9l-3.5 3.5"
  }));
}
var VMe = ["size", "color", "stroke"];
function XMe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, VMe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-plus",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("line", {
    x1: 12,
    y1: 5,
    x2: 12,
    y2: 19
  }), e.createElement("line", {
    x1: 5,
    y1: 12,
    x2: 19,
    y2: 12
  }));
}
var YMe = ["size", "color", "stroke"];
function ZMe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, YMe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-png",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M21 8h-2a2 2 0 0 0 -2 2v4a2 2 0 0 0 2 2h2v-4h-1"
  }), e.createElement("path", {
    d: "M3 16v-8h2a2 2 0 1 1 0 4h-2"
  }), e.createElement("path", {
    d: "M10 16v-8l4 8v-8"
  }));
}
var $Me = ["size", "color", "stroke"];
function _Me(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, $Me);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-podium-off",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M12 8h7l-.621 2.485a2 2 0 0 1 -1.94 1.515h-.439m-4 0h-4.439a2 2 0 0 1 -1.94 -1.515l-.621 -2.485h3"
  }), e.createElement("path", {
    d: "M7 8v-1m.864 -3.106a2.99 2.99 0 0 1 2.136 -.894"
  }), e.createElement("path", {
    d: "M8 12l1 9"
  }), e.createElement("path", {
    d: "M15.599 15.613l-.599 5.387"
  }), e.createElement("path", {
    d: "M7 21h10"
  }), e.createElement("path", {
    d: "M3 3l18 18"
  }));
}
var exe = ["size", "color", "stroke"];
function txe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, exe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-podium",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M5 8h14l-.621 2.485a2 2 0 0 1 -1.94 1.515h-8.878a2 2 0 0 1 -1.94 -1.515l-.621 -2.485z"
  }), e.createElement("path", {
    d: "M7 8v-2a3 3 0 0 1 3 -3"
  }), e.createElement("path", {
    d: "M8 12l1 9"
  }), e.createElement("path", {
    d: "M16 12l-1 9"
  }), e.createElement("path", {
    d: "M7 21h10"
  }));
}
var oxe = ["size", "color", "stroke"];
function rxe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, oxe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-point-off",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M9.15 9.194a4 4 0 0 0 5.697 5.617m1.153 -2.811a4 4 0 0 0 -4 -4"
  }), e.createElement("path", {
    d: "M3 3l18 18"
  }));
}
var nxe = ["size", "color", "stroke"];
function lxe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, nxe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-point",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 4
  }));
}
var axe = ["size", "color", "stroke"];
function ixe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, axe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-pointer",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M7.904 17.563a1.2 1.2 0 0 0 2.228 .308l2.09 -3.093l4.907 4.907a1.067 1.067 0 0 0 1.509 0l1.047 -1.047a1.067 1.067 0 0 0 0 -1.509l-4.907 -4.907l3.113 -2.09a1.2 1.2 0 0 0 -.309 -2.228l-13.582 -3.904l3.904 13.563z"
  }));
}
var cxe = ["size", "color", "stroke"];
function sxe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, cxe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-pokeball-off",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M20.04 16.048a9 9 0 0 0 -12.083 -12.09m-2.32 1.678a9 9 0 1 0 12.737 12.719"
  }), e.createElement("path", {
    d: "M9.884 9.874a3 3 0 1 0 4.24 4.246m.57 -3.441a3.012 3.012 0 0 0 -1.41 -1.39"
  }), e.createElement("path", {
    d: "M3 12h6m7 0h5"
  }), e.createElement("path", {
    d: "M3 3l18 18"
  }));
}
var hxe = ["size", "color", "stroke"];
function dxe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, hxe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-pokeball",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 9
  }), e.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 3
  }), e.createElement("path", {
    d: "M3 12h6"
  }), e.createElement("path", {
    d: "M15 12h6"
  }));
}
var vxe = ["size", "color", "stroke"];
function mxe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, vxe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-poker-chip",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 9
  }), e.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 5
  }), e.createElement("path", {
    d: "M12 3v4"
  }), e.createElement("path", {
    d: "M12 17v4"
  }), e.createElement("path", {
    d: "M3 12h4"
  }), e.createElement("path", {
    d: "M17 12h4"
  }), e.createElement("path", {
    d: "M18.364 5.636l-2.828 2.828"
  }), e.createElement("path", {
    d: "M8.464 15.536l-2.828 2.828"
  }), e.createElement("path", {
    d: "M5.636 5.636l2.828 2.828"
  }), e.createElement("path", {
    d: "M15.536 15.536l2.828 2.828"
  }));
}
var kxe = ["size", "color", "stroke"];
function wxe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, kxe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-polaroid",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("rect", {
    x: 4,
    y: 4,
    width: 16,
    height: 16,
    rx: 2
  }), e.createElement("line", {
    x1: 4,
    y1: 16,
    x2: 20,
    y2: 16
  }), e.createElement("path", {
    d: "M4 12l3 -3c.928 -.893 2.072 -.893 3 0l4 4"
  }), e.createElement("path", {
    d: "M13 12l2 -2c.928 -.893 2.072 -.893 3 0l2 2"
  }), e.createElement("line", {
    x1: 14,
    y1: 7,
    x2: 14.01,
    y2: 7
  }));
}
var pxe = ["size", "color", "stroke"];
function Exe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, pxe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-polygon-off",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("circle", {
    cx: 12,
    cy: 5,
    r: 2
  }), e.createElement("circle", {
    cx: 19,
    cy: 8,
    r: 2
  }), e.createElement("circle", {
    cx: 5,
    cy: 11,
    r: 2
  }), e.createElement("circle", {
    cx: 15,
    cy: 19,
    r: 2
  }), e.createElement("path", {
    d: "M6.5 9.5l1.546 -1.311"
  }), e.createElement("path", {
    d: "M14 5.5l3 1.5"
  }), e.createElement("path", {
    d: "M18.5 10l-1.185 3.318m-1.062 2.972l-.253 .71"
  }), e.createElement("path", {
    d: "M13.5 17.5l-7 -5"
  }), e.createElement("path", {
    d: "M3 3l18 18"
  }));
}
var uxe = ["size", "color", "stroke"];
function gxe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, uxe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-polygon",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("circle", {
    cx: 12,
    cy: 5,
    r: 2
  }), e.createElement("circle", {
    cx: 19,
    cy: 8,
    r: 2
  }), e.createElement("circle", {
    cx: 5,
    cy: 11,
    r: 2
  }), e.createElement("circle", {
    cx: 15,
    cy: 19,
    r: 2
  }), e.createElement("path", {
    d: "M6.5 9.5l3.5 -3"
  }), e.createElement("path", {
    d: "M14 5.5l3 1.5"
  }), e.createElement("path", {
    d: "M18.5 10l-2.5 7"
  }), e.createElement("path", {
    d: "M13.5 17.5l-7 -5"
  }));
}
var Mxe = ["size", "color", "stroke"];
function xxe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Mxe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-poo",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M10 12h.01"
  }), e.createElement("path", {
    d: "M14 12h.01"
  }), e.createElement("path", {
    d: "M10 16a3.5 3.5 0 0 0 4 0"
  }), e.createElement("path", {
    d: "M11 4c2 0 3.5 1.5 3.5 4l.164 .005a2.5 2.5 0 0 1 2.196 3.32a3 3 0 0 1 1.615 3.063a3 3 0 0 1 -1.299 5.607l-.176 .005h-10a3 3 0 0 1 -1.474 -5.613a3 3 0 0 1 1.615 -3.062a2.5 2.5 0 0 1 2.195 -3.32l.164 -.005c1.5 0 2.5 -2 1.5 -4z"
  }));
}
var fxe = ["size", "color", "stroke"];
function zxe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, fxe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-pool-off",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M2 20a2.4 2.4 0 0 0 2 1a2.4 2.4 0 0 0 2 -1a2.4 2.4 0 0 1 2 -1a2.4 2.4 0 0 1 2 1a2.4 2.4 0 0 0 2 1a2.4 2.4 0 0 0 2 -1a2.4 2.4 0 0 1 2 -1a2.4 2.4 0 0 1 2 1a2.4 2.4 0 0 0 2 1c.303 .006 .6 -.045 .876 -.146"
  }), e.createElement("path", {
    d: "M2 16a2.4 2.4 0 0 0 2 1a2.4 2.4 0 0 0 2 -1a2.4 2.4 0 0 1 2 -1a2.4 2.4 0 0 1 2 1a2.4 2.4 0 0 0 2 1a2.4 2.4 0 0 0 2 -1a2.4 2.4 0 0 1 1.13 -.856m5.727 1.717a2.4 2.4 0 0 0 1.143 -.861"
  }), e.createElement("path", {
    d: "M15 11v-6.5a1.5 1.5 0 0 1 3 0"
  }), e.createElement("path", {
    d: "M9 12v-3m0 -4v-.5a1.5 1.5 0 0 0 -1.936 -1.436"
  }), e.createElement("path", {
    d: "M15 5h-6"
  }), e.createElement("path", {
    d: "M9 10h1m4 0h1"
  }), e.createElement("path", {
    d: "M3 3l18 18"
  }));
}
var bxe = ["size", "color", "stroke"];
function Lxe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, bxe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-pool",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M2 20a2.4 2.4 0 0 0 2 1a2.4 2.4 0 0 0 2 -1a2.4 2.4 0 0 1 2 -1a2.4 2.4 0 0 1 2 1a2.4 2.4 0 0 0 2 1a2.4 2.4 0 0 0 2 -1a2.4 2.4 0 0 1 2 -1a2.4 2.4 0 0 1 2 1a2.4 2.4 0 0 0 2 1a2.4 2.4 0 0 0 2 -1"
  }), e.createElement("path", {
    d: "M2 16a2.4 2.4 0 0 0 2 1a2.4 2.4 0 0 0 2 -1a2.4 2.4 0 0 1 2 -1a2.4 2.4 0 0 1 2 1a2.4 2.4 0 0 0 2 1a2.4 2.4 0 0 0 2 -1a2.4 2.4 0 0 1 2 -1a2.4 2.4 0 0 1 2 1a2.4 2.4 0 0 0 2 1a2.4 2.4 0 0 0 2 -1"
  }), e.createElement("path", {
    d: "M15 12v-7.5a1.5 1.5 0 0 1 3 0"
  }), e.createElement("path", {
    d: "M9 12v-7.5a1.5 1.5 0 0 0 -3 0"
  }), e.createElement("line", {
    x1: 15,
    y1: 5,
    x2: 9,
    y2: 5
  }), e.createElement("line", {
    x1: 9,
    y1: 10,
    x2: 15,
    y2: 10
  }));
}
var yxe = ["size", "color", "stroke"];
function Cxe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, yxe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-power",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M7 6a7.75 7.75 0 1 0 10 0"
  }), e.createElement("line", {
    x1: 12,
    y1: 4,
    x2: 12,
    y2: 12
  }));
}
var jxe = ["size", "color", "stroke"];
function Bxe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, jxe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-pray",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("circle", {
    cx: 12,
    cy: 5,
    r: 1
  }), e.createElement("path", {
    d: "M7 20h8l-4 -4v-7l4 3l2 -2"
  }));
}
var Hxe = ["size", "color", "stroke"];
function Nxe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Hxe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-premium-rights",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 9
  }), e.createElement("path", {
    d: "M13.867 9.75c-.246 -.48 -.708 -.769 -1.2 -.75h-1.334c-.736 0 -1.333 .67 -1.333 1.5c0 .827 .597 1.499 1.333 1.499h1.334c.736 0 1.333 .671 1.333 1.5c0 .828 -.597 1.499 -1.333 1.499h-1.334c-.492 .019 -.954 -.27 -1.2 -.75"
  }), e.createElement("path", {
    d: "M12 7v2"
  }), e.createElement("path", {
    d: "M12 15v2"
  }));
}
var Wxe = ["size", "color", "stroke"];
function qxe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Wxe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-prescription",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M6 19v-16h4.5a4.5 4.5 0 1 1 0 9h-4.5"
  }), e.createElement("path", {
    d: "M19 21l-9 -9"
  }), e.createElement("path", {
    d: "M13 21l6 -6"
  }));
}
var Oxe = ["size", "color", "stroke"];
function Pxe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Oxe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-presentation-analytics",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M9 12v-4"
  }), e.createElement("path", {
    d: "M15 12v-2"
  }), e.createElement("path", {
    d: "M12 12v-1"
  }), e.createElement("path", {
    d: "M3 4h18"
  }), e.createElement("path", {
    d: "M4 4v10a2 2 0 0 0 2 2h12a2 2 0 0 0 2 -2v-10"
  }), e.createElement("path", {
    d: "M12 16v4"
  }), e.createElement("path", {
    d: "M9 20h6"
  }));
}
var Sxe = ["size", "color", "stroke"];
function Ixe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Sxe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-presentation-off",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M3 4h1m4 0h13"
  }), e.createElement("path", {
    d: "M4 4v10a2 2 0 0 0 2 2h10m3.42 -.592c.359 -.362 .58 -.859 .58 -1.408v-10"
  }), e.createElement("path", {
    d: "M12 16v4"
  }), e.createElement("path", {
    d: "M9 20h6"
  }), e.createElement("path", {
    d: "M8 12l2 -2m4 0l2 -2"
  }), e.createElement("path", {
    d: "M3 3l18 18"
  }));
}
var Axe = ["size", "color", "stroke"];
function Dxe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Axe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-presentation",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("line", {
    x1: 3,
    y1: 4,
    x2: 21,
    y2: 4
  }), e.createElement("path", {
    d: "M4 4v10a2 2 0 0 0 2 2h12a2 2 0 0 0 2 -2v-10"
  }), e.createElement("line", {
    x1: 12,
    y1: 16,
    x2: 12,
    y2: 20
  }), e.createElement("line", {
    x1: 9,
    y1: 20,
    x2: 15,
    y2: 20
  }), e.createElement("path", {
    d: "M8 12l3 -3l2 2l3 -3"
  }));
}
var Fxe = ["size", "color", "stroke"];
function Gxe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Fxe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-printer-off",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M20.412 16.416c.363 -.362 .588 -.863 .588 -1.416v-4a2 2 0 0 0 -2 -2h-6m-4 0h-4a2 2 0 0 0 -2 2v4a2 2 0 0 0 2 2h2"
  }), e.createElement("path", {
    d: "M17 9v-4a2 2 0 0 0 -2 -2h-6c-.551 0 -1.05 .223 -1.412 .584m-.588 3.416v2"
  }), e.createElement("path", {
    d: "M17 17v2a2 2 0 0 1 -2 2h-6a2 2 0 0 1 -2 -2v-4a2 2 0 0 1 2 -2h4"
  }), e.createElement("path", {
    d: "M3 3l18 18"
  }));
}
var Jxe = ["size", "color", "stroke"];
function Kxe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Jxe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-printer",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M17 17h2a2 2 0 0 0 2 -2v-4a2 2 0 0 0 -2 -2h-14a2 2 0 0 0 -2 2v4a2 2 0 0 0 2 2h2"
  }), e.createElement("path", {
    d: "M17 9v-4a2 2 0 0 0 -2 -2h-6a2 2 0 0 0 -2 2v4"
  }), e.createElement("rect", {
    x: 7,
    y: 13,
    width: 10,
    height: 8,
    rx: 2
  }));
}
var Qxe = ["size", "color", "stroke"];
function Rxe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Qxe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-prison",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M18 4v16"
  }), e.createElement("path", {
    d: "M14 4v16"
  }), e.createElement("path", {
    d: "M6 4v5"
  }), e.createElement("path", {
    d: "M6 15v5"
  }), e.createElement("path", {
    d: "M10 4v5"
  }), e.createElement("path", {
    d: "M11 9h-6v6h6z"
  }), e.createElement("path", {
    d: "M10 15v5"
  }), e.createElement("path", {
    d: "M8 12h-.01"
  }));
}
var Txe = ["size", "color", "stroke"];
function Uxe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Txe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-prompt",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("polyline", {
    points: "5 7 10 12 5 17"
  }), e.createElement("line", {
    x1: 13,
    y1: 17,
    x2: 19,
    y2: 17
  }));
}
var Vxe = ["size", "color", "stroke"];
function Xxe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Vxe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-propeller-off",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M10.448 10.432a3 3 0 1 0 4.106 4.143"
  }), e.createElement("path", {
    d: "M14.272 10.272c.66 -1.459 1.058 -2.888 1.198 -4.286c.22 -1.63 -.762 -2.986 -3.47 -2.986c-1.94 0 -2.994 .696 -3.355 1.69m.697 4.653c.145 .384 .309 .77 .491 1.157"
  }), e.createElement("path", {
    d: "M13.169 16.751c.97 1.395 2.057 2.523 3.257 3.386c1.02 .789 2.265 .853 3.408 -.288m1.479 -2.493c.492 -1.634 -.19 -2.726 -1.416 -3.229c-.82 -.37 -1.703 -.654 -2.65 -.852"
  }), e.createElement("path", {
    d: "M8.664 12.999c-1.693 .143 -3.213 .52 -4.56 1.128c-1.522 .623 -2.206 2.153 -.852 4.498s3.02 2.517 4.321 1.512c1.2 -.863 2.287 -1.991 3.258 -3.386"
  }), e.createElement("path", {
    d: "M3 3l18 18"
  }));
}
var Yxe = ["size", "color", "stroke"];
function Zxe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Yxe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-propeller",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("circle", {
    cx: 12,
    cy: 13,
    r: 3
  }), e.createElement("path", {
    d: "M14.167 10.5c.722 -1.538 1.156 -3.043 1.303 -4.514c.22 -1.63 -.762 -2.986 -3.47 -2.986s-3.69 1.357 -3.47 2.986c.147 1.471 .581 2.976 1.303 4.514"
  }), e.createElement("path", {
    d: "M13.169 16.751c.97 1.395 2.057 2.523 3.257 3.386c1.3 1.006 2.967 .833 4.321 -1.512c1.354 -2.345 .67 -3.874 -.85 -4.498c-1.348 -.608 -2.868 -.985 -4.562 -1.128"
  }), e.createElement("path", {
    d: "M8.664 12.999c-1.693 .143 -3.213 .52 -4.56 1.128c-1.522 .623 -2.206 2.153 -.852 4.498s3.02 2.517 4.321 1.512c1.2 -.863 2.287 -1.991 3.258 -3.386"
  }));
}
var $xe = ["size", "color", "stroke"];
function _xe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, $xe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-pumpkin-scary",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M9 15l1.5 1l1.5 -1l1.5 1l1.5 -1"
  }), e.createElement("path", {
    d: "M10 11h.01"
  }), e.createElement("path", {
    d: "M14 11h.01"
  }), e.createElement("path", {
    d: "M17 6.082c2.609 .588 3.627 4.162 2.723 7.983c-.903 3.82 -2.75 6.44 -5.359 5.853a3.355 3.355 0 0 1 -.774 -.279a3.728 3.728 0 0 1 -1.59 .361c-.556 0 -1.09 -.127 -1.59 -.362a3.296 3.296 0 0 1 -.774 .28c-2.609 .588 -4.456 -2.033 -5.36 -5.853c-.903 -3.82 .115 -7.395 2.724 -7.983c1.085 -.244 1.575 .066 2.585 .787c.716 -.554 1.54 -.869 2.415 -.869c.876 0 1.699 .315 2.415 .87c1.01 -.722 1.5 -1.032 2.585 -.788z"
  }), e.createElement("path", {
    d: "M12 6c0 -1.226 .693 -2.346 1.789 -2.894l.211 -.106"
  }));
}
var efe = ["size", "color", "stroke"];
function tfe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, efe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-puzzle-2",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("rect", {
    x: 4,
    y: 4,
    width: 16,
    height: 16,
    rx: 2
  }), e.createElement("path", {
    d: "M12 4v2.5a0.5 .5 0 0 1 -.5 .5a1.5 1.5 0 0 0 0 3a0.5 .5 0 0 1 .5 .5v1.5"
  }), e.createElement("path", {
    d: "M12 12v1.5a0.5 .5 0 0 0 .5 .5a1.5 1.5 0 0 1 0 3a0.5 .5 0 0 0 -.5 .5v2.5"
  }), e.createElement("path", {
    d: "M20 12h-2.5a0.5 .5 0 0 1 -.5 -.5a1.5 1.5 0 0 0 -3 0a0.5 .5 0 0 1 -.5 .5h-1.5"
  }), e.createElement("path", {
    d: "M12 12h-1.5a0.5 .5 0 0 0 -.5 .5a1.5 1.5 0 0 1 -3 0a0.5 .5 0 0 0 -.5 -.5h-2.5"
  }));
}
var ofe = ["size", "color", "stroke"];
function rfe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, ofe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-puzzle-off",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M8.18 4.171a2 2 0 0 1 3.82 .829v1a1 1 0 0 0 1 1h3a1 1 0 0 1 1 1v3a1 1 0 0 0 1 1h1a2 2 0 0 1 .819 3.825m-2.819 1.175v3a1 1 0 0 1 -1 1h-3a1 1 0 0 1 -1 -1v-1a2 2 0 1 0 -4 0v1a1 1 0 0 1 -1 1h-3a1 1 0 0 1 -1 -1v-3a1 1 0 0 1 1 -1h1a2 2 0 1 0 0 -4h-1a1 1 0 0 1 -1 -1v-3a1 1 0 0 1 1 -1h3"
  }), e.createElement("path", {
    d: "M3 3l18 18"
  }));
}
var nfe = ["size", "color", "stroke"];
function lfe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, nfe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-puzzle",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M4 7h3a1 1 0 0 0 1 -1v-1a2 2 0 0 1 4 0v1a1 1 0 0 0 1 1h3a1 1 0 0 1 1 1v3a1 1 0 0 0 1 1h1a2 2 0 0 1 0 4h-1a1 1 0 0 0 -1 1v3a1 1 0 0 1 -1 1h-3a1 1 0 0 1 -1 -1v-1a2 2 0 0 0 -4 0v1a1 1 0 0 1 -1 1h-3a1 1 0 0 1 -1 -1v-3a1 1 0 0 1 1 -1h1a2 2 0 0 0 0 -4h-1a1 1 0 0 1 -1 -1v-3a1 1 0 0 1 1 -1"
  }));
}
var afe = ["size", "color", "stroke"];
function ife(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, afe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-pyramid-off",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M8.483 8.471l-5.483 8.529l9 4l6.22 -2.764m2.78 -1.236l-9 -14l-1.937 3.014"
  }), e.createElement("path", {
    d: "M12 3v5m0 4v9"
  }), e.createElement("path", {
    d: "M3 3l18 18"
  }));
}
var cfe = ["size", "color", "stroke"];
function sfe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, cfe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-pyramid",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M3 17l9 4l9 -4l-9 -14z"
  }), e.createElement("path", {
    d: "M12 3v18"
  }));
}
var hfe = ["size", "color", "stroke"];
function dfe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, hfe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-qrcode-off",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M8 4h1a1 1 0 0 1 1 1v1m-.297 3.711a0.997 .997 0 0 1 -.703 .289h-4a1 1 0 0 1 -1 -1v-4c0 -.275 .11 -.524 .29 -.705"
  }), e.createElement("path", {
    d: "M7 17v.01"
  }), e.createElement("rect", {
    x: 14,
    y: 4,
    width: 6,
    height: 6,
    rx: 1
  }), e.createElement("path", {
    d: "M7 7v.01"
  }), e.createElement("rect", {
    x: 4,
    y: 14,
    width: 6,
    height: 6,
    rx: 1
  }), e.createElement("path", {
    d: "M17 7v.01"
  }), e.createElement("path", {
    d: "M20 14v.01"
  }), e.createElement("path", {
    d: "M14 14v3"
  }), e.createElement("path", {
    d: "M14 20h3"
  }), e.createElement("path", {
    d: "M3 3l18 18"
  }));
}
var vfe = ["size", "color", "stroke"];
function mfe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, vfe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-qrcode",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("rect", {
    x: 4,
    y: 4,
    width: 6,
    height: 6,
    rx: 1
  }), e.createElement("line", {
    x1: 7,
    y1: 17,
    x2: 7,
    y2: 17.01
  }), e.createElement("rect", {
    x: 14,
    y: 4,
    width: 6,
    height: 6,
    rx: 1
  }), e.createElement("line", {
    x1: 7,
    y1: 7,
    x2: 7,
    y2: 7.01
  }), e.createElement("rect", {
    x: 4,
    y: 14,
    width: 6,
    height: 6,
    rx: 1
  }), e.createElement("line", {
    x1: 17,
    y1: 7,
    x2: 17,
    y2: 7.01
  }), e.createElement("line", {
    x1: 14,
    y1: 14,
    x2: 17,
    y2: 14
  }), e.createElement("line", {
    x1: 20,
    y1: 14,
    x2: 20,
    y2: 14.01
  }), e.createElement("line", {
    x1: 14,
    y1: 14,
    x2: 14,
    y2: 17
  }), e.createElement("line", {
    x1: 14,
    y1: 20,
    x2: 17,
    y2: 20
  }), e.createElement("line", {
    x1: 17,
    y1: 17,
    x2: 20,
    y2: 17
  }), e.createElement("line", {
    x1: 20,
    y1: 17,
    x2: 20,
    y2: 20
  }));
}
var kfe = ["size", "color", "stroke"];
function wfe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, kfe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-question-circle",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M12 16v.01"
  }), e.createElement("path", {
    d: "M12 13a2.003 2.003 0 0 0 .914 -3.782a1.98 1.98 0 0 0 -2.414 .483"
  }), e.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 9
  }));
}
var pfe = ["size", "color", "stroke"];
function Efe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, pfe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-question-mark",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M8 8a3.5 3 0 0 1 3.5 -3h1a3.5 3 0 0 1 3.5 3a3 3 0 0 1 -2 3a3 4 0 0 0 -2 4"
  }), e.createElement("line", {
    x1: 12,
    y1: 19,
    x2: 12,
    y2: 19.01
  }));
}
var ufe = ["size", "color", "stroke"];
function gfe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, ufe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-quote-off",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M10 11h-4a1 1 0 0 1 -1 -1v-3a1 1 0 0 1 1 -1m4 4v3c0 2.667 -1.333 4.333 -4 5"
  }), e.createElement("path", {
    d: "M19 11h-4m-1 -1v-3a1 1 0 0 1 1 -1h3a1 1 0 0 1 1 1v6c0 .66 -.082 1.26 -.245 1.798m-1.653 2.29c-.571 .4 -1.272 .704 -2.102 .912"
  }), e.createElement("path", {
    d: "M3 3l18 18"
  }));
}
var Mfe = ["size", "color", "stroke"];
function xfe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Mfe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-quote",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M10 11h-4a1 1 0 0 1 -1 -1v-3a1 1 0 0 1 1 -1h3a1 1 0 0 1 1 1v6c0 2.667 -1.333 4.333 -4 5"
  }), e.createElement("path", {
    d: "M19 11h-4a1 1 0 0 1 -1 -1v-3a1 1 0 0 1 1 -1h3a1 1 0 0 1 1 1v6c0 2.667 -1.333 4.333 -4 5"
  }));
}
var ffe = ["size", "color", "stroke"];
function zfe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, ffe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-radar-2",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 1
  }), e.createElement("path", {
    d: "M15.51 15.56a5 5 0 1 0 -3.51 1.44"
  }), e.createElement("path", {
    d: "M18.832 17.86a9 9 0 1 0 -6.832 3.14"
  }), e.createElement("path", {
    d: "M12 12v9"
  }));
}
var bfe = ["size", "color", "stroke"];
function Lfe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, bfe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-radar-off",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M11.291 11.295a1 1 0 0 0 .709 1.705v8c2.488 0 4.74 -1.01 6.37 -2.642m1.675 -2.319a8.962 8.962 0 0 0 .955 -4.039h-5"
  }), e.createElement("path", {
    d: "M15.999 8.998a5 5 0 0 0 -5.063 -1.88m-2.466 1.347a5 5 0 0 0 .53 7.535"
  }), e.createElement("path", {
    d: "M20.486 8.995a9 9 0 0 0 -12.525 -5.032m-2.317 1.675a9 9 0 0 0 3.36 14.852"
  }), e.createElement("path", {
    d: "M3 3l18 18"
  }));
}
var yfe = ["size", "color", "stroke"];
function Cfe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, yfe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-radar",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M21 12h-8a1 1 0 1 0 -1 1v8a9 9 0 0 0 9 -9"
  }), e.createElement("path", {
    d: "M15.999 8.998a5 5 0 1 0 -6.999 7.003"
  }), e.createElement("path", {
    d: "M20.486 8.995a9 9 0 1 0 -11.482 11.495"
  }));
}
var jfe = ["size", "color", "stroke"];
function Bfe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, jfe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-radio-off",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M14 3l-4.986 1.995m-2.875 1.15l-1.51 .604a1 1 0 0 0 -.629 .928v11.323a1 1 0 0 0 1 1h14a0.997 .997 0 0 0 .708 -.294m.292 -3.706v-8a1 1 0 0 0 -1 -1h-8m-4 0h-2.5"
  }), e.createElement("path", {
    d: "M4 12h8m4 0h4"
  }), e.createElement("path", {
    d: "M7 12v-2"
  }), e.createElement("path", {
    d: "M13 16v.01"
  }), e.createElement("path", {
    d: "M3 3l18 18"
  }));
}
var Hfe = ["size", "color", "stroke"];
function Nfe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Hfe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-radio",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M14 3l-9.371 3.749a1 1 0 0 0 -.629 .928v11.323a1 1 0 0 0 1 1h14a1 1 0 0 0 1 -1v-11a1 1 0 0 0 -1 -1h-14.5"
  }), e.createElement("path", {
    d: "M4 12h16"
  }), e.createElement("path", {
    d: "M7 12v-2"
  }), e.createElement("path", {
    d: "M17 16v.01"
  }), e.createElement("path", {
    d: "M13 16v.01"
  }));
}
var Wfe = ["size", "color", "stroke"];
function qfe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Wfe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-radioactive-off",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M14.118 14.127c-.182 .181 -.39 .341 -.618 .473l3 5.19a8.994 8.994 0 0 0 1.856 -1.423m1.68 -2.32a8.993 8.993 0 0 0 .964 -4.047h-5"
  }), e.createElement("path", {
    d: "M13.5 9.4l3 -5.19a9 9 0 0 0 -8.536 -.25"
  }), e.createElement("path", {
    d: "M10.5 14.6l-3 5.19a9 9 0 0 1 -4.5 -7.79h6a3 3 0 0 0 1.5 2.6"
  }), e.createElement("path", {
    d: "M3 3l18 18"
  }));
}
var Ofe = ["size", "color", "stroke"];
function Pfe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Ofe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-radioactive",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M13.5 14.6l3 5.19a9 9 0 0 0 4.5 -7.79h-6a3 3 0 0 1 -1.5 2.6"
  }), e.createElement("path", {
    d: "M13.5 9.4l3 -5.19a9 9 0 0 0 -9 0l3 5.19a3 3 0 0 1 3 0"
  }), e.createElement("path", {
    d: "M10.5 14.6l-3 5.19a9 9 0 0 1 -4.5 -7.79h6a3 3 0 0 0 1.5 2.6"
  }));
}
var Sfe = ["size", "color", "stroke"];
function Ife(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Sfe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-radius-bottom-left",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M19 19h-6a8 8 0 0 1 -8 -8v-6"
  }));
}
var Afe = ["size", "color", "stroke"];
function Dfe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Afe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-radius-bottom-right",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M19 5v6a8 8 0 0 1 -8 8h-6"
  }));
}
var Ffe = ["size", "color", "stroke"];
function Gfe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Ffe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-radius-top-left",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M5 19v-6a8 8 0 0 1 8 -8h6"
  }));
}
var Jfe = ["size", "color", "stroke"];
function Kfe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Jfe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-radius-top-right",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M5 5h6a8 8 0 0 1 8 8v6"
  }));
}
var Qfe = ["size", "color", "stroke"];
function Rfe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Qfe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-rainbow-off",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M22 17c0 -5.523 -4.477 -10 -10 -10c-.308 0 -.613 .014 -.914 .041m-3.208 .845a10.002 10.002 0 0 0 -5.878 9.114"
  }), e.createElement("path", {
    d: "M11.088 11.069a6.001 6.001 0 0 0 -5.088 5.931"
  }), e.createElement("path", {
    d: "M14 17a2 2 0 1 0 -4 0"
  }), e.createElement("path", {
    d: "M3 3l18 18"
  }));
}
var Tfe = ["size", "color", "stroke"];
function Ufe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Tfe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-rainbow",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M22 17c0 -5.523 -4.477 -10 -10 -10s-10 4.477 -10 10"
  }), e.createElement("path", {
    d: "M18 17a6 6 0 1 0 -12 0"
  }), e.createElement("path", {
    d: "M14 17a2 2 0 1 0 -4 0"
  }));
}
var Vfe = ["size", "color", "stroke"];
function Xfe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Vfe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-rating-12-plus",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 9
  }), e.createElement("path", {
    d: "M7 15v-6"
  }), e.createElement("path", {
    d: "M15.5 12h3"
  }), e.createElement("path", {
    d: "M17 10.5v3"
  }), e.createElement("path", {
    d: "M10 10.5a1.5 1.5 0 0 1 3 0c0 .443 -.313 .989 -.612 1.393l-2.388 3.107h3"
  }));
}
var Yfe = ["size", "color", "stroke"];
function Zfe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Yfe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-rating-14-plus",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 9
  }), e.createElement("path", {
    d: "M7 15v-6"
  }), e.createElement("path", {
    d: "M15.5 12h3"
  }), e.createElement("path", {
    d: "M17 10.5v3"
  }), e.createElement("path", {
    d: "M12.5 15v-6m-2.5 0v4h3"
  }));
}
var $fe = ["size", "color", "stroke"];
function _fe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, $fe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-rating-16-plus",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 9
  }), e.createElement("circle", {
    cx: 11.5,
    cy: 13.5,
    r: 1.5
  }), e.createElement("path", {
    d: "M7 15v-6"
  }), e.createElement("path", {
    d: "M15.5 12h3"
  }), e.createElement("path", {
    d: "M17 10.5v3"
  }), e.createElement("path", {
    d: "M10 13.5v-3a1.5 1.5 0 0 1 1.5 -1.5h1"
  }));
}
var eze = ["size", "color", "stroke"];
function tze(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, eze);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-rating-18-plus",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 9
  }), e.createElement("circle", {
    cx: 11.5,
    cy: 10.5,
    r: 1.5
  }), e.createElement("circle", {
    cx: 11.5,
    cy: 13.5,
    r: 1.5
  }), e.createElement("path", {
    d: "M7 15v-6"
  }), e.createElement("path", {
    d: "M15.5 12h3"
  }), e.createElement("path", {
    d: "M17 10.5v3"
  }));
}
var oze = ["size", "color", "stroke"];
function rze(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, oze);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-rating-21-plus",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 9
  }), e.createElement("path", {
    d: "M13 15v-6"
  }), e.createElement("path", {
    d: "M15.5 12h3"
  }), e.createElement("path", {
    d: "M17 10.5v3"
  }), e.createElement("path", {
    d: "M7 10.5a1.5 1.5 0 0 1 3 0c0 .443 -.313 .989 -.612 1.393l-2.388 3.107h3"
  }));
}
var nze = ["size", "color", "stroke"];
function lze(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, nze);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-razor-electric",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M8 3v2"
  }), e.createElement("path", {
    d: "M12 3v2"
  }), e.createElement("path", {
    d: "M16 3v2"
  }), e.createElement("path", {
    d: "M9 12v6a3 3 0 0 0 6 0v-6h-6z"
  }), e.createElement("path", {
    d: "M8 5h8l-1 4h-6z"
  }), e.createElement("path", {
    d: "M12 17v1"
  }));
}
var aze = ["size", "color", "stroke"];
function ize(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, aze);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-razor",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M7 3h10v4h-10z"
  }), e.createElement("path", {
    d: "M12 7v4"
  }), e.createElement("path", {
    d: "M12 11a2 2 0 0 1 2 2v6a2 2 0 1 1 -4 0v-6a2 2 0 0 1 2 -2z"
  }));
}
var cze = ["size", "color", "stroke"];
function sze(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, cze);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-receipt-2",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M5 21v-16a2 2 0 0 1 2 -2h10a2 2 0 0 1 2 2v16l-3 -2l-2 2l-2 -2l-2 2l-2 -2l-3 2"
  }), e.createElement("path", {
    d: "M14 8h-2.5a1.5 1.5 0 0 0 0 3h1a1.5 1.5 0 0 1 0 3h-2.5m2 0v1.5m0 -9v1.5"
  }));
}
var hze = ["size", "color", "stroke"];
function dze(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, hze);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-receipt-off",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M5 21v-16m2 -2h10a2 2 0 0 1 2 2v10m0 4.01v1.99l-3 -2l-2 2l-2 -2l-2 2l-2 -2l-3 2"
  }), e.createElement("line", {
    x1: 11,
    y1: 7,
    x2: 15,
    y2: 7
  }), e.createElement("line", {
    x1: 9,
    y1: 11,
    x2: 11,
    y2: 11
  }), e.createElement("line", {
    x1: 13,
    y1: 15,
    x2: 15,
    y2: 15
  }), e.createElement("line", {
    x1: 15,
    y1: 11,
    x2: 15,
    y2: 11.01
  }), e.createElement("line", {
    x1: 3,
    y1: 3,
    x2: 21,
    y2: 21
  }));
}
var vze = ["size", "color", "stroke"];
function mze(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, vze);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-receipt-refund",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M5 21v-16a2 2 0 0 1 2 -2h10a2 2 0 0 1 2 2v16l-3 -2l-2 2l-2 -2l-2 2l-2 -2l-3 2"
  }), e.createElement("path", {
    d: "M15 14v-2a2 2 0 0 0 -2 -2h-4l2 -2m0 4l-2 -2"
  }));
}
var kze = ["size", "color", "stroke"];
function wze(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, kze);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-receipt-tax",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("line", {
    x1: 9,
    y1: 14,
    x2: 15,
    y2: 8
  }), e.createElement("circle", {
    cx: 9.5,
    cy: 8.5,
    r: .5,
    fill: "currentColor"
  }), e.createElement("circle", {
    cx: 14.5,
    cy: 13.5,
    r: .5,
    fill: "currentColor"
  }), e.createElement("path", {
    d: "M5 21v-16a2 2 0 0 1 2 -2h10a2 2 0 0 1 2 2v16l-3 -2l-2 2l-2 -2l-2 2l-2 -2l-3 2"
  }));
}
var pze = ["size", "color", "stroke"];
function Eze(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, pze);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-receipt",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M5 21v-16a2 2 0 0 1 2 -2h10a2 2 0 0 1 2 2v16l-3 -2l-2 2l-2 -2l-2 2l-2 -2l-3 2m4 -14h6m-6 4h6m-2 4h2"
  }));
}
var uze = ["size", "color", "stroke"];
function gze(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, uze);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-recharging",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M7.038 4.5a9 9 0 0 0 -2.495 2.47"
  }), e.createElement("path", {
    d: "M3.186 10.209a9 9 0 0 0 0 3.508"
  }), e.createElement("path", {
    d: "M4.5 16.962a9 9 0 0 0 2.47 2.495"
  }), e.createElement("path", {
    d: "M10.209 20.814a9 9 0 0 0 3.5 0"
  }), e.createElement("path", {
    d: "M16.962 19.5a9 9 0 0 0 2.495 -2.47"
  }), e.createElement("path", {
    d: "M20.814 13.791a9 9 0 0 0 0 -3.508"
  }), e.createElement("path", {
    d: "M19.5 7.038a9 9 0 0 0 -2.47 -2.495"
  }), e.createElement("path", {
    d: "M13.791 3.186a9 9 0 0 0 -3.508 -.02"
  }), e.createElement("path", {
    d: "M12 8l-2 4h4l-2 4"
  }), e.createElement("path", {
    d: "M12 21a9 9 0 0 0 0 -18"
  }));
}
var Mze = ["size", "color", "stroke"];
function xze(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Mze);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-record-mail-off",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("circle", {
    cx: 7,
    cy: 12,
    r: 3
  }), e.createElement("path", {
    d: "M18.569 14.557a3 3 0 1 0 -4.113 -4.149"
  }), e.createElement("path", {
    d: "M7 15h8"
  }), e.createElement("path", {
    d: "M3 3l18 18"
  }));
}
var fze = ["size", "color", "stroke"];
function zze(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, fze);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-record-mail",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("circle", {
    cx: 7,
    cy: 12,
    r: 3
  }), e.createElement("circle", {
    cx: 17,
    cy: 12,
    r: 3
  }), e.createElement("line", {
    x1: 7,
    y1: 15,
    x2: 17,
    y2: 15
  }));
}
var bze = ["size", "color", "stroke"];
function Lze(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, bze);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-rectangle-vertical",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("rect", {
    x: 5,
    y: 3,
    width: 14,
    height: 18,
    rx: 2
  }));
}
var yze = ["size", "color", "stroke"];
function Cze(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, yze);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-rectangle",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("rect", {
    x: 3,
    y: 5,
    width: 18,
    height: 14,
    rx: 2
  }));
}
var jze = ["size", "color", "stroke"];
function Bze(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, jze);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-recycle-off",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M12 17l-2 2l2 2m-2 -2h9m1.896 -2.071a1.999 1.999 0 0 0 -.146 -.679l-.55 -1"
  }), e.createElement("path", {
    d: "M8.536 11l-.732 -2.732l-2.732 .732m2.732 -.732l-4.5 7.794a2 2 0 0 0 1.506 2.89l1.141 .024"
  }), e.createElement("path", {
    d: "M15.464 11l2.732 .732l.732 -2.732m-.732 2.732l-4.5 -7.794a2 2 0 0 0 -3.256 -.14l-.591 .976"
  }), e.createElement("path", {
    d: "M3 3l18 18"
  }));
}
var Hze = ["size", "color", "stroke"];
function Nze(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Hze);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-recycle",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M12 17l-2 2l2 2"
  }), e.createElement("path", {
    d: "M10 19h9a2 2 0 0 0 1.75 -2.75l-.55 -1"
  }), e.createElement("path", {
    d: "M8.536 11l-.732 -2.732l-2.732 .732"
  }), e.createElement("path", {
    d: "M7.804 8.268l-4.5 7.794a2 2 0 0 0 1.506 2.89l1.141 .024"
  }), e.createElement("path", {
    d: "M15.464 11l2.732 .732l.732 -2.732"
  }), e.createElement("path", {
    d: "M18.196 11.732l-4.5 -7.794a2 2 0 0 0 -3.256 -.14l-.591 .976"
  }));
}
var Wze = ["size", "color", "stroke"];
function qze(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Wze);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-refresh-alert",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M20 11a8.1 8.1 0 0 0 -15.5 -2m-.5 -4v4h4"
  }), e.createElement("path", {
    d: "M4 13a8.1 8.1 0 0 0 15.5 2m.5 4v-4h-4"
  }), e.createElement("line", {
    x1: 12,
    y1: 9,
    x2: 12,
    y2: 12
  }), e.createElement("line", {
    x1: 12,
    y1: 15,
    x2: 12.01,
    y2: 15
  }));
}
var Oze = ["size", "color", "stroke"];
function Pze(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Oze);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-refresh-dot",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M20 11a8.1 8.1 0 0 0 -15.5 -2m-.5 -4v4h4"
  }), e.createElement("path", {
    d: "M4 13a8.1 8.1 0 0 0 15.5 2m.5 4v-4h-4"
  }), e.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 1
  }));
}
var Sze = ["size", "color", "stroke"];
function Ize(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Sze);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-refresh-off",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M20 11a8.1 8.1 0 0 0 -11.271 -6.305m-2.41 1.624a8.083 8.083 0 0 0 -1.819 2.681m-.5 -4v4h4"
  }), e.createElement("path", {
    d: "M4 13a8.1 8.1 0 0 0 13.671 4.691m2.329 -1.691v-1h-1"
  }), e.createElement("path", {
    d: "M3 3l18 18"
  }));
}
var Aze = ["size", "color", "stroke"];
function Dze(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Aze);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-refresh",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M20 11a8.1 8.1 0 0 0 -15.5 -2m-.5 -4v4h4"
  }), e.createElement("path", {
    d: "M4 13a8.1 8.1 0 0 0 15.5 2m.5 4v-4h-4"
  }));
}
var Fze = ["size", "color", "stroke"];
function Gze(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Fze);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-regex-off",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M6.5 15a2.5 2.5 0 1 1 0 5a2.5 2.5 0 0 1 0 -5z"
  }), e.createElement("path", {
    d: "M17 7.875l3 -1.687"
  }), e.createElement("path", {
    d: "M17 7.875v3.375"
  }), e.createElement("path", {
    d: "M17 7.875l-3 -1.687"
  }), e.createElement("path", {
    d: "M17 7.875l3 1.688"
  }), e.createElement("path", {
    d: "M17 4.5v3.375"
  }), e.createElement("path", {
    d: "M17 7.875l-3 1.688"
  }), e.createElement("path", {
    d: "M3 3l18 18"
  }));
}
var Jze = ["size", "color", "stroke"];
function Kze(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Jze);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-regex",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M6.5 15a2.5 2.5 0 1 1 0 5a2.5 2.5 0 0 1 0 -5z"
  }), e.createElement("path", {
    d: "M17 7.875l3 -1.687"
  }), e.createElement("path", {
    d: "M17 7.875v3.375"
  }), e.createElement("path", {
    d: "M17 7.875l-3 -1.687"
  }), e.createElement("path", {
    d: "M17 7.875l3 1.688"
  }), e.createElement("path", {
    d: "M17 4.5v3.375"
  }), e.createElement("path", {
    d: "M17 7.875l-3 1.688"
  }));
}
var Qze = ["size", "color", "stroke"];
function Rze(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Qze);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-registered",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 9
  }), e.createElement("path", {
    d: "M10 15v-6h2a2 2 0 1 1 0 4h-2"
  }), e.createElement("path", {
    d: "M14 15l-2 -2"
  }));
}
var Tze = ["size", "color", "stroke"];
function Uze(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Tze);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-relation-many-to-many",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("rect", {
    x: 3,
    y: 5,
    width: 18,
    height: 14,
    rx: 2
  }), e.createElement("path", {
    d: "M15 14v-4l3 4v-4"
  }), e.createElement("path", {
    d: "M6 14v-4l3 4v-4"
  }), e.createElement("line", {
    x1: 12,
    y1: 10.5,
    x2: 12,
    y2: 10.51
  }), e.createElement("line", {
    x1: 12,
    y1: 13.5,
    x2: 12,
    y2: 13.51
  }));
}
var Vze = ["size", "color", "stroke"];
function Xze(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Vze);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-relation-one-to-many",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("rect", {
    x: 3,
    y: 5,
    width: 18,
    height: 14,
    rx: 2
  }), e.createElement("path", {
    d: "M7 10h1v4"
  }), e.createElement("path", {
    d: "M14 14v-4l3 4v-4"
  }), e.createElement("line", {
    x1: 11,
    y1: 10.5,
    x2: 11,
    y2: 10.51
  }), e.createElement("line", {
    x1: 11,
    y1: 13.5,
    x2: 11,
    y2: 13.51
  }));
}
var Yze = ["size", "color", "stroke"];
function Zze(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Yze);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-relation-one-to-one",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("rect", {
    x: 3,
    y: 5,
    width: 18,
    height: 14,
    rx: 2
  }), e.createElement("path", {
    d: "M8 10h1v4"
  }), e.createElement("path", {
    d: "M15 10h1v4"
  }), e.createElement("line", {
    x1: 12,
    y1: 10.5,
    x2: 12,
    y2: 10.51
  }), e.createElement("line", {
    x1: 12,
    y1: 13.5,
    x2: 12,
    y2: 13.51
  }));
}
var $ze = ["size", "color", "stroke"];
function _ze(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, $ze);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-reload",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M19.933 13.041a8 8 0 1 1 -9.925 -8.788c3.899 -1.002 7.935 1.007 9.425 4.747"
  }), e.createElement("path", {
    d: "M20 4v5h-5"
  }));
}
var ebe = ["size", "color", "stroke"];
function tbe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, ebe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-repeat-off",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M4 12v-3c0 -1.336 .873 -2.468 2.08 -2.856m3.92 -.144h10m-3 -3l3 3l-3 3"
  }), e.createElement("path", {
    d: "M20 12v3a3 3 0 0 1 -.133 .886m-1.99 1.984a3 3 0 0 1 -.877 .13h-13m3 3l-3 -3l3 -3"
  }), e.createElement("path", {
    d: "M3 3l18 18"
  }));
}
var obe = ["size", "color", "stroke"];
function rbe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, obe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-repeat-once",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M4 12v-3a3 3 0 0 1 3 -3h13m-3 -3l3 3l-3 3"
  }), e.createElement("path", {
    d: "M20 12v3a3 3 0 0 1 -3 3h-13m3 3l-3 -3l3 -3"
  }), e.createElement("path", {
    d: "M11 11l1 -1v4"
  }));
}
var nbe = ["size", "color", "stroke"];
function lbe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, nbe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-repeat",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M4 12v-3a3 3 0 0 1 3 -3h13m-3 -3l3 3l-3 3"
  }), e.createElement("path", {
    d: "M20 12v3a3 3 0 0 1 -3 3h-13m3 3l-3 -3l3 -3"
  }));
}
var abe = ["size", "color", "stroke"];
function ibe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, abe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-replace-off",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M7 3h1a1 1 0 0 1 1 1v1m-.303 3.717a0.997 .997 0 0 1 -.697 .283h-4a1 1 0 0 1 -1 -1v-4c0 -.28 .115 -.532 .3 -.714"
  }), e.createElement("path", {
    d: "M19 15h1a1 1 0 0 1 1 1v1m-.303 3.717a0.997 .997 0 0 1 -.697 .283h-4a1 1 0 0 1 -1 -1v-4c0 -.28 .115 -.532 .3 -.714"
  }), e.createElement("path", {
    d: "M21 11v-3a2 2 0 0 0 -2 -2h-6l3 3m0 -6l-3 3"
  }), e.createElement("path", {
    d: "M3 13v3a2 2 0 0 0 2 2h6l-3 -3m0 6l3 -3"
  }), e.createElement("path", {
    d: "M3 3l18 18"
  }));
}
var cbe = ["size", "color", "stroke"];
function sbe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, cbe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-replace",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("rect", {
    x: 3,
    y: 3,
    width: 6,
    height: 6,
    rx: 1
  }), e.createElement("rect", {
    x: 15,
    y: 15,
    width: 6,
    height: 6,
    rx: 1
  }), e.createElement("path", {
    d: "M21 11v-3a2 2 0 0 0 -2 -2h-6l3 3m0 -6l-3 3"
  }), e.createElement("path", {
    d: "M3 13v3a2 2 0 0 0 2 2h6l-3 -3m0 6l3 -3"
  }));
}
var hbe = ["size", "color", "stroke"];
function dbe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, hbe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-report-analytics",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M9 5h-2a2 2 0 0 0 -2 2v12a2 2 0 0 0 2 2h10a2 2 0 0 0 2 -2v-12a2 2 0 0 0 -2 -2h-2"
  }), e.createElement("rect", {
    x: 9,
    y: 3,
    width: 6,
    height: 4,
    rx: 2
  }), e.createElement("path", {
    d: "M9 17v-5"
  }), e.createElement("path", {
    d: "M12 17v-1"
  }), e.createElement("path", {
    d: "M15 17v-3"
  }));
}
var vbe = ["size", "color", "stroke"];
function mbe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, vbe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-report-medical",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M9 5h-2a2 2 0 0 0 -2 2v12a2 2 0 0 0 2 2h10a2 2 0 0 0 2 -2v-12a2 2 0 0 0 -2 -2h-2"
  }), e.createElement("rect", {
    x: 9,
    y: 3,
    width: 6,
    height: 4,
    rx: 2
  }), e.createElement("line", {
    x1: 10,
    y1: 14,
    x2: 14,
    y2: 14
  }), e.createElement("line", {
    x1: 12,
    y1: 12,
    x2: 12,
    y2: 16
  }));
}
var kbe = ["size", "color", "stroke"];
function wbe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, kbe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-report-money",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M9 5h-2a2 2 0 0 0 -2 2v12a2 2 0 0 0 2 2h10a2 2 0 0 0 2 -2v-12a2 2 0 0 0 -2 -2h-2"
  }), e.createElement("rect", {
    x: 9,
    y: 3,
    width: 6,
    height: 4,
    rx: 2
  }), e.createElement("path", {
    d: "M14 11h-2.5a1.5 1.5 0 0 0 0 3h1a1.5 1.5 0 0 1 0 3h-2.5"
  }), e.createElement("path", {
    d: "M12 17v1m0 -8v1"
  }));
}
var pbe = ["size", "color", "stroke"];
function Ebe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, pbe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-report-off",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M5.576 5.595a1.994 1.994 0 0 0 -.576 1.405v12a2 2 0 0 0 2 2h10a2 2 0 0 0 2 -2m0 -4v-8a2 2 0 0 0 -2 -2h-2"
  }), e.createElement("path", {
    d: "M9 5a2 2 0 0 1 2 -2h2a2 2 0 1 1 0 4h-2"
  }), e.createElement("path", {
    d: "M3 3l18 18"
  }));
}
var ube = ["size", "color", "stroke"];
function gbe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, ube);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-report-search",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M8 5h-2a2 2 0 0 0 -2 2v12a2 2 0 0 0 2 2h5.697"
  }), e.createElement("path", {
    d: "M18 12v-5a2 2 0 0 0 -2 -2h-2"
  }), e.createElement("rect", {
    x: 8,
    y: 3,
    width: 6,
    height: 4,
    rx: 2
  }), e.createElement("path", {
    d: "M8 11h4"
  }), e.createElement("path", {
    d: "M8 15h3"
  }), e.createElement("circle", {
    cx: 16.5,
    cy: 17.5,
    r: 2.5
  }), e.createElement("path", {
    d: "M18.5 19.5l2.5 2.5"
  }));
}
var Mbe = ["size", "color", "stroke"];
function xbe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Mbe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-report",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M8 5h-2a2 2 0 0 0 -2 2v12a2 2 0 0 0 2 2h5.697"
  }), e.createElement("path", {
    d: "M18 14v4h4"
  }), e.createElement("path", {
    d: "M18 11v-4a2 2 0 0 0 -2 -2h-2"
  }), e.createElement("rect", {
    x: 8,
    y: 3,
    width: 6,
    height: 4,
    rx: 2
  }), e.createElement("circle", {
    cx: 18,
    cy: 18,
    r: 4
  }), e.createElement("path", {
    d: "M8 11h4"
  }), e.createElement("path", {
    d: "M8 15h3"
  }));
}
var fbe = ["size", "color", "stroke"];
function zbe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, fbe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-resize",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M4 11v8a1 1 0 0 0 1 1h8m-9 -14v-1a1 1 0 0 1 1 -1h1m5 0h2m5 0h1a1 1 0 0 1 1 1v1m0 5v2m0 5v1a1 1 0 0 1 -1 1h-1"
  }), e.createElement("path", {
    d: "M4 12h7a1 1 0 0 1 1 1v7"
  }));
}
var bbe = ["size", "color", "stroke"];
function Lbe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, bbe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-ribbon-health",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M7 21s9.286 -9.841 9.286 -13.841a3.864 3.864 0 0 0 -1.182 -3.008a4.13 4.13 0 0 0 -3.104 -1.144a4.13 4.13 0 0 0 -3.104 1.143a3.864 3.864 0 0 0 -1.182 3.01c0 3.999 9.286 13.84 9.286 13.84"
  }));
}
var ybe = ["size", "color", "stroke"];
function Cbe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, ybe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-ripple-off",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M3 7c.915 -.61 1.83 -1.034 2.746 -1.272m4.212 .22c.68 .247 1.361 .598 2.042 1.052c3 2 6 2 9 0"
  }), e.createElement("path", {
    d: "M3 17c3 -2 6 -2 9 0c2.092 1.395 4.184 1.817 6.276 1.266"
  }), e.createElement("path", {
    d: "M3 12c3 -2 6 -2 9 0m5.482 1.429c1.173 -.171 2.345 -.647 3.518 -1.429"
  }), e.createElement("path", {
    d: "M3 3l18 18"
  }));
}
var jbe = ["size", "color", "stroke"];
function Bbe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, jbe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-ripple",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M3 7c3 -2 6 -2 9 0s6 2 9 0"
  }), e.createElement("path", {
    d: "M3 17c3 -2 6 -2 9 0s6 2 9 0"
  }), e.createElement("path", {
    d: "M3 12c3 -2 6 -2 9 0s6 2 9 0"
  }));
}
var Hbe = ["size", "color", "stroke"];
function Nbe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Hbe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-road-off",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M4 19l3.332 -11.661"
  }), e.createElement("path", {
    d: "M16 5l2.806 9.823"
  }), e.createElement("path", {
    d: "M12 8v-2"
  }), e.createElement("path", {
    d: "M12 13v-1"
  }), e.createElement("path", {
    d: "M12 18v-2"
  }), e.createElement("path", {
    d: "M3 3l18 18"
  }));
}
var Wbe = ["size", "color", "stroke"];
function qbe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Wbe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-road-sign",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M10.5 20.4l-6.9 -6.9c-.781 -.781 -.781 -2.219 0 -3l6.9 -6.9c.781 -.781 2.219 -.781 3 0l6.9 6.9c.781 .781 .781 2.219 0 3l-6.9 6.9c-.781 .781 -2.219 .781 -3 0z"
  }), e.createElement("path", {
    d: "M9 14v-2c0 -.59 .414 -1 1 -1h5"
  }), e.createElement("path", {
    d: "M13 9l2 2l-2 2"
  }));
}
var Obe = ["size", "color", "stroke"];
function Pbe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Obe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-road",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M4 19l4 -14"
  }), e.createElement("path", {
    d: "M16 5l4 14"
  }), e.createElement("path", {
    d: "M12 8v-2"
  }), e.createElement("path", {
    d: "M12 13v-2"
  }), e.createElement("path", {
    d: "M12 18v-2"
  }));
}
var Sbe = ["size", "color", "stroke"];
function Ibe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Sbe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-robot-off",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M11 7h6a2 2 0 0 1 2 2v1l1 1v3l-1 1m-.171 3.811a2 2 0 0 1 -1.829 1.189h-10a2 2 0 0 1 -2 -2v-3l-1 -1v-3l1 -1v-1a2 2 0 0 1 2 -2"
  }), e.createElement("path", {
    d: "M10 16h4"
  }), e.createElement("circle", {
    cx: 8.5,
    cy: 11.5,
    r: 1
  }), e.createElement("path", {
    d: "M15.854 11.853a0.498 .498 0 0 0 -.354 -.853a0.498 .498 0 0 0 -.356 .149"
  }), e.createElement("path", {
    d: "M8.336 4.343l-.336 -1.343"
  }), e.createElement("path", {
    d: "M15 7l1 -4"
  }), e.createElement("path", {
    d: "M3 3l18 18"
  }));
}
var Abe = ["size", "color", "stroke"];
function Dbe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Abe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-robot",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M7 7h10a2 2 0 0 1 2 2v1l1 1v3l-1 1v3a2 2 0 0 1 -2 2h-10a2 2 0 0 1 -2 -2v-3l-1 -1v-3l1 -1v-1a2 2 0 0 1 2 -2z"
  }), e.createElement("path", {
    d: "M10 16h4"
  }), e.createElement("circle", {
    cx: 8.5,
    cy: 11.5,
    r: .5,
    fill: "currentColor"
  }), e.createElement("circle", {
    cx: 15.5,
    cy: 11.5,
    r: .5,
    fill: "currentColor"
  }), e.createElement("path", {
    d: "M9 7l-1 -4"
  }), e.createElement("path", {
    d: "M15 7l1 -4"
  }));
}
var Fbe = ["size", "color", "stroke"];
function Gbe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Fbe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-rocket-off",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M9.29 9.275a9.03 9.03 0 0 0 -.29 .725a6 6 0 0 0 -5 3a8 8 0 0 1 7 7a6 6 0 0 0 3 -5c.241 -.085 .478 -.18 .708 -.283m2.428 -1.61a8.998 8.998 0 0 0 2.864 -6.107a3 3 0 0 0 -3 -3a8.998 8.998 0 0 0 -6.107 2.864"
  }), e.createElement("path", {
    d: "M7 14a6 6 0 0 0 -3 6a6 6 0 0 0 6 -3"
  }), e.createElement("circle", {
    cx: 15,
    cy: 9,
    r: 1
  }), e.createElement("path", {
    d: "M3 3l18 18"
  }));
}
var Jbe = ["size", "color", "stroke"];
function Kbe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Jbe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-rocket",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M4 13a8 8 0 0 1 7 7a6 6 0 0 0 3 -5a9 9 0 0 0 6 -8a3 3 0 0 0 -3 -3a9 9 0 0 0 -8 6a6 6 0 0 0 -5 3"
  }), e.createElement("path", {
    d: "M7 14a6 6 0 0 0 -3 6a6 6 0 0 0 6 -3"
  }), e.createElement("circle", {
    cx: 15,
    cy: 9,
    r: 1
  }));
}
var Qbe = ["size", "color", "stroke"];
function Rbe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Qbe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-roller-skating",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M5.905 5h3.418a1 1 0 0 1 .928 .629l1.143 2.856a3 3 0 0 0 2.207 1.83l4.717 .926a2.084 2.084 0 0 1 1.682 2.045v.714a1 1 0 0 1 -1 1h-13.895a1 1 0 0 1 -.995 -1.1l.8 -8a1 1 0 0 1 .995 -.9z"
  }), e.createElement("circle", {
    cx: 8,
    cy: 17,
    r: 2
  }), e.createElement("circle", {
    cx: 16,
    cy: 17,
    r: 2
  }));
}
var Tbe = ["size", "color", "stroke"];
function Ube(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Tbe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-rollercoaster-off",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M3 21a5.55 5.55 0 0 0 5.265 -3.795l.735 -2.205a8.759 8.759 0 0 1 2.35 -3.652m2.403 -1.589a8.76 8.76 0 0 1 3.572 -.759h3.675"
  }), e.createElement("path", {
    d: "M20 9v7m0 4v1"
  }), e.createElement("path", {
    d: "M8 21v-3"
  }), e.createElement("path", {
    d: "M12 21v-9"
  }), e.createElement("path", {
    d: "M16 9.5v2.5m0 4v5"
  }), e.createElement("path", {
    d: "M15 3h5v3h-5z"
  }), e.createElement("path", {
    d: "M9.446 5.415l.554 -.415l2 2.5l-.285 .213m-2.268 1.702l-1.447 1.085l-1.8 -.5l-.2 -2l1.139 -.854"
  }), e.createElement("path", {
    d: "M3 3l18 18"
  }));
}
var Vbe = ["size", "color", "stroke"];
function Xbe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Vbe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-rollercoaster",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M3 21a5.55 5.55 0 0 0 5.265 -3.795l.735 -2.205a8.775 8.775 0 0 1 8.325 -6h3.675"
  }), e.createElement("path", {
    d: "M20 9v12"
  }), e.createElement("path", {
    d: "M8 21v-3"
  }), e.createElement("path", {
    d: "M12 21v-10"
  }), e.createElement("path", {
    d: "M16 9.5v11.5"
  }), e.createElement("path", {
    d: "M15 3h5v3h-5z"
  }), e.createElement("path", {
    d: "M6 8l4 -3l2 2.5l-4 3l-1.8 -.5z"
  }));
}
var Ybe = ["size", "color", "stroke"];
function Zbe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Ybe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-rosette-number-0",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M10 10v4a2 2 0 1 0 4 0v-4a2 2 0 1 0 -4 0z"
  }), e.createElement("path", {
    d: "M5 7.2a2.2 2.2 0 0 1 2.2 -2.2h1a2.2 2.2 0 0 0 1.55 -.64l.7 -.7a2.2 2.2 0 0 1 3.12 0l.7 .7c.412 .41 .97 .64 1.55 .64h1a2.2 2.2 0 0 1 2.2 2.2v1c0 .58 .23 1.138 .64 1.55l.7 .7a2.2 2.2 0 0 1 0 3.12l-.7 .7a2.2 2.2 0 0 0 -.64 1.55v1a2.2 2.2 0 0 1 -2.2 2.2h-1a2.2 2.2 0 0 0 -1.55 .64l-.7 .7a2.2 2.2 0 0 1 -3.12 0l-.7 -.7a2.2 2.2 0 0 0 -1.55 -.64h-1a2.2 2.2 0 0 1 -2.2 -2.2v-1a2.2 2.2 0 0 0 -.64 -1.55l-.7 -.7a2.2 2.2 0 0 1 0 -3.12l.7 -.7a2.2 2.2 0 0 0 .64 -1.55v-1"
  }));
}
var $be = ["size", "color", "stroke"];
function _be(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, $be);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-rosette-number-1",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M10 10l2 -2v8"
  }), e.createElement("path", {
    d: "M5 7.2a2.2 2.2 0 0 1 2.2 -2.2h1a2.2 2.2 0 0 0 1.55 -.64l.7 -.7a2.2 2.2 0 0 1 3.12 0l.7 .7c.412 .41 .97 .64 1.55 .64h1a2.2 2.2 0 0 1 2.2 2.2v1c0 .58 .23 1.138 .64 1.55l.7 .7a2.2 2.2 0 0 1 0 3.12l-.7 .7a2.2 2.2 0 0 0 -.64 1.55v1a2.2 2.2 0 0 1 -2.2 2.2h-1a2.2 2.2 0 0 0 -1.55 .64l-.7 .7a2.2 2.2 0 0 1 -3.12 0l-.7 -.7a2.2 2.2 0 0 0 -1.55 -.64h-1a2.2 2.2 0 0 1 -2.2 -2.2v-1a2.2 2.2 0 0 0 -.64 -1.55l-.7 -.7a2.2 2.2 0 0 1 0 -3.12l.7 -.7a2.2 2.2 0 0 0 .64 -1.55v-1"
  }));
}
var eLe = ["size", "color", "stroke"];
function tLe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, eLe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-rosette-number-2",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M10 8h3a1 1 0 0 1 1 1v2a1 1 0 0 1 -1 1h-2a1 1 0 0 0 -1 1v2a1 1 0 0 0 1 1h3"
  }), e.createElement("path", {
    d: "M5 7.2a2.2 2.2 0 0 1 2.2 -2.2h1a2.2 2.2 0 0 0 1.55 -.64l.7 -.7a2.2 2.2 0 0 1 3.12 0l.7 .7c.412 .41 .97 .64 1.55 .64h1a2.2 2.2 0 0 1 2.2 2.2v1c0 .58 .23 1.138 .64 1.55l.7 .7a2.2 2.2 0 0 1 0 3.12l-.7 .7a2.2 2.2 0 0 0 -.64 1.55v1a2.2 2.2 0 0 1 -2.2 2.2h-1a2.2 2.2 0 0 0 -1.55 .64l-.7 .7a2.2 2.2 0 0 1 -3.12 0l-.7 -.7a2.2 2.2 0 0 0 -1.55 -.64h-1a2.2 2.2 0 0 1 -2.2 -2.2v-1a2.2 2.2 0 0 0 -.64 -1.55l-.7 -.7a2.2 2.2 0 0 1 0 -3.12l.7 -.7a2.2 2.2 0 0 0 .64 -1.55v-1"
  }));
}
var oLe = ["size", "color", "stroke"];
function rLe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, oLe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-rosette-number-3",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M10 9a1 1 0 0 1 1 -1h2a1 1 0 0 1 1 1v2a1 1 0 0 1 -1 1h-2h2a1 1 0 0 1 1 1v2a1 1 0 0 1 -1 1h-2a1 1 0 0 1 -1 -1"
  }), e.createElement("path", {
    d: "M5 7.2a2.2 2.2 0 0 1 2.2 -2.2h1a2.2 2.2 0 0 0 1.55 -.64l.7 -.7a2.2 2.2 0 0 1 3.12 0l.7 .7c.412 .41 .97 .64 1.55 .64h1a2.2 2.2 0 0 1 2.2 2.2v1c0 .58 .23 1.138 .64 1.55l.7 .7a2.2 2.2 0 0 1 0 3.12l-.7 .7a2.2 2.2 0 0 0 -.64 1.55v1a2.2 2.2 0 0 1 -2.2 2.2h-1a2.2 2.2 0 0 0 -1.55 .64l-.7 .7a2.2 2.2 0 0 1 -3.12 0l-.7 -.7a2.2 2.2 0 0 0 -1.55 -.64h-1a2.2 2.2 0 0 1 -2.2 -2.2v-1a2.2 2.2 0 0 0 -.64 -1.55l-.7 -.7a2.2 2.2 0 0 1 0 -3.12l.7 -.7a2.2 2.2 0 0 0 .64 -1.55v-1"
  }));
}
var nLe = ["size", "color", "stroke"];
function lLe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, nLe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-rosette-number-4",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M10 8v3a1 1 0 0 0 1 1h3"
  }), e.createElement("path", {
    d: "M14 8v8"
  }), e.createElement("path", {
    d: "M5 7.2a2.2 2.2 0 0 1 2.2 -2.2h1a2.2 2.2 0 0 0 1.55 -.64l.7 -.7a2.2 2.2 0 0 1 3.12 0l.7 .7c.412 .41 .97 .64 1.55 .64h1a2.2 2.2 0 0 1 2.2 2.2v1c0 .58 .23 1.138 .64 1.55l.7 .7a2.2 2.2 0 0 1 0 3.12l-.7 .7a2.2 2.2 0 0 0 -.64 1.55v1a2.2 2.2 0 0 1 -2.2 2.2h-1a2.2 2.2 0 0 0 -1.55 .64l-.7 .7a2.2 2.2 0 0 1 -3.12 0l-.7 -.7a2.2 2.2 0 0 0 -1.55 -.64h-1a2.2 2.2 0 0 1 -2.2 -2.2v-1a2.2 2.2 0 0 0 -.64 -1.55l-.7 -.7a2.2 2.2 0 0 1 0 -3.12l.7 -.7a2.2 2.2 0 0 0 .64 -1.55v-1"
  }));
}
var aLe = ["size", "color", "stroke"];
function iLe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, aLe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-rosette-number-5",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M10 15a1 1 0 0 0 1 1h2a1 1 0 0 0 1 -1v-2a1 1 0 0 0 -1 -1h-3v-4h4"
  }), e.createElement("path", {
    d: "M5 7.2a2.2 2.2 0 0 1 2.2 -2.2h1a2.2 2.2 0 0 0 1.55 -.64l.7 -.7a2.2 2.2 0 0 1 3.12 0l.7 .7c.412 .41 .97 .64 1.55 .64h1a2.2 2.2 0 0 1 2.2 2.2v1c0 .58 .23 1.138 .64 1.55l.7 .7a2.2 2.2 0 0 1 0 3.12l-.7 .7a2.2 2.2 0 0 0 -.64 1.55v1a2.2 2.2 0 0 1 -2.2 2.2h-1a2.2 2.2 0 0 0 -1.55 .64l-.7 .7a2.2 2.2 0 0 1 -3.12 0l-.7 -.7a2.2 2.2 0 0 0 -1.55 -.64h-1a2.2 2.2 0 0 1 -2.2 -2.2v-1a2.2 2.2 0 0 0 -.64 -1.55l-.7 -.7a2.2 2.2 0 0 1 0 -3.12l.7 -.7a2.2 2.2 0 0 0 .64 -1.55v-1"
  }));
}
var cLe = ["size", "color", "stroke"];
function sLe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, cLe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-rosette-number-6",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M14 9a1 1 0 0 0 -1 -1h-2a1 1 0 0 0 -1 1v6a1 1 0 0 0 1 1h2a1 1 0 0 0 1 -1v-2a1 1 0 0 0 -1 -1h-3"
  }), e.createElement("path", {
    d: "M5 7.2a2.2 2.2 0 0 1 2.2 -2.2h1a2.2 2.2 0 0 0 1.55 -.64l.7 -.7a2.2 2.2 0 0 1 3.12 0l.7 .7c.412 .41 .97 .64 1.55 .64h1a2.2 2.2 0 0 1 2.2 2.2v1c0 .58 .23 1.138 .64 1.55l.7 .7a2.2 2.2 0 0 1 0 3.12l-.7 .7a2.2 2.2 0 0 0 -.64 1.55v1a2.2 2.2 0 0 1 -2.2 2.2h-1a2.2 2.2 0 0 0 -1.55 .64l-.7 .7a2.2 2.2 0 0 1 -3.12 0l-.7 -.7a2.2 2.2 0 0 0 -1.55 -.64h-1a2.2 2.2 0 0 1 -2.2 -2.2v-1a2.2 2.2 0 0 0 -.64 -1.55l-.7 -.7a2.2 2.2 0 0 1 0 -3.12l.7 -.7a2.2 2.2 0 0 0 .64 -1.55v-1"
  }));
}
var hLe = ["size", "color", "stroke"];
function dLe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, hLe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-rosette-number-7",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M10 8h4l-2 8"
  }), e.createElement("path", {
    d: "M5 7.2a2.2 2.2 0 0 1 2.2 -2.2h1a2.2 2.2 0 0 0 1.55 -.64l.7 -.7a2.2 2.2 0 0 1 3.12 0l.7 .7c.412 .41 .97 .64 1.55 .64h1a2.2 2.2 0 0 1 2.2 2.2v1c0 .58 .23 1.138 .64 1.55l.7 .7a2.2 2.2 0 0 1 0 3.12l-.7 .7a2.2 2.2 0 0 0 -.64 1.55v1a2.2 2.2 0 0 1 -2.2 2.2h-1a2.2 2.2 0 0 0 -1.55 .64l-.7 .7a2.2 2.2 0 0 1 -3.12 0l-.7 -.7a2.2 2.2 0 0 0 -1.55 -.64h-1a2.2 2.2 0 0 1 -2.2 -2.2v-1a2.2 2.2 0 0 0 -.64 -1.55l-.7 -.7a2.2 2.2 0 0 1 0 -3.12l.7 -.7a2.2 2.2 0 0 0 .64 -1.55v-1"
  }));
}
var vLe = ["size", "color", "stroke"];
function mLe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, vLe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-rosette-number-8",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M12 12h-1a1 1 0 0 1 -1 -1v-2a1 1 0 0 1 1 -1h2a1 1 0 0 1 1 1v2a1 1 0 0 1 -1 1h-2a1 1 0 0 0 -1 1v2a1 1 0 0 0 1 1h2a1 1 0 0 0 1 -1v-2a1 1 0 0 0 -1 -1"
  }), e.createElement("path", {
    d: "M5 7.2a2.2 2.2 0 0 1 2.2 -2.2h1a2.2 2.2 0 0 0 1.55 -.64l.7 -.7a2.2 2.2 0 0 1 3.12 0l.7 .7c.412 .41 .97 .64 1.55 .64h1a2.2 2.2 0 0 1 2.2 2.2v1c0 .58 .23 1.138 .64 1.55l.7 .7a2.2 2.2 0 0 1 0 3.12l-.7 .7a2.2 2.2 0 0 0 -.64 1.55v1a2.2 2.2 0 0 1 -2.2 2.2h-1a2.2 2.2 0 0 0 -1.55 .64l-.7 .7a2.2 2.2 0 0 1 -3.12 0l-.7 -.7a2.2 2.2 0 0 0 -1.55 -.64h-1a2.2 2.2 0 0 1 -2.2 -2.2v-1a2.2 2.2 0 0 0 -.64 -1.55l-.7 -.7a2.2 2.2 0 0 1 0 -3.12l.7 -.7a2.2 2.2 0 0 0 .64 -1.55v-1"
  }));
}
var kLe = ["size", "color", "stroke"];
function wLe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, kLe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-rosette-number-9",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M10 15a1 1 0 0 0 1 1h2a1 1 0 0 0 1 -1v-6a1 1 0 0 0 -1 -1h-2a1 1 0 0 0 -1 1v2a1 1 0 0 0 1 1h3"
  }), e.createElement("path", {
    d: "M5 7.2a2.2 2.2 0 0 1 2.2 -2.2h1a2.2 2.2 0 0 0 1.55 -.64l.7 -.7a2.2 2.2 0 0 1 3.12 0l.7 .7c.412 .41 .97 .64 1.55 .64h1a2.2 2.2 0 0 1 2.2 2.2v1c0 .58 .23 1.138 .64 1.55l.7 .7a2.2 2.2 0 0 1 0 3.12l-.7 .7a2.2 2.2 0 0 0 -.64 1.55v1a2.2 2.2 0 0 1 -2.2 2.2h-1a2.2 2.2 0 0 0 -1.55 .64l-.7 .7a2.2 2.2 0 0 1 -3.12 0l-.7 -.7a2.2 2.2 0 0 0 -1.55 -.64h-1a2.2 2.2 0 0 1 -2.2 -2.2v-1a2.2 2.2 0 0 0 -.64 -1.55l-.7 -.7a2.2 2.2 0 0 1 0 -3.12l.7 -.7a2.2 2.2 0 0 0 .64 -1.55v-1"
  }));
}
var pLe = ["size", "color", "stroke"];
function ELe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, pLe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-rosette",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M5 7.2a2.2 2.2 0 0 1 2.2 -2.2h1a2.2 2.2 0 0 0 1.55 -.64l.7 -.7a2.2 2.2 0 0 1 3.12 0l.7 .7c.412 .41 .97 .64 1.55 .64h1a2.2 2.2 0 0 1 2.2 2.2v1c0 .58 .23 1.138 .64 1.55l.7 .7a2.2 2.2 0 0 1 0 3.12l-.7 .7a2.2 2.2 0 0 0 -.64 1.55v1a2.2 2.2 0 0 1 -2.2 2.2h-1a2.2 2.2 0 0 0 -1.55 .64l-.7 .7a2.2 2.2 0 0 1 -3.12 0l-.7 -.7a2.2 2.2 0 0 0 -1.55 -.64h-1a2.2 2.2 0 0 1 -2.2 -2.2v-1a2.2 2.2 0 0 0 -.64 -1.55l-.7 -.7a2.2 2.2 0 0 1 0 -3.12l.7 -.7a2.2 2.2 0 0 0 .64 -1.55v-1"
  }));
}
var uLe = ["size", "color", "stroke"];
function gLe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, uLe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-rotate-2",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M15 4.55a8 8 0 0 0 -6 14.9m0 -4.45v5h-5"
  }), e.createElement("line", {
    x1: 18.37,
    y1: 7.16,
    x2: 18.37,
    y2: 7.17
  }), e.createElement("line", {
    x1: 13,
    y1: 19.94,
    x2: 13,
    y2: 19.95
  }), e.createElement("line", {
    x1: 16.84,
    y1: 18.37,
    x2: 16.84,
    y2: 18.38
  }), e.createElement("line", {
    x1: 19.37,
    y1: 15.1,
    x2: 19.37,
    y2: 15.11
  }), e.createElement("line", {
    x1: 19.94,
    y1: 11,
    x2: 19.94,
    y2: 11.01
  }));
}
var MLe = ["size", "color", "stroke"];
function xLe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, MLe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-rotate-360",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M12 16h4v4"
  }), e.createElement("path", {
    d: "M19.458 11.042c.86 -2.366 .722 -4.58 -.6 -5.9c-2.272 -2.274 -7.185 -1.045 -10.973 2.743c-3.788 3.788 -5.017 8.701 -2.744 10.974c2.227 2.226 6.987 1.093 10.74 -2.515"
  }));
}
var fLe = ["size", "color", "stroke"];
function zLe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, fLe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-rotate-clockwise-2",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M9 4.55a8 8 0 0 1 6 14.9m0 -4.45v5h5"
  }), e.createElement("line", {
    x1: 5.63,
    y1: 7.16,
    x2: 5.63,
    y2: 7.17
  }), e.createElement("line", {
    x1: 4.06,
    y1: 11,
    x2: 4.06,
    y2: 11.01
  }), e.createElement("line", {
    x1: 4.63,
    y1: 15.1,
    x2: 4.63,
    y2: 15.11
  }), e.createElement("line", {
    x1: 7.16,
    y1: 18.37,
    x2: 7.16,
    y2: 18.38
  }), e.createElement("line", {
    x1: 11,
    y1: 19.94,
    x2: 11,
    y2: 19.95
  }));
}
var bLe = ["size", "color", "stroke"];
function LLe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, bLe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-rotate-clockwise",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M4.05 11a8 8 0 1 1 .5 4m-.5 5v-5h5"
  }));
}
var yLe = ["size", "color", "stroke"];
function CLe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, yLe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-rotate-dot",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M19.95 11a8 8 0 1 0 -.5 4m.5 5v-5h-5"
  }), e.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 1
  }));
}
var jLe = ["size", "color", "stroke"];
function BLe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, jLe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-rotate-rectangle",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M10.09 4.01l.496 -.495a2 2 0 0 1 2.828 0l7.071 7.07a2 2 0 0 1 0 2.83l-7.07 7.07a2 2 0 0 1 -2.83 0l-7.07 -7.07a2 2 0 0 1 0 -2.83l3.535 -3.535h-3.988"
  }), e.createElement("path", {
    d: "M7.05 11.038v-3.988"
  }));
}
var HLe = ["size", "color", "stroke"];
function NLe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, HLe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-rotate",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M19.95 11a8 8 0 1 0 -.5 4m.5 5v-5h-5"
  }));
}
var WLe = ["size", "color", "stroke"];
function qLe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, WLe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-route-2",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M3 17l4 4"
  }), e.createElement("path", {
    d: "M7 17l-4 4"
  }), e.createElement("path", {
    d: "M17 3l4 4"
  }), e.createElement("path", {
    d: "M21 3l-4 4"
  }), e.createElement("path", {
    d: "M14 5a2 2 0 0 0 -2 2v10a2 2 0 0 1 -2 2"
  }));
}
var OLe = ["size", "color", "stroke"];
function PLe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, OLe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-route-off",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("circle", {
    cx: 6,
    cy: 19,
    r: 2
  }), e.createElement("circle", {
    cx: 18,
    cy: 5,
    r: 2
  }), e.createElement("path", {
    d: "M12 19h4.5c.71 0 1.372 -.212 1.924 -.576m1.545 -2.459a3.5 3.5 0 0 0 -3.469 -3.965h-.499m-4 0h-3.501a3.5 3.5 0 0 1 -2.477 -5.972m2.477 -1.028h3.5"
  }), e.createElement("path", {
    d: "M3 3l18 18"
  }));
}
var SLe = ["size", "color", "stroke"];
function ILe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, SLe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-route",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("circle", {
    cx: 6,
    cy: 19,
    r: 2
  }), e.createElement("circle", {
    cx: 18,
    cy: 5,
    r: 2
  }), e.createElement("path", {
    d: "M12 19h4.5a3.5 3.5 0 0 0 0 -7h-8a3.5 3.5 0 0 1 0 -7h3.5"
  }));
}
var ALe = ["size", "color", "stroke"];
function DLe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, ALe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-router-off",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M17 13h2a2 2 0 0 1 2 2v2m-.588 3.417c-.362 .36 -.861 .583 -1.412 .583h-14a2 2 0 0 1 -2 -2v-4a2 2 0 0 1 2 -2h8"
  }), e.createElement("path", {
    d: "M17 17v.01"
  }), e.createElement("path", {
    d: "M13 17v.01"
  }), e.createElement("path", {
    d: "M12.226 8.2a4 4 0 0 1 6.024 .55"
  }), e.createElement("path", {
    d: "M9.445 5.407a8 8 0 0 1 12.055 1.093"
  }), e.createElement("path", {
    d: "M3 3l18 18"
  }));
}
var FLe = ["size", "color", "stroke"];
function GLe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, FLe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-router",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("rect", {
    x: 3,
    y: 13,
    width: 18,
    height: 8,
    rx: 2
  }), e.createElement("line", {
    x1: 17,
    y1: 17,
    x2: 17,
    y2: 17.01
  }), e.createElement("line", {
    x1: 13,
    y1: 17,
    x2: 13,
    y2: 17.01
  }), e.createElement("line", {
    x1: 15,
    y1: 13,
    x2: 15,
    y2: 11
  }), e.createElement("path", {
    d: "M11.75 8.75a4 4 0 0 1 6.5 0"
  }), e.createElement("path", {
    d: "M8.5 6.5a8 8 0 0 1 13 0"
  }));
}
var JLe = ["size", "color", "stroke"];
function KLe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, JLe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-row-insert-bottom",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M20 6v4a1 1 0 0 1 -1 1h-14a1 1 0 0 1 -1 -1v-4a1 1 0 0 1 1 -1h14a1 1 0 0 1 1 1z"
  }), e.createElement("line", {
    x1: 12,
    y1: 15,
    x2: 12,
    y2: 19
  }), e.createElement("line", {
    x1: 14,
    y1: 17,
    x2: 10,
    y2: 17
  }));
}
var QLe = ["size", "color", "stroke"];
function RLe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, QLe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-row-insert-top",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M4 18v-4a1 1 0 0 1 1 -1h14a1 1 0 0 1 1 1v4a1 1 0 0 1 -1 1h-14a1 1 0 0 1 -1 -1z"
  }), e.createElement("path", {
    d: "M12 9v-4"
  }), e.createElement("line", {
    x1: 10,
    y1: 7,
    x2: 14,
    y2: 7
  }));
}
var TLe = ["size", "color", "stroke"];
function ULe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, TLe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-rss",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("circle", {
    cx: 5,
    cy: 19,
    r: 1
  }), e.createElement("path", {
    d: "M4 4a16 16 0 0 1 16 16"
  }), e.createElement("path", {
    d: "M4 11a9 9 0 0 1 9 9"
  }));
}
var VLe = ["size", "color", "stroke"];
function XLe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, VLe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-rubber-stamp-off",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M8.273 8.273c.805 2.341 2.857 5.527 -1.484 5.527c-2.368 0 -3.789 0 -3.789 4.05h14.85"
  }), e.createElement("path", {
    d: "M5 21h14"
  }), e.createElement("path", {
    d: "M3 3l18 18"
  }), e.createElement("path", {
    d: "M8.712 4.722a3.99 3.99 0 0 1 3.288 -1.722a4 4 0 0 1 4 4c0 .992 -.806 2.464 -1.223 3.785m6.198 6.196c-.182 -2.883 -1.332 -3.153 -3.172 -3.178"
  }));
}
var YLe = ["size", "color", "stroke"];
function ZLe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, YLe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-rubber-stamp",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M21 17.85h-18c0 -4.05 1.421 -4.05 3.79 -4.05c5.21 0 1.21 -4.59 1.21 -6.8a4 4 0 1 1 8 0c0 2.21 -4 6.8 1.21 6.8c2.369 0 3.79 0 3.79 4.05z"
  }), e.createElement("path", {
    d: "M5 21h14"
  }));
}
var $Le = ["size", "color", "stroke"];
function _Le(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, $Le);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-ruler-2-off",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M12.03 7.97l4.97 -4.97l4 4l-5 5m-2 2l-7 7l-4 -4l7 -7"
  }), e.createElement("path", {
    d: "M16 7l-1.5 -1.5"
  }), e.createElement("path", {
    d: "M10 13l-1.5 -1.5"
  }), e.createElement("path", {
    d: "M7 16l-1.5 -1.5"
  }), e.createElement("path", {
    d: "M3 3l18 18"
  }));
}
var eye = ["size", "color", "stroke"];
function tye(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, eye);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-ruler-2",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M17 3l4 4l-14 14l-4 -4z"
  }), e.createElement("path", {
    d: "M16 7l-1.5 -1.5"
  }), e.createElement("path", {
    d: "M13 10l-1.5 -1.5"
  }), e.createElement("path", {
    d: "M10 13l-1.5 -1.5"
  }), e.createElement("path", {
    d: "M7 16l-1.5 -1.5"
  }));
}
var oye = ["size", "color", "stroke"];
function rye(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, oye);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-ruler-3",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M19.875 8c.621 0 1.125 .512 1.125 1.143v5.714c0 .631 -.504 1.143 -1.125 1.143h-15.875a1 1 0 0 1 -1 -1v-5.857c0 -.631 .504 -1.143 1.125 -1.143h15.75z"
  }), e.createElement("path", {
    d: "M9 8v2"
  }), e.createElement("path", {
    d: "M6 8v3"
  }), e.createElement("path", {
    d: "M12 8v3"
  }), e.createElement("path", {
    d: "M18 8v3"
  }), e.createElement("path", {
    d: "M15 8v2"
  }));
}
var nye = ["size", "color", "stroke"];
function lye(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, nye);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-ruler-measure",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M19.875 12c.621 0 1.125 .512 1.125 1.143v5.714c0 .631 -.504 1.143 -1.125 1.143h-15.875a1 1 0 0 1 -1 -1v-5.857c0 -.631 .504 -1.143 1.125 -1.143h15.75z"
  }), e.createElement("path", {
    d: "M9 12v2"
  }), e.createElement("path", {
    d: "M6 12v3"
  }), e.createElement("path", {
    d: "M12 12v3"
  }), e.createElement("path", {
    d: "M18 12v3"
  }), e.createElement("path", {
    d: "M15 12v2"
  }), e.createElement("path", {
    d: "M3 3v4"
  }), e.createElement("path", {
    d: "M3 5h18"
  }), e.createElement("path", {
    d: "M21 3v4"
  }));
}
var aye = ["size", "color", "stroke"];
function iye(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, aye);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-ruler-off",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M8 4h11a1 1 0 0 1 1 1v5a1 1 0 0 1 -1 1h-4m-3.713 .299a0.997 .997 0 0 0 -.287 .701v7a1 1 0 0 1 -1 1h-5a1 1 0 0 1 -1 -1v-14c0 -.284 .118 -.54 .308 -.722"
  }), e.createElement("path", {
    d: "M4 8h2"
  }), e.createElement("path", {
    d: "M4 12h3"
  }), e.createElement("path", {
    d: "M4 16h2"
  }), e.createElement("path", {
    d: "M12 4v3"
  }), e.createElement("path", {
    d: "M16 4v2"
  }), e.createElement("path", {
    d: "M3 3l18 18"
  }));
}
var cye = ["size", "color", "stroke"];
function sye(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, cye);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-ruler",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M5 4h14a1 1 0 0 1 1 1v5a1 1 0 0 1 -1 1h-7a1 1 0 0 0 -1 1v7a1 1 0 0 1 -1 1h-5a1 1 0 0 1 -1 -1v-14a1 1 0 0 1 1 -1"
  }), e.createElement("line", {
    x1: 4,
    y1: 8,
    x2: 6,
    y2: 8
  }), e.createElement("line", {
    x1: 4,
    y1: 12,
    x2: 7,
    y2: 12
  }), e.createElement("line", {
    x1: 4,
    y1: 16,
    x2: 6,
    y2: 16
  }), e.createElement("line", {
    x1: 8,
    y1: 4,
    x2: 8,
    y2: 6
  }), e.createElement("polyline", {
    points: "12 4 12 7 "
  }), e.createElement("polyline", {
    points: "16 4 16 6 "
  }));
}
var hye = ["size", "color", "stroke"];
function dye(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, hye);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-run",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("circle", {
    cx: 13,
    cy: 4,
    r: 1
  }), e.createElement("path", {
    d: "M4 17l5 1l.75 -1.5"
  }), e.createElement("path", {
    d: "M15 21l0 -4l-4 -3l1 -6"
  }), e.createElement("path", {
    d: "M7 12l0 -3l5 -1l3 3l3 1"
  }));
}
var vye = ["size", "color", "stroke"];
function mye(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, vye);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-s-turn-down",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M7 5a2 2 0 1 1 -4 0a2 2 0 0 1 4 0z"
  }), e.createElement("path", {
    d: "M5 7v9.5a3.5 3.5 0 0 0 7 0v-9a3.5 3.5 0 0 1 7 0v13.5"
  }), e.createElement("path", {
    d: "M16 18l3 3l3 -3"
  }));
}
var kye = ["size", "color", "stroke"];
function wye(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, kye);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-s-turn-left",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M19 7a2 2 0 1 1 0 -4a2 2 0 0 1 0 4z"
  }), e.createElement("path", {
    d: "M17 5h-9.5a3.5 3.5 0 0 0 0 7h9a3.5 3.5 0 0 1 0 7h-13.5"
  }), e.createElement("path", {
    d: "M6 16l-3 3l3 3"
  }));
}
var pye = ["size", "color", "stroke"];
function Eye(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, pye);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-s-turn-right",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("circle", {
    cx: 5,
    cy: 5,
    r: 2
  }), e.createElement("path", {
    d: "M7 5h9.5a3.5 3.5 0 0 1 0 7h-9a3.5 3.5 0 0 0 0 7h13.5"
  }), e.createElement("path", {
    d: "M18 16l3 3l-3 3"
  }));
}
var uye = ["size", "color", "stroke"];
function gye(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, uye);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-s-turn-up",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M7 19a2 2 0 1 0 -4 0a2 2 0 0 0 4 0z"
  }), e.createElement("path", {
    d: "M5 17v-9.5a3.5 3.5 0 0 1 7 0v9a3.5 3.5 0 0 0 7 0v-13.5"
  }), e.createElement("path", {
    d: "M16 6l3 -3l3 3"
  }));
}
var Mye = ["size", "color", "stroke"];
function xye(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Mye);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-sailboat-2",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M2 20a2.4 2.4 0 0 0 2 1a2.4 2.4 0 0 0 2 -1a2.4 2.4 0 0 1 2 -1a2.4 2.4 0 0 1 2 1a2.4 2.4 0 0 0 2 1a2.4 2.4 0 0 0 2 -1a2.4 2.4 0 0 1 2 -1a2.4 2.4 0 0 1 2 1a2.4 2.4 0 0 0 2 1a2.4 2.4 0 0 0 2 -1"
  }), e.createElement("path", {
    d: "M4 18l-1 -3h18l-1 3"
  }), e.createElement("path", {
    d: "M12 11v4"
  }), e.createElement("path", {
    d: "M7 3c1.333 2.667 1.333 5.333 0 8h10c1.333 -2.667 1.333 -5.333 0 -8"
  }), e.createElement("path", {
    d: "M6 3h12"
  }));
}
var fye = ["size", "color", "stroke"];
function zye(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, fye);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-sailboat-off",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M2 20a2.4 2.4 0 0 0 2 1a2.4 2.4 0 0 0 2 -1a2.4 2.4 0 0 1 2 -1a2.4 2.4 0 0 1 2 1a2.4 2.4 0 0 0 2 1a2.4 2.4 0 0 0 2 -1a2.4 2.4 0 0 1 2 -1a2.4 2.4 0 0 1 2 1a2.4 2.4 0 0 0 2 1a2.4 2.4 0 0 0 2 -1"
  }), e.createElement("path", {
    d: "M4 18l-1 -3h12m4 0h2l-.506 1.517"
  }), e.createElement("path", {
    d: "M11 11v1h1m4 0h2l-7 -9v4"
  }), e.createElement("path", {
    d: "M7.713 7.718l-1.713 4.282"
  }), e.createElement("path", {
    d: "M3 3l18 18"
  }));
}
var bye = ["size", "color", "stroke"];
function Lye(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, bye);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-sailboat",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M2 20a2.4 2.4 0 0 0 2 1a2.4 2.4 0 0 0 2 -1a2.4 2.4 0 0 1 2 -1a2.4 2.4 0 0 1 2 1a2.4 2.4 0 0 0 2 1a2.4 2.4 0 0 0 2 -1a2.4 2.4 0 0 1 2 -1a2.4 2.4 0 0 1 2 1a2.4 2.4 0 0 0 2 1a2.4 2.4 0 0 0 2 -1"
  }), e.createElement("path", {
    d: "M4 18l-1 -3h18l-1 3"
  }), e.createElement("path", {
    d: "M11 12h7l-7 -9v9"
  }), e.createElement("line", {
    x1: 8,
    y1: 7,
    x2: 6,
    y2: 12
  }));
}
var yye = ["size", "color", "stroke"];
function Cye(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, yye);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-salad",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M4 11h16a1 1 0 0 1 1 1v.5c0 1.5 -2.517 5.573 -4 6.5v1a1 1 0 0 1 -1 1h-8a1 1 0 0 1 -1 -1v-1c-1.687 -1.054 -4 -5 -4 -6.5v-.5a1 1 0 0 1 1 -1z"
  }), e.createElement("path", {
    d: "M18.5 11c.351 -1.017 .426 -2.236 .5 -3.714v-1.286h-2.256c-2.83 0 -4.616 .804 -5.64 2.076"
  }), e.createElement("path", {
    d: "M5.255 11.008a12.204 12.204 0 0 1 -.255 -2.008v-1h1.755c.98 0 1.801 .124 2.479 .35"
  }), e.createElement("path", {
    d: "M8 8l1 -4l4 2.5"
  }), e.createElement("path", {
    d: "M13 11v-.5a2.5 2.5 0 1 0 -5 0v.5"
  }));
}
var jye = ["size", "color", "stroke"];
function Bye(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, jye);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-salt",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M12 13v.01"
  }), e.createElement("path", {
    d: "M10 16v.01"
  }), e.createElement("path", {
    d: "M14 16v.01"
  }), e.createElement("path", {
    d: "M7.5 8h9l-.281 -2.248a2 2 0 0 0 -1.985 -1.752h-4.468a2 2 0 0 0 -1.986 1.752l-.28 2.248z"
  }), e.createElement("path", {
    d: "M7.5 8l-1.612 9.671a2 2 0 0 0 1.973 2.329h8.278a2 2 0 0 0 1.973 -2.329l-1.612 -9.671"
  }));
}
var Hye = ["size", "color", "stroke"];
function Nye(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Hye);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-satellite-off",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M7.707 3.707l5.586 5.586m-1.293 2.707l-1.293 1.293a1 1 0 0 1 -1.414 0l-5.586 -5.586a1 1 0 0 1 0 -1.414l1.293 -1.293"
  }), e.createElement("path", {
    d: "M6 10l-3 3l3 3l3 -3"
  }), e.createElement("path", {
    d: "M10 6l3 -3l3 3l-3 3"
  }), e.createElement("path", {
    d: "M12 12l1.5 1.5"
  }), e.createElement("path", {
    d: "M14.5 17c.69 0 1.316 -.28 1.769 -.733"
  }), e.createElement("path", {
    d: "M15 21c1.654 0 3.151 -.67 4.237 -1.752m1.507 -2.507a6 6 0 0 0 .256 -1.741"
  }), e.createElement("path", {
    d: "M3 3l18 18"
  }));
}
var Wye = ["size", "color", "stroke"];
function qye(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Wye);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-satellite",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M3.707 6.293l2.586 -2.586a1 1 0 0 1 1.414 0l5.586 5.586a1 1 0 0 1 0 1.414l-2.586 2.586a1 1 0 0 1 -1.414 0l-5.586 -5.586a1 1 0 0 1 0 -1.414z"
  }), e.createElement("path", {
    d: "M6 10l-3 3l3 3l3 -3"
  }), e.createElement("path", {
    d: "M10 6l3 -3l3 3l-3 3"
  }), e.createElement("line", {
    x1: 12,
    y1: 12,
    x2: 13.5,
    y2: 13.5
  }), e.createElement("path", {
    d: "M14.5 17a2.5 2.5 0 0 0 2.5 -2.5"
  }), e.createElement("path", {
    d: "M15 21a6 6 0 0 0 6 -6"
  }));
}
var Oye = ["size", "color", "stroke"];
function Pye(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Oye);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-sausage",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M5.5 5.5a2.5 2.5 0 0 0 -2.5 2.5c0 7.18 5.82 13 13 13a2.5 2.5 0 1 0 0 -5a8 8 0 0 1 -8 -8a2.5 2.5 0 0 0 -2.5 -2.5z"
  }), e.createElement("path", {
    d: "M5.195 5.519l-1.243 -1.989a1 1 0 0 1 .848 -1.53h1.392a1 1 0 0 1 .848 1.53l-1.245 1.99"
  }), e.createElement("path", {
    d: "M18.482 18.225l1.989 -1.243a1 1 0 0 1 1.53 .848v1.392a1 1 0 0 1 -1.53 .848l-1.991 -1.245"
  }));
}
var Sye = ["size", "color", "stroke"];
function Iye(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Sye);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-scale-off",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M7 20h10"
  }), e.createElement("path", {
    d: "M9.452 5.425l2.548 -.425l6 1"
  }), e.createElement("path", {
    d: "M12 3v5m0 4v8"
  }), e.createElement("path", {
    d: "M9 12l-3 -6l-3 6a3 3 0 0 0 6 0"
  }), e.createElement("path", {
    d: "M18.873 14.871a3.001 3.001 0 0 0 2.127 -2.871l-3 -6l-2.677 5.355"
  }), e.createElement("path", {
    d: "M3 3l18 18"
  }));
}
var Aye = ["size", "color", "stroke"];
function Dye(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Aye);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-scale-outline-off",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M7 3h10a4 4 0 0 1 4 4v10m-1.173 2.83a3.987 3.987 0 0 1 -2.827 1.17h-10a4 4 0 0 1 -4 -4v-10c0 -1.104 .447 -2.103 1.17 -2.827"
  }), e.createElement("path", {
    d: "M11.062 7.062c.31 -.041 .622 -.062 .938 -.062c1.956 0 3.724 .802 4.994 2.095a142.85 142.85 0 0 0 -1.994 1.905m-3.723 .288a3 3 0 0 0 -1.315 .71l-2.956 -2.903a6.977 6.977 0 0 1 1.142 -.942"
  }), e.createElement("path", {
    d: "M3 3l18 18"
  }));
}
var Fye = ["size", "color", "stroke"];
function Gye(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Fye);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-scale-outline",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("rect", {
    x: 3,
    y: 3,
    width: 18,
    height: 18,
    rx: 4
  }), e.createElement("path", {
    d: "M12 7c1.956 0 3.724 .802 4.994 2.095l-2.956 2.904a3 3 0 0 0 -2.038 -.799a3 3 0 0 0 -2.038 .798l-2.956 -2.903a6.979 6.979 0 0 1 4.994 -2.095z"
  }));
}
var Jye = ["size", "color", "stroke"];
function Kye(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Jye);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-scale",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("line", {
    x1: 7,
    y1: 20,
    x2: 17,
    y2: 20
  }), e.createElement("path", {
    d: "M6 6l6 -1l6 1"
  }), e.createElement("line", {
    x1: 12,
    y1: 3,
    x2: 12,
    y2: 20
  }), e.createElement("path", {
    d: "M9 12l-3 -6l-3 6a3 3 0 0 0 6 0"
  }), e.createElement("path", {
    d: "M21 12l-3 -6l-3 6a3 3 0 0 0 6 0"
  }));
}
var Qye = ["size", "color", "stroke"];
function Rye(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Qye);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-scan-eye",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M4 8v-2a2 2 0 0 1 2 -2h2"
  }), e.createElement("path", {
    d: "M4 16v2a2 2 0 0 0 2 2h2"
  }), e.createElement("path", {
    d: "M16 4h2a2 2 0 0 1 2 2v2"
  }), e.createElement("path", {
    d: "M16 20h2a2 2 0 0 0 2 -2v-2"
  }), e.createElement("path", {
    d: "M7 12c3.333 -4.667 6.667 -4.667 10 0"
  }), e.createElement("path", {
    d: "M7 12c3.333 4.667 6.667 4.667 10 0"
  }), e.createElement("path", {
    d: "M12 12h-.01"
  }));
}
var Tye = ["size", "color", "stroke"];
function Uye(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Tye);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-scan",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M4 7v-1a2 2 0 0 1 2 -2h2"
  }), e.createElement("path", {
    d: "M4 17v1a2 2 0 0 0 2 2h2"
  }), e.createElement("path", {
    d: "M16 4h2a2 2 0 0 1 2 2v1"
  }), e.createElement("path", {
    d: "M16 20h2a2 2 0 0 0 2 -2v-1"
  }), e.createElement("line", {
    x1: 5,
    y1: 12,
    x2: 19,
    y2: 12
  }));
}
var Vye = ["size", "color", "stroke"];
function Xye(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Vye);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-schema-off",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M6 2h4v4m-4 0h-1v-1"
  }), e.createElement("path", {
    d: "M15 11v-1h5v4h-2"
  }), e.createElement("path", {
    d: "M5 18h5v4h-5z"
  }), e.createElement("path", {
    d: "M5 10h5v4h-5z"
  }), e.createElement("path", {
    d: "M10 12h2"
  }), e.createElement("path", {
    d: "M7.5 7.5v2.5"
  }), e.createElement("path", {
    d: "M7.5 14v4"
  }), e.createElement("path", {
    d: "M3 3l18 18"
  }));
}
var Yye = ["size", "color", "stroke"];
function Zye(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Yye);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-schema",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M5 2h5v4h-5z"
  }), e.createElement("path", {
    d: "M15 10h5v4h-5z"
  }), e.createElement("path", {
    d: "M5 18h5v4h-5z"
  }), e.createElement("path", {
    d: "M5 10h5v4h-5z"
  }), e.createElement("path", {
    d: "M10 12h5"
  }), e.createElement("path", {
    d: "M7.5 6v4"
  }), e.createElement("path", {
    d: "M7.5 14v4"
  }));
}
var $ye = ["size", "color", "stroke"];
function _ye(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, $ye);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-school-bell",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M4 17a3 3 0 0 0 3 3"
  }), e.createElement("path", {
    d: "M14.805 6.37l2.783 -2.784a2 2 0 1 1 2.829 2.828l-2.784 2.786"
  }), e.createElement("path", {
    d: "M16.505 7.495a5.105 5.105 0 0 1 .176 7.035l-.176 .184l-1.867 1.867a3.48 3.48 0 0 0 -1.013 2.234l-.008 .23v.934c0 .327 -.13 .64 -.36 .871a0.51 .51 0 0 1 -.652 .06l-.07 -.06l-9.385 -9.384a0.51 .51 0 0 1 0 -.722c.198 -.198 .456 -.322 .732 -.353l.139 -.008h.933c.848 0 1.663 -.309 2.297 -.864l.168 -.157l1.867 -1.867l.16 -.153a5.105 5.105 0 0 1 7.059 .153z"
  }));
}
var eCe = ["size", "color", "stroke"];
function tCe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, eCe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-school-off",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M22 9l-10 -4l-2.136 .854m-2.864 1.146l-5 2l10 4l.697 -.279m2.878 -1.151l6.425 -2.57v6"
  }), e.createElement("path", {
    d: "M6 10.6v5.4c0 1.657 2.686 3 6 3c2.334 0 4.357 -.666 5.35 -1.64m.65 -3.36v-3.4"
  }), e.createElement("path", {
    d: "M3 3l18 18"
  }));
}
var oCe = ["size", "color", "stroke"];
function rCe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, oCe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-school",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M22 9l-10 -4l-10 4l10 4l10 -4v6"
  }), e.createElement("path", {
    d: "M6 10.6v5.4a6 3 0 0 0 12 0v-5.4"
  }));
}
var nCe = ["size", "color", "stroke"];
function lCe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, nCe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-scissors-off",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M4.432 4.442a3 3 0 1 0 4.114 4.146"
  }), e.createElement("circle", {
    cx: 6,
    cy: 17,
    r: 3
  }), e.createElement("path", {
    d: "M8.6 15.4l3.4 -3.4m2 -2l5 -5"
  }), e.createElement("path", {
    d: "M3 3l18 18"
  }));
}
var aCe = ["size", "color", "stroke"];
function iCe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, aCe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-scissors",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("circle", {
    cx: 6,
    cy: 7,
    r: 3
  }), e.createElement("circle", {
    cx: 6,
    cy: 17,
    r: 3
  }), e.createElement("line", {
    x1: 8.6,
    y1: 8.6,
    x2: 19,
    y2: 19
  }), e.createElement("line", {
    x1: 8.6,
    y1: 15.4,
    x2: 19,
    y2: 5
  }));
}
var cCe = ["size", "color", "stroke"];
function sCe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, cCe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-scooter-electric",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("circle", {
    cx: 18,
    cy: 17,
    r: 2
  }), e.createElement("circle", {
    cx: 6,
    cy: 17,
    r: 2
  }), e.createElement("path", {
    d: "M8 17h5a6 6 0 0 1 5 -5v-5a2 2 0 0 0 -2 -2h-1"
  }), e.createElement("path", {
    d: "M10 4l-2 4h3l-2 4"
  }));
}
var hCe = ["size", "color", "stroke"];
function dCe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, hCe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-scooter",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("circle", {
    cx: 18,
    cy: 17,
    r: 2
  }), e.createElement("circle", {
    cx: 6,
    cy: 17,
    r: 2
  }), e.createElement("path", {
    d: "M8 17h5a6 6 0 0 1 5 -5v-5a2 2 0 0 0 -2 -2h-1"
  }));
}
var vCe = ["size", "color", "stroke"];
function mCe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, vCe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-screen-share-off",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M21 12v3a1 1 0 0 1 -1 1h-16a1 1 0 0 1 -1 -1v-10a1 1 0 0 1 1 -1h9"
  }), e.createElement("line", {
    x1: 7,
    y1: 20,
    x2: 17,
    y2: 20
  }), e.createElement("line", {
    x1: 9,
    y1: 16,
    x2: 9,
    y2: 20
  }), e.createElement("line", {
    x1: 15,
    y1: 16,
    x2: 15,
    y2: 20
  }), e.createElement("path", {
    d: "M17 8l4 -4m-4 0l4 4"
  }));
}
var kCe = ["size", "color", "stroke"];
function wCe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, kCe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-screen-share",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M21 12v3a1 1 0 0 1 -1 1h-16a1 1 0 0 1 -1 -1v-10a1 1 0 0 1 1 -1h9"
  }), e.createElement("line", {
    x1: 7,
    y1: 20,
    x2: 17,
    y2: 20
  }), e.createElement("line", {
    x1: 9,
    y1: 16,
    x2: 9,
    y2: 20
  }), e.createElement("line", {
    x1: 15,
    y1: 16,
    x2: 15,
    y2: 20
  }), e.createElement("path", {
    d: "M17 4h4v4"
  }), e.createElement("path", {
    d: "M16 9l5 -5"
  }));
}
var pCe = ["size", "color", "stroke"];
function ECe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, pCe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-screenshot",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M7 19a2 2 0 0 1 -2 -2"
  }), e.createElement("path", {
    d: "M5 13v-2"
  }), e.createElement("path", {
    d: "M5 7a2 2 0 0 1 2 -2"
  }), e.createElement("path", {
    d: "M11 5h2"
  }), e.createElement("path", {
    d: "M17 5a2 2 0 0 1 2 2"
  }), e.createElement("path", {
    d: "M19 11v2"
  }), e.createElement("path", {
    d: "M19 17v4"
  }), e.createElement("path", {
    d: "M21 19h-4"
  }), e.createElement("path", {
    d: "M13 19h-2"
  }));
}
var uCe = ["size", "color", "stroke"];
function gCe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, uCe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-scribble-off",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M3 15c2 3 4 4 7 4c1.95 0 4.324 -1.268 5.746 -3.256m1.181 -2.812a5.97 5.97 0 0 0 .073 -.932c0 -4 -3 -7 -6 -7c-.642 0 -1.239 .069 -1.78 .201m-2.492 1.515c-.47 .617 -.728 1.386 -.728 2.284c0 2.5 2 5 6 5c.597 0 1.203 -.055 1.808 -.156m3.102 -.921c2.235 -.953 4.152 -2.423 5.09 -3.923"
  }), e.createElement("path", {
    d: "M3 3l18 18"
  }));
}
var MCe = ["size", "color", "stroke"];
function xCe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, MCe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-scribble",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M3 15c2 3 4 4 7 4s7 -3 7 -7s-3 -7 -6 -7s-5 1.5 -5 4s2 5 6 5s8.408 -2.453 10 -5"
  }));
}
var fCe = ["size", "color", "stroke"];
function zCe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, fCe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-script-minus",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M17 19h4"
  }), e.createElement("path", {
    d: "M14 20h-8a3 3 0 0 1 0 -6h11a3 3 0 0 0 -3 3m7 -2v-9a2 2 0 0 0 -2 -2h-10a2 2 0 0 0 -2 2v8"
  }));
}
var bCe = ["size", "color", "stroke"];
function LCe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, bCe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-script-plus",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M17 19h4"
  }), e.createElement("path", {
    d: "M14 20h-8a3 3 0 0 1 0 -6h11a3 3 0 0 0 -3 3m7 -3v-8a2 2 0 0 0 -2 -2h-10a2 2 0 0 0 -2 2v8"
  }), e.createElement("path", {
    d: "M19 17v4"
  }));
}
var yCe = ["size", "color", "stroke"];
function CCe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, yCe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-script-x",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M14 20h-8a3 3 0 0 1 0 -6h11a3 3 0 0 0 -3 3m7 -3v-8a2 2 0 0 0 -2 -2h-10a2 2 0 0 0 -2 2v8"
  }), e.createElement("path", {
    d: "M17 17l4 4m0 -4l-4 4"
  }));
}
var jCe = ["size", "color", "stroke"];
function BCe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, jCe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-script",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M17 20h-11a3 3 0 0 1 0 -6h11a3 3 0 0 0 0 6h1a3 3 0 0 0 3 -3v-11a2 2 0 0 0 -2 -2h-10a2 2 0 0 0 -2 2v8"
  }));
}
var HCe = ["size", "color", "stroke"];
function NCe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, HCe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-scuba-mask-off",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M11 7h5a1 1 0 0 1 1 1v4.5c0 .154 -.014 .304 -.04 .45m-1.997 2.007c-.15 .028 -.305 .043 -.463 .043h-.5a2 2 0 0 1 -2 -2a2 2 0 1 0 -4 0a2 2 0 0 1 -2 2h-.5a2.5 2.5 0 0 1 -2.5 -2.5v-4.5a1 1 0 0 1 1 -1h3"
  }), e.createElement("path", {
    d: "M10 17a2 2 0 0 0 2 2h3.5a5.475 5.475 0 0 0 2.765 -.744m1.996 -2c.47 -.81 .739 -1.752 .739 -2.756v-9.5"
  }), e.createElement("path", {
    d: "M3 3l18 18"
  }));
}
var WCe = ["size", "color", "stroke"];
function qCe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, WCe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-scuba-mask",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M4 7h12a1 1 0 0 1 1 1v4.5a2.5 2.5 0 0 1 -2.5 2.5h-.5a2 2 0 0 1 -2 -2a2 2 0 1 0 -4 0a2 2 0 0 1 -2 2h-.5a2.5 2.5 0 0 1 -2.5 -2.5v-4.5a1 1 0 0 1 1 -1z"
  }), e.createElement("path", {
    d: "M10 17a2 2 0 0 0 2 2h3.5a5.5 5.5 0 0 0 5.5 -5.5v-9.5"
  }));
}
var OCe = ["size", "color", "stroke"];
function PCe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, OCe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-sdk",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M7 8h-3a1 1 0 0 0 -1 1v2a1 1 0 0 0 1 1h2a1 1 0 0 1 1 1v2a1 1 0 0 1 -1 1h-3"
  }), e.createElement("path", {
    d: "M17 8v8"
  }), e.createElement("path", {
    d: "M21 8l-3 4l3 4"
  }), e.createElement("path", {
    d: "M17 12h1"
  }), e.createElement("path", {
    d: "M10 8v8h2a2 2 0 0 0 2 -2v-4a2 2 0 0 0 -2 -2h-2z"
  }));
}
var SCe = ["size", "color", "stroke"];
function ICe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, SCe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-search-off",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M5.039 5.062a7 7 0 0 0 9.91 9.89m1.584 -2.434a7 7 0 0 0 -9.038 -9.057"
  }), e.createElement("path", {
    d: "M3 3l18 18"
  }));
}
var ACe = ["size", "color", "stroke"];
function DCe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, ACe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-search",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 7
  }), e.createElement("line", {
    x1: 21,
    y1: 21,
    x2: 15,
    y2: 15
  }));
}
var FCe = ["size", "color", "stroke"];
function GCe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, FCe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-section-sign",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M9.172 19.004a3.001 3.001 0 1 0 2.828 -4.004"
  }), e.createElement("path", {
    d: "M14.83 5.002a3.001 3.001 0 1 0 -2.83 3.998"
  }), e.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 3
  }));
}
var JCe = ["size", "color", "stroke"];
function KCe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, JCe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-section",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M20 20h.01"
  }), e.createElement("path", {
    d: "M4 20h.01"
  }), e.createElement("path", {
    d: "M8 20h.01"
  }), e.createElement("path", {
    d: "M12 20h.01"
  }), e.createElement("path", {
    d: "M16 20h.01"
  }), e.createElement("path", {
    d: "M20 4h.01"
  }), e.createElement("path", {
    d: "M4 4h.01"
  }), e.createElement("path", {
    d: "M8 4h.01"
  }), e.createElement("path", {
    d: "M12 4h.01"
  }), e.createElement("path", {
    d: "M16 4l0 0"
  }), e.createElement("rect", {
    x: 4,
    y: 8,
    width: 16,
    height: 8,
    rx: 1
  }));
}
var QCe = ["size", "color", "stroke"];
function RCe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, QCe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-seeding-off",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M11.412 7.407a6.025 6.025 0 0 0 -2.82 -2.82m-4.592 -.587h-1v2a6 6 0 0 0 6 6h3"
  }), e.createElement("path", {
    d: "M12 14a6 6 0 0 1 .255 -1.736m1.51 -2.514a5.981 5.981 0 0 1 4.235 -1.75h3v1c0 2.158 -1.14 4.05 -2.85 5.107m-3.15 .893h-3"
  }), e.createElement("path", {
    d: "M12 20v-8"
  }), e.createElement("path", {
    d: "M3 3l18 18"
  }));
}
var TCe = ["size", "color", "stroke"];
function UCe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, TCe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-seeding",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M12 10a6 6 0 0 0 -6 -6h-3v2a6 6 0 0 0 6 6h3"
  }), e.createElement("path", {
    d: "M12 14a6 6 0 0 1 6 -6h3v1a6 6 0 0 1 -6 6h-3"
  }), e.createElement("line", {
    x1: 12,
    y1: 20,
    x2: 12,
    y2: 10
  }));
}
var VCe = ["size", "color", "stroke"];
function XCe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, VCe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-select",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("rect", {
    x: 4,
    y: 4,
    width: 16,
    height: 16,
    rx: 2
  }), e.createElement("path", {
    d: "M9 11l3 3l3 -3"
  }));
}
var YCe = ["size", "color", "stroke"];
function ZCe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, YCe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-selector",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("polyline", {
    points: "8 9 12 5 16 9"
  }), e.createElement("polyline", {
    points: "16 15 12 19 8 15"
  }));
}
var $Ce = ["size", "color", "stroke"];
function _Ce(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, $Ce);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-send-off",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M10 14l2.001 -2.001m1.999 -1.999l7 -7"
  }), e.createElement("path", {
    d: "M10.718 6.713l10.282 -3.713l-3.715 10.289m-1.063 2.941l-1.722 4.77a0.55 .55 0 0 1 -1 0l-3.5 -7l-7 -3.5a0.55 .55 0 0 1 0 -1l4.772 -1.723"
  }), e.createElement("path", {
    d: "M3 3l18 18"
  }));
}
var eje = ["size", "color", "stroke"];
function tje(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, eje);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-send",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("line", {
    x1: 10,
    y1: 14,
    x2: 21,
    y2: 3
  }), e.createElement("path", {
    d: "M21 3l-6.5 18a0.55 .55 0 0 1 -1 0l-3.5 -7l-7 -3.5a0.55 .55 0 0 1 0 -1l18 -6.5"
  }));
}
var oje = ["size", "color", "stroke"];
function rje(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, oje);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-seo",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M7 8h-3a1 1 0 0 0 -1 1v2a1 1 0 0 0 1 1h2a1 1 0 0 1 1 1v2a1 1 0 0 1 -1 1h-3"
  }), e.createElement("path", {
    d: "M14 16h-4v-8h4"
  }), e.createElement("path", {
    d: "M11 12h2"
  }), e.createElement("rect", {
    x: 17,
    y: 8,
    width: 4,
    height: 8,
    rx: 1
  }));
}
var nje = ["size", "color", "stroke"];
function lje(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, nje);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-separator-horizontal",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("line", {
    x1: 4,
    y1: 12,
    x2: 20,
    y2: 12
  }), e.createElement("polyline", {
    points: "8 8 12 4 16 8"
  }), e.createElement("polyline", {
    points: "16 16 12 20 8 16"
  }));
}
var aje = ["size", "color", "stroke"];
function ije(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, aje);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-separator-vertical",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("line", {
    x1: 12,
    y1: 4,
    x2: 12,
    y2: 20
  }), e.createElement("polyline", {
    points: "8 8 4 12 8 16"
  }), e.createElement("polyline", {
    points: "16 16 20 12 16 8"
  }));
}
var cje = ["size", "color", "stroke"];
function sje(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, cje);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-separator",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("line", {
    x1: 3,
    y1: 12,
    x2: 3,
    y2: 12.01
  }), e.createElement("line", {
    x1: 7,
    y1: 12,
    x2: 17,
    y2: 12
  }), e.createElement("line", {
    x1: 21,
    y1: 12,
    x2: 21,
    y2: 12.01
  }));
}
var hje = ["size", "color", "stroke"];
function dje(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, hje);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-server-2",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("rect", {
    x: 3,
    y: 4,
    width: 18,
    height: 8,
    rx: 3
  }), e.createElement("rect", {
    x: 3,
    y: 12,
    width: 18,
    height: 8,
    rx: 3
  }), e.createElement("line", {
    x1: 7,
    y1: 8,
    x2: 7,
    y2: 8.01
  }), e.createElement("line", {
    x1: 7,
    y1: 16,
    x2: 7,
    y2: 16.01
  }), e.createElement("path", {
    d: "M11 8h6"
  }), e.createElement("path", {
    d: "M11 16h6"
  }));
}
var vje = ["size", "color", "stroke"];
function mje(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, vje);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-server-bolt",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("rect", {
    x: 3,
    y: 4,
    width: 18,
    height: 8,
    rx: 3
  }), e.createElement("path", {
    d: "M15 20h-9a3 3 0 0 1 -3 -3v-2a3 3 0 0 1 3 -3h12"
  }), e.createElement("path", {
    d: "M7 8v.01"
  }), e.createElement("path", {
    d: "M7 16v.01"
  }), e.createElement("path", {
    d: "M20 15l-2 3h3l-2 3"
  }));
}
var kje = ["size", "color", "stroke"];
function wje(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, kje);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-server-cog",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("rect", {
    x: 3,
    y: 4,
    width: 18,
    height: 8,
    rx: 3
  }), e.createElement("path", {
    d: "M12 20h-6a3 3 0 0 1 -3 -3v-2a3 3 0 0 1 3 -3h10.5"
  }), e.createElement("circle", {
    cx: 18.001,
    cy: 18,
    r: 2
  }), e.createElement("path", {
    d: "M18.001 14.5v1.5"
  }), e.createElement("path", {
    d: "M18.001 20v1.5"
  }), e.createElement("path", {
    d: "M21.032 16.25l-1.299 .75"
  }), e.createElement("path", {
    d: "M16.27 19l-1.3 .75"
  }), e.createElement("path", {
    d: "M14.97 16.25l1.3 .75"
  }), e.createElement("path", {
    d: "M19.733 19l1.3 .75"
  }), e.createElement("path", {
    d: "M7 8v.01"
  }), e.createElement("path", {
    d: "M7 16v.01"
  }));
}
var pje = ["size", "color", "stroke"];
function Eje(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, pje);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-server-off",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M12 12h-6a3 3 0 0 1 -3 -3v-2c0 -1.083 .574 -2.033 1.435 -2.56m3.565 -.44h10a3 3 0 0 1 3 3v2a3 3 0 0 1 -3 3h-2"
  }), e.createElement("path", {
    d: "M16 12h2a3 3 0 0 1 3 3v2m-1.448 2.568a2.986 2.986 0 0 1 -1.552 .432h-12a3 3 0 0 1 -3 -3v-2a3 3 0 0 1 3 -3h6"
  }), e.createElement("path", {
    d: "M7 8v.01"
  }), e.createElement("path", {
    d: "M7 16v.01"
  }), e.createElement("path", {
    d: "M3 3l18 18"
  }));
}
var uje = ["size", "color", "stroke"];
function gje(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, uje);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-server",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("rect", {
    x: 3,
    y: 4,
    width: 18,
    height: 8,
    rx: 3
  }), e.createElement("rect", {
    x: 3,
    y: 12,
    width: 18,
    height: 8,
    rx: 3
  }), e.createElement("line", {
    x1: 7,
    y1: 8,
    x2: 7,
    y2: 8.01
  }), e.createElement("line", {
    x1: 7,
    y1: 16,
    x2: 7,
    y2: 16.01
  }));
}
var Mje = ["size", "color", "stroke"];
function xje(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Mje);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-servicemark",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M9 9h-2.5a1.5 1.5 0 0 0 0 3h1a1.5 1.5 0 0 1 0 3h-2.5"
  }), e.createElement("path", {
    d: "M13 15v-6l3 4l3 -4v6"
  }));
}
var fje = ["size", "color", "stroke"];
function zje(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, fje);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-settings-2",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M19 6.873a2 2 0 0 1 1 1.747v6.536a2 2 0 0 1 -1.029 1.748l-6 3.833a2 2 0 0 1 -1.942 0l-6 -3.833a2 2 0 0 1 -1.029 -1.747v-6.537a2 2 0 0 1 1.029 -1.748l6 -3.572a2.056 2.056 0 0 1 2 0l6 3.573h-.029z"
  }), e.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 3
  }));
}
var bje = ["size", "color", "stroke"];
function Lje(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, bje);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-settings-automation",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M10.325 4.317c.426 -1.756 2.924 -1.756 3.35 0a1.724 1.724 0 0 0 2.573 1.066c1.543 -.94 3.31 .826 2.37 2.37a1.724 1.724 0 0 0 1.065 2.572c1.756 .426 1.756 2.924 0 3.35a1.724 1.724 0 0 0 -1.066 2.573c.94 1.543 -.826 3.31 -2.37 2.37a1.724 1.724 0 0 0 -2.572 1.065c-.426 1.756 -2.924 1.756 -3.35 0a1.724 1.724 0 0 0 -2.573 -1.066c-1.543 .94 -3.31 -.826 -2.37 -2.37a1.724 1.724 0 0 0 -1.065 -2.572c-1.756 -.426 -1.756 -2.924 0 -3.35a1.724 1.724 0 0 0 1.066 -2.573c-.94 -1.543 .826 -3.31 2.37 -2.37c1 .608 2.296 .07 2.572 -1.065z"
  }), e.createElement("path", {
    d: "M10 9v6l5 -3z"
  }));
}
var yje = ["size", "color", "stroke"];
function Cje(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, yje);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-settings-off",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M9.456 5.435c.416 -.22 .745 -.609 .869 -1.118c.426 -1.756 2.924 -1.756 3.35 0a1.724 1.724 0 0 0 2.573 1.066c1.543 -.94 3.31 .826 2.37 2.37a1.724 1.724 0 0 0 1.065 2.572c1.756 .426 1.756 2.924 0 3.35a1.724 1.724 0 0 0 -1.187 1.016m-.126 3.666c-.516 .522 -1.348 .733 -2.123 .261a1.724 1.724 0 0 0 -2.572 1.065c-.426 1.756 -2.924 1.756 -3.35 0a1.724 1.724 0 0 0 -2.573 -1.066c-1.543 .94 -3.31 -.826 -2.37 -2.37a1.724 1.724 0 0 0 -1.065 -2.572c-1.756 -.426 -1.756 -2.924 0 -3.35a1.724 1.724 0 0 0 1.066 -2.573c-.468 -.768 -.266 -1.59 .246 -2.108"
  }), e.createElement("path", {
    d: "M9.879 9.878a3 3 0 1 0 4.256 4.23m.552 -3.444a3.012 3.012 0 0 0 -1.412 -1.38"
  }), e.createElement("path", {
    d: "M3 3l18 18"
  }));
}
var jje = ["size", "color", "stroke"];
function Bje(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, jje);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-settings",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M10.325 4.317c.426 -1.756 2.924 -1.756 3.35 0a1.724 1.724 0 0 0 2.573 1.066c1.543 -.94 3.31 .826 2.37 2.37a1.724 1.724 0 0 0 1.065 2.572c1.756 .426 1.756 2.924 0 3.35a1.724 1.724 0 0 0 -1.066 2.573c.94 1.543 -.826 3.31 -2.37 2.37a1.724 1.724 0 0 0 -2.572 1.065c-.426 1.756 -2.924 1.756 -3.35 0a1.724 1.724 0 0 0 -2.573 -1.066c-1.543 .94 -3.31 -.826 -2.37 -2.37a1.724 1.724 0 0 0 -1.065 -2.572c-1.756 -.426 -1.756 -2.924 0 -3.35a1.724 1.724 0 0 0 1.066 -2.573c-.94 -1.543 .826 -3.31 2.37 -2.37c1 .608 2.296 .07 2.572 -1.065z"
  }), e.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 3
  }));
}
var Hje = ["size", "color", "stroke"];
function Nje(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Hje);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-shadow-off",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M5.634 5.638a9 9 0 0 0 12.728 12.727m1.68 -2.32a9 9 0 0 0 -12.086 -12.088"
  }), e.createElement("path", {
    d: "M16 12h2"
  }), e.createElement("path", {
    d: "M13 15h2"
  }), e.createElement("path", {
    d: "M13 18h1"
  }), e.createElement("path", {
    d: "M13 9h4"
  }), e.createElement("path", {
    d: "M13 6h1"
  }), e.createElement("path", {
    d: "M3 3l18 18"
  }));
}
var Wje = ["size", "color", "stroke"];
function qje(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Wje);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-shadow",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 9
  }), e.createElement("path", {
    d: "M13 12h5"
  }), e.createElement("path", {
    d: "M13 15h4"
  }), e.createElement("path", {
    d: "M13 18h1"
  }), e.createElement("path", {
    d: "M13 9h4"
  }), e.createElement("path", {
    d: "M13 6h1"
  }));
}
var Oje = ["size", "color", "stroke"];
function Pje(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Oje);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-shape-2",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("circle", {
    cx: 5,
    cy: 5,
    r: 2
  }), e.createElement("circle", {
    cx: 19,
    cy: 19,
    r: 2
  }), e.createElement("circle", {
    cx: 19,
    cy: 5,
    r: 2
  }), e.createElement("circle", {
    cx: 5,
    cy: 19,
    r: 2
  }), e.createElement("path", {
    d: "M6.5 17.5l11 -11m-12.5 .5v10m14 -10v10"
  }));
}
var Sje = ["size", "color", "stroke"];
function Ije(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Sje);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-shape-3",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("circle", {
    cx: 5,
    cy: 5,
    r: 2
  }), e.createElement("circle", {
    cx: 19,
    cy: 19,
    r: 2
  }), e.createElement("circle", {
    cx: 19,
    cy: 5,
    r: 2
  }), e.createElement("circle", {
    cx: 5,
    cy: 19,
    r: 2
  }), e.createElement("path", {
    d: "M7 5h10m-12 2v10m14 -10v10"
  }));
}
var Aje = ["size", "color", "stroke"];
function Dje(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Aje);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-shape-off",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M3.575 3.597a2 2 0 0 0 2.849 2.808"
  }), e.createElement("circle", {
    cx: 19,
    cy: 5,
    r: 2
  }), e.createElement("circle", {
    cx: 5,
    cy: 19,
    r: 2
  }), e.createElement("path", {
    d: "M17.574 17.598a2 2 0 0 0 2.826 2.83"
  }), e.createElement("path", {
    d: "M5 7v10"
  }), e.createElement("path", {
    d: "M9 5h8"
  }), e.createElement("path", {
    d: "M7 19h10"
  }), e.createElement("path", {
    d: "M19 7v8"
  }), e.createElement("path", {
    d: "M3 3l18 18"
  }));
}
var Fje = ["size", "color", "stroke"];
function Gje(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Fje);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-shape",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("circle", {
    cx: 5,
    cy: 5,
    r: 2
  }), e.createElement("circle", {
    cx: 19,
    cy: 5,
    r: 2
  }), e.createElement("circle", {
    cx: 5,
    cy: 19,
    r: 2
  }), e.createElement("circle", {
    cx: 19,
    cy: 19,
    r: 2
  }), e.createElement("line", {
    x1: 5,
    y1: 7,
    x2: 5,
    y2: 17
  }), e.createElement("line", {
    x1: 7,
    y1: 5,
    x2: 17,
    y2: 5
  }), e.createElement("line", {
    x1: 7,
    y1: 19,
    x2: 17,
    y2: 19
  }), e.createElement("line", {
    x1: 19,
    y1: 7,
    x2: 19,
    y2: 17
  }));
}
var Jje = ["size", "color", "stroke"];
function Kje(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Jje);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-share-off",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("circle", {
    cx: 6,
    cy: 12,
    r: 3
  }), e.createElement("circle", {
    cx: 18,
    cy: 6,
    r: 3
  }), e.createElement("path", {
    d: "M15.861 15.896a3 3 0 0 0 4.265 4.22m.578 -3.417a3.012 3.012 0 0 0 -1.507 -1.45"
  }), e.createElement("path", {
    d: "M8.7 10.7l1.336 -.688m2.624 -1.352l2.64 -1.36"
  }), e.createElement("path", {
    d: "M8.7 13.3l6.6 3.4"
  }), e.createElement("path", {
    d: "M3 3l18 18"
  }));
}
var Qje = ["size", "color", "stroke"];
function Rje(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Qje);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-share",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("circle", {
    cx: 6,
    cy: 12,
    r: 3
  }), e.createElement("circle", {
    cx: 18,
    cy: 6,
    r: 3
  }), e.createElement("circle", {
    cx: 18,
    cy: 18,
    r: 3
  }), e.createElement("line", {
    x1: 8.7,
    y1: 10.7,
    x2: 15.3,
    y2: 7.3
  }), e.createElement("line", {
    x1: 8.7,
    y1: 13.3,
    x2: 15.3,
    y2: 16.7
  }));
}
var Tje = ["size", "color", "stroke"];
function Uje(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Tje);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-shield-check",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M9 12l2 2l4 -4"
  }), e.createElement("path", {
    d: "M12 3a12 12 0 0 0 8.5 3a12 12 0 0 1 -8.5 15a12 12 0 0 1 -8.5 -15a12 12 0 0 0 8.5 -3"
  }));
}
var Vje = ["size", "color", "stroke"];
function Xje(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Vje);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-shield-checkered",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M12 3a12 12 0 0 0 8.5 3a12 12 0 0 1 -8.5 15a12 12 0 0 1 -8.5 -15a12 12 0 0 0 8.5 -3"
  }), e.createElement("path", {
    d: "M12 3v18"
  }), e.createElement("path", {
    d: "M3.5 12h17"
  }));
}
var Yje = ["size", "color", "stroke"];
function Zje(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Yje);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-shield-chevron",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M12 3a12 12 0 0 0 8.5 3a12 12 0 0 1 -8.5 15a12 12 0 0 1 -8.5 -15a12 12 0 0 0 8.5 -3"
  }), e.createElement("path", {
    d: "M4 14l8 -3l8 3"
  }));
}
var $je = ["size", "color", "stroke"];
function _je(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, $je);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-shield-half-filled",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M12 3a12 12 0 0 0 8.5 3a12 12 0 0 1 -8.5 15a12 12 0 0 1 -8.5 -15a12 12 0 0 0 8.5 -3"
  }), e.createElement("path", {
    d: "M12 3v18"
  }), e.createElement("path", {
    d: "M12 11h8.9"
  }), e.createElement("path", {
    d: "M12 8h8.9"
  }), e.createElement("path", {
    d: "M12 5h3.1"
  }), e.createElement("path", {
    d: "M12 17h6.2"
  }), e.createElement("path", {
    d: "M12 14h8"
  }));
}
var eBe = ["size", "color", "stroke"];
function tBe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, eBe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-shield-half",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M12 3a12 12 0 0 0 8.5 3a12 12 0 0 1 -8.5 15a12 12 0 0 1 -8.5 -15a12 12 0 0 0 8.5 -3"
  }), e.createElement("path", {
    d: "M12 3v18"
  }));
}
var oBe = ["size", "color", "stroke"];
function rBe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, oBe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-shield-lock",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M12 3a12 12 0 0 0 8.5 3a12 12 0 0 1 -8.5 15a12 12 0 0 1 -8.5 -15a12 12 0 0 0 8.5 -3"
  }), e.createElement("circle", {
    cx: 12,
    cy: 11,
    r: 1
  }), e.createElement("line", {
    x1: 12,
    y1: 12,
    x2: 12,
    y2: 14.5
  }));
}
var nBe = ["size", "color", "stroke"];
function lBe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, nBe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-shield-off",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("line", {
    x1: 3,
    y1: 3,
    x2: 21,
    y2: 21
  }), e.createElement("path", {
    d: "M17.669 17.669a12 12 0 0 1 -5.669 3.331a12 12 0 0 1 -8.5 -15c.797 .036 1.589 0 2.366 -.126m3.092 -.912a12 12 0 0 0 3.042 -1.962a12 12 0 0 0 8.5 3a12 12 0 0 1 -1.117 9.379"
  }));
}
var aBe = ["size", "color", "stroke"];
function iBe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, aBe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-shield-x",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M12 3a12 12 0 0 0 8.5 3a12 12 0 0 1 -8.5 15a12 12 0 0 1 -8.5 -15a12 12 0 0 0 8.5 -3"
  }), e.createElement("path", {
    d: "M10 10l4 4m0 -4l-4 4"
  }));
}
var cBe = ["size", "color", "stroke"];
function sBe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, cBe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-shield",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M12 3a12 12 0 0 0 8.5 3a12 12 0 0 1 -8.5 15a12 12 0 0 1 -8.5 -15a12 12 0 0 0 8.5 -3"
  }));
}
var hBe = ["size", "color", "stroke"];
function dBe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, hBe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-ship-off",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M2 20a2.4 2.4 0 0 0 2 1a2.4 2.4 0 0 0 2 -1a2.4 2.4 0 0 1 2 -1a2.4 2.4 0 0 1 2 1a2.4 2.4 0 0 0 2 1a2.4 2.4 0 0 0 2 -1a2.4 2.4 0 0 1 2 -1a2.4 2.4 0 0 1 2 1a2.4 2.4 0 0 0 2 1a2.4 2.4 0 0 0 2 -1"
  }), e.createElement("path", {
    d: "M4 18l-1 -5h10m4 0h4l-1.334 2.668"
  }), e.createElement("path", {
    d: "M5 13v-6h2m4 0h2l4 6"
  }), e.createElement("path", {
    d: "M3 3l18 18"
  }));
}
var vBe = ["size", "color", "stroke"];
function mBe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, vBe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-ship",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M2 20a2.4 2.4 0 0 0 2 1a2.4 2.4 0 0 0 2 -1a2.4 2.4 0 0 1 2 -1a2.4 2.4 0 0 1 2 1a2.4 2.4 0 0 0 2 1a2.4 2.4 0 0 0 2 -1a2.4 2.4 0 0 1 2 -1a2.4 2.4 0 0 1 2 1a2.4 2.4 0 0 0 2 1a2.4 2.4 0 0 0 2 -1"
  }), e.createElement("path", {
    d: "M4 18l-1 -5h18l-2 4"
  }), e.createElement("path", {
    d: "M5 13v-6h8l4 6"
  }), e.createElement("path", {
    d: "M7 7v-4h-1"
  }));
}
var kBe = ["size", "color", "stroke"];
function wBe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, kBe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-shirt-off",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M8.243 4.252l.757 -.252c0 .43 .09 .837 .252 1.206m1.395 1.472a3 3 0 0 0 4.353 -2.678l6 2v5h-3v3m0 4v1a1 1 0 0 1 -1 1h-10a1 1 0 0 1 -1 -1v-8h-3v-5l2.26 -.753"
  }), e.createElement("path", {
    d: "M3 3l18 18"
  }));
}
var pBe = ["size", "color", "stroke"];
function EBe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, pBe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-shirt-sport",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M15 4l6 2v5h-3v8a1 1 0 0 1 -1 1h-10a1 1 0 0 1 -1 -1v-8h-3v-5l6 -2a3 3 0 0 0 6 0"
  }), e.createElement("path", {
    d: "M10.5 11h2.5l-1.5 5"
  }));
}
var uBe = ["size", "color", "stroke"];
function gBe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, uBe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-shirt",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M15 4l6 2v5h-3v8a1 1 0 0 1 -1 1h-10a1 1 0 0 1 -1 -1v-8h-3v-5l6 -2a3 3 0 0 0 6 0"
  }));
}
var MBe = ["size", "color", "stroke"];
function xBe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, MBe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-shoe-off",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M13.846 9.868l4.08 .972a4 4 0 0 1 3.074 3.89v2.27m-3 1h-14a1 1 0 0 1 -1 -1v-10a1 1 0 0 1 1 -1h2"
  }), e.createElement("path", {
    d: "M8 18v-1a4 4 0 0 0 -4 -4h-1"
  }), e.createElement("path", {
    d: "M10 12l.663 -1.327"
  }), e.createElement("path", {
    d: "M3 3l18 18"
  }));
}
var fBe = ["size", "color", "stroke"];
function zBe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, fBe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-shoe",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M4 6h5.426a1 1 0 0 1 .863 .496l1.064 1.823a3 3 0 0 0 1.896 1.407l4.677 1.114a4 4 0 0 1 3.074 3.89v2.27a1 1 0 0 1 -1 1h-16a1 1 0 0 1 -1 -1v-10a1 1 0 0 1 1 -1z"
  }), e.createElement("path", {
    d: "M14 13l1 -2"
  }), e.createElement("path", {
    d: "M8 18v-1a4 4 0 0 0 -4 -4h-1"
  }), e.createElement("path", {
    d: "M10 12l1.5 -3"
  }));
}
var bBe = ["size", "color", "stroke"];
function LBe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, bBe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-shopping-bag",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M6.331 8h11.339a2 2 0 0 1 1.977 2.304l-1.255 8.152a3 3 0 0 1 -2.966 2.544h-6.852a3 3 0 0 1 -2.965 -2.544l-1.255 -8.152a2 2 0 0 1 1.977 -2.304z"
  }), e.createElement("path", {
    d: "M9 11v-5a3 3 0 0 1 6 0v5"
  }));
}
var yBe = ["size", "color", "stroke"];
function CBe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, yBe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-shopping-cart-discount",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("circle", {
    cx: 6,
    cy: 19,
    r: 2
  }), e.createElement("circle", {
    cx: 17,
    cy: 19,
    r: 2
  }), e.createElement("path", {
    d: "M17 17h-11v-14h-2"
  }), e.createElement("path", {
    d: "M20 6l-1 7h-13"
  }), e.createElement("path", {
    d: "M10 10l6 -6"
  }), e.createElement("circle", {
    cx: 10.5,
    cy: 4.5,
    r: .5
  }), e.createElement("circle", {
    cx: 15.5,
    cy: 9.5,
    r: .5
  }));
}
var jBe = ["size", "color", "stroke"];
function BBe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, jBe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-shopping-cart-off",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("circle", {
    cx: 6,
    cy: 19,
    r: 2
  }), e.createElement("path", {
    d: "M17 17a2 2 0 1 0 2 2"
  }), e.createElement("path", {
    d: "M17 17h-11v-11"
  }), e.createElement("path", {
    d: "M9.239 5.231l10.761 .769l-1 7h-2m-4 0h-7"
  }), e.createElement("path", {
    d: "M3 3l18 18"
  }));
}
var HBe = ["size", "color", "stroke"];
function NBe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, HBe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-shopping-cart-plus",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("circle", {
    cx: 6,
    cy: 19,
    r: 2
  }), e.createElement("circle", {
    cx: 17,
    cy: 19,
    r: 2
  }), e.createElement("path", {
    d: "M17 17h-11v-14h-2"
  }), e.createElement("path", {
    d: "M6 5l6.005 .429m7.138 6.573l-.143 .998h-13"
  }), e.createElement("path", {
    d: "M15 6h6m-3 -3v6"
  }));
}
var WBe = ["size", "color", "stroke"];
function qBe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, WBe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-shopping-cart-x",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("circle", {
    cx: 6,
    cy: 19,
    r: 2
  }), e.createElement("circle", {
    cx: 17,
    cy: 19,
    r: 2
  }), e.createElement("path", {
    d: "M17 17h-11v-14h-2"
  }), e.createElement("path", {
    d: "M6 5l7.999 .571m5.43 4.43l-.429 2.999h-13"
  }), e.createElement("path", {
    d: "M17 3l4 4"
  }), e.createElement("path", {
    d: "M21 3l-4 4"
  }));
}
var OBe = ["size", "color", "stroke"];
function PBe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, OBe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-shopping-cart",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("circle", {
    cx: 6,
    cy: 19,
    r: 2
  }), e.createElement("circle", {
    cx: 17,
    cy: 19,
    r: 2
  }), e.createElement("path", {
    d: "M17 17h-11v-14h-2"
  }), e.createElement("path", {
    d: "M6 5l14 1l-1 7h-13"
  }));
}
var SBe = ["size", "color", "stroke"];
function IBe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, SBe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-shovel",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M17 4l3 3"
  }), e.createElement("path", {
    d: "M18.5 5.5l-8 8"
  }), e.createElement("path", {
    d: "M8.276 11.284l4.44 4.44a0.968 .968 0 0 1 0 1.369l-2.704 2.704a4.108 4.108 0 0 1 -5.809 -5.81l2.704 -2.703a0.968 .968 0 0 1 1.37 0z"
  }));
}
var ABe = ["size", "color", "stroke"];
function DBe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, ABe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-shredder",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("rect", {
    x: 4,
    y: 10,
    width: 16,
    height: 5,
    rx: 1
  }), e.createElement("path", {
    d: "M17 10v-4a2 2 0 0 0 -2 -2h-6a2 2 0 0 0 -2 2v4m5 5v5m4 -5v2m-8 -2v3"
  }));
}
var FBe = ["size", "color", "stroke"];
function GBe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, FBe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-sign-left",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M16 21h-4"
  }), e.createElement("path", {
    d: "M14 21v-10"
  }), e.createElement("path", {
    d: "M14 6v-3"
  }), e.createElement("path", {
    d: "M18 6h-10l-2 2.5l2 2.5h10z"
  }));
}
var JBe = ["size", "color", "stroke"];
function KBe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, JBe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-sign-right",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M8 21h4"
  }), e.createElement("path", {
    d: "M10 21v-10"
  }), e.createElement("path", {
    d: "M10 6v-3"
  }), e.createElement("path", {
    d: "M6 6h10l2 2.5l-2 2.5h-10z"
  }));
}
var QBe = ["size", "color", "stroke"];
function RBe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, QBe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-signal-3g",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M5 8h3a2 2 0 1 1 0 4h-3"
  }), e.createElement("path", {
    d: "M19 8h-3a2 2 0 0 0 -2 2v4a2 2 0 0 0 2 2h3v-4h-1"
  }), e.createElement("path", {
    d: "M8 12a2 2 0 1 1 0 4h-3"
  }));
}
var TBe = ["size", "color", "stroke"];
function UBe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, TBe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-signal-4g-plus",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M3 8v5h5"
  }), e.createElement("path", {
    d: "M7 8v8"
  }), e.createElement("path", {
    d: "M15 8h-2a2 2 0 0 0 -2 2v4a2 2 0 0 0 2 2h2v-4h-1"
  }), e.createElement("path", {
    d: "M18 12h4"
  }), e.createElement("path", {
    d: "M20 10v4"
  }));
}
var VBe = ["size", "color", "stroke"];
function XBe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, VBe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-signal-4g",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M5 8v5h5"
  }), e.createElement("path", {
    d: "M9 8v8"
  }), e.createElement("path", {
    d: "M19 8h-3a2 2 0 0 0 -2 2v4a2 2 0 0 0 2 2h3v-4h-1"
  }));
}
var YBe = ["size", "color", "stroke"];
function ZBe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, YBe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-signal-5g",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M10 8h-5v4h3a2 2 0 1 1 0 4h-3"
  }), e.createElement("path", {
    d: "M19 8h-3a2 2 0 0 0 -2 2v4a2 2 0 0 0 2 2h3v-4h-1"
  }));
}
var $Be = ["size", "color", "stroke"];
function _Be(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, $Be);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-signature-off",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M3 17c3.333 -3.333 5 -6 5 -8c0 -.394 -.017 -.735 -.05 -1.033m-1.95 -1.967c-1 0 -2.032 1.085 -2 3c.034 2.048 1.658 4.877 2.5 6c1.5 2 2.5 2.5 3.5 1l2 -3c.333 2.667 1.333 4 3 4c.219 0 .708 -.341 1.231 -.742m3.769 -.258c.303 .245 .64 .677 1 1"
  }), e.createElement("path", {
    d: "M3 3l18 18"
  }));
}
var eHe = ["size", "color", "stroke"];
function tHe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, eHe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-signature",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M3 17c3.333 -3.333 5 -6 5 -8c0 -3 -1 -3 -2 -3s-2.032 1.085 -2 3c.034 2.048 1.658 4.877 2.5 6c1.5 2 2.5 2.5 3.5 1l2 -3c.333 2.667 1.333 4 3 4c.53 0 2.639 -2 3 -2c.517 0 1.517 .667 3 2"
  }));
}
var oHe = ["size", "color", "stroke"];
function rHe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, oHe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-sitemap-off",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("rect", {
    x: 3,
    y: 15,
    width: 6,
    height: 6,
    rx: 2
  }), e.createElement("path", {
    d: "M19 15a2 2 0 0 1 2 2m-.591 3.42c-.362 .358 -.86 .58 -1.409 .58h-2a2 2 0 0 1 -2 -2v-2c0 -.549 .221 -1.046 .579 -1.407"
  }), e.createElement("path", {
    d: "M9 5a2 2 0 0 1 2 -2h2a2 2 0 0 1 2 2v2a2 2 0 0 1 -2 2"
  }), e.createElement("path", {
    d: "M6 15v-1a2 2 0 0 1 2 -2h4m4 0a2 2 0 0 1 2 2"
  }), e.createElement("path", {
    d: "M3 3l18 18"
  }));
}
var nHe = ["size", "color", "stroke"];
function lHe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, nHe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-sitemap",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("rect", {
    x: 3,
    y: 15,
    width: 6,
    height: 6,
    rx: 2
  }), e.createElement("rect", {
    x: 15,
    y: 15,
    width: 6,
    height: 6,
    rx: 2
  }), e.createElement("rect", {
    x: 9,
    y: 3,
    width: 6,
    height: 6,
    rx: 2
  }), e.createElement("path", {
    d: "M6 15v-1a2 2 0 0 1 2 -2h8a2 2 0 0 1 2 2v1"
  }), e.createElement("line", {
    x1: 12,
    y1: 9,
    x2: 12,
    y2: 12
  }));
}
var aHe = ["size", "color", "stroke"];
function iHe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, aHe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-skateboard-off",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("circle", {
    cx: 7,
    cy: 15,
    r: 2
  }), e.createElement("path", {
    d: "M15 15a2 2 0 0 0 2 2m2 -2a2 2 0 0 0 -2 -2"
  }), e.createElement("path", {
    d: "M3 9c0 .552 .895 1 2 1h5m4 0h5c1.105 0 2 -.448 2 -1"
  }), e.createElement("path", {
    d: "M3 3l18 18"
  }));
}
var cHe = ["size", "color", "stroke"];
function sHe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, cHe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-skateboard",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("circle", {
    cx: 7,
    cy: 15,
    r: 2
  }), e.createElement("circle", {
    cx: 17,
    cy: 15,
    r: 2
  }), e.createElement("path", {
    d: "M3 9a2 1 0 0 0 2 1h14a2 1 0 0 0 2 -1"
  }));
}
var hHe = ["size", "color", "stroke"];
function dHe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, hHe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-skull",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M12 4c4.418 0 8 3.358 8 7.5c0 1.901 -.755 3.637 -1.999 4.96l-.001 2.54a1 1 0 0 1 -1 1h-10a1 1 0 0 1 -1 -1v-2.54c-1.245 -1.322 -2 -3.058 -2 -4.96c0 -4.142 3.582 -7.5 8 -7.5z"
  }), e.createElement("path", {
    d: "M10 17v3"
  }), e.createElement("path", {
    d: "M14 17v3"
  }), e.createElement("circle", {
    cx: 9,
    cy: 11,
    r: 1
  }), e.createElement("circle", {
    cx: 15,
    cy: 11,
    r: 1
  }));
}
var vHe = ["size", "color", "stroke"];
function mHe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, vHe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-slash",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M17 5l-10 14"
  }));
}
var kHe = ["size", "color", "stroke"];
function wHe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, kHe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-slashes",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M14 5l-10 14"
  }), e.createElement("path", {
    d: "M20 5l-10 14"
  }));
}
var pHe = ["size", "color", "stroke"];
function EHe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, pHe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-sleigh",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M3 19h15a4 4 0 0 0 4 -4"
  }), e.createElement("path", {
    d: "M16 15h-9a4 4 0 0 1 -4 -4v-6l1.243 1.243a6 6 0 0 0 4.242 1.757h3.515v2a2 2 0 0 0 2 2h.5a1.5 1.5 0 0 0 1.5 -1.5a1.5 1.5 0 0 1 3 0v1.5a3 3 0 0 1 -3 3z"
  }), e.createElement("path", {
    d: "M15 15v4"
  }), e.createElement("path", {
    d: "M7 15v4"
  }));
}
var uHe = ["size", "color", "stroke"];
function gHe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, uHe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-slice",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M3 19l15 -15l3 3l-6 6l2 2a14 14 0 0 1 -14 4"
  }));
}
var MHe = ["size", "color", "stroke"];
function xHe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, MHe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-slideshow",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("line", {
    x1: 15,
    y1: 6,
    x2: 15.01,
    y2: 6
  }), e.createElement("rect", {
    x: 3,
    y: 3,
    width: 18,
    height: 14,
    rx: 3
  }), e.createElement("path", {
    d: "M3 13l4 -4a3 5 0 0 1 3 0l4 4"
  }), e.createElement("path", {
    d: "M13 12l2 -2a3 5 0 0 1 3 0l3 3"
  }), e.createElement("line", {
    x1: 8,
    y1: 21,
    x2: 8.01,
    y2: 21
  }), e.createElement("line", {
    x1: 12,
    y1: 21,
    x2: 12.01,
    y2: 21
  }), e.createElement("line", {
    x1: 16,
    y1: 21,
    x2: 16.01,
    y2: 21
  }));
}
var fHe = ["size", "color", "stroke"];
function zHe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, fHe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-smart-home-off",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M7.097 7.125l-2.037 1.585a2.665 2.665 0 0 0 -1.029 2.105v7.2a2 2 0 0 0 2 2h12c.559 0 1.064 -.229 1.427 -.598m.572 -3.417v-5.185c0 -.823 -.38 -1.6 -1.03 -2.105l-5.333 -4.148a2.666 2.666 0 0 0 -3.274 0l-1.029 .8"
  }), e.createElement("path", {
    d: "M15.332 15.345c-2.213 .976 -5.335 .86 -7.332 -.345"
  }), e.createElement("path", {
    d: "M3 3l18 18"
  }));
}
var bHe = ["size", "color", "stroke"];
function LHe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, bHe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-smart-home",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M19 8.71l-5.333 -4.148a2.666 2.666 0 0 0 -3.274 0l-5.334 4.148a2.665 2.665 0 0 0 -1.029 2.105v7.2a2 2 0 0 0 2 2h12a2 2 0 0 0 2 -2v-7.2c0 -.823 -.38 -1.6 -1.03 -2.105"
  }), e.createElement("path", {
    d: "M16 15c-2.21 1.333 -5.792 1.333 -8 0"
  }));
}
var yHe = ["size", "color", "stroke"];
function CHe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, yHe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-smoking-no",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("line", {
    x1: 8,
    y1: 13,
    x2: 8,
    y2: 17
  }), e.createElement("path", {
    d: "M16 5v.5a2 2 0 0 0 2 2a2 2 0 0 1 2 2v.5"
  }), e.createElement("line", {
    x1: 3,
    y1: 3,
    x2: 21,
    y2: 21
  }), e.createElement("path", {
    d: "M17 13h3a1 1 0 0 1 1 1v2c0 .28 -.115 .533 -.3 .714m-3.7 .286h-13a1 1 0 0 1 -1 -1v-2a1 1 0 0 1 1 -1h9"
  }));
}
var jHe = ["size", "color", "stroke"];
function BHe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, jHe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-smoking",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("rect", {
    x: 3,
    y: 13,
    width: 18,
    height: 4,
    rx: 1
  }), e.createElement("line", {
    x1: 8,
    y1: 13,
    x2: 8,
    y2: 17
  }), e.createElement("path", {
    d: "M16 5v.5a2 2 0 0 0 2 2a2 2 0 0 1 2 2v.5"
  }));
}
var HHe = ["size", "color", "stroke"];
function NHe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, HHe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-snowflake-off",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M10 4l2 1l2 -1"
  }), e.createElement("path", {
    d: "M12 2v6m1.196 1.186l1.804 1.034"
  }), e.createElement("path", {
    d: "M17.928 6.268l.134 2.232l1.866 1.232"
  }), e.createElement("path", {
    d: "M20.66 7l-5.629 3.25l-.031 .75"
  }), e.createElement("path", {
    d: "M19.928 14.268l-1.015 .67"
  }), e.createElement("path", {
    d: "M14.212 14.226l-2.171 1.262"
  }), e.createElement("path", {
    d: "M14 20l-2 -1l-2 1"
  }), e.createElement("path", {
    d: "M12 22v-6.5l-3 -1.72"
  }), e.createElement("path", {
    d: "M6.072 17.732l-.134 -2.232l-1.866 -1.232"
  }), e.createElement("path", {
    d: "M3.34 17l5.629 -3.25l-.01 -3.458"
  }), e.createElement("path", {
    d: "M4.072 9.732l1.866 -1.232l.134 -2.232"
  }), e.createElement("path", {
    d: "M3.34 7l5.629 3.25l.802 -.466"
  }), e.createElement("path", {
    d: "M3 3l18 18"
  }));
}
var WHe = ["size", "color", "stroke"];
function qHe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, WHe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-snowflake",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M10 4l2 1l2 -1"
  }), e.createElement("path", {
    d: "M12 2v6.5l3 1.72"
  }), e.createElement("path", {
    d: "M17.928 6.268l.134 2.232l1.866 1.232"
  }), e.createElement("path", {
    d: "M20.66 7l-5.629 3.25l.01 3.458"
  }), e.createElement("path", {
    d: "M19.928 14.268l-1.866 1.232l-.134 2.232"
  }), e.createElement("path", {
    d: "M20.66 17l-5.629 -3.25l-2.99 1.738"
  }), e.createElement("path", {
    d: "M14 20l-2 -1l-2 1"
  }), e.createElement("path", {
    d: "M12 22v-6.5l-3 -1.72"
  }), e.createElement("path", {
    d: "M6.072 17.732l-.134 -2.232l-1.866 -1.232"
  }), e.createElement("path", {
    d: "M3.34 17l5.629 -3.25l-.01 -3.458"
  }), e.createElement("path", {
    d: "M4.072 9.732l1.866 -1.232l.134 -2.232"
  }), e.createElement("path", {
    d: "M3.34 7l5.629 3.25l2.99 -1.738"
  }));
}
var OHe = ["size", "color", "stroke"];
function PHe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, OHe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-snowman",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M12 3a4 4 0 0 1 2.906 6.75a6 6 0 1 1 -5.81 0a4 4 0 0 1 2.904 -6.75z"
  }), e.createElement("path", {
    d: "M17.5 11.5l2.5 -1.5"
  }), e.createElement("path", {
    d: "M6.5 11.5l-2.5 -1.5"
  }), e.createElement("path", {
    d: "M12 13h.01"
  }), e.createElement("path", {
    d: "M12 16h.01"
  }));
}
var SHe = ["size", "color", "stroke"];
function IHe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, SHe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-soccer-field",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 3
  }), e.createElement("path", {
    d: "M3 9h3v6h-3z"
  }), e.createElement("path", {
    d: "M18 9h3v6h-3z"
  }), e.createElement("rect", {
    x: 3,
    y: 5,
    width: 18,
    height: 14,
    rx: 2
  }), e.createElement("line", {
    x1: 12,
    y1: 5,
    x2: 12,
    y2: 19
  }));
}
var AHe = ["size", "color", "stroke"];
function DHe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, AHe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-social-off",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("circle", {
    cx: 12,
    cy: 5,
    r: 2
  }), e.createElement("circle", {
    cx: 5,
    cy: 19,
    r: 2
  }), e.createElement("path", {
    d: "M17.57 17.602a2 2 0 0 0 2.83 2.827"
  }), e.createElement("path", {
    d: "M11.113 11.133a3.001 3.001 0 1 0 3.765 3.715"
  }), e.createElement("path", {
    d: "M12 7v1"
  }), e.createElement("path", {
    d: "M6.7 17.8l2.8 -2"
  }), e.createElement("path", {
    d: "M17.3 17.8l-2.8 -2"
  }), e.createElement("path", {
    d: "M3 3l18 18"
  }));
}
var FHe = ["size", "color", "stroke"];
function GHe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, FHe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-social",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("circle", {
    cx: 12,
    cy: 5,
    r: 2
  }), e.createElement("circle", {
    cx: 5,
    cy: 19,
    r: 2
  }), e.createElement("circle", {
    cx: 19,
    cy: 19,
    r: 2
  }), e.createElement("circle", {
    cx: 12,
    cy: 14,
    r: 3
  }), e.createElement("line", {
    x1: 12,
    y1: 7,
    x2: 12,
    y2: 11
  }), e.createElement("line", {
    x1: 6.7,
    y1: 17.8,
    x2: 9.5,
    y2: 15.8
  }), e.createElement("line", {
    x1: 17.3,
    y1: 17.8,
    x2: 14.5,
    y2: 15.8
  }));
}
var JHe = ["size", "color", "stroke"];
function KHe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, JHe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-sock",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M13 3v6l4.798 5.142a4 4 0 0 1 -5.441 5.86l-6.736 -6.41a2 2 0 0 1 -.621 -1.451v-9.141h8z"
  }), e.createElement("path", {
    d: "M7.895 15.768c.708 -.721 1.105 -1.677 1.105 -2.768a4 4 0 0 0 -4 -4"
  }));
}
var QHe = ["size", "color", "stroke"];
function RHe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, QHe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-sofa-off",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M18 14v-1a2 2 0 1 1 4 0v5m-3 1h-16a1 1 0 0 1 -1 -1v-5a2 2 0 1 1 4 0v1h8"
  }), e.createElement("path", {
    d: "M4 11v-3c0 -1.082 .573 -2.03 1.432 -2.558m3.568 -.442h8a3 3 0 0 1 3 3v3"
  }), e.createElement("path", {
    d: "M12 5v3m0 4v2"
  }), e.createElement("path", {
    d: "M3 3l18 18"
  }));
}
var THe = ["size", "color", "stroke"];
function UHe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, THe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-sofa",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M4 11a2 2 0 0 1 2 2v1h12v-1a2 2 0 1 1 4 0v5a1 1 0 0 1 -1 1h-18a1 1 0 0 1 -1 -1v-5a2 2 0 0 1 2 -2z"
  }), e.createElement("path", {
    d: "M4 11v-3a3 3 0 0 1 3 -3h10a3 3 0 0 1 3 3v3"
  }), e.createElement("path", {
    d: "M12 5v9"
  }));
}
var VHe = ["size", "color", "stroke"];
function XHe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, VHe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-sort-0-9",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M11 12h2"
  }), e.createElement("path", {
    d: "M4 10v4a2 2 0 1 0 4 0v-4a2 2 0 1 0 -4 0z"
  }), e.createElement("path", {
    d: "M16 15a1 1 0 0 0 1 1h2a1 1 0 0 0 1 -1v-6a1 1 0 0 0 -1 -1h-2a1 1 0 0 0 -1 1v2a1 1 0 0 0 1 1h3"
  }));
}
var YHe = ["size", "color", "stroke"];
function ZHe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, YHe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-sort-9-0",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M4 15a1 1 0 0 0 1 1h2a1 1 0 0 0 1 -1v-6a1 1 0 0 0 -1 -1h-2a1 1 0 0 0 -1 1v2a1 1 0 0 0 1 1h3"
  }), e.createElement("path", {
    d: "M16 10v4a2 2 0 1 0 4 0v-4a2 2 0 1 0 -4 0z"
  }), e.createElement("path", {
    d: "M11 12h2"
  }));
}
var $He = ["size", "color", "stroke"];
function _He(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, $He);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-sort-a-z",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M16 8h4l-4 8h4"
  }), e.createElement("path", {
    d: "M4 16v-6a2 2 0 1 1 4 0v6"
  }), e.createElement("path", {
    d: "M4 13h4"
  }), e.createElement("path", {
    d: "M11 12h2"
  }));
}
var eNe = ["size", "color", "stroke"];
function tNe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, eNe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-sort-ascending-2",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M14 9l3 -3l3 3"
  }), e.createElement("rect", {
    x: 5,
    y: 5,
    width: 5,
    height: 5,
    rx: .5
  }), e.createElement("rect", {
    x: 5,
    y: 14,
    width: 5,
    height: 5,
    rx: .5
  }), e.createElement("path", {
    d: "M17 6v12"
  }));
}
var oNe = ["size", "color", "stroke"];
function rNe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, oNe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-sort-ascending-letters",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M15 10v-5c0 -1.38 .62 -2 2 -2s2 .62 2 2v5m0 -3h-4"
  }), e.createElement("path", {
    d: "M19 21h-4l4 -7h-4"
  }), e.createElement("path", {
    d: "M4 15l3 3l3 -3"
  }), e.createElement("path", {
    d: "M7 6v12"
  }));
}
var nNe = ["size", "color", "stroke"];
function lNe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, nNe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-sort-ascending-numbers",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M4 15l3 3l3 -3"
  }), e.createElement("path", {
    d: "M7 6v12"
  }), e.createElement("path", {
    d: "M17 3a2 2 0 0 1 2 2v3a2 2 0 1 1 -4 0v-3a2 2 0 0 1 2 -2z"
  }), e.createElement("circle", {
    cx: 17,
    cy: 16,
    r: 2
  }), e.createElement("path", {
    d: "M19 16v3a2 2 0 0 1 -2 2h-1.5"
  }));
}
var aNe = ["size", "color", "stroke"];
function iNe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, aNe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-sort-ascending",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("line", {
    x1: 4,
    y1: 6,
    x2: 11,
    y2: 6
  }), e.createElement("line", {
    x1: 4,
    y1: 12,
    x2: 11,
    y2: 12
  }), e.createElement("line", {
    x1: 4,
    y1: 18,
    x2: 13,
    y2: 18
  }), e.createElement("polyline", {
    points: "15 9 18 6 21 9"
  }), e.createElement("line", {
    x1: 18,
    y1: 6,
    x2: 18,
    y2: 18
  }));
}
var cNe = ["size", "color", "stroke"];
function sNe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, cNe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-sort-descending-2",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("rect", {
    x: 5,
    y: 5,
    width: 5,
    height: 5,
    rx: .5
  }), e.createElement("rect", {
    x: 5,
    y: 14,
    width: 5,
    height: 5,
    rx: .5
  }), e.createElement("path", {
    d: "M14 15l3 3l3 -3"
  }), e.createElement("path", {
    d: "M17 18v-12"
  }));
}
var hNe = ["size", "color", "stroke"];
function dNe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, hNe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-sort-descending-letters",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M15 21v-5c0 -1.38 .62 -2 2 -2s2 .62 2 2v5m0 -3h-4"
  }), e.createElement("path", {
    d: "M19 10h-4l4 -7h-4"
  }), e.createElement("path", {
    d: "M4 15l3 3l3 -3"
  }), e.createElement("path", {
    d: "M7 6v12"
  }));
}
var vNe = ["size", "color", "stroke"];
function mNe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, vNe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-sort-descending-numbers",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M4 15l3 3l3 -3"
  }), e.createElement("path", {
    d: "M7 6v12"
  }), e.createElement("path", {
    d: "M17 14a2 2 0 0 1 2 2v3a2 2 0 1 1 -4 0v-3a2 2 0 0 1 2 -2z"
  }), e.createElement("circle", {
    cx: 17,
    cy: 5,
    r: 2
  }), e.createElement("path", {
    d: "M19 5v3a2 2 0 0 1 -2 2h-1.5"
  }));
}
var kNe = ["size", "color", "stroke"];
function wNe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, kNe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-sort-descending",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("line", {
    x1: 4,
    y1: 6,
    x2: 13,
    y2: 6
  }), e.createElement("line", {
    x1: 4,
    y1: 12,
    x2: 11,
    y2: 12
  }), e.createElement("line", {
    x1: 4,
    y1: 18,
    x2: 11,
    y2: 18
  }), e.createElement("polyline", {
    points: "15 15 18 18 21 15"
  }), e.createElement("line", {
    x1: 18,
    y1: 6,
    x2: 18,
    y2: 18
  }));
}
var pNe = ["size", "color", "stroke"];
function ENe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, pNe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-sort-z-a",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M4 8h4l-4 8h4"
  }), e.createElement("path", {
    d: "M16 16v-6a2 2 0 1 1 4 0v6"
  }), e.createElement("path", {
    d: "M16 13h4"
  }), e.createElement("path", {
    d: "M11 12h2"
  }));
}
var uNe = ["size", "color", "stroke"];
function gNe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, uNe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-sos",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M7 8h-3a1 1 0 0 0 -1 1v2a1 1 0 0 0 1 1h2a1 1 0 0 1 1 1v2a1 1 0 0 1 -1 1h-3"
  }), e.createElement("path", {
    d: "M10 8h4v8h-4z"
  }), e.createElement("path", {
    d: "M17 16h3a1 1 0 0 0 1 -1v-2a1 1 0 0 0 -1 -1h-2a1 1 0 0 1 -1 -1v-2a1 1 0 0 1 1 -1h3"
  }));
}
var MNe = ["size", "color", "stroke"];
function xNe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, MNe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-soup-off",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M3 19h16"
  }), e.createElement("path", {
    d: "M15 11h6c0 1.691 -.525 3.26 -1.42 4.552m-2.034 2.032a7.963 7.963 0 0 1 -4.546 1.416h-2a8 8 0 0 1 -8 -8h8"
  }), e.createElement("path", {
    d: "M12 5v3"
  }), e.createElement("path", {
    d: "M15 5v3"
  }), e.createElement("path", {
    d: "M3 3l18 18"
  }));
}
var fNe = ["size", "color", "stroke"];
function zNe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, fNe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-soup",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M4 11h16a1 1 0 0 1 1 1v.5c0 1.5 -2.517 5.573 -4 6.5v1a1 1 0 0 1 -1 1h-8a1 1 0 0 1 -1 -1v-1c-1.687 -1.054 -4 -5 -4 -6.5v-.5a1 1 0 0 1 1 -1z"
  }), e.createElement("path", {
    d: "M12 4a2.4 2.4 0 0 0 -1 2a2.4 2.4 0 0 0 1 2"
  }), e.createElement("path", {
    d: "M16 4a2.4 2.4 0 0 0 -1 2a2.4 2.4 0 0 0 1 2"
  }), e.createElement("path", {
    d: "M8 4a2.4 2.4 0 0 0 -1 2a2.4 2.4 0 0 0 1 2"
  }));
}
var bNe = ["size", "color", "stroke"];
function LNe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, bNe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-source-code",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M14.5 4h2.5a3 3 0 0 1 3 3v10a3 3 0 0 1 -3 3h-10a3 3 0 0 1 -3 -3v-5"
  }), e.createElement("path", {
    d: "M6 5l-2 2l2 2"
  }), e.createElement("path", {
    d: "M10 9l2 -2l-2 -2"
  }));
}
var yNe = ["size", "color", "stroke"];
function CNe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, yNe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-space-off",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M4 10v3a1 1 0 0 0 1 1h9m4 0h1a1 1 0 0 0 1 -1v-3"
  }), e.createElement("path", {
    d: "M3 3l18 18"
  }));
}
var jNe = ["size", "color", "stroke"];
function BNe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, jNe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-space",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M4 10v3a1 1 0 0 0 1 1h14a1 1 0 0 0 1 -1v-3"
  }));
}
var HNe = ["size", "color", "stroke"];
function NNe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, HNe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-spacing-horizontal",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M20 20h-2a2 2 0 0 1 -2 -2v-12a2 2 0 0 1 2 -2h2"
  }), e.createElement("path", {
    d: "M4 20h2a2 2 0 0 0 2 -2v-12a2 2 0 0 0 -2 -2h-2"
  }), e.createElement("path", {
    d: "M12 8v8"
  }));
}
var WNe = ["size", "color", "stroke"];
function qNe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, WNe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-spacing-vertical",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M4 20v-2a2 2 0 0 1 2 -2h12a2 2 0 0 1 2 2v2"
  }), e.createElement("path", {
    d: "M4 4v2a2 2 0 0 0 2 2h12a2 2 0 0 0 2 -2v-2"
  }), e.createElement("path", {
    d: "M16 12h-8"
  }));
}
var ONe = ["size", "color", "stroke"];
function PNe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, ONe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-spade",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M12 3l4.919 4.5c.61 .587 1.177 1.177 1.703 1.771a5.527 5.527 0 0 1 .264 6.979c-1.18 1.56 -3.338 1.92 -4.886 .75v1l1 3h-6l1 -3v-1c-1.54 1.07 -3.735 .772 -4.886 -.75a5.527 5.527 0 0 1 .264 -6.979a30.883 30.883 0 0 1 1.703 -1.771a1541.72 1541.72 0 0 1 4.919 -4.5z"
  }));
}
var SNe = ["size", "color", "stroke"];
function INe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, SNe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-speakerphone",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M18 8a3 3 0 0 1 0 6"
  }), e.createElement("path", {
    d: "M10 8v11a1 1 0 0 1 -1 1h-1a1 1 0 0 1 -1 -1v-5"
  }), e.createElement("path", {
    d: "M12 8h0l4.524 -3.77a0.9 .9 0 0 1 1.476 .692v12.156a0.9 .9 0 0 1 -1.476 .692l-4.524 -3.77h-8a1 1 0 0 1 -1 -1v-4a1 1 0 0 1 1 -1h8"
  }));
}
var ANe = ["size", "color", "stroke"];
function DNe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, ANe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-speedboat",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M3 17h13.4a3 3 0 0 0 2.5 -1.34l3.1 -4.66h0h-6.23a4 4 0 0 0 -1.49 .29l-3.56 1.42a4 4 0 0 1 -1.49 .29h-3.73h0h-1l-1.5 4z"
  }), e.createElement("line", {
    x1: 6,
    y1: 13,
    x2: 7.5,
    y2: 8
  }), e.createElement("path", {
    d: "M6 8h8l2 3"
  }));
}
var FNe = ["size", "color", "stroke"];
function GNe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, FNe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-spider",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M5 4v2l5 5"
  }), e.createElement("path", {
    d: "M2.5 9.5l1.5 1.5h6"
  }), e.createElement("path", {
    d: "M4 19v-2l6 -6"
  }), e.createElement("path", {
    d: "M19 4v2l-5 5"
  }), e.createElement("path", {
    d: "M21.5 9.5l-1.5 1.5h-6"
  }), e.createElement("path", {
    d: "M20 19v-2l-6 -6"
  }), e.createElement("circle", {
    cx: 12,
    cy: 15,
    r: 4
  }), e.createElement("circle", {
    cx: 12,
    cy: 9,
    r: 2
  }));
}
var JNe = ["size", "color", "stroke"];
function KNe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, JNe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-spiral-off",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M10 12.057a1.9 1.9 0 0 0 .614 .743c.682 .459 1.509 .374 2.164 -.02m1.103 -2.92a3.298 3.298 0 0 0 -1.749 -2.059a3.6 3.6 0 0 0 -.507 -.195m-3.385 .634a4.154 4.154 0 0 0 -1.347 1.646c-1.095 2.432 .29 5.248 2.71 6.246c1.955 .806 4.097 .35 5.65 -.884m1.745 -2.268l.043 -.103c1.36 -3.343 -.557 -7.134 -3.896 -8.41c-1.593 -.61 -3.27 -.599 -4.79 -.113m-2.579 1.408a7.574 7.574 0 0 0 -2.268 3.128c-1.63 4.253 .823 9.024 5.082 10.576c3.211 1.17 6.676 .342 9.124 -1.738m1.869 -2.149a9.354 9.354 0 0 0 1.417 -4.516"
  }), e.createElement("path", {
    d: "M3 3l18 18"
  }));
}
var QNe = ["size", "color", "stroke"];
function RNe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, QNe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-spiral",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M10 12.057a1.9 1.9 0 0 0 .614 .743c1.06 .713 2.472 .112 3.043 -.919c.839 -1.513 -.022 -3.368 -1.525 -4.08c-2.003 -.95 -4.371 .154 -5.24 2.086c-1.095 2.432 .29 5.248 2.71 6.246c2.931 1.208 6.283 -.418 7.438 -3.255c1.36 -3.343 -.557 -7.134 -3.896 -8.41c-3.855 -1.474 -8.2 .68 -9.636 4.422c-1.63 4.253 .823 9.024 5.082 10.576c4.778 1.74 10.118 -.941 11.833 -5.59a9.354 9.354 0 0 0 .577 -2.813"
  }));
}
var TNe = ["size", "color", "stroke"];
function UNe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, TNe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-sport-billard",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("circle", {
    cx: 12,
    cy: 10,
    r: 2
  }), e.createElement("circle", {
    cx: 12,
    cy: 14,
    r: 2
  }), e.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 8
  }));
}
var VNe = ["size", "color", "stroke"];
function XNe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, VNe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-spray",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("rect", {
    x: 4,
    y: 10,
    width: 8,
    height: 11,
    rx: 2
  }), e.createElement("path", {
    d: "M6 10v-4a1 1 0 0 1 1 -1h2a1 1 0 0 1 1 1v4"
  }), e.createElement("path", {
    d: "M15 7h.01"
  }), e.createElement("path", {
    d: "M18 9h.01"
  }), e.createElement("path", {
    d: "M18 5h.01"
  }), e.createElement("path", {
    d: "M21 3h.01"
  }), e.createElement("path", {
    d: "M21 7h.01"
  }), e.createElement("path", {
    d: "M21 11h.01"
  }), e.createElement("path", {
    d: "M10 7h1"
  }));
}
var YNe = ["size", "color", "stroke"];
function ZNe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, YNe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-spy-off",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M3 11h8m4 0h6"
  }), e.createElement("path", {
    d: "M5 11v-4c0 -.571 .16 -1.105 .437 -1.56m2.563 -1.44h8a3 3 0 0 1 3 3v4"
  }), e.createElement("circle", {
    cx: 7,
    cy: 17,
    r: 3
  }), e.createElement("path", {
    d: "M14.88 14.877a3 3 0 1 0 4.239 4.247m.59 -3.414a3.012 3.012 0 0 0 -1.425 -1.422"
  }), e.createElement("path", {
    d: "M10 17h4"
  }), e.createElement("path", {
    d: "M3 3l18 18"
  }));
}
var $Ne = ["size", "color", "stroke"];
function _Ne(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, $Ne);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-spy",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M3 11h18"
  }), e.createElement("path", {
    d: "M5 11v-4a3 3 0 0 1 3 -3h8a3 3 0 0 1 3 3v4"
  }), e.createElement("circle", {
    cx: 7,
    cy: 17,
    r: 3
  }), e.createElement("circle", {
    cx: 17,
    cy: 17,
    r: 3
  }), e.createElement("path", {
    d: "M10 17h4"
  }));
}
var eWe = ["size", "color", "stroke"];
function tWe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, eWe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-square-arrow-down",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M8 12l4 4l4 -4"
  }), e.createElement("path", {
    d: "M12 8v8"
  }), e.createElement("path", {
    d: "M6.667 4h10.666a2.667 2.667 0 0 1 2.667 2.667v10.666a2.667 2.667 0 0 1 -2.667 2.667h-10.666a2.667 2.667 0 0 1 -2.667 -2.667v-10.666a2.667 2.667 0 0 1 2.667 -2.667z"
  }));
}
var oWe = ["size", "color", "stroke"];
function rWe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, oWe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-square-arrow-left",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M12 8l-4 4l4 4"
  }), e.createElement("path", {
    d: "M16 12h-8"
  }), e.createElement("path", {
    d: "M20 6.667v10.666a2.667 2.667 0 0 1 -2.667 2.667h-10.666a2.667 2.667 0 0 1 -2.667 -2.667v-10.666a2.667 2.667 0 0 1 2.667 -2.667h10.666a2.667 2.667 0 0 1 2.667 2.667z"
  }));
}
var nWe = ["size", "color", "stroke"];
function lWe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, nWe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-square-arrow-right",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M12 16l4 -4l-4 -4"
  }), e.createElement("path", {
    d: "M8 12h8"
  }), e.createElement("path", {
    d: "M4 17.333v-10.666a2.667 2.667 0 0 1 2.667 -2.667h10.666a2.667 2.667 0 0 1 2.667 2.667v10.666a2.667 2.667 0 0 1 -2.667 2.667h-10.666a2.667 2.667 0 0 1 -2.667 -2.667z"
  }));
}
var aWe = ["size", "color", "stroke"];
function iWe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, aWe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-square-arrow-up",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M16 12l-4 -4l-4 4"
  }), e.createElement("path", {
    d: "M12 16v-8"
  }), e.createElement("path", {
    d: "M17.333 20h-10.666a2.667 2.667 0 0 1 -2.667 -2.667v-10.666a2.667 2.667 0 0 1 2.667 -2.667h10.666a2.667 2.667 0 0 1 2.667 2.667v10.666a2.667 2.667 0 0 1 -2.667 2.667z"
  }));
}
var cWe = ["size", "color", "stroke"];
function sWe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, cWe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-square-asterisk",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("rect", {
    x: 4,
    y: 4,
    width: 16,
    height: 16,
    rx: 2
  }), e.createElement("path", {
    d: "M12 8.5v7"
  }), e.createElement("path", {
    d: "M9 10l6 4"
  }), e.createElement("path", {
    d: "M9 14l6 -4"
  }));
}
var hWe = ["size", "color", "stroke"];
function dWe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, hWe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-square-check",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("rect", {
    x: 4,
    y: 4,
    width: 16,
    height: 16,
    rx: 2
  }), e.createElement("path", {
    d: "M9 12l2 2l4 -4"
  }));
}
var vWe = ["size", "color", "stroke"];
function mWe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, vWe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-square-chevron-down",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M15 11l-3 3l-3 -3"
  }), e.createElement("path", {
    d: "M20 6.667v10.666a2.667 2.667 0 0 1 -2.667 2.667h-10.666a2.667 2.667 0 0 1 -2.667 -2.667v-10.666a2.667 2.667 0 0 1 2.667 -2.667h10.666a2.667 2.667 0 0 1 2.667 2.667z"
  }));
}
var kWe = ["size", "color", "stroke"];
function wWe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, kWe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-square-chevron-left",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M13 15l-3 -3l3 -3"
  }), e.createElement("path", {
    d: "M20 6.667v10.666a2.667 2.667 0 0 1 -2.667 2.667h-10.666a2.667 2.667 0 0 1 -2.667 -2.667v-10.666a2.667 2.667 0 0 1 2.667 -2.667h10.666a2.667 2.667 0 0 1 2.667 2.667z"
  }));
}
var pWe = ["size", "color", "stroke"];
function EWe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, pWe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-square-chevron-right",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M11 9l3 3l-3 3"
  }), e.createElement("path", {
    d: "M20 6.667v10.666a2.667 2.667 0 0 1 -2.667 2.667h-10.666a2.667 2.667 0 0 1 -2.667 -2.667v-10.666a2.667 2.667 0 0 1 2.667 -2.667h10.666a2.667 2.667 0 0 1 2.667 2.667z"
  }));
}
var uWe = ["size", "color", "stroke"];
function gWe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, uWe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-square-chevron-up",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M20 6.667v10.666a2.667 2.667 0 0 1 -2.667 2.667h-10.666a2.667 2.667 0 0 1 -2.667 -2.667v-10.666a2.667 2.667 0 0 1 2.667 -2.667h10.666a2.667 2.667 0 0 1 2.667 2.667z"
  }), e.createElement("path", {
    d: "M9 13l3 -3l3 3"
  }));
}
var MWe = ["size", "color", "stroke"];
function xWe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, MWe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-square-chevrons-down",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M15 9l-3 3l-3 -3"
  }), e.createElement("path", {
    d: "M15 13l-3 3l-3 -3"
  }), e.createElement("path", {
    d: "M20 6.667v10.666a2.667 2.667 0 0 1 -2.667 2.667h-10.666a2.667 2.667 0 0 1 -2.667 -2.667v-10.666a2.667 2.667 0 0 1 2.667 -2.667h10.666a2.667 2.667 0 0 1 2.667 2.667z"
  }));
}
var fWe = ["size", "color", "stroke"];
function zWe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, fWe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-square-chevrons-left",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M15 15l-3 -3l3 -3"
  }), e.createElement("path", {
    d: "M11 15l-3 -3l3 -3"
  }), e.createElement("path", {
    d: "M20 6.667v10.666a2.667 2.667 0 0 1 -2.667 2.667h-10.666a2.667 2.667 0 0 1 -2.667 -2.667v-10.666a2.667 2.667 0 0 1 2.667 -2.667h10.666a2.667 2.667 0 0 1 2.667 2.667z"
  }));
}
var bWe = ["size", "color", "stroke"];
function LWe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, bWe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-square-chevrons-right",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M9 9l3 3l-3 3"
  }), e.createElement("path", {
    d: "M13 9l3 3l-3 3"
  }), e.createElement("path", {
    d: "M20 6.667v10.666a2.667 2.667 0 0 1 -2.667 2.667h-10.666a2.667 2.667 0 0 1 -2.667 -2.667v-10.666a2.667 2.667 0 0 1 2.667 -2.667h10.666a2.667 2.667 0 0 1 2.667 2.667z"
  }));
}
var yWe = ["size", "color", "stroke"];
function CWe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, yWe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-square-chevrons-up",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M9 15l3 -3l3 3"
  }), e.createElement("path", {
    d: "M9 11l3 -3l3 3"
  }), e.createElement("path", {
    d: "M20 6.667v10.666a2.667 2.667 0 0 1 -2.667 2.667h-10.666a2.667 2.667 0 0 1 -2.667 -2.667v-10.666a2.667 2.667 0 0 1 2.667 -2.667h10.666a2.667 2.667 0 0 1 2.667 2.667z"
  }));
}
var jWe = ["size", "color", "stroke"];
function BWe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, jWe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-square-dot",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("rect", {
    x: 4,
    y: 4,
    width: 16,
    height: 16,
    rx: 2
  }), e.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 1
  }));
}
var HWe = ["size", "color", "stroke"];
function NWe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, HWe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-square-f0",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M20 6.667v10.666a2.667 2.667 0 0 1 -2.667 2.667h-10.666a2.667 2.667 0 0 1 -2.667 -2.667v-10.666a2.667 2.667 0 0 1 2.667 -2.667h10.666a2.667 2.667 0 0 1 2.667 2.667z"
  }), e.createElement("path", {
    d: "M13 10.5v3a1.5 1.5 0 0 0 3 0v-3a1.5 1.5 0 0 0 -3 0z"
  }), e.createElement("path", {
    d: "M8 12h2"
  }), e.createElement("path", {
    d: "M10 9h-2v6"
  }));
}
var WWe = ["size", "color", "stroke"];
function qWe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, WWe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-square-f1",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M20 6.667v10.666a2.667 2.667 0 0 1 -2.667 2.667h-10.666a2.667 2.667 0 0 1 -2.667 -2.667v-10.666a2.667 2.667 0 0 1 2.667 -2.667h10.666a2.667 2.667 0 0 1 2.667 2.667z"
  }), e.createElement("path", {
    d: "M13 11l2 -2v6"
  }), e.createElement("path", {
    d: "M8 12h2"
  }), e.createElement("path", {
    d: "M10 9h-2v6"
  }));
}
var OWe = ["size", "color", "stroke"];
function PWe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, OWe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-square-f2",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M20 6.667v10.666a2.667 2.667 0 0 1 -2.667 2.667h-10.666a2.667 2.667 0 0 1 -2.667 -2.667v-10.666a2.667 2.667 0 0 1 2.667 -2.667h10.666a2.667 2.667 0 0 1 2.667 2.667z"
  }), e.createElement("path", {
    d: "M13 9h2a1 1 0 0 1 1 1v1a1 1 0 0 1 -1 1h-1a1 1 0 0 0 -1 1v1a1 1 0 0 0 1 1h2"
  }), e.createElement("path", {
    d: "M8 12h2"
  }), e.createElement("path", {
    d: "M10 9h-2v6"
  }));
}
var SWe = ["size", "color", "stroke"];
function IWe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, SWe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-square-f3",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M20 6.667v10.666a2.667 2.667 0 0 1 -2.667 2.667h-10.666a2.667 2.667 0 0 1 -2.667 -2.667v-10.666a2.667 2.667 0 0 1 2.667 -2.667h10.666a2.667 2.667 0 0 1 2.667 2.667z"
  }), e.createElement("path", {
    d: "M13 9.5a0.5 .5 0 0 1 .5 -.5h1a1.5 1.5 0 0 1 0 3h-.5h.5a1.5 1.5 0 0 1 0 3h-1a0.5 .5 0 0 1 -.5 -.5"
  }), e.createElement("path", {
    d: "M8 12h2"
  }), e.createElement("path", {
    d: "M10 9h-2v6"
  }));
}
var AWe = ["size", "color", "stroke"];
function DWe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, AWe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-square-f4",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M20 6.667v10.666a2.667 2.667 0 0 1 -2.667 2.667h-10.666a2.667 2.667 0 0 1 -2.667 -2.667v-10.666a2.667 2.667 0 0 1 2.667 -2.667h10.666a2.667 2.667 0 0 1 2.667 2.667z"
  }), e.createElement("path", {
    d: "M13 9v2a1 1 0 0 0 1 1h1"
  }), e.createElement("path", {
    d: "M16 9v6"
  }), e.createElement("path", {
    d: "M8 12h2"
  }), e.createElement("path", {
    d: "M10 9h-2v6"
  }));
}
var FWe = ["size", "color", "stroke"];
function GWe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, FWe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-square-f5",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M20 6.667v10.666a2.667 2.667 0 0 1 -2.667 2.667h-10.666a2.667 2.667 0 0 1 -2.667 -2.667v-10.666a2.667 2.667 0 0 1 2.667 -2.667h10.666a2.667 2.667 0 0 1 2.667 2.667z"
  }), e.createElement("path", {
    d: "M13 14.25c0 .414 .336 .75 .75 .75h1.25a1 1 0 0 0 1 -1v-1a1 1 0 0 0 -1 -1h-2v-3h3"
  }), e.createElement("path", {
    d: "M8 12h2"
  }), e.createElement("path", {
    d: "M10 9h-2v6"
  }));
}
var JWe = ["size", "color", "stroke"];
function KWe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, JWe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-square-f6",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M20 6.667v10.666a2.667 2.667 0 0 1 -2.667 2.667h-10.666a2.667 2.667 0 0 1 -2.667 -2.667v-10.666a2.667 2.667 0 0 1 2.667 -2.667h10.666a2.667 2.667 0 0 1 2.667 2.667z"
  }), e.createElement("path", {
    d: "M16 9.75a0.75 .75 0 0 0 -.75 -.75h-1.25a1 1 0 0 0 -1 1v4a1 1 0 0 0 1 1h1a1 1 0 0 0 1 -1v-1a1 1 0 0 0 -1 -1h-2"
  }), e.createElement("path", {
    d: "M8 12h2"
  }), e.createElement("path", {
    d: "M10 9h-2v6"
  }));
}
var QWe = ["size", "color", "stroke"];
function RWe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, QWe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-square-f7",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M20 6.667v10.666a2.667 2.667 0 0 1 -2.667 2.667h-10.666a2.667 2.667 0 0 1 -2.667 -2.667v-10.666a2.667 2.667 0 0 1 2.667 -2.667h10.666a2.667 2.667 0 0 1 2.667 2.667z"
  }), e.createElement("path", {
    d: "M13 9h3l-1.5 6"
  }), e.createElement("path", {
    d: "M8 12h2"
  }), e.createElement("path", {
    d: "M10 9h-2v6"
  }));
}
var TWe = ["size", "color", "stroke"];
function UWe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, TWe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-square-f8",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M20 6.667v10.666a2.667 2.667 0 0 1 -2.667 2.667h-10.666a2.667 2.667 0 0 1 -2.667 -2.667v-10.666a2.667 2.667 0 0 1 2.667 -2.667h10.666a2.667 2.667 0 0 1 2.667 2.667z"
  }), e.createElement("path", {
    d: "M14.5 12h-.5a1 1 0 0 1 -1 -1v-1a1 1 0 0 1 1 -1h1a1 1 0 0 1 1 1v1a1 1 0 0 1 -1 1h-1a1 1 0 0 0 -1 1v1a1 1 0 0 0 1 1h1a1 1 0 0 0 1 -1v-1a1 1 0 0 0 -1 -1"
  }), e.createElement("path", {
    d: "M8 12h2"
  }), e.createElement("path", {
    d: "M10 9h-2v6"
  }));
}
var VWe = ["size", "color", "stroke"];
function XWe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, VWe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-square-f9",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M20 6.667v10.666a2.667 2.667 0 0 1 -2.667 2.667h-10.666a2.667 2.667 0 0 1 -2.667 -2.667v-10.666a2.667 2.667 0 0 1 2.667 -2.667h10.666a2.667 2.667 0 0 1 2.667 2.667z"
  }), e.createElement("path", {
    d: "M13 14.25c0 .414 .336 .75 .75 .75h1.5a0.75 .75 0 0 0 .75 -.75v-4.5a0.75 .75 0 0 0 -.75 -.75h-1.5a0.75 .75 0 0 0 -.75 .75v1.5c0 .414 .336 .75 .75 .75h2.25"
  }), e.createElement("path", {
    d: "M8 12h2"
  }), e.createElement("path", {
    d: "M10 9h-2v6"
  }));
}
var YWe = ["size", "color", "stroke"];
function ZWe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, YWe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-square-forbid-2",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("rect", {
    x: 4,
    y: 4,
    width: 16,
    height: 16,
    rx: 2
  }), e.createElement("line", {
    x1: 9,
    y1: 15,
    x2: 15,
    y2: 9
  }));
}
var $We = ["size", "color", "stroke"];
function _We(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, $We);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-square-forbid",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("rect", {
    x: 4,
    y: 4,
    width: 16,
    height: 16,
    rx: 2
  }), e.createElement("line", {
    x1: 9,
    y1: 9,
    x2: 15,
    y2: 15
  }));
}
var eqe = ["size", "color", "stroke"];
function tqe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, eqe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-square-half",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M12 4v16"
  }), e.createElement("rect", {
    x: 4,
    y: 4,
    width: 16,
    height: 16,
    rx: 2
  }), e.createElement("path", {
    d: "M12 13l7.5 -7.5"
  }), e.createElement("path", {
    d: "M12 18l8 -8"
  }), e.createElement("path", {
    d: "M15 20l5 -5"
  }), e.createElement("path", {
    d: "M12 8l4 -4"
  }));
}
var oqe = ["size", "color", "stroke"];
function rqe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, oqe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-square-key",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("circle", {
    cx: 14,
    cy: 10,
    r: 2
  }), e.createElement("path", {
    d: "M12.5 11.5l-4 4l1.5 1.5"
  }), e.createElement("path", {
    d: "M12 15l-1.5 -1.5"
  }), e.createElement("path", {
    d: "M20 6.667v10.666a2.667 2.667 0 0 1 -2.667 2.667h-10.666a2.667 2.667 0 0 1 -2.667 -2.667v-10.666a2.667 2.667 0 0 1 2.667 -2.667h10.666a2.667 2.667 0 0 1 2.667 2.667z"
  }));
}
var nqe = ["size", "color", "stroke"];
function lqe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, nqe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-square-letter-a",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("rect", {
    x: 4,
    y: 4,
    width: 16,
    height: 16,
    rx: 2
  }), e.createElement("path", {
    d: "M10 16v-6a2 2 0 1 1 4 0v6"
  }), e.createElement("path", {
    d: "M10 13h4"
  }));
}
var aqe = ["size", "color", "stroke"];
function iqe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, aqe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-square-letter-b",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("rect", {
    x: 4,
    y: 4,
    width: 16,
    height: 16,
    rx: 2
  }), e.createElement("path", {
    d: "M10 16h2a2 2 0 1 0 0 -4h-2h2a2 2 0 1 0 0 -4h-2v8z"
  }));
}
var cqe = ["size", "color", "stroke"];
function sqe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, cqe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-square-letter-c",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("rect", {
    x: 4,
    y: 4,
    width: 16,
    height: 16,
    rx: 2
  }), e.createElement("path", {
    d: "M14 10a2 2 0 1 0 -4 0v4a2 2 0 1 0 4 0"
  }));
}
var hqe = ["size", "color", "stroke"];
function dqe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, hqe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-square-letter-d",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("rect", {
    x: 4,
    y: 4,
    width: 16,
    height: 16,
    rx: 2
  }), e.createElement("path", {
    d: "M10 8v8h2a2 2 0 0 0 2 -2v-4a2 2 0 0 0 -2 -2h-2z"
  }));
}
var vqe = ["size", "color", "stroke"];
function mqe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, vqe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-square-letter-e",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("rect", {
    x: 4,
    y: 4,
    width: 16,
    height: 16,
    rx: 2
  }), e.createElement("path", {
    d: "M14 8h-4v8h4"
  }), e.createElement("path", {
    d: "M10 12h2.5"
  }));
}
var kqe = ["size", "color", "stroke"];
function wqe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, kqe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-square-letter-f",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("rect", {
    x: 4,
    y: 4,
    width: 16,
    height: 16,
    rx: 2
  }), e.createElement("path", {
    d: "M10 12h3"
  }), e.createElement("path", {
    d: "M14 8h-4v8"
  }));
}
var pqe = ["size", "color", "stroke"];
function Eqe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, pqe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-square-letter-g",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("rect", {
    x: 4,
    y: 4,
    width: 16,
    height: 16,
    rx: 2
  }), e.createElement("path", {
    d: "M14 8h-2a2 2 0 0 0 -2 2v4a2 2 0 0 0 2 2h2v-4h-1"
  }));
}
var uqe = ["size", "color", "stroke"];
function gqe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, uqe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-square-letter-h",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("rect", {
    x: 4,
    y: 4,
    width: 16,
    height: 16,
    rx: 2
  }), e.createElement("path", {
    d: "M10 16v-8m4 0v8"
  }), e.createElement("path", {
    d: "M10 12h4"
  }));
}
var Mqe = ["size", "color", "stroke"];
function xqe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Mqe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-square-letter-i",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("rect", {
    x: 4,
    y: 4,
    width: 16,
    height: 16,
    rx: 2
  }), e.createElement("path", {
    d: "M12 8v8"
  }));
}
var fqe = ["size", "color", "stroke"];
function zqe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, fqe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-square-letter-j",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("rect", {
    x: 4,
    y: 4,
    width: 16,
    height: 16,
    rx: 2
  }), e.createElement("path", {
    d: "M10 8h4v6a2 2 0 1 1 -4 0"
  }));
}
var bqe = ["size", "color", "stroke"];
function Lqe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, bqe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-square-letter-k",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("rect", {
    x: 4,
    y: 4,
    width: 16,
    height: 16,
    rx: 2
  }), e.createElement("path", {
    d: "M10 8v8"
  }), e.createElement("path", {
    d: "M14 8l-2.5 4l2.5 4"
  }), e.createElement("path", {
    d: "M10 12h1.5"
  }));
}
var yqe = ["size", "color", "stroke"];
function Cqe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, yqe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-square-letter-l",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("rect", {
    x: 4,
    y: 4,
    width: 16,
    height: 16,
    rx: 2
  }), e.createElement("path", {
    d: "M10 8v8h4"
  }));
}
var jqe = ["size", "color", "stroke"];
function Bqe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, jqe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-square-letter-m",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("rect", {
    x: 4,
    y: 4,
    width: 16,
    height: 16,
    rx: 2
  }), e.createElement("path", {
    d: "M9 16v-8l3 5l3 -5v8"
  }));
}
var Hqe = ["size", "color", "stroke"];
function Nqe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Hqe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-square-letter-n",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("rect", {
    x: 4,
    y: 4,
    width: 16,
    height: 16,
    rx: 2
  }), e.createElement("path", {
    d: "M10 16v-8l4 8v-8"
  }));
}
var Wqe = ["size", "color", "stroke"];
function qqe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Wqe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-square-letter-o",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("rect", {
    x: 4,
    y: 4,
    width: 16,
    height: 16,
    rx: 2
  }), e.createElement("path", {
    d: "M12 8a2 2 0 0 1 2 2v4a2 2 0 1 1 -4 0v-4a2 2 0 0 1 2 -2z"
  }));
}
var Oqe = ["size", "color", "stroke"];
function Pqe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Oqe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-square-letter-p",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("rect", {
    x: 4,
    y: 4,
    width: 16,
    height: 16,
    rx: 2
  }), e.createElement("path", {
    d: "M10 12h2a2 2 0 1 0 0 -4h-2v8"
  }));
}
var Sqe = ["size", "color", "stroke"];
function Iqe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Sqe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-square-letter-q",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("rect", {
    x: 4,
    y: 4,
    width: 16,
    height: 16,
    rx: 2
  }), e.createElement("path", {
    d: "M12 8a2 2 0 0 1 2 2v4a2 2 0 1 1 -4 0v-4a2 2 0 0 1 2 -2z"
  }), e.createElement("path", {
    d: "M13 15l1 1"
  }));
}
var Aqe = ["size", "color", "stroke"];
function Dqe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Aqe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-square-letter-r",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("rect", {
    x: 4,
    y: 4,
    width: 16,
    height: 16,
    rx: 2
  }), e.createElement("path", {
    d: "M10 12h2a2 2 0 1 0 0 -4h-2v8m4 0l-3 -4"
  }));
}
var Fqe = ["size", "color", "stroke"];
function Gqe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Fqe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-square-letter-s",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("rect", {
    x: 4,
    y: 4,
    width: 16,
    height: 16,
    rx: 2
  }), e.createElement("path", {
    d: "M10 15a1 1 0 0 0 1 1h2a1 1 0 0 0 1 -1v-2a1 1 0 0 0 -1 -1h-2a1 1 0 0 1 -1 -1v-2a1 1 0 0 1 1 -1h2a1 1 0 0 1 1 1"
  }));
}
var Jqe = ["size", "color", "stroke"];
function Kqe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Jqe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-square-letter-t",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("rect", {
    x: 4,
    y: 4,
    width: 16,
    height: 16,
    rx: 2
  }), e.createElement("path", {
    d: "M10 8h4"
  }), e.createElement("path", {
    d: "M12 8v8"
  }));
}
var Qqe = ["size", "color", "stroke"];
function Rqe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Qqe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-square-letter-u",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("rect", {
    x: 4,
    y: 4,
    width: 16,
    height: 16,
    rx: 2
  }), e.createElement("path", {
    d: "M10 8v6a2 2 0 1 0 4 0v-6"
  }));
}
var Tqe = ["size", "color", "stroke"];
function Uqe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Tqe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-square-letter-v",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("rect", {
    x: 4,
    y: 4,
    width: 16,
    height: 16,
    rx: 2
  }), e.createElement("path", {
    d: "M10 8l2 8l2 -8"
  }));
}
var Vqe = ["size", "color", "stroke"];
function Xqe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Vqe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-square-letter-w",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("rect", {
    x: 4,
    y: 4,
    width: 16,
    height: 16,
    rx: 2
  }), e.createElement("path", {
    d: "M9 8l1 8l2 -5l2 5l1 -8"
  }));
}
var Yqe = ["size", "color", "stroke"];
function Zqe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, Yqe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-square-letter-x",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("rect", {
    x: 4,
    y: 4,
    width: 16,
    height: 16,
    rx: 2
  }), e.createElement("path", {
    d: "M10 8l4 8"
  }), e.createElement("path", {
    d: "M10 16l4 -8"
  }));
}
var $qe = ["size", "color", "stroke"];
function _qe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, $qe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-square-letter-y",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("rect", {
    x: 4,
    y: 4,
    width: 16,
    height: 16,
    rx: 2
  }), e.createElement("path", {
    d: "M10 8l2 5l2 -5"
  }), e.createElement("path", {
    d: "M12 16v-3"
  }));
}
var eOe = ["size", "color", "stroke"];
function tOe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, eOe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-square-letter-z",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("rect", {
    x: 4,
    y: 4,
    width: 16,
    height: 16,
    rx: 2
  }), e.createElement("path", {
    d: "M10 8h4l-4 8h4"
  }));
}
var oOe = ["size", "color", "stroke"];
function rOe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, oOe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-square-minus",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("rect", {
    x: 4,
    y: 4,
    width: 16,
    height: 16,
    rx: 2
  }), e.createElement("line", {
    x1: 9,
    y1: 12,
    x2: 15,
    y2: 12
  }));
}
var nOe = ["size", "color", "stroke"];
function lOe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, nOe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-square-number-0",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("rect", {
    x: 4,
    y: 4,
    width: 16,
    height: 16,
    rx: 2
  }), e.createElement("path", {
    d: "M10 10v4a2 2 0 1 0 4 0v-4a2 2 0 1 0 -4 0z"
  }));
}
var aOe = ["size", "color", "stroke"];
function iOe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, aOe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-square-number-1",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("rect", {
    x: 4,
    y: 4,
    width: 16,
    height: 16,
    rx: 2
  }), e.createElement("path", {
    d: "M10 10l2 -2v8"
  }));
}
var cOe = ["size", "color", "stroke"];
function sOe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, cOe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-square-number-2",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("rect", {
    x: 4,
    y: 4,
    width: 16,
    height: 16,
    rx: 2
  }), e.createElement("path", {
    d: "M10 8h3a1 1 0 0 1 1 1v2a1 1 0 0 1 -1 1h-2a1 1 0 0 0 -1 1v2a1 1 0 0 0 1 1h3"
  }));
}
var hOe = ["size", "color", "stroke"];
function dOe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, hOe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-square-number-3",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("rect", {
    x: 4,
    y: 4,
    width: 16,
    height: 16,
    rx: 2
  }), e.createElement("path", {
    d: "M10 9a1 1 0 0 1 1 -1h2a1 1 0 0 1 1 1v2a1 1 0 0 1 -1 1h-2h2a1 1 0 0 1 1 1v2a1 1 0 0 1 -1 1h-2a1 1 0 0 1 -1 -1"
  }));
}
var vOe = ["size", "color", "stroke"];
function mOe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, vOe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-square-number-4",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("rect", {
    x: 4,
    y: 4,
    width: 16,
    height: 16,
    rx: 2
  }), e.createElement("path", {
    d: "M10 8v3a1 1 0 0 0 1 1h3"
  }), e.createElement("path", {
    d: "M14 8v8"
  }));
}
var kOe = ["size", "color", "stroke"];
function wOe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, kOe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-square-number-5",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("rect", {
    x: 4,
    y: 4,
    width: 16,
    height: 16,
    rx: 2
  }), e.createElement("path", {
    d: "M10 15a1 1 0 0 0 1 1h2a1 1 0 0 0 1 -1v-2a1 1 0 0 0 -1 -1h-3v-4h4"
  }));
}
var pOe = ["size", "color", "stroke"];
function EOe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, pOe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-square-number-6",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("rect", {
    x: 4,
    y: 4,
    width: 16,
    height: 16,
    rx: 2
  }), e.createElement("path", {
    d: "M14 9a1 1 0 0 0 -1 -1h-2a1 1 0 0 0 -1 1v6a1 1 0 0 0 1 1h2a1 1 0 0 0 1 -1v-2a1 1 0 0 0 -1 -1h-3"
  }));
}
var uOe = ["size", "color", "stroke"];
function gOe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, uOe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-square-number-7",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("rect", {
    x: 4,
    y: 4,
    width: 16,
    height: 16,
    rx: 2
  }), e.createElement("path", {
    d: "M10 8h4l-2 8"
  }));
}
var MOe = ["size", "color", "stroke"];
function xOe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, MOe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-square-number-8",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("rect", {
    x: 4,
    y: 4,
    width: 16,
    height: 16,
    rx: 2
  }), e.createElement("path", {
    d: "M12 12h-1a1 1 0 0 1 -1 -1v-2a1 1 0 0 1 1 -1h2a1 1 0 0 1 1 1v2a1 1 0 0 1 -1 1h-2a1 1 0 0 0 -1 1v2a1 1 0 0 0 1 1h2a1 1 0 0 0 1 -1v-2a1 1 0 0 0 -1 -1"
  }));
}
var fOe = ["size", "color", "stroke"];
function zOe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, fOe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-square-number-9",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("rect", {
    x: 4,
    y: 4,
    width: 16,
    height: 16,
    rx: 2
  }), e.createElement("path", {
    d: "M10 15a1 1 0 0 0 1 1h2a1 1 0 0 0 1 -1v-6a1 1 0 0 0 -1 -1h-2a1 1 0 0 0 -1 1v2a1 1 0 0 0 1 1h3"
  }));
}
var bOe = ["size", "color", "stroke"];
function LOe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, bOe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-square-off",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M8 4h10a2 2 0 0 1 2 2v10m-.584 3.412a1.994 1.994 0 0 1 -1.416 .588h-12a2 2 0 0 1 -2 -2v-12c0 -.552 .224 -1.052 .586 -1.414"
  }), e.createElement("path", {
    d: "M3 3l18 18"
  }));
}
var yOe = ["size", "color", "stroke"];
function COe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, yOe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-square-plus",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("rect", {
    x: 4,
    y: 4,
    width: 16,
    height: 16,
    rx: 2
  }), e.createElement("line", {
    x1: 9,
    y1: 12,
    x2: 15,
    y2: 12
  }), e.createElement("line", {
    x1: 12,
    y1: 9,
    x2: 12,
    y2: 15
  }));
}
var jOe = ["size", "color", "stroke"];
function BOe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, jOe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-square-root-2",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M13 12h1c1 0 1 1 2.016 3.527c.984 2.473 .984 3.473 1.984 3.473h1"
  }), e.createElement("path", {
    d: "M12 19c1.5 0 3 -2 4 -3.5s2.5 -3.5 4 -3.5"
  }), e.createElement("path", {
    d: "M3 12h1l3 8l3 -16h10"
  }));
}
var HOe = ["size", "color", "stroke"];
function NOe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, HOe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-square-root",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M3 12h2l4 8l4 -16h8"
  }));
}
var WOe = ["size", "color", "stroke"];
function qOe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, WOe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-square-rotated-forbid-2",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M10.5 20.4l-6.9 -6.9c-.781 -.781 -.781 -2.219 0 -3l6.9 -6.9c.781 -.781 2.219 -.781 3 0l6.9 6.9c.781 .781 .781 2.219 0 3l-6.9 6.9c-.781 .781 -2.219 .781 -3 0z"
  }), e.createElement("path", {
    d: "M9.5 9.5l5 5"
  }));
}
var OOe = ["size", "color", "stroke"];
function POe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, OOe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-square-rotated-forbid",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M10.5 20.4l-6.9 -6.9c-.781 -.781 -.781 -2.219 0 -3l6.9 -6.9c.781 -.781 2.219 -.781 3 0l6.9 6.9c.781 .781 .781 2.219 0 3l-6.9 6.9c-.781 .781 -2.219 .781 -3 0z"
  }), e.createElement("path", {
    d: "M9.5 14.5l5 -5"
  }));
}
var SOe = ["size", "color", "stroke"];
function IOe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, SOe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-square-rotated-off",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M16.964 16.952l-3.462 3.461c-.782 .783 -2.222 .783 -3.004 0l-6.911 -6.91c-.783 -.783 -.783 -2.223 0 -3.005l3.455 -3.456m2.003 -2.003l1.453 -1.452c.782 -.783 2.222 -.783 3.004 0l6.911 6.91c.783 .783 .783 2.223 0 3.005l-1.448 1.45"
  }), e.createElement("path", {
    d: "M3 3l18 18"
  }));
}
var AOe = ["size", "color", "stroke"];
function DOe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, AOe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-square-rotated",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M10.5 20.4l-6.9 -6.9c-.781 -.781 -.781 -2.219 0 -3l6.9 -6.9c.781 -.781 2.219 -.781 3 0l6.9 6.9c.781 .781 .781 2.219 0 3l-6.9 6.9c-.781 .781 -2.219 .781 -3 0z"
  }));
}
var FOe = ["size", "color", "stroke"];
function GOe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, FOe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-square-rounded-arrow-down",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M8 12l4 4l4 -4"
  }), e.createElement("path", {
    d: "M12 8v8"
  }), e.createElement("path", {
    d: "M12 3c7.2 0 9 1.8 9 9s-1.8 9 -9 9s-9 -1.8 -9 -9s1.8 -9 9 -9z"
  }));
}
var JOe = ["size", "color", "stroke"];
function KOe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, JOe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-square-rounded-arrow-left",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M12 8l-4 4l4 4"
  }), e.createElement("path", {
    d: "M16 12h-8"
  }), e.createElement("path", {
    d: "M12 3c7.2 0 9 1.8 9 9s-1.8 9 -9 9s-9 -1.8 -9 -9s1.8 -9 9 -9z"
  }));
}
var QOe = ["size", "color", "stroke"];
function ROe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, QOe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-square-rounded-arrow-right",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M12 16l4 -4l-4 -4"
  }), e.createElement("path", {
    d: "M8 12h8"
  }), e.createElement("path", {
    d: "M12 3c7.2 0 9 1.8 9 9s-1.8 9 -9 9s-9 -1.8 -9 -9s1.8 -9 9 -9z"
  }));
}
var TOe = ["size", "color", "stroke"];
function UOe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, TOe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-square-rounded-arrow-up",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M16 12l-4 -4l-4 4"
  }), e.createElement("path", {
    d: "M12 16v-8"
  }), e.createElement("path", {
    d: "M12 3c7.2 0 9 1.8 9 9s-1.8 9 -9 9s-9 -1.8 -9 -9s1.8 -9 9 -9z"
  }));
}
var VOe = ["size", "color", "stroke"];
function XOe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, VOe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-square-rounded-check",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M9 12l2 2l4 -4"
  }), e.createElement("path", {
    d: "M12 3c7.2 0 9 1.8 9 9s-1.8 9 -9 9s-9 -1.8 -9 -9s1.8 -9 9 -9z"
  }));
}
var YOe = ["size", "color", "stroke"];
function ZOe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, YOe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-square-rounded-chevron-down",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M15 11l-3 3l-3 -3"
  }), e.createElement("path", {
    d: "M12 3c7.2 0 9 1.8 9 9s-1.8 9 -9 9s-9 -1.8 -9 -9s1.8 -9 9 -9z"
  }));
}
var $Oe = ["size", "color", "stroke"];
function _Oe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, $Oe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-square-rounded-chevron-left",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M13 15l-3 -3l3 -3"
  }), e.createElement("path", {
    d: "M12 3c7.2 0 9 1.8 9 9s-1.8 9 -9 9s-9 -1.8 -9 -9s1.8 -9 9 -9z"
  }));
}
var ePe = ["size", "color", "stroke"];
function tPe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, ePe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-square-rounded-chevron-right",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M11 9l3 3l-3 3"
  }), e.createElement("path", {
    d: "M12 3c7.2 0 9 1.8 9 9s-1.8 9 -9 9s-9 -1.8 -9 -9s1.8 -9 9 -9z"
  }));
}
var oPe = ["size", "color", "stroke"];
function rPe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, oPe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-square-rounded-chevron-up",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M9 13l3 -3l3 3"
  }), e.createElement("path", {
    d: "M12 3c7.2 0 9 1.8 9 9s-1.8 9 -9 9s-9 -1.8 -9 -9s1.8 -9 9 -9z"
  }));
}
var nPe = ["size", "color", "stroke"];
function lPe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, nPe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-square-rounded-chevrons-down",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M15 9l-3 3l-3 -3"
  }), e.createElement("path", {
    d: "M15 13l-3 3l-3 -3"
  }), e.createElement("path", {
    d: "M12 3c7.2 0 9 1.8 9 9s-1.8 9 -9 9s-9 -1.8 -9 -9s1.8 -9 9 -9z"
  }));
}
var aPe = ["size", "color", "stroke"];
function iPe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, aPe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-square-rounded-chevrons-left",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M15 15l-3 -3l3 -3"
  }), e.createElement("path", {
    d: "M11 15l-3 -3l3 -3"
  }), e.createElement("path", {
    d: "M12 3c7.2 0 9 1.8 9 9s-1.8 9 -9 9s-9 -1.8 -9 -9s1.8 -9 9 -9z"
  }));
}
var cPe = ["size", "color", "stroke"];
function sPe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, cPe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-square-rounded-chevrons-right",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M9 9l3 3l-3 3"
  }), e.createElement("path", {
    d: "M13 9l3 3l-3 3"
  }), e.createElement("path", {
    d: "M12 3c7.2 0 9 1.8 9 9s-1.8 9 -9 9s-9 -1.8 -9 -9s1.8 -9 9 -9z"
  }));
}
var hPe = ["size", "color", "stroke"];
function dPe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, hPe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-square-rounded-chevrons-up",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M9 15l3 -3l3 3"
  }), e.createElement("path", {
    d: "M9 11l3 -3l3 3"
  }), e.createElement("path", {
    d: "M12 3c7.2 0 9 1.8 9 9s-1.8 9 -9 9s-9 -1.8 -9 -9s1.8 -9 9 -9z"
  }));
}
var vPe = ["size", "color", "stroke"];
function mPe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, vPe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-square-rounded-letter-a",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M10 16v-6a2 2 0 1 1 4 0v6"
  }), e.createElement("path", {
    d: "M10 13h4"
  }), e.createElement("path", {
    d: "M12 3c7.2 0 9 1.8 9 9s-1.8 9 -9 9s-9 -1.8 -9 -9s1.8 -9 9 -9z"
  }));
}
var kPe = ["size", "color", "stroke"];
function wPe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, kPe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-square-rounded-letter-b",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M10 16h2a2 2 0 1 0 0 -4h-2h2a2 2 0 1 0 0 -4h-2v8z"
  }), e.createElement("path", {
    d: "M12 3c7.2 0 9 1.8 9 9s-1.8 9 -9 9s-9 -1.8 -9 -9s1.8 -9 9 -9z"
  }));
}
var pPe = ["size", "color", "stroke"];
function EPe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, pPe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-square-rounded-letter-c",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M14 10a2 2 0 1 0 -4 0v4a2 2 0 1 0 4 0"
  }), e.createElement("path", {
    d: "M12 3c7.2 0 9 1.8 9 9s-1.8 9 -9 9s-9 -1.8 -9 -9s1.8 -9 9 -9z"
  }));
}
var uPe = ["size", "color", "stroke"];
function gPe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, uPe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-square-rounded-letter-d",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M10 8v8h2a2 2 0 0 0 2 -2v-4a2 2 0 0 0 -2 -2h-2z"
  }), e.createElement("path", {
    d: "M12 3c7.2 0 9 1.8 9 9s-1.8 9 -9 9s-9 -1.8 -9 -9s1.8 -9 9 -9z"
  }));
}
var MPe = ["size", "color", "stroke"];
function xPe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, MPe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-square-rounded-letter-e",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M14 8h-4v8h4"
  }), e.createElement("path", {
    d: "M10 12h2.5"
  }), e.createElement("path", {
    d: "M12 3c7.2 0 9 1.8 9 9s-1.8 9 -9 9s-9 -1.8 -9 -9s1.8 -9 9 -9z"
  }));
}
var fPe = ["size", "color", "stroke"];
function zPe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, fPe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-square-rounded-letter-f",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M10 12h3"
  }), e.createElement("path", {
    d: "M14 8h-4v8"
  }), e.createElement("path", {
    d: "M12 3c7.2 0 9 1.8 9 9s-1.8 9 -9 9s-9 -1.8 -9 -9s1.8 -9 9 -9z"
  }));
}
var bPe = ["size", "color", "stroke"];
function LPe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, bPe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-square-rounded-letter-g",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M14 8h-2a2 2 0 0 0 -2 2v4a2 2 0 0 0 2 2h2v-4h-1"
  }), e.createElement("path", {
    d: "M12 3c7.2 0 9 1.8 9 9s-1.8 9 -9 9s-9 -1.8 -9 -9s1.8 -9 9 -9z"
  }));
}
var yPe = ["size", "color", "stroke"];
function CPe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, yPe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-square-rounded-letter-h",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M10 16v-8m4 0v8"
  }), e.createElement("path", {
    d: "M10 12h4"
  }), e.createElement("path", {
    d: "M12 3c7.2 0 9 1.8 9 9s-1.8 9 -9 9s-9 -1.8 -9 -9s1.8 -9 9 -9z"
  }));
}
var jPe = ["size", "color", "stroke"];
function BPe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, jPe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-square-rounded-letter-i",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M12 8v8"
  }), e.createElement("path", {
    d: "M12 3c7.2 0 9 1.8 9 9s-1.8 9 -9 9s-9 -1.8 -9 -9s1.8 -9 9 -9z"
  }));
}
var HPe = ["size", "color", "stroke"];
function NPe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, HPe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-square-rounded-letter-j",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M10 8h4v6a2 2 0 1 1 -4 0"
  }), e.createElement("path", {
    d: "M12 3c7.2 0 9 1.8 9 9s-1.8 9 -9 9s-9 -1.8 -9 -9s1.8 -9 9 -9z"
  }));
}
var WPe = ["size", "color", "stroke"];
function qPe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, WPe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-square-rounded-letter-k",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M10 8v8"
  }), e.createElement("path", {
    d: "M14 8l-2.5 4l2.5 4"
  }), e.createElement("path", {
    d: "M10 12h1.5"
  }), e.createElement("path", {
    d: "M12 3c7.2 0 9 1.8 9 9s-1.8 9 -9 9s-9 -1.8 -9 -9s1.8 -9 9 -9z"
  }));
}
var OPe = ["size", "color", "stroke"];
function PPe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, OPe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-square-rounded-letter-l",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M10 8v8h4"
  }), e.createElement("path", {
    d: "M12 3c7.2 0 9 1.8 9 9s-1.8 9 -9 9s-9 -1.8 -9 -9s1.8 -9 9 -9z"
  }));
}
var SPe = ["size", "color", "stroke"];
function IPe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, SPe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-square-rounded-letter-m",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M9 16v-8l3 5l3 -5v8"
  }), e.createElement("path", {
    d: "M12 3c7.2 0 9 1.8 9 9s-1.8 9 -9 9s-9 -1.8 -9 -9s1.8 -9 9 -9z"
  }));
}
var APe = ["size", "color", "stroke"];
function DPe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, APe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-square-rounded-letter-n",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M10 16v-8l4 8v-8"
  }), e.createElement("path", {
    d: "M12 3c7.2 0 9 1.8 9 9s-1.8 9 -9 9s-9 -1.8 -9 -9s1.8 -9 9 -9z"
  }));
}
var FPe = ["size", "color", "stroke"];
function GPe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, FPe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-square-rounded-letter-o",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M12 8a2 2 0 0 1 2 2v4a2 2 0 1 1 -4 0v-4a2 2 0 0 1 2 -2z"
  }), e.createElement("path", {
    d: "M12 3c7.2 0 9 1.8 9 9s-1.8 9 -9 9s-9 -1.8 -9 -9s1.8 -9 9 -9z"
  }));
}
var JPe = ["size", "color", "stroke"];
function KPe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, JPe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-square-rounded-letter-p",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M10 12h2a2 2 0 1 0 0 -4h-2v8"
  }), e.createElement("path", {
    d: "M12 3c7.2 0 9 1.8 9 9s-1.8 9 -9 9s-9 -1.8 -9 -9s1.8 -9 9 -9z"
  }));
}
var QPe = ["size", "color", "stroke"];
function RPe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, QPe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-square-rounded-letter-q",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M12 8a2 2 0 0 1 2 2v4a2 2 0 1 1 -4 0v-4a2 2 0 0 1 2 -2z"
  }), e.createElement("path", {
    d: "M13 15l1 1"
  }), e.createElement("path", {
    d: "M12 3c7.2 0 9 1.8 9 9s-1.8 9 -9 9s-9 -1.8 -9 -9s1.8 -9 9 -9z"
  }));
}
var TPe = ["size", "color", "stroke"];
function UPe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, TPe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-square-rounded-letter-r",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M10 12h2a2 2 0 1 0 0 -4h-2v8m4 0l-3 -4"
  }), e.createElement("path", {
    d: "M12 3c7.2 0 9 1.8 9 9s-1.8 9 -9 9s-9 -1.8 -9 -9s1.8 -9 9 -9z"
  }));
}
var VPe = ["size", "color", "stroke"];
function XPe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, VPe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-square-rounded-letter-s",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M10 15a1 1 0 0 0 1 1h2a1 1 0 0 0 1 -1v-2a1 1 0 0 0 -1 -1h-2a1 1 0 0 1 -1 -1v-2a1 1 0 0 1 1 -1h2a1 1 0 0 1 1 1"
  }), e.createElement("path", {
    d: "M12 3c7.2 0 9 1.8 9 9s-1.8 9 -9 9s-9 -1.8 -9 -9s1.8 -9 9 -9z"
  }));
}
var YPe = ["size", "color", "stroke"];
function ZPe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, YPe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-square-rounded-letter-t",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M10 8h4"
  }), e.createElement("path", {
    d: "M12 8v8"
  }), e.createElement("path", {
    d: "M12 3c7.2 0 9 1.8 9 9s-1.8 9 -9 9s-9 -1.8 -9 -9s1.8 -9 9 -9z"
  }));
}
var $Pe = ["size", "color", "stroke"];
function _Pe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, $Pe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-square-rounded-letter-u",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M10 8v6a2 2 0 1 0 4 0v-6"
  }), e.createElement("path", {
    d: "M12 3c7.2 0 9 1.8 9 9s-1.8 9 -9 9s-9 -1.8 -9 -9s1.8 -9 9 -9z"
  }));
}
var eSe = ["size", "color", "stroke"];
function tSe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, eSe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-square-rounded-letter-v",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M10 8l2 8l2 -8"
  }), e.createElement("path", {
    d: "M12 3c7.2 0 9 1.8 9 9s-1.8 9 -9 9s-9 -1.8 -9 -9s1.8 -9 9 -9z"
  }));
}
var oSe = ["size", "color", "stroke"];
function rSe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, oSe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-square-rounded-letter-w",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M9 8l1 8l2 -5l2 5l1 -8"
  }), e.createElement("path", {
    d: "M12 3c7.2 0 9 1.8 9 9s-1.8 9 -9 9s-9 -1.8 -9 -9s1.8 -9 9 -9z"
  }));
}
var nSe = ["size", "color", "stroke"];
function lSe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, nSe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-square-rounded-letter-x",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M10 8l4 8"
  }), e.createElement("path", {
    d: "M10 16l4 -8"
  }), e.createElement("path", {
    d: "M12 3c7.2 0 9 1.8 9 9s-1.8 9 -9 9s-9 -1.8 -9 -9s1.8 -9 9 -9z"
  }));
}
var aSe = ["size", "color", "stroke"];
function iSe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, aSe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-square-rounded-letter-y",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M10 8l2 5l2 -5"
  }), e.createElement("path", {
    d: "M12 16v-3"
  }), e.createElement("path", {
    d: "M12 3c7.2 0 9 1.8 9 9s-1.8 9 -9 9s-9 -1.8 -9 -9s1.8 -9 9 -9z"
  }));
}
var cSe = ["size", "color", "stroke"];
function sSe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, cSe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-square-rounded-letter-z",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M10 8h4l-4 8h4"
  }), e.createElement("path", {
    d: "M12 3c7.2 0 9 1.8 9 9s-1.8 9 -9 9s-9 -1.8 -9 -9s1.8 -9 9 -9z"
  }));
}
var hSe = ["size", "color", "stroke"];
function dSe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, hSe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-square-rounded-minus",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M9 12h6"
  }), e.createElement("path", {
    d: "M12 3c7.2 0 9 1.8 9 9s-1.8 9 -9 9s-9 -1.8 -9 -9s1.8 -9 9 -9z"
  }));
}
var vSe = ["size", "color", "stroke"];
function mSe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, vSe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-square-rounded-number-0",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M10 10v4a2 2 0 1 0 4 0v-4a2 2 0 1 0 -4 0z"
  }), e.createElement("path", {
    d: "M12 3c7.2 0 9 1.8 9 9s-1.8 9 -9 9s-9 -1.8 -9 -9s1.8 -9 9 -9z"
  }));
}
var kSe = ["size", "color", "stroke"];
function wSe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, kSe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-square-rounded-number-1",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M10 10l2 -2v8"
  }), e.createElement("path", {
    d: "M12 3c7.2 0 9 1.8 9 9s-1.8 9 -9 9s-9 -1.8 -9 -9s1.8 -9 9 -9z"
  }));
}
var pSe = ["size", "color", "stroke"];
function ESe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, pSe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-square-rounded-number-2",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M10 8h3a1 1 0 0 1 1 1v2a1 1 0 0 1 -1 1h-2a1 1 0 0 0 -1 1v2a1 1 0 0 0 1 1h3"
  }), e.createElement("path", {
    d: "M12 3c7.2 0 9 1.8 9 9s-1.8 9 -9 9s-9 -1.8 -9 -9s1.8 -9 9 -9z"
  }));
}
var uSe = ["size", "color", "stroke"];
function gSe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, uSe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-square-rounded-number-3",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M10 9a1 1 0 0 1 1 -1h2a1 1 0 0 1 1 1v2a1 1 0 0 1 -1 1h-2h2a1 1 0 0 1 1 1v2a1 1 0 0 1 -1 1h-2a1 1 0 0 1 -1 -1"
  }), e.createElement("path", {
    d: "M12 3c7.2 0 9 1.8 9 9s-1.8 9 -9 9s-9 -1.8 -9 -9s1.8 -9 9 -9z"
  }));
}
var MSe = ["size", "color", "stroke"];
function xSe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, MSe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-square-rounded-number-4",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M10 8v3a1 1 0 0 0 1 1h3"
  }), e.createElement("path", {
    d: "M14 8v8"
  }), e.createElement("path", {
    d: "M12 3c7.2 0 9 1.8 9 9s-1.8 9 -9 9s-9 -1.8 -9 -9s1.8 -9 9 -9z"
  }));
}
var fSe = ["size", "color", "stroke"];
function zSe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, fSe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-square-rounded-number-5",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M10 15a1 1 0 0 0 1 1h2a1 1 0 0 0 1 -1v-2a1 1 0 0 0 -1 -1h-3v-4h4"
  }), e.createElement("path", {
    d: "M12 3c7.2 0 9 1.8 9 9s-1.8 9 -9 9s-9 -1.8 -9 -9s1.8 -9 9 -9z"
  }));
}
var bSe = ["size", "color", "stroke"];
function LSe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, bSe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-square-rounded-number-6",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M14 9a1 1 0 0 0 -1 -1h-2a1 1 0 0 0 -1 1v6a1 1 0 0 0 1 1h2a1 1 0 0 0 1 -1v-2a1 1 0 0 0 -1 -1h-3"
  }), e.createElement("path", {
    d: "M12 3c7.2 0 9 1.8 9 9s-1.8 9 -9 9s-9 -1.8 -9 -9s1.8 -9 9 -9z"
  }));
}
var ySe = ["size", "color", "stroke"];
function CSe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, ySe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-square-rounded-number-7",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M10 8h4l-2 8"
  }), e.createElement("path", {
    d: "M12 3c7.2 0 9 1.8 9 9s-1.8 9 -9 9s-9 -1.8 -9 -9s1.8 -9 9 -9z"
  }));
}
var jSe = ["size", "color", "stroke"];
function BSe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, jSe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-square-rounded-number-8",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M12 12h-1a1 1 0 0 1 -1 -1v-2a1 1 0 0 1 1 -1h2a1 1 0 0 1 1 1v2a1 1 0 0 1 -1 1h-2a1 1 0 0 0 -1 1v2a1 1 0 0 0 1 1h2a1 1 0 0 0 1 -1v-2a1 1 0 0 0 -1 -1"
  }), e.createElement("path", {
    d: "M12 3c7.2 0 9 1.8 9 9s-1.8 9 -9 9s-9 -1.8 -9 -9s1.8 -9 9 -9z"
  }));
}
var HSe = ["size", "color", "stroke"];
function NSe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, HSe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-square-rounded-number-9",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M10 15a1 1 0 0 0 1 1h2a1 1 0 0 0 1 -1v-6a1 1 0 0 0 -1 -1h-2a1 1 0 0 0 -1 1v2a1 1 0 0 0 1 1h3"
  }), e.createElement("path", {
    d: "M12 3c7.2 0 9 1.8 9 9s-1.8 9 -9 9s-9 -1.8 -9 -9s1.8 -9 9 -9z"
  }));
}
var WSe = ["size", "color", "stroke"];
function qSe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, WSe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-square-rounded-plus",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M9 12h6"
  }), e.createElement("path", {
    d: "M12 9v6"
  }), e.createElement("path", {
    d: "M12 3c7.2 0 9 1.8 9 9s-1.8 9 -9 9s-9 -1.8 -9 -9s1.8 -9 9 -9z"
  }));
}
var OSe = ["size", "color", "stroke"];
function PSe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, OSe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-square-rounded-x",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M10 10l4 4m0 -4l-4 4"
  }), e.createElement("path", {
    d: "M12 3c7.2 0 9 1.8 9 9s-1.8 9 -9 9s-9 -1.8 -9 -9s1.8 -9 9 -9z"
  }));
}
var SSe = ["size", "color", "stroke"];
function ISe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, SSe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-square-rounded",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M12 3c7.2 0 9 1.8 9 9s-1.8 9 -9 9s-9 -1.8 -9 -9s1.8 -9 9 -9z"
  }));
}
var ASe = ["size", "color", "stroke"];
function DSe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, ASe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-square-toggle-horizontal",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M22 12h-20"
  }), e.createElement("path", {
    d: "M4 14v-8a2 2 0 0 1 2 -2h12a2 2 0 0 1 2 2v8"
  }), e.createElement("path", {
    d: "M18 20a2 2 0 0 0 2 -2"
  }), e.createElement("path", {
    d: "M4 18a2 2 0 0 0 2 2"
  }), e.createElement("line", {
    x1: 14,
    y1: 20,
    x2: 10,
    y2: 20
  }));
}
var FSe = ["size", "color", "stroke"];
function GSe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, FSe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-square-toggle",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("line", {
    x1: 12,
    y1: 2,
    x2: 12,
    y2: 22
  }), e.createElement("path", {
    d: "M14 20h-8a2 2 0 0 1 -2 -2v-12a2 2 0 0 1 2 -2h8"
  }), e.createElement("path", {
    d: "M20 6a2 2 0 0 0 -2 -2"
  }), e.createElement("path", {
    d: "M18 20a2 2 0 0 0 2 -2"
  }), e.createElement("line", {
    x1: 20,
    y1: 10,
    x2: 20,
    y2: 14
  }));
}
var JSe = ["size", "color", "stroke"];
function KSe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, JSe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-square-x",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("rect", {
    x: 4,
    y: 4,
    width: 16,
    height: 16,
    rx: 2
  }), e.createElement("path", {
    d: "M10 10l4 4m0 -4l-4 4"
  }));
}
var QSe = ["size", "color", "stroke"];
function RSe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, QSe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-square",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("rect", {
    x: 4,
    y: 4,
    width: 16,
    height: 16,
    rx: 2
  }));
}
var TSe = ["size", "color", "stroke"];
function USe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, TSe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-squares-diagonal",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("rect", {
    x: 8,
    y: 8,
    width: 12,
    height: 12,
    rx: 2
  }), e.createElement("path", {
    d: "M16 8v-2a2 2 0 0 0 -2 -2h-8a2 2 0 0 0 -2 2v8a2 2 0 0 0 2 2h2"
  }), e.createElement("path", {
    d: "M8.586 19.414l10.827 -10.827"
  }));
}
var VSe = ["size", "color", "stroke"];
function XSe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, VSe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-squares-filled",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("rect", {
    x: 8,
    y: 8,
    width: 12,
    height: 12,
    rx: 2
  }), e.createElement("path", {
    d: "M8 14.5l6.492 -6.492"
  }), e.createElement("path", {
    d: "M13.496 20.004l6.504 -6.504l-6.504 6.504z"
  }), e.createElement("path", {
    d: "M8.586 19.414l10.827 -10.827"
  }), e.createElement("path", {
    d: "M16 8v-2a2 2 0 0 0 -2 -2h-8a2 2 0 0 0 -2 2v8a2 2 0 0 0 2 2h2"
  }));
}
var YSe = ["size", "color", "stroke"];
function ZSe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, YSe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-stack-2",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("polyline", {
    points: "12 4 4 8 12 12 20 8 12 4"
  }), e.createElement("polyline", {
    points: "4 12 12 16 20 12"
  }), e.createElement("polyline", {
    points: "4 16 12 20 20 16"
  }));
}
var $Se = ["size", "color", "stroke"];
function _Se(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, $Se);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-stack-3",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M12 2l-8 4l8 4l8 -4l-8 -4"
  }), e.createElement("path", {
    d: "M4 10l8 4l8 -4"
  }), e.createElement("path", {
    d: "M4 18l8 4l8 -4"
  }), e.createElement("path", {
    d: "M4 14l8 4l8 -4"
  }));
}
var eIe = ["size", "color", "stroke"];
function tIe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, eIe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-stack-pop",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M7 9.5l-3 1.5l8 4l8 -4l-2.999 -1.5"
  }), e.createElement("path", {
    d: "M4 15l8 4l8 -4"
  }), e.createElement("path", {
    d: "M12 11v-7"
  }), e.createElement("path", {
    d: "M9 7l3 -3l3 3"
  }));
}
var oIe = ["size", "color", "stroke"];
function rIe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, oIe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-stack-push",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M6 10l-2 1l8 4l8 -4l-2 -1"
  }), e.createElement("path", {
    d: "M4 15l8 4l8 -4"
  }), e.createElement("path", {
    d: "M12 4v7"
  }), e.createElement("path", {
    d: "M15 8l-3 3l-3 -3"
  }));
}
var nIe = ["size", "color", "stroke"];
function lIe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, nIe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-stack",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M12 6l-8 4l8 4l8 -4l-8 -4"
  }), e.createElement("path", {
    d: "M4 14l8 4l8 -4"
  }));
}
var aIe = ["size", "color", "stroke"];
function iIe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, aIe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-stairs-down",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M4 20h4v-4h4v-4h4v-4h4"
  }), e.createElement("path", {
    d: "M11 4l-7 7v-4m4 4h-4"
  }));
}
var cIe = ["size", "color", "stroke"];
function sIe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, cIe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-stairs-up",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M4 20h4v-4h4v-4h4v-4h4"
  }), e.createElement("path", {
    d: "M4 11l7 -7v4m-4 -4h4"
  }));
}
var hIe = ["size", "color", "stroke"];
function dIe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, hIe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-stairs",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M4 18h4v-4h4v-4h4v-4h4"
  }));
}
var vIe = ["size", "color", "stroke"];
function mIe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, vIe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-star-half",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M12 17.75l-6.172 3.245l1.179 -6.873l-5 -4.867l6.9 -1l3.086 -6.253z"
  }));
}
var kIe = ["size", "color", "stroke"];
function wIe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, kIe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-star-off",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("line", {
    x1: 3,
    y1: 3,
    x2: 21,
    y2: 21
  }), e.createElement("path", {
    d: "M10.012 6.016l1.981 -4.014l3.086 6.253l6.9 1l-4.421 4.304m.012 4.01l.588 3.426l-6.158 -3.245l-6.172 3.245l1.179 -6.873l-5 -4.867l6.327 -.917"
  }));
}
var pIe = ["size", "color", "stroke"];
function EIe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, pIe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-star",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M12 17.75l-6.172 3.245l1.179 -6.873l-5 -4.867l6.9 -1l3.086 -6.253l3.086 6.253l6.9 1l-5 4.867l1.179 6.873z"
  }));
}
var uIe = ["size", "color", "stroke"];
function gIe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, uIe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-stars-off",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M17.373 13.371l.076 -.154a0.392 .392 0 0 1 .702 0l.907 1.831m.367 .39c.498 .071 1.245 .18 2.24 .324a0.39 .39 0 0 1 .217 .665c-.326 .316 -.57 .553 -.732 .712m-.611 3.405a0.39 .39 0 0 1 -.567 .411l-2.172 -1.138l-2.172 1.138a0.392 .392 0 0 1 -.568 -.41l.415 -2.411l-1.757 -1.707a0.389 .389 0 0 1 .217 -.665l1.601 -.232"
  }), e.createElement("path", {
    d: "M6.2 19.817l-2.172 1.138a0.392 .392 0 0 1 -.568 -.41l.415 -2.411l-1.757 -1.707a0.389 .389 0 0 1 .217 -.665l2.428 -.352l1.086 -2.193a0.392 .392 0 0 1 .702 0l1.086 2.193l2.428 .352a0.39 .39 0 0 1 .217 .665l-1.757 1.707l.414 2.41a0.39 .39 0 0 1 -.567 .411l-2.172 -1.138z"
  }), e.createElement("path", {
    d: "M9.557 5.556l1.006 -.146l1.086 -2.193a0.392 .392 0 0 1 .702 0l1.086 2.193l2.428 .352a0.39 .39 0 0 1 .217 .665l-1.757 1.707l.414 2.41a0.39 .39 0 0 1 -.014 .187m-4.153 -.166l-.744 .39a0.392 .392 0 0 1 -.568 -.41l.188 -1.093"
  }), e.createElement("path", {
    d: "M3 3l18 18"
  }));
}
var MIe = ["size", "color", "stroke"];
function xIe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, MIe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-stars",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M17.8 19.817l-2.172 1.138a0.392 .392 0 0 1 -.568 -.41l.415 -2.411l-1.757 -1.707a0.389 .389 0 0 1 .217 -.665l2.428 -.352l1.086 -2.193a0.392 .392 0 0 1 .702 0l1.086 2.193l2.428 .352a0.39 .39 0 0 1 .217 .665l-1.757 1.707l.414 2.41a0.39 .39 0 0 1 -.567 .411l-2.172 -1.138z"
  }), e.createElement("path", {
    d: "M6.2 19.817l-2.172 1.138a0.392 .392 0 0 1 -.568 -.41l.415 -2.411l-1.757 -1.707a0.389 .389 0 0 1 .217 -.665l2.428 -.352l1.086 -2.193a0.392 .392 0 0 1 .702 0l1.086 2.193l2.428 .352a0.39 .39 0 0 1 .217 .665l-1.757 1.707l.414 2.41a0.39 .39 0 0 1 -.567 .411l-2.172 -1.138z"
  }), e.createElement("path", {
    d: "M12 9.817l-2.172 1.138a0.392 .392 0 0 1 -.568 -.41l.415 -2.411l-1.757 -1.707a0.389 .389 0 0 1 .217 -.665l2.428 -.352l1.086 -2.193a0.392 .392 0 0 1 .702 0l1.086 2.193l2.428 .352a0.39 .39 0 0 1 .217 .665l-1.757 1.707l.414 2.41a0.39 .39 0 0 1 -.567 .411l-2.172 -1.138z"
  }));
}
var fIe = ["size", "color", "stroke"];
function zIe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, fIe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-status-change",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("circle", {
    cx: 6,
    cy: 18,
    r: 2
  }), e.createElement("circle", {
    cx: 18,
    cy: 18,
    r: 2
  }), e.createElement("path", {
    d: "M6 12v-2a6 6 0 1 1 12 0v2"
  }), e.createElement("path", {
    d: "M15 9l3 3l3 -3"
  }));
}
var bIe = ["size", "color", "stroke"];
function LIe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, bIe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-steam",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("circle", {
    cx: 12,
    cy: 4,
    r: 1
  }), e.createElement("circle", {
    cx: 4,
    cy: 12,
    r: 1
  }), e.createElement("circle", {
    cx: 20,
    cy: 12,
    r: 1
  }), e.createElement("circle", {
    cx: 12,
    cy: 20,
    r: 1
  }), e.createElement("path", {
    d: "M5.5 5.5l3 3"
  }), e.createElement("path", {
    d: "M15.5 15.5l3 3"
  }), e.createElement("path", {
    d: "M18.5 5.5l-3 3"
  }), e.createElement("path", {
    d: "M8.5 15.5l-3 3"
  }));
}
var yIe = ["size", "color", "stroke"];
function CIe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, yIe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-steering-wheel-off",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M20.04 16.048a9 9 0 0 0 -12.083 -12.09m-2.32 1.678a9 9 0 1 0 12.737 12.719"
  }), e.createElement("path", {
    d: "M10.595 10.576a2 2 0 1 0 2.827 2.83"
  }), e.createElement("path", {
    d: "M12 14v7"
  }), e.createElement("path", {
    d: "M10 12l-6.75 -2"
  }), e.createElement("path", {
    d: "M15.542 11.543l5.208 -1.543"
  }), e.createElement("path", {
    d: "M3 3l18 18"
  }));
}
var jIe = ["size", "color", "stroke"];
function BIe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, jIe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-steering-wheel",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 9
  }), e.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 2
  }), e.createElement("line", {
    x1: 12,
    y1: 14,
    x2: 12,
    y2: 21
  }), e.createElement("line", {
    x1: 10,
    y1: 12,
    x2: 3.25,
    y2: 10
  }), e.createElement("line", {
    x1: 14,
    y1: 12,
    x2: 20.75,
    y2: 10
  }));
}
var HIe = ["size", "color", "stroke"];
function NIe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, HIe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-step-into",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("line", {
    x1: 12,
    y1: 3,
    x2: 12,
    y2: 15
  }), e.createElement("line", {
    x1: 16,
    y1: 11,
    x2: 12,
    y2: 15
  }), e.createElement("line", {
    x1: 8,
    y1: 11,
    x2: 12,
    y2: 15
  }), e.createElement("circle", {
    cx: 12,
    cy: 20,
    r: 1
  }));
}
var WIe = ["size", "color", "stroke"];
function qIe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, WIe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-step-out",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("line", {
    x1: 12,
    y1: 3,
    x2: 12,
    y2: 15
  }), e.createElement("line", {
    x1: 16,
    y1: 7,
    x2: 12,
    y2: 3
  }), e.createElement("line", {
    x1: 8,
    y1: 7,
    x2: 12,
    y2: 3
  }), e.createElement("circle", {
    cx: 12,
    cy: 20,
    r: 1
  }));
}
var OIe = ["size", "color", "stroke"];
function PIe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, OIe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-stereo-glasses",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M8 3h-2l-3 9"
  }), e.createElement("path", {
    d: "M16 3h2l3 9"
  }), e.createElement("path", {
    d: "M3 12v7a1 1 0 0 0 1 1h4.586a1 1 0 0 0 .707 -.293l2 -2a1 1 0 0 1 1.414 0l2 2a1 1 0 0 0 .707 .293h4.586a1 1 0 0 0 1 -1v-7h-18z"
  }), e.createElement("path", {
    d: "M7 16h1"
  }), e.createElement("path", {
    d: "M16 16h1"
  }));
}
var SIe = ["size", "color", "stroke"];
function IIe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, SIe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-stethoscope-off",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M4.172 4.179a2 2 0 0 0 -1.172 1.821v3.5a5.5 5.5 0 0 0 9.856 3.358m1.144 -2.858v-4a2 2 0 0 0 -2 -2h-1"
  }), e.createElement("path", {
    d: "M8 15a6 6 0 0 0 10.714 3.712m1.216 -2.798c.046 -.3 .07 -.605 .07 -.914v-3"
  }), e.createElement("path", {
    d: "M11 3v2"
  }), e.createElement("circle", {
    cx: 20,
    cy: 10,
    r: 2
  }), e.createElement("path", {
    d: "M3 3l18 18"
  }));
}
var AIe = ["size", "color", "stroke"];
function DIe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, AIe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-stethoscope",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M6 4h-1a2 2 0 0 0 -2 2v3.5h0a5.5 5.5 0 0 0 11 0v-3.5a2 2 0 0 0 -2 -2h-1"
  }), e.createElement("path", {
    d: "M8 15a6 6 0 1 0 12 0v-3"
  }), e.createElement("path", {
    d: "M11 3v2"
  }), e.createElement("path", {
    d: "M6 3v2"
  }), e.createElement("circle", {
    cx: 20,
    cy: 10,
    r: 2
  }));
}
var FIe = ["size", "color", "stroke"];
function GIe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, FIe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-sticker",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M20 12l-2 .5a6 6 0 0 1 -6.5 -6.5l.5 -2l8 8"
  }), e.createElement("path", {
    d: "M20 12a8 8 0 1 1 -8 -8"
  }));
}
var JIe = ["size", "color", "stroke"];
function KIe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, JIe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-storm-off",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M9.884 9.874a3 3 0 1 0 4.24 4.246m.57 -3.441a3.012 3.012 0 0 0 -1.41 -1.39"
  }), e.createElement("path", {
    d: "M7.037 7.063a7 7 0 0 0 9.907 9.892m1.585 -2.426a7 7 0 0 0 -9.058 -9.059"
  }), e.createElement("path", {
    d: "M5.369 14.236c-1.605 -3.428 -1.597 -6.673 -1 -9.849"
  }), e.createElement("path", {
    d: "M18.63 9.76a14.323 14.323 0 0 1 1.368 6.251m-.37 3.608c-.087 .46 -.187 .92 -.295 1.377"
  }), e.createElement("path", {
    d: "M3 3l18 18"
  }));
}
var QIe = ["size", "color", "stroke"];
function RIe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, QIe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-storm",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 3
  }), e.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 7
  }), e.createElement("path", {
    d: "M5.369 14.236c-1.839 -3.929 -1.561 -7.616 -.704 -11.236"
  }), e.createElement("path", {
    d: "M18.63 9.76c1.837 3.928 1.561 7.615 .703 11.236"
  }));
}
var TIe = ["size", "color", "stroke"];
function UIe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, TIe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-stretching",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("circle", {
    cx: 16,
    cy: 5,
    r: 1
  }), e.createElement("path", {
    d: "M5 20l5 -.5l1 -2"
  }), e.createElement("path", {
    d: "M18 20v-5h-5.5l2.5 -6.5l-5.5 1l1.5 2"
  }));
}
var VIe = ["size", "color", "stroke"];
function XIe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, VIe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-strikethrough",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("line", {
    x1: 5,
    y1: 12,
    x2: 19,
    y2: 12
  }), e.createElement("path", {
    d: "M16 6.5a4 2 0 0 0 -4 -1.5h-1a3.5 3.5 0 0 0 0 7h2a3.5 3.5 0 0 1 0 7h-1.5a4 2 0 0 1 -4 -1.5"
  }));
}
var YIe = ["size", "color", "stroke"];
function ZIe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, YIe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-submarine",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M3 11v6h2l1 -1.5l3 1.5h10a3 3 0 0 0 0 -6h-10h0l-3 1.5l-1 -1.5h-2z"
  }), e.createElement("path", {
    d: "M17 11l-1 -3h-5l-1 3"
  }), e.createElement("path", {
    d: "M13 8v-2a1 1 0 0 1 1 -1h1"
  }));
}
var $Ie = ["size", "color", "stroke"];
function _Ie(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, $Ie);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-subscript",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M5 7l8 10m-8 0l8 -10"
  }), e.createElement("path", {
    d: "M21 20h-4l3.5 -4a1.73 1.73 0 0 0 -3.5 -2"
  }));
}
var eAe = ["size", "color", "stroke"];
function tAe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, eAe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-subtask",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("line", {
    x1: 6,
    y1: 9,
    x2: 12,
    y2: 9
  }), e.createElement("line", {
    x1: 4,
    y1: 5,
    x2: 8,
    y2: 5
  }), e.createElement("path", {
    d: "M6 5v11a1 1 0 0 0 1 1h5"
  }), e.createElement("rect", {
    x: 12,
    y: 7,
    width: 8,
    height: 4,
    rx: 1
  }), e.createElement("rect", {
    x: 12,
    y: 15,
    width: 8,
    height: 4,
    rx: 1
  }));
}
var oAe = ["size", "color", "stroke"];
function rAe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, oAe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-sum-off",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M18 18a1 1 0 0 1 -1 1h-11l6 -7m-3 -7h8a1 1 0 0 1 1 1v2"
  }), e.createElement("path", {
    d: "M3 3l18 18"
  }));
}
var nAe = ["size", "color", "stroke"];
function lAe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, nAe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-sum",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M18 16v2a1 1 0 0 1 -1 1h-11l6 -7l-6 -7h11a1 1 0 0 1 1 1v2"
  }));
}
var aAe = ["size", "color", "stroke"];
function iAe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, aAe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-sun-high",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M14.828 14.828a4 4 0 1 0 -5.656 -5.656a4 4 0 0 0 5.656 5.656z"
  }), e.createElement("path", {
    d: "M6.343 17.657l-1.414 1.414"
  }), e.createElement("path", {
    d: "M6.343 6.343l-1.414 -1.414"
  }), e.createElement("path", {
    d: "M17.657 6.343l1.414 -1.414"
  }), e.createElement("path", {
    d: "M17.657 17.657l1.414 1.414"
  }), e.createElement("path", {
    d: "M4 12h-2"
  }), e.createElement("path", {
    d: "M12 4v-2"
  }), e.createElement("path", {
    d: "M20 12h2"
  }), e.createElement("path", {
    d: "M12 20v2"
  }));
}
var cAe = ["size", "color", "stroke"];
function sAe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, cAe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-sun-low",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 4
  }), e.createElement("path", {
    d: "M4 12h.01"
  }), e.createElement("path", {
    d: "M12 4v.01"
  }), e.createElement("path", {
    d: "M20 12h.01"
  }), e.createElement("path", {
    d: "M12 20v.01"
  }), e.createElement("path", {
    d: "M6.31 6.31l-.01 -.01"
  }), e.createElement("path", {
    d: "M17.71 6.31l-.01 -.01"
  }), e.createElement("path", {
    d: "M17.7 17.7l.01 .01"
  }), e.createElement("path", {
    d: "M6.3 17.7l.01 .01"
  }));
}
var hAe = ["size", "color", "stroke"];
function dAe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, hAe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-sun-moon",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M9.173 14.83a4 4 0 1 1 5.657 -5.657"
  }), e.createElement("path", {
    d: "M11.294 12.707l.174 .247a7.5 7.5 0 0 0 8.845 2.492a9 9 0 0 1 -14.671 2.914"
  }), e.createElement("path", {
    d: "M3 12h1"
  }), e.createElement("path", {
    d: "M12 3v1"
  }), e.createElement("path", {
    d: "M5.6 5.6l.7 .7"
  }), e.createElement("path", {
    d: "M3 21l18 -18"
  }));
}
var vAe = ["size", "color", "stroke"];
function mAe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, vAe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-sun-off",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("line", {
    x1: 3,
    y1: 3,
    x2: 21,
    y2: 21
  }), e.createElement("path", {
    d: "M16 12a4 4 0 0 0 -4 -4m-2.834 1.177a4 4 0 0 0 5.66 5.654"
  }), e.createElement("path", {
    d: "M3 12h1m8 -9v1m8 8h1m-9 8v1m-6.4 -15.4l.7 .7m12.1 -.7l-.7 .7m0 11.4l.7 .7m-12.1 -.7l-.7 .7"
  }));
}
var kAe = ["size", "color", "stroke"];
function wAe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, kAe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-sun-wind",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M14.468 10.005a4 4 0 1 0 -5.466 5.46"
  }), e.createElement("path", {
    d: "M2 12h1"
  }), e.createElement("path", {
    d: "M11 3v1"
  }), e.createElement("path", {
    d: "M11 20v1"
  }), e.createElement("path", {
    d: "M4.6 5.6l.7 .7"
  }), e.createElement("path", {
    d: "M17.4 5.6l-.7 .7"
  }), e.createElement("path", {
    d: "M5.3 17.7l-.7 .7"
  }), e.createElement("path", {
    d: "M15 13h5a2 2 0 1 0 0 -4"
  }), e.createElement("path", {
    d: "M12 16h5.714l.253 -.004a2.004 2.004 0 0 1 2.033 2.004a2 2 0 0 1 -2 2h-.286"
  }));
}
var pAe = ["size", "color", "stroke"];
function EAe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, pAe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-sun",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 4
  }), e.createElement("path", {
    d: "M3 12h1m8 -9v1m8 8h1m-9 8v1m-6.4 -15.4l.7 .7m12.1 -.7l-.7 .7m0 11.4l.7 .7m-12.1 -.7l-.7 .7"
  }));
}
var uAe = ["size", "color", "stroke"];
function gAe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, uAe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-sunglasses",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M8 4h-2l-3 10"
  }), e.createElement("path", {
    d: "M16 4h2l3 10"
  }), e.createElement("path", {
    d: "M10 16h4"
  }), e.createElement("path", {
    d: "M21 16.5a3.5 3.5 0 0 1 -7 0v-2.5h7v2.5"
  }), e.createElement("path", {
    d: "M10 16.5a3.5 3.5 0 0 1 -7 0v-2.5h7v2.5"
  }), e.createElement("path", {
    d: "M4 14l4.5 4.5"
  }), e.createElement("path", {
    d: "M15 14l4.5 4.5"
  }));
}
var MAe = ["size", "color", "stroke"];
function xAe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, MAe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-sunrise",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M3 17h1m16 0h1m-15.4 -6.4l.7 .7m12.1 -.7l-.7 .7m-9.7 5.7a4 4 0 0 1 8 0"
  }), e.createElement("line", {
    x1: 3,
    y1: 21,
    x2: 21,
    y2: 21
  }), e.createElement("path", {
    d: "M12 9v-6l3 3m-6 0l3 -3"
  }));
}
var fAe = ["size", "color", "stroke"];
function zAe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, fAe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-sunset-2",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M3 13h1"
  }), e.createElement("path", {
    d: "M20 13h1"
  }), e.createElement("path", {
    d: "M5.6 6.6l.7 .7"
  }), e.createElement("path", {
    d: "M18.4 6.6l-.7 .7"
  }), e.createElement("path", {
    d: "M8 13a4 4 0 1 1 8 0"
  }), e.createElement("path", {
    d: "M3 17h18"
  }), e.createElement("path", {
    d: "M7 20h5"
  }), e.createElement("path", {
    d: "M16 20h1"
  }), e.createElement("path", {
    d: "M12 5v-1"
  }));
}
var bAe = ["size", "color", "stroke"];
function LAe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, bAe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-sunset",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M3 17h1m16 0h1m-15.4 -6.4l.7 .7m12.1 -.7l-.7 .7m-9.7 5.7a4 4 0 0 1 8 0"
  }), e.createElement("line", {
    x1: 3,
    y1: 21,
    x2: 21,
    y2: 21
  }), e.createElement("path", {
    d: "M12 3v6l3 -3m-6 0l3 3"
  }));
}
var yAe = ["size", "color", "stroke"];
function CAe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, yAe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-superscript",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M5 7l8 10m-8 0l8 -10"
  }), e.createElement("path", {
    d: "M21 11h-4l3.5 -4a1.73 1.73 0 0 0 -3.5 -2"
  }));
}
var jAe = ["size", "color", "stroke"];
function BAe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, jAe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-svg",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M21 8h-2a2 2 0 0 0 -2 2v4a2 2 0 0 0 2 2h2v-4h-1"
  }), e.createElement("path", {
    d: "M7 8h-3a1 1 0 0 0 -1 1v2a1 1 0 0 0 1 1h2a1 1 0 0 1 1 1v2a1 1 0 0 1 -1 1h-3"
  }), e.createElement("path", {
    d: "M10 8l1.5 8h1l1.5 -8"
  }));
}
var HAe = ["size", "color", "stroke"];
function NAe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, HAe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-swimming",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("circle", {
    cx: 16,
    cy: 9,
    r: 1
  }), e.createElement("path", {
    d: "M6 11l4 -2l3.5 3l-1.5 2"
  }), e.createElement("path", {
    d: "M3 16.75a2.4 2.4 0 0 0 1 .25a2.4 2.4 0 0 0 2 -1a2.4 2.4 0 0 1 2 -1a2.4 2.4 0 0 1 2 1a2.4 2.4 0 0 0 2 1a2.4 2.4 0 0 0 2 -1a2.4 2.4 0 0 1 2 -1a2.4 2.4 0 0 1 2 1a2.4 2.4 0 0 0 2 1a2.4 2.4 0 0 0 1 -.25"
  }));
}
var WAe = ["size", "color", "stroke"];
function qAe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, WAe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-swipe",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M15 16.572v2.42a2.01 2.01 0 0 1 -2.009 2.008h-7.981a2.01 2.01 0 0 1 -2.01 -2.009v-7.981a2.01 2.01 0 0 1 2.009 -2.01h2.954"
  }), e.createElement("path", {
    d: "M9.167 4.511a2.04 2.04 0 0 1 2.496 -1.441l7.826 2.097a2.04 2.04 0 0 1 1.441 2.496l-2.097 7.826a2.04 2.04 0 0 1 -2.496 1.441l-7.827 -2.097a2.04 2.04 0 0 1 -1.441 -2.496l2.098 -7.827z"
  }));
}
var OAe = ["size", "color", "stroke"];
function PAe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, OAe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-switch-2",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M3 17h5l1.67 -2.386m3.66 -5.227l1.67 -2.387h6"
  }), e.createElement("path", {
    d: "M18 4l3 3l-3 3"
  }), e.createElement("path", {
    d: "M3 7h5l7 10h6"
  }), e.createElement("path", {
    d: "M18 20l3 -3l-3 -3"
  }));
}
var SAe = ["size", "color", "stroke"];
function IAe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, SAe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-switch-3",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M3 17h2.397a5 5 0 0 0 4.096 -2.133l.177 -.253m3.66 -5.227l.177 -.254a5 5 0 0 1 4.096 -2.133h3.397"
  }), e.createElement("path", {
    d: "M18 4l3 3l-3 3"
  }), e.createElement("path", {
    d: "M3 7h2.397a5 5 0 0 1 4.096 2.133l4.014 5.734a5 5 0 0 0 4.096 2.133h3.397"
  }), e.createElement("path", {
    d: "M18 20l3 -3l-3 -3"
  }));
}
var AAe = ["size", "color", "stroke"];
function DAe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, AAe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-switch-horizontal",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("polyline", {
    points: "16 3 20 7 16 11"
  }), e.createElement("line", {
    x1: 10,
    y1: 7,
    x2: 20,
    y2: 7
  }), e.createElement("polyline", {
    points: "8 13 4 17 8 21"
  }), e.createElement("line", {
    x1: 4,
    y1: 17,
    x2: 13,
    y2: 17
  }));
}
var FAe = ["size", "color", "stroke"];
function GAe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, FAe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-switch-vertical",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("polyline", {
    points: "3 8 7 4 11 8"
  }), e.createElement("line", {
    x1: 7,
    y1: 4,
    x2: 7,
    y2: 13
  }), e.createElement("polyline", {
    points: "13 16 17 20 21 16"
  }), e.createElement("line", {
    x1: 17,
    y1: 10,
    x2: 17,
    y2: 20
  }));
}
var JAe = ["size", "color", "stroke"];
function KAe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, JAe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-switch",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("polyline", {
    points: "15 4 19 4 19 8"
  }), e.createElement("line", {
    x1: 14.75,
    y1: 9.25,
    x2: 19,
    y2: 4
  }), e.createElement("line", {
    x1: 5,
    y1: 19,
    x2: 9,
    y2: 15
  }), e.createElement("polyline", {
    points: "15 19 19 19 19 15"
  }), e.createElement("line", {
    x1: 5,
    y1: 5,
    x2: 19,
    y2: 19
  }));
}
var QAe = ["size", "color", "stroke"];
function RAe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, QAe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-sword-off",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M11.938 7.937l3.062 -3.937h5v5l-3.928 3.055m-2.259 1.757l-2.813 2.188l-4 4l-3 -3l4 -4l2.19 -2.815"
  }), e.createElement("path", {
    d: "M6.5 11.5l6 6"
  }), e.createElement("path", {
    d: "M3 3l18 18"
  }));
}
var TAe = ["size", "color", "stroke"];
function UAe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, TAe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-sword",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M20 4v5l-9 7l-4 4l-3 -3l4 -4l7 -9z"
  }), e.createElement("path", {
    d: "M6.5 11.5l6 6"
  }));
}
var VAe = ["size", "color", "stroke"];
function XAe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, VAe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-swords",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M21 3v5l-11 9l-4 4l-3 -3l4 -4l9 -11z"
  }), e.createElement("path", {
    d: "M5 13l6 6"
  }), e.createElement("path", {
    d: "M14.32 17.32l3.68 3.68l3 -3l-3.365 -3.365"
  }), e.createElement("path", {
    d: "M10 5.5l-2 -2.5h-5v5l3 2.5"
  }));
}
var YAe = ["size", "color", "stroke"];
function ZAe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, YAe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-table-alias",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M4 12v-6a2 2 0 0 1 2 -2h12a2 2 0 0 1 2 2v12a2 2 0 0 1 -2 2h-6"
  }), e.createElement("rect", {
    x: 3,
    y: 15,
    width: 6,
    height: 6,
    rx: 1
  }), e.createElement("path", {
    d: "M4 10h16"
  }), e.createElement("path", {
    d: "M10 4v8"
  }));
}
var $Ae = ["size", "color", "stroke"];
function _Ae(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, $Ae);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-table-export",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M11.5 20h-5.5a2 2 0 0 1 -2 -2v-12a2 2 0 0 1 2 -2h12a2 2 0 0 1 2 2v7.5m-16 -3.5h16m-10 -6v16m4 -1h7m-3 -3l3 3l-3 3"
  }));
}
var eDe = ["size", "color", "stroke"];
function tDe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, eDe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-table-import",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M4 13.5v-7.5a2 2 0 0 1 2 -2h12a2 2 0 0 1 2 2v12a2 2 0 0 1 -2 2h-6m-8 -10h16m-10 -6v11.5m-8 3.5h7m-3 -3l3 3l-3 3"
  }));
}
var oDe = ["size", "color", "stroke"];
function rDe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, oDe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-table-off",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M8 4h10a2 2 0 0 1 2 2v10m-.588 3.417c-.362 .36 -.86 .583 -1.412 .583h-12a2 2 0 0 1 -2 -2v-12c0 -.552 .224 -1.053 .586 -1.414"
  }), e.createElement("path", {
    d: "M4 10h6m4 0h6"
  }), e.createElement("path", {
    d: "M10 4v2m0 4v10"
  }), e.createElement("line", {
    x1: 3,
    y1: 3,
    x2: 21,
    y2: 21
  }));
}
var nDe = ["size", "color", "stroke"];
function lDe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, nDe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-table-options",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M4 12v-6a2 2 0 0 1 2 -2h12a2 2 0 0 1 2 2v12a2 2 0 0 1 -2 2h-6"
  }), e.createElement("path", {
    d: "M4 10h16"
  }), e.createElement("path", {
    d: "M10 4v9"
  }), e.createElement("circle", {
    cx: 5.281,
    cy: 18.5,
    r: 2
  }), e.createElement("path", {
    d: "M5.281 15v1.5"
  }), e.createElement("path", {
    d: "M5.281 20.5v1.5"
  }), e.createElement("path", {
    d: "M8.312 16.75l-1.299 .75"
  }), e.createElement("path", {
    d: "M3.55 19.5l-1.3 .75"
  }), e.createElement("path", {
    d: "M2.25 16.75l1.3 .75"
  }), e.createElement("path", {
    d: "M7.013 19.5l1.3 .75"
  }));
}
var aDe = ["size", "color", "stroke"];
function iDe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, aDe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-table-shortcut",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M4 12v-6a2 2 0 0 1 2 -2h12a2 2 0 0 1 2 2v12a2 2 0 0 1 -2 2h-6"
  }), e.createElement("path", {
    d: "M4 10h16"
  }), e.createElement("path", {
    d: "M10 4v8"
  }), e.createElement("path", {
    d: "M3 21l6 -6"
  }), e.createElement("path", {
    d: "M4 15h5v5"
  }));
}
var cDe = ["size", "color", "stroke"];
function sDe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, cDe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-table",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("rect", {
    x: 4,
    y: 4,
    width: 16,
    height: 16,
    rx: 2
  }), e.createElement("line", {
    x1: 4,
    y1: 10,
    x2: 20,
    y2: 10
  }), e.createElement("line", {
    x1: 10,
    y1: 4,
    x2: 10,
    y2: 20
  }));
}
var hDe = ["size", "color", "stroke"];
function dDe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, hDe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-tag-off",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M7.792 7.793a1 1 0 0 0 1.414 1.414"
  }), e.createElement("path", {
    d: "M4.88 4.877a2.99 2.99 0 0 0 -.88 2.123v3.859c0 .537 .213 1.052 .593 1.432l8.116 8.116a2.025 2.025 0 0 0 2.864 0l2.416 -2.416m2.002 -2.002l.416 -.416a2.025 2.025 0 0 0 0 -2.864l-8.117 -8.116a2.025 2.025 0 0 0 -1.431 -.593h-2.859"
  }), e.createElement("path", {
    d: "M3 3l18 18"
  }));
}
var vDe = ["size", "color", "stroke"];
function mDe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, vDe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-tag",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("circle", {
    cx: 8.5,
    cy: 8.5,
    r: 1,
    fill: "currentColor"
  }), e.createElement("path", {
    d: "M4 7v3.859c0 .537 .213 1.052 .593 1.432l8.116 8.116a2.025 2.025 0 0 0 2.864 0l4.834 -4.834a2.025 2.025 0 0 0 0 -2.864l-8.117 -8.116a2.025 2.025 0 0 0 -1.431 -.593h-3.859a3 3 0 0 0 -3 3z"
  }));
}
var kDe = ["size", "color", "stroke"];
function wDe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, kDe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-tags-off",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M6 6h-.975a2.025 2.025 0 0 0 -2.025 2.025v2.834c0 .537 .213 1.052 .593 1.432l6.116 6.116a2.025 2.025 0 0 0 2.864 0l2.834 -2.834c.028 -.028 .055 -.056 .08 -.085"
  }), e.createElement("path", {
    d: "M17.573 18.407l.418 -.418m1.997 -1.997l.419 -.419a2.025 2.025 0 0 0 0 -2.864l-7.117 -7.116"
  }), e.createElement("path", {
    d: "M6 9h-.01"
  }), e.createElement("path", {
    d: "M3 3l18 18"
  }));
}
var pDe = ["size", "color", "stroke"];
function EDe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, pDe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-tags",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M7.859 6h-2.834a2.025 2.025 0 0 0 -2.025 2.025v2.834c0 .537 .213 1.052 .593 1.432l6.116 6.116a2.025 2.025 0 0 0 2.864 0l2.834 -2.834a2.025 2.025 0 0 0 0 -2.864l-6.117 -6.116a2.025 2.025 0 0 0 -1.431 -.593z"
  }), e.createElement("path", {
    d: "M17.573 18.407l2.834 -2.834a2.025 2.025 0 0 0 0 -2.864l-7.117 -7.116"
  }), e.createElement("path", {
    d: "M6 9h-.01"
  }));
}
var uDe = ["size", "color", "stroke"];
function gDe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, uDe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-tallymark-1",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("line", {
    x1: 12,
    y1: 5,
    x2: 12,
    y2: 19
  }));
}
var MDe = ["size", "color", "stroke"];
function xDe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, MDe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-tallymark-2",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("line", {
    x1: 10,
    y1: 5,
    x2: 10,
    y2: 19
  }), e.createElement("line", {
    x1: 14,
    y1: 5,
    x2: 14,
    y2: 19
  }));
}
var fDe = ["size", "color", "stroke"];
function zDe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, fDe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-tallymark-3",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("line", {
    x1: 8,
    y1: 5,
    x2: 8,
    y2: 19
  }), e.createElement("line", {
    x1: 12,
    y1: 5,
    x2: 12,
    y2: 19
  }), e.createElement("line", {
    x1: 16,
    y1: 5,
    x2: 16,
    y2: 19
  }));
}
var bDe = ["size", "color", "stroke"];
function LDe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, bDe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-tallymark-4",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("line", {
    x1: 6,
    y1: 5,
    x2: 6,
    y2: 19
  }), e.createElement("line", {
    x1: 10,
    y1: 5,
    x2: 10,
    y2: 19
  }), e.createElement("line", {
    x1: 14,
    y1: 5,
    x2: 14,
    y2: 19
  }), e.createElement("line", {
    x1: 18,
    y1: 5,
    x2: 18,
    y2: 19
  }));
}
var yDe = ["size", "color", "stroke"];
function CDe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, yDe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-tallymarks",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("line", {
    x1: 6,
    y1: 5,
    x2: 6,
    y2: 19
  }), e.createElement("line", {
    x1: 10,
    y1: 5,
    x2: 10,
    y2: 19
  }), e.createElement("line", {
    x1: 14,
    y1: 5,
    x2: 14,
    y2: 19
  }), e.createElement("line", {
    x1: 18,
    y1: 5,
    x2: 18,
    y2: 19
  }), e.createElement("line", {
    x1: 3,
    y1: 17,
    x2: 21,
    y2: 7
  }));
}
var jDe = ["size", "color", "stroke"];
function BDe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, jDe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-tank",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("rect", {
    x: 2,
    y: 12,
    width: 18,
    height: 6,
    rx: 3
  }), e.createElement("path", {
    d: "M6 12l1 -5h5l3 5"
  }), e.createElement("line", {
    x1: 21,
    y1: 9,
    x2: 13.2,
    y2: 9
  }));
}
var HDe = ["size", "color", "stroke"];
function NDe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, HDe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-target-arrow",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 1
  }), e.createElement("path", {
    d: "M12 7a5 5 0 1 0 5 5"
  }), e.createElement("path", {
    d: "M13.004 3.055a9 9 0 1 0 7.941 7.945"
  }), e.createElement("path", {
    d: "M15 6v3h3l3 -3h-3v-3z"
  }), e.createElement("path", {
    d: "M15 9l-3 3"
  }));
}
var WDe = ["size", "color", "stroke"];
function qDe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, WDe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-target-off",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M11.286 11.3a1 1 0 0 0 1.41 1.419"
  }), e.createElement("path", {
    d: "M8.44 8.49a5 5 0 0 0 7.098 7.044m1.377 -2.611a5 5 0 0 0 -5.846 -5.836"
  }), e.createElement("path", {
    d: "M5.649 5.623a9 9 0 1 0 12.698 12.758m1.683 -2.313a9 9 0 0 0 -12.076 -12.11"
  }), e.createElement("path", {
    d: "M3 3l18 18"
  }));
}
var ODe = ["size", "color", "stroke"];
function PDe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, ODe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-target",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 1
  }), e.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 5
  }), e.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 9
  }));
}
var SDe = ["size", "color", "stroke"];
function IDe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, SDe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-teapot",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M10.29 3h3.42a2 2 0 0 1 1.988 1.78l1.555 14a2 2 0 0 1 -1.988 2.22h-6.53a2 2 0 0 1 -1.988 -2.22l1.555 -14a2 2 0 0 1 1.988 -1.78z"
  }), e.createElement("path", {
    d: "M7.47 12.5l-4.257 -5.019a0.899 .899 0 0 1 .69 -1.481h13.09a3.004 3.004 0 0 1 3.007 3v3c0 1.657 -1.346 3 -3.007 3"
  }), e.createElement("path", {
    d: "M7 17h10"
  }));
}
var ADe = ["size", "color", "stroke"];
function DDe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, ADe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-telescope-off",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M6 21.002l6 -5l6 5"
  }), e.createElement("path", {
    d: "M12 13.002v8"
  }), e.createElement("path", {
    d: "M8.238 8.264l-4.183 2.51c-1.02 .614 -1.357 1.898 -.76 2.906l.165 .28c.52 .88 1.624 1.266 2.605 .91l6.457 -2.34m2.907 -1.055l4.878 -1.77a1.023 1.023 0 0 0 .565 -1.455l-2.62 -4.705a1.087 1.087 0 0 0 -1.447 -.42l-.056 .032l-6.016 3.61"
  }), e.createElement("path", {
    d: "M14 5.002l3 5.5"
  }), e.createElement("path", {
    d: "M3 3l18 18"
  }));
}
var FDe = ["size", "color", "stroke"];
function GDe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, FDe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-telescope",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M6 21l6 -5l6 5"
  }), e.createElement("path", {
    d: "M12 13v8"
  }), e.createElement("path", {
    d: "M3.294 13.678l.166 .281c.52 .88 1.624 1.265 2.605 .91l14.242 -5.165a1.023 1.023 0 0 0 .565 -1.456l-2.62 -4.705a1.087 1.087 0 0 0 -1.447 -.42l-.056 .032l-12.694 7.618c-1.02 .613 -1.357 1.897 -.76 2.905z"
  }), e.createElement("path", {
    d: "M14 5l3 5.5"
  }));
}
var JDe = ["size", "color", "stroke"];
function KDe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, JDe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-temperature-celsius",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("circle", {
    cx: 6,
    cy: 8,
    r: 2
  }), e.createElement("path", {
    d: "M20 9a3 3 0 0 0 -3 -3h-1a3 3 0 0 0 -3 3v6a3 3 0 0 0 3 3h1a3 3 0 0 0 3 -3"
  }));
}
var QDe = ["size", "color", "stroke"];
function RDe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, QDe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-temperature-fahrenheit",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("circle", {
    cx: 6,
    cy: 8,
    r: 2
  }), e.createElement("line", {
    x1: 13,
    y1: 12,
    x2: 18,
    y2: 12
  }), e.createElement("path", {
    d: "M20 6h-6a1 1 0 0 0 -1 1v11"
  }));
}
var TDe = ["size", "color", "stroke"];
function UDe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, TDe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-temperature-minus",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M8 13.5a4 4 0 1 0 4 0v-8.5a2 2 0 0 0 -4 0v8.5"
  }), e.createElement("line", {
    x1: 8,
    y1: 9,
    x2: 12,
    y2: 9
  }), e.createElement("line", {
    x1: 16,
    y1: 9,
    x2: 22,
    y2: 9
  }));
}
var VDe = ["size", "color", "stroke"];
function XDe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, VDe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-temperature-off",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M10 10v3.5a4 4 0 1 0 5.836 2.33m-1.836 -5.83v-5a2 2 0 1 0 -4 0v1"
  }), e.createElement("path", {
    d: "M13 9h1"
  }), e.createElement("path", {
    d: "M3 3l18 18"
  }));
}
var YDe = ["size", "color", "stroke"];
function ZDe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, YDe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-temperature-plus",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M8 13.5a4 4 0 1 0 4 0v-8.5a2 2 0 0 0 -4 0v8.5"
  }), e.createElement("line", {
    x1: 8,
    y1: 9,
    x2: 12,
    y2: 9
  }), e.createElement("line", {
    x1: 16,
    y1: 9,
    x2: 22,
    y2: 9
  }), e.createElement("line", {
    x1: 19,
    y1: 6,
    x2: 19,
    y2: 12
  }));
}
var $De = ["size", "color", "stroke"];
function _De(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, $De);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-temperature",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M10 13.5a4 4 0 1 0 4 0v-8.5a2 2 0 0 0 -4 0v8.5"
  }), e.createElement("line", {
    x1: 10,
    y1: 9,
    x2: 14,
    y2: 9
  }));
}
var eFe = ["size", "color", "stroke"];
function tFe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, eFe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-template-off",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M8 4h11a1 1 0 0 1 1 1v2a1 1 0 0 1 -1 1h-7m-4 0h-3a1 1 0 0 1 -1 -1v-2c0 -.271 .108 -.517 .283 -.697"
  }), e.createElement("rect", {
    x: 4,
    y: 12,
    width: 6,
    height: 8,
    rx: 1
  }), e.createElement("path", {
    d: "M16 12h4"
  }), e.createElement("path", {
    d: "M14 16h2"
  }), e.createElement("path", {
    d: "M14 20h6"
  }), e.createElement("path", {
    d: "M3 3l18 18"
  }));
}
var oFe = ["size", "color", "stroke"];
function rFe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, oFe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-template",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("rect", {
    x: 4,
    y: 4,
    width: 16,
    height: 4,
    rx: 1
  }), e.createElement("rect", {
    x: 4,
    y: 12,
    width: 6,
    height: 8,
    rx: 1
  }), e.createElement("line", {
    x1: 14,
    y1: 12,
    x2: 20,
    y2: 12
  }), e.createElement("line", {
    x1: 14,
    y1: 16,
    x2: 20,
    y2: 16
  }), e.createElement("line", {
    x1: 14,
    y1: 20,
    x2: 20,
    y2: 20
  }));
}
var nFe = ["size", "color", "stroke"];
function lFe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, nFe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-tent-off",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M11 14l4 6h5m-2.863 -6.868l-5.137 -9.132l-1.44 2.559m-1.44 2.563l-6.12 10.878h6l4 -6"
  }), e.createElement("path", {
    d: "M3 3l18 18"
  }));
}
var aFe = ["size", "color", "stroke"];
function iFe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, aFe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-tent",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M11 14l4 6h6l-9 -16l-9 16h6l4 -6"
  }));
}
var cFe = ["size", "color", "stroke"];
function sFe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, cFe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-terminal-2",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M8 9l3 3l-3 3"
  }), e.createElement("line", {
    x1: 13,
    y1: 15,
    x2: 16,
    y2: 15
  }), e.createElement("rect", {
    x: 3,
    y: 4,
    width: 18,
    height: 16,
    rx: 2
  }));
}
var hFe = ["size", "color", "stroke"];
function dFe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, hFe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-terminal",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M5 7l5 5l-5 5"
  }), e.createElement("line", {
    x1: 12,
    y1: 19,
    x2: 19,
    y2: 19
  }));
}
var vFe = ["size", "color", "stroke"];
function mFe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, vFe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-test-pipe-2",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M15 3v15a3 3 0 0 1 -6 0v-15"
  }), e.createElement("path", {
    d: "M9 12h6"
  }), e.createElement("path", {
    d: "M8 3h8"
  }));
}
var kFe = ["size", "color", "stroke"];
function wFe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, kFe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-test-pipe-off",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M20 8.04a803.533 803.533 0 0 0 -4 3.96m-2 2c-1.085 1.085 -3.125 3.14 -6.122 6.164a2.857 2.857 0 0 1 -4.041 -4.04c3.018 -2.996 5.073 -5.037 6.163 -6.124m2 -2c.872 -.872 2.191 -2.205 3.959 -4"
  }), e.createElement("path", {
    d: "M7 13h6"
  }), e.createElement("path", {
    d: "M19 15l1.5 1.6m-.74 3.173a2 2 0 0 1 -2.612 -2.608"
  }), e.createElement("path", {
    d: "M15 3l6 6"
  }), e.createElement("path", {
    d: "M3 3l18 18"
  }));
}
var pFe = ["size", "color", "stroke"];
function EFe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, pFe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-test-pipe",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M20 8.04l-12.122 12.124a2.857 2.857 0 1 1 -4.041 -4.04l12.122 -12.124"
  }), e.createElement("path", {
    d: "M7 13h8"
  }), e.createElement("path", {
    d: "M19 15l1.5 1.6a2 2 0 1 1 -3 0l1.5 -1.6z"
  }), e.createElement("path", {
    d: "M15 3l6 6"
  }));
}
var uFe = ["size", "color", "stroke"];
function gFe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, uFe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-tex",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M9 8v-1h-6v1"
  }), e.createElement("path", {
    d: "M6 15v-8"
  }), e.createElement("path", {
    d: "M21 15l-5 -8"
  }), e.createElement("path", {
    d: "M16 15l5 -8"
  }), e.createElement("path", {
    d: "M14 11h-4v8h4"
  }), e.createElement("path", {
    d: "M10 15h3"
  }));
}
var MFe = ["size", "color", "stroke"];
function xFe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, MFe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-text-caption",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M4 15h16"
  }), e.createElement("rect", {
    x: 4,
    y: 4,
    width: 6,
    height: 6,
    rx: 1
  }), e.createElement("path", {
    d: "M4 20h12"
  }));
}
var fFe = ["size", "color", "stroke"];
function zFe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, fFe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-text-color",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M9 15v-7a3 3 0 0 1 6 0v7"
  }), e.createElement("path", {
    d: "M9 11h6"
  }), e.createElement("path", {
    d: "M5 19h14"
  }));
}
var bFe = ["size", "color", "stroke"];
function LFe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, bFe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-text-decrease",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M4 19v-10.5a3.5 3.5 0 1 1 7 0v10.5"
  }), e.createElement("path", {
    d: "M4 13h7"
  }), e.createElement("path", {
    d: "M21 12h-6"
  }));
}
var yFe = ["size", "color", "stroke"];
function CFe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, yFe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-text-direction-ltr",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M5 19h14"
  }), e.createElement("path", {
    d: "M17 21l2 -2l-2 -2"
  }), e.createElement("path", {
    d: "M16 4h-6.5a3.5 3.5 0 0 0 0 7h.5"
  }), e.createElement("path", {
    d: "M14 15v-11"
  }), e.createElement("path", {
    d: "M10 15v-11"
  }));
}
var jFe = ["size", "color", "stroke"];
function BFe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, jFe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-text-direction-rtl",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M16 4h-6.5a3.5 3.5 0 0 0 0 7h.5"
  }), e.createElement("path", {
    d: "M14 15v-11"
  }), e.createElement("path", {
    d: "M10 15v-11"
  }), e.createElement("path", {
    d: "M5 19h14"
  }), e.createElement("path", {
    d: "M7 21l-2 -2l2 -2"
  }));
}
var HFe = ["size", "color", "stroke"];
function NFe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, HFe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-text-increase",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M4 19v-10.5a3.5 3.5 0 1 1 7 0v10.5"
  }), e.createElement("path", {
    d: "M4 13h7"
  }), e.createElement("path", {
    d: "M18 9v6"
  }), e.createElement("path", {
    d: "M21 12h-6"
  }));
}
var WFe = ["size", "color", "stroke"];
function qFe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, WFe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-text-orientation",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M9 15l-5 -5c-1.367 -1.367 -1.367 -3.633 0 -5s3.633 -1.367 5 0l5 5"
  }), e.createElement("path", {
    d: "M5.5 11.5l5 -5"
  }), e.createElement("path", {
    d: "M21 12l-9 9"
  }), e.createElement("path", {
    d: "M21 12v4"
  }), e.createElement("path", {
    d: "M21 12h-4"
  }));
}
var OFe = ["size", "color", "stroke"];
function PFe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, OFe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-text-plus",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M19 10h-14"
  }), e.createElement("path", {
    d: "M5 6h14"
  }), e.createElement("path", {
    d: "M14 14h-9"
  }), e.createElement("path", {
    d: "M5 18h6"
  }), e.createElement("path", {
    d: "M18 15v6"
  }), e.createElement("path", {
    d: "M15 18h6"
  }));
}
var SFe = ["size", "color", "stroke"];
function IFe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, SFe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-text-recognition",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M4 8v-2a2 2 0 0 1 2 -2h2"
  }), e.createElement("path", {
    d: "M4 16v2a2 2 0 0 0 2 2h2"
  }), e.createElement("path", {
    d: "M16 4h2a2 2 0 0 1 2 2v2"
  }), e.createElement("path", {
    d: "M16 20h2a2 2 0 0 0 2 -2v-2"
  }), e.createElement("path", {
    d: "M12 16v-7"
  }), e.createElement("path", {
    d: "M9 9h6"
  }));
}
var AFe = ["size", "color", "stroke"];
function DFe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, AFe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-text-resize",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("circle", {
    cx: 5,
    cy: 5,
    r: 2
  }), e.createElement("circle", {
    cx: 19,
    cy: 5,
    r: 2
  }), e.createElement("circle", {
    cx: 5,
    cy: 19,
    r: 2
  }), e.createElement("circle", {
    cx: 19,
    cy: 19,
    r: 2
  }), e.createElement("path", {
    d: "M5 7v10"
  }), e.createElement("path", {
    d: "M7 5h10"
  }), e.createElement("path", {
    d: "M7 19h10"
  }), e.createElement("path", {
    d: "M19 7v10"
  }), e.createElement("path", {
    d: "M10 10h4"
  }), e.createElement("path", {
    d: "M12 14v-4"
  }));
}
var FFe = ["size", "color", "stroke"];
function GFe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, FFe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-text-size",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M3 7v-2h13v2"
  }), e.createElement("path", {
    d: "M10 5v14"
  }), e.createElement("path", {
    d: "M12 19h-4"
  }), e.createElement("path", {
    d: "M15 13v-1h6v1"
  }), e.createElement("path", {
    d: "M18 12v7"
  }), e.createElement("path", {
    d: "M17 19h2"
  }));
}
var JFe = ["size", "color", "stroke"];
function KFe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, JFe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-text-spellcheck",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M5 15v-7.5a3.5 3.5 0 0 1 7 0v7.5"
  }), e.createElement("path", {
    d: "M5 10h7"
  }), e.createElement("path", {
    d: "M10 18l3 3l7 -7"
  }));
}
var QFe = ["size", "color", "stroke"];
function RFe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, QFe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-text-wrap-disabled",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("line", {
    x1: 4,
    y1: 6,
    x2: 14,
    y2: 6
  }), e.createElement("line", {
    x1: 4,
    y1: 18,
    x2: 14,
    y2: 18
  }), e.createElement("path", {
    d: "M4 12h17l-3 -3m0 6l3 -3"
  }));
}
var TFe = ["size", "color", "stroke"];
function UFe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, TFe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-text-wrap",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("line", {
    x1: 4,
    y1: 6,
    x2: 20,
    y2: 6
  }), e.createElement("line", {
    x1: 4,
    y1: 18,
    x2: 9,
    y2: 18
  }), e.createElement("path", {
    d: "M4 12h13a3 3 0 0 1 0 6h-4l2 -2m0 4l-2 -2"
  }));
}
var VFe = ["size", "color", "stroke"];
function XFe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, VFe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-texture",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M6 3l-3 3"
  }), e.createElement("path", {
    d: "M21 18l-3 3"
  }), e.createElement("path", {
    d: "M11 3l-8 8"
  }), e.createElement("path", {
    d: "M16 3l-13 13"
  }), e.createElement("path", {
    d: "M21 3l-18 18"
  }), e.createElement("path", {
    d: "M21 8l-13 13"
  }), e.createElement("path", {
    d: "M21 13l-8 8"
  }));
}
var YFe = ["size", "color", "stroke"];
function ZFe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, YFe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-thermometer",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M19 5a2.828 2.828 0 0 1 0 4l-8 8h-4v-4l8 -8a2.828 2.828 0 0 1 4 0z"
  }), e.createElement("path", {
    d: "M16 7l-1.5 -1.5"
  }), e.createElement("path", {
    d: "M13 10l-1.5 -1.5"
  }), e.createElement("path", {
    d: "M10 13l-1.5 -1.5"
  }), e.createElement("path", {
    d: "M7 17l-3 3"
  }));
}
var $Fe = ["size", "color", "stroke"];
function _Fe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, $Fe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-thumb-down-off",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M7 13v-6m-3 -3a1 1 0 0 0 -1 1v7a1 1 0 0 0 1 1h3a4 4 0 0 1 4 4v1a2 2 0 1 0 4 0v-3m2 -2h1a2 2 0 0 0 2 -2l-1 -5c-.295 -1.26 -1.11 -2.076 -2 -2h-7c-.57 0 -1.102 .159 -1.556 .434"
  }), e.createElement("path", {
    d: "M3 3l18 18"
  }));
}
var eGe = ["size", "color", "stroke"];
function tGe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, eGe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-thumb-down",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M7 13v-8a1 1 0 0 0 -1 -1h-2a1 1 0 0 0 -1 1v7a1 1 0 0 0 1 1h3a4 4 0 0 1 4 4v1a2 2 0 0 0 4 0v-5h3a2 2 0 0 0 2 -2l-1 -5a2 3 0 0 0 -2 -2h-7a3 3 0 0 0 -3 3"
  }));
}
var oGe = ["size", "color", "stroke"];
function rGe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, oGe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-thumb-up-off",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M7 11v8a1 1 0 0 1 -1 1h-2a1 1 0 0 1 -1 -1v-7a1 1 0 0 1 1 -1h3a3.987 3.987 0 0 0 2.828 -1.172m1.172 -2.828v-1a2 2 0 1 1 4 0v5h3a2 2 0 0 1 2 2c-.222 1.112 -.39 1.947 -.5 2.503m-.758 3.244c-.392 .823 -1.044 1.312 -1.742 1.253h-7a3 3 0 0 1 -3 -3"
  }), e.createElement("path", {
    d: "M3 3l18 18"
  }));
}
var nGe = ["size", "color", "stroke"];
function lGe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, nGe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-thumb-up",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M7 11v8a1 1 0 0 1 -1 1h-2a1 1 0 0 1 -1 -1v-7a1 1 0 0 1 1 -1h3a4 4 0 0 0 4 -4v-1a2 2 0 0 1 4 0v5h3a2 2 0 0 1 2 2l-1 5a2 3 0 0 1 -2 2h-7a3 3 0 0 1 -3 -3"
  }));
}
var aGe = ["size", "color", "stroke"];
function iGe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, aGe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-tic-tac",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("circle", {
    cx: 6,
    cy: 6,
    r: 2
  }), e.createElement("path", {
    d: "M3 12h18"
  }), e.createElement("path", {
    d: "M12 3v18"
  }), e.createElement("path", {
    d: "M4 16l4 4"
  }), e.createElement("path", {
    d: "M4 20l4 -4"
  }), e.createElement("path", {
    d: "M16 4l4 4"
  }), e.createElement("path", {
    d: "M16 8l4 -4"
  }), e.createElement("circle", {
    cx: 18,
    cy: 18,
    r: 2
  }));
}
var cGe = ["size", "color", "stroke"];
function sGe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, cGe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-ticket-off",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M15 5v2"
  }), e.createElement("path", {
    d: "M15 17v2"
  }), e.createElement("path", {
    d: "M9 5h10a2 2 0 0 1 2 2v3a2 2 0 1 0 0 4v3m-2 2h-14a2 2 0 0 1 -2 -2v-3a2 2 0 1 0 0 -4v-3a2 2 0 0 1 2 -2"
  }), e.createElement("path", {
    d: "M3 3l18 18"
  }));
}
var hGe = ["size", "color", "stroke"];
function dGe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, hGe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-ticket",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("line", {
    x1: 15,
    y1: 5,
    x2: 15,
    y2: 7
  }), e.createElement("line", {
    x1: 15,
    y1: 11,
    x2: 15,
    y2: 13
  }), e.createElement("line", {
    x1: 15,
    y1: 17,
    x2: 15,
    y2: 19
  }), e.createElement("path", {
    d: "M5 5h14a2 2 0 0 1 2 2v3a2 2 0 0 0 0 4v3a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2v-3a2 2 0 0 0 0 -4v-3a2 2 0 0 1 2 -2"
  }));
}
var vGe = ["size", "color", "stroke"];
function mGe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, vGe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-tie",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M12 22l4 -4l-2.5 -11l.993 -2.649a1 1 0 0 0 -.936 -1.351h-3.114a1 1 0 0 0 -.936 1.351l.993 2.649l-2.5 11l4 4z"
  }), e.createElement("path", {
    d: "M10.5 7h3l5 5.5"
  }));
}
var kGe = ["size", "color", "stroke"];
function wGe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, kGe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-tilde",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M4 12c0 -1.657 1.592 -3 3.556 -3c1.963 0 3.11 1.5 4.444 3c1.333 1.5 2.48 3 4.444 3s3.556 -1.343 3.556 -3"
  }));
}
var pGe = ["size", "color", "stroke"];
function EGe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, pGe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-tilt-shift-off",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M8.56 3.69a9 9 0 0 0 -.577 .263"
  }), e.createElement("path", {
    d: "M3.69 8.56a9 9 0 0 0 -.69 3.44"
  }), e.createElement("path", {
    d: "M3.69 15.44a9 9 0 0 0 1.95 2.92"
  }), e.createElement("path", {
    d: "M8.56 20.31a9 9 0 0 0 3.44 .69"
  }), e.createElement("path", {
    d: "M15.44 20.31a9 9 0 0 0 2.92 -1.95"
  }), e.createElement("path", {
    d: "M20.31 15.44a9 9 0 0 0 .69 -3.44"
  }), e.createElement("path", {
    d: "M20.31 8.56a9 9 0 0 0 -1.95 -2.92"
  }), e.createElement("path", {
    d: "M15.44 3.69a9 9 0 0 0 -3.44 -.69"
  }), e.createElement("path", {
    d: "M10.57 10.602a2 2 0 0 0 2.862 2.795"
  }), e.createElement("path", {
    d: "M3 3l18 18"
  }));
}
var uGe = ["size", "color", "stroke"];
function gGe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, uGe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-tilt-shift",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M8.56 3.69a9 9 0 0 0 -2.92 1.95"
  }), e.createElement("path", {
    d: "M3.69 8.56a9 9 0 0 0 -.69 3.44"
  }), e.createElement("path", {
    d: "M3.69 15.44a9 9 0 0 0 1.95 2.92"
  }), e.createElement("path", {
    d: "M8.56 20.31a9 9 0 0 0 3.44 .69"
  }), e.createElement("path", {
    d: "M15.44 20.31a9 9 0 0 0 2.92 -1.95"
  }), e.createElement("path", {
    d: "M20.31 15.44a9 9 0 0 0 .69 -3.44"
  }), e.createElement("path", {
    d: "M20.31 8.56a9 9 0 0 0 -1.95 -2.92"
  }), e.createElement("path", {
    d: "M15.44 3.69a9 9 0 0 0 -3.44 -.69"
  }), e.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 2
  }));
}
var MGe = ["size", "color", "stroke"];
function xGe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, MGe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-timeline-event-exclamation",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("circle", {
    cx: 12,
    cy: 20,
    r: 2
  }), e.createElement("path", {
    d: "M10 20h-6"
  }), e.createElement("path", {
    d: "M14 20h6"
  }), e.createElement("path", {
    d: "M12 15l-2 -2h-3a1 1 0 0 1 -1 -1v-8a1 1 0 0 1 1 -1h10a1 1 0 0 1 1 1v8a1 1 0 0 1 -1 1h-3l-2 2z"
  }), e.createElement("path", {
    d: "M12 6v2"
  }), e.createElement("path", {
    d: "M12 11v.01"
  }));
}
var fGe = ["size", "color", "stroke"];
function zGe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, fGe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-timeline-event-minus",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("circle", {
    cx: 12,
    cy: 20,
    r: 2
  }), e.createElement("path", {
    d: "M10 20h-6"
  }), e.createElement("path", {
    d: "M14 20h6"
  }), e.createElement("path", {
    d: "M12 15l-2 -2h-3a1 1 0 0 1 -1 -1v-8a1 1 0 0 1 1 -1h10a1 1 0 0 1 1 1v8a1 1 0 0 1 -1 1h-3l-2 2z"
  }), e.createElement("path", {
    d: "M10 8h4"
  }));
}
var bGe = ["size", "color", "stroke"];
function LGe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, bGe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-timeline-event-plus",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("circle", {
    cx: 12,
    cy: 20,
    r: 2
  }), e.createElement("path", {
    d: "M10 20h-6"
  }), e.createElement("path", {
    d: "M14 20h6"
  }), e.createElement("path", {
    d: "M12 15l-2 -2h-3a1 1 0 0 1 -1 -1v-8a1 1 0 0 1 1 -1h10a1 1 0 0 1 1 1v8a1 1 0 0 1 -1 1h-3l-2 2z"
  }), e.createElement("path", {
    d: "M10 8h4"
  }), e.createElement("path", {
    d: "M12 6v4"
  }));
}
var yGe = ["size", "color", "stroke"];
function CGe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, yGe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-timeline-event-text",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("circle", {
    cx: 12,
    cy: 20,
    r: 2
  }), e.createElement("path", {
    d: "M10 20h-6"
  }), e.createElement("path", {
    d: "M14 20h6"
  }), e.createElement("path", {
    d: "M12 15l-2 -2h-3a1 1 0 0 1 -1 -1v-8a1 1 0 0 1 1 -1h10a1 1 0 0 1 1 1v8a1 1 0 0 1 -1 1h-3l-2 2z"
  }), e.createElement("path", {
    d: "M9 6h6"
  }), e.createElement("path", {
    d: "M9 9h3"
  }));
}
var jGe = ["size", "color", "stroke"];
function BGe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, jGe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-timeline-event-x",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("circle", {
    cx: 12,
    cy: 20,
    r: 2
  }), e.createElement("path", {
    d: "M10 20h-6"
  }), e.createElement("path", {
    d: "M14 20h6"
  }), e.createElement("path", {
    d: "M12 15l-2 -2h-3a1 1 0 0 1 -1 -1v-8a1 1 0 0 1 1 -1h10a1 1 0 0 1 1 1v8a1 1 0 0 1 -1 1h-3l-2 2z"
  }), e.createElement("path", {
    d: "M13.5 9.5l-3 -3"
  }), e.createElement("path", {
    d: "M10.5 9.5l3 -3"
  }));
}
var HGe = ["size", "color", "stroke"];
function NGe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, HGe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-timeline-event",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("circle", {
    cx: 12,
    cy: 20,
    r: 2
  }), e.createElement("path", {
    d: "M10 20h-6"
  }), e.createElement("path", {
    d: "M14 20h6"
  }), e.createElement("path", {
    d: "M12 15l-2 -2h-3a1 1 0 0 1 -1 -1v-8a1 1 0 0 1 1 -1h10a1 1 0 0 1 1 1v8a1 1 0 0 1 -1 1h-3l-2 2z"
  }));
}
var WGe = ["size", "color", "stroke"];
function qGe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, WGe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-timeline",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M4 16l6 -7l5 5l5 -6"
  }), e.createElement("circle", {
    cx: 15,
    cy: 14,
    r: 1
  }), e.createElement("circle", {
    cx: 10,
    cy: 9,
    r: 1
  }), e.createElement("circle", {
    cx: 4,
    cy: 16,
    r: 1
  }), e.createElement("circle", {
    cx: 20,
    cy: 8,
    r: 1
  }));
}
var OGe = ["size", "color", "stroke"];
function PGe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, OGe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-tir",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("circle", {
    cx: 5,
    cy: 17,
    r: 2
  }), e.createElement("circle", {
    cx: 17,
    cy: 17,
    r: 2
  }), e.createElement("path", {
    d: "M7 18h8m4 0h2v-6a5 7 0 0 0 -5 -7h-1l1.5 7h4.5"
  }), e.createElement("path", {
    d: "M12 18v-13h3"
  }), e.createElement("polyline", {
    points: "3 17 3 12 12 12"
  }));
}
var SGe = ["size", "color", "stroke"];
function IGe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, SGe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-toggle-left",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("circle", {
    cx: 8,
    cy: 12,
    r: 2
  }), e.createElement("rect", {
    x: 2,
    y: 6,
    width: 20,
    height: 12,
    rx: 6
  }));
}
var AGe = ["size", "color", "stroke"];
function DGe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, AGe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-toggle-right",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("circle", {
    cx: 16,
    cy: 12,
    r: 2
  }), e.createElement("rect", {
    x: 2,
    y: 6,
    width: 20,
    height: 12,
    rx: 6
  }));
}
var FGe = ["size", "color", "stroke"];
function GGe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, FGe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-toilet-paper-off",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M4.27 4.28c-.768 1.27 -1.27 3.359 -1.27 5.72c0 3.866 1.343 7 3 7s3 -3.134 3 -7c0 -.34 -.01 -.672 -.03 -.999"
  }), e.createElement("path", {
    d: "M21 10c0 -3.866 -1.343 -7 -3 -7"
  }), e.createElement("path", {
    d: "M7 3h11"
  }), e.createElement("path", {
    d: "M21 10v7m-1.513 2.496l-1.487 -.496l-3 2l-3 -3l-3 2v-10"
  }), e.createElement("path", {
    d: "M6 10h.01"
  }), e.createElement("path", {
    d: "M3 3l18 18"
  }));
}
var JGe = ["size", "color", "stroke"];
function KGe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, JGe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-toilet-paper",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("ellipse", {
    cx: 6,
    cy: 10,
    rx: 3,
    ry: 7
  }), e.createElement("path", {
    d: "M21 10c0 -3.866 -1.343 -7 -3 -7"
  }), e.createElement("path", {
    d: "M6 3h12"
  }), e.createElement("path", {
    d: "M21 10v10l-3 -1l-3 2l-3 -3l-3 2v-10"
  }), e.createElement("path", {
    d: "M6 10h.01"
  }));
}
var QGe = ["size", "color", "stroke"];
function RGe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, QGe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-tool",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M7 10h3v-3l-3.5 -3.5a6 6 0 0 1 8 8l6 6a2 2 0 0 1 -3 3l-6 -6a6 6 0 0 1 -8 -8l3.5 3.5"
  }));
}
var TGe = ["size", "color", "stroke"];
function UGe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, TGe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-tools-kitchen-2-off",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M14.386 10.409c.53 -2.28 1.766 -4.692 4.614 -7.409v12m-4 0h-1c-.002 -.313 -.002 -.627 .002 -.941"
  }), e.createElement("path", {
    d: "M19 19v2h-1v-3"
  }), e.createElement("path", {
    d: "M8 8v13"
  }), e.createElement("path", {
    d: "M5 5v2a3 3 0 0 0 4.546 2.572m1.454 -2.572v-3"
  }), e.createElement("path", {
    d: "M3 3l18 18"
  }));
}
var VGe = ["size", "color", "stroke"];
function XGe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, VGe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-tools-kitchen-2",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M19 3v12h-5c-.023 -3.681 .184 -7.406 5 -12zm0 12v6h-1v-3m-10 -14v17m-3 -17v3a3 3 0 1 0 6 0v-3"
  }));
}
var YGe = ["size", "color", "stroke"];
function ZGe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, YGe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-tools-kitchen-off",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M7 3h5l-.5 4.5m-.4 3.595l-.1 .905h-6l-.875 -7.874"
  }), e.createElement("path", {
    d: "M7 18h2v3h-2z"
  }), e.createElement("path", {
    d: "M15.225 11.216c.42 -2.518 1.589 -5.177 4.775 -8.216v12h-1"
  }), e.createElement("path", {
    d: "M20 15v1m0 4v1h-1v-2"
  }), e.createElement("path", {
    d: "M8 12v6"
  }), e.createElement("path", {
    d: "M3 3l18 18"
  }));
}
var $Ge = ["size", "color", "stroke"];
function _Ge(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, $Ge);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-tools-kitchen",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M4 3h8l-1 9h-6z"
  }), e.createElement("path", {
    d: "M7 18h2v3h-2z"
  }), e.createElement("path", {
    d: "M20 3v12h-5c-.023 -3.681 .184 -7.406 5 -12z"
  }), e.createElement("path", {
    d: "M20 15v6h-1v-3"
  }), e.createElement("line", {
    x1: 8,
    y1: 12,
    x2: 8,
    y2: 18
  }));
}
var eJe = ["size", "color", "stroke"];
function tJe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, eJe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-tools-off",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M16 12l4 -4a2.828 2.828 0 1 0 -4 -4l-4 4m-2 2l-7 7v4h4l7 -7"
  }), e.createElement("path", {
    d: "M14.5 5.5l4 4"
  }), e.createElement("path", {
    d: "M12 8l-5 -5m-2.004 2.004l-1.996 1.996l5 5"
  }), e.createElement("path", {
    d: "M7 8l-1.5 1.5"
  }), e.createElement("path", {
    d: "M16 12l5 5m-2 2l-2 2l-5 -5"
  }), e.createElement("path", {
    d: "M16 17l-1.5 1.5"
  }), e.createElement("path", {
    d: "M3 3l18 18"
  }));
}
var oJe = ["size", "color", "stroke"];
function rJe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, oJe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-tools",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M3 21h4l13 -13a1.5 1.5 0 0 0 -4 -4l-13 13v4"
  }), e.createElement("line", {
    x1: 14.5,
    y1: 5.5,
    x2: 18.5,
    y2: 9.5
  }), e.createElement("polyline", {
    points: "12 8 7 3 3 7 8 12"
  }), e.createElement("line", {
    x1: 7,
    y1: 8,
    x2: 5.5,
    y2: 9.5
  }), e.createElement("polyline", {
    points: "16 12 21 17 17 21 12 16"
  }), e.createElement("line", {
    x1: 16,
    y1: 17,
    x2: 14.5,
    y2: 18.5
  }));
}
var nJe = ["size", "color", "stroke"];
function lJe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, nJe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-tooltip",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("circle", {
    cx: 12,
    cy: 18,
    r: 2
  }), e.createElement("path", {
    d: "M12 13l-1.707 -1.707a1 1 0 0 0 -.707 -.293h-2.586a2 2 0 0 1 -2 -2v-3a2 2 0 0 1 2 -2h10a2 2 0 0 1 2 2v3a2 2 0 0 1 -2 2h-2.586a1 1 0 0 0 -.707 .293l-1.707 1.707z"
  }));
}
var aJe = ["size", "color", "stroke"];
function iJe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, aJe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-topology-bus",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M14 10a2 2 0 1 0 -4 0a2 2 0 0 0 4 0z"
  }), e.createElement("path", {
    d: "M6 10a2 2 0 1 0 -4 0a2 2 0 0 0 4 0z"
  }), e.createElement("path", {
    d: "M22 10a2 2 0 1 0 -4 0a2 2 0 0 0 4 0z"
  }), e.createElement("path", {
    d: "M2 16h20"
  }), e.createElement("path", {
    d: "M4 12v4"
  }), e.createElement("path", {
    d: "M12 12v4"
  }), e.createElement("path", {
    d: "M20 12v4"
  }));
}
var cJe = ["size", "color", "stroke"];
function sJe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, cJe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-topology-complex",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M20 18a2 2 0 1 0 -4 0a2 2 0 0 0 4 0z"
  }), e.createElement("path", {
    d: "M8 18a2 2 0 1 0 -4 0a2 2 0 0 0 4 0z"
  }), e.createElement("path", {
    d: "M8 6a2 2 0 1 0 -4 0a2 2 0 0 0 4 0z"
  }), e.createElement("path", {
    d: "M20 6a2 2 0 1 0 -4 0a2 2 0 0 0 4 0z"
  }), e.createElement("path", {
    d: "M14 12a2 2 0 1 0 -4 0a2 2 0 0 0 4 0z"
  }), e.createElement("path", {
    d: "M7.5 7.5l3 3"
  }), e.createElement("path", {
    d: "M6 8v8"
  }), e.createElement("path", {
    d: "M18 16v-8"
  }), e.createElement("path", {
    d: "M8 6h8"
  }), e.createElement("path", {
    d: "M16 18h-8"
  }));
}
var hJe = ["size", "color", "stroke"];
function dJe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, hJe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-topology-full-hierarchy",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M20 18a2 2 0 1 0 -4 0a2 2 0 0 0 4 0z"
  }), e.createElement("path", {
    d: "M8 18a2 2 0 1 0 -4 0a2 2 0 0 0 4 0z"
  }), e.createElement("path", {
    d: "M8 6a2 2 0 1 0 -4 0a2 2 0 0 0 4 0z"
  }), e.createElement("path", {
    d: "M20 6a2 2 0 1 0 -4 0a2 2 0 0 0 4 0z"
  }), e.createElement("path", {
    d: "M14 12a2 2 0 1 0 -4 0a2 2 0 0 0 4 0z"
  }), e.createElement("path", {
    d: "M6 8v8"
  }), e.createElement("path", {
    d: "M18 16v-8"
  }), e.createElement("path", {
    d: "M8 6h8"
  }), e.createElement("path", {
    d: "M16 18h-8"
  }), e.createElement("path", {
    d: "M7.5 7.5l3 3"
  }), e.createElement("path", {
    d: "M13.5 13.5l3 3"
  }), e.createElement("path", {
    d: "M16.5 7.5l-3 3"
  }), e.createElement("path", {
    d: "M10.5 13.5l-3 3"
  }));
}
var vJe = ["size", "color", "stroke"];
function mJe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, vJe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-topology-full",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M20 18a2 2 0 1 0 -4 0a2 2 0 0 0 4 0z"
  }), e.createElement("path", {
    d: "M8 18a2 2 0 1 0 -4 0a2 2 0 0 0 4 0z"
  }), e.createElement("path", {
    d: "M8 6a2 2 0 1 0 -4 0a2 2 0 0 0 4 0z"
  }), e.createElement("path", {
    d: "M20 6a2 2 0 1 0 -4 0a2 2 0 0 0 4 0z"
  }), e.createElement("path", {
    d: "M6 8v8"
  }), e.createElement("path", {
    d: "M18 16v-8"
  }), e.createElement("path", {
    d: "M8 6h8"
  }), e.createElement("path", {
    d: "M16 18h-8"
  }), e.createElement("path", {
    d: "M7.5 7.5l9 9"
  }), e.createElement("path", {
    d: "M7.5 16.5l9 -9"
  }));
}
var kJe = ["size", "color", "stroke"];
function wJe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, kJe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-topology-ring-2",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M14 6a2 2 0 1 0 -4 0a2 2 0 0 0 4 0z"
  }), e.createElement("path", {
    d: "M7 18a2 2 0 1 0 -4 0a2 2 0 0 0 4 0z"
  }), e.createElement("path", {
    d: "M21 18a2 2 0 1 0 -4 0a2 2 0 0 0 4 0z"
  }), e.createElement("path", {
    d: "M7 18h10"
  }), e.createElement("path", {
    d: "M18 16l-5 -8"
  }), e.createElement("path", {
    d: "M11 8l-5 8"
  }));
}
var pJe = ["size", "color", "stroke"];
function EJe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, pJe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-topology-ring-3",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M8 18a2 2 0 1 0 -4 0a2 2 0 0 0 4 0z"
  }), e.createElement("path", {
    d: "M20 18a2 2 0 1 0 -4 0a2 2 0 0 0 4 0z"
  }), e.createElement("path", {
    d: "M20 6a2 2 0 1 0 -4 0a2 2 0 0 0 4 0z"
  }), e.createElement("path", {
    d: "M8 6a2 2 0 1 0 -4 0a2 2 0 0 0 4 0z"
  }), e.createElement("path", {
    d: "M6 8v8"
  }), e.createElement("path", {
    d: "M18 16v-8"
  }), e.createElement("path", {
    d: "M8 6h8"
  }), e.createElement("path", {
    d: "M16 18h-8"
  }));
}
var uJe = ["size", "color", "stroke"];
function gJe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, uJe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-topology-ring",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M14 20a2 2 0 1 0 -4 0a2 2 0 0 0 4 0z"
  }), e.createElement("path", {
    d: "M14 4a2 2 0 1 0 -4 0a2 2 0 0 0 4 0z"
  }), e.createElement("path", {
    d: "M6 12a2 2 0 1 0 -4 0a2 2 0 0 0 4 0z"
  }), e.createElement("path", {
    d: "M22 12a2 2 0 1 0 -4 0a2 2 0 0 0 4 0z"
  }), e.createElement("path", {
    d: "M13.5 5.5l5 5"
  }), e.createElement("path", {
    d: "M5.5 13.5l5 5"
  }), e.createElement("path", {
    d: "M13.5 18.5l5 -5"
  }), e.createElement("path", {
    d: "M10.5 5.5l-5 5"
  }));
}
var MJe = ["size", "color", "stroke"];
function xJe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, MJe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-topology-star-2",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M14 20a2 2 0 1 0 -4 0a2 2 0 0 0 4 0z"
  }), e.createElement("path", {
    d: "M14 4a2 2 0 1 0 -4 0a2 2 0 0 0 4 0z"
  }), e.createElement("path", {
    d: "M6 12a2 2 0 1 0 -4 0a2 2 0 0 0 4 0z"
  }), e.createElement("path", {
    d: "M22 12a2 2 0 1 0 -4 0a2 2 0 0 0 4 0z"
  }), e.createElement("path", {
    d: "M14 12a2 2 0 1 0 -4 0a2 2 0 0 0 4 0z"
  }), e.createElement("path", {
    d: "M6 12h4"
  }), e.createElement("path", {
    d: "M14 12h4"
  }), e.createElement("path", {
    d: "M12 6v4"
  }), e.createElement("path", {
    d: "M12 14v4"
  }));
}
var fJe = ["size", "color", "stroke"];
function zJe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, fJe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-topology-star-3",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M10 19a2 2 0 1 0 -4 0a2 2 0 0 0 4 0z"
  }), e.createElement("path", {
    d: "M18 5a2 2 0 1 0 -4 0a2 2 0 0 0 4 0z"
  }), e.createElement("path", {
    d: "M10 5a2 2 0 1 0 -4 0a2 2 0 0 0 4 0z"
  }), e.createElement("path", {
    d: "M6 12a2 2 0 1 0 -4 0a2 2 0 0 0 4 0z"
  }), e.createElement("path", {
    d: "M18 19a2 2 0 1 0 -4 0a2 2 0 0 0 4 0z"
  }), e.createElement("path", {
    d: "M14 12a2 2 0 1 0 -4 0a2 2 0 0 0 4 0z"
  }), e.createElement("path", {
    d: "M22 12a2 2 0 1 0 -4 0a2 2 0 0 0 4 0z"
  }), e.createElement("path", {
    d: "M6 12h4"
  }), e.createElement("path", {
    d: "M14 12h4"
  }), e.createElement("path", {
    d: "M15 7l-2 3"
  }), e.createElement("path", {
    d: "M9 7l2 3"
  }), e.createElement("path", {
    d: "M11 14l-2 3"
  }), e.createElement("path", {
    d: "M13 14l2 3"
  }));
}
var bJe = ["size", "color", "stroke"];
function LJe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, bJe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-topology-star-ring-2",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M14 20a2 2 0 1 0 -4 0a2 2 0 0 0 4 0z"
  }), e.createElement("path", {
    d: "M14 4a2 2 0 1 0 -4 0a2 2 0 0 0 4 0z"
  }), e.createElement("path", {
    d: "M6 12a2 2 0 1 0 -4 0a2 2 0 0 0 4 0z"
  }), e.createElement("path", {
    d: "M22 12a2 2 0 1 0 -4 0a2 2 0 0 0 4 0z"
  }), e.createElement("path", {
    d: "M14 12a2 2 0 1 0 -4 0a2 2 0 0 0 4 0z"
  }), e.createElement("path", {
    d: "M6 12h4"
  }), e.createElement("path", {
    d: "M14 12h4"
  }), e.createElement("path", {
    d: "M12 6v4"
  }), e.createElement("path", {
    d: "M12 14v4"
  }), e.createElement("path", {
    d: "M5.5 10.5l5 -5"
  }), e.createElement("path", {
    d: "M13.5 5.5l5 5"
  }), e.createElement("path", {
    d: "M18.5 13.5l-5 5"
  }), e.createElement("path", {
    d: "M10.5 18.5l-5 -5"
  }));
}
var yJe = ["size", "color", "stroke"];
function CJe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, yJe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-topology-star-ring-3",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M10 19a2 2 0 1 0 -4 0a2 2 0 0 0 4 0z"
  }), e.createElement("path", {
    d: "M18 5a2 2 0 1 0 -4 0a2 2 0 0 0 4 0z"
  }), e.createElement("path", {
    d: "M10 5a2 2 0 1 0 -4 0a2 2 0 0 0 4 0z"
  }), e.createElement("path", {
    d: "M6 12a2 2 0 1 0 -4 0a2 2 0 0 0 4 0z"
  }), e.createElement("path", {
    d: "M18 19a2 2 0 1 0 -4 0a2 2 0 0 0 4 0z"
  }), e.createElement("path", {
    d: "M14 12a2 2 0 1 0 -4 0a2 2 0 0 0 4 0z"
  }), e.createElement("path", {
    d: "M22 12a2 2 0 1 0 -4 0a2 2 0 0 0 4 0z"
  }), e.createElement("path", {
    d: "M6 12h4"
  }), e.createElement("path", {
    d: "M14 12h4"
  }), e.createElement("path", {
    d: "M15 7l-2 3"
  }), e.createElement("path", {
    d: "M9 7l2 3"
  }), e.createElement("path", {
    d: "M11 14l-2 3"
  }), e.createElement("path", {
    d: "M13 14l2 3"
  }), e.createElement("path", {
    d: "M10 5h4"
  }), e.createElement("path", {
    d: "M10 19h4"
  }), e.createElement("path", {
    d: "M17 17l2 -3"
  }), e.createElement("path", {
    d: "M19 10l-2 -3"
  }), e.createElement("path", {
    d: "M7 7l-2 3"
  }), e.createElement("path", {
    d: "M5 14l2 3"
  }));
}
var jJe = ["size", "color", "stroke"];
function BJe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, jJe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-topology-star-ring",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M14 20a2 2 0 1 0 -4 0a2 2 0 0 0 4 0z"
  }), e.createElement("path", {
    d: "M14 4a2 2 0 1 0 -4 0a2 2 0 0 0 4 0z"
  }), e.createElement("path", {
    d: "M6 12a2 2 0 1 0 -4 0a2 2 0 0 0 4 0z"
  }), e.createElement("path", {
    d: "M22 12a2 2 0 1 0 -4 0a2 2 0 0 0 4 0z"
  }), e.createElement("path", {
    d: "M14 12a2 2 0 1 0 -4 0a2 2 0 0 0 4 0z"
  }), e.createElement("path", {
    d: "M6 12h4"
  }), e.createElement("path", {
    d: "M14 12h4"
  }), e.createElement("path", {
    d: "M13.5 5.5l5 5"
  }), e.createElement("path", {
    d: "M5.5 13.5l5 5"
  }), e.createElement("path", {
    d: "M13.5 18.5l5 -5"
  }), e.createElement("path", {
    d: "M10.5 5.5l-5 5"
  }), e.createElement("path", {
    d: "M12 6v4"
  }), e.createElement("path", {
    d: "M12 14v4"
  }));
}
var HJe = ["size", "color", "stroke"];
function NJe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, HJe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-topology-star",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M8 18a2 2 0 1 0 -4 0a2 2 0 0 0 4 0z"
  }), e.createElement("path", {
    d: "M20 6a2 2 0 1 0 -4 0a2 2 0 0 0 4 0z"
  }), e.createElement("path", {
    d: "M8 6a2 2 0 1 0 -4 0a2 2 0 0 0 4 0z"
  }), e.createElement("path", {
    d: "M20 18a2 2 0 1 0 -4 0a2 2 0 0 0 4 0z"
  }), e.createElement("path", {
    d: "M14 12a2 2 0 1 0 -4 0a2 2 0 0 0 4 0z"
  }), e.createElement("path", {
    d: "M7.5 7.5l3 3"
  }), e.createElement("path", {
    d: "M7.5 16.5l3 -3"
  }), e.createElement("path", {
    d: "M13.5 13.5l3 3"
  }), e.createElement("path", {
    d: "M16.5 7.5l-3 3"
  }));
}
var WJe = ["size", "color", "stroke"];
function qJe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, WJe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-torii",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M4 4c5.333 1.333 10.667 1.333 16 0"
  }), e.createElement("path", {
    d: "M4 8h16"
  }), e.createElement("path", {
    d: "M12 5v3"
  }), e.createElement("path", {
    d: "M18 4.5v15.5"
  }), e.createElement("path", {
    d: "M6 4.5v15.5"
  }));
}
var OJe = ["size", "color", "stroke"];
function PJe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, OJe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-tornado",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("line", {
    x1: 21,
    y1: 4,
    x2: 3,
    y2: 4
  }), e.createElement("line", {
    x1: 13,
    y1: 16,
    x2: 7,
    y2: 16
  }), e.createElement("line", {
    x1: 11,
    y1: 20,
    x2: 15,
    y2: 20
  }), e.createElement("line", {
    x1: 6,
    y1: 8,
    x2: 20,
    y2: 8
  }), e.createElement("line", {
    x1: 4,
    y1: 12,
    x2: 16,
    y2: 12
  }));
}
var SJe = ["size", "color", "stroke"];
function IJe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, SJe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-tournament",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("circle", {
    cx: 4,
    cy: 4,
    r: 2
  }), e.createElement("circle", {
    cx: 20,
    cy: 10,
    r: 2
  }), e.createElement("circle", {
    cx: 4,
    cy: 12,
    r: 2
  }), e.createElement("circle", {
    cx: 4,
    cy: 20,
    r: 2
  }), e.createElement("path", {
    d: "M6 12h3a1 1 0 0 1 1 1v6a1 1 0 0 1 -1 1h-3"
  }), e.createElement("path", {
    d: "M6 4h7a1 1 0 0 1 1 1v10a1 1 0 0 1 -1 1h-2"
  }), e.createElement("path", {
    d: "M14 10h4"
  }));
}
var AJe = ["size", "color", "stroke"];
function DJe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, AJe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-tower-off",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M10 6v-2a1 1 0 0 1 1 -1h2a1 1 0 0 1 1 1v2h3v-2a1 1 0 0 1 1 -1h1a1 1 0 0 1 1 1v4.394a2 2 0 0 1 -.336 1.11l-1.328 1.992a2 2 0 0 0 -.336 1.11v1.394m0 4v2a1 1 0 0 1 -1 1h-10a1 1 0 0 1 -1 -1v-7.394a2 2 0 0 0 -.336 -1.11l-1.328 -1.992a2 2 0 0 1 -.336 -1.11v-4.394"
  }), e.createElement("path", {
    d: "M10 21v-5a2 2 0 1 1 4 0v5"
  }), e.createElement("path", {
    d: "M3 3l18 18"
  }));
}
var FJe = ["size", "color", "stroke"];
function GJe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, FJe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-tower",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M5 3h1a1 1 0 0 1 1 1v2h3v-2a1 1 0 0 1 1 -1h2a1 1 0 0 1 1 1v2h3v-2a1 1 0 0 1 1 -1h1a1 1 0 0 1 1 1v4.394a2 2 0 0 1 -.336 1.11l-1.328 1.992a2 2 0 0 0 -.336 1.11v7.394a1 1 0 0 1 -1 1h-10a1 1 0 0 1 -1 -1v-7.394a2 2 0 0 0 -.336 -1.11l-1.328 -1.992a2 2 0 0 1 -.336 -1.11v-4.394a1 1 0 0 1 1 -1z"
  }), e.createElement("path", {
    d: "M10 21v-5a2 2 0 1 1 4 0v5"
  }));
}
var JJe = ["size", "color", "stroke"];
function KJe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, JJe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-track",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M4 15l11 -11m5 5l-11 11m-4 -8l7 7m-3.5 -10.5l7 7m-3.5 -10.5l7 7"
  }));
}
var QJe = ["size", "color", "stroke"];
function RJe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, QJe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-tractor",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("circle", {
    cx: 7,
    cy: 15,
    r: 4
  }), e.createElement("line", {
    x1: 7,
    y1: 15,
    x2: 7,
    y2: 15.01
  }), e.createElement("circle", {
    cx: 19,
    cy: 17,
    r: 2
  }), e.createElement("line", {
    x1: 10.5,
    y1: 17,
    x2: 17,
    y2: 17
  }), e.createElement("path", {
    d: "M20 15.2v-4.2a1 1 0 0 0 -1 -1h-6l-2 -5h-6v6.5"
  }), e.createElement("path", {
    d: "M18 5h-1a1 1 0 0 0 -1 1v4"
  }));
}
var TJe = ["size", "color", "stroke"];
function UJe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, TJe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-trademark",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M4.5 9h5m-2.5 0v6"
  }), e.createElement("path", {
    d: "M13 15v-6l3 4l3 -4v6"
  }));
}
var VJe = ["size", "color", "stroke"];
function XJe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, VJe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-traffic-cone-off",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M4 20h16"
  }), e.createElement("path", {
    d: "M9.4 10h.6m4 0h.6"
  }), e.createElement("path", {
    d: "M7.8 15h7.2"
  }), e.createElement("path", {
    d: "M6 20l3.5 -10.5"
  }), e.createElement("path", {
    d: "M10.5 6.5l.5 -1.5h2l2 6m2 6l1 3"
  }), e.createElement("path", {
    d: "M3 3l18 18"
  }));
}
var YJe = ["size", "color", "stroke"];
function ZJe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, YJe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-traffic-cone",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("line", {
    x1: 4,
    y1: 20,
    x2: 20,
    y2: 20
  }), e.createElement("line", {
    x1: 9.4,
    y1: 10,
    x2: 14.6,
    y2: 10
  }), e.createElement("line", {
    x1: 7.8,
    y1: 15,
    x2: 16.2,
    y2: 15
  }), e.createElement("path", {
    d: "M6 20l5 -15h2l5 15"
  }));
}
var $Je = ["size", "color", "stroke"];
function _Je(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, $Je);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-traffic-lights-off",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M8 4c.912 -1.219 2.36 -2 4 -2a5 5 0 0 1 5 5v6m0 4a5 5 0 0 1 -10 0v-10"
  }), e.createElement("path", {
    d: "M12 8a1 1 0 1 0 -1 -1"
  }), e.createElement("path", {
    d: "M11.291 11.295a1 1 0 0 0 1.418 1.41"
  }), e.createElement("circle", {
    cx: 12,
    cy: 17,
    r: 1
  }), e.createElement("path", {
    d: "M3 3l18 18"
  }));
}
var eKe = ["size", "color", "stroke"];
function tKe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, eKe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-traffic-lights",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("rect", {
    x: 7,
    y: 2,
    width: 10,
    height: 20,
    rx: 5
  }), e.createElement("circle", {
    cx: 12,
    cy: 7,
    r: 1
  }), e.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 1
  }), e.createElement("circle", {
    cx: 12,
    cy: 17,
    r: 1
  }));
}
var oKe = ["size", "color", "stroke"];
function rKe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, oKe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-train",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M21 13c0 -3.87 -3.37 -7 -10 -7h-8"
  }), e.createElement("path", {
    d: "M3 15h16a2 2 0 0 0 2 -2"
  }), e.createElement("path", {
    d: "M3 6v5h17.5"
  }), e.createElement("line", {
    x1: 3,
    y1: 10,
    x2: 3,
    y2: 14
  }), e.createElement("line", {
    x1: 8,
    y1: 11,
    x2: 8,
    y2: 6
  }), e.createElement("line", {
    x1: 13,
    y1: 11,
    x2: 13,
    y2: 6.5
  }), e.createElement("line", {
    x1: 3,
    y1: 19,
    x2: 21,
    y2: 19
  }));
}
var nKe = ["size", "color", "stroke"];
function lKe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, nKe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-transfer-in",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M4 18v3h16v-14l-8 -4l-8 4v3"
  }), e.createElement("path", {
    d: "M4 14h9"
  }), e.createElement("path", {
    d: "M10 11l3 3l-3 3"
  }));
}
var aKe = ["size", "color", "stroke"];
function iKe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, aKe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-transfer-out",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M4 19v2h16v-14l-8 -4l-8 4v2"
  }), e.createElement("path", {
    d: "M13 14h-9"
  }), e.createElement("path", {
    d: "M7 11l-3 3l3 3"
  }));
}
var cKe = ["size", "color", "stroke"];
function sKe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, cKe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-transform",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M5 13v.875c0 3.383 2.686 6.125 6 6.125"
  }), e.createElement("circle", {
    cx: 6,
    cy: 6,
    r: 3
  }), e.createElement("circle", {
    cx: 18,
    cy: 18,
    r: 3
  }), e.createElement("path", {
    d: "M16 9l2 2l2 -2"
  }), e.createElement("path", {
    d: "M18 10v-.875c0 -3.383 -2.686 -6.125 -6 -6.125"
  }), e.createElement("path", {
    d: "M3 15l2 -2l2 2"
  }));
}
var hKe = ["size", "color", "stroke"];
function dKe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, hKe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-transition-bottom",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M21 18a3 3 0 0 1 -3 3h-12a3 3 0 0 1 -3 -3"
  }), e.createElement("rect", {
    x: 3,
    y: 3,
    width: 18,
    height: 6,
    rx: 3
  }), e.createElement("path", {
    d: "M12 9v8"
  }), e.createElement("path", {
    d: "M9 14l3 3l3 -3"
  }));
}
var vKe = ["size", "color", "stroke"];
function mKe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, vKe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-transition-left",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M6 21a3 3 0 0 1 -3 -3v-12a3 3 0 0 1 3 -3"
  }), e.createElement("path", {
    d: "M21 6v12a3 3 0 0 1 -6 0v-12a3 3 0 0 1 6 0z"
  }), e.createElement("path", {
    d: "M15 12h-8"
  }), e.createElement("path", {
    d: "M10 9l-3 3l3 3"
  }));
}
var kKe = ["size", "color", "stroke"];
function wKe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, kKe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-transition-right",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M18 3a3 3 0 0 1 3 3v12a3 3 0 0 1 -3 3"
  }), e.createElement("path", {
    d: "M3 18v-12a3 3 0 1 1 6 0v12a3 3 0 0 1 -6 0z"
  }), e.createElement("path", {
    d: "M9 12h8"
  }), e.createElement("path", {
    d: "M14 15l3 -3l-3 -3"
  }));
}
var pKe = ["size", "color", "stroke"];
function EKe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, pKe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-transition-top",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M21 6a3 3 0 0 0 -3 -3h-12a3 3 0 0 0 -3 3"
  }), e.createElement("path", {
    d: "M6 21h12a3 3 0 0 0 0 -6h-12a3 3 0 0 0 0 6z"
  }), e.createElement("path", {
    d: "M12 15v-8"
  }), e.createElement("path", {
    d: "M9 10l3 -3l3 3"
  }));
}
var uKe = ["size", "color", "stroke"];
function gKe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, uKe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-trash-off",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("line", {
    x1: 3,
    y1: 3,
    x2: 21,
    y2: 21
  }), e.createElement("path", {
    d: "M4 7h3m4 0h9"
  }), e.createElement("line", {
    x1: 10,
    y1: 11,
    x2: 10,
    y2: 17
  }), e.createElement("line", {
    x1: 14,
    y1: 14,
    x2: 14,
    y2: 17
  }), e.createElement("path", {
    d: "M5 7l1 12a2 2 0 0 0 2 2h8a2 2 0 0 0 2 -2l.077 -.923"
  }), e.createElement("line", {
    x1: 18.384,
    y1: 14.373,
    x2: 19,
    y2: 7
  }), e.createElement("path", {
    d: "M9 5v-1a1 1 0 0 1 1 -1h4a1 1 0 0 1 1 1v3"
  }));
}
var MKe = ["size", "color", "stroke"];
function xKe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, MKe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-trash-x",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M4 7h16"
  }), e.createElement("path", {
    d: "M5 7l1 12a2 2 0 0 0 2 2h8a2 2 0 0 0 2 -2l1 -12"
  }), e.createElement("path", {
    d: "M9 7v-3a1 1 0 0 1 1 -1h4a1 1 0 0 1 1 1v3"
  }), e.createElement("path", {
    d: "M10 12l4 4m0 -4l-4 4"
  }));
}
var fKe = ["size", "color", "stroke"];
function zKe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, fKe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-trash",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("line", {
    x1: 4,
    y1: 7,
    x2: 20,
    y2: 7
  }), e.createElement("line", {
    x1: 10,
    y1: 11,
    x2: 10,
    y2: 17
  }), e.createElement("line", {
    x1: 14,
    y1: 11,
    x2: 14,
    y2: 17
  }), e.createElement("path", {
    d: "M5 7l1 12a2 2 0 0 0 2 2h8a2 2 0 0 0 2 -2l1 -12"
  }), e.createElement("path", {
    d: "M9 7v-3a1 1 0 0 1 1 -1h4a1 1 0 0 1 1 1v3"
  }));
}
var bKe = ["size", "color", "stroke"];
function LKe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, bKe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-tree",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M12 13l-2 -2"
  }), e.createElement("path", {
    d: "M12 12l2 -2"
  }), e.createElement("path", {
    d: "M12 21v-13"
  }), e.createElement("path", {
    d: "M9.824 15.995a3 3 0 0 1 -2.743 -3.69a2.998 2.998 0 0 1 .304 -4.833a3 3 0 0 1 4.615 -3.707a3 3 0 0 1 4.614 3.707a2.997 2.997 0 0 1 .305 4.833a3 3 0 0 1 -2.919 3.695h-4z"
  }));
}
var yKe = ["size", "color", "stroke"];
function CKe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, yKe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-trees",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M16 5l3 3l-2 1l4 4l-3 1l4 4h-9"
  }), e.createElement("line", {
    x1: 15,
    y1: 21,
    x2: 15,
    y2: 18
  }), e.createElement("path", {
    d: "M8 13l-2 -2"
  }), e.createElement("path", {
    d: "M8 12l2 -2"
  }), e.createElement("path", {
    d: "M8 21v-13"
  }), e.createElement("path", {
    d: "M5.824 15.995a3 3 0 0 1 -2.743 -3.69a2.998 2.998 0 0 1 .304 -4.833a3 3 0 0 1 4.615 -3.707a3 3 0 0 1 4.614 3.707a2.997 2.997 0 0 1 .305 4.833a3 3 0 0 1 -2.919 3.695h-4z"
  }));
}
var jKe = ["size", "color", "stroke"];
function BKe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, jKe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-trekking",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("circle", {
    cx: 12,
    cy: 4,
    r: 1
  }), e.createElement("path", {
    d: "M7 21l2 -4"
  }), e.createElement("path", {
    d: "M13 21v-4l-3 -3l1 -6l3 4l3 2"
  }), e.createElement("path", {
    d: "M10 14l-1.827 -1.218a2 2 0 0 1 -.831 -2.15l.28 -1.117a2 2 0 0 1 1.939 -1.515h1.439l4 1l3 -2"
  }), e.createElement("path", {
    d: "M17 12v9"
  }), e.createElement("path", {
    d: "M16 20h2"
  }));
}
var HKe = ["size", "color", "stroke"];
function NKe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, HKe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-trending-down-2",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M3 6h5l7 10h6"
  }), e.createElement("path", {
    d: "M18 19l3 -3l-3 -3"
  }));
}
var WKe = ["size", "color", "stroke"];
function qKe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, WKe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-trending-down-3",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M3 6h2.397a5 5 0 0 1 4.096 2.133l4.014 5.734a5 5 0 0 0 4.096 2.133h3.397"
  }), e.createElement("path", {
    d: "M18 19l3 -3l-3 -3"
  }));
}
var OKe = ["size", "color", "stroke"];
function PKe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, OKe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-trending-down",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("polyline", {
    points: "3 7 9 13 13 9 21 17"
  }), e.createElement("polyline", {
    points: "21 10 21 17 14 17"
  }));
}
var SKe = ["size", "color", "stroke"];
function IKe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, SKe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-trending-up-2",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M18 5l3 3l-3 3"
  }), e.createElement("path", {
    d: "M3 18h5l7 -10h6"
  }));
}
var AKe = ["size", "color", "stroke"];
function DKe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, AKe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-trending-up-3",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M18 5l3 3l-3 3"
  }), e.createElement("path", {
    d: "M3 18h2.397a5 5 0 0 0 4.096 -2.133l4.014 -5.734a5 5 0 0 1 4.096 -2.133h3.397"
  }));
}
var FKe = ["size", "color", "stroke"];
function GKe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, FKe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-trending-up",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("polyline", {
    points: "3 17 9 11 13 15 21 7"
  }), e.createElement("polyline", {
    points: "14 7 21 7 21 14"
  }));
}
var JKe = ["size", "color", "stroke"];
function KKe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, JKe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-triangle-inverted",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M5 4h14a2 2 0 0 1 1.84 2.75l-7.1 12.25a2 2 0 0 1 -3.5 0l-7.1 -12.25a2 2 0 0 1 1.75 -2.75"
  }));
}
var QKe = ["size", "color", "stroke"];
function RKe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, QKe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-triangle-off",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M5 19h14m1.986 -2.014a2 2 0 0 0 -.146 -.736l-7.1 -12.25a2 2 0 0 0 -3.5 0l-.825 1.424m-1.467 2.53l-4.808 8.296a2 2 0 0 0 1.75 2.75"
  }), e.createElement("path", {
    d: "M3 3l18 18"
  }));
}
var TKe = ["size", "color", "stroke"];
function UKe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, TKe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-triangle-square-circle",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M12 3l-4 7h8z"
  }), e.createElement("circle", {
    cx: 17,
    cy: 17,
    r: 3
  }), e.createElement("rect", {
    x: 4,
    y: 14,
    width: 6,
    height: 6,
    rx: 1
  }));
}
var VKe = ["size", "color", "stroke"];
function XKe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, VKe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-triangle",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M5 19h14a2 2 0 0 0 1.84 -2.75l-7.1 -12.25a2 2 0 0 0 -3.5 0l-7.1 12.25a2 2 0 0 0 1.75 2.75"
  }));
}
var YKe = ["size", "color", "stroke"];
function ZKe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, YKe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-triangles",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M9.974 21h8.052a0.975 .975 0 0 0 .81 -1.517l-4.025 -6.048a0.973 .973 0 0 0 -1.622 0l-4.025 6.048a0.977 .977 0 0 0 .81 1.517z"
  }), e.createElement("path", {
    d: "M4.98 16h14.04c.542 0 .98 -.443 .98 -.989a0.995 .995 0 0 0 -.156 -.534l-7.02 -11.023a0.974 .974 0 0 0 -1.648 0l-7.02 11.023a0.994 .994 0 0 0 .294 1.366a0.973 .973 0 0 0 .53 .157z"
  }));
}
var $Ke = ["size", "color", "stroke"];
function _Ke(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, $Ke);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-trident",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M3 6l2 -2v3a7 7 0 0 0 14 0v-3l2 2"
  }), e.createElement("path", {
    d: "M12 21v-18l-2 2m4 0l-2 -2"
  }));
}
var eQe = ["size", "color", "stroke"];
function tQe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, eQe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-trolley",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("circle", {
    cx: 11,
    cy: 19,
    r: 2
  }), e.createElement("path", {
    d: "M6 16l3 2"
  }), e.createElement("path", {
    d: "M12 17l8 -12"
  }), e.createElement("path", {
    d: "M17 10l2 1"
  }), e.createElement("path", {
    d: "M9.592 4.695l3.306 2.104a1.3 1.3 0 0 1 .396 1.8l-3.094 4.811a1.3 1.3 0 0 1 -1.792 .394l-3.306 -2.104a1.3 1.3 0 0 1 -.396 -1.8l3.094 -4.81a1.3 1.3 0 0 1 1.792 -.394z"
  }));
}
var oQe = ["size", "color", "stroke"];
function rQe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, oQe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-trophy-off",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M8 21h8"
  }), e.createElement("path", {
    d: "M12 17v4"
  }), e.createElement("path", {
    d: "M8 4h9"
  }), e.createElement("path", {
    d: "M17 4v8c0 .31 -.028 .612 -.082 .905m-1.384 2.632a5 5 0 0 1 -8.534 -3.537v-5"
  }), e.createElement("circle", {
    cx: 5,
    cy: 9,
    r: 2
  }), e.createElement("circle", {
    cx: 19,
    cy: 9,
    r: 2
  }), e.createElement("path", {
    d: "M3 3l18 18"
  }));
}
var nQe = ["size", "color", "stroke"];
function lQe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, nQe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-trophy",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("line", {
    x1: 8,
    y1: 21,
    x2: 16,
    y2: 21
  }), e.createElement("line", {
    x1: 12,
    y1: 17,
    x2: 12,
    y2: 21
  }), e.createElement("line", {
    x1: 7,
    y1: 4,
    x2: 17,
    y2: 4
  }), e.createElement("path", {
    d: "M17 4v8a5 5 0 0 1 -10 0v-8"
  }), e.createElement("circle", {
    cx: 5,
    cy: 9,
    r: 2
  }), e.createElement("circle", {
    cx: 19,
    cy: 9,
    r: 2
  }));
}
var aQe = ["size", "color", "stroke"];
function iQe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, aQe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-trowel",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M14.42 9.058l-5.362 5.363a1.978 1.978 0 0 1 -3.275 -.773l-2.682 -8.044a1.978 1.978 0 0 1 2.502 -2.502l8.045 2.682a1.978 1.978 0 0 1 .773 3.274z"
  }), e.createElement("path", {
    d: "M10 10l6.5 6.5"
  }), e.createElement("path", {
    d: "M19.347 16.575l1.08 1.079a1.96 1.96 0 0 1 -2.773 2.772l-1.08 -1.079a1.96 1.96 0 0 1 2.773 -2.772z"
  }));
}
var cQe = ["size", "color", "stroke"];
function sQe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, cQe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-truck-delivery",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("circle", {
    cx: 7,
    cy: 17,
    r: 2
  }), e.createElement("circle", {
    cx: 17,
    cy: 17,
    r: 2
  }), e.createElement("path", {
    d: "M5 17h-2v-4m-1 -8h11v12m-4 0h6m4 0h2v-6h-8m0 -5h5l3 5"
  }), e.createElement("line", {
    x1: 3,
    y1: 9,
    x2: 7,
    y2: 9
  }));
}
var hQe = ["size", "color", "stroke"];
function dQe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, hQe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-truck-loading",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M2 3h1a2 2 0 0 1 2 2v10a2 2 0 0 0 2 2h15"
  }), e.createElement("rect", {
    x: 9,
    y: 6,
    width: 10,
    height: 8,
    rx: 3
  }), e.createElement("circle", {
    cx: 9,
    cy: 19,
    r: 2
  }), e.createElement("circle", {
    cx: 18,
    cy: 19,
    r: 2
  }));
}
var vQe = ["size", "color", "stroke"];
function mQe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, vQe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-truck-off",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("circle", {
    cx: 7,
    cy: 17,
    r: 2
  }), e.createElement("path", {
    d: "M15.585 15.586a2 2 0 0 0 2.826 2.831"
  }), e.createElement("path", {
    d: "M5 17h-2v-11a1 1 0 0 1 1 -1h1m3.96 0h4.04v4m0 4v4m-4 0h6m6 0v-6h-6m-2 -5h5l3 5"
  }), e.createElement("line", {
    x1: 3,
    y1: 3,
    x2: 21,
    y2: 21
  }));
}
var kQe = ["size", "color", "stroke"];
function wQe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, kQe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-truck-return",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("circle", {
    cx: 7,
    cy: 17,
    r: 2
  }), e.createElement("circle", {
    cx: 17,
    cy: 17,
    r: 2
  }), e.createElement("path", {
    d: "M5 17h-2v-11a1 1 0 0 1 1 -1h9v6h-5l2 2m0 -4l-2 2"
  }), e.createElement("line", {
    x1: 9,
    y1: 17,
    x2: 15,
    y2: 17
  }), e.createElement("path", {
    d: "M13 6h5l3 5v6h-2"
  }));
}
var pQe = ["size", "color", "stroke"];
function EQe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, pQe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-truck",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("circle", {
    cx: 7,
    cy: 17,
    r: 2
  }), e.createElement("circle", {
    cx: 17,
    cy: 17,
    r: 2
  }), e.createElement("path", {
    d: "M5 17h-2v-11a1 1 0 0 1 1 -1h9v12m-4 0h6m4 0h2v-6h-8m0 -5h5l3 5"
  }));
}
var uQe = ["size", "color", "stroke"];
function gQe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, uQe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-txt",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M3 8h4"
  }), e.createElement("path", {
    d: "M5 8v8"
  }), e.createElement("path", {
    d: "M17 8h4"
  }), e.createElement("path", {
    d: "M19 8v8"
  }), e.createElement("path", {
    d: "M10 8l4 8"
  }), e.createElement("path", {
    d: "M10 16l4 -8"
  }));
}
var MQe = ["size", "color", "stroke"];
function xQe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, MQe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-typography-off",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M4 20h3"
  }), e.createElement("path", {
    d: "M14 20h6"
  }), e.createElement("path", {
    d: "M6.9 15h6.9"
  }), e.createElement("path", {
    d: "M13 13l3 7"
  }), e.createElement("path", {
    d: "M5 20l4.09 -10.906"
  }), e.createElement("path", {
    d: "M10.181 6.183l.819 -2.183h2l3.904 8.924"
  }), e.createElement("path", {
    d: "M3 3l18 18"
  }));
}
var fQe = ["size", "color", "stroke"];
function zQe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, fQe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-typography",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("line", {
    x1: 4,
    y1: 20,
    x2: 7,
    y2: 20
  }), e.createElement("line", {
    x1: 14,
    y1: 20,
    x2: 21,
    y2: 20
  }), e.createElement("line", {
    x1: 6.9,
    y1: 15,
    x2: 13.8,
    y2: 15
  }), e.createElement("line", {
    x1: 10.2,
    y1: 6.3,
    x2: 16,
    y2: 20
  }), e.createElement("polyline", {
    points: "5 20 11 4 13 4 20 20"
  }));
}
var bQe = ["size", "color", "stroke"];
function LQe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, bQe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-uf-off",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M16.95 9.01c3.02 .739 5.05 2.123 5.05 3.714c0 1.08 -.931 2.063 -2.468 2.814m-3.001 1c-1.36 .295 -2.9 .462 -4.531 .462c-5.52 0 -10 -1.909 -10 -4.276c0 -1.59 2.04 -2.985 5.07 -3.724"
  }), e.createElement("path", {
    d: "M14.69 10.686c1.388 -.355 2.31 -.976 2.31 -1.686v-.035c0 -2.742 -2.239 -4.965 -5 -4.965c-1.125 0 -2.164 .37 -3 .992m-1.707 2.297a4.925 4.925 0 0 0 -.293 1.676v.035c0 .961 1.696 1.764 3.956 1.956"
  }), e.createElement("path", {
    d: "M15 17l2 3"
  }), e.createElement("path", {
    d: "M8.5 17l-1.5 3"
  }), e.createElement("path", {
    d: "M12 14h.01"
  }), e.createElement("path", {
    d: "M7 13h.01"
  }), e.createElement("path", {
    d: "M17 13h.01"
  }), e.createElement("path", {
    d: "M3 3l18 18"
  }));
}
var yQe = ["size", "color", "stroke"];
function CQe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, yQe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-ufo",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M16.95 9.01c3.02 .739 5.05 2.123 5.05 3.714c0 2.367 -4.48 4.276 -10 4.276s-10 -1.909 -10 -4.276c0 -1.59 2.04 -2.985 5.07 -3.724"
  }), e.createElement("path", {
    d: "M7 9c0 1.105 2.239 2 5 2s5 -.895 5 -2v-.035c0 -2.742 -2.239 -4.965 -5 -4.965s-5 2.223 -5 4.965v.035"
  }), e.createElement("path", {
    d: "M15 17l2 3"
  }), e.createElement("path", {
    d: "M8.5 17l-1.5 3"
  }), e.createElement("path", {
    d: "M12 14h.01"
  }), e.createElement("path", {
    d: "M7 13h.01"
  }), e.createElement("path", {
    d: "M17 13h.01"
  }));
}
var jQe = ["size", "color", "stroke"];
function BQe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, jQe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-umbrella-off",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M12 12h-8c0 -2.209 .895 -4.208 2.342 -5.656m2.382 -1.645a8 8 0 0 1 11.276 7.301l-4 .001"
  }), e.createElement("path", {
    d: "M12 12v6a2 2 0 1 0 4 0"
  }), e.createElement("path", {
    d: "M3 3l18 18"
  }));
}
var HQe = ["size", "color", "stroke"];
function NQe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, HQe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-umbrella",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M4 12a8 8 0 0 1 16 0z"
  }), e.createElement("path", {
    d: "M12 12v6a2 2 0 0 0 4 0"
  }));
}
var WQe = ["size", "color", "stroke"];
function qQe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, WQe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-underline",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M7 5v5a5 5 0 0 0 10 0v-5"
  }), e.createElement("path", {
    d: "M5 19h14"
  }));
}
var OQe = ["size", "color", "stroke"];
function PQe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, OQe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-unlink",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M10 14a3.5 3.5 0 0 0 5 0l4 -4a3.5 3.5 0 0 0 -5 -5l-.5 .5"
  }), e.createElement("path", {
    d: "M14 10a3.5 3.5 0 0 0 -5 0l-4 4a3.5 3.5 0 0 0 5 5l.5 -.5"
  }), e.createElement("line", {
    x1: 16,
    y1: 21,
    x2: 16,
    y2: 19
  }), e.createElement("line", {
    x1: 19,
    y1: 16,
    x2: 21,
    y2: 16
  }), e.createElement("line", {
    x1: 3,
    y1: 8,
    x2: 5,
    y2: 8
  }), e.createElement("line", {
    x1: 8,
    y1: 3,
    x2: 8,
    y2: 5
  }));
}
var SQe = ["size", "color", "stroke"];
function IQe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, SQe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-upload",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M4 17v2a2 2 0 0 0 2 2h12a2 2 0 0 0 2 -2v-2"
  }), e.createElement("polyline", {
    points: "7 9 12 4 17 9"
  }), e.createElement("line", {
    x1: 12,
    y1: 4,
    x2: 12,
    y2: 16
  }));
}
var AQe = ["size", "color", "stroke"];
function DQe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, AQe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-urgent",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M8 16v-4a4 4 0 0 1 8 0v4"
  }), e.createElement("path", {
    d: "M3 12h1m8 -9v1m8 8h1m-15.4 -6.4l.7 .7m12.1 -.7l-.7 .7"
  }), e.createElement("rect", {
    x: 6,
    y: 16,
    width: 12,
    height: 4,
    rx: 1
  }));
}
var FQe = ["size", "color", "stroke"];
function GQe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, FQe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-usb",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("circle", {
    cx: 12,
    cy: 19,
    r: 2
  }), e.createElement("path", {
    d: "M12 17v-11.5"
  }), e.createElement("path", {
    d: "M7 10v3l5 3"
  }), e.createElement("path", {
    d: "M12 14.5l5 -2v-2.5"
  }), e.createElement("path", {
    d: "M16 10h2v-2h-2z"
  }), e.createElement("circle", {
    cx: 7,
    cy: 9,
    r: 1
  }), e.createElement("path", {
    d: "M10 5.5h4l-2 -2.5z"
  }));
}
var JQe = ["size", "color", "stroke"];
function KQe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, JQe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-user-check",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("circle", {
    cx: 9,
    cy: 7,
    r: 4
  }), e.createElement("path", {
    d: "M3 21v-2a4 4 0 0 1 4 -4h4a4 4 0 0 1 4 4v2"
  }), e.createElement("path", {
    d: "M16 11l2 2l4 -4"
  }));
}
var QQe = ["size", "color", "stroke"];
function RQe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, QQe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-user-circle",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 9
  }), e.createElement("circle", {
    cx: 12,
    cy: 10,
    r: 3
  }), e.createElement("path", {
    d: "M6.168 18.849a4 4 0 0 1 3.832 -2.849h4a4 4 0 0 1 3.834 2.855"
  }));
}
var TQe = ["size", "color", "stroke"];
function UQe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, TQe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-user-exclamation",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("circle", {
    cx: 9,
    cy: 7,
    r: 4
  }), e.createElement("path", {
    d: "M3 21v-2a4 4 0 0 1 4 -4h4a4 4 0 0 1 4 4v2"
  }), e.createElement("line", {
    x1: 19,
    y1: 7,
    x2: 19,
    y2: 10
  }), e.createElement("line", {
    x1: 19,
    y1: 14,
    x2: 19,
    y2: 14.01
  }));
}
var VQe = ["size", "color", "stroke"];
function XQe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, VQe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-user-minus",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("circle", {
    cx: 9,
    cy: 7,
    r: 4
  }), e.createElement("path", {
    d: "M3 21v-2a4 4 0 0 1 4 -4h4a4 4 0 0 1 4 4v2"
  }), e.createElement("line", {
    x1: 16,
    y1: 11,
    x2: 22,
    y2: 11
  }));
}
var YQe = ["size", "color", "stroke"];
function ZQe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, YQe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-user-off",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M14.274 10.291a4 4 0 1 0 -5.554 -5.58m-.548 3.453a4.01 4.01 0 0 0 2.62 2.65"
  }), e.createElement("path", {
    d: "M6 21v-2a4 4 0 0 1 4 -4h4a4 4 0 0 1 1.147 .167m2.685 2.681a4 4 0 0 1 .168 1.152v2"
  }), e.createElement("line", {
    x1: 3,
    y1: 3,
    x2: 21,
    y2: 21
  }));
}
var $Qe = ["size", "color", "stroke"];
function _Qe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, $Qe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-user-plus",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("circle", {
    cx: 9,
    cy: 7,
    r: 4
  }), e.createElement("path", {
    d: "M3 21v-2a4 4 0 0 1 4 -4h4a4 4 0 0 1 4 4v2"
  }), e.createElement("path", {
    d: "M16 11h6m-3 -3v6"
  }));
}
var eRe = ["size", "color", "stroke"];
function tRe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, eRe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-user-search",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("circle", {
    cx: 12,
    cy: 7,
    r: 4
  }), e.createElement("path", {
    d: "M6 21v-2a4 4 0 0 1 4 -4h1"
  }), e.createElement("circle", {
    cx: 16.5,
    cy: 17.5,
    r: 2.5
  }), e.createElement("path", {
    d: "M18.5 19.5l2.5 2.5"
  }));
}
var oRe = ["size", "color", "stroke"];
function rRe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, oRe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-user-x",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("circle", {
    cx: 9,
    cy: 7,
    r: 4
  }), e.createElement("path", {
    d: "M3 21v-2a4 4 0 0 1 4 -4h4a4 4 0 0 1 4 4v2"
  }), e.createElement("path", {
    d: "M17 9l4 4m0 -4l-4 4"
  }));
}
var nRe = ["size", "color", "stroke"];
function lRe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, nRe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-user",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("circle", {
    cx: 12,
    cy: 7,
    r: 4
  }), e.createElement("path", {
    d: "M6 21v-2a4 4 0 0 1 4 -4h4a4 4 0 0 1 4 4v2"
  }));
}
var aRe = ["size", "color", "stroke"];
function iRe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, aRe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-users",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("circle", {
    cx: 9,
    cy: 7,
    r: 4
  }), e.createElement("path", {
    d: "M3 21v-2a4 4 0 0 1 4 -4h4a4 4 0 0 1 4 4v2"
  }), e.createElement("path", {
    d: "M16 3.13a4 4 0 0 1 0 7.75"
  }), e.createElement("path", {
    d: "M21 21v-2a4 4 0 0 0 -3 -3.85"
  }));
}
var cRe = ["size", "color", "stroke"];
function sRe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, cRe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-uv-index",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M3 12h1m16 0h1m-15.4 -6.4l.7 .7m12.1 -.7l-.7 .7m-9.7 5.7a4 4 0 1 1 8 0"
  }), e.createElement("path", {
    d: "M12 4v-1"
  }), e.createElement("path", {
    d: "M13 16l2 5h1l2 -5"
  }), e.createElement("path", {
    d: "M6 16v3a2 2 0 1 0 4 0v-3"
  }));
}
var hRe = ["size", "color", "stroke"];
function dRe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, hRe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-ux-circle",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 9
  }), e.createElement("path", {
    d: "M7 10v2a2 2 0 1 0 4 0v-2"
  }), e.createElement("path", {
    d: "M14 10l3 4"
  }), e.createElement("path", {
    d: "M14 14l3 -4"
  }));
}
var vRe = ["size", "color", "stroke"];
function mRe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, vRe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-vaccine-bottle-off",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M9 5v-1a1 1 0 0 1 1 -1h4a1 1 0 0 1 1 1v1a1 1 0 0 1 -1 1h-4"
  }), e.createElement("path", {
    d: "M8.7 8.705a1.806 1.806 0 0 1 -.2 .045c-.866 .144 -1.5 .893 -1.5 1.77v8.48a2 2 0 0 0 2 2h6a2 2 0 0 0 2 -2v-2m0 -4v-2.48c0 -.877 -.634 -1.626 -1.5 -1.77a1.795 1.795 0 0 1 -1.5 -1.77v-.98"
  }), e.createElement("path", {
    d: "M7 12h5m4 0h1"
  }), e.createElement("path", {
    d: "M7 18h10"
  }), e.createElement("path", {
    d: "M11 15h2"
  }), e.createElement("path", {
    d: "M3 3l18 18"
  }));
}
var kRe = ["size", "color", "stroke"];
function wRe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, kRe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-vaccine-bottle",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("rect", {
    x: 9,
    y: 3,
    width: 6,
    height: 3,
    rx: 1
  }), e.createElement("path", {
    d: "M10 6v.98c0 .877 -.634 1.626 -1.5 1.77c-.866 .144 -1.5 .893 -1.5 1.77v8.48a2 2 0 0 0 2 2h6a2 2 0 0 0 2 -2v-8.48c0 -.877 -.634 -1.626 -1.5 -1.77a1.795 1.795 0 0 1 -1.5 -1.77v-.98"
  }), e.createElement("path", {
    d: "M7 12h10"
  }), e.createElement("path", {
    d: "M7 18h10"
  }), e.createElement("path", {
    d: "M11 15h2"
  }));
}
var pRe = ["size", "color", "stroke"];
function ERe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, pRe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-vaccine-off",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M17 3l4 4"
  }), e.createElement("path", {
    d: "M19 5l-4.5 4.5"
  }), e.createElement("path", {
    d: "M11.5 6.5l6 6"
  }), e.createElement("path", {
    d: "M16.5 11.5l-.5 .5m-2 2l-4 4h-4v-4l4 -4m2 -2l.5 -.5"
  }), e.createElement("path", {
    d: "M7.5 12.5l1.5 1.5"
  }), e.createElement("path", {
    d: "M3 21l3 -3"
  }), e.createElement("path", {
    d: "M3 3l18 18"
  }));
}
var uRe = ["size", "color", "stroke"];
function gRe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, uRe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-vaccine",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M17 3l4 4"
  }), e.createElement("path", {
    d: "M19 5l-4.5 4.5"
  }), e.createElement("path", {
    d: "M11.5 6.5l6 6"
  }), e.createElement("path", {
    d: "M16.5 11.5l-6.5 6.5h-4v-4l6.5 -6.5"
  }), e.createElement("path", {
    d: "M7.5 12.5l1.5 1.5"
  }), e.createElement("path", {
    d: "M10.5 9.5l1.5 1.5"
  }), e.createElement("path", {
    d: "M3 21l3 -3"
  }));
}
var MRe = ["size", "color", "stroke"];
function xRe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, MRe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-vacuum-cleaner",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M21 12a9 9 0 1 1 -18 0a9 9 0 0 1 18 0z"
  }), e.createElement("path", {
    d: "M14 9a2 2 0 1 1 -4 0a2 2 0 0 1 4 0z"
  }), e.createElement("path", {
    d: "M12 16h.01"
  }));
}
var fRe = ["size", "color", "stroke"];
function zRe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, fRe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-variable-minus",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M8 16c1.5 0 3 -2 4 -3.5s2.5 -3.5 4 -3.5"
  }), e.createElement("path", {
    d: "M5 4c-2.5 5 -2.5 10 0 16m14 -16c1.775 3.55 2.29 7.102 1.544 11.01m-11.544 -6.01h1c1 0 1 1 2.016 3.527c.782 1.966 .943 3 1.478 3.343"
  }), e.createElement("path", {
    d: "M8 16c1.5 0 3 -2 4 -3.5s2.5 -3.5 4 -3.5"
  }), e.createElement("path", {
    d: "M16 19h6"
  }));
}
var bRe = ["size", "color", "stroke"];
function LRe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, bRe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-variable-off",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M4.675 4.68c-2.17 4.776 -2.062 9.592 .325 15.32"
  }), e.createElement("path", {
    d: "M19 4c1.959 3.917 2.383 7.834 1.272 12.232m-.983 3.051c-.093 .238 -.189 .477 -.289 .717"
  }), e.createElement("path", {
    d: "M11.696 11.696c.095 .257 .2 .533 .32 .831c.984 2.473 .984 3.473 1.984 3.473h1"
  }), e.createElement("path", {
    d: "M8 16c1.5 0 3 -2 4 -3.5m2.022 -2.514c.629 -.582 1.304 -.986 1.978 -.986"
  }), e.createElement("path", {
    d: "M3 3l18 18"
  }));
}
var yRe = ["size", "color", "stroke"];
function CRe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, yRe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-variable-plus",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M5 4c-2.5 5 -2.5 10 0 16m14 -16c1.38 2.76 1.998 5.52 1.855 8.448m-11.855 -3.448h1c1 0 1 1 2.016 3.527c.785 1.972 .944 3.008 1.483 3.346"
  }), e.createElement("path", {
    d: "M8 16c1.5 0 3 -2 4 -3.5s2.5 -3.5 4 -3.5"
  }), e.createElement("path", {
    d: "M16 19h6"
  }), e.createElement("path", {
    d: "M19 16v6"
  }));
}
var jRe = ["size", "color", "stroke"];
function BRe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, jRe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-variable",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M5 4c-2.5 5 -2.5 10 0 16m14 -16c2.5 5 2.5 10 0 16m-10 -11h1c1 0 1 1 2.016 3.527c.984 2.473 .984 3.473 1.984 3.473h1"
  }), e.createElement("path", {
    d: "M8 16c1.5 0 3 -2 4 -3.5s2.5 -3.5 4 -3.5"
  }));
}
var HRe = ["size", "color", "stroke"];
function NRe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, HRe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-vector-bezier-2",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("rect", {
    x: 3,
    y: 3,
    width: 4,
    height: 4,
    rx: 1
  }), e.createElement("rect", {
    x: 17,
    y: 17,
    width: 4,
    height: 4,
    rx: 1
  }), e.createElement("line", {
    x1: 7,
    y1: 5,
    x2: 14,
    y2: 5
  }), e.createElement("line", {
    x1: 10,
    y1: 19,
    x2: 17,
    y2: 19
  }), e.createElement("circle", {
    cx: 9,
    cy: 19,
    r: 1
  }), e.createElement("circle", {
    cx: 15,
    cy: 5,
    r: 1
  }), e.createElement("path", {
    d: "M7 5.5a5 6.5 0 0 1 5 6.5a5 6.5 0 0 0 5 6.5"
  }));
}
var WRe = ["size", "color", "stroke"];
function qRe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, WRe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-vector-bezier-arc",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("rect", {
    x: 3,
    y: 10,
    width: 4,
    height: 4,
    rx: 1
  }), e.createElement("rect", {
    x: 17,
    y: 10,
    width: 4,
    height: 4,
    rx: 1
  }), e.createElement("rect", {
    x: 10,
    y: 3,
    width: 4,
    height: 4,
    rx: 1
  }), e.createElement("rect", {
    x: 10,
    y: 17,
    width: 4,
    height: 4,
    rx: 1
  }), e.createElement("path", {
    d: "M19 10a5 5 0 0 0 -5 -5"
  }), e.createElement("path", {
    d: "M5 14a5 5 0 0 0 5 5"
  }), e.createElement("path", {
    d: "M5 10a5 5 0 0 1 5 -5"
  }));
}
var ORe = ["size", "color", "stroke"];
function PRe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, ORe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-vector-bezier-circle",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("rect", {
    x: 3,
    y: 10,
    width: 4,
    height: 4,
    rx: 1
  }), e.createElement("rect", {
    x: 17,
    y: 10,
    width: 4,
    height: 4,
    rx: 1
  }), e.createElement("rect", {
    x: 10,
    y: 3,
    width: 4,
    height: 4,
    rx: 1
  }), e.createElement("rect", {
    x: 10,
    y: 17,
    width: 4,
    height: 4,
    rx: 1
  }), e.createElement("path", {
    d: "M19 10a5 5 0 0 0 -5 -5"
  }), e.createElement("path", {
    d: "M19 14a5 5 0 0 1 -5 5"
  }), e.createElement("path", {
    d: "M5 14a5 5 0 0 0 5 5"
  }), e.createElement("path", {
    d: "M5 10a5 5 0 0 1 5 -5"
  }));
}
var SRe = ["size", "color", "stroke"];
function IRe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, SRe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-vector-bezier",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("rect", {
    x: 3,
    y: 14,
    width: 4,
    height: 4,
    rx: 1
  }), e.createElement("rect", {
    x: 17,
    y: 14,
    width: 4,
    height: 4,
    rx: 1
  }), e.createElement("rect", {
    x: 10,
    y: 6,
    width: 4,
    height: 4,
    rx: 1
  }), e.createElement("path", {
    d: "M10 8.5a6 6 0 0 0 -5 5.5"
  }), e.createElement("path", {
    d: "M14 8.5a6 6 0 0 1 5 5.5"
  }), e.createElement("line", {
    x1: 10,
    y1: 8,
    x2: 4,
    y2: 8
  }), e.createElement("line", {
    x1: 20,
    y1: 8,
    x2: 14,
    y2: 8
  }), e.createElement("circle", {
    cx: 3,
    cy: 8,
    r: 1
  }), e.createElement("circle", {
    cx: 21,
    cy: 8,
    r: 1
  }));
}
var ARe = ["size", "color", "stroke"];
function DRe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, ARe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-vector-off",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M6.68 6.733a0.996 .996 0 0 1 -.68 .267h-2a1 1 0 0 1 -1 -1v-2c0 -.276 .112 -.527 .293 -.708"
  }), e.createElement("rect", {
    x: 17,
    y: 3,
    width: 4,
    height: 4,
    rx: 1
  }), e.createElement("path", {
    d: "M20.72 20.693a0.997 .997 0 0 1 -.72 .307h-2a1 1 0 0 1 -1 -1v-2c0 -.282 .116 -.536 .304 -.718"
  }), e.createElement("rect", {
    x: 3,
    y: 17,
    width: 4,
    height: 4,
    rx: 1
  }), e.createElement("path", {
    d: "M5 7v10"
  }), e.createElement("path", {
    d: "M19 7v8"
  }), e.createElement("path", {
    d: "M9 5h8"
  }), e.createElement("path", {
    d: "M7 19h10"
  }), e.createElement("path", {
    d: "M3 3l18 18"
  }));
}
var FRe = ["size", "color", "stroke"];
function GRe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, FRe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-vector-spline",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("rect", {
    x: 17,
    y: 3,
    width: 4,
    height: 4,
    rx: 1
  }), e.createElement("rect", {
    x: 3,
    y: 17,
    width: 4,
    height: 4,
    rx: 1
  }), e.createElement("path", {
    d: "M17 5c-6.627 0 -12 5.373 -12 12"
  }));
}
var JRe = ["size", "color", "stroke"];
function KRe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, JRe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-vector-triangle-off",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M10 6v-1a1 1 0 0 1 1 -1h2a1 1 0 0 1 1 1v2a1 1 0 0 1 -1 1h-1"
  }), e.createElement("rect", {
    x: 3,
    y: 17,
    width: 4,
    height: 4,
    rx: 1
  }), e.createElement("path", {
    d: "M20.705 20.709a0.997 .997 0 0 1 -.705 .291h-2a1 1 0 0 1 -1 -1v-2c0 -.28 .115 -.532 .3 -.714"
  }), e.createElement("path", {
    d: "M6.5 17.1l3.749 -6.823"
  }), e.createElement("path", {
    d: "M13.158 9.197l-.658 -1.197"
  }), e.createElement("path", {
    d: "M7 19h10"
  }), e.createElement("path", {
    d: "M3 3l18 18"
  }));
}
var QRe = ["size", "color", "stroke"];
function RRe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, QRe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-vector-triangle",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("rect", {
    x: 10,
    y: 4,
    width: 4,
    height: 4,
    rx: 1
  }), e.createElement("rect", {
    x: 3,
    y: 17,
    width: 4,
    height: 4,
    rx: 1
  }), e.createElement("rect", {
    x: 17,
    y: 17,
    width: 4,
    height: 4,
    rx: 1
  }), e.createElement("line", {
    x1: 6.5,
    y1: 17.1,
    x2: 11.5,
    y2: 8
  }), e.createElement("line", {
    x1: 17.5,
    y1: 17.1,
    x2: 12.5,
    y2: 8
  }), e.createElement("line", {
    x1: 7,
    y1: 19,
    x2: 17,
    y2: 19
  }));
}
var TRe = ["size", "color", "stroke"];
function URe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, TRe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-vector",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("rect", {
    x: 3,
    y: 3,
    width: 4,
    height: 4,
    rx: 1
  }), e.createElement("rect", {
    x: 17,
    y: 3,
    width: 4,
    height: 4,
    rx: 1
  }), e.createElement("rect", {
    x: 17,
    y: 17,
    width: 4,
    height: 4,
    rx: 1
  }), e.createElement("rect", {
    x: 3,
    y: 17,
    width: 4,
    height: 4,
    rx: 1
  }), e.createElement("line", {
    x1: 5,
    y1: 7,
    x2: 5,
    y2: 17
  }), e.createElement("line", {
    x1: 19,
    y1: 7,
    x2: 19,
    y2: 17
  }), e.createElement("line", {
    x1: 7,
    y1: 5,
    x2: 17,
    y2: 5
  }), e.createElement("line", {
    x1: 7,
    y1: 19,
    x2: 17,
    y2: 19
  }));
}
var VRe = ["size", "color", "stroke"];
function XRe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, VRe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-venus",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("circle", {
    cx: 12,
    cy: 9,
    r: 5
  }), e.createElement("line", {
    x1: 12,
    y1: 14,
    x2: 12,
    y2: 21
  }), e.createElement("line", {
    x1: 9,
    y1: 18,
    x2: 15,
    y2: 18
  }));
}
var YRe = ["size", "color", "stroke"];
function ZRe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, YRe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-versions-off",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M10.184 6.162a2 2 0 0 1 1.816 -1.162h6a2 2 0 0 1 2 2v9m-1.185 2.827a1.993 1.993 0 0 1 -.815 .173h-6a2 2 0 0 1 -2 -2v-7"
  }), e.createElement("path", {
    d: "M7 7v10"
  }), e.createElement("path", {
    d: "M4 8v8"
  }), e.createElement("path", {
    d: "M3 3l18 18"
  }));
}
var $Re = ["size", "color", "stroke"];
function _Re(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, $Re);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-versions",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("rect", {
    x: 10,
    y: 5,
    width: 10,
    height: 14,
    rx: 2
  }), e.createElement("line", {
    x1: 7,
    y1: 7,
    x2: 7,
    y2: 17
  }), e.createElement("line", {
    x1: 4,
    y1: 8,
    x2: 4,
    y2: 16
  }));
}
var eTe = ["size", "color", "stroke"];
function tTe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, eTe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-video-minus",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M15 10l4.553 -2.276a1 1 0 0 1 1.447 .894v6.764a1 1 0 0 1 -1.447 .894l-4.553 -2.276v-4z"
  }), e.createElement("rect", {
    x: 3,
    y: 6,
    width: 12,
    height: 12,
    rx: 2
  }), e.createElement("line", {
    x1: 7,
    y1: 12,
    x2: 11,
    y2: 12
  }));
}
var oTe = ["size", "color", "stroke"];
function rTe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, oTe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-video-off",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("line", {
    x1: 3,
    y1: 3,
    x2: 21,
    y2: 21
  }), e.createElement("path", {
    d: "M15 11v-1l4.553 -2.276a1 1 0 0 1 1.447 .894v6.764a1 1 0 0 1 -.675 .946"
  }), e.createElement("path", {
    d: "M10 6h3a2 2 0 0 1 2 2v3m0 4v1a2 2 0 0 1 -2 2h-8a2 2 0 0 1 -2 -2v-8a2 2 0 0 1 2 -2h1"
  }));
}
var nTe = ["size", "color", "stroke"];
function lTe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, nTe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-video-plus",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M15 10l4.553 -2.276a1 1 0 0 1 1.447 .894v6.764a1 1 0 0 1 -1.447 .894l-4.553 -2.276v-4z"
  }), e.createElement("rect", {
    x: 3,
    y: 6,
    width: 12,
    height: 12,
    rx: 2
  }), e.createElement("line", {
    x1: 7,
    y1: 12,
    x2: 11,
    y2: 12
  }), e.createElement("line", {
    x1: 9,
    y1: 10,
    x2: 9,
    y2: 14
  }));
}
var aTe = ["size", "color", "stroke"];
function iTe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, aTe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-video",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M15 10l4.553 -2.276a1 1 0 0 1 1.447 .894v6.764a1 1 0 0 1 -1.447 .894l-4.553 -2.276v-4z"
  }), e.createElement("rect", {
    x: 3,
    y: 6,
    width: 12,
    height: 12,
    rx: 2
  }));
}
var cTe = ["size", "color", "stroke"];
function sTe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, cTe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-view-360-off",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M8.335 8.388a18.998 18.998 0 0 0 -.335 3.612c0 4.97 1.79 9 4 9c1.622 0 3.018 -2.172 3.646 -5.294m.354 -3.706c0 -4.97 -1.79 -9 -4 -9c-1.035 0 -1.979 .885 -2.689 2.337"
  }), e.createElement("path", {
    d: "M5.65 5.623a9 9 0 1 0 12.71 12.745m1.684 -2.328a9 9 0 0 0 -12.094 -12.08"
  }), e.createElement("path", {
    d: "M8.32 8.349c-3.136 .625 -5.32 2.025 -5.32 3.651c0 2.21 4.03 4 9 4c1.286 0 2.51 -.12 3.616 -.336m3.059 -.98c1.445 -.711 2.325 -1.653 2.325 -2.684c0 -2.21 -4.03 -4 -9 -4"
  }), e.createElement("path", {
    d: "M3 3l18 18"
  }));
}
var hTe = ["size", "color", "stroke"];
function dTe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, hTe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-view-360",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 9
  }), e.createElement("ellipse", {
    cx: 12,
    cy: 12,
    rx: 4,
    ry: 9
  }), e.createElement("path", {
    d: "M3 12c0 2.21 4.03 4 9 4s9 -1.79 9 -4s-4.03 -4 -9 -4s-9 1.79 -9 4z"
  }));
}
var vTe = ["size", "color", "stroke"];
function mTe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, vTe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-viewfinder-off",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M5.65 5.623a9 9 0 1 0 12.71 12.745m1.684 -2.328a9 9 0 0 0 -12.094 -12.08"
  }), e.createElement("path", {
    d: "M12 3v4"
  }), e.createElement("path", {
    d: "M12 21v-3"
  }), e.createElement("path", {
    d: "M3 12h4"
  }), e.createElement("path", {
    d: "M21 12h-3"
  }), e.createElement("path", {
    d: "M12 12v.01"
  }), e.createElement("path", {
    d: "M3 3l18 18"
  }));
}
var kTe = ["size", "color", "stroke"];
function wTe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, kTe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-viewfinder",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 9
  }), e.createElement("line", {
    x1: 12,
    y1: 3,
    x2: 12,
    y2: 7
  }), e.createElement("line", {
    x1: 12,
    y1: 21,
    x2: 12,
    y2: 18
  }), e.createElement("line", {
    x1: 3,
    y1: 12,
    x2: 7,
    y2: 12
  }), e.createElement("line", {
    x1: 21,
    y1: 12,
    x2: 18,
    y2: 12
  }), e.createElement("line", {
    x1: 12,
    y1: 12,
    x2: 12,
    y2: 12.01
  }));
}
var pTe = ["size", "color", "stroke"];
function ETe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, pTe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-viewport-narrow",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M3 12h7l-3 -3m0 6l3 -3"
  }), e.createElement("path", {
    d: "M21 12h-7l3 -3m0 6l-3 -3"
  }), e.createElement("path", {
    d: "M9 6v-3h6v3"
  }), e.createElement("path", {
    d: "M9 18v3h6v-3"
  }));
}
var uTe = ["size", "color", "stroke"];
function gTe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, uTe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-viewport-wide",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M10 12h-7l3 -3m0 6l-3 -3"
  }), e.createElement("path", {
    d: "M14 12h7l-3 -3m0 6l3 -3"
  }), e.createElement("path", {
    d: "M3 6v-3h18v3"
  }), e.createElement("path", {
    d: "M3 18v3h18v-3"
  }));
}
var MTe = ["size", "color", "stroke"];
function xTe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, MTe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-vinyl",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M16.004 3.937a9 9 0 1 0 4.996 8.063"
  }), e.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 1
  }), e.createElement("circle", {
    cx: 20,
    cy: 4,
    r: 1
  }), e.createElement("path", {
    d: "M20 4l-3.5 10l-2.5 2"
  }));
}
var fTe = ["size", "color", "stroke"];
function zTe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, fTe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-vip-off",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M3 5h2m4 0h12"
  }), e.createElement("path", {
    d: "M3 19h16"
  }), e.createElement("path", {
    d: "M4 9l2 6h1l2 -6"
  }), e.createElement("path", {
    d: "M12 12v3"
  }), e.createElement("path", {
    d: "M16 12v-3h2a2 2 0 1 1 0 4h-1"
  }), e.createElement("path", {
    d: "M3 3l18 18"
  }));
}
var bTe = ["size", "color", "stroke"];
function LTe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, bTe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-vip",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M3 5h18"
  }), e.createElement("path", {
    d: "M3 19h18"
  }), e.createElement("path", {
    d: "M4 9l2 6h1l2 -6"
  }), e.createElement("path", {
    d: "M12 9v6"
  }), e.createElement("path", {
    d: "M16 15v-6h2a2 2 0 1 1 0 4h-2"
  }));
}
var yTe = ["size", "color", "stroke"];
function CTe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, yTe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-virus-off",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M3 3l18 18"
  }), e.createElement("path", {
    d: "M8.469 8.46a5 5 0 0 0 7.058 7.084"
  }), e.createElement("path", {
    d: "M16.913 12.936a5 5 0 0 0 -5.826 -5.853"
  }), e.createElement("path", {
    d: "M12 7v-4"
  }), e.createElement("path", {
    d: "M11 3h2"
  }), e.createElement("path", {
    d: "M15.536 8.464l2.828 -2.828"
  }), e.createElement("path", {
    d: "M17.657 4.929l1.414 1.414"
  }), e.createElement("path", {
    d: "M17 12h4"
  }), e.createElement("path", {
    d: "M21 11v2"
  }), e.createElement("path", {
    d: "M18.364 18.363l-.707 .707"
  }), e.createElement("path", {
    d: "M12 17v4"
  }), e.createElement("path", {
    d: "M13 21h-2"
  }), e.createElement("path", {
    d: "M8.465 15.536l-2.829 2.828"
  }), e.createElement("path", {
    d: "M6.343 19.071l-1.413 -1.414"
  }), e.createElement("path", {
    d: "M7 12h-4"
  }), e.createElement("path", {
    d: "M3 13v-2"
  }), e.createElement("path", {
    d: "M5.636 5.637l-.707 .707"
  }));
}
var jTe = ["size", "color", "stroke"];
function BTe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, jTe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-virus-search",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M17 12a5 5 0 1 0 -5 5"
  }), e.createElement("path", {
    d: "M12 7v-4"
  }), e.createElement("path", {
    d: "M11 3h2"
  }), e.createElement("path", {
    d: "M15.536 8.464l2.828 -2.828"
  }), e.createElement("path", {
    d: "M17.657 4.929l1.414 1.414"
  }), e.createElement("path", {
    d: "M17 12h4"
  }), e.createElement("path", {
    d: "M21 11v2"
  }), e.createElement("path", {
    d: "M12 17v4"
  }), e.createElement("path", {
    d: "M13 21h-2"
  }), e.createElement("path", {
    d: "M8.465 15.536l-2.829 2.828"
  }), e.createElement("path", {
    d: "M6.343 19.071l-1.413 -1.414"
  }), e.createElement("path", {
    d: "M7 12h-4"
  }), e.createElement("path", {
    d: "M3 13v-2"
  }), e.createElement("path", {
    d: "M8.464 8.464l-2.828 -2.828"
  }), e.createElement("path", {
    d: "M4.929 6.343l1.414 -1.413"
  }), e.createElement("circle", {
    cx: 17.5,
    cy: 17.5,
    r: 2.5
  }), e.createElement("path", {
    d: "M19.5 19.5l2.5 2.5"
  }));
}
var HTe = ["size", "color", "stroke"];
function NTe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, HTe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-virus",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 5
  }), e.createElement("path", {
    d: "M12 7v-4"
  }), e.createElement("path", {
    d: "M11 3h2"
  }), e.createElement("path", {
    d: "M15.536 8.464l2.828 -2.828"
  }), e.createElement("path", {
    d: "M17.657 4.929l1.414 1.414"
  }), e.createElement("path", {
    d: "M17 12h4"
  }), e.createElement("path", {
    d: "M21 11v2"
  }), e.createElement("path", {
    d: "M15.535 15.536l2.829 2.828"
  }), e.createElement("path", {
    d: "M19.071 17.657l-1.414 1.414"
  }), e.createElement("path", {
    d: "M12 17v4"
  }), e.createElement("path", {
    d: "M13 21h-2"
  }), e.createElement("path", {
    d: "M8.465 15.536l-2.829 2.828"
  }), e.createElement("path", {
    d: "M6.343 19.071l-1.413 -1.414"
  }), e.createElement("path", {
    d: "M7 12h-4"
  }), e.createElement("path", {
    d: "M3 13v-2"
  }), e.createElement("path", {
    d: "M8.464 8.464l-2.828 -2.828"
  }), e.createElement("path", {
    d: "M4.929 6.343l1.414 -1.413"
  }));
}
var WTe = ["size", "color", "stroke"];
function qTe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, WTe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-vocabulary-off",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M7 3h3a2 2 0 0 1 2 2a2 2 0 0 1 2 -2h6a1 1 0 0 1 1 1v13m-2 2h-5a2 2 0 0 0 -2 2a2 2 0 0 0 -2 -2h-6a1 1 0 0 1 -1 -1v-14c0 -.279 .114 -.53 .298 -.712"
  }), e.createElement("path", {
    d: "M12 5v3m0 4v9"
  }), e.createElement("path", {
    d: "M7 11h1"
  }), e.createElement("path", {
    d: "M16 7h1"
  }), e.createElement("path", {
    d: "M16 11h1"
  }), e.createElement("path", {
    d: "M3 3l18 18"
  }));
}
var OTe = ["size", "color", "stroke"];
function PTe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, OTe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-vocabulary",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M10 19h-6a1 1 0 0 1 -1 -1v-14a1 1 0 0 1 1 -1h6a2 2 0 0 1 2 2a2 2 0 0 1 2 -2h6a1 1 0 0 1 1 1v14a1 1 0 0 1 -1 1h-6a2 2 0 0 0 -2 2a2 2 0 0 0 -2 -2z"
  }), e.createElement("path", {
    d: "M12 5v16"
  }), e.createElement("path", {
    d: "M7 7h1"
  }), e.createElement("path", {
    d: "M7 11h1"
  }), e.createElement("path", {
    d: "M16 7h1"
  }), e.createElement("path", {
    d: "M16 11h1"
  }), e.createElement("path", {
    d: "M16 15h1"
  }));
}
var STe = ["size", "color", "stroke"];
function ITe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, STe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-volume-2",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M15 8a5 5 0 0 1 0 8"
  }), e.createElement("path", {
    d: "M6 15h-2a1 1 0 0 1 -1 -1v-4a1 1 0 0 1 1 -1h2l3.5 -4.5a0.8 .8 0 0 1 1.5 .5v14a0.8 .8 0 0 1 -1.5 .5l-3.5 -4.5"
  }));
}
var ATe = ["size", "color", "stroke"];
function DTe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, ATe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-volume-3",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M6 15h-2a1 1 0 0 1 -1 -1v-4a1 1 0 0 1 1 -1h2l3.5 -4.5a0.8 .8 0 0 1 1.5 .5v14a0.8 .8 0 0 1 -1.5 .5l-3.5 -4.5"
  }), e.createElement("path", {
    d: "M16 10l4 4m0 -4l-4 4"
  }));
}
var FTe = ["size", "color", "stroke"];
function GTe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, FTe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-volume-off",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M15 8a5 5 0 0 1 1.912 4.934m-1.377 2.602a5.001 5.001 0 0 1 -.535 .464"
  }), e.createElement("path", {
    d: "M17.7 5a9 9 0 0 1 2.362 11.086m-1.676 2.299a9.005 9.005 0 0 1 -.686 .615"
  }), e.createElement("path", {
    d: "M9.069 5.054l.431 -.554a0.8 .8 0 0 1 1.5 .5v2m0 4v8a0.8 .8 0 0 1 -1.5 .5l-3.5 -4.5h-2a1 1 0 0 1 -1 -1v-4a1 1 0 0 1 1 -1h2l1.294 -1.664"
  }), e.createElement("path", {
    d: "M3 3l18 18"
  }));
}
var JTe = ["size", "color", "stroke"];
function KTe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, JTe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-volume",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M15 8a5 5 0 0 1 0 8"
  }), e.createElement("path", {
    d: "M17.7 5a9 9 0 0 1 0 14"
  }), e.createElement("path", {
    d: "M6 15h-2a1 1 0 0 1 -1 -1v-4a1 1 0 0 1 1 -1h2l3.5 -4.5a0.8 .8 0 0 1 1.5 .5v14a0.8 .8 0 0 1 -1.5 .5l-3.5 -4.5"
  }));
}
var QTe = ["size", "color", "stroke"];
function RTe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, QTe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-walk",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("circle", {
    cx: 13,
    cy: 4,
    r: 1
  }), e.createElement("line", {
    x1: 7,
    y1: 21,
    x2: 10,
    y2: 17
  }), e.createElement("path", {
    d: "M16 21l-2 -4l-3 -3l1 -6"
  }), e.createElement("path", {
    d: "M6 12l2 -3l4 -1l3 3l3 1"
  }));
}
var TTe = ["size", "color", "stroke"];
function UTe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, TTe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-wall-off",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M8 4h10a2 2 0 0 1 2 2v10m-.589 3.417c-.361 .36 -.86 .583 -1.411 .583h-12a2 2 0 0 1 -2 -2v-12c0 -.55 .222 -1.047 .58 -1.409"
  }), e.createElement("path", {
    d: "M4 8h4m4 0h8"
  }), e.createElement("path", {
    d: "M20 12h-4m-4 0h-8"
  }), e.createElement("path", {
    d: "M4 16h12"
  }), e.createElement("path", {
    d: "M9 4v1"
  }), e.createElement("path", {
    d: "M14 8v2"
  }), e.createElement("path", {
    d: "M8 12v4"
  }), e.createElement("path", {
    d: "M11 16v4"
  }), e.createElement("path", {
    d: "M3 3l18 18"
  }));
}
var VTe = ["size", "color", "stroke"];
function XTe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, VTe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-wall",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("rect", {
    x: 4,
    y: 4,
    width: 16,
    height: 16,
    rx: 2
  }), e.createElement("path", {
    d: "M4 8h16"
  }), e.createElement("path", {
    d: "M20 12h-16"
  }), e.createElement("path", {
    d: "M4 16h16"
  }), e.createElement("path", {
    d: "M9 4v4"
  }), e.createElement("path", {
    d: "M14 8v4"
  }), e.createElement("path", {
    d: "M8 12v4"
  }), e.createElement("path", {
    d: "M16 12v4"
  }), e.createElement("path", {
    d: "M11 16v4"
  }));
}
var YTe = ["size", "color", "stroke"];
function ZTe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, YTe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-wallet-off",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M17 8v-3a1 1 0 0 0 -1 -1h-8m-3.413 .584a2 2 0 0 0 1.413 3.416h2m4 0h6a1 1 0 0 1 1 1v3"
  }), e.createElement("path", {
    d: "M19 19a1 1 0 0 1 -1 1h-12a2 2 0 0 1 -2 -2v-12"
  }), e.createElement("path", {
    d: "M16 12h4v4m-4 0a2 2 0 0 1 -2 -2"
  }), e.createElement("path", {
    d: "M3 3l18 18"
  }));
}
var $Te = ["size", "color", "stroke"];
function _Te(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, $Te);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-wallet",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M17 8v-3a1 1 0 0 0 -1 -1h-10a2 2 0 0 0 0 4h12a1 1 0 0 1 1 1v3m0 4v3a1 1 0 0 1 -1 1h-12a2 2 0 0 1 -2 -2v-12"
  }), e.createElement("path", {
    d: "M20 12v4h-4a2 2 0 0 1 0 -4h4"
  }));
}
var eUe = ["size", "color", "stroke"];
function tUe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, eUe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-wallpaper-off",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M10 6h8a2 2 0 0 1 2 2v8m-.58 3.409a1.994 1.994 0 0 1 -1.42 .591h-12"
  }), e.createElement("circle", {
    cx: 6,
    cy: 18,
    r: 2
  }), e.createElement("path", {
    d: "M8 18v-10m-3.427 -3.402c-.353 .362 -.573 .856 -.573 1.402v12"
  }), e.createElement("path", {
    d: "M3 3l18 18"
  }));
}
var oUe = ["size", "color", "stroke"];
function rUe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, oUe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-wallpaper",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M8 6h10a2 2 0 0 1 2 2v10a2 2 0 0 1 -2 2h-12"
  }), e.createElement("circle", {
    cx: 6,
    cy: 18,
    r: 2
  }), e.createElement("path", {
    d: "M8 18v-12a2 2 0 1 0 -4 0v12"
  }));
}
var nUe = ["size", "color", "stroke"];
function lUe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, nUe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-wand-off",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M10.5 10.5l-7.5 7.5l3 3l7.5 -7.5m2 -2l5.5 -5.5l-3 -3l-5.5 5.5"
  }), e.createElement("path", {
    d: "M15 6l3 3"
  }), e.createElement("path", {
    d: "M8.433 4.395c.35 -.36 .567 -.852 .567 -1.395a2 2 0 0 0 2 2c-.554 0 -1.055 .225 -1.417 .589"
  }), e.createElement("path", {
    d: "M18.418 14.41c.36 -.36 .582 -.86 .582 -1.41a2 2 0 0 0 2 2c-.555 0 -1.056 .226 -1.419 .59"
  }), e.createElement("path", {
    d: "M3 3l18 18"
  }));
}
var aUe = ["size", "color", "stroke"];
function iUe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, aUe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-wand",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("polyline", {
    points: "6 21 21 6 18 3 3 18 6 21"
  }), e.createElement("line", {
    x1: 15,
    y1: 6,
    x2: 18,
    y2: 9
  }), e.createElement("path", {
    d: "M9 3a2 2 0 0 0 2 2a2 2 0 0 0 -2 2a2 2 0 0 0 -2 -2a2 2 0 0 0 2 -2"
  }), e.createElement("path", {
    d: "M19 13a2 2 0 0 0 2 2a2 2 0 0 0 -2 2a2 2 0 0 0 -2 -2a2 2 0 0 0 2 -2"
  }));
}
var cUe = ["size", "color", "stroke"];
function sUe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, cUe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-wash-dry-1",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("rect", {
    x: 3,
    y: 3,
    width: 18,
    height: 18,
    rx: 3
  }), e.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 6
  }), e.createElement("path", {
    d: "M12 12h.01"
  }));
}
var hUe = ["size", "color", "stroke"];
function dUe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, hUe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-wash-dry-2",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("rect", {
    x: 3,
    y: 3,
    width: 18,
    height: 18,
    rx: 3
  }), e.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 6
  }), e.createElement("path", {
    d: "M10 12h.01"
  }), e.createElement("path", {
    d: "M14 12h.01"
  }));
}
var vUe = ["size", "color", "stroke"];
function mUe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, vUe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-wash-dry-3",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("rect", {
    x: 3,
    y: 3,
    width: 18,
    height: 18,
    rx: 3
  }), e.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 6
  }), e.createElement("path", {
    d: "M12 12h.01"
  }), e.createElement("path", {
    d: "M9 12h.01"
  }), e.createElement("path", {
    d: "M15 12h.01"
  }));
}
var kUe = ["size", "color", "stroke"];
function wUe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, kUe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-wash-dry-a",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 9
  }), e.createElement("path", {
    d: "M9 16v-4.8c0 -1.657 1.343 -3.2 3 -3.2s3 1.543 3 3.2v4.8"
  }), e.createElement("path", {
    d: "M15 13h-6"
  }));
}
var pUe = ["size", "color", "stroke"];
function EUe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, pUe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-wash-dry-dip",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("rect", {
    x: 3,
    y: 3,
    width: 18,
    height: 18,
    rx: 3
  }), e.createElement("path", {
    d: "M12 7v10"
  }), e.createElement("path", {
    d: "M16 7v10"
  }), e.createElement("path", {
    d: "M8 7v10"
  }));
}
var uUe = ["size", "color", "stroke"];
function gUe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, uUe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-wash-dry-f",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 9
  }), e.createElement("path", {
    d: "M10 16v-8h4"
  }), e.createElement("path", {
    d: "M13 12h-3"
  }));
}
var MUe = ["size", "color", "stroke"];
function xUe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, MUe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-wash-dry-hang",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("rect", {
    x: 3,
    y: 3,
    width: 18,
    height: 18,
    rx: 3
  }), e.createElement("path", {
    d: "M4 4.01c5.333 5.323 10.667 5.32 16 -.01"
  }));
}
var fUe = ["size", "color", "stroke"];
function zUe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, fUe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-wash-dry-off",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M20.116 20.127a2.99 2.99 0 0 1 -2.116 .873h-12a3 3 0 0 1 -3 -3v-12c0 -.827 .335 -1.576 .877 -2.12m3.123 -.88h11a3 3 0 0 1 3 3v11"
  }), e.createElement("path", {
    d: "M3 3l18 18"
  }));
}
var bUe = ["size", "color", "stroke"];
function LUe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, bUe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-wash-dry-p",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 9
  }), e.createElement("path", {
    d: "M10 16v-8h2.5a2.5 2.5 0 1 1 0 5h-2.5"
  }));
}
var yUe = ["size", "color", "stroke"];
function CUe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, yUe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-wash-dry-shade",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("rect", {
    x: 3,
    y: 3,
    width: 18,
    height: 18,
    rx: 3
  }), e.createElement("path", {
    d: "M3 11l8 -8"
  }), e.createElement("path", {
    d: "M3 17l14 -14"
  }));
}
var jUe = ["size", "color", "stroke"];
function BUe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, jUe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-wash-dry-w",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 9
  }), e.createElement("path", {
    d: "M8 8l1.5 8h1l1.5 -6l1.5 6h1l1.5 -8"
  }));
}
var HUe = ["size", "color", "stroke"];
function NUe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, HUe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-wash-dry",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("rect", {
    x: 3,
    y: 3,
    width: 18,
    height: 18,
    rx: 3
  }));
}
var WUe = ["size", "color", "stroke"];
function qUe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, WUe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-wash-dryclean-off",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M20.048 16.033a9 9 0 0 0 -12.094 -12.075m-2.321 1.682a9 9 0 0 0 12.733 12.723"
  }), e.createElement("path", {
    d: "M3 3l18 18"
  }));
}
var OUe = ["size", "color", "stroke"];
function PUe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, OUe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-wash-dryclean",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 9
  }));
}
var SUe = ["size", "color", "stroke"];
function IUe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, SUe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-wash-gentle",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M3.486 5.965c.168 .02 .34 .033 .514 .035c.79 .009 1.539 -.178 2 -.5c.461 -.32 1.21 -.507 2 -.5c.79 -.007 1.539 .18 2 .5c.461 .322 1.21 .509 2 .5c.79 .009 1.539 -.178 2 -.5c.461 -.32 1.21 -.507 2 -.5c.79 -.007 1.539 .18 2 .5c.461 .322 1.21 .509 2 .5c.17 -.002 .339 -.014 .503 -.034"
  }), e.createElement("path", {
    d: "M3 3l1.721 10.329a2 2 0 0 0 1.973 1.671h10.612a2 2 0 0 0 1.973 -1.671l1.721 -10.329"
  }), e.createElement("path", {
    d: "M5 18h14"
  }), e.createElement("path", {
    d: "M5 21h14"
  }));
}
var AUe = ["size", "color", "stroke"];
function DUe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, AUe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-wash-machine",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("rect", {
    x: 5,
    y: 3,
    width: 14,
    height: 18,
    rx: 2
  }), e.createElement("circle", {
    cx: 12,
    cy: 14,
    r: 4
  }), e.createElement("path", {
    d: "M8 6h.01"
  }), e.createElement("path", {
    d: "M11 6h.01"
  }), e.createElement("path", {
    d: "M14 6h2"
  }), e.createElement("path", {
    d: "M8 14c1.333 -.667 2.667 -.667 4 0c1.333 .667 2.667 .667 4 0"
  }));
}
var FUe = ["size", "color", "stroke"];
function GUe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, FUe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-wash-off",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M3 6l1.721 10.329a2 2 0 0 0 1.973 1.671h10.612c.208 0 .41 -.032 .6 -.092m1.521 -2.472l1.573 -9.436"
  }), e.createElement("path", {
    d: "M3.486 8.965c.168 .02 .34 .033 .514 .035c.79 .009 1.539 -.178 2 -.5c.461 -.32 1.21 -.507 2 -.5m4.92 .919c.428 -.083 .805 -.227 1.08 -.418c.461 -.322 1.21 -.508 2 -.5c.79 -.008 1.539 .178 2 .5c.461 .32 1.21 .508 2 .5c.17 -.003 .339 -.015 .503 -.035"
  }), e.createElement("path", {
    d: "M3 3l18 18"
  }));
}
var JUe = ["size", "color", "stroke"];
function KUe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, JUe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-wash-press",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M3.486 7.965c.168 .02 .34 .033 .514 .035c.79 .009 1.539 -.178 2 -.5c.461 -.32 1.21 -.507 2 -.5c.79 -.007 1.539 .18 2 .5c.461 .322 1.21 .509 2 .5c.79 .009 1.539 -.178 2 -.5c.461 -.32 1.21 -.507 2 -.5c.79 -.007 1.539 .18 2 .5c.461 .322 1.21 .509 2 .5c.17 -.002 .339 -.014 .503 -.034"
  }), e.createElement("path", {
    d: "M3 5l1.721 10.329a2 2 0 0 0 1.973 1.671h10.612a2 2 0 0 0 1.973 -1.671l1.721 -10.329"
  }), e.createElement("path", {
    d: "M5 20h14"
  }));
}
var QUe = ["size", "color", "stroke"];
function RUe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, QUe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-wash-temperature-1",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M3 6l1.721 10.329a2 2 0 0 0 1.973 1.671h10.612a2 2 0 0 0 1.973 -1.671l1.721 -10.329"
  }), e.createElement("path", {
    d: "M3.486 8.965c.168 .02 .34 .033 .514 .035c.79 .009 1.539 -.178 2 -.5c.461 -.32 1.21 -.507 2 -.5c.79 -.007 1.539 .18 2 .5c.461 .322 1.21 .509 2 .5c.79 .009 1.539 -.178 2 -.5c.461 -.32 1.21 -.507 2 -.5c.79 -.007 1.539 .18 2 .5c.461 .322 1.21 .509 2 .5c.17 -.002 .339 -.014 .503 -.034"
  }), e.createElement("path", {
    d: "M12 13h.01"
  }));
}
var TUe = ["size", "color", "stroke"];
function UUe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, TUe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-wash-temperature-2",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M3.486 8.965c.168 .02 .34 .033 .514 .035c.79 .009 1.539 -.178 2 -.5c.461 -.32 1.21 -.507 2 -.5c.79 -.007 1.539 .18 2 .5c.461 .322 1.21 .509 2 .5c.79 .009 1.539 -.178 2 -.5c.461 -.32 1.21 -.507 2 -.5c.79 -.007 1.539 .18 2 .5c.461 .322 1.21 .509 2 .5c.17 -.002 .339 -.014 .503 -.034"
  }), e.createElement("path", {
    d: "M3 6l1.721 10.329a2 2 0 0 0 1.973 1.671h10.612a2 2 0 0 0 1.973 -1.671l1.721 -10.329"
  }), e.createElement("path", {
    d: "M14 13h.01"
  }), e.createElement("path", {
    d: "M10 13h.01"
  }));
}
var VUe = ["size", "color", "stroke"];
function XUe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, VUe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-wash-temperature-3",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M3.486 8.965c.168 .02 .34 .033 .514 .035c.79 .009 1.539 -.178 2 -.5c.461 -.32 1.21 -.507 2 -.5c.79 -.007 1.539 .18 2 .5c.461 .322 1.21 .509 2 .5c.79 .009 1.539 -.178 2 -.5c.461 -.32 1.21 -.507 2 -.5c.79 -.007 1.539 .18 2 .5c.461 .322 1.21 .509 2 .5c.17 -.002 .339 -.014 .503 -.034"
  }), e.createElement("path", {
    d: "M3 6l1.721 10.329a2 2 0 0 0 1.973 1.671h10.612a2 2 0 0 0 1.973 -1.671l1.721 -10.329"
  }), e.createElement("path", {
    d: "M12 13h.01"
  }), e.createElement("path", {
    d: "M15 13h.01"
  }), e.createElement("path", {
    d: "M9 13h.01"
  }));
}
var YUe = ["size", "color", "stroke"];
function ZUe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, YUe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-wash-temperature-4",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M3.486 8.965c.168 .02 .34 .033 .514 .035c.79 .009 1.539 -.178 2 -.5c.461 -.32 1.21 -.507 2 -.5c.79 -.007 1.539 .18 2 .5c.461 .322 1.21 .509 2 .5c.79 .009 1.539 -.178 2 -.5c.461 -.32 1.21 -.507 2 -.5c.79 -.007 1.539 .18 2 .5c.461 .322 1.21 .509 2 .5c.17 -.002 .339 -.014 .503 -.034"
  }), e.createElement("path", {
    d: "M3 6l1.721 10.329a2 2 0 0 0 1.973 1.671h10.612a2 2 0 0 0 1.973 -1.671l1.721 -10.329"
  }), e.createElement("path", {
    d: "M10 15h.01"
  }), e.createElement("path", {
    d: "M14 15h.01"
  }), e.createElement("path", {
    d: "M14 12h.01"
  }), e.createElement("path", {
    d: "M10 12h.01"
  }));
}
var $Ue = ["size", "color", "stroke"];
function _Ue(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, $Ue);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-wash-temperature-5",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M10 15h.01"
  }), e.createElement("path", {
    d: "M3 6l1.721 10.329a2 2 0 0 0 1.973 1.671h10.612a2 2 0 0 0 1.973 -1.671l1.721 -10.329"
  }), e.createElement("path", {
    d: "M14 15h.01"
  }), e.createElement("path", {
    d: "M15 12h.01"
  }), e.createElement("path", {
    d: "M12 12h.01"
  }), e.createElement("path", {
    d: "M9 12h.01"
  }), e.createElement("path", {
    d: "M3.486 8.965c.168 .02 .34 .033 .514 .035c.79 .009 1.539 -.178 2 -.5c.461 -.32 1.21 -.507 2 -.5c.79 -.007 1.539 .18 2 .5c.461 .322 1.21 .509 2 .5c.79 .009 1.539 -.178 2 -.5c.461 -.32 1.21 -.507 2 -.5c.79 -.007 1.539 .18 2 .5c.461 .322 1.21 .509 2 .5c.17 -.002 .339 -.014 .503 -.034"
  }));
}
var eVe = ["size", "color", "stroke"];
function tVe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, eVe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-wash-temperature-6",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M9 15h.01"
  }), e.createElement("path", {
    d: "M3 6l1.721 10.329a2 2 0 0 0 1.973 1.671h10.612a2 2 0 0 0 1.973 -1.671l1.721 -10.329"
  }), e.createElement("path", {
    d: "M12 15h.01"
  }), e.createElement("path", {
    d: "M15 15h.01"
  }), e.createElement("path", {
    d: "M15 12h.01"
  }), e.createElement("path", {
    d: "M12 12h.01"
  }), e.createElement("path", {
    d: "M9 12h.01"
  }), e.createElement("path", {
    d: "M3.486 8.965c.168 .02 .34 .033 .514 .035c.79 .009 1.539 -.178 2 -.5c.461 -.32 1.21 -.507 2 -.5c.79 -.007 1.539 .18 2 .5c.461 .322 1.21 .509 2 .5c.79 .009 1.539 -.178 2 -.5c.461 -.32 1.21 -.507 2 -.5c.79 -.007 1.539 .18 2 .5c.461 .322 1.21 .509 2 .5c.17 -.002 .339 -.014 .503 -.034"
  }));
}
var oVe = ["size", "color", "stroke"];
function rVe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, oVe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-wash-tumble-dry",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("rect", {
    x: 3,
    y: 3,
    width: 18,
    height: 18,
    rx: 3
  }), e.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 6
  }));
}
var nVe = ["size", "color", "stroke"];
function lVe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, nVe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-wash-tumble-off",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M20.116 20.127a2.99 2.99 0 0 1 -2.116 .873h-12a3 3 0 0 1 -3 -3v-12c0 -.827 .335 -1.576 .877 -2.12m3.123 -.88h11a3 3 0 0 1 3 3v11"
  }), e.createElement("path", {
    d: "M17.744 13.74a6 6 0 0 0 -7.486 -7.482m-2.499 1.497a6 6 0 1 0 8.48 8.49"
  }), e.createElement("path", {
    d: "M3 3l18 18"
  }));
}
var aVe = ["size", "color", "stroke"];
function iVe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, aVe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-wash",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M3.486 8.965c.168 .02 .34 .033 .514 .035c.79 .009 1.539 -.178 2 -.5c.461 -.32 1.21 -.507 2 -.5c.79 -.007 1.539 .18 2 .5c.461 .322 1.21 .509 2 .5c.79 .009 1.539 -.178 2 -.5c.461 -.32 1.21 -.507 2 -.5c.79 -.007 1.539 .18 2 .5c.461 .322 1.21 .509 2 .5c.17 -.002 .339 -.014 .503 -.034"
  }), e.createElement("path", {
    d: "M3 6l1.721 10.329a2 2 0 0 0 1.973 1.671h10.612a2 2 0 0 0 1.973 -1.671l1.721 -10.329"
  }));
}
var cVe = ["size", "color", "stroke"];
function sVe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, cVe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-wave-saw-tool",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M3 12h5l4 8v-16l4 8h5"
  }));
}
var hVe = ["size", "color", "stroke"];
function dVe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, hVe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-wave-sine",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M21 12h-2c-.894 0 -1.662 -.857 -1.761 -2c-.296 -3.45 -.749 -6 -2.749 -6s-2.5 3.582 -2.5 8s-.5 8 -2.5 8s-2.452 -2.547 -2.749 -6c-.1 -1.147 -.867 -2 -1.763 -2h-2"
  }));
}
var vVe = ["size", "color", "stroke"];
function mVe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, vVe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-wave-square",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M3 12h5v8h4v-16h4v8h5"
  }));
}
var kVe = ["size", "color", "stroke"];
function wVe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, kVe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-webhook-off",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M4.876 13.61a4 4 0 1 0 6.124 3.39h6"
  }), e.createElement("path", {
    d: "M15.066 20.502a4 4 0 0 0 4.763 -.675m1.171 -2.827a4 4 0 0 0 -4 -4"
  }), e.createElement("path", {
    d: "M16 8a4 4 0 0 0 -6.824 -2.833m-1.176 2.833c0 1.506 .77 2.818 2 3.5l-3 5.5"
  }), e.createElement("path", {
    d: "M3 3l18 18"
  }));
}
var pVe = ["size", "color", "stroke"];
function EVe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, pVe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-webhook",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M4.876 13.61a4 4 0 1 0 6.124 3.39h6"
  }), e.createElement("path", {
    d: "M15.066 20.502a4 4 0 1 0 1.934 -7.502c-.706 0 -1.424 .179 -2 .5l-3 -5.5"
  }), e.createElement("path", {
    d: "M16 8a4 4 0 1 0 -8 0c0 1.506 .77 2.818 2 3.5l-3 5.5"
  }));
}
var uVe = ["size", "color", "stroke"];
function gVe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, uVe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-weight",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("circle", {
    cx: 12,
    cy: 6,
    r: 3
  }), e.createElement("path", {
    d: "M6.835 9h10.33a1 1 0 0 1 .984 .821l1.637 9a1 1 0 0 1 -.984 1.179h-13.604a1 1 0 0 1 -.984 -1.179l1.637 -9a1 1 0 0 1 .984 -.821z"
  }));
}
var MVe = ["size", "color", "stroke"];
function xVe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, MVe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-wheelchair-off",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("circle", {
    cx: 8,
    cy: 16,
    r: 5
  }), e.createElement("path", {
    d: "M17.582 17.59a2 2 0 0 0 2.833 2.824"
  }), e.createElement("path", {
    d: "M14 14h-1.4"
  }), e.createElement("path", {
    d: "M6 6v5"
  }), e.createElement("path", {
    d: "M6 8h2m4 0h5"
  }), e.createElement("path", {
    d: "M15 8v3"
  }), e.createElement("path", {
    d: "M3 3l18 18"
  }));
}
var fVe = ["size", "color", "stroke"];
function zVe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, fVe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-wheelchair",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("circle", {
    cx: 8,
    cy: 16,
    r: 5
  }), e.createElement("circle", {
    cx: 19,
    cy: 19,
    r: 2
  }), e.createElement("path", {
    d: "M19 17a3 3 0 0 0 -3 -3h-3.4"
  }), e.createElement("path", {
    d: "M3 3h1a2 2 0 0 1 2 2v6"
  }), e.createElement("path", {
    d: "M6 8h11"
  }), e.createElement("path", {
    d: "M15 8v6"
  }));
}
var bVe = ["size", "color", "stroke"];
function LVe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, bVe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-whirl",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M14 12a2 2 0 1 0 -4 0a2 2 0 0 0 4 0z"
  }), e.createElement("path", {
    d: "M12 21c-3.314 0 -6 -2.462 -6 -5.5s2.686 -5.5 6 -5.5"
  }), e.createElement("path", {
    d: "M21 12c0 3.314 -2.462 6 -5.5 6s-5.5 -2.686 -5.5 -6"
  }), e.createElement("path", {
    d: "M12 14c3.314 0 6 -2.462 6 -5.5s-2.686 -5.5 -6 -5.5"
  }), e.createElement("path", {
    d: "M14 12c0 -3.314 -2.462 -6 -5.5 -6s-5.5 2.686 -5.5 6"
  }));
}
var yVe = ["size", "color", "stroke"];
function CVe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, yVe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-wifi-0",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("line", {
    x1: 12,
    y1: 18,
    x2: 12.01,
    y2: 18
  }));
}
var jVe = ["size", "color", "stroke"];
function BVe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, jVe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-wifi-1",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("line", {
    x1: 12,
    y1: 18,
    x2: 12.01,
    y2: 18
  }), e.createElement("path", {
    d: "M9.172 15.172a4 4 0 0 1 5.656 0"
  }));
}
var HVe = ["size", "color", "stroke"];
function NVe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, HVe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-wifi-2",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("line", {
    x1: 12,
    y1: 18,
    x2: 12.01,
    y2: 18
  }), e.createElement("path", {
    d: "M9.172 15.172a4 4 0 0 1 5.656 0"
  }), e.createElement("path", {
    d: "M6.343 12.343a8 8 0 0 1 11.314 0"
  }));
}
var WVe = ["size", "color", "stroke"];
function qVe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, WVe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-wifi-off",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("line", {
    x1: 12,
    y1: 18,
    x2: 12.01,
    y2: 18
  }), e.createElement("path", {
    d: "M9.172 15.172a4 4 0 0 1 5.656 0"
  }), e.createElement("path", {
    d: "M6.343 12.343a7.963 7.963 0 0 1 3.864 -2.14m4.163 .155a7.965 7.965 0 0 1 3.287 2"
  }), e.createElement("path", {
    d: "M3.515 9.515a12 12 0 0 1 3.544 -2.455m3.101 -.92a12 12 0 0 1 10.325 3.374"
  }), e.createElement("line", {
    x1: 3,
    y1: 3,
    x2: 21,
    y2: 21
  }));
}
var OVe = ["size", "color", "stroke"];
function PVe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, OVe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-wifi",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("line", {
    x1: 12,
    y1: 18,
    x2: 12.01,
    y2: 18
  }), e.createElement("path", {
    d: "M9.172 15.172a4 4 0 0 1 5.656 0"
  }), e.createElement("path", {
    d: "M6.343 12.343a8 8 0 0 1 11.314 0"
  }), e.createElement("path", {
    d: "M3.515 9.515c4.686 -4.687 12.284 -4.687 17 0"
  }));
}
var SVe = ["size", "color", "stroke"];
function IVe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, SVe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-wind-off",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M5 8h3m4 0h1.5a2.5 2.5 0 1 0 -2.34 -3.24"
  }), e.createElement("path", {
    d: "M3 12h9"
  }), e.createElement("path", {
    d: "M16 12h2.5a2.5 2.5 0 0 1 1.801 4.282"
  }), e.createElement("path", {
    d: "M4 16h5.5a2.5 2.5 0 1 1 -2.34 3.24"
  }), e.createElement("path", {
    d: "M3 3l18 18"
  }));
}
var AVe = ["size", "color", "stroke"];
function DVe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, AVe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-wind",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M5 8h8.5a2.5 2.5 0 1 0 -2.34 -3.24"
  }), e.createElement("path", {
    d: "M3 12h15.5a2.5 2.5 0 1 1 -2.34 3.24"
  }), e.createElement("path", {
    d: "M4 16h5.5a2.5 2.5 0 1 1 -2.34 3.24"
  }));
}
var FVe = ["size", "color", "stroke"];
function GVe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, FVe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-windmill-off",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M15.061 11.06c1.18 -.824 1.939 -2.11 1.939 -3.56c0 -2.49 -2.24 -4.5 -5 -4.5v5"
  }), e.createElement("path", {
    d: "M12 12c0 2.76 2.01 5 4.5 5c.166 0 .33 -.01 .49 -.03m2.624 -1.36c.856 -.91 1.386 -2.19 1.386 -3.61h-5"
  }), e.createElement("path", {
    d: "M12 12c-2.76 0 -5 2.01 -5 4.5s2.24 4.5 5 4.5v-9z"
  }), e.createElement("path", {
    d: "M6.981 7.033c-2.244 .285 -3.981 2.402 -3.981 4.967h9"
  }), e.createElement("path", {
    d: "M3 3l18 18"
  }));
}
var JVe = ["size", "color", "stroke"];
function KVe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, JVe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-windmill",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M12 12c2.76 0 5 -2.01 5 -4.5s-2.24 -4.5 -5 -4.5v9z"
  }), e.createElement("path", {
    d: "M12 12c0 2.76 2.01 5 4.5 5s4.5 -2.24 4.5 -5h-9z"
  }), e.createElement("path", {
    d: "M12 12c-2.76 0 -5 2.01 -5 4.5s2.24 4.5 5 4.5v-9z"
  }), e.createElement("path", {
    d: "M12 12c0 -2.76 -2.01 -5 -4.5 -5s-4.5 2.24 -4.5 5h9z"
  }));
}
var QVe = ["size", "color", "stroke"];
function RVe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, QVe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-window-maximize",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("rect", {
    x: 3,
    y: 16,
    width: 5,
    height: 5,
    rx: 1
  }), e.createElement("path", {
    d: "M4 12v-6a2 2 0 0 1 2 -2h12a2 2 0 0 1 2 2v12a2 2 0 0 1 -2 2h-6"
  }), e.createElement("path", {
    d: "M12 8h4v4"
  }), e.createElement("path", {
    d: "M16 8l-5 5"
  }));
}
var TVe = ["size", "color", "stroke"];
function UVe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, TVe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-window-minimize",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("rect", {
    x: 3,
    y: 16,
    width: 5,
    height: 5,
    rx: 1
  }), e.createElement("path", {
    d: "M4 12v-6a2 2 0 0 1 2 -2h12a2 2 0 0 1 2 2v12a2 2 0 0 1 -2 2h-6"
  }), e.createElement("path", {
    d: "M15 13h-4v-4"
  }), e.createElement("path", {
    d: "M11 13l5 -5"
  }));
}
var VVe = ["size", "color", "stroke"];
function XVe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, VVe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-window-off",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M6.166 6.19a6.903 6.903 0 0 0 -1.166 3.81v10a1 1 0 0 0 1 1h12a1 1 0 0 0 1 -1v-1m0 -4v-5c0 -3.728 -3.134 -7 -7 -7a6.86 6.86 0 0 0 -3.804 1.158"
  }), e.createElement("path", {
    d: "M5 13h8m4 0h2"
  }), e.createElement("path", {
    d: "M12 3v5m0 4v9"
  }), e.createElement("path", {
    d: "M3 3l18 18"
  }));
}
var YVe = ["size", "color", "stroke"];
function ZVe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, YVe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-window",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M12 3c-3.866 0 -7 3.272 -7 7v10a1 1 0 0 0 1 1h12a1 1 0 0 0 1 -1v-10c0 -3.728 -3.134 -7 -7 -7z"
  }), e.createElement("line", {
    x1: 5,
    y1: 13,
    x2: 19,
    y2: 13
  }), e.createElement("line", {
    x1: 12,
    y1: 3,
    x2: 12,
    y2: 21
  }));
}
var $Ve = ["size", "color", "stroke"];
function _Ve(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, $Ve);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-windsock",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M6 3v18"
  }), e.createElement("path", {
    d: "M6 11l12 -1v-4l-12 -1"
  }), e.createElement("path", {
    d: "M10 5.5v5"
  }), e.createElement("path", {
    d: "M14 6v4"
  }), e.createElement("path", {
    d: "M4 21h4"
  }));
}
var eXe = ["size", "color", "stroke"];
function tXe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, eXe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-wiper-wash",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("circle", {
    cx: 12,
    cy: 20,
    r: 1
  }), e.createElement("path", {
    d: "M3 11l5.5 5.5a5 5 0 0 1 7 0l5.5 -5.5a12 12 0 0 0 -18 0"
  }), e.createElement("line", {
    x1: 12,
    y1: 20,
    x2: 12,
    y2: 6
  }), e.createElement("path", {
    d: "M4 6a4 4 0 0 1 .4 -1.8"
  }), e.createElement("path", {
    d: "M7 2.1a4 4 0 0 1 2 0"
  }), e.createElement("path", {
    d: "M12 6a4 4 0 0 0 -.4 -1.8"
  }), e.createElement("path", {
    d: "M12 6a4 4 0 0 1 .4 -1.8"
  }), e.createElement("path", {
    d: "M15 2.1a4 4 0 0 1 2 0"
  }), e.createElement("path", {
    d: "M20 6a4 4 0 0 0 -.4 -1.8"
  }));
}
var oXe = ["size", "color", "stroke"];
function rXe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, oXe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-wiper",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("circle", {
    cx: 12,
    cy: 18,
    r: 1
  }), e.createElement("path", {
    d: "M3 9l5.5 5.5a5 5 0 0 1 7 0l5.5 -5.5a12 12 0 0 0 -18 0"
  }), e.createElement("line", {
    x1: 12,
    y1: 18,
    x2: 9.8,
    y2: 5.2
  }));
}
var nXe = ["size", "color", "stroke"];
function lXe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, nXe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-woman",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M10 16v5"
  }), e.createElement("path", {
    d: "M14 16v5"
  }), e.createElement("path", {
    d: "M8 16h8l-2 -7h-4z"
  }), e.createElement("path", {
    d: "M5 11c1.667 -1.333 3.333 -2 5 -2"
  }), e.createElement("path", {
    d: "M19 11c-1.667 -1.333 -3.333 -2 -5 -2"
  }), e.createElement("circle", {
    cx: 12,
    cy: 4,
    r: 2
  }));
}
var aXe = ["size", "color", "stroke"];
function iXe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, aXe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-wood",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("ellipse", {
    cx: 12,
    cy: 5.5,
    rx: 6,
    ry: 2.5
  }), e.createElement("path", {
    d: "M18 5.5v4.626a1.415 1.415 0 0 1 1.683 2.18l-.097 .108l-1.586 1.586v4c0 1.61 -2.54 2.925 -5.725 2.997l-.275 .003c-3.314 0 -6 -1.343 -6 -3v-2l-1.586 -1.586a1.414 1.414 0 0 1 1.586 -2.287v-6.627"
  }), e.createElement("path", {
    d: "M10 12.5v1.5"
  }), e.createElement("path", {
    d: "M14 16v1"
  }));
}
var cXe = ["size", "color", "stroke"];
function sXe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, cXe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-world-download",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M21 12a9 9 0 1 0 -9 9"
  }), e.createElement("path", {
    d: "M3.6 9h16.8"
  }), e.createElement("path", {
    d: "M3.6 15h8.4"
  }), e.createElement("path", {
    d: "M11.578 3a17 17 0 0 0 0 18"
  }), e.createElement("path", {
    d: "M12.5 3c1.719 2.755 2.5 5.876 2.5 9"
  }), e.createElement("path", {
    d: "M18 14v7m-3 -3l3 3l3 -3"
  }));
}
var hXe = ["size", "color", "stroke"];
function dXe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, hXe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-world-latitude",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 9
  }), e.createElement("line", {
    x1: 4.6,
    y1: 7,
    x2: 19.4,
    y2: 7
  }), e.createElement("line", {
    x1: 3,
    y1: 12,
    x2: 21,
    y2: 12
  }), e.createElement("line", {
    x1: 4.6,
    y1: 17,
    x2: 19.4,
    y2: 17
  }));
}
var vXe = ["size", "color", "stroke"];
function mXe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, vXe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-world-longitude",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 9
  }), e.createElement("path", {
    d: "M11.5 3a11.2 11.2 0 0 0 0 18"
  }), e.createElement("path", {
    d: "M12.5 3a11.2 11.2 0 0 1 0 18"
  }), e.createElement("line", {
    x1: 12,
    y1: 3,
    x2: 12,
    y2: 21
  }));
}
var kXe = ["size", "color", "stroke"];
function wXe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, kXe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-world-off",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M3.6 9h5.4m4 0h7.4"
  }), e.createElement("path", {
    d: "M5.65 5.623a9 9 0 1 0 12.71 12.745m1.684 -2.328a9 9 0 0 0 -12.094 -12.08"
  }), e.createElement("path", {
    d: "M3.6 15h11.4m4 0h1.4"
  }), e.createElement("path", {
    d: "M8.335 8.388a18.998 18.998 0 0 0 -.335 3.612c0 4.97 1.79 9 4 9c1.622 0 3.018 -2.172 3.646 -5.294m.354 -3.706c0 -4.97 -1.79 -9 -4 -9c-1.035 0 -1.979 .885 -2.689 2.337"
  }), e.createElement("path", {
    d: "M3 3l18 18"
  }));
}
var pXe = ["size", "color", "stroke"];
function EXe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, pXe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-world-upload",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M21 12a9 9 0 1 0 -9 9"
  }), e.createElement("path", {
    d: "M3.6 9h16.8"
  }), e.createElement("path", {
    d: "M3.6 15h8.4"
  }), e.createElement("path", {
    d: "M11.578 3a17 17 0 0 0 0 18"
  }), e.createElement("path", {
    d: "M12.5 3c1.719 2.755 2.5 5.876 2.5 9"
  }), e.createElement("path", {
    d: "M18 21v-7m3 3l-3 -3l-3 3"
  }));
}
var uXe = ["size", "color", "stroke"];
function gXe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, uXe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-world-www",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M19.5 7a8.998 8.998 0 0 0 -7.5 -4a8.991 8.991 0 0 0 -7.484 4"
  }), e.createElement("path", {
    d: "M11.5 3a16.989 16.989 0 0 0 -1.826 4"
  }), e.createElement("path", {
    d: "M12.5 3a16.989 16.989 0 0 1 1.828 4.004"
  }), e.createElement("path", {
    d: "M19.5 17a8.998 8.998 0 0 1 -7.5 4a8.991 8.991 0 0 1 -7.484 -4"
  }), e.createElement("path", {
    d: "M11.5 21a16.989 16.989 0 0 1 -1.826 -4"
  }), e.createElement("path", {
    d: "M12.5 21a16.989 16.989 0 0 0 1.828 -4.004"
  }), e.createElement("path", {
    d: "M2 10l1 4l1.5 -4l1.5 4l1 -4"
  }), e.createElement("path", {
    d: "M17 10l1 4l1.5 -4l1.5 4l1 -4"
  }), e.createElement("path", {
    d: "M9.5 10l1 4l1.5 -4l1.5 4l1 -4"
  }));
}
var MXe = ["size", "color", "stroke"];
function xXe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, MXe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-world",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 9
  }), e.createElement("line", {
    x1: 3.6,
    y1: 9,
    x2: 20.4,
    y2: 9
  }), e.createElement("line", {
    x1: 3.6,
    y1: 15,
    x2: 20.4,
    y2: 15
  }), e.createElement("path", {
    d: "M11.5 3a17 17 0 0 0 0 18"
  }), e.createElement("path", {
    d: "M12.5 3a17 17 0 0 1 0 18"
  }));
}
var fXe = ["size", "color", "stroke"];
function zXe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, fXe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-wrecking-ball",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("circle", {
    cx: 19,
    cy: 13,
    r: 2
  }), e.createElement("circle", {
    cx: 4,
    cy: 17,
    r: 2
  }), e.createElement("circle", {
    cx: 13,
    cy: 17,
    r: 2
  }), e.createElement("line", {
    x1: 13,
    y1: 19,
    x2: 4,
    y2: 19
  }), e.createElement("line", {
    x1: 4,
    y1: 15,
    x2: 13,
    y2: 15
  }), e.createElement("path", {
    d: "M8 12v-5h2a3 3 0 0 1 3 3v5"
  }), e.createElement("path", {
    d: "M5 15v-2a1 1 0 0 1 1 -1h7"
  }), e.createElement("path", {
    d: "M19 11v-7l-6 7"
  }));
}
var bXe = ["size", "color", "stroke"];
function LXe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, bXe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-writing-off",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M16 7h4"
  }), e.createElement("path", {
    d: "M16 16v1l2 2l.5 -.5m1.5 -2.5v-11c0 -1.121 -.879 -2 -2 -2s-2 .879 -2 2v7"
  }), e.createElement("path", {
    d: "M18 19h-13a2 2 0 1 1 0 -4h4a2 2 0 1 0 0 -4h-3"
  }), e.createElement("path", {
    d: "M3 3l18 18"
  }));
}
var yXe = ["size", "color", "stroke"];
function CXe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, yXe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-writing-sign-off",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M3 19c3.333 -2 5 -4 5 -6c0 -3 -1 -3 -2 -3s-2.032 1.085 -2 3c.034 2.048 1.658 2.877 2.5 4c1.5 2 2.5 2.5 3.5 1c.667 -1 1.167 -1.833 1.5 -2.5c1 2.333 2.333 3.5 4 3.5h2.5"
  }), e.createElement("path", {
    d: "M16 16v1l2 2l.5 -.5m1.5 -2.5v-11c0 -1.121 -.879 -2 -2 -2s-2 .879 -2 2v7"
  }), e.createElement("path", {
    d: "M16 7h4"
  }), e.createElement("path", {
    d: "M3 3l18 18"
  }));
}
var jXe = ["size", "color", "stroke"];
function BXe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, jXe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-writing-sign",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M3 19c3.333 -2 5 -4 5 -6c0 -3 -1 -3 -2 -3s-2.032 1.085 -2 3c.034 2.048 1.658 2.877 2.5 4c1.5 2 2.5 2.5 3.5 1c.667 -1 1.167 -1.833 1.5 -2.5c1 2.333 2.333 3.5 4 3.5h2.5"
  }), e.createElement("path", {
    d: "M20 17v-12c0 -1.121 -.879 -2 -2 -2s-2 .879 -2 2v12l2 2l2 -2z"
  }), e.createElement("path", {
    d: "M16 7h4"
  }));
}
var HXe = ["size", "color", "stroke"];
function NXe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, HXe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-writing",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M20 17v-12c0 -1.121 -.879 -2 -2 -2s-2 .879 -2 2v12l2 2l2 -2z"
  }), e.createElement("path", {
    d: "M16 7h4"
  }), e.createElement("path", {
    d: "M18 19h-13a2 2 0 1 1 0 -4h4a2 2 0 1 0 0 -4h-3"
  }));
}
var WXe = ["size", "color", "stroke"];
function qXe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, WXe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-x",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("line", {
    x1: 18,
    y1: 6,
    x2: 6,
    y2: 18
  }), e.createElement("line", {
    x1: 6,
    y1: 6,
    x2: 18,
    y2: 18
  }));
}
var OXe = ["size", "color", "stroke"];
function PXe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, OXe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-xbox-a",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M12 21a9 9 0 0 0 9 -9a9 9 0 0 0 -9 -9a9 9 0 0 0 -9 9a9 9 0 0 0 9 9z"
  }), e.createElement("path", {
    d: "M15 16l-3 -8l-3 8"
  }), e.createElement("path", {
    d: "M14 14h-4"
  }));
}
var SXe = ["size", "color", "stroke"];
function IXe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, SXe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-xbox-b",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M12 21a9 9 0 0 0 9 -9a9 9 0 0 0 -9 -9a9 9 0 0 0 -9 9a9 9 0 0 0 9 9z"
  }), e.createElement("path", {
    d: "M13 12a2 2 0 1 1 0 4h-3v-4"
  }), e.createElement("path", {
    d: "M13 12h-3"
  }), e.createElement("path", {
    d: "M13 12a2 2 0 1 0 0 -4h-3v4"
  }));
}
var AXe = ["size", "color", "stroke"];
function DXe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, AXe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-xbox-x",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M12 21a9 9 0 0 0 9 -9a9 9 0 0 0 -9 -9a9 9 0 0 0 -9 9a9 9 0 0 0 9 9z"
  }), e.createElement("path", {
    d: "M9 8l6 8"
  }), e.createElement("path", {
    d: "M15 8l-6 8"
  }));
}
var FXe = ["size", "color", "stroke"];
function GXe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, FXe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-xbox-y",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M12 21a9 9 0 0 0 9 -9a9 9 0 0 0 -9 -9a9 9 0 0 0 -9 9a9 9 0 0 0 9 9z"
  }), e.createElement("path", {
    d: "M9 8l3 4"
  }), e.createElement("path", {
    d: "M15 8l-2.988 3.984l-.012 4.016"
  }));
}
var JXe = ["size", "color", "stroke"];
function KXe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, JXe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-yin-yang",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 9
  }), e.createElement("path", {
    d: "M12 3a4.5 4.5 0 0 0 0 9a4.5 4.5 0 0 1 0 9"
  }), e.createElement("circle", {
    cx: 12,
    cy: 7.5,
    r: .5,
    fill: "currentColor"
  }), e.createElement("circle", {
    cx: 12,
    cy: 16.5,
    r: .5,
    fill: "currentColor"
  }));
}
var QXe = ["size", "color", "stroke"];
function RXe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, QXe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-yoga",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("circle", {
    cx: 12,
    cy: 4,
    r: 1
  }), e.createElement("path", {
    d: "M4 20h4l1.5 -3"
  }), e.createElement("path", {
    d: "M17 20l-1 -5h-5l1 -7"
  }), e.createElement("path", {
    d: "M4 10l4 -1l4 -1l4 1.5l4 1.5"
  }));
}
var TXe = ["size", "color", "stroke"];
function UXe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, TXe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-zeppelin-off",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M15.773 15.783c-.723 .141 -1.486 .217 -2.273 .217c-2.13 0 -4.584 -.926 -7.364 -2.777l-2.136 1.777v-3.33a46.07 46.07 0 0 1 -2 -1.67a46.07 46.07 0 0 1 2 -1.67v-3.33l2.135 1.778c.13 -.087 .261 -.172 .39 -.256m2.564 -1.42c1.601 -.735 3.071 -1.102 4.411 -1.102c4.694 0 8.5 2.686 8.5 6c0 1.919 -1.276 3.627 -3.261 4.725"
  }), e.createElement("path", {
    d: "M10 15.5v4.5h6v-4"
  }), e.createElement("path", {
    d: "M3 3l18 18"
  }));
}
var VXe = ["size", "color", "stroke"];
function XXe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, VXe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-zeppelin",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M13.5 4c4.694 0 8.5 2.686 8.5 6s-3.806 6 -8.5 6c-2.13 0 -4.584 -.926 -7.364 -2.777l-2.136 1.777v-3.33a46.07 46.07 0 0 1 -2 -1.67a46.07 46.07 0 0 1 2 -1.67v-3.33l2.135 1.778c2.78 -1.852 5.235 -2.778 7.365 -2.778z"
  }), e.createElement("path", {
    d: "M10 15.5v4.5h6v-4"
  }));
}
var YXe = ["size", "color", "stroke"];
function ZXe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, YXe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-zip",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M16 16v-8h2a2 2 0 1 1 0 4h-2"
  }), e.createElement("path", {
    d: "M12 8v8"
  }), e.createElement("path", {
    d: "M4 8h4l-4 8h4"
  }));
}
var $Xe = ["size", "color", "stroke"];
function _Xe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, $Xe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-zodiac-aquarius",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M3 10l3 -3l3 3l3 -3l3 3l3 -3l3 3"
  }), e.createElement("path", {
    d: "M3 17l3 -3l3 3l3 -3l3 3l3 -3l3 3"
  }));
}
var eYe = ["size", "color", "stroke"];
function tYe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, eYe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-zodiac-aries",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M12 5a5 5 0 1 0 -4 8"
  }), e.createElement("path", {
    d: "M16 13a5 5 0 1 0 -4 -8"
  }), e.createElement("line", {
    x1: 12,
    y1: 21,
    x2: 12,
    y2: 5
  }));
}
var oYe = ["size", "color", "stroke"];
function rYe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, oYe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-zodiac-cancer",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("circle", {
    cx: 6,
    cy: 12,
    r: 3
  }), e.createElement("circle", {
    cx: 18,
    cy: 12,
    r: 3
  }), e.createElement("path", {
    d: "M3 12a10 6.5 0 0 1 14 -6.5"
  }), e.createElement("path", {
    d: "M21 12a10 6.5 0 0 1 -14 6.5"
  }));
}
var nYe = ["size", "color", "stroke"];
function lYe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, nYe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-zodiac-capricorn",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M4 4a3 3 0 0 1 3 3v9"
  }), e.createElement("path", {
    d: "M7 7a3 3 0 0 1 6 0v11a3 3 0 0 1 -3 3"
  }), e.createElement("circle", {
    cx: 16,
    cy: 17,
    r: 3
  }));
}
var aYe = ["size", "color", "stroke"];
function iYe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, aYe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-zodiac-gemini",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M3 3a21 21 0 0 0 18 0"
  }), e.createElement("path", {
    d: "M3 21a21 21 0 0 1 18 0"
  }), e.createElement("line", {
    x1: 7,
    y1: 4.5,
    x2: 7,
    y2: 19.5
  }), e.createElement("line", {
    x1: 17,
    y1: 4.5,
    x2: 17,
    y2: 19.5
  }));
}
var cYe = ["size", "color", "stroke"];
function sYe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, cYe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-zodiac-leo",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M13 17a4 4 0 1 0 8 0"
  }), e.createElement("circle", {
    cx: 6,
    cy: 16,
    r: 3
  }), e.createElement("circle", {
    cx: 11,
    cy: 7,
    r: 4
  }), e.createElement("path", {
    d: "M7 7c0 3 2 5 2 9"
  }), e.createElement("path", {
    d: "M15 7c0 4 -2 6 -2 10"
  }));
}
var hYe = ["size", "color", "stroke"];
function dYe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, hYe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-zodiac-libra",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("line", {
    x1: 5,
    y1: 20,
    x2: 19,
    y2: 20
  }), e.createElement("path", {
    d: "M5 17h5v-.3a7 7 0 1 1 4 0v.3h5"
  }));
}
var vYe = ["size", "color", "stroke"];
function mYe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, vYe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-zodiac-pisces",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M5 3a21 21 0 0 1 0 18"
  }), e.createElement("path", {
    d: "M19 3a21 21 0 0 0 0 18"
  }), e.createElement("line", {
    x1: 5,
    y1: 12,
    x2: 19,
    y2: 12
  }));
}
var kYe = ["size", "color", "stroke"];
function wYe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, kYe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-zodiac-sagittarius",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("line", {
    x1: 4,
    y1: 20,
    x2: 20,
    y2: 4
  }), e.createElement("path", {
    d: "M13 4h7v7"
  }), e.createElement("line", {
    x1: 6.5,
    y1: 12.5,
    x2: 11.5,
    y2: 17.5
  }));
}
var pYe = ["size", "color", "stroke"];
function EYe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, pYe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-zodiac-scorpio",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M3 4a2 2 0 0 1 2 2v9"
  }), e.createElement("path", {
    d: "M5 6a2 2 0 0 1 4 0v9"
  }), e.createElement("path", {
    d: "M9 6a2 2 0 0 1 4 0v10a3 3 0 0 0 3 3h5l-3 -3m0 6l3 -3"
  }));
}
var uYe = ["size", "color", "stroke"];
function gYe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, uYe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-zodiac-taurus",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M6 3a6 6 0 0 0 12 0"
  }), e.createElement("circle", {
    cx: 12,
    cy: 15,
    r: 6
  }));
}
var MYe = ["size", "color", "stroke"];
function xYe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, MYe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-zodiac-virgo",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M3 4a2 2 0 0 1 2 2v9"
  }), e.createElement("path", {
    d: "M5 6a2 2 0 0 1 4 0v9"
  }), e.createElement("path", {
    d: "M9 6a2 2 0 0 1 4 0v10a7 5 0 0 0 7 5"
  }), e.createElement("path", {
    d: "M12 21a7 5 0 0 0 7 -5v-2a3 3 0 0 0 -6 0"
  }));
}
var fYe = ["size", "color", "stroke"];
function zYe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, fYe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-zoom-cancel",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 7
  }), e.createElement("line", {
    x1: 8,
    y1: 8,
    x2: 12,
    y2: 12
  }), e.createElement("line", {
    x1: 12,
    y1: 8,
    x2: 8,
    y2: 12
  }), e.createElement("line", {
    x1: 21,
    y1: 21,
    x2: 15,
    y2: 15
  }));
}
var bYe = ["size", "color", "stroke"];
function LYe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, bYe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-zoom-check",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 7
  }), e.createElement("path", {
    d: "M21 21l-6 -6"
  }), e.createElement("path", {
    d: "M7 10l2 2l4 -4"
  }));
}
var yYe = ["size", "color", "stroke"];
function CYe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, yYe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-zoom-code",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 7
  }), e.createElement("path", {
    d: "M21 21l-6 -6"
  }), e.createElement("path", {
    d: "M8 8l-2 2l2 2"
  }), e.createElement("path", {
    d: "M12 8l2 2l-2 2"
  }));
}
var jYe = ["size", "color", "stroke"];
function BYe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, jYe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-zoom-exclamation",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 7
  }), e.createElement("path", {
    d: "M21 21l-6 -6"
  }), e.createElement("path", {
    d: "M10 13v.01"
  }), e.createElement("path", {
    d: "M10 7v3"
  }));
}
var HYe = ["size", "color", "stroke"];
function NYe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, HYe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-zoom-in-area",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M15 13v4"
  }), e.createElement("path", {
    d: "M13 15h4"
  }), e.createElement("circle", {
    cx: 15,
    cy: 15,
    r: 5
  }), e.createElement("path", {
    d: "M22 22l-3 -3"
  }), e.createElement("path", {
    d: "M6 18h-1a2 2 0 0 1 -2 -2v-1"
  }), e.createElement("path", {
    d: "M3 11v-1"
  }), e.createElement("path", {
    d: "M3 6v-1a2 2 0 0 1 2 -2h1"
  }), e.createElement("path", {
    d: "M10 3h1"
  }), e.createElement("path", {
    d: "M15 3h1a2 2 0 0 1 2 2v1"
  }));
}
var WYe = ["size", "color", "stroke"];
function qYe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, WYe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-zoom-in",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 7
  }), e.createElement("line", {
    x1: 7,
    y1: 10,
    x2: 13,
    y2: 10
  }), e.createElement("line", {
    x1: 10,
    y1: 7,
    x2: 10,
    y2: 13
  }), e.createElement("line", {
    x1: 21,
    y1: 21,
    x2: 15,
    y2: 15
  }));
}
var OYe = ["size", "color", "stroke"];
function PYe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, OYe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-zoom-money",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 7
  }), e.createElement("path", {
    d: "M21 21l-6 -6"
  }), e.createElement("path", {
    d: "M12 7h-2.5a1.5 1.5 0 0 0 0 3h1a1.5 1.5 0 0 1 0 3h-2.5"
  }), e.createElement("path", {
    d: "M10 13v1m0 -8v1"
  }));
}
var SYe = ["size", "color", "stroke"];
function IYe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, SYe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-zoom-out-area",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M13 15h4"
  }), e.createElement("circle", {
    cx: 15,
    cy: 15,
    r: 5
  }), e.createElement("path", {
    d: "M22 22l-3 -3"
  }), e.createElement("path", {
    d: "M6 18h-1a2 2 0 0 1 -2 -2v-1"
  }), e.createElement("path", {
    d: "M3 11v-1"
  }), e.createElement("path", {
    d: "M3 6v-1a2 2 0 0 1 2 -2h1"
  }), e.createElement("path", {
    d: "M10 3h1"
  }), e.createElement("path", {
    d: "M15 3h1a2 2 0 0 1 2 2v1"
  }));
}
var AYe = ["size", "color", "stroke"];
function DYe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, AYe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-zoom-out",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 7
  }), e.createElement("line", {
    x1: 7,
    y1: 10,
    x2: 13,
    y2: 10
  }), e.createElement("line", {
    x1: 21,
    y1: 21,
    x2: 15,
    y2: 15
  }));
}
var FYe = ["size", "color", "stroke"];
function GYe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, FYe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-zoom-pan",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 3
  }), e.createElement("path", {
    d: "M17 17l-2.5 -2.5"
  }), e.createElement("path", {
    d: "M10 5l2 -2l2 2"
  }), e.createElement("path", {
    d: "M19 10l2 2l-2 2"
  }), e.createElement("path", {
    d: "M5 10l-2 2l2 2"
  }), e.createElement("path", {
    d: "M10 19l2 2l2 -2"
  }));
}
var JYe = ["size", "color", "stroke"];
function KYe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, JYe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-zoom-question",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 7
  }), e.createElement("path", {
    d: "M21 21l-6 -6"
  }), e.createElement("line", {
    x1: 10,
    y1: 13,
    x2: 10,
    y2: 13.01
  }), e.createElement("path", {
    d: "M10 10a1.5 1.5 0 1 0 -1.14 -2.474"
  }));
}
var QYe = ["size", "color", "stroke"];
function RYe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, QYe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-zoom-replace",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M21 21l-6 -6"
  }), e.createElement("path", {
    d: "M3.291 8.003a7 7 0 0 1 5.077 -4.806a7.021 7.021 0 0 1 8.242 4.403"
  }), e.createElement("path", {
    d: "M17 4v4h-4"
  }), e.createElement("path", {
    d: "M16.705 12.005a7 7 0 0 1 -5.074 4.798a7.021 7.021 0 0 1 -8.241 -4.403"
  }), e.createElement("path", {
    d: "M3 16v-4h4"
  }));
}
var TYe = ["size", "color", "stroke"];
function UYe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, TYe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-zoom-reset",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M21 21l-6 -6"
  }), e.createElement("path", {
    d: "M3.268 12.043a7.017 7.017 0 0 0 6.634 4.957a7.012 7.012 0 0 0 7.043 -6.131a7 7 0 0 0 -5.314 -7.672a7.021 7.021 0 0 0 -8.241 4.403"
  }), e.createElement("path", {
    d: "M3 4v4h4"
  }));
}
var VYe = ["size", "color", "stroke"];
function XYe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, VYe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-zzz-off",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M4 12h6l-6 8h6"
  }), e.createElement("path", {
    d: "M14 4h6l-5.146 6.862m1.146 1.138h4"
  }), e.createElement("path", {
    d: "M3 3l18 18"
  }));
}
var YYe = ["size", "color", "stroke"];
function ZYe(r) {
  var n = r.size,
    l = void 0 === n ? 24 : n,
    a = r.color,
    i = void 0 === a ? "currentColor" : a,
    c = r.stroke,
    s = void 0 === c ? 2 : c,
    h = o(r, YYe);
  return e.createElement("svg", t({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-zzz",
    width: l,
    height: l,
    viewBox: "0 0 24 24",
    strokeWidth: s,
    stroke: i,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, h), e.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), e.createElement("path", {
    d: "M4 12h6l-6 8h6"
  }), e.createElement("path", {
    d: "M14 4h6l-6 8h6"
  }));
}
export { n as Icon123, a as Icon24Hours, c as Icon2fa, v as Icon360, h as Icon360View, p as Icon3dCubeSphere, k as Icon3dCubeSphereOff, u as Icon3dRotate, b as IconAB, M as IconAB2, f as IconABOff, j as IconAbacus, y as IconAbacusOff, H as IconAbc, O as IconAccessPoint, W as IconAccessPointOff, A as IconAccessible, S as IconAccessibleOff, J as IconActivity, F as IconActivityHeartbeat, V as IconAd, Q as IconAd2, T as IconAdOff, $ as IconAddressBook, Y as IconAddressBookOff, ae as IconAdjustments, ee as IconAdjustmentsAlt, oe as IconAdjustmentsHorizontal, ne as IconAdjustmentsOff, ce as IconAerialLift, he as IconAffiliate, ve as IconAirBalloon, pe as IconAirConditioning, ke as IconAirConditioningDisabled, ye as IconAlarm, ue as IconAlarmMinus, Me as IconAlarmOff, fe as IconAlarmPlus, be as IconAlarmSnooze, He as IconAlbum, je as IconAlbumOff, We as IconAlertCircle, Oe as IconAlertOctagon, Se as IconAlertTriangle, Ae as IconAlien, Fe as IconAlignBoxBottomCenter, Je as IconAlignBoxBottomLeft, Qe as IconAlignBoxBottomRight, Te as IconAlignBoxLeftBottom, Ve as IconAlignBoxLeftMiddle, Ye as IconAlignBoxLeftTop, $e as IconAlignBoxRightBottom, et as IconAlignBoxRightMiddle, ot as IconAlignBoxRightTop, nt as IconAlignBoxTopCenter, at as IconAlignBoxTopLeft, ct as IconAlignBoxTopRight, ht as IconAlignCenter, vt as IconAlignJustified, kt as IconAlignLeft, pt as IconAlignRight, ut as IconAlpha, Mt as IconAlphabetCyrillic, ft as IconAlphabetGreek, bt as IconAlphabetLatin, yt as IconAmbulance, jt as IconAmpersand, Wt as IconAnalyze, Ht as IconAnalyzeOff, St as IconAnchor, Ot as IconAnchorOff, At as IconAngle, Ft as IconAnkh, oo as IconAntenna, Jt as IconAntennaBars1, Qt as IconAntennaBars2, Tt as IconAntennaBars3, Vt as IconAntennaBars4, Yt as IconAntennaBars5, $t as IconAntennaBarsOff, eo as IconAntennaOff, ao as IconAperture, no as IconApertureOff, wo as IconApi, ho as IconApiApp, co as IconApiAppOff, mo as IconApiOff, Eo as IconAppWindow, go as IconApple, zo as IconApps, xo as IconAppsOff, Co as IconArchive, Lo as IconArchiveOff, Po as IconArmchair, No as IconArmchair2, Bo as IconArmchair2Off, qo as IconArmchairOff, Io as IconArrowAutofitContent, Do as IconArrowAutofitDown, Go as IconArrowAutofitHeight, Ko as IconArrowAutofitLeft, Ro as IconArrowAutofitRight, Uo as IconArrowAutofitUp, Xo as IconArrowAutofitWidth, _o as IconArrowBack, Zo as IconArrowBackUp, tr as IconArrowBadgeDown, rr as IconArrowBadgeLeft, lr as IconArrowBadgeRight, ir as IconArrowBadgeUp, sr as IconArrowBarDown, dr as IconArrowBarLeft, mr as IconArrowBarRight, wr as IconArrowBarToDown, Er as IconArrowBarToLeft, gr as IconArrowBarToRight, xr as IconArrowBarToUp, zr as IconArrowBarUp, Cr as IconArrowBearLeft, Lr as IconArrowBearLeft2, Nr as IconArrowBearRight, Br as IconArrowBearRight2, Ir as IconArrowBigDown, qr as IconArrowBigDownLine, Pr as IconArrowBigDownLines, Kr as IconArrowBigLeft, Dr as IconArrowBigLeftLine, Gr as IconArrowBigLeftLines, Xr as IconArrowBigRight, Rr as IconArrowBigRightLine, Ur as IconArrowBigRightLines, Zr as IconArrowBigTop, _r as IconArrowBigUpLine, tn as IconArrowBigUpLines, rn as IconArrowBounce, ln as IconArrowCurveLeft, cn as IconArrowCurveRight, jn as IconArrowDown, hn as IconArrowDownBar, vn as IconArrowDownCircle, pn as IconArrowDownLeft, kn as IconArrowDownLeftCircle, un as IconArrowDownRhombus, fn as IconArrowDownRight, Mn as IconArrowDownRightCircle, bn as IconArrowDownSquare, yn as IconArrowDownTail, Hn as IconArrowFork, On as IconArrowForward, Wn as IconArrowForwardUp, Sn as IconArrowGuide, An as IconArrowIteration, $n as IconArrowLeft, Fn as IconArrowLeftBar, Jn as IconArrowLeftCircle, Qn as IconArrowLeftRhombus, Tn as IconArrowLeftRight, Vn as IconArrowLeftSquare, Yn as IconArrowLeftTail, ol as IconArrowLoopLeft, el as IconArrowLoopLeft2, al as IconArrowLoopRight, nl as IconArrowLoopRight2, kl as IconArrowMerge, cl as IconArrowMergeBoth, hl as IconArrowMergeLeft, vl as IconArrowMergeRight, pl as IconArrowMoveDown, ul as IconArrowMoveLeft, Ml as IconArrowMoveRight, fl as IconArrowMoveUp, bl as IconArrowNarrowDown, yl as IconArrowNarrowLeft, jl as IconArrowNarrowRight, Hl as IconArrowNarrowUp, Sl as IconArrowRampLeft, Wl as IconArrowRampLeft2, Ol as IconArrowRampLeft3, Jl as IconArrowRampRight, Al as IconArrowRampRight2, Fl as IconArrowRampRight3, ea as IconArrowRight, Ql as IconArrowRightBar, Tl as IconArrowRightCircle, Vl as IconArrowRightRhombus, Yl as IconArrowRightSquare, $l as IconArrowRightTail, oa as IconArrowRotaryFirstLeft, na as IconArrowRotaryFirstRight, aa as IconArrowRotaryLastLeft, ca as IconArrowRotaryLastRight, ha as IconArrowRotaryLeft, va as IconArrowRotaryRight, ka as IconArrowRotaryStraight, pa as IconArrowRoundaboutLeft, ua as IconArrowRoundaboutRight, Ma as IconArrowSharpTurnLeft, fa as IconArrowSharpTurnRight, Ja as IconArrowUp, ba as IconArrowUpBar, ya as IconArrowUpCircle, Ha as IconArrowUpLeft, ja as IconArrowUpLeftCircle, Wa as IconArrowUpRhombus, Sa as IconArrowUpRight, Oa as IconArrowUpRightCircle, Aa as IconArrowUpSquare, Fa as IconArrowUpTail, Qa as IconArrowWaveLeftDown, Ta as IconArrowWaveLeftUp, Va as IconArrowWaveRightDown, Ya as IconArrowWaveRightUp, $a as IconArrowZigZag, ei as IconArrowsCross, ci as IconArrowsDiagonal, oi as IconArrowsDiagonal2, ai as IconArrowsDiagonalMinimize, ni as IconArrowsDiagonalMinimize2, hi as IconArrowsDiff, vi as IconArrowsDoubleNeSw, ki as IconArrowsDoubleNwSe, pi as IconArrowsDoubleSeNw, ui as IconArrowsDoubleSwNe, fi as IconArrowsDown, Mi as IconArrowsDownUp, yi as IconArrowsExchange, bi as IconArrowsExchange2, ji as IconArrowsHorizontal, Wi as IconArrowsJoin, Hi as IconArrowsJoin2, Ai as IconArrowsLeft, Oi as IconArrowsLeftDown, Si as IconArrowsLeftRight, Fi as IconArrowsMaximize, Ji as IconArrowsMinimize, Vi as IconArrowsMove, Qi as IconArrowsMoveHorizontal, Ti as IconArrowsMoveVertical, Yi as IconArrowsRandom, oc as IconArrowsRight, $i as IconArrowsRightDown, ec as IconArrowsRightLeft, ac as IconArrowsShuffle, nc as IconArrowsShuffle2, cc as IconArrowsSort, vc as IconArrowsSplit, hc as IconArrowsSplit2, kc as IconArrowsTransferDown, pc as IconArrowsTransferUp, bc as IconArrowsUp, uc as IconArrowsUpDown, Mc as IconArrowsUpLeft, fc as IconArrowsUpRight, yc as IconArrowsVertical, Hc as IconArtboard, jc as IconArtboardOff, Oc as IconArticle, Wc as IconArticleOff, Ac as IconAspectRatio, Sc as IconAspectRatioOff, Jc as IconAssembly, Fc as IconAssemblyOff, Qc as IconAsset, Vc as IconAsterisk, Tc as IconAsteriskSimple, $c as IconAt, Yc as IconAtOff, ns as IconAtom, es as IconAtom2, os as IconAtomOff, hs as IconAugmentedReality, as as IconAugmentedReality2, cs as IconAugmentedRealityOff, ks as IconAward, vs as IconAwardOff, ps as IconAxe, us as IconAxisX, Ms as IconAxisY, fs as IconBabyBottle, bs as IconBabyCarriage, ys as IconBackhoe, Hs as IconBackpack, js as IconBackpackOff, Ws as IconBackspace, ah as IconBadge, Os as IconBadge3d, Ss as IconBadge4k, As as IconBadge8k, Fs as IconBadgeAd, Js as IconBadgeAr, Qs as IconBadgeCc, Ts as IconBadgeHd, Vs as IconBadgeOff, Ys as IconBadgeSd, $s as IconBadgeTm, eh as IconBadgeVo, oh as IconBadgeVr, nh as IconBadgeWc, hh as IconBadges, ch as IconBadgesOff, vh as IconBaguette, ph as IconBallAmericanFootball, kh as IconBallAmericanFootballOff, uh as IconBallBaseball, Mh as IconBallBasketball, fh as IconBallBowling, yh as IconBallFootball, bh as IconBallFootballOff, jh as IconBallTennis, Hh as IconBallVolleyball, Oh as IconBallon, Wh as IconBallonOff, Ah as IconBallpen, Sh as IconBallpenOff, Fh as IconBan, Qh as IconBandage, Jh as IconBandageOff, Vh as IconBarbell, Th as IconBarbellOff, $h as IconBarcode, Yh as IconBarcodeOff, od as IconBarrel, ed as IconBarrelOff, ad as IconBarrierBlock, nd as IconBarrierBlockOff, cd as IconBaseline, vd as IconBasket, hd as IconBasketOff, kd as IconBat, ud as IconBath, pd as IconBathOff, Ad as IconBattery, Md as IconBattery1, fd as IconBattery2, bd as IconBattery3, yd as IconBattery4, jd as IconBatteryAutomotive, Wd as IconBatteryCharging, Hd as IconBatteryCharging2, Od as IconBatteryEco, Sd as IconBatteryOff, Jd as IconBeach, Fd as IconBeachOff, Td as IconBed, Qd as IconBedOff, Yd as IconBeer, Vd as IconBeerOff, kv as IconBell, $d as IconBellMinus, ev as IconBellOff, ov as IconBellPlus, av as IconBellRinging, nv as IconBellRinging2, cv as IconBellSchool, hv as IconBellX, vv as IconBellZ, pv as IconBeta, uv as IconBible, fv as IconBike, Mv as IconBikeOff, Hv as IconBinary, bv as IconBinaryOff, jv as IconBinaryTree, yv as IconBinaryTree2, Ov as IconBiohazard, Wv as IconBiohazardOff, Sv as IconBlade, Qv as IconBleach, Av as IconBleachChlorine, Fv as IconBleachNoChlorine, Jv as IconBleachOff, Tv as IconBlockquote, em as IconBluetooth, Vv as IconBluetoothConnected, Yv as IconBluetoothOff, $v as IconBluetoothX, nm as IconBlur, om as IconBlurOff, am as IconBmp, hm as IconBold, cm as IconBoldOff, km as IconBolt, vm as IconBoltOff, pm as IconBomb, Mm as IconBone, um as IconBoneOff, bm as IconBong, fm as IconBongOff, Om as IconBook, ym as IconBook2, jm as IconBookDownload, Hm as IconBookOff, Wm as IconBookUpload, Am as IconBookmark, Sm as IconBookmarkOff, Jm as IconBookmarks, Fm as IconBookmarksOff, Tm as IconBooks, Qm as IconBooksOff, Vm as IconBorderAll, Ym as IconBorderBottom, $m as IconBorderHorizontal, ek as IconBorderInner, ok as IconBorderLeft, nk as IconBorderNone, ak as IconBorderOuter, ck as IconBorderRadius, hk as IconBorderRight, kk as IconBorderStyle, vk as IconBorderStyle2, pk as IconBorderTop, uk as IconBorderVertical, fk as IconBottle, Mk as IconBottleOff, bk as IconBounceLeft, yk as IconBounceRight, jk as IconBow, Hk as IconBowl, Ww as IconBox, Sk as IconBoxAlignBottom, Wk as IconBoxAlignBottomLeft, Ok as IconBoxAlignBottomRight, Ak as IconBoxAlignLeft, Fk as IconBoxAlignRight, Tk as IconBoxAlignTop, Jk as IconBoxAlignTopLeft, Qk as IconBoxAlignTopRight, Vk as IconBoxMargin, ow as IconBoxModel, $k as IconBoxModel2, Yk as IconBoxModel2Off, ew as IconBoxModelOff, bw as IconBoxMultiple, nw as IconBoxMultiple0, aw as IconBoxMultiple1, cw as IconBoxMultiple2, hw as IconBoxMultiple3, vw as IconBoxMultiple4, kw as IconBoxMultiple5, pw as IconBoxMultiple6, uw as IconBoxMultiple7, Mw as IconBoxMultiple8, fw as IconBoxMultiple9, yw as IconBoxOff, jw as IconBoxPadding, Hw as IconBoxSeam, Sw as IconBraces, Ow as IconBracesOff, Tw as IconBrackets, Jw as IconBracketsContain, Aw as IconBracketsContainEnd, Fw as IconBracketsContainStart, Qw as IconBracketsOff, Vw as IconBraile, Yw as IconBrain, $w as IconBrand4chan, ep as IconBrandAbstract, op as IconBrandAdobe, np as IconBrandAdonisJs, ap as IconBrandAirbnb, cp as IconBrandAirtable, hp as IconBrandAlgolia, vp as IconBrandAlpineJs, kp as IconBrandAmazon, pp as IconBrandAmd, up as IconBrandAmigo, Mp as IconBrandAmongus, fp as IconBrandAndroid, bp as IconBrandAngular, yp as IconBrandAo3, jp as IconBrandAppgallery, Op as IconBrandApple, Hp as IconBrandAppleArcade, Wp as IconBrandApplePodcast, Sp as IconBrandAppstore, Ap as IconBrandAsana, Fp as IconBrandBackbone, Jp as IconBrandBadoo, Qp as IconBrandBaidu, Tp as IconBrandBandcamp, Vp as IconBrandBandlab, Yp as IconBrandBeats, $p as IconBrandBehance, eE as IconBrandBinance, oE as IconBrandBing, nE as IconBrandBitbucket, aE as IconBrandBlackbery, cE as IconBrandBlender, hE as IconBrandBlogger, vE as IconBrandBooking, kE as IconBrandBootstrap, pE as IconBrandBulma, uE as IconBrandBumble, ME as IconBrandBunpo, fE as IconBrandCampaignmonitor, bE as IconBrandCarbon, yE as IconBrandCashapp, jE as IconBrandChrome, HE as IconBrandCitymapper, WE as IconBrandCodecov, OE as IconBrandCodepen, SE as IconBrandCodesandbox, AE as IconBrandCohost, FE as IconBrandCoinbase, JE as IconBrandComedyCentral, QE as IconBrandCoreos, TE as IconBrandCouchdb, VE as IconBrandCouchsurfing, YE as IconBrandCpp, $E as IconBrandCss3, eu as IconBrandCtemplar, ou as IconBrandCucumber, nu as IconBrandCupra, au as IconBrandCypress, cu as IconBrandD3, hu as IconBrandDaysCounter, vu as IconBrandDcos, ku as IconBrandDebian, pu as IconBrandDeliveroo, uu as IconBrandDeno, Mu as IconBrandDenodo, fu as IconBrandDeviantart, bu as IconBrandDingtalk, yu as IconBrandDiscord, ju as IconBrandDisney, Hu as IconBrandDisqus, Wu as IconBrandDjango, Ou as IconBrandDocker, Su as IconBrandDoctrine, Au as IconBrandDolbyDigital, Fu as IconBrandDouban, Ju as IconBrandDribbble, Qu as IconBrandDrops, Tu as IconBrandDrupal, Vu as IconBrandEdge, Yu as IconBrandElastic, $u as IconBrandEmber, eg as IconBrandEnvato, og as IconBrandEtsy, ng as IconBrandEvernote, ag as IconBrandFacebook, cg as IconBrandFigma, hg as IconBrandFinder, vg as IconBrandFirebase, kg as IconBrandFirefox, pg as IconBrandFlickr, ug as IconBrandFlightradar24, Mg as IconBrandFlipboard, fg as IconBrandFlutter, bg as IconBrandFortnite, yg as IconBrandFoursquare, jg as IconBrandFramer, Hg as IconBrandFunimation, Wg as IconBrandGatsby, Og as IconBrandGit, Ag as IconBrandGithub, Sg as IconBrandGithubCopilot, Fg as IconBrandGitlab, Jg as IconBrandGmail, cM as IconBrandGoogle, Qg as IconBrandGoogleAnalytics, Tg as IconBrandGoogleBigQuery, Vg as IconBrandGoogleDrive, Yg as IconBrandGoogleFit, $g as IconBrandGoogleHome, eM as IconBrandGoogleOne, oM as IconBrandGooglePhotos, nM as IconBrandGooglePlay, aM as IconBrandGooglePodcasts, hM as IconBrandGrammarly, vM as IconBrandGraphql, kM as IconBrandGravatar, pM as IconBrandGrindr, uM as IconBrandGuardian, MM as IconBrandGumroad, fM as IconBrandHbo, bM as IconBrandHeadlessui, yM as IconBrandHipchat, jM as IconBrandHtml5, HM as IconBrandInertia, WM as IconBrandInstagram, OM as IconBrandIntercom, SM as IconBrandJavascript, AM as IconBrandKickstarter, FM as IconBrandKotlin, JM as IconBrandLaravel, QM as IconBrandLastfm, TM as IconBrandLinkedin, VM as IconBrandLinktree, YM as IconBrandLinqpad, $M as IconBrandLoom, ex as IconBrandMailgun, ox as IconBrandMantine, nx as IconBrandMastercard, ax as IconBrandMastodon, cx as IconBrandMatrix, hx as IconBrandMcdonalds, vx as IconBrandMedium, kx as IconBrandMercedes, px as IconBrandMessenger, ux as IconBrandMeta, Mx as IconBrandMiniprogram, fx as IconBrandMixpanel, bx as IconBrandMonday, yx as IconBrandMongodb, jx as IconBrandMyOppo, Hx as IconBrandMysql, Wx as IconBrandNationalGeographic, Ox as IconBrandNem, Sx as IconBrandNetbeans, Ax as IconBrandNeteaseMusic, Fx as IconBrandNetflix, Jx as IconBrandNexo, Qx as IconBrandNextcloud, Tx as IconBrandNextjs, Vx as IconBrandNordVpn, Yx as IconBrandNotion, $x as IconBrandNpm, ef as IconBrandNuxt, of as IconBrandNytimes, nf as IconBrandOffice, af as IconBrandOkRu, sf as IconBrandOnedrive, df as IconBrandOnlyfans, mf as IconBrandOpenSource, wf as IconBrandOpenvpn, Ef as IconBrandOpera, gf as IconBrandPagekit, xf as IconBrandPatreon, zf as IconBrandPaypal, Lf as IconBrandPaypay, Cf as IconBrandPeanut, Bf as IconBrandPepsi, Nf as IconBrandPhp, qf as IconBrandPicsart, Pf as IconBrandPinterest, If as IconBrandPocket, Df as IconBrandPolymer, Gf as IconBrandPowershell, Kf as IconBrandPrisma, Rf as IconBrandProducthunt, Uf as IconBrandPushbullet, Xf as IconBrandPushover, Zf as IconBrandPython, _f as IconBrandQq, rz as IconBrandReact, tz as IconBrandReactNative, lz as IconBrandReason, iz as IconBrandReddit, sz as IconBrandRedhat, dz as IconBrandRedux, mz as IconBrandRevolut, wz as IconBrandSafari, Ez as IconBrandSamsungpass, gz as IconBrandSass, xz as IconBrandSentry, zz as IconBrandSharik, Lz as IconBrandShazam, Cz as IconBrandShopee, Bz as IconBrandSketch, Nz as IconBrandSkype, qz as IconBrandSlack, Pz as IconBrandSnapchat, Iz as IconBrandSnapseed, Dz as IconBrandSnowflake, Gz as IconBrandSocketIo, Kz as IconBrandSolidjs, Rz as IconBrandSoundcloud, Uz as IconBrandSpacehey, Xz as IconBrandSpotify, Zz as IconBrandStackoverflow, _z as IconBrandStackshare, tb as IconBrandSteam, rb as IconBrandStorybook, lb as IconBrandStorytel, ib as IconBrandStrava, sb as IconBrandStripe, db as IconBrandSublimeText, mb as IconBrandSuperhuman, wb as IconBrandSupernova, Eb as IconBrandSurfshark, gb as IconBrandSvelte, xb as IconBrandSymfony, zb as IconBrandTabler, Lb as IconBrandTailwind, Cb as IconBrandTaobao, Bb as IconBrandTed, Nb as IconBrandTelegram, qb as IconBrandTether, Pb as IconBrandThreejs, Ib as IconBrandTidal, Db as IconBrandTiktok, Gb as IconBrandTinder, Kb as IconBrandTopbuzz, Rb as IconBrandTorchain, Ub as IconBrandToyota, Xb as IconBrandTrello, Zb as IconBrandTripadvisor, _b as IconBrandTumblr, tL as IconBrandTwilio, rL as IconBrandTwitch, lL as IconBrandTwitter, iL as IconBrandTypescript, sL as IconBrandUber, dL as IconBrandUbuntu, mL as IconBrandUnity, wL as IconBrandUnsplash, EL as IconBrandUpwork, gL as IconBrandValorant, xL as IconBrandVercel, zL as IconBrandVimeo, LL as IconBrandVinted, CL as IconBrandVisa, BL as IconBrandVisualStudio, NL as IconBrandVite, qL as IconBrandVivaldi, PL as IconBrandVk, IL as IconBrandVolkswagen, DL as IconBrandVsco, GL as IconBrandVscode, KL as IconBrandVue, RL as IconBrandWalmart, UL as IconBrandWaze, XL as IconBrandWebflow, ZL as IconBrandWechat, _L as IconBrandWeibo, ty as IconBrandWhatsapp, ry as IconBrandWindows, ly as IconBrandWindy, iy as IconBrandWish, sy as IconBrandWix, dy as IconBrandWordpress, my as IconBrandXbox, wy as IconBrandXing, Ey as IconBrandYahoo, gy as IconBrandYatse, xy as IconBrandYcombinator, Ly as IconBrandYoutube, zy as IconBrandYoutubeKids, Cy as IconBrandZalando, By as IconBrandZapier, Ny as IconBrandZeit, qy as IconBrandZhihu, Py as IconBrandZoom, Iy as IconBrandZulip, Dy as IconBrandZwift, Ky as IconBread, Gy as IconBreadOff, Uy as IconBriefcase, Ry as IconBriefcaseOff, lC as IconBrightness, Xy as IconBrightness2, Zy as IconBrightnessDown, _y as IconBrightnessHalf, tC as IconBrightnessOff, rC as IconBrightnessUp, sC as IconBroadcast, iC as IconBroadcastOff, gC as IconBrowser, dC as IconBrowserCheck, mC as IconBrowserOff, wC as IconBrowserPlus, EC as IconBrowserX, zC as IconBrush, xC as IconBrushOff, BC as IconBucket, LC as IconBucketDroplet, CC as IconBucketOff, qC as IconBug, NC as IconBugOff, Nj as IconBuilding, PC as IconBuildingArch, IC as IconBuildingBank, GC as IconBuildingBridge, DC as IconBuildingBridge2, KC as IconBuildingBroadcastTower, RC as IconBuildingCarousel, UC as IconBuildingCastle, XC as IconBuildingChurch, ZC as IconBuildingCircus, _C as IconBuildingCommunity, tj as IconBuildingCottage, rj as IconBuildingEstate, ij as IconBuildingFactory, lj as IconBuildingFactory2, sj as IconBuildingFortress, dj as IconBuildingHospital, mj as IconBuildingLighthouse, wj as IconBuildingMonument, Ej as IconBuildingPavilon, gj as IconBuildingSkyscraper, xj as IconBuildingStadium, zj as IconBuildingStore, Lj as IconBuildingTunnel, Cj as IconBuildingWarehouse, Bj as IconBuildingWindTurbine, Pj as IconBulb, qj as IconBulbOff, Ij as IconBulldozer, Kj as IconBus, Dj as IconBusOff, Gj as IconBusStop, Rj as IconBusinessplan, Uj as IconButterfly, Xj as IconCSharp, _j as IconCactus, Zj as IconCactusOff, rB as IconCake, tB as IconCakeOff, iB as IconCalculator, lB as IconCalculatorOff, zB as IconCalendar, sB as IconCalendarDue, dB as IconCalendarEvent, mB as IconCalendarMinus, wB as IconCalendarOff, EB as IconCalendarPlus, gB as IconCalendarStats, xB as IconCalendarTime, PB as IconCamera, LB as IconCameraMinus, CB as IconCameraOff, BB as IconCameraPlus, NB as IconCameraRotate, qB as IconCameraSelfie, IB as IconCampfire, DB as IconCandle, KB as IconCandy, GB as IconCandyOff, RB as IconCane, UB as IconCannabis, ZB as IconCapture, XB as IconCaptureOff, iH as IconCar, _B as IconCarCrane, tH as IconCarCrash, rH as IconCarOff, lH as IconCarTurbine, sH as IconCaravan, mH as IconCardboards, dH as IconCardboardsOff, wH as IconCards, EH as IconCaretDown, gH as IconCaretLeft, xH as IconCaretRight, zH as IconCaretUp, LH as IconCarouselHorizontal, CH as IconCarouselVertical, NH as IconCarrot, BH as IconCarrotOff, DH as IconCash, PH as IconCashBanknote, qH as IconCashBanknoteOff, IH as IconCashOff, KH as IconCast, GH as IconCastOff, RH as IconCat, XH as IconCategory, UH as IconCategory2, _H as IconCe, ZH as IconCeOff, mN as IconCell, tN as IconCellSignal1, rN as IconCellSignal2, lN as IconCellSignal3, iN as IconCellSignal4, sN as IconCellSignal5, dN as IconCellSignalOff, xN as IconCertificate, EN as IconCertificate2, wN as IconCertificate2Off, gN as IconCertificateOff, zN as IconChairDirector, CN as IconChalkboard, LN as IconChalkboardOff, BN as IconChargingPile, qN as IconChartArcs, NN as IconChartArcs3, IN as IconChartArea, PN as IconChartAreaLine, GN as IconChartArrows, DN as IconChartArrowsVertical, RN as IconChartBar, KN as IconChartBarOff, UN as IconChartBubble, XN as IconChartCandle, ZN as IconChartCircles, lW as IconChartDonut, _N as IconChartDonut2, tW as IconChartDonut3, rW as IconChartDonut4, dW as IconChartDots, iW as IconChartDots2, sW as IconChartDots3, mW as IconChartGridDots, wW as IconChartHistogram, EW as IconChartInfographic, gW as IconChartLine, BW as IconChartPie, xW as IconChartPie2, zW as IconChartPie3, LW as IconChartPie4, CW as IconChartPieOff, NW as IconChartPpf, qW as IconChartRadar, PW as IconChartSankey, IW as IconChartTreemap, DW as IconCheck, GW as IconCheckbox, KW as IconChecklist, RW as IconChecks, UW as IconCheckupList, XW as IconCheese, _W as IconChefHat, ZW as IconChefHatOff, tq as IconCherry, mq as IconChess, rq as IconChessBishop, lq as IconChessKing, iq as IconChessKnight, sq as IconChessQueen, dq as IconChessRook, gq as IconChevronDown, wq as IconChevronDownLeft, Eq as IconChevronDownRight, xq as IconChevronLeft, zq as IconChevronRight, Bq as IconChevronUp, Lq as IconChevronUpLeft, Cq as IconChevronUpRight, Pq as IconChevronsDown, Nq as IconChevronsDownLeft, qq as IconChevronsDownRight, Iq as IconChevronsLeft, Dq as IconChevronsRight, Rq as IconChevronsUp, Gq as IconChevronsUpLeft, Kq as IconChevronsUpRight, Uq as IconChisel, Zq as IconChristmasTree, Xq as IconChristmasTreeOff, gS as IconCircle, _q as IconCircleCaretDown, tO as IconCircleCaretLeft, rO as IconCircleCaretRight, lO as IconCircleCaretUp, iO as IconCircleCheck, sO as IconCircleChevronDown, dO as IconCircleChevronLeft, mO as IconCircleChevronRight, wO as IconCircleChevronUp, EO as IconCircleChevronsDown, gO as IconCircleChevronsLeft, xO as IconCircleChevronsRight, zO as IconCircleChevronsUp, LO as IconCircleDashed, CO as IconCircleDot, BO as IconCircleDotted, PO as IconCircleHalf, NO as IconCircleHalf2, qO as IconCircleHalfVertical, IO as IconCircleKey, DO as IconCircleLetterA, GO as IconCircleLetterB, KO as IconCircleLetterC, RO as IconCircleLetterD, UO as IconCircleLetterE, XO as IconCircleLetterF, ZO as IconCircleLetterG, _O as IconCircleLetterH, tP as IconCircleLetterI, rP as IconCircleLetterJ, lP as IconCircleLetterK, iP as IconCircleLetterL, sP as IconCircleLetterM, dP as IconCircleLetterN, mP as IconCircleLetterO, wP as IconCircleLetterP, EP as IconCircleLetterQ, gP as IconCircleLetterR, xP as IconCircleLetterS, zP as IconCircleLetterT, LP as IconCircleLetterU, CP as IconCircleLetterV, BP as IconCircleLetterW, NP as IconCircleLetterX, qP as IconCircleLetterY, PP as IconCircleLetterZ, IP as IconCircleMinus, DP as IconCircleNumber0, GP as IconCircleNumber1, KP as IconCircleNumber2, RP as IconCircleNumber3, UP as IconCircleNumber4, XP as IconCircleNumber5, ZP as IconCircleNumber6, _P as IconCircleNumber7, tS as IconCircleNumber8, rS as IconCircleNumber9, lS as IconCircleOff, iS as IconCirclePlus, dS as IconCircleRectangle, sS as IconCircleRectangleOff, mS as IconCircleSquare, wS as IconCircleTriangle, ES as IconCircleX, zS as IconCircles, xS as IconCirclesRelation, LS as IconCircuitAmmeter, CS as IconCircuitBattery, BS as IconCircuitBulb, qS as IconCircuitCapacitor, NS as IconCircuitCapacitorPolarized, IS as IconCircuitCell, PS as IconCircuitCellPlus, DS as IconCircuitChangeover, KS as IconCircuitDiode, GS as IconCircuitDiodeZener, US as IconCircuitGround, RS as IconCircuitGroundDigital, XS as IconCircuitInductor, ZS as IconCircuitMotor, _S as IconCircuitPushbutton, tI as IconCircuitResistor, rI as IconCircuitSwitchClosed, lI as IconCircuitSwitchOpen, iI as IconCircuitVoltmeter, sI as IconClearAll, dI as IconClearFormatting, mI as IconClick, PI as IconClipboard, wI as IconClipboardCheck, EI as IconClipboardCopy, gI as IconClipboardData, xI as IconClipboardHeart, zI as IconClipboardList, LI as IconClipboardOff, CI as IconClipboardPlus, BI as IconClipboardText, NI as IconClipboardTypography, qI as IconClipboardX, zA as IconClock, II as IconClock2, DI as IconClockCancel, GI as IconClockEdit, KI as IconClockHour1, RI as IconClockHour10, UI as IconClockHour11, XI as IconClockHour12, ZI as IconClockHour2, _I as IconClockHour3, tA as IconClockHour4, rA as IconClockHour5, lA as IconClockHour6, iA as IconClockHour7, sA as IconClockHour8, dA as IconClockHour9, mA as IconClockOff, wA as IconClockPause, EA as IconClockPlay, gA as IconClockRecord, xA as IconClockStop, CA as IconClothesRack, LA as IconClothesRackOff, ZA as IconCloud, BA as IconCloudComputing, NA as IconCloudDataConnection, qA as IconCloudDownload, PA as IconCloudFog, DA as IconCloudLock, IA as IconCloudLockOpen, GA as IconCloudOff, KA as IconCloudRain, RA as IconCloudSnow, UA as IconCloudStorm, XA as IconCloudUpload, tD as IconClover, _A as IconClover2, rD as IconClubs, gD as IconCode, lD as IconCodeAsterix, sD as IconCodeCircle, iD as IconCodeCircle2, dD as IconCodeDots, mD as IconCodeMinus, wD as IconCodeOff, ED as IconCodePlus, zD as IconCoffee, xD as IconCoffeeOff, LD as IconCoffin, KD as IconCoin, CD as IconCoinBitcoin, BD as IconCoinEuro, ND as IconCoinMonero, qD as IconCoinOff, PD as IconCoinPound, ID as IconCoinRupee, DD as IconCoinYen, GD as IconCoinYuan, RD as IconCoins, UD as IconColorFilter, ZD as IconColorPicker, XD as IconColorPickerOff, tF as IconColorSwatch, _D as IconColorSwatchOff, rF as IconColumnInsertLeft, lF as IconColumnInsertRight, sF as IconColumns, iF as IconColumnsOff, dF as IconComet, wF as IconCommand, mF as IconCommandOff, gF as IconCompass, EF as IconCompassOff, zF as IconComponents, xF as IconComponentsOff, BF as IconCone, LF as IconCone2, CF as IconConeOff, qF as IconConfetti, NF as IconConfettiOff, PF as IconConfucius, DF as IconContainer, IF as IconContainerOff, UF as IconContrast, KF as IconContrast2, GF as IconContrast2Off, RF as IconContrastOff, XF as IconCooker, tG as IconCookie, ZF as IconCookieMan, _F as IconCookieOff, lG as IconCopy, rG as IconCopyOff, sG as IconCopyleft, iG as IconCopyleftOff, mG as IconCopyright, dG as IconCopyrightOff, EG as IconCornerDownLeft, wG as IconCornerDownLeftDouble, xG as IconCornerDownRight, gG as IconCornerDownRightDouble, LG as IconCornerLeftDown, zG as IconCornerLeftDownDouble, BG as IconCornerLeftUp, CG as IconCornerLeftUpDouble, qG as IconCornerRightDown, NG as IconCornerRightDownDouble, IG as IconCornerRightUp, PG as IconCornerRightUpDouble, GG as IconCornerUpLeft, DG as IconCornerUpLeftDouble, RG as IconCornerUpRight, KG as IconCornerUpRightDouble, ZG as IconCpu, UG as IconCpu2, XG as IconCpuOff, tJ as IconCrane, _G as IconCraneOff, wJ as IconCreativeCommons, rJ as IconCreativeCommonsBy, lJ as IconCreativeCommonsNc, iJ as IconCreativeCommonsNd, sJ as IconCreativeCommonsOff, dJ as IconCreativeCommonsSa, mJ as IconCreativeCommonsZero, gJ as IconCreditCard, EJ as IconCreditCardOff, xJ as IconCricket, zJ as IconCrop, CJ as IconCross, LJ as IconCrossOff, BJ as IconCrosshair, qJ as IconCrown, NJ as IconCrownOff, IJ as IconCrutches, PJ as IconCrutchesOff, DJ as IconCrystalBall, GJ as IconCubeSend, KJ as IconCubeUnfolded, UJ as IconCup, RJ as IconCupOff, XJ as IconCurling, ZJ as IconCurlyLoop, wR as IconCurrency, _J as IconCurrencyAfghani, tK as IconCurrencyBahraini, rK as IconCurrencyBaht, lK as IconCurrencyBitcoin, iK as IconCurrencyCent, sK as IconCurrencyDinar, dK as IconCurrencyDirham, mK as IconCurrencyDogecoin, BK as IconCurrencyDollar, wK as IconCurrencyDollarAustralian, EK as IconCurrencyDollarBrunei, gK as IconCurrencyDollarCanadian, xK as IconCurrencyDollarGuyanese, zK as IconCurrencyDollarOff, LK as IconCurrencyDollarSingapore, CK as IconCurrencyDollarZimbabwean, NK as IconCurrencyDong, qK as IconCurrencyDram, PK as IconCurrencyEthereum, DK as IconCurrencyEuro, IK as IconCurrencyEuroOff, GK as IconCurrencyForint, KK as IconCurrencyFrank, RK as IconCurrencyGuarani, UK as IconCurrencyHryvnia, XK as IconCurrencyKip, ZK as IconCurrencyKroneCzech, _K as IconCurrencyKroneDanish, tQ as IconCurrencyKroneSwedish, rQ as IconCurrencyLari, lQ as IconCurrencyLeu, iQ as IconCurrencyLira, sQ as IconCurrencyLitecoin, dQ as IconCurrencyLyd, mQ as IconCurrencyManat, wQ as IconCurrencyMonero, EQ as IconCurrencyNaira, gQ as IconCurrencyOff, xQ as IconCurrencyPaanga, zQ as IconCurrencyPeso, CQ as IconCurrencyPound, LQ as IconCurrencyPoundOff, BQ as IconCurrencyQuetzal, NQ as IconCurrencyReal, qQ as IconCurrencyRenminbi, PQ as IconCurrencyRipple, IQ as IconCurrencyRiyal, DQ as IconCurrencyRubel, GQ as IconCurrencyRufiyaa, RQ as IconCurrencyRupee, KQ as IconCurrencyRupeeNepalese, UQ as IconCurrencyShekel, XQ as IconCurrencySolana, ZQ as IconCurrencySom, _Q as IconCurrencyTaka, tR as IconCurrencyTenge, rR as IconCurrencyTugrik, lR as IconCurrencyWon, sR as IconCurrencyYen, iR as IconCurrencyYenOff, dR as IconCurrencyYuan, mR as IconCurrencyZloty, gR as IconCurrentLocation, ER as IconCurrentLocationOff, xR as IconCursorOff, zR as IconCursorText, LR as IconCut, CR as IconCylinder, NR as IconDashboard, BR as IconDashboardOff, DR as IconDatabase, qR as IconDatabaseExport, PR as IconDatabaseImport, IR as IconDatabaseOff, GR as IconDeer, KR as IconDelta, XR as IconDental, RR as IconDentalBroken, UR as IconDentalOff, _R as IconDetails, ZR as IconDetailsOff, rT as IconDeviceAirpods, tT as IconDeviceAirpodsCase, lT as IconDeviceAnalytics, iT as IconDeviceAudioTape, sT as IconDeviceCameraPhone, mT as IconDeviceCctv, dT as IconDeviceCctvOff, ET as IconDeviceComputerCamera, wT as IconDeviceComputerCameraOff, zT as IconDeviceDesktop, gT as IconDeviceDesktopAnalytics, xT as IconDeviceDesktopOff, LT as IconDeviceFloppy, BT as IconDeviceGamepad, CT as IconDeviceGamepad2, NT as IconDeviceHeartMonitor, PT as IconDeviceIpad, qT as IconDeviceIpadHorizontal, IT as IconDeviceLandlinePhone, GT as IconDeviceLaptop, DT as IconDeviceLaptopOff, _T as IconDeviceMobile, KT as IconDeviceMobileCharging, RT as IconDeviceMobileMessage, UT as IconDeviceMobileOff, XT as IconDeviceMobileRotated, ZT as IconDeviceMobileVibration, rU as IconDeviceNintendo, tU as IconDeviceNintendoOff, lU as IconDeviceSdCard, mU as IconDeviceSim, iU as IconDeviceSim1, sU as IconDeviceSim2, dU as IconDeviceSim3, EU as IconDeviceSpeaker, wU as IconDeviceSpeakerOff, xU as IconDeviceTablet, gU as IconDeviceTabletOff, CU as IconDeviceTv, zU as IconDeviceTvOff, LU as IconDeviceTvOld, PU as IconDeviceWatch, BU as IconDeviceWatchOff, qU as IconDeviceWatchStats, NU as IconDeviceWatchStats2, RU as IconDevices, IU as IconDevices2, DU as IconDevicesOff, KU as IconDevicesPc, GU as IconDevicesPcOff, XU as IconDialpad, UU as IconDialpadOff, _U as IconDiamond, ZU as IconDiamondOff, tV as IconDiamonds, wV as IconDice, rV as IconDice1, lV as IconDice2, iV as IconDice3, sV as IconDice4, dV as IconDice5, mV as IconDice6, EV as IconDimensions, LV as IconDirection, gV as IconDirectionHorizontal, zV as IconDirectionSign, xV as IconDirectionSignOff, BV as IconDirections, CV as IconDirectionsOff, PV as IconDisabled, NV as IconDisabled2, qV as IconDisabledOff, GV as IconDisc, IV as IconDiscGolf, DV as IconDiscOff, ZV as IconDiscount, RV as IconDiscount2, KV as IconDiscount2Off, UV as IconDiscountCheck, XV as IconDiscountOff, _V as IconDivide, iX as IconDna, rX as IconDna2, tX as IconDna2Off, lX as IconDnaOff, dX as IconDog, sX as IconDogBowl, gX as IconDoor, mX as IconDoorEnter, wX as IconDoorExit, EX as IconDoorOff, BX as IconDots, xX as IconDotsCircleHorizontal, LX as IconDotsDiagonal, zX as IconDotsDiagonal2, CX as IconDotsVertical, qX as IconDownload, NX as IconDownloadOff, IX as IconDragDrop, PX as IconDragDrop2, GX as IconDrone, DX as IconDroneOff, KX as IconDropCircle, tY as IconDroplet, UX as IconDropletFilled, RX as IconDropletFilled2, ZX as IconDropletHalf, XX as IconDropletHalf2, _X as IconDropletOff, rY as IconEPassport, iY as IconEar, lY as IconEarOff, wY as IconEaseIn, sY as IconEaseInControlPoint, mY as IconEaseInOut, dY as IconEaseInOutControlPoints, gY as IconEaseOut, EY as IconEaseOutControlPoint, CY as IconEdit, zY as IconEditCircle, xY as IconEditCircleOff, LY as IconEditOff, PY as IconEgg, BY as IconEggCracked, NY as IconEggFried, qY as IconEggOff, IY as IconEggs, GY as IconElevator, DY as IconElevatorOff, KY as IconEmergencyBed, UY as IconEmpathize, RY as IconEmpathizeOff, XY as IconEmphasis, _Y as IconEngine, ZY as IconEngineOff, lZ as IconEqual, tZ as IconEqualDouble, rZ as IconEqualNot, sZ as IconEraser, iZ as IconEraserOff, mZ as IconError404, dZ as IconError404Off, EZ as IconExchange, wZ as IconExchangeOff, gZ as IconExclamationCircle, zZ as IconExclamationMark, xZ as IconExclamationMarkOff, CZ as IconExplicit, LZ as IconExplicitOff, GZ as IconExposure, BZ as IconExposure0, NZ as IconExposureMinus1, qZ as IconExposureMinus2, PZ as IconExposureOff, IZ as IconExposurePlus1, DZ as IconExposurePlus2, RZ as IconExternalLink, KZ as IconExternalLinkOff, _Z as IconEye, UZ as IconEyeCheck, XZ as IconEyeOff, ZZ as IconEyeTable, l$ as IconEyeglass, t$ as IconEyeglass2, r$ as IconEyeglassOff, s$ as IconFaceId, i$ as IconFaceIdError, m$ as IconFaceMask, d$ as IconFaceMaskOff, w$ as IconFall, g$ as IconFeather, E$ as IconFeatherOff, z$ as IconFence, x$ as IconFenceOff, L$ as IconFidgetSpinner, I0 as IconFile, C$ as IconFile3d, B$ as IconFileAlert, N$ as IconFileAnalytics, q$ as IconFileArrowLeft, P$ as IconFileArrowRight, I$ as IconFileBarcode, D$ as IconFileBroken, G$ as IconFileCertificate, K$ as IconFileChart, R$ as IconFileCheck, X$ as IconFileCode, U$ as IconFileCode2, Z$ as IconFileDatabase, _$ as IconFileDelta, t_ as IconFileDescription, r_ as IconFileDiff, l_ as IconFileDigit, i_ as IconFileDislike, s_ as IconFileDollar, d_ as IconFileDots, m_ as IconFileDownload, w_ as IconFileEuro, E_ as IconFileExport, g_ as IconFileFunction, x_ as IconFileHorizontal, z_ as IconFileImport, L_ as IconFileInfinity, C_ as IconFileInfo, B_ as IconFileInvoice, N_ as IconFileLambda, q_ as IconFileLike, P_ as IconFileMinus, I_ as IconFileMusic, D_ as IconFileOff, G_ as IconFileOrientation, K_ as IconFilePencil, R_ as IconFilePercent, U_ as IconFilePhone, X_ as IconFilePlus, Z_ as IconFilePower, __ as IconFileReport, t0 as IconFileRss, r0 as IconFileScissors, l0 as IconFileSearch, i0 as IconFileSettings, s0 as IconFileShredder, d0 as IconFileSignal, m0 as IconFileSpreadsheet, w0 as IconFileStack, E0 as IconFileStar, g0 as IconFileSymlink, x0 as IconFileText, z0 as IconFileTime, L0 as IconFileTypography, C0 as IconFileUnknown, B0 as IconFileUpload, N0 as IconFileVector, q0 as IconFileX, P0 as IconFileZip, G0 as IconFiles, D0 as IconFilesOff, R0 as IconFilter, K0 as IconFilterOff, X0 as IconFingerprint, U0 as IconFingerprintOff, _0 as IconFireHydrant, Z0 as IconFireHydrantOff, t2 as IconFiretruck, l2 as IconFirstAidKit, r2 as IconFirstAidKitOff, E2 as IconFish, i2 as IconFishBone, s2 as IconFishChristianity, m2 as IconFishHook, d2 as IconFishHookOff, w2 as IconFishOff, C2 as IconFlag, x2 as IconFlag2, g2 as IconFlag2Off, z2 as IconFlag3, L2 as IconFlagOff, N2 as IconFlame, B2 as IconFlameOff, q2 as IconFlare, G2 as IconFlask, I2 as IconFlask2, P2 as IconFlask2Off, D2 as IconFlaskOff, K2 as IconFlipFlops, R2 as IconFlipHorizontal, U2 as IconFlipVertical, X2 as IconFloatCenter, Z2 as IconFloatLeft, _2 as IconFloatNone, t1 as IconFloatRight, l1 as IconFlower, r1 as IconFlowerOff, d1 as IconFocus, i1 as IconFocus2, s1 as IconFocusCentered, E1 as IconFold, m1 as IconFoldDown, w1 as IconFoldUp, C1 as IconFolder, g1 as IconFolderMinus, x1 as IconFolderOff, z1 as IconFolderPlus, L1 as IconFolderX, N1 as IconFolders, B1 as IconFoldersOff, P1 as IconForbid, q1 as IconForbid2, I1 as IconForklift, D1 as IconForms, K1 as IconFountain, G1 as IconFountainOff, U1 as IconFrame, R1 as IconFrameOff, X1 as IconFreeRights, _1 as IconFridge, Z1 as IconFridgeOff, r4 as IconFriends, t4 as IconFriendsOff, i4 as IconFunction, l4 as IconFunctionOff, d4 as IconGardenCart, s4 as IconGardenCartOff, w4 as IconGasStation, m4 as IconGasStationOff, g4 as IconGauge, E4 as IconGaugeOff, x4 as IconGavel, z4 as IconGenderAgender, L4 as IconGenderAndrogyne, C4 as IconGenderBigender, B4 as IconGenderDemiboy, N4 as IconGenderDemigirl, q4 as IconGenderEpicene, P4 as IconGenderFemale, I4 as IconGenderFemme, D4 as IconGenderGenderfluid, G4 as IconGenderGenderless, K4 as IconGenderGenderqueer, R4 as IconGenderHermaphrodite, U4 as IconGenderIntergender, X4 as IconGenderMale, Z4 as IconGenderNeutrois, _4 as IconGenderThird, t3 as IconGenderTransgender, r3 as IconGenderTrasvesti, l3 as IconGeometry, d3 as IconGhost, i3 as IconGhost2, s3 as IconGhostOff, m3 as IconGif, g3 as IconGift, w3 as IconGiftCard, E3 as IconGiftOff, z3 as IconGitBranch, x3 as IconGitBranchDeleted, L3 as IconGitCherryPick, C3 as IconGitCommit, B3 as IconGitCompare, N3 as IconGitFork, q3 as IconGitMerge, D3 as IconGitPullRequest, P3 as IconGitPullRequestClosed, I3 as IconGitPullRequestDraft, G3 as IconGizmo, U3 as IconGlass, K3 as IconGlassFull, R3 as IconGlassOff, Z3 as IconGlobe, X3 as IconGlobeOff, _3 as IconGoGame, r5 as IconGolf, t5 as IconGolfOff, l5 as IconGps, i5 as IconGradienter, s5 as IconGrain, m5 as IconGraph, d5 as IconGraphOff, E5 as IconGrave, w5 as IconGrave2, g5 as IconGridDots, x5 as IconGridPattern, B5 as IconGrill, z5 as IconGrillFork, L5 as IconGrillOff, C5 as IconGrillSpatula, N5 as IconGripHorizontal, q5 as IconGripVertical, P5 as IconGrowth, I5 as IconGuitarPick, D5 as IconH1, G5 as IconH2, K5 as IconH3, R5 as IconH4, U5 as IconH5, X5 as IconH6, _5 as IconHammer, Z5 as IconHammerOff, t6 as IconHandClick, l6 as IconHandFinger, r6 as IconHandFingerOff, i6 as IconHandGrab, s6 as IconHandLittleFinger, d6 as IconHandMiddleFinger, m6 as IconHandMove, w6 as IconHandOff, E6 as IconHandRingFinger, g6 as IconHandRock, x6 as IconHandSanitizer, z6 as IconHandStop, L6 as IconHandThreeFingers, C6 as IconHandTwoFingers, q6 as IconHanger, B6 as IconHanger2, N6 as IconHangerOff, P6 as IconHash, I6 as IconHaze, G6 as IconHeading, D6 as IconHeadingOff, R6 as IconHeadphones, K6 as IconHeadphonesOff, X6 as IconHeadset, U6 as IconHeadsetOff, Z6 as IconHealthRecognition, d8 as IconHeart, _6 as IconHeartBroken, t8 as IconHeartHandshake, r8 as IconHeartMinus, l8 as IconHeartOff, i8 as IconHeartPlus, s8 as IconHeartRateMonitor, m8 as IconHeartbeat, E8 as IconHearts, w8 as IconHeartsOff, x8 as IconHelicopter, g8 as IconHelicopterLanding, L8 as IconHelmet, z8 as IconHelmetOff, B8 as IconHelp, C8 as IconHelpOff, _7 as IconHexagon, N8 as IconHexagon3d, q8 as IconHexagonLetterA, P8 as IconHexagonLetterB, I8 as IconHexagonLetterC, D8 as IconHexagonLetterD, G8 as IconHexagonLetterE, K8 as IconHexagonLetterF, R8 as IconHexagonLetterG, U8 as IconHexagonLetterH, X8 as IconHexagonLetterI, Z8 as IconHexagonLetterJ, _8 as IconHexagonLetterK, t7 as IconHexagonLetterL, r7 as IconHexagonLetterM, l7 as IconHexagonLetterN, i7 as IconHexagonLetterO, s7 as IconHexagonLetterP, d7 as IconHexagonLetterQ, m7 as IconHexagonLetterR, w7 as IconHexagonLetterS, E7 as IconHexagonLetterT, g7 as IconHexagonLetterU, x7 as IconHexagonLetterV, z7 as IconHexagonLetterW, L7 as IconHexagonLetterX, C7 as IconHexagonLetterY, B7 as IconHexagonLetterZ, N7 as IconHexagonNumber0, q7 as IconHexagonNumber1, P7 as IconHexagonNumber2, I7 as IconHexagonNumber3, D7 as IconHexagonNumber4, G7 as IconHexagonNumber5, K7 as IconHexagonNumber6, R7 as IconHexagonNumber7, U7 as IconHexagonNumber8, X7 as IconHexagonNumber9, Z7 as IconHexagonOff, r9 as IconHexagons, t9 as IconHexagonsOff, d9 as IconHierarchy, l9 as IconHierarchy2, i9 as IconHierarchy3, s9 as IconHierarchyOff, w9 as IconHighlight, m9 as IconHighlightOff, x9 as IconHistory, E9 as IconHistoryOff, g9 as IconHistoryToggle, Cee as IconHome, z9 as IconHome2, L9 as IconHomeBolt, C9 as IconHomeCancel, B9 as IconHomeCheck, N9 as IconHomeCog, q9 as IconHomeDollar, P9 as IconHomeDot, I9 as IconHomeDown, D9 as IconHomeEco, G9 as IconHomeEdit, K9 as IconHomeExclamation, R9 as IconHomeHand, U9 as IconHomeHeart, X9 as IconHomeInfinity, Z9 as IconHomeLink, _9 as IconHomeMinus, tee as IconHomeMove, ree as IconHomeOff, lee as IconHomePlus, iee as IconHomeQuestion, see as IconHomeRibbon, dee as IconHomeSearch, mee as IconHomeShare, wee as IconHomeShield, Eee as IconHomeSignal, gee as IconHomeStar, xee as IconHomeStats, zee as IconHomeUp, Lee as IconHomeX, Bee as IconHorseToy, Nee as IconHotelService, Gee as IconHourglass, qee as IconHourglassEmpty, Pee as IconHourglassHigh, Iee as IconHourglassLow, Dee as IconHourglassOff, Uee as IconIceCream, Kee as IconIceCream2, Ree as IconIceCreamOff, Xee as IconIceSkating, _ee as IconIcons, Zee as IconIconsOff, ste as IconId, lte as IconIdBadge, tte as IconIdBadge2, rte as IconIdBadgeOff, ite as IconIdOff, mte as IconInbox, dte as IconInboxOff, wte as IconIndentDecrease, Ete as IconIndentIncrease, xte as IconInfinity, gte as IconInfinityOff, zte as IconInfoCircle, Cte as IconInfoSquare, Lte as IconInfoSquareRounded, qte as IconInnerShadowBottom, Bte as IconInnerShadowBottomLeft, Nte as IconInnerShadowBottomRight, Pte as IconInnerShadowLeft, Ite as IconInnerShadowRight, Kte as IconInnerShadowTop, Dte as IconInnerShadowTopLeft, Gte as IconInnerShadowTopRight, Rte as IconInputSearch, Ute as IconIroning1, Xte as IconIroning2, Zte as IconIroning3, _te as IconIroningOff, roe as IconIroningSteam, toe as IconIroningSteamOff, loe as IconItalic, ioe as IconJacket, soe as IconJetpack, doe as IconJewishStar, moe as IconJpg, woe as IconJumpRope, Eoe as IconKarate, goe as IconKayak, xoe as IconKering, Loe as IconKey, zoe as IconKeyOff, qoe as IconKeyboard, Coe as IconKeyboardHide, Boe as IconKeyboardOff, Noe as IconKeyboardShow, Goe as IconKeyframe, Poe as IconKeyframeAlignCenter, Ioe as IconKeyframeAlignHorizontal, Doe as IconKeyframeAlignVertical, Koe as IconKeyframes, Uoe as IconLadder, Roe as IconLadderOff, Xoe as IconLambda, tre as IconLamp, Zoe as IconLamp2, _oe as IconLampOff, sre as IconLanguage, rre as IconLanguageHiragana, lre as IconLanguageKatakana, ire as IconLanguageOff, wre as IconLasso, dre as IconLassoOff, mre as IconLassoPolygon, Ere as IconLayersDifference, xre as IconLayersIntersect, gre as IconLayersIntersect2, zre as IconLayersLinked, Lre as IconLayersOff, Cre as IconLayersSubtract, Bre as IconLayersUnion, Kne as IconLayout, Nre as IconLayout2, qre as IconLayoutAlignBottom, Pre as IconLayoutAlignCenter, Ire as IconLayoutAlignLeft, Dre as IconLayoutAlignMiddle, Gre as IconLayoutAlignRight, Kre as IconLayoutAlignTop, Ure as IconLayoutBoard, Rre as IconLayoutBoardSplit, _re as IconLayoutBottombar, Xre as IconLayoutBottombarCollapse, Zre as IconLayoutBottombarExpand, tne as IconLayoutCards, rne as IconLayoutCollage, lne as IconLayoutColumns, ine as IconLayoutDashboard, sne as IconLayoutDistributeHorizontal, dne as IconLayoutDistributeVertical, wne as IconLayoutGrid, mne as IconLayoutGridAdd, Ene as IconLayoutKanban, gne as IconLayoutList, Lne as IconLayoutNavbar, xne as IconLayoutNavbarCollapse, zne as IconLayoutNavbarExpand, Cne as IconLayoutOff, Bne as IconLayoutRows, Gne as IconLayoutSidebar, Nne as IconLayoutSidebarLeftCollapse, qne as IconLayoutSidebarLeftExpand, Dne as IconLayoutSidebarRight, Pne as IconLayoutSidebarRightCollapse, Ine as IconLayoutSidebarRightExpand, Une as IconLeaf, Rne as IconLeafOff, Zne as IconLego, Xne as IconLegoOff, tle as IconLemon, _ne as IconLemon2, rle as IconLetterA, lle as IconLetterB, ile as IconLetterC, wle as IconLetterCase, sle as IconLetterCaseLower, dle as IconLetterCaseToggle, mle as IconLetterCaseUpper, Ele as IconLetterD, gle as IconLetterE, xle as IconLetterF, zle as IconLetterG, Lle as IconLetterH, Cle as IconLetterI, Ble as IconLetterJ, Nle as IconLetterK, qle as IconLetterL, Ple as IconLetterM, Ile as IconLetterN, Dle as IconLetterO, Gle as IconLetterP, Kle as IconLetterQ, Rle as IconLetterR, Ule as IconLetterS, Xle as IconLetterSpacing, Zle as IconLetterT, _le as IconLetterU, tae as IconLetterV, rae as IconLetterW, lae as IconLetterX, iae as IconLetterY, sae as IconLetterZ, mae as IconLicense, dae as IconLicenseOff, Eae as IconLifebuoy, wae as IconLifebuoyOff, Lae as IconLine, gae as IconLineDashed, xae as IconLineDotted, zae as IconLineHeight, Bae as IconLink, Cae as IconLinkOff, Dae as IconList, Nae as IconListCheck, qae as IconListDetails, Pae as IconListNumbers, Iae as IconListSearch, Kae as IconLivePhoto, Gae as IconLivePhotoOff, Rae as IconLiveView, _ae as IconLoader, Uae as IconLoader2, Xae as IconLoader3, Zae as IconLoaderQuarter, lie as IconLocation, tie as IconLocationBroken, rie as IconLocationOff, xie as IconLock, sie as IconLockAccess, iie as IconLockAccessOff, die as IconLockOff, wie as IconLockOpen, mie as IconLockOpenOff, gie as IconLockSquare, Eie as IconLockSquareRounded, zie as IconLogicAnd, Lie as IconLogicBuffer, Cie as IconLogicNand, Bie as IconLogicNor, Nie as IconLogicNot, qie as IconLogicOr, Pie as IconLogicXnor, Iie as IconLogicXor, Die as IconLogin, Gie as IconLogout, Rie as IconLollipop, Kie as IconLollipopOff, Xie as IconLuggage, Uie as IconLuggageOff, _ie as IconLungs, Zie as IconLungsOff, rce as IconMacro, tce as IconMacroOff, ice as IconMagnet, lce as IconMagnetOff, Ece as IconMail, sce as IconMailFast, dce as IconMailForward, mce as IconMailOff, wce as IconMailOpened, xce as IconMailbox, gce as IconMailboxOff, zce as IconMan, Lce as IconManualGearbox, Dce as IconMap, Cce as IconMap2, Bce as IconMapOff, qce as IconMapPin, Nce as IconMapPinOff, Pce as IconMapPins, Ice as IconMapSearch, Kce as IconMarkdown, Gce as IconMarkdownOff, Xce as IconMarquee, Rce as IconMarquee2, Uce as IconMarqueeOff, Zce as IconMars, tse as IconMask, _ce as IconMaskOff, lse as IconMasksTheater, rse as IconMasksTheaterOff, ise as IconMassage, sse as IconMatchstick, Ehe as IconMath, dse as IconMath1Divide2, mse as IconMath1Divide3, wse as IconMathAvg, Ese as IconMathEqualGreater, gse as IconMathEqualLower, Lse as IconMathFunction, xse as IconMathFunctionOff, zse as IconMathFunctionY, Cse as IconMathGreater, Nse as IconMathIntegral, Bse as IconMathIntegralX, qse as IconMathIntegrals, Pse as IconMathLower, Ise as IconMathMax, Dse as IconMathMin, Gse as IconMathNot, Kse as IconMathOff, Use as IconMathPi, Rse as IconMathPiDivide2, Xse as IconMathSymbols, Zse as IconMathXDivide2, the as IconMathXDivideY, _se as IconMathXDivideY2, rhe as IconMathXMinusX, lhe as IconMathXMinusY, ihe as IconMathXPlusX, she as IconMathXPlusY, dhe as IconMathXy, mhe as IconMathYMinusY, whe as IconMathYPlusY, xhe as IconMaximize, ghe as IconMaximizeOff, Lhe as IconMeat, zhe as IconMeatOff, Bhe as IconMedal, Che as IconMedal2, qhe as IconMedicalCross, Nhe as IconMedicalCrossOff, Phe as IconMedicineSyrup, Ihe as IconMeeple, Dhe as IconMenorah, Rhe as IconMenu, Ghe as IconMenu2, Khe as IconMenuOrder, Lde as IconMessage, _he as IconMessage2, Uhe as IconMessage2Code, Xhe as IconMessage2Off, Zhe as IconMessage2Share, tde as IconMessageChatbot, ide as IconMessageCircle, rde as IconMessageCircle2, lde as IconMessageCircleOff, sde as IconMessageCode, dde as IconMessageDots, mde as IconMessageForward, wde as IconMessageLanguage, Ede as IconMessageOff, gde as IconMessagePlus, xde as IconMessageReport, zde as IconMessageShare, Bde as IconMessages, Cde as IconMessagesOff, qde as IconMeteor, Nde as IconMeteorOff, Pde as IconMickey, Kde as IconMicrophone, Dde as IconMicrophone2, Ide as IconMicrophone2Off, Gde as IconMicrophoneOff, Ude as IconMicroscope, Rde as IconMicroscopeOff, Zde as IconMicrowave, Xde as IconMicrowaveOff, _de as IconMilitaryAward, tve as IconMilitaryRank, lve as IconMilk, rve as IconMilkOff, ive as IconMilkshake, sve as IconMinimize, mve as IconMinus, dve as IconMinusVertical, Eve as IconMist, wve as IconMistOff, gve as IconMoneybag, xve as IconMoodAngry, Lve as IconMoodAnnoyed, zve as IconMoodAnnoyed2, Cve as IconMoodBoy, Bve as IconMoodConfuzed, Nve as IconMoodCrazyHappy, qve as IconMoodCry, Pve as IconMoodEmpty, Ive as IconMoodHappy, Dve as IconMoodKid, Gve as IconMoodLookLeft, Kve as IconMoodLookRight, Rve as IconMoodNerd, Uve as IconMoodNervous, Xve as IconMoodNeutral, Zve as IconMoodOff, lme as IconMoodSad, _ve as IconMoodSad2, tme as IconMoodSadDizzy, rme as IconMoodSadSquint, ime as IconMoodSick, sme as IconMoodSilence, dme as IconMoodSing, Eme as IconMoodSmile, mme as IconMoodSmileBeam, wme as IconMoodSmileDizzy, gme as IconMoodSuprised, Lme as IconMoodTongue, zme as IconMoodTongueWink, xme as IconMoodTongueWink2, Cme as IconMoodUnamused, Nme as IconMoodWink, Bme as IconMoodWink2, qme as IconMoodWrrr, Pme as IconMoodXd, Kme as IconMoon, Ime as IconMoon2, Dme as IconMoonOff, Gme as IconMoonStars, Rme as IconMoped, Ume as IconMotorbike, Zme as IconMountain, Xme as IconMountainOff, rke as IconMouse, _me as IconMouse2, tke as IconMouseOff, lke as IconMoustache, ske as IconMovie, ike as IconMovieOff, mke as IconMug, dke as IconMugOff, wke as IconMultiplier05x, Eke as IconMultiplier15x, gke as IconMultiplier1x, xke as IconMultiplier2x, Lke as IconMushroom, zke as IconMushroomOff, Bke as IconMusic, Cke as IconMusicOff, qke as IconNavigation, Nke as IconNavigationOff, Ike as IconNeedle, Pke as IconNeedleThread, Gke as IconNetwork, Dke as IconNetworkOff, Kke as IconNewSection, Uke as IconNews, Rke as IconNewsOff, Zke as IconNfc, Xke as IconNfcOff, _ke as IconNoCopyright, twe as IconNoCreativeCommons, rwe as IconNoDerivatives, lwe as IconNorthStar, swe as IconNote, iwe as IconNoteOff, mwe as IconNotebook, dwe as IconNotebookOff, Ewe as IconNotes, wwe as IconNotesOff, xwe as IconNotification, gwe as IconNotificationOff, Kwe as IconNumber, zwe as IconNumber0, Lwe as IconNumber1, Cwe as IconNumber2, Bwe as IconNumber3, Nwe as IconNumber4, qwe as IconNumber5, Pwe as IconNumber6, Iwe as IconNumber7, Dwe as IconNumber8, Gwe as IconNumber9, Rwe as IconNumbers, Uwe as IconNurse, Zwe as IconOctagon, Xwe as IconOctagonOff, _we as IconOld, rpe as IconOlympics, tpe as IconOlympicsOff, lpe as IconOm, ipe as IconOmega, spe as IconOutbound, dpe as IconOutlet, wpe as IconOval, mpe as IconOvalVertical, Epe as IconOverline, xpe as IconPackage, gpe as IconPackageOff, zpe as IconPackages, Lpe as IconPackgeExport, Cpe as IconPackgeImport, Bpe as IconPacman, Npe as IconPageBreak, Ppe as IconPaint, qpe as IconPaintOff, Dpe as IconPalette, Ipe as IconPaletteOff, Kpe as IconPanoramaHorizontal, Gpe as IconPanoramaHorizontalOff, Upe as IconPanoramaVertical, Rpe as IconPanoramaVerticalOff, Zpe as IconPaperBag, Xpe as IconPaperBagOff, _pe as IconPaperclip, rEe as IconParachute, tEe as IconParachuteOff, iEe as IconParentheses, lEe as IconParenthesesOff, dEe as IconParking, sEe as IconParkingOff, mEe as IconPassword, EEe as IconPaw, wEe as IconPawOff, gEe as IconPeace, CEe as IconPencil, xEe as IconPencilMinus, zEe as IconPencilOff, LEe as IconPencilPlus, qEe as IconPennant, BEe as IconPennant2, NEe as IconPennantOff, IEe as IconPentagon, PEe as IconPentagonOff, DEe as IconPentagram, KEe as IconPepper, GEe as IconPepperOff, REe as IconPercentage, UEe as IconPerfume, ZEe as IconPerspective, XEe as IconPerspectiveOff, Eue as IconPhone, _Ee as IconPhoneCall, tue as IconPhoneCalling, rue as IconPhoneCheck, lue as IconPhoneIncoming, iue as IconPhoneOff, sue as IconPhoneOutgoing, due as IconPhonePause, mue as IconPhonePlus, wue as IconPhoneX, Rue as IconPhoto, gue as IconPhotoCancel, xue as IconPhotoCheck, zue as IconPhotoDown, Lue as IconPhotoEdit, Cue as IconPhotoHeart, Bue as IconPhotoMinus, Nue as IconPhotoOff, que as IconPhotoPlus, Pue as IconPhotoSearch, Iue as IconPhotoShield, Due as IconPhotoStar, Gue as IconPhotoUp, Kue as IconPhotoX, Uue as IconPhysotherapist, tge as IconPictureInPicture, Xue as IconPictureInPictureOff, Zue as IconPictureInPictureOn, _ue as IconPictureInPictureTop, ige as IconPig, rge as IconPigMoney, lge as IconPigOff, sge as IconPilcrow, mge as IconPill, dge as IconPillOff, wge as IconPills, Ege as IconPin, gge as IconPingPong, zge as IconPinned, xge as IconPinnedOff, Cge as IconPizza, Lge as IconPizzaOff, Bge as IconPlaceholder, Gge as IconPlane, Nge as IconPlaneArrival, qge as IconPlaneDeparture, Pge as IconPlaneInflight, Ige as IconPlaneOff, Dge as IconPlaneTilt, Rge as IconPlanet, Kge as IconPlanetOff, _ge as IconPlant, Xge as IconPlant2, Uge as IconPlant2Off, Zge as IconPlantOff, rMe as IconPlayCard, tMe as IconPlayCardOff, lMe as IconPlayerEject, iMe as IconPlayerPause, sMe as IconPlayerPlay, dMe as IconPlayerRecord, mMe as IconPlayerSkipBack, wMe as IconPlayerSkipForward, EMe as IconPlayerStop, gMe as IconPlayerTrackNext, xMe as IconPlayerTrackPrev, BMe as IconPlaylist, zMe as IconPlaylistAdd, LMe as IconPlaylistOff, CMe as IconPlaylistX, NMe as IconPlaystationCircle, qMe as IconPlaystationSquare, PMe as IconPlaystationTriangle, IMe as IconPlaystationX, UMe as IconPlug, GMe as IconPlugConnected, DMe as IconPlugConnectedX, KMe as IconPlugOff, RMe as IconPlugX, XMe as IconPlus, ZMe as IconPng, txe as IconPodium, _Me as IconPodiumOff, lxe as IconPoint, rxe as IconPointOff, ixe as IconPointer, dxe as IconPokeball, sxe as IconPokeballOff, mxe as IconPokerChip, wxe as IconPolaroid, gxe as IconPolygon, Exe as IconPolygonOff, xxe as IconPoo, Lxe as IconPool, zxe as IconPoolOff, Cxe as IconPower, Bxe as IconPray, Nxe as IconPremiumRights, qxe as IconPrescription, Dxe as IconPresentation, Pxe as IconPresentationAnalytics, Ixe as IconPresentationOff, Kxe as IconPrinter, Gxe as IconPrinterOff, Rxe as IconPrison, Uxe as IconPrompt, Zxe as IconPropeller, Xxe as IconPropellerOff, _xe as IconPumpkinScary, lfe as IconPuzzle, tfe as IconPuzzle2, rfe as IconPuzzleOff, sfe as IconPyramid, ife as IconPyramidOff, mfe as IconQrcode, dfe as IconQrcodeOff, wfe as IconQuestionCircle, Efe as IconQuestionMark, xfe as IconQuote, gfe as IconQuoteOff, Cfe as IconRadar, zfe as IconRadar2, Lfe as IconRadarOff, Nfe as IconRadio, Bfe as IconRadioOff, Pfe as IconRadioactive, qfe as IconRadioactiveOff, Ife as IconRadiusBottomLeft, Dfe as IconRadiusBottomRight, Gfe as IconRadiusTopLeft, Kfe as IconRadiusTopRight, Ufe as IconRainbow, Rfe as IconRainbowOff, Xfe as IconRating12Plus, Zfe as IconRating14Plus, _fe as IconRating16Plus, tze as IconRating18Plus, rze as IconRating21Plus, ize as IconRazor, lze as IconRazorElectric, Eze as IconReceipt, sze as IconReceipt2, dze as IconReceiptOff, mze as IconReceiptRefund, wze as IconReceiptTax, gze as IconRecharging, zze as IconRecordMail, xze as IconRecordMailOff, Cze as IconRectangle, Lze as IconRectangleVertical, Nze as IconRecycle, Bze as IconRecycleOff, Dze as IconRefresh, qze as IconRefreshAlert, Pze as IconRefreshDot, Ize as IconRefreshOff, Kze as IconRegex, Gze as IconRegexOff, Rze as IconRegistered, Uze as IconRelationManyToMany, Xze as IconRelationOneToMany, Zze as IconRelationOneToOne, _ze as IconReload, lbe as IconRepeat, tbe as IconRepeatOff, rbe as IconRepeatOnce, sbe as IconReplace, ibe as IconReplaceOff, xbe as IconReport, dbe as IconReportAnalytics, mbe as IconReportMedical, wbe as IconReportMoney, Ebe as IconReportOff, gbe as IconReportSearch, zbe as IconResize, Lbe as IconRibbonHealth, Bbe as IconRipple, Cbe as IconRippleOff, Pbe as IconRoad, Nbe as IconRoadOff, qbe as IconRoadSign, Dbe as IconRobot, Ibe as IconRobotOff, Kbe as IconRocket, Gbe as IconRocketOff, Rbe as IconRollerSkating, Xbe as IconRollercoaster, Ube as IconRollercoasterOff, ELe as IconRosette, Zbe as IconRosetteNumber0, _be as IconRosetteNumber1, tLe as IconRosetteNumber2, rLe as IconRosetteNumber3, lLe as IconRosetteNumber4, iLe as IconRosetteNumber5, sLe as IconRosetteNumber6, dLe as IconRosetteNumber7, mLe as IconRosetteNumber8, wLe as IconRosetteNumber9, NLe as IconRotate, gLe as IconRotate2, xLe as IconRotate360, LLe as IconRotateClockwise, zLe as IconRotateClockwise2, CLe as IconRotateDot, BLe as IconRotateRectangle, ILe as IconRoute, qLe as IconRoute2, PLe as IconRouteOff, GLe as IconRouter, DLe as IconRouterOff, KLe as IconRowInsertBottom, RLe as IconRowInsertTop, ULe as IconRss, ZLe as IconRubberStamp, XLe as IconRubberStampOff, sye as IconRuler, tye as IconRuler2, _Le as IconRuler2Off, rye as IconRuler3, lye as IconRulerMeasure, iye as IconRulerOff, dye as IconRun, mye as IconSTurnDown, wye as IconSTurnLeft, Eye as IconSTurnRight, gye as IconSTurnUp, Lye as IconSailboat, xye as IconSailboat2, zye as IconSailboatOff, Cye as IconSalad, Bye as IconSalt, qye as IconSatellite, Nye as IconSatelliteOff, Pye as IconSausage, Kye as IconScale, Iye as IconScaleOff, Gye as IconScaleOutline, Dye as IconScaleOutlineOff, Uye as IconScan, Rye as IconScanEye, Zye as IconSchema, Xye as IconSchemaOff, rCe as IconSchool, _ye as IconSchoolBell, tCe as IconSchoolOff, iCe as IconScissors, lCe as IconScissorsOff, dCe as IconScooter, sCe as IconScooterElectric, wCe as IconScreenShare, mCe as IconScreenShareOff, ECe as IconScreenshot, xCe as IconScribble, gCe as IconScribbleOff, BCe as IconScript, zCe as IconScriptMinus, LCe as IconScriptPlus, CCe as IconScriptX, qCe as IconScubaMask, NCe as IconScubaMaskOff, PCe as IconSdk, DCe as IconSearch, ICe as IconSearchOff, KCe as IconSection, GCe as IconSectionSign, UCe as IconSeeding, RCe as IconSeedingOff, XCe as IconSelect, ZCe as IconSelector, tje as IconSend, _Ce as IconSendOff, rje as IconSeo, sje as IconSeparator, lje as IconSeparatorHorizontal, ije as IconSeparatorVertical, gje as IconServer, dje as IconServer2, mje as IconServerBolt, wje as IconServerCog, Eje as IconServerOff, xje as IconServicemark, Bje as IconSettings, zje as IconSettings2, Lje as IconSettingsAutomation, Cje as IconSettingsOff, qje as IconShadow, Nje as IconShadowOff, Gje as IconShape, Pje as IconShape2, Ije as IconShape3, Dje as IconShapeOff, Rje as IconShare, Kje as IconShareOff, sBe as IconShield, Uje as IconShieldCheck, Xje as IconShieldCheckered, Zje as IconShieldChevron, tBe as IconShieldHalf, _je as IconShieldHalfFilled, rBe as IconShieldLock, lBe as IconShieldOff, iBe as IconShieldX, mBe as IconShip, dBe as IconShipOff, gBe as IconShirt, wBe as IconShirtOff, EBe as IconShirtSport, zBe as IconShoe, xBe as IconShoeOff, LBe as IconShoppingBag, PBe as IconShoppingCart, CBe as IconShoppingCartDiscount, BBe as IconShoppingCartOff, NBe as IconShoppingCartPlus, qBe as IconShoppingCartX, IBe as IconShovel, DBe as IconShredder, GBe as IconSignLeft, KBe as IconSignRight, RBe as IconSignal3g, XBe as IconSignal4g, UBe as IconSignal4gPlus, ZBe as IconSignal5g, tHe as IconSignature, _Be as IconSignatureOff, lHe as IconSitemap, rHe as IconSitemapOff, sHe as IconSkateboard, iHe as IconSkateboardOff, dHe as IconSkull, mHe as IconSlash, wHe as IconSlashes, EHe as IconSleigh, gHe as IconSlice, xHe as IconSlideshow, LHe as IconSmartHome, zHe as IconSmartHomeOff, BHe as IconSmoking, CHe as IconSmokingNo, qHe as IconSnowflake, NHe as IconSnowflakeOff, PHe as IconSnowman, IHe as IconSoccerField, GHe as IconSocial, DHe as IconSocialOff, KHe as IconSock, UHe as IconSofa, RHe as IconSofaOff, XHe as IconSort09, ZHe as IconSort90, _He as IconSortAZ, iNe as IconSortAscending, tNe as IconSortAscending2, rNe as IconSortAscendingLetters, lNe as IconSortAscendingNumbers, wNe as IconSortDescending, sNe as IconSortDescending2, dNe as IconSortDescendingLetters, mNe as IconSortDescendingNumbers, ENe as IconSortZA, gNe as IconSos, zNe as IconSoup, xNe as IconSoupOff, LNe as IconSourceCode, BNe as IconSpace, CNe as IconSpaceOff, NNe as IconSpacingHorizontal, qNe as IconSpacingVertical, PNe as IconSpade, INe as IconSpeakerphone, DNe as IconSpeedboat, GNe as IconSpider, RNe as IconSpiral, KNe as IconSpiralOff, UNe as IconSportBillard, XNe as IconSpray, _Ne as IconSpy, ZNe as IconSpyOff, RSe as IconSquare, tWe as IconSquareArrowDown, rWe as IconSquareArrowLeft, lWe as IconSquareArrowRight, iWe as IconSquareArrowUp, sWe as IconSquareAsterisk, dWe as IconSquareCheck, mWe as IconSquareChevronDown, wWe as IconSquareChevronLeft, EWe as IconSquareChevronRight, gWe as IconSquareChevronUp, xWe as IconSquareChevronsDown, zWe as IconSquareChevronsLeft, LWe as IconSquareChevronsRight, CWe as IconSquareChevronsUp, BWe as IconSquareDot, NWe as IconSquareF0, qWe as IconSquareF1, PWe as IconSquareF2, IWe as IconSquareF3, DWe as IconSquareF4, GWe as IconSquareF5, KWe as IconSquareF6, RWe as IconSquareF7, UWe as IconSquareF8, XWe as IconSquareF9, _We as IconSquareForbid, ZWe as IconSquareForbid2, tqe as IconSquareHalf, rqe as IconSquareKey, lqe as IconSquareLetterA, iqe as IconSquareLetterB, sqe as IconSquareLetterC, dqe as IconSquareLetterD, mqe as IconSquareLetterE, wqe as IconSquareLetterF, Eqe as IconSquareLetterG, gqe as IconSquareLetterH, xqe as IconSquareLetterI, zqe as IconSquareLetterJ, Lqe as IconSquareLetterK, Cqe as IconSquareLetterL, Bqe as IconSquareLetterM, Nqe as IconSquareLetterN, qqe as IconSquareLetterO, Pqe as IconSquareLetterP, Iqe as IconSquareLetterQ, Dqe as IconSquareLetterR, Gqe as IconSquareLetterS, Kqe as IconSquareLetterT, Rqe as IconSquareLetterU, Uqe as IconSquareLetterV, Xqe as IconSquareLetterW, Zqe as IconSquareLetterX, _qe as IconSquareLetterY, tOe as IconSquareLetterZ, rOe as IconSquareMinus, lOe as IconSquareNumber0, iOe as IconSquareNumber1, sOe as IconSquareNumber2, dOe as IconSquareNumber3, mOe as IconSquareNumber4, wOe as IconSquareNumber5, EOe as IconSquareNumber6, gOe as IconSquareNumber7, xOe as IconSquareNumber8, zOe as IconSquareNumber9, LOe as IconSquareOff, COe as IconSquarePlus, NOe as IconSquareRoot, BOe as IconSquareRoot2, DOe as IconSquareRotated, POe as IconSquareRotatedForbid, qOe as IconSquareRotatedForbid2, IOe as IconSquareRotatedOff, ISe as IconSquareRounded, GOe as IconSquareRoundedArrowDown, KOe as IconSquareRoundedArrowLeft, ROe as IconSquareRoundedArrowRight, UOe as IconSquareRoundedArrowUp, XOe as IconSquareRoundedCheck, ZOe as IconSquareRoundedChevronDown, _Oe as IconSquareRoundedChevronLeft, tPe as IconSquareRoundedChevronRight, rPe as IconSquareRoundedChevronUp, lPe as IconSquareRoundedChevronsDown, iPe as IconSquareRoundedChevronsLeft, sPe as IconSquareRoundedChevronsRight, dPe as IconSquareRoundedChevronsUp, mPe as IconSquareRoundedLetterA, wPe as IconSquareRoundedLetterB, EPe as IconSquareRoundedLetterC, gPe as IconSquareRoundedLetterD, xPe as IconSquareRoundedLetterE, zPe as IconSquareRoundedLetterF, LPe as IconSquareRoundedLetterG, CPe as IconSquareRoundedLetterH, BPe as IconSquareRoundedLetterI, NPe as IconSquareRoundedLetterJ, qPe as IconSquareRoundedLetterK, PPe as IconSquareRoundedLetterL, IPe as IconSquareRoundedLetterM, DPe as IconSquareRoundedLetterN, GPe as IconSquareRoundedLetterO, KPe as IconSquareRoundedLetterP, RPe as IconSquareRoundedLetterQ, UPe as IconSquareRoundedLetterR, XPe as IconSquareRoundedLetterS, ZPe as IconSquareRoundedLetterT, _Pe as IconSquareRoundedLetterU, tSe as IconSquareRoundedLetterV, rSe as IconSquareRoundedLetterW, lSe as IconSquareRoundedLetterX, iSe as IconSquareRoundedLetterY, sSe as IconSquareRoundedLetterZ, dSe as IconSquareRoundedMinus, mSe as IconSquareRoundedNumber0, wSe as IconSquareRoundedNumber1, ESe as IconSquareRoundedNumber2, gSe as IconSquareRoundedNumber3, xSe as IconSquareRoundedNumber4, zSe as IconSquareRoundedNumber5, LSe as IconSquareRoundedNumber6, CSe as IconSquareRoundedNumber7, BSe as IconSquareRoundedNumber8, NSe as IconSquareRoundedNumber9, qSe as IconSquareRoundedPlus, PSe as IconSquareRoundedX, GSe as IconSquareToggle, DSe as IconSquareToggleHorizontal, KSe as IconSquareX, USe as IconSquaresDiagonal, XSe as IconSquaresFilled, lIe as IconStack, ZSe as IconStack2, _Se as IconStack3, tIe as IconStackPop, rIe as IconStackPush, dIe as IconStairs, iIe as IconStairsDown, sIe as IconStairsUp, EIe as IconStar, mIe as IconStarHalf, wIe as IconStarOff, xIe as IconStars, gIe as IconStarsOff, zIe as IconStatusChange, LIe as IconSteam, BIe as IconSteeringWheel, CIe as IconSteeringWheelOff, NIe as IconStepInto, qIe as IconStepOut, PIe as IconStereoGlasses, DIe as IconStethoscope, IIe as IconStethoscopeOff, GIe as IconSticker, RIe as IconStorm, KIe as IconStormOff, UIe as IconStretching, XIe as IconStrikethrough, ZIe as IconSubmarine, _Ie as IconSubscript, tAe as IconSubtask, lAe as IconSum, rAe as IconSumOff, EAe as IconSun, iAe as IconSunHigh, sAe as IconSunLow, dAe as IconSunMoon, mAe as IconSunOff, wAe as IconSunWind, gAe as IconSunglasses, xAe as IconSunrise, LAe as IconSunset, zAe as IconSunset2, CAe as IconSuperscript, BAe as IconSvg, NAe as IconSwimming, qAe as IconSwipe, KAe as IconSwitch, PAe as IconSwitch2, IAe as IconSwitch3, DAe as IconSwitchHorizontal, GAe as IconSwitchVertical, UAe as IconSword, RAe as IconSwordOff, XAe as IconSwords, sDe as IconTable, ZAe as IconTableAlias, _Ae as IconTableExport, tDe as IconTableImport, rDe as IconTableOff, lDe as IconTableOptions, iDe as IconTableShortcut, mDe as IconTag, dDe as IconTagOff, EDe as IconTags, wDe as IconTagsOff, gDe as IconTallymark1, xDe as IconTallymark2, zDe as IconTallymark3, LDe as IconTallymark4, CDe as IconTallymarks, BDe as IconTank, PDe as IconTarget, NDe as IconTargetArrow, qDe as IconTargetOff, IDe as IconTeapot, GDe as IconTelescope, DDe as IconTelescopeOff, _De as IconTemperature, KDe as IconTemperatureCelsius, RDe as IconTemperatureFahrenheit, UDe as IconTemperatureMinus, XDe as IconTemperatureOff, ZDe as IconTemperaturePlus, rFe as IconTemplate, tFe as IconTemplateOff, iFe as IconTent, lFe as IconTentOff, dFe as IconTerminal, sFe as IconTerminal2, EFe as IconTestPipe, mFe as IconTestPipe2, wFe as IconTestPipeOff, gFe as IconTex, xFe as IconTextCaption, zFe as IconTextColor, LFe as IconTextDecrease, CFe as IconTextDirectionLtr, BFe as IconTextDirectionRtl, NFe as IconTextIncrease, qFe as IconTextOrientation, PFe as IconTextPlus, IFe as IconTextRecognition, DFe as IconTextResize, GFe as IconTextSize, KFe as IconTextSpellcheck, UFe as IconTextWrap, RFe as IconTextWrapDisabled, XFe as IconTexture, ZFe as IconThermometer, tGe as IconThumbDown, _Fe as IconThumbDownOff, lGe as IconThumbUp, rGe as IconThumbUpOff, iGe as IconTicTac, dGe as IconTicket, sGe as IconTicketOff, mGe as IconTie, wGe as IconTilde, gGe as IconTiltShift, EGe as IconTiltShiftOff, qGe as IconTimeline, NGe as IconTimelineEvent, xGe as IconTimelineEventExclamation, zGe as IconTimelineEventMinus, LGe as IconTimelineEventPlus, CGe as IconTimelineEventText, BGe as IconTimelineEventX, PGe as IconTir, IGe as IconToggleLeft, DGe as IconToggleRight, KGe as IconToiletPaper, GGe as IconToiletPaperOff, RGe as IconTool, rJe as IconTools, _Ge as IconToolsKitchen, XGe as IconToolsKitchen2, UGe as IconToolsKitchen2Off, ZGe as IconToolsKitchenOff, tJe as IconToolsOff, lJe as IconTooltip, iJe as IconTopologyBus, sJe as IconTopologyComplex, mJe as IconTopologyFull, dJe as IconTopologyFullHierarchy, gJe as IconTopologyRing, wJe as IconTopologyRing2, EJe as IconTopologyRing3, NJe as IconTopologyStar, xJe as IconTopologyStar2, zJe as IconTopologyStar3, BJe as IconTopologyStarRing, LJe as IconTopologyStarRing2, CJe as IconTopologyStarRing3, qJe as IconTorii, PJe as IconTornado, IJe as IconTournament, GJe as IconTower, DJe as IconTowerOff, KJe as IconTrack, RJe as IconTractor, UJe as IconTrademark, ZJe as IconTrafficCone, XJe as IconTrafficConeOff, tKe as IconTrafficLights, _Je as IconTrafficLightsOff, rKe as IconTrain, lKe as IconTransferIn, iKe as IconTransferOut, sKe as IconTransform, dKe as IconTransitionBottom, mKe as IconTransitionLeft, wKe as IconTransitionRight, EKe as IconTransitionTop, zKe as IconTrash, gKe as IconTrashOff, xKe as IconTrashX, LKe as IconTree, CKe as IconTrees, BKe as IconTrekking, PKe as IconTrendingDown, NKe as IconTrendingDown2, qKe as IconTrendingDown3, GKe as IconTrendingUp, IKe as IconTrendingUp2, DKe as IconTrendingUp3, XKe as IconTriangle, KKe as IconTriangleInverted, RKe as IconTriangleOff, UKe as IconTriangleSquareCircle, ZKe as IconTriangles, _Ke as IconTrident, tQe as IconTrolley, lQe as IconTrophy, rQe as IconTrophyOff, iQe as IconTrowel, EQe as IconTruck, sQe as IconTruckDelivery, dQe as IconTruckLoading, mQe as IconTruckOff, wQe as IconTruckReturn, gQe as IconTxt, zQe as IconTypography, xQe as IconTypographyOff, LQe as IconUfOff, CQe as IconUfo, NQe as IconUmbrella, BQe as IconUmbrellaOff, qQe as IconUnderline, PQe as IconUnlink, IQe as IconUpload, DQe as IconUrgent, GQe as IconUsb, lRe as IconUser, KQe as IconUserCheck, RQe as IconUserCircle, UQe as IconUserExclamation, XQe as IconUserMinus, ZQe as IconUserOff, _Qe as IconUserPlus, tRe as IconUserSearch, rRe as IconUserX, iRe as IconUsers, sRe as IconUvIndex, dRe as IconUxCircle, gRe as IconVaccine, wRe as IconVaccineBottle, mRe as IconVaccineBottleOff, ERe as IconVaccineOff, xRe as IconVacuumCleaner, BRe as IconVariable, zRe as IconVariableMinus, LRe as IconVariableOff, CRe as IconVariablePlus, URe as IconVector, IRe as IconVectorBezier, NRe as IconVectorBezier2, qRe as IconVectorBezierArc, PRe as IconVectorBezierCircle, DRe as IconVectorOff, GRe as IconVectorSpline, RRe as IconVectorTriangle, KRe as IconVectorTriangleOff, XRe as IconVenus, _Re as IconVersions, ZRe as IconVersionsOff, iTe as IconVideo, tTe as IconVideoMinus, rTe as IconVideoOff, lTe as IconVideoPlus, dTe as IconView360, sTe as IconView360Off, wTe as IconViewfinder, mTe as IconViewfinderOff, ETe as IconViewportNarrow, gTe as IconViewportWide, xTe as IconVinyl, LTe as IconVip, zTe as IconVipOff, NTe as IconVirus, CTe as IconVirusOff, BTe as IconVirusSearch, PTe as IconVocabulary, qTe as IconVocabularyOff, KTe as IconVolume, ITe as IconVolume2, DTe as IconVolume3, GTe as IconVolumeOff, RTe as IconWalk, XTe as IconWall, UTe as IconWallOff, _Te as IconWallet, ZTe as IconWalletOff, rUe as IconWallpaper, tUe as IconWallpaperOff, iUe as IconWand, lUe as IconWandOff, iVe as IconWash, NUe as IconWashDry, sUe as IconWashDry1, dUe as IconWashDry2, mUe as IconWashDry3, wUe as IconWashDryA, EUe as IconWashDryDip, gUe as IconWashDryF, xUe as IconWashDryHang, zUe as IconWashDryOff, LUe as IconWashDryP, CUe as IconWashDryShade, BUe as IconWashDryW, PUe as IconWashDryclean, qUe as IconWashDrycleanOff, IUe as IconWashGentle, DUe as IconWashMachine, GUe as IconWashOff, KUe as IconWashPress, RUe as IconWashTemperature1, UUe as IconWashTemperature2, XUe as IconWashTemperature3, ZUe as IconWashTemperature4, _Ue as IconWashTemperature5, tVe as IconWashTemperature6, rVe as IconWashTumbleDry, lVe as IconWashTumbleOff, sVe as IconWaveSawTool, dVe as IconWaveSine, mVe as IconWaveSquare, EVe as IconWebhook, wVe as IconWebhookOff, gVe as IconWeight, zVe as IconWheelchair, xVe as IconWheelchairOff, LVe as IconWhirl, PVe as IconWifi, CVe as IconWifi0, BVe as IconWifi1, NVe as IconWifi2, qVe as IconWifiOff, DVe as IconWind, IVe as IconWindOff, KVe as IconWindmill, GVe as IconWindmillOff, ZVe as IconWindow, RVe as IconWindowMaximize, UVe as IconWindowMinimize, XVe as IconWindowOff, _Ve as IconWindsock, rXe as IconWiper, tXe as IconWiperWash, lXe as IconWoman, iXe as IconWood, xXe as IconWorld, sXe as IconWorldDownload, dXe as IconWorldLatitude, mXe as IconWorldLongitude, wXe as IconWorldOff, EXe as IconWorldUpload, gXe as IconWorldWww, zXe as IconWreckingBall, NXe as IconWriting, LXe as IconWritingOff, BXe as IconWritingSign, CXe as IconWritingSignOff, qXe as IconX, PXe as IconXboxA, IXe as IconXboxB, DXe as IconXboxX, GXe as IconXboxY, KXe as IconYinYang, RXe as IconYoga, XXe as IconZeppelin, UXe as IconZeppelinOff, ZXe as IconZip, _Xe as IconZodiacAquarius, tYe as IconZodiacAries, rYe as IconZodiacCancer, lYe as IconZodiacCapricorn, iYe as IconZodiacGemini, sYe as IconZodiacLeo, dYe as IconZodiacLibra, mYe as IconZodiacPisces, wYe as IconZodiacSagittarius, EYe as IconZodiacScorpio, gYe as IconZodiacTaurus, xYe as IconZodiacVirgo, zYe as IconZoomCancel, LYe as IconZoomCheck, CYe as IconZoomCode, BYe as IconZoomExclamation, qYe as IconZoomIn, NYe as IconZoomInArea, PYe as IconZoomMoney, DYe as IconZoomOut, IYe as IconZoomOutArea, GYe as IconZoomPan, KYe as IconZoomQuestion, RYe as IconZoomReplace, UYe as IconZoomReset, ZYe as IconZzz, XYe as IconZzzOff };